/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(230);
	module.exports = __webpack_require__(84);


/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = assertString;
	function assertString(input) {
	  var isString = typeof input === 'string' || input instanceof String;
	
	  if (!isString) {
	    throw new TypeError('This library (validator.js) validates strings only');
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(339)
	var ieee754 = __webpack_require__(368)
	var isArray = __webpack_require__(90)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production","PUBLIC_URL":"."}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(534);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(533);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(10)))

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(18);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 6 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 7 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	var exports = module.exports;
	
	var azureutil = __webpack_require__(16);
	
	__webpack_require__(284);
	
	var nodeVersion = azureutil.getNodeVersion();
	if (nodeVersion.major === 0 && nodeVersion.minor > 8 && !(nodeVersion.minor > 10 || (nodeVersion.minor === 10 && nodeVersion.patch >= 3))) {
	  throw new Error('The Microsoft Azure node SDK does not work with node versions > 0.9.0 and < 0.10.3. Please upgrade to node >= 0.10.3');
	}
	
	exports.xmlbuilder = __webpack_require__(120);
	exports.xml2js = __webpack_require__(228);
	
	exports.Logger = __webpack_require__(79);
	exports.WebResource = __webpack_require__(130);
	
	// Services
	exports.StorageServiceClient = __webpack_require__(274);
	
	// Models
	exports.ServicePropertiesResult = __webpack_require__(131);
	exports.ServiceStatsParser = __webpack_require__(272);
	exports.AclResult = __webpack_require__(271);
	
	// Filters
	exports.LinearRetryPolicyFilter = __webpack_require__(270);
	exports.ExponentialRetryPolicyFilter = __webpack_require__(269);
	exports.RetryPolicyFilter = __webpack_require__(80);
	
	// Signing
	exports.SharedAccessSignature = __webpack_require__(134);
	exports.SharedKey = __webpack_require__(135);
	
	// Streams
	exports.BatchOperation = __webpack_require__(276);
	exports.ChunkAllocator = __webpack_require__(278);
	exports.ChunkStream = __webpack_require__(137);
	exports.ChunkStreamWithStream = __webpack_require__(279);
	exports.SpeedSummary = __webpack_require__(281);
	exports.BufferStream = __webpack_require__(136);
	
	// Utilities
	exports.Constants = __webpack_require__(12);
	exports.SR = __webpack_require__(25);
	exports.date = __webpack_require__(283);
	exports.ISO8061Date = __webpack_require__(138);
	exports.util = __webpack_require__(16);
	exports.validate = __webpack_require__(82);
	exports.StorageUtilities = __webpack_require__(63);
	exports.AccessCondition = __webpack_require__(282);

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(40);


/***/ },
/* 10 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var DOMProperty = __webpack_require__(45);
	var ReactDOMComponentFlags = __webpack_require__(171);
	
	var invariant = __webpack_require__(3);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Expose 'Constants'.
	exports = module.exports;
	
	var storageDnsSuffix = ({"NODE_ENV":"production","PUBLIC_URL":"."}).AZURE_STORAGE_DNS_SUFFIX || 'core.windows.net';
	
	/**
	* Defines constants.
	*/
	var Constants = {
	  /*
	  * Specifies the value to use for UserAgent header.
	  *
	  * @const
	  * @type {string}
	  */
	  USER_AGENT_PRODUCT_NAME: 'Azure-Storage',
	
	  /*
	  * Specifies the value to use for UserAgent header.
	  *
	  * @const
	  * @type {string}
	  */
	  USER_AGENT_PRODUCT_VERSION: '2.8.2',
	
	  /**
	  * The number of default concurrent requests for parallel operation.
	  *
	  * @const
	  * @type {int}
	  */
	  DEFAULT_PARALLEL_OPERATION_THREAD_COUNT: 5,
	
	  /**
	  * The value of default socket reuse for batch operation.
	  *
	  * @const
	  * @type {boolean}
	  */
	  DEFAULT_ENABLE_REUSE_SOCKET: true,
	
	  /**
	  * Constant representing a kilobyte (Non-SI version).
	  *
	  * @const
	  * @type {int}
	  */
	  KB: 1024,
	
	  /**
	  * Constant representing a megabyte (Non-SI version).
	  *
	  * @const
	  * @type {int}
	  */
	  MB: 1024 * 1024,
	
	  /**
	  * Constant representing a gigabyte (Non-SI version).
	  *
	  * @const
	  * @type {int}
	  */
	  GB: 1024 * 1024 * 1024,
	
	  /**
	  * Specifies HTTP.
	  *
	  * @const
	  * @type {string}
	  */
	  HTTP: 'http:',
	
	  /**
	  * Specifies HTTPS.
	  *
	  * @const
	  * @type {string}
	  */
	  HTTPS: 'https:',
	  
	  /**
	  * Default HTTP port.
	  *
	  * @const
	  * @type {int}
	  */
	  DEFAULT_HTTP_PORT: 80,
	  
	  /**
	  * Default HTTPS port.
	  *
	  * @const
	  * @type {int}
	  */
	  DEFAULT_HTTPS_PORT: 443,
	
	  /**
	   * Default client request timeout in milliseconds.
	   * Integer containing the number of milliseconds to wait for a server to send response headers (and start the response body) before aborting the request.
	   * 2 minutes by default.
	   * 
	   * @const
	   * @type {int}
	   */
	  DEFAULT_CLIENT_REQUEST_TIMEOUT_IN_MS: 120000,
	
	  /**
	  * Marker for atom metadata.
	  *
	  * @const
	  * @type {string}
	  */
	  XML_METADATA_MARKER: '$',
	
	  /**
	  * Marker for atom value.
	  *
	  * @const
	  * @type {string}
	  */
	  XML_VALUE_MARKER: '_',
	  
	  /**
	  * Defines the service types indicators.
	  * 
	  * @const
	  * @enum {string}
	  */
	  ServiceType: {
	    Blob: 'blob',
	    Queue: 'queue',
	    Table: 'table',
	    File: 'file'
	  },
	
	  /**
	  * Specifies the location used to indicate which location the operation can be performed against.
	  *
	  * @const
	  * @enum {int}
	  */
	  RequestLocationMode: {
	    PRIMARY_ONLY: 0,
	    SECONDARY_ONLY: 1,
	    PRIMARY_OR_SECONDARY: 2
	  },
	
	  /**
	  * Represents a storage service location.
	  *
	  * @const
	  * @enum {int}
	  */
	  StorageLocation: {
	    PRIMARY: 0,
	    SECONDARY: 1
	  },
	
	  /**
	   * Defines constants for use with account SAS.
	   */
	  AccountSasConstants:{
	    /**
	    * Permission types.
	    *
	    * @const
	    * @enum {string}
	    */
	    Permissions: {
	      READ: 'r',
	      ADD: 'a',
	      CREATE: 'c',
	      UPDATE: 'u',
	      PROCESS: 'p',
	      WRITE: 'w',
	      DELETE: 'd',
	      LIST: 'l'
	    },
	    
	    /**
	    * Services types.
	    *
	    * @const
	    * @enum {string}
	    */
	    Services: {
	      BLOB: 'b',
	      FILE: 'f',
	      QUEUE: 'q',
	      TABLE: 't'
	    },
	    
	    /**
	    * Resources types.
	    *
	    * @const
	    * @enum {string}
	    */
	    Resources: {
	      SERVICE: 's',
	      CONTAINER: 'c',
	      OBJECT: 'o'
	    },
	
	    /**
	     * Protocols types.
	     *
	     * @const
	     * @enum {string}
	     */
	    Protocols: {
	      HTTPSONLY: 'https',
	      HTTPSORHTTP: 'https,http'
	    }
	  },
	
	  /**
	  * Defines constants for use with shared access policies.
	  */
	  AclConstants: {
	    /**
	    * XML element for an access policy.
	    *
	    * @const
	    * @type {string}
	    */
	    ACCESS_POLICY: 'AccessPolicy',
	
	    /**
	    * XML element for the end time of an access policy.
	    *
	    * @const
	    * @type {string}
	    */
	    EXPIRY: 'Expiry',
	
	    /**
	    * XML attribute for IDs.
	    *
	    * @const
	    * @type {string}
	    */
	    ID: 'Id',
	
	    /**
	    * XML element for the permission of an access policy.
	    *
	    * @const
	    * @type {string}
	    */
	    PERMISSION: 'Permission',
	
	    /**
	    * XML element for a signed identifier.
	    *
	    * @const
	    * @type {string}
	    */
	    SIGNED_IDENTIFIER_ELEMENT: 'SignedIdentifier',
	
	    /**
	    * XML element for signed identifiers.
	    *
	    * @const
	    * @type {string}
	    */
	    SIGNED_IDENTIFIERS_ELEMENT: 'SignedIdentifiers',
	
	    /**
	    * XML element for the start time of an access policy.
	    *
	    * @const
	    * @type {string}
	    */
	    START: 'Start'
	  },
	
	  /**
	  * Defines constants for use with service properties.
	  */
	  ServicePropertiesConstants: {
	    /**
	    * XML element for storage service properties.
	    *
	    * @const
	    * @type {string}
	    */
	    STORAGE_SERVICE_PROPERTIES_ELEMENT: 'StorageServiceProperties',
	
	    /**
	    * Default analytics version to send for logging, hour metrics and minute metrics.
	    *
	    * @const
	    * @type {string}
	    */
	    DEFAULT_ANALYTICS_VERSION: '1.0',
	
	    /**
	    * XML element for logging.
	    *
	    * @const
	    * @type {string}
	    */
	    LOGGING_ELEMENT: 'Logging',
	
	    /**
	    * XML element for version.
	    *
	    * @const
	    * @type {string}
	    */
	    VERSION_ELEMENT: 'Version',
	
	    /**
	    * XML element for delete.
	    *
	    * @const
	    * @type {string}
	    */
	    DELETE_ELEMENT: 'Delete',
	
	    /**
	    * XML element for read.
	    *
	    * @const
	    * @type {string}
	    */
	    READ_ELEMENT: 'Read',
	
	    /**
	    * XML element for write.
	    *
	    * @const
	    * @type {string}
	    */
	    WRITE_ELEMENT: 'Write',
	
	    /**
	    * XML element for retention policy.
	    *
	    * @const
	    * @type {string}
	    */
	    RETENTION_POLICY_ELEMENT: 'RetentionPolicy',
	
	    /**
	    * XML element for enabled.
	    *
	    * @const
	    * @type {string}
	    */
	    ENABLED_ELEMENT: 'Enabled',
	
	    /**
	    * XML element for days.
	    *
	    * @const
	    * @type {string}
	    */
	    DAYS_ELEMENT: 'Days',
	
	    /**
	    * XML element for HourMetrics.
	    *
	    * @const
	    * @type {string}
	    */
	    HOUR_METRICS_ELEMENT: 'HourMetrics',
	
	    /**
	    * XML element for MinuteMetrics.
	    *
	    * @const
	    * @type {string}
	    */
	    MINUTE_METRICS_ELEMENT: 'MinuteMetrics',
	
	    /**
	    * XML element for Cors.
	    *
	    * @const
	    * @type {string}
	    */
	    CORS_ELEMENT: 'Cors',
	
	    /**
	    * XML element for CorsRule.
	    *
	    * @const
	    * @type {string}
	    */
	    CORS_RULE_ELEMENT: 'CorsRule',
	
	    /**
	    * XML element for AllowedOrigins.
	    *
	    * @const
	    * @type {string}
	    */
	    ALLOWED_ORIGINS_ELEMENT: 'AllowedOrigins',
	
	    /**
	    * XML element for AllowedMethods.
	    *
	    * @const
	    * @type {string}
	    */
	    ALLOWED_METHODS_ELEMENT: 'AllowedMethods',
	
	    /**
	    * XML element for MaxAgeInSeconds.
	    *
	    * @const
	    * @type {string}
	    */
	    MAX_AGE_IN_SECONDS_ELEMENT: 'MaxAgeInSeconds',
	
	    /**
	    * XML element for ExposedHeaders.
	    *
	    * @const
	    * @type {string}
	    */
	    EXPOSED_HEADERS_ELEMENT: 'ExposedHeaders',
	
	    /**
	    * XML element for AllowedHeaders.
	    *
	    * @const
	    * @type {string}
	    */
	    ALLOWED_HEADERS_ELEMENT: 'AllowedHeaders',
	
	    /**
	    * XML element for IncludeAPIs.
	    *
	    * @const
	    * @type {string}
	    */
	    INCLUDE_APIS_ELEMENT: 'IncludeAPIs',
	
	    /**
	    * XML element for DefaultServiceVersion.
	    *
	    * @const
	    * @type {string}
	    */
	    DEFAULT_SERVICE_VERSION_ELEMENT: 'DefaultServiceVersion',
	
	    /**
	    * XML element for DeleteRetentionPolicy.
	    *
	    * @const
	    * @type {string}
	    */
	    DEFAULT_DELETE_RETENTION_POLICY_ELEMENT: 'DeleteRetentionPolicy'
	  },
	
	  /**
	  * Defines constants for use with blob operations.
	  */
	  BlobConstants: {
	    /**
	    * XML element for the latest.
	    *
	    * @const
	    * @type {string}
	    */
	    LATEST_ELEMENT: 'Latest',
	
	    /**
	    * XML element for uncommitted blocks.
	    *
	    * @const
	    * @type {string}
	    */
	    UNCOMMITTED_ELEMENT: 'Uncommitted',
	
	    /**
	    * XML element for a block list.
	    *
	    * @const
	    * @type {string}
	    */
	    BLOCK_LIST_ELEMENT: 'BlockList',
	
	    /**
	    * XML element for committed blocks.
	    *
	    * @const
	    * @type {string}
	    */
	    COMMITTED_ELEMENT: 'Committed',
	
	    /**
	    * The default write page size, in bytes, used by blob streams.
	    *
	    * @const
	    * @type {int}
	    */
	    DEFAULT_WRITE_PAGE_SIZE_IN_BYTES: 4 * 1024 * 1024,
	    
	    /**
	    * The minimum write page size, in bytes, used by blob streams.
	    *
	    * @const
	    * @type {int}
	    */
	    MIN_WRITE_PAGE_SIZE_IN_BYTES: 2 * 1024 * 1024,
	
	    /**
	    * The default maximum size, in bytes, of a blob before it must be separated into blocks.
	    *
	    * @const
	    * @type {int}
	    */
	    DEFAULT_SINGLE_BLOB_PUT_THRESHOLD_IN_BYTES: 32 * 1024 * 1024,
	
	    /**
	    * The default write block size, in bytes, used by blob streams.
	    *
	    * @const
	    * @type {int}
	    */
	    DEFAULT_WRITE_BLOCK_SIZE_IN_BYTES: 4 * 1024 * 1024,
	
	    /**
	    * The default critical memory limitation in 32bit Node.js environment, in bytes.
	    *
	    * @const
	    * @type {int}
	    */
	    DEFAULT_CRITICAL_MEMORY_LIMITATION_32_IN_BYTES: 800 * 1024 * 1024,
	
	   /**
	    * The default critical memory limitation in browser environment, in bytes.
	    *
	    * @const
	    * @type {int}
	    */
	    DEFAULT_CRITICAL_MEMORY_LIMITATION_BROWSER_IN_BYTES: 1 * 1024 * 1024 * 1024,
	
	   /**
	    * The default minimum memory usage in browser environment, in bytes.
	    *
	    * @const
	    * @type {int}
	    */
	    DEFAULT_MINIMUM_MEMORY_USAGE_BROWSER_IN_BYTES: 4 * 1024 * 1024,
	
	    /**
	    * The maximum size of a single block of block blob.
	    *
	    * @const
	    * @type {int}
	    */
	    MAX_BLOCK_BLOB_BLOCK_SIZE: 100 * 1024 * 1024,
	
	    /**
	    * The maximum size of a single block of append blob.
	    *
	    * @const
	    * @type {int}
	    */
	    MAX_APPEND_BLOB_BLOCK_SIZE: 4 * 1024 * 1024,
	
	    /**
	    * The maximum size, in bytes, of a blob before it must be separated into blocks.
	    *
	    * @const
	    * @type {int}
	    */
	    MAX_SINGLE_UPLOAD_BLOB_SIZE_IN_BYTES: 64 * 1024 * 1024,
	
	    /**
	    * The maximum range get size when requesting for a contentMD5.
	    *
	    * @const
	    * @type {int}
	    */
	    MAX_RANGE_GET_SIZE_WITH_MD5 : 4 * 1024 * 1024,
	
	    /**
	    * The maximum page range size for a page update operation.
	    *
	    * @const
	    * @type {int}
	    */
	    MAX_UPDATE_PAGE_SIZE : 4 * 1024 * 1024,
	    
	    /**
	    * The maximum buffer size for writing a stream buffer.
	    *
	    * @const
	    * @type {int}
	    */
	    MAX_QUEUED_WRITE_DISK_BUFFER_SIZE : 64 * 1024 * 1024,
	    
	    /**
	    * Max size for single get page range. The max value should be 150MB.
	    * http://blogs.msdn.com/b/windowsazurestorage/archive/2012/03/26/getting-the-page-ranges-of-a-large-page-blob-in-segments.aspx
	    *
	    * @const
	    * @type {int}
	    */
	    MAX_SINGLE_GET_PAGE_RANGE_SIZE : 37 * 4 * 1024 * 1024,
	
	    /**
	    * The size of a page, in bytes, in a page blob.
	    *
	    * @const
	    * @type {int}
	    */
	    PAGE_SIZE: 512,
	
	    /**
	    * Resource types.
	    *
	    * @const
	    * @enum {string}
	    */
	    ResourceTypes: {
	      CONTAINER: 'c',
	      BLOB: 'b'
	    },
	
	    /**
	    * List blob types.
	    *
	    * @const
	    * @enum {string}
	    */
	    ListBlobTypes: {
	      Blob: 'b',
	      Directory: 'd'
	    },
	
	    /**
	    * Put page write options
	    *
	    * @const
	    * @enum {string}
	    */
	    PageWriteOptions: {
	      UPDATE: 'update',
	      CLEAR: 'clear'
	    },
	
	    /**
	    * Blob types
	    *
	    * @const
	    * @enum {string}
	    */
	    BlobTypes: {
	      BLOCK: 'BlockBlob',
	      PAGE: 'PageBlob',
	      APPEND: 'AppendBlob'
	    },
	
	    /**
	    * Blob lease constants
	    *
	    * @const
	    * @enum {string}
	    */
	    LeaseOperation: {
	      ACQUIRE: 'acquire',
	      RENEW: 'renew',
	      CHANGE: 'change',
	      RELEASE: 'release',
	      BREAK: 'break'
	    }
	  },
	
	  /**
	  * Defines constants for use with file operations.
	  */
	  FileConstants: {
	    /**
	    * The default write size, in bytes, used by file streams.
	    *
	    * @const
	    * @type {int}
	    */
	    DEFAULT_WRITE_SIZE_IN_BYTES: 4 * 1024 * 1024,
	
	    /**
	    * The maximum range size when requesting for a contentMD5.
	    *
	    * @const
	    * @type {int}
	    */
	    MAX_RANGE_GET_SIZE_WITH_MD5 : 4 * 1024 * 1024,
	
	    /**
	    * The maximum range size for a file update operation.
	    *
	    * @const
	    * @type {int}
	    */
	    MAX_UPDATE_FILE_SIZE : 4 * 1024 * 1024,
	
	    /**
	    * The default minimum size, in bytes, of a file when it must be separated into ranges.
	    *
	    * @const
	    * @type {int}
	    */
	    DEFAULT_SINGLE_FILE_GET_THRESHOLD_IN_BYTES: 32 * 1024 * 1024,
	
	    /**
	    * The minimum write file size, in bytes, used by file streams.
	    *
	    * @const
	    * @type {int}
	    */
	    MIN_WRITE_FILE_SIZE_IN_BYTES: 2 * 1024 * 1024,
	
	    /**
	    * Put range write options
	    *
	    * @const
	    * @enum {string}
	    */
	    RangeWriteOptions: {
	      UPDATE: 'update',
	      CLEAR: 'clear'
	    },
	
	    /**
	    * Resource types.
	    *
	    * @const
	    * @enum {string}
	    */
	    ResourceTypes: {
	      SHARE: 's',
	      FILE: 'f'
	    }
	  },
	
	  /**
	  * Defines constants for use with queue storage.
	  */
	  QueueConstants: {
	    /**
	    * XML element for QueueMessage.
	    *
	    * @const
	    * @type {string}
	    */
	    QUEUE_MESSAGE_ELEMENT: 'QueueMessage',
	
	    /**
	    * XML element for MessageText.
	    *
	    * @const
	    * @type {string}
	    */
	    MESSAGE_TEXT_ELEMENT: 'MessageText'
	  },
	
	  /**
	  * Defines constants for use with table storage.
	  */
	  TableConstants: {
	    /**
	    * The changeset response delimiter.
	    *
	    * @const
	    * @type {string}
	    */
	    CHANGESET_DELIMITER: '--changesetresponse_',
	
	    /**
	    * The batch response delimiter.
	    *
	    * @const
	    * @type {string}
	    */
	    BATCH_DELIMITER: '--batchresponse_',
	
	    /**
	    * The next continuation row key token.
	    *
	    * @const
	    * @type {string}
	    */
	    CONTINUATION_NEXT_ROW_KEY: 'x-ms-continuation-nextrowkey',
	
	    /**
	    * The next continuation partition key token.
	    *
	    * @const
	    * @type {string}
	    */
	    CONTINUATION_NEXT_PARTITION_KEY: 'x-ms-continuation-nextpartitionkey',
	
	    /**
	    * The next continuation table name token.
	    *
	    * @const
	    * @type {string}
	    */
	    CONTINUATION_NEXT_TABLE_NAME: 'x-ms-continuation-nexttablename',
	
	    /**
	    * The next row key query string argument.
	    *
	    * @const
	    * @type {string}
	    */
	    NEXT_ROW_KEY: 'NextRowKey',
	
	    /**
	    * The next partition key query string argument.
	    *
	    * @const
	    * @type {string}
	    */
	    NEXT_PARTITION_KEY: 'NextPartitionKey',
	
	    /**
	    * The next table name query string argument.
	    *
	    * @const
	    * @type {string}
	    */
	    NEXT_TABLE_NAME: 'NextTableName',
	
	    /**
	    * Prefix of the odata properties returned in a JSON query.
	    *
	    * @const
	    * @type {string}
	    */
	    ODATA_PREFIX: 'odata.',
	
	    /**
	    * Constant representing the string following a type annotation in a JSON table query.
	    *
	    * @const
	    * @type {string}
	    */
	    ODATA_TYPE_SUFFIX: '@odata.type',
	
	    /**
	    * Constant representing the property where the odata metadata elements are stored.
	    *
	    * @const
	    * @type {string}
	    */
	    ODATA_METADATA_MARKER: '.metadata',
	
	    /**
	    * Constant representing the value for an entity property.
	    *
	    * @const
	    * @type {string}
	    */
	    ODATA_VALUE_MARKER: '_',
	
	    /** 
	    * Constant representing the type for an entity property.
	    *
	    * @const
	    * @type {string}
	    */
	    ODATA_TYPE_MARKER: '$',
	
	    /**
	    * The value to set the maximum data service version header.
	    *
	    * @const
	    * @type {string}
	    */
	    DEFAULT_DATA_SERVICE_VERSION: '3.0;NetFx',
	
	    /**
	    * The name of the property that stores the table name.
	    *
	    * @const
	    * @type {string}
	    */
	    TABLE_NAME: 'TableName',
	
	    /**
	    * The name of the special table used to store tables.
	    *
	    * @const
	    * @type {string}
	    */
	    TABLE_SERVICE_TABLE_NAME: 'Tables',
	
	    /**
	    * Operations.
	    *
	    * @const
	    * @enum {string}
	    */
	    Operations: {
	      RETRIEVE: 'RETRIEVE',
	      INSERT: 'INSERT',
	      REPLACE: 'REPLACE',
	      MERGE: 'MERGE',
	      DELETE: 'DELETE',
	      INSERT_OR_REPLACE: 'INSERT_OR_REPLACE',
	      INSERT_OR_MERGE: 'INSERT_OR_MERGE'
	    }
	  },
	
	  /**
	  * Defines constants for use with HTTP headers.
	  */
	  HeaderConstants: {
	    /**
	    * The accept ranges header.
	    *
	    * @const
	    * @type {string}
	    */
	    ACCEPT_RANGES: 'accept_ranges',
	
	    /**
	    * The content transfer encoding header.
	    *
	    * @const
	    * @type {string}
	    */
	    CONTENT_TRANSFER_ENCODING: 'content-transfer-encoding',
	
	    /**
	    * The transfer encoding header.
	    *
	    * @const
	    * @type {string}
	    */
	    TRANSFER_ENCODING: 'transfer-encoding',
	
	    /**
	    * The server header.
	    *
	    * @const
	    * @type {string}
	    */
	    SERVER: 'server',
	
	    /**
	    * The location header.
	    *
	    * @const
	    * @type {string}
	    */
	    LOCATION: 'location',
	
	    /**
	    * The Last-Modified header
	    *
	    * @const
	    * @type {string}
	    */
	    LAST_MODIFIED: 'Last-Modified',
	
	    /**
	    * The data service version.
	    *
	    * @const
	    * @type {string}
	    */
	    DATA_SERVICE_VERSION: 'dataserviceversion',
	
	    /**
	    * The maximum data service version.
	    *
	    * @const
	    * @type {string}
	    */
	    MAX_DATA_SERVICE_VERSION: 'maxdataserviceversion',
	
	    /**
	    * The master Windows Azure Storage header prefix.
	    *
	    * @const
	    * @type {string}
	    */
	    PREFIX_FOR_STORAGE: 'x-ms-',
	
	    /**
	    * The client request Id header.
	    *
	    * @const
	    * @type {string}
	    */
	    CLIENT_REQUEST_ID: 'x-ms-client-request-id',
	
	    /**
	    * The header that specifies the approximate message count of a queue.
	    *
	    * @const
	    * @type {string}
	    */
	    APPROXIMATE_MESSAGES_COUNT: 'x-ms-approximate-messages-count',
	
	    /**
	    * The Authorization header.
	    *
	    * @const
	    * @type {string}
	    */
	    AUTHORIZATION: 'authorization',
	
	    /**
	    * The header that is used to avoid browser cache.
	    *
	    * @const
	    * @type {string}
	    */
	    FORCE_NO_CACHE_IN_BROWSER: '_',
	
	    /**
	    * The header that specifies public access to blobs.
	    *
	    * @const
	    * @type {string}
	    */
	    BLOB_PUBLIC_ACCESS: 'x-ms-blob-public-access',
	
	    /**
	    * The header for the blob type.
	    *
	    * @const
	    * @type {string}
	    */
	    BLOB_TYPE: 'x-ms-blob-type',
	
	    /**
	    * The header for the type.
	    *
	    * @const
	    * @type {string}
	    */
	    TYPE: 'x-ms-type',
	
	    /**
	    * Specifies the block blob type.
	    *
	    * @const
	    * @type {string}
	    */
	    BLOCK_BLOB: 'blockblob',
	
	    /**
	    * The CacheControl header.
	    *
	    * @const
	    * @type {string}
	    */
	    CACHE_CONTROL: 'cache-control',
	
	    /**
	    * The header that specifies blob caching control.
	    *
	    * @const
	    * @type {string}
	    */
	    BLOB_CACHE_CONTROL: 'x-ms-blob-cache-control',
	
	    /**
	    * The header that specifies caching control.
	    *
	    * @const
	    * @type {string}
	    */
	    FILE_CACHE_CONTROL: 'x-ms-cache-control',
	
	    /**
	    * The copy status.
	    *
	    * @const
	    * @type {string}
	    */
	    COPY_STATUS: 'x-ms-copy-status',
	
	    /**
	    * The copy completion time
	    *
	    * @const
	    * @type {string}
	    */
	    COPY_COMPLETION_TIME: 'x-ms-copy-completion-time',
	
	    /**
	    * The copy status message
	    *
	    * @const
	    * @type {string}
	    */
	    COPY_STATUS_DESCRIPTION: 'x-ms-copy-status-description',
	
	    /**
	    * The copy identifier.
	    *
	    * @const
	    * @type {string}
	    */
	    COPY_ID: 'x-ms-copy-id',
	
	    /**
	    * Progress of any copy operation
	    *
	    * @const
	    * @type {string}
	    */
	    COPY_PROGRESS: 'x-ms-copy-progress',
	
	    /**
	    * The copy action.
	    *
	    * @const
	    * @type {string}
	    */
	    COPY_ACTION: 'x-ms-copy-action',
	
	    /**
	    * Flag if the blob is incremental copy blob.
	    *
	    * @const
	    * @type {string}
	    */
	    INCREMENTAL_COPY: 'x-ms-incremental-copy',
	
	    /**
	    * Snapshot time of the last successful incremental copy snapshot for this blob.
	    *
	    * @const
	    * @type {string}
	    */
	    COPY_DESTINATION_SNAPSHOT: 'x-ms-copy-destination-snapshot',
	
	    /**
	    * The ContentID header.
	    *
	    * @const
	    * @type {string}
	    */
	    CONTENT_ID: 'content-id',
	
	    /**
	    * The ContentEncoding header.
	    *
	    * @const
	    * @type {string}
	    */
	    CONTENT_ENCODING: 'content-encoding',
	
	    /**
	    * The header that specifies blob content encoding.
	    *
	    * @const
	    * @type {string}
	    */
	    BLOB_CONTENT_ENCODING: 'x-ms-blob-content-encoding',
	
	    /**
	    * The header that specifies content encoding.
	    *
	    * @const
	    * @type {string}
	    */
	    FILE_CONTENT_ENCODING: 'x-ms-content-encoding',
	
	    /**
	    * The ContentLangauge header.
	    *
	    * @const
	    * @type {string}
	    */
	    CONTENT_LANGUAGE: 'content-language',
	
	    /**
	    * The header that specifies blob content language.
	    *
	    * @const
	    * @type {string}
	    */
	    BLOB_CONTENT_LANGUAGE: 'x-ms-blob-content-language',
	
	    /**
	    * The header that specifies content language.
	    *
	    * @const
	    * @type {string}
	    */
	    FILE_CONTENT_LANGUAGE: 'x-ms-content-language',
	
	    /**
	    * The ContentLength header.
	    *
	    * @const
	    * @type {string}
	    */
	    CONTENT_LENGTH: 'content-length',
	
	    /**
	    * The header that specifies blob content length.
	    *
	    * @const
	    * @type {string}
	    */
	    BLOB_CONTENT_LENGTH: 'x-ms-blob-content-length',
	
	    /**
	    * The header that specifies content length.
	    *
	    * @const
	    * @type {string}
	    */
	    FILE_CONTENT_LENGTH: 'x-ms-content-length',
	
	    /**
	    * The ContentDisposition header.
	    * @const
	    * @type {string}
	    */
	    CONTENT_DISPOSITION: 'content-disposition',
	
	    /**
	    * The header that specifies blob content disposition.
	    *
	    * @const
	    * @type {string}
	    */
	    BLOB_CONTENT_DISPOSITION: 'x-ms-blob-content-disposition',
	
	    /**
	    * The header that specifies content disposition.
	    *
	    * @const
	    * @type {string}
	    */
	    FILE_CONTENT_DISPOSITION: 'x-ms-content-disposition',
	
	    /**
	    * The ContentMD5 header.
	    *
	    * @const
	    * @type {string}
	    */
	    CONTENT_MD5: 'content-md5',
	
	    /**
	    * The header that specifies blob content MD5.
	    *
	    * @const
	    * @type {string}
	    */
	    BLOB_CONTENT_MD5: 'x-ms-blob-content-md5',
	
	    /**
	    * The header that specifies content MD5.
	    *
	    * @const
	    * @type {string}
	    */
	    FILE_CONTENT_MD5: 'x-ms-content-md5',
	
	    /**
	    * The ContentRange header.
	    *
	    * @const
	    * @type {string}
	    */
	    CONTENT_RANGE: 'cache-range',
	
	    /**
	    * The ContentType header.
	    *
	    * @const
	    * @type {string}
	    */
	    CONTENT_TYPE: 'content-type',
	
	    /**
	    * The header that specifies blob content type.
	    *
	    * @const
	    * @type {string}
	    */
	    BLOB_CONTENT_TYPE: 'x-ms-blob-content-type',
	
	    /**
	    * The header that specifies content type.
	    *
	    * @const
	    * @type {string}
	    */
	    FILE_CONTENT_TYPE: 'x-ms-content-type',
	
	    /**
	    * The header for copy source.
	    *
	    * @const
	    * @type {string}
	    */
	    COPY_SOURCE: 'x-ms-copy-source',
	
	    /**
	    * The header that specifies the date.
	    *
	    * @const
	    * @type {string}
	    */
	    DATE: 'date',
	
	    /**
	    * The header that specifies the date.
	    *
	    * @const
	    * @type {string}
	    */
	    MS_DATE: 'x-ms-date',
	
	    /**
	    * The header to delete snapshots.
	    *
	    * @const
	    * @type {string}
	    */
	    DELETE_SNAPSHOT: 'x-ms-delete-snapshots',
	
	    /**
	    * The ETag header.
	    *
	    * @const
	    * @type {string}
	    */
	    ETAG: 'etag',
	
	    /**
	    * The IfMatch header.
	    *
	    * @const
	    * @type {string}
	    */
	    IF_MATCH: 'if-match',
	
	    /**
	    * The IfModifiedSince header.
	    *
	    * @const
	    * @type {string}
	    */
	    IF_MODIFIED_SINCE: 'if-modified-since',
	
	    /**
	    * The IfNoneMatch header.
	    *
	    * @const
	    * @type {string}
	    */
	    IF_NONE_MATCH: 'if-none-match',
	
	    /**
	    * The IfUnmodifiedSince header.
	    *
	    * @const
	    * @type {string}
	    */
	    IF_UNMODIFIED_SINCE: 'if-unmodified-since',
	
	    /**
	    * Specifies snapshots are to be included.
	    *
	    * @const
	    * @type {string}
	    */
	    INCLUDE_SNAPSHOTS_VALUE: 'include',
	
	    /**
	    * Specifies that the content-type is JSON.
	    *
	    * @const
	    * @type {string}
	    */
	    JSON_CONTENT_TYPE_VALUE: 'application/json;',
	
	
	    /**
	    * The header that specifies lease ID.
	    *
	    * @const
	    * @type {string}
	    */
	    LEASE_ID: 'x-ms-lease-id',
	
	    /**
	    * The header that specifies the lease break period.
	    *
	    * @const
	    * @type {string}
	    */
	    LEASE_BREAK_PERIOD: 'x-ms-lease-break-period',
	
	    /**
	    * The header that specifies the proposed lease identifier.
	    *
	    * @const
	    * @type {string}
	    */
	    PROPOSED_LEASE_ID: 'x-ms-proposed-lease-id',
	
	    /**
	    * The header that specifies the lease duration.
	    *
	    * @const
	    * @type {string}
	    */
	    LEASE_DURATION: 'x-ms-lease-duration',
	
	    /**
	    * The header that specifies the source lease ID.
	    *
	    * @const
	    * @type {string}
	    */
	    SOURCE_LEASE_ID: 'x-ms-source-lease-id',
	
	    /**
	    * The header that specifies lease time.
	    *
	    * @const
	    * @type {string}
	    */
	    LEASE_TIME: 'x-ms-lease-time',
	
	    /**
	    * The header that specifies lease status.
	    *
	    * @const
	    * @type {string}
	    */
	    LEASE_STATUS: 'x-ms-lease-status',
	
	    /**
	    * The header that specifies lease state.
	    *
	    * @const
	    * @type {string}
	    */
	    LEASE_STATE: 'x-ms-lease-state',
	
	    /**
	    * Specifies the page blob type.
	    *
	    * @const
	    * @type {string}
	    */
	    PAGE_BLOB: 'PageBlob',
	
	    /**
	    * The header that specifies page write mode.
	    *
	    * @const
	    * @type {string}
	    */
	    PAGE_WRITE: 'x-ms-page-write',
	
	    /**
	    * The header that specifies file range write mode.
	    *
	    * @const
	    * @type {string}
	    */
	    FILE_WRITE: 'x-ms-write',
	
	    /**
	    * The header that specifies whether the response should include the inserted entity.
	    *
	    * @const
	    * @type {string}
	    */
	    PREFER: 'Prefer',
	
	    /**
	    * The header value which specifies that the response should include the inserted entity.
	    *
	    * @const
	    * @type {string}
	    */
	    PREFER_CONTENT: 'return-content',
	
	    /**
	    * The header value which specifies that the response should not include the inserted entity.
	    *
	    * @const
	    * @type {string}
	    */
	    PREFER_NO_CONTENT: 'return-no-content',
	
	    /**
	    * The header prefix for metadata.
	    *
	    * @const
	    * @type {string}
	    */
	    PREFIX_FOR_STORAGE_METADATA: 'x-ms-meta-',
	
	    /**
	    * The header prefix for properties.
	    *
	    * @const
	    * @type {string}
	    */
	    PREFIX_FOR_STORAGE_PROPERTIES: 'x-ms-prop-',
	
	    /**
	    * The Range header.
	    *
	    * @const
	    * @type {string}
	    */
	    RANGE: 'Range',
	
	    /**
	    * The header that specifies if the request will populate the ContentMD5 header for range gets.
	    *
	    * @const
	    * @type {string}
	    */
	    RANGE_GET_CONTENT_MD5: 'x-ms-range-get-content-md5',
	
	    /**
	    * The format string for specifying ranges.
	    *
	    * @const
	    * @type {string}
	    */
	    RANGE_HEADER_FORMAT: 'bytes:%d-%d',
	
	    /**
	    * The header that indicates the request ID.
	    *
	    * @const
	    * @type {string}
	    */
	    REQUEST_ID: 'x-ms-request-id',
	
	    /**
	    * The header for specifying the sequence number.
	    *
	    * @const
	    * @type {string}
	    */
	    SEQUENCE_NUMBER: 'x-ms-blob-sequence-number',
	
	    /**
	    * The header for specifying the If-Sequence-Number-EQ condition.
	    *
	    * @const
	    * @type {string}
	    */
	    SEQUENCE_NUMBER_EQUAL: 'x-ms-if-sequence-number-eq',
	
	    /**
	    * The header for specifying the If-Sequence-Number-LT condition.
	    *
	    * @const
	    * @type {string}
	    */
	    SEQUENCE_NUMBER_LESS_THAN: 'x-ms-if-sequence-number-lt',
	
	    /**
	    * The header for specifying the If-Sequence-Number-LE condition.
	    *
	    * @const
	    * @type {string}
	    */
	    SEQUENCE_NUMBER_LESS_THAN_OR_EQUAL: 'x-ms-if-sequence-number-le',
	
	    /**
	    * The header that specifies sequence number action.
	    *
	    * @const
	    * @type {string}
	    */
	    SEQUENCE_NUMBER_ACTION: 'x-ms-sequence-number-action',
	
	    /**
	    * The header for the blob content length.
	    *
	    * @const
	    * @type {string}
	    */
	    SIZE: 'x-ms-blob-content-length',
	
	    /**
	    * The header for snapshots.
	    *
	    * @const
	    * @type {string}
	    */
	    SNAPSHOT: 'x-ms-snapshot',
	
	    /**
	    * Specifies only snapshots are to be included.
	    *
	    * @const
	    * @type {string}
	    */
	    SNAPSHOTS_ONLY_VALUE: 'only',
	
	    /**
	    * The header for the If-Match condition.
	    *
	    * @const
	    * @type {string}
	    */
	    SOURCE_IF_MATCH: 'x-ms-source-if-match',
	
	    /**
	    * The header for the If-Modified-Since condition.
	    *
	    * @const
	    * @type {string}
	    */
	    SOURCE_IF_MODIFIED_SINCE: 'x-ms-source-if-modified-since',
	
	    /**
	    * The header for the If-None-Match condition.
	    *
	    * @const
	    * @type {string}
	    */
	    SOURCE_IF_NONE_MATCH: 'x-ms-source-if-none-match',
	
	    /**
	    * The header for the If-Unmodified-Since condition.
	    *
	    * @const
	    * @type {string}
	    */
	    SOURCE_IF_UNMODIFIED_SINCE: 'x-ms-source-if-unmodified-since',
	
	    /**
	    * The header for data ranges.
	    *
	    * @const
	    * @type {string}
	    */
	    STORAGE_RANGE: 'x-ms-range',
	
	    /**
	    * The header for storage version.
	    *
	    * @const
	    * @type {string}
	    */
	    STORAGE_VERSION: 'x-ms-version',
	
	    /**
	    * The current storage version header value.
	    *
	    * @const
	    * @type {string}
	    */
	    TARGET_STORAGE_VERSION: '2017-07-29',
	
	    /**
	    * The UserAgent header.
	    *
	    * @const
	    * @type {string}
	    */
	    USER_AGENT: 'user-agent',
	
	    /**
	    * The pop receipt header.
	    *
	    * @const
	    * @type {string}
	    */
	    POP_RECEIPT: 'x-ms-popreceipt',
	
	    /**
	    * The time next visibile header.
	    *
	    * @const
	    * @type {string}
	    */
	    TIME_NEXT_VISIBLE: 'x-ms-time-next-visible',
	
	    /**
	    * The approximate message counter header.
	    *
	    * @const
	    * @type {string}
	    */
	    APPROXIMATE_MESSAGE_COUNT: 'x-ms-approximate-message-count',
	
	    /**
	    * The lease action header.
	    *
	    * @const
	    * @type {string}
	    */
	    LEASE_ACTION: 'x-ms-lease-action',
	
	    /**
	    * The accept header.
	    *
	    * @const
	    * @type {string}
	    */
	    ACCEPT: 'accept',
	
	    /**
	    * The accept charset header.
	    *
	    * @const
	    * @type {string}
	    */
	    ACCEPT_CHARSET: 'Accept-Charset',
	
	    /**
	    * The host header.
	    *
	    * @const
	    * @type {string}
	    */
	    HOST: 'host',
	
	    /**
	    * The correlation identifier header.
	    *
	    * @const
	    * @type {string}
	    */
	    CORRELATION_ID: 'x-ms-correlation-id',
	
	    /**
	    * The group identifier header.
	    *
	    * @const
	    * @type {string}
	    */
	    GROUP_ID: 'x-ms-group-id',
	
	    /**
	    * The share quota header.
	    *
	    * @const
	    * @type {string}
	    */
	    SHARE_QUOTA: 'x-ms-share-quota',
	    
	    /**
	    * The max blob size header.
	    *
	    * @const
	    * @type {string}
	    */
	    BLOB_CONDITION_MAX_SIZE: 'x-ms-blob-condition-maxsize',
	
	    /**
	    * The append blob position header.
	    *
	    * @const
	    * @type {string}
	    */
	    BLOB_CONDITION_APPEND_POSITION: 'x-ms-blob-condition-appendpos',
	
	    /**
	    * The append blob append offset header.
	    *
	    * @const
	    * @type {string}
	    */
	    BLOB_APPEND_OFFSET: 'x-ms-blob-append-offset',
	
	    /**
	    * The append blob committed block header.
	    *
	    * @const
	    * @type {string}
	    */
	    BLOB_COMMITTED_BLOCK_COUNT: 'x-ms-blob-committed-block-count',
	
	    /**
	     * If the contents of the request have been successfully encrypted using the specified algorithm.
	     *
	     * @const
	     * @type {string}
	     */
	    REQUEST_SERVER_ENCRYPTED: 'x-ms-request-server-encrypted',
	
	    /**
	    * If the data and application metadata are completely encrypted using the specified algorithm.
	    *
	    * @const
	    * @type {string}
	    */
	    SERVER_ENCRYPTED: 'x-ms-server-encrypted',
	
	    /**
	    * Header indicates the resulting tier of the blob.
	    *
	    * @const
	    * @type {string}
	    */
	    ACCESS_TIER: 'x-ms-access-tier',
	
	    /**
	    * This is the datetime of when the last time tier was changed on the blob.
	    *
	    * @const
	    * @type {string}
	    */
	    ACCESS_TIER_CHANGE_TIME: 'x-ms-access-tier-change-time',
	
	    /**
	    * If the access tier is not explicitly set on the blob, 
	    * the tier is inferred based on its content length 
	    * and this header will be returned with true value.
	    *
	    * @const
	    * @type {string}
	    */
	    ACCESS_TIER_INFERRED: 'x-ms-access-tier-inferred',
	
	    /**
	    * For BlobStorage accounts, the header is returned if archive tier is set
	    * and rehydrate operation is pending for the request version is 2017-04-17 or later.
	    * The valid values are rehydrate-pending-to-hot or rehydrate-pending-to-cool.
	    *
	    * @const
	    * @type {string}
	    */
	    ARCHIVE_STATUS: 'x-ms-archive-status'
	  },
	
	  QueryStringConstants: {
	
	    /**
	    * Query component for SAS API version.
	    * @const
	    * @type {string}
	    */
	    API_VERSION: 'api-version',
	
	    /**
	    * The Comp value.
	    *
	    * @const
	    * @type {string}
	    */
	    COMP: 'comp',
	
	    /**
	    * The Res Type.
	    *
	    * @const
	    * @type {string}
	    */
	    RESTYPE: 'restype',
	
	    /**
	    * The copy Id.
	    * @const
	    * @type {string}
	    */
	    COPY_ID: 'copyid',
	
	    /**
	    * The snapshot value.
	    *
	    * @const
	    * @type {string}
	    */
	    SNAPSHOT: 'snapshot',
	
	    /**
	    * The share snapshot value.
	    *
	    * @const
	    * @type {string}
	    */
	    SHARE_SNAPSHOT: 'sharesnapshot',
	
	    /**
	    * The previous snapshot value.
	    *
	    * @const
	    * @type {string}
	    */
	    PREV_SNAPSHOT: 'prevsnapshot',
	
	    /**
	    * The timeout value.
	    *
	    * @const
	    * @type {string}
	    */
	    TIMEOUT: 'timeout',
	
	    /**
	    * The signed start time query string argument for shared access signature.
	    *
	    * @const
	    * @type {string}
	    */
	    SIGNED_START: 'st',
	
	    /**
	    * The signed expiry time query string argument for shared access signature.
	    *
	    * @const
	    * @type {string}
	    */
	    SIGNED_EXPIRY: 'se',
	
	    /**
	    * The signed resource query string argument for shared access signature.
	    *
	    * @const
	    * @type {string}
	    */
	    SIGNED_RESOURCE: 'sr',
	
	    /**
	    * The signed permissions query string argument for shared access signature.
	    *
	    * @const
	    * @type {string}
	    */
	    SIGNED_PERMISSIONS: 'sp',
	    
	    /**
	    * The signed services query string argument for shared access signature.
	    *
	    * @const
	    * @type {string}
	    */
	    SIGNED_SERVICES: 'ss',
	    
	    /**
	    * The signed resource types query string argument for shared access signature.
	    *
	    * @const
	    * @type {string}
	    */
	    SIGNED_RESOURCE_TYPES: 'srt',
	    
	    /**
	    * The signed IP query string argument for shared access signature.
	    *
	    * @const
	    * @type {string}
	    */
	    SIGNED_IP: 'sip',
	    
	    /**
	    * The signed protocol query string argument for shared access signature.
	    *
	    * @const
	    * @type {string}
	    */
	    SIGNED_PROTOCOL: 'spr',
	
	    /**
	    * The signed identifier query string argument for shared access signature.
	    *
	    * @const
	    * @type {string}
	    */
	    SIGNED_IDENTIFIER: 'si',
	
	    /**
	    * The signature query string argument for shared access signature.
	    *
	    * @const
	    * @type {string}
	    */
	    SIGNATURE: 'sig',
	
	    /**
	    * The signed version argument for shared access signature.
	    *
	    * @const
	    * @type {string}
	    */
	    SIGNED_VERSION: 'sv',
	
	    /**
	    * The cache control argument for shared access signature.
	    *
	    * @const
	    * @type {string}
	    */
	    CACHE_CONTROL: 'rscc',
	
	    /**
	    * The content type argument for shared access signature.
	    *
	    * @const
	    * @type {string}
	    */
	    CONTENT_TYPE: 'rsct',
	
	    /**
	    * The content encoding argument for shared access signature.
	    *
	    * @const
	    * @type {string}
	    */
	    CONTENT_ENCODING: 'rsce',
	
	    /**
	    * The content language argument for shared access signature.
	    *
	    * @const
	    * @type {string}
	    */
	    CONTENT_LANGUAGE: 'rscl',
	
	    /**
	    * The content disposition argument for shared access signature.
	    *
	    * @const
	    * @type {string}
	    */
	    CONTENT_DISPOSITION: 'rscd',
	
	    /**
	    * The block identifier query string argument for blob service.
	    *
	    * @const
	    * @type {string}
	    */
	    BLOCK_ID: 'blockid',
	
	    /**
	    * The block list type query string argument for blob service.
	    *
	    * @const
	    * @type {string}
	    */
	    BLOCK_LIST_TYPE: 'blocklisttype',
	
	    /**
	    * The prefix query string argument for listing operations.
	    *
	    * @const
	    * @type {string}
	    */
	    PREFIX: 'prefix',
	
	    /**
	    * The marker query string argument for listing operations.
	    *
	    * @const
	    * @type {string}
	    */
	    MARKER: 'marker',
	
	    /**
	    * The maxresults query string argument for listing operations.
	    *
	    * @const
	    * @type {string}
	    */
	    MAX_RESULTS: 'maxresults',
	
	    /**
	    * The delimiter query string argument for listing operations.
	    *
	    * @const
	    * @type {string}
	    */
	    DELIMITER: 'delimiter',
	
	    /**
	    * The include query string argument for listing operations.
	    *
	    * @const
	    * @type {string}
	    */
	    INCLUDE: 'include',
	
	    /**
	    * The peekonly query string argument for queue service.
	    *
	    * @const
	    * @type {string}
	    */
	    PEEK_ONLY: 'peekonly',
	
	    /**
	    * The numofmessages query string argument for queue service.
	    *
	    * @const
	    * @type {string}
	    */
	    NUM_OF_MESSAGES: 'numofmessages',
	
	    /**
	    * The popreceipt query string argument for queue service.
	    *
	    * @const
	    * @type {string}
	    */
	    POP_RECEIPT: 'popreceipt',
	
	    /**
	    * The visibilitytimeout query string argument for queue service.
	    *
	    * @const
	    * @type {string}
	    */
	    VISIBILITY_TIMEOUT: 'visibilitytimeout',
	
	    /**
	    * The messagettl query string argument for queue service.
	    *
	    * @const
	    * @type {string}
	    */
	    MESSAGE_TTL: 'messagettl',
	
	    /**
	    * The select query string argument.
	    *
	    * @const
	    * @type {string}
	    */
	    SELECT: '$select',
	
	    /**
	    * The filter query string argument.
	    *
	    * @const
	    * @type {string}
	    */
	    FILTER: '$filter',
	
	    /**
	    * The top query string argument.
	    *
	    * @const
	    * @type {string}
	    */
	    TOP: '$top',
	
	    /**
	    * The skip query string argument.
	    *
	    * @const
	    * @type {string}
	    */
	    SKIP: '$skip',
	
	    /**
	    * The next partition key query string argument for table service.
	    *
	    * @const
	    * @type {string}
	    */
	    NEXT_PARTITION_KEY: 'NextPartitionKey',
	
	    /**
	    * The next row key query string argument for table service.
	    *
	    * @const
	    * @type {string}
	    */
	    NEXT_ROW_KEY: 'NextRowKey',
	
	    /**
	    * The lock identifier for service bus messages.
	    *
	    * @const
	    * @type {string}
	    */
	    LOCK_ID: 'lockid',
	
	    /**
	    * The table name for table SAS URI's.
	    *
	    * @const
	    * @type {string}
	    */
	    TABLENAME: 'tn',
	
	    /**
	    * The starting Partition Key for tableSAS URI's.
	    *
	    * @const
	    * @type {string}
	    */
	    STARTPK: 'spk',
	
	    /**
	    * The starting Partition Key for tableSAS URI's.
	    *
	    * @const
	    * @type {string}
	    */
	    STARTRK: 'srk',
	
	    /**
	    * The ending Partition Key for tableSAS URI's.
	    *
	    * @const
	    * @type {string}
	    */
	    ENDPK: 'epk',
	
	    /**
	    * The ending Partition Key for tableSAS URI's.
	    *
	    * @const
	    * @type {string}
	    */
	    ENDRK: 'erk'
	  },
	
	  StorageServiceClientConstants: {
	    /**
	    * The default protocol.
	    *
	    * @const
	    * @type {string}
	    */
	    DEFAULT_PROTOCOL: 'https:',
	
	    /*
	    * Used environment variables.
	    *
	    * @const
	    * @enum {string}
	    */
	    EnvironmentVariables: {
	      AZURE_STORAGE_ACCOUNT: 'AZURE_STORAGE_ACCOUNT',
	      AZURE_STORAGE_ACCESS_KEY: 'AZURE_STORAGE_ACCESS_KEY',
	      AZURE_STORAGE_DNS_SUFFIX: 'AZURE_STORAGE_DNS_SUFFIX',
	      AZURE_STORAGE_CONNECTION_STRING: 'AZURE_STORAGE_CONNECTION_STRING',
	      HTTP_PROXY: 'HTTP_PROXY',
	      HTTPS_PROXY: 'HTTPS_PROXY',
	      EMULATED: 'EMULATED'
	    },
	
	    /**
	    * Default credentials.
	    */
	    DEVSTORE_STORAGE_ACCOUNT: 'devstoreaccount1',
	    DEVSTORE_STORAGE_ACCESS_KEY: 'Eby8vdM02xNOcqFlqUwJPLlmEtlCDXJ1OUzFT50uSRZ6IFsuFq2UVErCz4I6tq/K1SZFPTOtr/KBHBeksoGMGw==',
	
	    /**
	    * The development store URI.
	    *
	    * @const
	    * @type {string}
	    */
	    DEV_STORE_URI: 'http://127.0.0.1',
	
	    /**
	    * Development ServiceClient URLs.
	    */
	    DEVSTORE_DEFAULT_PROTOCOL: 'http://',
	    DEVSTORE_BLOB_HOST: '127.0.0.1:10000',
	    DEVSTORE_QUEUE_HOST: '127.0.0.1:10001',
	    DEVSTORE_TABLE_HOST: '127.0.0.1:10002',
	
	    /**
	    * Production ServiceClient URLs.
	    */
	    CLOUD_BLOB_HOST: 'blob.' + storageDnsSuffix,
	    CLOUD_QUEUE_HOST: 'queue.' + storageDnsSuffix,
	    CLOUD_TABLE_HOST: 'table.' + storageDnsSuffix,
	    CLOUD_FILE_HOST: 'file.' + storageDnsSuffix
	  },
	
	  HttpConstants: {
	    /**
	    * Http Verbs
	    *
	    * @const
	    * @enum {string}
	    */
	    HttpVerbs: {
	      PUT: 'PUT',
	      GET: 'GET',
	      DELETE: 'DELETE',
	      POST: 'POST',
	      MERGE: 'MERGE',
	      HEAD: 'HEAD'
	    },
	
	    /**
	    * Response codes.
	    *
	    * @const
	    * @enum {int}
	    */
	    HttpResponseCodes: {
	      Ok: 200,
	      Created: 201,
	      Accepted: 202,
	      NoContent: 204,
	      PartialContent: 206,
	      BadRequest: 400,
	      Unauthorized: 401,
	      Forbidden: 403,
	      NotFound: 404,
	      Conflict: 409,
	      LengthRequired: 411,
	      PreconditionFailed: 412
	    }
	  },
	
	  CompatibleVersionConstants: {
	    /**
	    * Constant for the 2013-08-15 version.
	    *
	    * @const
	    * @type {string}
	    */
	    AUGUST_2013: '2013-08-15',
	
	    /**
	    * Constant for the 2012-02-12 version.
	    *
	    * @const
	    * @type {string}
	    */
	    FEBRUARY_2012: '2012-02-12'
	  },
	
	  BlobErrorCodeStrings: {
	    INVALID_BLOCK_ID: 'InvalidBlockId',
	    BLOB_NOT_FOUND: 'BlobNotFound',
	    BLOB_ALREADY_EXISTS: 'BlobAlreadyExists',
	    CONTAINER_ALREADY_EXISTS: 'ContainerAlreadyExists',
	    CONTAINER_NOT_FOUND: 'ContainerNotFound',
	    INVALID_BLOB_OR_BLOCK: 'InvalidBlobOrBlock',
	    INVALID_BLOCK_LIST: 'InvalidBlockList'
	  },
	
	  FileErrorCodeStrings: {
	    SHARE_ALREADY_EXISTS: 'ShareAlreadyExists',
	    SHARE_NOT_FOUND: 'ShareNotFound',
	    FILE_NOT_FOUND: 'FileNotFound'
	  },
	
	  QueueErrorCodeStrings: {
	    QUEUE_NOT_FOUND: 'QueueNotFound',
	    QUEUE_DISABLED: 'QueueDisabled',
	    QUEUE_ALREADY_EXISTS: 'QueueAlreadyExists',
	    QUEUE_NOT_EMPTY: 'QueueNotEmpty',
	    QUEUE_BEING_DELETED: 'QueueBeingDeleted',
	    POP_RECEIPT_MISMATCH: 'PopReceiptMismatch',
	    INVALID_PARAMETER: 'InvalidParameter',
	    MESSAGE_NOT_FOUND: 'MessageNotFound',
	    MESSAGE_TOO_LARGE: 'MessageTooLarge',
	    INVALID_MARKER: 'InvalidMarker'
	  },
	
	  /**
	  * Constants for storage error strings
	  *
	  * More details are at: http://msdn.microsoft.com/en-us/library/azure/dd179357.aspx
	  */
	  StorageErrorCodeStrings: {
	    // Not Modified (304): The condition specified in the conditional header(s) was not met for a read operation.
	    // Precondition Failed (412): The condition specified in the conditional header(s) was not met for a write operation.
	    CONDITION_NOT_MET: 'ConditionNotMet', 
	    // Bad Request (400): A required HTTP header was not specified.
	    MISSING_REQUIRED_HEADER: 'MissingRequiredHeader', 
	    // Bad Request (400): A required XML node was not specified in the request body.
	    MISSING_REQUIRED_XML_NODE: 'MissingRequiredXmlNode', 
	    // Bad Request (400): One of the HTTP headers specified in the request is not supported.
	    UNSUPPORTED_HEADER: 'UnsupportedHeader',
	    // Bad Request (400): One of the XML nodes specified in the request body is not supported.
	    UNSUPPORTED_XML_NODE: 'UnsupportedXmlNode', 
	    // Bad Request (400): The value provided for one of the HTTP headers was not in the correct format.
	    INVALID_HEADER_VALUE: 'InvalidHeaderValue', 
	    // Bad Request (400): The value provided for one of the XML nodes in the request body was not in the correct format.
	    INVALID_XML_NODE_VALUE: 'InvalidXmlNodeValue',
	    // Bad Request (400): A required query parameter was not specified for this request.
	    MISSING_REQUIRED_QUERY_PARAMETER: 'MissingRequiredQueryParameter',
	    // Bad Request (400): One of the query parameters specified in the request URI is not supported.
	    UNSUPPORTED_QUERY_PARAMETER: 'UnsupportedQueryParameter',
	    // Bad Request (400): An invalid value was specified for one of the query parameters in the request URI.
	    INVALID_QUERY_PARAMETER_VALUE: 'InvalidQueryParameterValue',
	    // Bad Request (400): A query parameter specified in the request URI is outside the permissible range.
	    OUT_OF_RANGE_QUERY_PARAMETER_VALUE: 'OutOfRangeQueryParameterValue',
	    // Bad Request (400): The url in the request could not be parsed.
	    REQUEST_URL_FAILED_TO_PARSE: 'RequestUrlFailedToParse',
	    // Bad Request (400): The requested URI does not represent any resource on the server.
	    INVALID_URI: 'InvalidUri',
	    // Bad Request (400): The HTTP verb specified was not recognized by the server.
	    INVALID_HTTP_VERB: 'InvalidHttpVerb',
	    // Bad Request (400): The key for one of the metadata key-value pairs is empty.
	    EMPTY_METADATA_KEY: 'EmptyMetadataKey',
	    // Bad Request (400): The specified XML is not syntactically valid.
	    INVALID_XML_DOCUMENT: 'InvalidXmlDocument',
	    // Bad Request (400): The MD5 value specified in the request did not match the MD5 value calculated by the server.
	    MD5_MISMATCH: 'Md5Mismatch',
	    // Bad Request (400): The MD5 value specified in the request is invalid. The MD5 value must be 128 bits and Base64-encoded.
	    INVALID_MD5: 'InvalidMd5',
	    // Bad Request (400): One of the request inputs is out of range.
	    OUT_OF_RANGE_INPUT: 'OutOfRangeInput',
	    // Bad Request (400): The authentication information was not provided in the correct format. Verify the value of Authorization header.
	    INVALID_AUTHENTICATION_INFO: 'InvalidAuthenticationInfo',
	    // Bad Request (400): One of the request inputs is not valid.
	    INVALID_INPUT: 'InvalidInput',
	    // Bad Request (400): The specified metadata is invalid. It includes characters that are not permitted.
	    INVALID_METADATA: 'InvalidMetadata',
	    // Bad Request (400): The specifed resource name contains invalid characters.
	    INVALID_RESOURCE_NAME: 'InvalidResourceName',
	    // Bad Request (400): The size of the specified metadata exceeds the maximum size permitted.
	    METADATA_TOO_LARGE: 'MetadataTooLarge',
	    // Bad Request (400): Condition headers are not supported.
	    CONDITION_HEADER_NOT_SUPPORTED: 'ConditionHeadersNotSupported',
	    // Bad Request (400): Multiple condition headers are not supported.
	    MULTIPLE_CONDITION_HEADER_NOT_SUPPORTED: 'MultipleConditionHeadersNotSupported',
	    // Forbidden (403): Server failed to authenticate the request. Make sure the value of the Authorization header is formed correctly including the signature.
	    AUTHENTICATION_FAILED: 'AuthenticationFailed',
	    // Forbidden (403): Read-access geo-redundant replication is not enabled for the account.
	    // Forbidden (403): Write operations to the secondary location are not allowed.
	    // Forbidden (403): The account being accessed does not have sufficient permissions to execute this operation.
	    INSUFFICIENT_ACCOUNT_PERMISSIONS: 'InsufficientAccountPermissions',
	    // Not Found (404): The specified resource does not exist.
	    RESOURCE_NOT_FOUND: 'ResourceNotFound',
	    // Forbidden (403): The specified account is disabled.
	    ACCOUNT_IS_DISABLED: 'AccountIsDisabled',
	    // Method Not Allowed (405): The resource doesn't support the specified HTTP verb.
	    UNSUPPORTED_HTTP_VERB: 'UnsupportedHttpVerb',
	    // Conflict (409): The specified account already exists. 
	    ACCOUNT_ALREADY_EXISTS: 'AccountAlreadyExists',
	    // Conflict (409): The specified account is in the process of being created.
	    ACCOUNT_BEING_CREATED: 'AccountBeingCreated',
	    // Conflict (409): The specified resource already exists.
	    RESOURCE_ALREADY_EXISTS: 'ResourceAlreadyExists',
	    // Conflict (409): The specified resource type does not match the type of the existing resource.
	    RESOURCE_TYPE_MISMATCH: 'ResourceTypeMismatch',
	    // Length Required (411): The Content-Length header was not specified.
	    MISSING_CONTENT_LENGTH_HEADER: 'MissingContentLengthHeader',
	    // Request Entity Too Large (413): The size of the request body exceeds the maximum size permitted.
	    REQUEST_BODY_TOO_LARGE: 'RequestBodyTooLarge',
	    // Requested Range Not Satisfiable (416): The range specified is invalid for the current size of the resource.
	    INVALID_RANGE: 'InvalidRange',
	    // Internal Server Error (500): The server encountered an internal error. Please retry the request.
	    INTERNAL_ERROR: 'InternalError',
	    // Internal Server Error (500): The operation could not be completed within the permitted time.
	    OPERATION_TIMED_OUT: 'OperationTimedOut',
	    // Service Unavailable (503): The server is currently unable to receive requests. Please retry your request. 
	    SERVER_BUSY: 'ServerBusy',
	
	    // Legacy error code strings
	    UPDATE_CONDITION_NOT_SATISFIED: 'UpdateConditionNotSatisfied',
	    CONTAINER_NOT_FOUND: 'ContainerNotFound',
	    CONTAINER_ALREADY_EXISTS: 'ContainerAlreadyExists',
	    CONTAINER_DISABLED: 'ContainerDisabled',
	    CONTAINER_BEING_DELETED: 'ContainerBeingDeleted'
	  },
	
	  TableErrorCodeStrings: {
	    XMETHOD_NOT_USING_POST: 'XMethodNotUsingPost',
	    XMETHOD_INCORRECT_VALUE: 'XMethodIncorrectValue',
	    XMETHOD_INCORRECT_COUNT: 'XMethodIncorrectCount',
	    TABLE_HAS_NO_PROPERTIES: 'TableHasNoProperties',
	    DUPLICATE_PROPERTIES_SPECIFIED: 'DuplicatePropertiesSpecified',
	    TABLE_HAS_NO_SUCH_PROPERTY: 'TableHasNoSuchProperty',
	    DUPLICATE_KEY_PROPERTY_SPECIFIED: 'DuplicateKeyPropertySpecified',
	    TABLE_ALREADY_EXISTS: 'TableAlreadyExists',
	    TABLE_NOT_FOUND: 'TableNotFound',
	    ENTITY_NOT_FOUND: 'EntityNotFound',
	    ENTITY_ALREADY_EXISTS: 'EntityAlreadyExists',
	    PARTITION_KEY_NOT_SPECIFIED: 'PartitionKeyNotSpecified',
	    OPERATOR_INVALID: 'OperatorInvalid',
	    UPDATE_CONDITION_NOT_SATISFIED: 'UpdateConditionNotSatisfied',
	    PROPERTIES_NEED_VALUE: 'PropertiesNeedValue',
	    PARTITION_KEY_PROPERTY_CANNOT_BE_UPDATED: 'PartitionKeyPropertyCannotBeUpdated',
	    TOO_MANY_PROPERTIES: 'TooManyProperties',
	    ENTITY_TOO_LARGE: 'EntityTooLarge',
	    PROPERTY_VALUE_TOO_LARGE: 'PropertyValueTooLarge',
	    INVALID_VALUE_TYPE: 'InvalidValueType',
	    TABLE_BEING_DELETED: 'TableBeingDeleted',
	    TABLE_SERVER_OUT_OF_MEMORY: 'TableServerOutOfMemory',
	    PRIMARY_KEY_PROPERTY_IS_INVALID_TYPE: 'PrimaryKeyPropertyIsInvalidType',
	    PROPERTY_NAME_TOO_LONG: 'PropertyNameTooLong',
	    PROPERTY_NAME_INVALID: 'PropertyNameInvalid',
	    BATCH_OPERATION_NOT_SUPPORTED: 'BatchOperationNotSupported',
	    JSON_FORMAT_NOT_SUPPORTED: 'JsonFormatNotSupported',
	    METHOD_NOT_ALLOWED: 'MethodNotAllowed',
	    NOT_IMPLEMENTED: 'NotImplemented'
	  },
	
	  ConnectionStringKeys: {
	    USE_DEVELOPMENT_STORAGE_NAME: 'UseDevelopmentStorage',
	    DEVELOPMENT_STORAGE_PROXY_URI_NAME: 'DevelopmentStorageProxyUri',
	    DEFAULT_ENDPOINTS_PROTOCOL_NAME: 'DefaultEndpointsProtocol',
	    ACCOUNT_NAME_NAME: 'AccountName',
	    ACCOUNT_KEY_NAME: 'AccountKey',
	    BLOB_ENDPOINT_NAME: 'BlobEndpoint',
	    FILE_ENDPOINT_NAME: 'FileEndpoint',
	    QUEUE_ENDPOINT_NAME: 'QueueEndpoint',
	    TABLE_ENDPOINT_NAME: 'TableEndpoint',
	    SHARED_ACCESS_SIGNATURE_NAME: 'SharedAccessSignature',
	    ENDPOINT_SUFFIX_NAME: 'EndpointSuffix',
	    BLOB_BASE_DNS_NAME: 'blob.core.windows.net',
	    FILE_BASE_DNS_NAME: 'file.core.windows.net',
	    QUEUE_BASE_DNS_NAME: 'queue.core.windows.net',
	    TABLE_BASE_DNS_NAME: 'table.core.windows.net'
	  }
	};
	
	module.exports = Constants;


/***/ },
/* 13 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 14 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
	//     http://underscorejs.org
	//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var
	    push             = ArrayProto.push,
	    slice            = ArrayProto.slice,
	    toString         = ObjProto.toString,
	    hasOwnProperty   = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind,
	    nativeCreate       = Object.create;
	
	  // Naked function reference for surrogate-prototype-swapping.
	  var Ctor = function(){};
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.8.3';
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  var optimizeCb = function(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      case 2: return function(value, other) {
	        return func.call(context, value, other);
	      };
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  };
	
	  // A mostly-internal function to generate callbacks that can be applied
	  // to each element in a collection, returning the desired result — either
	  // identity, an arbitrary callback, a property matcher, or a property accessor.
	  var cb = function(value, context, argCount) {
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
	    if (_.isObject(value)) return _.matcher(value);
	    return _.property(value);
	  };
	  _.iteratee = function(value, context) {
	    return cb(value, context, Infinity);
	  };
	
	  // An internal function for creating assigner functions.
	  var createAssigner = function(keysFunc, undefinedOnly) {
	    return function(obj) {
	      var length = arguments.length;
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  };
	
	  // An internal function for creating a new object that inherits from another.
	  var baseCreate = function(prototype) {
	    if (!_.isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  };
	
	  var property = function(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  };
	
	  // Helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object
	  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	  var getLength = property('length');
	  var isArrayLike = function(collection) {
	    var length = getLength(collection);
	    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
	  };
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  _.each = _.forEach = function(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (i = 0, length = keys.length; i < length; i++) {
	        iteratee(obj[keys[i]], keys[i], obj);
	      }
	    }
	    return obj;
	  };
	
	  // Return the results of applying the iteratee to each element.
	  _.map = _.collect = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  // Create a reducing function iterating left or right.
	  function createReduce(dir) {
	    // Optimized iterator function as using arguments.length
	    // in the main function will deoptimize the, see #1991.
	    function iterator(obj, iteratee, memo, keys, index, length) {
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = keys ? keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    }
	
	    return function(obj, iteratee, memo, context) {
	      iteratee = optimizeCb(iteratee, context, 4);
	      var keys = !isArrayLike(obj) && _.keys(obj),
	          length = (keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      // Determine the initial value if none is provided.
	      if (arguments.length < 3) {
	        memo = obj[keys ? keys[index] : index];
	        index += dir;
	      }
	      return iterator(obj, iteratee, memo, keys, index, length);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  _.reduce = _.foldl = _.inject = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  _.reduceRight = _.foldr = createReduce(-1);
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, predicate, context) {
	    var key;
	    if (isArrayLike(obj)) {
	      key = _.findIndex(obj, predicate, context);
	    } else {
	      key = _.findKey(obj, predicate, context);
	    }
	    if (key !== void 0 && key !== -1) return obj[key];
	  };
	
	  // Return all the elements that pass a truth test.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    _.each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, predicate, context) {
	    return _.filter(obj, _.negate(cb(predicate)), context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Aliased as `any`.
	  _.some = _.any = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  };
	
	  // Determine if the array or object contains a given item (using `===`).
	  // Aliased as `includes` and `include`.
	  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = _.values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return _.indexOf(obj, item, fromIndex) >= 0;
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      var func = isFunc ? method : value[method];
	      return func == null ? func : func.apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, _.property(key));
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs) {
	    return _.filter(obj, _.matcher(attrs));
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.find(obj, _.matcher(attrs));
	  };
	
	  // Return the maximum element (or element-based computation).
	  _.max = function(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Shuffle a collection, using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  _.shuffle = function(obj) {
	    var set = isArrayLike(obj) ? obj : _.values(obj);
	    var length = set.length;
	    var shuffled = Array(length);
	    for (var index = 0, rand; index < length; index++) {
	      rand = _.random(0, index);
	      if (rand !== index) shuffled[index] = shuffled[rand];
	      shuffled[rand] = set[index];
	    }
	    return shuffled;
	  };
	
	  // Sample **n** random values from a collection.
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  _.sortBy = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iteratee(value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior) {
	    return function(obj, iteratee, context) {
	      var result = {};
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (isArrayLike(obj)) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
	  };
	
	  // Split a collection into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var pass = [], fail = [];
	    _.each(obj, function(value, key, obj) {
	      (predicate(value, key, obj) ? pass : fail).push(value);
	    });
	    return [pass, fail];
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[0];
	    return _.initial(array, array.length - n);
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[array.length - 1];
	    return _.rest(array, Math.max(0, array.length - n));
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, strict, startIndex) {
	    var output = [], idx = 0;
	    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
	        //flatten current level of array or arguments object
	        if (!shallow) value = flatten(value, shallow, strict);
	        var j = 0, len = value.length;
	        output.length += len;
	        while (j < len) {
	          output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  };
	
	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, false);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
	    if (!_.isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!_.contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!_.contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(flatten(arguments, true, true));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (_.contains(result, item)) continue;
	      for (var j = 1; j < argsLength; j++) {
	        if (!_.contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = flatten(arguments, true, true, 1);
	    return _.filter(array, function(value){
	      return !_.contains(rest, value);
	    });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function() {
	    return _.unzip(arguments);
	  };
	
	  // Complement of _.zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices
	  _.unzip = function(array) {
	    var length = array && _.max(array, getLength).length || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = _.pluck(array, index);
	    }
	    return result;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // Generator function to create the findIndex and findLastIndex functions
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a predicate test
	  _.findIndex = createPredicateIndexFinder(1);
	  _.findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  };
	
	  // Generator function to create the indexOf and lastIndexOf functions
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	            i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), _.isNaN);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
	  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = step || 1;
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Determines whether to execute a function as a constructor
	  // or a normal function with the provided arguments
	  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (_.isObject(result)) return result;
	    return self;
	  };
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
	    var args = slice.call(arguments, 2);
	    var bound = function() {
	      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
	    };
	    return bound;
	  };
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder, allowing any combination of arguments to be pre-filled.
	  _.partial = function(func) {
	    var boundArgs = slice.call(arguments, 1);
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  };
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var i, length = arguments.length, key;
	    if (length <= 1) throw new Error('bindAll must be passed function names');
	    for (i = 1; i < length; i++) {
	      key = arguments[i];
	      obj[key] = _.bind(obj[key], obj);
	    }
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){
	      return func.apply(null, args);
	    }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = _.partial(_.delay, _, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    if (!options) options = {};
	    var later = function() {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	    return function() {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, args, context, timestamp, result;
	
	    var later = function() {
	      var last = _.now() - timestamp;
	
	      if (last < wait && last >= 0) {
	        timeout = setTimeout(later, wait - last);
	      } else {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	          if (!timeout) context = args = null;
	        }
	      }
	    };
	
	    return function() {
	      context = this;
	      args = arguments;
	      timestamp = _.now();
	      var callNow = immediate && !timeout;
	      if (!timeout) timeout = setTimeout(later, wait);
	      if (callNow) {
	        result = func.apply(context, args);
	        context = args = null;
	      }
	
	      return result;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return _.partial(wrapper, func);
	  };
	
	  // Returns a negated version of the passed-in predicate.
	  _.negate = function(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  };
	
	  // Returns a function that will only be executed on and after the Nth call.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Returns a function that will only be executed up to (but not including) the Nth call.
	  _.before = function(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = _.partial(_.before, 2);
	
	  // Object Functions
	  // ----------------
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  function collectNonEnumProps(obj, keys) {
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve all the property names of an object.
	  _.allKeys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };
	
	  // Returns the results of applying the iteratee to each element of the object
	  // In contrast to _.map it returns an object
	  _.mapObject = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys =  _.keys(obj),
	          length = keys.length,
	          results = {},
	          currentKey;
	      for (var index = 0; index < length; index++) {
	        currentKey = keys[index];
	        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	      }
	      return results;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = createAssigner(_.allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in object(s)
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  _.extendOwn = _.assign = createAssigner(_.keys);
	
	  // Returns the first key on an object that passes a predicate test
	  _.findKey = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = _.keys(obj), key;
	    for (var i = 0, length = keys.length; i < length; i++) {
	      key = keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(object, oiteratee, context) {
	    var result = {}, obj = object, iteratee, keys;
	    if (obj == null) return result;
	    if (_.isFunction(oiteratee)) {
	      keys = _.allKeys(obj);
	      iteratee = optimizeCb(oiteratee, context);
	    } else {
	      keys = flatten(arguments, false, false, 1);
	      iteratee = function(value, key, obj) { return key in obj; };
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  };
	
	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj, iteratee, context) {
	    if (_.isFunction(iteratee)) {
	      iteratee = _.negate(iteratee);
	    } else {
	      var keys = _.map(flatten(arguments, false, false, 1), String);
	      iteratee = function(value, key) {
	        return !_.contains(keys, key);
	      };
	    }
	    return _.pick(obj, iteratee, context);
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = createAssigner(_.allKeys, true);
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  _.create = function(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) _.extendOwn(result, props);
	    return result;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  _.isMatch = function(object, attrs) {
	    var keys = _.keys(attrs), length = keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  };
	
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	      case '[object RegExp]':
	      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
	                               _.isFunction(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var keys = _.keys(a), key;
	      length = keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (_.keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = keys[length];
	        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
	    return _.keys(obj).length === 0;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) === '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
	  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) === '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return _.has(obj, 'callee');
	    };
	  }
	
	  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
	  // IE 11 (#1621), and in Safari 8 (#1929).
	  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
	    _.isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj !== +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iteratees.
	  _.identity = function(value) {
	    return value;
	  };
	
	  // Predicate-generating functions. Often useful outside of Underscore.
	  _.constant = function(value) {
	    return function() {
	      return value;
	    };
	  };
	
	  _.noop = function(){};
	
	  _.property = property;
	
	  // Generates a function for a given object that returns a given property.
	  _.propertyOf = function(obj) {
	    return obj == null ? function(){} : function(key) {
	      return obj[key];
	    };
	  };
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  _.matcher = _.matches = function(attrs) {
	    attrs = _.extendOwn({}, attrs);
	    return function(obj) {
	      return _.isMatch(obj, attrs);
	    };
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	   // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	  var unescapeMap = _.invert(escapeMap);
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped
	    var source = '(?:' + _.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	  _.escape = createEscaper(escapeMap);
	  _.unescape = createEscaper(unescapeMap);
	
	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function(object, property, fallback) {
	    var value = object == null ? void 0 : object[property];
	    if (value === void 0) {
	      value = fallback;
	    }
	    return _.isFunction(value) ? value.call(object) : value;
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  var escapeChar = function(match) {
	    return '\\' + escapes[match];
	  };
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  _.template = function(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escaper, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offest.
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    try {
	      var render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function. Start chaining a wrapped Underscore object.
	  _.chain = function(obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function(instance, obj) {
	    return instance._chain ? _(obj).chain() : obj;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    _.each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	      return result(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  _.each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxy for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	
	  _.prototype.toString = function() {
	    return '' + this._wrapped;
	  };
	
	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}.call(this));


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, Buffer) {// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	var _ = __webpack_require__(15);
	var util = __webpack_require__(4);
	var url = __webpack_require__(33);
	var stream = __webpack_require__(20);
	var Constants = __webpack_require__(12);
	var Md5Wrapper = __webpack_require__(34);
	var StorageUtilities = __webpack_require__(63);
	var SR = __webpack_require__(25);
	
	/**
	* Trim the default port in the url.
	*
	* @param {string} uri The URI to be encoded.
	* @return {string} The URI without defualt port.
	*/
	exports.trimPortFromUri = function (uri) {
	  var uri = url.parse(uri);
	  if ((uri.protocol === Constants.HTTPS && uri.port == Constants.DEFAULT_HTTPS_PORT) || (uri.protocol === Constants.HTTP && uri.port == Constants.DEFAULT_HTTP_PORT)) {
	    uri.host = uri.hostname;
	  }
	  return url.format(uri);
	};
	
	/**
	* Returns the number of keys (properties) in an object.
	*
	* @param {object} value The object which keys are to be counted.
	* @return {number} The number of keys in the object.
	*/
	exports.objectKeysLength = function (value) {
	  if (!value) {
	    return 0;
	  }
	
	  return _.keys(value).length;
	};
	
	/**
	* Checks if in a browser environment.
	*
	* @return {bool} True if in a browser environment, false otherwise.
	*/
	exports.isBrowser = function () {
	  return typeof window !== 'undefined';
	};
	
	/**
	* Checks if in IE.
	*
	* @return {bool} True if in IE, false otherwise.
	*/
	exports.isIE = function () {
	  if (!exports.isBrowser()) {
	    return false;
	  }
	
	  var ua = window.navigator.userAgent;
	  var msie = ua.indexOf('MSIE ');
	  var trident = ua.indexOf('Trident/');
	  return msie > 0 || trident > 0;
	};
	
	/**
	* Checks if in a 32bit Node.js environment.
	*
	* @return {bool} True if in a 32bit Node.js environment, false otherwise.
	*/
	exports.is32 = function () {
	  return !exports.isBrowser() && process.arch === 'ia32';
	};
	
	/**
	* Checks if a value is null or undefined.
	*
	* @param {object} value The value to check for null or undefined.
	* @return {bool} True if the value is null or undefined, false otherwise.
	*/
	exports.objectIsNull = function (value) {
	  return _.isNull(value) || _.isUndefined(value);
	};
	
	/**
	* Checks if an object is empty.
	*
	* @param {object} object The object to check if it is null.
	* @return {bool} True if the object is empty, false otherwise.
	*/
	exports.objectIsEmpty = function (object) {
	  return _.isEmpty(object);
	};
	
	/**
	* Determines if an object contains an integer number.
	*
	* @param {object}  value  The object to assert.
	* @return {bool} True if the object contains an integer number; false otherwise.
	*/
	exports.objectIsInt = function (value) {
	  return typeof value === 'number' && parseFloat(value) == parseInt(value, 10) && !isNaN(value);
	};
	
	/**
	* Determines if an object is a NaN.
	*
	* @param {object}  value  The object to assert.
	* @return {bool} True if the object is a NaN; false otherwise.
	*/
	exports.objectIsNaN = function (value) {
	  return typeof(value) === 'number' && isNaN(value);
	};
	
	/**
	* Checks if an object is a string.
	*
	* @param {object} object The object to check if it is a string.
	* @return {bool} True if the object is a string, false otherwise.
	*/
	exports.objectIsString = function (object) {
	  return _.isString(object);
	};
	
	/**
	* Check if an object is a function
	* @param {object} object The object to check whether it is function
	* @return {bool} True if the specified object is function, otherwise false
	*/
	exports.objectIsFunction = function (object) {
	  return _.isFunction(object);
	};
	
	
	/**
	* Front zero padding of string to sepcified length
	*/
	exports.zeroPaddingString = function(str, len) {
	  var paddingStr = '0000000000' + str;
	  if(paddingStr.length < len) {
	    return exports.zeroPaddingString(paddingStr, len);
	  } else {
	    return paddingStr.substr(-1 * len);
	  }
	};
	
	/**
	* Checks if a value is an empty string, null or undefined.
	*
	* @param {object} value The value to check for an empty string, null or undefined.
	* @return {bool} True if the value is an empty string, null or undefined, false otherwise.
	*/
	exports.stringIsEmpty = function (value) {
	  return _.isNull(value) || _.isUndefined(value) || value === '';
	};
	
	/**
	* Checks if a value is null, empty, undefined or consists only of white-space characters.
	*
	* @param {object} value The value to check for null, empty, undefined and white-space only characters.
	* @return {bool} True if the value is an empty string, null, undefined, or consists only of white-space characters, false otherwise.
	*/
	exports.IsNullOrEmptyOrUndefinedOrWhiteSpace = function (value) {
	  if(_.isNull(value) || _.isUndefined(value) || value === '') {
	    return true;
	  }
	
	  if(_.isString(value) && value.trim().length === 0) {
	    return true;
	  }
	
	  return false;
	};
	
	/**
	* Formats a text replacing '?' by the arguments.
	*
	* @param {string}       text      The string where the ? should be replaced.
	* @param {array}        arguments Value(s) to insert in question mark (?) parameters.
	* @return {string}
	*/
	exports.stringFormat = function (text) {
	  if (arguments.length > 1) {
	    for (var i = 1; text.indexOf('?') !== -1; i++) {
	      text = text.replace('?', arguments[i]);
	    }
	  }
	
	  return text;
	};
	
	/**
	* Determines if a string starts with another.
	*
	* @param {string}       text      The string to assert.
	* @param {string}       prefix    The string prefix.
	* @return {Bool} True if the string starts with the prefix; false otherwise.
	*/
	exports.stringStartsWith = function (text, prefix) {
	  if (_.isNull(prefix)) {
	    return true;
	  }
	
	  return text.substr(0, prefix.length) === prefix;
	};
	
	/**
	* Determines if a string ends with another.
	*
	* @param {string}       text      The string to assert.
	* @param {string}       suffix    The string suffix.
	* @return {Bool} True if the string ends with the suffix; false otherwise.
	*/
	exports.stringEndsWith = function (text, suffix) {
	  if (_.isNull(suffix)) {
	    return true;
	  }
	
	  return text.substr(text.length - suffix.length) === suffix;
	};
	
	/**
	* Removes the BOM from a string.
	*
	* @param {string} str The string from where the BOM is to be removed
	* @return {string} The string without the BOM.
	*/
	exports.removeBOM = function (str) {
	  if (str.charCodeAt(0) === 0xfeff || str.charCodeAt(0) === 0xffef) {
	    str = str.substring(1);
	  }
	
	  return str;
	};
	
	/**
	* Merges multiple objects.
	*
	* @param {object} object The objects to be merged
	* @return {object} The merged object.
	*/
	exports.merge = function () {
	  return _.extend.apply(this, arguments);
	};
	
	/**
	* Checks if a value exists in an array. The comparison is done in a case
	* insensitive manner.
	*
	* @param {string} needle     The searched value.
	* @param {array}  haystack   The array.
	*
	* @static
	*
	* @return {boolean}
	*/
	exports.inArrayInsensitive = function (needle, haystack) {
	  return _.contains(_.map(haystack, function (h) { return h.toLowerCase(); }), needle.toLowerCase());
	};
	
	/**
	* Returns the specified value of the key passed from object and in case that
	* this key doesn't exist, the default value is returned. The key matching is
	* done in a case insensitive manner.
	*
	* @param {string} key      The array key.
	* @param {object} haystack The object to be used.
	* @param {mix}    default  The value to return if $key is not found in $array.
	*
	* @static
	*
	* @return mix
	*/
	exports.tryGetValueInsensitive = function (key, haystack, defaultValue) {
	  if (haystack) {
	    for (var i in haystack) {
	      if (haystack.hasOwnProperty(i) && i.toString().toLowerCase() === key.toString().toLowerCase()) {
	        return haystack[i];
	      }
	    }
	  }
	
	  return defaultValue;
	};
	
	/**
	* Returns the value in a chained object.
	*
	* @param {object} object   The object with the values.
	* @param {array}  keys     The keys.
	* @param {mix}    default  The value to return if $key is not found in $array.
	*
	* @static
	*
	* @return mix
	*/
	exports.tryGetValueChain = function (object, keys, defaultValue) {
	  if (keys.length === 0) {
	    return object;
	  }
	
	  var currentKey = keys.shift();
	  if (object && object[currentKey] !== undefined) {
	    return exports.tryGetValueChain(object[currentKey], keys, defaultValue);
	  }
	
	  return defaultValue;
	};
	
	/**
	* Set the value of an inner property of an object.
	*
	* @param {object} object   The target object.
	* @param {array}  keys     The property chain keys.
	* @param {mix}    object   The value to be set.
	*
	* @static
	
	* @example
	* // Set targetObject.propA.propB to 'testValue'
	* var targetObject = {};
	* util.setObjectInnerPropertyValue(targetObject, ['propA', 'propB'], 'testValue');
	*/
	exports.setObjectInnerPropertyValue = function(object, propertyChainKeys, value){
	  if(!object || propertyChainKeys.length < 1) {
	    return;
	  }
	
	  var currentKey = propertyChainKeys.shift();
	  if(propertyChainKeys.length === 0) {
	    object[currentKey] = value;
	    return;
	  }
	  
	  if (!object[currentKey]) {
	    object[currentKey] = {};
	  }
	  
	  exports.setObjectInnerPropertyValue(object[currentKey], propertyChainKeys, value);
	};
	
	/**
	* Rounds a date off to seconds.
	*
	* @param {Date} a date
	* @return {string} the date in ISO8061 format, with no milliseconds component
	*/
	exports.truncatedISO8061Date = function (date) {
	  var dateString = date.toISOString();
	  return dateString.substring(0, dateString.length - 5) + 'Z';
	};
	
	exports.normalizeArgs = function (optionsOrCallback, callback, result) {
	  var options = {};
	  if(_.isFunction(optionsOrCallback) && !callback) {
	    callback = optionsOrCallback;
	  } else if (optionsOrCallback) {
	    options = optionsOrCallback;
	  }
	
	  result(options, callback);
	};
	
	exports.getNodeVersion = function () {
	  var parsedVersion = process.version.split('.');
	  return {
	    major: parseInt(parsedVersion[0].substr(1), 10),
	    minor: parseInt(parsedVersion[1], 10),
	    patch: parseInt(parsedVersion[2], 10)
	  };
	};
	
	/**
	* Calculate md5sum for the stream
	* @ignore
	*/
	exports.calculateMD5 = function(readStream, bufferLength, options, callback) {
	  var internalBuff = new Buffer(bufferLength);
	  var index = 0;
	  var internalHash = new Md5Wrapper().createMd5Hash();
	  readStream.on('data', function(data) {
	    if (index + data.length > bufferLength) {
	      var copyLength = bufferLength - index;
	      if (copyLength > 0) {
	        data = data.slice(0, copyLength);
	        data.copy(internalBuff, index);
	        internalHash.update(data);
	        index += copyLength;
	      }
	      readStream.emit('end');
	    } else {
	      data.copy(internalBuff, index);
	      internalHash.update(data);
	      index += data.length;
	    }
	  }).on('end', function() {
	    if (!readStream.endEmitted) {
	      internalBuff = internalBuff.slice(0, index);
	      var contentMD5 = internalHash.digest('base64');
	      // Set the flag to be compatible with Nodejs 0.10 which will keep emitting data from 
	      // the file stream when the read stream has emitted the end event from its listner. 
	      readStream.endEmitted = true;
	      callback(internalBuff, contentMD5);
	    }
	  });
	};
	
	/**
	* Whether the content of buffer is all zero
	*/
	exports.isBufferAllZero = function (buffer) {
	  for(var i = 0, len = buffer.length; i < len; i++) {
	    if (buffer[i] !== 0) {
	      return false;
	    }
	  }
	  return true;
	};
	
	/**
	* Write zero to stream
	*/
	var zeroBuffer = null;
	exports.writeZerosToStream = function (stream, length, md5Hash, progressCallback, callback) {
	  var defaultBufferSize = Constants.BlobConstants.DEFAULT_WRITE_BLOCK_SIZE_IN_BYTES;
	  var bufferSize = Math.min(defaultBufferSize, length);
	  var remaining = length - bufferSize;
	  var buffer = null;
	  if (bufferSize == defaultBufferSize) {
	    if (!zeroBuffer) {
	      zeroBuffer = new Buffer(defaultBufferSize);
	      zeroBuffer.fill(0);
	    }
	    buffer = zeroBuffer;
	  } else {
	    buffer = new Buffer(bufferSize);
	    buffer.fill(0);
	  }
	  if (md5Hash) {
	    md5Hash.update(buffer);
	  }
	  //We can only write the entire buffer to stream instead of part of buffer.
	  return stream.write(buffer, function () {
	    if (exports.objectIsFunction(progressCallback)) {
	      progressCallback(null, buffer.length);
	    }
	    buffer = null;
	    if (remaining > 0) {
	      exports.writeZerosToStream(stream, remaining, md5Hash, progressCallback, callback);
	    } else if (exports.objectIsFunction(callback)) {
	      callback(null, null);
	    }
	  });
	};
	
	/**
	* Calculate md5sum for the content
	*/
	exports.getContentMd5 = function (content, encoding) {
	  if (!encoding) encoding = 'base64';
	  var internalHash = new Md5Wrapper().createMd5Hash();
	  internalHash.update(content, 'utf8');
	  return internalHash.digest(encoding);
	};
	
	exports.getNextLocation = function(lastLocation, locationMode) {
	  switch(locationMode) {
	  case StorageUtilities.LocationMode.PRIMARY_ONLY:
	    return Constants.StorageLocation.PRIMARY;
	  case StorageUtilities.LocationMode.SECONDARY_ONLY:
	    return Constants.StorageLocation.SECONDARY;
	  case StorageUtilities.LocationMode.PRIMARY_THEN_SECONDARY:
	  case StorageUtilities.LocationMode.SECONDARY_THEN_PRIMARY:
	    return (lastLocation === Constants.StorageLocation.PRIMARY) ? Constants.StorageLocation.SECONDARY : Constants.StorageLocation.PRIMARY;
	  default:
	    throw new RangeError(util.format(SR.ARGUMENT_OUT_OF_RANGE_ERROR, 'locationMode', locationMode));
	  }
	};
	
	exports.getNextListingLocationMode = function (token) {
	  if(_.isNull(token) || _.isUndefined(token)) {
	    return Constants.RequestLocationMode.PRIMARY_OR_SECONDARY;
	  }
	  else {
	    switch (token.targetLocation) {
	    case Constants.StorageLocation.PRIMARY:
	      return Constants.RequestLocationMode.PRIMARY_ONLY;
	    case Constants.StorageLocation.SECONDARY:
	      return Constants.RequestLocationMode.SECONDARY_ONLY;
	    default:
	      throw new RangeError(util.format(SR.ARGUMENT_OUT_OF_RANGE_ERROR, 'targetLocation', token.targetLocation));
	    }
	  }
	};
	
	exports.isStreamPaused = function (object) {
	  if (object instanceof stream) {
	    return object._paused === true || (object._readableState && object._readableState.flowing === false);
	  }
	  return false;
	};
	
	/**
	* Parse copy progress string in the format of bytesCopied/totalBytes
	*/
	exports.parseCopyProgress = function (progress) {
	  if (typeof progress != 'string' || progress.indexOf('/') === -1) {
	    return {};
	  }
	  
	  var progressInfo = progress.split('/');
	  return { bytesCopied: progressInfo[0], totalBytes: progressInfo[1] };
	};
	
	/**
	* The list of the properties should be normalized with explicit mapping
	*/
	var normalizePropertyNameExceptionList = {
	  'x-ms-blob-sequence-number': 'sequenceNumber',
	  'content-Type': 'contentSettings.contentType',
	  'content-Encoding': 'contentSettings.contentEncoding',
	  'content-Language': 'contentSettings.contentLanguage',
	  'cache-Control': 'contentSettings.cacheControl',
	  'content-Disposition': 'contentSettings.contentDisposition',
	  'content-MD5': 'contentSettings.contentMD5',
	  'leaseId': 'lease.id',
	  'leaseStatus': 'lease.status',
	  'leaseDuration': 'lease.duration',
	  'leaseState': 'lease.state',
	  'copyId': 'copy.id',
	  'copyStatus': 'copy.status',
	  'copySource': 'copy.source',
	  'copyProgress': 'copy.progress',
	  'copyCompletionTime': 'copy.completionTime',
	  'copyStatusDescription': 'copy.statusDescription',
	  'copyDestinationSnapshot': 'copy.destinationSnapshot',
	  'publicAccess': 'publicAccessLevel',
	  'incrementalCopy': 'isIncrementalCopy'
	};
	
	/**
	* Normalize the property name from XML to keep consistent with 
	* the name defined in the property headers
	*/
	exports.normalizePropertyNameFromXML = function (propertyName) {
	  if (this.IsNullOrEmptyOrUndefinedOrWhiteSpace(propertyName)) {
	    return '';
	  }
	  
	  propertyName = propertyName.trim();
	  propertyName = propertyName[0].toLowerCase() + propertyName.substring(1);
	  // So far the cases are:
	  //   for the 'last-modified' property in listing resources
	  //   for the 'content-*' properties in listing resources
	  //   for the 'cache-control' property in listing blobs
	  //   for the 'x-ms-blob-sequence-number' in listing blobs
	  if (propertyName in normalizePropertyNameExceptionList) {
	    return normalizePropertyNameExceptionList[propertyName];
	  } else if (propertyName.toLowerCase().indexOf('-') != -1) {
	    return propertyName.replace('-', '');
	  } else {
	    return propertyName;
	  }
	};
	
	/**
	* Set the property value from XML
	*/
	exports.setPropertyValueFromXML = function (result, xmlNode, toNormalize) {
	  for (var subPropertyName in xmlNode) {
	    if (xmlNode.hasOwnProperty(subPropertyName)) {
	      if (toNormalize) {
	        var propertyChain = this.normalizePropertyNameFromXML(subPropertyName).split('.');
	        exports.setObjectInnerPropertyValue(result, propertyChain, xmlNode[subPropertyName]);
	      } else {
	        result[subPropertyName.toLowerCase()] = xmlNode[subPropertyName];
	      }
	      
	      if (subPropertyName.toLowerCase() === 'copyprogress') {
	        var info = this.parseCopyProgress(xmlNode[subPropertyName]);
	        exports.setObjectInnerPropertyValue(result, ['copy', 'bytesCopied'], parseInt(info.bytesCopied));
	        exports.setObjectInnerPropertyValue(result, ['copy', 'totalBytes'], parseInt(info.totalBytes));
	      }
	    }
	  }
	};
	
	/**
	 * Filter out non-reserved properties from options
	 */
	exports.filterOutNonReservedProperties = function (reserved, options) {
	  var nonReservedProperties = {};
	  if (options) {
	    for (var prop in options) {
	      if (options.hasOwnProperty(prop)) {
	        var isReserved = reserved.hasOwnProperty(prop);
	        var isFunction = typeof options[prop] === 'function';
	        if (!isReserved && !isFunction) {
	          nonReservedProperties[prop] = options[prop];
	        }
	      }
	    }
	  }
	  return nonReservedProperties;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(2).Buffer))

/***/ },
/* 17 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 18 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 19 */
[599, 76, 76, 252, 253, 61, 256, 254, 257],
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(14).EventEmitter;
	var inherits = __webpack_require__(13);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(503);
	Stream.Writable = __webpack_require__(505);
	Stream.Duplex = __webpack_require__(501);
	Stream.Transform = __webpack_require__(504);
	Stream.PassThrough = __webpack_require__(502);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Immutable = factory());
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step !== 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      if (o !== o || o === Infinity) {
	        return 0;
	      }
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
	      return emptyMap().withMutations(function(map ) {
	        for (var i = 0; i < keyValues.length; i += 2) {
	          if (i + 1 >= keyValues.length) {
	            throw new Error('Missing value for key: ' + keyValues[i]);
	          }
	          map.set(keyValues[i], keyValues[i + 1]);
	        }
	      });
	    };
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      if (end === Infinity) {
	        end = originalSize;
	      } else {
	        end = end | 0;
	      }
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      if (this._map && !this._map.has(k)) {
	        var defaultVal = this._defaultValues[k];
	        if (v === defaultVal) {
	          return this;
	        }
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findEntry: function(predicate, context, notSetValue) {
	      var found = notSetValue;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    findLastEntry: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toKeyedSeq().reverse().findKey(predicate, context);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.toKeyedSeq().reverse().keyOf(searchValue);
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.lastKeyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var entry = this.findLastEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    keySeq: function() {
	      return Range(0, this.size);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : String(value);
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(7);
	
	var CallbackQueue = __webpack_require__(169);
	var PooledClass = __webpack_require__(38);
	var ReactFeatureFlags = __webpack_require__(174);
	var ReactReconciler = __webpack_require__(47);
	var Transaction = __webpack_require__(68);
	
	var invariant = __webpack_require__(3);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 25 */
/***/ function(module, exports) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	exports = module.exports;
	
	var SR = {
	  ANONYMOUS_ACCESS_BLOBSERVICE_ONLY: 'Anonymous access is only valid for the BlobService.',
	  ARGUMENT_NULL_OR_EMPTY: 'The argument must not be null or an empty string. Argument name: %s.',
	  ARGUMENT_NULL_OR_UNDEFINED: 'The argument must not be null or undefined. Argument name: %s.',
	  ARGUMENT_OUT_OF_RANGE_ERROR: 'The argument is out of range. Argument name: %s, Value passed: %s.',
	  BATCH_ONE_PARTITION_KEY: 'All entities in the batch must have the same PartitionKey value.',
	  BATCH_ONE_RETRIEVE: 'If a retrieve operation is part of a batch, it must be the only operation in the batch.',
	  BATCH_TOO_LARGE: 'Batches must not contain more than 100 operations.',
	  BLOB_INVALID_SEQUENCE_NUMBER: 'The sequence number may not be specified for an increment operation.',
	  BLOB_TYPE_MISMATCH: 'Blob type of the blob reference doesn\'t match blob type of the blob.',
	  CANNOT_CREATE_SAS_WITHOUT_ACCOUNT_KEY: 'Cannot create Shared Access Signature unless the Account Name and Key are used to create the ServiceClient.',
	  CONTENT_LENGTH_MISMATCH: 'An incorrect number of bytes was read from the connection. The connection may have been closed.',
	  CONTENT_TYPE_MISSING: 'Content-Type response header is missing or invalid.',
	  EMPTY_BATCH: 'Batch must not be empty.',
	  EXCEEDED_SIZE_LIMITATION: 'Upload exceeds the size limitation. Max size is %s but the current size is %s',
	  HASH_MISMATCH: 'Hash mismatch (integrity check failed), Expected value is %s, retrieved %s.',
	  INCORRECT_ENTITY_KEYS: 'PartitionKey and RowKey must be specified as strings in the entity object.',
	  INVALID_BLOB_LENGTH: 'createBlockBlobFromText requires the size of text to be less than 64MB. Please use createBlockBlobFromLocalFile or createBlockBlobFromStream to upload large blobs.',
	  INVALID_CONNECTION_STRING: 'Connection strings must be of the form "key1=value1;key2=value2".',
	  INVALID_CONNECTION_STRING_BAD_KEY: 'Connection string contains unrecognized key: "%s"',
	  INVALID_CONNECTION_STRING_DUPLICATE_KEY: 'Connection string contains duplicate key: "%s"',
	  INVALID_CONNECTION_STRING_EMPTY_KEY: 'Connection strings must not contain empty keys.',
	  INVALID_DELETE_SNAPSHOT_OPTION: 'The deleteSnapshots option cannot be included when deleting a specific snapshot using the snapshotId option.',
	  INVALID_EDM_TYPE: 'The value \'%s\' does not match the type \'%s\'.',
	  INVALID_FILE_LENGTH: 'createFileFromText requires the size of text to be less than 4MB. Please use createFileFromLocalFile or createFileFromStream to upload large files.',
	  INVALID_FILE_RANGE_FOR_UPDATE: 'Range size should be less than 4MB for a file range update operation.',
	  INVALID_HEADERS: 'Headers are not supported in the 2012-02-12 version.',
	  INVALID_MESSAGE_ID: 'Message ID cannot be null or undefined for deleteMessage and updateMessage operations.',
	  INVALID_PAGE_BLOB_LENGTH: 'Page blob length must be multiple of 512.',
	  INVALID_PAGE_END_OFFSET: 'Page end offset must be multiple of 512.',
	  INVALID_PAGE_RANGE_FOR_UPDATE: 'Page range size should be less than 4MB for a page update operation.',
	  INVALID_PAGE_START_OFFSET: 'Page start offset must be multiple of 512.',
	  INVALID_POP_RECEIPT: 'Pop Receipt cannot be null or undefined for deleteMessage and updateMessage operations.',
	  INVALID_PROPERTY_RESOLVER: 'The specified property resolver returned an invalid type. %s:{_:%s,$:%s }',
	  INVALID_RANGE_FOR_MD5: 'The requested range should be less than 4MB when contentMD5 is expected from the server',
	  INVALID_SAS_VERSION: 'SAS Version ? is invalid. Valid versions include: ?.',
	  INVALID_SAS_TOKEN: 'The SAS token should not contain api-version.',
	  INVALID_SIGNED_IDENTIFIERS: 'Signed identifiers need to be a hash object with key as the id and the value as the access policy.',
	  INVALID_STREAM_LENGTH: 'The length of the provided stream is invalid.',
	  INVALID_STRING_ERROR: 'Invalid string error.',
	  INVALID_TABLE_OPERATION: 'Operation not found: %s',
	  INVALID_TEXT_LENGTH: 'The length of the provided text is invalid.',
	  MAXIMUM_EXECUTION_TIMEOUT_EXCEPTION: 'The client could not finish the operation within specified maximum execution timeout.',
	  MD5_NOT_POSSIBLE: 'MD5 cannot be calculated for an existing blob because it would require reading the existing data. Please disable storeBlobContentMD5.',
	  MD5_NOT_PRESENT_ERROR: 'MD5 does not exist. If you do not want to force validation, please disable useTransactionalMD5.',
	  METADATA_KEY_INVALID: 'The key for one of the metadata key-value pairs is null, empty, or whitespace.',
	  METADATA_VALUE_INVALID: 'The value for one of the metadata key-value pairs is null, empty, or whitespace.',
	  NO_CREDENTIALS_PROVIDED: 'Credentials must be provided when creating a service client.',
	  PRIMARY_ONLY_COMMAND: 'This operation can only be executed against the primary storage location.',
	  QUERY_OPERATOR_REQUIRES_WHERE: '%s operator needs to be used after where.',
	  SECONDARY_ONLY_COMMAND: 'This operation can only be executed against the secondary storage location.',
	  STORAGE_HOST_LOCATION_REQUIRED: 'The host for the storage service must be specified.',
	  STORAGE_HOST_MISSING_LOCATION: 'The host for the target storage location is not specified. Please consider changing the request\'s location mode.',
	  TYPE_NOT_SUPPORTED: 'Type not supported when sending data to the service: ',
	  MAX_BLOB_SIZE_CONDITION_NOT_MEET: 'Append block data should not exceed the maximum blob size condition value.',
	};
	
	module.exports = SR;

/***/ },
/* 26 */
/***/ function(module, exports) {

	var hasOwn = Object.prototype.hasOwnProperty;
	var toString = Object.prototype.toString;
	
	function isPlainObject(obj) {
		if (!obj || toString.call(obj) !== '[object Object]' || obj.nodeType || obj.setInterval)
			return false;
	
		var has_own_constructor = hasOwn.call(obj, 'constructor');
		var has_is_property_of_method = hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
		// Not own constructor property must be Object
		if (obj.constructor && !has_own_constructor && !has_is_property_of_method)
			return false;
	
		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own.
		var key;
		for ( key in obj ) {}
	
		return key === undefined || hasOwn.call( obj, key );
	};
	
	module.exports = function extend() {
		var options, name, src, copy, copyIsArray, clone,
		    target = arguments[0] || {},
		    i = 1,
		    length = arguments.length,
		    deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
			target = arguments[1] || {};
			// skip the boolean and the target
			i = 2;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && typeof target !== "function") {
			target = {};
		}
	
		for ( ; i < length; i++ ) {
			// Only deal with non-null/undefined values
			if ( (options = arguments[ i ]) != null ) {
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( isPlainObject(copy) || (copyIsArray = Array.isArray(copy)) ) ) {
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && Array.isArray(src) ? src : [];
	
						} else {
							clone = src && isPlainObject(src) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var PooledClass = __webpack_require__(38);
	
	var emptyFunction = __webpack_require__(18);
	var warning = __webpack_require__(5);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.connectAdvanced = exports.createProvider = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(480);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connectAdvanced = __webpack_require__(190);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _connect = __webpack_require__(481);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider2.default;
	exports.createProvider = _Provider.createProvider;
	exports.connectAdvanced = _connectAdvanced2.default;
	exports.connect = _connect2.default;

/***/ },
/* 29 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Module dependencies.
	var util = __webpack_require__(4);
	var _ = __webpack_require__(15);
	
	function captureStackTrace(targetObject, constructorOpt) {
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(targetObject, constructorOpt);
	  }
	}
	
	function ArgumentError(argumentName, message) {
	  captureStackTrace(this, this.constructor); 
	  this.name = this.constructor.name;
	  this.argumentName = argumentName;
	  this.message = message || util.format('Invalid or missing argument supplied: %s', argumentName);
	}
	util.inherits(ArgumentError, Error);
	
	function ArgumentNullError(argumentName, message) {
	  captureStackTrace(this, this.constructor); 
	  this.name = this.constructor.name;
	  this.argumentName = argumentName;
	  this.message = message || util.format('Missing argument: %s', argumentName);
	}
	
	util.inherits(ArgumentNullError, Error);
	
	function StorageError(message, properties) {
	  captureStackTrace(this, this.constructor); 
	  this.name = this.constructor.name;
	  this.message = message;
	  
	  if(properties){
	    _.extend(this, properties);
	  }
	}
	
	util.inherits(StorageError, Error);
	
	function TimeoutError(message) {
	  captureStackTrace(this, this.constructor); 
	  this.name = this.constructor.name;
	  this.message = message;
	}
	
	util.inherits(TimeoutError, Error);
	
	module.exports.ArgumentError = ArgumentError;
	module.exports.ArgumentNullError = ArgumentNullError;
	module.exports.StorageError = StorageError;
	module.exports.TimeoutError = TimeoutError;
	module.exports.captureStackTrace = captureStackTrace;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setProjectConfig = exports.selectProject = exports.setEditorPath = exports.showRunningInfo = exports.appendConsoleLog = exports.stopSample = exports.runSample = exports.setComponentSize = exports.switchGuide = exports.setSensorData = exports.switchBoard = undefined;
	
	var _actionTypes = __webpack_require__(53);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// board
	var switchBoard = exports.switchBoard = function switchBoard(dispatch, on) {
	    dispatch({
	        type: types.SWITCH_ON_OFF_BOARD,
	        data: on
	    });
	};
	
	var setSensorData = exports.setSensorData = function setSensorData(dispatch, sensor, data) {
	    dispatch({
	        type: types.SET_SENSOR_DATA,
	        sensor: sensor,
	        data: data
	    });
	};
	
	// main
	var switchGuide = exports.switchGuide = function switchGuide(dispatch, id) {
	    dispatch({
	        type: types.SWITCH_HELP,
	        data: id
	    });
	};
	
	var setComponentSize = exports.setComponentSize = function setComponentSize(dispatch, id, size) {
	    dispatch({
	        type: types.SET_COMPONENT_SIZE,
	        id: id,
	        size: size
	    });
	};
	
	var runSample = exports.runSample = function runSample(dispatch) {
	    switchBoard(dispatch, true);
	    dispatch({
	        type: types.RUN_SAMPLE
	    });
	};
	
	var stopSample = exports.stopSample = function stopSample(dispatch) {
	    dispatch({
	        type: types.STOP_SAMPLE
	    });
	    switchBoard(dispatch, false);
	};
	
	var appendConsoleLog = exports.appendConsoleLog = function appendConsoleLog(dispatch, data) {
	    dispatch({
	        type: types.APPEND_CONSOLE_LOG,
	        data: data
	    });
	};
	
	var showRunningInfo = exports.showRunningInfo = function showRunningInfo(dispatch, data) {
	    dispatch({
	        type: types.SHOW_RUNNING_INFO,
	        data: data
	    });
	};
	
	var setEditorPath = exports.setEditorPath = function setEditorPath(dispatch, path) {
	    dispatch({
	        type: types.SET_EDITOR_PATH,
	        path: path
	    });
	};
	
	var selectProject = exports.selectProject = function selectProject(dispatch, name) {
	    dispatch({
	        type: types.SELECT_PROJECT,
	        data: name
	    });
	    stopSample(dispatch);
	};
	
	var setProjectConfig = exports.setProjectConfig = function setProjectConfig(dispatch, configObject) {
	    dispatch({
	        type: types.SET_PROJECT_CONFIG,
	        data: configObject
	    });
	};

/***/ },
/* 32 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PROJECT = exports.PROJECT = 0;
	var EDITOR = exports.EDITOR = 1;
	var CONFIG_CLOUD = exports.CONFIG_CLOUD = 2;
	var CONFIG_LOCAL = exports.CONFIG_LOCAL = 3;
	var CONFIG_ERROR = exports.CONFIG_ERROR = 10;
	var CONTROL_BAR = exports.CONTROL_BAR = 4;
	var BOARD = exports.BOARD = 5;
	var CONSOLE = exports.CONSOLE = 6;
	var END = exports.END = 7;
	
	var CLOSE = exports.CLOSE = -1;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var punycode = __webpack_require__(531);
	var util = __webpack_require__(532);
	
	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;
	
	exports.Url = Url;
	
	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}
	
	// Reference: RFC 3986, RFC 1808, RFC 2396
	
	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	    portPattern = /:[0-9]*$/,
	
	    // Special case for a simple path URL
	    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
	
	    // RFC 2396: characters reserved for delimiting URLs.
	    // We actually just auto-escape these.
	    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
	
	    // RFC 2396: characters not allowed for various reasons.
	    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
	
	    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	    autoEscape = ['\''].concat(unwise),
	    // Characters that are never ever allowed in a hostname.
	    // Note that any invalid chars are also handled, but these
	    // are the ones that are *expected* to be seen, so we fast-path
	    // them.
	    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	    hostEndingChars = ['/', '?', '#'],
	    hostnameMaxLen = 255,
	    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
	    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
	    // protocols that can allow "unsafe" and "unwise" chars.
	    unsafeProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that never have a hostname.
	    hostlessProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that always contain a // bit.
	    slashedProtocol = {
	      'http': true,
	      'https': true,
	      'ftp': true,
	      'gopher': true,
	      'file': true,
	      'http:': true,
	      'https:': true,
	      'ftp:': true,
	      'gopher:': true,
	      'file:': true
	    },
	    querystring = __webpack_require__(43);
	
	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && util.isObject(url) && url instanceof Url) return url;
	
	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}
	
	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  if (!util.isString(url)) {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }
	
	  // Copy chrome, IE, opera backslash-handling behavior.
	  // Back slashes before the query string get converted to forward slashes
	  // See: https://code.google.com/p/chromium/issues/detail?id=25916
	  var queryIndex = url.indexOf('?'),
	      splitter =
	          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
	      uSplit = url.split(splitter),
	      slashRegex = /\\/g;
	  uSplit[0] = uSplit[0].replace(slashRegex, '/');
	  url = uSplit.join(splitter);
	
	  var rest = url;
	
	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();
	
	  if (!slashesDenoteHost && url.split('#').length === 1) {
	    // Try fast path regexp
	    var simplePath = simplePathPattern.exec(rest);
	    if (simplePath) {
	      this.path = rest;
	      this.href = rest;
	      this.pathname = simplePath[1];
	      if (simplePath[2]) {
	        this.search = simplePath[2];
	        if (parseQueryString) {
	          this.query = querystring.parse(this.search.substr(1));
	        } else {
	          this.query = this.search.substr(1);
	        }
	      } else if (parseQueryString) {
	        this.search = '';
	        this.query = {};
	      }
	      return this;
	    }
	  }
	
	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }
	
	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }
	
	  if (!hostlessProtocol[proto] &&
	      (slashes || (proto && !slashedProtocol[proto]))) {
	
	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c
	
	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.
	
	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	
	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }
	
	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }
	
	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      hostEnd = rest.length;
	
	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);
	
	    // pull out port.
	    this.parseHost();
	
	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    this.hostname = this.hostname || '';
	
	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = this.hostname[0] === '[' &&
	        this.hostname[this.hostname.length - 1] === ']';
	
	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) continue;
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }
	
	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }
	
	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a punycoded representation of "domain".
	      // It only converts parts of the domain name that
	      // have non-ASCII characters, i.e. it doesn't matter if
	      // you call it with a domain that already is ASCII-only.
	      this.hostname = punycode.toASCII(this.hostname);
	    }
	
	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;
	
	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }
	
	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {
	
	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      if (rest.indexOf(ae) === -1)
	        continue;
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }
	
	
	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) this.pathname = rest;
	  if (slashedProtocol[lowerProto] &&
	      this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }
	
	  //to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }
	
	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};
	
	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (util.isString(obj)) obj = urlParse(obj);
	  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
	  return obj.format();
	}
	
	Url.prototype.format = function() {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }
	
	  var protocol = this.protocol || '',
	      pathname = this.pathname || '',
	      hash = this.hash || '',
	      host = false,
	      query = '';
	
	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ?
	        this.hostname :
	        '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }
	
	  if (this.query &&
	      util.isObject(this.query) &&
	      Object.keys(this.query).length) {
	    query = querystring.stringify(this.query);
	  }
	
	  var search = this.search || (query && ('?' + query)) || '';
	
	  if (protocol && protocol.substr(-1) !== ':') protocol += ':';
	
	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (this.slashes ||
	      (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
	  } else if (!host) {
	    host = '';
	  }
	
	  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
	  if (search && search.charAt(0) !== '?') search = '?' + search;
	
	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');
	
	  return protocol + host + pathname + search + hash;
	};
	
	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}
	
	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};
	
	function urlResolveObject(source, relative) {
	  if (!source) return relative;
	  return urlParse(source, false, true).resolveObject(relative);
	}
	
	Url.prototype.resolveObject = function(relative) {
	  if (util.isString(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }
	
	  var result = new Url();
	  var tkeys = Object.keys(this);
	  for (var tk = 0; tk < tkeys.length; tk++) {
	    var tkey = tkeys[tk];
	    result[tkey] = this[tkey];
	  }
	
	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;
	
	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }
	
	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    var rkeys = Object.keys(relative);
	    for (var rk = 0; rk < rkeys.length; rk++) {
	      var rkey = rkeys[rk];
	      if (rkey !== 'protocol')
	        result[rkey] = relative[rkey];
	    }
	
	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	        result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }
	
	    result.href = result.format();
	    return result;
	  }
	
	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      var keys = Object.keys(relative);
	      for (var v = 0; v < keys.length; v++) {
	        var k = keys[v];
	        result[k] = relative[k];
	      }
	      result.href = result.format();
	      return result;
	    }
	
	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift()));
	      if (!relative.host) relative.host = '';
	      if (!relative.hostname) relative.hostname = '';
	      if (relPath[0] !== '') relPath.unshift('');
	      if (relPath.length < 2) relPath.unshift('');
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }
	
	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	      isRelAbs = (
	          relative.host ||
	          relative.pathname && relative.pathname.charAt(0) === '/'
	      ),
	      mustEndAbs = (isRelAbs || isSourceAbs ||
	                    (result.host && relative.pathname)),
	      removeAllDots = mustEndAbs,
	      srcPath = result.pathname && result.pathname.split('/') || [],
	      relPath = relative.pathname && relative.pathname.split('/') || [],
	      psychotic = result.protocol && !slashedProtocol[result.protocol];
	
	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') srcPath[0] = result.host;
	      else srcPath.unshift(result.host);
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') relPath[0] = relative.host;
	        else relPath.unshift(relative.host);
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }
	
	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	                  relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	                      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) srcPath = [];
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!util.isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especially happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                       result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	                    (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	      (result.host || relative.host || srcPath.length > 1) &&
	      (last === '.' || last === '..') || last === '');
	
	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last === '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }
	
	  if (mustEndAbs && srcPath[0] !== '' &&
	      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }
	
	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }
	
	  var isAbsolute = srcPath[0] === '' ||
	      (srcPath[0] && srcPath[0].charAt(0) === '/');
	
	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	                                    srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especially happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                     result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }
	
	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);
	
	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }
	
	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }
	
	  //to support request.http
	  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	                  (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};
	
	Url.prototype.parseHost = function() {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) this.hostname = host;
	};


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	//
	 
	var MD5 = __webpack_require__(386);
	
	var Md5Wrapper = function () {
	};
	
	Md5Wrapper.prototype.createMd5Hash = function() {
	    return new MD5();
	};
	
	module.exports = Md5Wrapper;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.userProperties = exports.traceEvent = exports.tracePageViewAI = exports.tracePageView = undefined;
	
	var _applicationinsightsJs = __webpack_require__(231);
	
	var _uuid = __webpack_require__(116);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _reactGa = __webpack_require__(474);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	var _index = __webpack_require__(84);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _guide = __webpack_require__(32);
	
	var GUIDE = _interopRequireWildcard(_guide);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pkg = __webpack_require__(372);
	
	var intrumentKey = '76c785d0-bf63-4b98-9fa7-9294dba6beb5';
	var googleAnalticsKey = 'UA-98097460-4';
	
	var userProperties = {
	    project: getAppName(),
	    userId: getUserId(),
	    version: getAppVersion()
	};
	
	_applicationinsightsJs.AppInsights.downloadAndSetup({ instrumentationKey: intrumentKey });
	_reactGa2.default.initialize(googleAnalticsKey);
	
	// Prevent AI from tracking user's location IP information.
	_applicationinsightsJs.AppInsights.queue.push(function () {
	    _applicationinsightsJs.AppInsights.context.addTelemetryInitializer(function (envelope) {
	        envelope.tags['ai.location.ip'] = '0.0.0.0';
	    });
	});
	
	function tracePageView() {
	    _reactGa2.default.set(userProperties);
	    _reactGa2.default.ga('send', 'pageview');
	}
	
	function getAppName() {
	    return pkg.name;
	}
	
	function getAppVersion() {
	    return pkg.version;
	}
	
	function getUserId() {
	    var id = localStorage.getItem('userId');
	    if (!id) {
	        id = _uuid2.default.v1().toString();
	        localStorage.setItem('userId', id);
	    }
	    return id;
	}
	
	function tracePageViewAI(name, property, metric) {
	    property = Object.assign({ referrer: document.referrer }, property, userProperties);
	    _applicationinsightsJs.AppInsights.trackPageView(null, null, property);
	    _applicationinsightsJs.AppInsights.flush();
	}
	
	function traceEvent(name, property, metric) {
	    var guideOn = _index2.default.getState().main.get('guideId') !== GUIDE.CLOSE;
	    property = Object.assign({ 'with-guide': guideOn }, property, userProperties);
	    _applicationinsightsJs.AppInsights.trackEvent(name, property, metric);
	    _applicationinsightsJs.AppInsights.flush();
	}
	
	exports.tracePageView = tracePageView;
	exports.tracePageViewAI = tracePageViewAI;
	exports.traceEvent = traceEvent;
	exports.userProperties = userProperties;

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactLocalization = __webpack_require__(476);
	
	var _reactLocalization2 = _interopRequireDefault(_reactLocalization);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Localization = function () {
	    function Localization() {
	        _classCallCheck(this, Localization);
	    }
	
	    _createClass(Localization, null, [{
	        key: "getLocalizedString",
	        value: function getLocalizedString() {
	            if (!this.localizedString) {
	                this.localizedString = new _reactLocalization2.default(Localization.localizedStringList);
	            }
	            return this.localizedString;
	        }
	    }]);
	
	    return Localization;
	}();
	
	;
	
	Localization.localizedStringList = {
	    en: {
	        pageTitle: "MXChip IoT DevKit Simulator",
	        pageTitleMobile: "MXChip IoT DevKit Simulator",
	        runButton: "Run",
	        stopButton: "Stop",
	        helpButton: "Help",
	        buyButton: "Buy",
	        getAKitButton: "Get a kit",
	        deployButton: "Deploy",
	        buyLink: "http://mxchip.com/az3166",
	        guideTurnOff: "Turn guides off",
	        guideNextStep: "Next step",
	        guideStepFileTitle: "Welcome! Select a file to get started.",
	        guideStepFileDetail: "Here is an open project named Shake Shake, which will connect DevKit to Azure IoT and use the motion sensor to detect shaking and find a random tweet with a #hashtag. Select the source code file and move to the next step.",
	        guideStepCodeTitle: "Code display area",
	        guideStepCodeDetail: "There are two parts in this project. The code will be running on the DevKit is Arduino code. The files under azureFunction folder will be deployed to Azure Cloud for data processing.",
	        guideStepDeployTitle: "Deploy your Azure Resource Manager template to Azure",
	        guideStepDeployDetail: "By clicking the Deploy button, you can provision all the services required in the Shake Shake project, which includes an Azure IoT hub and an Azure Function. Click the link below to learn how to deploy.",
	        guideStepDeployLinkName: "How to deploy",
	        guideStepDeployLinkHref: "https://github.com/Azure-Samples/iot-devkit-web-simulator#deploy-your-azure-resource-manager-arm-template",
	        guideStepFillCSTitle: "Configure your DevKit",
	        guideStepFillCSDetail: "Here are the configurations you need to tell your DevKit. One is the IoT Hub Device connection string, and the other is the #hashtag you want for the tweets. Click the link below to learn how to fill in these.",
	        guideStepFillCSLinkName: "How to configure your DevKit",
	        guideStepFillCSLinkHref: "https://github.com/Azure-Samples/iot-devkit-web-simulator#create-an-az3166-device-in-your-iot-hub",
	        guideStepFillCSErrorTitle: "Oops, something wrong here",
	        guideStepFillCSErrorDetail: "It looks like the connection string is incorrect. Click the link below to see how to get the device connection string from Azure portal.",
	        guideStepFillCSErrorLinkName: "How to configure your DevKit",
	        guideStepFillCSErrorLinkHref: "https://github.com/Azure-Samples/iot-devkit-web-simulator#create-an-az3166-device-in-your-iot-hub",
	        guideStepRunTitle: "Time to RUN the code!",
	        guideStepRunDetail: "Click the Run button to deploy and start the application on your DevKit.",
	        guideStepBoardTitle: "Have fun with DevKit!",
	        guideStepBoardDetail: "The OLED screen turns on and you can see the real-time status of the DevKit. Click button A to start your shake. Click button B to scroll down the message. Click Reset button to reset the DevKit. Click top-right of this page to quit the wizard.",
	        guideStepBoardImageTitle: "",
	        guideStepShakeImageTitle: ""
	    }
	};
	
	exports.default = Localization;

/***/ },
/* 37 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 38 */
[603, 6],
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	// Adapted from ReactART:
	// https://github.com/reactjs/react-art
	
	var Konva = __webpack_require__(374);
	var React = __webpack_require__(40);
	
	var PropTypes = __webpack_require__(54);
	var createClass = __webpack_require__(345);
	
	var ReactInstanceMap = __webpack_require__(46);
	var ReactMultiChild = __webpack_require__(178);
	var ReactUpdates = __webpack_require__(23);
	
	var assign = __webpack_require__(7);
	var emptyObject = __webpack_require__(42);
	
	// some patching to make Konva.Node looks like DOM nodes
	var oldAdd = Konva.Container.prototype.add;
	Konva.Container.prototype.add = function(child) {
	  child.parentNode = this;
	  oldAdd.apply(this, arguments);
	};
	
	Konva.Container.prototype.replaceChild = function(newChild, oldChild) {
	  var index = oldChild.index;
	  var parent = oldChild.parent;
	  oldChild.destroy();
	  oldChild.parentNode = null;
	  parent.add(newChild);
	  if (newChild.index !== index) {
	    newChild.setZIndex(index);
	  }
	  parent.getLayer().batchDraw();
	};
	
	function createComponent(name) {
	  var ReactKonvaComponent = function(element) {
	    this.node = null;
	    this.subscriptions = null;
	    this.listeners = null;
	    this._mountImage = null;
	    this._renderedChildren = null;
	    this._mostRecentlyPlacedChild = null;
	    this._nativeContainerInfo = null;
	    this._initialProps = element.props;
	    this._currentElement = element;
	  };
	
	  ReactKonvaComponent.displayName = name;
	
	  for (var i = 1, l = arguments.length; i < l; i++) {
	    assign(ReactKonvaComponent.prototype, arguments[i]);
	  }
	
	  return ReactKonvaComponent;
	}
	
	var ContainerMixin = assign({}, ReactMultiChild.Mixin, {
	  moveChild: function(prevChild, lastPlacedNode, nextIndex, lastIndex) {
	    var childNode = prevChild._mountImage.node;
	    if (childNode.index !== nextIndex) {
	      childNode.setZIndex(nextIndex);
	      var layer = childNode.getLayer();
	      layer && layer.batchDraw();
	    }
	  },
	  createChild: function(child, afterNode, mountImage) {
	    child._mountImage = mountImage;
	    var childNode = mountImage.node;
	    childNode.moveTo(this.node);
	    childNode.parentNode = this.node;
	    if (child._mountIndex !== childNode.index) {
	      childNode.setZIndex(child._mountIndex);
	    }
	    this._mostRecentlyPlacedChild = childNode;
	    var layer = childNode.getLayer();
	    layer && layer.batchDraw();
	  },
	  removeChild: function(child, node) {
	    var layer = child._mountImage.node.getLayer();
	    child._mountImage.node.destroy();
	    child._mountImage.node.parentNode = null;
	    layer && layer.batchDraw();
	    child._mountImage = null;
	  },
	  updateChildrenAtRoot: function(nextChildren, transaction) {
	    this.updateChildren(nextChildren, transaction, emptyObject);
	  },
	  mountAndInjectChildrenAtRoot: function(children, transaction) {
	    this.mountAndInjectChildren(children, transaction, emptyObject);
	  },
	  updateChildren: function(nextChildren, transaction, context) {
	    this._mostRecentlyPlacedChild = null;
	    this._updateChildren(nextChildren, transaction, context);
	  },
	  mountAndInjectChildren: function(children, transaction, context) {
	    var mountedImages = this.mountChildren(children, transaction, context);
	    // Each mount image corresponds to one of the flattened children
	    var i = 0;
	    for (var key in this._renderedChildren) {
	      if (this._renderedChildren.hasOwnProperty(key)) {
	        var child = this._renderedChildren[key];
	        child._mountImage = mountedImages[i];
	        // runtime check for moveTo method
	        // it is possible that child component with be not Konva.Node instance
	        // for instance <noscript> for null element
	        var node = mountedImages[i].node;
	        if (!node instanceof Konva.Node) {
	          var message = 'Looks like one of child element is not Konva.Node.' +
	            'react-konva do not support in for now.';
	          ('if you have empty(null) child, replace it with <Group/>');
	          console.error(message, this);
	          continue;
	        }
	        if (node.parent !== this.node) {
	          node.moveTo(this.node);
	        }
	        i++;
	      }
	    }
	  },
	  mountAndAddChildren: function() {
	    console.log('mountAndAddChildren');
	  }
	});
	
	var propsToSkip = { children: true, ref: true, key: true, style: true };
	
	var NodeMixin = {
	  construct: function(element) {
	    this._currentElement = element;
	  },
	  receiveComponent: function(nextComponent, transaction, context) {
	    var props = nextComponent.props;
	    var oldProps = this._currentElement.props || this._initialProps;
	    this.applyNodeProps(oldProps, props);
	    this.updateChildren(props.children, transaction, context);
	    this._currentElement = nextComponent;
	  },
	  getPublicInstance: function() {
	    return this.node;
	  },
	  putEventListener: function(type, listener) {
	    // NOPE...
	  },
	  handleEvent: function(event) {
	    // NOPE...
	  },
	  getNativeNode: function() {
	    return this.node;
	  },
	  applyNodeProps: function(oldProps, props) {
	    var updatedProps = {};
	    var hasUpdates = false;
	    for (var key in oldProps) {
	      if (propsToSkip[key]) {
	        continue;
	      }
	      var isEvent = key.slice(0, 2) === 'on';
	      var propChanged = oldProps[key] !== props[key];
	      if (isEvent && propChanged) {
	        var eventName = key.substr(2).toLowerCase();
	        if (eventName.substr(0, 7) === 'content') {
	          eventName = 'content' +
	            eventName.substr(7, 1).toUpperCase() +
	            eventName.substr(8);
	        }
	        this.node.off(eventName, oldProps[key]);
	      }
	      var toRemove = !props.hasOwnProperty(key);
	      if (toRemove) {
	        this.node.setAttr(key, undefined);
	      }
	    }
	    for (var key in props) {
	      if (propsToSkip[key]) {
	        continue;
	      }
	      var isEvent = key.slice(0, 2) === 'on';
	      var toAdd = oldProps[key] !== props[key];
	      if (isEvent && toAdd) {
	        var eventName = key.substr(2).toLowerCase();
	        if (eventName.substr(0, 7) === 'content') {
	          eventName = 'content' +
	            eventName.substr(7, 1).toUpperCase() +
	            eventName.substr(8);
	        }
	        this.node.on(eventName, props[key]);
	      }
	      if (
	        !isEvent &&
	        (props[key] !== oldProps[key] || props[key] !== this.node.getAttr(key))
	      ) {
	        hasUpdates = true;
	        updatedProps[key] = props[key];
	      }
	    }
	
	    if (hasUpdates) {
	      this.node.setAttrs(updatedProps);
	      var drawingNode = this.node.getLayer() || this.node.getStage();
	      drawingNode && drawingNode.batchDraw();
	      var val, prop;
	      for (prop in updatedProps) {
	        val = updatedProps[prop];
	        if (val instanceof window.Image && !val.complete) {
	          var node = this.node;
	          val.addEventListener('load', function() {
	            var layer = node.getLayer();
	            layer && layer.batchDraw();
	          });
	        }
	      }
	    }
	  },
	  unmountComponent: function() {},
	  mountComponentIntoNode: function(rootID, container) {
	    throw new Error(
	      'You cannot render an ART component standalone. ' +
	        'You need to wrap it in a Stage.'
	    );
	  }
	};
	
	var Stage = createClass({
	  propTypes: {
	    width: PropTypes.oneOfType([
	      PropTypes.number,
	      PropTypes.string
	    ]),
	    height: PropTypes.oneOfType([
	      PropTypes.number,
	      PropTypes.string
	    ])
	  },
	  displayName: 'Stage',
	  mixins: [ContainerMixin],
	  componentDidMount: function() {
	    this.node = new Konva.Stage({
	      container: this.domNode,
	      width: this.props.width,
	      height: this.props.height
	    });
	    this.applyNodeProps(emptyObject, this.props);
	    this._debugID = this._reactInternalInstance._debugID;
	    var transaction = ReactUpdates.ReactReconcileTransaction.getPooled();
	
	    transaction.perform(
	      this.mountAndInjectChildren,
	      this,
	      this.props.children,
	      transaction,
	      ReactInstanceMap.get(this)._context
	    );
	    ReactUpdates.ReactReconcileTransaction.release(transaction);
	
	    this.node.draw();
	  },
	  getStage: function() {
	    return this.node;
	  },
	  componentDidUpdate: function(oldProps) {
	    var node = this.node;
	
	    this.applyNodeProps(oldProps, this.props);
	
	    var transaction = ReactUpdates.ReactReconcileTransaction.getPooled();
	    transaction.perform(
	      this.updateChildren,
	      this,
	      this.props.children,
	      transaction,
	      ReactInstanceMap.get(this)._context
	    );
	    ReactUpdates.ReactReconcileTransaction.release(transaction);
	  },
	  componentWillUnmount: function() {
	    this.unmountChildren();
	    this.node.destroy();
	    this.node.parentNode = null;
	  },
	  applyNodeProps: NodeMixin.applyNodeProps,
	  render: function() {
	    var props = this.props;
	
	    return React.createElement('div', {
	      ref: (function(c) {
	        return (this.domNode = c);
	      }).bind(this),
	      className: props.className,
	      role: props.role,
	      style: props.style,
	      tabIndex: props.tabIndex,
	      title: props.title
	    });
	  }
	});
	
	var GroupMixin = {
	  mountComponent: function(
	    transaction,
	    nativeParent,
	    nativeContainerInfo,
	    context
	  ) {
	    this._nativeContainerInfo = nativeContainerInfo;
	    this.node = new Konva[this.constructor.displayName]();
	    nativeParent.node.add(this.node);
	    var props = this._initialProps;
	    this.applyNodeProps(emptyObject, props);
	    this.mountAndInjectChildren(props.children, transaction, context);
	    return { children: [], node: this.node, html: null, text: null };
	  },
	  unmountComponent: function() {
	    this.unmountChildren();
	  }
	};
	
	var ShapeMixin = {
	  construct: function(element) {
	    this._currentElement = element;
	    this._oldPath = null;
	  },
	  mountComponent: function(
	    transaction,
	    nativeParent,
	    nativeContainerInfo,
	    context
	  ) {
	    this._nativeContainerInfo = nativeContainerInfo;
	    this.node = new Konva[this.constructor.displayName]();
	    if (nativeParent) {
	      nativeParent.node.add(this.node);
	    }
	    this.applyNodeProps(emptyObject, this._initialProps);
	    return { children: [], node: this.node, html: null, text: null };
	  },
	  receiveComponent: function(nextComponent, transaction, context) {
	    var props = nextComponent.props;
	    var oldProps = this._currentElement.props || this._initialProps;
	    this.applyNodeProps(oldProps, props);
	    this._currentElement = nextComponent;
	  }
	};
	
	var Group = createComponent('Group', NodeMixin, ContainerMixin, GroupMixin);
	var Layer = createComponent('Layer', NodeMixin, ContainerMixin, GroupMixin);
	var FastLayer = createComponent(
	  'FastLayer',
	  NodeMixin,
	  ContainerMixin,
	  GroupMixin
	);
	
	var Label = createComponent('Label', NodeMixin, ContainerMixin, GroupMixin);
	
	var ReactKonva = {
	  Stage: Stage,
	  Group: Group,
	  Layer: Layer,
	  FastLayer: FastLayer,
	  Label: Label
	};
	
	var shapes = [
	  'Rect',
	  'Circle',
	  'Ellipse',
	  'Wedge',
	  'Line',
	  'Sprite',
	  'Image',
	  'Text',
	  'TextPath',
	  'Star',
	  'Ring',
	  'Arc',
	  'Tag',
	  'Path',
	  'RegularPolygon',
	  'Arrow',
	  'Shape'
	];
	
	shapes.forEach(function(shapeName) {
	  ReactKonva[shapeName] = createComponent(shapeName, NodeMixin, ShapeMixin);
	});
	
	module.exports = ReactKonva;


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var ReactBaseClasses = __webpack_require__(194);
	var ReactChildren = __webpack_require__(491);
	var ReactDOMFactories = __webpack_require__(492);
	var ReactElement = __webpack_require__(48);
	var ReactPropTypes = __webpack_require__(493);
	var ReactVersion = __webpack_require__(494);
	
	var createReactClass = __webpack_require__(495);
	var onlyChild = __webpack_require__(499);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var processNextTick = __webpack_require__(93);
	/*</replacement>*/
	
	/*<replacement>*/
	var util = __webpack_require__(24);
	util.inherits = __webpack_require__(13);
	/*</replacement>*/
	
	var Readable = __webpack_require__(200);
	var Writable = __webpack_require__(112);
	
	util.inherits(Duplex, Readable);
	
	var keys = objectKeys(Writable.prototype);
	for (var v = 0; v < keys.length; v++) {
	  var method = keys[v];
	  if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  processNextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(395);
	exports.encode = exports.stringify = __webpack_require__(396);


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(95);
	var setInnerHTML = __webpack_require__(70);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(103);
	var setTextContent = __webpack_require__(188);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(3);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 46 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(447);
	var ReactInstrumentation = __webpack_require__(22);
	
	var warning = __webpack_require__(5);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var ReactCurrentOwner = __webpack_require__(29);
	
	var warning = __webpack_require__(5);
	var canDefineProperty = __webpack_require__(198);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(196);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(71);
	/*</replacement>*/
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var util = __webpack_require__(24);
	util.inherits = __webpack_require__(13);
	/*</replacement>*/
	
	var Readable = __webpack_require__(206);
	var Writable = __webpack_require__(208);
	
	util.inherits(Duplex, Readable);
	
	{
	  // avoid scope creep, the keys array can then be collected
	  var keys = objectKeys(Writable.prototype);
	  for (var v = 0; v < keys.length; v++) {
	    var method = keys[v];
	    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	  }
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  pna.nextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});
	
	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();
	
	  pna.nextTick(cb, err);
	};

/***/ },
/* 50 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = merge;
	function merge() {
	  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var defaults = arguments[1];
	
	  for (var key in defaults) {
	    if (typeof obj[key] === 'undefined') {
	      obj[key] = defaults[key];
	    }
	  }
	  return obj;
	}
	module.exports = exports['default'];

/***/ },
/* 51 */
/***/ function(module, exports) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Expose 'BlobUtilities'.
	exports = module.exports;
	
	/**
	* Defines constants, enums, and utility functions for use with the Blob service.
	* @namespace BlobUtilities
	*/
	var BlobUtilities = {
	  /**
	  * Permission types
	  *
	  * @const
	  * @enum {string}
	  */
	  SharedAccessPermissions: {
	    READ: 'r',
	    ADD: 'a',
	    CREATE: 'c',
	    WRITE: 'w',
	    DELETE: 'd',
	    LIST: 'l'
	  },
	
	  /**
	  * Blob listing details.
	  *
	  * @const
	  * @enum {string}
	  */
	  BlobListingDetails: {
	    SNAPSHOTS: 'snapshots',
	    METADATA: 'metadata',
	    UNCOMMITTED_BLOBS: 'uncommittedblobs',
	    COPY: 'copy',
	    DELETED: 'deleted'
	  },
	
	  /**
	  * Deletion options for blob snapshots
	  *
	  * @const
	  * @enum {string}
	  */
	  SnapshotDeleteOptions: {
	    SNAPSHOTS_ONLY: 'only',
	    BLOB_AND_SNAPSHOTS: 'include'
	  },
	
	  /**
	  * Type of block list to retrieve
	  *
	  * @const
	  * @enum {string}
	  */
	  BlockListFilter: {
	    ALL: 'all',
	    COMMITTED: 'committed',
	    UNCOMMITTED: 'uncommitted'
	  },
	
	  /**
	  * Blobs and container public access types.
	  *
	  * @const
	  * @enum {string}
	  */
	  BlobContainerPublicAccessType: {
	    OFF: null,
	    CONTAINER: 'container',
	    BLOB: 'blob'
	  },
	
	  /**
	  * Describes actions that can be performed on a page blob sequence number.
	  * @const
	  * @enum {string}
	  */
	  SequenceNumberAction: {
	    MAX: 'max',
	    UPDATE: 'update',
	    INCREMENT: 'increment'
	  },
	
	  /**
	  * Candidate values for blob tiers.
	  *
	  * @property {object} PremiumPageBlobTier      Candidate values for premium pageblob tiers.
	  * @property {string} PremiumPageBlobTier.P4
	  * @property {string} PremiumPageBlobTier.P6
	  * @property {string} PremiumPageBlobTier.P10
	  * @property {string} PremiumPageBlobTier.P20
	  * @property {string} PremiumPageBlobTier.P30
	  * @property {string} PremiumPageBlobTier.P40
	  * @property {string} PremiumPageBlobTier.P50
	  * @property {string} PremiumPageBlobTier.P60
	  * @property {object} StandardBlobTier         Candidate values for standard blobs tiers.
	  * @property {string} StandardBlobTier.HOT
	  * @property {string} StandardBlobTier.COOL
	  * @property {string} StandardBlobTier.ARCHIVE
	  */
	  BlobTier: {
	    PremiumPageBlobTier: {
	      P4: 'P4',
	      P6: 'P6',
	      P10: 'P10',
	      P20: 'P20',
	      P30: 'P30',
	      P40: 'P40',
	      P50: 'P50',
	      P60: 'P60'
	    },
	    StandardBlobTier: {
	      HOT: 'Hot',
	      COOL: 'Cool',
	      ARCHIVE: 'Archive'
	    }
	  }
	};
	
	module.exports = BlobUtilities;

/***/ },
/* 52 */
/***/ function(module, exports) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Expose 'HeaderConstants'.
	exports = module.exports;
	
	/**
	* Defines constants, enums, and utility functions for use with the Table service.
	* @namespace TableUtilities
	*/
	var TableUtilities = {
	  /**
	  * Permission types.
	  *
	  * @const
	  * @enum {string}
	  */
	  SharedAccessPermissions: {
	    QUERY: 'r',
	    ADD: 'a',
	    UPDATE: 'u',
	    DELETE: 'd'
	  },
	
	  /**
	  * Payload Format.
	  *
	  * @const
	  * @enum {string}
	  */
	  PayloadFormat: {
	    FULL_METADATA: 'application/json;odata=fullmetadata',
	    MINIMAL_METADATA: 'application/json;odata=minimalmetadata',
	    NO_METADATA: 'application/json;odata=nometadata'
	  },
	
	  /**
	  * Defines the set of Boolean operators for constructing queries.
	  *
	  * @const
	  * @enum {string}
	  */
	  TableOperators: {
	    AND: 'and',
	    NOT: 'not',
	    OR: 'or'
	  },
	
	  /**
	  * Filter property comparison operators.
	  *
	  * @const
	  * @enum {string}
	  */
	  QueryComparisons: {
	    EQUAL: 'eq',
	    NOT_EQUAL: 'ne',
	    GREATER_THAN: 'gt',
	    GREATER_THAN_OR_EQUAL: 'ge',
	    LESS_THAN: 'lt',
	    LESS_THAN_OR_EQUAL: 'le'
	  },
	
	  /**
	  * Edm types.
	  *
	  * @const
	  * @enum {string}
	  */
	  EdmType: {
	    STRING: 'Edm.String',
	    BINARY: 'Edm.Binary',
	    INT64: 'Edm.Int64',
	    INT32: 'Edm.Int32',
	    DOUBLE: 'Edm.Double',
	    DATETIME: 'Edm.DateTime',
	    GUID: 'Edm.Guid',
	    BOOLEAN: 'Edm.Boolean'
	  },
	
	  /**
	  * A helper to create table entities.
	  *
	  * @example
	  * var entGen = TableUtilities.entityGenerator;
	  * var entity = {  PartitionKey: entGen.String('part2'),
	  *        RowKey: entGen.String('row1'),
	  *        boolValue: entGen.Boolean(true),
	  *        intValue: entGen.Int32(42),
	  *        dateValue: entGen.DateTime(new Date(Date.UTC(2011, 10, 25))),
	  *       };
	  */
	  entityGenerator: (function()
	  {
	    var EntityProperty = function (value, type) {
	        var entityProperty = { _:value};
	        if (type) {
	          entityProperty['$'] = type;
	        }
	        return entityProperty;
	      };
	
	      return {
	      EntityProperty : EntityProperty,
	      
	      Int32 : function(value) {
	        return new EntityProperty(value, 'Edm.Int32');
	      },
	
	      Int64 : function(value) {
	        return new EntityProperty(value, 'Edm.Int64');
	      },
	
	      Binary : function(value) {
	        return new EntityProperty(value, 'Edm.Binary');
	      },
	
	      Boolean : function(value) {
	        return new EntityProperty(value, 'Edm.Boolean');
	      },
	
	      String : function(value) {
	        return new EntityProperty(value, 'Edm.String');
	      },
	
	      Guid : function(value) {
	        return new EntityProperty(value, 'Edm.Guid');
	      },
	
	      Double : function(value) {
	        return new EntityProperty(value, 'Edm.Double');
	      },
	
	      DateTime : function(value) {
	        return new EntityProperty(value, 'Edm.DateTime');
	      }
	    };
	  })()
	};
	
	module.exports = TableUtilities;

/***/ },
/* 53 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var RUN_SAMPLE = exports.RUN_SAMPLE = Symbol('RUN_SAMPLE');
	var STOP_SAMPLE = exports.STOP_SAMPLE = Symbol('STOP_SAMPLE');
	var APPEND_CONSOLE_LOG = exports.APPEND_CONSOLE_LOG = Symbol('APPEND_CONSOLE_LOG');
	
	var SELECT_PROJECT = exports.SELECT_PROJECT = Symbol('SELECT_PROJECT');
	var SET_EDITOR_PATH = exports.SET_EDITOR_PATH = Symbol('SET_EDITOR_PATH');
	var SET_PROJECT_CONFIG = exports.SET_PROJECT_CONFIG = Symbol('SET_PROJECT_CONFIG');
	var SHOW_RUNNING_INFO = exports.SHOW_RUNNING_INFO = Symbol('SHOW_RUNNING_INFO');
	
	var SWITCH_HELP = exports.SWITCH_HELP = Symbol('SWITCH_HELP');
	var SET_COMPONENT_SIZE = exports.SET_COMPONENT_SIZE = Symbol('SET_COMPONENT_SIZE');
	
	var SWITCH_ON_OFF_BOARD = exports.SWITCH_ON_OFF_BOARD = Symbol('SWITCH_ON_OFF_BOARD');
	var SET_SENSOR_DATA = exports.SET_SENSOR_DATA = Symbol('SET_SENSOR_DATA');

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(393)();
	}


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var EventPluginRegistry = __webpack_require__(96);
	var EventPluginUtils = __webpack_require__(97);
	var ReactErrorUtils = __webpack_require__(101);
	
	var accumulateInto = __webpack_require__(181);
	var forEachAccumulated = __webpack_require__(182);
	var invariant = __webpack_require__(3);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(55);
	var EventPluginUtils = __webpack_require__(97);
	
	var accumulateInto = __webpack_require__(181);
	var forEachAccumulated = __webpack_require__(182);
	var warning = __webpack_require__(5);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(27);
	
	var getEventTarget = __webpack_require__(106);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 58 */
6,
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(2)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ },
/* 60 */
/***/ function(module, exports) {

	/*! Copyright (c) Microsoft. All rights reserved.
	 *! Licensed under the MIT license. See LICENSE file in the project root for full license information.
	 */
	'use strict';
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * Error thrown when an argument is invalid.
	 *
	 * @augments {Error}
	 */
	var ArgumentError = (function (_super) {
	    __extends(ArgumentError, _super);
	    function ArgumentError(message) {
	        _super.call(this, message);
	        this.name = 'ArgumentError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return ArgumentError;
	}(Error));
	exports.ArgumentError = ArgumentError;
	/**
	 * Error thrown when an argument has a value that is out of the admissible range.
	 *
	 * @augments {Error}
	 */
	var ArgumentOutOfRangeError = (function (_super) {
	    __extends(ArgumentOutOfRangeError, _super);
	    function ArgumentOutOfRangeError(message) {
	        _super.call(this, message);
	        this.name = 'ArgumentOutOfRangeError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return ArgumentOutOfRangeError;
	}(Error));
	exports.ArgumentOutOfRangeError = ArgumentOutOfRangeError;
	/**
	 * Error thrown when the message queue for a device is full.
	 *
	 * @augments {Error}
	 */
	var DeviceMaximumQueueDepthExceededError = (function (_super) {
	    __extends(DeviceMaximumQueueDepthExceededError, _super);
	    function DeviceMaximumQueueDepthExceededError(message) {
	        _super.call(this, message);
	        this.name = 'DeviceMaximumQueueDepthExceededError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return DeviceMaximumQueueDepthExceededError;
	}(Error));
	exports.DeviceMaximumQueueDepthExceededError = DeviceMaximumQueueDepthExceededError;
	/**
	 * Error thrown when a device cannot be found in the IoT Hub instance registry.
	 *
	 * @augments {Error}
	 */
	var DeviceNotFoundError = (function (_super) {
	    __extends(DeviceNotFoundError, _super);
	    function DeviceNotFoundError(message) {
	        _super.call(this, message);
	        this.name = 'DeviceNotFoundError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return DeviceNotFoundError;
	}(Error));
	exports.DeviceNotFoundError = DeviceNotFoundError;
	/**
	 * Error thrown when a string that is supposed to have a specific formatting is not formatted properly.
	 *
	 * @augments {Error}
	 */
	var FormatError = (function (_super) {
	    __extends(FormatError, _super);
	    function FormatError(message) {
	        _super.call(this, message);
	        this.name = 'FormatError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return FormatError;
	}(Error));
	exports.FormatError = FormatError;
	/**
	 * Error thrown when the connection parameters are wrong and the server refused the connection.
	 *
	 * @augments {Error}
	 */
	var UnauthorizedError = (function (_super) {
	    __extends(UnauthorizedError, _super);
	    function UnauthorizedError(message) {
	        _super.call(this, message);
	        this.name = 'UnauthorizedError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return UnauthorizedError;
	}(Error));
	exports.UnauthorizedError = UnauthorizedError;
	/**
	 * Error thrown when a feature is not implemented yet but the placeholder is present.
	 *
	 * @augments {Error}
	 */
	var NotImplementedError = (function (_super) {
	    __extends(NotImplementedError, _super);
	    function NotImplementedError(message) {
	        _super.call(this, message);
	        this.name = 'NotImplementedError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return NotImplementedError;
	}(Error));
	exports.NotImplementedError = NotImplementedError;
	/**
	 * Error thrown when the device is disconnected and the operation cannot be completed.
	 *
	 * @augments {Error}
	 */
	var NotConnectedError = (function (_super) {
	    __extends(NotConnectedError, _super);
	    function NotConnectedError(message) {
	        _super.call(this, message);
	        this.name = 'NotConnectedError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return NotConnectedError;
	}(Error));
	exports.NotConnectedError = NotConnectedError;
	/**
	 * Error thrown the the Azure IoT hub quota has been exceeded. Quotas are reset periodically, this operation will have to wait until then.
	 * To learn more about quotas, see {@link https://docs.microsoft.com/en-us/azure/iot-hub/iot-hub-devguide-quotas-throttling|Azure IoT Hub quotas and throttling}
	 *
	 * @augments {Error}
	 */
	var IotHubQuotaExceededError = (function (_super) {
	    __extends(IotHubQuotaExceededError, _super);
	    function IotHubQuotaExceededError(message) {
	        _super.call(this, message);
	        this.name = 'IotHubQuotaExceededError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return IotHubQuotaExceededError;
	}(Error));
	exports.IotHubQuotaExceededError = IotHubQuotaExceededError;
	/**
	 * Error thrown when the message sent is too large: the maximum size is 256Kb.
	 *
	 * @augments {Error}
	 */
	var MessageTooLargeError = (function (_super) {
	    __extends(MessageTooLargeError, _super);
	    function MessageTooLargeError(message) {
	        _super.call(this, message);
	        this.name = 'MessageTooLargeError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return MessageTooLargeError;
	}(Error));
	exports.MessageTooLargeError = MessageTooLargeError;
	/**
	 * Error thrown when an internal server error occured. You may have found a bug?
	 *
	 * @augments {Error}
	 */
	var InternalServerError = (function (_super) {
	    __extends(InternalServerError, _super);
	    function InternalServerError(message) {
	        _super.call(this, message);
	        this.name = 'InternalServerError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return InternalServerError;
	}(Error));
	exports.InternalServerError = InternalServerError;
	/**
	 * Error thrown when the service is unavailable. The operation should be retried.
	 *
	 * @augments {Error}
	 */
	var ServiceUnavailableError = (function (_super) {
	    __extends(ServiceUnavailableError, _super);
	    function ServiceUnavailableError(message) {
	        _super.call(this, message);
	        this.name = 'ServiceUnavailableError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return ServiceUnavailableError;
	}(Error));
	exports.ServiceUnavailableError = ServiceUnavailableError;
	/**
	 * Error thrown when the Azure IoT hub was not found.
	 *
	 * @augments {Error}
	 */
	var IotHubNotFoundError = (function (_super) {
	    __extends(IotHubNotFoundError, _super);
	    function IotHubNotFoundError(message) {
	        _super.call(this, message);
	        this.name = 'IotHubNotFoundError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return IotHubNotFoundError;
	}(Error));
	exports.IotHubNotFoundError = IotHubNotFoundError;
	/**
	 * Error thrown when IoT Hub has been suspended.
	 *
	 * @augments {Error}
	 */
	var IoTHubSuspendedError = (function (_super) {
	    __extends(IoTHubSuspendedError, _super);
	    function IoTHubSuspendedError(message) {
	        _super.call(this, message);
	        this.name = 'IoTHubSuspendedError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return IoTHubSuspendedError;
	}(Error));
	exports.IoTHubSuspendedError = IoTHubSuspendedError;
	/**
	 * Error thrown when the job with the specified identifier was not found.
	 *
	 * @augments {Error}
	 */
	var JobNotFoundError = (function (_super) {
	    __extends(JobNotFoundError, _super);
	    function JobNotFoundError(message) {
	        _super.call(this, message);
	        this.name = 'JobNotFoundError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return JobNotFoundError;
	}(Error));
	exports.JobNotFoundError = JobNotFoundError;
	/**
	 * Error thrown when the maximum number of devices on a specific hub has been reached.
	 *
	 * @augments {Error}
	 */
	var TooManyDevicesError = (function (_super) {
	    __extends(TooManyDevicesError, _super);
	    function TooManyDevicesError(message) {
	        _super.call(this, message);
	        this.name = 'TooManyDevicesError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return TooManyDevicesError;
	}(Error));
	exports.TooManyDevicesError = TooManyDevicesError;
	/**
	 * Error thrown when IoT Hub is throttled due to excessive activity.
	 * To learn more about quotas, see {@link https://docs.microsoft.com/en-us/azure/iot-hub/iot-hub-devguide-quotas-throttling|Azure IoT Hub quotas and throttling}
	 *
	 * @augments {Error}
	 */
	var ThrottlingError = (function (_super) {
	    __extends(ThrottlingError, _super);
	    function ThrottlingError(message) {
	        _super.call(this, message);
	        this.name = 'ThrottlingError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return ThrottlingError;
	}(Error));
	exports.ThrottlingError = ThrottlingError;
	/**
	 * Error thrown when the device id used for device creation already exists in the Device Identity Registry.
	 *
	 * @augments {Error}
	 */
	var DeviceAlreadyExistsError = (function (_super) {
	    __extends(DeviceAlreadyExistsError, _super);
	    function DeviceAlreadyExistsError(message) {
	        _super.call(this, message);
	        this.name = 'DeviceAlreadyExistsError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return DeviceAlreadyExistsError;
	}(Error));
	exports.DeviceAlreadyExistsError = DeviceAlreadyExistsError;
	/**
	 * Error thrown when settling a message fails because the lock token associated with the message is lost.
	 *
	 * @augments {Error}
	 */
	var DeviceMessageLockLostError = (function (_super) {
	    __extends(DeviceMessageLockLostError, _super);
	    function DeviceMessageLockLostError(message) {
	        _super.call(this, message);
	        this.name = 'DeviceMessageLockLostError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return DeviceMessageLockLostError;
	}(Error));
	exports.DeviceMessageLockLostError = DeviceMessageLockLostError;
	/**
	 * Error thrown when the eTag specified is incorrectly formatted or out of date.
	 *
	 * @augments {Error}
	 */
	var InvalidEtagError = (function (_super) {
	    __extends(InvalidEtagError, _super);
	    function InvalidEtagError(message) {
	        _super.call(this, message);
	        this.name = 'InvalidEtagError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return InvalidEtagError;
	}(Error));
	exports.InvalidEtagError = InvalidEtagError;
	/**
	 * Error thrown when an operation is attempted but is not allowed.
	 *
	 * @augments {Error}
	 */
	var InvalidOperationError = (function (_super) {
	    __extends(InvalidOperationError, _super);
	    function InvalidOperationError(message) {
	        _super.call(this, message);
	        this.name = 'InvalidOperationError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return InvalidOperationError;
	}(Error));
	exports.InvalidOperationError = InvalidOperationError;
	/**
	 * Error thrown when a condition that should have been met in order to execute an operation was not.
	 *
	 * @augments {Error}
	 */
	var PreconditionFailedError = (function (_super) {
	    __extends(PreconditionFailedError, _super);
	    function PreconditionFailedError(message) {
	        _super.call(this, message);
	        this.name = 'PreconditionFailedError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return PreconditionFailedError;
	}(Error));
	exports.PreconditionFailedError = PreconditionFailedError;
	/**
	 * Error thrown when a timeout occurs
	 *
	 * @augments {Error}
	 */
	var TimeoutError = (function (_super) {
	    __extends(TimeoutError, _super);
	    function TimeoutError(message) {
	        _super.call(this, message);
	        this.name = 'TimeoutError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return TimeoutError;
	}(Error));
	exports.TimeoutError = TimeoutError;
	/**
	 * Error thrown when a device sends a bad response to a device method call.
	 *
	 * @augments {Error}
	 */
	var BadDeviceResponseError = (function (_super) {
	    __extends(BadDeviceResponseError, _super);
	    function BadDeviceResponseError(message) {
	        _super.call(this, message);
	        this.name = 'BadDeviceResponseError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return BadDeviceResponseError;
	}(Error));
	exports.BadDeviceResponseError = BadDeviceResponseError;
	/**
	 * Error thrown when the IoT Hub instance doesn't process the device method call in time.
	 *
	 * @augments {Error}
	 */
	var GatewayTimeoutError = (function (_super) {
	    __extends(GatewayTimeoutError, _super);
	    function GatewayTimeoutError(message) {
	        _super.call(this, message);
	        this.name = 'GatewayTimeoutError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return GatewayTimeoutError;
	}(Error));
	exports.GatewayTimeoutError = GatewayTimeoutError;
	/**
	 * Error thrown when the device doesn't process the method call in time.
	 *
	 * @augments {Error}
	 */
	var DeviceTimeoutError = (function (_super) {
	    __extends(DeviceTimeoutError, _super);
	    function DeviceTimeoutError(message) {
	        _super.call(this, message);
	        this.name = 'DeviceTimeoutError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return DeviceTimeoutError;
	}(Error));
	exports.DeviceTimeoutError = DeviceTimeoutError;
	/**
	 * Error thrown when the c2d feature stopped working at the transport level, requiring the client to retry starting it.
	 *
	 * @augments {Error}
	 */
	var CloudToDeviceDetachedError = (function (_super) {
	    __extends(CloudToDeviceDetachedError, _super);
	    function CloudToDeviceDetachedError(message) {
	        _super.call(this, message);
	        this.name = 'CloudToDeviceDetachedError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return CloudToDeviceDetachedError;
	}(Error));
	exports.CloudToDeviceDetachedError = CloudToDeviceDetachedError;
	/**
	 * Error thrown when the device methods feature stopped working at the transport level, requiring the client to retry starting it.
	 *
	 * @augments {Error}
	 */
	var DeviceMethodsDetachedError = (function (_super) {
	    __extends(DeviceMethodsDetachedError, _super);
	    function DeviceMethodsDetachedError(message) {
	        _super.call(this, message);
	        this.name = 'DeviceMethodsDetachedError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return DeviceMethodsDetachedError;
	}(Error));
	exports.DeviceMethodsDetachedError = DeviceMethodsDetachedError;
	/**
	 * Error thrown when the twin feature stopped working at the transport level, requiring the client to retry starting it.
	 *
	 * @augments {Error}
	 */
	var TwinDetachedError = (function (_super) {
	    __extends(TwinDetachedError, _super);
	    function TwinDetachedError(message) {
	        _super.call(this, message);
	        this.name = 'TwinDetachedError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return TwinDetachedError;
	}(Error));
	exports.TwinDetachedError = TwinDetachedError;
	/**
	 * Generic error thrown when a twin request fails with an unknown error code.
	 *
	 * @augments {Error}
	 */
	var TwinRequestError = (function (_super) {
	    __extends(TwinRequestError, _super);
	    function TwinRequestError(message) {
	        _super.call(this, message);
	        this.name = 'TwinRequestError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return TwinRequestError;
	}(Error));
	exports.TwinRequestError = TwinRequestError;
	/**
	 * Error thrown when any operation (local or remote) is cancelled
	 *
	 * @augments {Error}
	 */
	var OperationCancelledError = (function (_super) {
	    __extends(OperationCancelledError, _super);
	    function OperationCancelledError(message) {
	        _super.call(this, message);
	        this.name = 'OperationCancelledError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return OperationCancelledError;
	}(Error));
	exports.OperationCancelledError = OperationCancelledError;
	/**
	 * Error thrown when a DPS registration operation fails
	 *
	 * @augments {Error}
	 */
	var DeviceRegistrationFailedError = (function (_super) {
	    __extends(DeviceRegistrationFailedError, _super);
	    function DeviceRegistrationFailedError(message) {
	        _super.call(this, message);
	        this.name = 'ProvisioningRegistrationFailedError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return DeviceRegistrationFailedError;
	}(Error));
	exports.DeviceRegistrationFailedError = DeviceRegistrationFailedError;
	/**
	 * Error thrown when a low level security device/driver fails.
	 *
	 * @augments {Error}
	 */
	var SecurityDeviceError = (function (_super) {
	    __extends(SecurityDeviceError, _super);
	    function SecurityDeviceError(message) {
	        _super.call(this, message);
	        this.name = 'SecurityDeviceError';
	        this.message = message;
	        Error.captureStackTrace(this, this.constructor);
	    }
	    return SecurityDeviceError;
	}(Error));
	exports.SecurityDeviceError = SecurityDeviceError;
	//# sourceMappingURL=errors.js.map

/***/ },
/* 61 */
/***/ function(module, exports) {

	// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	
	'use strict';
	
	/**
	 * @class       module:azure-iot-common.ArgumentError
	 * @classdesc   Error thrown when an argument is invalid.
	 *
	 * @augments {Error}
	 */
	function ArgumentError(message) {
	  this.message = message;
	  Error.captureStackTrace(this, this.constructor);
	  Error.call(this, message);
	}
	
	ArgumentError.prototype = Object.create(Error.prototype);
	ArgumentError.prototype.constructor = ArgumentError;
	ArgumentError.prototype.name = 'ArgumentError';
	
	/**
	 * @class       module:azure-iot-common.DeviceMaximumQueueDepthExceededError
	 * @classdesc   Error thrown when the message queue for a device is full.
	 *
	 * @augments {Error}
	 */
	function DeviceMaximumQueueDepthExceededError(message) {
	  this.message = message;
	  Error.captureStackTrace(this, this.constructor);
	  Error.call(this, message);
	}
	
	DeviceMaximumQueueDepthExceededError.prototype = Object.create(Error.prototype);
	DeviceMaximumQueueDepthExceededError.prototype.constructor = DeviceMaximumQueueDepthExceededError;
	DeviceMaximumQueueDepthExceededError.prototype.name = 'DeviceMaximumQueueDepthExceededError';
	
	/**
	 * @class       module:azure-iot-common.DeviceNotFoundError
	 * @classdesc   Error thrown when a device cannot be found in the IoT Hub instance registry.
	 *
	 * @augments {Error}
	 */
	  function DeviceNotFoundError(message) {
	  this.message = message;
	  Error.captureStackTrace(this, this.constructor);
	  Error.call(this, message);
	}
	
	DeviceNotFoundError.prototype = Object.create(Error.prototype);
	DeviceNotFoundError.prototype.constructor = DeviceNotFoundError;
	DeviceNotFoundError.prototype.name = 'DeviceNotFoundError';
	
	/**
	 * @class       module:azure-iot-common.FormatError
	 * @classdesc   Error thrown when a string that is supposed to have a specific formatting is not formatted properly.
	 *
	 * @augments {Error}
	 */
	function FormatError(message) {
	  this.message = message;
	  Error.captureStackTrace(this, this.constructor);
	  Error.call(this, message);
	}
	
	FormatError.prototype = Object.create(Error.prototype);
	FormatError.prototype.constructor = FormatError;
	FormatError.prototype.name = 'FormatError';
	
	/**
	 * @class       module:azure-iot-common.UnauthorizedError
	 * @classdesc   Error thrown when the connection parameters are wrong and the server refused the connection.
	 *
	 * @augments {Error}
	 */
	function UnauthorizedError(message) {
	  this.message = message;
	  Error.captureStackTrace(this, this.constructor);
	  Error.call(this, message);
	}
	
	UnauthorizedError.prototype = Object.create(Error.prototype);
	UnauthorizedError.prototype.constructor = UnauthorizedError;
	UnauthorizedError.prototype.name = 'UnauthorizedError';
	
	function NotImplementedError(message) {
	  this.message = message;
	  Error.captureStackTrace(this, this.constructor);
	  Error.call(this, message);
	}
	
	NotImplementedError.prototype = Object.create(Error.prototype);
	NotImplementedError.prototype.constructor = NotImplementedError;
	NotImplementedError.prototype.name = 'NotImplementedError';
	
	function NotConnectedError(message) {
	  this.message = message;
	  Error.captureStackTrace(this, this.constructor);
	  Error.call(this, message);
	}
	
	NotConnectedError.prototype = Object.create(Error.prototype);
	NotConnectedError.prototype.constructor = NotConnectedError;
	NotConnectedError.prototype.name = 'NotConnectedError';
	
	function IotHubQuotaExceededError(message) {
	  this.message = message;
	  Error.captureStackTrace(this, this.constructor);
	  Error.call(this, message);
	}
	
	IotHubQuotaExceededError.prototype = Object.create(Error.prototype);
	IotHubQuotaExceededError.prototype.constructor = IotHubQuotaExceededError;
	IotHubQuotaExceededError.prototype.name = 'IotHubQuotaExceededError';
	
	function MessageTooLargeError(message) {
	  this.message = message;
	  Error.captureStackTrace(this, this.constructor);
	  Error.call(this, message);
	}
	
	MessageTooLargeError.prototype = Object.create(Error.prototype);
	MessageTooLargeError.prototype.constructor = MessageTooLargeError;
	MessageTooLargeError.prototype.name = 'MessageTooLargeError';
	
	function InternalServerError(message) {
	  this.message = message;
	  Error.captureStackTrace(this, this.constructor);
	  Error.call(this, message);
	}
	
	InternalServerError.prototype = Object.create(Error.prototype);
	InternalServerError.prototype.constructor = InternalServerError;
	InternalServerError.prototype.name = 'InternalServerError';
	
	function ServiceUnavailableError(message) {
	  this.message = message;
	  Error.captureStackTrace(this, this.constructor);
	  Error.call(this, message);
	}
	
	ServiceUnavailableError.prototype = Object.create(Error.prototype);
	ServiceUnavailableError.prototype.constructor = ServiceUnavailableError;
	ServiceUnavailableError.prototype.name = 'ServiceUnavailableError';
	
	function IotHubNotFoundError(message) {
	  this.message = message;
	  Error.captureStackTrace(this, this.constructor);
	  Error.call(this, message);
	}
	
	IotHubNotFoundError.prototype = Object.create(Error.prototype);
	IotHubNotFoundError.prototype.constructor = IotHubNotFoundError;
	IotHubNotFoundError.prototype.name = 'IotHubNotFoundError';
	
	function JobNotFoundError(message) {
	  this.message = message;
	  Error.captureStackTrace(this, this.constructor);
	  Error.call(this, message);
	}
	
	JobNotFoundError.prototype = Object.create(Error.prototype);
	JobNotFoundError.prototype.constructor = JobNotFoundError;
	JobNotFoundError.prototype.name = 'JobNotFoundError';
	
	function TooManyDevicesError(message) {
	  this.message = message;
	  Error.captureStackTrace(this, this.constructor);
	  Error.call(this, message);
	}
	
	TooManyDevicesError.prototype = Object.create(Error.prototype);
	TooManyDevicesError.prototype.constructor = TooManyDevicesError;
	TooManyDevicesError.prototype.name = 'TooManyDevicesError';
	
	function ThrottlingError(message) {
	  this.message = message;
	  Error.captureStackTrace(this, this.constructor);
	  Error.call(this, message);
	}
	
	ThrottlingError.prototype = Object.create(Error.prototype);
	ThrottlingError.prototype.constructor = ThrottlingError;
	ThrottlingError.prototype.name = 'ThrottlingError';
	
	function DeviceAlreadyExistsError(message) {
	  this.message = message;
	  Error.captureStackTrace(this, this.constructor);
	  Error.call(this, message);
	}
	
	DeviceAlreadyExistsError.prototype = Object.create(Error.prototype);
	DeviceAlreadyExistsError.prototype.constructor = DeviceAlreadyExistsError;
	DeviceAlreadyExistsError.prototype.name = 'DeviceAlreadyExistsError';
	
	function InvalidEtagError(message) {
	  this.message = message;
	  Error.captureStackTrace(this, this.constructor);
	  Error.call(this, message);
	}
	
	InvalidEtagError.prototype = Object.create(Error.prototype);
	InvalidEtagError.prototype.constructor = InvalidEtagError;
	InvalidEtagError.prototype.name = 'InvalidEtagError';
	
	/**
	 * @class       module:azure-iot-common.TimeoutError
	 * @classdesc   Error thrown when a timeout occurs
	 *
	 * @augments {Error}
	 */
	function TimeoutError(message) {
	  this.message = message;
	  Error.captureStackTrace(this, this.constructor);
	  Error.call(this, message);
	}
	
	TimeoutError.prototype = Object.create(Error.prototype);
	TimeoutError.prototype.constructor = TimeoutError;
	TimeoutError.prototype.name = 'TimeoutError';
	
	/**
	 * @class       module:azure-iot-common.BadDeviceResponseError
	 * @classdesc   Error thrown when a device sends a bad response to a device method call.
	 *
	 * @augments {Error}
	 */
	function BadDeviceResponseError(message) {
	  this.message = message;
	  Error.captureStackTrace(this, this.constructor);
	  Error.call(this, message);
	}
	
	BadDeviceResponseError.prototype = Object.create(Error.prototype);
	BadDeviceResponseError.prototype.constructor = BadDeviceResponseError;
	BadDeviceResponseError.prototype.name = 'BadDeviceResponseError';
	
	
	/**
	 * @class       module:azure-iot-common.GatewayTimeoutError
	 * @classdesc   Error thrown when the IoT Hub instance doesn't process the device method call in time.
	 *
	 * @augments {Error}
	 */
	function GatewayTimeoutError(message) {
	  this.message = message;
	  Error.captureStackTrace(this, this.constructor);
	  Error.call(this, message);
	}
	
	GatewayTimeoutError.prototype = Object.create(Error.prototype);
	GatewayTimeoutError.prototype.constructor = GatewayTimeoutError;
	GatewayTimeoutError.prototype.name = 'GatewayTimeoutError';
	
	/**
	 * @class       module:azure-iot-common.DeviceTimeoutError
	 * @classdesc   Error thrown when the device doesn't process the method call in time.
	 *
	 * @augments {Error}
	 */
	function DeviceTimeoutError(message) {
	  this.message = message;
	  Error.captureStackTrace(this, this.constructor);
	  Error.call(this, message);
	}
	
	DeviceTimeoutError.prototype = Object.create(Error.prototype);
	DeviceTimeoutError.prototype.constructor = DeviceTimeoutError;
	DeviceTimeoutError.prototype.name = 'DeviceTimeoutError';
	
	module.exports = {
	  ArgumentError: ArgumentError,
	  DeviceMaximumQueueDepthExceededError: DeviceMaximumQueueDepthExceededError,
	  DeviceNotFoundError: DeviceNotFoundError,
	  FormatError: FormatError,
	  UnauthorizedError: UnauthorizedError,
	  NotImplementedError: NotImplementedError,
	  NotConnectedError: NotConnectedError,
	  IotHubQuotaExceededError: IotHubQuotaExceededError,
	  MessageTooLargeError: MessageTooLargeError,
	  InternalServerError: InternalServerError,
	  ServiceUnavailableError: ServiceUnavailableError,
	  IotHubNotFoundError: IotHubNotFoundError,
	  JobNotFoundError: JobNotFoundError,
	  TooManyDevicesError: TooManyDevicesError,
	  ThrottlingError: ThrottlingError,
	  DeviceAlreadyExistsError: DeviceAlreadyExistsError,
	  InvalidEtagError: InvalidEtagError,
	  TimeoutError : TimeoutError,
	  BadDeviceResponseError: BadDeviceResponseError,
	  GatewayTimeoutError: GatewayTimeoutError,
	  DeviceTimeoutError: DeviceTimeoutError
	};


/***/ },
/* 62 */
61,
/* 63 */
/***/ function(module, exports) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Expose 'StorageUtilities'.
	
	/**
	* Defines constants, enums, and utility functions for use with storage.
	* @namespace
	*/
	var StorageUtilities = {
		/**
	  * Specifies the location mode used to decide which location the request should be sent to.
	  *
	  * @const
	  * @enum {number}
	  */
	  LocationMode: {
	    /** The primary location only */
	    PRIMARY_ONLY: 0,
	    /** The primary location first, then the secondary */
	    PRIMARY_THEN_SECONDARY: 1,
	    /** The secondary location only */
	    SECONDARY_ONLY: 2,
	    /** The secondary location first, then the primary */
	    SECONDARY_THEN_PRIMARY: 3
	  }
	};
	
	module.exports = StorageUtilities;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = xor;
	function xor(a, b) {
	  var len = Math.min(a.length, b.length);
	  var out = new Buffer(len);
	  var i = -1;
	  while (++i < len) {
	    out.writeUInt8(a[i] ^ b[i], i);
	  }
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var rng = __webpack_require__(350)
	
	function error () {
	  var m = [].slice.call(arguments).join(' ')
	  throw new Error([
	    m,
	    'we accept pull requests',
	    'http://github.com/dominictarr/crypto-browserify'
	    ].join('\n'))
	}
	
	exports.createHash = __webpack_require__(156)
	
	exports.createHmac = __webpack_require__(346)
	
	exports.randomBytes = function(size, callback) {
	  if (callback && callback.call) {
	    try {
	      callback.call(this, undefined, new Buffer(rng(size)))
	    } catch (err) { callback(err) }
	  } else {
	    return new Buffer(rng(size))
	  }
	}
	
	function each(a, f) {
	  for(var i in a)
	    f(a[i], i)
	}
	
	exports.getHashes = function () {
	  return ['sha1', 'sha256', 'sha512', 'md5', 'rmd160']
	}
	
	var p = __webpack_require__(349)(exports)
	exports.pbkdf2 = p.pbkdf2
	exports.pbkdf2Sync = p.pbkdf2Sync
	__webpack_require__(342)(exports, module.exports);
	
	// the least I can do is make error messages for the rest of the node.js/crypto api.
	each(['createCredentials'
	, 'createSign'
	, 'createVerify'
	, 'createDiffieHellman'
	], function (name) {
	  exports[name] = function () {
	    error('sorry,', name, 'is not implemented yet')
	  }
	})
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var EventPluginRegistry = __webpack_require__(96);
	var ReactEventEmitterMixin = __webpack_require__(440);
	var ViewportMetrics = __webpack_require__(180);
	
	var getVendorPrefixedEventName = __webpack_require__(471);
	var isEventSupported = __webpack_require__(107);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(57);
	var ViewportMetrics = __webpack_require__(180);
	
	var getEventModifierState = __webpack_require__(105);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(3);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 69 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(17);
	var DOMNamespaces = __webpack_require__(95);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(103);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (!process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = { nextTick: nextTick };
	} else {
	  module.exports = process
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ },
/* 72 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var alpha = exports.alpha = {
	  'en-US': /^[A-Z]+$/i,
	  'bg-BG': /^[А-Я]+$/i,
	  'cs-CZ': /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
	  'da-DK': /^[A-ZÆØÅ]+$/i,
	  'de-DE': /^[A-ZÄÖÜß]+$/i,
	  'el-GR': /^[Α-ω]+$/i,
	  'es-ES': /^[A-ZÁÉÍÑÓÚÜ]+$/i,
	  'fr-FR': /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
	  'it-IT': /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
	  'nb-NO': /^[A-ZÆØÅ]+$/i,
	  'nl-NL': /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
	  'nn-NO': /^[A-ZÆØÅ]+$/i,
	  'hu-HU': /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
	  'pl-PL': /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
	  'pt-PT': /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]+$/i,
	  'ru-RU': /^[А-ЯЁ]+$/i,
	  'sk-SK': /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
	  'sr-RS@latin': /^[A-ZČĆŽŠĐ]+$/i,
	  'sr-RS': /^[А-ЯЂЈЉЊЋЏ]+$/i,
	  'sv-SE': /^[A-ZÅÄÖ]+$/i,
	  'tr-TR': /^[A-ZÇĞİıÖŞÜ]+$/i,
	  'uk-UA': /^[А-ЩЬЮЯЄIЇҐі]+$/i,
	  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/
	};
	
	var alphanumeric = exports.alphanumeric = {
	  'en-US': /^[0-9A-Z]+$/i,
	  'bg-BG': /^[0-9А-Я]+$/i,
	  'cs-CZ': /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
	  'da-DK': /^[0-9A-ZÆØÅ]+$/i,
	  'de-DE': /^[0-9A-ZÄÖÜß]+$/i,
	  'el-GR': /^[0-9Α-ω]+$/i,
	  'es-ES': /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
	  'fr-FR': /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
	  'it-IT': /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
	  'hu-HU': /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
	  'nb-NO': /^[0-9A-ZÆØÅ]+$/i,
	  'nl-NL': /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
	  'nn-NO': /^[0-9A-ZÆØÅ]+$/i,
	  'pl-PL': /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
	  'pt-PT': /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]+$/i,
	  'ru-RU': /^[0-9А-ЯЁ]+$/i,
	  'sk-SK': /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
	  'sr-RS@latin': /^[0-9A-ZČĆŽŠĐ]+$/i,
	  'sr-RS': /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
	  'sv-SE': /^[0-9A-ZÅÄÖ]+$/i,
	  'tr-TR': /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
	  'uk-UA': /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
	  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/
	};
	
	var decimal = exports.decimal = {
	  'en-US': '.',
	  ar: '٫'
	};
	
	var englishLocales = exports.englishLocales = ['AU', 'GB', 'HK', 'IN', 'NZ', 'ZA', 'ZM'];
	
	for (var locale, i = 0; i < englishLocales.length; i++) {
	  locale = 'en-' + englishLocales[i];
	  alpha[locale] = alpha['en-US'];
	  alphanumeric[locale] = alphanumeric['en-US'];
	  decimal[locale] = decimal['en-US'];
	}
	
	// Source: http://www.localeplanet.com/java/
	var arabicLocales = exports.arabicLocales = ['AE', 'BH', 'DZ', 'EG', 'IQ', 'JO', 'KW', 'LB', 'LY', 'MA', 'QM', 'QA', 'SA', 'SD', 'SY', 'TN', 'YE'];
	
	for (var _locale, _i = 0; _i < arabicLocales.length; _i++) {
	  _locale = 'ar-' + arabicLocales[_i];
	  alpha[_locale] = alpha.ar;
	  alphanumeric[_locale] = alphanumeric.ar;
	  decimal[_locale] = decimal.ar;
	}
	
	// Source: https://en.wikipedia.org/wiki/Decimal_mark
	var dotDecimal = exports.dotDecimal = [];
	var commaDecimal = exports.commaDecimal = ['bg-BG', 'cs-CZ', 'da-DK', 'de-DE', 'el-GR', 'es-ES', 'fr-FR', 'it-IT', 'hu-HU', 'nb-NO', 'nn-NO', 'nl-NL', 'pl-Pl', 'pt-PT', 'ru-RU', 'sr-RS@latin', 'sr-RS', 'sv-SE', 'tr-TR', 'uk-UA'];
	
	for (var _i2 = 0; _i2 < dotDecimal.length; _i2++) {
	  decimal[dotDecimal[_i2]] = decimal['en-US'];
	}
	
	for (var _i3 = 0; _i3 < commaDecimal.length; _i3++) {
	  decimal[commaDecimal[_i3]] = ',';
	}
	
	alpha['pt-BR'] = alpha['pt-PT'];
	alphanumeric['pt-BR'] = alphanumeric['pt-PT'];
	decimal['pt-BR'] = decimal['pt-PT'];

/***/ },
/* 73 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*! Copyright (c) Microsoft. All rights reserved.
	 *! Licensed under the MIT license. See LICENSE file in the project root for full license information.
	 */
	'use strict';
	var crypto = __webpack_require__(65);
	/**
	 * Returns the seconds elapsed since 1 January 1970 00:00:00 UTC until one
	 * hour from now.
	 * @function anHourFromNow
	 */
	function anHourFromNow() {
	    var raw = (Date.now() / 1000) + 3600;
	    return Math.ceil(raw);
	}
	exports.anHourFromNow = anHourFromNow;
	/*Codes_SRS_NODE_COMMON_AUTHORIZATION_05_004: [<urlEncodedSignature> shall be the URL-encoded <signature>.]*/
	/*Codes_SRS_NODE_COMMON_AUTHORIZATION_05_007: [<urlEncodedKeyName> shall be the URL-encoded <keyName>.]*/
	function encodeUriComponentStrict(str) {
	    // this stricter version of encodeURIComponent is a recommendation straight out of the MDN docs, see:
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent#Description
	    return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
	        return '%' + c.charCodeAt(0).toString(16);
	    });
	}
	exports.encodeUriComponentStrict = encodeUriComponentStrict;
	/*Codes_SRS_NODE_COMMON_AUTHORIZATION_05_006: [<stringToSign> shall be a concatenation of <resourceUri> + '\n' + <expiry>.]*/
	function stringToSign(resourceUri, expiry) {
	    return resourceUri + '\n' + expiry;
	}
	exports.stringToSign = stringToSign;
	/*Codes_SRS_NODE_COMMON_AUTHORIZATION_05_005: [<signature> shall be an HMAC-SHA256 hash of <stringToSign>, which is then base64-encoded.]*/
	/*Codes_SRS_NODE_COMMON_AUTHORIZATION_05_011: [The crypto algorithm should directly convert from base64 encoded password buffer to ensure JS compatibility]*/
	function hmacHash(password, stringToSign) {
	    var hmac = crypto.createHmac('sha256', new Buffer(password, 'base64'));
	    hmac.update(stringToSign);
	    return hmac.digest('base64');
	}
	exports.hmacHash = hmacHash;
	//# sourceMappingURL=authorization.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	'use strict';
	var retry_error_filter_1 = __webpack_require__(238);
	/**
	 * Parameters used with the {@link azure-iot-common.ExponentialBackOffWithJitter} policy to compute retry intervals.
	 */
	/*SRS_NODE_COMMON_RETRY_POLICY_16_009: [The default constants to use with the Math formula for the normal conditions retry are:
	```
	c = 100
	cMin = 100
	cMax = 10000
	ju = 0.25
	jd = 0.5
	```]*/
	var ExponentialBackoffWithJitterParameters = (function () {
	    function ExponentialBackoffWithJitterParameters() {
	        /**
	         * Initial retry interval: 100 ms by default.
	         */
	        this.c = 100;
	        /**
	         * Minimal interval between each retry. 100 milliseconds by default
	         */
	        this.cMin = 100;
	        /**
	         * Maximum interval between each retry. 10 seconds by default
	         */
	        this.cMax = 10000;
	        /**
	         * Jitter up factor. 0.25 by default.
	         */
	        this.ju = 0.25;
	        /**
	         * Jitter down factor. 0.5 by default
	         */
	        this.jd = 0.5;
	    }
	    return ExponentialBackoffWithJitterParameters;
	}());
	exports.ExponentialBackoffWithJitterParameters = ExponentialBackoffWithJitterParameters;
	/**
	 * Implements an Exponential Backoff with Jitter retry strategy.
	 * The function to calculate the next interval is the following (x is the xth retry):
	 * F(x) = min(Cmin+ (2^(x-1)-1) * rand(C * (1 – Jd), C*(1-Ju)), Cmax)
	 * @implements {RetryStrategy}
	 */
	/*Codes_SRS_NODE_COMMON_RETRY_POLICY_16_005: [The `ExponentialBackoffWithJitter` class shall implement the `RetryPolicy` interface.]*/
	var ExponentialBackOffWithJitter = (function () {
	    /**
	     * Initializes a new instance of the {@link azure-iot-common.ExponentialBackOffWithJitter} class.
	     * @param maxTimeout            maximum allowed timeout in milliseconds.
	     * @param immediateFirstRetry   boolean indicating whether the first retry should be immediate (default) or wait the first interval (c value).
	     */
	    function ExponentialBackOffWithJitter(immediateFirstRetry, errorFilter) {
	        this._errorFilter = errorFilter ? errorFilter : new retry_error_filter_1.DefaultErrorFilter();
	        this.immediateFirstRetry = immediateFirstRetry !== false; // should default to true if not specified.
	        this.normalParameters = new ExponentialBackoffWithJitterParameters();
	        this.throttledParameters = new ExponentialBackoffWithJitterParameters();
	        /*SRS_NODE_COMMON_RETRY_POLICY_16_010: [The default constants to use with the Math formula for the throttled conditions retry are:
	        ```
	        c = 5000
	        cMin = 10000
	        cMax = 60000
	        ju = 0.5
	        jd = 0.25
	        ```]*/
	        this.throttledParameters.c = 5000;
	        this.throttledParameters.cMin = 10000;
	        this.throttledParameters.cMax = 60000;
	    }
	    /**
	     * Computes the interval to wait before retrying at each new retry tentative.
	     *
	     * @param {number} retryCount    Current retry tentative.
	     * @param {boolean} isThrottled  Boolean indicating whether the Azure IoT hub is throttling operations.
	     * @returns {number}             The time to wait before attempting a retry in milliseconds.
	     */
	    ExponentialBackOffWithJitter.prototype.nextRetryTimeout = function (retryCount, isThrottled) {
	        /*SRS_NODE_COMMON_RETRY_POLICY_16_008: [The `getNextTimeout` method shall return `0` instead of the result of the math formula if the following 3 conditions are met:
	        - the `constructor` was called with the `immediateFirstTimeout` boolean set to `true`
	        - the `isThrottled` boolean is `false`.
	        - the `currentRetryCount` is `0` (meaning it's the first retry).]*/
	        if (this.immediateFirstRetry && retryCount === 0 && !isThrottled) {
	            return 0;
	        }
	        else {
	            /*Codes_SRS_NODE_COMMON_RETRY_POLICY_16_007: [The `getNextTimeout` method shall implement the following math formula to determine the next timeout value: `F(x) = min(Cmin+ (2^(x-1)-1) * rand(C * (1 – Jd), C*(1-Ju)), Cmax)`]*/
	            var constants = isThrottled ? this.throttledParameters : this.normalParameters;
	            var minRandomFactor = constants.c * (1 - constants.jd);
	            var maxRandomFactor = constants.c * (1 - constants.ju);
	            var randomJitter = Math.random() * (maxRandomFactor - minRandomFactor);
	            return Math.min(constants.cMin + (Math.pow(retryCount - 1, 2) - 1) * randomJitter, constants.cMax);
	        }
	    };
	    /**
	     * Based on the error passed as argument, determines if an error is transient and if the operation should be retried or not.
	     *
	     * @param {Error} error The error encountered by the operation.
	     * @returns {boolean}   Whether the operation should be retried or not.
	     */
	    ExponentialBackOffWithJitter.prototype.shouldRetry = function (error) {
	        /*Codes_SRS_NODE_COMMON_RETRY_POLICY_16_006: [The `shouldRetry` method of the new instance shall use the error filter passed to the constructor when the object was instantiated.]*/
	        return this._errorFilter[error.name];
	    };
	    return ExponentialBackOffWithJitter;
	}());
	exports.ExponentialBackOffWithJitter = ExponentialBackOffWithJitter;
	/**
	 * Stub policy that blocks any retry tentative. Operations are not retried.
	 *
	 * @implements {RetryPolicy}
	 */
	var NoRetry = (function () {
	    function NoRetry() {
	    }
	    /**
	     * This will always return -1 as no retry is desired.
	     *
	     * @param {number} retryCount This parameter is ignored.
	     */
	    /*Codes_SRS_NODE_COMMON_RETRY_POLICY_16_004: [The `getNextTimeout` method shall always return `-1`.]*/
	    NoRetry.prototype.nextRetryTimeout = function (retryCount) {
	        return -1;
	    };
	    /**
	     * This will always return false as no retry is desired.
	     *
	     * @param {Error} err This parameter is ignored.
	     * @returns {boolean} Will always be false: retry should not be attempted no matter what the error is.
	     */
	    /*Codes_SRS_NODE_COMMON_RETRY_POLICY_16_03: [The `shouldRetry` method shall always return `false`.]*/
	    NoRetry.prototype.shouldRetry = function (err) {
	        return false;
	    };
	    return NoRetry;
	}());
	exports.NoRetry = NoRetry;
	//# sourceMappingURL=retry_policy.js.map

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	
	'use strict';
	
	var crypto = __webpack_require__(65);
	
	/**
	 * Returns the seconds elapsed since 1 January 1970 00:00:00 UTC until one
	 * hour from now.
	 * @function anHourFromNow
	 */
	function anHourFromNow() {
	  var raw = (Date.now() / 1000) + 3600;
	  return Math.ceil(raw);
	}
	
	/*Codes_SRS_NODE_COMMON_AUTHORIZATION_05_004: [<urlEncodedSignature> shall be the URL-encoded <signature>.]*/
	/*Codes_SRS_NODE_COMMON_AUTHORIZATION_05_007: [<urlEncodedKeyName> shall be the URL-encoded <keyName>.]*/
	function encodeUriComponentStrict(str) {
	  // this stricter version of encodeURIComponent is a recommendation straight out of the MDN docs, see:
	  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent#Description
	  return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
	    return '%' + c.charCodeAt(0).toString(16);
	  });
	}
	
	/*Codes_SRS_NODE_COMMON_AUTHORIZATION_05_006: [<stringToSign> shall be a concatenation of <resourceUri> + '\n' + <expiry>.]*/
	function stringToSign(resourceUri, expiry) {
	  return resourceUri + '\n' + expiry;
	}
	
	/*Codes_SRS_NODE_COMMON_AUTHORIZATION_05_005: [<signature> shall be an HMAC-SHA256 hash of <stringToSign>, which is then base64-encoded.]*/
	/*Codes_SRS_NODE_COMMON_AUTHORIZATION_05_011: [The crypto algorithm should directly convert from base64 encoded password buffer to ensure JS compatibility]*/
	function hmacHash(password, stringToSign) {
	  var hmac = crypto.createHmac('sha256', new Buffer(password, 'base64'));
	  hmac.update(stringToSign);
	  return hmac.digest('base64');
	}
	
	module.exports = {
	  anHourFromNow: anHourFromNow,
	  encodeUriComponentStrict: encodeUriComponentStrict,
	  stringToSign: stringToSign,
	  hmacHash: hmacHash
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 77 */
76,
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	var azureCommon = __webpack_require__(8);
	
	// Streams
	azureCommon.FileReadStream = __webpack_require__(280);
	
	module.exports = azureCommon;

/***/ },
/* 79 */
/***/ function(module, exports) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	/**
	* Creates a new Logger object
	* @class
	* The Logger class is used to write log information.
	* 
	* @constructor
	*
	* @param {string} [level]           The log level. Refer to Logger.LogLevels.
	* @param {object} [loggerFunction]  The function to write log information.
	*/
	function Logger(level, loggerFunction) {
	  /**
	   * The log level. Refer to the Logger.LogLevels for available log levels. 
	   * @name  Logger#level
	   * @type  {string}
	   * @see Logger.LogLevels
	   */
	  this.level = level;
	  
	  this.loggerFunction = loggerFunction;
	
	  if (!this.loggerFunction) {
	    this.loggerFunction = this.defaultLoggerFunction;
	  }
	}
	
	/**
	* The available log levels.
	*
	* @const
	* @enum {string}
	*/
	Logger.LogLevels = {
	  /**
	  * System is unusable.
	  */
	  EMERGENCY: 'emergency',
	
	  /**
	  * Action must be taken immediately.
	  */
	  ALERT : 'alert',
	
	  /**
	  * Critical condition.
	  */
	  CRITICAL : 'critical',
	
	  /**
	  * Error condition.
	  */
	  ERROR : 'error',
	
	  /**
	  * Warning condition.
	  */
	  WARNING : 'warning',
	
	  /**
	  * Normal but significant condition.
	  */
	  NOTICE : 'notice',
	
	  /**
	  * Purely informational message.
	  */
	  INFO : 'info',
	
	  /**
	  * Application debug messages.
	  */
	  DEBUG : 'debug'
	};
	
	Logger.logPriority = [
	  Logger.LogLevels.EMERGENCY,
	  Logger.LogLevels.ALERT,
	  Logger.LogLevels.CRITICAL,
	  Logger.LogLevels.ERROR,
	  Logger.LogLevels.WARNING,
	  Logger.LogLevels.NOTICE,
	  Logger.LogLevels.INFO,
	  Logger.LogLevels.DEBUG
	];
	
	Logger.prototype.log = function (level, msg) {
	  this.loggerFunction(level, msg);
	};
	
	Logger.prototype.emergency = function(msg) {
	  this.log(Logger.LogLevels.EMERGENCY, msg);
	};
	
	Logger.prototype.critical = function(msg) {
	  this.log(Logger.LogLevels.CRITICAL, msg);
	};
	
	Logger.prototype.alert = function(msg) {
	  this.log(Logger.LogLevels.ALERT, msg);
	};
	
	Logger.prototype.error = function(msg) {
	  this.log(Logger.LogLevels.ERROR, msg);
	};
	
	Logger.prototype.warn = function(msg) {
	  this.log(Logger.LogLevels.WARNING, msg);
	};
	
	Logger.prototype.notice = function(msg) {
	  this.log(Logger.LogLevels.NOTICE, msg);
	};
	
	Logger.prototype.info = function(msg) {
	  this.log(Logger.LogLevels.INFO, msg);
	};
	
	Logger.prototype.debug = function(msg) {
	  this.log(Logger.LogLevels.DEBUG, msg);
	};
	
	Logger.prototype.defaultLoggerFunction = function(logLevel , msg) {
	  var currentLevelIndex = Logger.logPriority.indexOf(this.level);
	  var logLevelIndex = Logger.logPriority.indexOf(logLevel);
	  var time = new Date();
	  var timeStamp = time.toISOString();
	  if (logLevelIndex <= currentLevelIndex) {
	    console.log('[' + timeStamp + ']' + this.level + ' : ' + msg);
	  }
	};
	
	module.exports = Logger;


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	var azureutil = __webpack_require__(16);
	var Constants = __webpack_require__(12);
	var StorageUtilities = __webpack_require__(63);
	var extend = __webpack_require__(4)._extend;
	
	/**
	* Creates a new RetryPolicyFilter instance.
	* @class
	* The RetryPolicyFilter allows you to retry operations,
	* using a custom retry policy. Users are responsible to 
	* define the shouldRetry method.
	* To apply a filter to service operations, use `withFilter`
	* and specify the filter to be used when creating a service.
	* @constructor
	* @param {number} [retryCount=30000]        The client retry count.
	* @param {number} [retryInterval=3]     The client retry interval, in milliseconds.
	*
	* @example
	* var azure = require('azure-storage');
	* var retryPolicy = new azure.RetryPolicyFilter();
	* retryPolicy.retryCount = 3;
	* retryPolicy.retryInterval = 3000;
	* retryPolicy.shouldRetry = function(statusCode, retryContext) {
	*
	* };
	* var blobService = azure.createBlobService().withFilter(retryPolicy);
	*/
	function RetryPolicyFilter(retryCount, retryInterval) {
	  this.retryCount = retryCount ? retryCount : RetryPolicyFilter.DEFAULT_CLIENT_RETRY_COUNT;
	  this.retryInterval = retryInterval ? retryInterval : RetryPolicyFilter.DEFAULT_CLIENT_RETRY_INTERVAL;
	}
	
	/**
	* Represents the default client retry interval, in milliseconds.
	*/
	RetryPolicyFilter.DEFAULT_CLIENT_RETRY_INTERVAL = 1000 * 30;
	
	/**
	* Represents the default client retry count.
	*/
	RetryPolicyFilter.DEFAULT_CLIENT_RETRY_COUNT = 3;
	
	/**
	* Handles an operation with a retry policy.
	*
	* @param {Object}   requestOptions The original request options.
	* @param {function} next           The next filter to be handled.
	*/
	RetryPolicyFilter.prototype.handle = function (requestOptions, next) {
	  RetryPolicyFilter._handle(this, requestOptions, next);
	};
	
	/**
	* Handles an operation with a retry policy.
	*
	* @param {Object}   requestOptions The original request options.
	* @param {function} next           The next filter to be handled.
	*/
	RetryPolicyFilter._handle = function (self, requestOptions, next) {
	
	  var retryRequestOptions = extend({}, requestOptions);
	  retryRequestOptions.retryInterval = 0;
	
	  // Initialize retryContext because that will be passed to the shouldRetry method which users will implement 
	  retryRequestOptions.retryContext = {
	    retryCount: 0,
	    error: null,
	    retryInterval: retryRequestOptions.retryInterval,
	    locationMode: retryRequestOptions.locationMode,
	    currentLocation: retryRequestOptions.currentLocation
	  };
	
	  var lastPrimaryAttempt;
	  var lastSecondaryAttempt;
	  var operation = function () {
	    // retry policies dont really do anything to the request options
	    // so move on to next
	    if (next) {
	      next(retryRequestOptions, function (returnObject, finalCallback, nextPostCallback) {
	        // Previous operation ended so update the retry data
	        if (returnObject.error) {
	          if (retryRequestOptions.retryContext.error) {
	            returnObject.error.innerError = retryRequestOptions.retryContext.error;
	          }
	
	          retryRequestOptions.retryContext.error = returnObject.error;
	        }
	
	        // If a request sent to the secondary location fails with 404 (Not Found), it is possible
	        // that the resource replication is not finished yet. So, in case of 404 only in the secondary
	        // location, the failure should still be retryable.
	        var secondaryNotFound = (retryRequestOptions.currentLocation === Constants.StorageLocation.SECONDARY) && ((returnObject.response && returnObject.response.statusCode === 404) || (returnObject.error && returnObject.error.code === 'ENOTFOUND'));
	 
	        var notExceedMaxRetryCount = retryRequestOptions.retryContext.retryCount ? retryRequestOptions.retryContext.retryCount <= self.retryCount : true;
	        var retryInfo = self.shouldRetry(secondaryNotFound ? 500 : (azureutil.objectIsNull(returnObject.response) ? 306 : returnObject.response.statusCode), retryRequestOptions);
	        retryRequestOptions.retryContext.retryCount++;
	
	        if (retryInfo.ignore) {
	          returnObject.error = null;
	        }
	
	        // If the custom retry logic(shouldRetry) does not return a targetLocation, calculate based on the previous location and locationMode.
	        if(azureutil.objectIsNull(retryInfo.targetLocation)) {
	          retryInfo.targetLocation = azureutil.getNextLocation(retryRequestOptions.currentLocation, retryRequestOptions.locationMode);
	        }
	
	        // If the custom retry logic(shouldRetry) does not return a retryInterval, try to set it to the value on the instance if it is available. Otherwise, the default(30000) will be used.
	        if(azureutil.objectIsNull(retryInfo.retryInterval)) {
	          retryInfo.retryInterval = self.retryInterval;
	        }
	        
	        // Only in the case of success from server but client side failure like MD5 or length mismatch, returnObject.retryable has a value(we explicitly set it to false). 
	        // In this case, we should not retry the request.
	        // If the output stream already get sent to server and get error back, 
	        // we should NOT retry within the SDK as the stream data is not valid anymore if we retry directly.
	        if (
	            !returnObject.outputStreamSent && returnObject.error && azureutil.objectIsNull(returnObject.retryable) && notExceedMaxRetryCount &&
	            (
	              (!azureutil.objectIsNull(returnObject.response) && retryInfo.retryable) || 
	              (
	                returnObject.error.code === 'ECONNREFUSED' ||
	                returnObject.error.code === 'ETIMEDOUT' ||
	                returnObject.error.code === 'ESOCKETTIMEDOUT' || 
	                returnObject.error.code === 'ECONNRESET' || 
	                returnObject.error.code === 'EAI_AGAIN' ||
	                returnObject.error.message === 'XHR error' // stream-http XHR network error message in browsers
	              )
	            )
	          ) {
	          if (retryRequestOptions.currentLocation === Constants.StorageLocation.PRIMARY) {
	            lastPrimaryAttempt = returnObject.operationEndTime;
	          } else {
	            lastSecondaryAttempt = returnObject.operationEndTime;
	          }
	
	          // Moreover, in case of 404 when trying the secondary location, instead of retrying on the
	          // secondary, further requests should be sent only to the primary location, as it most
	          // probably has a higher chance of succeeding there.
	          if (secondaryNotFound && (retryRequestOptions.locationMode !== StorageUtilities.LocationMode.SECONDARY_ONLY))
	          {
	            retryInfo.locationMode = StorageUtilities.LocationMode.PRIMARY_ONLY;
	            retryInfo.targetLocation = Constants.StorageLocation.PRIMARY;
	          }
	
	          // Now is the time to calculate the exact retry interval. ShouldRetry call above already
	          // returned back how long two requests to the same location should be apart from each other.
	          // However, for the reasons explained above, the time spent between the last attempt to
	          // the target location and current time must be subtracted from the total retry interval
	          // that ShouldRetry returned.
	          var lastAttemptTime = retryInfo.targetLocation === Constants.StorageLocation.PRIMARY ? lastPrimaryAttempt : lastSecondaryAttempt;
	          if (!azureutil.objectIsNull(lastAttemptTime)) {
	            var sinceLastAttempt = new Date().getTime() - lastAttemptTime.getTime();
	            if (sinceLastAttempt < 0) {
	              sinceLastAttempt = 0;
	            }
	
	            retryRequestOptions.retryInterval = retryInfo.retryInterval - sinceLastAttempt;
	          }
	          else {
	            retryRequestOptions.retryInterval = 0;
	          }
	
	          if(!azureutil.objectIsNull(retryInfo.locationMode)) {
	            retryRequestOptions.locationMode = retryInfo.locationMode;
	          }
	
	          retryRequestOptions.currentLocation = retryInfo.targetLocation;
	          operation();
	        } else {
	          if (nextPostCallback) {
	            nextPostCallback(returnObject);
	          } else if (finalCallback) {
	            finalCallback(returnObject);
	          }
	        }
	      });
	    }
	  };
	
	  operation();
	};
	
	RetryPolicyFilter._shouldRetryOnError = function (statusCode, requestOptions) {
	  var retryInfo = (requestOptions && requestOptions.retryContext) ? requestOptions.retryContext : {};
	
	  // Non-timeout Cases
	  if (statusCode >= 300 && statusCode != 408) {
	    // Always no retry on "not implemented" and "version not supported"
	    if (statusCode == 501 || statusCode == 505) {
	      retryInfo.retryable = false;
	      return retryInfo;
	    }
	    
	    // When absorbConditionalErrorsOnRetry is set (for append blob)
	    if (requestOptions && requestOptions.absorbConditionalErrorsOnRetry) {
	      if (statusCode == 412) {
	        // When appending block with precondition failure and their was a server error before, we ignore the error.
	        if (retryInfo.lastServerError) {
	          retryInfo.ignore = true;
	          retryInfo.retryable = true;
	        } else {
	          retryInfo.retryable = false;
	        }
	      } else if (retryInfo.retryable && statusCode >= 500 && statusCode < 600) {
	        // Retry on the server error
	        retryInfo.retryable = true;
	        retryInfo.lastServerError = true;
	      }
	    } else if (statusCode < 500) {
	      // No retry on the client error
	      retryInfo.retryable = false;
	    }
	  }
	
	  return retryInfo;
	};
	
	module.exports = RetryPolicyFilter;


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	var azureCommon = __webpack_require__(8);
	var azureutil = azureCommon.util;
	var Constants = __webpack_require__(12);
	var EventEmitter = __webpack_require__(14).EventEmitter;
	
	/**
	* Range stream
	*/
	function RangeStream(serviceClient, container, blob, options) {
	  this.serviceClient = serviceClient;
	  this._emitter = new EventEmitter();
	  this._paused = false;
	  this._emittedAll = false;
	  this._emittedRangeIndex = 0;
	  this._rangelist = [];
	  this._resourcePath = [];
	  this._isEmitting = false;
	  this._rangeStreamEnded = false;
	  this._lengthHeader = Constants.HeaderConstants.CONTENT_LENGTH;
	  this._minRangeSize = Constants.BlobConstants.MIN_WRITE_PAGE_SIZE_IN_BYTES;
	  this._maxRangeSize = Constants.BlobConstants.DEFAULT_WRITE_PAGE_SIZE_IN_BYTES;
	  if (options.rangeStart) {
	    this._startOffset = options.rangeStart;
	  } else {
	    this._startOffset = 0;
	  }
	  this._dataOffset = this._startOffset;
	  if (options.rangeEnd) {
	    this._endOffset = options.rangeEnd;
	  } else {
	    this._endOffset = Number.MAX_VALUE;
	  }
	  if (container) {
	    this._resourcePath.push(container);
	  }
	  if (blob) {
	    this._resourcePath.push(blob); 
	  }
	}
	
	/**
	* Get range list
	*/
	RangeStream.prototype.list = function (options, callback) {
	  var start = this._startOffset;
	  var end;
	  var singleRangeSize = Constants.BlobConstants.MAX_SINGLE_GET_PAGE_RANGE_SIZE;
	
	  if (this._listFunc === undefined) {
	    // the default function puts the whole blob into a single list item
	    this._listFunc = this._defaultListFunc;
	    end = this._endOffset;
	  } else {
	    end = Math.min(this._startOffset + singleRangeSize - 1, this._endOffset);
	  }
	  options.rangeStart = start;
	  if (end != Number.MAX_VALUE) {
	    options.rangeEnd = end;
	  }
	
	  var self = this;
	  var onList = function (error, ranges, response) {
	    if (error) {
	      callback(error);
	    } else {
	      if (self._rangeStreamEnded) {
	        return;
	      }
	
	      var totalSize = parseInt(response.headers[self._lengthHeader], 10);
	      var endOffset = Math.min(totalSize - 1, self._endOffset);
	      var rangeEnd = Math.min(end, endOffset);
	  
	      if (!ranges.length) {
	        // convert single object to range
	        // start >= end means there is no valid regions
	        ranges.push({ start : start, end : rangeEnd, dataSize: 0 });
	      } else if (ranges[ranges.length - 1].end !== rangeEnd) {
	        // don't forget the zero chunk at the end of range
	        ranges.push({ start : ranges[ranges.length - 1].end + 1, end : rangeEnd, dataSize: 0 });
	      }
	      
	      if (end >= endOffset) {
	        self._rangeStreamEnded = true;
	      }
	      self.resizeAndSaveRanges(ranges);
	      self._startOffset += singleRangeSize;
	      self._emitRange();
	      
	      // This is only valid when listing pages because when listing with the default function, the "endOffset" will always equal to or greater than the "end". 
	      if (end < endOffset && !self._rangeStreamEnded) {
	        process.nextTick(function () {
	          ranges = null;
	          self.list(options, callback);
	          self = null;
	        });
	      }
	    }
	  };
	
	  var callArguments = Array.prototype.slice.call(this._resourcePath);
	  callArguments.push(options);
	  callArguments.push(onList);
	  this._listFunc.apply(this.serviceClient, callArguments);
	};
	
	/**
	* Resize regions:
	*   1. Merge small pieces into a range no less than this._minRangeSize
	*   2. Split large pieces into ranges no more than this._maxRangeSize
	*/
	RangeStream.prototype.resizeAndSaveRanges = function (ranges) {
	  var rangeList = this._rangelist;
	  var holdingRange = { type : 'range', size : 0, dataSize : 0, start : this._startOffset, end : -1 };
	  var readingRange = null;
	  var rangeSize = 0;
	
	  for (var index = 0; index < ranges.length; index++) {
	    readingRange = ranges[index];
	    rangeSize = readingRange.end - holdingRange.start + 1;
	    
	    if (rangeSize < this._minRangeSize) {
	      // merge fragment ranges
	      this.mergeRanges(holdingRange, readingRange);
	    } else {
	      if (holdingRange.end != -1) {
	        // save the holding range list and hold the reading range
	        this.splitAndSaveRanges(holdingRange, rangeList);
	        holdingRange = readingRange;
	      }
	      
	      if (this._dataOffset != readingRange.start) {
	        // padding zero for empty range and hold the reading range 
	        this.putZeroRange(this._dataOffset, readingRange.start - 1, rangeList);
	        holdingRange = readingRange;
	      } else if (holdingRange.end == -1) {
	        // if holdingRange is never set, it means readingRange exceeds MIN_WRITE_FILE_SIZE_IN_BYTES
	        this.splitAndSaveRanges(readingRange, rangeList);
	        // reading range has been saved, offset the holding start position for calculating the range size in next loop
	        holdingRange.start = readingRange.end + 1;
	      }
	    }
	    
	    // If it is the last range, put the holding range into list anyway
	    if (index == ranges.length - 1 && holdingRange.end > holdingRange.start) {
	      this.splitAndSaveRanges(holdingRange, rangeList);
	    }
	    
	    this._dataOffset = readingRange.end + 1;
	  }
	};
	
	/**
	* Put a zero range into range list
	*/
	RangeStream.prototype.putZeroRange = function (startOffset, endOffset, rangeList) {
	  var zeroDataRange = { type : 'range', size : -1, dataSize : 0, start : startOffset, end : endOffset };
	  this.splitAndSaveRanges(zeroDataRange, rangeList);
	};
	
	/**
	* Merge small ranges
	*/
	RangeStream.prototype.mergeRanges = function (holdingRange, readingRange) {
	  holdingRange.size = readingRange.end - holdingRange.start + 1;
	  holdingRange.dataSize += readingRange.dataSize;
	  holdingRange.end = readingRange.end;
	  return holdingRange;
	};
	
	/**
	* Split range into small pieces with maximum _maxRangeSize and minimum _minRangeSize size.
	* For example, [0, 10G - 1] => [0, 4MB - 1], [4MB, 8MB - 1] ... [10GB - 4MB, 10GB - 1]
	*/
	RangeStream.prototype.splitAndSaveRanges = function (range, rangeList) {
	  var rangeSize = range.end - range.start + 1;
	  var offset = range.start;
	  var limitedSize = 0;
	
	  while (rangeSize > 0) {
	    var newRange = { type : 'range', size : 0, dataSize : 0, start : -1, end : -1 };
	    limitedSize = Math.min(rangeSize, this._maxRangeSize);
	    newRange.start = offset;
	    newRange.size = limitedSize;
	    if (range.dataSize === 0) {
	      newRange.dataSize = 0;
	    } else {
	      newRange.dataSize = limitedSize;
	    }
	    offset += limitedSize;
	    newRange.end = offset - 1;
	    rangeList.push(newRange);
	    rangeSize -= limitedSize;
	  }
	};
	
	/**
	* Emit a range
	*/
	RangeStream.prototype._emitRange = function () {
	  if (this._paused || this._emittedAll || this._isEmitting) return;
	  this._isEmitting = true;
	  try {
	    for (; this._emittedRangeIndex < this._rangelist.length; this._emittedRangeIndex++) {
	      if (this._paused) {
	        return;
	      }
	      var range = this._rangelist[this._emittedRangeIndex];
	      this._emitter.emit('range', range);
	      this._rangelist[this._emittedRangeIndex] = null;
	    }
	    
	    if (this._rangeStreamEnded) {
	      this._rangelist = null;
	      this._emittedAll = true;
	      this._emitter.emit('end');
	    }
	  } finally {
	    this._isEmitting = false;
	  }
	};
	
	/**
	* The Default list function which puts the whole blob into one range.
	*/
	RangeStream.prototype._defaultListFunc = function (container, blob, optionsOrCallback, callback) {
	  var options;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { options = o; callback = c; });
	  
	  this.getBlobProperties(container, blob, options, function (error, result, response) {
	    if (error) {
	      callback(error);
	    } else {
	      var range = [{}];
	      range[0].start = options.rangeStart ? Math.max(options.rangeStart, 0) : 0;
	      range[0].end = options.rangeEnd ? Math.min(options.rangeEnd, result.contentLength - 1) : result.contentLength - 1;
	      range[0].size = range[0].end - range[0].start + 1;
	      range[0].dataSize = range[0].size;
	      callback(error, range, response);
	    }
	  });
	};
	
	/**
	* Add event listener
	*/
	RangeStream.prototype.on = function (event, listener) {
	  this._emitter.on(event, listener);
	};
	
	/**
	* Pause the stream
	*/
	RangeStream.prototype.pause = function () {
	  this._paused = true;
	};
	
	/**
	* Resume the stream
	*/
	RangeStream.prototype.resume = function () {
	  this._paused = false;
	  if (!this._isEmitting) {
	    this._emitRange();
	  }
	};
	
	/**
	* Stop the stream
	*/
	RangeStream.prototype.stop = function () {
	  this.pause();
	  this._emittedAll = true;
	  this._emitter.emit('end');
	};
	
	module.exports = RangeStream;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	var _ = __webpack_require__(15);
	var util = __webpack_require__(4);
	
	var constants = __webpack_require__(12);
	var blobConstants = constants.BlobConstants;
	var BlobUtilities = __webpack_require__(51);
	var FileUtilities = __webpack_require__(139);
	var azureutil = __webpack_require__(16);
	var SR = __webpack_require__(25);
	var check = __webpack_require__(217);
	var errors = __webpack_require__(30);
	var ArgumentError = errors.ArgumentError;
	var ArgumentNullError = errors.ArgumentNullError;
	
	exports = module.exports;
	
	function initCallback(callbackParam, resultsCb) {
	  var fail;
	  if (callbackParam) {
	    fail = function (err) {
	      callbackParam(err);
	      return false;
	    };
	  } else {
	    fail = function (err) {
	      throw err;
	    };
	    callbackParam = function () {};
	  }
	
	  resultsCb(fail, callbackParam);
	}
	
	/**
	* Checks if the given value is a valid enumeration or not.
	*
	* @param {object} value     The value to validate.
	* @param {object} list      The enumeration values.
	* @return {boolean}
	*/
	exports.isValidEnumValue = function (value, list, callback) {
	  var fail;
	  
	  initCallback(callback, function (f, cb) {
	    fail = f;
	    callback = cb;
	  });
	
	  if (!list.some(function (current) {
	    return current.toLowerCase() === value.toLowerCase();
	  })) {
	    return fail(new RangeError(util.format('Invalid value: %s. Options are: %s.', value, list)));
	  }
	
	  callback();
	  return true;
	};
	
	/**
	* Creates a anonymous function that check if the given uri is valid or not.
	*
	* @param {string} uri     The uri to validate.
	* @return {boolean}
	*/
	exports.isValidUri = function (uri) {
	  if (!check.isURL(uri)){
	    throw new URIError('The provided URI "' + uri + '" is invalid.');
	  }
	  return true;
	};
	
	/**
	* Checks if the given host is valid or not.
	*
	* @param {string|object} host     The host to validate.
	* @return {boolean}
	*/
	exports.isValidHost= function (host) {
	  if (azureutil.objectIsNull(host)) {
	    throw new ArgumentNullError('host', SR.STORAGE_HOST_LOCATION_REQUIRED);
	  } else {
	    var storageHost = {};
	    storageHost.primaryHost = _.isString(host) ? host : host.primaryHost;
	    if (storageHost.primaryHost && !check.isURL(storageHost.primaryHost)){
	      throw new URIError('The provided URI "' + storageHost.primaryHost + '" is invalid.');
	    }
	
	    storageHost.secondaryHost = _.isString(host) ? undefined : host.secondaryHost;
	    if (storageHost.secondaryHost && !check.isURL(storageHost.secondaryHost)){
	      throw new URIError('The provided URI "' + storageHost.secondaryHost + '" is invalid.');
	    }
	
	    if (!storageHost.primaryHost && !storageHost.secondaryHost) {
	      throw new ArgumentNullError('host', SR.STORAGE_HOST_LOCATION_REQUIRED);
	    }
	  } 
	
	  return true;
	};
	
	/**
	* Checks if the given value is a valid UUID or not.
	*
	* @param {string|object} uuid     The uuid to validate.
	* @return {boolean}
	*/
	exports.isValidUuid = function(uuid, callback) {
	  var validUuidRegex = /^[a-zA-Z0-9]{8}\-[a-zA-Z0-9]{4}\-[a-zA-Z0-9]{4}\-[a-zA-Z0-9]{4}\-[a-zA-Z0-9]{12}$/;
	
	  var fail;
	
	  initCallback(callback, function (f, cb) {
	    fail = f;
	    callback = cb;
	  });
	
	  if (!validUuidRegex.test(uuid)) {
	    return fail(new SyntaxError('The value is not a valid UUID format.'));
	  }
	  
	  callback();
	  return true;
	};
	
	/**
	* Creates a anonymous function that check if a given key is base 64 encoded.
	*
	* @param {string} key The key to validate.
	* @return {function}
	*/
	exports.isBase64Encoded = function (key) {
	  var isValidBase64String = key.match(/^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/);
	
	  if (isValidBase64String) {
	    return true;
	  } else {
	    throw new SyntaxError('The provided account key ' + key + ' is not a valid base64 string.');
	  }
	};
	
	/**
	* Validates a function.
	*
	* @param {object} function The function to validate.
	* @return {function}
	*/
	exports.isValidFunction = function (functionObject, functionName) {
	  if (!functionObject) {
	    throw new ArgumentNullError('functionObject', functionName + ' must be specified.');
	  }
	  if(!_.isFunction(functionObject)){
	    throw new TypeError(functionName + ' specified should be a function.');
	  }
	  return true;
	};
	
	var getNameError = function(name, typeName) {
	  // checks if name is null, undefined or empty
	  if (azureutil.stringIsEmpty(name)) {
	    return new ArgumentNullError('name', util.format('%s name must be a non empty string.', typeName));
	  }
	
	  // check if name is between 3 and 63 characters
	  if (name.length < 3 || name.length > 63) {
	    return new ArgumentError('name', util.format('%s name must be between 3 and 63 characters long.', typeName));
	  }
	
	  // check if name follows naming rules
	  if (name.match(/^([a-z0-9]+(-[a-z0-9]+)*)$/) === null) {
	    return new SyntaxError(util.format('%s name format is incorrect.', typeName));
	  }
	
	  return null;
	};
	
	/**
	* Validates a container name.
	*
	* @param {string} containerName The container name.
	*/
	exports.containerNameIsValid = function (containerName, callback) {
	  var fail;
	  initCallback(callback, function (f, cb) {
	    fail = f;
	    callback = cb;
	  });
	
	  var nameError = getNameError(containerName, 'Container');
	
	  if (!nameError || containerName.match(/^(\$root|\$logs)$/)) {
	    callback();
	    return true;
	  } else {
	    return fail(nameError);
	  }
	};
	
	/**
	* Validates a blob name.
	*
	* @param {string} containerName The container name.
	* @param {string} blobname      The blob name.
	*/
	exports.blobNameIsValid = function (containerName, blobName, callback) {
	  var fail;
	  
	  initCallback(callback, function (f, cb) {
	    fail = f;
	    callback = cb;
	  });
	  
	  if (!blobName) {
	    return fail(new ArgumentNullError('blobName', 'Blob name is not specified.'));
	  }
	  
	  if (containerName === '$root' && blobName.indexOf('/') !== -1) {
	    return fail(new SyntaxError('Blob name format is incorrect.'));
	  }
	  
	  callback();
	  return true;
	};
	
	/**
	* Validates a blob tier name.
	*
	* @param {string} blobTier The blob tier name.
	*/
	exports.blobTierNameIsValid = function (blobTier, callback) {
	  var fail;
	  
	  initCallback(callback, function (f, cb) {
	    fail = f;
	    callback = cb;
	  });
	  
	  if (!blobTier) {
	    return fail(new ArgumentNullError('blobTier', 'Blob tier is not specified.'));
	  }
	
	  if (!_.chain(_.union(
	    _.values(BlobUtilities.BlobTier.PremiumPageBlobTier),
	    _.values(BlobUtilities.BlobTier.StandardBlobTier)
	  ))
	    .map(function (val) { return val.toString().toUpperCase(); })
	    .contains(blobTier.toString().toUpperCase())
	    .value()) {
	    return fail(new SyntaxError('Blob tier is incorrect. Refer to BlobUtilities.BlobTier for possible values.'));
	  }
	
	  callback();
	  return true;
	};
	
	/**
	* Validates a share name.
	*
	* @param {string} shareName The share name.
	*/
	exports.shareNameIsValid = function (shareName, callback) {
	  var fail;
	  initCallback(callback, function (f, cb) {
	    fail = f;
	    callback = cb;
	  });
	
	  var nameError = getNameError(shareName, 'Share');
	
	  if (!nameError) {
	    callback();
	    return true;
	  } else {
	    return fail(nameError);
	  }
	};
	
	/**
	* Validates a queue name.
	*
	* @param {string} queueName The queue name.
	*/
	exports.queueNameIsValid = function (queueName, callback) {
	  var fail;
	
	  initCallback(callback, function (f, cb) {
	    fail = f;
	    callback = cb;
	  });
	
	  var nameError = getNameError(queueName, 'Queue');
	
	  if (!nameError) {
	    callback();
	    return true;
	  } else {
	    return fail(nameError);
	  }
	};
	
	/**
	* Validates a table name.
	*
	* @param {string} table  The table name.
	*/
	exports.tableNameIsValid = function (table, callback) {
	  var fail;
	
	  initCallback(callback, function (f, cb) {
	    fail = f;
	    callback = cb;
	  });
	
	  if (azureutil.stringIsEmpty(table)) {
	    return fail(new ArgumentNullError('table', 'Table name must be a non empty string.'));
	  }
	
	  if (table.length < 3 || table.length > 63) {
	    return fail(new ArgumentError('table', 'Table name must be between 3 and 63 characters long.'));
	  }
	
	  if(table.toLowerCase() === 'tables') {
	    return fail(new RangeError('Table name cannot be \'Tables\'.'));
	  }
	
	  if (table.match(/^([A-Za-z][A-Za-z0-9]{2,62})$/) !== null || table === '$MetricsCapacityBlob' || table.match(/^(\$Metrics(HourPrimary|MinutePrimary|HourSecondary|MinuteSecondary)?(Transactions)(Blob|Queue|Table|File))$/) !== null)
	  {
	    callback();
	    return true;
	  } else {
	    return fail(new SyntaxError('Table name format is incorrect.'));
	  }
	};
	
	/**
	* Validates an HTML File object.
	*
	* @param {File} browserFile  The HTML File object.
	*/
	exports.browserFileIsValid = function (browserFile, callback) {
	  var fail;
	
	  initCallback(callback, function (f, cb) {
	    fail = f;
	    callback = cb;
	  });
	
	  // IE doesn't support File.constructor.name
	  if (!azureutil.isBrowser() ||
	    !browserFile ||
	    !browserFile.constructor ||
	    (!azureutil.isIE() && !browserFile.constructor.name) ||
	    (!azureutil.isIE() && browserFile.constructor.name !== 'File' && browserFile.constructor.name !== 'Blob') ||
	    !azureutil.objectIsInt(browserFile.size)) {
	    return fail(new ArgumentError('type', 'Invalid HTML File object.'));
	  } else {
	    callback();
	    return true;
	  }
	};
	
	/**
	* Validates page ranges.
	*
	* @param {int} rangeStart             The range starting position.
	* @param {int} rangeEnd               The range ending position.
	* @param {int} writeBlockSizeInBytes  The block size.
	*/
	exports.pageRangesAreValid = function (rangeStart, rangeEnd, writeBlockSizeInBytes, callback) {
	  var fail;
	
	  initCallback(callback, function (f, cb) {
	    fail = f;
	    callback = cb;
	  });
	
	  if (rangeStart % 512 !== 0) {
	    return fail(new RangeError('Start byte offset must be a multiple of 512.'));
	  }
	
	  var size = null;
	  if (!azureutil.objectIsNull(rangeEnd)) {
	    if ((rangeEnd + 1) % 512 !== 0) {
	      return fail(new RangeError('End byte offset must be a multiple of 512 minus 1.'));
	    }
	
	    size = (rangeEnd - rangeStart) + 1;
	    if (size > writeBlockSizeInBytes) {
	      return fail(new RangeError('Page blob size cannot be larger than ' + writeBlockSizeInBytes + ' bytes.'));
	    }
	  }
	  
	  callback();
	  return true;
	};
	
	/**
	* Validates a blob type.
	*
	* @param {string} type  The type name.
	*/
	exports.blobTypeIsValid = function (type, callback) {
	  var getEnumValues = function (obj) {
	    var values = [];
	    for (var prop in obj) {
	      if (obj.hasOwnProperty(prop)) {
	        values.push(obj[prop]);
	      }
	    }
	    return values;
	  };
	  
	  return this.isValidEnumValue(type, getEnumValues(blobConstants.BlobTypes), callback);
	};
	
	/**
	* Validates share ACL type.
	*
	* @param {string} type  The type name.
	*/
	exports.shareACLIsValid = function (type, callback) {
	  var fail;
	  
	  initCallback(callback, function (f, cb) {
	    fail = f;
	    callback = cb;
	  });
	  
	  if (type != FileUtilities.SharePublicAccessType.OFF) {
	    fail(new ArgumentError('type', 'The access type is not supported.'));
	  }
	
	  callback();
	  return true;
	};
	
	/**
	* Validates share quota value.
	*
	* @param {int} type  The quota value.
	*/
	exports.shareQuotaIsValid = function (quota, callback) {
	  var fail;
	  
	  initCallback(callback, function (f, cb) {
	    fail = f;
	    callback = cb;
	  });
	  
	  if (quota && quota <= 0) {
	    fail(new RangeError('The share quota value, in GB, must be greater than 0.'));
	  }
	  
	  callback();
	  return true;
	};
	
	// common functions for validating arguments
	
	function throwMissingArgument(name, func) {
	  throw new ArgumentNullError(name, 'Required argument ' + name + ' for function ' + func + ' is not defined');
	}
	
	function ArgumentValidator(functionName) {
	  this.func = functionName;
	}
	
	_.extend(ArgumentValidator.prototype, {
	  string: function (val, name) {
	    this.exists(val, name);
	    if (typeof val !== 'string') {
	      throw new TypeError('Parameter ' + name + ' for function ' + this.func + ' should be a non-empty string');
	    }
	  },
	
	  stringAllowEmpty: function (val, name) {
	    if (typeof val !== 'string') {
	      throw new TypeError('Parameter ' + name + ' for function ' + this.func + ' should be a string');
	    }
	  },
	
	  object: function (val, name) {
	    this.exists(val, name);
	    if (typeof val !== 'object') {
	      throw new TypeError('Parameter ' + name + ' for function ' + this.func + ' should be an object');
	    }
	  },
	
	  exists: function (val, name) {
	    if (!val) {
	      throwMissingArgument(name, this.func);
	    }
	  },
	
	  function: function (val, name) {
	    this.exists(val, name);
	    if (typeof val !== 'function') {
	      throw new TypeError('Parameter ' + name + ' for function ' + this.func + ' should be a function');
	    }
	  },
	
	  value: function (val, name) {
	    if (!val && val !== 0) {
	      throwMissingArgument(name, this.func);
	    }
	  },
	
	  nonEmptyArray: function (val, name) {
	    if (!val || val.length === 0) {
	      throw new TypeError('Required array argument ' + name + ' for function ' + this.func + ' is either not defined or empty');
	    }
	  },
	
	  callback: function (val) {
	    this.exists(val, 'callback');
	    this.function(val, 'callback');
	  },
	
	  test: function (predicate, message) {
	    if (!predicate()) {
	      throw new Error(message + ' in function ' + this.func);
	    }
	  },
	
	  tableNameIsValid: exports.tableNameIsValid,
	  browserFileIsValid: exports.browserFileIsValid,
	  containerNameIsValid: exports.containerNameIsValid,
	  shareNameIsValid: exports.shareNameIsValid,
	  blobNameIsValid: exports.blobNameIsValid,
	  blobTierNameIsValid: exports.blobTierNameIsValid,
	  pageRangesAreValid: exports.pageRangesAreValid,
	  queueNameIsValid: exports.queueNameIsValid,
	  blobTypeIsValid: exports.blobTypeIsValid,
	  shareACLIsValid: exports.shareACLIsValid,
	  shareQuotaIsValid: exports.shareQuotaIsValid,
	  isValidEnumValue: exports.isValidEnumValue
	});
	
	function validateArgs(functionName, validationRules) {
	  var validator = new ArgumentValidator(functionName);
	  validationRules(validator);
	}
	
	exports.ArgumentValidator = ArgumentValidator;
	exports.validateArgs = validateArgs;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Module dependencies.
	var azureCommon = __webpack_require__(8);
	var Constants = azureCommon.Constants;
	var TableConstants = Constants.TableConstants;
	var HeaderConstants = Constants.HeaderConstants;
	var odataHandler = __webpack_require__(142);
	
	exports = module.exports;
	
	exports.serialize = function (entity) {
	  return odataHandler.serializeJson(entity);
	};
	
	exports.parseQuery = function (response, autoResolveProperties, propertyResolver, entityResolver) {
	  var result = {};
	  if (response.body) {
	    result = odataHandler.parseJsonEntities(response.body, autoResolveProperties, propertyResolver, entityResolver);
	  }
	
	  return result;
	};
	
	exports.parseEntity = function (response, autoResolveProperties, propertyResolver, entityResolver) {
	  var result = {};
	  if (response.body) {
	    result = odataHandler.parseJsonSingleEntity(response.body, autoResolveProperties, propertyResolver, entityResolver);
	  }
	
	  if (response.headers && response.headers[HeaderConstants.ETAG.toLowerCase()]) {
	    if (!result[TableConstants.ODATA_METADATA_MARKER]) {
	      result[TableConstants.ODATA_METADATA_MARKER] = {};
	    }
	
	    result[TableConstants.ODATA_METADATA_MARKER].etag = response.headers[HeaderConstants.ETAG.toLowerCase()];
	  }
	
	  return result;
	};
	
	exports.getEtag = function (entity) {
	  var etag;
	  if (entity && entity[TableConstants.ODATA_METADATA_MARKER]) {
	    etag = entity[TableConstants.ODATA_METADATA_MARKER].etag;
	  } 
	  return etag;
	};

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(167);
	
	var _reactRedux = __webpack_require__(28);
	
	var _redux = __webpack_require__(113);
	
	var _app = __webpack_require__(323);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _reducers = __webpack_require__(336);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = (0, _redux.createStore)(_reducers2.default, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
	
	(0, _reactDom.render)(_react2.default.createElement(
	    _reactRedux.Provider,
	    { store: store },
	    _react2.default.createElement(_app2.default, null)
	), document.getElementById('root'));
	
	exports.default = store;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var uint_max = Math.pow(2, 32);
	function fixup_uint32(x) {
	    var ret, x_pos;
	    ret = x > uint_max || x < 0 ? (x_pos = Math.abs(x) % uint_max, x < 0 ? uint_max - x_pos : x_pos) : x;
	    return ret;
	}
	function scrub_vec(v) {
	  var i, _i, _ref;
	  for (i = _i = 0, _ref = v.length; 0 <= _ref ? _i < _ref : _i > _ref; i = 0 <= _ref ? ++_i : --_i) {
	    v[i] = 0;
	  }
	  return false;
	}
	
	function Global() {
	  var i;
	  this.SBOX = [];
	  this.INV_SBOX = [];
	  this.SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.INV_SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.init();
	  this.RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
	}
	
	Global.prototype.init = function() {
	  var d, i, sx, t, x, x2, x4, x8, xi, _i;
	  d = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 256; i = ++_i) {
	      if (i < 128) {
	        _results.push(i << 1);
	      } else {
	        _results.push((i << 1) ^ 0x11b);
	      }
	    }
	    return _results;
	  })();
	  x = 0;
	  xi = 0;
	  for (i = _i = 0; _i < 256; i = ++_i) {
	    sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	    this.SBOX[x] = sx;
	    this.INV_SBOX[sx] = x;
	    x2 = d[x];
	    x4 = d[x2];
	    x8 = d[x4];
	    t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	    this.SUB_MIX[0][x] = (t << 24) | (t >>> 8);
	    this.SUB_MIX[1][x] = (t << 16) | (t >>> 16);
	    this.SUB_MIX[2][x] = (t << 8) | (t >>> 24);
	    this.SUB_MIX[3][x] = t;
	    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	    this.INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8);
	    this.INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16);
	    this.INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24);
	    this.INV_SUB_MIX[3][sx] = t;
	    if (x === 0) {
	      x = xi = 1;
	    } else {
	      x = x2 ^ d[d[d[x8 ^ x2]]];
	      xi ^= d[d[xi]];
	    }
	  }
	  return true;
	};
	
	var G = new Global();
	
	
	AES.blockSize = 4 * 4;
	
	AES.prototype.blockSize = AES.blockSize;
	
	AES.keySize = 256 / 8;
	
	AES.prototype.keySize = AES.keySize;
	
	AES.ivSize = AES.blockSize;
	
	AES.prototype.ivSize = AES.ivSize;
	
	 function bufferToArray(buf) {
	  var len = buf.length/4;
	  var out = new Array(len);
	  var i = -1;
	  while (++i < len) {
	    out[i] = buf.readUInt32BE(i * 4);
	  }
	  return out;
	 }
	function AES(key) {
	  this._key = bufferToArray(key);
	  this._doReset();
	}
	
	AES.prototype._doReset = function() {
	  var invKsRow, keySize, keyWords, ksRow, ksRows, t, _i, _j;
	  keyWords = this._key;
	  keySize = keyWords.length;
	  this._nRounds = keySize + 6;
	  ksRows = (this._nRounds + 1) * 4;
	  this._keySchedule = [];
	  for (ksRow = _i = 0; 0 <= ksRows ? _i < ksRows : _i > ksRows; ksRow = 0 <= ksRows ? ++_i : --_i) {
	    this._keySchedule[ksRow] = ksRow < keySize ? keyWords[ksRow] : (t = this._keySchedule[ksRow - 1], (ksRow % keySize) === 0 ? (t = (t << 8) | (t >>> 24), t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff], t ^= G.RCON[(ksRow / keySize) | 0] << 24) : keySize > 6 && ksRow % keySize === 4 ? t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff] : void 0, this._keySchedule[ksRow - keySize] ^ t);
	  }
	  this._invKeySchedule = [];
	  for (invKsRow = _j = 0; 0 <= ksRows ? _j < ksRows : _j > ksRows; invKsRow = 0 <= ksRows ? ++_j : --_j) {
	    ksRow = ksRows - invKsRow;
	    t = this._keySchedule[ksRow - (invKsRow % 4 ? 0 : 4)];
	    this._invKeySchedule[invKsRow] = invKsRow < 4 || ksRow <= 4 ? t : G.INV_SUB_MIX[0][G.SBOX[t >>> 24]] ^ G.INV_SUB_MIX[1][G.SBOX[(t >>> 16) & 0xff]] ^ G.INV_SUB_MIX[2][G.SBOX[(t >>> 8) & 0xff]] ^ G.INV_SUB_MIX[3][G.SBOX[t & 0xff]];
	  }
	  return true;
	};
	
	AES.prototype.encryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var out = this._doCryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[1], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[3], 12);
	  return buf;
	};
	
	AES.prototype.decryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var temp = [M[3], M[1]];
	  M[1] = temp[0];
	  M[3] = temp[1];
	  var out = this._doCryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[3], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[1], 12);
	  return buf;
	};
	
	AES.prototype.scrub = function() {
	  scrub_vec(this._keySchedule);
	  scrub_vec(this._invKeySchedule);
	  scrub_vec(this._key);
	};
	
	AES.prototype._doCryptBlock = function(M, keySchedule, SUB_MIX, SBOX) {
	  var ksRow, round, s0, s1, s2, s3, t0, t1, t2, t3, _i, _ref;
	
	  s0 = M[0] ^ keySchedule[0];
	  s1 = M[1] ^ keySchedule[1];
	  s2 = M[2] ^ keySchedule[2];
	  s3 = M[3] ^ keySchedule[3];
	  ksRow = 4;
	  for (round = _i = 1, _ref = this._nRounds; 1 <= _ref ? _i < _ref : _i > _ref; round = 1 <= _ref ? ++_i : --_i) {
	    t0 = SUB_MIX[0][s0 >>> 24] ^ SUB_MIX[1][(s1 >>> 16) & 0xff] ^ SUB_MIX[2][(s2 >>> 8) & 0xff] ^ SUB_MIX[3][s3 & 0xff] ^ keySchedule[ksRow++];
	    t1 = SUB_MIX[0][s1 >>> 24] ^ SUB_MIX[1][(s2 >>> 16) & 0xff] ^ SUB_MIX[2][(s3 >>> 8) & 0xff] ^ SUB_MIX[3][s0 & 0xff] ^ keySchedule[ksRow++];
	    t2 = SUB_MIX[0][s2 >>> 24] ^ SUB_MIX[1][(s3 >>> 16) & 0xff] ^ SUB_MIX[2][(s0 >>> 8) & 0xff] ^ SUB_MIX[3][s1 & 0xff] ^ keySchedule[ksRow++];
	    t3 = SUB_MIX[0][s3 >>> 24] ^ SUB_MIX[1][(s0 >>> 16) & 0xff] ^ SUB_MIX[2][(s1 >>> 8) & 0xff] ^ SUB_MIX[3][s2 & 0xff] ^ keySchedule[ksRow++];
	    s0 = t0;
	    s1 = t1;
	    s2 = t2;
	    s3 = t3;
	  }
	  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
	  return [
	    fixup_uint32(t0),
	    fixup_uint32(t1),
	    fixup_uint32(t2),
	    fixup_uint32(t3)
	  ];
	
	};
	
	
	
	
	  exports.AES = AES;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var Transform = __webpack_require__(20).Transform;
	var inherits = __webpack_require__(13);
	
	module.exports = CipherBase;
	inherits(CipherBase, Transform);
	function CipherBase() {
	  Transform.call(this);
	}
	CipherBase.prototype.update = function (data, inputEnd, outputEnc) {
	  this.write(data, inputEnd);
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	CipherBase.prototype.final = function (outputEnc) {
	  this.end();
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 87 */
/***/ function(module, exports) {

	exports['aes-128-ecb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-192-ecb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-256-ecb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-128-cbc'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-192-cbc'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-256-cbc'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes128'] = exports['aes-128-cbc'];
	exports['aes192'] = exports['aes-192-cbc'];
	exports['aes256'] = exports['aes-256-cbc'];
	exports['aes-128-cfb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-192-cfb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-256-cfb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-128-ofb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-192-ofb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-256-ofb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-128-ctr'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-192-ctr'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-256-ctr'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};

/***/ },
/* 88 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var http = __webpack_require__(114);
	
	var https = module.exports;
	
	for (var key in http) {
	    if (http.hasOwnProperty(key)) https[key] = http[key];
	};
	
	https.request = function (params, cb) {
	    if (!params) params = {};
	    params.scheme = 'https';
	    params.protocol = 'https:';
	    return http.request.call(this, params, cb);
	}


/***/ },
/* 90 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(375),
	    getPrototype = __webpack_require__(377),
	    isObjectLike = __webpack_require__(382);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 92 */
/***/ function(module, exports) {



/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (!process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = nextTick;
	} else {
	  module.exports = process.nextTick;
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(44);
	var Danger = __webpack_require__(417);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactInstrumentation = __webpack_require__(22);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(103);
	var setInnerHTML = __webpack_require__(70);
	var setTextContent = __webpack_require__(188);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 95 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactErrorUtils = __webpack_require__(101);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 98 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactPropTypesSecret = __webpack_require__(445);
	var propTypesFactory = __webpack_require__(164);
	
	var React = __webpack_require__(40);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(3);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactCurrentOwner = __webpack_require__(29);
	var ReactInstanceMap = __webpack_require__(46);
	var ReactInstrumentation = __webpack_require__(22);
	var ReactUpdates = __webpack_require__(23);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 103 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 104 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 105 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 106 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(17);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 108 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var emptyFunction = __webpack_require__(18);
	var warning = __webpack_require__(5);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 110 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(41);
	
	/*<replacement>*/
	var util = __webpack_require__(24);
	util.inherits = __webpack_require__(13);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function TransformState(stream) {
	  this.afterTransform = function (er, data) {
	    return afterTransform(stream, er, data);
	  };
	
	  this.needTransform = false;
	  this.transforming = false;
	  this.writecb = null;
	  this.writechunk = null;
	  this.writeencoding = null;
	}
	
	function afterTransform(stream, er, data) {
	  var ts = stream._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) return stream.emit('error', new Error('no writecb in Transform class'));
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data !== null && data !== undefined) stream.push(data);
	
	  cb(er);
	
	  var rs = stream._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    stream._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = new TransformState(this);
	
	  // when the writable side finishes, then flush out anything remaining.
	  var stream = this;
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  this.once('prefinish', function () {
	    if (typeof this._flush === 'function') this._flush(function (er) {
	      done(stream, er);
	    });else done(stream);
	  });
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	function done(stream, er) {
	  if (er) return stream.emit('error', er);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  var ws = stream._writableState;
	  var ts = stream._transformState;
	
	  if (ws.length) throw new Error('calling transform done when ws.length != 0');
	
	  if (ts.transforming) throw new Error('calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate) {// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	module.exports = Writable;
	
	/*<replacement>*/
	var processNextTick = __webpack_require__(93);
	/*</replacement>*/
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : processNextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Buffer = __webpack_require__(2).Buffer;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = __webpack_require__(24);
	util.inherits = __webpack_require__(13);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(214)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream;
	(function () {
	  try {
	    Stream = __webpack_require__(20);
	  } catch (_) {} finally {
	    if (!Stream) Stream = __webpack_require__(14).EventEmitter;
	  }
	})();
	/*</replacement>*/
	
	var Buffer = __webpack_require__(2).Buffer;
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	var Duplex;
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(41);
	
	  options = options || {};
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = ~ ~this.highWaterMark;
	
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // create the two objects needed to store the corked requests
	  // they are not a linked list, as no new elements are inserted in there
	  this.corkedRequestsFree = new CorkedRequest(this);
	  this.corkedRequestsFree.next = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function writableStateGetBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.')
	    });
	  } catch (_) {}
	})();
	
	var Duplex;
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(41);
	
	  // Writable ctor is applied to Duplexes, though they're not
	  // instanceof Writable, they're instanceof Readable.
	  if (!(this instanceof Writable) && !(this instanceof Duplex)) return new Writable(options);
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe. Not readable.'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  processNextTick(cb, er);
	}
	
	// If we get something that is not a buffer, string, null, or undefined,
	// and we're not in objectMode, then that's an error.
	// Otherwise stream chunks are all considered to be of length=1, and the
	// watermarks determine how many objects to keep in the buffer, rather than
	// how many bytes or characters.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	
	  if (!Buffer.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== null && chunk !== undefined && !state.objectMode) {
	    var er = new TypeError('Invalid non-string/buffer chunk');
	    stream.emit('error', er);
	    processNextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (Buffer.isBuffer(chunk)) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = new Buffer(chunk, encoding);
	  }
	  return chunk;
	}
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, chunk, encoding, cb) {
	  chunk = decodeChunk(state, chunk, encoding);
	
	  if (Buffer.isBuffer(chunk)) encoding = 'buffer';
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = new WriteReq(chunk, encoding, cb);
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	  if (sync) processNextTick(cb, er);else cb(er);
	
	  stream._writableState.errorEmitted = true;
	  stream.emit('error', er);
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	        afterWrite(stream, state, finished, cb);
	      }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    while (entry) {
	      buffer[count] = entry;
	      entry = entry.next;
	      count += 1;
	    }
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    state.corkedRequestsFree = holder.next;
	    holder.next = null;
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequestCount = 0;
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	
	function prefinish(stream, state) {
	  if (!state.prefinished) {
	    state.prefinished = true;
	    stream.emit('prefinish');
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    if (state.pendingcb === 0) {
	      prefinish(stream, state);
	      state.finished = true;
	      stream.emit('finish');
	    } else {
	      prefinish(stream, state);
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) processNextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	
	  this.finish = function (err) {
	    var entry = _this.entry;
	    _this.entry = null;
	    while (entry) {
	      var cb = entry.callback;
	      state.pendingcb--;
	      cb(err);
	      entry = entry.next;
	    }
	    if (state.corkedRequestsFree) {
	      state.corkedRequestsFree.next = _this;
	    } else {
	      state.corkedRequestsFree = _this;
	    }
	  };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(213).setImmediate))

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(202);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(508);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(507);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(506);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(201);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(203);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var ClientRequest = __webpack_require__(517)
	var response = __webpack_require__(205)
	var extend = __webpack_require__(593)
	var statusCodes = __webpack_require__(344)
	var url = __webpack_require__(33)
	
	var http = exports
	
	http.request = function (opts, cb) {
		if (typeof opts === 'string')
			opts = url.parse(opts)
		else
			opts = extend(opts)
	
		// Normally, the page is loaded from http or https, so not specifying a protocol
		// will result in a (valid) protocol-relative url. However, this won't work if
		// the protocol is something else, like 'file:'
		var defaultProtocol = global.location.protocol.search(/^https?:$/) === -1 ? 'http:' : ''
	
		var protocol = opts.protocol || defaultProtocol
		var host = opts.hostname || opts.host
		var port = opts.port
		var path = opts.path || '/'
	
		// Necessary for IPv6 addresses
		if (host && host.indexOf(':') !== -1)
			host = '[' + host + ']'
	
		// This may be a relative url. The browser should always be able to interpret it correctly.
		opts.url = (host ? (protocol + '//' + host) : '') + (port ? ':' + port : '') + path
		opts.method = (opts.method || 'GET').toUpperCase()
		opts.headers = opts.headers || {}
	
		// Also valid opts.auth, opts.mode
	
		var req = new ClientRequest(opts)
		if (cb)
			req.on('response', cb)
		return req
	}
	
	http.get = function get (opts, cb) {
		var req = http.request(opts, cb)
		req.end()
		return req
	}
	
	http.ClientRequest = ClientRequest
	http.IncomingMessage = response.IncomingMessage
	
	http.Agent = function () {}
	http.Agent.defaultMaxSockets = 4
	
	http.globalAgent = new http.Agent()
	
	http.STATUS_CODES = statusCodes
	
	http.METHODS = [
		'CHECKOUT',
		'CONNECT',
		'COPY',
		'DELETE',
		'GET',
		'HEAD',
		'LOCK',
		'M-SEARCH',
		'MERGE',
		'MKACTIVITY',
		'MKCOL',
		'MOVE',
		'NOTIFY',
		'OPTIONS',
		'PATCH',
		'POST',
		'PROPFIND',
		'PROPPATCH',
		'PURGE',
		'PUT',
		'REPORT',
		'SEARCH',
		'SUBSCRIBE',
		'TRACE',
		'UNLOCK',
		'UNSUBSCRIBE'
	]
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var Buffer = __webpack_require__(2).Buffer;
	
	var isBufferEncoding = Buffer.isEncoding
	  || function(encoding) {
	       switch (encoding && encoding.toLowerCase()) {
	         case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw': return true;
	         default: return false;
	       }
	     }
	
	
	function assertEncoding(encoding) {
	  if (encoding && !isBufferEncoding(encoding)) {
	    throw new Error('Unknown encoding: ' + encoding);
	  }
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters. CESU-8 is handled as part of the UTF-8 encoding.
	//
	// @TODO Handling all encodings inside a single object makes it very difficult
	// to reason about this code, so it should be split up in the future.
	// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
	// points as used by CESU-8.
	var StringDecoder = exports.StringDecoder = function(encoding) {
	  this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
	  assertEncoding(encoding);
	  switch (this.encoding) {
	    case 'utf8':
	      // CESU-8 represents each of Surrogate Pair by 3-bytes
	      this.surrogateSize = 3;
	      break;
	    case 'ucs2':
	    case 'utf16le':
	      // UTF-16 represents each of Surrogate Pair by 2-bytes
	      this.surrogateSize = 2;
	      this.detectIncompleteChar = utf16DetectIncompleteChar;
	      break;
	    case 'base64':
	      // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
	      this.surrogateSize = 3;
	      this.detectIncompleteChar = base64DetectIncompleteChar;
	      break;
	    default:
	      this.write = passThroughWrite;
	      return;
	  }
	
	  // Enough space to store all bytes of a single character. UTF-8 needs 4
	  // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
	  this.charBuffer = new Buffer(6);
	  // Number of bytes received for the current incomplete multi-byte character.
	  this.charReceived = 0;
	  // Number of bytes expected for the current incomplete multi-byte character.
	  this.charLength = 0;
	};
	
	
	// write decodes the given buffer and returns it as JS string that is
	// guaranteed to not contain any partial multi-byte characters. Any partial
	// character found at the end of the buffer is buffered up, and will be
	// returned when calling write again with the remaining bytes.
	//
	// Note: Converting a Buffer containing an orphan surrogate to a String
	// currently works, but converting a String to a Buffer (via `new Buffer`, or
	// Buffer#write) will replace incomplete surrogates with the unicode
	// replacement character. See https://codereview.chromium.org/121173009/ .
	StringDecoder.prototype.write = function(buffer) {
	  var charStr = '';
	  // if our last write ended with an incomplete multibyte character
	  while (this.charLength) {
	    // determine how many remaining bytes this buffer has to offer for this char
	    var available = (buffer.length >= this.charLength - this.charReceived) ?
	        this.charLength - this.charReceived :
	        buffer.length;
	
	    // add the new bytes to the char buffer
	    buffer.copy(this.charBuffer, this.charReceived, 0, available);
	    this.charReceived += available;
	
	    if (this.charReceived < this.charLength) {
	      // still not enough chars in this buffer? wait for more ...
	      return '';
	    }
	
	    // remove bytes belonging to the current character from the buffer
	    buffer = buffer.slice(available, buffer.length);
	
	    // get the character that was split
	    charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);
	
	    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	    var charCode = charStr.charCodeAt(charStr.length - 1);
	    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	      this.charLength += this.surrogateSize;
	      charStr = '';
	      continue;
	    }
	    this.charReceived = this.charLength = 0;
	
	    // if there are no more bytes in this buffer, just emit our char
	    if (buffer.length === 0) {
	      return charStr;
	    }
	    break;
	  }
	
	  // determine and set charLength / charReceived
	  this.detectIncompleteChar(buffer);
	
	  var end = buffer.length;
	  if (this.charLength) {
	    // buffer the incomplete character bytes we got
	    buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
	    end -= this.charReceived;
	  }
	
	  charStr += buffer.toString(this.encoding, 0, end);
	
	  var end = charStr.length - 1;
	  var charCode = charStr.charCodeAt(end);
	  // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	  if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	    var size = this.surrogateSize;
	    this.charLength += size;
	    this.charReceived += size;
	    this.charBuffer.copy(this.charBuffer, size, 0, size);
	    buffer.copy(this.charBuffer, 0, 0, size);
	    return charStr.substring(0, end);
	  }
	
	  // or just emit the charStr
	  return charStr;
	};
	
	// detectIncompleteChar determines if there is an incomplete UTF-8 character at
	// the end of the given buffer. If so, it sets this.charLength to the byte
	// length that character, and sets this.charReceived to the number of bytes
	// that are available for this character.
	StringDecoder.prototype.detectIncompleteChar = function(buffer) {
	  // determine how many bytes we have to check at the end of this buffer
	  var i = (buffer.length >= 3) ? 3 : buffer.length;
	
	  // Figure out if one of the last i bytes of our buffer announces an
	  // incomplete char.
	  for (; i > 0; i--) {
	    var c = buffer[buffer.length - i];
	
	    // See http://en.wikipedia.org/wiki/UTF-8#Description
	
	    // 110XXXXX
	    if (i == 1 && c >> 5 == 0x06) {
	      this.charLength = 2;
	      break;
	    }
	
	    // 1110XXXX
	    if (i <= 2 && c >> 4 == 0x0E) {
	      this.charLength = 3;
	      break;
	    }
	
	    // 11110XXX
	    if (i <= 3 && c >> 3 == 0x1E) {
	      this.charLength = 4;
	      break;
	    }
	  }
	  this.charReceived = i;
	};
	
	StringDecoder.prototype.end = function(buffer) {
	  var res = '';
	  if (buffer && buffer.length)
	    res = this.write(buffer);
	
	  if (this.charReceived) {
	    var cr = this.charReceived;
	    var buf = this.charBuffer;
	    var enc = this.encoding;
	    res += buf.slice(0, cr).toString(enc);
	  }
	
	  return res;
	};
	
	function passThroughWrite(buffer) {
	  return buffer.toString(this.encoding);
	}
	
	function utf16DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 2;
	  this.charLength = this.charReceived ? 2 : 0;
	}
	
	function base64DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 3;
	  this.charLength = this.charReceived ? 3 : 0;
	}


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	var v1 = __webpack_require__(535);
	var v4 = __webpack_require__(536);
	
	var uuid = v4;
	uuid.v1 = v1;
	uuid.v4 = v4;
	
	module.exports = uuid;


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFQDN;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _merge = __webpack_require__(50);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_fqdn_options = {
	  require_tld: true,
	  allow_underscores: false,
	  allow_trailing_dot: false
	};
	
	function isFQDN(str, options) {
	  (0, _assertString2.default)(str);
	  options = (0, _merge2.default)(options, default_fqdn_options);
	
	  /* Remove the optional trailing dot before checking validity */
	  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
	    str = str.substring(0, str.length - 1);
	  }
	  var parts = str.split('.');
	  if (options.require_tld) {
	    var tld = parts.pop();
	    if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
	      return false;
	    }
	    // disallow spaces
	    if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(tld)) {
	      return false;
	    }
	  }
	  for (var part, i = 0; i < parts.length; i++) {
	    part = parts[i];
	    if (options.allow_underscores) {
	      part = part.replace(/_/g, '');
	    }
	    if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
	      return false;
	    }
	    // disallow full-width chars
	    if (/[\uff01-\uff5e]/.test(part)) {
	      return false;
	    }
	    if (part[0] === '-' || part[part.length - 1] === '-') {
	      return false;
	    }
	  }
	  return true;
	}
	module.exports = exports['default'];

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toDate;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toDate(date) {
	  (0, _assertString2.default)(date);
	  date = Date.parse(date);
	  return !isNaN(date) ? new Date(date) : null;
	}
	module.exports = exports['default'];

/***/ },
/* 119 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = toString;
	function toString(input) {
	  if ((typeof input === 'undefined' ? 'undefined' : _typeof(input)) === 'object' && input !== null) {
	    if (typeof input.toString === 'function') {
	      input = input.toString();
	    } else {
	      input = '[object Object]';
	    }
	  } else if (input === null || typeof input === 'undefined' || isNaN(input) && !input.length) {
	    input = '';
	  }
	  return String(input);
	}
	module.exports = exports['default'];

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.3.3
	(function() {
	  var XMLBuilder;
	
	  XMLBuilder = __webpack_require__(229);
	
	  module.exports.create = function(name, xmldec, doctype, options) {
	    if (name != null) {
	      return new XMLBuilder(name, xmldec, doctype, options).root();
	    } else {
	      return new XMLBuilder();
	    }
	  };
	
	}).call(this);


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	
	'use strict';
	
	/**
	 * The `azure-iot-common` module contains code common to the Azure IoT Hub Device and Service SDKs.
	 *
	 * @module azure-iot-common
	 */
	
	module.exports = {
	  anHourFromNow: __webpack_require__(74).anHourFromNow,
	  encodeUriComponentStrict: __webpack_require__(74).encodeUriComponentStrict,
	  ConnectionString: __webpack_require__(233).ConnectionString,
	  endpoint: __webpack_require__(234),
	  errors: __webpack_require__(60),
	  results: __webpack_require__(237),
	  Message: __webpack_require__(235).Message,
	  SharedAccessSignature: __webpack_require__(240).SharedAccessSignature,
	  RetryOperation: __webpack_require__(239).RetryOperation,
	  RetryPolicy: __webpack_require__(75).RetryPolicy,
	  NoRetry: __webpack_require__(75).NoRetry,
	  ExponentialBackOffWithJitter: __webpack_require__(75).ExponentialBackOffWithJitter,
	  AuthenticationProvider: __webpack_require__(122).X509AuthenticationProvider,
	  AuthenticationType: __webpack_require__(122).AuthenticationType
	};

/***/ },
/* 122 */
/***/ function(module, exports) {

	// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	"use strict";
	/**
	 * Designate the type of authentication used by an `AuthenticationProvider`.
	 */
	(function (AuthenticationType) {
	    /**
	     * X509 Certificate based authentication.
	     */
	    AuthenticationType[AuthenticationType["X509"] = 0] = "X509";
	    /**
	     * Token-based authentication uses shared access signature security tokens, generated and signed with a secret key.
	     */
	    AuthenticationType[AuthenticationType["Token"] = 1] = "Token";
	})(exports.AuthenticationType || (exports.AuthenticationType = {}));
	var AuthenticationType = exports.AuthenticationType;
	//# sourceMappingURL=authentication_provider.js.map

/***/ },
/* 123 */
/***/ function(module, exports) {

	/*! Copyright (c) Microsoft. All rights reserved.
	 *! Licensed under the MIT license. See LICENSE file in the project root for full license information.
	 */
	'use strict';
	/*Codes_SRS_NODE_COMMON_DICTIONARY_05_001: [The function createDictionary shall accept as arguments the source string and a field separator string.]*/
	function createDictionary(source, separator) {
	    var dict = {};
	    /*Codes_SRS_NODE_COMMON_DICTIONARY_05_003: [createDictionary shall search the source string for elements of the form 'key=value', where the element is found either at the beginning of the source string, or immediately following an instance of the field separator string.]*/
	    /*Codes_SRS_NODE_COMMON_DICTIONARY_05_002: [createDictionary shall convert the source and separator arguments to type String before using them.]*/
	    /*Codes_SRS_NODE_COMMON_DICTIONARY_05_006: [If the source string is falsy, createDictionary shall return an object with no properties.]*/
	    var elems = String(source).split(String(separator));
	    elems.forEach(function (elem) {
	        var pos = elem.indexOf('=');
	        if (pos < 0)
	            return;
	        var name = elem.substring(0, pos);
	        var value = elem.substring(pos + 1);
	        if (name && value) {
	            /*Codes_SRS_NODE_COMMON_DICTIONARY_05_004: [If there are multiple pairs with the same key, createDictionary shall keep the last pair.]*/
	            dict[name] = value;
	        }
	    });
	    /*Codes_SRS_NODE_COMMON_DICTIONARY_05_005: [createDictionary shall return an object with properties matching each discovered element in the source string.]*/
	    return dict;
	}
	exports.createDictionary = createDictionary;
	//# sourceMappingURL=dictionary.js.map

/***/ },
/* 124 */
/***/ function(module, exports) {

	// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	
	'use strict';
	
	/**
	 * @class         module:azure-iot-device.BlobSasError
	 * @classdesc     Error used when the client fails to get a blob shared access signature from the IoT Hub service.
	 * 
	 * @params        {string}  message  Error message
	 * @augments      {Error}
	 */
	function BlobSasError (message) {
	  this.message = message;
	  this.stack = (new Error()).stack;
	  Error.call(this, message);
	}
	
	BlobSasError.prototype = Object.create(Error.prototype);
	BlobSasError.prototype.constructor = BlobSasError;
	BlobSasError.prototype.name = 'BlobSasError';
	
	/**
	 * @class         module:azure-iot-device.BlobUploadNotificationError
	 * @classdesc     Error used when the client fails to notify the IoT Hub service that the upload is complete.
	 * 
	 * @params        {string}  message  Error message
	 * @augments      {Error}
	 */
	function BlobUploadNotificationError (message) {
	  this.message = message;
	  this.stack = (new Error()).stack;
	  Error.call(this, message);
	}
	
	BlobUploadNotificationError.prototype = Object.create(Error.prototype);
	BlobUploadNotificationError.prototype.constructor = BlobUploadNotificationError;
	BlobUploadNotificationError.prototype.name = 'BlobUploadNotificationError';
	
	module.exports = {
	  BlobSasError: BlobSasError,
	  BlobUploadNotificationError: BlobUploadNotificationError
	};

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	
	'use strict';
	
	var Base = __webpack_require__(19).ConnectionString;
	var errors = __webpack_require__(19).errors;
	
	module.exports = {
	  parse: function parse(source) {
	    /*Codes_SRS_NODE_DEVICE_CONNSTR_05_001: [The parse method shall return the result of calling azure-iot-common.ConnectionString.parse.]*/
	    /*Codes_SRS_NODE_DEVICE_CONNSTR_05_002: [It shall throw ArgumentError if any of 'HostName' or 'DeviceId' fields are not found in the source argument.]*/
	    var connectionString = Base.parse(source, ['HostName', 'DeviceId']);
	    /*Codes_SRS_NODE_DEVICE_CONNSTR_16_001: [It shall throw `ArgumentError` if `SharedAccessKey` and `x509` are present at the same time or if none of them are present.]*/
	    if((connectionString.SharedAccessKey && connectionString.x509) || (!connectionString.SharedAccessKey && !connectionString.x509)) {
	      throw new errors.ArgumentError('The connection string must contain either a SharedAccessKey or x509=true');
	    }
	
	    return connectionString;
	  },
	  createWithSharedAccessKey: function createWithSharedAccessKey(hostName, deviceId, symmetricKey) {
	    /*Codes_SRS_NODE_DEVICE_CONNSTR_16_003: [The `createWithSharedAccessKey` static method shall throw a `ReferenceError` if one or more of the `hostName`, `deviceId` or `sharedAccessKey` are falsy.]*/
	    if (!hostName) {
	      throw new ReferenceError('hostName cannot be \'' + hostName + '\'');
	    } else if (!deviceId) {
	      throw new ReferenceError('deviceId cannot be \'' + deviceId + '\'');
	    } else if (!symmetricKey) {
	      throw new ReferenceError('symmetricKey cannot be \'' + symmetricKey + '\'');
	    }
	
	    /*Codes_SRS_NODE_DEVICE_CONNSTR_16_002: [The `createWithSharedAccessKey` static method shall returns a valid connection string with the values passed as arguments.]*/
	    return 'HostName=' + hostName + ';DeviceId=' + deviceId + ';SharedAccessKey=' + symmetricKey;
	  },
	  createWithX509Certificate: function createWithX509Certificate(hostName, deviceId) {
	    /*Codes_SRS_NODE_DEVICE_CONNSTR_16_005: [The `createWithX509Certificate` static method shall throw a `ReferenceError` if one or more of the `hostName` or `deviceId` are falsy.]*/
	    if (!hostName) {
	      throw new ReferenceError('hostName cannot be \'' + hostName + '\'');
	    } else if (!deviceId) {
	      throw new ReferenceError('deviceId cannot be \'' + deviceId + '\'');
	    }
	
	    /*Codes_SRS_NODE_DEVICE_CONNSTR_16_004: [The `createWithX509Certificate` static method shall returns a valid x509 connection string with the values passed as arguments.]*/
	    return 'HostName=' + hostName + ';DeviceId=' + deviceId + ';x509=true';
	  }
	};


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	
	'use strict';
	
	module.exports = {
	  DeviceMethodRequest: __webpack_require__(248),
	  DeviceMethodResponse: __webpack_require__(249)
	};


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	
	'use strict';
	
	var Base = __webpack_require__(19).SharedAccessSignature;
	var encodeUriComponentStrict = __webpack_require__(19).encodeUriComponentStrict;
	
	module.exports = {
	  create: function create(host, deviceId, key, expiry) {
	    /*Codes_SRS_NODE_DEVICE_SAS_05_004: [<urlEncodedDeviceId> shall be the URL-encoded value of deviceId.]*/
	    var uri = encodeUriComponentStrict(host + '/devices/' + deviceId);
	    /*Codes_SRS_NODE_DEVICE_SAS_05_003: [The create method shall return the result of calling azure-iot-common.SharedAccessSignature.create with following arguments:
	    resourceUri - host + '%2Fdevices%2F' + <urlEncodedDeviceId>
	    keyName - null
	    key - key
	    expiry - expiry]*/
	    return Base.create(uri, null, key, expiry);
	  },
	  parse: function parse(source) {
	    /*Codes_SRS_NODE_DEVICE_SAS_05_001: [The parse method shall return the result of calling azure-iot-common.SharedAccessSignature.parse.]*/
	    /*Codes_SRS_NODE_DEVICE_SAS_05_002: [It shall throw ArgumentError if any of 'sr', 'sig', 'se' fields are not found in the source argument.]*/
	    return Base.parse(source, ['sr', 'sig', 'se']);
	  }
	};

/***/ },
/* 128 */
/***/ function(module, exports) {

	// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	
	'use strict';
	
	/*Codes_SRS_NODE_COMMON_DICTIONARY_05_001: [The function createDictionary shall accept as arguments the source string and a field separator string.]*/
	function createDictionary(source, separator) {
	  var dict = Object.create(null);
	  /*Codes_SRS_NODE_COMMON_DICTIONARY_05_003: [createDictionary shall search the source string for elements of the form 'key=value', where the element is found either at the beginning of the source string, or immediately following an instance of the field separator string.]*/
	  /*Codes_SRS_NODE_COMMON_DICTIONARY_05_002: [createDictionary shall convert the source and separator arguments to type String before using them.]*/
	  /*Codes_SRS_NODE_COMMON_DICTIONARY_05_006: [If the source string is falsy, createDictionary shall return an object with no properties.]*/
	  var elems = String(source).split(String(separator));
	
	  elems.forEach(function (elem) {
	    var pos = elem.indexOf('=');
	    if (pos < 0) return;
	
	    var name = elem.substring(0, pos);
	    var value = elem.substring(pos + 1);
	
	    if (name && value) {
	      /*Codes_SRS_NODE_COMMON_DICTIONARY_05_004: [If there are multiple pairs with the same key, createDictionary shall keep the last pair.]*/
	      dict[name] = value;
	    }
	  });
	
	  /*Codes_SRS_NODE_COMMON_DICTIONARY_05_005: [createDictionary shall return an object with properties matching each discovered element in the source string.]*/
	  return dict;
	}
	
	module.exports = createDictionary;


/***/ },
/* 129 */
128,
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Module dependencies.
	var azureutil = __webpack_require__(16);
	var SR = __webpack_require__(25);
	var Constants = __webpack_require__(12);
	var errors = __webpack_require__(30);
	var ArgumentError = errors.ArgumentError;
	var HeaderConstants = Constants.HeaderConstants;
	var HttpConstants = Constants.HttpConstants;
	var HttpConstants = Constants.HttpConstants;
	var HttpVerbs = HttpConstants.HttpVerbs;
	
	function encodeSpecialCharacters(path) {
	  return path.replace(/'/g, '%27');
	}
	
	/**
	* Creates a new WebResource object.
	*
	* This class provides an abstraction over a REST call by being library / implementation agnostic and wrapping the necessary
	* properties to initiate a request.
	*
	* @constructor
	*/
	function WebResource() {
	  this.rawResponse = false;
	  this.queryString = {};
	}
	
	/**
	* Creates a new put request web resource.
	*
	* @param {string} path The path for the put operation.
	* @return {WebResource} A new webresource with a put operation for the given path.
	*/
	WebResource.put = function (path) {
	  var webResource = new WebResource();
	  webResource.path = path ? encodeSpecialCharacters(path) : null;
	  webResource.method = HttpConstants.HttpVerbs.PUT;
	  return webResource;
	};
	
	/**
	* Creates a new get request web resource.
	*
	* @param {string} path The path for the get operation.
	* @return {WebResource} A new webresource with a get operation for the given path.
	*/
	WebResource.get = function (path) {
	  var webResource = new WebResource();
	  webResource.path = path ? encodeSpecialCharacters(path) : null;
	  webResource.method = HttpConstants.HttpVerbs.GET;
	  return webResource;
	};
	
	/**
	* Creates a new head request web resource.
	*
	* @param {string} path The path for the head operation.
	* @return {WebResource} A new webresource with a head operation for the given path.
	*/
	WebResource.head = function (path) {
	  var webResource = new WebResource();
	  webResource.path = path ? encodeSpecialCharacters(path) : null;
	  webResource.method = HttpConstants.HttpVerbs.HEAD;
	  return webResource;
	};
	
	/**
	* Creates a new delete request web resource.
	*
	* @param {string} path The path for the delete operation.
	* @return {WebResource} A new webresource with a delete operation for the given path.
	*/
	WebResource.del = function (path) {
	  var webResource = new WebResource();
	  webResource.path = path ? encodeSpecialCharacters(path) : null;
	  webResource.method = HttpConstants.HttpVerbs.DELETE;
	  return webResource;
	};
	
	/**
	* Creates a new post request web resource.
	*
	* @param {string} path The path for the post operation.
	* @return {WebResource} A new webresource with a post operation for the given path.
	*/
	WebResource.post = function (path) {
	  var webResource = new WebResource();
	  webResource.path = path ? encodeSpecialCharacters(path) : null;
	  webResource.method = HttpConstants.HttpVerbs.POST;
	  return webResource;
	};
	
	/**
	* Creates a new merge request web resource.
	*
	* @param {string} path The path for the merge operation.
	* @return {WebResource} A new webresource with a merge operation for the given path.
	*/
	WebResource.merge = function (path) {
	  var webResource = new WebResource();
	  webResource.path = path ? encodeSpecialCharacters(path) : null;
	  webResource.method = HttpConstants.HttpVerbs.MERGE;
	  return webResource;
	};
	
	/**
	* Specifies a custom property in the web resource.
	*
	* @param {string} name  The property name.
	* @param {string} value The property value.
	* @return {WebResource} The webresource.
	*/
	WebResource.prototype.withProperty = function (name, value) {
	  if (!this.properties) {
	    this.properties = {};
	  }
	
	  this.properties[name] = value;
	
	  return this;
	};
	
	/**
	* Specifies if the response should be parsed or not.
	*
	* @param {bool} rawResponse true if the response should not be parsed; false otherwise.
	* @return {WebResource} The webresource.
	*/
	WebResource.prototype.withRawResponse = function (rawResponse) {
	  this.rawResponse = rawResponse;
	
	  if (azureutil.objectIsNull(this.rawResponse)) {
	    this.rawResponse = true;
	  }
	
	  return this;
	};
	
	WebResource.prototype.withHeadersOnly = function (headersOnly) {
	  if (headersOnly !== undefined) {
	    this.headersOnly = headersOnly;
	  } else {
	    this.headersOnly = true;
	  }
	
	  return this;
	};
	
	/**
	* Adds an optional query string parameter.
	*
	* @param {Object} name          The name of the query string parameter.
	* @param {Object} value         The value of the query string parameter.
	* @param {Object} defaultValue  The default value for the query string parameter to be used if no value is passed.
	* @return {Object} The web resource.
	*/
	WebResource.prototype.withQueryOption = function (name, value, defaultValue) {
	  if (!azureutil.objectIsNull(value)) {
	    this.queryString[name] = value;
	  } else if (defaultValue) {
	    this.queryString[name] = defaultValue;
	  }
	
	  return this;
	};
	
	/**
	* Adds optional query string parameters.
	*
	* Additional arguments will be the needles to search in the haystack. 
	*
	* @param {Object} object  The haystack of query string parameters.
	* @return {Object} The web resource.
	*/
	WebResource.prototype.withQueryOptions = function (object) {
	  if (object) {
	    for (var i = 1; i < arguments.length; i++) {
	      if (object[arguments[i]]) {
	        this.withQueryOption(arguments[i], object[arguments[i]]);
	      }
	    }
	  }
	
	  return this;
	};
	
	/**
	* Adds an optional header parameter.
	*
	* @param {Object} name  The name of the header parameter.
	* @param {Object} value The value of the header parameter.
	* @return {Object} The web resource.
	*/
	WebResource.prototype.withHeader = function (name, value) {
	  if (!this.headers) {
	    this.headers = {};
	  }
	
	  if (!azureutil.IsNullOrEmptyOrUndefinedOrWhiteSpace(value)) {
	    value = value instanceof Date ? value.toUTCString() : value;
	    
	    this.headers[name] = value;
	  }
	
	  return this;
	};
	
	/**
	* Adds an optional body.
	*
	* @param {Object} body  The request body.
	* @return {Object} The web resource.
	*/
	WebResource.prototype.withBody = function (body) {
	  this.body = body;
	  return this;
	};
	
	/**
	* Adds optional query string parameters.
	*
	* Additional arguments will be the needles to search in the haystack. 
	*
	* @param {Object} object  The haystack of headers.
	* @return {Object} The web resource.
	*/
	WebResource.prototype.withHeaders = function (object) {
	  if (object) {
	    for (var i = 1; i < arguments.length; i++) {
	      if (object[arguments[i]]) {
	        this.withHeader(arguments[i], object[arguments[i]]);
	      }
	    }
	  }
	
	  return this;
	};
	
	WebResource.prototype.addOptionalMetadataHeaders = function (metadata) {
	  var self = this;
	
	  if (metadata) {
	    Object.keys(metadata).forEach(function (metadataKey) {
	      if (azureutil.IsNullOrEmptyOrUndefinedOrWhiteSpace(metadataKey)) {
	        throw new ArgumentError('metadata', SR.METADATA_KEY_INVALID);
	      }
	
	      var value = metadata[metadataKey];
	      if (azureutil.IsNullOrEmptyOrUndefinedOrWhiteSpace(value)) {
	        throw new ArgumentError('metadata', SR.METADATA_VALUE_INVALID);
	      }
	      
	      var metadataHeaderName = HeaderConstants.PREFIX_FOR_STORAGE_METADATA + metadataKey;
	      var existingMetadataHeaderName = '';
	      var headers = self.headers ? self.headers : {};
	      if (Object.keys(headers).some(function (headerName) {
	        existingMetadataHeaderName = headerName;
	        return headerName.toString().toLowerCase() === metadataHeaderName.toLowerCase();
	      })) {        
	        self.withHeader(existingMetadataHeaderName, self.headers[existingMetadataHeaderName] + ',' + value);
	      } else {
	        self.withHeader(metadataHeaderName, value);
	      }
	    });
	  }
	
	  return this;
	};
	
	/**
	* Determines if a status code corresponds to a valid response according to the WebResource's expected status codes.
	*
	* @param {int} statusCode The response status code.
	* @return true if the response is valid; false otherwise.
	*/
	WebResource.validResponse = function (statusCode) {
	  if (statusCode >= 200 && statusCode < 300) {
	    return true;
	  }
	
	  return false;
	};
	
	function isMethodWithBody(verb) {
	  return verb === HttpVerbs.PUT ||
	    verb === HttpVerbs.POST ||
	    verb === HttpVerbs.MERGE;
	}
	
	/**
	* Hook up the given input stream to a destination output stream if the WebResource method
	* requires a request body and a body is not already set.
	*
	* @param {Stream} inputStream the stream to pipe from
	* @param {Stream} outputStream the stream to pipe to
	*
	* @return destStream
	*/
	WebResource.prototype.pipeInput = function(inputStream, destStream) {
	  if (isMethodWithBody(this.method) && !this.hasOwnProperty('body')) {
	    inputStream.pipe(destStream);
	  }
	
	  return destStream;
	};
	
	module.exports = WebResource;

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Module dependencies.
	var _ = __webpack_require__(15);
	var xmlbuilder = __webpack_require__(120);
	
	var Constants = __webpack_require__(12);
	var ServicePropertiesConstants = Constants.ServicePropertiesConstants;
	
	exports = module.exports;
	
	function serializeRetentionPolicy(doc, policy) {
	  if (policy !== null) {
	    if (typeof policy === 'undefined') {
	      policy = {};
	    }
	
	    doc = doc.ele(ServicePropertiesConstants.RETENTION_POLICY_ELEMENT);
	    if (typeof policy.Enabled !== 'undefined') {
	      doc = doc.ele(ServicePropertiesConstants.ENABLED_ELEMENT)
	        .txt(policy.Enabled)
	        .up();
	    } else {
	      doc = doc.ele(ServicePropertiesConstants.ENABLED_ELEMENT)
	        .txt(false)
	        .up();
	    }
	
	    if (typeof policy.Days !== 'undefined') {
	      doc = doc.ele(ServicePropertiesConstants.DAYS_ELEMENT)
	        .txt(policy.Days)
	        .up();
	    } else if (policy.Enabled === true) {
	      doc = doc.ele(ServicePropertiesConstants.DAYS_ELEMENT)
	        .txt(1)
	        .up();
	    }
	
	    doc = doc.up();
	  }
	}
	
	function serializeDeleteRetentionPolicy(doc, policy) {
	  if (policy !== null) {
	    if (typeof policy === 'undefined') {
	      policy = {};
	    }
	
	    if (typeof policy.Enabled !== 'undefined') {
	      doc = doc.ele(ServicePropertiesConstants.ENABLED_ELEMENT)
	        .txt(policy.Enabled)
	        .up();
	    } else {
	      doc = doc.ele(ServicePropertiesConstants.ENABLED_ELEMENT)
	        .txt(false)
	        .up();
	    }
	
	    if (typeof policy.Days !== 'undefined') {
	      doc = doc.ele(ServicePropertiesConstants.DAYS_ELEMENT)
	        .txt(policy.Days)
	        .up();
	    } else if (policy.Enabled === true) {
	      doc = doc.ele(ServicePropertiesConstants.DAYS_ELEMENT)
	        .txt(1)
	        .up();
	    }
	
	    doc = doc.up();
	  }
	}
	
	function serializeLogging(doc, logging) {
	  if (typeof logging.Version !== 'undefined') {
	    doc = doc.ele(ServicePropertiesConstants.VERSION_ELEMENT)
	      .txt(logging.Version)
	      .up();
	  } else {
	    doc = doc.ele(ServicePropertiesConstants.VERSION_ELEMENT)
	      .txt(ServicePropertiesConstants.DEFAULT_ANALYTICS_VERSION)
	      .up();
	  }
	
	  if (typeof logging.Delete !== 'undefined') {
	    doc = doc.ele(ServicePropertiesConstants.DELETE_ELEMENT)
	      .txt(logging.Delete)
	      .up();
	  } else {
	    doc = doc.ele(ServicePropertiesConstants.DELETE_ELEMENT)
	      .txt(false)
	      .up();
	  }
	
	  if (typeof logging.Read !== 'undefined') {
	    doc = doc.ele(ServicePropertiesConstants.READ_ELEMENT)
	      .txt(logging.Read)
	      .up();
	  } else {
	    doc = doc.ele(ServicePropertiesConstants.READ_ELEMENT)
	      .txt(false)
	      .up();
	  }
	
	  if (typeof logging.Write !== 'undefined') {
	    doc = doc.ele(ServicePropertiesConstants.WRITE_ELEMENT)
	      .txt(logging.Write)
	      .up();
	  } else {
	    doc = doc.ele(ServicePropertiesConstants.WRITE_ELEMENT)
	      .txt(false)
	      .up();
	  }
	
	  serializeRetentionPolicy(doc, logging.RetentionPolicy);
	
	  doc = doc.up();
	}
	
	function serializeMetrics(doc, metrics) {
	  if (typeof metrics.Version !== 'undefined') {
	    doc = doc.ele(ServicePropertiesConstants.VERSION_ELEMENT)
	      .txt(metrics.Version)
	      .up();
	  } else {
	    doc = doc.ele(ServicePropertiesConstants.VERSION_ELEMENT)
	      .txt(ServicePropertiesConstants.DEFAULT_ANALYTICS_VERSION)
	      .up();
	  }
	
	  if (typeof metrics.Enabled !== 'undefined') {
	    doc = doc.ele(ServicePropertiesConstants.ENABLED_ELEMENT)
	      .txt(metrics.Enabled)
	      .up();
	  } else {
	    doc = doc.ele(ServicePropertiesConstants.ENABLED_ELEMENT)
	      .txt(false)
	      .up();
	  }
	
	  if (metrics.Enabled) {
	    if (typeof metrics.IncludeAPIs !== 'undefined') {
	      doc = doc.ele(ServicePropertiesConstants.INCLUDE_APIS_ELEMENT)
	        .txt(metrics.IncludeAPIs)
	        .up();
	    } else if (metrics.Enabled === true) {
	      doc = doc.ele(ServicePropertiesConstants.INCLUDE_APIS_ELEMENT)
	        .txt(false)
	        .up();
	    }
	  }
	  serializeRetentionPolicy(doc, metrics.RetentionPolicy);
	}
	
	function serializeCorsRules(doc, rules) {
	  if (typeof rules !== 'undefined' && rules !== null && _.isArray(rules)) {
	    rules.forEach(function (rule) {
	      doc = doc.ele(ServicePropertiesConstants.CORS_RULE_ELEMENT);
	
	      if (typeof rule.AllowedMethods !== 'undefined' && _.isArray(rule.AllowedMethods)) {
	        doc = doc.ele(ServicePropertiesConstants.ALLOWED_METHODS_ELEMENT)
	          .txt(rule.AllowedMethods.join(','))
	          .up();
	      }
	
	      if (typeof rule.AllowedOrigins !== 'undefined' && _.isArray(rule.AllowedOrigins)) {
	        doc = doc.ele(ServicePropertiesConstants.ALLOWED_ORIGINS_ELEMENT)
	          .txt(rule.AllowedOrigins.join(','))
	          .up();
	      }
	
	      if (typeof rule.AllowedHeaders !== 'undefined' && _.isArray(rule.AllowedHeaders)) {
	        doc = doc.ele(ServicePropertiesConstants.ALLOWED_HEADERS_ELEMENT)
	          .txt(rule.AllowedHeaders.join(','))
	          .up();
	      } else {
	        doc = doc.ele(ServicePropertiesConstants.ALLOWED_HEADERS_ELEMENT)
	          .txt('')
	          .up();
	      }
	
	      if (typeof rule.ExposedHeaders !== 'undefined' && _.isArray(rule.ExposedHeaders)) {
	        doc = doc.ele(ServicePropertiesConstants.EXPOSED_HEADERS_ELEMENT)
	          .txt(rule.ExposedHeaders.join(','))
	          .up();
	      } else {
	        doc = doc.ele(ServicePropertiesConstants.EXPOSED_HEADERS_ELEMENT)
	          .txt('')
	          .up();
	      }
	
	      if (typeof rule.MaxAgeInSeconds !== 'undefined') {
	        doc = doc.ele(ServicePropertiesConstants.MAX_AGE_IN_SECONDS_ELEMENT)
	          .txt(rule.MaxAgeInSeconds)
	          .up();
	      } else {
	        doc = doc.ele(ServicePropertiesConstants.MAX_AGE_IN_SECONDS_ELEMENT)
	          .txt('0')
	          .up();
	      }
	
	      doc = doc.up();
	    });
	  }
	}
	
	exports.serialize = function (servicePropertiesJs) {
	  var doc = xmlbuilder.create();
	  doc = doc.begin(ServicePropertiesConstants.STORAGE_SERVICE_PROPERTIES_ELEMENT, { version: '1.0', encoding: 'utf-8' });
	
	  if (servicePropertiesJs.Logging) {
	    doc = doc.ele(ServicePropertiesConstants.LOGGING_ELEMENT);
	    serializeLogging(doc, servicePropertiesJs.Logging);
	    doc = doc.up();
	  }
	
	  if (servicePropertiesJs.HourMetrics) {
	    doc = doc.ele(ServicePropertiesConstants.HOUR_METRICS_ELEMENT);
	    serializeMetrics(doc, servicePropertiesJs.HourMetrics);
	    doc = doc.up();
	  }
	
	  if (servicePropertiesJs.MinuteMetrics) {
	    doc = doc.ele(ServicePropertiesConstants.MINUTE_METRICS_ELEMENT);
	    serializeMetrics(doc, servicePropertiesJs.MinuteMetrics);
	    doc = doc.up();
	  }
	
	  if (servicePropertiesJs.Cors) {
	    doc = doc.ele(ServicePropertiesConstants.CORS_ELEMENT);
	    serializeCorsRules(doc, servicePropertiesJs.Cors.CorsRule);
	    doc = doc.up();
	  }
	
	  if (servicePropertiesJs.DefaultServiceVersion) {
	    doc = doc.ele(ServicePropertiesConstants.DEFAULT_SERVICE_VERSION_ELEMENT)
	      .txt(servicePropertiesJs.DefaultServiceVersion)
	      .up();
	  }
	
	  if (servicePropertiesJs.DeleteRetentionPolicy) {
	    doc = doc.ele(ServicePropertiesConstants.DEFAULT_DELETE_RETENTION_POLICY_ELEMENT);
	    serializeDeleteRetentionPolicy(doc, servicePropertiesJs.DeleteRetentionPolicy);
	    doc = doc.up();
	  }
	
	  return doc.doc().toString();
	};
	
	function parseRetentionPolicy(policyXml) {
	  var policy = {};
	
	  if (typeof policyXml.Enabled !== 'undefined') {
	    policy.Enabled = policyXml.Enabled === 'true';
	  }
	
	  if (typeof policyXml.Days !== 'undefined') {
	    policy.Days = parseInt(policyXml.Days, 10);
	  }
	
	  return policy;
	}
	
	function parseLogging(loggingXml) {
	  var logging = {};
	
	  if (typeof loggingXml.Version !== 'undefined') {
	    logging.Version = loggingXml.Version;
	  }
	
	  if (typeof loggingXml.Delete !== 'undefined') {
	    logging.Delete = loggingXml.Delete === 'true';
	  }
	
	  if (typeof loggingXml.Read !== 'undefined') {
	    logging.Read = loggingXml.Read === 'true';
	  }
	
	  if (typeof loggingXml.Write !== 'undefined') {
	    logging.Write = loggingXml.Write === 'true';
	  }
	
	  if (typeof loggingXml.RetentionPolicy !== 'undefined') {
	    logging.RetentionPolicy = parseRetentionPolicy(loggingXml.RetentionPolicy);
	  }
	
	  return logging;
	}
	
	function parseMetrics(metricsXml) {
	  var metrics = {};
	
	  if (typeof metricsXml.Version !== 'undefined') {
	    metrics.Version = metricsXml.Version;
	  }
	
	  if (typeof metricsXml.Enabled !== 'undefined') {
	    metrics.Enabled = metricsXml.Enabled === 'true';
	  }
	
	  if (typeof metricsXml.IncludeAPIs !== 'undefined') {
	    metrics.IncludeAPIs = metricsXml.IncludeAPIs === 'true';
	  }
	
	  if (typeof metricsXml.RetentionPolicy !== 'undefined') {
	    metrics.RetentionPolicy = parseRetentionPolicy(metricsXml.RetentionPolicy);
	  }
	
	  return metrics;
	}
	
	function parseCors(corsXml) {
	  var cors = {};
	
	  if (typeof corsXml.CorsRule !== 'undefined') {
	    var rulesXml = corsXml.CorsRule;
	    if (!_.isArray(rulesXml)) {
	      rulesXml = [rulesXml];
	    }
	
	    cors.CorsRule = [];
	    rulesXml.forEach(function (ruleXml) {
	      var rule = {};
	
	      if (typeof ruleXml.AllowedMethods !== 'undefined') {
	        if (ruleXml.AllowedMethods !== '') {
	          rule.AllowedMethods = ruleXml.AllowedMethods.split(',');
	        }
	        else {
	          rule.AllowedMethods = [];
	        }
	      }
	
	      if (typeof ruleXml.AllowedOrigins !== 'undefined') {
	        if (ruleXml.AllowedOrigins !== '') {
	          rule.AllowedOrigins = ruleXml.AllowedOrigins.split(',');
	        }
	        else {
	          rule.AllowedOrigins = [];
	        }
	      }
	
	      if (typeof ruleXml.AllowedHeaders !== 'undefined') {
	        if (ruleXml.AllowedHeaders !== '') {
	          rule.AllowedHeaders = ruleXml.AllowedHeaders.split(',');
	        }
	        else {
	          rule.AllowedHeaders = [];
	        }
	      }
	
	      if (typeof ruleXml.ExposedHeaders !== 'undefined') {
	        if (ruleXml.ExposedHeaders !== '') {
	          rule.ExposedHeaders = ruleXml.ExposedHeaders.split(',');
	        }
	        else {
	          rule.ExposedHeaders = [];
	        }
	      }
	
	      if (typeof ruleXml.MaxAgeInSeconds !== 'undefined') {
	        rule.MaxAgeInSeconds = parseInt(ruleXml.MaxAgeInSeconds, 10);
	      }
	
	      cors.CorsRule.push(rule);
	    });
	  }
	
	  return cors;
	}
	
	function parseDeleteRetentionPolicy(deleteRetentionPolicyXml) {
	  var deleteRetentionPolicy = {};
	
	  if (typeof deleteRetentionPolicyXml.Enabled !== 'undefined') {
	    deleteRetentionPolicy.Enabled = deleteRetentionPolicyXml.Enabled === 'true';
	  }
	
	  if (typeof deleteRetentionPolicyXml.Days !== 'undefined') {
	    deleteRetentionPolicy.Days = deleteRetentionPolicyXml.Days;
	  }
	
	  return deleteRetentionPolicy;
	}
	
	exports.parse = function (servicePropertiesXml) {
	  var serviceProperties = {};
	
	  if (typeof servicePropertiesXml.Logging !== 'undefined') {
	    serviceProperties.Logging = parseLogging(servicePropertiesXml.Logging);
	  }
	
	  if (typeof servicePropertiesXml.HourMetrics !== 'undefined') {
	    serviceProperties.HourMetrics = parseMetrics(servicePropertiesXml.HourMetrics);
	  }
	
	  if (typeof servicePropertiesXml.MinuteMetrics !== 'undefined') {
	    serviceProperties.MinuteMetrics = parseMetrics(servicePropertiesXml.MinuteMetrics);
	  }
	
	  if (typeof servicePropertiesXml.Cors !== 'undefined') {
	    serviceProperties.Cors = parseCors(servicePropertiesXml.Cors);
	  }
	
	  if (typeof servicePropertiesXml.DefaultServiceVersion !== 'undefined') {
	    serviceProperties.DefaultServiceVersion = servicePropertiesXml.DefaultServiceVersion;
	  }
	
	  if (typeof servicePropertiesXml.DeleteRetentionPolicy !== 'undefined') {
	    serviceProperties.DeleteRetentionPolicy = parseDeleteRetentionPolicy(servicePropertiesXml.DeleteRetentionPolicy);
	  }
	
	  return serviceProperties;
	};

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	var util = __webpack_require__(4);
	
	var azureUtil = __webpack_require__(16);
	var errors = __webpack_require__(30);
	var SR = __webpack_require__(25);
	var Constants = __webpack_require__(12);
	
	exports = module.exports;
	
	/**
	* The default protocol.
	*/
	exports.DEFAULT_PROTOCOL = Constants.HTTPS;
	
	var NoMatchError = function (msg, constr) {
	  errors.captureStackTrace(this, constr || this);
	  this.message = msg || 'Error';
	};
	
	util.inherits(NoMatchError, Error);
	NoMatchError.prototype.name = 'NoMatchError';
	
	exports.NoMatchError = NoMatchError;
	
	/**
	* Throws an exception if the connection string format does not match any of the
	* available formats.
	*
	* @param {string} connectionString The invalid formatted connection string.
	* @return none
	*/
	exports.noMatchConnectionString = function (connectionString) {
	  throw new NoMatchError('The provided connection string "' + connectionString + '" does not have complete configuration settings.');
	};
	
	/**
	* Throws an exception if the settings dont match any of the
	* available formats.
	*
	* @param {object} settings The invalid settings.
	* @return none
	*/
	exports.noMatchSettings = function (settings) {
	  throw new NoMatchError('The provided settings ' + JSON.stringify(settings) + ' are not complete.');
	};
	
	/**
	* Parses the connection string and then validate that the parsed keys belong to
	* the validSettingKeys
	*
	* @param {string} connectionString The user provided connection string.
	* @param {array}  validKeys        The valid keys.
	* @return {array} The tokenized connection string keys.
	*/
	exports.parseAndValidateKeys = function (connectionString, validKeys) {
	  var parsedConnectionString = { };
	
	  // parse key/value pairs from connection string
	  var pairs = connectionString.split(';');
	  for (var m = 0; m < pairs.length; m++) {
	    if (pairs[m].length === 0) {
	        continue;
	    }
	
	    var equalDex = pairs[m].indexOf('=');
	    if (equalDex < 0) {
	        throw new SyntaxError(SR.INVALID_CONNECTION_STRING);
	    } else if (equalDex === 0) {
	      // empty key name.
	      throw new SyntaxError(SR.INVALID_CONNECTION_STRING_EMPTY_KEY);
	    }
	
	    var key = pairs[m].substring(0, equalDex);
	
	    // assure that all given keys are valid.
	    if (!azureUtil.inArrayInsensitive(key, validKeys)) {
	      throw new SyntaxError(util.format(SR.INVALID_CONNECTION_STRING_BAD_KEY, key));
	    }
	
	    var value = pairs[m].substring(equalDex + 1);
	    
	    if(typeof parsedConnectionString[key] === 'undefined'){
	      parsedConnectionString[key] = value;
	    } else {
	      // duplicate key name
	      throw new SyntaxError(util.format(SR.INVALID_CONNECTION_STRING_DUPLICATE_KEY, key));
	    }
	  }
	
	  return parsedConnectionString;
	};
	
	/**
	* Creates an anonymous function that acts as predicate to perform a validation.
	*
	* @param array   {requirements} The array of conditions to satisfy.
	* @param boolean {isRequired}   Either these conditions are all required or all
	* optional.
	* @param boolean {atLeastOne}   Indicates that at least one requirement must
	* succeed.
	* @return {function}
	*/
	exports.getValidator = function (requirements, isRequired, atLeastOne) {
	  return function (userSettings) {
	    var oneFound = false;
	    var result = { };
	
	    for (var key in userSettings) {
	      if (userSettings.hasOwnProperty(key)) {
	        result[key.toLowerCase()] = userSettings[key];
	      }
	    }
	
	    for (var requirement in requirements) {
	      if (requirements.hasOwnProperty(requirement)) {
	        var settingName = requirements[requirement].SettingName.toLowerCase();
	
	        // Check if the setting name exists in the provided user settings.
	        if (result[settingName]) {
	          // Check if the provided user setting value is valid.
	          var validationFunc = requirements[requirement].SettingConstraint;
	          var isValid = validationFunc(result[settingName]);
	
	          if (isValid) {
	            // Remove the setting as indicator for successful validation.
	            delete result[settingName];
	            oneFound = true;
	          }
	        } else if (isRequired) {
	          // If required then fail because the setting does not exist
	          return null;
	        }
	      }
	    }
	
	    if (atLeastOne) {
	      // At least one requirement must succeed, otherwise fail.
	      return oneFound ? result : null;
	    } else {
	      return result;
	    }
	  };
	};
	
	/**
	* Creates a setting value condition that validates it is one of the
	* passed valid values.
	*
	* @param {string} name The setting key name.
	* @return {array}
	*/
	exports.setting = function (name) {
	  var validValues = Array.prototype.slice.call(arguments, 1, arguments.length);
	
	  var predicate = function (settingValue) {
	    var validValuesString = JSON.stringify(validValues);
	    if (validValues.length === 0) {
	      // No restrictions, succeed.
	      return true;
	    }
	
	    // Check to find if the settingValue is valid or not.
	    for (var index = 0; index < validValues.length; index++) {
	      if (settingValue.toString() == validValues[index].toString()) {
	        // SettingValue is found in valid values set, succeed.
	        return true;
	      }
	    }
	
	    // settingValue is missing in valid values set, fail.
	    throw new RangeError('The provided config value ' + settingValue + ' does not belong to the valid values subset:\n' + validValuesString);
	  };
	
	  return exports.settingWithFunc(name, predicate);
	};
	
	/**
	* Creates an "at lease one" predicate for the provided list of requirements.
	*
	* @return callable
	*/
	exports.atLeastOne = function () {
	  var allSettings = arguments;
	  return exports.getValidator(allSettings, false, true);
	};
	
	/**
	* Creates an optional predicate for the provided list of requirements.
	*
	* @return {function}
	*/
	exports.optional = function () {
	  var optionalSettings = arguments;
	  return exports.getValidator(optionalSettings, false, false);
	};
	
	/**
	* Creates an required predicate for the provided list of requirements.
	*
	* @return {function}
	*/
	exports.allRequired = function () {
	  var requiredSettings = arguments;
	  return exports.getValidator(requiredSettings, true, false);
	};
	
	/**
	* Creates a setting value condition using the passed predicate.
	*
	* @param {string}   name      The setting key name.
	* @param {function} predicate The setting value predicate.
	* @return {array}
	*/
	exports.settingWithFunc = function (name, predicate) {
	  var requirement = {};
	  requirement.SettingName = name;
	  requirement.SettingConstraint = predicate;
	
	  return requirement;
	};
	
	
	/**
	* Tests to see if a given list of settings matches a set of filters exactly.
	*
	* @param array $settings The settings to check.
	* @return boolean If any filter returns null, false. If there are any settings
	* left over after all filters are processed, false. Otherwise true.
	*/
	exports.matchedSpecification = function (settings) {
	  var constraints = Array.prototype.slice.call(arguments, 1, arguments.length);
	
	  for (var constraint in constraints) {
	    if (constraints.hasOwnProperty(constraint)) {
	      var remainingSettings = constraints[constraint](settings);
	
	      if (!remainingSettings) {
	        return false;
	      } else {
	        settings = remainingSettings;
	      }
	    }
	  }
	
	  return azureUtil.objectKeysLength(settings) === 0;
	};

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Module dependencies.
	var crypto = __webpack_require__(65);
	
	/**
	* Creates a new HmacSHA256Sign object.
	*
	* @constructor
	*/
	function HmacSha256Sign(accessKey) {
	  this._accessKey = accessKey;
	  this._decodedAccessKey = new Buffer(this._accessKey, 'base64');
	}
	
	/**
	* Computes a signature for the specified string using the HMAC-SHA256 algorithm.
	*
	* @param {string} stringToSign The UTF-8-encoded string to sign.
	* @return A String that contains the HMAC-SHA256-encoded signature.
	*/
	HmacSha256Sign.prototype.sign = function (stringToSign) {
	  // Encoding the Signature
	  // Signature=Base64(HMAC-SHA256(UTF8(StringToSign)))
	
	  return crypto.createHmac('sha256', this._decodedAccessKey).update(stringToSign, 'utf-8').digest('base64');
	};
	
	module.exports = HmacSha256Sign;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	var HmacSha256Sign = __webpack_require__(133);
	var Constants = __webpack_require__(12);
	var SR = __webpack_require__(25);
	
	/**
	* Creates a new SharedAccessSignature object.
	*
	* @constructor
	* @param {string} sasToken    The sasToken.
	*/
	function SharedAccessSignature(sasToken) {
	  this.sasToken = sasToken;
	  this.signer = new HmacSha256Sign(sasToken);
	}
	
	/**
	* Signs a request with the signature header.
	*
	* @this {SharedAccessSignature}
	* @param {WebResource} The webresource to be signed.
	* @param {function(error)}  callback  The callback function.
	*/
	SharedAccessSignature.prototype.signRequest = function (webResource, callback) {
	  if (webResource.uri.indexOf('?') === -1) {
	    webResource.uri += '?';
	  } else {
	    webResource.uri += '&';
	  }
	
	  webResource.uri += this.sasToken;
	
	  // Add the api-version
	  if (this.sasToken.indexOf('api-version') == -1) {
	    webResource.uri += '&' + Constants.QueryStringConstants.API_VERSION + '=' + Constants.HeaderConstants.TARGET_STORAGE_VERSION;
	  } else {
	    throw new SyntaxError(SR.INVALID_SAS_TOKEN);
	  }
	  callback(null);
	};
	
	module.exports = SharedAccessSignature;


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Module dependencies.
	var _ = __webpack_require__(15);
	var qs = __webpack_require__(43);
	
	var azureutil = __webpack_require__(16);
	var HmacSha256Sign = __webpack_require__(133);
	var SR = __webpack_require__(25);
	var errors = __webpack_require__(30);
	var ArgumentError = errors.ArgumentError;
	
	var Constants = __webpack_require__(12);
	var HeaderConstants = Constants.HeaderConstants;
	var QueryStringConstants = Constants.QueryStringConstants;
	var HeaderConstants = Constants.HeaderConstants;
	var CompatibleVersionConstants = Constants.CompatibleVersionConstants;
	
	/**
	* Creates a new SharedKey object.
	*
	* @constructor
	* @param {string} storageAccount    The storage account.
	* @param {string} storageAccessKey  The storage account's access key.
	* @param {bool}   usePathStyleUri   Boolean value indicating if the path, or the hostname, should include the storage account.
	*/
	function SharedKey(storageAccount, storageAccessKey, usePathStyleUri) {
	  this.storageAccount = storageAccount;
	  this.storageAccessKey = storageAccessKey;
	  this.usePathStyleUri = usePathStyleUri;
	  this.signer = new HmacSha256Sign(storageAccessKey);
	}
	
	/**
	* Generates the shared access signature for a account.
	* For more detailed information, refer to https://msdn.microsoft.com/en-us/library/azure/mt584140.aspx
	*
	* @param {object}                     sharedAccessPolicy                                The shared access policy.
	* @param {SharedAccessServices}       sharedAccessPolicy.AccessPolicy.Services          The services (blob, file, queue, table) for a shared access signature associated with this shared access policy.
	*                                                                                       Refer to `Constants.AccountSasConstants.Services`.
	* @param {SharedAccessResourceTypes}  sharedAccessPolicy.AccessPolicy.ResourceTypes     The resource type for a shared access signature associated with this shared access policy.
	*                                                                                       Refer to `Constants.AccountSasConstants.Resources`.
	* @param {SharedAccessPermissions}    sharedAccessPolicy.AccessPolicy.Permissions       The permissions for a shared access signature. 
	*                                                                                       Refer to `Constants.AccountSasConstants.Permissions`.
	* @param {date}                       sharedAccessPolicy.AccessPolicy.Start             The time at which the Shared Access Signature becomes valid.
	* @param {date}                       sharedAccessPolicy.AccessPolicy.Expiry            The time at which the Shared Access Signature becomes expired.
	* @param {string}                     sharedAccessPolicy.AccessPolicy.IPAddressOrRange  An IP address or a range of IP addresses from which to accept requests. When specifying a range, note that the range is inclusive.
	* @param {string}                     sharedAccessPolicy.AccessPolicy.Protocols         The protocols permitted for a request made with the account SAS. 
	*                                                                                       Possible values are both HTTPS and HTTP (https,http) or HTTPS only (https). The default value is https,http. 
	*                                                                                       Refer to `Constants.AccountSasConstants.Protocols`.
	* @return {string} The shared access signature.
	*/
	SharedKey.prototype.generateAccountSignedQueryString = function (sharedAccessPolicy) {
	  var addIfNotNull = function (queryString, name, value) {
	    if (!azureutil.objectIsNull(name) && !azureutil.objectIsNull(value)) {
	      queryString[name] = value;
	    }
	  };
	
	  var formatAccessPolicyDates = function (accessPolicy) {
	    if (!azureutil.objectIsNull(accessPolicy.Start)) {
	      if (!_.isDate(accessPolicy.Start)) {
	        accessPolicy.Start = new Date(accessPolicy.Start);
	      }
	 
	      accessPolicy.Start = azureutil.truncatedISO8061Date(accessPolicy.Start);
	    }
	
	    if (!azureutil.objectIsNull(accessPolicy.Expiry)) {
	      if (!_.isDate(accessPolicy.Expiry)) {
	        accessPolicy.Expiry = new Date(accessPolicy.Expiry);
	      }
	
	      accessPolicy.Expiry = azureutil.truncatedISO8061Date(accessPolicy.Expiry);
	    }
	  };
	
	  var queryString = {};
	
	  addIfNotNull(queryString, QueryStringConstants.SIGNED_VERSION, HeaderConstants.TARGET_STORAGE_VERSION);
	
	  // add shared access policy params
	  if (sharedAccessPolicy.AccessPolicy) {
	    formatAccessPolicyDates(sharedAccessPolicy.AccessPolicy);
	
	    addIfNotNull(queryString, QueryStringConstants.SIGNED_SERVICES, sharedAccessPolicy.AccessPolicy.Services);
	    addIfNotNull(queryString, QueryStringConstants.SIGNED_RESOURCE_TYPES, sharedAccessPolicy.AccessPolicy.ResourceTypes);
	    addIfNotNull(queryString, QueryStringConstants.SIGNED_PERMISSIONS, sharedAccessPolicy.AccessPolicy.Permissions);
	    addIfNotNull(queryString, QueryStringConstants.SIGNED_START, sharedAccessPolicy.AccessPolicy.Start);
	    addIfNotNull(queryString, QueryStringConstants.SIGNED_EXPIRY, sharedAccessPolicy.AccessPolicy.Expiry);
	    addIfNotNull(queryString, QueryStringConstants.SIGNED_IP, sharedAccessPolicy.AccessPolicy.IPAddressOrRange);
	    addIfNotNull(queryString, QueryStringConstants.SIGNED_PROTOCOL, sharedAccessPolicy.AccessPolicy.Protocols);
	  }
	  
	  // add signature
	  addIfNotNull(queryString, QueryStringConstants.SIGNATURE, this._generateAccountSharedAccessSignature(sharedAccessPolicy));
	
	  return qs.stringify(queryString);
	};
	
	
	/**
	* Generates the signature part of the shared access signature for a account.
	* For more detailed information, refer to https://msdn.microsoft.com/en-us/library/azure/mt584140.aspx
	*
	* @param {object}                     sharedAccessPolicy                                The shared access policy.
	* @param {SharedAccessServices}       sharedAccessPolicy.AccessPolicy.Services          The services (blob, file, queue, table) for a shared access signature associated with this shared access policy.
	*                                                                                       Refer to `Constants.AccountSasConstants.Services`.
	* @param {SharedAccessResourceTypes}  sharedAccessPolicy.AccessPolicy.ResourceTypes     The resource type for a shared access signature associated with this shared access policy.
	*                                                                                       Refer to `Constants.AccountSasConstants.ResourceTypes`.
	* @param {SharedAccessPermissions}    sharedAccessPolicy.AccessPolicy.Permissions       The permissions for a shared access signature. 
	*                                                                                       Refer to `Constants.AccountSasConstants.Permissions`.
	* @param {date}                       sharedAccessPolicy.AccessPolicy.Start             The time at which the Shared Access Signature becomes valid.
	* @param {date}                       sharedAccessPolicy.AccessPolicy.Expiry            The time at which the Shared Access Signature becomes expired.
	* @param {string}                     sharedAccessPolicy.AccessPolicy.IPAddressOrRange  An IP address or a range of IP addresses from which to accept requests. When specifying a range, note that the range is inclusive.
	* @param {string}                     sharedAccessPolicy.AccessPolicy.Protocols         The protocols permitted for a request made with the account SAS. 
	*                                                                                       Possible values are both HTTPS and HTTP (https,http) or HTTPS only (https). The default value is https,http. 
	*                                                                                       Refer to `Constants.AccountSasConstants.Protocols`.
	* @return {string} The signature part of the shared access signature.
	*/
	SharedKey.prototype._generateAccountSharedAccessSignature = function(sharedAccessPolicy){
	  var getvalueToAppend = function (value, noNewLine) {
	    var returnValue = '';
	    if (!azureutil.objectIsNull(value)) {
	      returnValue = value;
	    }
	
	    if (noNewLine !== true) {
	      returnValue += '\n';
	    }
	
	    return returnValue;
	  };  
	  
	  var stringToSign = getvalueToAppend(this.storageAccount) +
	      getvalueToAppend(sharedAccessPolicy.AccessPolicy ? sharedAccessPolicy.AccessPolicy.Permissions : '') +
	      getvalueToAppend(sharedAccessPolicy.AccessPolicy ? sharedAccessPolicy.AccessPolicy.Services : '') +
	      getvalueToAppend(sharedAccessPolicy.AccessPolicy ? sharedAccessPolicy.AccessPolicy.ResourceTypes : '') +
	      getvalueToAppend(sharedAccessPolicy.AccessPolicy ? sharedAccessPolicy.AccessPolicy.Start : '') +
	      getvalueToAppend(sharedAccessPolicy.AccessPolicy ? sharedAccessPolicy.AccessPolicy.Expiry : '') +
	      getvalueToAppend(sharedAccessPolicy.AccessPolicy ? sharedAccessPolicy.AccessPolicy.IPAddressOrRange : '') +
	      getvalueToAppend(sharedAccessPolicy.AccessPolicy ? sharedAccessPolicy.AccessPolicy.Protocols : '') +
	      getvalueToAppend(HeaderConstants.TARGET_STORAGE_VERSION);
	      
	  return this.signer.sign(stringToSign);  
	};
	
	/**
	* Signs a request with the Authentication header.
	*
	* @param {WebResource} The webresource to be signed.
	* @param {function(error)}  callback  The callback function.
	*/
	SharedKey.prototype.signRequest = function (webResource, callback) {
	  var getvalueToAppend = function (value, headerName) {
	    // Do not sign content-length 0 in 2014-08-16 and later
	    if (headerName === HeaderConstants.CONTENT_LENGTH && (azureutil.objectIsNull(value[headerName]) || value[headerName].toString() === '0')) {
	      return '\n';
	    } else if (azureutil.objectIsNull(value) || azureutil.objectIsNull(value[headerName])) {
	      return '\n';
	    } else {
	      return value[headerName] + '\n';
	    }
	  };
	
	  var stringToSign =
	    webResource.method + '\n' +
	    getvalueToAppend(webResource.headers, HeaderConstants.CONTENT_ENCODING) +
	    getvalueToAppend(webResource.headers, HeaderConstants.CONTENT_LANGUAGE) +
	    getvalueToAppend(webResource.headers, HeaderConstants.CONTENT_LENGTH) +
	    getvalueToAppend(webResource.headers, HeaderConstants.CONTENT_MD5) +
	    getvalueToAppend(webResource.headers, HeaderConstants.CONTENT_TYPE) +
	    getvalueToAppend(webResource.headers, HeaderConstants.DATE) +
	    getvalueToAppend(webResource.headers, HeaderConstants.IF_MODIFIED_SINCE) +
	    getvalueToAppend(webResource.headers, HeaderConstants.IF_MATCH) +
	    getvalueToAppend(webResource.headers, HeaderConstants.IF_NONE_MATCH) +
	    getvalueToAppend(webResource.headers, HeaderConstants.IF_UNMODIFIED_SINCE) +
	    getvalueToAppend(webResource.headers, HeaderConstants.RANGE) +
	    this._getCanonicalizedHeaders(webResource) +
	    this._getCanonicalizedResource(webResource);
	
	  var signature = this.signer.sign(stringToSign);
	
	  webResource.withHeader(HeaderConstants.AUTHORIZATION, 'SharedKey ' + this.storageAccount + ':' + signature);
	  callback(null);
	};
	
	/*
	* Retrieves the webresource's canonicalized resource string.
	* @param {WebResource} webResource The webresource to get the canonicalized resource string from.
	* @return {string} The canonicalized resource string.
	*/
	SharedKey.prototype._getCanonicalizedResource = function (webResource) {
	  var path = '/';
	  if (webResource.path) {
	    path = webResource.path;
	  }
	
	  var canonicalizedResource = '/' + this.storageAccount + path;
	
	  // Get the raw query string values for signing
	  var queryStringValues = webResource.queryString;
	
	  // Build the canonicalized resource by sorting the values by name.
	  if (queryStringValues) {
	    var paramNames = [];
	    Object.keys(queryStringValues).forEach(function (n) {
	      paramNames.push(n);
	    });
	
	    paramNames = paramNames.sort();
	    Object.keys(paramNames).forEach(function (name) {
	      canonicalizedResource += '\n' + paramNames[name] + ':' + queryStringValues[paramNames[name]];
	    });
	  }
	
	  return canonicalizedResource;
	};
	
	/*
	* Constructs the Canonicalized Headers string.
	*
	* To construct the CanonicalizedHeaders portion of the signature string,
	* follow these steps: 1. Retrieve all headers for the resource that begin
	* with x-ms-, including the x-ms-date header. 2. Convert each HTTP header
	* name to lowercase. 3. Sort the headers lexicographically by header name,
	* in ascending order. Each header may appear only once in the
	* string. 4. Unfold the string by replacing any breaking white space with a
	* single space. 5. Trim any white space around the colon in the header. 6.
	* Finally, append a new line character to each canonicalized header in the
	* resulting list. Construct the CanonicalizedHeaders string by
	* concatenating all headers in this list into a single string.
	*
	* @param {object} The webresource object.
	* @return {string} The canonicalized headers.
	*/
	SharedKey.prototype._getCanonicalizedHeaders = function (webResource) {
	  // Build canonicalized headers
	  var canonicalizedHeaders = '';
	  if (webResource.headers) {
	    var canonicalizedHeadersArray = [];
	    for (var header in webResource.headers) {
	      if (header.indexOf(HeaderConstants.PREFIX_FOR_STORAGE) === 0) {
	        var headerItem = { canonicalized: header.toLowerCase(), original: header };
	        canonicalizedHeadersArray.push(headerItem);
	      }
	    }
	
	    canonicalizedHeadersArray.sort(function(a, b) { return a.canonicalized.localeCompare(b.canonicalized); });
	
	    _.each(canonicalizedHeadersArray, function (currentHeaderItem) {
	      var value = webResource.headers[currentHeaderItem.original];
	      if (!azureutil.IsNullOrEmptyOrUndefinedOrWhiteSpace(value)) {
	        canonicalizedHeaders += currentHeaderItem.canonicalized + ':' + value + '\n';
	      } else {
	        canonicalizedHeaders += currentHeaderItem.canonicalized + ':\n';
	      }
	    });
	  }
	
	  return canonicalizedHeaders;
	};
	
	/**
	* Generates the query string for a shared access signature signing.
	*
	* @this {SharedAccessSignature}
	* @param {string}                     serviceType                                         The service type.
	* @param {string}                     path                                                The path to the resource.
	* @param {object}                     sharedAccessPolicy                                  The shared access policy.
	* @param {string}                     [sharedAccessPolicy.Id]                             The signed identifier.
	* @param {SharedAccessPermissions}    [sharedAccessPolicy.AccessPolicy.Permissions]       The permission type.
	* @param {date}                       [sharedAccessPolicy.AccessPolicy.Start]             The time at which the Shared Access Signature becomes valid.
	* @param {date}                       [sharedAccessPolicy.AccessPolicy.Expiry]            The time at which the Shared Access Signature becomes expired.
	* @param {string}                     [sharedAccessPolicy.AccessPolicy.IPAddressOrRange]  An IP address or a range of IP addresses from which to accept requests. When specifying a range, note that the range is inclusive.
	* @param {string}                     [sharedAccessPolicy.AccessPolicy.Protocols]         The protocols permitted for a request made with the account SAS. 
	*                                                                                         Possible values are both HTTPS and HTTP (https,http) or HTTPS only (https). The default value is https,http. 
	* @param {string}                     sasVersion                                          A string indicating the desired SAS Version to use, in storage service version format. Value must be 2012-02-12 or later.
	* @parma {ResourceTypes}              [args.resourceType]                                 The resource type, if the resource is a blob or container.  Null if the resource is a queue or table.
	* @parma {ResourceTypes}              [args.tableName]                                    The table name, if the resource is a table.  Null if the resource is a blob orqueue.
	* @parma {ResourceTypes}              [args.queryString]                                  The query string, if additional parameters are desired.
	* @param {object}                     [args.headers]                                      The optional header values to set for a blob returned wth this SAS.
	* @param {string}                     [args.headers.CacheControl]                         The value of the Cache-Control response header to be returned when this SAS is used.
	* @param {string}                     [args.headers.ContentType]                          The value of the Content-Type response header to be returned when this SAS is used.
	* @param {string}                     [args.headers.ContentEncoding]                      The value of the Content-Encoding response header to be returned when this SAS is used.
	* @param {string}                     [args.headers.ContentLanguage]                      The value of the Content-Language response header to be returned when this SAS is used.
	* @param {string}                     [args.headers.ContentDisposition]                   The value of the Content-Disposition response header to be returned when this SAS is used.
	* @return {object} The shared access signature query string.
	*/
	SharedKey.prototype.generateSignedQueryString = function (serviceType, path, sharedAccessPolicy, sasVersion, args) {
	  var addIfNotNull = function (queryString, name, value) {
	    if (!azureutil.objectIsNull(name) && !azureutil.objectIsNull(value)) {
	      queryString[name] = value;
	    }
	  };
	
	  var validateVersion = function (sasVersion) {
	    // validate and add version
	    if (azureutil.objectIsNull(sasVersion)) {
	      return HeaderConstants.TARGET_STORAGE_VERSION;
	    } else {
	      var values = _.values(CompatibleVersionConstants);
	      if (values.some(function(version) {
	        return version.toLowerCase() === sasVersion.toLowerCase();
	      })) {
	        return sasVersion;
	      } else {
	        throw new ArgumentError('sasVersion', azureutil.stringFormat(SR.INVALID_SAS_VERSION, sasVersion, values));
	      }
	    }
	  };
	
	  var formatAccessPolicyDates = function (accessPolicy) {
	    if (!azureutil.objectIsNull(accessPolicy.Start)) {
	      if (!_.isDate(accessPolicy.Start)) {
	        accessPolicy.Start = new Date(accessPolicy.Start);
	      }
	 
	      accessPolicy.Start = azureutil.truncatedISO8061Date(accessPolicy.Start);
	    }
	
	    if (!azureutil.objectIsNull(accessPolicy.Expiry)) {
	      if (!_.isDate(accessPolicy.Expiry)) {
	        accessPolicy.Expiry = new Date(accessPolicy.Expiry);
	      }
	
	      accessPolicy.Expiry = azureutil.truncatedISO8061Date(accessPolicy.Expiry);
	    }
	  };
	
	  // set up optional args
	  var queryString;
	  var resourceType;
	  var headers;
	  var tableName;
	  
	  if(args) {
	    queryString = args.queryString;
	    resourceType = args.resourceType;
	    tableName = args.tableName;
	    headers = args.headers;
	  }
	
	  if(!queryString) {
	    queryString = {};
	  }
	
	  // add shared access policy params
	  if (sharedAccessPolicy.AccessPolicy) {
	    formatAccessPolicyDates(sharedAccessPolicy.AccessPolicy);
	
	    addIfNotNull(queryString, QueryStringConstants.SIGNED_START, sharedAccessPolicy.AccessPolicy.Start);
	    addIfNotNull(queryString, QueryStringConstants.SIGNED_EXPIRY, sharedAccessPolicy.AccessPolicy.Expiry);
	    addIfNotNull(queryString, QueryStringConstants.SIGNED_PERMISSIONS, sharedAccessPolicy.AccessPolicy.Permissions);
	    addIfNotNull(queryString, QueryStringConstants.SIGNED_IP, sharedAccessPolicy.AccessPolicy.IPAddressOrRange);
	    addIfNotNull(queryString, QueryStringConstants.SIGNED_PROTOCOL, sharedAccessPolicy.AccessPolicy.Protocols);
	
	    // tables only
	    addIfNotNull(queryString, QueryStringConstants.STARTPK, sharedAccessPolicy.AccessPolicy.StartPk);
	    addIfNotNull(queryString, QueryStringConstants.ENDPK, sharedAccessPolicy.AccessPolicy.EndPk);
	    addIfNotNull(queryString, QueryStringConstants.STARTRK, sharedAccessPolicy.AccessPolicy.StartRk);
	    addIfNotNull(queryString, QueryStringConstants.ENDRK, sharedAccessPolicy.AccessPolicy.EndRk);
	  }
	
	  // validate and add version
	  var validatedSASVersionString = validateVersion(sasVersion);
	  addIfNotNull(queryString, QueryStringConstants.SIGNED_VERSION, validatedSASVersionString);
	
	  // add signed identifier
	  addIfNotNull(queryString, QueryStringConstants.SIGNED_IDENTIFIER, sharedAccessPolicy.Id);
	
	  // blobs only
	  addIfNotNull(queryString, QueryStringConstants.SIGNED_RESOURCE, resourceType);
	  if (headers) {
	    addIfNotNull(queryString, QueryStringConstants.CACHE_CONTROL, headers.cacheControl);
	    addIfNotNull(queryString, QueryStringConstants.CONTENT_TYPE, headers.contentType);
	    addIfNotNull(queryString, QueryStringConstants.CONTENT_ENCODING, headers.contentEncoding);
	    addIfNotNull(queryString, QueryStringConstants.CONTENT_LANGUAGE, headers.contentLanguage);
	    addIfNotNull(queryString, QueryStringConstants.CONTENT_DISPOSITION, headers.contentDisposition);
	  }
	
	  // tables only
	  addIfNotNull(queryString, QueryStringConstants.TABLENAME, tableName);
	
	  // add signature
	  addIfNotNull(queryString, QueryStringConstants.SIGNATURE, this._generateSignature(serviceType, path, sharedAccessPolicy, validatedSASVersionString, {resourceType: resourceType, headers: headers, tableName: tableName}));
	
	  return qs.stringify(queryString);
	};
	
	/**
	* Generates the shared access signature for a resource.
	*
	* @this {SharedAccessSignature}
	* @param {string}                     serviceType                                         The service type.
	* @param {string}                     path                                                The path to the resource.
	* @param {object}                     sharedAccessPolicy                                  The shared access policy.
	* @param {string}                     [sharedAccessPolicy.Id]                             The signed identifier.
	* @param {SharedAccessPermissions}    [sharedAccessPolicy.AccessPolicy.Permissions]       The permission type.
	* @param {date}                       [sharedAccessPolicy.AccessPolicy.Start]             The time at which the Shared Access Signature becomes valid.
	* @param {date}                       [sharedAccessPolicy.AccessPolicy.Expiry]            The time at which the Shared Access Signature becomes expired.
	* @param {string}                     [sharedAccessPolicy.AccessPolicy.IPAddressOrRange]  An IP address or a range of IP addresses from which to accept requests. When specifying a range, note that the range is inclusive.
	* @param {string}                     [sharedAccessPolicy.AccessPolicy.Protocols]         The protocols permitted for a request made with the account SAS. 
	*                                                                                         Possible values are both HTTPS and HTTP (https,http) or HTTPS only (https). The default value is https,http.
	* @param {string}                     sasVersion                                          A string indicating the desired SAS Version to use, in storage service version format. Value must be 2012-02-12 or later.
	* @parma {ResourceTypes}              [args.resourceType]                                 The resource type, if the resource is a blob or container.  Null if the resource is a queue or table.
	* @parma {ResourceTypes}              [args.tableName]                                    The table name, if the resource is a table.  Null if the resource is a blob or queue.
	* @param {object}                     [args.headers]                                      The optional header values to set for a blob returned wth this SAS.
	* @param {string}                     [args.headers.CacheControl]                         The value of the Cache-Control response header to be returned when this SAS is used.
	* @param {string}                     [args.headers.ContentType]                          The value of the Content-Type response header to be returned when this SAS is used.
	* @param {string}                     [args.headers.ContentEncoding]                      The value of the Content-Encoding response header to be returned when this SAS is used.
	* @param {string}                     [args.headers.ContentLanguage]                      The value of the Content-Language response header to be returned when this SAS is used.
	* @param {string}                     [args.headers.ContentDisposition]                   The value of the Content-Disposition response header to be returned when this SAS is used.
	* @return {string} The shared access signature.
	*/
	SharedKey.prototype._generateSignature = function (serviceType, path, sharedAccessPolicy, sasVersion, args) {
	  var getvalueToAppend = function (value, noNewLine) {
	    var returnValue = '';
	    if (!azureutil.objectIsNull(value)) {
	      returnValue = value;
	    }
	
	    if (noNewLine !== true) {
	      returnValue += '\n';
	    }
	
	    return returnValue;
	  };
	
	  // set up optional args
	  var resourceType;
	  var tableName;
	  var headers;
	  if(args) {
	    resourceType = args.resourceType;
	    tableName = args.tableName;
	    headers = args.headers;
	  }
	
	  // Add leading slash to path
	  if (path.substr(0, 1) !== '/') {
	    path = '/' + path;
	  }
	
	  var canonicalizedResource;
	  if (sasVersion === CompatibleVersionConstants.FEBRUARY_2012 || sasVersion === CompatibleVersionConstants.AUGUST_2013) {
	    // Do not prepend service name for older versions
	    canonicalizedResource = '/' + this.storageAccount + path;
	  } else {
	    canonicalizedResource = '/' + serviceType + '/' + this.storageAccount + path;
	  }
	
	  var stringToSign = getvalueToAppend(sharedAccessPolicy.AccessPolicy ? sharedAccessPolicy.AccessPolicy.Permissions : '') +
	      getvalueToAppend(sharedAccessPolicy.AccessPolicy ? sharedAccessPolicy.AccessPolicy.Start : '') +
	      getvalueToAppend(sharedAccessPolicy.AccessPolicy ? sharedAccessPolicy.AccessPolicy.Expiry : '') +
	      getvalueToAppend(canonicalizedResource) +
	      getvalueToAppend(sharedAccessPolicy.Id) +
	      getvalueToAppend(sharedAccessPolicy.AccessPolicy ? sharedAccessPolicy.AccessPolicy.IPAddressOrRange : '') +
	      getvalueToAppend(sharedAccessPolicy.AccessPolicy ? sharedAccessPolicy.AccessPolicy.Protocols : '') +
	      sasVersion;
	
	  if(sasVersion == CompatibleVersionConstants.FEBRUARY_2012) {
	    if(headers) {
	      throw new ArgumentError('args.headers', SR.INVALID_HEADERS);
	    }
	  } else if (resourceType) {
	    stringToSign += '\n' +
	    getvalueToAppend(headers ? headers.cacheControl : '') +
	    getvalueToAppend(headers ? headers.contentDisposition : '') +
	    getvalueToAppend(headers ? headers.contentEncoding : '') +
	    getvalueToAppend(headers ? headers.contentLanguage : '') +
	    getvalueToAppend(headers ? headers.contentType : '', true);
	  }
	
	  if(tableName) {
	    stringToSign += '\n' + 
	    getvalueToAppend(sharedAccessPolicy.AccessPolicy ? sharedAccessPolicy.AccessPolicy.StartPk : '') +
	    getvalueToAppend(sharedAccessPolicy.AccessPolicy ? sharedAccessPolicy.AccessPolicy.StartRk : '') +
	    getvalueToAppend(sharedAccessPolicy.AccessPolicy ? sharedAccessPolicy.AccessPolicy.EndPk : '') +
	    getvalueToAppend(sharedAccessPolicy.AccessPolicy ? sharedAccessPolicy.AccessPolicy.EndRk : '', true);
	  }
	
	  return this.signer.sign(stringToSign);
	};
	
	module.exports = SharedKey;

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	var stream = __webpack_require__(20);
	var util = __webpack_require__(4);
	
	function BufferStream(buffer, options) {
	    stream.Readable.call(this, options);
	
	    this._buffer = buffer;
	    this._offset = 0;
	    this._chunkSize = 4 * 1024 * 1024;
	    this._bufferSize = buffer.length;
	}
	
	util.inherits(BufferStream, stream.Readable);
	
	BufferStream.prototype._read = function () {
	    while (this.push(this._readNextChunk())) {
	        continue;
	    }
	};
	
	BufferStream.prototype._readNextChunk = function () {
	    var data = null;
	
	    if (this._offset < this._bufferSize) {
	        var end = this._offset + this._chunkSize;
	        end = end > this._bufferSize ? this._bufferSize : end;
	        data = this._buffer.slice(this._offset, end);
	        this._offset = end;
	    }
	
	    return data;
	};
	
	module.exports = BufferStream;

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	var stream = __webpack_require__(20);
	var util = __webpack_require__(4);
	
	var azureutil = __webpack_require__(16);
	var Md5Wrapper = __webpack_require__(34);
	var Constants = __webpack_require__(12);
	var bufferSize = Constants.BlobConstants.DEFAULT_WRITE_BLOCK_SIZE_IN_BYTES;
	
	/**
	*  Chunk stream
	*  1. Calculate md5
	*  2. Track reading offset
	*  3. Work with customize memory allocator
	*  4. Buffer data from stream.
	*  @param {object} options stream.Readable options
	*/
	function ChunkStream(options) {
	  stream.Stream.call(this);
	  this.writable = this.readable = true;
	
	  if (!options) {
	    options = {};
	  }
	
	  this._highWaterMark = options.highWaterMark || bufferSize;
	
	  this._paused = undefined; //True/false is the external status from users.
	
	  this._isStreamOpened = false;
	  this._offset = 0;
	  this._allocator = options.allocator;
	  this._streamEnded = false;
	  this._md5hash = null;
	  this._buffer = null;
	  this._internalBufferSize = 0;
	  this._outputLengthLimit = 0;
	  this._md5sum = undefined;
	
	  if (options.calcContentMd5) {
	    this._md5hash = new Md5Wrapper().createMd5Hash();
	  }
	}
	
	util.inherits(ChunkStream, stream.Stream);
	
	/**
	* Set the memory allocator.
	*/
	ChunkStream.prototype.setMemoryAllocator = function(allocator) {
	  this._allocator = allocator;
	};
	
	/**
	* Set the output length.
	*/
	ChunkStream.prototype.setOutputLength = function(length) {
	  if (length) {
	    this._outputLengthLimit = length;
	  }
	};
	
	/**
	* Internal stream ended
	*/
	ChunkStream.prototype.end = function (chunk, encoding, cb) {
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk) {
	    this.write(chunk, encoding);
	  }
	
	  this._streamEnded = true;
	  this._flushInternalBuffer();
	  
	  if (cb) {
	    this.once('end', cb);
	  }
	
	  this.emit('end');
	};
	
	ChunkStream.prototype.finish = function () {
	  this.emit('finish');
	
	  this.destroy();
	};
	
	ChunkStream.prototype.error = function () {
	  this.emit('error');
	
	  this.destroy();
	};
	
	ChunkStream.prototype.destroy = function () {
	  this.writable = this.readable = false;
	
	  if (this._allocator && azureutil.objectIsFunction(this._allocator.destroy)) {
	    this._allocator.destroy();
	  }
	  
	  this.emit('close');
	};
	
	ChunkStream.prototype.stop = function () {
	  this.destroy();
	  this._streamEnded = true;
	  this.emit('end');
	};
	
	/**
	* Add event listener
	*/
	ChunkStream.prototype.write = function (chunk, encoding) {
	  if (!this._isStreamOpened) {
	    this._isStreamOpened = true;
	  }
	
	  this._buildChunk(chunk, encoding);
	
	  return !this._paused;
	};
	
	/**
	* Buffer the data into a chunk and emit it
	*/
	ChunkStream.prototype._buildChunk = function (data) {
	  if (typeof data == 'string') {
	    data = new Buffer(data);
	  }
	  var dataSize = data.length;
	  var dataOffset = 0;
	  do {
	    var buffer = null;
	    var targetSize = this._internalBufferSize + dataSize;
	
	    if (targetSize < this._highWaterMark) {
	      // add the data to the internal buffer and return as it is not yet full
	      this._copyToInternalBuffer(data, dataOffset, data.length);
	      return;
	    } else if (targetSize == this._highWaterMark){
	      var canReleaseInnerStreamBuffer = this._stream && this._stream._allocator && this._stream._allocator.releaseBuffer;
	      if(this._internalBufferSize === 0 && data.length === this._highWaterMark && !canReleaseInnerStreamBuffer) {
	        // set the buffer to the data passed in to avoid creating a new buffer
	        buffer = data;
	      } else {
	        // add the data to the internal buffer and pop that buffer
	        this._copyToInternalBuffer(data, dataOffset, data.length);
	        buffer = this._popInternalBuffer();
	      }
	      dataSize = 0;
	    } else {
	      // add data to the internal buffer until its full, then return it
	      // set the dataSize parameter so that additional data is not lost
	      var copySize = this._highWaterMark - this._internalBufferSize;
	      this._copyToInternalBuffer(data, dataOffset, dataOffset + copySize);
	      dataSize -= copySize;
	      dataOffset += copySize;
	      buffer = this._popInternalBuffer();
	    }
	    this._emitBufferData(buffer);
	  } while(dataSize > 0);
	};
	
	/**
	* Emit the buffer
	*/
	ChunkStream.prototype._emitBufferData = function(buffer) {
	  var newOffset = this._offset + buffer.length;
	  var range = {
	    start : this._offset,
	    end : newOffset - 1,
	    size : buffer.length
	  };
	
	  this._offset = newOffset;
	  
	  if (this._outputLengthLimit > 0) {
	    // When the start postion is larger than the limit, no data will be consumed though there is an event to be emitted.
	    // So the buffer should not be calculated.
	    if (range.start <= this._outputLengthLimit) {
	      if (this._offset > this._outputLengthLimit) {
	        // Don't use negative end parameter which means the index starting from the end of the buffer
	        // to be compatible with node 0.8.
	        buffer = buffer.slice(0, buffer.length - (this._offset - this._outputLengthLimit));
	      }
	      if (this._md5hash) {
	        this._md5hash.update(buffer);
	      }
	    }
	  } else if (this._md5hash) {
	    this._md5hash.update(buffer);
	  }
	
	  this.emit('data', buffer, range);
	};
	
	/**
	* Copy data into internal buffer
	*/
	ChunkStream.prototype._copyToInternalBuffer = function(data, start, end) {
	  if(start === undefined) start = 0;
	  if(end === undefined) end = data.length;
	  if (!this._buffer) {
	    this._buffer = this._allocateNewBuffer();
	    this._internalBufferSize = 0;
	  }
	  var copied = data.copy(this._buffer, this._internalBufferSize, start, end);
	  this._internalBufferSize += copied;
	
	  if (this._stream && this._stream._allocator && this._stream._allocator.releaseBuffer) {
	    this._stream._allocator.releaseBuffer(data);
	  }
	
	  if(copied != (end - start)) {
	    throw new Error('Can not copy entire data to buffer');
	  }
	};
	
	/**
	* Flush internal buffer
	*/
	ChunkStream.prototype._flushInternalBuffer = function() {
	  var buffer = this._popInternalBuffer();
	  if (buffer) {
	    this._emitBufferData(buffer);
	  }
	};
	
	/**
	* Pop internal buffer
	*/
	ChunkStream.prototype._popInternalBuffer = function () {
	  var buf = null;
	  if (!this._buffer || this._internalBufferSize === 0) {
	    buf = null;
	  } else if(this._internalBufferSize == this._highWaterMark) {
	    buf = this._buffer;
	  } else {
	    buf = this._buffer.slice(0, this._internalBufferSize);
	  }
	
	  this._buffer = null;
	  this._internalBufferSize = 0;
	
	  return buf;
	};
	
	/**
	* Allocate a buffer
	*/
	ChunkStream.prototype._allocateNewBuffer = function() {
	  var size = this._highWaterMark;
	  if(this._allocator && azureutil.objectIsFunction(this._allocator.getBuffer)) {
	    return this._allocator.getBuffer(size);
	  } else {
	    var buffer = new Buffer(size);
	    return buffer;
	  }
	};
	
	/**
	* Get file content md5 when read completely.
	*/
	ChunkStream.prototype.getContentMd5 = function(encoding) {
	  if (!encoding) encoding = 'base64';
	  if(!this._md5hash) {
	    throw new Error('Can\'t get content md5, please set the calcContentMd5 option for FileReadStream.');
	  } else {
	    if (this._streamEnded) {
	      if (!this._md5sum) {
	        this._md5sum = this._md5hash.digest(encoding);
	      }
	      return this._md5sum;
	    } else {
	      throw new Error('Stream has not ended.');
	    }
	  }
	};
	
	/**
	* Pause chunk stream
	*/
	ChunkStream.prototype.pause = function() {
	  this._paused = true;
	};
	
	/**
	* Resume read stream
	*/
	ChunkStream.prototype.resume = function() {
	  if (this._paused) {
	    this._paused = false;
	
	    this.emit('drain');
	  }
	};
	
	module.exports = ChunkStream;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 138 */
/***/ function(module, exports) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	var rightPad = function (n, number) {
	  var currentN = '' + n;
	  while (currentN.length < number) {
	    currentN = currentN + '0';
	  }
	
	  return currentN;
	};
	
	/**
	* Formats a date into an iso 8061 string.
	*
	* @param {date}    date The date to format.
	* @param {bool}    skipMilliseconds Boolean value indicating if the miliseconds part of the date should not be included.
	* @param {integer} millisecondsPading Number of digits to left pad the miliseconds.
	* @return {string} The date formated in the ISO 8061 date format.
	*/
	exports.format = function (date) {
	  var dateString = date.toISOString();
	  return dateString.substring(0, dateString.length - 1) + '0000Z';
	};
	
	/**
	* Parses an ISO 8061 date string into a date object.
	*
	* @param {string} stringDateTime The string with the date to parse in the ISO 8061 format.
	* @return {date} The parsed date.
	*/
	exports.parse = function (stringDateTime) {
	  var parts = stringDateTime.split('T');
	  var ymd = parts[0].split('-');
	  var time = parts[1].split('.');
	  var hms = time[0].split(':');
	  var ms = 0;
	  if (time[1]) {
	    ms = time[1].split('Z');
	  }
	
	  var date = new Date(Date.UTC(
	    parseInt(ymd[0], 10),
	    parseInt(ymd[1], 10) - 1,
	    parseInt(ymd[2], 10),
	    parseInt(hms[0], 10),
	    parseInt(hms[1], 10),
	    parseInt(hms[2], 10),
	    Math.round(parseInt(rightPad(ms[0], 7), 10) / 10000)
	  ));
	
	  return date;
	};

/***/ },
/* 139 */
/***/ function(module, exports) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Expose 'FileUtilities'.
	exports = module.exports;
	
	/**
	* Defines constants, enums, and utility functions for use with the File service.
	* @namespace FileUtilities
	*/
	var FileUtilities = {
	  /**
	  * Permission types
	  *
	  * @const
	  * @enum {string}
	  */
	  SharedAccessPermissions: {
	    READ: 'r',
	    CREATE: 'c',
	    WRITE: 'w',
	    DELETE: 'd',
	    LIST: 'l'
	  },
	
	  /**
	  * Listing details.
	  *
	  * @const
	  * @enum {string}
	  */
	  ListingDetails: {
	    METADATA: 'metadata'
	  },
	
	  /**
	  * File and share public access types.
	  *
	  * @const
	  * @enum {string}
	  */
	  SharePublicAccessType: {
	    OFF: null,
	    SHARE: 'share',
	    FILE: 'file'
	  },
	
	  /**
	  * Deletion options for share snapshots
	  *
	  * @const
	  * @enum {string}
	  */
	  ShareSnapshotDeleteOptions: {
	    SHARE_AND_SNAPSHOTS: 'include'
	  },
	};
	
	module.exports = FileUtilities;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Module dependencies.
	
	var util = __webpack_require__(4);
	
	/**
	 * The interface for classes that represent a encoder which can be used to specify how the queue service encodes and decodes queue messages.
	 * 
	 * To specify how the queue service encodes and decodes queue messages, set `queueService.messageEncoder` to object of built-in encoder types
	 * `[TextBase64QueueMessageEncoder]{@link TextBase64QueueMessageEncoder}`, `[BinaryBase64QueueMessageEncoder]{@link BinaryBase64QueueMessageEncoder}`, `[TextXmlQueueMessageEncoder]{@link TextXmlQueueMessageEncoder}`,
	 * or custom implementation of the QueueMessageEncoder.
	 * 
	 * @class
	 */
	function QueueMessageEncoder() {
	}
	
	/**
	 * Function to encode queue messages.
	 * 
	 * @param   {object}    [input]               The target to be encoded.
	 * @return  {string}
	 */
	QueueMessageEncoder.prototype.encode = function(input){
	  return input;
	};
	
	/**
	 * Function to decode queue messages
	 * 
	 * @param   {string}    [textToBeDecoded]     The base64 string to be decoded.
	 * @returns {any}
	 */
	QueueMessageEncoder.prototype.decode = function(textToBeDecoded){
	  return textToBeDecoded;
	};
	
	
	/**
	 * Create a new TextBase64QueueMessageEncoder object
	 * @class
	 * 
	 * Encode from utf-8 string to base64 string
	 * Decode from base64 string to utf-8 string.
	 * 
	 * @constructor
	 * @extends {QueueMessageEncoder}
	 */
	function TextBase64QueueMessageEncoder(){
	}
	util.inherits(TextBase64QueueMessageEncoder, QueueMessageEncoder);
	
	/**
	 * Encode from utf-8 string to base64 string
	 * @this TextBase64QueueMessageEncoder
	 * 
	 * @param   {string}    [input]               The target to be encoded.
	 * 
	 * @return {string}
	 */
	TextBase64QueueMessageEncoder.prototype.encode = function(input){
	  return new Buffer(input, 'utf8').toString('base64');
	};
	
	/**
	 * Decode from base64 string to utf-8 string.
	 * @this TextBase64QueueMessageEncoder
	 * 
	 * @param   {string}    [textToBeDecoded]     The base64 string to be decoded.
	 * 
	 * @return {string}
	 */
	TextBase64QueueMessageEncoder.prototype.decode = function(textToDecode){
	  return new Buffer(textToDecode, 'base64').toString('utf8');
	};
	
	
	/**
	 * Create a new BinaryBase64QueueMessageEncoder object
	 * @class
	 * 
	 * Encode from binary buffer to base64 string
	 * Decode from base64 string to binary buffer.
	 * 
	 * @constructor
	 * @extends {QueueMessageEncoder}
	 */
	function BinaryBase64QueueMessageEncoder(){
	}
	util.inherits(BinaryBase64QueueMessageEncoder, QueueMessageEncoder);
	
	/**
	 * Encode from binary buffer string to base64 string
	 * @this BinaryBase64QueueMessageEncoder
	 * 
	 * @param   {Buffer}    [input]               The target to be encoded.
	 * 
	 * @return {string}
	 */
	BinaryBase64QueueMessageEncoder.prototype.encode = function(input){
	  return input.toString('base64');
	};
	
	
	/**
	 * Decode from base64 string to binary buffer.
	 * @this BinaryBase64QueueMessageEncoder
	 * 
	 * @param   {string}    [textToBeDecoded]     The base64 string to be decoded.
	 * 
	 * @return {Buffer}
	 */
	BinaryBase64QueueMessageEncoder.prototype.decode = function(textToDecode){
	  return new Buffer(textToDecode, 'base64');
	};
	
	
	/**
	 * Create a new TextXmlQueueMessageEncoder object
	 * @class
	 * 
	 * Encode utf-8 string by escaping the xml markup characters.
	 * Decode from utf-8 string by unescaping the xml markup characters.
	 * 
	 * @constructor
	 * @extends {QueueMessageEncoder}
	 */
	function TextXmlQueueMessageEncoder(){
	}
	util.inherits(TextXmlQueueMessageEncoder, QueueMessageEncoder);
	
	/**
	 * Encode utf-8 string by escaping the xml markup characters.
	 * @this TextXmlQueueMessageEncoder
	 * 
	 * @param   {string}    [input]               The target to be encoded.
	 * 
	 * @return {string}
	 */
	TextXmlQueueMessageEncoder.prototype.encode = function(input){
	  return input.replace(/&/gm, '&amp;')
	    .replace(/</gm, '&lt;')
	    .replace(/>/gm, '&gt;')
	    .replace(/"/gm, '&quot;')
	    .replace(/'/gm, '&apos;');
	};
	
	/**
	 * Decode from utf-8 string by unescaping the xml markup characters.
	 * @this TextXmlQueueMessageEncoder
	 * 
	 * @param   {string}    [textToBeDecoded]     The base64 string to be decoded.
	 * 
	 * @return {string}
	 */
	TextXmlQueueMessageEncoder.prototype.decode = function(textToDecode){
	  return textToDecode.replace(/&amp;/gm, '&')
	    .replace(/&lt;/gm, '<')
	    .replace(/&gt;/gm, '>')
	    .replace(/&quot;/gm, '"')
	    .replace(/&apos;/gm, '\'');
	};
	
	module.exports = QueueMessageEncoder;
	module.exports.TextBase64QueueMessageEncoder = TextBase64QueueMessageEncoder;
	module.exports.BinaryBase64QueueMessageEncoder = BinaryBase64QueueMessageEncoder;
	module.exports.TextXmlQueueMessageEncoder = TextXmlQueueMessageEncoder;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	var _ = __webpack_require__(15);
	var util = __webpack_require__(4);
	var guid = __webpack_require__(116);
	
	var azureCommon = __webpack_require__(8);
	var azureutil = azureCommon.util;
	var SR = azureCommon.SR;
	
	var TableUtilities = __webpack_require__(52);
	var EdmType = TableUtilities.EdmType;
	
	/**
	* Get the Edm type of an object.
	*
	* @param {object} value A typed instance.
	* @return {string} The Edm type.
	*/
	exports.propertyType = function (value, guessNumberType) {
	  if (_.isNumber(value)) {
	    if (guessNumberType) {
	      if (azureutil.objectIsInt(value)) {
	        return 'Edm.Int32';
	      } else {
	        return 'Edm.Double';
	      }
	    } else {
	      return null;
	    }
	  } else if (_.isBoolean(value)) {
	    return 'Edm.Boolean';
	  } else if (_.isDate(value)) {
	    return 'Edm.DateTime';
	  } else {
	    return 'Edm.String';
	  }
	};
	
	/**
	* Convert a JSON value from over the wire into the correct EDM type.
	* 
	* Note that Int64, is remaining a string.  Converting it to a Number would lose precision.
	* Int32, Boolean, and Double should already be the correct non-string types
	*
	* @param {string} type  The type of the value as it appears in the type attribute.
	* @param value The value in JSON format.
	* @return {object} The unserialized value.
	*/
	exports.deserializeValueFromJson = function (type, value) {
	  if (type) {
	    switch (type) {
	      case EdmType.BINARY:
	        return new Buffer(value, 'base64');
	      case EdmType.DATETIME:
	        return new Date(value);
	      case EdmType.GUID:
	        return value;
	      case EdmType.DOUBLE:
	        // Account for Infinity and NaN:
	        if (typeof value !== 'number') {
	          return parseFloat(value);
	        }
	        return value;
	      case EdmType.INT32:
	      case EdmType.INT64:
	      case EdmType.STRING:
	      case EdmType.BOOLEAN:
	        return value;
	      default:
	        throw new Error(util.format(SR.TYPE_NOT_SUPPORTED, type));
	    }
	  } else {
	    return value;
	  }
	};
	
	/**
	* Convert a raw EdmType value into the JSON value expected to be sent over the wire.
	*
	* TODO: validate correct input types?
	* Expects Edm.Int64 and Edm.String to be string, Edm.Double and Edm.Int32 to be Number,
	* Edm.Guid to be an array or buffer compatible with Node.uuid, Edm.Binary to be a Node Buffer, Edm.DateTime to be a Date,
	* and Edm.Boolean to be a boolean.
	*
	* @param {string} type  The type of the value as it will appear in the type attribute.
	* @param {string} value The value
	* @return {object} The serialized value.
	*/
	exports.serializeValue = function (type, value) {
	  switch (type) {
	    case EdmType.BINARY:
	      if (Buffer.isBuffer(value)) {
	        return value.toString('base64');
	      }
	      return value;
	    case EdmType.DATETIME:
	      if (_.isDate(value)) {
	        return value.toISOString();
	      }
	      return value;
	    case EdmType.GUID:
	      if (Buffer.isBuffer(value) || _.isArray(value)) {
	        return guid.unparse(value);
	      }
	      return value;
	    case EdmType.INT64:
	    case EdmType.DOUBLE:
	      return value.toString();
	    case EdmType.INT32:
	      if (value === Number.POSITIVE_INFINITY) {
	        return 'Infinity';
	      }
	      if (value === Number.NEGATIVE_INFINITY) {
	        return '-Infinity';
	      }
	      if (azureutil.objectIsNaN(value)) {
	        return 'NaN';
	      }
	      return value;
	    case EdmType.STRING:
	    case EdmType.BOOLEAN:
	      return value;
	    default:
	      throw new Error(SR.TYPE_NOT_SUPPORTED + type);
	  }
	};
	
	/*
	* Determines if a type annotation is required for the input type when sending JSON data to the service. 
	*/
	exports.isTypeRequired = function(type, value) {
	  switch (type) {
	  case EdmType.BINARY:
	  case EdmType.INT64:
	  case EdmType.DATETIME:
	  case EdmType.GUID:
	  case EdmType.DOUBLE:
	    return true;
	  case EdmType.INT32:
	    if (typeof value !== 'number' || value === Number.POSITIVE_INFINITY || value === Number.NEGATIVE_INFINITY || (azureutil.objectIsNaN(value))) {
	      return true;
	    }
	    return false;
	  case EdmType.STRING:
	  case EdmType.BOOLEAN:
	    return false;
	  default:
	    throw new Error(util.format(SR.TYPE_NOT_SUPPORTED, type));
	  }
	};
	
	/**
	* Serializes value into proper value to be used in odata query value.
	*
	* @param {object} value The value to be serialized.
	* @return {string} The serialized value.
	*/
	exports.serializeQueryValue = function (value, type) {
	  var edmType = type || exports.propertyType(value, true);
	  switch (edmType) {
	    case EdmType.INT32:
	      return value.toString();
	    case EdmType.BOOLEAN:
	      return value ? 'true' : 'false';
	    case EdmType.DOUBLE:
	      return value.toString();
	    case EdmType.INT64:
	      return value.toString() + 'L';
	    case EdmType.DATETIME:
	      if(_.isDate(value)) {
	        var dateTimeString = value.toISOString();
	        return 'datetime\'' + dateTimeString + '\'';
	      }
	      throw new Error(util.format(SR.INVALID_EDM_TYPE, value, type));
	    case EdmType.GUID:
	      return 'guid\'' + value.toString() + '\'';
	    case EdmType.BINARY:
	      return 'X\'' + value.toString('hex') + '\'';
	    default:
	      return '\'' + value.toString().replace(/'/g, '\'\'') + '\'';
	  }   
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Module dependencies.
	var util = __webpack_require__(4);
	
	var azureCommon = __webpack_require__(8);
	var azureutil = azureCommon.util;
	var SR = azureCommon.SR;
	var Constants = azureCommon.Constants;
	var edmHandler = __webpack_require__(141);
	
	var prefixLength = Constants.TableConstants.ODATA_PREFIX.length;
	var suffixLength = Constants.TableConstants.ODATA_TYPE_SUFFIX.length;
	
	exports = module.exports;
	
	/* Serialize an entity to an Odata (Json based) payload
	* Input must be in the following format:
	* { stringValue: { '$': 'Edm.String', '_': 'my string' }, myInt: { '$': 'Edm.Int32', '_': 3 } }
	*/
	exports.serializeJson = function (entity) {
	  function normalizeEntityProperty(property) {
	    if(azureutil.objectIsNull(property)) {
	      return { _: property };
	    }
	
	    if (typeof property === 'object' && property.hasOwnProperty(Constants.TableConstants.ODATA_VALUE_MARKER)) {
	      return property;
	    }
	
	    var result = { _: property };
	    result[Constants.TableConstants.ODATA_TYPE_MARKER] = edmHandler.propertyType(property, true);
	
	    return result;
	  }
	
	  var result = {};
	  for (var propName in entity) {
	    // ignore if .metadata or null or undefined
	    if (propName !== Constants.TableConstants.ODATA_METADATA_MARKER) {
	      var property = normalizeEntityProperty(entity[propName]);
	      if (!azureutil.objectIsNull(property[Constants.TableConstants.ODATA_VALUE_MARKER])) {
	        var value = property[Constants.TableConstants.ODATA_VALUE_MARKER];
	        var type = property[Constants.TableConstants.ODATA_TYPE_MARKER];
	
	        if (type === undefined) {
	          type = edmHandler.propertyType(value, true);
	        }
	
	        result[propName] = edmHandler.serializeValue(type, value);
	        if (edmHandler.isTypeRequired(type, value)) {
	          result[propName + Constants.TableConstants.ODATA_TYPE_SUFFIX] = type;
	        }
	      }
	    } 
	  }
	
	  var replacer = function(key, value) {
	    if (value === Number.POSITIVE_INFINITY) {
	      return 'Infinity';
	    }
	    if (value === Number.NEGATIVE_INFINITY) {
	      return '-Infinity';
	    }
	    if (azureutil.objectIsNaN(value)) {
	      return 'NaN';
	    }
	    return value;
	  };
	  
	  return JSON.stringify(result, replacer);
	};
	
	/*
	Input: The body of the HTTP response from the server from a table list as JSON (responseObject.response.body).
	
	Return:
	This will return an array in the following format:
	
	[
	  tableName1,
	  tableName2
	]
	
	For example,
	
	[
	  myTable1,
	  myTable2
	]
	
	*/
	exports.parseJsonTables = function (response) {
	  var result = [];
	
	  if (response.value) {
	    for (var i = 0; i < response.value.length; i++) {
	      var entity = response.value[i].TableName;
	      result.push(entity);
	    }
	  }
	
	  return result;
	};
	
	/*
	Input: The body of the HTTP response from the server from a table query as JSON (responseObject.response.body).
	
	Return:
	This will return an array in the following format:
	
	[
	  {{ '$': edmHandler1, '_': value1}, { '$': edmHandler2, '_': value2}, { '$': edmHandler3, '_': value3}},
	  {{ '$': edmHandler4, '_': value4}, { '$': edmHandler5, '_': value5}, { '$': edmHandler6, '_': value6}}
	]
	
	For example,
	
	[
	  {{ '$': Edm.Int32, '_': 42}, { '$': Edm.String, '_': 'sample string'}, { '$': Edm.Boolean, '_': false}},
	  {{ '$': Edm.Int64, '_': 42}, { '$': Edm.String, '_': 'sample string 2'}, { '$': Edm.Boolean, '_': true}}
	]
	
	*/
	exports.parseJsonEntities = function (response, autoResolveProperties, propertyResolver, entityResolver) {
	  if (!response.value) {
	    return [exports.parseJsonSingleEntity(response, autoResolveProperties, propertyResolver, entityResolver)];
	  } else {
	    var result = [];
	
	    for (var i = 0; i < response.value.length; i++) {
	      var rawEntity = response.value[i];
	      var entity = exports.parseJsonSingleEntity(rawEntity, autoResolveProperties, propertyResolver, entityResolver);
	      result.push(entity);
	    }
	
	    return result;  
	  }
	};
	
	exports.parseJsonSingleEntity = function(rawEntity, autoResolveProperties, propertyResolver, entityResolver) {
	  var rawEntityProperties = {};
	  var entityPropertyTypes = {PartitionKey: 'Edm.String', RowKey: 'Edm.String', Timestamp: 'Edm.DateTime'};
	  var odataMetadata = {};
	
	  // parse properties
	  for (var entityPropertyName in rawEntity) {
	    if (azureutil.stringStartsWith(entityPropertyName, Constants.TableConstants.ODATA_PREFIX)) {
	      odataMetadata[entityPropertyName.slice(prefixLength)] = rawEntity[entityPropertyName];
	    } else if (azureutil.stringEndsWith(entityPropertyName, Constants.TableConstants.ODATA_TYPE_SUFFIX)) {
	      entityPropertyTypes[entityPropertyName.slice(0, entityPropertyName.length - suffixLength)] = rawEntity[entityPropertyName];
	    } else {
	      rawEntityProperties[entityPropertyName] = rawEntity[entityPropertyName];
	    }
	  }
	
	  // make sure etag is set
	  if (!odataMetadata.etag && rawEntityProperties.Timestamp) {
	    var timestampString = new Buffer(rawEntityProperties.Timestamp).toString();
	    odataMetadata.etag = 'W/"datetime\'' + timestampString + '\'"';
	  }
	
	  var entity = {};
	  for (var entityPropertyName in rawEntityProperties) {
	    if (rawEntityProperties.hasOwnProperty(entityPropertyName)) {
	      // set the type, if given in the response
	      var entityPropertyType = entityPropertyTypes[entityPropertyName];
	      entity[entityPropertyName] = {};  
	
	      // use the given property resolver if present, otherwise infer type if undefined
	      if (propertyResolver) {
	        // partition key, row key, name, value, type if present
	        entityPropertyType = propertyResolver(rawEntityProperties.PartitionKey, rawEntityProperties.RowKey, entityPropertyName, rawEntityProperties[entityPropertyName], entityPropertyType);
	      }
	      if (!entityPropertyType && autoResolveProperties) {
	        entityPropertyType = edmHandler.propertyType(rawEntityProperties[entityPropertyName], false);
	      } 
	
	      if (entityPropertyType) {
	        entity[entityPropertyName][Constants.TableConstants.ODATA_TYPE_MARKER] = entityPropertyType;
	      } 
	
	      try {
	        entity[entityPropertyName][Constants.TableConstants.ODATA_VALUE_MARKER] = edmHandler.deserializeValueFromJson(entityPropertyType, rawEntityProperties[entityPropertyName]);
	      } catch (err) {
	        if (propertyResolver) {
	          // if a property resolver was used and the type is invalid, throw an appropriate error
	          throw new Error(util.format(SR.INVALID_PROPERTY_RESOLVER, entityPropertyName, entityPropertyType, rawEntityProperties[entityPropertyName]));
	        } else {
	          throw err;
	        }
	      }
	    }
	  }
	
	  entity[Constants.TableConstants.ODATA_METADATA_MARKER] = odataMetadata;
	
	  if (entityResolver) {
	    entity = entityResolver(entity);
	  }
	
	  return entity;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	var util = __webpack_require__(4);
	var azureCommon = __webpack_require__(8);
	var WebResource = azureCommon.WebResource;
	var SR = azureCommon.SR;
	var Constants = azureCommon.Constants;
	var HeaderConstants = Constants.HeaderConstants;
	var TableConstants = Constants.TableConstants;
	var entityResult = __webpack_require__(83);
	
	exports = module.exports;
	
	/**
	* Retrieves the entity path from the table name and an entity descriptor.
	* @ignore
	*
	* @param {string}   table         The table name.
	* @param {object}   entity        The entity descriptor.
	* @return {string} The entity path.
	*/
	function getEntityPath (tableName, partitionKey, rowKey) {
	  var path = '/' + tableName;
	
	  if (typeof (partitionKey) === 'string' && typeof (rowKey) === 'string') {
	    // Escape single quotes according to OData Protocol Specification: "single quotes within string literals are represented as two consecutive single quotes".
	    partitionKey = partitionKey.replace(/'/g, '\'\'');
	    rowKey = rowKey.replace(/'/g, '\'\'');
	    path = path + '(PartitionKey=\'' + encodeURIComponent(partitionKey.toString('utf8')) + '\',RowKey=\'' + encodeURIComponent(rowKey.toString('utf8')) + '\')';
	  } else {
	    throw new Error(SR.INCORRECT_ENTITY_KEYS);
	  }
	
	  return path;
	}
	
	/**
	* Constructs the web resource for a table operation.
	*
	* @param {string}             operation                           The operation to perform.
	* @param {string}             table                               The table name.
	* @param {object}             entityDescriptor                    The entity descriptor.
	* @param {object}             [options]                           The create options or callback function.
	* @param {boolean}            [options.checkEtag]                 Boolean value indicating weather the etag should be matched or not.
	* @param {string}             [options.echoContent]               Whether or not to return the entity upon a successful insert. Default to false.
	* @param {string}             [options.payloadFormat]             The payload format to use for the request.
	* @param {LocationMode}       [options.locationMode]              Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                 Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                 The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                 execution time is checked intermittently while performing requests, and before executing retries.
	* @return {webResource}
	*/
	exports.constructEntityWebResource = function (operation, table, entityDescriptor, options) {
	  var webResource = null;
	  if (operation === TableConstants.Operations.INSERT) {
	    webResource = WebResource.post(table)
	      .withHeader(HeaderConstants.PREFER, options.echoContent ? HeaderConstants.PREFER_CONTENT : HeaderConstants.PREFER_NO_CONTENT);
	  } else {
	    var partitionKey;
	    var rowKey;
	
	    if (typeof (entityDescriptor.PartitionKey) === 'string') {
	      partitionKey = entityDescriptor.PartitionKey;
	    } else {
	      partitionKey = entityDescriptor.PartitionKey[TableConstants.ODATA_VALUE_MARKER];
	    }
	
	    if (typeof (entityDescriptor.RowKey) === 'string') {
	      rowKey = entityDescriptor.RowKey;
	    } else {
	      rowKey = entityDescriptor.RowKey[TableConstants.ODATA_VALUE_MARKER];
	    }
	
	    var path = getEntityPath(table, partitionKey, rowKey);
	
	    if (operation === TableConstants.Operations.DELETE) {
	      webResource = WebResource.del(path);
	    } else if (operation === TableConstants.Operations.MERGE || operation === TableConstants.Operations.INSERT_OR_MERGE) {
	      webResource = WebResource.merge(path);
	    } else if (operation === TableConstants.Operations.REPLACE || operation === TableConstants.Operations.INSERT_OR_REPLACE) {
	      webResource = WebResource.put(path);
	    } else if (operation === TableConstants.Operations.RETRIEVE) {
	      webResource = WebResource.get(path);
	    } else {
	      throw new Error(util.format(SR.INVALID_TABLE_OPERATION, operation));
	    }
	  }
	
	  if (operation === TableConstants.Operations.DELETE || operation === TableConstants.Operations.REPLACE || operation === TableConstants.Operations.MERGE) {
	    webResource.withHeader(HeaderConstants.IF_MATCH, entityResult.getEtag(entityDescriptor) || '*');
	  }
	
	  var entitySerializedDescriptor;
	  if (!(operation === TableConstants.Operations.DELETE || operation === TableConstants.Operations.RETRIEVE)) {
	    entitySerializedDescriptor = entityResult.serialize(entityDescriptor);
	  }
	
	  exports.setTableRequestHeadersAndBody(webResource, entitySerializedDescriptor, options.payloadFormat);
	
	  return webResource;
	};
	
	/**
	* Sets the table request headers.
	*
	* @param {string}             webResource       The webResource to add headers to.
	* @param {object}             [body]            The body of the request.
	*/
	exports.setTableRequestHeadersAndBody = function (webResource, body, acceptType) {
	  if (body) {
	    webResource.withHeader(HeaderConstants.CONTENT_LENGTH, Buffer.byteLength(body, 'utf8'))
	      .withBody(body)
	      .withHeader(HeaderConstants.CONTENT_TYPE, HeaderConstants.JSON_CONTENT_TYPE_VALUE);
	  }
	
	  webResource.withHeader(HeaderConstants.ACCEPT, acceptType)
	    .withHeader(HeaderConstants.MAX_DATA_SERVICE_VERSION, TableConstants.DEFAULT_DATA_SERVICE_VERSION);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Module dependencies.
	var _ = __webpack_require__(15);
	var util = __webpack_require__(4);
	
	var azureCommon = __webpack_require__(8);
	var azureutil = azureCommon.util;
	var SR = azureCommon.SR;
	var QueryStringConstants =  azureCommon.Constants.QueryStringConstants;
	
	var edmHandler = __webpack_require__(141);
	var TableUtilities = __webpack_require__(52);
	var QueryComparisons = TableUtilities.QueryComparisons;
	var TableOperators = TableUtilities.TableOperators;
	var EdmType = TableUtilities.EdmType;
	
	/**
	 * Creates a new TableQuery object.
	 *
	 * @constructor
	 */
	function TableQuery() {
	  this._fields = [];
	  this._where = [];
	  this._top = null;
	}
	
	/**
	* Specifies the select clause. If no arguments are given, all fields will be selected.
	*
	* @param {array} fields The fields to be selected.
	* @return {TableQuery} A table query object with the select clause.
	* @example
	* var tableQuery = new TableQuery().select('field1', 'field2');
	*/
	TableQuery.prototype.select = function () {
	  var self = this;
	  if (arguments) {
	    _.each(arguments, function (argument) {
	      self._fields.push(argument);
	    });
	  }
	
	  return this;
	};
	
	/**
	 * Specifies the top clause.
	 *
	 * @param {int} top The number of items to fetch.
	 * @return {TableQuery} A table query object with the top clause.
	 * @example
	 * var tableQuery = new TableQuery().top(10);
	 *
	 * // tasktable should already exist and have entities
	 * tableService.queryEntities('tasktable', tableQuery, null \/*currentToken*\/, function(error, result) {
	 *   if(!error) { 
	 *     var entities = result.entities; // there will be 10 or less entities
	 *     // do stuff with the returned entities if there are any
	 *     // if result.continuationToken exists, to get the next 10 (or less) entities
	 *     // call queryEntities as above, but with the returned token instead of null
	 *   }
	 * });
	 */
	TableQuery.prototype.top = function (top) {
	  this._top = top;
	  return this;
	};
	
	/**
	 * Specifies the where clause.
	 *
	 * Valid type specifier strings include: ?string?, ?bool?, ?int32?, ?double?, ?date?, ?guid?, ?int64?, ?binary?
	 * A type must be specified for guid, int64, and binaries or the filter produced will be incorrect.
	 *
	 * @param {string}       condition   The condition string.
	 * @param {string|array} value       Value(s) to insert in question mark (?) parameters.
	 * @return {TableQuery}  A table query object with the where clause.
	 * @example
	 * var tableQuery = new TableQuery().where(TableQuery.guidFilter('GuidField', QueryComparisons.EQUAL, guidVal));
	 * OR
	 * var tableQuery = new TableQuery().where('Name == ? or Name <= ?', name1, name2);
	 * OR
	 * var tableQuery = new TableQuery().where('Name == ?string? && Value == ?int64?', name1, int64Val);
	 *
	 * // tasktable should already exist and have entities
	 * tableService.queryEntities('tasktable', tableQuery, null \/*currentToken*\/, function(error, result, response) {
	 *   if(!error) { 
	 *     var entities = result.entities;
	 *     // do stuff with the returned entities if there are any
	 *   }
	 * });
	 */
	TableQuery.prototype.where = function (condition) {  
	  this._where.push(TableQuery._encodeConditionString(condition, arguments));
	  return this;
	};
	
	/**
	 * Generates a property filter condition string for an 'int' value.
	 *
	 * @param {string}       propertyName   A string containing the name of the property to compare.
	 * @param {string}       operation      A string containing the comparison operator to use. 
	 *                                      See Constants.TableConstants.QueryComparisons for a list of allowed operations.
	 * @param {string|int}   value          An 'int' containing the value to compare with the property.
	 * @return {string} A string containing the formatted filter condition.
	 * @example
	 * var query = TableQuery.int32Filter('IntField', QueryComparisons.EQUAL, 5);
	 */
	TableQuery.int32Filter = function (propertyName, operation, value) {
	  return TableQuery._concatFilterString(propertyName, operation, value, EdmType.INT32);
	};
	
	/**
	 * Generates a property filter condition string for a 'int64' value.
	 *
	 * @param {string}       propertyName   A string containing the name of the property to compare.
	 * @param {string}       operation      A string containing the comparison operator to use. 
	 *                                      See Constants.TableConstants.QueryComparisons for a list of allowed operations.
	 * @param {string|int64} value          An 'int64' containing the value to compare with the property.
	 * @return {string} A string containing the formatted filter condition.
	 * @example
	 * var query = TableQuery.int64Filter('Int64Field', QueryComparisons.EQUAL, 123);
	 */
	TableQuery.int64Filter = function (propertyName, operation, value) {
	  return TableQuery._concatFilterString(propertyName, operation, value, EdmType.INT64);
	};
	
	/**
	 * Generates a property filter condition string for a 'double' value.
	 *
	 * @param {string}       propertyName   A string containing the name of the property to compare.
	 * @param {string}       operation      A string containing the comparison operator to use. 
	 *                                      See Constants.TableConstants.QueryComparisons for a list of allowed operations.
	 * @param {string|double}value          A 'double' containing the value to compare with the property.
	 * @return {string} A string containing the formatted filter condition.
	 * @example
	 * var query = TableQuery.doubleFilter('DoubleField', QueryComparisons.EQUAL, 123.45);
	 */
	TableQuery.doubleFilter = function (propertyName, operation, value) {
	  return TableQuery._concatFilterString(propertyName, operation, value, EdmType.DOUBLE);
	};
	
	/**
	 * Generates a property filter condition string for a 'boolean' value.
	 *
	 * @param {string}       propertyName   A string containing the name of the property to compare.
	 * @param {string}       operation      A string containing the comparison operator to use. 
	 *                                      See Constants.TableConstants.QueryComparisons for a list of allowed operations.
	 * @param {string|boolean}       value          A 'boolean' containing the value to compare with the property.
	 * @return {string} A string containing the formatted filter condition.
	 * @example
	 * var query = TableQuery.booleanFilter('BooleanField', QueryComparisons.EQUAL, false);
	 */
	TableQuery.booleanFilter = function (propertyName, operation, value) {
	  return TableQuery._concatFilterString(propertyName, operation, value, EdmType.BOOLEAN);
	};
	
	/**
	 * Generates a property filter condition string for a 'datetime' value.
	 *
	 * @param {string}       propertyName   A string containing the name of the property to compare.
	 * @param {string}       operation      A string containing the comparison operator to use. 
	 *                                      See Constants.TableConstants.QueryComparisons for a list of allowed operations.
	 * @param {string|date}     value              A 'datetime' containing the value to compare with the property.
	 * @return {string} A string containing the formatted filter condition.
	 * @example
	 * var query = TableQuery.dateFilter('DateTimeField', QueryComparisons.EQUAL, new Date(Date.UTC(2001, 1, 3, 4, 5, 6)));
	 */
	TableQuery.dateFilter = function (propertyName, operation, value) {
	  return TableQuery._concatFilterString(propertyName, operation, value, EdmType.DATETIME);
	};
	
	/**
	 * Generates a property filter condition string for a 'guid' value.
	 *
	 * @param {string}       propertyName   A string containing the name of the property to compare.
	 * @param {string}       operation      A string containing the comparison operator to use. 
	 *                                      See Constants.TableConstants.QueryComparisons for a list of allowed operations.
	 * @param {string|guid}  value          A 'guid' containing the value to compare with the property.
	 * @return {string} A string containing the formatted filter condition.
	 * @example
	 * var query = TableQuery.guidFilter('GuidField', QueryComparisons.EQUAL, guid.v1());
	 */
	TableQuery.guidFilter = function (propertyName, operation, value) {
	  return TableQuery._concatFilterString(propertyName, operation, value, EdmType.GUID);
	};
	
	/**
	 * Generates a property filter condition string for a 'binary' value.
	 *
	 * @param {string}       propertyName   A string containing the name of the property to compare.
	 * @param {string}       operation      A string containing the comparison operator to use. 
	 *                                      See Constants.TableConstants.QueryComparisons for a list of allowed operations.
	 * @param {string|buffer}value          A 'buffer' containing the value to compare with the property.
	 * @return {string} A string containing the formatted filter condition.
	 * @example
	 * var query = TableQuery.binaryFilter('BinaryField', QueryComparisons.EQUAL, new Buffer('hello'));
	 */
	TableQuery.binaryFilter = function (propertyName, operation, value) {
	  return TableQuery._concatFilterString(propertyName, operation, value, EdmType.BINARY);
	};
	
	/**
	 * Generates a property filter condition string.
	 *
	 * @param {string}       propertyName   A string containing the name of the property to compare.
	 * @param {string}       operation      A string containing the comparison operator to use. 
	 *                                      See Constants.TableConstants.QueryComparisons for a list of allowed operations.
	 * @param {string}       value          A 'string' containing the value to compare with the property.
	 * @return {string} A string containing the formatted filter condition.
	 * @example
	 * var query = TableQuery.stringFilter('StringField', QueryComparisons.EQUAL, 'name');
	 */
	TableQuery.stringFilter = function (propertyName, operation, value) {
	  return TableQuery._concatFilterString(propertyName, operation, value, EdmType.STRING);
	};
	
	/**
	 * Creates a filter condition using the specified logical operator on two filter conditions.
	 *
	 * @param {string}       filterA          A string containing the first formatted filter condition.
	 * @param {string}       operatorString   A string containing the operator to use (AND, OR).
	 * @param {string}       filterB          A string containing the second formatted filter condition.
	 * @return {string} A string containing the combined filter expression.
	 * @example
	 * var filter1 = TableQuery.stringFilter('Name', QueryComparisons.EQUAL, 'Person');
	 * var filter2 = TableQuery.booleanFilter('Visible', QueryComparisons.EQUAL, true);
	 * var combinedFilter = TableQuery.combineFilters(filter1, TableUtilities.TableOperators.AND, filter2);
	 */
	TableQuery.combineFilters = function (filterA, operatorString, filterB) {
	  return filterA + ' ' + operatorString + ' ' + filterB;
	};
	
	/**
	 * Specifies an AND where condition.
	 *
	 * @param {string}       condition   The condition string.
	 * @param {array}        arguments   Any number of arguments to be replaced in the condition by the question mark (?).
	 * @return {TableQuery} A table query object with the and clause.
	 * @example
	 * var tableQuery = new TableQuery()
	 *                      .where('Name == ? or Name <= ?', 'Person1', 'Person2');
	 *                      .and('Age >= ?', 18);
	 */
	TableQuery.prototype.and = function (condition) {
	  if (this._where.length === 0) {
	    throw new Error(util.format(SR.QUERY_OPERATOR_REQUIRES_WHERE, 'AND'));
	  }
	
	  this._where.push(' and ' + TableQuery._encodeConditionString(condition, arguments));
	  return this;
	};
	
	/**
	 * Specifies an OR where condition.
	 *
	 * @param {string}       condition   The condition.
	 * @param {array}        arguments   Any number of arguments to be replaced in the condition by the question mark (?).
	 * @return {TableQuery} A table query object with the or clause.
	 * @example
	 * var tableQuery = new TableQuery()
	 *                      .where('Name == ? or Name <= ?', 'Person1', 'Person2');
	 *                      .or('Age >= ?', 18);
	 */
	TableQuery.prototype.or = function (condition) {
	  if (this._where.length === 0) {
	    throw new Error(util.format(SR.QUERY_OPERATOR_REQUIRES_WHERE, 'OR'));
	  }
	
	  this._where.push(' or ' + TableQuery._encodeConditionString(condition, arguments));
	  return this;
	};
	
	/**
	 * Returns the query string object for the query.
	 *
	 * @return {object} JSON object representing the query string arguments for the query.
	 */
	TableQuery.prototype.toQueryObject = function () {
	  var query = {};
	  if (this._fields.length > 0) {
	    query[QueryStringConstants.SELECT] = this._fields.join(',');
	  }
	
	  if (this._where.length > 0) {
	    query[QueryStringConstants.FILTER] = this._where.join('');
	  }
	
	  if (this._top) {
	    query[QueryStringConstants.TOP] = this._top;
	  }
	
	  return query;
	};
	
	// Functions
	
	/**
	* Concat the filter string parameters.
	*
	* @param {string}       propertyName   A string containing the name of the property to compare.
	* @param {string}       operation      A string containing the comparison operator to use. 
	*                                      See Constants.TableConstants.QueryComparisons for a list of allowed operations.
	* @param {object}       value          The value to compare with the property.
	* @param {string}       type           A string EdmType of the property to compare.
	* @return {string} A string containing the formatted filter condition.
	* @ignore
	*/
	TableQuery._concatFilterString = function (propertyName, operation, value, type) {
	  if (azureutil.objectIsNull(propertyName)) {
	    throw new Error(util.format(SR.ARGUMENT_NULL_OR_UNDEFINED, 'propertyName'));
	  }
	
	  if (azureutil.objectIsNull(operation)) {
	    throw new Error(util.format(SR.ARGUMENT_NULL_OR_UNDEFINED, 'operation'));
	  }
	
	  if (azureutil.objectIsNull(value)) {
	    throw new Error(util.format(SR.ARGUMENT_NULL_OR_UNDEFINED, 'value'));
	  }
	
	  var serializedValue = edmHandler.serializeQueryValue(value, type);
	  return propertyName + ' ' + operation + ' ' + serializedValue;
	};
	
	/**
	 * Encodes a condition string.
	 *
	 * @param {string}       condition   The condition.
	 * @param {array}        arguments   Any number of arguments to be replaced in the condition by the question mark (?).
	 * @return {TableQuery} A table query object with the or clause
	 * @ignore
	 */
	TableQuery._encodeConditionString = function (condition, args) {
	  var encodedCondition = TableQuery._replaceOperators(condition);
	  if (args.length > 1) {
	    var sections = encodedCondition.split(/(\?string\?|\?int32\?|\?int64\?|\?bool\?|\?double\?|\?date\?|\?binary\?|\?guid\?|\?)/);
	    var count = 1;
	    for (var i = 0; i < sections.length && count < args.length; i++) {
	      if (sections[i].indexOf('?') === 0) {
	        var type = TableQuery._getEdmType(sections[i]);
	        sections[i] = edmHandler.serializeQueryValue(args[count], type);
	        count++;
	      }
	    }
	    encodedCondition = sections.join('');
	  }
	
	  return encodedCondition;
	};
	
	/**
	 * Converts the query string type to an Edm type.
	 *
	 * @param {string} type The type included in the query string.
	 * @return {string} The EdmType.
	 * @ignore
	 */
	TableQuery._getEdmType = function (type) {
	  switch (type) {
	    case '?binary?':
	      return EdmType.BINARY;
	    case '?int64?':
	      return EdmType.INT64;
	    case '?date?':
	      return EdmType.DATETIME;
	    case '?guid?':
	      return EdmType.GUID;
	    case '?int32?':
	      return EdmType.INT32;
	    case '?double?':
	      return EdmType.DOUBLE;
	    case '?bool?':
	      return EdmType.BOOLEAN;
	    case '?string?':
	      return EdmType.STRING;
	    default:
	      return undefined;
	  }
	};
	
	/**
	 * Replace operators.
	 * @ignore
	 * @param {string} whereClause The text where to replace the operators.
	 * @return {string} The string with the replaced operators.
	 * @ignore
	 */
	TableQuery._replaceOperators = function (whereClause) {
	  var encodedWhereClause = whereClause.replace(/ == /g, ' ' + QueryComparisons.EQUAL + ' ');
	  encodedWhereClause = encodedWhereClause.replace(/ != /g, ' ' + QueryComparisons.NOT_EQUAL + ' ');
	  encodedWhereClause = encodedWhereClause.replace(/ >= /g, ' ' + QueryComparisons.GREATER_THAN_OR_EQUAL + ' ');
	  encodedWhereClause = encodedWhereClause.replace(/ > /g, ' ' + QueryComparisons.GREATER_THAN + ' ');
	  encodedWhereClause = encodedWhereClause.replace(/ <= /g, ' ' + QueryComparisons.LESS_THAN_OR_EQUAL + ' ');
	  encodedWhereClause = encodedWhereClause.replace(/ < /g, ' ' + QueryComparisons.LESS_THAN + ' ');
	  encodedWhereClause = encodedWhereClause.replace(/ \&\& /g, ' ' + TableOperators.AND + ' ');
	  encodedWhereClause = encodedWhereClause.replace(/ \|\| /g, ' ' + TableOperators.OR + ' ');
	  encodedWhereClause = encodedWhereClause.replace(/!/g, TableOperators.NOT);
	
	  return encodedWhereClause;
	};
	
	module.exports = TableQuery;


/***/ },
/* 145 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SHAKESHAKE_CONNECTIONSTRING = exports.SHAKESHAKE_CONNECTIONSTRING = 'config_shakeshake_connectionstring';
	var SHAKESHAKE_TOPIC = exports.SHAKESHAKE_TOPIC = 'config_shakeshake_topic';
	var GETSTARTED_CONNECTIONSTRING = exports.GETSTARTED_CONNECTIONSTRING = 'config_getstared_connectionstring';

/***/ },
/* 146 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var BUTTON_A = exports.BUTTON_A = 'buttonA';
	var BUTTON_B = exports.BUTTON_B = 'buttonB';
	var LED = exports.LED = 'led';
	var HTS221 = exports.HTS221 = 'hts221';
	var LSM6DSL = exports.LSM6DSL = 'lsm6dsl';
	var OLED = exports.OLED = 'oled';

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _azureIotDevice = __webpack_require__(241);
	
	var _telemetry = __webpack_require__(35);
	
	var _mqtt = __webpack_require__(332);
	
	var _mqtt2 = _interopRequireDefault(_mqtt);
	
	var _index = __webpack_require__(84);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _actions = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClientWrapper = function (_Client) {
	    _inherits(ClientWrapper, _Client);
	
	    function ClientWrapper(transport, connStr, blobUploadClient) {
	        var _this, _ret;
	
	        _classCallCheck(this, ClientWrapper);
	
	        window.azure_iot_device_client = (_this = _possibleConstructorReturn(this, (ClientWrapper.__proto__ || Object.getPrototypeOf(ClientWrapper)).call(this, transport, connStr, blobUploadClient)), _this);
	        return _ret = window.azure_iot_device_client, _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ClientWrapper, null, [{
	        key: 'fromConnectionString',
	        value: function fromConnectionString(connStr, transport) {
	            window.azure_iot_device_client = _get(ClientWrapper.__proto__ || Object.getPrototypeOf(ClientWrapper), 'fromConnectionString', this).call(this, connStr, transport);
	            return window.azure_iot_device_client;
	        }
	    }]);
	
	    return ClientWrapper;
	}(_azureIotDevice.Client);
	
	var SampleRunner = function () {
	    function SampleRunner() {
	        _classCallCheck(this, SampleRunner);
	
	        this.runningFunction = null;
	        if (!window.oldSetTimeout) {
	            window.timeoutList = [];
	            window.intervalList = [];
	
	            window.oldSetTimeout = window.setTimeout;
	            window.oldSetInterval = window.setInterval;
	            window.oldClearTimeout = window.clearTimeout;
	            window.oldClearInterval = window.clearInterval;
	
	            window.setTimeout = function (code, delay) {
	                var retval = window.oldSetTimeout(code, delay);
	                window.timeoutList.push(retval);
	                return retval;
	            };
	            window.clearTimeout = function (id) {
	                var ind = window.timeoutList.indexOf(id);
	                if (ind >= 0) {
	                    window.timeoutList.splice(ind, 1);
	                }
	                var retval = window.oldClearTimeout(id);
	                return retval;
	            };
	            window.setInterval = function (code, delay) {
	                var retval = window.oldSetInterval(code, delay);
	                window.intervalList.push(retval);
	                return retval;
	            };
	            window.clearInterval = function (id) {
	                var ind = window.intervalList.indexOf(id);
	                if (ind >= 0) {
	                    window.intervalList.splice(ind, 1);
	                }
	                var retval = window.oldClearInterval(id);
	                return retval;
	            };
	            window.clearAllTimeouts = function () {
	                for (var i in window.timeoutList) {
	                    window.oldClearTimeout(window.timeoutList[i]);
	                }
	                window.timeoutList = [];
	            };
	            window.clearAllIntervals = function () {
	                for (var i in window.intervalList) {
	                    window.oldClearInterval(window.intervalList[i]);
	                }
	                window.intervalList = [];
	            };
	        }
	        this.actualClient = null;
	    }
	
	    _createClass(SampleRunner, [{
	        key: 'stop',
	        value: function stop() {
	            window.clearAllIntervals();
	            window.clearAllTimeouts();
	            window.azure_iot_device_client.close();
	        }
	    }, {
	        key: 'run',
	        value: function run(msgCb, errCb) {
	            var _this2 = this;
	
	            // a prefix of UUID to avoid name conflict, here just use a fix one
	            var prefix = '76f98350';
	            var sampleName = _index2.default.getState().project.getIn(['currentProject', 'displayName']);
	            (0, _telemetry.traceEvent)('sample-run', { 'sample-name': sampleName });
	            var connectionString = _index2.default.getState().project.getIn(['currentProject', 'config', 'connectionString']);
	            var topic = _index2.default.getState().project.getIn(['currentProject', 'config', 'topic']);
	            if (connectionString === '') {
	                (0, _actions.showRunningInfo)(_index2.default.dispatch, 'Please provision cloud service and then provide the connection string');
	                return 1;
	            }
	            if (!/^HostName=([^;]*);DeviceId=([^;]*);SharedAccessKey=(.*)$/.test(connectionString)) {
	                (0, _actions.showRunningInfo)(_index2.default.dispatch, 'Invalid format for connection string');
	                return 2;
	            }
	            (0, _actions.runSample)(_index2.default.dispatch);
	            (0, _actions.showRunningInfo)(_index2.default.dispatch, '');
	            var replaces = [{
	                src: /require\('azure-iot-device'\)\.Client/g,
	                dest: 'Client'
	            }, {
	                src: /require\('azure-iot-device'\)\.Message/g,
	                dest: 'Message'
	            }, {
	                src: /require\('azure-iot-device-mqtt'\)\.Mqtt/g,
	                dest: 'Protocol'
	            }, {
	                src: /console\.log/g,
	                dest: 'msgCb'
	            }, {
	                src: /console\.error/g,
	                dest: 'errCb'
	            }, {
	                src: /require\('led'\)/g,
	                dest: 'led'
	            }, {
	                src: /require\('buttonA'\)/g,
	                dest: 'buttonA'
	            }, {
	                src: /require\('buttonB'\)/g,
	                dest: 'buttonB'
	            }, {
	                src: /require\('oled'\)/g,
	                dest: 'oled'
	            }, {
	                src: /require\('hts221'\)/g,
	                dest: 'hts221'
	            }, {
	                src: /require\('lsm6dsl'\)/g,
	                dest: 'lsm6dsl'
	            }, {
	                src: /require\('traceEvent'\)/g,
	                dest: 'traceEvent'
	            }];
	
	            try {
	                var code = _index2.default.getState().project.getIn(['currentProject', 'jsCode']);
	                for (var i = 0; i < replaces.length; i++) {
	                    var replace = replaces[i];
	                    code = code.replace(replace.src, 'replaces' + prefix + '.' + replace.dest);
	                }
	                code = code.replace(/\[CONNECTION_STRING_PLACE_HOLDER\]/g, connectionString);
	                code = code.replace(/\[TOPIC_PLACE_HOLDER\]/g, topic);
	                // eslint-disable-next-line no-new-func
	                this.runningFunction = new Function('replaces' + prefix, code);
	                setTimeout(function () {
	                    _this2.runningFunction(Object.assign({
	                        Client: ClientWrapper,
	                        Message: _azureIotDevice.Message,
	                        Protocol: _mqtt2.default,
	                        msgCb: msgCb,
	                        errCb: errCb,
	                        traceEvent: _telemetry.traceEvent
	                    }, window.devkitPlayground));
	                }, 0);
	            } catch (err) {
	                (0, _telemetry.traceEvent)('connect-fail', { 'sample-name': sampleName, reason: err });
	                errCb(err.message || JSON.stringify(err));
	                return 3;
	            }
	
	            return 0;
	        }
	    }], [{
	        key: 'getInstance',
	        value: function getInstance() {
	            if (!this.instance) {
	                this.instance = new SampleRunner();
	            }
	            return this.instance;
	        }
	    }]);
	
	    return SampleRunner;
	}();
	
	exports.default = SampleRunner;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = function (crypto, password, keyLen, ivLen) {
	  keyLen = keyLen/8;
	  ivLen = ivLen || 0;
	  var ki = 0;
	  var ii = 0;
	  var key = new Buffer(keyLen);
	  var iv = new Buffer(ivLen);
	  var addmd = 0;
	  var md, md_buf;
	  var i;
	  while (true) {
	    md = crypto.createHash('md5');
	    if(addmd++ > 0) {
	       md.update(md_buf);
	    }
	    md.update(password);
	    md_buf = md.digest();
	    i = 0;
	    if(keyLen > 0) {
	      while(true) {
	        if(keyLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	        key[ki++] = md_buf[i];
	        keyLen--;
	        i++;
	       }
	    }
	    if(ivLen > 0 && i !== md_buf.length) {
	      while(true) {
	        if(ivLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	       iv[ii++] = md_buf[i];
	       ivLen--;
	       i++;
	     }
	   }
	   if(keyLen === 0 && ivLen === 0) {
	      break;
	    }
	  }
	  for(i=0;i<md_buf.length;i++) {
	    md_buf[i] = 0;
	  }
	  return {
	    key: key,
	    iv: iv
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	var xor = __webpack_require__(64);
	exports.encrypt = function (self, block) {
	  var data = xor(block, self._prev);
	  self._prev = self._cipher.encryptBlock(data);
	  return self._prev;
	};
	exports.decrypt = function (self, block) {
	  var pad = self._prev;
	  self._prev = block;
	  var out = self._cipher.decryptBlock(block);
	  return xor(out, pad);
	};

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(64);
	exports.encrypt = function (self, data, decrypt) {
	  var out = new Buffer('');
	  var len;
	  while (data.length) {
	    if (self._cache.length === 0) {
	      self._cache = self._cipher.encryptBlock(self._prev);
	      self._prev = new Buffer('');
	    }
	    if (self._cache.length <= data.length) {
	      len = self._cache.length;
	      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)]);
	      data = data.slice(len);
	    } else {
	      out = Buffer.concat([out, encryptStart(self, data, decrypt)]);
	      break;
	    }
	  }
	  return out;
	};
	function encryptStart(self, data, decrypt) {
	  var len = data.length;
	  var out = xor(data, self._cache);
	  self._cache = self._cache.slice(len);
	  self._prev = Buffer.concat([self._prev, decrypt?data:out]);
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(64);
	function getBlock(self) {
	  var out = self._cipher.encryptBlock(self._prev);
	  incr32(self._prev);
	  return out;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	function incr32(iv) {
	  var len = iv.length;
	  var item;
	  while (len--) {
	    item = iv.readUInt8(len);
	    if (item === 255) {
	      iv.writeUInt8(0, len);
	    } else {
	      item++;
	      iv.writeUInt8(item, len);
	      break;
	    }
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 152 */
/***/ function(module, exports) {

	exports.encrypt = function (self, block) {
	  return self._cipher.encryptBlock(block);
	};
	exports.decrypt = function (self, block) {
	  return self._cipher.decryptBlock(block);
	};

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(64);
	function getBlock(self) {
	  self._prev = self._cipher.encryptBlock(self._prev);
	  return self._prev;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(85);
	var Transform = __webpack_require__(86);
	var inherits = __webpack_require__(13);
	
	inherits(StreamCipher, Transform);
	module.exports = StreamCipher;
	function StreamCipher(mode, key, iv, decrypt) {
	  if (!(this instanceof StreamCipher)) {
	    return new StreamCipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  this._cache = new Buffer('');
	  this._secCache = new Buffer('');
	  this._decrypt = decrypt;
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	StreamCipher.prototype._transform = function (chunk, _, next) {
	  next(null, this._mode.encrypt(this, chunk, this._decrypt));
	};
	StreamCipher.prototype._flush = function (next) {
	  this._cipher.scrub();
	  next();
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var emptyObject = __webpack_require__(42);
	var _invariant = __webpack_require__(3);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(513)
	
	var md5 = toConstructor(__webpack_require__(348))
	var rmd160 = toConstructor(__webpack_require__(509))
	
	function toConstructor (fn) {
	  return function () {
	    var buffers = []
	    var m= {
	      update: function (data, enc) {
	        if(!Buffer.isBuffer(data)) data = new Buffer(data, enc)
	        buffers.push(data)
	        return this
	      },
	      digest: function (enc) {
	        var buf = Buffer.concat(buffers)
	        var r = fn(buf)
	        buffers = null
	        return enc ? r.toString(enc) : r
	      }
	    }
	    return m
	  }
	}
	
	module.exports = function (alg) {
	  if('md5' === alg) return new md5()
	  if('rmd160' === alg) return new rmd160()
	  return createHash(alg)
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(351);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = ({"NODE_ENV":"production","PUBLIC_URL":"."}).DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(18);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 159 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 160 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(381);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 162 */
/***/ function(module, exports) {

	exports.endianness = function () { return 'LE' };
	
	exports.hostname = function () {
	    if (typeof location !== 'undefined') {
	        return location.hostname
	    }
	    else return '';
	};
	
	exports.loadavg = function () { return [] };
	
	exports.uptime = function () { return 0 };
	
	exports.freemem = function () {
	    return Number.MAX_VALUE;
	};
	
	exports.totalmem = function () {
	    return Number.MAX_VALUE;
	};
	
	exports.cpus = function () { return [] };
	
	exports.type = function () { return 'Browser' };
	
	exports.release = function () {
	    if (typeof navigator !== 'undefined') {
	        return navigator.appVersion;
	    }
	    return '';
	};
	
	exports.networkInterfaces
	= exports.getNetworkInterfaces
	= function () { return {} };
	
	exports.arch = function () { return 'javascript' };
	
	exports.platform = function () { return 'browser' };
	
	exports.tmpdir = exports.tmpDir = function () {
	    return '/tmp';
	};
	
	exports.EOL = '\n';


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(232);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(394);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 165 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 166 */
/***/ function(module, exports) {

	module.exports = "// Copyright (c) Microsoft. All rights reserved.\n// Licensed under the MIT license. \n// To get started please visit https://microsoft.github.io/azure-iot-developer-kit/docs/projects/shake-shake/?utm_source=ArduinoExtension&utm_medium=ReleaseNote&utm_campaign=VSCode\n#include \"AZ3166WiFi.h\"\n#include \"AzureIotHub.h\"\n#include \"IoTHubMQTTClient.h\"\n#include \"OledDisplay.h\"\n#include \"Sensor.h\"\n#include \"ShakeUI.h\"\n#include \"SystemTickCounter.h\"\n\n#define RGB_LED_BRIGHTNESS  32\n#define LOOP_DELAY          100\n\n#define HEARTBEAT_INTERVAL  300000\n#define PULL_TIMEOUT        15000\n\n#define MSG_HEADER_SIZE     20\n#define MSG_BODY_SIZE       200\n\n#define SCROLL_OFFSET       16\n\nstatic const char* iot_event = \"{\\\"topic\\\":\\\"iot\\\"}\"; // The #hashtag is 'iot' here, you can change to other keyword you want\nstatic const char* iot_event_heartbeat = \"{\\\"topic\\\":\\\"\\\"}\";  // Empty for heart beat\n\n// Application running status\n// 0 - idle\n// 1 - shaking\n// 2 - do work\nstatic int app_status;\n\n// Peripherals \nstatic DevI2C *ext_i2c;\nstatic LSM6DSLSensor *acc_gyro;\nstatic RGB_LED rgbLed;\n\n// Tweet message\nstatic char msgHeader[MSG_HEADER_SIZE];\nstatic char msgBody[MSG_BODY_SIZE];\nstatic int msgStart = 0;\n\n// Indicate whether WiFi is ready\nstatic bool hasWifi = false;\n\n// Time interval check for heart beat\nstatic uint64_t hb_interval_ms;\n// Time interval check for retrieving the tweet\nstatic uint64_t tweet_timeout_ms;\n\n// Shake shake processing status\n// 0 - Not start\n// 1 - Shaked and sending message to IoT hub\n// 2 - Message has been sent to IoT hub (get confirmed)\n// 3 - Got the tweet message, sometime it's empty\n// 4 - The tweet is OK and show it on the screen\nstatic int shake_progress;\n\n//////////////////////////////////////////////////////////////////////////////////////////////////////////\n// Utilities\nstatic char PrintableChar(char c)\n{\n  return (c >= 0x20 and c != 0x7f) ? c : '?';  \n}\n\nstatic void ScrollTweet()\n{\n  if (msgBody[0] == 0)\n  {\n    return;\n  }\n  \n  if (msgStart < 0)\n  {\n    // First time\n    DrawAppTitle(msgHeader);\n    msgStart = 0;\n  }\n  else\n  {\n    msgStart += SCROLL_OFFSET;\n    if (msgStart >= strlen(msgBody))\n    {\n        msgStart = 0;\n    }\n  }\n        \n  // Clean the msg screen\n  Screen.print(1, \" \");\n  Screen.print(2, \" \");\n  Screen.print(3, \" \");\n  // Update it\n  Screen.print(1, &msgBody[msgStart], true);\n}\n\nstatic void InitWiFi()\n{\n  Screen.clean();\n  DrawAppTitle(\"IoT DevKit\");\n  Screen.print(2, \"Connecting...\");\n  \n  if (WiFi.begin() == WL_CONNECTED)\n  {\n    IPAddress ip = WiFi.localIP();\n    Screen.print(1, ip.get_address());\n    hasWifi = true;\n    Screen.print(2, \"Running... \\r\\n\");\n  }\n  else\n  {\n    hasWifi = false;\n    Screen.print(1, \"No Wi-Fi\\r\\n \");\n  }\n}\n\nstatic void HeartBeat()\n{\n  if ((int)(SystemTickCounterRead() - hb_interval_ms) < HEARTBEAT_INTERVAL)\n  {\n    return;\n  }\n\n  Serial.println(\">>Heartbeat<<\");\n\n  DigitalOut LedUser(LED_BUILTIN);\n  LedUser = 1;\n  // Send heart beat message\n  IoTHubMQTT_SendEvent(iot_event_heartbeat);\n  LedUser = 0;\n  \n  // Reset\n  hb_interval_ms = SystemTickCounterRead();\n}\n\nstatic bool ParseTweet(const char *tweet, int lenTweet)\n{\n  if (lenTweet == 0)\n  {\n    msgHeader[0] = 0;\n    msgBody[0] = 0;\n    return false;\n  }\n  \n  // Split into header and body\n  int i = 0;\n  int j = 0;\n  // The header\n  for (; i < min(lenTweet, sizeof(msgHeader)); i++)\n  {\n      if(tweet[i] == '\\n')\n      {\n          break;\n      }\n      msgHeader[j++] = PrintableChar(tweet[i]);\n  }\n  msgHeader[j] = 0;\n  Serial.println(msgHeader);\n  if (strcmp(msgHeader, \"No new tweet.\") == 0)\n  {\n    // Not a tweet from Twitter, there must be something wrong on the Service side.\n    msgHeader[0] = 0;\n    msgBody[0] = 0;\n    return false;\n  }\n  else\n  {\n    // The body\n    j = 0;\n    for (; i < min(lenTweet, sizeof(msgHeader) + sizeof(msgBody)); i++)\n    {\n      if (tweet[i] != '\\r' && tweet[i] != '\\n')\n      {\n        msgBody[j++] = PrintableChar(tweet[i]);\n      }\n    }\n    msgBody[j] = 0;\n    Serial.println(msgBody);\n    return true;\n  }\n}\n\nstatic void ShowShakeProgress()\n{\n  if (shake_progress == 1)\n  {\n    DrawAppTitle(\"Processing...\");\n    Screen.print(1, \"   DevKit\");\n    Screen.print(2, \"   Azure\");\n    Screen.print(3, \"   Twitter\");\n  }\n\n  DrawCheckBox(1, 0, (shake_progress >= 1) ? 1 : 0);\n  DrawCheckBox(2, 0, (shake_progress >= 2) ? 1 : 0);\n  DrawCheckBox(3, 0, (shake_progress == 4) ? 1 : 0);\n  \n  delay(500);\n}\n\nstatic void NoTweets()\n{\n  Screen.clean();\n  if (WiFi.status() == WL_CONNECTED)\n  {\n    DrawAppTitle(\"No tweets...\");\n  }\n  else\n  {\n    DrawAppTitle(\"No Wi-Fi...\");\n  }\n  Screen.print(3, \"Press A to Shake!\");\n  DrawTweetImage(1, 20, 0);\n\n  // Turn off the RGB LED\n  rgbLed.setColor(0, 0, 0);\n\n  // Log the shake failed message\n  LogShakeResult(\"ShakeShakeFailed\");\n  \n  // Switch back to idle mode\n  app_status = 0;\n}\n\nstatic void LogShakeResult(const char* result)\n{\n  char sz[32];\n  sprintf(sz, \"progress-%d\", shake_progress);\n  LogTrace(result, sz);\n}\n\n//////////////////////////////////////////////////////////////////////////////////////////////////////////\n// Callback functions\nstatic void TwitterMessageCallback(const char *tweet, int lenTweet)\n{\n  if (app_status != 2 || tweet == NULL)\n  {\n    // Return if not under do work mode or the tweet is empty.\n    return;\n  }\n\n  if (ParseTweet(tweet, lenTweet))\n  {\n    // The tweet message is OK\n    shake_progress = 4;\n  }\n  else\n  {\n    // Got message from Azure, but not a tweet from Twitter.\n    // There must be something wrong on the Service side.\n    shake_progress = 3;\n  }\n}\n\n//////////////////////////////////////////////////////////////////////////////////////////////////////////\n// Actions\nstatic void DoIdle()\n{\n    if (digitalRead(USER_BUTTON_A) == LOW)\n    {\n      // Enter Shake mode\n      app_status = 1;\n      \n      msgHeader[0] = 0;\n      msgBody[0] = 0;\n      shake_progress = 0;\n\n      // Set the RGB LED to green\n      rgbLed.setColor(0, RGB_LED_BRIGHTNESS, 0);\n\n      Screen.clean();\n      DrawAppTitle(\"Shake Shake!\");\n\n      acc_gyro->resetStepCounter();\n    }\n    else if (digitalRead(USER_BUTTON_B) == LOW)\n    {\n      // Show / scroll the tweet\n      ScrollTweet();\n    }\n    \n    // Heart beat\n    HeartBeat();\n    \n    // Check with the IoT hub\n    IoTHubMQTT_Check();\n}\n\nstatic void DoShake()\n{\n  int steps = 0;\n  acc_gyro->getStepCounter(&steps);\n  if (steps > 2)\n  {\n    // Enter the do work mode\n    app_status = 2;\n    // Shake detected\n    shake_progress = 1;\n\n    // LED\n    DigitalOut LedUser(LED_BUILTIN);\n    LedUser = 1;\n    // Set RGB LED to red\n    rgbLed.setColor(RGB_LED_BRIGHTNESS, 0, 0);\n    // Update the screen\n    ShowShakeProgress();\n    // Send to IoT hub\n    if (IoTHubMQTT_SendEvent(iot_event))\n    {\n      if (shake_progress < 2)\n      {\n        // Because the tweet may return quickly and the TwitterMessageCallback be executed before run to here,\n        // So check the shake_progress to avoid set the wrong value.\n        // IoT hub has got the message\n        shake_progress = 2;\n      }\n      // Update the screen\n      ShowShakeProgress();\n      // Start retrieving tweet timeout clock\n      tweet_timeout_ms = SystemTickCounterRead();\n    }\n    else\n    {\n      // Failed to send message to IoT hub\n      NoTweets();\n    }\n    LedUser = 0;\n  }\n  else\n  {\n    // Draw the animation\n    DrawShakeAnimation();\n  }\n}\n\nstatic void DoWork()\n{\n  if ((int)(SystemTickCounterRead() - tweet_timeout_ms) >= PULL_TIMEOUT)\n  {\n    // Timeout\n    NoTweets();\n  }\n  // Check with the IoT hub\n  IoTHubMQTT_Check();\n\n  if (shake_progress > 2)\n  {\n    // Got the tweet message\n    // Update the progress\n    ShowShakeProgress();\n\n    if (shake_progress == 4)\n    {\n      Screen.clean();\n      // Got the tweet\n      // Show the action UI and let user to choose read or shake again\n      DrawAppTitle(\"New tweet!\");\n      Screen.print(3, \"Press B to read!\");\n      DrawTweetImage(1, 20, 1);\n\n      // Prepare for reading and scrolling\n      msgStart = -SCROLL_OFFSET;\n\n      // Set RGB LED to blue, means for reading\n      rgbLed.setColor(0, 0, RGB_LED_BRIGHTNESS);\n      // Switch back to idle mode\n      app_status = 0;\n\n      // Log shake succeed message\n      LogShakeResult(\"ShakeShakeSucceed\");\n    }\n    else\n    {\n      // No tweet\n      NoTweets();\n    }\n  }\n}\n\n//////////////////////////////////////////////////////////////////////////////////////////////////////////\n// Arduino sketch\nvoid setup()\n{\n  msgHeader[0] = 0;\n  msgBody[0] = 0;\n  app_status = 0;\n  shake_progress = 0;\n  \n  Screen.init();\n  DrawAppTitle(\"IoT DevKit\");\n  Screen.print(2, \"Initializing...\");\n  \n  Screen.print(3, \" > Serial\");\n  Serial.begin(115200);\n  \n  // Initialize the WiFi module\n  Screen.print(3, \" > WiFi\");\n  hasWifi = false;\n  InitWiFi();\n  if (!hasWifi)\n  {\n    return;\n  }\n  \n  LogShakeResult(\"ShakeShakeSetup\");\n    \n  // Initialize LEDs\n  Screen.print(3, \" > LEDs\");\n  rgbLed.turnOff();\n  \n  // Initialize button\n  Screen.print(3, \" > Button\");\n  pinMode(USER_BUTTON_A, INPUT);\n  pinMode(USER_BUTTON_B, INPUT);\n  pinMode(LED_BUILTIN, OUTPUT);\n  \n  // Initialize the motion sensor\n  Screen.print(3, \" > Motion sensor     \");\n  ext_i2c = new DevI2C(D14, D15);\n  acc_gyro = new LSM6DSLSensor(*ext_i2c, D4, D5);\n  acc_gyro->init(NULL); \n  acc_gyro->enableAccelerator();\n  acc_gyro->enableGyroscope();\n  acc_gyro->enablePedometer();\n  acc_gyro->setPedometerThreshold(LSM6DSL_PEDOMETER_THRESHOLD_MID_LOW);\n\n  Screen.print(3, \" > IoT Hub\");\n  \n  IoTHubMQTT_Init();\n  IoTHubMQTT_SetMessageCallback(TwitterMessageCallback);\n  \n  rgbLed.setColor(RGB_LED_BRIGHTNESS, 0, 0);\n  hb_interval_ms = -(HEARTBEAT_INTERVAL);   // Trigger heart beat immediately\n  HeartBeat();\n  rgbLed.setColor(0, 0, 0);\n  \n  Screen.print(2, \"Press A to Shake!\");\n  Screen.print(3, \" \");\n}\n\nvoid loop()\n{\n  if (hasWifi)\n  {\n    switch(app_status)\n    {\n      case 0:\n        DoIdle();\n        break;\n      \n      case 1:\n        DoShake();\n        break;\n        \n      case 2:\n        DoWork();\n        break;\n    }\n  }\n\n  delay(LOOP_DELAY);\n}\n"

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(425);


/***/ },
/* 168 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(38);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(45);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactInstrumentation = __webpack_require__(22);
	
	var quoteAttributeValueForBrowser = __webpack_require__(472);
	var warning = __webpack_require__(5);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 171 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var LinkedValueUtils = __webpack_require__(99);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactUpdates = __webpack_require__(23);
	
	var warning = __webpack_require__(5);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 173 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 174 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(3);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(433);
	
	var containsNode = __webpack_require__(356);
	var focusNode = __webpack_require__(159);
	var getActiveElement = __webpack_require__(160);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var DOMLazyTree = __webpack_require__(44);
	var DOMProperty = __webpack_require__(45);
	var React = __webpack_require__(40);
	var ReactBrowserEventEmitter = __webpack_require__(66);
	var ReactCurrentOwner = __webpack_require__(29);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactDOMContainerInfo = __webpack_require__(427);
	var ReactDOMFeatureFlags = __webpack_require__(429);
	var ReactFeatureFlags = __webpack_require__(174);
	var ReactInstanceMap = __webpack_require__(46);
	var ReactInstrumentation = __webpack_require__(22);
	var ReactMarkupChecksum = __webpack_require__(443);
	var ReactReconciler = __webpack_require__(47);
	var ReactUpdateQueue = __webpack_require__(102);
	var ReactUpdates = __webpack_require__(23);
	
	var emptyObject = __webpack_require__(42);
	var instantiateReactComponent = __webpack_require__(186);
	var invariant = __webpack_require__(3);
	var setInnerHTML = __webpack_require__(70);
	var shouldUpdateReactComponent = __webpack_require__(108);
	var warning = __webpack_require__(5);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactComponentEnvironment = __webpack_require__(100);
	var ReactInstanceMap = __webpack_require__(46);
	var ReactInstrumentation = __webpack_require__(22);
	
	var ReactCurrentOwner = __webpack_require__(29);
	var ReactReconciler = __webpack_require__(47);
	var ReactChildReconciler = __webpack_require__(422);
	
	var emptyFunction = __webpack_require__(18);
	var flattenChildren = __webpack_require__(467);
	var invariant = __webpack_require__(3);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var React = __webpack_require__(40);
	
	var invariant = __webpack_require__(3);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 180 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 182 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(179);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(17);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(11);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(7);
	
	var ReactCompositeComponent = __webpack_require__(424);
	var ReactEmptyComponent = __webpack_require__(173);
	var ReactHostComponent = __webpack_require__(175);
	
	var getNextDebugID = __webpack_require__(497);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 187 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(17);
	var escapeTextContentForBrowser = __webpack_require__(69);
	var setInnerHTML = __webpack_require__(70);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactCurrentOwner = __webpack_require__(29);
	var REACT_ELEMENT_TYPE = __webpack_require__(439);
	
	var getIteratorFn = __webpack_require__(469);
	var invariant = __webpack_require__(3);
	var KeyEscapeUtils = __webpack_require__(98);
	var warning = __webpack_require__(5);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = connectAdvanced;
	
	var _hoistNonReactStatics = __webpack_require__(367);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(369);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(9);
	
	var _Subscription = __webpack_require__(487);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _PropTypes = __webpack_require__(192);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	function noop() {}
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$getDisplayName = _ref.getDisplayName,
	      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName,
	      _ref$methodName = _ref.methodName,
	      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
	      _ref$renderCountProp = _ref.renderCountProp,
	      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
	      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
	      _ref$storeKey = _ref.storeKey,
	      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
	      _ref$withRef = _ref.withRef,
	      withRef = _ref$withRef === undefined ? false : _ref$withRef,
	      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return;
	
	        // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription2.default(this.store, parentSub, this.onStateChange.bind(this));
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      Connect.prototype.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	          this.initSubscription();
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = __webpack_require__(193);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    // allow detectFactoryAndVerify to get ownProps
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = undefined;
	
	var _propTypes = __webpack_require__(54);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscriptionShape = exports.subscriptionShape = _propTypes2.default.shape({
	  trySubscribe: _propTypes2.default.func.isRequired,
	  tryUnsubscribe: _propTypes2.default.func.isRequired,
	  notifyNestedSubs: _propTypes2.default.func.isRequired,
	  isSubscribed: _propTypes2.default.func.isRequired
	});
	
	var storeShape = exports.storeShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	});

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = __webpack_require__(91);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(110);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject2.default)(value)) {
	    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(58),
	    _assign = __webpack_require__(7);
	
	var ReactNoopUpdateQueue = __webpack_require__(197);
	
	var canDefineProperty = __webpack_require__(198);
	var emptyObject = __webpack_require__(42);
	var invariant = __webpack_require__(3);
	var lowPriorityWarning = __webpack_require__(498);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(58);
	
	var ReactCurrentOwner = __webpack_require__(29);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 196 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(5);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(111);
	
	/*<replacement>*/
	var util = __webpack_require__(24);
	util.inherits = __webpack_require__(13);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	module.exports = Readable;
	
	/*<replacement>*/
	var processNextTick = __webpack_require__(93);
	/*</replacement>*/
	
	/*<replacement>*/
	var isArray = __webpack_require__(90);
	/*</replacement>*/
	
	/*<replacement>*/
	var Buffer = __webpack_require__(2).Buffer;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	var EE = __webpack_require__(14);
	
	/*<replacement>*/
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream;
	(function () {
	  try {
	    Stream = __webpack_require__(20);
	  } catch (_) {} finally {
	    if (!Stream) Stream = __webpack_require__(14).EventEmitter;
	  }
	})();
	/*</replacement>*/
	
	var Buffer = __webpack_require__(2).Buffer;
	
	/*<replacement>*/
	var util = __webpack_require__(24);
	util.inherits = __webpack_require__(13);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(596);
	var debug = undefined;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var Duplex;
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(41);
	
	  options = options || {};
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = ~ ~this.highWaterMark;
	
	  this.buffer = [];
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // when piping, we only care about 'readable' events that happen
	  // after read()ing all the bytes and not getting any pushback.
	  this.ranOut = false;
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(115).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	var Duplex;
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(41);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options && typeof options.read === 'function') this._read = options.read;
	
	  Stream.call(this);
	}
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	
	  if (!state.objectMode && typeof chunk === 'string') {
	    encoding = encoding || state.defaultEncoding;
	    if (encoding !== state.encoding) {
	      chunk = new Buffer(chunk, encoding);
	      encoding = '';
	    }
	  }
	
	  return readableAddChunk(this, state, chunk, encoding, false);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  var state = this._readableState;
	  return readableAddChunk(this, state, chunk, '', true);
	};
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	function readableAddChunk(stream, state, chunk, encoding, addToFront) {
	  var er = chunkInvalid(state, chunk);
	  if (er) {
	    stream.emit('error', er);
	  } else if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else if (state.objectMode || chunk && chunk.length > 0) {
	    if (state.ended && !addToFront) {
	      var e = new Error('stream.push() after EOF');
	      stream.emit('error', e);
	    } else if (state.endEmitted && addToFront) {
	      var e = new Error('stream.unshift() after end event');
	      stream.emit('error', e);
	    } else {
	      var skipAdd;
	      if (state.decoder && !addToFront && !encoding) {
	        chunk = state.decoder.write(chunk);
	        skipAdd = !state.objectMode && chunk.length === 0;
	      }
	
	      if (!addToFront) state.reading = false;
	
	      // Don't add to the buffer if we've decoded to an empty string chunk and
	      // we're not in object mode
	      if (!skipAdd) {
	        // if we want the data now, just emit it.
	        if (state.flowing && state.length === 0 && !state.sync) {
	          stream.emit('data', chunk);
	          stream.read(0);
	        } else {
	          // update the buffer info.
	          state.length += state.objectMode ? 1 : chunk.length;
	          if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	          if (state.needReadable) emitReadable(stream);
	        }
	      }
	
	      maybeReadMore(stream, state);
	    }
	  } else if (!addToFront) {
	    state.reading = false;
	  }
	
	  return needMoreData(state);
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(115).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	function howMuchToRead(n, state) {
	  if (state.length === 0 && state.ended) return 0;
	
	  if (state.objectMode) return n === 0 ? 0 : 1;
	
	  if (n === null || isNaN(n)) {
	    // only flow one buffer at a time
	    if (state.flowing && state.buffer.length) return state.buffer[0].length;else return state.length;
	  }
	
	  if (n <= 0) return 0;
	
	  // If we're asking for more than the target buffer level,
	  // then raise the water mark.  Bump up to the next highest
	  // power of 2, to prevent increasing it excessively in tiny
	  // amounts.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	
	  // don't have that much.  return null, unless we've ended.
	  if (n > state.length) {
	    if (!state.ended) {
	      state.needReadable = true;
	      return 0;
	    } else {
	      return state.length;
	    }
	  }
	
	  return n;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (typeof n !== 'number' || n > 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  }
	
	  if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	  }
	
	  // If _read pushed data synchronously, then `reading` will be false,
	  // and we need to re-evaluate how much data we can return to the user.
	  if (doRead && !state.reading) n = howMuchToRead(nOrig, state);
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  }
	
	  state.length -= n;
	
	  // If we have nothing in the buffer, then we want to know
	  // as soon as we *do* get something into the buffer.
	  if (state.length === 0 && !state.ended) state.needReadable = true;
	
	  // If we tried to read() past the EOF, then emit end on the next tick.
	  if (nOrig !== n && state.ended && state.length === 0) endReadable(this);
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function chunkInvalid(state, chunk) {
	  var er = null;
	  if (!Buffer.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== null && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) processNextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    processNextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : cleanup;
	  if (state.endEmitted) processNextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable) {
	    debug('onunpipe');
	    if (readable === src) {
	      cleanup();
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', cleanup);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    var ret = dest.write(chunk);
	    if (false === ret) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      if (state.pipesCount === 1 && state.pipes[0] === dest && src.listenerCount('data') === 1 && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	  // This is a brutally ugly hack to make sure that our error handler
	  // is attached before any userland ones.  NEVER DO THIS.
	  if (!dest._events || !dest._events.error) dest.on('error', onerror);else if (isArray(dest._events.error)) dest._events.error.unshift(onerror);else dest._events.error = [onerror, dest._events.error];
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var _i = 0; _i < len; _i++) {
	      dests[_i].emit('unpipe', this);
	    }return this;
	  }
	
	  // try to find the right one.
	  var i = indexOf(state.pipes, dest);
	  if (i === -1) return this;
	
	  state.pipes.splice(i, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  // If listening to data, and it has not explicitly been paused,
	  // then call resume to start the flow of data on the next tick.
	  if (ev === 'data' && false !== this._readableState.flowing) {
	    this.resume();
	  }
	
	  if (ev === 'readable' && !this._readableState.endEmitted) {
	    var state = this._readableState;
	    if (!state.readableListening) {
	      state.readableListening = true;
	      state.emittedReadable = false;
	      state.needReadable = true;
	      if (!state.reading) {
	        processNextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this, state);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    processNextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  if (state.flowing) {
	    do {
	      var chunk = stream.read();
	    } while (null !== chunk && state.flowing);
	  }
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var state = this._readableState;
	  var paused = false;
	
	  var self = this;
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) self.push(chunk);
	    }
	
	    self.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = self.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  var events = ['error', 'close', 'destroy', 'pause', 'resume'];
	  forEach(events, function (ev) {
	    stream.on(ev, self.emit.bind(self, ev));
	  });
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  self._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return self;
	};
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	function fromList(n, state) {
	  var list = state.buffer;
	  var length = state.length;
	  var stringMode = !!state.decoder;
	  var objectMode = !!state.objectMode;
	  var ret;
	
	  // nothing in the list, definitely empty.
	  if (list.length === 0) return null;
	
	  if (length === 0) ret = null;else if (objectMode) ret = list.shift();else if (!n || n >= length) {
	    // read it all, truncate the array.
	    if (stringMode) ret = list.join('');else if (list.length === 1) ret = list[0];else ret = Buffer.concat(list, length);
	    list.length = 0;
	  } else {
	    // read just some of it.
	    if (n < list[0].length) {
	      // just take a part of the first list item.
	      // slice is the same for buffers and strings.
	      var buf = list[0];
	      ret = buf.slice(0, n);
	      list[0] = buf.slice(n);
	    } else if (n === list[0].length) {
	      // first list is a perfect match
	      ret = list.shift();
	    } else {
	      // complex case.
	      // we have enough to cover it, but it spans past the first buffer.
	      if (stringMode) ret = '';else ret = new Buffer(n);
	
	      var c = 0;
	      for (var i = 0, l = list.length; i < l && c < n; i++) {
	        var buf = list[0];
	        var cpy = Math.min(n - c, buf.length);
	
	        if (stringMode) ret += buf.slice(0, cpy);else buf.copy(ret, c, 0, cpy);
	
	        if (cpy < buf.length) list[0] = buf.slice(cpy);else list.shift();
	
	        c += cpy;
	      }
	    }
	  }
	
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('endReadable called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    processNextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ },
/* 201 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(91);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(520);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 203 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 204 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.fetch = isFunction(global.fetch) && isFunction(global.ReadableStream)
	
	exports.writableStream = isFunction(global.WritableStream)
	
	exports.abortController = isFunction(global.AbortController)
	
	exports.blobConstructor = false
	try {
		new Blob([new ArrayBuffer(1)])
		exports.blobConstructor = true
	} catch (e) {}
	
	// The xhr request to example.com may violate some restrictive CSP configurations,
	// so if we're running in a browser that supports `fetch`, avoid calling getXHR()
	// and assume support for certain features below.
	var xhr
	function getXHR () {
		// Cache the xhr value
		if (xhr !== undefined) return xhr
	
		if (global.XMLHttpRequest) {
			xhr = new global.XMLHttpRequest()
			// If XDomainRequest is available (ie only, where xhr might not work
			// cross domain), use the page location. Otherwise use example.com
			// Note: this doesn't actually make an http request.
			try {
				xhr.open('GET', global.XDomainRequest ? '/' : 'https://example.com')
			} catch(e) {
				xhr = null
			}
		} else {
			// Service workers don't have XHR
			xhr = null
		}
		return xhr
	}
	
	function checkTypeSupport (type) {
		var xhr = getXHR()
		if (!xhr) return false
		try {
			xhr.responseType = type
			return xhr.responseType === type
		} catch (e) {}
		return false
	}
	
	// For some strange reason, Safari 7.0 reports typeof global.ArrayBuffer === 'object'.
	// Safari 7.1 appears to have fixed this bug.
	var haveArrayBuffer = typeof global.ArrayBuffer !== 'undefined'
	var haveSlice = haveArrayBuffer && isFunction(global.ArrayBuffer.prototype.slice)
	
	// If fetch is supported, then arraybuffer will be supported too. Skip calling
	// checkTypeSupport(), since that calls getXHR().
	exports.arraybuffer = exports.fetch || (haveArrayBuffer && checkTypeSupport('arraybuffer'))
	
	// These next two tests unavoidably show warnings in Chrome. Since fetch will always
	// be used if it's available, just return false for these to avoid the warnings.
	exports.msstream = !exports.fetch && haveSlice && checkTypeSupport('ms-stream')
	exports.mozchunkedarraybuffer = !exports.fetch && haveArrayBuffer &&
		checkTypeSupport('moz-chunked-arraybuffer')
	
	// If fetch is supported, then overrideMimeType will be supported too. Skip calling
	// getXHR().
	exports.overrideMimeType = exports.fetch || (getXHR() ? isFunction(getXHR().overrideMimeType) : false)
	
	exports.vbArray = isFunction(global.VBArray)
	
	function isFunction (value) {
		return typeof value === 'function'
	}
	
	xhr = null // Help gc
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, Buffer, global) {var capability = __webpack_require__(204)
	var inherits = __webpack_require__(13)
	var stream = __webpack_require__(211)
	
	var rStates = exports.readyStates = {
		UNSENT: 0,
		OPENED: 1,
		HEADERS_RECEIVED: 2,
		LOADING: 3,
		DONE: 4
	}
	
	var IncomingMessage = exports.IncomingMessage = function (xhr, response, mode) {
		var self = this
		stream.Readable.call(self)
	
		self._mode = mode
		self.headers = {}
		self.rawHeaders = []
		self.trailers = {}
		self.rawTrailers = []
	
		// Fake the 'close' event, but only once 'end' fires
		self.on('end', function () {
			// The nextTick is necessary to prevent the 'request' module from causing an infinite loop
			process.nextTick(function () {
				self.emit('close')
			})
		})
	
		if (mode === 'fetch') {
			self._fetchResponse = response
	
			self.url = response.url
			self.statusCode = response.status
			self.statusMessage = response.statusText
			
			response.headers.forEach(function (header, key){
				self.headers[key.toLowerCase()] = header
				self.rawHeaders.push(key, header)
			})
	
			if (capability.writableStream) {
				var writable = new WritableStream({
					write: function (chunk) {
						return new Promise(function (resolve, reject) {
							if (self._destroyed) {
								return
							} else if(self.push(new Buffer(chunk))) {
								resolve()
							} else {
								self._resumeFetch = resolve
							}
						})
					},
					close: function () {
						if (!self._destroyed)
							self.push(null)
					},
					abort: function (err) {
						if (!self._destroyed)
							self.emit('error', err)
					}
				})
	
				try {
					response.body.pipeTo(writable)
					return
				} catch (e) {} // pipeTo method isn't defined. Can't find a better way to feature test this
			}
			// fallback for when writableStream or pipeTo aren't available
			var reader = response.body.getReader()
			function read () {
				reader.read().then(function (result) {
					if (self._destroyed)
						return
					if (result.done) {
						self.push(null)
						return
					}
					self.push(new Buffer(result.value))
					read()
				}).catch(function(err) {
					if (!self._destroyed)
						self.emit('error', err)
				})
			}
			read()
		} else {
			self._xhr = xhr
			self._pos = 0
	
			self.url = xhr.responseURL
			self.statusCode = xhr.status
			self.statusMessage = xhr.statusText
			var headers = xhr.getAllResponseHeaders().split(/\r?\n/)
			headers.forEach(function (header) {
				var matches = header.match(/^([^:]+):\s*(.*)/)
				if (matches) {
					var key = matches[1].toLowerCase()
					if (key === 'set-cookie') {
						if (self.headers[key] === undefined) {
							self.headers[key] = []
						}
						self.headers[key].push(matches[2])
					} else if (self.headers[key] !== undefined) {
						self.headers[key] += ', ' + matches[2]
					} else {
						self.headers[key] = matches[2]
					}
					self.rawHeaders.push(matches[1], matches[2])
				}
			})
	
			self._charset = 'x-user-defined'
			if (!capability.overrideMimeType) {
				var mimeType = self.rawHeaders['mime-type']
				if (mimeType) {
					var charsetMatch = mimeType.match(/;\s*charset=([^;])(;|$)/)
					if (charsetMatch) {
						self._charset = charsetMatch[1].toLowerCase()
					}
				}
				if (!self._charset)
					self._charset = 'utf-8' // best guess
			}
		}
	}
	
	inherits(IncomingMessage, stream.Readable)
	
	IncomingMessage.prototype._read = function () {
		var self = this
	
		var resolve = self._resumeFetch
		if (resolve) {
			self._resumeFetch = null
			resolve()
		}
	}
	
	IncomingMessage.prototype._onXHRProgress = function () {
		var self = this
	
		var xhr = self._xhr
	
		var response = null
		switch (self._mode) {
			case 'text:vbarray': // For IE9
				if (xhr.readyState !== rStates.DONE)
					break
				try {
					// This fails in IE8
					response = new global.VBArray(xhr.responseBody).toArray()
				} catch (e) {}
				if (response !== null) {
					self.push(new Buffer(response))
					break
				}
				// Falls through in IE8	
			case 'text':
				try { // This will fail when readyState = 3 in IE9. Switch mode and wait for readyState = 4
					response = xhr.responseText
				} catch (e) {
					self._mode = 'text:vbarray'
					break
				}
				if (response.length > self._pos) {
					var newData = response.substr(self._pos)
					if (self._charset === 'x-user-defined') {
						var buffer = new Buffer(newData.length)
						for (var i = 0; i < newData.length; i++)
							buffer[i] = newData.charCodeAt(i) & 0xff
	
						self.push(buffer)
					} else {
						self.push(newData, self._charset)
					}
					self._pos = response.length
				}
				break
			case 'arraybuffer':
				if (xhr.readyState !== rStates.DONE || !xhr.response)
					break
				response = xhr.response
				self.push(new Buffer(new Uint8Array(response)))
				break
			case 'moz-chunked-arraybuffer': // take whole
				response = xhr.response
				if (xhr.readyState !== rStates.LOADING || !response)
					break
				self.push(new Buffer(new Uint8Array(response)))
				break
			case 'ms-stream':
				response = xhr.response
				if (xhr.readyState !== rStates.LOADING)
					break
				var reader = new global.MSStreamReader()
				reader.onprogress = function () {
					if (reader.result.byteLength > self._pos) {
						self.push(new Buffer(new Uint8Array(reader.result.slice(self._pos))))
						self._pos = reader.result.byteLength
					}
				}
				reader.onload = function () {
					self.push(null)
				}
				// reader.onerror = ??? // TODO: this
				reader.readAsArrayBuffer(response)
				break
		}
	
		// The ms-stream case handles end separately in reader.onload()
		if (self._xhr.readyState === rStates.DONE && self._mode !== 'ms-stream') {
			self.push(null)
		}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(2).Buffer, (function() { return this; }())))

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(71);
	/*</replacement>*/
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(90);
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	/*<replacement>*/
	var EE = __webpack_require__(14).EventEmitter;
	
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(210);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(59).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	/*<replacement>*/
	var util = __webpack_require__(24);
	util.inherits = __webpack_require__(13);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(597);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var BufferList = __webpack_require__(519);
	var destroyImpl = __webpack_require__(209);
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
	
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
	
	  // This is a hack to make sure that our error handler is attached before any
	  // userland ones.  NEVER DO THIS. This is here only because this code needs
	  // to continue to work with older versions of Node.js that do not include
	  // the prependListener() method. The goal is to eventually remove this hack.
	  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	}
	
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(49);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var readableHwm = options.readableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(212).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(49);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }
	
	  Stream.call(this);
	}
	
	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});
	
	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;
	
	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }
	
	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};
	
	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }
	
	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }
	
	  return needMoreData(state);
	}
	
	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}
	
	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(212).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (n !== 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }
	
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;
	
	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    pna.nextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	
	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, unpipeInfo);
	    }return this;
	  }
	
	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this, unpipeInfo);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        pna.nextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    pna.nextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var _this = this;
	
	  var state = this._readableState;
	  var paused = false;
	
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) _this.push(chunk);
	    }
	
	    _this.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = _this.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
	  }
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  this._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return this;
	};
	
	Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._readableState.highWaterMark;
	  }
	});
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }
	
	  return ret;
	}
	
	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}
	
	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    pna.nextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(10)))

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(49);
	
	/*<replacement>*/
	var util = __webpack_require__(24);
	util.inherits = __webpack_require__(13);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function afterTransform(er, data) {
	  var ts = this._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) {
	    return this.emit('error', new Error('write callback called multiple times'));
	  }
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    this.push(data);
	
	  cb(er);
	
	  var rs = this._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    this._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = {
	    afterTransform: afterTransform.bind(this),
	    needTransform: false,
	    transforming: false,
	    writecb: null,
	    writechunk: null,
	    writeencoding: null
	  };
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  // When the writable side finishes, then flush out anything remaining.
	  this.on('prefinish', prefinish);
	}
	
	function prefinish() {
	  var _this = this;
	
	  if (typeof this._flush === 'function') {
	    this._flush(function (er, data) {
	      done(_this, er, data);
	    });
	  } else {
	    done(this, null, null);
	  }
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	Transform.prototype._destroy = function (err, cb) {
	  var _this2 = this;
	
	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this2.emit('close');
	  });
	};
	
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    stream.push(data);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
	
	  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(71);
	/*</replacement>*/
	
	module.exports = Writable;
	
	/* <replacement> */
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = __webpack_require__(24);
	util.inherits = __webpack_require__(13);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(214)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(210);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(59).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	var destroyImpl = __webpack_require__(209);
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(49);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var writableHwm = options.writableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // if _final has been called
	  this.finalCalled = false;
	
	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();
	
	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	      if (this !== Writable) return false;
	
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}
	
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(49);
	
	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.
	
	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	
	    if (typeof options.final === 'function') this._final = options.final;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  pna.nextTick(cb, er);
	}
	
	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    pna.nextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = !state.objectMode && _isUint8Array(chunk);
	
	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}
	
	Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	
	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    pna.nextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    pna.nextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	    state.bufferedRequestCount = 0;
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      state.bufferedRequestCount--;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      pna.nextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }
	  if (state.corkedRequestsFree) {
	    state.corkedRequestsFree.next = corkReq;
	  } else {
	    state.corkedRequestsFree = corkReq;
	  }
	}
	
	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function () {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});
	
	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(213).setImmediate, (function() { return this; }())))

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(71);
	/*</replacement>*/
	
	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;
	
	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;
	
	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
	      pna.nextTick(emitErrorNT, this, err);
	    }
	    return this;
	  }
	
	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks
	
	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }
	
	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }
	
	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      pna.nextTick(emitErrorNT, _this, err);
	      if (_this._writableState) {
	        _this._writableState.errorEmitted = true;
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });
	
	  return this;
	}
	
	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }
	
	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}
	
	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}
	
	module.exports = {
	  destroy: destroy,
	  undestroy: undestroy
	};

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(14).EventEmitter;


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(206);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(208);
	exports.Duplex = __webpack_require__(49);
	exports.Transform = __webpack_require__(207);
	exports.PassThrough = __webpack_require__(518);


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(59).Buffer;
	/*</replacement>*/
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte. If an invalid byte is detected, -2 is returned.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return byte >> 6 === 0x02 ? -1 : -2;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd';
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd';
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd';
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character is added when ending on a partial
	// character.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd';
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(511);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 214 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 215 */
/***/ function(module, exports) {

	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex;
	  return bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]];
	}
	
	module.exports = bytesToUuid;


/***/ },
/* 216 */
/***/ function(module, exports) {

	// Unique ID creation requires a high quality random # generator.  In the
	// browser this is a little complicated due to unknown quality of Math.random()
	// and inconsistent support for the `crypto` API.  We do the best we can via
	// feature-detection
	
	// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
	var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues.bind(crypto)) ||
	                      (typeof(msCrypto) != 'undefined' && msCrypto.getRandomValues.bind(msCrypto));
	if (getRandomValues) {
	  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
	
	  module.exports = function whatwgRNG() {
	    getRandomValues(rnds8);
	    return rnds8;
	  };
	} else {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var rnds = new Array(16);
	
	  module.exports = function mathRNG() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return rnds;
	  };
	}


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toDate = __webpack_require__(118);
	
	var _toDate2 = _interopRequireDefault(_toDate);
	
	var _toFloat = __webpack_require__(227);
	
	var _toFloat2 = _interopRequireDefault(_toFloat);
	
	var _toInt = __webpack_require__(587);
	
	var _toInt2 = _interopRequireDefault(_toInt);
	
	var _toBoolean = __webpack_require__(586);
	
	var _toBoolean2 = _interopRequireDefault(_toBoolean);
	
	var _equals = __webpack_require__(538);
	
	var _equals2 = _interopRequireDefault(_equals);
	
	var _contains = __webpack_require__(537);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _matches = __webpack_require__(583);
	
	var _matches2 = _interopRequireDefault(_matches);
	
	var _isEmail = __webpack_require__(552);
	
	var _isEmail2 = _interopRequireDefault(_isEmail);
	
	var _isURL = __webpack_require__(578);
	
	var _isURL2 = _interopRequireDefault(_isURL);
	
	var _isMACAddress = __webpack_require__(568);
	
	var _isMACAddress2 = _interopRequireDefault(_isMACAddress);
	
	var _isIP = __webpack_require__(223);
	
	var _isIP2 = _interopRequireDefault(_isIP);
	
	var _isFQDN = __webpack_require__(117);
	
	var _isFQDN2 = _interopRequireDefault(_isFQDN);
	
	var _isBoolean = __webpack_require__(546);
	
	var _isBoolean2 = _interopRequireDefault(_isBoolean);
	
	var _isAlpha = __webpack_require__(541);
	
	var _isAlpha2 = _interopRequireDefault(_isAlpha);
	
	var _isAlphanumeric = __webpack_require__(542);
	
	var _isAlphanumeric2 = _interopRequireDefault(_isAlphanumeric);
	
	var _isNumeric = __webpack_require__(574);
	
	var _isNumeric2 = _interopRequireDefault(_isNumeric);
	
	var _isPort = __webpack_require__(575);
	
	var _isPort2 = _interopRequireDefault(_isPort);
	
	var _isLowercase = __webpack_require__(567);
	
	var _isLowercase2 = _interopRequireDefault(_isLowercase);
	
	var _isUppercase = __webpack_require__(580);
	
	var _isUppercase2 = _interopRequireDefault(_isUppercase);
	
	var _isAscii = __webpack_require__(543);
	
	var _isAscii2 = _interopRequireDefault(_isAscii);
	
	var _isFullWidth = __webpack_require__(220);
	
	var _isFullWidth2 = _interopRequireDefault(_isFullWidth);
	
	var _isHalfWidth = __webpack_require__(221);
	
	var _isHalfWidth2 = _interopRequireDefault(_isHalfWidth);
	
	var _isVariableWidth = __webpack_require__(581);
	
	var _isVariableWidth2 = _interopRequireDefault(_isVariableWidth);
	
	var _isMultibyte = __webpack_require__(573);
	
	var _isMultibyte2 = _interopRequireDefault(_isMultibyte);
	
	var _isSurrogatePair = __webpack_require__(577);
	
	var _isSurrogatePair2 = _interopRequireDefault(_isSurrogatePair);
	
	var _isInt = __webpack_require__(224);
	
	var _isInt2 = _interopRequireDefault(_isInt);
	
	var _isFloat = __webpack_require__(554);
	
	var _isFloat2 = _interopRequireDefault(_isFloat);
	
	var _isDecimal = __webpack_require__(550);
	
	var _isDecimal2 = _interopRequireDefault(_isDecimal);
	
	var _isHexadecimal = __webpack_require__(222);
	
	var _isHexadecimal2 = _interopRequireDefault(_isHexadecimal);
	
	var _isDivisibleBy = __webpack_require__(551);
	
	var _isDivisibleBy2 = _interopRequireDefault(_isDivisibleBy);
	
	var _isHexColor = __webpack_require__(556);
	
	var _isHexColor2 = _interopRequireDefault(_isHexColor);
	
	var _isISRC = __webpack_require__(561);
	
	var _isISRC2 = _interopRequireDefault(_isISRC);
	
	var _isMD = __webpack_require__(569);
	
	var _isMD2 = _interopRequireDefault(_isMD);
	
	var _isHash = __webpack_require__(555);
	
	var _isHash2 = _interopRequireDefault(_isHash);
	
	var _isJSON = __webpack_require__(564);
	
	var _isJSON2 = _interopRequireDefault(_isJSON);
	
	var _isEmpty = __webpack_require__(553);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _isLength = __webpack_require__(566);
	
	var _isLength2 = _interopRequireDefault(_isLength);
	
	var _isByteLength = __webpack_require__(219);
	
	var _isByteLength2 = _interopRequireDefault(_isByteLength);
	
	var _isUUID = __webpack_require__(579);
	
	var _isUUID2 = _interopRequireDefault(_isUUID);
	
	var _isMongoId = __webpack_require__(572);
	
	var _isMongoId2 = _interopRequireDefault(_isMongoId);
	
	var _isAfter = __webpack_require__(540);
	
	var _isAfter2 = _interopRequireDefault(_isAfter);
	
	var _isBefore = __webpack_require__(545);
	
	var _isBefore2 = _interopRequireDefault(_isBefore);
	
	var _isIn = __webpack_require__(563);
	
	var _isIn2 = _interopRequireDefault(_isIn);
	
	var _isCreditCard = __webpack_require__(547);
	
	var _isCreditCard2 = _interopRequireDefault(_isCreditCard);
	
	var _isISIN = __webpack_require__(558);
	
	var _isISIN2 = _interopRequireDefault(_isISIN);
	
	var _isISBN = __webpack_require__(557);
	
	var _isISBN2 = _interopRequireDefault(_isISBN);
	
	var _isISSN = __webpack_require__(562);
	
	var _isISSN2 = _interopRequireDefault(_isISSN);
	
	var _isMobilePhone = __webpack_require__(571);
	
	var _isMobilePhone2 = _interopRequireDefault(_isMobilePhone);
	
	var _isCurrency = __webpack_require__(548);
	
	var _isCurrency2 = _interopRequireDefault(_isCurrency);
	
	var _isISO = __webpack_require__(560);
	
	var _isISO2 = _interopRequireDefault(_isISO);
	
	var _isISO31661Alpha = __webpack_require__(559);
	
	var _isISO31661Alpha2 = _interopRequireDefault(_isISO31661Alpha);
	
	var _isBase = __webpack_require__(544);
	
	var _isBase2 = _interopRequireDefault(_isBase);
	
	var _isDataURI = __webpack_require__(549);
	
	var _isDataURI2 = _interopRequireDefault(_isDataURI);
	
	var _isMimeType = __webpack_require__(570);
	
	var _isMimeType2 = _interopRequireDefault(_isMimeType);
	
	var _isLatLong = __webpack_require__(565);
	
	var _isLatLong2 = _interopRequireDefault(_isLatLong);
	
	var _isPostalCode = __webpack_require__(576);
	
	var _isPostalCode2 = _interopRequireDefault(_isPostalCode);
	
	var _ltrim = __webpack_require__(225);
	
	var _ltrim2 = _interopRequireDefault(_ltrim);
	
	var _rtrim = __webpack_require__(226);
	
	var _rtrim2 = _interopRequireDefault(_rtrim);
	
	var _trim = __webpack_require__(588);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	var _escape = __webpack_require__(539);
	
	var _escape2 = _interopRequireDefault(_escape);
	
	var _unescape = __webpack_require__(589);
	
	var _unescape2 = _interopRequireDefault(_unescape);
	
	var _stripLow = __webpack_require__(585);
	
	var _stripLow2 = _interopRequireDefault(_stripLow);
	
	var _whitelist = __webpack_require__(590);
	
	var _whitelist2 = _interopRequireDefault(_whitelist);
	
	var _blacklist = __webpack_require__(218);
	
	var _blacklist2 = _interopRequireDefault(_blacklist);
	
	var _isWhitelisted = __webpack_require__(582);
	
	var _isWhitelisted2 = _interopRequireDefault(_isWhitelisted);
	
	var _normalizeEmail = __webpack_require__(584);
	
	var _normalizeEmail2 = _interopRequireDefault(_normalizeEmail);
	
	var _toString = __webpack_require__(119);
	
	var _toString2 = _interopRequireDefault(_toString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var version = '9.4.1';
	
	var validator = {
	  version: version,
	  toDate: _toDate2.default,
	  toFloat: _toFloat2.default,
	  toInt: _toInt2.default,
	  toBoolean: _toBoolean2.default,
	  equals: _equals2.default,
	  contains: _contains2.default,
	  matches: _matches2.default,
	  isEmail: _isEmail2.default,
	  isURL: _isURL2.default,
	  isMACAddress: _isMACAddress2.default,
	  isIP: _isIP2.default,
	  isFQDN: _isFQDN2.default,
	  isBoolean: _isBoolean2.default,
	  isAlpha: _isAlpha2.default,
	  isAlphanumeric: _isAlphanumeric2.default,
	  isNumeric: _isNumeric2.default,
	  isPort: _isPort2.default,
	  isLowercase: _isLowercase2.default,
	  isUppercase: _isUppercase2.default,
	  isAscii: _isAscii2.default,
	  isFullWidth: _isFullWidth2.default,
	  isHalfWidth: _isHalfWidth2.default,
	  isVariableWidth: _isVariableWidth2.default,
	  isMultibyte: _isMultibyte2.default,
	  isSurrogatePair: _isSurrogatePair2.default,
	  isInt: _isInt2.default,
	  isFloat: _isFloat2.default,
	  isDecimal: _isDecimal2.default,
	  isHexadecimal: _isHexadecimal2.default,
	  isDivisibleBy: _isDivisibleBy2.default,
	  isHexColor: _isHexColor2.default,
	  isISRC: _isISRC2.default,
	  isMD5: _isMD2.default,
	  isHash: _isHash2.default,
	  isJSON: _isJSON2.default,
	  isEmpty: _isEmpty2.default,
	  isLength: _isLength2.default,
	  isByteLength: _isByteLength2.default,
	  isUUID: _isUUID2.default,
	  isMongoId: _isMongoId2.default,
	  isAfter: _isAfter2.default,
	  isBefore: _isBefore2.default,
	  isIn: _isIn2.default,
	  isCreditCard: _isCreditCard2.default,
	  isISIN: _isISIN2.default,
	  isISBN: _isISBN2.default,
	  isISSN: _isISSN2.default,
	  isMobilePhone: _isMobilePhone2.default,
	  isPostalCode: _isPostalCode2.default,
	  isCurrency: _isCurrency2.default,
	  isISO8601: _isISO2.default,
	  isISO31661Alpha2: _isISO31661Alpha2.default,
	  isBase64: _isBase2.default,
	  isDataURI: _isDataURI2.default,
	  isMimeType: _isMimeType2.default,
	  isLatLong: _isLatLong2.default,
	  ltrim: _ltrim2.default,
	  rtrim: _rtrim2.default,
	  trim: _trim2.default,
	  escape: _escape2.default,
	  unescape: _unescape2.default,
	  stripLow: _stripLow2.default,
	  whitelist: _whitelist2.default,
	  blacklist: _blacklist2.default,
	  isWhitelisted: _isWhitelisted2.default,
	  normalizeEmail: _normalizeEmail2.default,
	  toString: _toString2.default
	};
	
	exports.default = validator;
	module.exports = exports['default'];

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = blacklist;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function blacklist(str, chars) {
	  (0, _assertString2.default)(str);
	  return str.replace(new RegExp('[' + chars + ']+', 'g'), '');
	}
	module.exports = exports['default'];

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isByteLength;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable prefer-rest-params */
	function isByteLength(str, options) {
	  (0, _assertString2.default)(str);
	  var min = void 0;
	  var max = void 0;
	  if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	    min = options.min || 0;
	    max = options.max;
	  } else {
	    // backwards compatibility: isByteLength(str, min [, max])
	    min = arguments[1];
	    max = arguments[2];
	  }
	  var len = encodeURI(str).split(/%..|./).length - 1;
	  return len >= min && (typeof max === 'undefined' || len <= max);
	}
	module.exports = exports['default'];

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fullWidth = undefined;
	exports.default = isFullWidth;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fullWidth = exports.fullWidth = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
	
	function isFullWidth(str) {
	  (0, _assertString2.default)(str);
	  return fullWidth.test(str);
	}

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.halfWidth = undefined;
	exports.default = isHalfWidth;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var halfWidth = exports.halfWidth = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
	
	function isHalfWidth(str) {
	  (0, _assertString2.default)(str);
	  return halfWidth.test(str);
	}

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isHexadecimal;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hexadecimal = /^[0-9A-F]+$/i;
	
	function isHexadecimal(str) {
	  (0, _assertString2.default)(str);
	  return hexadecimal.test(str);
	}
	module.exports = exports['default'];

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isIP;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ipv4Maybe = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
	var ipv6Block = /^[0-9A-F]{1,4}$/i;
	
	function isIP(str) {
	  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  (0, _assertString2.default)(str);
	  version = String(version);
	  if (!version) {
	    return isIP(str, 4) || isIP(str, 6);
	  } else if (version === '4') {
	    if (!ipv4Maybe.test(str)) {
	      return false;
	    }
	    var parts = str.split('.').sort(function (a, b) {
	      return a - b;
	    });
	    return parts[3] <= 255;
	  } else if (version === '6') {
	    var blocks = str.split(':');
	    var foundOmissionBlock = false; // marker to indicate ::
	
	    // At least some OS accept the last 32 bits of an IPv6 address
	    // (i.e. 2 of the blocks) in IPv4 notation, and RFC 3493 says
	    // that '::ffff:a.b.c.d' is valid for IPv4-mapped IPv6 addresses,
	    // and '::a.b.c.d' is deprecated, but also valid.
	    var foundIPv4TransitionBlock = isIP(blocks[blocks.length - 1], 4);
	    var expectedNumberOfBlocks = foundIPv4TransitionBlock ? 7 : 8;
	
	    if (blocks.length > expectedNumberOfBlocks) {
	      return false;
	    }
	    // initial or final ::
	    if (str === '::') {
	      return true;
	    } else if (str.substr(0, 2) === '::') {
	      blocks.shift();
	      blocks.shift();
	      foundOmissionBlock = true;
	    } else if (str.substr(str.length - 2) === '::') {
	      blocks.pop();
	      blocks.pop();
	      foundOmissionBlock = true;
	    }
	
	    for (var i = 0; i < blocks.length; ++i) {
	      // test for a :: which can not be at the string start/end
	      // since those cases have been handled above
	      if (blocks[i] === '' && i > 0 && i < blocks.length - 1) {
	        if (foundOmissionBlock) {
	          return false; // multiple :: in address
	        }
	        foundOmissionBlock = true;
	      } else if (foundIPv4TransitionBlock && i === blocks.length - 1) {
	        // it has been checked before that the last
	        // block is a valid IPv4 address
	      } else if (!ipv6Block.test(blocks[i])) {
	        return false;
	      }
	    }
	    if (foundOmissionBlock) {
	      return blocks.length >= 1;
	    }
	    return blocks.length === expectedNumberOfBlocks;
	  }
	  return false;
	}
	module.exports = exports['default'];

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isInt;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var int = /^(?:[-+]?(?:0|[1-9][0-9]*))$/;
	var intLeadingZeroes = /^[-+]?[0-9]+$/;
	
	function isInt(str, options) {
	  (0, _assertString2.default)(str);
	  options = options || {};
	
	  // Get the regex to use for testing, based on whether
	  // leading zeroes are allowed or not.
	  var regex = options.hasOwnProperty('allow_leading_zeroes') && !options.allow_leading_zeroes ? int : intLeadingZeroes;
	
	  // Check min/max/lt/gt
	  var minCheckPassed = !options.hasOwnProperty('min') || str >= options.min;
	  var maxCheckPassed = !options.hasOwnProperty('max') || str <= options.max;
	  var ltCheckPassed = !options.hasOwnProperty('lt') || str < options.lt;
	  var gtCheckPassed = !options.hasOwnProperty('gt') || str > options.gt;
	
	  return regex.test(str) && minCheckPassed && maxCheckPassed && ltCheckPassed && gtCheckPassed;
	}
	module.exports = exports['default'];

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ltrim;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ltrim(str, chars) {
	  (0, _assertString2.default)(str);
	  var pattern = chars ? new RegExp('^[' + chars + ']+', 'g') : /^\s+/g;
	  return str.replace(pattern, '');
	}
	module.exports = exports['default'];

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = rtrim;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function rtrim(str, chars) {
	  (0, _assertString2.default)(str);
	  var pattern = chars ? new RegExp('[' + chars + ']') : /\s/;
	
	  var idx = str.length - 1;
	  while (idx >= 0 && pattern.test(str[idx])) {
	    idx--;
	  }
	
	  return idx < str.length ? str.substr(0, idx + 1) : str;
	}
	module.exports = exports['default'];

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toFloat;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toFloat(str) {
	  (0, _assertString2.default)(str);
	  return parseFloat(str);
	}
	module.exports = exports['default'];

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.6.3
	(function() {
	  var events, isEmpty, sax,
	    __hasProp = {}.hasOwnProperty,
	    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	  sax = __webpack_require__(510);
	
	  events = __webpack_require__(14);
	
	  isEmpty = function(thing) {
	    return typeof thing === "object" && (thing != null) && Object.keys(thing).length === 0;
	  };
	
	  exports.defaults = {
	    "0.1": {
	      explicitCharkey: false,
	      trim: true,
	      normalize: true,
	      normalizeTags: false,
	      attrkey: "@",
	      charkey: "#",
	      explicitArray: false,
	      ignoreAttrs: false,
	      mergeAttrs: false,
	      explicitRoot: false,
	      validator: null,
	      xmlns: false,
	      explicitChildren: false,
	      childkey: '@@',
	      charsAsChildren: false,
	      async: false,
	      strict: true
	    },
	    "0.2": {
	      explicitCharkey: false,
	      trim: false,
	      normalize: false,
	      normalizeTags: false,
	      attrkey: "$",
	      charkey: "_",
	      explicitArray: true,
	      ignoreAttrs: false,
	      mergeAttrs: false,
	      explicitRoot: true,
	      validator: null,
	      xmlns: false,
	      explicitChildren: false,
	      childkey: '$$',
	      charsAsChildren: false,
	      async: false,
	      strict: true
	    }
	  };
	
	  exports.ValidationError = (function(_super) {
	    __extends(ValidationError, _super);
	
	    function ValidationError(message) {
	      this.message = message;
	    }
	
	    return ValidationError;
	
	  })(Error);
	
	  exports.Parser = (function(_super) {
	    __extends(Parser, _super);
	
	    function Parser(opts) {
	      this.parseString = __bind(this.parseString, this);
	      this.reset = __bind(this.reset, this);
	      var key, value, _ref;
	      if (!(this instanceof exports.Parser)) {
	        return new exports.Parser(opts);
	      }
	      this.options = {};
	      _ref = exports.defaults["0.2"];
	      for (key in _ref) {
	        if (!__hasProp.call(_ref, key)) continue;
	        value = _ref[key];
	        this.options[key] = value;
	      }
	      for (key in opts) {
	        if (!__hasProp.call(opts, key)) continue;
	        value = opts[key];
	        this.options[key] = value;
	      }
	      if (this.options.xmlns) {
	        this.options.xmlnskey = this.options.attrkey + "ns";
	      }
	      this.reset();
	    }
	
	    Parser.prototype.reset = function() {
	      var attrkey, charkey, err, ontext, stack,
	        _this = this;
	      this.removeAllListeners();
	      this.saxParser = sax.parser(this.options.strict, {
	        trim: false,
	        normalize: false,
	        xmlns: this.options.xmlns
	      });
	      err = false;
	      this.saxParser.onerror = function(error) {
	        if (!err) {
	          err = true;
	          return _this.emit("error", error);
	        }
	      };
	      this.EXPLICIT_CHARKEY = this.options.explicitCharkey;
	      this.resultObject = null;
	      stack = [];
	      attrkey = this.options.attrkey;
	      charkey = this.options.charkey;
	      this.saxParser.onopentag = function(node) {
	        var key, obj, _ref;
	        obj = {};
	        obj[charkey] = "";
	        if (!_this.options.ignoreAttrs) {
	          _ref = node.attributes;
	          for (key in _ref) {
	            if (!__hasProp.call(_ref, key)) continue;
	            if (!(attrkey in obj) && !_this.options.mergeAttrs) {
	              obj[attrkey] = {};
	            }
	            if (_this.options.mergeAttrs) {
	              obj[key] = node.attributes[key];
	            } else {
	              obj[attrkey][key] = node.attributes[key];
	            }
	          }
	        }
	        obj["#name"] = _this.options.normalizeTags ? node.name.toLowerCase() : node.name;
	        if (_this.options.xmlns) {
	          obj[_this.options.xmlnskey] = {
	            uri: node.uri,
	            local: node.local
	          };
	        }
	        return stack.push(obj);
	      };
	      this.saxParser.onclosetag = function() {
	        var cdata, emptyStr, node, nodeName, obj, old, s, xpath;
	        obj = stack.pop();
	        nodeName = obj["#name"];
	        delete obj["#name"];
	        cdata = obj.cdata;
	        delete obj.cdata;
	        s = stack[stack.length - 1];
	        if (obj[charkey].match(/^\s*$/) && !cdata) {
	          emptyStr = obj[charkey];
	          delete obj[charkey];
	        } else {
	          if (_this.options.trim) {
	            obj[charkey] = obj[charkey].trim();
	          }
	          if (_this.options.normalize) {
	            obj[charkey] = obj[charkey].replace(/\s{2,}/g, " ").trim();
	          }
	          if (Object.keys(obj).length === 1 && charkey in obj && !_this.EXPLICIT_CHARKEY) {
	            obj = obj[charkey];
	          }
	        }
	        if (isEmpty(obj)) {
	          obj = _this.options.emptyTag !== void 0 ? _this.options.emptyTag : emptyStr;
	        }
	        if (_this.options.validator != null) {
	          xpath = "/" + ((function() {
	            var _i, _len, _results;
	            _results = [];
	            for (_i = 0, _len = stack.length; _i < _len; _i++) {
	              node = stack[_i];
	              _results.push(node["#name"]);
	            }
	            return _results;
	          })()).concat(nodeName).join("/");
	          try {
	            obj = _this.options.validator(xpath, s && s[nodeName], obj);
	          } catch (_error) {
	            err = _error;
	            _this.emit("error", err);
	          }
	        }
	        if (_this.options.explicitChildren && !_this.options.mergeAttrs && typeof obj === 'object') {
	          node = {};
	          if (_this.options.attrkey in obj) {
	            node[_this.options.attrkey] = obj[_this.options.attrkey];
	            delete obj[_this.options.attrkey];
	          }
	          if (!_this.options.charsAsChildren && _this.options.charkey in obj) {
	            node[_this.options.charkey] = obj[_this.options.charkey];
	            delete obj[_this.options.charkey];
	          }
	          if (Object.getOwnPropertyNames(obj).length > 0) {
	            node[_this.options.childkey] = obj;
	          }
	          obj = node;
	        }
	        if (stack.length > 0) {
	          if (!_this.options.explicitArray) {
	            if (!(nodeName in s)) {
	              return s[nodeName] = obj;
	            } else if (s[nodeName] instanceof Array) {
	              return s[nodeName].push(obj);
	            } else {
	              old = s[nodeName];
	              s[nodeName] = [old];
	              return s[nodeName].push(obj);
	            }
	          } else {
	            if (!(s[nodeName] instanceof Array)) {
	              s[nodeName] = [];
	            }
	            return s[nodeName].push(obj);
	          }
	        } else {
	          if (_this.options.explicitRoot) {
	            old = obj;
	            obj = {};
	            obj[nodeName] = old;
	          }
	          _this.resultObject = obj;
	          return _this.emit("end", _this.resultObject);
	        }
	      };
	      ontext = function(text) {
	        var s;
	        s = stack[stack.length - 1];
	        if (s) {
	          s[charkey] += text;
	          return s;
	        }
	      };
	      this.saxParser.ontext = ontext;
	      return this.saxParser.oncdata = function(text) {
	        var s;
	        s = ontext(text);
	        if (s) {
	          return s.cdata = true;
	        }
	      };
	    };
	
	    Parser.prototype.parseString = function(str, cb) {
	      if ((cb != null) && typeof cb === "function") {
	        this.on("end", function(result) {
	          this.reset();
	          if (this.options.async) {
	            return process.nextTick(function() {
	              return cb(null, result);
	            });
	          } else {
	            return cb(null, result);
	          }
	        });
	        this.on("error", function(err) {
	          this.reset();
	          if (this.options.async) {
	            return process.nextTick(function() {
	              return cb(err);
	            });
	          } else {
	            return cb(err);
	          }
	        });
	      }
	      if (str.toString().trim() === '') {
	        this.emit("end", null);
	        return true;
	      }
	      return this.saxParser.write(str.toString());
	    };
	
	    return Parser;
	
	  })(events.EventEmitter);
	
	  exports.parseString = function(str, a, b) {
	    var cb, options, parser;
	    if (b != null) {
	      if (typeof b === 'function') {
	        cb = b;
	      }
	      if (typeof a === 'object') {
	        options = a;
	      }
	    } else {
	      if (typeof a === 'function') {
	        cb = a;
	      }
	      options = {};
	    }
	    parser = new exports.Parser(options);
	    return parser.parseString(str, cb);
	  };
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.3.3
	(function() {
	  var XMLBuilder, XMLFragment,
	    __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	  XMLFragment = __webpack_require__(592);
	
	  XMLBuilder = (function() {
	
	    function XMLBuilder(name, xmldec, doctype, options) {
	      this.assertLegalChar = __bind(this.assertLegalChar, this);
	
	      var att, child, _ref;
	      this.children = [];
	      this.rootObject = null;
	      if (this.is(name, 'Object')) {
	        _ref = [name, xmldec], xmldec = _ref[0], doctype = _ref[1];
	        name = null;
	      }
	      if (name != null) {
	        name = '' + name || '';
	        if (xmldec == null) {
	          xmldec = {
	            'version': '1.0'
	          };
	        }
	      }
	      this.allowSurrogateChars = options != null ? options.allowSurrogateChars : void 0;
	      if ((xmldec != null) && !(xmldec.version != null)) {
	        throw new Error("Version number is required");
	      }
	      if (xmldec != null) {
	        xmldec.version = '' + xmldec.version || '';
	        if (!xmldec.version.match(/1\.[0-9]+/)) {
	          throw new Error("Invalid version number: " + xmldec.version);
	        }
	        att = {
	          version: xmldec.version
	        };
	        if (xmldec.encoding != null) {
	          xmldec.encoding = '' + xmldec.encoding || '';
	          if (!xmldec.encoding.match(/[A-Za-z](?:[A-Za-z0-9._-]|-)*/)) {
	            throw new Error("Invalid encoding: " + xmldec.encoding);
	          }
	          att.encoding = xmldec.encoding;
	        }
	        if (xmldec.standalone != null) {
	          att.standalone = xmldec.standalone ? "yes" : "no";
	        }
	        child = new XMLFragment(this, '?xml', att);
	        this.children.push(child);
	      }
	      if (doctype != null) {
	        att = {};
	        if (name != null) {
	          att.name = name;
	        }
	        if (doctype.ext != null) {
	          doctype.ext = '' + doctype.ext || '';
	          att.ext = doctype.ext;
	        }
	        child = new XMLFragment(this, '!DOCTYPE', att);
	        this.children.push(child);
	      }
	      if (name != null) {
	        this.begin(name);
	      }
	    }
	
	    XMLBuilder.prototype.begin = function(name, xmldec, doctype) {
	      var doc, root;
	      if (!(name != null)) {
	        throw new Error("Root element needs a name");
	      }
	      if (this.rootObject) {
	        this.children = [];
	        this.rootObject = null;
	      }
	      if (xmldec != null) {
	        doc = new XMLBuilder(name, xmldec, doctype);
	        return doc.root();
	      }
	      name = '' + name || '';
	      root = new XMLFragment(this, name, {});
	      root.isRoot = true;
	      root.documentObject = this;
	      this.children.push(root);
	      this.rootObject = root;
	      return root;
	    };
	
	    XMLBuilder.prototype.root = function() {
	      return this.rootObject;
	    };
	
	    XMLBuilder.prototype.end = function(options) {
	      return toString(options);
	    };
	
	    XMLBuilder.prototype.toString = function(options) {
	      var child, r, _i, _len, _ref;
	      r = '';
	      _ref = this.children;
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        child = _ref[_i];
	        r += child.toString(options);
	      }
	      return r;
	    };
	
	    XMLBuilder.prototype.is = function(obj, type) {
	      var clas;
	      clas = Object.prototype.toString.call(obj).slice(8, -1);
	      return (obj != null) && clas === type;
	    };
	
	    XMLBuilder.prototype.assertLegalChar = function(str) {
	      var chars, chr;
	      if (this.allowSurrogateChars) {
	        chars = /[\u0000-\u0008\u000B-\u000C\u000E-\u001F\uFFFE-\uFFFF]/;
	      } else {
	        chars = /[\u0000-\u0008\u000B-\u000C\u000E-\u001F\uD800-\uDFFF\uFFFE-\uFFFF]/;
	      }
	      chr = str.match(chars);
	      if (chr) {
	        throw new Error("Invalid character (" + chr + ") in string: " + str + " at index " + chr.index);
	      }
	    };
	
	    return XMLBuilder;
	
	  })();
	
	  module.exports = XMLBuilder;
	
	}).call(this);


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(391).enable();
	  window.Promise = __webpack_require__(390);
	}
	
	if (typeof Error.captureStackTrace === 'undefined') {
	  Error.captureStackTrace = function () { }
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(591);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(7);


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	var Microsoft;
	(function (Microsoft) {
	    var ApplicationInsights;
	    (function (ApplicationInsights) {
	        "use strict";
	    })(ApplicationInsights = Microsoft.ApplicationInsights || (Microsoft.ApplicationInsights = {}));
	})(Microsoft || (Microsoft = {}));
	// THIS FILE WAS AUTOGENERATED
	var Microsoft;
	(function (Microsoft) {
	    var Telemetry;
	    (function (Telemetry) {
	        "use strict";
	        /**
	         * Data struct to contain only C section with custom fields.
	         */
	        var Base = /** @class */ (function () {
	            function Base() {
	            }
	            return Base;
	        }());
	        Telemetry.Base = Base;
	    })(Telemetry = Microsoft.Telemetry || (Microsoft.Telemetry = {}));
	})(Microsoft || (Microsoft = {}));
	// THIS FILE WAS AUTOGENERATED
	/// <reference path="Base.ts" />
	var Microsoft;
	(function (Microsoft) {
	    var Telemetry;
	    (function (Telemetry) {
	        "use strict";
	        /**
	         * System variables for a telemetry item.
	         */
	        var Envelope = /** @class */ (function () {
	            function Envelope() {
	                this.ver = 1;
	                this.sampleRate = 100.0;
	                this.tags = {};
	            }
	            return Envelope;
	        }());
	        Telemetry.Envelope = Envelope;
	    })(Telemetry = Microsoft.Telemetry || (Microsoft.Telemetry = {}));
	})(Microsoft || (Microsoft = {}));
	var Microsoft;
	(function (Microsoft) {
	    var ApplicationInsights;
	    (function (ApplicationInsights) {
	        var Context;
	        (function (Context) {
	            "use strict";
	        })(Context = ApplicationInsights.Context || (ApplicationInsights.Context = {}));
	    })(ApplicationInsights = Microsoft.ApplicationInsights || (Microsoft.ApplicationInsights = {}));
	})(Microsoft || (Microsoft = {}));
	var Microsoft;
	(function (Microsoft) {
	    var ApplicationInsights;
	    (function (ApplicationInsights) {
	        var Context;
	        (function (Context) {
	            "use strict";
	        })(Context = ApplicationInsights.Context || (ApplicationInsights.Context = {}));
	    })(ApplicationInsights = Microsoft.ApplicationInsights || (Microsoft.ApplicationInsights = {}));
	})(Microsoft || (Microsoft = {}));
	var Microsoft;
	(function (Microsoft) {
	    var ApplicationInsights;
	    (function (ApplicationInsights) {
	        var Context;
	        (function (Context) {
	            "use strict";
	        })(Context = ApplicationInsights.Context || (ApplicationInsights.Context = {}));
	    })(ApplicationInsights = Microsoft.ApplicationInsights || (Microsoft.ApplicationInsights = {}));
	})(Microsoft || (Microsoft = {}));
	var Microsoft;
	(function (Microsoft) {
	    var ApplicationInsights;
	    (function (ApplicationInsights) {
	        var Context;
	        (function (Context) {
	            "use strict";
	        })(Context = ApplicationInsights.Context || (ApplicationInsights.Context = {}));
	    })(ApplicationInsights = Microsoft.ApplicationInsights || (Microsoft.ApplicationInsights = {}));
	})(Microsoft || (Microsoft = {}));
	var Microsoft;
	(function (Microsoft) {
	    var ApplicationInsights;
	    (function (ApplicationInsights) {
	        var Context;
	        (function (Context) {
	            "use strict";
	        })(Context = ApplicationInsights.Context || (ApplicationInsights.Context = {}));
	    })(ApplicationInsights = Microsoft.ApplicationInsights || (Microsoft.ApplicationInsights = {}));
	})(Microsoft || (Microsoft = {}));
	var Microsoft;
	(function (Microsoft) {
	    var ApplicationInsights;
	    (function (ApplicationInsights) {
	        var Context;
	        (function (Context) {
	            "use strict";
	        })(Context = ApplicationInsights.Context || (ApplicationInsights.Context = {}));
	    })(ApplicationInsights = Microsoft.ApplicationInsights || (Microsoft.ApplicationInsights = {}));
	})(Microsoft || (Microsoft = {}));
	var Microsoft;
	(function (Microsoft) {
	    var ApplicationInsights;
	    (function (ApplicationInsights) {
	        var Context;
	        (function (Context) {
	            "use strict";
	        })(Context = ApplicationInsights.Context || (ApplicationInsights.Context = {}));
	    })(ApplicationInsights = Microsoft.ApplicationInsights || (Microsoft.ApplicationInsights = {}));
	})(Microsoft || (Microsoft = {}));
	var Microsoft;
	(function (Microsoft) {
	    var ApplicationInsights;
	    (function (ApplicationInsights) {
	        var Context;
	        (function (Context) {
	            "use strict";
	        })(Context = ApplicationInsights.Context || (ApplicationInsights.Context = {}));
	    })(ApplicationInsights = Microsoft.ApplicationInsights || (Microsoft.ApplicationInsights = {}));
	})(Microsoft || (Microsoft = {}));
	var Microsoft;
	(function (Microsoft) {
	    var ApplicationInsights;
	    (function (ApplicationInsights) {
	        "use strict";
	    })(ApplicationInsights = Microsoft.ApplicationInsights || (Microsoft.ApplicationInsights = {}));
	})(Microsoft || (Microsoft = {}));
	/// <reference path="./ISerializable.ts" />
	var Microsoft;
	(function (Microsoft) {
	    var ApplicationInsights;
	    (function (ApplicationInsights) {
	        "use strict";
	    })(ApplicationInsights = Microsoft.ApplicationInsights || (Microsoft.ApplicationInsights = {}));
	})(Microsoft || (Microsoft = {}));
	/// <reference path="./Contracts/Generated/Envelope.ts" />
	/// <reference path="./Context/IApplication.ts"/>
	/// <reference path="./Context/IDevice.ts"/>
	/// <reference path="./Context/IInternal.ts"/>
	/// <reference path="./Context/ILocation.ts"/>
	/// <reference path="./Context/IOperation.ts"/>
	/// <reference path="./Context/ISample.ts"/>
	/// <reference path="./Context/IUser.ts"/>
	/// <reference path="./Context/ISession.ts"/>
	/// <reference path="./Telemetry/IEnvelope.ts"/>
	var Microsoft;
	(function (Microsoft) {
	    var ApplicationInsights;
	    (function (ApplicationInsights) {
	        "use strict";
	    })(ApplicationInsights = Microsoft.ApplicationInsights || (Microsoft.ApplicationInsights = {}));
	})(Microsoft || (Microsoft = {}));
	// THIS FILE WAS AUTOGENERATED
	var AI;
	(function (AI) {
	    "use strict";
	    /**
	     * Defines the level of severity for the event.
	     */
	    var SeverityLevel;
	    (function (SeverityLevel) {
	        SeverityLevel[SeverityLevel["Verbose"] = 0] = "Verbose";
	        SeverityLevel[SeverityLevel["Information"] = 1] = "Information";
	        SeverityLevel[SeverityLevel["Warning"] = 2] = "Warning";
	        SeverityLevel[SeverityLevel["Error"] = 3] = "Error";
	        SeverityLevel[SeverityLevel["Critical"] = 4] = "Critical";
	    })(SeverityLevel = AI.SeverityLevel || (AI.SeverityLevel = {}));
	})(AI || (AI = {}));
	/// <reference path="./IConfig.ts" />
	/// <reference path="./ITelemetryContext.ts" />
	/// <reference path="./Contracts/Generated/SeverityLevel.ts" />
	var Microsoft;
	(function (Microsoft) {
	    var ApplicationInsights;
	    (function (ApplicationInsights) {
	        "use strict";
	    })(ApplicationInsights = Microsoft.ApplicationInsights || (Microsoft.ApplicationInsights = {}));
	})(Microsoft || (Microsoft = {}));
	/// <reference path="../JavaScriptSDK.Interfaces/IConfig.ts"/>
	/// <reference path="../JavaScriptSDK.Interfaces/IAppInsights.ts"/>
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    "use strict";
	    Object.defineProperty(exports, "__esModule", { value: true });
	    var AppInsightsModule = /** @class */ (function () {
	        function AppInsightsModule() {
	        }
	        AppInsightsModule._createLazyMethod = function (name) {
	            var aiObject = window[AppInsightsModule.appInsightsName];
	            // Define a temporary method that queues-up a the real method call
	            aiObject[name] = function () {
	                // Capture the original arguments passed to the method
	                var originalArguments = arguments;
	                // If the queue is available, it means that the function wasn't yet replaced with actual function value
	                if (aiObject.queue) {
	                    aiObject.queue.push(function () { return aiObject[name].apply(aiObject, originalArguments); });
	                }
	                else {
	                    // otherwise execute the function
	                    aiObject[name].apply(aiObject, originalArguments);
	                }
	            };
	        };
	        ;
	        AppInsightsModule._defineLazyMethods = function () {
	            var aiObject = window[AppInsightsModule.appInsightsName];
	            // capture initial cookie if possible
	            try {
	                aiObject.cookie = document.cookie;
	            }
	            catch (e) {
	            }
	            aiObject.queue = [];
	            var method = [
	                "clearAuthenticatedUserContext",
	                "flush",
	                "setAuthenticatedUserContext",
	                "startTrackEvent",
	                "startTrackPage",
	                "stopTrackEvent",
	                "stopTrackPage",
	                "trackDependency",
	                "trackEvent",
	                "trackException",
	                "trackMetric",
	                "trackPageView",
	                "trackTrace"
	            ];
	            while (method.length) {
	                AppInsightsModule._createLazyMethod(method.pop());
	            }
	        };
	        AppInsightsModule._download = function (aiConfig) {
	            AppInsightsModule.appInsightsInstance.config = aiConfig;
	            var aiObject = window[AppInsightsModule.appInsightsName];
	            // if script was previously downloaded and initialized, queue will be deleted, reinitialize it
	            if (!aiObject.queue) {
	                aiObject.queue = [];
	            }
	            setTimeout(function () {
	                var scriptElement = document.createElement("script");
	                scriptElement.src = aiConfig.url || "https://az416426.vo.msecnd.net/scripts/a/ai.0.js";
	                document.head.appendChild(scriptElement);
	            });
	            // collect global errors by wrapping the window.onerror method
	            if (!aiConfig.disableExceptionTracking) {
	                var method_1 = "onerror";
	                AppInsightsModule._createLazyMethod("_" + method_1);
	                var originalOnError = window[method_1];
	                window[method_1] = function (message, url, lineNumber, columnNumber, error) {
	                    var handled = originalOnError && originalOnError(message, url, lineNumber, columnNumber, error);
	                    if (handled !== true) {
	                        aiObject["_" + method_1](message, url, lineNumber, columnNumber, error);
	                    }
	                    return handled;
	                };
	            }
	        };
	        Object.defineProperty(AppInsightsModule, "appInsightsInstance", {
	            get: function () {
	                if (typeof window === 'undefined') {
	                    return;
	                }
	                if (!window[AppInsightsModule.appInsightsName]) {
	                    window[AppInsightsModule.appInsightsName] = {
	                        downloadAndSetup: AppInsightsModule._download,
	                        // exposing it for unit tests only, not part of interface
	                        _defineLazyMethods: AppInsightsModule._defineLazyMethods
	                    };
	                    AppInsightsModule._defineLazyMethods();
	                }
	                return window[AppInsightsModule.appInsightsName];
	            },
	            enumerable: true,
	            configurable: true
	        });
	        AppInsightsModule.appInsightsInitialized = false;
	        AppInsightsModule.appInsightsName = "appInsights";
	        return AppInsightsModule;
	    }());
	    exports.AppInsights = AppInsightsModule.appInsightsInstance;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	//# sourceMappingURL=ai.module.js.map

/***/ },
/* 232 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	/*! Copyright (c) Microsoft. All rights reserved.
	 *! Licensed under the MIT license. See LICENSE file in the project root for full license information.
	 */
	'use strict';
	var dictionary_1 = __webpack_require__(123);
	var errors_1 = __webpack_require__(60);
	/**
	 * Describes the parameters that enable a device or cloud application to connect to an Azure IoT hub.
	 */
	var ConnectionString = (function () {
	    function ConnectionString() {
	    }
	    /**
	     * Parses a string and returns the corresponding {@link azure-iot-common.ConnectionString} object.
	     * @param {string}   source          string from which the connection string will be extracted
	     * @param {string[]} requiredFields  array of strings listing the fields that are expected to be found.
	     */
	    ConnectionString.parse = function (source, requiredFields) {
	        /*Codes_SRS_NODE_CONNSTR_05_001: [The input argument source shall be converted to string if necessary.]*/
	        /*Codes_SRS_NODE_CONNSTR_05_002: [The parse method shall create a new instance of ConnectionString.]*/
	        var connectionString = dictionary_1.createDictionary(source, ';');
	        var err = 'The connection string is missing the property: ';
	        /*Codes_SRS_NODE_CONNSTR_05_007: [If requiredFields is falsy, parse shall not validate fields.]*/
	        requiredFields = requiredFields || [];
	        /*Codes_SRS_NODE_CONNSTR_05_005: [The parse method shall throw ArgumentError if any of fields in the requiredFields argument are not found in the source argument.]*/
	        requiredFields.forEach(function (key) {
	            if (!(key in connectionString))
	                throw new errors_1.ArgumentError(err + key);
	        });
	        /*Codes_SRS_NODE_CONNSTR_05_003: [It shall accept a string argument of the form 'name=value[;name=value…]' and for each name extracted it shall create a new property on the ConnectionString object instance.]*/
	        /*Codes_SRS_NODE_CONNSTR_05_004: [The value of the property shall be the value extracted from the source argument for the corresponding name.]*/
	        /*Codes_SRS_NODE_CONNSTR_05_006: [The generated ConnectionString object shall be returned to the caller.]*/
	        return connectionString;
	    };
	    return ConnectionString;
	}());
	exports.ConnectionString = ConnectionString;
	//# sourceMappingURL=connection_string.js.map

/***/ },
/* 234 */
/***/ function(module, exports) {

	/*! Copyright (c) Microsoft. All rights reserved.
	 *! Licensed under the MIT license. See LICENSE file in the project root for full license information.
	 */
	'use strict';
	exports.apiVersion = '2018-01-16';
	function devicePath(id) {
	    return '/devices/' + id;
	}
	exports.devicePath = devicePath;
	function eventPath(id) {
	    return devicePath(id) + '/messages/events';
	}
	exports.eventPath = eventPath;
	function messagePath(id) {
	    return devicePath(id) + '/messages/devicebound';
	}
	exports.messagePath = messagePath;
	function feedbackPath(id, lockToken) {
	    return messagePath(id) + '/' + lockToken;
	}
	exports.feedbackPath = feedbackPath;
	function versionQueryString() {
	    return '?api-version=' + exports.apiVersion;
	}
	exports.versionQueryString = versionQueryString;
	//# sourceMappingURL=endpoint.js.map

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*! Copyright (c) Microsoft. All rights reserved.
	 *! Licensed under the MIT license. See LICENSE file in the project root for full license information.
	 */
	'use strict';
	var properties_1 = __webpack_require__(236);
	/**
	 * The {@link azure-iot-common.Message} object is used for telemetry (device-to-cloud) and commands (cloud-to-device) asynchronous
	 * messaging between the device and the IoT Hub service. It is transport-agnostic, meaning it works the same way over AMQP, MQTT and HTTP.
	 */
	var Message = (function () {
	    /**
	     * Creates a new {@link azure-iot-common.Message} object
	     * @constructor
	     * @param data a Node [Buffer]{@link https://nodejs.org/api/globals.html#globals_class_buffer}
	     *             object or anything that can be passed to the [Buffer]{@link https://nodejs.org/api/globals.html#globals_class_buffer} constructor
	     *             to construct a [Buffer]{@link https://nodejs.org/api/globals.html#globals_class_buffer} from.
	     */
	    /*Codes_SRS_NODE_IOTHUB_MESSAGE_07_004: [The Message constructor shall accept a variable message that will be transmitted.]*/
	    function Message(data) {
	        this.data = data;
	        this.properties = new properties_1.Properties();
	        this.messageId = '';
	        this.to = '';
	        this.expiryTimeUtc = undefined;
	        this.lockToken = '';
	        this.correlationId = '';
	        this.userId = '';
	        this.contentEncoding = undefined;
	        this.contentType = undefined;
	    }
	    /**
	     * Gets the content (body) of the {@link azure-iot-common.Message}.
	     *
	     * @returns {*} The content of the {@link azure-iot-common.Message}.
	     */
	    Message.prototype.getData = function () {
	        /*Codes_SRS_NODE_IOTHUB_MESSAGE_07_003: [The getData function shall return a representation of the body of the message as the type that was presented during construction.]*/
	        return this.data;
	    };
	    ;
	    /**
	     * Gets the data passed to the constructor as a [Buffer]{@link https://nodejs.org/api/globals.html#globals_class_buffer}
	     *
	     * @returns {Buffer}
	     */
	    Message.prototype.getBytes = function () {
	        if (Buffer.isBuffer(this.data)) {
	            /*Codes_SRS_NODE_IOTHUB_MESSAGE_07_001: [If the data message that is store is of type Buffer then the data object will get returned unaltered.]*/
	            return this.data;
	        }
	        else {
	            /*Codes_SRS_NODE_IOTHUB_MESSAGE_07_002: [If the data message is of any other type then the data will be converted to a Buffer object and returned.]*/
	            return new Buffer(this.data);
	        }
	    };
	    ;
	    return Message;
	}());
	exports.Message = Message;
	//# sourceMappingURL=message.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 236 */
/***/ function(module, exports) {

	/*! Copyright (c) Microsoft. All rights reserved.
	 *! Licensed under the MIT license. See LICENSE file in the project root for full license information.
	 */
	'use strict';
	/**
	 * Collection of user defined properties of a {@link azure-iot-common.Message} object that are going to be sent alongside the body of the message
	 * and can be used for [routing](https://docs.microsoft.com/en-us/azure/iot-hub/iot-hub-csharp-csharp-process-d2c).
	 * Values can only be strings.
	 */
	var Properties = (function () {
	    function Properties() {
	        /**
	         * Array containing the properties stored as key/value pairs
	         * ```json
	         * [
	         *   { key: 'prop1', value: 'value1' },
	         *   { key: 'prop2', value: 'value2' }
	         * ]
	         * ```
	         */
	        this.propertyList = [];
	    }
	    /**
	     * Adds the key-value pair to the collection. The strings `'Authorization'`
	     * and `'iothub-to'` are considered as reserved key names and will cause the
	     * function to return `false` if those key names are used.
	     */
	    /* Codes_SRS_NODE_IOTHUB_PROPERTIES_07_003: [The getData function shall return a string representation of the body of the message.] */
	    Properties.prototype.add = function (itemKey, itemValue) {
	        /* Codes_SRS_NODE_IOTHUB_PROPERTIES_07_004: [If itemKey contains any of the reserved key names then the add function will return false] */
	        if (itemKey === 'Authorization' || itemKey === 'iothub-to') {
	            return false;
	        }
	        else {
	            this.propertyList.push({ key: itemKey, value: itemValue });
	            return true;
	        }
	    };
	    ;
	    /**
	     * Returns the key-value pair corresponding to the given index.
	     * @returns {Object}  Key-value pair corresponding to the given index. The
	     *                    returned object has the properties `key` and `value`
	     *                    corresponding to the key and value of the property.
	     */
	    /* Codes_SRS_NODE_IOTHUB_PROPERTIES_07_001: [if the supplied index is greater or equal to zero and the is less than property map length then it shall return the property object.] */
	    Properties.prototype.getItem = function (index) {
	        if (index >= 0 && index < this.propertyList.length)
	            return this.propertyList[index];
	        /*Codes_SRS_NODE_IOTHUB_PROPERTIES_13_001: [ If the supplied index is less than zero or greater than or equal to the property map length then it shall return undefined. ]*/
	        return undefined;
	    };
	    ;
	    /**
	     * Returns the value property of the element that has the given key.
	     * @returns {Object}  corresponding value or undefined if the key doesn't exist.
	     */
	    Properties.prototype.getValue = function (key) {
	        for (var i = 0; i < this.propertyList.length; i++) {
	            /*Codes_SRS_NODE_IOTHUB_PROPERTIES_16_002: [`Properties.getValue` should return the corresponding value of the `value` property of the element with the `key` property passed as argument.]*/
	            if (this.propertyList[i].key === key) {
	                return this.propertyList[i].value;
	            }
	        }
	        /*Codes_SRS_NODE_IOTHUB_PROPERTIES_16_001: [`Properties.getValue` should return `undefined` if no element within the `propertyList` array contains `key`.]*/
	        return undefined;
	    };
	    ;
	    /**
	     * Returns the number of items in the collection.
	     */
	    /* Codes_SRS_NODE_IOTHUB_PROPERTIES_07_002: [Properties.Count shall return the number of items in the Properties map.] */
	    Properties.prototype.count = function () {
	        return this.propertyList.length;
	    };
	    ;
	    return Properties;
	}());
	exports.Properties = Properties;
	;
	//# sourceMappingURL=properties.js.map

/***/ },
/* 237 */
/***/ function(module, exports) {

	/*! Copyright (c) Microsoft. All rights reserved.
	 *! Licensed under the MIT license. See LICENSE file in the project root for full license information.
	 */
	'use strict';
	/**
	 * Result returned when a message was successfully enqueued.
	 */
	var MessageEnqueued = (function () {
	    /**
	     * @private
	     * @constructor
	     * @param transportObj optional transport object to help with debugging.
	     */
	    function MessageEnqueued(transportObj) {
	        this.transportObj = transportObj;
	    }
	    return MessageEnqueued;
	}());
	exports.MessageEnqueued = MessageEnqueued;
	/**
	 * Result returned when a message was successfully rejected.
	 */
	var MessageCompleted = (function () {
	    /**
	     * @private
	     * @constructor
	     * @param transportObj optional transport object to help with debugging.
	     */
	    function MessageCompleted(transportObj) {
	        this.transportObj = transportObj;
	    }
	    return MessageCompleted;
	}());
	exports.MessageCompleted = MessageCompleted;
	/**
	 * Result returned when a message was successfully rejected.
	 */
	var MessageRejected = (function () {
	    /**
	     * @private
	     * @constructor
	     * @param transportObj optional transport object to help with debugging.
	     */
	    function MessageRejected(transportObj) {
	        this.transportObj = transportObj;
	    }
	    return MessageRejected;
	}());
	exports.MessageRejected = MessageRejected;
	/**
	 * Result returned when a message was successfully abandoned.
	 */
	var MessageAbandoned = (function () {
	    /**
	     * @private
	     * @constructor
	     * @param transportObj optional transport object to help with debugging.
	     */
	    function MessageAbandoned(transportObj) {
	        this.transportObj = transportObj;
	    }
	    return MessageAbandoned;
	}());
	exports.MessageAbandoned = MessageAbandoned;
	/**
	 * Result returned when a transport is successfully connected.
	 */
	var Connected = (function () {
	    /**
	     * @private
	     * @constructor
	     * @param transportObj optional transport object to help with debugging.
	     */
	    function Connected(transportObj) {
	        this.transportObj = transportObj;
	    }
	    return Connected;
	}());
	exports.Connected = Connected;
	/**
	 * Result returned when a transport is successfully disconnected.
	 */
	var Disconnected = (function () {
	    /**
	     * @private
	     * @constructor
	     * @param transportObj optional transport object to help with debugging.
	     */
	    function Disconnected(transportObj, reason) {
	        this.transportObj = transportObj;
	        this.reason = reason;
	    }
	    return Disconnected;
	}());
	exports.Disconnected = Disconnected;
	/**
	 * Result returned when a transport is successfully configured.
	 */
	var TransportConfigured = (function () {
	    /**
	     * @private
	     * @constructor
	     * @param transportObj optional transport object to help with debugging.
	     */
	    function TransportConfigured(transportObj) {
	        this.transportObj = transportObj;
	    }
	    return TransportConfigured;
	}());
	exports.TransportConfigured = TransportConfigured;
	/**
	 * Result returned when a SAS token has been successfully updated.
	 */
	var SharedAccessSignatureUpdated = (function () {
	    /**
	     * @private
	     * @constructor
	     * @param transportObj optional transport object to help with debugging.
	     */
	    function SharedAccessSignatureUpdated(needToReconnect) {
	        this.needToReconnect = needToReconnect;
	    }
	    return SharedAccessSignatureUpdated;
	}());
	exports.SharedAccessSignatureUpdated = SharedAccessSignatureUpdated;
	//# sourceMappingURL=results.js.map

/***/ },
/* 238 */
/***/ function(module, exports) {

	// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	'use strict';
	/* tslint:disable:variable-name */
	/**
	 * @private
	 */
	var DefaultErrorFilter = (function () {
	    function DefaultErrorFilter() {
	        this.ArgumentError = false;
	        this.ArgumentOutOfRangeError = false;
	        this.DeviceMaximumQueueDepthExceededError = false; // ??
	        this.DeviceNotFoundError = false;
	        this.FormatError = false;
	        this.UnauthorizedError = false;
	        this.NotImplementedError = false;
	        this.NotConnectedError = true;
	        this.IotHubQuotaExceededError = false;
	        this.MessageTooLargeError = false;
	        this.InternalServerError = true;
	        this.ServiceUnavailableError = true;
	        this.IotHubNotFoundError = false;
	        this.IoTHubSuspendedError = false; // ??
	        this.JobNotFoundError = false;
	        this.TooManyDevicesError = false;
	        this.ThrottlingError = true;
	        this.DeviceAlreadyExistsError = false;
	        this.DeviceMessageLockLostError = false;
	        this.InvalidEtagError = false;
	        this.InvalidOperationError = false;
	        this.PreconditionFailedError = false; // ??
	        this.TimeoutError = true;
	        this.BadDeviceResponseError = false;
	        this.GatewayTimeoutError = false; // ??
	        this.DeviceTimeoutError = false; // ??
	        this.TwinRequestError = false;
	    }
	    return DefaultErrorFilter;
	}());
	exports.DefaultErrorFilter = DefaultErrorFilter;
	/* tslint:enable:variable-name */
	//# sourceMappingURL=retry_error_filter.js.map

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	'use strict';
	var errors = __webpack_require__(60);
	/**
	 * Implements the necessary logic to retry operations such as connecting, receiving C2D messages, sending telemetry, twin updates, etc.
	 */
	var RetryOperation = (function () {
	    /**
	     * Creates an instance of {@link azure-iot-common.RetryOperation.}
	     * @param {RetryPolicy} policy The retry policy to be used for this operation, which determines what error is "retryable" or not and how fast to retry.
	     * @param {number} maxTimeout  The maximum timeout for this operation, after which no retry will be attempted.
	     */
	    function RetryOperation(policy, maxTimeout) {
	        this._retryCount = 0;
	        this._totalRetryTime = 0;
	        this._policy = policy;
	        this._maxTimeout = maxTimeout;
	    }
	    /**
	     * Executes an operation and retries if it fails and the retry policy allows it.
	     *
	     * @param {(opCallback: (err?: Error, result?: any) => void) => void} operation The operation to execute.
	     * @param {(err?: Error, result?: any) => void} finalCallback                   The callback to call with the final error or result, after retries if necessary.
	     */
	    RetryOperation.prototype.retry = function (operation, finalCallback) {
	        var _this = this;
	        var retryOperation = function () {
	            _this._retryCount++;
	            /*Codes_SRS_NODE_COMMON_RETRY_OPERATION_16_001: [The `operation` function should be called at every retry.]*/
	            operation(function (err, result, response) {
	                if (err) {
	                    /*Codes_SRS_NODE_COMMON_RETRY_OPERATION_16_003: [If the `operation` fails with an error the `retry` method should determine whether to retry or not using the `shouldRetry` method of the policy passed to the constructor.]*/
	                    if (_this._policy.shouldRetry(err)) {
	                        /*Codes_SRS_NODE_COMMON_RETRY_OPERATION_16_005: [If the `operation` fails and should be retried, the time at which to try again the `operation` should be computed using the `nextRetryTimeout` method of the policy passed to the constructor. ]*/
	                        var nextRetryTimeout = _this._policy.nextRetryTimeout(_this._retryCount, (err instanceof errors.ThrottlingError));
	                        _this._totalRetryTime += nextRetryTimeout;
	                        /*Codes_SRS_NODE_COMMON_RETRY_OPERATION_16_006: [The `operation` should not be retried past the `maxTimeout` parameter passed to the constructor.]*/
	                        if (_this._totalRetryTime > _this._maxTimeout || nextRetryTimeout < 0) {
	                            finalCallback(err);
	                        }
	                        else {
	                            _this._currentTimeout = setTimeout(retryOperation, nextRetryTimeout);
	                        }
	                    }
	                    else {
	                        /*Codes_SRS_NODE_COMMON_RETRY_OPERATION_16_004: [If the `operation` fails and should not be retried, the `finalCallback` should be called with the last error as the only parameter. ]*/
	                        finalCallback(err);
	                    }
	                }
	                else {
	                    /*Codes_SRS_NODE_COMMON_RETRY_OPERATION_16_002: [If the `operation` is successful the `finalCallback` function should be called with a `null` error parameter and the result of the operation.]*/
	                    finalCallback(null, result, response);
	                }
	            });
	        };
	        retryOperation();
	    };
	    return RetryOperation;
	}());
	exports.RetryOperation = RetryOperation;
	//# sourceMappingURL=retry_operation.js.map

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*! Copyright (c) Microsoft. All rights reserved.
	 *! Licensed under the MIT license. See LICENSE file in the project root for full license information.
	 */
	'use strict';
	var authorization = __webpack_require__(74);
	var errors_1 = __webpack_require__(60);
	var dictionary_1 = __webpack_require__(123);
	/**
	 * Shared access signature tokens are used to authenticate the connection when using symmetric keys (as opposed to x509 certificates) to secure the connection with the Azure IoT hub.
	 */
	var SharedAccessSignature = (function () {
	    function SharedAccessSignature() {
	    }
	    /**
	     * @method          module:azure-iot-common.SharedAccessSignature.extend
	     * @description     Extend the Sas and return the string form of it.
	     *
	     * @param {Integer} expiry          an integer value representing the number of seconds since the epoch 00:00:00 UTC on 1 January 1970.
	     *
	     * @throws {ReferenceError}         Will be thrown if the argument is falsy.
	     *
	     * @returns {string} The string form of the shared access signature.
	     *
	     */
	    SharedAccessSignature.prototype.extend = function (expiry) {
	        if (!expiry)
	            throw new ReferenceError('expiry' + ' is ' + expiry);
	        this.se = expiry;
	        this.sig = authorization.encodeUriComponentStrict(authorization.hmacHash(this._key, authorization.stringToSign(this.sr, this.se.toString())));
	        return this.toString();
	    };
	    ;
	    /**
	     * @method          module:azure-iot-common.SharedAccessSignature#toString
	     * @description     Formats a SharedAccessSignatureObject into a properly formatted string.
	     *
	     * @returns {String} A properly formatted shared access signature token.
	     */
	    SharedAccessSignature.prototype.toString = function () {
	        var _this = this;
	        /*Codes_SRS_NODE_COMMON_SAS_05_019: [The toString method shall return a shared-access signature token of the form:
	        SharedAccessSignature sr=<url-encoded resourceUri>&sig=<urlEncodedSignature>&se=<expiry>&skn=<urlEncodedKeyName>]*/
	        var sas = 'SharedAccessSignature ';
	        ['sr', 'sig', 'skn', 'se'].forEach(function (key) {
	            /*Codes_SRS_NODE_COMMON_SAS_05_020: [The skn segment is not part of the returned string if the skn property is not defined.]*/
	            if (_this[key]) {
	                if (sas[sas.length - 1] !== ' ')
	                    sas += '&';
	                sas += key + '=' + _this[key];
	            }
	        });
	        return sas;
	    };
	    ;
	    /**
	     * @method          module:azure-iot-common.SharedAccessSignature.create
	     * @description     Instantiate a SharedAccessSignature token with the given parameters.
	     *
	     * @param {String}  resourceUri     the resource URI to encode into the token.
	     * @param {String}  keyName         an identifier associated with the key.
	     * @param {String}  key             a base64-encoded key value.
	     * @param {Integer} expiry          an integer value representing the number of seconds since the epoch 00:00:00 UTC on 1 January 1970.
	     *
	     * @throws {ReferenceError}         Will be thrown if one of the arguments is falsy.
	     *
	     * @returns {SharedAccessSignature} A shared access signature token.
	     */
	    /*Codes_SRS_NODE_COMMON_SAS_05_008: [The create method shall accept four arguments:
	        resourceUri - the resource URI to encode into the token
	        keyName - an identifier associated with the key
	        key - a base64-encoded key value
	        expiry - an integer value representing the number of seconds since the epoch 00:00:00 UTC on 1 January 1970.]*/
	    SharedAccessSignature.create = function (resourceUri, keyName, key, expiry) {
	        function throwRef(name, value) {
	            throw new ReferenceError('Argument \'' + name + '\' is ' + value);
	        }
	        /*Codes_SRS_NODE_COMMON_SAS_05_009: [If resourceUri, key, or expiry are falsy (i.e., undefined, null, or empty), create shall throw ReferenceException.]*/
	        if (!resourceUri)
	            throwRef('resourceUri', resourceUri);
	        if (!key)
	            throwRef('key', key);
	        if (!expiry)
	            throwRef('expiry', expiry);
	        /*Codes_SRS_NODE_COMMON_SAS_05_010: [The create method shall create a new instance of SharedAccessSignature with properties: sr, sig, se, and optionally skn.]*/
	        var sas = new SharedAccessSignature();
	        sas._key = key;
	        /*Codes_SRS_NODE_COMMON_SAS_05_011: [The sr property shall have the value of resourceUri.]*/
	        sas.sr = resourceUri;
	        /*Codes_SRS_NODE_COMMON_SAS_05_018: [If the keyName argument to the create method was falsy, skn shall not be defined.]*/
	        /*Codes_SRS_NODE_COMMON_SAS_05_017: [<urlEncodedKeyName> shall be the URL-encoded value of keyName.]*/
	        /*Codes_SRS_NODE_COMMON_SAS_05_016: [The skn property shall be the value <urlEncodedKeyName>.]*/
	        if (keyName)
	            sas.skn = authorization.encodeUriComponentStrict(keyName);
	        /*Codes_SRS_NODE_COMMON_SAS_05_015: [The se property shall have the value of expiry.]*/
	        sas.se = expiry;
	        /*Codes_SRS_NODE_COMMON_SAS_05_013: [<signature> shall be an HMAC-SHA256 hash of the value <stringToSign>, which is then base64-encoded.]*/
	        /*Codes_SRS_NODE_COMMON_SAS_05_014: [<stringToSign> shall be a concatenation of resourceUri + '\n' + expiry.]*/
	        /*Codes_SRS_NODE_COMMON_SAS_05_012: [The sig property shall be the result of URL-encoding the value <signature>.]*/
	        sas.sig = authorization.encodeUriComponentStrict(authorization.hmacHash(sas._key, authorization.stringToSign(sas.sr, sas.se.toString())));
	        return sas;
	    };
	    ;
	    /**
	     * @private
	     */
	    SharedAccessSignature.createWithSigningFunction = function (credentials, expiry, signingFunction, callback) {
	        function throwRef(name, value) {
	            throw new ReferenceError('Argument \'' + name + '\' is ' + value);
	        }
	        /*Codes_SRS_NODE_COMMON_SAS_06_001: [If `credentials`, `expiry`, `signingFunction`, or `callback` are falsy, `createWithSigningFunction` shall throw `ReferenceError`.] */
	        if (!credentials)
	            throwRef('credentials', credentials);
	        if (!expiry)
	            throwRef('expiry', expiry);
	        if (!signingFunction)
	            throwRef('signingFunction', signingFunction);
	        if (!callback)
	            throwRef('callback', callback);
	        var sas = new SharedAccessSignature();
	        /*Codes_SRS_NODE_COMMON_SAS_06_002: [The `createWithSigningFunction` shall create a `SharedAccessSignature` object with an `sr` property formed by url encoding `credentials.host` + `/devices/` + `credentials.deviceId`.] */
	        sas.sr = authorization.encodeUriComponentStrict(credentials.host + '/devices/' + credentials.deviceId);
	        /*Codes_SRS_NODE_COMMON_SAS_06_003: [** The `createWithSigningFunction` shall create a `SharedAccessSignature` object with an `se` property containing the value of the parameter `expiry`.] */
	        sas.se = expiry;
	        /*Codes_SRS_NODE_COMMON_SAS_06_004: [The `createWithSigningFunction` shall create a `SharedAccessSignature` object with an optional property `skn`, if the `credentials.sharedAccessKeyName` is not falsy,  The value of the `skn` property will be the url encoded value of `credentials.sharedAccessKeyName`.] */
	        if (credentials.sharedAccessKeyName) {
	            sas.skn = authorization.encodeUriComponentStrict(credentials.sharedAccessKeyName);
	        }
	        signingFunction(Buffer.from(authorization.stringToSign(sas.sr, sas.se.toString())), function (err, signed) {
	            if (err) {
	                /*Codes_SRS_NODE_COMMON_SAS_06_006: [** The `createWithSigningFunction` will invoke the `callback` function with an error value if an error occurred during the signing. **] */
	                callback(err);
	            }
	            else {
	                /*Codes_SRS_NODE_COMMON_SAS_06_005: [The `createWithSigningFunction` shall create a `SharedAccessSignature` object with a `sig` property with the SHA256 hash of the string sr + `\n` + se.  The `sig` value will first be base64 encoded THEN url encoded.] */
	                sas.sig = authorization.encodeUriComponentStrict(signed.toString('base64'));
	                callback(null, sas);
	            }
	        });
	    };
	    /**
	     * @method          module:azure-iot-common.SharedAccessSignature.parse
	     * @description     Instantiate a SharedAccessSignature token from a string.
	     *
	     * @param {String}  source          the string to parse in order to create the SharedAccessSignature token.
	     * @param {Array}   requiredFields  an array of fields that we expect to find in the source string.
	     *
	     * @throws {FormatError}            Will be thrown if the source string is malformed.
	     *
	     * @returns {SharedAccessSignature} A shared access signature token.
	     */
	    SharedAccessSignature.parse = function (source, requiredFields) {
	        /*Codes_SRS_NODE_COMMON_SAS_05_001: [The input argument source shall be converted to string if necessary.]*/
	        var parts = String(source).split(/\s/);
	        /*Codes_SRS_NODE_COMMON_SAS_05_005: [The parse method shall throw FormatError if the shared access signature string does not start with 'SharedAccessSignature<space>'.]*/
	        if (parts.length !== 2 || !parts[0].match(/SharedAccessSignature/)) {
	            throw new errors_1.FormatError('Malformed signature');
	        }
	        var dict = dictionary_1.createDictionary(parts[1], '&');
	        var err = 'The shared access signature is missing the property: ';
	        requiredFields = requiredFields || [];
	        /*Codes_SRS_NODE_COMMON_SAS_05_006: [The parse method shall throw ArgumentError if any of fields in the requiredFields argument are not found in the source argument.]*/
	        requiredFields.forEach(function (key) {
	            if (!(key in dict))
	                throw new errors_1.ArgumentError(err + key);
	        });
	        /*Codes_SRS_NODE_COMMON_SAS_05_002: [The parse method shall create a new instance of SharedAccessSignature.]*/
	        var sas = new SharedAccessSignature();
	        /*Codes_SRS_NODE_COMMON_SAS_05_003: [It shall accept a string argument of the form 'name=value[&name=value…]' and for each name extracted it shall create a new property on the SharedAccessSignature object instance.]*/
	        /*Codes_SRS_NODE_COMMON_SAS_05_004: [The value of the property shall be the value extracted from the source argument for the corresponding name.]*/
	        Object.keys(dict).forEach(function (key) {
	            sas[key] = dict[key];
	        });
	        /*Codes_SRS_NODE_COMMON_SAS_05_007: [The generated SharedAccessSignature object shall be returned to the caller.]*/
	        return sas;
	    };
	    ;
	    return SharedAccessSignature;
	}());
	exports.SharedAccessSignature = SharedAccessSignature;
	//# sourceMappingURL=shared_access_signature.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	
	/**
	 * The `azure-iot-device` module provides a means for devices to send events to and
	 * receive messages from an Azure IoT Hub.  The client handles
	 * communication with the IoT Hub through a transport supplied by the caller
	 * (e.g., [Http]{@linkcode module:adapters/https.Http}).
	 *
	 * @example
	 * var Device = require('azure-iot-device');
	 * var Client = Device.Client;
	 * var Message = Device.Message;
	 * var Http = Device.Http;
	 *
	 * function print(err, res) {
	 *   if (err) console.log(err.toString());
	 *   if (res) console.log(res.statusCode + ' ' + res.statusMessage);
	 * }
	 *
	 * var config = {
	 *   host: 'hostname',
	 *   keyName: 'deviceId',
	 *   key: 'password'
	 * };
	 *
	 * var client = new Client(new Http(config));
	 *
	 * client.sendEvent(new Message('hello world'), print);
	 *
	 * client.receive (function (err, res, msg) {
	 *   print(err, res);
	 *   if (msg) console.log('Message: ' + msg);
	 *   if (!err && res.statusCode !== 204) {
	 *     client.complete(msg, print);
	 *   }
	 * });
	 *
	 * @module azure-iot-device
	 */
	
	'use strict';
	
	var common = __webpack_require__(19);
	
	module.exports = {
	  Client: __webpack_require__(247),
	  ConnectionString: __webpack_require__(125),
	  Message: common.Message,
	  SharedAccessSignature: __webpack_require__(127)
	};

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	
	'use strict';
	
	var BlobUploadResult = __webpack_require__(243);
	var DefaultBlobUploader = __webpack_require__(244);
	var DefaultFileUploadApi = __webpack_require__(245);
	var errors = __webpack_require__(124);
	
	function BlobUploadClient (config, fileUploadApi, blobUploader) {
	  /*Codes_SRS_NODE_DEVICE_BLOB_UPLOAD_CLIENT_16_001: [`BlobUploadClient` shall throw a `ReferenceError` if `config` is falsy.]*/
	  if(!config) throw new ReferenceError('config cannot be \'' + config + '\'');
	  this._config = config;
	
	  /*Codes_SRS_NODE_DEVICE_BLOB_UPLOAD_CLIENT_16_002: [If specified, `BlobUploadClient` shall use the `fileUploadApi` passed as a parameter instead of the default one.]*/
	  this._fileUploadApi = fileUploadApi ? fileUploadApi : new DefaultFileUploadApi(this._config.deviceId, this._config.host); 
	
	  /*Codes_SRS_NODE_DEVICE_BLOB_UPLOAD_CLIENT_16_003: [If specified, `BlobUploadClient` shall use the `blobUploader` passed as a parameter instead of the default one.]*/
	  this._blobUploader = blobUploader ? blobUploader : new DefaultBlobUploader();
	}
	
	BlobUploadClient.prototype.updateSharedAccessSignature = function (sharedAccessSignature) {
	  /*Codes_SRS_NODE_DEVICE_BLOB_UPLOAD_CLIENT_16_011: [`updateSharedAccessSignature` shall update the value used by the `BlobUploadClient` instance to the value passed as an argument.]*/
	  this._config.sharedAccessSignature = sharedAccessSignature;
	};
	
	BlobUploadClient.prototype.uploadToBlob = function(blobName, stream, streamLength, done) {
	  var self = this;
	  /*Codes_SRS_NODE_DEVICE_BLOB_UPLOAD_CLIENT_16_004: [`uploadToBlob` shall obtain a blob SAS token using the IoT Hub service file upload API endpoint.]*/
	  var auth = self._config.x509 ? self._config.x509 : self._config.sharedAccessSignature;
	  self._fileUploadApi.getBlobSharedAccessSignature(blobName, auth, function (err, uploadParams) {
	    if (err) {
	      /*Codes_SRS_NODE_DEVICE_BLOB_UPLOAD_CLIENT_16_005: [`uploadToBlob` shall call the `done` callback with a `BlobSasError` parameter if retrieving the SAS token fails.]*/
	      var error = new errors.BlobSasError('Could not obtain blob shared access signature.');
	      error.innerError = err;
	      done(error);
	    } else {
	      /*Codes_SRS_NODE_DEVICE_BLOB_UPLOAD_CLIENT_16_006: [`uploadToBlob` shall upload the stream to the specified blob using its BlobUploader instance.]*/
	      self._blobUploader.uploadToBlob(uploadParams, stream, streamLength, function (err, body, result) {
	        var uploadResult = BlobUploadResult.fromAzureStorageCallbackArgs(err, body, result);
	        /*Codes_SRS_NODE_DEVICE_BLOB_UPLOAD_CLIENT_16_008: [`uploadToBlob` shall notify the result of a blob upload to the IoT Hub service using the file upload API endpoint.]*/
	        self._fileUploadApi.notifyUploadComplete(uploadParams.correlationId, auth, uploadResult, function (err) {
	          if(err) {
	            /*Codes_SRS_NODE_DEVICE_BLOB_UPLOAD_CLIENT_16_009: [`uploadToBlob` shall call the `done` callback with a `BlobUploadNotificationError` if notifying the IoT Hub instance of the transfer outcome fails.]*/
	            var error = new errors.BlobUploadNotificationError('Could not notify the IoT Hub of the file upload completion.');
	            error.innerError = err;
	            done (error);
	          } else {
	            /*Codes_SRS_NODE_DEVICE_BLOB_UPLOAD_CLIENT_16_010: [`uploadToBlob` shall call the `done` callback with no arguments if IoT Hub was successfully notified of the blob upload outcome, regardless of the success state of the transfer itself.]*/
	            done ();
	          }
	        });
	      });
	    }
	  });
	};
	
	module.exports = BlobUploadClient;

/***/ },
/* 243 */
/***/ function(module, exports) {

	// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	
	'use strict';
	
	/**
	 * @class         module:azure-iot-device.BlobUploadResult
	 * @classdesc     Result object used by the {@link module:azure-iot-device.blobUpload.BlobUploader} class to describe a successful upload to a blob.
	 * 
	 * @params        isSuccess          {Boolean} Indicates whether the upload was successful or failed
	 * @params        statusCode         {Number}  Status code returned by the blob storage upload operation
	 * @params        statusDescription  {String}  String containing useful information pertaining to the result of the blob upload.
	 * 
	 * @augments      {Error}
	 */
	function BlobUploadResult(isSuccess, statusCode, statusDescription) {
	  /*Codes_SRS_NODE_DEVICE_BLOB_UPLOAD_RESULT_16_001: [The `isSuccess` parameter shall be assigned to the the `isSuccess` property of the newly created `BlobUploadResult` instance.]*/
	  this.isSuccess = isSuccess;
	  /*Codes_SRS_NODE_DEVICE_BLOB_UPLOAD_RESULT_16_002: [The `statusCode` parameter shall be assigned to the the `statusCode` property of the newly created `BlobUploadResult` instance.]*/
	  this.statusCode = statusCode;
	  /*Codes_SRS_NODE_DEVICE_BLOB_UPLOAD_RESULT_16_003: [The `statusDescription` parameter shall be assigned to the the `statusDescription` property of the newly created `BlobUploadResult` instance.]*/
	  this.statusDescription = statusDescription;
	}
	
	/**
	 * @method           module:azure-iot-device.BlobUploadResult#fromAzureStorageCallbackArgs
	 * @description      The `fromAzureStorageCallbackArgs` static method creates a new BlobUploadResult instance from the arguments passed to the callback of the azure storage upload method.
	 *
	 * @param {Object}   err         The error object that is passed to the callback.
	 * @param {Object}   body        The body of the HTTP response.
	 * @param {Object}   response    The HTTP response object.
	 *
	 * @throws {ReferenceException} If err is null and either body or response are also falsy.
	 */
	/*Codes_SRS_NODE_DEVICE_BLOB_UPLOAD_RESULT_16_004: [If the `err` argument is not `null`, the `BlobUploadResult` error shall have the `isSuccess` property set to `false`.]*/
	/*Codes_SRS_NODE_DEVICE_BLOB_UPLOAD_RESULT_16_005: [If `err`, `body` and `response` are not `null` (HTTP error), the `BlobUploadResult` error shall have the `statusCode` property set to the HTTP error code of the blob upload response.]*/
	/*Codes_SRS_NODE_DEVICE_BLOB_UPLOAD_RESULT_16_006: [If `err`, `body` and `response` are not `null` (HTTP error), the `BlobUploadResult` error shall have the `statusDescription` property set to the HTTP error body of the blob upload response.]*/
	/*Codes_SRS_NODE_DEVICE_BLOB_UPLOAD_RESULT_16_007: [If the `err` argument is not `null` but body and response are `undefined` (non HTTP error), the `BlobUploadResult` error shall have the `statusCode` property set to -1.]*/
	/*Codes_SRS_NODE_DEVICE_BLOB_UPLOAD_RESULT_16_008: [If the `err` argument is not `null` but body and response are `undefined` (non HTTP error), the `BlobUploadResult` error shall have the `statusDescription` property set to the error message.]*/
	/*Codes_SRS_NODE_DEVICE_BLOB_UPLOAD_RESULT_16_009: [If `err` is null but `body` and `reponse` are provided, the `BlobUploadResult` error shall have the `isSuccess` property set to `false`.]*/
	/*Codes_SRS_NODE_DEVICE_BLOB_UPLOAD_RESULT_16_010: [If `err` is null but `body` and `reponse` are provided, the `BlobUploadResult` error shall have the `statusCode` property set to the HTTP status code of the blob upload response.]*/
	/*Codes_SRS_NODE_DEVICE_BLOB_UPLOAD_RESULT_16_011: [If `err` is null but `body` and `reponse` are provided, the `BlobUploadResult` error shall have the `statusDescription` property set to the HTTP response body of the blob upload response.]*/
	/*Codes_SRS_NODE_DEVICE_BLOB_UPLOAD_RESULT_16_012: [If `err` is null and `body` and/or `response` is/are falsy, `fromAzureStorageCallbackArgs` shall throw a `ReferenceError`.]*/
	BlobUploadResult.fromAzureStorageCallbackArgs = function (err, body, response) {
	  if (!err && (!body || !response)) throw new ReferenceError('if err is null, body and response must be supplied');
	  var uploadResult;
	  if (err) {
	    var statusCode = response ? response.statusCode : -1;
	    var statusDescription = response ? response.body : err.message;
	    uploadResult = new BlobUploadResult(false, statusCode, statusDescription);
	  } else {
	    uploadResult = new BlobUploadResult(true, response.statusCode, response.body);
	  }
	  
	  return uploadResult;
	};
	
	module.exports = BlobUploadResult;


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	
	'use strict';
	
	var ArgumentError = __webpack_require__(19).errors.ArgumentError;
	
	function BlobUploader(storageApi) {
	  if (storageApi) {
	    /*Codes_SRS_NODE_DEVICE_BLOB_UPLOAD_16_008: [`BlobUploader` should use the `storageApi` object to upload data if `storageApi` is truthy.]*/
	    this.storageApi = storageApi;
	  } else {
	    /*Codes_SRS_NODE_DEVICE_BLOB_UPLOAD_06_001: [`BlobUploader` should denote delay loading with null for the storageApi property if `storageApi` is falsy]*/
	    this.storageApi = null;
	  }
	}
	
	BlobUploader.prototype.uploadToBlob = function uploadToBlob (blobInfo, stream, streamLength, done) {
	  /*Codes_SRS_NODE_DEVICE_BLOB_UPLOAD_16_001: [`uploadToBlob` shall throw a `ReferenceError` if `blobInfo` is falsy.]*/
	  if (!blobInfo) throw new ReferenceError('blobInfo cannot be \'' + blobInfo + '\'');
	  /*Codes_SRS_NODE_DEVICE_BLOB_UPLOAD_16_002: [`uploadToBlob` shall throw a `ReferenceError` if `stream` is falsy.]*/
	  if (!stream) throw new ReferenceError('stream cannot be \'' + stream + '\'');
	  /*Codes_SRS_NODE_DEVICE_BLOB_UPLOAD_16_003: [`uploadToBlob` shall throw a `ReferenceError` if `streamSize` is falsy.]*/
	  if (!streamLength) throw new ReferenceError('streamLength cannot be \'' + streamLength + '\'');
	
	  /*Codes_SRS_NODE_DEVICE_BLOB_UPLOAD_16_004: [`uploadToBlob` shall throw an `ArgumentError` if `blobInfo` is missing one or more of the following properties: `hostName`, `containerName`, `blobName`, `sasToken`).]*/
	  if (!blobInfo.hostName || !blobInfo.containerName || !blobInfo.blobName || !blobInfo.sasToken) {
	    throw new ArgumentError('Invalid upload parameters');
	  }
	
	  if (!this.storageApi) {
	    /*Codes_SRS_NODE_DEVICE_BLOB_UPLOAD_06_002: [`BlobUploader` should delay load azure-storage into the storageAPI property if `storageApi` is falsy]*/
	    this.storageApi = __webpack_require__(267);
	  }
	  var blobService = this.storageApi.createBlobServiceWithSas(blobInfo.hostName, blobInfo.sasToken);
	  /*Codes_SRS_NODE_DEVICE_BLOB_UPLOAD_16_005: [`uploadToBlob` shall call the `done` calback with the result of the storage api call.]*/
	  blobService.createBlockBlobFromStream(blobInfo.containerName, blobInfo.blobName, stream, streamLength, done);
	};
	
	module.exports = BlobUploader;

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	
	'use strict';
	
	var endpoint = __webpack_require__(19).endpoint;
	var packageJson = __webpack_require__(371);
	var DefaultHttpTransport = __webpack_require__(258).Http;
	
	
	/**
	 * @class         module:azure-iot-device.FileUploadApi
	 * @classdesc     Provides methods to use Azure IoT Hub APIs that enable simple upload to a blob.
	 * 
	 * @params        {String}  deviceId   Device identifier.
	 * @params        {String}  hostname   Hostname of the Azure IoT Hub instance.
	 * @params        {Object}  transport  Transport layer that shall be used (HTTP or mock).
	 * 
	 * @throws        {ReferenceError}     Thrown if one of the parameters is falsy.
	 */
	/*Codes_SRS_NODE_FILE_UPLOAD_ENDPOINT_16_002: [`FileUploadApi` shall throw a `ReferenceError` if `deviceId` is falsy.]*/
	/*Codes_SRS_NODE_FILE_UPLOAD_ENDPOINT_16_003: [`FileUploadApi` shall throw a `ReferenceError` if `hostname` is falsy.]*/
	function FileUploadApi(deviceId, hostname, httpTransport) {
	  if (!deviceId) throw new ReferenceError('deviceId cannot be \'' + deviceId + '\'');
	  if (!hostname) throw new ReferenceError('hostname cannot be \'' + hostname + '\'');
	  
	  this.deviceId = deviceId;
	  this.hostname = hostname;
	  /*Codes_SRS_NODE_FILE_UPLOAD_ENDPOINT_16_018: [`FileUploadApi` shall instantiate the default `azure-iot-http-base.Http` transport if `transport` is not specified, otherwise it shall use the specified transport.]*/
	  this.http = httpTransport ? httpTransport : new DefaultHttpTransport();
	}
	
	FileUploadApi.prototype.getBlobSharedAccessSignature = function (blobName, auth, done) {
	  /*Codes_SRS_NODE_FILE_UPLOAD_ENDPOINT_16_004: [`getBlobSharedAccessSignature` shall throw a `ReferenceError` if `blobName` is falsy.]*/
	  /*Codes_SRS_NODE_FILE_UPLOAD_ENDPOINT_16_005: [`getBlobSharedAccessSignature` shall throw a `ReferenceError` if `auth` is falsy.]*/
	  if (!blobName) throw new ReferenceError('blobName cannot be \'' + blobName + '\'');
	  if (!auth) throw new ReferenceError('auth cannot be \'' + auth + '\'');
	
	  /*Codes_SRS_NODE_FILE_UPLOAD_ENDPOINT_16_006: [`getBlobSharedAccessSignature` shall create a `GET` HTTP request to a path formatted as the following:`/devices/<deviceId>/files/<filename>?api-version=<api-version>]*/
	  var path = endpoint.devicePath(this.deviceId) + '/files/' + blobName + endpoint.versionQueryString();
	
	  /*Codes_SRS_NODE_FILE_UPLOAD_ENDPOINT_16_007: [The `GET` HTTP request shall have the following headers:
	  ```
	  Accept: 'application/json'
	  Host: <hostname>
	  Authorization: <iotHubSas>
	  'User-Agent': <sdk name and version>,
	  ```]*/
	  var headers = {
	    Accept: 'application/json',
	    Host: this.hostname,
	    'User-Agent': packageJson.name + '/' + packageJson.version,
	  };
	
	  var x509Opts = null;
	  if (typeof auth === 'string') {
	    headers.Authorization  = auth;
	  } else {
	    x509Opts = auth;
	  }
	
	  var req = this.http.buildRequest('GET', path, headers, this.hostname, x509Opts, function (err, body, response) {
	    if (err) {
	      err.responseBody = body;
	      err.response = response;
	      /*Codes_SRS_NODE_FILE_UPLOAD_ENDPOINT_16_008: [`getBlobSasUri` shall call the `done` callback with an `Error` object if the request fails.]*/
	      done(err);
	    } else {
	      /*Codes_SRS_NODE_FILE_UPLOAD_ENDPOINT_16_009: [`getBlobSasUri` shall call the `done` callback with a `null` error object and a result object containing a correlation ID and a SAS parameters if the request succeeds]*/
	      var result = JSON.parse(body);
	      done(null, result);
	    }
	  });
	  req.end();
	};
	
	FileUploadApi.prototype.notifyUploadComplete = function (correlationId, auth, uploadResult, done) {
	  /*Codes_SRS_NODE_FILE_UPLOAD_ENDPOINT_16_010: [`notifyUploadComplete` shall throw a `ReferenceError` if `correlationId` is falsy.]*/
	  /*Codes_SRS_NODE_FILE_UPLOAD_ENDPOINT_16_011: [`notifyUploadComplete` shall throw a `ReferenceError` if `auth` is falsy.]*/
	  /*Codes_SRS_NODE_FILE_UPLOAD_ENDPOINT_16_012: [`notifyUploadComplete` shall throw a `ReferenceError` if `uploadResult` is falsy.]*/
	  if (!correlationId) throw new ReferenceError('correlationId cannot be \'' + correlationId + '\'');
	  if (!auth) throw new ReferenceError('auth cannot be \'' + auth + '\'');
	  if (!uploadResult) throw new ReferenceError('uploadResult cannot be \'' + uploadResult + '\'');
	
	  /*Codes_SRS_NODE_FILE_UPLOAD_ENDPOINT_16_013: [`notifyUploadComplete` shall create a `POST` HTTP request to a path formatted as the following:`/devices/<deviceId>/files/<correlationId>?api-version=<api-version>`]*/
	  var path = endpoint.devicePath(this.deviceId) + '/files/notifications/' + encodeURIComponent(correlationId) + endpoint.versionQueryString();
	  var body = JSON.stringify(uploadResult);
	  
	  /*Codes_SRS_NODE_FILE_UPLOAD_ENDPOINT_16_014: [The `POST` HTTP request shall have the following headers:
	  ```
	  Host: <hostname>,
	  Authorization: <sharedAccessSignature>,
	  'User-Agent': <version>,
	  'Content-Type': 'application/json; charset=utf-8',
	  'Content-Length': <content length>,
	  'iothub-name': <hub name>
	  ```]*/
	  var headers = {
	    Host: this.hostname,
	    'User-Agent': packageJson.name + '/' + packageJson.version,
	    'Content-Type': 'application/json; charset=utf-8',
	    'Content-Length': body.length,
	    'iothub-name': this.hostname.split('.')[0]
	  };
	
	  var x509Opts = null;
	  if (typeof auth === 'string') {
	    headers.Authorization  = auth;
	  } else {
	    x509Opts = auth;
	  }
	
	  var req = this.http.buildRequest('POST', path, headers, this.hostname, x509Opts, function (err) {
	    if (err) {
	      /*Codes_SRS_NODE_FILE_UPLOAD_ENDPOINT_16_016: [** `notifyUploadComplete` shall call the `done` callback with an `Error` object if the request fails.]*/
	      done(err);
	    } else {
	      /*Codes_SRS_NODE_FILE_UPLOAD_ENDPOINT_16_017: [** `notifyUploadComplete` shall call the `done` callback with no parameters if the request succeeds.]*/
	      done();
	    }
	  });
	  req.write(body);
	  req.end();
	};
	
	module.exports = FileUploadApi;

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	
	'use strict';
	
	module.exports = {
	  BlobUploadClient: __webpack_require__(242),
	  errors: __webpack_require__(124)
	};

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	
	'use strict';
	
	var EventEmitter = __webpack_require__(14).EventEmitter;
	var util = __webpack_require__(4);
	var debug = __webpack_require__(157)('azure-iot-device.Client');
	var machina = __webpack_require__(384);
	
	var anHourFromNow = __webpack_require__(19).anHourFromNow;
	var results = __webpack_require__(19).results;
	var errors = __webpack_require__(19).errors;
	var ConnectionString = __webpack_require__(125);
	var SharedAccessSignature = __webpack_require__(127);
	var BlobUploadClient = __webpack_require__(246).BlobUploadClient;
	var DeviceMethodRequest = __webpack_require__(126).DeviceMethodRequest;
	var DeviceMethodResponse = __webpack_require__(126).DeviceMethodResponse;
	
	function safeCallback(callback, error, result) {
	  if (callback) callback(error, result);
	}
	
	/**
	 * @class           module:azure-iot-device.Client
	 * @classdesc       Creates an IoT Hub device client. Normally, consumers will
	 *                  call the factory method,
	 *                  {@link module:azure-iot-device.Client.fromConnectionString|fromConnectionString},
	 *                  to create an IoT Hub device client.
	 * @param {Object}  transport         An object that implements the interface
	 *                                    expected of a transport object, e.g.,
	 *                                    {@link module:azure-iot-device~Http|Http}.
	 * @param {String}  connStr           A connection string (optional: when not provided, updateSharedAccessSignature must be called to set the SharedAccessSignature token directly).
	 * @param {Object}  blobUploadClient  An object that is capable of uploading a stream to a blob.
	 */
	var Client = function (transport, connStr, blobUploadClient) {
	  EventEmitter.call(this);
	  /*Codes_SRS_NODE_DEVICE_CLIENT_05_001: [The Client constructor shall throw ReferenceError if the transport argument is falsy.]*/
	  if (!transport) throw new ReferenceError('transport is \'' + transport + '\'');
	
	  /*Codes_SRS_NODE_DEVICE_CLIENT_16_026: [The Client constructor shall accept a connection string as an optional second argument] */
	  this._connectionString = connStr;
	
	  if (this._connectionString && ConnectionString.parse(this._connectionString).SharedAccessKey) {
	    /*Codes_SRS_NODE_DEVICE_CLIENT_16_027: [If a connection string argument is provided and is using SharedAccessKey authentication, the Client shall automatically generate and renew SAS tokens.] */
	    this._sasRenewalTimeout = setTimeout(this._renewSharedAccessSignature.bind(this), Client.sasRenewalInterval); 
	  }
	
	  this.blobUploadClient = blobUploadClient;
	
	  this._transport = transport;
	  this._receiver = null;
	  this._methodCallbackMap = {};
	  var thisClient = this;
	
	  this.on('removeListener', function (eventName) {
	    if (thisClient._receiver && eventName === 'message' && thisClient.listeners('message').length === 0) {
	      thisClient._disconnectReceiver();
	    }
	  });
	
	  this.on('newListener', function (eventName) {
	    if (eventName === 'message') {
	      /* Schedules the startReceiver() on the next tick because the event handler for the 
	       * 'message' event is only added after this handler (for 'newListener') finishes and
	       * the state machine depends on having an event handler on 'message' to determine if 
	       * it should connect the receiver, depending on its state.
	       */
	      process.nextTick(function() { 
	        thisClient._fsm.handle('startReceiver');
	      });
	    }
	  });
	
	  function _closeTransport(closeCallback) {
	    function onDisconnected(err, result) {
	      thisClient._fsm.transition('disconnected');
	      /*Codes_SRS_NODE_DEVICE_CLIENT_16_056: [The `close` method shall not throw if the `closeCallback` is not passed.]*/
	      /*Codes_SRS_NODE_DEVICE_CLIENT_16_055: [The `close` method shall call the `closeCallback` function when done with either a single Error object if it failed or null and a results.Disconnected object if successful.]*/
	      safeCallback(closeCallback, err, result);
	    }
	
	    if (thisClient._sasRenewalTimeout) {
	      clearTimeout(thisClient._sasRenewalTimeout);
	    }
	    if (thisClient._isImplementedInTransport('disconnect')) {
	      /*Codes_SRS_NODE_DEVICE_CLIENT_16_001: [The `close` function shall call the transport's `disconnect` function if it exists.]*/
	      thisClient._transport.disconnect(function(disconnectError, disconnectResult) {
	        /*Codes_SRS_NODE_DEVICE_CLIENT_16_046: [The `close` method shall remove the listener that has been attached to the transport `disconnect` event.]*/
	        thisClient._transport.removeListener('disconnect', thisClient._disconnectHandler);
	        onDisconnected(disconnectError, disconnectResult);
	      });
	    } else {
	      onDisconnected(null, new results.Disconnected());
	    }
	  }
	
	  this._fsm = new machina.Fsm({
	    namespace: 'device-client',
	    initialState: 'disconnected',
	    states: {
	      'disconnected': {
	        open: function(openCallback) {
	          var transportConnectedCallback = function(err, result) {
	            thisClient._fsm.transition(!!err ? 'disconnected' : 'connected');
	            /*Codes_SRS_NODE_DEVICE_CLIENT_16_060: [The `open` method shall call the `openCallback` callback with a null error object and a `results.Connected()` result object if the transport is already connected, doesn't need to connect or has just connected successfully.]*/
	            safeCallback(openCallback, err, result);
	          };
	
	          this.transition('connecting');
	          if (thisClient._isImplementedInTransport('connect')) {
	            thisClient._transport.connect(function(connectErr, connectResult) {
	              /*Codes_SRS_NODE_DEVICE_CLIENT_16_045: [If the transport successfully establishes a connection the `open` method shall subscribe to the `disconnect` event of the transport.]*/
	              thisClient._transport.removeListener('disconnect', thisClient._disconnectHandler); // remove the old one before adding a new -- this can happen when renewing SAS tokens
	              thisClient._transport.on('disconnect', thisClient._disconnectHandler);
	              transportConnectedCallback(connectErr, connectResult);
	            });
	          } else {
	            transportConnectedCallback(null, new results.Connected());
	          }
	        },
	        close: function(closeCallback) {
	          /*Codes_SRS_NODE_DEVICE_CLIENT_16_058: [The `close` method shall immediately call the `closeCallback` function if provided and the transport is already disconnected.]*/
	          safeCallback(closeCallback, null, new results.Disconnected());
	        },
	        updateSharedAccessSignature: function(newSas, updateSasCallback) {
	          thisClient._transport.updateSharedAccessSignature(newSas, updateSasCallback);
	        },
	        startReceiver: function() {
	          this.deferUntilTransition('connected');
	          this.handle('open', function(err) {
	            if(err) {
	              thisClient.emit('error', err);
	            }
	          });
	        },
	        getTwin: function(callback) {
	          this.deferUntilTransition('connected');
	          this.handle('open', function(err) {
	            if(err) {
	              callback(err);
	            }
	          });
	        },
	        '*': function(method, message, callback) {
	          this.deferUntilTransition('connected');
	          this.handle('open', function(err) {
	            if(err) {
	              callback(err);
	            }
	          });
	        }
	      },
	      'connecting': {
	        /*Codes_SRS_NODE_DEVICE_CLIENT_16_001: [The `close` function shall call the transport's `disconnect` function if it exists.]*/
	        close: function(closeCallback) {
	          _closeTransport(closeCallback);
	        },
	        '*': function() {
	          this.deferUntilTransition();
	        }
	      },
	      'connected': {
	        _onEnter: function() {
	          /*Codes_SRS_NODE_DEVICE_CLIENT_16_065: [The client shall connect the transport if needed to subscribe receive messages.]*/
	          if (!thisClient._receiver) {
	            if ((thisClient.listeners('message').length > 0) || (Object.keys(thisClient._methodCallbackMap).length > 0)) {
	              thisClient._connectReceiver();
	            }
	          }
	        },
	        _onExit: function() {
	          thisClient._disconnectReceiver();
	          thisClient._receiver = null;
	        },
	        /*Codes_SRS_NODE_DEVICE_CLIENT_16_060: [The `open` method shall call the `openCallback` callback with a null error object and a `results.Connected()` result object if the transport is already connected, doesn't need to connect or has just connected successfully.]*/
	        open: function(openCallback) {
	          /*Codes_SRS_NODE_DEVICE_CLIENT_16_061: [The `open` method shall not throw if the `openCallback` callback has not been provided.]*/
	          safeCallback(openCallback, null, new results.Connected());
	        },
	        close: function (closeCallback) {
	          this.transition('disconnecting');
	          _closeTransport(function(err, result) {
	            this.transition('disconnected');
	            safeCallback(closeCallback, err, result);
	          }.bind(this));
	        },
	        sendEvent: function (msg, sendEventCallback) {
	          /*Codes_SRS_NODE_DEVICE_CLIENT_16_081: [The `sendEvent` method shall throw a `NotImplementedError` if the transport doesn't have that feature.]*/
	          if (thisClient._isImplementedInTransport('sendEvent')) {
	            thisClient._transport.sendEvent(msg, function(err, result) {
	              safeCallback(sendEventCallback, err, result);
	            });
	          } else {
	            throw new errors.NotImplementedError('sendEvent is not supported with ' + thisClient._transport.constructor.name);
	          }
	        },
	        sendEventBatch: function (msgBatch, sendEventBatchCallback) {
	          /*Codes_SRS_NODE_DEVICE_CLIENT_16_082: [The `sendEventBatch` method shall throw a `NotImplementedError` if the transport doesn't have that feature.]*/
	          if (thisClient._isImplementedInTransport('sendEventBatch')) {
	            thisClient._transport.sendEventBatch(msgBatch, function(err, result) {
	              safeCallback(sendEventBatchCallback, err, result);
	            });
	          } else {
	            throw new errors.NotImplementedError('sendEventBatch is not supported with ' + thisClient._transport.constructor.name);
	          }
	        },
	        updateSharedAccessSignature: function(sharedAccessSignature, updateSasCallback) {
	          this.transition('updating_sas');
	          function safeUpdateSasCallback(err, result) {
	            if (err) {
	              thisClient._fsm.transition('disconnected');
	            } else {
	              thisClient._fsm.transition('connected');
	            }
	            safeCallback(updateSasCallback, err, result);
	          }
	
	          thisClient.blobUploadClient.updateSharedAccessSignature(sharedAccessSignature);
	          if (thisClient._twin) {
	            thisClient._twin.updateSharedAccessSignature();
	          }
	
	          /*Codes_SRS_NODE_DEVICE_CLIENT_16_032: [The updateSharedAccessSignature method shall call the updateSharedAccessSignature method of the transport currently inuse with the sharedAccessSignature parameter.]*/
	          thisClient._transport.updateSharedAccessSignature(sharedAccessSignature, function (err, result) {
	            if (err) {
	              /*Codes_SRS_NODE_DEVICE_CLIENT_16_035: [The updateSharedAccessSignature method shall call the `updateSasCallback` callback with an error object if an error happened while renewng the token.]*/
	              safeUpdateSasCallback(err);
	            } else {
	              debug('sas token updated: ' + result.constructor.name + ' needToReconnect: ' + result.needToReconnect);
	              /*Codes_SRS_NODE_DEVICE_CLIENT_16_033: [The updateSharedAccessSignature method shall reconnect the transport to the IoTHub service if it was connected before before the method is clled.]*/
	              /*Codes_SRS_NODE_DEVICE_CLIENT_16_034: [The updateSharedAccessSignature method shall not reconnect the transport if the transport was disconnected to begin with.]*/
	              if (result.needToReconnect) {
	                thisClient._fsm.transition('connecting');
	                thisClient._transport.connect(function(connectErr) {
	                  if (connectErr) {
	                    safeUpdateSasCallback(connectErr);
	                  } else {
	                    thisClient._sasRenewalTimeout = setTimeout(thisClient._renewSharedAccessSignature.bind(thisClient), Client.sasRenewalInterval); 
	                    /*Codes_SRS_NODE_DEVICE_CLIENT_16_036: [The updateSharedAccessSignature method shall call the `updateSasCallback` callback with a null error object and a result of type SharedAccessSignatureUpdated if the oken was updated successfully.]*/
	                    safeUpdateSasCallback(null, new results.SharedAccessSignatureUpdated(false));
	                  }
	                });
	              } else {
	                thisClient._sasRenewalTimeout = setTimeout(thisClient._renewSharedAccessSignature.bind(thisClient), Client.sasRenewalInterval); 
	                /*Codes_SRS_NODE_DEVICE_CLIENT_16_036: [The updateSharedAccessSignature method shall call the `updateSasCallback` callback with a null error object and a result of type SharedAccessSignatureUpdated if the oken was updated successfully.]*/
	                safeUpdateSasCallback(null, new results.SharedAccessSignatureUpdated(false));
	              }
	            }
	          });
	        },
	        complete: function(message, completeCallback) {
	          /*Codes_SRS_NODE_DEVICE_CLIENT_16_078: [The `complete` method shall throw a `NotImplementedError` if the transport doesn't have that feature.]*/
	          if (thisClient._isImplementedInTransport('complete')) {
	            thisClient._transport.complete(message, function(err, result) {
	              safeCallback(completeCallback, err, result);
	            });
	          } else {
	            throw new errors.NotImplementedError('complete is not supported with ' + thisClient._transport.constructor.name);
	          }
	        },
	        abandon: function(message, abandonCallback) {
	          /*Codes_SRS_NODE_DEVICE_CLIENT_16_080: [The `abandon` method shall throw a `NotImplementedError` if the transport doesn't have that feature.]*/
	          if (thisClient._isImplementedInTransport('abandon')) {
	            thisClient._transport.abandon(message, function(err, result) {
	              safeCallback(abandonCallback, err, result);
	            });
	          } else {
	            throw new errors.NotImplementedError('abandon is not supported with ' + thisClient._transport.constructor.name);
	          }
	        },
	        reject: function(message, rejectCallback) {
	          /*Codes_SRS_NODE_DEVICE_CLIENT_16_079: [The `reject` method shall throw a `NotImplementedError` if the transport doesn't have that feature.]*/
	          if (thisClient._isImplementedInTransport('reject')) {
	            thisClient._transport.reject(message, function(err, result) {
	              safeCallback(rejectCallback, err, result);
	            });
	          } else {
	            throw new errors.NotImplementedError('reject is not supported with ' + thisClient._transport.constructor.name);
	          }
	        },
	        startReceiver: function() {
	          /*Codes_SRS_NODE_DEVICE_CLIENT_16_065: [The client shall connect the transport if needed to subscribe receive messages.]*/
	          if (!thisClient._receiver) {
	            thisClient._connectReceiver();
	          }
	        },
	        getTwin: function(done, twin) {
	          /* Codes_SRS_NODE_DEVICE_CLIENT_18_001: [** The `getTwin` method shall call the `azure-iot-device-core!Twin.fromDeviceClient` method to create the device client object. **]** */
	          /* Codes_SRS_NODE_DEVICE_CLIENT_18_002: [** The `getTwin` method shall pass itself as the first parameter to `fromDeviceClient` and it shall pass the `done` method as the second parameter. **]**  */
	          /* Codes_SRS_NODE_DEVICE_CLIENT_18_003: [** The `getTwin` method shall use the second parameter (if it is not falsy) to call `fromDeviceClient` on. **]**    */
	          (twin || __webpack_require__(250)).fromDeviceClient(thisClient, done);
	        }
	      },
	      'disconnecting': {
	        '*': function() {
	          this.deferUntilTransition();
	        }
	      },
	      'updating_sas': {
	        close: function (closeCallback) {
	          this.transition('disconnecting');
	          _closeTransport(function(err, result) {
	            this.transition('disconnected');
	            closeCallback(err, result);
	          }.bind(this));
	        },
	        '*': function() {
	          this.deferUntilTransition();
	        }
	      }
	    }
	  });
	  
	  this._fsm.on('transition', function (data) {
	    debug('Client state change: ' + data.fromState + ' -> ' + data.toState + ' (action: ' + data.action + ')');
	  });
	
	  this._disconnectHandler = function (err) {
	    thisClient._fsm.transition('disconnected');
	    thisClient.emit('disconnect', new results.Disconnected(err));
	  };
	};
	
	util.inherits(Client, EventEmitter);
	
	Client.prototype._validateDeviceMethodInputs = function(methodName, callback) {
	  // Codes_SRS_NODE_DEVICE_CLIENT_13_020: [ onDeviceMethod shall throw a ReferenceError if methodName is falsy. ]
	  if(!methodName) {
	    throw new ReferenceError('methodName cannot be \'' + methodName + '\'');
	  }
	  // Codes_SRS_NODE_DEVICE_CLIENT_13_024: [ onDeviceMethod shall throw a TypeError if methodName is not a string. ]
	  if(typeof(methodName) !== 'string') {
	    throw new TypeError('methodName\'s type is \'' + typeof(methodName) + '\'. A string was expected.');
	  }
	
	  // Codes_SRS_NODE_DEVICE_CLIENT_13_022: [ onDeviceMethod shall throw a ReferenceError if callback is falsy. ]
	  if(!callback) {
	    throw new ReferenceError('callback cannot be \'' + callback + '\'');
	  }
	
	  // Codes_SRS_NODE_DEVICE_CLIENT_13_025: [ onDeviceMethod shall throw a TypeError if callback is not a Function. ]
	  if(typeof(callback) !== 'function') {
	    throw new TypeError('callback\'s type is \'' + typeof(callback) + '\'. A function reference was expected.');
	  }
	
	  // Codes_SRS_NODE_DEVICE_CLIENT_13_021: [ onDeviceMethod shall throw an Error if the underlying transport does not support device methods. ]
	  if(!(this._transport.sendMethodResponse)) {
	    throw new Error('The transport for this client does not support device methods');
	  }
	
	  // Codes_SRS_NODE_DEVICE_CLIENT_13_023: [ onDeviceMethod shall throw an Error if a listener is already subscribed for a given method call. ]
	  if(!!(this._methodCallbackMap[methodName])) {
	    throw new Error('A handler for this method has already been registered with the client.');
	  }
	};
	
	/**
	 * @method            module:azure-iot-device.Client#onDeviceMethod
	 * @description       Registers the `callback` to be invoked when a
	 *                    cloud-to-device method call is received by the client
	 *                    for the given `methodName`.
	 *
	 * @param {String}   methodName   The name of the method for which the callback
	 *                                is to be registered.
	 * @param {Function} callback     The callback to be invoked when the C2D method
	 *                                call is received.
	 *
	 * @throws {ReferenceError}       If the `methodName` or `callback` parameter
	 *                                is falsy.
	 * @throws {TypeError}            If the `methodName` parameter is not a string
	 *                                or if the `callback` is not a function.
	 */
	Client.prototype.onDeviceMethod = function(methodName, callback) {
	  // validate input args
	  this._validateDeviceMethodInputs(methodName, callback);
	
	  // Codes_SRS_NODE_DEVICE_CLIENT_13_003: [ The client shall start listening for method calls from the service whenever there is a listener subscribed for a method callback. ]
	  this._methodCallbackMap[methodName] = callback;
	  if(!this._receiver) {
	    this._connectReceiver();
	  } else {
	    this._addMethodCallback(methodName, callback);
	  }
	};
	
	Client.prototype._addMethodCallback = function(methodName, callback) {
	  var self = this;
	  this._receiver.onDeviceMethod(methodName, function(message) {
	    // build the request object
	    var request = new DeviceMethodRequest(
	      message.requestId,
	      message.methods.methodName,
	      message.body
	    );
	
	    // build the response object
	    var response = new DeviceMethodResponse(message.requestId, self._transport);
	
	    // Codes_SRS_NODE_DEVICE_CLIENT_13_001: [ The onDeviceMethod method shall cause the callback function to be invoked when a cloud-to-device method invocation signal is received from the IoT Hub service. ]
	    callback(request, response);
	  });
	};
	
	// SAS token created by the client have a lifetime of 60 minutes, renew every 45 minutes
	Client.sasRenewalInterval = 2700000;
	
	Client.prototype._connectReceiver = function () {
	  debug('Getting receiver object from the transport');
	  var self = this;
	  this._transport.getReceiver(function (err, receiver) {
	    if (!err) {
	      debug('Subscribing to message events from the receiver object of the transport');
	      self._receiver = receiver;
	      self._receiver.on('message', function (msg) {
	        self.emit('message', msg);
	      });
	
	      // add listeners for all existing method callbacks
	      for (var methodName in self._methodCallbackMap) {
	        if (self._methodCallbackMap.hasOwnProperty(methodName)) {
	          var callback = self._methodCallbackMap[methodName];
	          self._addMethodCallback(methodName, callback);
	        }
	      }
	
	      /*Codes_SRS_NODE_DEVICE_CLIENT_16_006: [The ‘error’ event shall be emitted when an error occurred within the client code.] */
	      self._receiver.on('errorReceived', function (err) {
	        self.emit('error', err);
	      });
	    } else {
	      throw new Error('Transport failed to start receiving messages: ' + err.message);
	    }
	  });
	};
	
	Client.prototype._disconnectReceiver = function () {
	  if (this._receiver) {
	    this._receiver.removeAllListeners('message');
	    this._receiver = null;
	  }
	};
	
	Client.prototype._renewSharedAccessSignature = function () {
	  var cn = ConnectionString.parse(this._connectionString);
	  var sas = SharedAccessSignature.create(cn.HostName, cn.DeviceId, cn.SharedAccessKey, anHourFromNow());
	
	  this.updateSharedAccessSignature(sas.toString(), function (err) {
	    if (err) {
	      /*Codes_SRS_NODE_DEVICE_CLIENT_16_006: [The ‘error’ event shall be emitted when an error occurred within the client code.] */
	      this.emit('error', err);
	    } else {
	      this.emit('_sharedAccessSignatureUpdated');
	    }
	  }.bind(this));
	};
	
	Client.prototype._isImplementedInTransport = function(fnName) {
	  return typeof this._transport[fnName] === 'function';
	};
	
	/**
	 * @method            module:azure-iot-device.Client.fromConnectionString
	 * @description       Creates an IoT Hub device client from the given
	 *                    connection string using the given transport type.
	 *
	 * @param {String}    connStr       A connection string which encapsulates "device
	 *                                  connect" permissions on an IoT hub.
	 * @param {Function}  Transport     A transport constructor.
	 *
	 * @throws {ReferenceError}         If the connStr parameter is falsy.
	 *
	 * @returns {module:azure-iothub.Client}
	*/
	Client.fromConnectionString = function fromConnectionString(connStr, Transport) {
	  /*Codes_SRS_NODE_DEVICE_CLIENT_05_003: [The fromConnectionString method shall throw ReferenceError if the connStr argument is falsy.]*/
	  if (!connStr) throw new ReferenceError('connStr is \'' + connStr + '\'');
	
	  /*Codes_SRS_NODE_DEVICE_CLIENT_05_005: [fromConnectionString shall derive and transform the needed parts from the connection string in order to create a new instance of Transport.]*/
	  var cn = ConnectionString.parse(connStr);
	
	  var config = {
	    host: cn.HostName,
	    deviceId: cn.DeviceId,
	    hubName: cn.HostName.split('.')[0]
	  };
	
	  if (cn.hasOwnProperty('SharedAccessKey')) {
	    var sas = SharedAccessSignature.create(cn.HostName, cn.DeviceId, cn.SharedAccessKey, anHourFromNow());
	    config.sharedAccessSignature = sas.toString();
	  }
	
	  /*Codes_SRS_NODE_DEVICE_CLIENT_05_006: [The fromConnectionString method shall return a new instance of the Client object, as by a call to new Client(new Transport(...)).]*/
	  return new Client(new Transport(config), connStr, new BlobUploadClient(config));
	};
	
	/**
	 * @method            module:azure-iot-device.Client.fromSharedAccessSignature
	 * @description       Creates an IoT Hub device client from the given
	 *                    shared access signature using the given transport type.
	 *
	 * @param {String}    sharedAccessSignature      A shared access signature which encapsulates "device
	 *                                  connect" permissions on an IoT hub.
	 * @param {Function}  Transport     A transport constructor.
	 *
	 * @throws {ReferenceError}         If the connStr parameter is falsy.
	 *
	 * @returns {module:azure-iothub.Client}
	*/
	Client.fromSharedAccessSignature = function (sharedAccessSignature, Transport) {
	  /*Codes_SRS_NODE_DEVICE_CLIENT_16_029: [The fromSharedAccessSignature method shall throw a ReferenceError if the sharedAccessSignature argument is falsy.] */
	  if (!sharedAccessSignature) throw new ReferenceError('sharedAccessSignature is \'' + sharedAccessSignature + '\'');
	
	  var sas = SharedAccessSignature.parse(sharedAccessSignature);
	  var decodedUri = decodeURIComponent(sas.sr);
	  var uriSegments = decodedUri.split('/');
	  var config = {
	    host: uriSegments[0],
	    deviceId: uriSegments[uriSegments.length - 1],
	    hubName: uriSegments[0].split('.')[0],
	    sharedAccessSignature: sharedAccessSignature
	  };
	
	  /*Codes_SRS_NODE_DEVICE_CLIENT_16_030: [The fromSharedAccessSignature method shall return a new instance of the Client object] */
	  return new Client(new Transport(config), null, new BlobUploadClient(config));
	};
	
	/**
	 * @method            module:azure-iot-device.Client#updateSharedAccessSignature
	 * @description       Updates the Shared Access Signature token used by the transport to authenticate with the IoT Hub service.
	 *
	 * @param {String}   sharedAccessSignature   The new SAS token to use.
	 * @param {Function} done       The callback to be invoked when `updateSharedAccessSignature`
	 *                              completes execution.
	 *
	 * @throws {ReferenceError}     If the sharedAccessSignature parameter is falsy.
	 */
	Client.prototype.updateSharedAccessSignature = function (sharedAccessSignature, updateSasCallback) {
	  /*Codes_SRS_NODE_DEVICE_CLIENT_16_031: [The updateSharedAccessSignature method shall throw a ReferenceError if the sharedAccessSignature parameter is falsy.]*/
	  if (!sharedAccessSignature) throw new ReferenceError('sharedAccessSignature is falsy');
	  this._fsm.handle('updateSharedAccessSignature', sharedAccessSignature, updateSasCallback);
	};
	
	/**
	 * @method            module:azure-iot-device.Client#open
	 * @description       Call the transport layer CONNECT function if the
	 *                    transport layer implements it
	 *
	 * @param {Function} openCallback  The callback to be invoked when `open`
	 *                                 completes execution.
	 */
	Client.prototype.open = function (openCallback) {
	  this._fsm.handle('open', openCallback);
	};
	
	/*Codes_SRS_NODE_DEVICE_CLIENT_05_016: [When a Client method encounters an error in the transport, the callback function (indicated by the done argument) shall be invoked with the following arguments:
	err - the standard JavaScript Error object, with a response property that points to a transport-specific response object, and a responseBody property that contains the body of the transport response.]*/
	/*Codes_SRS_NODE_DEVICE_CLIENT_05_017: [With the exception of receive, when a Client method completes successfully, the callback function (indicated by the done argument) shall be invoked with the following arguments:
	err - null
	response - a transport-specific response object]*/
	
	
	/**
	 * @method            module:azure-iot-device.Client#sendEvent
	 * @description       The [sendEvent]{@linkcode Client#sendEvent} method sends an event message
	 *                    to the IoT Hub as the device indicated by the connection string passed
	 *                    via the constructor.
	 *
	 * @param {Message}  message            The [message]{@linkcode module:common/message.Message}
	 *                                      to be sent.
	 * @param {Function} sendEventCallback  The callback to be invoked when `sendEvent`
	         *                              completes execution.
	 * @see [Message]{@linkcode module:common/message.Message}
	 */
	Client.prototype.sendEvent = function (message, sendEventCallback) {
	  /*Codes_SRS_NODE_DEVICE_CLIENT_05_007: [The sendEvent method shall send the event indicated by the message argument via the transport associated with the Client instance.]*/
	  this._fsm.handle('sendEvent', message, sendEventCallback);
	};
	
	/**
	 * @method            module:azure-iot-device.Client#sendEventBatch
	 * @description       The [sendEventBatch]{@linkcode Client#sendEventBatch} method sends a list
	 *                    of event messages to the IoT Hub as the device indicated by the connection
	 *                    string passed via the constructor.
	 *
	 * @param {array<Message>} messages               Array of [Message]{@linkcode module:common/message.Message}
	 *                                                objects to be sent as a batch.
	 * @param {Function}      sendEventBatchCallback  The callback to be invoked when
	 *                                                `sendEventBatch` completes execution.
	 */
	Client.prototype.sendEventBatch = function (messages, sendEventBatchCallback) {
	  /*Codes_SRS_NODE_DEVICE_CLIENT_05_008: [The sendEventBatch method shall send the list of events (indicated by the messages argument) via the transport associated with the Client instance.]*/
	  this._fsm.handle('sendEventBatch', messages, sendEventBatchCallback);
	};
	
	/**
	 * @method           module:azure-iot-device.Client#close
	 * @description      The `close` method directs the transport to close the current connection to the IoT Hub instance
	
	 * @param {Function} closeCallback    The callback to be invoked when the connection has been closed.
	 */
	Client.prototype.close = function (closeCallback) {
	  this._fsm.handle('close', closeCallback);
	};
	
	/**
	 * @deprecated      Use Client.setOptions instead.
	 * @method          module:azure-iot-device.Client#setTransportOptions
	 * @description     The `setTransportOptions` method configures transport-specific options for the client and its underlying transport object.
	 *
	 * @param {Object}      options     The options that shall be set (see transports documentation).
	 * @param {Function}    done        The callback that shall be invoked with either an error or a result object.
	 */
	Client.prototype.setTransportOptions = function (options, done) {
	  /*Codes_SRS_NODE_DEVICE_CLIENT_16_024: [The ‘setTransportOptions’ method shall throw a ‘ReferenceError’ if the options object is falsy] */
	  if (!options) throw new ReferenceError('options cannot be falsy.');
	  /*Codes_SRS_NODE_DEVICE_CLIENT_16_025: [The ‘setTransportOptions’ method shall throw a ‘NotImplementedError’ if the transport doesn’t implement a ‘setOption’ method.] */
	  if (typeof this._transport.setOptions !== 'function') throw new errors.NotImplementedError('setOptions does not exist on this transport');
	
	  var clientOptions = {
	    http: {
	      receivePolicy: options
	    }
	  };
	
	  /*Codes_SRS_NODE_DEVICE_CLIENT_16_021: [The ‘setTransportOptions’ method shall call the ‘setOptions’ method on the transport object.]*/
	  this._transport.setOptions(clientOptions, function(err) {
	    if (err) {
	      done(err);
	    } else {
	      done(null, new results.TransportConfigured());
	    }
	  });
	};
	
	/**
	 * @method          module:azure-iot-device.Client#setOptions
	 * @description     The `setOptions` method let the user configure the client.
	 * 
	 * @param  {Object}    options  The options structure
	 * @param  {Function}  done     The callback that shall be called when setOptions is finished.
	 * 
	 * @throws {ReferenceError}     If the options structure is falsy
	 */
	
	Client.prototype.setOptions = function (options, done) {
	  /*Codes_SRS_NODE_DEVICE_CLIENT_16_042: [The `setOptions` method shall throw a `ReferenceError` if the options object is falsy.]*/
	  if (!options) throw new ReferenceError('options cannot be falsy.');
	
	  this._transport.setOptions(options, function(err) {
	    /*Codes_SRS_NODE_DEVICE_CLIENT_16_043: [The `done` callback shall be invoked no parameters when it has successfully finished setting the client and/or transport options.]*/
	    /*Codes_SRS_NODE_DEVICE_CLIENT_16_044: [The `done` callback shall be invoked with a standard javascript `Error` object and no result object if the client could not be configured as requested.]*/
	    if (done) {
	      done(err);
	    }
	  });
	};
	
	/**
	 * @method           module:azure-iot-device.Client#complete
	 * @description      The `complete` method directs the transport to settle the message passed as argument as 'completed'.
	 *
	 * @param {Message}  message           The message to settle.
	 * @param {Function} completeCallback  The callback to call when the message is completed.
	 *
	 * @throws {ReferenceError} If the message is falsy.
	 */
	Client.prototype.complete = function (message, completeCallback) {
	  /*Codes_SRS_NODE_DEVICE_CLIENT_16_016: [The ‘complete’ method shall throw a ReferenceError if the ‘message’ parameter is falsy.] */
	  if (!message) throw new ReferenceError('message is \'' + message + '\'');
	
	  this._fsm.handle('complete', message, completeCallback);
	};
	
	/**
	 * @method           module:azure-iot-device.Client#reject
	 * @description      The `reject` method directs the transport to settle the message passed as argument as 'rejected'.
	 *
	 * @param {Message}  message         The message to settle.
	 * @param {Function} rejectCallback  The callback to call when the message is rejected.
	 *
	 * @throws {ReferenceException} If the message is falsy.
	 */
	Client.prototype.reject = function (message, rejectCallback) {
	  /*Codes_SRS_NODE_DEVICE_CLIENT_16_018: [The reject method shall throw a ReferenceError if the ‘message’ parameter is falsy.] */
	  if (!message) throw new ReferenceError('message is \'' + message + '\'');
	
	  this._fsm.handle('reject', message, rejectCallback);
	};
	
	/**
	 * @method           module:azure-iot-device.Client#abandon
	 * @description      The `abandon` method directs the transport to settle the message passed as argument as 'abandoned'.
	 *
	 * @param {Message}  message          The message to settle.
	 * @param {Function} abandonCallback  The callback to call when the message is abandoned.
	 *
	 * @throws {ReferenceException} If the message is falsy.
	 */
	Client.prototype.abandon = function (message, abandonCallback) {
	  /*Codes_SRS_NODE_DEVICE_CLIENT_16_017: [The abandon method shall throw a ReferenceError if the ‘message’ parameter is falsy.] */
	  if (!message) throw new ReferenceError('message is \'' + message + '\'');
	
	  this._fsm.handle('abandon', message, abandonCallback);
	};
	
	/**
	 * @method           module:azure-iot-device.Client#uploadToBlob
	 * @description      The `uploadToBlob` method uploads a stream to a blob.
	 *
	 * @param {String}   blobName         The name to use for the blob that will be created with the content of the stream.
	 * @param {Stream}   stream           The data to that should be uploaded to the blob.
	 * @param {Number}   streamLength     The size of the data to that should be uploaded to the blob.
	 * @param {Function} done             The callback to call when the upload is complete.
	 *
	 * @throws {ReferenceException} If blobName or stream or streamLength is falsy.
	 */
	Client.prototype.uploadToBlob = function (blobName, stream, streamLength, done) {
	  /*Codes_SRS_NODE_DEVICE_CLIENT_16_037: [The `uploadToBlob` method shall throw a `ReferenceError` if `blobName` is falsy.]*/
	  if (!blobName) throw new ReferenceError('blobName cannot be \'' + blobName + '\'');
	  /*Codes_SRS_NODE_DEVICE_CLIENT_16_038: [The `uploadToBlob` method shall throw a `ReferenceError` if `stream` is falsy.]*/
	  if (!stream) throw new ReferenceError('stream cannot be \'' + stream + '\'');
	  /*Codes_SRS_NODE_DEVICE_CLIENT_16_039: [The `uploadToBlob` method shall throw a `ReferenceError` if `streamLength` is falsy.]*/
	  if (!streamLength) throw new ReferenceError('streamLength cannot be \'' + streamLength + '\'');
	
	  /*Codes_SRS_NODE_DEVICE_CLIENT_16_040: [The `uploadToBlob` method shall call the `done` callback with an `Error` object if the upload fails.]*/
	  /*Codes_SRS_NODE_DEVICE_CLIENT_16_041: [The `uploadToBlob` method shall call the `done` callback no parameters if the upload succeeds.]*/
	  this.blobUploadClient.uploadToBlob(blobName, stream, streamLength, done);
	};
	
	/**
	 * @method           module:azure-iot-device.Client#getTwin
	 * @description      The `getTwin` method creates a Twin object and establishes a connection with the Twin service.
	 *
	 * @param {Function} done             The callback to call when the connection is established.
	 *
	 */
	Client.prototype.getTwin = function(done, twin) {
	  this._fsm.handle('getTwin', done, twin);
	};
	
	module.exports = Client;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ },
/* 248 */
/***/ function(module, exports) {

	// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	
	'use strict';
	
	/**
	 * @class           module:azure-iot-device.deviceMethod.DeviceMethodRequest
	 * @classdesc       `DeviceMethodRequest` is a class that captures the data
	 *                  passed in from the service when a device method call is
	 *                  made. An instance of this class is passed as the second
	 *                  parameter to the callback registered via the
	 *                  {@link module:azure-iot-device.Client#onDeviceMethod} method.
	 * @param {String}  requestId         The request identifier supplied by the
	 *                                    service for this device method call.
	 * @param {String}  methodName        The name of the method to be called.
	 * @param {Buffer}  body              A Node `Buffer` representing the payload
	 *                                    of the method call request.
	 */
	function DeviceMethodRequest(requestId, methodName, body) {
	  // Codes_SRS_NODE_DEVICE_METHOD_REQUEST_13_002: [ DeviceMethodRequest shall throw an Error if requestId is an empty string. ]
	  if(typeof(requestId) === 'string' && requestId.length === 0) {
	    throw new Error('requestId must not be an empty string');
	  }
	  // Codes_SRS_NODE_DEVICE_METHOD_REQUEST_13_001: [ DeviceMethodRequest shall throw a ReferenceError if requestId is falsy or is not a string. ]
	  if(typeof(requestId) !== 'string') {
	    throw new ReferenceError('requestId must be a string');
	  }
	
	  // Codes_SRS_NODE_DEVICE_METHOD_REQUEST_13_004: [ DeviceMethodRequest shall throw an Error if methodName is an empty string. ]
	  if(typeof(methodName) === 'string' && methodName.length === 0) {
	    throw new Error('methodName must not be an empty string');
	  }
	  // Codes_SRS_NODE_DEVICE_METHOD_REQUEST_13_003: [ DeviceMethodRequest shall throw a ReferenceError if methodName is falsy or is not a string. ]
	  if(typeof(methodName) !== 'string') {
	    throw new ReferenceError('methodName must be a string');
	  }
	
	  this.requestId = requestId;
	  this.methodName = methodName;
	  this.payload = JSON.parse(body.toString());
	}
	
	module.exports = DeviceMethodRequest;


/***/ },
/* 249 */
/***/ function(module, exports) {

	// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	
	'use strict';
	
	/**
	 * @class           module:azure-iot-device.deviceMethod.DeviceMethodResponse
	 * @classdesc       `DeviceMethodResponse` provides functionality that allows
	 *                  a device method implementation to construct and send a
	 *                  response back to the service for a device method call. An
	 *                  instance of this class is passed as the second parameter
	 *                  to the callback registered via the
	 *                  {@link module:azure-iot-device.Client#onDeviceMethod} method.
	 *                  method.
	 * @param {String}  requestId         The request identifier supplied by the
	 *                                    service for this device method call.
	 * @param {Object}  transport         An object that implements the interface
	 *                                    expected of a transport object, e.g.,
	 *                                    {@link module:azure-iot-device~Http|Http}.
	 */
	function DeviceMethodResponse(requestId, transport) {
	  // Codes_SRS_NODE_DEVICE_METHOD_RESPONSE_13_002: [ DeviceMethodRequest shall throw an Error if requestId is an empty string. ]
	  if(typeof(requestId) === 'string' && requestId.length === 0) {
	    throw new Error('requestId must not be an empty string');
	  }
	
	  // Codes_SRS_NODE_DEVICE_METHOD_RESPONSE_13_001: [ DeviceMethodRequest shall throw a ReferenceError if requestId is falsy or is not a string. ]
	  if(typeof(requestId) !== 'string') {
	    throw new ReferenceError('requestId must be a string');
	  }
	
	  // Codes_SRS_NODE_DEVICE_METHOD_RESPONSE_13_006: [ DeviceMethodResponse shall throw a ReferenceError if transport is falsy. ]
	  if (!transport) throw new ReferenceError('transport is \'' + transport + '\'');
	
	  this.requestId = requestId;
	  this.isResponseComplete = false;
	  this.status = null;
	  this.payload = null;
	  this._transport = transport;
	}
	
	/**
	 * @method            module:azure-iot-device.deviceMethod.DeviceMethodResponse#send
	 * @description       Sends the device method's response back to the service via
	 *                    the underlying transport object using the status parameter
	 *                    as the status of the method call.
	 *
	 * @param {Number}    status      A numeric status code to be sent back to the
	 *                                service.
	 * @param {Object}    payload     [optional] The payload of the method response.
	 * @param {Function}  done        [optional] A callback function which will be
	 *                                called once the response has been sent back to
	 *                                the service. An error object is passed as an
	 *                                argument to the function in case an error
	 *                                occurs.
	 *
	 * @throws {ReferenceError}       If the `status` parameter is not a number.
	 * @throws {Error}                If this response has already been sent to the
	 *                                service in a previous call to it. This method
	 *                                should be called only once.
	 */
	DeviceMethodResponse.prototype.send = function(status, payload, done) {
	  // Codes_SRS_NODE_DEVICE_METHOD_RESPONSE_13_009: [ DeviceMethodResponse.send shall throw an Error object if it is called more than once for the same request. ]
	  if(this.isResponseComplete) {
	    throw new Error('This response has already ended. Cannot end the same response more than once.');
	  }
	
	  if(typeof(status) !== 'number') {
	    // Codes_SRS_NODE_DEVICE_METHOD_RESPONSE_13_007: [ DeviceMethodResponse.end shall throw a ReferenceError if status is undefined or not a number. ]
	    throw new ReferenceError('"status" is "' + status + '". Expected a number.');
	  }
	
	  if (typeof(payload) === 'function') {
	    if (done !== undefined) {
	      throw new Error('Callback must be the last argument');
	    } else {
	      done = payload;
	      payload = null;
	    }
	  }
	
	  this.status = status;
	  this.payload = payload;
	
	  this.isResponseComplete = true;
	  // Codes_SRS_NODE_DEVICE_METHOD_RESPONSE_13_008: [ DeviceMethodResponse.send shall notify the service and supply the response for the request along with the status by calling sendMethodResponse on the underlying transport object. ]
	  // Codes_SRS_NODE_DEVICE_METHOD_RESPONSE_13_010: [ DeviceMethodResponse.send shall invoke the callback specified by done if it is not falsy. ]
	  // Codes_SRS_NODE_DEVICE_METHOD_RESPONSE_13_011: [ DeviceMethodResponse.send shall pass the status of sending the response to the service to done. ]
	  this._transport.sendMethodResponse(this, done);
	};
	
	module.exports = DeviceMethodResponse;


/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	
	'use strict';
	
	var EventEmitter = __webpack_require__(14).EventEmitter;
	var util = __webpack_require__(4);
	var errors = __webpack_require__(19).errors;
	var _ = __webpack_require__(383);
	var traverse = __webpack_require__(523);
	__webpack_require__(352);
	var translateError = __webpack_require__(251);
	
	var Twin = function(client) {
	  EventEmitter.call(this);
	
	  this._client = client;
	  this._rid = 4200;   // arbitrary starting value.  
	};
	
	util.inherits(Twin, EventEmitter);
	
	Twin.timeout = 1000;
	
	Twin.errorEvent = 'error';
	Twin.subscribedEvent = 'subscribed';
	
	Twin.responseEvent = 'response';
	Twin.postEvent = 'post';
	
	Twin.desiredPath = 'properties.desired';
	
	/**
	 * @method          module:azure-iot-device.Twin#fromDeviceClient
	 * @description     Get a Twin object for the given client connection
	 *
	 * @param {Object}      client  The [client]{@link module:azure-iot-device.Client} object that this Twin object is associated with.
	 *
	 * @param {Function}      done  the callback to be invoked when this function completes.
	 *
	 * @throws {ReferenceError}   One of the required parameters is falsy
	 */
	
	Twin.fromDeviceClient = function(client, done) {
	  /* Codes_SRS_NODE_DEVICE_TWIN_18_002: [** `fromDeviceclient` shall throw `ReferenceError` if the `client` object is falsy **]** */
	  if (!client) {
	    throw new ReferenceError('client parameter is required');
	  }
	  /* Codes_SRS_NODE_DEVICE_TWIN_18_030: [** `fromDeviceclient` shall throw `ReferenceError` if the `done` argument is falsy **]** */
	  if (!done) {
	    throw new ReferenceError('done parameter is required');
	  }
	
	  /* Codes_SRS_NODE_DEVICE_TWIN_18_028: [** if `fromDeviceClient` has previously been called for this client, it shall perform a GET operation and return the same object **]** */
	  if (client._twin) {
	    client._twin._getPropertiesFromService(function (err) {
	        done(err,client._twin);
	      });
	  } else {
	    /* Codes_SRS_NODE_DEVICE_TWIN_18_029: [** if `fromDeviceClient` is called with 2 different `client`s, it shall return 2 unique `Twin` objects **]** */
	    /* Codes_SRS_NODE_DEVICE_TWIN_18_003: [** `fromDeviceClient` shall allocate a new `Twin` object **]**  */
	    var twin = new Twin(client);
	
	    twin.on("newListener", twin._handleNewListener.bind(twin));
	
	    /* Codes_SRS_NODE_DEVICE_TWIN_18_005: [** If the protocol does not contain a `getTwinReceiver` method, `fromDeviceClient` shall throw a `NotImplementedError` error **]**  */
	    if (!client._transport.getTwinReceiver) {
	      throw new errors.NotImplementedError('transport does not support Twin');
	    } else {
	      client._twin = twin;
	      client.on('_sharedAccessSignatureUpdated', function() {
	        twin._connectSubscribeAndGetProperties(function() {});
	      });
	      twin._connectSubscribeAndGetProperties(done);
	    }
	  }
	};
	
	Twin.prototype.updateSharedAccessSignature = function() {
	  this._receiver.removeAllListeners(Twin.responseEvent);
	  this._receiver.removeAllListeners(Twin.postEvent);
	};
	
	Twin.prototype._connectSubscribeAndGetProperties = function(done) {
	  var self = this;
	  /* Codes_SRS_NODE_DEVICE_TWIN_18_004: [** `fromDeviceClient` shall call `getTwinReceiver` on the protocol object to get a twin receiver. **]**  */
	  this._client._transport.getTwinReceiver(function(err, receiver) {
	    if (err) {
	      done(err);
	    } else {
	      self._receiver = receiver;
	
	       self._subscribe( function(err) {
	        if (err) {
	          done(err);
	        } else {
	          self._getPropertiesFromService(function (err) {
	            /* Codes_SRS_NODE_DEVICE_TWIN_18_043: [** If the GET operation fails, `fromDeviceClient` shall call the done method with the error object in the first parameter **]** */
	            done(err, self);
	          });
	        }
	      });
	    }
	  });
	};
	
	
	/* Codes_SRS_NODE_DEVICE_TWIN_18_031: [** `fromDeviceClient` shall subscribe to the response topic **]** */
	/* Codes_SRS_NODE_DEVICE_TWIN_18_032: [** `fromDeviceClient` shall subscribe to the desired property patch topic **]** */
	Twin.prototype._subscribe = function(done) {
	
	  var twin = this;
	  var receiver = twin._receiver;
	  var topics = [
	    {
	      topicName : Twin.responseEvent,
	      subscribed : false,
	      handler : twin._onServiceResponse.bind(this)
	    },
	    {
	      topicName : Twin.postEvent,
	      subscribed : false,
	      handler : twin._onServicePost.bind(this)
	    }
	  ];
	
	  var handleSubscribed = function(obj) {
	    if (topics.some(function(topic) {
	      if (topic.topicName === obj.eventName) {
	        topic.subscribed = true;
	        return true;
	      }
	    })) {
	      if (topics.every(function(topic) {
	        return topic.subscribed; 
	      })) {
	        cleanupAndReturn(null, twin);
	      }
	    }
	  };
	    
	  
	  /* Codes_SRS_NODE_DEVICE_TWIN_18_010: [** `fromDeviceClient` shall call the `done` callback passing  the first error that is returned from `error` event on the twinReceiver. **]**  */
	  var errAlreadySent = false;
	  var handleError = function(topic) {
	    if (!errAlreadySent) {
	      errAlreadySent = true;
	      cleanupAndReturn(new errors.ServiceUnavailableError('failed to subscribe to '   + topic));
	    }
	  };
	      
	
	  var timeout = null;
	  var cleanupAndReturn = function(err) {
	    clearTimeout(timeout);
	    timeout = null;
	    /* Codes_SRS_NODE_DEVICE_TWIN_18_012: [** `fromDeviceClient` shall remove the handlers for both the `subscribed` and `error` events before calling the `done` callback. **]**   */
	    receiver.removeListener(Twin.subscribedEvent, handleSubscribed);
	    receiver.removeListener(Twin.errorEvent, handleError);
	    done(err);
	  };
	
	  /* Codes_SRS_NODE_DEVICE_TWIN_18_007: [** `fromDeviceClient` shall add handlers for the both the `subscribed` and `error` events on the twinReceiver **]**  */
	  receiver.on(Twin.subscribedEvent, handleSubscribed);
	  receiver.on(Twin.errorEvent, handleError);
	
	  /* Codes_SRS_NODE_DEVICE_TWIN_18_009: [** `fromDeviceClient` shall call the `done` callback passing a `TimeoutError` if it has not received all necessary `subscribed` events within `Twin.timeout` milliseconds. **]** */
	  timeout = setTimeout(function() {
	    cleanupAndReturn(new errors.TimeoutError('subscription to twin messages timed out'), null);
	  }, Twin.timeout);
	
	  topics.forEach(function(topic) {
	    receiver.on(topic.topicName, topic.handler);
	  });
	  
	};
	
	Twin.prototype._sendTwinRequest = function(method, resource, properties, body, done) {
	
	  /* Codes_SRS_NODE_DEVICE_TWIN_18_014: [** `_sendTwinRequest` shall use an arbitrary starting `rid` and increment it by one for every call to `_sendTwinRequest` **]**  */
	  /* Codes_SRS_NODE_DEVICE_TWIN_18_017: [** `_sendTwinRequest` shall put the `rid` value into the `properties` object that gets passed to `sendTwinRequest` on the transport **]**  */
	  var propCopy = JSON.parse(JSON.stringify(properties));  
	  propCopy .$rid = this._rid;
	  this._rid++;
	
	  var self = this;
	
	  var handleResponse = function(resp) {
	    /* Codes_SRS_NODE_DEVICE_TWIN_18_018: [** The response handler shall ignore any messages that dont have an `rid` that matches the `rid` of the request **]**   */
	    if (resp.$rid.toString() === propCopy.$rid.toString())
	    {
	      /* Codes_SRS_NODE_DEVICE_TWIN_18_019: [** `_sendTwinRequest` shall call `done` with `err`=`null` if the response event returns `status`===200 or 204 **]**   */
	      if (resp.status.toString() === '200' || resp.status.toString() === '204') {
	       cleanupAndReturn(null, resp.body);
	      } else {
	        /* Codes_SRS_NODE_DEVICE_TWIN_18_020: [** `_sendTwinRequest` shall call `done` with an `err` value translated using `translateError`**]**  */
	        cleanupAndReturn(translateError(resp, resp.status));
	      }
	    }
	  };
	  
	  /* Codes_SRS_NODE_DEVICE_TWIN_18_021: [** Before calling `done`, `_sendTwinRequest` shall remove the handler for the `response` event **]**  */
	  var timeout = null;
	  var cleanupAndReturn = function(err, body) {
	    clearTimeout(timeout);
	    timeout = null;
	    self._receiver.removeListener('response', handleResponse);
	    done(err, body);
	  };
	
	  /* Codes_SRS_NODE_DEVICE_TWIN_18_015: [** `_sendTwinRequest` shall add a handler for the `response` event on the twinReceiver object.  **]** */
	  this._receiver.on('response', handleResponse);
	
	  /* Codes_SRS_NODE_DEVICE_TWIN_18_022: [** If the response doesnt come within `Twin.timeout` milliseconds, `_sendTwinRequest` shall call `done` with `err`=`TimeoutError` **]**   */
	  timeout = setTimeout(function() {
	    cleanupAndReturn(new errors.TimeoutError('message timed out'), null);
	  }, Twin.timeout);
	
	  /* Codes_SRS_NODE_DEVICE_TWIN_18_016: [** `_sendTwinRequest` shall use the `sendTwinRequest` method on the transport to send the request **]**  */
	  this._client._transport.sendTwinRequest(method, resource, propCopy, body);
	};
	
	
	Twin.prototype._updateReportedProperties = function (state, done) {
	  /* Codes_SRS_NODE_DEVICE_TWIN_18_025: [** `properties.reported.update` shall use _sendTwinRequest to send the patch object to the service. **]**  */
	  /* Codes_SRS_NODE_DEVICE_TWIN_18_026: [** When calling `_sendTwinRequest`, `properties.reported.update` shall pass `method`='PATCH', `resource`='/properties/reported/', `properties`={}, and `body`=the `body` parameter passed in to `reportState` as a string. **]**    */
	  /* Codes_SRS_NODE_DEVICE_TWIN_18_027: [** `properties.reported.update` shall call `done` with the results from `_sendTwinRequest` **]**  */
	  var self = this;
	  this._sendTwinRequest('PATCH', '/properties/reported/', {}, JSON.stringify(state), function (err) {
	    /* Codes_SRS_NODE_DEVICE_TWIN_18_033: [** If `_sendTwinRequest` fails, `properties.reported.update` shall not merge the contents of the patch object into `properties.reported` **]** */
	    if (err) {
	      done(err);
	    } else {
	      self._mergePatch(self.properties.reported, state);
	      done();
	    }
	  });
	};
	
	/* Codes_SRS_NODE_DEVICE_TWIN_18_031: [** `properties.reported.update` shall merge the contents of the patch object into `properties.reported` **]** */
	Twin.prototype._mergePatch = function(dest, patch) {
	  _.merge(dest, patch);
	
	  /* Codes_SRS_NODE_DEVICE_TWIN_18_032: [** When merging the patch, if any properties are set to `null`, `properties.reported.update` shall delete that property from `properties.reported`. **]** */
	  traverse(dest).forEach(function (prop) {
	    if (prop === null) {
	      this.remove();
	    }
	  });
	};
	
	Twin.prototype._onServiceResponse = function() {
	};
	
	Twin.prototype._clearCachedProperties = function () {
	  var self = this;
	  this.properties = { 
	    reported : {
	      update : function(state, done) {
	        self._updateReportedProperties(state, done);
	      }
	    },
	    desired : {
	    }
	  };
	};
	
	/* Codes_SRS_NODE_DEVICE_TWIN_18_044: [** `fromDeviceClient` shall do a GET call to retrieve desired properties from the service. **]** */
	Twin.prototype._getPropertiesFromService = function(done) {
	  var self = this;
	  /* Codes_SRS_NODE_DEVICE_TWIN_18_034: [** `fromDeviceClient` shall ignore any PATCH operations that arrive before the GET returns **]** */
	  this._clearCachedProperties();
	  this._sendTwinRequest('GET', '/', {}, ' ', function(err, body) {
	    if(err) {
	      done(err);
	    } else {
	      /* Codes_SRS_NODE_DEVICE_TWIN_18_035: [** When a the results of a GET operation is received, the `Twin` object shall merge the properties into `this.properties.desired`. **]** */
	      var props = JSON.parse(body.toString('ascii'));
	      self._mergePatch(self.properties.desired, props.desired);
	      self._mergePatch(self.properties.reported, props.reported);
	      self._fireChangeEvents(self.properties.desired);
	      done();
	    }
	  });
	};
	
	/* Codes_SRS_NODE_DEVICE_TWIN_18_039: [** After merging a GET result, the `Twin` object shall recursively fire property changed events for every changed property. **]** */
	/* Codes_SRS_NODE_DEVICE_TWIN_18_040: [** After merging a PATCH result, the `Twin` object shall recursively fire property changed events for every changed property. **]** */
	Twin.prototype._fireChangeEvents = function(desiredProperties) {
	  var self = this;
	  this.emit(Twin.desiredPath, desiredProperties);
	  traverse(desiredProperties).forEach(function() {
	    var path = this.path.join('.');
	    if (path) {
	      /* Codes_SRS_NODE_DEVICE_TWIN_18_041: [** When firing a property changed event, the `Twin` object shall name the event from the property using dot notation starting with 'properties.desired.' **]** */
	      /* Codes_SRS_NODE_DEVICE_TWIN_18_042: [** When firing a property changed event, the `Twin` object shall pass the changed value of the property as the event parameter **]** */
	      self.emit(Twin.desiredPath + '.' + path, _.at(desiredProperties,path)[0]);
	    }
	  });
	};
	
	/* Codes_SRS_NODE_DEVICE_TWIN_18_036: [** When a PATCH operation is received, the `Twin` object shall merge the properties into `this.properties.desired`. **]** */
	Twin.prototype._onServicePost = function(body) {
	  var patch = JSON.parse(body.toString('ascii'));
	  this._mergePatch(this.properties.desired, patch);
	  this._fireChangeEvents(patch);
	};
	
	/* Codes_SRS_NODE_DEVICE_TWIN_18_045: [** If a property is already set when a handler is added for that property, the `Twin` object shall fire a property changed event for the property. **]*  */
	Twin.prototype._handleNewListener = function(eventName) {
	  var self = this;  
	  if (eventName.indexOf(Twin.desiredPath) === 0) {
	    var propertyValue = _.at(this, eventName)[0];
	    if (propertyValue) {
	      process.nextTick(function() {
	        self.emit(eventName, propertyValue);
	      });
	    }
	  }
	};
	
	module.exports = Twin;
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	
	'use strict';
	
	var errors = __webpack_require__(19).errors;
	
	var translateError = function translateError(response, status) {
	  var error;
	  switch(status) {
	    case 400:
	      /*Codes_SRS_NODE_DEVICE_TWIN_ERRORS_18_003: [`translateError` shall return an `ArgumentError` if the response status code is `400`.]*/
	      error = new errors.ArgumentError();
	      break;
	    case 401:
	      /*Codes_SRS_NODE_DEVICE_TWIN_ERRORS_18_004: [`translateError` shall return an `UnauthorizedError` if the response status code is `401`.]*/
	      error = new errors.UnauthorizedError();
	      break;
	    case 403:
	      /*Codes_SRS_NODE_DEVICE_TWIN_ERRORS_18_005: [`translateError` shall return an `IotHubQuotaExceededError` if the response status code is `403`.]*/
	      error = new errors.IotHubQuotaExceededError();
	      break;
	    case 404:
	      /*Codes_SRS_NODE_DEVICE_TWIN_ERRORS_18_006: [`translateError` shall return an `DeviceNotFoundError` if the response status code is `404`.]*/
	      error = new errors.DeviceNotFoundError();
	      break;
	    case 413:
	      /*Codes_SRS_NODE_DEVICE_TWIN_ERRORS_18_007: [`translateError` shall return an `MessageTooLargeError` if the response status code is `413`.]*/
	      error = new errors.MessageTooLargeError();
	      break;
	    case 500:
	      /*Codes_SRS_NODE_DEVICE_TWIN_ERRORS_18_008: [`translateError` shall return an `InternalServerError` if the response status code is `500`.]*/
	      error = new errors.InternalServerError();
	      break;
	    case 503:
	      /*Codes_SRS_NODE_DEVICE_TWIN_ERRORS_18_009: [`translateError` shall return an `ServiceUnavailableError` if the response status code is `503`.]*/
	      error = new errors.ServiceUnavailableError();
	      break;
	    case 504:
	      /*Codes_SRS_NODE_DEVICE_TWIN_ERRORS_18_011: [`translateError` shall return an `ServiceUnavailableError` if the response status code is `504`.]*/
	      error = new errors.ServiceUnavailableError();
	      break;
	    case 429:
	      /* Codes_SRS_NODE_DEVICE_TWIN_ERRORS_18_012: [`translateError` shall return an `ThrottlingError` if the response status code is `429`.] */
	      error = new errors.ThrottlingError();
	      break;
	    case 412:
	      /* Codes_SRS_NODE_DEVICE_TWIN_ERRORS_18_013: [`translateError` shall return an `InvalidEtagError` if the response status code is `412`.] */
	      error = new errors.InvalidEtagError();
	      break;
	    default:
	      /*Codes_SRS_NODE_DEVICE_TWIN_ERRORS_18_002: [If the error code is unknown, `translateError` should return a generic Javascript `Error` object.]*/
	      error = new Error("server returned error " + status);
	  }
	  
	  error.response = response;
	  return error;
	};
	
	module.exports = translateError;


/***/ },
/* 252 */
[600, 128, 61],
/* 253 */
/***/ function(module, exports) {

	// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	
	'use strict';
	
	var apiVersion = '2016-11-14';
	
	function devicePath(id) {
	  return '/devices/' + id;
	}
	
	function eventPath(id) {
	  return devicePath(id) + '/messages/events';
	}
	
	function messagePath(id) {
	  return devicePath(id) + '/messages/devicebound';
	}
	
	function feedbackPath(id, lockToken) {
	  return messagePath(id) + '/' + lockToken;
	}
	
	function versionQueryString() {
	  return '?api-version=' + apiVersion;
	}
	
	var endpoint = {
	  devicePath: devicePath,
	  eventPath: eventPath,
	  messagePath: messagePath,
	  feedbackPath: feedbackPath,
	  versionQueryString: versionQueryString,
	  apiVersion: apiVersion
	};
	
	module.exports = endpoint;


/***/ },
/* 254 */
[601, 255],
/* 255 */
/***/ function(module, exports) {

	// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	
	/**
	 * The `properties` module exports the {@linkcode Properties} class which
	 * is a collection type that allows you to store a collection of user
	 * defined properties.
	 *
	 * @module common/properties
	 */
	
	'use strict';
	
	/**
	 * @class Properties
	 * @classdesc Collection of user defined properties. Values can only be
	 *            strings.
	 */
	var Properties = function () {
	  this.propertyList = [];
	};
	
	/**
	 * Adds the key-value pair to the collection. The strings `'Authorization'`
	 * and `'iothub-to'` are considered as reserved key names and will cause the
	 * function to return `false` if those key names are used.
	 */
	/* Codes_SRS_NODE_IOTHUB_PROPERTIES_07_003: [The getData function shall return a string representation of the body of the message.] */
	Properties.prototype.add = function (itemKey, itemValue) {
	  /* Codes_SRS_NODE_IOTHUB_PROPERTIES_07_004: [If itemKey contains any of the reserved key names then the add function will return false] */
	  if (itemKey === 'Authorization' || itemKey === 'iothub-to') {
	    return false;
	  }
	  else {
	    var objProperty = { key: itemKey, value: itemValue };
	    this.propertyList.push(objProperty);
	    return true;
	  }
	};
	
	/**
	 * Returns the key-value pair corresponding to the given index.
	 * @returns {Object}  Key-value pair corresponding to the given index. The
	 *                    returned object has the properties `key` and `value`
	 *                    corresponding to the key and value of the property.
	 */
	/* Codes_SRS_NODE_IOTHUB_PROPERTIES_07_001: [if the supplied index is greater or equal to zero and the is less than property map length then it shall return the property object.] */
	Properties.prototype.getItem = function (index) {
	  if (index >= 0 && index < this.propertyList.length)
	    return this.propertyList[index];
	
	  /*Codes_SRS_NODE_IOTHUB_PROPERTIES_13_001: [ If the supplied index is less than zero or greater than or equal to the property map length then it shall return undefined. ]*/
	  return undefined;
	};
	
	/**
	 * Returns the value property of the element that has the given key.
	 * @returns {Object}  corresponding value or undefined if the key doesn't exist.
	 */
	Properties.prototype.getValue = function (key) {
	  for (var i = 0; i < this.propertyList.length; i++) {
	    /*Codes_SRS_NODE_IOTHUB_PROPERTIES_16_002: [`Properties.getValue` should return the corresponding value of the `value` property of the element with the `key` property passed as argument.]*/
	    if (this.propertyList[i].key === key) {
	      return this.propertyList[i].value;
	    }
	  }
	
	  /*Codes_SRS_NODE_IOTHUB_PROPERTIES_16_001: [`Properties.getValue` should return `undefined` if no element within the `propertyList` array contains `key`.]*/
	  return undefined;
	};
	
	/**
	 * Returns the number of items in the collection.
	 */
	/* Codes_SRS_NODE_IOTHUB_PROPERTIES_07_002: [Properties.Count shall return the number of items in the Properties map.] */
	Properties.prototype.count = function () {
	  return this.propertyList.length;
	};
	
	module.exports = Properties;

/***/ },
/* 256 */
/***/ function(module, exports) {

	// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	
	'use strict';
	
	/**
	 * @class       module:azure-iot-common.MessageEnqueued
	 * @classdesc   Result returned when a message was successfully enqueued.
	 *
	 * @property {Object} transportObj  The transport-specific object
	 *
	 * @augments {Object}
	 */
	function MessageEnqueued(transportObj) {
	  this.transportObj = transportObj;
	}
	
	/**
	 * @class       module:azure-iot-common.MessageCompleted
	 * @classdesc   Result returned when a message was successfully rejected.
	 *
	 * @property {Object} transportObj  The transport-specific object
	 *
	 * @augments {Object}
	 */
	function MessageCompleted(transportObj) {
	  this.transportObj = transportObj;
	}
	
	/**
	 * @class       module:azure-iot-common.MessageRejected
	 * @classdesc   Result returned when a message was successfully rejected.
	 *
	 * @property {Object} transportObj  The transport-specific object
	 *
	 * @augments {Object}
	 */
	function MessageRejected(transportObj) {
	  this.transportObj = transportObj;
	}
	
	/**
	 * @class       module:azure-iot-common.MessageAbandoned
	 * @classdesc   Result returned when a message was successfully abandoned.
	 *
	 * @property {Object} transportObj  The transport-specific object
	 *
	 * @augments {Object}
	 */
	function MessageAbandoned(transportObj) {
	  this.transportObj = transportObj;
	}
	
	/**
	 * @class       module:azure-iot-common.Connected
	 * @classdesc   Result returned when a transport is successfully connected.
	 *
	 * @property {Object} transportObj  The transport-specific object
	 *
	 * @augments {Object}
	 */
	function Connected(transportObj) {
	  this.transportObj = transportObj;
	}
	
	/**
	 * @class       module:azure-iot-common.Disconnected
	 * @classdesc   Result returned when a transport is successfully disconnected.
	 *
	 * @property {Object} transportObj  The transport-specific object.
	 * @property {String} reason        The reason why the disconnected event is emitted.
	 *
	 * @augments {Object}
	 */
	function Disconnected(transportObj, reason) {
	  this.transportObj = transportObj;
	  this.reason = reason;
	}
	
	/**
	 * @class       module:azure-iot-common.TransportConfigured
	 * @classdesc   Result returned when a transport is successfully configured.
	 *
	 * @property {Object} transportObj  The transport-specific object.
	 *
	 * @augments {Object}
	 */
	function TransportConfigured(transportObj) {
	  this.transportObj = transportObj;
	}
	
	/**
	 * @class       module:azure-iot-common.SharedAccessSignatureUpdated
	 * @classdesc   Result returned when a SAS token has been successfully updated.
	 *
	 * @param {Boolean} needToReconnect  Value indicating whether the client needs to reconnect or not.
	 *
	 * @augments {Object}
	 */
	function SharedAccessSignatureUpdated(needToReconnect) {
	  this.needToReconnect = needToReconnect;
	}
	
	module.exports = {
	  MessageEnqueued: MessageEnqueued,
	  MessageCompleted: MessageCompleted,
	  MessageRejected: MessageRejected,
	  MessageAbandoned: MessageAbandoned,
	  Connected: Connected,
	  Disconnected: Disconnected,
	  TransportConfigured: TransportConfigured,
	  SharedAccessSignatureUpdated: SharedAccessSignatureUpdated
	};

/***/ },
/* 257 */
[602, 76, 61, 128, 61],
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	
	'use strict';
	
	/**
	 * The `azure-iot-http-base` module contains HTTP support code common to the Azure IoT Hub Device and Service SDKs.
	 * 
	 * @module azure-iot-http-base
	 */
	
	module.exports = {
	  Http: __webpack_require__(259)
	};

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	
	'use strict';
	
	var Message = __webpack_require__(260).Message;
	var debug = __webpack_require__(157)('azure-iot-common.Http');
	
	/**
	 * @class           module:azure-iot-http-base.Http
	 * @classdesc       Basic HTTP request/response functionality used by higher-level IoT Hub libraries.
	 *                  You generally want to use these higher-level objects (such as [azure-iot-device-http.Http]{@link module:azure-iot-device-http.Http}) rather than this one.
	 */
	function Http() {
	  this._https = __webpack_require__(89);
	}
	
	/**
	 * @method              module:azure-iot-http-base.Http.buildRequest
	 * @description         Builds an HTTP request object using the parameters supplied by the caller.
	 *
	 * @param {String}      method          The HTTP verb to use (GET, POST, PUT, DELETE...).
	 * @param {String}      path            The section of the URI that should be appended after the hostname.
	 * @param {Object}      httpHeaders     An object containing the headers that should be used for the request.
	 * @param {String}      host            Fully-Qualified Domain Name of the server to which the request should be sent to.
	 * @param {Function}    done            The callback to call when a response or an error is received.
	 *
	 * @returns An HTTP request object.
	 */
	/*Codes_SRS_NODE_HTTP_05_001: [buildRequest shall accept the following arguments:
	    method - an HTTP verb, e.g., 'GET', 'POST', 'DELETE'
	    path - the path to the resource, not including the hostname
	    httpHeaders - an object whose properties represent the names and values of HTTP headers to include in the request
	    host - the fully-qualified DNS hostname of the IoT hub
	    x509Options - [optional] the x509 certificate, key and passphrase that are needed to connect to the service using x509 certificate authentication
	    done - a callback that will be invoked when a completed response is returned from the server]*/
	Http.prototype.buildRequest = function (method, path, httpHeaders, host, x509Options, done) {
	  if (!done && (typeof x509Options === 'function')) {
	    done = x509Options;
	    x509Options = null;
	  }
	
	  var httpOptions = {
	    host: host,
	    path: path,
	    method: method,
	    headers: httpHeaders
	  };
	
	  /*Codes_SRS_NODE_HTTP_16_001: [If `x509Options` is specified, the certificate, key and passphrase in the structure shall be used to authenticate the connection.]*/
	  if (x509Options) {
	    httpOptions.cert = x509Options.cert;
	    httpOptions.key = x509Options.key;
	    httpOptions.passphrase = x509Options.passphrase;
	  }
	
	  var request = this._https.request(httpOptions, function onResponse(response) {
	    var responseBody = '';
	    response.on('error', function (err) {
	      done(err);
	    });
	    response.on('data', function onResponseData(chunk) {
	      responseBody += chunk;
	    });
	    response.on('end', function onResponseEnd() {
	      /*Codes_SRS_NODE_HTTP_05_005: [When an HTTP response is received, the callback function indicated by the done argument shall be invoked with the following arguments:
	      err - the standard JavaScript Error object if status code >= 300, otherwise null
	      body - the body of the HTTP response as a string
	      response - the Node.js http.ServerResponse object returned by the transport]*/
	      var err = (response.statusCode >= 300) ?
	        new Error(response.statusMessage) :
	        null;
	      done(err, responseBody, response);
	    });
	  });
	
	  /*Codes_SRS_NODE_HTTP_05_003: [If buildRequest encounters an error before it can send the request, it shall invoke the done callback function and pass the standard JavaScript Error object with a text description of the error (err.message).]*/
	  request.on('error', done);
	  /*Codes_SRS_NODE_HTTP_05_002: [buildRequest shall return a Node.js https.ClientRequest object, upon which the caller must invoke the end method in order to actually send the request.]*/
	  return request;
	};
	
	/**
	 * @method                              module:azure-iot-http-base.Http.toMessage
	 * @description                         Transforms the body of an HTTP response into a {@link module:azure-iot-common.Message} that can be treated by the client.
	 *
	 * @param {module:http.IncomingMessage} response        A response as returned from the node.js http module
	 * @param {Object}                      body            The section of the URI that should be appended after the hostname.
	 *
	 * @returns {module:azure-iot-common.Message} A Message object.
	 */
	Http.prototype.toMessage = function toMessage(response, body) {
	  var msg;
	  /*Codes_SRS_NODE_HTTP_05_006: [If the status code of the HTTP response < 300, toMessage shall create a new azure-iot-common.Message object with data equal to the body of the HTTP response.]*/
	  if (response.statusCode < 300) {
	    msg = new Message(body);
	    for (var item in response.headers) {
	      if (item.search("iothub-") !== -1) {
	        /*Codes_SRS_NODE_HTTP_05_007: [If the HTTP response has an 'iothub-messageid' header, it shall be saved as the messageId property on the created Message.]*/
	        if (item.toLowerCase() === "iothub-messageid") {
	          msg.messageId = response.headers[item];
	        }
	        /*Codes_SRS_NODE_HTTP_05_008: [If the HTTP response has an 'iothub-to' header, it shall be saved as the to property on the created Message.]*/
	        else if (item.toLowerCase() === "iothub-to") {
	          msg.to = response.headers[item];
	        }
	        /*Codes_SRS_NODE_HTTP_05_009: [If the HTTP response has an 'iothub-expiry' header, it shall be saved as the expiryTimeUtc property on the created Message.]*/
	        else if (item.toLowerCase() === "iothub-expiry") {
	          msg.expiryTimeUtc = response.headers[item];
	        }
	        /*Codes_SRS_NODE_HTTP_05_010: [If the HTTP response has an 'iothub-correlationid' header, it shall be saved as the correlationId property on the created Message.]*/
	        else if (item.toLowerCase() === "iothub-correlationid") {
	          msg.correlationId = response.headers[item];
	        }
	        /*Codes_SRS_NODE_HTTP_13_001: [ If the HTTP response has a header with the prefix iothub-app- then a new property with the header name and value as the key and value shall be added to the message. ]*/
	        else if(item.search("iothub-app-") !== -1) {
	            msg.properties.add(item, response.headers[item]);
	        }
	      }
	      /*Codes_SRS_NODE_HTTP_05_011: [If the HTTP response has an 'etag' header, it shall be saved as the lockToken property on the created Message, minus any surrounding quotes.]*/
	      else if (item.toLowerCase() === "etag") {
	        // Need to strip the quotes from the string
	        var len = response.headers[item].length;
	        msg.lockToken = response.headers[item].substring(1, len - 1);
	      }
	    }
	  }
	
	  return msg;
	};
	
	
	/**
	 * @method              module:azure-iot-http-base.Http#parseErrorBody
	 * @description         Parses the body of an error response and returns it as an object.
	 *
	 * @params {String}     body  The body of the HTTP error response
	 * @returns {Object}    An object with 2 properties: code and message.
	 */
	Http.parseErrorBody = function parseError (body) {
	  var result = null;
	
	  try {
	    var jsonErr = JSON.parse(body);
	    var errParts = jsonErr.Message.split(';');
	    var errMessage = errParts[1];
	    var errCode = errParts[0].split(':')[1];
	
	    if(!!errCode && !!errMessage) {
	      result = {
	        message: errMessage,
	        code: errCode
	      };
	    }
	  } catch (err) {
	    if (err instanceof SyntaxError) {
	      debug('Could not parse error body: Invalid JSON');
	    } else if (err instanceof TypeError) {
	      debug('Could not parse error body: Unknown body format');
	    } else {
	      throw err;
	    }
	  }
	
	  return result;
	};
	
	module.exports = Http;


/***/ },
/* 260 */
[599, 77, 77, 261, 262, 62, 265, 263, 266],
/* 261 */
[600, 129, 62],
/* 262 */
253,
/* 263 */
[601, 264],
/* 264 */
255,
/* 265 */
256,
/* 266 */
[602, 77, 62, 129, 62],
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	var exports = module.exports;
	
	/**
	* Creates a connection string that can be used to create a service which runs on the storage emulator. The emulator must be downloaded separately.
	*
	* @param {string}   [proxyUri]                  The proxyUri. By default, http://127.0.0.1
	* @return {string}                              A connection string representing the development storage credentials.
	* @example
	* var azure = require('azure-storage');
	* var devStoreCreds = azure.generateDevelopmentStorageCredentials();
	* var blobService = azure.createBlobService(devStoreCreds);
	*/
	exports.generateDevelopmentStorageCredentials = function (proxyUri) {
	  var devStore = 'UseDevelopmentStorage=true;';
	  if(proxyUri){
	    devStore += 'DevelopmentStorageProxyUri=' + proxyUri;
	  }
	
	  return devStore;
	};
	
	/**
	 * Table client exports.
	 * @ignore
	 */
	var TableService = __webpack_require__(307);
	
	exports.TableService = TableService;
	exports.TableQuery = __webpack_require__(144);
	exports.TableBatch = __webpack_require__(306);
	exports.TableUtilities = __webpack_require__(52);
	
	/**
	* Creates a new {@link TableService} object.
	* If no storageaccount or storageaccesskey are provided, the AZURE_STORAGE_CONNECTION_STRING and then the AZURE_STORAGE_ACCOUNT and AZURE_STORAGE_ACCESS_KEY 
	* environment variables will be used.
	*
	* @param {string} [storageAccountOrConnectionString]  The storage account or the connection string.
	* @param {string} [storageAccessKey]                  The storage access key.
	* @param {string|object} [host]                       The host address. To define primary only, pass a string. 
	*                                                     Otherwise 'host.primaryHost' defines the primary host and 'host.secondaryHost' defines the secondary host.
	* @return {TableService}                              A new TableService object.
	*
	*/
	exports.createTableService = function (storageAccountOrConnectionString, storageAccessKey, host) {
	  return new TableService(storageAccountOrConnectionString, storageAccessKey, host);
	};
	
	/**
	* Creates a new {@link TableService} object using the host Uri and the SAS credentials provided.
	* 
	* @param {string|object} host                         The host address. To define primary only, pass a string. 
	*                                                     Otherwise 'host.primaryHost' defines the primary host and 'host.secondaryHost' defines the secondary host.
	* @param {string} sasToken                            The Shared Access Signature token.
	* @return {TableService}                              A new TableService object with the SAS credentials.
	*/
	exports.createTableServiceWithSas = function (hostUri, sasToken) {
	  return new TableService(null, null, hostUri, sasToken);
	};
	
	/**
	 * Blob client exports.
	 * @ignore
	 */
	var BlobService = __webpack_require__(286);
	
	exports.BlobService = BlobService;
	exports.BlobUtilities = __webpack_require__(51);
	
	/**
	* Creates a new {@link BlobService} object.
	* If no storageaccount or storageaccesskey are provided, the AZURE_STORAGE_CONNECTION_STRING and then the AZURE_STORAGE_ACCOUNT and AZURE_STORAGE_ACCESS_KEY 
	* environment variables will be used.
	*
	* @param {string} storageAccountOrConnectionString    The storage account or the connection string.
	* @param {string} [storageAccessKey]                  The storage access key.
	* @param {string|object} [host]                       The host address. To define primary only, pass a string. 
	*                                                     Otherwise 'host.primaryHost' defines the primary host and 'host.secondaryHost' defines the secondary host.
	* @return {BlobService}                               A new BlobService object.
	*/
	exports.createBlobService = function (storageAccountOrConnectionString, storageAccessKey, host) {
	  return new BlobService(storageAccountOrConnectionString, storageAccessKey, host, null);
	};
	
	/**
	* Creates a new {@link BlobService} object using the host Uri and the SAS credentials provided.
	* 
	* @param {string|object} host                         The host address. To define primary only, pass a string. 
	*                                                     Otherwise 'host.primaryHost' defines the primary host and 'host.secondaryHost' defines the secondary host.
	* @param {string} sasToken                            The Shared Access Signature token.
	* @return {BlobService}                               A new BlobService object with the SAS credentials.
	*/
	exports.createBlobServiceWithSas = function (host, sasToken) {
	  return new BlobService(null, null, host, sasToken);
	};
	
	/**
	* Creates a new {@link BlobService} object using the host uri and anonymous access.
	* 
	* @param {string|object} host                         The host address. To define primary only, pass a string. 
	*                                                     Otherwise 'host.primaryHost' defines the primary host and 'host.secondaryHost' defines the secondary host.
	* @return {BlobService}                               A new BlobService object with the anonymous credentials.
	*/
	exports.createBlobServiceAnonymous = function (host) {
	  return new BlobService(null, null, host, null);
	};
	
	/**
	 * File client exports.
	 * @ignore
	 */
	var FileService = __webpack_require__(294);
	
	exports.FileService = FileService;
	exports.FileUtilities = __webpack_require__(139);
	
	/**
	* Creates a new {@link FileService} object.
	* If no storageaccount or storageaccesskey are provided, the AZURE_STORAGE_CONNECTION_STRING and then the AZURE_STORAGE_ACCOUNT and AZURE_STORAGE_ACCESS_KEY 
	* environment variables will be used.
	*
	* @param {string} storageAccountOrConnectionString    The storage account or the connection string.
	* @param {string} [storageAccessKey]                  The storage access key.
	* @param {string|object} [host]                       The host address. To define primary only, pass a string. 
	*                                                     Otherwise 'host.primaryHost' defines the primary host and 'host.secondaryHost' defines the secondary host.
	* @return {FileService}                               A new FileService object.
	*/
	exports.createFileService = function (storageAccountOrConnectionString, storageAccessKey, host) {
	  return new FileService(storageAccountOrConnectionString, storageAccessKey, host);
	};
	
	/**
	* Creates a new {@link FileService} object using the host Uri and the SAS credentials provided.
	* 
	* @param {string|object} host                         The host address. To define primary only, pass a string. 
	*                                                     Otherwise 'host.primaryHost' defines the primary host and 'host.secondaryHost' defines the secondary host.
	* @param {string} sasToken                            The Shared Access Signature token.
	* @return {FileService}                               A new FileService object with the SAS credentials.
	*/
	exports.createFileServiceWithSas = function (hostUri, sasToken) {
	  return new FileService(null, null, hostUri, sasToken);
	};
	
	/**
	 * Queue client exports.
	 * @ignore
	 */
	var QueueService = __webpack_require__(301);
	
	exports.QueueService = QueueService;
	exports.QueueUtilities = __webpack_require__(302);
	exports.QueueMessageEncoder = __webpack_require__(140);
	
	/**
	* Creates a new {@link QueueService} object.
	* If no storageaccount or storageaccesskey are provided, the AZURE_STORAGE_CONNECTION_STRING and then the AZURE_STORAGE_ACCOUNT and AZURE_STORAGE_ACCESS_KEY 
	* environment variables will be used.
	*
	* @param {string} [storageAccountOrConnectionString]  The storage account or the connection string.
	* @param {string} [storageAccessKey]                  The storage access key.
	* @param {string|object} [host]                       The host address. To define primary only, pass a string. 
	*                                                     Otherwise 'host.primaryHost' defines the primary host and 'host.secondaryHost' defines the secondary host.
	* @return {QueueService}                              A new QueueService object.
	*/
	exports.createQueueService = function (storageAccountOrConnectionString, storageAccessKey, host) {
	  return new QueueService(storageAccountOrConnectionString, storageAccessKey, host);
	};
	
	/**
	* Creates a new {@link QueueService} object using the host Uri and the SAS credentials provided.
	* 
	* @param {string|object} host                         The host address. To define primary only, pass a string. 
	*                                                     Otherwise 'host.primaryHost' defines the primary host and 'host.secondaryHost' defines the secondary host.
	* @param {string} sasToken                            The Shared Access Signature token.
	* @return {QueueService}                              A new QueueService object with the SAS credentials.
	*/
	exports.createQueueServiceWithSas = function(hostUri, sasToken) {
	  return new QueueService(null, null, hostUri, sasToken);
	};
	
	/**
	* Account SAS
	* @ignore
	*/
	
	var azureCommon = __webpack_require__(78);
	var StorageServiceClient = azureCommon.StorageServiceClient;
	var SharedKey = azureCommon.SharedKey;
	/**
	* Generates an account shared access signature token
	* 
	* @param {string}                     [storageAccountOrConnectionString]                The storage account or the connection string.
	* @param {string}                     [storageAccessKey]                                The storage access key.
	* @param {object}                     sharedAccessPolicy                                The shared access policy.
	* @param {SharedAccessServices}       sharedAccessPolicy.AccessPolicy.Services          The services (blob, file, queue, table) for a shared access signature associated with this shared access policy.
	*                                                                                       Refer to `Constants.AccountSasConstants.Services`.
	* @param {SharedAccessResourceTypes}  sharedAccessPolicy.AccessPolicy.ResourceTypes     The resource type for a shared access signature associated with this shared access policy.
	*                                                                                       Refer to `Constants.AccountSasConstants.ResourceTypes`.
	* @param {SharedAccessPermissions}    sharedAccessPolicy.AccessPolicy.Permissions       The permissions for a shared access signature. 
	*                                                                                       Refer to `Constants.AccountSasConstants.Permissions`.
	* @param {date}                       sharedAccessPolicy.AccessPolicy.Start             The time at which the Shared Access Signature becomes valid.
	* @param {date}                       sharedAccessPolicy.AccessPolicy.Expiry            The time at which the Shared Access Signature becomes expired.
	* @param {string}                     sharedAccessPolicy.AccessPolicy.IPAddressOrRange  The permission type. Refer to `Constants.AccountSasConstants.ResourceTypes`.
	* @param {string}                     sharedAccessPolicy.AccessPolicy.Protocols          The possible protocols. Refer to `Constants.AccountSasConstants.ResourceTypes`.
	*/
	exports.generateAccountSharedAccessSignature = function(storageAccountOrConnectionString, storageAccessKey, sharedAccessAccountPolicy)
	{
	  var storageSettings = StorageServiceClient.getStorageSettings(storageAccountOrConnectionString, storageAccessKey);
	  var sharedKey = new SharedKey(storageSettings._name, storageSettings._key);
	  
	  return sharedKey.generateAccountSignedQueryString(sharedAccessAccountPolicy);
	};
	
	
	/**
	* A callback that returns a response object.
	* @callback errorOrResponse
	* @param {object} error         If an error occurs, will contain information about the error.
	* @param {object} response      Contains information about the response returned for the operation.
	*                               For example, HTTP status codes and headers.
	*/
	
	/**
	* A callback that returns result and response objects.
	* @callback errorOrResult
	* @param {object} error         If an error occurs, will contain information about the error.
	* @param {object} result        The result of the operation.
	* @param {object} response      Contains information about the response returned for the operation.
	*                               For example, HTTP status codes and headers.
	*/
	
	
	/**
	* Specifying conditional headers for blob service operations. See http://msdn.microsoft.com/en-us/library/dd179371.aspx for more information.
	* @typedef    {object}          AccessConditions
	* @property   {string}          EtagMatch                       If the ETag for the blob matches the specified ETag.
	*                                                               Specify the wildcard character (*) to perform the operation only if the resource does exist, and fail the operation if it does not exist.
	* @property   {string}          EtagNonMatch                    If the ETag for the blob does not match the specified ETag.
	*                                                               Specify the wildcard character (*) to perform the operation only if the resource does not exist, and fail the operation if it does exist.
	* @property   {Date|string}     DateModifedSince                If the blob has been modified since the specified date.
	* @property   {Date|string}     DateUnModifiedSince             If the blob has not been modified since the specified date.
	* @property   {Number|string}   SequenceNumberLessThanOrEqual   If the blob's sequence number is less than or equal to the specified value.
	*                                                               For Put Page operation only. See https://msdn.microsoft.com/en-us/library/azure/ee691975.aspx for more information.
	* @property   {Number|string}   SequenceNumberLessThan          If the blob's sequence number is less than the specified value.
	*                                                               For Put Page operation only. See https://msdn.microsoft.com/en-us/library/azure/ee691975.aspx for more information.
	* @property   {Number|string}   SequenceNumberEqual             If the blob's sequence number is equal to the specified value.
	*                                                               For Put Page operation only. See https://msdn.microsoft.com/en-us/library/azure/ee691975.aspx for more information.
	* @property   {Number|string}   MaxBlobSize                     If the Append Block operation would cause the blob to exceed that limit or if the blob size is already greater than the specified value. 
	*                                                               For Append Block operation only. See https://msdn.microsoft.com/en-us/library/mt427365.aspx for more information.
	* @property   {Number|string}   MaxAppendPosition               If the append position is equal to the specified value.
	*                                                               For Append Block operation only. See https://msdn.microsoft.com/en-us/library/mt427365.aspx for more information.
	*/
	
	/**
	* The properties of a storage service, including properties of Storage Analytics and CORS (Cross-Origin Resource Sharing) rules.
	* @typedef    {object}              ServiceProperties
	* @property   {string}              DefaultServiceVersion  The default version of Storage Analytics currently in use.
	* @property   {LoggingProperties}   Logging                The Logging settings.
	* @property   {MetricsProperties}   HourMetrics            The HourMetrics settings provide a summary of request statistics grouped by API in hourly aggregates.
	* @property   {MetricsProperties}   MinuteMetrics          The HourMetrics settings provide request statistics grouped by API for each minute.
	* @property   {object}              Cors                   Groups all CORS rules.
	* @property   {CorsRule[]}          Cors.CorsRules         Groups settings for a `[CORS rule]{@link CorsRule}`.
	*/
	
	/**
	* The Azure Analytics logging settings.
	* @typedef    {object}          LoggingProperties
	* @property   {string}          Version                    The version of Storage Analytics currently in use for logging.
	* @property   {boolean}         Delete                     Indicates whether delete requests are being logged.
	* @property   {boolean}         Read                       Indicates whether read requests are being logged.
	* @property   {boolean}         Write                      Indicates whether write requests are being logged.
	* @property   {RetentionPolicy} RetentionPolicy            The retention policy of the log data.
	*/
	
	/**
	* The setting of Azure Analytics summary of request stastics.
	* @typedef    {object}          MetricsProperties
	* @property   {string}          Version                    The version of Storage Analytics currently in use for hour metrics.
	* @property   {string}          Enabled                    Indicates whether metrics are enabled
	* @property   {boolean}         IncludeAPIs                Indicates whether metrics generate summary statistics for called API operations.
	* @property   {RetentionPolicy} RetentionPolicy            The retention policy of the metrics data.
	*/
	
	/**
	* The CORS rule of a storage service.
	* @typedef    {object}          CorsRule
	* @property   {string[]}        AllowedMethods             A list of HTTP methods that are allowed to be executed by the origin. For Azure Storage, permitted methods are DELETE, GET, HEAD, MERGE, POST, OPTIONS or PUT.
	* @property   {string[]}        AllowedOrigins             A list of origin domains that are allowed via CORS, or "*" if all domains are allowed.
	* @property   {string[]}        AllowedHeaders             A list of headers allowed to be part of the cross-origin request.
	* @property   {string[]}        ExposedHeaders             A list of response headers to expose to CORS clients.
	* @property   {number}          MaxAgeInSeconds            The number of seconds that the client/browser should cache a preflight response.
	*/
	
	/**
	* The Azure Analytics logging or metrics retention policy.
	* @typedef    {object}          RetentionPolicy
	* @property   {boolean}         Enabled                    Indicates whether a retention policy is enabled for the storage service.
	* @property   {number}          Days                       Indicates the number of days that logging data is retained. All data older than this value will be deleted.
	*/
	
	/**
	* The access policy.
	* @typedef    {object}          AccessPolicy
	* @property   {string}          Permissions                The permission type.
	* @property   {Date}            Start                      The time at which the access policy becomes valid.
	* @property   {Date}            Expiry                     The time at which the access policy becomes expired.
	* @property   {string}          IPAddressOrRange           An IP address or a range of IP addresses from which to accept requests. When specifying a range, note that the range is inclusive.
	* @property   {string}          Protocols                  The protocols permitted for a request made with the SAS.
	* @property   {string}          Services                   The services (blob, file, queue, table) for a shared access signature associated with this shared access policy.
	* @property   {string}          ResourceTypes              The resource type for a shared access signature associated with this shared access policy.
	*/
	
	/**
	* The service statistics.
	* @typedef    {object}          ServiceStats
	* @property   {object}          GeoReplication                  The geo replication stastics.
	* @property   {string}          GeoReplication.Status           The status of the secondary location.
	* @property   {Date}            GeoReplication.LastSyncTime     A GMT date/time value, to the second. 
	*                                                               All primary writes preceding this value are guaranteed to be available for read operations at the secondary.
	*                                                               Primary writes after this point in time may or may not be available for reads. 
	*/
	
	/**
	* The range.
	* @typedef    {object}          Range
	* @property   {number}          start                     The start of the range.
	* @property   {number}          end                       The end of the range.
	*/
	
	/**
	* The range diff. Refer to https://msdn.microsoft.com/en-us/library/azure/mt736912.aspx
	* @typedef    {object}          RangeDiff
	* @property   {number}          start                     The start of the range.
	* @property   {number}          end                       The end of the range.
	* @property   {boolean}         isCleared                 If the range is cleared or not.
	
	*/
	
	exports.Constants = azureCommon.Constants;
	exports.StorageUtilities = azureCommon.StorageUtilities;
	exports.AccessCondition = azureCommon.AccessCondition;
	
	exports.SR = azureCommon.SR;
	exports.StorageServiceClient = StorageServiceClient;
	exports.Logger = azureCommon.Logger;
	exports.WebResource = azureCommon.WebResource;
	exports.Validate = azureCommon.validate;
	exports.date = azureCommon.date;
	
	// Other filters
	exports.LinearRetryPolicyFilter = azureCommon.LinearRetryPolicyFilter;
	exports.ExponentialRetryPolicyFilter = azureCommon.ExponentialRetryPolicyFilter;
	exports.RetryPolicyFilter = azureCommon.RetryPolicyFilter;

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	var azureCommon = __webpack_require__(8);
	
	azureCommon.BrowserFileReadStream = __webpack_require__(277);
	
	module.exports = azureCommon;

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	'use strict';
	
	var RetryPolicyFilter = __webpack_require__(80);
	/**
	* Creates a new 'ExponentialRetryPolicyFilter' instance.
	* @class
	* The ExponentialRetryPolicyFilter allows you to retry operations,
	* using an exponential back-off interval between retries.
	* To apply a filter to service operations, use `withFilter`
	* and specify the filter to be used when creating a service.
	* @constructor
	* @param {number} [retryCount=3]            The client retry count.
	* @param {number} [retryInterval=30000]     The client retry interval, in milliseconds.
	* @param {number} [minRetryInterval=3000]   The minimum retry interval, in milliseconds.
	* @param {number} [maxRetryInterval=90000]  The maximum retry interval, in milliseconds.
	* 
	* @example
	* var azure = require('azure-storage');
	* var retryOperations = new azure.ExponentialRetryPolicyFilter();
	* var blobService = azure.createBlobService().withFilter(retryOperations)
	*/
	function ExponentialRetryPolicyFilter(retryCount, retryInterval, minRetryInterval, maxRetryInterval) {
	  this.retryCount = retryCount ? retryCount : ExponentialRetryPolicyFilter.DEFAULT_CLIENT_RETRY_COUNT;
	  this.retryInterval = retryInterval ? retryInterval : ExponentialRetryPolicyFilter.DEFAULT_CLIENT_RETRY_INTERVAL;
	  this.minRetryInterval = minRetryInterval ? minRetryInterval : ExponentialRetryPolicyFilter.DEFAULT_CLIENT_MIN_RETRY_INTERVAL;
	  this.maxRetryInterval = maxRetryInterval ? maxRetryInterval : ExponentialRetryPolicyFilter.DEFAULT_CLIENT_MAX_RETRY_INTERVAL;
	}
	
	/**
	* Represents the default client retry interval, in milliseconds.
	*/
	ExponentialRetryPolicyFilter.DEFAULT_CLIENT_RETRY_INTERVAL = 1000 * 30;
	
	/**
	* Represents the default client retry count.
	*/
	ExponentialRetryPolicyFilter.DEFAULT_CLIENT_RETRY_COUNT = 3;
	
	/**
	* Represents the default maximum retry interval, in milliseconds.
	*/
	ExponentialRetryPolicyFilter.DEFAULT_CLIENT_MAX_RETRY_INTERVAL = 1000 * 90;
	
	/**
	* Represents the default minimum retry interval, in milliseconds.
	*/
	ExponentialRetryPolicyFilter.DEFAULT_CLIENT_MIN_RETRY_INTERVAL = 1000 * 3;
	
	/**
	 * Determines if the operation should be retried and how long to wait until the next retry.
	 *
	 * @param {number} statusCode The HTTP status code.
	 * @param {object} requestOptions  The request options.
	 * @return {retryInfo} Information about whether the operation qualifies for a retry and the retryInterval.
	 */
	ExponentialRetryPolicyFilter.prototype.shouldRetry = function (statusCode, requestOptions) {
	  var retryData = (requestOptions && requestOptions.retryContext) ? requestOptions.retryContext : {};
	
	  // Adjust retry interval
	  var incrementDelta = Math.pow(2, retryData.retryCount) - 1;
	  var boundedRandDelta = this.retryInterval * 0.8 + Math.floor(Math.random() * (this.retryInterval * 1.2 - this.retryInterval * 0.8));
	  incrementDelta *= boundedRandDelta;
	      
	  retryData.retryInterval = Math.min(this.minRetryInterval + incrementDelta, this.maxRetryInterval);
	
	  return RetryPolicyFilter._shouldRetryOnError(statusCode, requestOptions);
	};
	
	/**
	* Handles an operation with an exponential retry policy.
	*
	* @param {Object}   requestOptions The original request options.
	* @param {function} next           The next filter to be handled.
	*/
	ExponentialRetryPolicyFilter.prototype.handle = function (requestOptions, next) {
	  RetryPolicyFilter._handle(this, requestOptions, next);
	};
	
	module.exports = ExponentialRetryPolicyFilter;


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	//
	'use strict';
	 
	var RetryPolicyFilter = __webpack_require__(80);
	
	/**
	* Creates a new LinearRetryPolicyFilter instance.
	* @class
	* The LinearRetryPolicyFilter allows you to retry operations,
	* using an linear back-off interval between retries.
	* To apply a filter to service operations, use `withFilter`
	* and specify the filter to be used when creating a service.
	* @constructor
	* @param {number} [retryCount=3]            The client retry count.
	* @param {number} [retryInterval=30000]     The client retry interval, in milliseconds.
	*
	* @example
	* var azure = require('azure-storage');
	* var retryOperations = new azure.LinearRetryPolicyFilter();
	* var blobService = azure.createBlobService().withFilter(retryOperations)
	*/
	function LinearRetryPolicyFilter(retryCount, retryInterval) {
	  this.retryCount = retryCount ? retryCount : LinearRetryPolicyFilter.DEFAULT_CLIENT_RETRY_COUNT;
	  this.retryInterval = retryInterval ? retryInterval : LinearRetryPolicyFilter.DEFAULT_CLIENT_RETRY_INTERVAL;
	}
	
	/**
	* Represents the default client retry interval, in milliseconds.
	*/
	LinearRetryPolicyFilter.DEFAULT_CLIENT_RETRY_INTERVAL = 1000 * 30;
	
	/**
	* Represents the default client retry count.
	*/
	LinearRetryPolicyFilter.DEFAULT_CLIENT_RETRY_COUNT = 3;
	
	/**
	* Determines if the operation should be retried and how long to wait until the next retry.
	*
	 * @param {number} statusCode       The HTTP status code.
	 * @param {object} requestOptions   The request options.
	 * @return {retryInfo} Information about whether the operation qualifies for a retry and the retryInterval.
	*/
	LinearRetryPolicyFilter.prototype.shouldRetry = function (statusCode, requestOptions) {
	  var retryData = (requestOptions && requestOptions.retryContext) ? requestOptions.retryContext : {};
	  retryData.retryInterval = this.retryInterval;
	
	  return RetryPolicyFilter._shouldRetryOnError(statusCode, requestOptions);
	};
	
	/**
	* Handles an operation with a linear retry policy.
	*
	* @param {Object}   requestOptions The original request options.
	* @param {function} next           The next filter to be handled.
	*/
	LinearRetryPolicyFilter.prototype.handle = function (requestOptions, next) {
	  RetryPolicyFilter._handle(this, requestOptions, next);
	};
	
	module.exports = LinearRetryPolicyFilter;


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Module dependencies.
	var _ = __webpack_require__(15);
	var xmlbuilder = __webpack_require__(120);
	
	var azureutil = __webpack_require__(16);
	var ISO8061Date = __webpack_require__(138);
	var Constants = __webpack_require__(12);
	var AclConstants = Constants.AclConstants;
	
	exports = module.exports;
	
	/**
	* Builds an XML representation for container acl permissions.
	*
	* @param  {Object.<string, AccessPolicy>}  entity The signed identifiers.
	* @return {string} The XML container acl permissions.
	*/
	exports.serialize = function (signedIdentifiersJs) {
	  var doc = xmlbuilder.create();
	  doc = doc.begin(AclConstants.SIGNED_IDENTIFIERS_ELEMENT, { version: '1.0', encoding: 'utf-8' });
	
	  var keys = Object.keys(signedIdentifiersJs);
	  if (keys.length > 0) {
	    keys.forEach(function (key) {
	      var accessPolicy = signedIdentifiersJs[key];
	      doc = doc
	        .ele(AclConstants.SIGNED_IDENTIFIER_ELEMENT)
	          .ele(AclConstants.ID)
	            .txt(key)
	          .up()
	          .ele(AclConstants.ACCESS_POLICY);
	
	      if (accessPolicy.Start) {
	        var startIsoString = accessPolicy.Start;
	        if (!_.isDate(startIsoString)) {
	          startIsoString = new Date(startIsoString);
	        }
	
	        // Convert to expected ISO 8061 date format
	        startIsoString = ISO8061Date.format(startIsoString);
	
	        doc = doc
	            .ele(AclConstants.START)
	              .txt(startIsoString)
	            .up();
	      }
	
	      if (accessPolicy.Expiry) {
	        var expiryIsoString = accessPolicy.Expiry;
	        if (!_.isDate(expiryIsoString)) {
	          expiryIsoString = new Date(expiryIsoString);
	        }
	
	        // Convert to expected ISO 8061 date format
	        expiryIsoString = ISO8061Date.format(expiryIsoString);
	
	        doc = doc
	            .ele(AclConstants.EXPIRY)
	              .txt(expiryIsoString)
	            .up();
	      }
	
	      if (accessPolicy.Permissions) {
	        doc = doc
	            .ele(AclConstants.PERMISSION)
	              .txt(accessPolicy.Permissions)
	            .up();
	      }
	
	      doc = doc.up().up();
	    });
	  }
	  return doc.doc().toString();
	};
	
	exports.parse = function (signedIdentifiersXml) {
	  var signedIdentifiers = {};
	
	  signedIdentifiersXml = azureutil.tryGetValueChain(signedIdentifiersXml, [ 'SignedIdentifiers', 'SignedIdentifier' ]);
	  if (signedIdentifiersXml) {
	    if (!_.isArray(signedIdentifiersXml)) {
	      signedIdentifiersXml = [ signedIdentifiersXml ];
	    }
	
	    signedIdentifiersXml.forEach(function (signedIdentifier) {
	      var accessPolicy = {};
	      if (signedIdentifier.AccessPolicy) {
	        if (signedIdentifier.AccessPolicy.Start) {
	          accessPolicy.Start = ISO8061Date.parse(signedIdentifier.AccessPolicy.Start);
	        }
	
	        if (signedIdentifier.AccessPolicy.Expiry) {
	          accessPolicy.Expiry = ISO8061Date.parse(signedIdentifier.AccessPolicy.Expiry);
	        }
	
	        if (signedIdentifier.AccessPolicy.Permission) {
	          accessPolicy.Permissions = signedIdentifier.AccessPolicy.Permission;
	        }
	      }
	
	      signedIdentifiers[signedIdentifier.Id] = accessPolicy;
	    });
	  }
	
	  return signedIdentifiers;
	};

/***/ },
/* 272 */
/***/ function(module, exports) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	exports = module.exports;
	
	exports.parse = function (serviceStatsXml) {
	  var serviceStats = {};
	
	  if (typeof serviceStatsXml.GeoReplication !== 'undefined') {   
	    serviceStats.GeoReplication = {};
	
	    if (typeof serviceStatsXml.GeoReplication.Status !== 'undefined') {
	      serviceStats.GeoReplication.Status = serviceStatsXml.GeoReplication.Status;
	    }
	
	    if (typeof serviceStatsXml.GeoReplication.LastSyncTime !== 'undefined' && serviceStatsXml.GeoReplication.LastSyncTime !== '') {
	      serviceStats.GeoReplication.LastSyncTime = new Date(serviceStatsXml.GeoReplication.LastSyncTime);
	    }
	  }
	
	  return serviceStats;
	};

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	//
	
	var azureCommon = __webpack_require__(268);
	var Duplex = __webpack_require__(20).Duplex;
	var extend = __webpack_require__(26);
	var http = __webpack_require__(114);
	var https = __webpack_require__(89);
	var url = __webpack_require__(33);
	var util = __webpack_require__(4);
	
	/**
	* Creates a new Request object.
	*
	* @constructor
	* @param {object} options    The options for a Request object.
	* @param {function} callback Callback
	*/
	function Request(options, callback) {
	    Duplex.call(this);
	
	    this._init(options, callback);
	    this._send();
	}
	
	util.inherits(Request, Duplex);
	
	Request.prototype._init = function (options, callback) {
	    this.callback = callback;
	
	    var nonReservedProperties = azureCommon.util.filterOutNonReservedProperties(this, options);
	    extend(this, nonReservedProperties);
	
	    this.agent = this.agent || false;
	    this.timeout = this.timeout || Math.pow(2, 32) * 1000;
	
	    this._initUri();
	    this._initHeaders();
	};
	
	Request.prototype._initUri = function () {
	    if (!this.uri) {
	        return this.emit('error', new Error('options.uri is a required argument'));
	    }
	
	    if (typeof this.uri === 'string') {
	        this.uri = url.parse(this.uri);
	    }
	
	    if (!this.uri.href) {
	        this.uri.href = url.format(this.uri);
	    }
	};
	
	Request.prototype._initHeaders = function () {
	    this.headers = this.headers || {};
	    this.headers['content-length'] = this.headers['content-length'] || 0;
	};
	
	Request.prototype._send = function () {
	    this._sent = true;
	
	    var protocol = this.uri.protocol || '';
	    var iface = (protocol === 'https:' ? https : http);
	
	    var options = {
	        scheme: protocol.replace(/:$/, ''),
	        method: this.method,
	        host: this.uri.hostname,
	        port: Number(this.uri.port) || (protocol === 'https:' ? 443 : 80),
	        path: this.uri.path,
	        agent: this.agent,
	        headers: this.headers,
	        withCredentials: this.withCredentials,
	        localAddress: this.localAddress,
	        mode: this.mode
	    };
	
	    if (protocol === 'https:') {
	        options.pfx = this.pfx;
	        options.key = this.key;
	        options.cert = this.cert;
	        options.ca = this.ca;
	        options.ciphers = this.ciphers;
	        options.rejectUnauthorized = this.rejectUnauthorized;
	        options.secureProtocol = this.secureProtocol;
	    }
	
	    var httpRequest = iface.request(options);
	    if (this.timeout && httpRequest.setTimeout) {
	        httpRequest.setTimeout(this.timeout);
	    }
	
	    this.httpRequest = httpRequest;
	    this.emit('request', httpRequest);
	
	    this._sendBody();
	    this._listenHttpResponse();
	    this._listenHttpError();
	
	    return httpRequest;
	};
	
	Request.prototype._sendBody = function () {
	    if (this.body) {
	        this.httpRequest.write(this.body);
	        this.httpRequest.end();
	        return;
	    }
	
	    if (this.headers['content-length'] == '0') {
	        this.httpRequest.end();
	        return;
	    }
	};
	
	Request.prototype._listenHttpError = function() {
	    var self = this;
	
	    self.httpRequest.on('error', function(error) {
	        self.emit('error', error);
	    });
	
	    self.on('error', function(error) {
	        if (self.callback) {
	            self.callback(error);
	        }
	    });
	};
	
	Request.prototype._listenHttpResponse = function () {
	    var self = this;
	
	    self.httpRequest.on('response', function (response) {
	        var buffers = [];
	        var bufferLength = 0;
	
	        self.response = response;
	
	        response.on('data', function (chunk) {
	            self.push(chunk);
	            buffers.push(chunk);
	            bufferLength += chunk.length;
	        });
	
	        response.on('error', function (error) {
	            self.emit('error', error);
	        });
	
	        response.on('end', function () {
	            self.push(null);
	
	            response.body = '';
	            if (bufferLength > 0) {
	                response.body = Buffer.concat(buffers, bufferLength);
	            }
	
	            if (self.encoding !== null) {
	                response.body = response.body.toString(self.encoding);
	            }
	
	            if (self.callback) {
	                self.callback(null, response);
	            }
	        });
	
	        self.emit('response', response);
	    });
	};
	
	/**
	* Set a Request header.
	*
	* @param {string} key The user provided header key.
	* @param {string} value The valid header value.
	*/
	Request.prototype.setHeader = function (key, value) {
	    if (this._sent) {
	        throw new Error('Request already sent');
	    }
	
	    this.headers[key] = value;
	    return this;
	};
	
	/**
	* Set a Request URI.
	*
	* @param {string} uri The user provided uri.
	*/
	Request.prototype.setLocation = function (uri) {
	    this.uri = uri;
	    return this;
	};
	
	Request.prototype.end = function (chunk) {
	    if (chunk) {
	        this.httpRequest.write(chunk);
	    }
	
	    this.httpRequest.end();
	};
	
	Request.prototype._write = function (chunk, encoding, callback) {
	    this.httpRequest.write(chunk);
	    callback();
	};
	
	Request.prototype._read = function () {
	};
	
	/**
	* Create a Request object
	* @ignore
	*
	* @param {object} options Options
	* @param {function} callback Callback
	* @return {Request} The created request object.
	*/
	function req(optionsOrCallback, callback) {
	    var reqDefaults = req.defaults();
	    return reqDefaults(optionsOrCallback, callback);
	}
	
	/**
	* Create a Request creator with default options
	* @ignore
	*
	* @param {object} defaultOptions Default options
	* @return {function}
	*/
	req.defaults = function (defaultOptions) {
	    return function (optionsOrCallback, callback) {
	        var options;
	        azureCommon.util.normalizeArgs(optionsOrCallback, callback, function (o, c) { options = o; callback = c; });
	
	        var nonReservedProperties = azureCommon.util.filterOutNonReservedProperties(options, defaultOptions);
	        extend(options, nonReservedProperties);
	
	        var request = new Request(options, callback);
	        return request;
	    };
	};
	
	module.exports = req;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, Buffer) {// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Module dependencies.
	var request = __webpack_require__(273);
	var url = __webpack_require__(33);
	var qs = __webpack_require__(43);
	var util = __webpack_require__(4);
	var xml2js = __webpack_require__(228);
	var events = __webpack_require__(14);
	var _ = __webpack_require__(15);
	var guid = __webpack_require__(116);
	var os = __webpack_require__(162);
	var extend = __webpack_require__(26);
	var Parser = __webpack_require__(370);
	
	var Md5Wrapper = __webpack_require__(34);
	var azureutil = __webpack_require__(16);
	var validate = __webpack_require__(82);
	var SR = __webpack_require__(25);
	var WebResource = __webpack_require__(130);
	var BufferStream = __webpack_require__(136);
	
	var ServiceSettings = __webpack_require__(132);
	var StorageServiceSettings = __webpack_require__(275);
	var Constants = __webpack_require__(12);
	var StorageUtilities = __webpack_require__(63);
	var ServicePropertiesResult = __webpack_require__(131);
	var TableUtilities = __webpack_require__(52);
	
	var SharedKey = __webpack_require__(135);
	var SharedAccessSignature = __webpack_require__(134);
	
	var HeaderConstants = Constants.HeaderConstants;
	var QueryStringConstants = Constants.QueryStringConstants;
	var HttpResponseCodes = Constants.HttpConstants.HttpResponseCodes;
	var StorageServiceClientConstants = Constants.StorageServiceClientConstants;
	var defaultRequestLocationMode = Constants.RequestLocationMode.PRIMARY_ONLY;
	var RequestLocationMode = Constants.RequestLocationMode;
	
	var Logger = __webpack_require__(79);
	var errors = __webpack_require__(30);
	var ArgumentError = errors.ArgumentError;
	var ArgumentNullError = errors.ArgumentNullError;
	var TimeoutError = errors.TimeoutError;
	var StorageError = errors.StorageError;
	
	/**
	* Creates a new StorageServiceClient object.
	*
	* @class
	* The StorageServiceClient class is the base class of all the service classes.
	* @constructor
	* @param {string} storageAccount           The storage account.
	* @param {string} storageAccessKey         The storage access key.
	* @param {object} host                     The host for the service.
	* @param {bool}   usePathStyleUri          Boolean value indicating wether to use path style uris.
	* @param {string} sasToken                 The Shared Access Signature token.
	*/
	function StorageServiceClient(storageAccount, storageAccessKey, host, usePathStyleUri, sasToken) {
	  StorageServiceClient['super_'].call(this);
	
	  if(storageAccount && storageAccessKey) {
	    // account and key
	    this.storageAccount = storageAccount;
	    this.storageAccessKey = storageAccessKey;
	    this.storageCredentials = new SharedKey(this.storageAccount, this.storageAccessKey, usePathStyleUri);
	  } else if (sasToken) {
	    // sas
	    this.sasToken = sasToken;
	    this.storageCredentials = new SharedAccessSignature(sasToken);
	  } else {
	    // anonymous
	    this.anonymous = true;
	    this.storageCredentials = {
	      signRequest: function(webResource, callback){
	        // no op, anonymous access
	        callback(null);
	      }
	    };
	  }
	
	  if(host){
	    this.setHost(host);
	  }
	
	  this.apiVersion = HeaderConstants.TARGET_STORAGE_VERSION;
	  this.usePathStyleUri = usePathStyleUri;
	
	  this._initDefaultFilter();
	
	  /**
	   * The logger of the service. To change the log level of the services, set the `[logger.level]{@link Logger#level}`.
	   * @name StorageServiceClient#logger
	   * @type Logger
	   * */
	  this.logger = new Logger(Logger.LogLevels.INFO);
	
	  this._setDefaultProxy();
	
	  this.xml2jsSettings = StorageServiceClient._getDefaultXml2jsSettings();
	  this.defaultLocationMode = StorageUtilities.LocationMode.PRIMARY_ONLY;
	}
	
	util.inherits(StorageServiceClient, events.EventEmitter);
	
	/**
	* Gets the default xml2js settings.
	* @ignore
	* @return {object} The default settings
	*/
	StorageServiceClient._getDefaultXml2jsSettings = function() {
	  var xml2jsSettings = _.clone(xml2js.defaults['0.2']);
	
	  // these determine what happens if the xml contains attributes
	  xml2jsSettings.attrkey = Constants.TableConstants.XML_METADATA_MARKER;
	  xml2jsSettings.charkey = Constants.TableConstants.XML_VALUE_MARKER;
	
	  // from xml2js guide: always put child nodes in an array if true; otherwise an array is created only if there is more than one.
	  xml2jsSettings.explicitArray = false;
	
	  return xml2jsSettings;
	};
	
	/**
	* Sets a host for the service.
	* @ignore
	* @param {string}     host                              The host for the service.
	*/
	StorageServiceClient.prototype.setHost = function (host) {
	  var parseHost = function(hostUri){
	    var parsedHost;
	    if(!azureutil.objectIsNull(hostUri)) {
	      if(hostUri.indexOf('http') === -1 && hostUri.indexOf('//') !== 0){
	        hostUri = '//' + hostUri;
	      }
	      parsedHost = url.parse(hostUri, false, true);
	
	      if(!parsedHost.protocol){
	        parsedHost.protocol = ServiceSettings.DEFAULT_PROTOCOL;
	      }
	
	      if (!parsedHost.port) {
	        if (parsedHost.protocol === Constants.HTTPS) {
	          parsedHost.port = Constants.DEFAULT_HTTPS_PORT;
	        } else {
	          parsedHost.port = Constants.DEFAULT_HTTP_PORT;
	        }
	      }
	
	      parsedHost = url.format({
	        protocol: parsedHost.protocol,
	        port: parsedHost.port,
	        hostname: parsedHost.hostname,
	        pathname: parsedHost.pathname
	      });
	    }
	
	    return parsedHost;
	  };
	
	  validate.isValidHost(host);
	
	  this.host = {
	    primaryHost: parseHost(host.primaryHost),
	    secondaryHost: parseHost(host.secondaryHost)
	  };
	};
	
	/**
	* Performs a REST service request through HTTP expecting an input stream.
	* @ignore
	*
	* @param {WebResource} webResource                        The webresource on which to perform the request.
	* @param {string}      outputData                         The outgoing request data as a raw string.
	* @param {object}      [options]                          The request options.
	* @param {int}         [options.timeoutIntervalInMs]      The timeout interval, in milliseconds, to use for the request.
	* @param {int}         [options.clientRequestTimeoutInMs] The timeout of client requests, in milliseconds, to use for the request.
	* @param {function}    callback                           The response callback function.
	*/
	StorageServiceClient.prototype.performRequest = function (webResource, outputData, options, callback) {
	    this._performRequest(webResource, { outputData: outputData }, options, callback);
	};
	
	/**
	* Performs a REST service request through HTTP expecting an input stream.
	* @ignore
	*
	* @param {WebResource} webResource                        The webresource on which to perform the request.
	* @param {Stream}      outputStream                       The outgoing request data as a stream.
	* @param {object}      [options]                          The request options.
	* @param {int}         [options.timeoutIntervalInMs]      The timeout interval, in milliseconds, to use for the request.
	* @param {int}         [options.clientRequestTimeoutInMs] The timeout of client requests, in milliseconds, to use for the request.
	* @param {function}    callback                           The response callback function.
	*/
	StorageServiceClient.prototype.performRequestOutputStream = function (webResource, outputStream, options, callback) {
	  this._performRequest(webResource, { outputStream: outputStream }, options, callback);
	};
	
	/**
	* Performs a REST service request through HTTP expecting an input stream.
	* @ignore
	*
	* @param {WebResource} webResource                        The webresource on which to perform the request.
	* @param {string}      outputData                         The outgoing request data as a raw string.
	* @param {Stream}      inputStream                        The ingoing response data as a stream.
	* @param {object}      [options]                          The request options.
	* @param {int}         [options.timeoutIntervalInMs]      The timeout interval, in milliseconds, to use for the request.
	* @param {int}         [options.clientRequestTimeoutInMs] The timeout of client requests, in milliseconds, to use for the request.
	* @param {function}    callback                           The response callback function.
	*/
	StorageServiceClient.prototype.performRequestInputStream = function (webResource, outputData, inputStream, options, callback) {
	  this._performRequest(webResource, { outputData: outputData, inputStream: inputStream }, options, callback);
	};
	
	/**
	* Performs a REST service request through HTTP.
	* @ignore
	*
	* @param {WebResource} webResource                        The webresource on which to perform the request.
	* @param {object}      body                               The request body.
	* @param {string}      [body.outputData]                  The outgoing request data as a raw string.
	* @param {Stream}      [body.outputStream]                The outgoing request data as a stream.
	* @param {Stream}      [body.inputStream]                 The ingoing response data as a stream.
	* @param {object}      [options]                          The request options.
	* @param {string}      [options.clientRequestId]          A string that represents the client request ID with a 1KB character limit.
	* @param {int}         [options.timeoutIntervalInMs]      The timeout interval, in milliseconds, to use for the request.
	* @param {int}         [options.clientRequestTimeoutInMs] The timeout of client requests, in milliseconds, to use for the request.
	* @param {function}    callback                           The response callback function.
	*/
	StorageServiceClient.prototype._performRequest = function (webResource, body, options, callback) {
	  var self = this;
	
	  // Sets a requestId on the webResource
	  if(!options.clientRequestId) {
	    options.clientRequestId = guid.v1();
	  }
	  
	  webResource.withHeader(HeaderConstants.CLIENT_REQUEST_ID, options.clientRequestId);
	
	  // Sets the user-agent string
	  var userAgentComment = util.format('(NODE-VERSION %s; %s %s)', process.version, os.type(), os.release());
	  webResource.withHeader(HeaderConstants.USER_AGENT, Constants.USER_AGENT_PRODUCT_NAME + '/' + Constants.USER_AGENT_PRODUCT_VERSION + ' ' + userAgentComment);
	
	  // Initialize the location that the request is going to be sent to.
	  if(azureutil.objectIsNull(options.locationMode)) {
	    options.locationMode = this.defaultLocationMode;
	  }
	
	  // Initialize the location that the request can be sent to.
	  if(azureutil.objectIsNull(options.requestLocationMode)) {
	    options.requestLocationMode = defaultRequestLocationMode;
	  }
	
	  // Initialize whether nagling is used or not.
	  if(azureutil.objectIsNull(options.useNagleAlgorithm)) {
	    options.useNagleAlgorithm = this.useNagleAlgorithm;
	  }
	
	  this._initializeLocation(options);
	  
	  // Initialize the operationExpiryTime
	  this._setOperationExpiryTime(options);
	
	  // If the output stream already got sent to server and got error back, 
	  // we should NOT retry within the SDK as the stream data is not valid anymore if we retry directly.
	  // And it's very hard for SDK to re-wind the stream.
	  //
	  // If users want to retry on this kind of error, they can implement their own logic to parse the response and 
	  // determine if they need to re-prepare a stream and call our SDK API to retry.
	  //
	  // Currently for blobs/files with size greater than 32MB (DEFAULT_SINGLE_BLOB_PUT_THRESHOLD_IN_BYTES), 
	  // we'll send the steam by chunk buffers which doesn't have this issue.
	  var outputStreamSent = false;
	
	  var operation = function (options, next) {
	    self._validateLocation(options);
	    var currentLocation = options.currentLocation;
	    self._buildRequestOptions(webResource, body, options, function (err, finalRequestOptions) {
	      if (err) {
	        callback({ error: err, response: null }, function (finalRequestOptions, finalCallback) {
	          finalCallback(finalRequestOptions);
	        });
	      } else {
	        self.logger.log(Logger.LogLevels.DEBUG, 'FINAL REQUEST OPTIONS:\n' + util.inspect(finalRequestOptions));
	
	        if(self._maximumExecutionTimeExceeded(Date.now(), options.operationExpiryTime)) {
	          callback({ error: new TimeoutError(SR.MAXIMUM_EXECUTION_TIMEOUT_EXCEPTION), response: null }, function (finalRequestOptions, finalCallback) {
	            finalCallback(finalRequestOptions);
	          });
	        } else {
	          var processResponseCallback = function (error, response) {
	            var responseObject;
	
	            if (error) {
	              responseObject = { error: error, response: null };
	            } else {
	              responseObject = self._processResponse(webResource, response, options);
	              responseObject.contentMD5 = response.contentMD5;
	              responseObject.length = response.length;
	            }
	
	            responseObject.operationEndTime = new Date();
	            // Required for listing operations to make sure successive operations go to the same location.
	            responseObject.targetLocation = currentLocation;
	            responseObject.outputStreamSent = outputStreamSent;
	
	            callback(responseObject, next);
	          };
	
	          var endResponse;
	          var buildRequest = function (headersOnly, inputStream) {
	            // Build request (if body was set before, request will process immediately, if not it'll wait for the piping to happen
	            var requestStream;
	
	            var requestWithDefaults;
	            
	            if(self.proxy) {
	              if(requestWithDefaults === undefined) {
	                requestWithDefaults = request.defaults({'proxy':self.proxy});
	              }
	            } else {
	              requestWithDefaults = request;
	            }
	
	            if (headersOnly) {
	              requestStream = requestWithDefaults(finalRequestOptions);
	
	              requestStream.on('error', processResponseCallback);
	              requestStream.on('response', function (response) {
	                var isValid = WebResource.validResponse(response.statusCode);
	                if (!isValid) {
	                    // When getting invalid response, try to get the error message for future steps to extract the detailed error information
	                    var contentLength = parseInt(response.headers['content-length']);
	                    var errorMessageBuffer;
	                    var index = 0;
	                    if (contentLength !== undefined) {
	                      errorMessageBuffer = new Buffer(contentLength);
	                    }
	                    
	                    requestStream.on('data', function (data) {
	                      if (contentLength !== undefined) {
	                        data.copy(errorMessageBuffer, index);
	                        index += data.length;
	                      } else {
	                        if (!errorMessageBuffer) {
	                          errorMessageBuffer = data;
	                        } else {
	                          errorMessageBuffer = Buffer.concat([errorMessageBuffer, data]);
	                        }
	                      }
	                    });
	                    requestStream.on('end', function () {
	                      if (errorMessageBuffer) {
	                        // Strip the UTF8 BOM following the same ways as 'request' module
	                        if (errorMessageBuffer.length > 3 &&
	                          errorMessageBuffer[0] === 239 &&
	                          errorMessageBuffer[1] === 187 &&
	                          errorMessageBuffer[2] === 191) {
	                          response.body = errorMessageBuffer.toString('utf8', 3);
	                        } else {
	                          response.body = errorMessageBuffer.toString('utf8');
	                        }
	                      }
	                      processResponseCallback(null, response);
	                    });
	                } else {
	                  // Only pipe to the destination stream when we get a valid response from service
	                  // Error message should NOT be piped to the destination stream
	                  if (inputStream) {
	                    requestStream.pipe(inputStream);
	                  }
	
	                  var responseLength = 0;
	                  var internalHash = new Md5Wrapper().createMd5Hash();
	                  response.on('data', function(data) {
	                    responseLength += data.length;
	                    internalHash.update(data);
	                  });
	
	                  response.on('end', function () {
	                    // Calculate and set MD5 here
	                    if(azureutil.objectIsNull(options.disableContentMD5Validation) || options.disableContentMD5Validation === false) {
	                      response.contentMD5 = internalHash.digest('base64');
	                    }
	                      
	                    response.length = responseLength;
	                    endResponse = response;
	                  });
	                }
	              });
	            } else {
	              requestStream = requestWithDefaults(finalRequestOptions, processResponseCallback);
	            }
	
	            //If useNagleAlgorithm is not set or the value is set and is false, setNoDelay is set to true.
	            if (azureutil.objectIsNull(options.useNagleAlgorithm) || options.useNagleAlgorithm === false) {
	              requestStream.on('request', function(httpRequest) {
	                httpRequest.setNoDelay(true);
	              });
	            }
	
	            // Workaround to avoid request from potentially setting unwanted (rejected) headers by the service
	            var oldEnd = requestStream.end;
	            requestStream.end = function () {
	              if (finalRequestOptions.headers['content-length']) {
	                requestStream.headers['content-length'] = finalRequestOptions.headers['content-length'];
	              } else if (requestStream.headers['content-length']) {
	                delete requestStream.headers['content-length'];
	              }
	
	              oldEnd.call(requestStream);
	            };
	
	            // Bubble events up -- This is when the request is going to be made.
	            requestStream.on('response', function (response) {
	              self.emit('receivedResponseEvent', response);
	            });
	
	            return requestStream;
	          };
	
	          if (body && body.outputData) {
	            if (!azureutil.isBrowser() && Buffer.isBuffer(body.outputData)) {
	              // Request module will take 200MB additional memory when we pass a 100MB buffer as body
	              // Transfer buffer to stream will highly reduce the memory used by request module
	              finalRequestOptions.body = new BufferStream(body.outputData);              
	            } else {
	              finalRequestOptions.body = body.outputData;
	            }
	          }
	
	          // Pipe any input / output streams
	          if (body && body.inputStream) {
	            body.inputStream.on('close', function () {
	              if (endResponse) {
	                processResponseCallback(null, endResponse);
	                endResponse = null;
	              }
	            });
	            body.inputStream.on('end', function () {
	              if (endResponse) {
	                processResponseCallback(null, endResponse);
	                endResponse = null;
	              }
	            });
	            body.inputStream.on('finish', function () {
	              if (endResponse) {
	                processResponseCallback(null, endResponse);
	                endResponse = null;
	              }
	            });
	            buildRequest(true, body.inputStream);
	          } else if (body && body.outputStream) {
	            var sendUnchunked = function () {
	              var size = finalRequestOptions.headers['content-length'] ?
	                finalRequestOptions.headers['content-length'] :
	                Constants.BlobConstants.MAX_SINGLE_UPLOAD_BLOB_SIZE_IN_BYTES;
	
	              var concatBuf = new Buffer(size);
	              var index = 0;
	
	              body.outputStream.on('data', function (d) {
	                outputStreamSent = true;
	                if(self._maximumExecutionTimeExceeded(Date.now(), options.operationExpiryTime)) {
	                  processResponseCallback(new TimeoutError(SR.MAXIMUM_EXECUTION_TIMEOUT_EXCEPTION));
	                } else {
	                  d.copy(concatBuf, index);
	                  index += d.length;
	                }
	              }).on('end', function () {
	                var requestStream = buildRequest();
	                requestStream.write(concatBuf);
	                requestStream.end();
	              });
	              if (azureutil.isStreamPaused(body.outputStream)) {
	                body.outputStream.resume();
	              }
	            };
	
	            var sendStream = function () {
	              // NOTE: workaround for an unexpected EPIPE exception when piping streams larger than 29 MB
	              if (!azureutil.objectIsNull(finalRequestOptions.headers['content-length']) && finalRequestOptions.headers['content-length'] < 29 * 1024 * 1024) {
	                body.outputStream.pipe(buildRequest());
	                outputStreamSent = true;
	
	                if (azureutil.isStreamPaused(body.outputStream)) {
	                  body.outputStream.resume();
	                }
	              } else {
	                sendUnchunked();
	              }
	            };
	
	            if (!body.outputStream.readable) {
	              // if the content length is zero, build the request and don't send a body
	              if (finalRequestOptions.headers['content-length'] === 0) {
	                buildRequest();
	              } else {
	                // otherwise, wait until we know the readable stream is actually valid before piping
	                body.outputStream.on('open', function () {
	                  sendStream();
	                });
	              }
	            } else {
	              sendStream();
	            }
	
	            // This catches any errors that happen while creating the readable stream (usually invalid names)
	            body.outputStream.on('error', function (error) {
	              processResponseCallback(error);
	            });
	          } else {
	            buildRequest();
	          }
	        }
	      }
	    });
	  };
	
	  // The filter will do what it needs to the requestOptions and will provide a
	  // function to be handled after the reply
	  self.filter(options, function (postFiltersRequestOptions, nextPostCallback) {
	    if(self._maximumExecutionTimeExceeded(Date.now() + postFiltersRequestOptions.retryInterval, postFiltersRequestOptions.operationExpiryTime)) {
	      callback({ error: new TimeoutError(SR.MAXIMUM_EXECUTION_TIMEOUT_EXCEPTION), response: null}, function (postFiltersRequestOptions, finalCallback) {
	        finalCallback(postFiltersRequestOptions);
	      });
	    } else {
	      // If there is a filter, flow is:
	      // filter -> operation -> process response
	      if(postFiltersRequestOptions.retryContext) {
	        var func = function() {
	          operation(postFiltersRequestOptions, nextPostCallback);
	        };
	
	        // Sleep for retryInterval before making the request
	        setTimeout(func, postFiltersRequestOptions.retryInterval);
	      } else {
	        // No retry policy filter specified
	        operation(postFiltersRequestOptions, nextPostCallback);
	      }
	    }
	  });
	};
	
	
	/**
	* Builds the request options to be passed to the http.request method.
	* @ignore
	* @param {WebResource} webResource The webresource where to build the options from.
	* @param {object}      options     The request options.
	* @param {function(error, requestOptions)}  callback  The callback function.
	*/
	StorageServiceClient.prototype._buildRequestOptions = function (webResource, body, options, callback) {
	  webResource.withHeader(HeaderConstants.STORAGE_VERSION, this.apiVersion);
	  webResource.withHeader(HeaderConstants.MS_DATE, new Date().toUTCString());
	  if (!webResource.headers[HeaderConstants.ACCEPT]) {
	    webResource.withHeader(HeaderConstants.ACCEPT, 'application/atom+xml,application/xml');
	  }
	  webResource.withHeader(HeaderConstants.ACCEPT_CHARSET, 'UTF-8');
	
	  // Browsers cache GET/HEAD requests by adding conditional headers such as 'IF_MODIFIED_SINCE' after Azure Storage 'Authorization header' calculation, 
	  // which may result in a 403 authorization error. So add timestamp to GET/HEAD request URLs thus avoid the browser cache. 
	  if (azureutil.isBrowser() && (
	    webResource.method === Constants.HttpConstants.HttpVerbs.GET || 
	    webResource.method === Constants.HttpConstants.HttpVerbs.HEAD)) {
	    webResource.withQueryOption(HeaderConstants.FORCE_NO_CACHE_IN_BROWSER, new Date().getTime());
	  }
	
	  if(azureutil.objectIsNull(options.timeoutIntervalInMs)) {
	    options.timeoutIntervalInMs = this.defaultTimeoutIntervalInMs;
	  }
	
	  if(azureutil.objectIsNull(options.clientRequestTimeoutInMs)) {
	    options.clientRequestTimeoutInMs = this.defaultClientRequestTimeoutInMs;
	  }
	
	  if(!azureutil.objectIsNull(options.timeoutIntervalInMs) && options.timeoutIntervalInMs > 0) {
	    webResource.withQueryOption(QueryStringConstants.TIMEOUT, Math.ceil(options.timeoutIntervalInMs / 1000));
	  }
	  
	  if(options.accessConditions) {
	    webResource.withHeader(HeaderConstants.IF_MATCH, options.accessConditions.EtagMatch);
	    webResource.withHeader(HeaderConstants.IF_MODIFIED_SINCE, options.accessConditions.DateModifedSince);
	    webResource.withHeader(HeaderConstants.IF_NONE_MATCH, options.accessConditions.EtagNonMatch);
	    webResource.withHeader(HeaderConstants.IF_UNMODIFIED_SINCE, options.accessConditions.DateUnModifiedSince);
	    webResource.withHeader(HeaderConstants.SEQUENCE_NUMBER_EQUAL, options.accessConditions.SequenceNumberEqual);
	    webResource.withHeader(HeaderConstants.SEQUENCE_NUMBER_LESS_THAN, options.accessConditions.SequenceNumberLessThan);
	    webResource.withHeader(HeaderConstants.SEQUENCE_NUMBER_LESS_THAN_OR_EQUAL, options.accessConditions.SequenceNumberLessThanOrEqual);
	    webResource.withHeader(HeaderConstants.BLOB_CONDITION_MAX_SIZE, options.accessConditions.MaxBlobSize);
	    webResource.withHeader(HeaderConstants.BLOB_CONDITION_APPEND_POSITION, options.accessConditions.MaxAppendPosition);
	  }
	
	  if(options.sourceAccessConditions) {
	    webResource.withHeader(HeaderConstants.SOURCE_IF_MATCH, options.sourceAccessConditions.EtagMatch);
	    webResource.withHeader(HeaderConstants.SOURCE_IF_MODIFIED_SINCE, options.sourceAccessConditions.DateModifedSince);
	    webResource.withHeader(HeaderConstants.SOURCE_IF_NONE_MATCH, options.sourceAccessConditions.EtagNonMatch);
	    webResource.withHeader(HeaderConstants.SOURCE_IF_UNMODIFIED_SINCE, options.sourceAccessConditions.DateUnModifiedSince);
	  }
	  
	  if (!webResource.headers || webResource.headers[HeaderConstants.CONTENT_TYPE] === undefined) {
	    // work around to add an empty content type header to prevent the request module from magically adding a content type.
	    webResource.headers[HeaderConstants.CONTENT_TYPE] = '';
	  } else if (webResource.headers && webResource.headers[HeaderConstants.CONTENT_TYPE] === null) {
	    delete webResource.headers[HeaderConstants.CONTENT_TYPE];
	  }
	
	  if (!webResource.headers || webResource.headers[HeaderConstants.CONTENT_LENGTH] === undefined) {
	    if (body && body.outputData) {
	      webResource.withHeader(HeaderConstants.CONTENT_LENGTH, Buffer.byteLength(body.outputData, 'UTF8'));
	    } else if (webResource.headers[HeaderConstants.CONTENT_LENGTH] === undefined) {
	      webResource.withHeader(HeaderConstants.CONTENT_LENGTH, 0);
	    }
	  } else if (webResource.headers && webResource.headers[HeaderConstants.CONTENT_LENGTH] === null) {
	    delete webResource.headers[HeaderConstants.CONTENT_LENGTH];
	  }
	
	  // Sets the request url in the web resource.
	  this._setRequestUrl(webResource, options);
	
	  this.emit('sendingRequestEvent', webResource);
	
	  // Now that the web request is finalized, sign it
	  this.storageCredentials.signRequest(webResource, function (error) {
	    var requestOptions = null;
	
	    if (!error) {
	      var targetUrl = webResource.uri;
	
	      requestOptions = {
	        uri: url.format(targetUrl),
	        method: webResource.method,
	        headers: webResource.headers,
	        mode: 'disable-fetch'
	      };
	
	      if (options) {
	        //set encoding of response data. If set to null, the body is returned as a Buffer
	        requestOptions.encoding = options.responseEncoding;
	      }
	      
	      if (options && options.clientRequestTimeoutInMs) {
	        requestOptions.timeout = options.clientRequestTimeoutInMs;
	      } else {
	        requestOptions.timeout = Constants.DEFAULT_CLIENT_REQUEST_TIMEOUT_IN_MS; // 2 minutes
	      }
	
	      requestOptions.forever = true;
	    }
	
	    callback(error, requestOptions);
	  });
	};
	
	/**
	* Process the response.
	* @ignore
	*
	* @param {WebResource} webResource                The web resource that made the request.
	* @param {Response}    response                   The response object.
	* @param {Options}     options                    The response parsing options.
	* @param {String}      options.payloadFormat      The payload format.
	* @return The normalized responseObject.
	*/
	StorageServiceClient.prototype._processResponse = function (webResource, response, options) {
	  var self = this;
	
	  function convertRawHeadersToHeaders(rawHeaders) {
	    var headers = {};
	    if(!rawHeaders) {
	      return undefined;
	    }
	
	    for(var i = 0; i < rawHeaders.length; i++) {
	      var headerName;
	      if (rawHeaders[i].indexOf(HeaderConstants.PREFIX_FOR_STORAGE_METADATA) === 0) {
	        headerName = rawHeaders[i];
	      } else {
	        headerName = rawHeaders[i].toLowerCase();
	      }
	      headers[headerName] = rawHeaders[++i];
	    }
	
	    return headers;
	  }
	
	  var validResponse = WebResource.validResponse(response.statusCode);
	  var rsp = StorageServiceClient._buildResponse(validResponse, response.body, convertRawHeadersToHeaders(response.rawHeaders) || response.headers, response.statusCode, response.md5);
	  var responseObject;
	
	  if (validResponse && webResource.rawResponse) {
	    responseObject = { error: null, response: rsp };
	  } else {
	    // attempt to parse the response body, errors will be returned in rsp.error without modifying the body
	    rsp = StorageServiceClient._parseResponse(rsp, self.xml2jsSettings, options);
	
	    if (validResponse && !rsp.error) {
	        responseObject = { error: null, response: rsp };
	    } else {
	      rsp.isSuccessful = false;
	
	      if (response.statusCode < 400 || response.statusCode >= 500) {
	        this.logger.log(Logger.LogLevels.DEBUG,
	            'ERROR code = ' + response.statusCode + ' :\n' + util.inspect(rsp.body));
	      }
	
	      // responseObject.error should contain normalized parser errors if they occured in _parseResponse
	      // responseObject.response.body should contain the raw response body in that case
	      var errorBody = rsp.body;
	      if(rsp.error) {
	        errorBody = rsp.error;
	        delete rsp.error;
	      }
	
	      if (!errorBody) {
	        var code = Object.keys(HttpResponseCodes).filter(function (name) {
	          if (HttpResponseCodes[name] === rsp.statusCode) {
	            return name;
	          }
	        });
	
	        errorBody = { error: { code: code[0] } };
	      }
	
	      var normalizedError = StorageServiceClient._normalizeError(errorBody, response);
	      responseObject = { error: normalizedError, response: rsp };
	    }
	  }
	
	  this.logger.log(Logger.LogLevels.DEBUG, 'RESPONSE:\n' + util.inspect(responseObject));
	
	  return responseObject;
	};
	
	/**
	* Associate a filtering operation with this StorageServiceClient. Filtering operations
	* can include logging, automatically retrying, etc. Filter operations are objects
	* that implement a method with the signature:
	*
	*     "function handle (requestOptions, next)".
	*
	* After doing its preprocessing on the request options, the method needs to call
	* "next" passing a callback with the following signature:
	* signature:
	*
	*     "function (returnObject, finalCallback, next)"
	*
	* In this callback, and after processing the returnObject (the response from the
	* request to the server), the callback needs to either invoke next if it exists to
	* continue processing other filters or simply invoke finalCallback otherwise to end
	* up the service invocation.
	*
	* @param {Object} filter The new filter object.
	* @return {StorageServiceClient} A new service client with the filter applied.
	*/
	StorageServiceClient.prototype.withFilter = function (newFilter) {
	    // Create a new object with the same members as the current service
	    var derived = _.clone(this);
	
	    // If the current service has a filter, merge it with the new filter
	    // (allowing us to effectively pipeline a series of filters)
	    var parentFilter = this.filter;
	    var mergedFilter = newFilter;
	    if (parentFilter !== undefined) {
	      // The parentFilterNext is either the operation or the nextPipe function generated on a previous merge
	      // Ordering is [f3 pre] -> [f2 pre] -> [f1 pre] -> operation -> [f1 post] -> [f2 post] -> [f3 post]
	      mergedFilter = function (originalRequestOptions, parentFilterNext) {
	        newFilter.handle(originalRequestOptions, function (postRequestOptions, newFilterCallback) {
	          // handle parent filter pre and get Parent filter post
	          var next = function (postPostRequestOptions, parentFilterCallback) {
	            // The parentFilterNext is the filter next to the merged filter.
	            // For 2 filters, that'd be the actual operation.
	            parentFilterNext(postPostRequestOptions, function (responseObject, responseCallback, finalCallback) {
	              parentFilterCallback(responseObject, finalCallback, function (postResponseObject) {
	                newFilterCallback(postResponseObject, responseCallback, finalCallback);
	              });
	            });
	          };
	
	          parentFilter(postRequestOptions, next);
	        });
	      };
	    }
	
	    // Store the filter so it can be applied in performRequest
	    derived.filter = mergedFilter;
	    return derived;
	  };
	
	/*
	* Builds a response object with normalized key names.
	* @ignore
	*
	* @param {Bool}     isSuccessful    Boolean value indicating if the request was successful
	* @param {Object}   body            The response body.
	* @param {Object}   headers         The response headers.
	* @param {int}      statusCode      The response status code.
	* @param {string}   md5             The response's content md5 hash.
	* @return {Object} A response object.
	*/
	StorageServiceClient._buildResponse = function (isSuccessful, body, headers, statusCode, md5) {
	  var response = {
	    isSuccessful: isSuccessful,
	    statusCode: statusCode,
	    body: body,
	    headers: headers,
	    md5: md5
	  };
	
	  if (!azureutil.objectIsNull(headers)) {
	    if (headers[HeaderConstants.REQUEST_SERVER_ENCRYPTED] !== undefined) {
	      response.requestServerEncrypted = (headers[HeaderConstants.REQUEST_SERVER_ENCRYPTED] === 'true');
	    }
	  }
	
	  return response;
	};
	
	/**
	* Parses a server response body from XML or JSON into a JS object.
	* This is done using the xml2js library.
	* @ignore
	*
	* @param {object}     response                   The response object with a property "body" with a XML or JSON string content.
	* @param {object}     xml2jsSettings             The XML to json settings.
	* @param {Options}    options                    The response parsing options.
	* @param {String}     options.payloadFormat      The payload format.
	* @return {object} The same response object with the body part as a JS object instead of a XML or JSON string.
	*/
	StorageServiceClient._parseResponse = function (response, xml2jsSettings, options) {
	  function parseXml(body) {
	    var parsed;
	    var parser = new xml2js.Parser(xml2jsSettings);
	    parser.parseString(azureutil.removeBOM(body.toString()), function (err, parsedBody) {
	      if (err) {
	        var xmlError = new SyntaxError('EXMLFORMAT');
	        xmlError.innerError = err;
	        throw xmlError;
	      } else { parsed = parsedBody; }
	    });
	
	    return parsed;
	  }
	
	  if (response.body && Buffer.byteLength(response.body.toString()) > 0) {
	    var contentType = '';
	    if (response.headers && response.headers['content-type']) {
	      contentType = response.headers['content-type'].toLowerCase();
	    }
	
	    try {
	      if (contentType.indexOf('application/json') !== -1) {
	        if (options && options.payloadFormat && options.payloadFormat !== TableUtilities.PayloadFormat.NO_METADATA) {
	          var parser = new Parser();
	          parser.onValue = function (value) {
	            response.body = value;
	          };
	          parser.write(response.body);
	        } else {
	          response.body = JSON.parse(response.body);
	        }
	      } else if (contentType.indexOf('application/xml') !== -1 || contentType.indexOf('application/atom+xml') !== -1) {
	        response.body = parseXml(response.body);
	      } else if (contentType.indexOf('text/html') !== -1) {
	        response.body = response.body;
	      } else {
	        response.body = parseXml(response.body);
	        // throw new SyntaxError(SR.CONTENT_TYPE_MISSING, null);
	      }
	    } catch (e) {
	      response.error = e;
	    }
	  }
	
	  return response;
	};
	
	/**
	* Gets the storage settings.
	*
	* @param {string} [storageAccountOrConnectionString]  The storage account or the connection string.
	* @param {string} [storageAccessKey]                  The storage access key.
	* @param {string} [host]                              The host address.
	* @param {object} [sasToken]                          The sas token.
	*
	* @return {StorageServiceSettings}
	*/
	StorageServiceClient.getStorageSettings = function (storageAccountOrConnectionString, storageAccessKey, host, sasToken, endpointSuffix) {
	  var storageServiceSettings;
	  if (storageAccountOrConnectionString && !storageAccessKey && !sasToken) {
	    // If storageAccountOrConnectionString was passed and no accessKey was passed, assume connection string
	    storageServiceSettings = StorageServiceSettings.createFromConnectionString(storageAccountOrConnectionString);
	  } else if ((storageAccountOrConnectionString && storageAccessKey) || sasToken || host) {
	    // Account and key or credentials or anonymous
	    storageServiceSettings = StorageServiceSettings.createExplicitly(storageAccountOrConnectionString, storageAccessKey, host, sasToken, endpointSuffix);
	  } else {
	    // Use environment variables
	    storageServiceSettings = StorageServiceSettings.createFromEnvironment();
	  }
	
	  return storageServiceSettings;
	};
	
	/**
	* Sets the webResource's requestUrl based on the service client settings.
	* @ignore
	*
	* @param {WebResource} webResource The web resource where to set the request url.
	*/
	StorageServiceClient.prototype._setRequestUrl = function (webResource, options) {
	  // Normalize the path
	  // Backup the original path of the webResource to make sure it works fine even this function get executed multiple times - like RetryFilter
	  webResource.originalPath = webResource.originalPath || webResource.path;
	  webResource.path = this._getPath(webResource.originalPath);
	
	  if(!this.host){
	    throw new ArgumentNullError('this.host', SR.STORAGE_HOST_LOCATION_REQUIRED);
	  }
	
	  var host = this.host.primaryHost;
	
	  if(!azureutil.objectIsNull(options) && options.currentLocation === Constants.StorageLocation.SECONDARY) {
	    host = this.host.secondaryHost;
	  }
	
	  if(host && host.lastIndexOf('/') !== (host.length - 1)){
	    host = host + '/';
	  }
	  
	  var fullPath = url.format({pathname: webResource.path, query: webResource.queryString});
	  webResource.uri = url.resolve(host, fullPath);
	  webResource.path = url.parse(webResource.uri).pathname;
	};
	
	/**
	* Retrieves the normalized path to be used in a request.
	* It also removes any leading "/" of the path in case
	* it's there before.
	* @ignore
	* @param {string} path The path to be normalized.
	* @return {string} The normalized path.
	*/
	StorageServiceClient.prototype._getPath = function (path) {
	  if (path === null || path === undefined) {
	    path = '';
	  } else if (path.indexOf('/') === 0) {
	    path = path.substring(1);
	  }
	
	  return path;
	};
	
	/**
	 * Get the url of a given path
	 */
	StorageServiceClient.prototype._getUrl = function (path, sasToken, primary) {
	  var host;
	  if (!azureutil.objectIsNull(primary) && primary === false) {
	    host = this.host.secondaryHost;
	  } else {
	    host = this.host.primaryHost;
	  }
	
	  host = azureutil.trimPortFromUri(host);
	  if(host && host.lastIndexOf('/') !== (host.length - 1)){
	    host = host + '/';
	  }
	
	  var query = qs.parse(sasToken);
	  var fullPath = url.format({ pathname: this._getPath(path), query: query });
	  return url.resolve(host, fullPath);
	};
	
	/**
	* Initializes the default filter.
	* This filter is responsible for chaining the pre filters request into the operation and, after processing the response,
	* pass it to the post processing filters. This method should only be invoked by the StorageServiceClient constructor.
	* @ignore
	*
	*/
	StorageServiceClient.prototype._initDefaultFilter = function () {
	  this.filter = function (requestOptions, nextPreCallback) {
	    if (nextPreCallback) {
	      // Handle the next pre callback and pass the function to be handled as post call back.
	      nextPreCallback(requestOptions, function (returnObject, finalCallback, nextPostCallback) {
	        if (nextPostCallback) {
	          nextPostCallback(returnObject);
	        } else if (finalCallback) {
	          finalCallback(returnObject);
	        }
	      });
	    }
	  };
	};
	
	/**
	* Retrieves the metadata headers from the response headers.
	* @ignore
	*
	* @param {object} headers The metadata headers.
	* @return {object} An object with the metadata headers (without the "x-ms-" prefix).
	*/
	StorageServiceClient.prototype.parseMetadataHeaders = function (headers) {
	  var metadata = {};
	
	  if (!headers) {
	    return metadata;
	  }
	
	  for (var header in headers) {
	    if (header.indexOf(HeaderConstants.PREFIX_FOR_STORAGE_METADATA) === 0) {
	      var key = header.substr(HeaderConstants.PREFIX_FOR_STORAGE_METADATA.length, header.length - HeaderConstants.PREFIX_FOR_STORAGE_METADATA.length);
	      metadata[key] = headers[header];
	    }
	  }
	  
	  return metadata;
	};
	
	/**
	* Gets the properties of a storage account’s service, including Azure Storage Analytics.
	* @ignore
	*
	* @this {StorageServiceClient}
	* @param {object}       [options]                               The request options.
	* @param {LocationMode} [options.locationMode]                  Specifies the location mode used to decide which location the request should be sent to. 
	*                                                               Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}          [options.timeoutIntervalInMs]           The server timeout interval, in milliseconds, to use for the request.
	* @param {int}          [options.clientRequestTimeoutInMs]      The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}          [options.maximumExecutionTimeInMs]      The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                               The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                               execution time is checked intermittently while performing requests, and before executing retries.
	* @param {bool}         [options.useNagleAlgorithm]             Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                               The default value is false.
	* @param {errorOrResult}  callback                              `error` will contain information if an error occurs; otherwise, `result` will contain the properties 
	*                                                               and `response` will contain information related to this operation.
	*/
	StorageServiceClient.prototype.getAccountServiceProperties = function (optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	  
	  validate.validateArgs('getServiceProperties', function (v) {
	    v.callback(callback);
	  });
	  
	  var options = extend(true, {}, userOptions);
	  
	  var webResource = WebResource.get()
	    .withQueryOption(QueryStringConstants.COMP, 'properties')
	    .withQueryOption(QueryStringConstants.RESTYPE, 'service');
	  
	  options.requestLocationMode = RequestLocationMode.PRIMARY_OR_SECONDARY;
	  
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.servicePropertiesResult = null;
	    if (!responseObject.error) {
	      responseObject.servicePropertiesResult = ServicePropertiesResult.parse(responseObject.response.body.StorageServiceProperties);
	    }
	    
	    // function to be called after all filters
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.servicePropertiesResult, returnObject.response);
	    };
	    
	    // call the first filter
	    next(responseObject, finalCallback);
	  };
	  
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Sets the properties of a storage account’s service, including Azure Storage Analytics.
	* You can also use this operation to set the default request version for all incoming requests that do not have a version specified.
	*
	* @this {StorageServiceClient}
	* @param {object}             serviceProperties                        The service properties.
	* @param {object}             [options]                                The request options.
	* @param {LocationMode}       [options.locationMode]                   Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                      Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]            The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]       The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]       The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                      The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                      execution time is checked intermittently while performing requests, and before executing retries.
	* @param {bool}               [options.useNagleAlgorithm]              Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                      The default value is false.
	* @param {errorOrResponse}    callback                                 `error` will contain information
	*                                                                      if an error occurs; otherwise, `response`
	*                                                                      will contain information related to this operation.
	*/
	StorageServiceClient.prototype.setAccountServiceProperties = function (serviceProperties, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	  
	  validate.validateArgs('setServiceProperties', function (v) {
	    v.object(serviceProperties, 'serviceProperties');
	    v.callback(callback);
	  });
	  
	  var options = extend(true, {}, userOptions);
	  var servicePropertiesXml = ServicePropertiesResult.serialize(serviceProperties);
	  
	  var webResource = WebResource.put()
	    .withQueryOption(QueryStringConstants.COMP, 'properties')
	    .withQueryOption(QueryStringConstants.RESTYPE, 'service')
	    .withHeader(HeaderConstants.CONTENT_TYPE, 'application/xml;charset="utf-8"')
	    .withHeader(HeaderConstants.CONTENT_LENGTH, Buffer.byteLength(servicePropertiesXml))
	    .withBody(servicePropertiesXml);
	  
	  var processResponseCallback = function (responseObject, next) {
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.response);
	    };
	    
	    next(responseObject, finalCallback);
	  };
	  
	  this.performRequest(webResource, webResource.body, options, processResponseCallback);
	};
	
	// Other functions
	
	/**
	* Processes the error body into a normalized error object with all the properties lowercased.
	*
	* Error information may be returned by a service call with additional debugging information:
	* http://msdn.microsoft.com/en-us/library/windowsazure/dd179382.aspx
	*
	* Table services returns these properties lowercased, example, "code" instead of "Code". So that the user
	* can always expect the same format, this method lower cases everything.
	*
	* @ignore
	*
	* @param {Object} error The error object as returned by the service and parsed to JSON by the xml2json.
	* @return {Object} The normalized error object with all properties lower cased.
	*/
	StorageServiceClient._normalizeError = function (error, response) {
	  if (azureutil.objectIsString(error)) {
	    return new StorageError(error, null);
	  } else if (error) {
	    var normalizedError = {};
	
	    // blob/queue errors should have error.Error, table errors should have error['odata.error']
	    var errorProperties = error.Error || error.error || error['odata.error'] || error['m:error'] || error;
	    normalizedError.code = errorProperties.message; // The message exists when there is error.Error.
	    
	    for (var property in errorProperties) {
	      if (errorProperties.hasOwnProperty(property)) {
	        var key = property.toLowerCase();
	        if(key.indexOf('m:') === 0) {
	          key = key.substring(2);
	        }
	        
	        normalizedError[key] = errorProperties[property];
	
	        // if this is a table error, message is an object - flatten it to normalize with blob/queue errors
	        // ex: "message":{"lang":"en-US","value":"The specified resource does not exist."} becomes message: "The specified resource does not exist."
	        if (key === 'message' && _.isObject(errorProperties[property])) {
	          if (errorProperties[property]['value']) {
	            normalizedError[key] = errorProperties[property]['value'];
	          }
	        }
	      }
	    }
	
	    // add status code and server request id if available
	    if (response) {
	      if (response.statusCode) {
	        normalizedError.statusCode = response.statusCode;
	      }
	
	      if (response.headers && response.headers['x-ms-request-id']) {
	        normalizedError.requestId = response.headers['x-ms-request-id'];
	      }
	    }
	
	    var errorObject = new StorageError(normalizedError.code, normalizedError);
	    return errorObject;
	  }
	
	  return null;
	};
	
	/**
	* Sets proxy object specified by caller.
	*
	* @param {object}   proxy       proxy to use for tunneling
	*                               {
	*                                host: hostname
	*                                port: port number
	*                                proxyAuth: 'user:password' for basic auth
	*                                headers: {...} headers for proxy server
	*                                key: key for proxy server
	*                                ca: ca for proxy server
	*                                cert: cert for proxy server
	*                               }
	*                               if null or undefined, clears proxy
	*/
	StorageServiceClient.prototype.setProxy = function (proxy) {
	  if (proxy) {
	    this.proxy = proxy;
	  } else {
	    this.proxy = null;
	  }
	};
	
	/**
	* Sets the service host default proxy from the environment.
	* Can be overridden by calling _setProxyUrl or _setProxy
	*
	*/
	StorageServiceClient.prototype._setDefaultProxy = function () {
	  var proxyUrl = StorageServiceClient._loadEnvironmentProxyValue();
	  if (proxyUrl) {
	    var parsedUrl = url.parse(proxyUrl);
	    if (!parsedUrl.port) {
	      parsedUrl.port = 80;
	    }
	    this.setProxy(parsedUrl);
	  } else {
	    this.setProxy(null);
	  }
	};
	
	/*
	* Loads the fields "useProxy" and respective protocol, port and url
	* from the environment values HTTPS_PROXY and HTTP_PROXY
	* in case those are set.
	* @ignore
	*
	* @return {string} or null
	*/
	StorageServiceClient._loadEnvironmentProxyValue = function () {
	  var proxyUrl = null;
	  if (({"NODE_ENV":"production","PUBLIC_URL":"."})[StorageServiceClientConstants.EnvironmentVariables.HTTPS_PROXY]) {
	    proxyUrl = ({"NODE_ENV":"production","PUBLIC_URL":"."})[StorageServiceClientConstants.EnvironmentVariables.HTTPS_PROXY];
	  } else if (({"NODE_ENV":"production","PUBLIC_URL":"."})[StorageServiceClientConstants.EnvironmentVariables.HTTPS_PROXY.toLowerCase()]) {
	    proxyUrl = ({"NODE_ENV":"production","PUBLIC_URL":"."})[StorageServiceClientConstants.EnvironmentVariables.HTTPS_PROXY.toLowerCase()];
	  } else if (({"NODE_ENV":"production","PUBLIC_URL":"."})[StorageServiceClientConstants.EnvironmentVariables.HTTP_PROXY]) {
	    proxyUrl = ({"NODE_ENV":"production","PUBLIC_URL":"."})[StorageServiceClientConstants.EnvironmentVariables.HTTP_PROXY];
	  } else if (({"NODE_ENV":"production","PUBLIC_URL":"."})[StorageServiceClientConstants.EnvironmentVariables.HTTP_PROXY.toLowerCase()]) {
	    proxyUrl = ({"NODE_ENV":"production","PUBLIC_URL":"."})[StorageServiceClientConstants.EnvironmentVariables.HTTP_PROXY.toLowerCase()];
	  }
	
	  return proxyUrl;
	};
	
	/**
	* Initializes the location to which the operation is being sent to.
	*/
	StorageServiceClient.prototype._initializeLocation = function (options) {
	  if(!azureutil.objectIsNull(options.locationMode)) {
	    switch(options.locationMode) {
	    case StorageUtilities.LocationMode.PRIMARY_ONLY:
	    case StorageUtilities.LocationMode.PRIMARY_THEN_SECONDARY:
	      options.currentLocation = Constants.StorageLocation.PRIMARY;
	      break;
	    case StorageUtilities.LocationMode.SECONDARY_ONLY:
	    case StorageUtilities.LocationMode.SECONDARY_THEN_PRIMARY:
	      options.currentLocation = Constants.StorageLocation.SECONDARY;
	      break;
	    default:
	      throw new RangeError(util.format(SR.ARGUMENT_OUT_OF_RANGE_ERROR, 'locationMode', options.locationMode));
	    }
	  } else {
	    options.locationMode = StorageUtilities.LocationMode.PRIMARY_ONLY;
	    options.currentLocation = Constants.StorageLocation.PRIMARY;
	  }
	};
	
	/**
	* Validates the location to which the operation is being sent to.
	*/
	StorageServiceClient.prototype._validateLocation = function (options) {
	  if(this._invalidLocationMode(options.locationMode)) {
	    throw new ArgumentNullError('host', SR.STORAGE_HOST_MISSING_LOCATION);
	  }
	
	  switch(options.requestLocationMode) {
	  case Constants.RequestLocationMode.PRIMARY_ONLY:
	    if(options.locationMode === StorageUtilities.LocationMode.SECONDARY_ONLY) {
	      throw new ArgumentError('host.primaryHost', SR.PRIMARY_ONLY_COMMAND);
	    }
	
	    options.currentLocation = Constants.StorageLocation.PRIMARY;
	    options.locationMode = StorageUtilities.LocationMode.PRIMARY_ONLY;
	    break;
	
	  case Constants.RequestLocationMode.SECONDARY_ONLY:
	    if(options.locationMode === StorageUtilities.LocationMode.PRIMARY_ONLY) {
	      throw new ArgumentError('host.secondaryHost', SR.SECONDARY_ONLY_COMMAND);
	    }
	
	    options.currentLocation = Constants.StorageLocation.SECONDARY;
	    options.locationMode = StorageUtilities.LocationMode.SECONDARY_ONLY;
	    break;
	
	  default:
	   // no op
	  }
	};
	
	/**
	* Checks whether we have the relevant host information based on the locationMode.
	*/
	StorageServiceClient.prototype._invalidLocationMode = function (locationMode) {
	  switch(locationMode) {
	  case StorageUtilities.LocationMode.PRIMARY_ONLY:
	    return azureutil.objectIsNull(this.host.primaryHost);
	  case StorageUtilities.LocationMode.SECONDARY_ONLY:
	    return azureutil.objectIsNull(this.host.secondaryHost);
	  default:
	    return (azureutil.objectIsNull(this.host.primaryHost) || azureutil.objectIsNull(this.host.secondaryHost));
	  }
	};
	
	/**
	* Checks to see if the maximum execution timeout provided has been exceeded.
	*/
	StorageServiceClient.prototype._maximumExecutionTimeExceeded = function (currentTime, expiryTime) {
	  if(!azureutil.objectIsNull(expiryTime) && currentTime > expiryTime) {
	    return true;
	  } else {
	    return false;
	  }
	};
	
	/**
	* Sets the operation expiry time.
	*/
	StorageServiceClient.prototype._setOperationExpiryTime = function (options) {
	  if(azureutil.objectIsNull(options.operationExpiryTime)) {
	    if(!azureutil.objectIsNull(options.maximumExecutionTimeInMs)) {
	      options.operationExpiryTime = Date.now() + options.maximumExecutionTimeInMs;
	    } else if(this.defaultMaximumExecutionTimeInMs) {
	      options.operationExpiryTime = Date.now() + this.defaultMaximumExecutionTimeInMs;
	    }
	  }
	};
	
	module.exports = StorageServiceClient;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(2).Buffer))

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	'use strict';
	
	var _ = __webpack_require__(15);
	var url = __webpack_require__(33);
	
	var util = __webpack_require__(16);
	var ServiceSettings = __webpack_require__(132);
	var Constants = __webpack_require__(12);
	var StorageServiceClientConstants = Constants.StorageServiceClientConstants;
	var ConnectionStringKeys = Constants.ConnectionStringKeys;
	var Validate = __webpack_require__(82);
	var SR = __webpack_require__(25);
	
	var useDevelopmentStorageSetting = ServiceSettings.setting(ConnectionStringKeys.USE_DEVELOPMENT_STORAGE_NAME, true);
	var developmentStorageProxyUriSetting = ServiceSettings.settingWithFunc(ConnectionStringKeys.DEVELOPMENT_STORAGE_PROXY_URI_NAME, Validate.isValidUri);
	var defaultEndpointsProtocolSetting = ServiceSettings.setting(ConnectionStringKeys.DEFAULT_ENDPOINTS_PROTOCOL_NAME, 'http', 'https');
	var accountNameSetting = ServiceSettings.setting(ConnectionStringKeys.ACCOUNT_NAME_NAME);
	var accountKeySetting = ServiceSettings.settingWithFunc(ConnectionStringKeys.ACCOUNT_KEY_NAME, Validate.isBase64Encoded);
	var sasSetting = ServiceSettings.settingWithFunc(ConnectionStringKeys.SHARED_ACCESS_SIGNATURE_NAME, _.isString);
	
	var blobEndpointSetting = ServiceSettings.settingWithFunc(
	  ConnectionStringKeys.BLOB_ENDPOINT_NAME,
	  Validate.isValidHost
	);
	
	var queueEndpointSetting = ServiceSettings.settingWithFunc(
	  ConnectionStringKeys.QUEUE_ENDPOINT_NAME,
	  Validate.isValidHost
	);
	
	var tableEndpointSetting = ServiceSettings.settingWithFunc(
	  ConnectionStringKeys.TABLE_ENDPOINT_NAME,
	  Validate.isValidHost
	);
	
	var fileEndpointSetting = ServiceSettings.settingWithFunc(
	  ConnectionStringKeys.FILE_ENDPOINT_NAME,
	  Validate.isValidHost
	);
	
	var endpointSuffixSetting = ServiceSettings.settingWithFunc(
	  ConnectionStringKeys.ENDPOINT_SUFFIX_NAME,
	  Validate.isValidHost
	);
	
	var validKeys = [
	  ConnectionStringKeys.USE_DEVELOPMENT_STORAGE_NAME,
	  ConnectionStringKeys.DEVELOPMENT_STORAGE_PROXY_URI_NAME,
	  ConnectionStringKeys.DEFAULT_ENDPOINTS_PROTOCOL_NAME,
	  ConnectionStringKeys.ACCOUNT_NAME_NAME,
	  ConnectionStringKeys.ACCOUNT_KEY_NAME,
	  ConnectionStringKeys.SHARED_ACCESS_SIGNATURE_NAME,
	  ConnectionStringKeys.BLOB_ENDPOINT_NAME,
	  ConnectionStringKeys.QUEUE_ENDPOINT_NAME,
	  ConnectionStringKeys.TABLE_ENDPOINT_NAME,
	  ConnectionStringKeys.FILE_ENDPOINT_NAME,
	  ConnectionStringKeys.ENDPOINT_SUFFIX_NAME
	];
	
	/**
	* Creates new storage service settings instance.
	*
	* @param {string} name                      The storage service name.
	* @param {string} key                       The storage service key.
	* @param {string} sasToken                  The storage service shared access signature token.
	* @param {string} blobEndpoint              The storage service blob endpoint.
	* @param {string} queueEndpoint             The storage service queue endpoint.
	* @param {string} tableEndpoint             The storage service table endpoint.
	* @param {string} fileEndpoint              The storage service file endpoint.
	* @param {bool}   usePathStyleUri           Boolean value indicating wether to use path style uri or not.
	*/
	function StorageServiceSettings(name, key, sasToken, blobEndpoint, queueEndpoint, tableEndpoint, fileEndpoint, usePathStyleUri) {
	  this._name = name;
	  this._key = key;
	
	  if (sasToken && sasToken[0] === '?') {
	    this._sasToken = sasToken.slice(1);
	  } else {
	    this._sasToken = sasToken;
	  }
	
	  this._blobEndpoint = blobEndpoint;
	  this._queueEndpoint = queueEndpoint;
	  this._tableEndpoint = tableEndpoint;
	  this._fileEndpoint = fileEndpoint;
	
	  if (usePathStyleUri) {
	    this._usePathStyleUri = usePathStyleUri;
	  } else {
	    this._usePathStyleUri = false;
	  }
	}
	
	/**
	* Creates a StorageServiceSettings object from the given connection string.
	*
	* @param {string} connectionString The storage settings connection string.
	* @return {StorageServiceSettings}
	*/
	StorageServiceSettings.createFromConnectionString = function (connectionString) {
	  var tokenizedSettings = ServiceSettings.parseAndValidateKeys(connectionString, validKeys);
	
	  try {
	    return StorageServiceSettings.createFromSettings(tokenizedSettings);
	  } catch (e) {
	    if (e instanceof ServiceSettings.NoMatchError) {
	      // Replace no match settings exception by no match connection string one.
	      ServiceSettings.noMatchConnectionString(connectionString);
	    } else {
	      throw e;
	    }
	  }
	};
	
	StorageServiceSettings.createExplicitly = function (storageAccount, storageAccessKey, host, sasToken, endpointSuffix) {
	  var settings = {};
	  function addIfNotNullOrEmpty(key, value){
	    if(typeof value === 'string' && !util.stringIsEmpty(value)){
	      settings[key] = value;
	    } else if (typeof value == 'object' && !util.objectIsNull(value)) {
	      settings[key] = value;
	    }
	  }
	
	  // Endpoints
	  if (host) {
	    addIfNotNullOrEmpty('blobendpoint', host);
	    addIfNotNullOrEmpty('tableendpoint', host);
	    addIfNotNullOrEmpty('queueendpoint', host);
	    addIfNotNullOrEmpty('fileendpoint', host);
	  } else {
	    addIfNotNullOrEmpty('defaultendpointsprotocol', ServiceSettings.DEFAULT_PROTOCOL.split(':', 1)[0]);
	  }
	
	  addIfNotNullOrEmpty('accountname', storageAccount);
	  addIfNotNullOrEmpty('accountkey', storageAccessKey);
	  addIfNotNullOrEmpty('sharedaccesssignature', sasToken);
	  addIfNotNullOrEmpty('endpointsuffix', endpointSuffix);
	
	  return StorageServiceSettings.createFromSettings(settings);
	};
	
	StorageServiceSettings.createFromEnvironment = function () {
	  var emulated = ({"NODE_ENV":"production","PUBLIC_URL":"."})[StorageServiceClientConstants.EnvironmentVariables.EMULATED];
	  if (emulated) {
	    return StorageServiceSettings.getDevelopmentStorageAccountSettings();
	  } 
	
	  var connectionString = ({"NODE_ENV":"production","PUBLIC_URL":"."})[StorageServiceClientConstants.EnvironmentVariables.AZURE_STORAGE_CONNECTION_STRING];
	  if (connectionString) {
	    return StorageServiceSettings.createFromConnectionString(connectionString);
	  } 
	
	  var storageAccount = ({"NODE_ENV":"production","PUBLIC_URL":"."})[StorageServiceClientConstants.EnvironmentVariables.AZURE_STORAGE_ACCOUNT];
	  var storageAccessKey = ({"NODE_ENV":"production","PUBLIC_URL":"."})[StorageServiceClientConstants.EnvironmentVariables.AZURE_STORAGE_ACCESS_KEY];
	  if(storageAccount && storageAccessKey){
	    return StorageServiceSettings.createExplicitly(storageAccount, storageAccessKey, null, null, null);
	  }
	
	  throw new Error(SR.NO_CREDENTIALS_PROVIDED);
	};
	
	/**
	* Creates a StorageServiceSettings object from a set of settings.
	*
	* @param {object} settings The settings object.
	* @return {StorageServiceSettings}
	*/
	StorageServiceSettings.createFromSettings = function (settings) {
	  // Devstore case
	  var matchedSpecs = ServiceSettings.matchedSpecification(
	    settings,
	    ServiceSettings.allRequired(useDevelopmentStorageSetting),
	    ServiceSettings.optional(developmentStorageProxyUriSetting)
	  );
	
	  if (matchedSpecs) {
	    var proxyUri = util.tryGetValueInsensitive(
	      ConnectionStringKeys.DEVELOPMENT_STORAGE_PROXY_URI_NAME,
	      settings
	    );
	
	    return this.getDevelopmentStorageAccountSettings(proxyUri);
	  }
	
	  // Account/Key automatic case
	  matchedSpecs = ServiceSettings.matchedSpecification(
	    settings,
	    ServiceSettings.allRequired(
	      defaultEndpointsProtocolSetting,
	      accountNameSetting,
	      accountKeySetting
	    ), 
	    ServiceSettings.optional(
	      blobEndpointSetting,
	      queueEndpointSetting,
	      tableEndpointSetting,
	      fileEndpointSetting,
	      endpointSuffixSetting
	    )
	  );
	
	  if (matchedSpecs) {  
	    return this._createStorageServiceSettings(settings);
	  }
	
	  // Account/Key explicit case
	  matchedSpecs = ServiceSettings.matchedSpecification(
	    settings,
	    ServiceSettings.allRequired(
	      accountNameSetting,
	      accountKeySetting
	    ),
	    ServiceSettings.atLeastOne(
	      blobEndpointSetting,
	      queueEndpointSetting,
	      tableEndpointSetting,
	      fileEndpointSetting,
	      endpointSuffixSetting
	    )
	  );
	
	  if (matchedSpecs) {  
	    return this._createStorageServiceSettings(settings);
	  }
	
	  // SAS case
	  matchedSpecs = ServiceSettings.matchedSpecification(
	    settings,
	    ServiceSettings.allRequired(
	      sasSetting
	    ),
	    ServiceSettings.atLeastOne(
	      blobEndpointSetting,
	      queueEndpointSetting,
	      tableEndpointSetting,
	      fileEndpointSetting,
	      endpointSuffixSetting
	    )
	  );
	
	  if(matchedSpecs) {
	    return this._createStorageServiceSettings(settings);
	  }
	
	  // anonymous explicit case
	  // Only blob anonymous access is valid.
	  matchedSpecs = ServiceSettings.matchedSpecification(
	    settings,
	    ServiceSettings.allRequired(
	      blobEndpointSetting
	    ),
	    ServiceSettings.optional(
	      fileEndpointSetting,
	      queueEndpointSetting,
	      tableEndpointSetting,
	      endpointSuffixSetting
	    )
	  );
	
	  if(matchedSpecs) {
	    return this._createStorageServiceSettings(settings);
	  }
	
	  ServiceSettings.noMatchSettings(settings);
	};
	
	/**
	* Returns a StorageServiceSettings with development storage credentials using
	* the specified proxy Uri.
	*
	* @param {string} proxyUri The proxy endpoint to use.
	* @return {StorageServiceSettings}
	*/
	StorageServiceSettings.getDevelopmentStorageAccountSettings = function (proxyUri) {
	  if (!proxyUri) {
	    proxyUri = StorageServiceClientConstants.DEV_STORE_URI;
	  }
	
	  var parsedUri = url.parse(proxyUri);
	  var scheme = parsedUri.protocol;
	  var host   = parsedUri.host;
	  var prefix = scheme + '//' + host;
	
	  var blobEndpoint = {
	    primaryHost: prefix + ':10000' + '/' + StorageServiceClientConstants.DEVSTORE_STORAGE_ACCOUNT,
	    secondaryHost: prefix + ':10000' + '/' + StorageServiceClientConstants.DEVSTORE_STORAGE_ACCOUNT + '-secondary'
	  };
	
	  var queueEndpoint = {
	    primaryHost: prefix + ':10001' + '/' + StorageServiceClientConstants.DEVSTORE_STORAGE_ACCOUNT,
	    secondaryHost: prefix + ':10001' + '/' + StorageServiceClientConstants.DEVSTORE_STORAGE_ACCOUNT + '-secondary'
	  };
	
	  var tableEndpoint = {
	    primaryHost: prefix + ':10002' + '/' + StorageServiceClientConstants.DEVSTORE_STORAGE_ACCOUNT,
	    secondaryHost: prefix + ':10002' + '/' + StorageServiceClientConstants.DEVSTORE_STORAGE_ACCOUNT + '-secondary'
	  };
	
	  return new StorageServiceSettings(
	    StorageServiceClientConstants.DEVSTORE_STORAGE_ACCOUNT,
	    StorageServiceClientConstants.DEVSTORE_STORAGE_ACCESS_KEY,
	    null,
	    blobEndpoint,
	    queueEndpoint,
	    tableEndpoint,
	    null,
	    true
	  );
	};
	
	/**
	* Creates StorageServiceSettings object given endpoints uri.
	*
	* @ignore
	* @param {array}  settings         The service settings.
	* @param {string} blobEndpointUri  The blob endpoint uri.
	* @param {string} queueEndpointUri The queue endpoint uri.
	* @param {string} tableEndpointUri The table endpoint uri.
	* @param {string} fileEndpointUri  The file endpoint uri.
	* @return {StorageServiceSettings}
	*/
	StorageServiceSettings._createStorageServiceSettings = function (settings) {
	  var standardizeHost = function (host, accountName, scheme, dns){
	    var storageHost;
	    if (host) {
	      storageHost = {};
	      storageHost.primaryHost = _.isString(host) ? host : host.primaryHost;
	      storageHost.secondaryHost = _.isString(host) ? undefined : host.secondaryHost;
	    }
	
	    if (scheme && accountName && dns) {
	      storageHost = storageHost ? storageHost : {};
	      storageHost.primaryHost = storageHost.primaryHost ? storageHost.primaryHost : url.format({ protocol: scheme, hostname: accountName + '.' + dns});
	      storageHost.secondaryHost = storageHost.secondaryHost ? storageHost.secondaryHost : url.format({ protocol: scheme, hostname: accountName + '-secondary.' + dns});
	    }
	
	    return storageHost;
	  };
	
	  var scheme = util.tryGetValueInsensitive(
	    ConnectionStringKeys.DEFAULT_ENDPOINTS_PROTOCOL_NAME,
	    settings
	  );
	
	  var accountName = util.tryGetValueInsensitive(
	    ConnectionStringKeys.ACCOUNT_NAME_NAME,
	    settings
	  );
	
	  var accountKey = util.tryGetValueInsensitive(
	    ConnectionStringKeys.ACCOUNT_KEY_NAME,
	    settings
	  );
	
	  var sasToken = util.tryGetValueInsensitive(
	    ConnectionStringKeys.SHARED_ACCESS_SIGNATURE_NAME,
	    settings
	  );
	
	  var endpointSuffix = util.tryGetValueInsensitive(
	    ConnectionStringKeys.ENDPOINT_SUFFIX_NAME,
	    settings
	  );
	
	  var blobEndpoint = standardizeHost(
	      util.tryGetValueInsensitive(ConnectionStringKeys.BLOB_ENDPOINT_NAME, settings),
	      accountName,
	      scheme,
	      endpointSuffix ? 'blob.' + endpointSuffix : StorageServiceClientConstants.CLOUD_BLOB_HOST);
	
	  var queueEndpoint = standardizeHost(
	      util.tryGetValueInsensitive(ConnectionStringKeys.QUEUE_ENDPOINT_NAME, settings),
	      accountName,
	      scheme,
	      endpointSuffix ? 'queue.' + endpointSuffix : StorageServiceClientConstants.CLOUD_QUEUE_HOST);
	
	  var tableEndpoint = standardizeHost(
	      util.tryGetValueInsensitive(ConnectionStringKeys.TABLE_ENDPOINT_NAME, settings),
	      accountName,
	      scheme,
	      endpointSuffix ? 'table.' + endpointSuffix : StorageServiceClientConstants.CLOUD_TABLE_HOST);
	
	  var fileEndpoint = standardizeHost(
	      util.tryGetValueInsensitive(ConnectionStringKeys.FILE_ENDPOINT_NAME, settings),
	      accountName,
	      scheme,
	      endpointSuffix ? 'file.' + endpointSuffix : StorageServiceClientConstants.CLOUD_FILE_HOST);
	
	
	  return new StorageServiceSettings(
	    accountName,
	    accountKey,
	    sasToken,
	    blobEndpoint,
	    queueEndpoint,
	    tableEndpoint,
	    fileEndpoint
	  );
	};
	
	StorageServiceSettings.validKeys = validKeys;
	
	exports = module.exports = StorageServiceSettings;

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	var util = __webpack_require__(4);
	var http = __webpack_require__(114);
	var https = __webpack_require__(89);
	var EventEmitter = __webpack_require__(14).EventEmitter;
	var os = __webpack_require__(162);
	
	var azureutil = __webpack_require__(16);
	var Logger = __webpack_require__(79);
	var Constants = __webpack_require__(12);
	var errors = __webpack_require__(30);
	var ArgumentError = errors.ArgumentError;
	
	var DEFAULT_OPERATION_MEMORY_USAGE = Constants.BlobConstants.DEFAULT_WRITE_BLOCK_SIZE_IN_BYTES;
	var DEFAULT_CRITICAL_MEMORY_LIMITATION_32_IN_BYTES = Constants.BlobConstants.DEFAULT_CRITICAL_MEMORY_LIMITATION_32_IN_BYTES;
	var DEFAULT_CRITICAL_MEMORY_LIMITATION_BROWSER_IN_BYTES = Constants.BlobConstants.DEFAULT_CRITICAL_MEMORY_LIMITATION_BROWSER_IN_BYTES;
	var DEFAULT_MINIMUM_MEMORY_USAGE_BROWSER_IN_BYTES = Constants.BlobConstants.DEFAULT_MINIMUM_MEMORY_USAGE_BROWSER_IN_BYTES;
	var DEFAULT_GLOBAL_CONCURRENCY = 5; //Default http connection limitation for nodejs
	
	var SystemTotalMemory = os.totalmem();
	var CriticalFreeMemory = 0.1 * SystemTotalMemory;
	var nodeVersion = azureutil.getNodeVersion();
	
	/**
	* Concurrently execute batch operations and call operation callback randomly or in sequence.
	* Random mode is for uploading.
	*   1. Fire user callback when the operation is done.
	* Sequence mode is for downloading.
	*   1. Fire user callback when the operation is done and all previous operations and callback has finished.
	*   2. BatchOperation guarantees the user callback is fired one by one.
	*   3. The next user callback can't be fired until the current one is completed.
	*/
	function BatchOperation(name, options) {
	  if (!options) {
	    options = {};
	  }
	
	  this.name = name;
	  this.logger = options.logger || new Logger(Logger.LogLevels.INFO);
	  this.operationMemoryUsage = options.operationMemoryUsage || DEFAULT_OPERATION_MEMORY_USAGE;
	  this.callbackInOrder = options.callbackInOrder === true;
	  this.callInOrder = options.callInOrder === true;
	  this._currentOperationId = this.callbackInOrder ? 1 : -1;
	  this.concurrency = DEFAULT_GLOBAL_CONCURRENCY;
	  this.enableReuseSocket = (nodeVersion.major > 0 || nodeVersion.minor >= 10) && options.enableReuseSocket;
	
	  this._emitter = new EventEmitter();
	  this._enableComplete = false;
	  this._ended = false;
	  this._error = null;
	  this._paused = false;
	
	  //Total operations count(queued and active and connected)
	  this._totalOperation = 0;
	
	  //Action operations count(The operations which are connecting to remote or executing callback or queued for executing)
	  this._activeOperation = 0;
	
	  //Queued operations count(The operations which are connecting to remote or queued for executing)
	  this._queuedOperation = 0;
	
	  //finished operation should be removed from this array
	  this._operations = [];
	}
	
	/**
	* Operation state
	*/
	var OperationState = {
	  INITED : 'inited',
	  QUEUED : 'queued',
	  RUNNING : 'running',
	  COMPLETE : 'complete',
	  CALLBACK : 'callback',
	  ERROR : 'error'
	};
	
	BatchOperation.OperationState = OperationState;
	
	/**
	* Set batch operation concurrency
	*/
	BatchOperation.prototype.setConcurrency = function(concurrency) {
	  if (concurrency) {
	    this.concurrency = concurrency;
	    http.Agent.maxSockets = this.concurrency;
	    https.Agent.maxSockets = this.concurrency;
	  }
	};
	
	/**
	* Is the workload heavy and It can be used to determine whether we could queue operations
	*/
	BatchOperation.prototype.IsWorkloadHeavy = function() {
	  //Only support one batch operation for now.
	  //In order to work with the multiple batch operation, we can use global operation track objects
	  //BatchOperation acquire a bunch of operation ids from global and allocated ids to RestOperation
	  //RestOperation start to run in order of id
	  var sharedRequest = 1;
	  if(this.enableReuseSocket && !this.callInOrder) {
	    sharedRequest = 2;
	  }
	  return this._activeOperation >= sharedRequest * this.concurrency || this._isLowMemory();
	};
	
	/**
	* Get the approximate memory usage for batch operation.
	*/
	BatchOperation.prototype._getApproximateMemoryUsage = function() {
	  var currentUsage = azureutil.isBrowser() ? DEFAULT_MINIMUM_MEMORY_USAGE_BROWSER_IN_BYTES : process.memoryUsage().rss; // Currently, we cannot get memory usage in browsers
	  var futureUsage = this._queuedOperation * this.operationMemoryUsage;
	  return currentUsage + futureUsage;
	};
	
	/**
	* Return whether in a low memory situation.
	*/
	BatchOperation.prototype._isLowMemory = function() {  
	  var approximateMemoryUsage = this._getApproximateMemoryUsage();
	  return os.freemem() < CriticalFreeMemory ||
	    (this._activeOperation >= this.concurrency && approximateMemoryUsage > 0.5 * SystemTotalMemory) ||
	    (azureutil.is32() && approximateMemoryUsage > DEFAULT_CRITICAL_MEMORY_LIMITATION_32_IN_BYTES) ||
	    (azureutil.isBrowser() && approximateMemoryUsage > DEFAULT_CRITICAL_MEMORY_LIMITATION_BROWSER_IN_BYTES);
	};
	
	/**
	* Add a operation into batch operation
	*/
	BatchOperation.prototype.addOperation = function(operation) {
	  this._operations.push(operation);
	  operation.status = OperationState.QUEUED;
	  operation.operationId = ++this._totalOperation;
	  this._queuedOperation++;
	  this.logger.debug(util.format('Add operation %d into batch operation %s. Active: %s; Queued: %s', operation.operationId, this.name, this._activeOperation, this._queuedOperation));
	  //Immediately start the idle operation if workload isn't heavy
	  this._runOperation(operation);
	  return this.IsWorkloadHeavy();
	};
	
	/**
	* Enable batch operation complete when there is no operation to run.
	*/
	BatchOperation.prototype.enableComplete = function() {
	  this._enableComplete = true;
	  this.logger.debug(util.format('Enable batch operation %s complete', this.name));
	  this._tryEmitEndEvent();
	};
	
	/**
	* Stop firing user call back
	*/
	BatchOperation.prototype.pause = function () {
	  this._paused = true;
	};
	
	/**
	* Start firing user call back
	*/
	BatchOperation.prototype.resume = function () {
	  if (this._paused) {
	    this._paused = false;
	    this._fireOperationUserCallback();
	  }
	};
	
	/**
	* Add event listener
	*/
	BatchOperation.prototype.on = function(event, listener) {
	  // only emit end if the batch has completed all operations
	  if(this._ended && event === 'end') {
	    listener();
	  } else {
	    this._emitter.on(event, listener);
	  }
	};
	
	/**
	* Run operation
	*/
	BatchOperation.prototype._runOperation = function (operation) {
	  this.logger.debug(util.format('Operation %d start to run', operation.operationId));
	  var cb = this.getBatchOperationCallback(operation);
	
	  if(this._error) {
	    cb(this._error);//Directly call the callback with previous error.
	  } else {
	    operation.run(cb);
	  }
	
	  this._activeOperation++;
	};
	
	/**
	* Return an general operation call back.
	* This callback is used to update the internal status and fire user's callback when operation is complete.
	*/
	BatchOperation.prototype.getBatchOperationCallback = function (operation) {
	  var self = this;
	  return function (error) {
	    self._queuedOperation--;
	    if (error) {
	      operation.status = OperationState.ERROR;
	      self.logger.debug(util.format('Operation %d failed. Error %s', operation.operationId, error));
	      self._error = error;
	    } else {
	      operation.status = OperationState.CALLBACK;
	      self.logger.debug(util.format('Operation %d succeed', operation.operationId));
	    }
	
	    operation._callbackArguments = arguments;
	    if (self._paused) {
	      operation.status = OperationState.CALLBACK;
	      self.logger.debug(util.format('Batch operation paused and Operation %d wait for firing callback', operation.operationId));
	    } else if (self.callbackInOrder) {
	      operation.status = OperationState.CALLBACK;
	      if (self._currentOperationId === operation.operationId) {
	        self._fireOperationUserCallback(operation);
	      } else if (self._currentOperationId > operation.operationId) {
	        throw new Error('Debug error: current callback operation id cannot be larger than operation id');
	      } else {
	        self.logger.debug(util.format('Operation %d is waiting for firing callback %s', operation.operationId, self._currentOperationId));
	      }
	    } else {
	      self._fireOperationUserCallback(operation);
	    }
	
	    self._tryEmitDrainEvent();
	    operation = null;
	    self = null;
	  };
	};
	
	/**
	* Fire user's call back
	*/
	BatchOperation.prototype._fireOperationUserCallback = function (operation) {
	  var index = this._getCallbackOperationIndex();
	  if (!operation && index != -1) {
	    operation = this._operations[index];
	  }
	
	  if (operation && !this._paused) {
	    // fire the callback, if exists
	    if (operation._userCallback) {
	      this.logger.debug(util.format('Fire user call back for operation %d', operation.operationId));
	      // make sure UserCallback is a sync operation in sequence mode.
	      // both async and sync operations are available for random mode.
	      operation._fireUserCallback();
	    }
	    
	    // remove the operation from the array and decrement the counter
	    this._operations.splice(index, 1);
	    this._activeOperation--;
	    operation.status = OperationState.COMPLETE;
	    index = operation = null;
	
	    if (this.callbackInOrder) {
	      this._currentOperationId++;
	    }
	
	    this._fireOperationUserCallback();
	  } else if (this._paused) {
	    this._tryEmitDrainEvent();
	  } else {
	    // check if batch has ended and if so emit end event
	    this._tryEmitEndEvent();
	  }
	};
	
	/**
	* Try to emit the BatchOperation end event
	* End event means all the operation and callback already finished.
	*/
	BatchOperation.prototype._tryEmitEndEvent = function () {
	  if(this._enableComplete && this._activeOperation === 0 && this._operations.length === 0) {
	    this._ended = true;
	    this.logger.debug(util.format('Batch operation %s emits the end event', this.name));
	    this._emitter.emit('end', this._error, null);
	    return true;
	  }
	  
	  // Workaround to recover from the 'hang' edge case. _tryEmitEndEvent function is not supposed to be called if the bacth is not really completed.
	  this._tryEmitDrainEvent();
	  return false;
	};
	
	/**
	* Try to emit the drain event
	*/
	BatchOperation.prototype._tryEmitDrainEvent = function () {
	  if (!this._emitter) return false;
	  if(!this.IsWorkloadHeavy() || this._activeOperation < this.concurrency) {
	    this._emitter.emit('drain');
	    return true;
	  }
	  return false;
	};
	
	/**
	* Get the current active operation index.
	* Only the active operation could call user's callback in sequence model.
	* The other finished but not active operations should wait for wake up.
	*/
	BatchOperation.prototype._getCallbackOperationIndex = function () {
	  var operation = null;
	  for (var i = 0; i < this._operations.length; i++) {
	    operation = this._operations[i];
	    if (this.callbackInOrder) {
	      //Sequence mode
	      if (operation.operationId == this._currentOperationId) {
	        if (operation.status === OperationState.CALLBACK) {
	          return i;
	        } else {
	          return -1;
	        }
	      }
	    } else {
	      //Random mode
	      if (operation.status === OperationState.CALLBACK) {
	        return i;
	      }
	    }
	  }
	  return -1;
	};
	
	/**
	* Do nothing and directly call the callback.
	* In random mode, the user callback will be called immediately
	* In sequence mode, the user callback will be called after the previous callback has been called
	*/
	BatchOperation.noOperation = function (cb) {
	  cb();
	};
	
	/**
	* Rest operation in sdk
	*/
	function RestOperation(serviceClient, operation) {
	  this.status = OperationState.Inited;
	  this.operationId = -1;
	  this._callbackArguments = null;
	
	  // setup callback and args
	  this._userCallback = arguments[arguments.length - 1];
	  var sliceEnd = arguments.length;
	  if(azureutil.objectIsFunction(this._userCallback)) {
	    sliceEnd--;
	  } else {
	    this._userCallback = null;
	  }
	  var operationArguments = Array.prototype.slice.call(arguments).slice(2, sliceEnd);
	
	  this.run = function(cb) {
	    var func = serviceClient[operation];
	    if(!func) {
	      throw new ArgumentError('operation', util.format('Unknown operation %s in serviceclient', operation));
	    } else {
	      if(!cb) cb = this._userCallback;
	      operationArguments.push(cb);
	      this.status = OperationState.RUNNING;
	      func.apply(serviceClient, operationArguments);
	      operationArguments = operation = null;
	    }
	  };
	
	  this._fireUserCallback = function () {
	    if(this._userCallback) {
	      this._userCallback.apply(null, this._callbackArguments);
	    }
	  };
	}
	
	BatchOperation.RestOperation = RestOperation;
	
	/**
	* Common operation wrapper
	*/
	function CommonOperation(operationFunc, callback) {
	  this.status = OperationState.Inited;
	  this.operationId = -1;
	  this._callbackArguments = null;
	  var sliceStart = 2;
	  if (azureutil.objectIsFunction(callback)) {
	    this._userCallback = callback;
	  } else {
	    this._userCallback = null;
	    sliceStart = 1;
	  }
	  var operationArguments = Array.prototype.slice.call(arguments).slice(sliceStart);
	  this.run = function (cb) {
	    if (!cb) cb = this._userCallback;
	    operationArguments.push(cb);
	    this.status = OperationState.RUNNING;
	    operationFunc.apply(null, operationArguments);
	    operationArguments = operationFunc = null;
	  };
	  
	  this._fireUserCallback = function () {
	    if (this._userCallback) {
	      this._userCallback.apply(null, this._callbackArguments);
	    }
	    this._userCallback = this._callbackArguments = null;
	  };
	}
	
	BatchOperation.CommonOperation = CommonOperation;
	
	module.exports = BatchOperation;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	var buffer = __webpack_require__(2).Buffer;
	var stream = __webpack_require__(20);
	var util = __webpack_require__(4);
	
	var Constants = __webpack_require__(12);
	var bufferSize = Constants.BlobConstants.DEFAULT_WRITE_BLOCK_SIZE_IN_BYTES;
	
	function BrowserFileReadStream(file, options) {
	  stream.Readable.call(this, options);
	
	  if (!options) {
	    options = {};
	  }
	
	  this._fileReader = new FileReader(file); // HTML FileReader
	  this._file = file;
	  this._size = file.size;
	  this._highWaterMark = options.highWaterMark || bufferSize;
	  this._offset = 0;
	  var self = this;
	
	  this._fileReader.onloadend = function (event) {
	    var data = event.target.result;
	    var buf = buffer.from(data);
	    self.push(buf);
	  };
	
	  this._fileReader.onerror = function (error) {
	    self.emit('error', error);
	  };
	}
	util.inherits(BrowserFileReadStream, stream.Readable);
	
	BrowserFileReadStream.prototype._read = function() {
	  if (this._offset >= this._size) {
	    this.push(null);
	  } else {
	    var end = this._offset + this._highWaterMark;
	    var slice = this._file.slice(this._offset, end);
	    this._fileReader.readAsArrayBuffer(slice);
	    this._offset = end;
	  }
	};
	
	module.exports = BrowserFileReadStream;

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	/**
	* Chunked memory pool allocator.
	* It could dramatically reduce the memory usage.
	* However, it can't dramatically reduce the CPU time since GC in v8 is very efficient.
	*/
	function ChunkAllocator(chunkSize, maxCount) {
	  // Track the unused buffers and number of used buffers
	  this._pool = [];
	  this._inuse = 0;
	
	  // Buffer size
	  this._chunkSize = chunkSize;
	
	  // If total memory is larger than this._chunkSize * this._maxCount, the buffer pool is not used.
	  this._maxCount = maxCount || 10;
	
	  // Immediately add a buffer to the pool.
	  this._extendMemoryPool();
	}
	
	/**
	* Synchronously require a buffer
	* Caller should be aware of that the content of buffer is random since the Buffer.fill is Time-consumed opreation.
	*/
	ChunkAllocator.prototype.getBuffer = function(size) {
	  var buffer = this._getBufferFromPool(size);
	  if (buffer === null) {
	    // Either the total memory is larger than this._chunkSize * this._maxCount
	    // Or, the size does not match the chunk size of the pool
	    buffer = new Buffer(size);
	  }
	
	  this._inuse++;
	  return buffer;
	};
	
	/**
	* Get buffer from the current memory pool.
	*/
	ChunkAllocator.prototype._getBufferFromPool = function(size) {
	  // Return null if the given size does not match the chunk size of the buffer pool.
	  if(size !== this._chunkSize) {
	    return null;
	  } 
	
	  // Extend the memory pool if it is empty.
	  if(this._pool.length === 0) {
	    this._extendMemoryPool();
	  }
	
	  // If the pool is not empty, return a buffer.
	  if(this._pool.length !== 0) {
	    return this._pool.pop();
	  } else {
	    return null;
	  }
	};
	
	/**
	* Extend the memory pool if the maximum size has not been reached.
	*/
	ChunkAllocator.prototype._extendMemoryPool = function() {
	  var total = this._pool.length + this._inuse;
	
	  // If the total is larger than the max, do not allocate more memory.
	  if(total >= this._maxCount) return;
	
	  // Calculate the new number of buffers, equal to the total*2 bounded by 1 and the maxCount
	  var nextSize = Math.min(total * 2, this._maxCount) || 1;
	
	  // Add more buffers.
	  var increment = nextSize - total;
	  for(var i = 0; i < increment; i++) {
	    var buffer = new Buffer(this._chunkSize);
	    this._pool.push(buffer);
	  }
	};
	
	/**
	* Release the buffer.
	*/
	ChunkAllocator.prototype.releaseBuffer = function(buffer) {
	  if(buffer.length !== this._chunkSize) {
	    // Directly delete the buffer if bufferSize is invalid and wait for GC.
	    buffer = null;
	    return;
	  }
	
	  // Add the buffer to the pool if it is not full, otherwise delete it
	  if (this._pool.length < this._maxCount) {
	    this._pool.push(buffer);
	  } else {
	    buffer = null;
	  }
	
	  // Decrement _inuse 
	  this._inuse--;
	
	  // _inuse could be below zero if a buffer is released which was not returned by getBuffer
	  if(this._inuse < 0) {
	    this._inuse = 0;
	  }
	};
	
	/**
	* Destroy ChunkAllocator.
	*/
	ChunkAllocator.prototype.destroy = function() {
	  this._pool = [];
	  this._inuse = 0;
	};
	
	module.exports = ChunkAllocator;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	var ChunkStream = __webpack_require__(137);
	var EventEmitter = __webpack_require__(14).EventEmitter;
	var util = __webpack_require__(4);
	var azureutil = __webpack_require__(16);
	
	/**
	*  Chunk stream
	*  1. Calculate md5
	*  2. Track reading offset
	*  3. Work with customize memory allocator
	*  4. Buffer data from stream.
	*  @param {object} options stream.Readable options
	*/
	function ChunkStreamWithStream(stream, options) {
	  ChunkStream.call(this, options);
	
	  stream.pause(); // Pause stream and wait for data listener. It's useful for node v0.8
	  this._stream = stream;
	  this._stream.on('end', this.end.bind(this)); // Should catch the end event for node v0.8
	}
	
	util.inherits(ChunkStreamWithStream, ChunkStream);
	
	/**
	* Add event listener
	*/
	ChunkStreamWithStream.prototype.on = function(event, listener) {
	  if(event === 'end' && this._streamEnded) {
	    listener(); //Directly call the end event when stream already ended
	  } else {
	    EventEmitter.prototype.on.call(this, event, listener);
	  }
	
	  if (event === 'data') {
	    if (!this._isStreamOpened) {
	      this._isStreamOpened = true;
	      this._stream.on('data', this._buildChunk.bind(this));
	    }
	    if (this._paused === undefined) {
	      this._stream.resume();
	    }
	  }
	  
	  return this;
	};
	
	/**
	* Stop stream from external
	*/
	ChunkStreamWithStream.prototype.stop = function (chunk, encoding, cb) {
	  if (azureutil.objectIsFunction(this._stream.destroy)) {
	    this._stream.destroy();
	  } else {
	    this.pause();
	  }
	  ChunkStream.prototype.end.call(this, chunk, encoding, cb);
	};
	
	/**
	* Pause chunk stream
	*/
	ChunkStreamWithStream.prototype.pause = function () {
	  ChunkStream.prototype.pause.call(this);
	
	  this._stream.pause();
	};
	
	/**
	* Resume read stream
	*/
	ChunkStreamWithStream.prototype.resume = function() {
	  ChunkStream.prototype.resume.call(this);
	
	  this._stream.resume();
	};
	
	ChunkStreamWithStream.prototype.finish = function () {
	  ChunkStream.prototype.finish.call(this);
	  this._stream.emit.call(this._stream, 'finish');
	};
	
	ChunkStreamWithStream.prototype.destroy = function () {
	  ChunkStream.prototype.destroy.call(this);
	  this._stream.emit.call(this._stream, 'close');
	};
	
	module.exports = ChunkStreamWithStream;


/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	var stream = __webpack_require__(20);
	var util = __webpack_require__(4);
	var fs = __webpack_require__(92);
	var validator = __webpack_require__(217);
	
	var Md5Wrapper = __webpack_require__(34);
	var Constants = __webpack_require__(12);
	var bufferSize = Constants.BlobConstants.DEFAULT_WRITE_BLOCK_SIZE_IN_BYTES;
	
	var EventEmitter = __webpack_require__(14).EventEmitter;
	
	/**
	*  File read stream
	*  1. Calculate md5
	*  2. Track reading offset
	*  3. Work with customize memory allocator
	*  4. Buffer data from stream.
	*  @param {object} options stream.Readable options
	*/
	function FileReadStream(path, options) {
	  stream.Stream.call(this);
	  this.readable = true;
	
	  if(!options) {
	    options = {};
	  }
	
	  this._destroyed = false;
	  this._streamEnded = false;
	  this._fd = null;
	  this._fileName = undefined;
	  this._highWaterMark = options.highWaterMark || bufferSize;
	  this._offset = 0;
	  this._paused = undefined;
	  this._allocator = options.allocator;
	  this._fileName = path;
	
	  this._md5hash = null;
	  this._md5sum = undefined;
	
	  if (options.calcContentMd5) {
	    this._md5hash = new Md5Wrapper().createMd5Hash();
	  }
	
	  this._open();
	}
	
	util.inherits(FileReadStream, stream.Stream);
	
	/**
	* Open file
	*/
	FileReadStream.prototype._open = function () {
	  var flags = 'r';
	  var self = this;
	  fs.open(this._fileName, flags, function(error, fd) {
	    if (error) {
	      self.emit('error', error);
	    } else {
	      self._fd = fd;
	      self.emit('open', fd);
	    }
	  });
	};
	
	/**
	* Add event listener
	*/
	FileReadStream.prototype.on = function(event, listener) {
	  if (event === 'data' && this._paused === undefined) {
	    this._paused = false;
	    this._emitData();
	  }
	
	  return EventEmitter.prototype.on.call(this, event, listener);
	};
	
	/**
	* Set memory allocator
	*/
	FileReadStream.prototype.setMemoryAllocator = function(allocator) {
	  this._allocator = allocator;
	};
	
	/**
	* Get buffer
	*/
	FileReadStream.prototype._getBuffer = function(size) {
	  if(this._allocator && this._allocator.getBuffer) {
	    return this._allocator.getBuffer(size);
	  } else {
	    var buffer = new Buffer(size);
	    return buffer;
	  }
	};
	
	/**
	* Release buffer
	*/
	FileReadStream.prototype._releaseBuffer = function(buffer) {
	  if(this._allocator && this._allocator.releaseBuffer) {
	    this._allocator.releaseBuffer(buffer);
	  }
	};
	
	/**
	* Emit the data from file
	*/
	FileReadStream.prototype._emitData = function() {
	  var self = this;
	  if(!this._fd) {
	    this.once('open', function() {
	      self._emitData();
	    });
	    return;
	  }
	
	  if (this._paused || this._streamEnded) {
	    return;
	  }
	  var buffer = this._getBuffer(this._highWaterMark);
	  fs.read(this._fd, buffer, 0, this._highWaterMark, this._offset, function(error, bytesRead, readBuffer) {
	    if (error) {
	      self.emit('error', error);
	      return;
	    }
	
	    if(bytesRead === 0) {
	      if(!self._streamEnded) {
	        self._streamEnded = true;
	        self.emit('end');
	      }
	      return;
	    }
	
	    var range = {
	      start : self._offset,
	      end : self._offset + bytesRead - 1,
	      size : bytesRead
	    };
	
	    var data;
	    if(bytesRead == self._highWaterMark) {
	      data = readBuffer;
	    } else {
	      data = readBuffer.slice(0, bytesRead);
	      //Release the current buffer since we created a new one
	      self._releaseBuffer(readBuffer);
	    }
	
	    if(self._md5hash) {
	      self._md5hash.update(data);
	    }
	
	    self.emit('data', data, range);
	
	    // cleanup
	    self._offset += bytesRead;
	    buffer = readBuffer = data = null;
	    self._emitData();
	  });
	};
	
	/**
	* Get file content md5 when read completely.
	*/
	FileReadStream.prototype.getContentMd5 = function(encoding) {
	  if (!encoding) encoding = 'base64';
	  if(!this._md5hash) {
	    throw new Error('Can\'t get content md5, please set the calcContentMd5 option for FileReadStream.');
	  } else {
	    if (this._streamEnded) {
	      if (!this._md5sum) {
	        this._md5sum = this._md5hash.digest(encoding);
	      }
	      return this._md5sum;
	    } else {
	      throw new Error('FileReadStream has not ended.');
	    }
	  }
	};
	
	/**
	* Pause chunk stream
	*/
	FileReadStream.prototype.pause = function() {
	  this._paused = true;
	};
	
	/**
	* Resume read stream
	*/
	FileReadStream.prototype.resume = function() {
	  var previousState = this._paused;
	  if (this._paused) {
	    this._paused = false;
	
	    if(previousState === true) {
	      //Only start to emit data when it's in pause state
	      this._emitData();
	    }
	  }
	};
	
	FileReadStream.prototype.finish = function () {
	  this.destroy();
	};
	
	FileReadStream.prototype.destroy = function () {
	  if (this._destroyed) {
	    return;
	  }
	
	  var self = this;
	  this.readable = false;
	
	  function close(fd) {
	    fs.close(fd || self._fd, function(err) {
	      if (err) {
	        self.emit('error', err);
	      }
	      else {
	        self.emit('close');
	      }
	    });
	    self._fd = null;
	    self._destroyed = true;
	  }
	
	  // when the stream is closed immediately after creating it
	  if (!validator.isInt('' + this._fd)) {
	    this.once('open', close);
	    return;
	  }
	
	  close();
	};
	
	FileReadStream.prototype.stop = function () {
	  this.destroy();
	  this._streamEnded = true;
	  this.emit('end');
	};
	
	module.exports = FileReadStream;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	var util = __webpack_require__(4);
	var azureutil = __webpack_require__(16);
	
	/**
	* Blob upload/download speed summary
	*/
	function SpeedSummary (name) {
	  this.name = name;
	  this._startTime = Date.now();
	  this._timeWindowInSeconds = 10;
	  this._timeWindow = this._timeWindowInSeconds * 1000;
	  this._totalWindowSize = 0;
	  this._speedTracks = new Array(this._timeWindowInSeconds);
	  this._speedTrackPtr = 0;
	  this.totalSize = undefined;
	  this.completeSize = 0;
	}
	
	/**
	* Convert the size to human readable size
	*/
	function toHumanReadableSize(size, len) {
	  if(!size) return '0B';
	  if (!len || len <= 0) {
	    len = 2;
	  }
	  var units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
	  var i = Math.floor( Math.log(size) / Math.log(1024));
	  return (size/Math.pow(1024, i)).toFixed(len) + units[i];
	}
	
	/**
	* Get running seconds
	*/
	SpeedSummary.prototype.getElapsedSeconds = function(humanReadable) {
	  var now = Date.now();
	  var seconds = parseInt((now - this._startTime) / 1000, 10);
	  if (humanReadable !== false) {
	    var s = parseInt(seconds % 60, 10);
	    seconds /= 60;
	    var m = Math.floor(seconds % 60);
	    seconds /= 60;
	    var h = Math.floor(seconds);
	    seconds = util.format('%s:%s:%s', azureutil.zeroPaddingString(h, 2), azureutil.zeroPaddingString(m, 2), azureutil.zeroPaddingString(s, 2));
	  }
	  return seconds;
	};
	
	/**
	* Get complete percentage
	* @param {int} len The number of digits after the decimal point.
	*/
	SpeedSummary.prototype.getCompletePercent = function(len) {
	  if (this.totalSize) {
	    if(!len || len <= 0) {
	      len = 1;
	    }
	    return (this.completeSize * 100 / this.totalSize).toFixed(len);
	  } else {
	    if(this.totalSize === 0) {
	      return 100;
	    } else {
	      return 0;
	    }
	  }
	};
	
	/**
	* Get average upload/download speed
	*/
	SpeedSummary.prototype.getAverageSpeed = function(humanReadable) {
	  var elapsedTime = this.getElapsedSeconds(false);
	  return this._getInternalSpeed(this.completeSize, elapsedTime, humanReadable);
	};
	
	/**
	* Get instant speed
	*/
	SpeedSummary.prototype.getSpeed = function(humanReadable) {
	  this._refreshSpeedTracks();
	  var elapsedTime = this.getElapsedSeconds(false);
	  elapsedTime = Math.min(elapsedTime, this._timeWindowInSeconds);
	  return this._getInternalSpeed(this._totalWindowSize, elapsedTime, humanReadable);
	};
	
	/**
	* Get internal speed
	*/
	SpeedSummary.prototype._getInternalSpeed = function(totalSize, elapsedTime, humanReadable) {
	  if (elapsedTime <= 0) {
	    elapsedTime = 1;
	  }
	  var speed = totalSize / elapsedTime;
	  if(humanReadable !== false) {
	    speed = toHumanReadableSize(speed) + '/s';
	  }
	  return speed;
	};
	
	/**
	* Refresh speed tracks
	*/
	SpeedSummary.prototype._refreshSpeedTracks = function() {
	  var now = Date.now();
	  var totalSize = 0;
	  for(var i = 0; i < this._speedTracks.length; i++) {
	    if(!this._speedTracks[i]) continue;
	    if(now - this._speedTracks[i].timeStamp <= this._timeWindow) {
	      totalSize += this._speedTracks[i].size;
	    } else {
	      this._speedTracks[i] = null;
	    }
	  }
	  this._totalWindowSize = totalSize;
	};
	
	/**
	* Increment the complete data size
	*/
	SpeedSummary.prototype.increment = function(len) {
	  this.completeSize += len;
	  this._recordSpeed(len);
	  return this.completeSize;
	};
	
	/**
	* record complete size into speed tracks
	*/
	SpeedSummary.prototype._recordSpeed = function(completeSize) {
	  var now = Date.now();
	  var track = this._speedTracks[this._speedTrackPtr];
	  if(track) {
	    var timeDiff = now - track.timeStamp;
	    if(timeDiff > this._timeWindow) {
	      track.timeStamp = now;
	      track.size = completeSize;
	    } else if(timeDiff <= 1000) { //1 seconds
	      track.size += completeSize;
	    } else {
	      this._speedTrackPtr = (this._speedTrackPtr + 1) % this._timeWindowInSeconds;
	      this._recordSpeed(completeSize);
	    }
	  } else {
	    track = {timeStamp : now, size: completeSize};
	    this._speedTracks[this._speedTrackPtr] = track;
	  }
	};
	
	/**
	* Get auto increment function
	*/
	SpeedSummary.prototype.getAutoIncrementFunction = function(size) {
	  var self = this;
	  return function(error, retValue) {
	    if(!error) {
	      var doneSize = 0;
	      if((!retValue && retValue !== 0) || isNaN(retValue)) {
	        doneSize = size;
	      } else {
	        doneSize = retValue;
	      }
	      self.increment(doneSize);
	    }
	  };
	};
	
	/**
	* Get total size
	*/
	SpeedSummary.prototype.getTotalSize = function(humanReadable) {
	  if (humanReadable !== false) {
	    return toHumanReadableSize(this.totalSize);
	  } else {
	    return this.totalSize;
	  }
	};
	
	/**
	* Get completed data size
	*/
	SpeedSummary.prototype.getCompleteSize = function(humanReadable) {
	  if (humanReadable !== false) {
	    return toHumanReadableSize(this.completeSize);
	  } else {
	    return this.completeSize;
	  }
	};
	
	module.exports = SpeedSummary;


/***/ },
/* 282 */
/***/ function(module, exports) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Expose 'AccessCondition'.
	
	/**
	* Defines constants, enums, and utility functions for use with storage access condition.
	* @namespace
	*/
	
	'use strict';
	
	exports = module.exports;
	
	/**
	* Constructs an empty access condition.
	*
	* @return {object} An empty AccessCondition object
	*/
	exports.generateEmptyCondition = function () {
	  return {};
	};
	
	/**
	* Constructs an access condition such that an operation will be performed only if the resource does not exist on the service
	*
	* Setting this access condition modifies the request to include the HTTP If-None-Match conditional header
	
	* @return {AccessConditions} An AccessCondition object that represents a condition that checks for nonexistence
	*/
	exports.generateIfNotExistsCondition = function () {
	  var accessCondition = {};
	  accessCondition.EtagNonMatch = '*';
	  return accessCondition;
	};
	
	/**
	* Constructs an access condition such that an operation will be performed only if the resource exists on the service
	*
	* Setting this access condition modifies the request to include the HTTP If-Match conditional header
	
	* @return {AccessConditions} An AccessCondition object that represents a condition that checks for existence
	*/
	exports.generateIfExistsCondition = function () {
	  var accessCondition = {};
	  accessCondition.EtagMatch = '*';
	  return accessCondition;
	};
	
	/**
	* Constructs an access condition such that an operation will be performed only if the resource's ETag value 
	* does not match the specified ETag value
	*
	* Setting this access condition modifies the request to include the HTTP If-None-Match conditional header
	*
	* @param  {string} etag                    The ETag value to check against the resource's ETag
	* @return {AccessConditions}               An AccessCondition object that represents the If-None-Match condition
	*/
	exports.generateIfNoneMatchCondition = function (etag) {
	  var accessCondition = {};
	  accessCondition.EtagNonMatch = etag;
	  return accessCondition;
	};
	
	/**
	* Constructs an access condition such that an operation will be performed only if the resource's ETag value
	* matches the specified ETag value
	*
	* Setting this access condition modifies the request to include the HTTP If-Match conditional header
	*
	* @param  {string} etag                    The ETag value to check against the resource's ETag
	* @return {AccessConditions}               An AccessCondition object that represents the If-Match condition
	*/
	exports.generateIfMatchCondition = function (etag) {
	  var accessCondition = {};
	  accessCondition.EtagMatch = etag;
	  return accessCondition;
	};
	
	/**
	* Constructs an access condition such that an operation will be performed only if the resource has been
	* modified since the specified time
	*
	* Setting this access condition modifies the request to include the HTTP If-Modified-Since conditional header
	*
	* @param  {Date|string}  time              A date object specifying the time since which the resource must have been modified
	* @return {AccessConditions}               An AccessCondition object that represents the If-Modified-Since condition
	*/
	exports.generateIfModifiedSinceCondition = function (time) {
	  var accessCondition = {};
	  accessCondition.DateModifedSince = time;
	  return accessCondition;
	};
	
	/**
	* Constructs an access condition such that an operation will be performed only if the resource has not been
	* modified since the specified time
	*
	* Setting this access condition modifies the request to include the HTTP If-Unmodified-Since conditional header
	*
	* @param  {Date|string}    time            A date object specifying the time since which the resource must have not been modified
	* @return {AccessConditions}               An AccessCondition object that represents the If-Unmodified-Since condition
	*/
	exports.generateIfNotModifiedSinceCondition = function (time) {
	  var accessCondition = {};
	  accessCondition.DateUnModifiedSince = time;
	  return accessCondition;
	};
	
	/**
	* Constructs an access condition such that an operation will be performed only if the resource's sequence number
	* is equal to the specified value
	*
	* Setting this access condition modifies the request to include the HTTP x-ms-if-sequence-number-eq conditional header
	*
	* @param  {Number|string}    sequenceNumber    A date object specifying the time since which the resource must have not been modified
	* @return {AccessConditions}                   An AccessCondition object that represents the If-Unmodified-Since condition
	*/
	exports.generateSequenceNumberEqualCondition = function (sequenceNumber) {
	  var accessCondition = {};
	  accessCondition.SequenceNumberEqual = sequenceNumber;
	  return accessCondition;
	};
	
	/**
	* Constructs an access condition such that an operation will be performed only if the resource's sequence number
	* is less than the specified value
	*
	* Setting this access condition modifies the request to include the HTTP x-ms-if-sequence-number-lt conditional header
	*
	* @param  {Number|string}    sequenceNumber    A date object specifying the time since which the resource must have not been modified
	* @return {AccessConditions}                   An AccessCondition object that represents the If-Unmodified-Since condition
	*/
	exports.generateSequenceNumberLessThanCondition = function (sequenceNumber) {
	  var accessCondition = {};
	  accessCondition.SequenceNumberLessThan = sequenceNumber;
	  return accessCondition;
	};
	
	/**
	* Constructs an access condition such that an operation will be performed only if the resource's sequence number
	* is less than or equal to the specified value
	*
	* Setting this access condition modifies the request to include the HTTP x-ms-if-sequence-number-le conditional header
	*
	* @param  {Number|string}    sequenceNumber    A date object specifying the time since which the resource must have not been modified
	* @return {AccessConditions}                   An AccessCondition object that represents the If-Unmodified-Since condition
	*/
	exports.generateSequenceNumberLessThanOrEqualCondition = function (sequenceNumber) {
	  var accessCondition = {};
	  accessCondition.SequenceNumberLessThanOrEqual = sequenceNumber;
	  return accessCondition;
	};

/***/ },
/* 283 */
/***/ function(module, exports) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	/**
	* Date/time related helper functions
	* @module date
	* 
	*/
	
	/**
	* Generates a Date object which is in the given days from now.
	* 
	* @param {int} days The days timespan.
	* @return {Date}
	*/
	exports.daysFromNow = function (days) {
	  var date = new Date();
	  date.setDate(date.getDate() + days);
	  return date;
	};
	
	/**
	* Generates a Date object which is in the given hours from now.
	*
	* @param {int} hours The hours timespan.
	* @return {Date}
	*/
	exports.hoursFromNow = function (hours) {
	  var date = new Date();
	  date.setHours(date.getHours() + hours);
	  return date;
	};
	
	/**
	* Generates a Date object which is in the given minutes from now.
	*
	* @param {int} minutes The minutes timespan.
	* @return {Date}
	*/
	exports.minutesFromNow = function (minutes) {
	  var date = new Date();
	  date.setMinutes(date.getMinutes() + minutes);
	  return date;
	};
	
	/**
	* Generates a Date object which is in the given seconds from now.
	*
	* @param {int} seconds The seconds timespan.
	* @return {Date}
	*/
	exports.secondsFromNow = function (seconds) {
	  var date = new Date();
	  date.setSeconds(date.getSeconds() + seconds);
	  return date;
	};

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	'use strict';
	
	var XMLBuilder = __webpack_require__(229);
	
	// Patch xmlbuilder to allow Unicode surrogate pair code
	// points in XML bodies
	
	XMLBuilder.prototype.assertLegalChar = function(str) {
	  var chars, chr;
	  chars = /[\u0000-\u0008\u000B-\u000C\u000E-\u001F\uFFFE-\uFFFF]/;
	  chr = str.match(chars);
	  if (chr) {
	    throw new Error('Invalid character (' + chr + ') in string: ' + str);
	  }
	};

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Module dependencies.
	var qs = __webpack_require__(43);
	var url = __webpack_require__(33);
	var util = __webpack_require__(4);
	var _ = __webpack_require__(15);
	var extend = __webpack_require__(26);
	
	var azureCommon = __webpack_require__(8);
	var BlockRangeStream = __webpack_require__(287);
	var Md5Wrapper = __webpack_require__(34);
	var PageRangeStream = __webpack_require__(288);
	var RangeStream = __webpack_require__(81);
	var azureutil = azureCommon.util;
	var SR = azureCommon.SR;
	var validate = azureCommon.validate;
	var StorageServiceClient = azureCommon.StorageServiceClient;
	var WebResource = azureCommon.WebResource;
	
	// Constants
	var Constants = azureCommon.Constants;
	var BlobConstants = Constants.BlobConstants;
	var HeaderConstants = Constants.HeaderConstants;
	var QueryStringConstants = Constants.QueryStringConstants;
	var RequestLocationMode = Constants.RequestLocationMode;
	
	// Streams
	var BatchOperation = azureCommon.BatchOperation;
	var SpeedSummary = azureCommon.SpeedSummary;
	var ChunkAllocator = azureCommon.ChunkAllocator;
	var ChunkStream = azureCommon.ChunkStream;
	var ChunkStreamWithStream = azureCommon.ChunkStreamWithStream;
	
	// Models requires
	var AclResult = azureCommon.AclResult;
	var ServiceStatsParser = azureCommon.ServiceStatsParser;
	var BlockListResult = __webpack_require__(290);
	var BlobResult = __webpack_require__(289);
	var ContainerResult = __webpack_require__(291);
	var LeaseResult = __webpack_require__(292);
	
	var BlobUtilities = __webpack_require__(51);
	
	// Errors requires
	var errors = __webpack_require__(30);
	var ArgumentError = errors.ArgumentError;
	var ArgumentNullError = errors.ArgumentNullError;
	var StorageError = errors.StorageError;
	
	/**
	* Creates a new BlobService object.
	* If no connection string or storageaccount and storageaccesskey are provided,
	* the AZURE_STORAGE_CONNECTION_STRING or AZURE_STORAGE_ACCOUNT and AZURE_STORAGE_ACCESS_KEY environment variables will be used.
	* @class
	* The BlobService class is used to perform operations on the Microsoft Azure Blob Service.
	* The Blob Service provides storage for binary large objects, and provides
	* functions for working with data stored in blobs as either streams or pages of data.
	* 
	* For more information on the Blob Service, as well as task focused information on using it in a Node.js application, see
	* [How to Use the Blob Service from Node.js](http://azure.microsoft.com/en-us/documentation/articles/storage-nodejs-how-to-use-blob-storage/).
	* The following defaults can be set on the blob service.
	* singleBlobPutThresholdInBytes                       The default maximum size, in bytes, of a blob before it must be separated into blocks.
	* defaultEnableReuseSocket                            The default boolean value to enable socket reuse when uploading local files or streams.
	*                                                     If the Node.js version is lower than 0.10.x, socket reuse will always be turned off.
	* defaultTimeoutIntervalInMs                          The default timeout interval, in milliseconds, to use for request made via the Blob service.
	* defaultClientRequestTimeoutInMs                     The default timeout of client requests, in milliseconds, to use for the request made via the Blob service.
	* defaultMaximumExecutionTimeInMs                     The default maximum execution time across all potential retries, for requests made via the Blob service.
	* defaultLocationMode                                 The default location mode for requests made via the Blob service.
	* parallelOperationThreadCount                        The number of parallel operations that may be performed when uploading a blob that is greater than 
	*                                                     the value specified by the singleBlobPutThresholdInBytes property in size.
	* useNagleAlgorithm                                   Determines whether the Nagle algorithm is used for requests made via the Blob service; true to use the  
	*                                                     Nagle algorithm; otherwise, false. The default value is false.
	* @constructor
	* @extends {StorageServiceClient}
	*
	* @param {string} [storageAccountOrConnectionString]  The storage account or the connection string.
	* @param {string} [storageAccessKey]                  The storage access key.
	* @param {string|object} [host]                       The host address. To define primary only, pass a string. 
	*                                                     Otherwise 'host.primaryHost' defines the primary host and 'host.secondaryHost' defines the secondary host.
	* @param {string} [sasToken]                          The Shared Access Signature token.
	* @param {string} [endpointSuffix]                    The endpoint suffix.
	*/
	function BlobService(storageAccountOrConnectionString, storageAccessKey, host, sasToken, endpointSuffix) {
	  var storageServiceSettings = StorageServiceClient.getStorageSettings(storageAccountOrConnectionString, storageAccessKey, host, sasToken, endpointSuffix);
	
	  BlobService['super_'].call(this,
	    storageServiceSettings._name,
	    storageServiceSettings._key,
	    storageServiceSettings._blobEndpoint,
	    storageServiceSettings._usePathStyleUri,
	    storageServiceSettings._sasToken);
	  
	  this.defaultEnableReuseSocket = Constants.DEFAULT_ENABLE_REUSE_SOCKET;
	  this.singleBlobPutThresholdInBytes = BlobConstants.DEFAULT_SINGLE_BLOB_PUT_THRESHOLD_IN_BYTES;
	  this.parallelOperationThreadCount = Constants.DEFAULT_PARALLEL_OPERATION_THREAD_COUNT;
	}
	
	util.inherits(BlobService, StorageServiceClient);
	
	// Non-class methods
	
	/**
	* Create resource name
	* @ignore
	*
	* @param {string} containerName Container name
	* @param {string} blobName      Blob name
	* @return {string} The encoded resource name.
	*/
	function createResourceName(containerName, blobName, forSAS) {
	  // Resource name
	  if (blobName && !forSAS) {
	    blobName = encodeURIComponent(blobName);
	    blobName = blobName.replace(/%2F/g, '/');
	    blobName = blobName.replace(/%5C/g, '/');
	    blobName = blobName.replace(/\+/g, '%20');
	  }
	
	  // return URI encoded resource name
	  if (blobName) {
	    return containerName + '/' + blobName;
	  }
	  else {
	    return containerName;
	  }
	}
	
	// Blob service methods
	
	/**
	* Gets the service stats for a storage account’s Blob service.
	*
	* @this {BlobService}
	* @param {object}       [options]                               The request options.
	* @param {LocationMode} [options.locationMode]                  Specifies the location mode used to decide which location the request should be sent to. 
	*                                                               Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}          [options.timeoutIntervalInMs]           The timeout interval, in milliseconds, to use for the request.
	* @param {int}          [options.clientRequestTimeoutInMs]      The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}          [options.maximumExecutionTimeInMs]      The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                               The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                               execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}       [options.clientRequestId]               A string that represents the client request ID with a 1KB character limit.
	* @param {bool}         [options.useNagleAlgorithm]             Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                               The default value is false.
	* @param {errorOrResult}  callback                              `error` will contain information if an error occurs; otherwise, `[result]{@link ServiceStats}` will contain the stats and 
	*                                                               `response` will contain information related to this operation.
	*/
	BlobService.prototype.getServiceStats = function (optionsOrCallback, callback) {
	  var options;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { options = o; callback = c; });
	
	  validate.validateArgs('getServiceStats', function (v) {
	    v.callback(callback);
	  });
	
	  var webResource = WebResource.get()
	    .withQueryOption(QueryStringConstants.COMP, 'stats')
	    .withQueryOption(QueryStringConstants.RESTYPE, 'service');
	
	  options.requestLocationMode = RequestLocationMode.PRIMARY_OR_SECONDARY;
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.serviceStatsResult = null;
	    if (!responseObject.error) {
	      responseObject.serviceStatsResult = ServiceStatsParser.parse(responseObject.response.body.StorageServiceStats);
	    }
	
	    // function to be called after all filters
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.serviceStatsResult, returnObject.response);
	    };
	
	    // call the first filter
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Gets the properties of a storage account’s Blob service, including Azure Storage Analytics.
	*
	* @this {BlobService}
	* @param {object}       [options]                               The request options.
	* @param {LocationMode} [options.locationMode]                  Specifies the location mode used to decide which location the request should be sent to. 
	*                                                               Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}          [options.timeoutIntervalInMs]           The server timeout interval, in milliseconds, to use for the request.
	* @param {int}          [options.clientRequestTimeoutInMs]      The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}          [options.maximumExecutionTimeInMs]      The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                               The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                               execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}       [options.clientRequestId]               A string that represents the client request ID with a 1KB character limit.
	* @param {bool}         [options.useNagleAlgorithm]             Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                               The default value is false.
	* @param {errorOrResult}  callback                              `error` will contain information if an error occurs; otherwise, `[result]{@link ServiceProperties}` will contain the properties 
	*                                                               and `response` will contain information related to this operation.
	*/
	BlobService.prototype.getServiceProperties = function (optionsOrCallback, callback) {
	  return this.getAccountServiceProperties(optionsOrCallback, callback);
	};
	
	/**
	* Sets the properties of a storage account's Blob service, including Azure Storage Analytics.
	* You can also use this operation to set the default request version for all incoming requests that do not have a version specified.
	* When you set blob service properties (such as enabling soft delete), it may take up to 30 seconds to take effect. 
	*
	* @this {BlobService}
	* @param {object}             serviceProperties                        The service properties.
	* @param {object}             [options]                                The request options.
	* @param {LocationMode}       [options.locationMode]                   Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                      Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]            The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]       The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]       The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                      The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                      execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]              Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                      The default value is false.
	* @param {errorOrResponse}    callback                                 `error` will contain information
	*                                                                      if an error occurs; otherwise, `response`
	*                                                                      will contain information related to this operation.
	*/
	BlobService.prototype.setServiceProperties = function (serviceProperties, optionsOrCallback, callback) {
	  return this.setAccountServiceProperties(serviceProperties, optionsOrCallback, callback);
	};
	
	/**
	* Sets the tier of a blockblob under a blob storage account, or the tier of a pageblob under a premium storage account.
	*
	* @this {BlobService}
	* @param {string}             container                                The container name.
	* @param {string}             blob                                     The blob name.
	* @param {string}             blobTier                                 Please see BlobUtilities.BlobTier.StandardBlobTier or BlobUtilities.BlobTier.PremiumPageBlobTier for possible values.
	* @param {LocationMode}       [options.locationMode]                   Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                      Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]            The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]       The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]       The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                      The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                      execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]              Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                      The default value is false.
	* @param {errorOrResponse}    callback                                 `error` will contain information
	*                                                                      if an error occurs; otherwise, `response`
	*                                                                      will contain information related to this operation.
	*/
	BlobService.prototype.setBlobTier = function (container, blob, blobTier, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	  
	  validate.validateArgs('setBlobTier', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.string(blobTier, 'blobTier');
	    v.containerNameIsValid(container);
	    v.blobNameIsValid(container, blob);
	    v.blobTierNameIsValid(blobTier);
	    v.callback(callback);
	  });
	  
	  var options = extend(true, {}, userOptions);
	  
	  var resourceName = createResourceName(container, blob);
	  var webResource = WebResource.put(resourceName)
	    .withQueryOption(QueryStringConstants.COMP, 'tier')
	    .withHeader(HeaderConstants.ACCESS_TIER, blobTier);
	  
	  var processResponseCallback = function (responseObject, next) {
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.response);
	    };
	    
	    next(responseObject, finalCallback);
	  };
	  
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Lists a segment containing a collection of container items under the specified account.
	*
	* @this {BlobService}
	* @param {object}             currentToken                                A continuation token returned by a previous listing operation. Please use 'null' or 'undefined' if this is the first operation.
	* @param {object}             [options]                                   The request options.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.maxResults]                        Specifies the maximum number of containers to return per call to Azure storage.
	* @param {string}             [options.include]                           Include this parameter to specify that the container's metadata be returned as part of the response body. (allowed values: '', 'metadata')
	*                                                                         **Note** that all metadata names returned from the server will be converted to lower case by NodeJS itself as metadata is set via HTTP headers and HTTP header names are case insensitive.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information
	*                                                                         if an error occurs; otherwise `result` will contain `entries` and `continuationToken`. 
	*                                                                         `entries`  gives a list of `[containers]{@link ContainerResult}` and the `continuationToken` is used for the next listing operation.
	*                                                                         `response` will contain information related to this operation.
	*/
	BlobService.prototype.listContainersSegmented = function (currentToken, optionsOrCallback, callback) {
	  this.listContainersSegmentedWithPrefix(null /* prefix */, currentToken, optionsOrCallback, callback);
	};
	
	/**
	* Lists a segment containing a collection of container items whose names begin with the specified prefix under the specified account.
	*
	* @this {BlobService}
	* @param {string}             prefix                                      The prefix of the container name.
	* @param {object}             currentToken                                A continuation token returned by a previous listing operation. Please use 'null' or 'undefined' if this is the first operation.
	* @param {object}             [options]                                   The request options.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.maxResults]                        Specifies the maximum number of containers to return per call to Azure storage.
	* @param {string}             [options.include]                           Include this parameter to specify that the container's metadata be returned as part of the response body. (allowed values: '', 'metadata')
	*                                                                         **Note** that all metadata names returned from the server will be converted to lower case by NodeJS itself as metadata is set via HTTP headers and HTTP header names are case insensitive.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information
	*                                                                         if an error occurs; otherwise `result` will contain `entries` and `continuationToken`. 
	*                                                                         `entries`  gives a list of `[containers]{@link ContainerResult}` and the `continuationToken` is used for the next listing operation.
	*                                                                         `response` will contain information related to this operation.
	*/
	BlobService.prototype.listContainersSegmentedWithPrefix = function (prefix, currentToken, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('listContainers', function (v) {
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.get()
	    .withQueryOption(QueryStringConstants.COMP, 'list')
	    .withQueryOption(QueryStringConstants.MAX_RESULTS, options.maxResults)
	    .withQueryOption(QueryStringConstants.INCLUDE, options.include);
	
	  if (!azureutil.objectIsNull(currentToken)) {
	    webResource.withQueryOption(QueryStringConstants.MARKER, currentToken.nextMarker);
	  }
	
	  webResource.withQueryOption(QueryStringConstants.PREFIX, prefix);
	
	  options.requestLocationMode = azureutil.getNextListingLocationMode(currentToken);
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.listContainersResult = null;
	
	    if (!responseObject.error) {
	      responseObject.listContainersResult = {
	        entries: null,
	        continuationToken: null
	      };
	      responseObject.listContainersResult.entries = [];
	
	      var containers = [];
	
	      if (responseObject.response.body.EnumerationResults.Containers && responseObject.response.body.EnumerationResults.Containers.Container) {
	        containers = responseObject.response.body.EnumerationResults.Containers.Container;
	        if (!_.isArray(containers)) {
	          containers = [containers];
	        }
	      }
	
	      containers.forEach(function (currentContainer) {
	        var containerResult = ContainerResult.parse(currentContainer);
	        responseObject.listContainersResult.entries.push(containerResult);
	      });
	
	      if (responseObject.response.body.EnumerationResults.NextMarker) {
	        responseObject.listContainersResult.continuationToken = {
	          nextMarker: null,
	          targetLocation: null
	        };
	
	        responseObject.listContainersResult.continuationToken.nextMarker = responseObject.response.body.EnumerationResults.NextMarker;
	        responseObject.listContainersResult.continuationToken.targetLocation = responseObject.targetLocation;
	      }
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.listContainersResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	// Container methods
	
	/**
	* Checks whether or not a container exists on the service.
	*
	* @this {BlobService}
	* @param {string}             container                               The container name.
	* @param {object}             [options]                               The request options.
	* @param {LocationMode}       [options.locationMode]                  Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                     Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]           The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]      The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                     The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                     execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]               A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]             Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                     The default value is false.
	* @param {errorOrResult}      callback                                `error` will contain information
	*                                                                     if an error occurs; otherwise `[result]{@link ContainerResult}` will contain
	*                                                                     the container information including `exists` boolean member. 
	*                                                                     `response` will contain information related to this operation.
	*/
	BlobService.prototype.doesContainerExist = function (container, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('doesContainerExist', function (v) {
	    v.string(container, 'container');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  this._doesContainerExist(container, false, options, callback);
	};
	
	/**
	* Creates a new container under the specified account.
	* If a container with the same name already exists, the operation fails.
	*
	* @this {BlobService}
	* @param {string}             container                           The container name.
	* @param {object}             [options]                           The request options.
	* @param {LocationMode}       [options.locationMode]              Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                 Please see StorageUtilities.LocationMode for the possible values.
	* @param {object}             [options.metadata]                  The metadata key/value pairs.
	* @param {string}             [options.publicAccessLevel]         Specifies whether data in the container may be accessed publicly and the level of access.
	* @param {int}                [options.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                 The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                 execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]           A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]         Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                 The default value is false.
	* @param {errorOrResult}      callback                            `error` will contain information
	*                                                                 if an error occurs; otherwise `[result]{@link ContainerResult}` will contain
	*                                                                 the container information.
	*                                                                 `response` will contain information related to this operation.
	*/
	BlobService.prototype.createContainer = function (container, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('createContainer', function (v) {
	    v.string(container, 'container');
	    v.test(function () { return container !== '$logs'; },
	      'Container name format is incorrect');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.put(container)
	    .withQueryOption(QueryStringConstants.RESTYPE, 'container');
	
	  webResource.addOptionalMetadataHeaders(options.metadata);
	  webResource.withHeader(HeaderConstants.BLOB_PUBLIC_ACCESS, options.publicAccessLevel);
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.containerResult = null;
	    if (!responseObject.error) {
	      responseObject.containerResult = new ContainerResult(container);
	      responseObject.containerResult.getPropertiesFromHeaders(responseObject.response.headers);
	
	      if (options.metadata) {
	        responseObject.containerResult.metadata = options.metadata;
	      }
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.containerResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Creates a new container under the specified account if the container does not exists.
	*
	* @this {BlobService}
	* @param {string}             container                                 The container name.
	* @param {object}             [options]                                 The request options.
	* @param {LocationMode}       [options.locationMode]                    Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                       Please see StorageUtilities.LocationMode for the possible values.
	* @param {object}             [options.metadata]                        The metadata key/value pairs.
	* @param {string}             [options.publicAccessLevel]               Specifies whether data in the container may be accessed publicly and the level of access.
	* @param {int}                [options.timeoutIntervalInMs]             The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]        The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]        The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                       The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                       execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                 A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]               Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                       The default value is false.
	* @param {errorOrResult}      callback                                  `error` will contain information
	*                                                                       if an error occurs; otherwise `[result]{@link ContainerResult}` will contain
	*                                                                       the container information including `created` boolean member. 
	*                                                                       `response` will contain information related to this operation.
	*
	* @example
	* var azure = require('azure-storage');
	* var blobService = azure.createBlobService();
	* blobService.createContainerIfNotExists('taskcontainer', {publicAccessLevel : 'blob'}, function(error) {
	*   if(!error) {
	*     // Container created or exists, and is public
	*   }
	* }); 
	*/
	BlobService.prototype.createContainerIfNotExists = function (container, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('createContainerIfNotExists', function (v) {
	    v.string(container, 'container');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var self = this;
	  self._doesContainerExist(container, true, options, function (error, result, response) {
	    var exists = result.exists;
	    result.created = false;
	    delete result.exists;
	
	    if (error) {
	      callback(error, result, response);
	    } else if (exists) {
	      response.isSuccessful = true;
	      callback(error, result, response);
	    } else {
	      self.createContainer(container, options, function (createError, containerResult, createResponse) {
	        if (!createError) {
	          containerResult.created = true;
	        }
	        else if (createError && createError.statusCode === Constants.HttpConstants.HttpResponseCodes.Conflict && createError.code === Constants.BlobErrorCodeStrings.CONTAINER_ALREADY_EXISTS) {
	          // If it was created before, there was no actual error.
	          createError = null;
	          createResponse.isSuccessful = true;
	        }
	
	        callback(createError, containerResult, createResponse);
	      });
	    }
	  });
	};
	
	/**
	* Retrieves a container and its properties from a specified account.
	* **Note** that all metadata names returned from the server will be converted to lower case by NodeJS itself as metadata is set via HTTP headers and HTTP header names are case insensitive.
	*
	* @this {BlobService}
	* @param {string}             container                           The container name.
	* @param {object}             [options]                           The request options.
	* @param {LocationMode}       [options.locationMode]              Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                 Please see StorageUtilities.LocationMode for the possible values.
	* @param {string}             [options.leaseId]                   The container lease identifier.
	* @param {int}                [options.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                 The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                 execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]           A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]         Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                 The default value is false.
	* @param {errorOrResult}      callback                            `error` will contain information
	*                                                                 if an error occurs; otherwise `[result]{@link ContainerResult}` will contain
	*                                                                 information for the container.
	*                                                                 `response` will contain information related to this operation.
	*/
	BlobService.prototype.getContainerProperties = function (container, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('getContainerProperties', function (v) {
	    v.string(container, 'container');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.head(container)
	    .withQueryOption(QueryStringConstants.RESTYPE, 'container')
	    .withHeader(HeaderConstants.LEASE_ID, options.leaseId);
	
	  options.requestLocationMode = Constants.RequestLocationMode.PRIMARY_OR_SECONDARY;
	
	  var self = this;
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.containerResult = null;
	    if (!responseObject.error) {
	      responseObject.containerResult = new ContainerResult(container);
	      responseObject.containerResult.metadata = self.parseMetadataHeaders(responseObject.response.headers);
	      responseObject.containerResult.getPropertiesFromHeaders(responseObject.response.headers);
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.containerResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Returns all user-defined metadata for the container.
	* **Note** that all metadata names returned from the server will be converted to lower case by NodeJS itself as metadata is set via HTTP headers and HTTP header names are case insensitive.
	*
	* @this {BlobService}
	* @param {string}             container                                 The container name.
	* @param {object}             [options]                                 The request options.
	* @param {string}             [options.leaseId]                         The container lease identifier.
	* @param {LocationMode}       [options.locationMode]                    Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                       Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]             The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]        The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]        The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                       The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                       execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                 A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]               Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                       The default value is false.
	* @param {errorOrResult}      callback                                  `error` will contain information
	*                                                                       if an error occurs; otherwise `[result]{@link ContainerResult}` will contain
	*                                                                       information for the container.
	*                                                                       `response` will contain information related to this operation.
	*/
	BlobService.prototype.getContainerMetadata = function (container, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('getContainerMetadata', function (v) {
	    v.string(container, 'container');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.head(container)
	    .withQueryOption(QueryStringConstants.RESTYPE, 'container')
	    .withQueryOption(QueryStringConstants.COMP, 'metadata')
	    .withHeader(HeaderConstants.LEASE_ID, options.leaseId);
	
	  options.requestLocationMode = Constants.RequestLocationMode.PRIMARY_OR_SECONDARY;
	
	  var self = this;
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.containerResult = null;
	    if (!responseObject.error) {
	      responseObject.containerResult = new ContainerResult(container);
	      responseObject.containerResult.metadata = self.parseMetadataHeaders(responseObject.response.headers);
	      responseObject.containerResult.getPropertiesFromHeaders(responseObject.response.headers);
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.containerResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Sets the container's metadata.
	*
	* Calling the Set Container Metadata operation overwrites all existing metadata that is associated with the container.
	* It's not possible to modify an individual name/value pair.
	*
	* @this {BlobService}
	* @param {string}             container                           The container name.
	* @param {object}             metadata                            The metadata key/value pairs.
	* @param {object}             [options]                           The request options.
	* @param {string}             [options.leaseId]                   The container lease identifier.
	* @param {LocationMode}       [options.locationMode]              Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                 Please see StorageUtilities.LocationMode for the possible values.
	* @param {AccessConditions}   [options.accessConditions]          The access conditions.
	* @param {int}                [options.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                 The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                 execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]           A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]         Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                 The default value is false.
	* @param {errorOrResponse}    callback                            `error` will contain information
	*                                                                 if an error occurs; otherwise 
	*                                                                 `response` will contain information related to this operation.
	*/
	BlobService.prototype.setContainerMetadata = function (container, metadata, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('setContainerMetadata', function (v) {
	    v.string(container, 'container');
	    v.object(metadata, 'metadata');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.put(container)
	    .withQueryOption(QueryStringConstants.RESTYPE, 'container')
	    .withQueryOption(QueryStringConstants.COMP, 'metadata')
	    .withHeader(HeaderConstants.LEASE_ID, options.leaseId);
	
	  webResource.addOptionalMetadataHeaders(metadata);
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.containerResult = null;
	    if (!responseObject.error) {
	      responseObject.containerResult = new ContainerResult(container);
	      responseObject.containerResult.getPropertiesFromHeaders(responseObject.response.headers);
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.containerResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Gets the container's ACL.
	*
	* @this {BlobService}
	* @param {string}             container                           The container name.
	* @param {object}             [options]                           The request options.
	* @param {string}             [options.leaseId]                   The container lease identifier.
	* @param {LocationMode}       [options.locationMode]              Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                 Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                 The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                 execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]           A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]         Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                 The default value is false.
	* @param {errorOrResult}      callback                            `error` will contain information
	*                                                                 if an error occurs; otherwise `[result]{@link ContainerAclResult}` will contain
	*                                                                 information for the container.
	*                                                                 `response` will contain information related to this operation.
	*/
	BlobService.prototype.getContainerAcl = function (container, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('getContainerAcl', function (v) {
	    v.string(container, 'container');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.get(container)
	    .withQueryOption(QueryStringConstants.RESTYPE, 'container')
	    .withQueryOption(QueryStringConstants.COMP, 'acl')
	    .withHeader(HeaderConstants.LEASE_ID, options.leaseId);
	
	  options.requestLocationMode = Constants.RequestLocationMode.PRIMARY_OR_SECONDARY;
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.containerResult = null;
	    if (!responseObject.error) {
	      responseObject.containerResult = new ContainerResult(container);
	      responseObject.containerResult.getPropertiesFromHeaders(responseObject.response.headers);
	      responseObject.containerResult.signedIdentifiers = AclResult.parse(responseObject.response.body);
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.containerResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Updates the container's ACL.
	*
	* @this {BlobService}
	* @param {string}                         container                           The container name.
	* @param {Object.<string, AccessPolicy>}  signedIdentifiers                   The container ACL settings. See `[AccessPolicy]{@link AccessPolicy}` for detailed information.
	* @param {object}                         [options]                           The request options.
	* @param {AccessConditions}               [options.accessConditions]          The access conditions.
	* @param {string}                         [options.publicAccessLevel]         Specifies whether data in the container may be accessed publicly and the level of access.
	* @param {string}                         [options.leaseId]                   The container lease identifier.
	* @param {int}                            [options.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                            [options.clientRequestTimeoutInMs]  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                            [options.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                             The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                             execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}                         [options.clientRequestId]           A string that represents the client request ID with a 1KB character limit.
	* @param {bool}                           [options.useNagleAlgorithm]         Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                             The default value is false.
	* @param {errorOrResult}                  callback                            `error` will contain information
	*                                                                             if an error occurs; otherwise `[result]{@link ContainerAclResult}` will contain
	*                                                                             information for the container.
	*                                                                             `response` will contain information related to this operation.
	*/
	BlobService.prototype.setContainerAcl = function (container, signedIdentifiers, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('setContainerAcl', function (v) {
	    v.string(container, 'container');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  var policies = null;
	  if (signedIdentifiers) {
	    if (_.isArray(signedIdentifiers)) {
	      throw new TypeError(SR.INVALID_SIGNED_IDENTIFIERS);
	    }
	    policies = AclResult.serialize(signedIdentifiers);
	  }
	
	  var webResource = WebResource.put(container)
	    .withQueryOption(QueryStringConstants.RESTYPE, 'container')
	    .withQueryOption(QueryStringConstants.COMP, 'acl')
	    .withHeader(HeaderConstants.CONTENT_LENGTH, !azureutil.objectIsNull(policies) ? Buffer.byteLength(policies) : 0)
	    .withHeader(HeaderConstants.BLOB_PUBLIC_ACCESS, options.publicAccessLevel)
	    .withHeader(HeaderConstants.LEASE_ID, options.leaseId)
	    .withBody(policies);
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.containerResult = null;
	    if (!responseObject.error) {
	      responseObject.containerResult = new ContainerResult(container, options.publicAccessLevel);
	      responseObject.containerResult.getPropertiesFromHeaders(responseObject.response.headers);
	      if (signedIdentifiers) {
	        responseObject.containerResult.signedIdentifiers = signedIdentifiers;
	      }
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.containerResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, webResource.body, options, processResponseCallback);
	};
	
	/**
	* Marks the specified container for deletion.
	* The container and any blobs contained within it are later deleted during garbage collection.
	*
	* @this {BlobService}
	* @param {string}             container                           The container name.
	* @param {object}             [options]                           The request options.
	* @param {AccessConditions}   [options.accessConditions]          The access conditions.
	* @param {string}             [options.leaseId]                   The container lease identifier.
	* @param {LocationMode}       [options.locationMode]              Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                 Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                 The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                 execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]           A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]         Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                 The default value is false.
	* @param {errorOrResponse}    callback                            `error` will contain information
	*                                                                 if an error occurs; otherwise
	*                                                                 `response` will contain information related to this operation.
	*/
	BlobService.prototype.deleteContainer = function (container, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('deleteContainer', function (v) {
	    v.string(container, 'container');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.del(container)
	    .withQueryOption(QueryStringConstants.RESTYPE, 'container')
	    .withHeader(HeaderConstants.LEASE_ID, options.leaseId);
	
	  var processResponseCallback = function (responseObject, next) {
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Marks the specified container for deletion if it exists.
	* The container and any blobs contained within it are later deleted during garbage collection.
	*
	* @this {BlobService}
	* @param {string}             container                           The container name.
	* @param {object}             [options]                           The request options.
	* @param {AccessConditions}   [options.accessConditions]          The access conditions.
	* @param {string}             [options.leaseId]                   The container lease identifier.
	* @param {LocationMode}       [options.locationMode]              Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                 Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                 The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                 execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]           A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]         Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                 The default value is false.
	* @param {errorOrResult}      callback                            `error` will contain information
	*                                                                 if an error occurs; otherwise `result` will 
	*                                                                 be true if the container exists and was deleted, or false if the container
	*                                                                 did not exist.
	*                                                                 `response` will contain information related to this operation.
	*/
	BlobService.prototype.deleteContainerIfExists = function (container, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('deleteContainerIfExists', function (v) {
	    v.string(container, 'container');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var self = this;
	  self._doesContainerExist(container, true, options, function (error, result, response) {
	    if (error) {
	      callback(error, result.exists, response);
	    } else if (!result.exists) {
	      response.isSuccessful = true;
	      callback(error, false, response);
	    } else {
	      self.deleteContainer(container, options, function (deleteError, deleteResponse) {
	        var deleted;
	        if (!deleteError) {
	          deleted = true;
	        } else if (deleteError && deleteError.statuscode === Constants.HttpConstants.HttpResponseCodes.NotFound && deleteError.code === Constants.BlobErrorCodeStrings.CONTAINER_NOT_FOUND) {
	          // If it was deleted already, there was no actual error.
	          deleted = false;
	          deleteError = null;
	          deleteResponse.isSuccessful = true;
	        }
	
	        callback(deleteError, deleted, deleteResponse);
	      });
	    }
	  });
	};
	
	/**
	* Lists a segment containing a collection of blob directory items in the container.
	*
	* @this {BlobService}
	* @param {string}             container                           The container name.
	* @param {object}             currentToken                        A continuation token returned by a previous listing operation. Please use 'null' or 'undefined' if this is the first operation.
	* @param {object}             [options]                           The request options.
	* @param {int}                [options.maxResults]                Specifies the maximum number of directories to return per call to Azure ServiceClient. This does NOT affect list size returned by this function. (maximum: 5000)
	* @param {LocationMode}       [options.locationMode]              Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                 Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                 The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                 execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]           A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]         Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                 The default value is false.
	* @param {errorOrResult}      callback                            `error` will contain information
	*                                                                 if an error occurs; otherwise `result` will contain `entries` and `continuationToken`. 
	*                                                                 `entries`  gives a list of `[directories]{@link DirectoryResult}` and the `continuationToken` is used for the next listing operation.
	*                                                                 `response` will contain information related to this operation.
	*/
	BlobService.prototype.listBlobDirectoriesSegmented = function (container, currentToken, optionsOrCallback, callback) {
	  this.listBlobDirectoriesSegmentedWithPrefix(container, null /* prefix */, currentToken, optionsOrCallback, callback);
	};
	
	/**
	* Lists a segment containing a collection of blob directory items in the container.
	*
	* @this {BlobService}
	* @param {string}             container                           The container name.
	* @param {string}             prefix                              The prefix of the blob directory.
	* @param {object}             currentToken                        A continuation token returned by a previous listing operation. Please use 'null' or 'undefined' if this is the first operation.
	* @param {object}             [options]                           The request options.
	* @param {int}                [options.maxResults]                Specifies the maximum number of directories to return per call to Azure ServiceClient. This does NOT affect list size returned by this function. (maximum: 5000)
	* @param {LocationMode}       [options.locationMode]              Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                 Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                 The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                 execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]           A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]         Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                 The default value is false.
	* @param {errorOrResult}      callback                            `error` will contain information
	*                                                                 if an error occurs; otherwise `result` will contain `entries` and `continuationToken`. 
	*                                                                 `entries`  gives a list of `[directories]{@link BlobResult}` and the `continuationToken` is used for the next listing operation.
	*                                                                 `response` will contain information related to this operation.
	*/
	BlobService.prototype.listBlobDirectoriesSegmentedWithPrefix = function (container, prefix, currentToken, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	  userOptions.delimiter = '/';
	
	  this._listBlobsOrDircotriesSegmentedWithPrefix(container, prefix, currentToken, BlobConstants.ListBlobTypes.Directory, userOptions, callback);
	};
	
	/**
	* Lists a segment containing a collection of blob items in the container.
	*
	* @this {BlobService}
	* @param {string}             container                           The container name.
	* @param {object}             currentToken                        A continuation token returned by a previous listing operation. Please use 'null' or 'undefined' if this is the first operation.
	* @param {object}             [options]                           The request options.
	* @param {string}             [options.delimiter]                 Delimiter, i.e. '/', for specifying folder hierarchy.
	* @param {int}                [options.maxResults]                Specifies the maximum number of blobs to return per call to Azure ServiceClient. This does NOT affect list size returned by this function. (maximum: 5000)
	* @param {string}             [options.include]                   Specifies that the response should include one or more of the following subsets: '', 'metadata', 'snapshots', 'uncommittedblobs', 'copy', 'deleted'). 
	*                                                                 Please find these values in BlobUtilities.BlobListingDetails. Multiple values can be added separated with a comma (,).
	*                                                                 **Note** that all metadata names returned from the server will be converted to lower case by NodeJS itself as metadata is set via HTTP headers and HTTP header names are case insensitive.
	* @param {LocationMode}       [options.locationMode]              Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                 Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                 The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                 execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]           A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]         Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                 The default value is false.
	* @param {errorOrResult}      callback                            `error` will contain information
	*                                                                 if an error occurs; otherwise `result` will contain `entries` and `continuationToken`. 
	*                                                                 `entries`  gives a list of `[blobs]{@link BlobResult}` and the `continuationToken` is used for the next listing operation.
	*                                                                 `response` will contain information related to this operation.
	*/
	BlobService.prototype.listBlobsSegmented = function (container, currentToken, optionsOrCallback, callback) {
	  this.listBlobsSegmentedWithPrefix(container, null /* prefix */, currentToken, optionsOrCallback, callback);
	};
	
	/**
	* Lists a segment containing a collection of blob items whose names begin with the specified prefix in the container.
	*
	* @this {BlobService}
	* @param {string}             container                           The container name.
	* @param {string}             prefix                              The prefix of the blob name.
	* @param {object}             currentToken                        A continuation token returned by a previous listing operation. Please use 'null' or 'undefined' if this is the first operation.
	* @param {object}             [options]                           The request options.
	* @param {string}             [options.delimiter]                 Delimiter, i.e. '/', for specifying folder hierarchy.
	* @param {int}                [options.maxResults]                Specifies the maximum number of blobs to return per call to Azure ServiceClient. This does NOT affect list size returned by this function. (maximum: 5000)
	* @param {string}             [options.include]                   Specifies that the response should include one or more of the following subsets: '', 'metadata', 'snapshots', 'uncommittedblobs', 'copy', 'deleted').
	*                                                                 Please find these values in BlobUtilities.BlobListingDetails. Multiple values can be added separated with a comma (,).
	*                                                                 **Note** that all metadata names returned from the server will be converted to lower case by NodeJS itself as metadata is set via HTTP headers and HTTP header names are case insensitive.
	* @param {LocationMode}       [options.locationMode]              Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                 Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                 The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                 execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]           A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]         Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                 The default value is false.
	* @param {errorOrResult}      callback                            `error` will contain information
	*                                                                 if an error occurs; otherwise `result` will contain
	*                                                                 the entries of `[blobs]{@link BlobResult}` and the continuation token for the next listing operation.
	*                                                                 `response` will contain information related to this operation.
	*/
	BlobService.prototype.listBlobsSegmentedWithPrefix = function (container, prefix, currentToken, optionsOrCallback, callback) {
	  this._listBlobsOrDircotriesSegmentedWithPrefix(container, prefix, currentToken, BlobConstants.ListBlobTypes.Blob, optionsOrCallback, callback);
	};
	
	// Lease methods
	
	/**
	* Acquires a new lease. If container and blob are specified, acquires a blob lease. Otherwise, if only container is specified and blob is null, acquires a container lease.
	*
	* @this {BlobService}
	* @param {string}             container                                   The container name.
	* @param {string}             blob                                        The blob name.
	* @param {object}             [options]                                   The request options.
	* @param {string}             [options.leaseDuration]                     The lease duration in seconds. A non-infinite lease can be between 15 and 60 seconds. Default is never to expire. 
	* @param {string}             [options.proposedLeaseId]                   The proposed lease identifier. Must be a GUID.
	* @param {AccessConditions}   [options.accessConditions]                  The access conditions.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information
	*                                                                         if an error occurs; otherwise `[result]{@link LeaseResult}` will contain
	*                                                                         the lease information.
	*                                                                         `response` will contain information related to this operation.
	*/
	BlobService.prototype.acquireLease = function (container, blob, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('acquireLease', function (v) {
	    v.string(container, 'container');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  if (!options.leaseDuration) {
	    options.leaseDuration = -1;
	  }
	
	  this._leaseImpl(container, blob, null /* leaseId */, BlobConstants.LeaseOperation.ACQUIRE, options, callback);
	};
	
	/**
	* Renews an existing lease. If container and blob are specified, renews the blob lease. Otherwise, if only container is specified and blob is null, renews the container lease.
	*
	* @this {BlobService}
	* @param {string}             container                                   The container name.
	* @param {string}             blob                                        The blob name.
	* @param {string}             leaseId                                     The lease identifier. Must be a GUID.
	* @param {object}             [options]                                   The request options.
	* @param {AccessConditions}   [options.accessConditions]                  The access conditions.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information
	*                                                                         if an error occurs; otherwise `[result]{@link LeaseResult}` will contain
	*                                                                         the lease information.
	*                                                                         `response` will contain information related to this operation.
	*/
	BlobService.prototype.renewLease = function (container, blob, leaseId, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('renewLease', function (v) {
	    v.string(container, 'container');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  this._leaseImpl(container, blob, leaseId, BlobConstants.LeaseOperation.RENEW, options, callback);
	};
	
	/**
	* Changes the lease ID of an active lease. If container and blob are specified, changes the blob lease. Otherwise, if only container is specified and blob is null, changes the 
	* container lease.
	*
	* @this {BlobService}
	* @param {string}             container                                   The container name.
	* @param {string}             blob                                        The blob name.
	* @param {string}             leaseId                                     The current lease identifier.
	* @param {string}             proposedLeaseId                             The proposed lease identifier. Must be a GUID. 
	* @param {object}             [options]                                   The request options.
	* @param {AccessConditions}   [options.accessConditions]                  The access conditions.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information if an error occurs; 
	*                                                                         otherwise `[result]{@link LeaseResult}` will contain  the lease information.
	*                                                                         `response` will contain information related to this operation.
	*/
	BlobService.prototype.changeLease = function (container, blob, leaseId, proposedLeaseId, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('changeLease', function (v) {
	    v.string(container, 'container');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  options.proposedLeaseId = proposedLeaseId;
	  this._leaseImpl(container, blob, leaseId, BlobConstants.LeaseOperation.CHANGE, options, callback);
	};
	
	/**
	* Releases the lease. If container and blob are specified, releases the blob lease. Otherwise, if only container is specified and blob is null, releases the container lease.
	*
	* @this {BlobService}
	* @param {string}             container                                   The container name.
	* @param {string}             blob                                        The blob name.
	* @param {string}             leaseId                                     The lease identifier.
	* @param {object}             [options]                                   The request options.
	* @param {AccessConditions}   [options.accessConditions]                  The access conditions.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information
	*                                                                         if an error occurs; otherwise `[result]{@link LeaseResult}` will contain
	*                                                                         the lease information.
	*                                                                         `response` will contain information related to this operation.
	*/
	BlobService.prototype.releaseLease = function (container, blob, leaseId, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('releaseLease', function (v) {
	    v.string(container, 'container');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  this._leaseImpl(container, blob, leaseId, BlobConstants.LeaseOperation.RELEASE, options, callback);
	};
	
	/**
	* Breaks the lease but ensures that another client cannot acquire a new lease until the current lease period has expired. If container and blob are specified, breaks the blob lease. 
	* Otherwise, if only container is specified and blob is null, breaks the container lease.
	*
	* @this {BlobService}
	* @param {string}             container                                   The container name.
	* @param {string}             blob                                        The blob name.
	* @param {object}             [options]                                   The request options.
	* @param {int}                [options.leaseBreakPeriod]                  The lease break period, between 0 and 60 seconds. If unspecified, a fixed-duration lease breaks after 
	*                                                                         the remaining lease period elapses, and an infinite lease breaks immediately.
	* @param {AccessConditions}   [options.accessConditions]                  The access conditions.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information
	*                                                                         if an error occurs; otherwise `[result]{@link LeaseResult}` will contain
	*                                                                         the lease information.
	*                                                                         `response` will contain information related to this operation.
	*/
	BlobService.prototype.breakLease = function (container, blob, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('breakLease', function (v) {
	    v.string(container, 'container');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  this._leaseImpl(container, blob, null /*leaseId*/, BlobConstants.LeaseOperation.BREAK, options, callback);
	};
	
	// Blob methods
	
	/**
	* Returns all user-defined metadata, standard HTTP properties, and system properties for the blob.
	* It does not return or modify the content of the blob.
	* **Note** that all metadata names returned from the server will be converted to lower case by NodeJS itself as metadata is set via HTTP headers and HTTP header names are case insensitive.
	*
	* @this {BlobService}
	* @param {string}             container                                   The container name.
	* @param {string}             blob                                        The blob name.
	* @param {object}             [options]                                   The request options.
	* @param {string}             [options.snapshotId]                        The snapshot identifier.
	* @param {string}             [options.leaseId]                           The lease identifier.
	* @param {AccessConditions}   [options.accessConditions]                  The access conditions.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information
	*                                                                         if an error occurs; otherwise `[result]{@link BlobResult}` will contain
	*                                                                         information about the blob.
	*                                                                         `response` will contain information related to this operation.
	*/
	BlobService.prototype.getBlobProperties = function (container, blob, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('getBlobProperties', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var resourceName = createResourceName(container, blob);
	  var webResource = WebResource.head(resourceName);
	
	  if (options.snapshotId) {
	    webResource.withQueryOption(QueryStringConstants.SNAPSHOT, options.snapshotId);
	  }
	
	  BlobResult.setHeadersFromBlob(webResource, options);
	
	  options.requestLocationMode = Constants.RequestLocationMode.PRIMARY_OR_SECONDARY;
	
	  var self = this;
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.blobResult = null;
	    if (!responseObject.error) {
	      responseObject.blobResult = new BlobResult(container, blob);
	      responseObject.blobResult.metadata = self.parseMetadataHeaders(responseObject.response.headers);
	      responseObject.blobResult.getPropertiesFromHeaders(responseObject.response.headers);
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.blobResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Returns all user-defined metadata for the specified blob or snapshot.
	* It does not modify or return the content of the blob.
	* **Note** that all metadata names returned from the server will be converted to lower case by NodeJS itself as metadata is set via HTTP headers and HTTP header names are case insensitive.
	*
	* @this {BlobService}
	* @param {string}             container                                   The container name.
	* @param {string}             blob                                        The blob name.
	* @param {object}             [options]                                   The request options.
	* @param {string}             [options.snapshotId]                        The snapshot identifier.
	* @param {string}             [options.leaseId]                           The lease identifier.
	* @param {AccessConditions}   [options.accessConditions]                  The access conditions.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information
	*                                                                         if an error occurs; otherwise `[result]{@link BlobResult}` will contain
	*                                                                         information about the blob.
	*                                                                         `response` will contain information related to this operation.
	*/
	BlobService.prototype.getBlobMetadata = function (container, blob, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('getBlobMetadata', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var resourceName = createResourceName(container, blob);
	  var webResource = WebResource.head(resourceName);
	
	  webResource.withQueryOption(QueryStringConstants.COMP, 'metadata');
	  webResource.withQueryOption(QueryStringConstants.SNAPSHOT, options.snapshotId);
	
	  BlobResult.setHeadersFromBlob(webResource, options);
	
	  options.requestLocationMode = Constants.RequestLocationMode.PRIMARY_OR_SECONDARY;
	
	  var self = this;
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.blobResult = null;
	    if (!responseObject.error) {
	      responseObject.blobResult = new BlobResult(container, blob);
	      responseObject.blobResult.metadata = self.parseMetadataHeaders(responseObject.response.headers);
	      responseObject.blobResult.getPropertiesFromHeaders(responseObject.response.headers);
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.blobResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Sets user-defined properties for the specified blob or snapshot.
	* It does not modify or return the content of the blob.
	*
	* @this {BlobService}
	* @param {string}             container                                   The container name.
	* @param {string}             blob                                        The blob name.
	* @param {object}             [properties]                                The blob properties to set.
	* @param {string}             [properties.contentType]                    The MIME content type of the blob. The default type is application/octet-stream.
	* @param {string}             [properties.contentEncoding]                The content encodings that have been applied to the blob.
	* @param {string}             [properties.contentLanguage]                The natural languages used by this resource.
	* @param {string}             [properties.cacheControl]                   The blob's cache control.
	* @param {string}             [properties.contentDisposition]             The blob's content disposition.
	* @param {string}             [properties.contentMD5]                     The blob's MD5 hash.
	* @param {object}             [options]                                   The request options.
	* @param {string}             [options.leaseId]                           The lease identifier.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {AccessConditions}   [options.accessConditions]                  The access conditions.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information
	*                                                                         if an error occurs; otherwise `[result]{@link BlobResult}` will contain
	*                                                                         information about the blob.
	*                                                                         `response` will contain information related to this operation.
	*/
	BlobService.prototype.setBlobProperties = function (container, blob, properties, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('setBlobProperties', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, { contentSettings: properties }, userOptions);
	  var resourceName = createResourceName(container, blob);
	  var webResource = WebResource.put(resourceName)
	    .withQueryOption(QueryStringConstants.COMP, 'properties');
	
	  BlobResult.setPropertiesFromBlob(webResource, options);
	
	  this._setBlobPropertiesHelper({
	    webResource: webResource,
	    options: options,
	    container: container,
	    blob: blob,
	    callback: callback
	  });
	};
	
	/**
	* Sets user-defined metadata for the specified blob or snapshot as one or more name-value pairs 
	* It does not modify or return the content of the blob.
	*
	* @this {BlobService}
	* @param {string}             container                                   The container name.
	* @param {string}             blob                                        The blob name.
	* @param {object}             metadata                                    The metadata key/value pairs.
	* @param {object}             [options]                                   The request options.
	* @param {string}             [options.snapshotId]                        The snapshot identifier.
	* @param {string}             [options.leaseId]                           The lease identifier.
	* @param {AccessConditions}   [options.accessConditions]                  The access conditions.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information
	*                                                                         if an error occurs; otherwise `[result]{@link BlobResult}` will contain
	*                                                                         information on the blob.
	*                                                                         `response` will contain information related to this operation.
	*/
	BlobService.prototype.setBlobMetadata = function (container, blob, metadata, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('setBlobMetadata', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.object(metadata, 'metadata');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var resourceName = createResourceName(container, blob);
	  var webResource = WebResource.put(resourceName)
	    .withQueryOption(QueryStringConstants.COMP, 'metadata');
	
	  webResource.withQueryOption(QueryStringConstants.SNAPSHOT, options.snapshotId);
	
	  options.metadata = metadata;
	  BlobResult.setHeadersFromBlob(webResource, options);
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.blobResult = null;
	    if (!responseObject.error) {
	      responseObject.blobResult = new BlobResult(container, blob);
	      responseObject.blobResult.getPropertiesFromHeaders(responseObject.response.headers);
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.blobResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	
	/**
	* Provides a stream to read from a blob.
	*
	* @this {BlobService}
	* @param {string}             container                                   The container name.
	* @param {string}             blob                                        The blob name.
	* @param {object}             [options]                                   The request options.
	* @param {string}             [options.snapshotId]                        The snapshot identifier.
	* @param {string}             [options.leaseId]                           The lease identifier.
	* @param {string}             [options.rangeStart]                        Return only the bytes of the blob in the specified range.
	* @param {string}             [options.rangeEnd]                          Return only the bytes of the blob in the specified range.
	* @param {AccessConditions}   [options.accessConditions]                  The access conditions.
	* @param {boolean}            [options.useTransactionalMD5]               When set to true, Calculate and send/validate content MD5 for transactions.
	* @param {boolean}            [options.disableContentMD5Validation]       When set to true, MD5 validation will be disabled when downloading blobs.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information if an error occurs; 
	*                                                                         otherwise `[result]{@link BlobResult}` will contain the blob information.
	*                                                                         `response` will contain information related to this operation.
	* @return {Readable}                                                      A Node.js Readable stream.
	* @example
	* var azure = require('azure-storage');
	* var blobService = azure.createBlobService();
	* var writable = fs.createWriteStream(destinationFileNameTarget);
	*  blobService.createReadStream(containerName, blobName).pipe(writable);
	*/
	BlobService.prototype.createReadStream = function (container, blob, optionsOrCallback, callback) {
	  var options;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { options = o; callback = c; });
	
	  validate.validateArgs('createReadStream', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	  });
	
	  var readStream = new ChunkStream();
	  this.getBlobToStream(container, blob, readStream, options, function (error, responseBlob, response) {
	    if (error) {
	      readStream.emit('error', error);
	    }
	
	    if (callback) {
	      callback(error, responseBlob, response);
	    }
	  });
	
	  return readStream;
	};
	
	/**
	* Downloads a blob into a stream.
	*
	* @this {BlobService}
	* @param {string}             container                                   The container name.
	* @param {string}             blob                                        The blob name.
	* @param {Writable}           writeStream                                 The Node.js Writable stream.
	* @param {object}             [options]                                   The request options.
	* @param {boolean}            [options.skipSizeCheck]                     Skip the size check to perform direct download.
	*                                                                         Set the option to true for small blobs.
	*                                                                         Parallel download and speed summary won't work with this option on.
	* @param {SpeedSummary}       [options.speedSummary]                      The download tracker objects.
	* @param {int}                [options.parallelOperationThreadCount]      The number of parallel operations that may be performed when uploading.
	* @param {string}             [options.snapshotId]                        The snapshot identifier.
	* @param {string}             [options.leaseId]                           The lease identifier.
	* @param {string}             [options.rangeStart]                        Return only the bytes of the blob in the specified range.
	* @param {string}             [options.rangeEnd]                          Return only the bytes of the blob in the specified range. 
	* @param {boolean}            [options.useTransactionalMD5]               When set to true, Calculate and send/validate content MD5 for transactions.
	* @param {boolean}            [options.disableContentMD5Validation]       When set to true, MD5 validation will be disabled when downloading blobs.
	* @param {AccessConditions}   [options.accessConditions]                  The access conditions.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information if an error occurs; 
	*                                                                         otherwise `[result]{@link BlobResult}` will contain the blob information.
	*                                                                         `response` will contain information related to this operation.
	* @return {SpeedSummary}
	*
	* @example
	* var azure = require('azure-storage');
	* var blobService = azure.createBlobService();
	* blobService.getBlobToStream('taskcontainer', 'task1', fs.createWriteStream('task1-download.txt'), function(error, serverBlob) {
	*   if(!error) {
	*     // Blob available in serverBlob.blob variable
	*   }
	* }); 
	*/
	BlobService.prototype.getBlobToStream = function (container, blob, writeStream, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	  userOptions.speedSummary = userOptions.speedSummary || new SpeedSummary(blob);
	
	  validate.validateArgs('getBlobToStream', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.object(writeStream, 'writeStream');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  var propertiesRequestOptions = {
	    timeoutIntervalInMs: options.timeoutIntervalInMs,
	    clientRequestTimeoutInMs: options.clientRequestTimeoutInMs,
	    snapshotId: options.snapshotId,
	    accessConditions: options.accessConditions
	  };
	
	  if (options.skipSizeCheck) {
	    this._getBlobToStream(container, blob, writeStream, options, callback);
	  } else {
	    var self = this;
	    this.getBlobProperties(container, blob, propertiesRequestOptions, function (error, properties) {
	      if (error) {
	        callback(error);
	      } else {
	        var size;
	        if (options.rangeStart) {
	          var endOffset = properties.contentLength - 1;
	          var end = options.rangeEnd ? Math.min(options.rangeEnd, endOffset) : endOffset;
	          size = end - options.rangeStart + 1;
	        } else {
	          size = properties.contentLength;
	        }
	        options.speedSummary.totalSize = size;
	
	        if (size > self.singleBlobPutThresholdInBytes) {
	          azureutil.setObjectInnerPropertyValue(options, ['contentSettings', 'contentMD5'], azureutil.tryGetValueChain(properties, ['contentSettings', 'contentMD5'], null));
	          self._getBlobToRangeStream(container, blob, properties.blobType, writeStream, options, callback);
	        } else {
	          self._getBlobToStream(container, blob, writeStream, options, callback);
	        }
	      }
	    });
	  }
	
	  return options.speedSummary;
	};
	
	/**
	* Downloads a blob into a text string.
	*
	* @this {BlobService}
	* @param {string}             container                                   The container name.
	* @param {string}             blob                                        The blob name.
	* @param {object}             [options]                                   The request options.
	* @param {string}             [options.snapshotId]                        The snapshot identifier.
	* @param {string}             [options.leaseId]                           The lease identifier. 
	* @param {string}             [options.rangeStart]                        Return only the bytes of the blob in the specified range.
	* @param {string}             [options.rangeEnd]                          Return only the bytes of the blob in the specified range.
	* @param {bool}               [options.useTransactionalMD5]               Calculate and send/validate content MD5 for transactions.
	* @param {boolean}            [options.disableContentMD5Validation]       When set to true, MD5 validation will be disabled when downloading blobs.
	* @param {AccessConditions}   [options.accessConditions]                  The access conditions.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {BlobService~blobToText}  callback                               `error` will contain information
	*                                                                         if an error occurs; otherwise `text` will contain the blob contents,
	*                                                                         and `[blockBlob]{@link BlobResult}` will contain
	*                                                                         the blob information.
	*                                                                         `response` will contain information related to this operation.
	*/
	BlobService.prototype.getBlobToText = function (container, blob, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('getBlobToText', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var resourceName = createResourceName(container, blob);
	  var webResource = WebResource.get(resourceName)
	    .withRawResponse();
	
	  webResource.withQueryOption(QueryStringConstants.SNAPSHOT, options.snapshotId);
	
	  BlobResult.setHeadersFromBlob(webResource, options);
	  this._setRangeContentMD5Header(webResource, options);
	
	  options.requestLocationMode = Constants.RequestLocationMode.PRIMARY_OR_SECONDARY;
	
	  var self = this;
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.text = null;
	    responseObject.blobResult = null;
	
	    if (!responseObject.error) {
	      responseObject.blobResult = new BlobResult(container, blob);
	      responseObject.blobResult.metadata = self.parseMetadataHeaders(responseObject.response.headers);
	      responseObject.blobResult.getPropertiesFromHeaders(responseObject.response.headers);
	      responseObject.text = responseObject.response.body;
	
	      self._validateLengthAndMD5(options, responseObject);
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.text, returnObject.blobResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Marks the specified blob or snapshot for deletion. The blob is later deleted during garbage collection.
	* If a blob has snapshots, you must delete them when deleting the blob. Using the deleteSnapshots option, you can choose either to delete both the blob and its snapshots, 
	* or to delete only the snapshots but not the blob itself. If the blob has snapshots, you must include the deleteSnapshots option or the blob service will return an error
	* and nothing will be deleted. 
	* If you are deleting a specific snapshot using the snapshotId option, the deleteSnapshots option must NOT be included.
	*
	* @this {BlobService}
	* @param {string}             container                                   The container name.
	* @param {string}             blob                                        The blob name.
	* @param {object}             [options]                                   The request options.
	* @param {string}             [options.deleteSnapshots]                   The snapshot delete option. See azure.BlobUtilities.SnapshotDeleteOptions.*. 
	* @param {string}             [options.snapshotId]                        The snapshot identifier.
	* @param {string}             [options.leaseId]                           The lease identifier.
	* @param {AccessConditions}   [options.accessConditions]                  The access conditions.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResponse}    callback                                    `error` will contain information
	*                                                                         if an error occurs; `response` will contain information related to this operation.
	*/
	BlobService.prototype.deleteBlob = function (container, blob, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('deleteBlob', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var resourceName = createResourceName(container, blob);
	  var webResource = WebResource.del(resourceName)
	    .withHeader(HeaderConstants.LEASE_ID, options.leaseId);
	
	  if (!azureutil.objectIsNull(options.snapshotId) && !azureutil.objectIsNull(options.deleteSnapshots)) {
	    throw new ArgumentError('options', SR.INVALID_DELETE_SNAPSHOT_OPTION);
	  }
	
	  webResource.withQueryOption(QueryStringConstants.SNAPSHOT, options.snapshotId);
	  webResource.withHeader(HeaderConstants.DELETE_SNAPSHOT, options.deleteSnapshots);
	
	  BlobResult.setHeadersFromBlob(webResource, options);
	
	  var processResponseCallback = function (responseObject, next) {
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* The undelete Blob operation restores the contents and metadata of soft deleted blob or snapshot.
	* Attempting to undelete a blob or snapshot that is not soft deleted will succeed without any changes.
	* 
	* @this {BlobService}
	* @param {string}             container                                   The container name.
	* @param {string}             blob                                        The blob name.
	* @param {object}             [options]                                   The request options.
	* @param {AccessConditions}   [options.accessConditions]                  The access conditions.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResponse}    callback                                    `error` will contain information
	*                                                                         if an error occurs; `response` will contain information related to this operation.
	*/
	BlobService.prototype.undeleteBlob = function (container, blob, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('deleteBlob', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var resourceName = createResourceName(container, blob);
	  var webResource = WebResource.put(resourceName)
	    .withQueryOption(QueryStringConstants.COMP, 'undelete');
	    
	  BlobResult.setHeadersFromBlob(webResource, options);  
	
	  var processResponseCallback = function (responseObject, next) {
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Checks whether or not a blob exists on the service.
	*
	* @this {BlobService}
	* @param {string}             container                               The container name.
	* @param {string}             blob                                    The blob name.
	* @param {object}             [options]                               The request options.
	* @param {string}             [options.snapshotId]                    The snapshot identifier.
	* @param {string}             [options.leaseId]                       The lease identifier.
	* @param {LocationMode}       [options.locationMode]                  Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                     Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]           The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]      The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]      The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                     The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                     execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]               A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]             Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                     The default value is false.
	* @param {Function(error, result, response)}  callback                `error` will contain information
	*                                                                     if an error occurs; otherwise `[result]{@link BlobResult}` will contain 
	*                                                                     the blob information including the `exists` boolean member. 
	*                                                                     `response` will contain information related to this operation.
	*/
	BlobService.prototype.doesBlobExist = function (container, blob, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('doesBlobExist', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  this._doesBlobExist(container, blob, false, options, callback);
	};
	
	/**
	* Marks the specified blob or snapshot for deletion if it exists. The blob is later deleted during garbage collection.
	* If a blob has snapshots, you must delete them when deleting the blob. Using the deleteSnapshots option, you can choose either to delete both the blob and its snapshots, 
	* or to delete only the snapshots but not the blob itself. If the blob has snapshots, you must include the deleteSnapshots option or the blob service will return an error
	* and nothing will be deleted. 
	* If you are deleting a specific snapshot using the snapshotId option, the deleteSnapshots option must NOT be included.
	*
	* @this {BlobService}
	* @param {string}             container                           The container name.
	* @param {string}             blob                                The blob name.
	* @param {object}             [options]                           The request options.
	* @param {string}             [options.deleteSnapshots]           The snapshot delete option. See azure.BlobUtilities.SnapshotDeleteOptions.*. 
	* @param {string}             [options.snapshotId]                The snapshot identifier.
	* @param {string}             [options.leaseId]                   The lease identifier.
	* @param {AccessConditions}   [options.accessConditions]          The access conditions.
	* @param {LocationMode}       [options.locationMode]              Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                 Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                 The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                 execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]           A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]         Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                 The default value is false.
	* @param {errorOrResult}      callback                            `error` will contain information
	*                                                                 if an error occurs; otherwise `result` will
	*                                                                 be true if the blob was deleted, or false if the blob
	*                                                                 does not exist.
	*                                                                 `response` will contain information related to this operation.
	*/
	BlobService.prototype.deleteBlobIfExists = function (container, blob, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('deleteBlobIfExists', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var self = this;
	  self._doesBlobExist(container, blob, true, options, function (error, existsResult, response) {
	    if (error) {
	      callback(error, existsResult.exists, response);
	    } else if (!existsResult.exists) {
	      response.isSuccessful = true;
	      callback(error, false, response);
	    } else {
	      self.deleteBlob(container, blob, options, function (deleteError, deleteResponse) {
	        var deleted;
	        if (!deleteError) {
	          deleted = true;
	        } else if (deleteError && deleteError.statusCode === Constants.HttpConstants.HttpResponseCodes.NotFound && deleteError.code === Constants.BlobErrorCodeStrings.BLOB_NOT_FOUND) {
	          // If it was deleted already, there was no actual error.
	          deleted = false;
	          deleteError = null;
	          deleteResponse.isSuccessful = true;
	        }
	
	        callback(deleteError, deleted, deleteResponse);
	      });
	    }
	  });
	};
	
	/**
	* Creates a read-only snapshot of a blob.
	*
	* @this {BlobService}
	* @param {string}             container                             The container name.
	* @param {string}             blob                                  The blob name.
	* @param {object}             [options]                             The request options.
	* @param {string}             [options.snapshotId]                  The snapshot identifier.
	* @param {object}             [options.metadata]                    The metadata key/value pairs.
	* @param {string}             [options.leaseId]                     The lease identifier.
	* @param {AccessConditions}   [options.accessConditions]            The access conditions.
	* @param {LocationMode}       [options.locationMode]                Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                   Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]         The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]    The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]    The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                   The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                   execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]             A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]           Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                   The default value is false.
	* @param {errorOrResult}      callback                              `error` will contain information
	*                                                                   if an error occurs; otherwise `result` will contain
	*                                                                   the ID of the snapshot.
	*                                                                   `response` will contain information related to this operation.
	*/
	BlobService.prototype.createBlobSnapshot = function (container, blob, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('createBlobSnapshot', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var resourceName = createResourceName(container, blob);
	  var webResource = WebResource.put(resourceName)
	    .withQueryOption(QueryStringConstants.COMP, 'snapshot');
	
	  BlobResult.setHeadersFromBlob(webResource, options);
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.snapshotId = null;
	    if (!responseObject.error) {
	      responseObject.snapshotId = responseObject.response.headers[HeaderConstants.SNAPSHOT];
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.snapshotId, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Starts to copy a blob to a destination within the storage account. The Copy Blob operation copies the entire committed blob.
	*
	* @this {BlobService}
	* @param {string}             sourceUri                                 The source blob URI.
	* @param {string}             targetContainer                           The target container name.
	* @param {string}             targetBlob                                The target blob name.
	* @param {object}             [options]                                 The request options.
	* @param {string}             [options.blobTier]                        For page blobs on premium accounts only. Set the tier of target blob. Refer to BlobUtilities.BlobTier.PremiumPageBlobTier.
	* @param {boolean}            [options.isIncrementalCopy]               If it's incremental copy or not. Refer to https://docs.microsoft.com/en-us/rest/api/storageservices/fileservices/incremental-copy-blob
	* @param {string}             [options.snapshotId]                      The source blob snapshot identifier.
	* @param {object}             [options.metadata]                        The target blob metadata key/value pairs.
	* @param {string}             [options.leaseId]                         The target blob lease identifier.
	* @param {string}             [options.sourceLeaseId]                   The source blob lease identifier.
	* @param {AccessConditions}   [options.accessConditions]                The access conditions.
	* @param {AccessConditions}   [options.sourceAccessConditions]          The source access conditions.
	* @param {LocationMode}       [options.locationMode]                    Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                       Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]             The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]        The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]        The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                       The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                       execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                 A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]               Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                       The default value is false.
	* @param {errorOrResult}      callback                                  `error` will contain information
	*                                                                       if an error occurs; otherwise `[result]{@link BlobResult}` will contain
	*                                                                       the blob information.
	*                                                                       `response` will contain information related to this operation.
	*/
	BlobService.prototype.startCopyBlob = function (sourceUri, targetContainer, targetBlob, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('startCopyBlob', function (v) {
	    v.string(sourceUri, 'sourceUri');
	    v.string(targetContainer, 'targetContainer');
	    v.string(targetBlob, 'targetBlob');
	    v.containerNameIsValid(targetContainer);
	    v.callback(callback);
	  });
	
	  var targetResourceName = createResourceName(targetContainer, targetBlob);
	
	  var options = extend(true, {}, userOptions);
	
	  if (options.snapshotId) {
	    var uri = url.parse(sourceUri, true);
	    if (uri.query['snapshot']) {
	      throw new ArgumentError('options.snapshotId', 'Duplicate snapshot supplied in both the source uri and option.');
	    }
	
	    uri.search = undefined;
	    uri.query['snapshot'] = options.snapshotId;
	
	    sourceUri = url.format(uri);
	  }
	
	  var webResource = WebResource.put(targetResourceName)
	    .withHeader(HeaderConstants.COPY_SOURCE, sourceUri);
	
	  if (options.isIncrementalCopy) {
	    webResource.withQueryOption(QueryStringConstants.COMP, 'incrementalcopy');
	  }
	
	  webResource.withHeader(HeaderConstants.ACCESS_TIER, options.blobTier);
	  webResource.withHeader(HeaderConstants.LEASE_ID, options.leaseId);
	  webResource.withHeader(HeaderConstants.SOURCE_LEASE_ID, options.sourceLeaseId);
	  webResource.addOptionalMetadataHeaders(options.metadata);
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.blobResult = null;
	    if (!responseObject.error) {
	      responseObject.blobResult = new BlobResult(targetContainer, targetBlob);
	      responseObject.blobResult.getPropertiesFromHeaders(responseObject.response.headers);
	
	      if (options.metadata) {
	        responseObject.blobResult.metadata = options.metadata;
	      }
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.blobResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Abort a blob copy operation.
	*
	* @this {BlobService}
	* @param {string}             container                                 The destination container name.
	* @param {string}             blob                                      The destination blob name.
	* @param {string}             copyId                                    The copy operation identifier.
	* @param {object}             [options]                                 The request options.
	* @param {string}             [options.leaseId]                         The target blob lease identifier.
	* @param {LocationMode}       [options.locationMode]                    Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                       Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]             The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]        The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]        The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                       The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                       execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                 A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]               Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                       The default value is false.
	* @param {errorOrResponse}    callback                                  `error` will contain information  if an error occurs; 
	*                                                                       `response` will contain information related to this operation.
	*/
	BlobService.prototype.abortCopyBlob = function (container, blob, copyId, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('abortCopyBlob', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var resourceName = createResourceName(container, blob);
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.put(resourceName)
	    .withQueryOption(QueryStringConstants.COPY_ID, copyId)
	    .withQueryOption(QueryStringConstants.COMP, 'copy')
	    .withHeader(HeaderConstants.COPY_ACTION, 'abort');
	
	  webResource.withHeader(HeaderConstants.LEASE_ID, options.leaseId);
	
	  var processResponseCallback = function (responseObject, next) {
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Retrieves a shared access signature token.
	*
	* @this {BlobService}
	* @param {string}                   container                                           The container name.
	* @param {string}                   [blob]                                              The blob name.
	* @param {object}                   sharedAccessPolicy                                  The shared access policy.
	* @param {string}                   [sharedAccessPolicy.Id]                             The signed identifier.
	* @param {object}                   [sharedAccessPolicy.AccessPolicy.Permissions]       The permission type.
	* @param {date|string}              [sharedAccessPolicy.AccessPolicy.Start]             The time at which the Shared Access Signature becomes valid (The UTC value will be used).
	* @param {date|string}              [sharedAccessPolicy.AccessPolicy.Expiry]            The time at which the Shared Access Signature becomes expired (The UTC value will be used).
	* @param {string}                   [sharedAccessPolicy.AccessPolicy.IPAddressOrRange]  An IP address or a range of IP addresses from which to accept requests. When specifying a range, note that the range is inclusive.
	* @param {string}                   [sharedAccessPolicy.AccessPolicy.Protocols]         The protocols permitted for a request made with the account SAS. 
	*                                                                                       Possible values are both HTTPS and HTTP (https,http) or HTTPS only (https). The default value is https,http.
	* @param {object}                   [headers]                                           The optional header values to set for a blob returned wth this SAS.
	* @param {string}                   [headers.cacheControl]                              The optional value of the Cache-Control response header to be returned when this SAS is used.
	* @param {string}                   [headers.contentType]                               The optional value of the Content-Type response header to be returned when this SAS is used.
	* @param {string}                   [headers.contentEncoding]                           The optional value of the Content-Encoding response header to be returned when this SAS is used.
	* @param {string}                   [headers.contentLanguage]                           The optional value of the Content-Language response header to be returned when this SAS is used.
	* @param {string}                   [headers.contentDisposition]                        The optional value of the Content-Disposition response header to be returned when this SAS is used.
	* @return {string}                                                                      The shared access signature query string. Note this string does not contain the leading "?".
	*/
	BlobService.prototype.generateSharedAccessSignature = function (container, blob, sharedAccessPolicy, headers) {
	  // check if the BlobService is able to generate a shared access signature
	  if (!this.storageCredentials) {
	    throw new ArgumentNullError('storageCredentials');
	  }
	
	  if (!this.storageCredentials.generateSignedQueryString) {
	    throw new ArgumentError('storageCredentials', SR.CANNOT_CREATE_SAS_WITHOUT_ACCOUNT_KEY);
	  }
	
	  // Validate container name. Blob name is optional.
	  validate.validateArgs('generateSharedAccessSignature', function (v) {
	    v.string(container, 'container');
	    v.containerNameIsValid(container);
	    v.object(sharedAccessPolicy, 'sharedAccessPolicy');
	  });
	
	  var resourceType = BlobConstants.ResourceTypes.CONTAINER;
	  if (blob) {
	    validate.validateArgs('generateSharedAccessSignature', function (v) {
	      v.string(blob, 'blob');
	    });
	    resourceType = BlobConstants.ResourceTypes.BLOB;
	  }
	
	  if (sharedAccessPolicy.AccessPolicy) {
	    if (!azureutil.objectIsNull(sharedAccessPolicy.AccessPolicy.Start)) {
	      if (!_.isDate(sharedAccessPolicy.AccessPolicy.Start)) {
	        sharedAccessPolicy.AccessPolicy.Start = new Date(sharedAccessPolicy.AccessPolicy.Start);
	      }
	
	      sharedAccessPolicy.AccessPolicy.Start = azureutil.truncatedISO8061Date(sharedAccessPolicy.AccessPolicy.Start);
	    }
	
	    if (!azureutil.objectIsNull(sharedAccessPolicy.AccessPolicy.Expiry)) {
	      if (!_.isDate(sharedAccessPolicy.AccessPolicy.Expiry)) {
	        sharedAccessPolicy.AccessPolicy.Expiry = new Date(sharedAccessPolicy.AccessPolicy.Expiry);
	      }
	
	      sharedAccessPolicy.AccessPolicy.Expiry = azureutil.truncatedISO8061Date(sharedAccessPolicy.AccessPolicy.Expiry);
	    }
	  }
	
	  var resourceName = createResourceName(container, blob, true);
	  return this.storageCredentials.generateSignedQueryString(Constants.ServiceType.Blob, resourceName, sharedAccessPolicy, null, { headers: headers, resourceType: resourceType });
	};
	
	/**
	* Retrieves a blob or container URL.
	*
	* @param {string}                   container                The container name.
	* @param {string}                   [blob]                   The blob name.
	* @param {string}                   [sasToken]               The Shared Access Signature token.
	* @param {boolean}                  [primary]                A boolean representing whether to use the primary or the secondary endpoint.
	* @param {string}                   [snapshotId]             The snapshot identifier.
	* @return {string}                                           The formatted URL string.
	* @example
	* var azure = require('azure-storage');
	* var blobService = azure.createBlobService();
	* var sharedAccessPolicy = {
	*   AccessPolicy: {
	*     Permissions: azure.BlobUtilities.SharedAccessPermissions.READ,
	*     Start: startDate,
	*     Expiry: expiryDate
	*   },
	* };
	* 
	* var sasToken = blobService.generateSharedAccessSignature(containerName, blobName, sharedAccessPolicy);
	* var sasUrl = blobService.getUrl(containerName, blobName, sasToken);
	*/
	BlobService.prototype.getUrl = function (container, blob, sasToken, primary, snapshotId) {
	  validate.validateArgs('getUrl', function (v) {
	    v.string(container, 'container');
	    v.containerNameIsValid(container);
	  });
	
	  var host;
	  if (!azureutil.objectIsNull(primary) && primary === false) {
	    host = this.host.secondaryHost;
	  } else {
	    host = this.host.primaryHost;
	  }
	
	  host = azureutil.trimPortFromUri(host);
	  if (host && host.lastIndexOf('/') !== (host.length - 1)) {
	    host = host + '/';
	  }
	
	  var query = qs.parse(sasToken);
	  if (snapshotId) {
	    query[QueryStringConstants.SNAPSHOT] = snapshotId;
	  }
	
	  var fullPath = url.format({ pathname: this._getPath(createResourceName(container, blob)), query: query });
	  return url.resolve(host, fullPath);
	};
	
	// Page blob methods
	
	/**
	* Creates a page blob of the specified length. If the blob already exists on the service, it will be overwritten.
	* To avoid overwriting and instead throw an error if the blob exists, please pass in an accessConditions parameter in the options object.
	*
	* @this {BlobService}
	* @param {string}             container                                     The container name.
	* @param {string}             blob                                          The blob name.
	* @param {int}                length                                        The length of the page blob in bytes.
	* @param {object}             [options]                                     The request options.
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {string}             [options.leaseId]                             The target blob lease identifier.
	* @param {string}             [options.blobTier]                            For page blobs on premium accounts only. Set the tier of the target blob. Refer to BlobUtilities.BlobTier.PremiumPageBlobTier.
	* @param {object}             [options.contentSettings]                     The content settings of the blob.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the blob. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the blob.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The Blob service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The blob's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The MD5 hash of the blob content.
	* @param {string}             [options.sequenceNumber]                      The blob's sequence number.
	* @param {AccessConditions}   [options.accessConditions]                    The access conditions.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResponse}    callback                                      `error` will contain information
	*                                                                           if an error occurs; otherwise 
	*                                                                           `response` will contain information related to this operation.
	*/
	BlobService.prototype.createPageBlob = function (container, blob, length, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('createPageBlob', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	    v.value(length, 'length');
	    v.callback(callback);
	  });
	
	  if (length && length % BlobConstants.PAGE_SIZE !== 0) {
	    throw new RangeError(SR.INVALID_PAGE_BLOB_LENGTH);
	  }
	
	  var options = extend(true, {}, userOptions);
	
	  var resourceName = createResourceName(container, blob);
	
	  var webResource = WebResource.put(resourceName)
	    .withHeader(HeaderConstants.BLOB_TYPE, BlobConstants.BlobTypes.PAGE)
	    .withHeader(HeaderConstants.BLOB_CONTENT_LENGTH, length)
	    .withHeader(HeaderConstants.CONTENT_LENGTH, 0)
	    .withHeader(HeaderConstants.ACCESS_TIER, options.blobTier)
	    .withHeader(HeaderConstants.LEASE_ID, options.leaseId);
	
	  BlobResult.setHeadersFromBlob(webResource, options);
	
	  var processResponseCallback = function (responseObject, next) {
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Uploads a page blob from a stream. If the blob already exists on the service, it will be overwritten.
	* To avoid overwriting and instead throw an error if the blob exists, please pass in an accessConditions parameter in the options object.
	*
	* @this {BlobService}
	* @param {string}             container                                     The container name.
	* @param {string}             blob                                          The blob name.
	* @param (Stream)             stream                                        Stream to the data to store.
	* @param {int}                streamLength                                  The length of the stream to upload.
	* @param {object}             [options]                                     The request options.
	* @param {SpeedSummary}       [options.speedSummary]                        The download tracker objects;
	* @param {int}                [options.parallelOperationThreadCount]        The number of parallel operations that may be performed when uploading.
	* @param {string}             [options.leaseId]                             The lease identifier.
	* @param {string}             [options.transactionalContentMD5]             An MD5 hash of the blob content. This hash is used to verify the integrity of the blob during transport.
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {bool}               [options.storeBlobContentMD5]                 Specifies whether the blob's ContentMD5 header should be set on uploads. 
	*                                                                           The default value is false for page blobs.
	* @param {bool}               [options.useTransactionalMD5]                 Calculate and send/validate content MD5 for transactions.
	* @param {string}             [options.blobTier]                            For page blobs on premium accounts only. Set the tier of the target blob. Refer to BlobUtilities.BlobTier.PremiumPageBlobTier.
	* @param {object}             [options.contentSettings]                     The content settings of the blob.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the blob. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the blob.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The Blob service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The blob's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The blob's MD5 hash.
	* @param {AccessConditions}   [options.accessConditions]                    The access conditions.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResult}      callback                                      `error` will contain information
	*                                                                           if an error occurs; otherwise `[result]{@link BlobResult}` will contain
	*                                                                           the blob information.
	*                                                                           `response` will contain information related to this operation.
	* @return {SpeedSummary}
	*/
	BlobService.prototype.createPageBlobFromStream = function (container, blob, stream, streamLength, optionsOrCallback, callback) {
	  return this._createBlobFromStream(container, blob, BlobConstants.BlobTypes.PAGE, stream, streamLength, optionsOrCallback, callback);
	};
	
	/**
	* Provides a stream to write to a page blob. Assumes that the blob exists. 
	* If it does not, please create the blob using createPageBlob before calling this method or use createWriteStreamNewPageBlob.
	* Please note the `Stream` returned by this API should be used with piping.
	*
	* @this {BlobService}
	* @param {string}             container                                     The container name.
	* @param {string}             blob                                          The blob name.
	* @param {object}             [options]                                     The request options.
	* @param {string}             [options.leaseId]                             The lease identifier.
	* @param {string}             [options.transactionalContentMD5]             The MD5 hash of the blob content. This hash is used to verify the integrity of the blob during transport.
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {int}                [options.parallelOperationThreadCount]        The number of parallel operations that may be performed when uploading.
	* @param {bool}               [options.storeBlobContentMD5]                 Specifies whether the blob's ContentMD5 header should be set on uploads. 
	*                                                                           The default value is false for page blobs and true for block blobs.
	* @param {bool}               [options.useTransactionalMD5]                 Calculate and send/validate content MD5 for transactions.
	* @param {object}             [options.contentSettings]                     The content settings of the blob.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the blob. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the blob.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The Blob service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The blob's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The blob's MD5 hash.
	* @param {AccessConditions}   [options.accessConditions]                    The access conditions.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResult}      callback                                      `error` will contain information
	*                                                                           if an error occurs; otherwise `[result]{@link BlobResult}` will contain
	*                                                                           the blob information.
	*                                                                           `response` will contain information related to this operation.
	* @return {Writable}                                                        A Node.js Writable stream.
	* @example
	* var azure = require('azure-storage');
	* var blobService = azure.createBlobService();
	* blobService.createPageBlob(containerName, blobName, 1024, function (err) {
	*   // Pipe file to a blob
	*   var stream = fs.createReadStream(fileNameTarget).pipe(blobService.createWriteStreamToExistingPageBlob(containerName, blobName));
	* });
	*/
	BlobService.prototype.createWriteStreamToExistingPageBlob = function (container, blob, optionsOrCallback, callback) {
	  return this._createWriteStreamToBlob(container, blob, BlobConstants.BlobTypes.PAGE, 0, false, optionsOrCallback, callback);
	};
	
	/**
	* Provides a stream to write to a page blob. Creates the blob before writing data. If the blob already exists on the service, it will be overwritten.
	* Please note the `Stream` returned by this API should be used with piping.
	*
	* @this {BlobService}
	* @param {string}             container                                     The container name.
	* @param {string}             blob                                          The blob name.
	* @param {string}             length                                        The blob length.
	* @param {object}             [options]                                     The request options.
	* @param {string}             [options.leaseId]                             The lease identifier.
	* @param {string}             [options.transactionalContentMD5]             The MD5 hash of the blob content. This hash is used to verify the integrity of the blob during transport.
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {int}                [options.parallelOperationThreadCount]        The number of parallel operations that may be performed when uploading.
	* @param {bool}               [options.storeBlobContentMD5]                 Specifies whether the blob's ContentMD5 header should be set on uploads. 
	*                                                                           The default value is false for page blobs and true for block blobs.
	* @param {bool}               [options.useTransactionalMD5]                 Calculate and send/validate content MD5 for transactions.
	* @param {string}             [options.blobTier]                            For page blobs on premium accounts only. Set the tier of the target blob. Refer to BlobUtilities.BlobTier.PremiumPageBlobTier.
	* @param {object}             [options.contentSettings]                     The content settings of the blob.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the blob. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the blob.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The Blob service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The blob's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The blob's MD5 hash.
	* @param {AccessConditions}   [options.accessConditions]                    The access conditions.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResult}      callback                                      `error` will contain information
	*                                                                           if an error occurs; otherwise `[result]{@link BlobResult}` will contain
	*                                                                           the blob information.
	*                                                                           `response` will contain information related to this operation.
	* @return {Writable}                                                        A Node.js Writable stream.
	* @example
	* var azure = require('azure-storage');
	* var blobService = azure.createBlobService();
	* blobService.createPageBlob(containerName, blobName, 1024, function (err) {
	*   // Pipe file to a blob
	*   var stream = fs.createReadStream(fileNameTarget).pipe(blobService.createWriteStreamToNewPageBlob(containerName, blobName));
	* });
	*/
	BlobService.prototype.createWriteStreamToNewPageBlob = function (container, blob, length, optionsOrCallback, callback) {
	  return this._createWriteStreamToBlob(container, blob, BlobConstants.BlobTypes.PAGE, length, true, optionsOrCallback, callback);
	};
	
	/**
	* Updates a page blob from a stream.
	*
	* @this {BlobService}
	* @param {string}             container                                   The container name.
	* @param {string}             blob                                        The blob name.
	* @param {Readable}           readStream                                  The Node.js Readable stream.
	* @param {int}                rangeStart                                  The range start.
	* @param {int}                rangeEnd                                    The range end.
	* @param {object}             [options]                                   The request options.
	* @param {string}             [options.leaseId]                           The target blob lease identifier.
	* @param {bool}               [options.useTransactionalMD5]               Calculate and send/validate content MD5 for transactions.
	* @param {string}             [options.transactionalContentMD5]           An optional hash value used to ensure transactional integrity for the page. 
	* @param {AccessConditions}   [options.accessConditions]                  The access conditions.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information
	*                                                                         if an error occurs; otherwise `[result]{@link BlobResult}` will contain
	*                                                                         the page information.
	*                                                                         `response` will contain information related to this operation.
	*/
	BlobService.prototype.createPagesFromStream = function (container, blob, readStream, rangeStart, rangeEnd, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('createPagesFromStream', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  if ((rangeEnd - rangeStart) + 1 > BlobConstants.MAX_UPDATE_PAGE_SIZE) {
	    throw new RangeError(SR.INVALID_PAGE_RANGE_FOR_UPDATE);
	  }
	
	  var self = this;
	  if (azureutil.objectIsNull(options.transactionalContentMD5) && options.useTransactionalMD5) {
	    azureutil.calculateMD5(readStream, BlobConstants.MAX_UPDATE_PAGE_SIZE, options, function (internalBuff, contentMD5) {
	      options.transactionalContentMD5 = contentMD5;
	      self._createPages(container, blob, internalBuff, null /* stream */, rangeStart, rangeEnd, options, callback);
	    });
	  } else {
	    self._createPages(container, blob, null /* text */, readStream, rangeStart, rangeEnd, options, callback);
	  }
	};
	
	/**
	* Lists page ranges. Lists all of the page ranges by default, or only the page ranges over a specific range of bytes if rangeStart and rangeEnd are specified.
	*
	* @this {BlobService}
	* @param {string}             container                                   The container name.
	* @param {string}             blob                                        The blob name.
	* @param {object}             [options]                                   The request options.
	* @param {AccessConditions}   [options.accessConditions]                  The access conditions.
	* @param {int}                [options.rangeStart]                        The range start.
	* @param {int}                [options.rangeEnd]                          The range end.
	* @param {string}             [options.snapshotId]                        The snapshot identifier.
	* @param {string}             [options.leaseId]                           The target blob lease identifier.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information
	*                                                                         if an error occurs; otherwise `result` will contain
	*                                                                         the page ranges information, see `[Range]{@link Range}` for detailed information.
	*                                                                         `response` will contain information related to this operation.
	*/
	BlobService.prototype.listPageRanges = function (container, blob, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('listPageRanges', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  var resourceName = createResourceName(container, blob);
	  var webResource = WebResource.get(resourceName)
	    .withQueryOption(QueryStringConstants.COMP, 'pagelist')
	    .withQueryOption(QueryStringConstants.SNAPSHOT, options.snapshotId);
	
	  if (options.rangeStart && options.rangeStart % BlobConstants.PAGE_SIZE !== 0) {
	    throw new RangeError(SR.INVALID_PAGE_START_OFFSET);
	  }
	
	  if (options.rangeEnd && (options.rangeEnd + 1) % BlobConstants.PAGE_SIZE !== 0) {
	    throw new RangeError(SR.INVALID_PAGE_END_OFFSET);
	  }
	
	  BlobResult.setHeadersFromBlob(webResource, options);
	
	  options.requestLocationMode = RequestLocationMode.PRIMARY_OR_SECONDARY;
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.pageRanges = null;
	    if (!responseObject.error) {
	      responseObject.pageRanges = [];
	
	      var pageRanges = [];
	      if (responseObject.response.body.PageList.PageRange) {
	        pageRanges = responseObject.response.body.PageList.PageRange;
	
	        if (!_.isArray(pageRanges)) {
	          pageRanges = [pageRanges];
	        }
	      }
	
	      pageRanges.forEach(function (pageRange) {
	        var range = {
	          start: parseInt(pageRange.Start, 10),
	          end: parseInt(pageRange.End, 10)
	        };
	
	        responseObject.pageRanges.push(range);
	      });
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.pageRanges, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Gets page ranges that have been updated or cleared since the snapshot specified by `previousSnapshotTime` was taken. Gets all of the page ranges by default, or only the page ranges over a specific range of bytes if rangeStart and rangeEnd are specified.
	*
	* @this {BlobService}
	* @param {string}             container                                   The container name.
	* @param {string}             blob                                        The blob name.
	* @param {string}             previousSnapshotTime                        The previous snapshot time for comparison. Must be prior to `options.snapshotId` if it's provided.
	* @param {object}             [options]                                   The request options.
	* @param {AccessConditions}   [options.accessConditions]                  The access conditions.
	* @param {int}                [options.rangeStart]                        The range start.
	* @param {int}                [options.rangeEnd]                          The range end.
	* @param {string}             [options.snapshotId]                        The snapshot identifier. 
	* @param {string}             [options.leaseId]                           The target blob lease identifier.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information
	*                                                                         if an error occurs; otherwise `result` will contain
	*                                                                         the page ranges diff information, see `[RangeDiff]{@link RangeDiff}` for detailed information.
	*                                                                         `response` will contain information related to this operation.
	*/
	BlobService.prototype.getPageRangesDiff = function (container, blob, previousSnapshotTime, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('getPageRangesDiff', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  var resourceName = createResourceName(container, blob);
	  var webResource = WebResource.get(resourceName)
	    .withQueryOption(QueryStringConstants.COMP, 'pagelist')
	    .withQueryOption(QueryStringConstants.SNAPSHOT, options.snapshotId)
	    .withQueryOption(QueryStringConstants.PREV_SNAPSHOT, previousSnapshotTime);
	
	  if (options.rangeStart && options.rangeStart % BlobConstants.PAGE_SIZE !== 0) {
	    throw new RangeError(SR.INVALID_PAGE_START_OFFSET);
	  }
	
	  if (options.rangeEnd && (options.rangeEnd + 1) % BlobConstants.PAGE_SIZE !== 0) {
	    throw new RangeError(SR.INVALID_PAGE_END_OFFSET);
	  }
	
	  if (options.rangeEnd && (options.rangeEnd + 1) % BlobConstants.PAGE_SIZE !== 0) {
	    throw new RangeError(SR.INVALID_PAGE_END_OFFSET);
	  }
	
	  BlobResult.setHeadersFromBlob(webResource, options);
	
	  options.requestLocationMode = RequestLocationMode.PRIMARY_OR_SECONDARY;
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.pageRangesDiff = null;
	    if (!responseObject.error) {
	      responseObject.pageRangesDiff = [];
	
	      if (responseObject.response.body.PageList.PageRange) {
	        var updatedPageRanges = responseObject.response.body.PageList.PageRange;
	
	        if (!_.isArray(updatedPageRanges)) {
	          updatedPageRanges = [updatedPageRanges];
	        }
	
	        updatedPageRanges.forEach(function (pageRange) {
	          var range = {
	            start: parseInt(pageRange.Start, 10),
	            end: parseInt(pageRange.End, 10),
	            isCleared: false
	          };
	
	          responseObject.pageRangesDiff.push(range);
	        });
	      }
	
	      if (responseObject.response.body.PageList.ClearRange) {
	        var clearedPageRanges = responseObject.response.body.PageList.ClearRange;
	
	        if (!_.isArray(clearedPageRanges)) {
	          clearedPageRanges = [clearedPageRanges];
	        }
	
	        clearedPageRanges.forEach(function (pageRange) {
	          var range = {
	            start: parseInt(pageRange.Start, 10),
	            end: parseInt(pageRange.End, 10),
	            isCleared: true
	          };
	
	          responseObject.pageRangesDiff.push(range);
	        });
	      }
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.pageRangesDiff, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Clears a range of pages.
	*
	* @this {BlobService}
	* @param {string}             container                                   The container name.
	* @param {string}             blob                                        The blob name.
	* @param {int}                rangeStart                                  The range start.
	* @param {int}                rangeEnd                                    The range end.
	* @param {object}             [options]                                   The request options.
	* @param {string}             [options.leaseId]                           The target blob lease identifier.
	* @param {AccessConditions}   [options.accessConditions]                  The access conditions.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResponse}    callback                                    `error` will contain information
	*                                                                         if an error occurs; otherwise 
	*                                                                         `response` will contain information related to this operation.
	*/
	BlobService.prototype.clearPageRange = function (container, blob, rangeStart, rangeEnd, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('clearPageRange', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var request = this._updatePageBlobPagesImpl(container, blob, rangeStart, rangeEnd, BlobConstants.PageWriteOptions.CLEAR, options);
	
	  var self = this;
	  var processResponseCallback = function (responseObject, next) {
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  self.performRequest(request, null, options, processResponseCallback);
	};
	
	/**
	* Resizes a page blob.
	*
	* @this {BlobService}
	* @param {string}               container                                   The container name.
	* @param {string}               blob                                        The blob name.
	* @param {String}               size                                        The size of the page blob, in bytes.
	* @param {object}               [options]                                   The request options.
	* @param {string}               [options.leaseId]                           The blob lease identifier.
	* @param {AccessConditions}     [options.accessConditions]                  The access conditions.
	* @param {LocationMode}         [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                  [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                  [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                  [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}               [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}                 [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResult}      callback                                      `error` will contain information
	*                                                                           if an error occurs; otherwise `[result]{@link BlobResult}` will contain
	*                                                                           the page information.
	*                                                                           `response` will contain information related to this operation.
	*/
	BlobService.prototype.resizePageBlob = function (container, blob, size, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('resizePageBlob', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var resourceName = createResourceName(container, blob);
	  var webResource = WebResource.put(resourceName)
	    .withQueryOption(QueryStringConstants.COMP, 'properties')
	    .withHeader(HeaderConstants.LEASE_ID, options.leaseId);
	
	  if (size && size % BlobConstants.PAGE_SIZE !== 0) {
	    throw new RangeError(SR.INVALID_PAGE_BLOB_LENGTH);
	  }
	
	  webResource.withHeader(HeaderConstants.BLOB_CONTENT_LENGTH, size);
	
	  this._setBlobPropertiesHelper({
	    webResource: webResource,
	    options: options,
	    container: container,
	    blob: blob,
	    callback: callback
	  });
	
	};
	
	/**
	* Sets the page blob's sequence number.
	*
	* @this {BlobService}
	* @param {string}               container                                   The container name.
	* @param {string}               blob                                        The blob name.
	* @param {SequenceNumberAction} sequenceNumberAction                        A value indicating the operation to perform on the sequence number. 
	*                                                                           The allowed values are defined in azure.BlobUtilities.SequenceNumberAction.
	* @param {string}               sequenceNumber                              The sequence number.  The value of the sequence number must be between 0 and 2^63 - 1.
	*                                                                           Set this parameter to null if this operation is an increment action.
	* @param {object}               [options]                                   The request options.
	* @param {AccessConditions}     [options.accessConditions]                  The access conditions.
	* @param {LocationMode}         [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                  [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                  [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                  [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}               [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}                 [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResult}      callback                                      `error` will contain information
	*                                                                           if an error occurs; otherwise `[result]{@link BlobResult}` will contain
	*                                                                           the page information.
	*                                                                           `response` will contain information related to this operation.
	*/
	BlobService.prototype.setPageBlobSequenceNumber = function (container, blob, sequenceNumberAction, sequenceNumber, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('setPageBlobSequenceNumber', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  if (sequenceNumberAction === BlobUtilities.SequenceNumberAction.INCREMENT) {
	    if (!azureutil.objectIsNull(sequenceNumber)) {
	      throw new ArgumentError('sequenceNumber', SR.BLOB_INVALID_SEQUENCE_NUMBER);
	    }
	  } else {
	    if (azureutil.objectIsNull(sequenceNumber)) {
	      throw new ArgumentNullError('sequenceNumber', util.format(SR.ARGUMENT_NULL_OR_EMPTY, 'sequenceNumber'));
	    }
	  }
	
	  var options = extend(true, {}, userOptions);
	  var resourceName = createResourceName(container, blob);
	  var webResource = WebResource.put(resourceName)
	    .withQueryOption(QueryStringConstants.COMP, 'properties')
	    .withHeader(HeaderConstants.SEQUENCE_NUMBER_ACTION, sequenceNumberAction);
	
	  if (sequenceNumberAction !== BlobUtilities.SequenceNumberAction.INCREMENT) {
	    webResource.withHeader(HeaderConstants.SEQUENCE_NUMBER, sequenceNumber);
	  }
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.blobResult = null;
	    if (!responseObject.error) {
	      responseObject.blobResult = new BlobResult(container, blob);
	      responseObject.blobResult.getPropertiesFromHeaders(responseObject.response.headers);
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.blobResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	// Block blob methods
	
	/**
	* Uploads a block blob from a stream. If the blob already exists on the service, it will be overwritten.
	* To avoid overwriting and instead throw an error if the blob exists, please pass in an accessConditions parameter in the options object.
	*
	* @this {BlobService}
	* @param {string}             container                                     The container name.
	* @param {string}             blob                                          The blob name.
	* @param (Stream)             stream                                        Stream to the data to store.
	* @param {int}                streamLength                                  The length of the stream to upload.
	* @param {object}             [options]                                     The request options.
	* @param {SpeedSummary}       [options.speedSummary]                        The download tracker objects.
	* @param {int}                [options.blockSize]                           The size of each block. Maximum is 100MB.
	* @param {string}             [options.blockIdPrefix]                       The prefix to be used to generate the block id.
	* @param {string}             [options.leaseId]                             The lease identifier.
	* @param {string}             [options.transactionalContentMD5]             The MD5 hash of the blob content. This hash is used to verify the integrity of the blob during transport.
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {int}                [options.parallelOperationThreadCount]        The number of parallel operations that may be performed when uploading.
	* @param {bool}               [options.storeBlobContentMD5]                 Specifies whether the blob's ContentMD5 header should be set on uploads. The default value is true for block blobs.
	* @param {bool}               [options.useTransactionalMD5]                 Calculate and send/validate content MD5 for transactions.
	* @param {object}             [options.contentSettings]                     The content settings of the blob.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the blob. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the blob.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The Blob service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The blob's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The blob's MD5 hash.
	* @param {AccessConditions}   [options.accessConditions]                    The access conditions.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResult}      callback                                      `error` will contain information
	*                                                                           if an error occurs; otherwise `[result]{@link BlobResult}` will contain
	*                                                                           the blob information.
	*                                                                           `response` will contain information related to this operation.
	* @return {SpeedSummary}
	*/
	BlobService.prototype.createBlockBlobFromStream = function (container, blob, stream, streamLength, optionsOrCallback, callback) {
	  return this._createBlobFromStream(container, blob, BlobConstants.BlobTypes.BLOCK, stream, streamLength, optionsOrCallback, callback);
	};
	
	/**
	* Uploads a block blob from a text string. If the blob already exists on the service, it will be overwritten.
	* To avoid overwriting and instead throw an error if the blob exists, please pass in an accessConditions parameter in the options object.
	*
	* @this {BlobService}
	* @param {string}             container                                     The container name.
	* @param {string}             blob                                          The blob name.
	* @param {string|object}      text                                          The blob text, as a string or in a Buffer.
	* @param {object}             [options]                                     The request options.
	* @param {string}             [options.leaseId]                             The lease identifier.
	* @param {string}             [options.transactionalContentMD5]             The MD5 hash of the blob content. This hash is used to verify the integrity of the blob during transport.
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {bool}               [options.storeBlobContentMD5]                 Specifies whether the blob's ContentMD5 header should be set on uploads. The default value is true for block blobs.
	* @param {bool}               [options.useTransactionalMD5]                 Calculate and send/validate content MD5 for transactions.
	* @param {object}             [options.contentSettings]                     The content settings of the blob.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the blob. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the blob.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The Blob service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The blob's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The blob's MD5 hash.
	* @param {AccessConditions}   [options.accessConditions]                    The access conditions.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResult}      callback                                      `error` will contain information
	*                                                                           if an error occurs; otherwise `[result]{@link BlobResult}` will contain
	*                                                                           the blob information.
	*                                                                           `response` will contain information related to this operation.
	*/
	BlobService.prototype.createBlockBlobFromText = function (container, blob, text, optionsOrCallback, callback) {
	  return this._createBlobFromText(container, blob, BlobConstants.BlobTypes.BLOCK, text, optionsOrCallback, callback);
	};
	
	/**
	* Provides a stream to write to a block blob. If the blob already exists on the service, it will be overwritten.
	* To avoid overwriting and instead throw an error if the blob exists, please pass in an accessConditions parameter in the options object.
	* Please note the `Stream` returned by this API should be used with piping.
	*
	* @this {BlobService}
	* @param {string}             container                                     The container name.
	* @param {string}             blob                                          The blob name.
	* @param {object}             [options]                                     The request options.
	* @param {int}                [options.blockSize]                           The size of each block. Maximum is 100MB.
	* @param {string}             [options.blockIdPrefix]                       The prefix to be used to generate the block id.
	* @param {string}             [options.leaseId]                             The lease identifier.
	* @param {string}             [options.transactionalContentMD5]             The MD5 hash of the blob content. This hash is used to verify the integrity of the blob during transport.
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {int}                [options.parallelOperationThreadCount]        The number of parallel operations that may be performed when uploading.
	* @param {bool}               [options.storeBlobContentMD5]                 Specifies whether the blob's ContentMD5 header should be set on uploads. 
	*                                                                           The default value is false for page blobs and true for block blobs.
	* @param {bool}               [options.useTransactionalMD5]                 Calculate and send/validate content MD5 for transactions.
	* @param {object}             [options.contentSettings]                     The content settings of the blob.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the blob. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the blob.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The Blob service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The blob's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The blob's MD5 hash.
	* @param {AccessConditions}   [options.accessConditions]                    The access conditions.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResult}      callback                                      `error` will contain information
	*                                                                           if an error occurs; otherwise `[result]{@link BlobResult}` will contain
	*                                                                           the blob information.
	*                                                                           `response` will contain information related to this operation.
	* @return {Writable}                                                        A Node.js Writable stream.
	* @example
	* var azure = require('azure-storage');
	* var blobService = azure.createBlobService();
	* var stream = fs.createReadStream(fileNameTarget).pipe(blobService.createWriteStreamToBlockBlob(containerName, blobName, { blockIdPrefix: 'block' }));
	*/
	BlobService.prototype.createWriteStreamToBlockBlob = function (container, blob, optionsOrCallback, callback) {
	  return this._createWriteStreamToBlob(container, blob, BlobConstants.BlobTypes.BLOCK, 0, false, optionsOrCallback, callback);
	};
	
	/**
	* Creates a new block to be committed as part of a blob.
	*
	* @this {BlobService}
	* @param {string}             blockId                                   The block identifier.
	* @param {string}             container                                 The container name.
	* @param {string}             blob                                      The blob name.
	* @param {Readable}           readStream                                The Node.js Readable stream.
	* @param {int}                streamLength                              The stream length.
	* @param {object}             [options]                                 The request options.
	* @param {bool}               [options.useTransactionalMD5]             Calculate and send/validate content MD5 for transactions.
	* @param {string}             [options.leaseId]                         The target blob lease identifier.
	* @param {string}             [options.transactionalContentMD5]         An MD5 hash of the block content. This hash is used to verify the integrity of the block during transport.
	* @param {AccessConditions}   [options.accessConditions]                The access conditions.
	* @param {LocationMode}       [options.locationMode]                    Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                       Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]             The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]        The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]        The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                       The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                       execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                 A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]               Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                       The default value is false.
	* @param {errorOrResponse}    callback                                  `error` will contain information
	*                                                                       if an error occurs; otherwise 
	*                                                                       `response` will contain information related to this operation.
	*/
	BlobService.prototype.createBlockFromStream = function (blockId, container, blob, readStream, streamLength, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('createBlockFromStream', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	    v.exists(readStream, 'readStream');
	    v.value(streamLength, 'streamLength');
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  if (streamLength > BlobConstants.MAX_BLOCK_BLOB_BLOCK_SIZE) {
	    throw new RangeError(SR.INVALID_STREAM_LENGTH);
	  } else {
	    this._createBlock(blockId, container, blob, null, readStream, streamLength, options, callback);
	  }
	};
	
	/**
	* Creates a new block to be committed as part of a blob.
	*
	* @this {BlobService}
	* @param {string}             blockId                                   The block identifier.
	* @param {string}             container                                 The container name.
	* @param {string}             blob                                      The blob name.
	* @param {string|buffer}      content                                   The block content.
	* @param {object}             [options]                                 The request options.
	* @param {bool}               [options.useTransactionalMD5]             Calculate and send/validate content MD5 for transactions.
	* @param {string}             [options.leaseId]                         The target blob lease identifier.
	* @param {string}             [options.transactionalContentMD5]         An MD5 hash of the block content. This hash is used to verify the integrity of the block during transport. 
	* @param {AccessConditions}   [options.accessConditions]                The access conditions.
	* @param {LocationMode}       [options.locationMode]                    Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                       Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]             The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]        The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]        The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                       The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                       execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                 A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]               Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                       The default value is false.
	* @param {errorOrResponse}    callback                                  `error` will contain information
	*                                                                       if an error occurs; otherwise 
	*                                                                       `response` will contain information related to this operation.
	*/
	BlobService.prototype.createBlockFromText = function (blockId, container, blob, content, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('createBlockFromText', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var contentLength = (Buffer.isBuffer(content) ? content.length : Buffer.byteLength(content));
	
	  if (contentLength > BlobConstants.MAX_BLOCK_BLOB_BLOCK_SIZE) {
	    throw new RangeError(SR.INVALID_TEXT_LENGTH);
	  } else {
	    this._createBlock(blockId, container, blob, content, null, contentLength, options, callback);
	  }
	};
	
	/**
	* Creates a new block to be committed as part of a block blob.
	* @ignore
	*
	* @this {BlobService}
	* @param {string}             blockId                                   The block identifier.
	* @param {string}             container                                 The container name.
	* @param {string}             blob                                      The blob name.
	* @param {string|buffer}      content                                   The block content.
	* @param (Stream)             stream                                    The stream to the data to store.
	* @param {int}                length                                    The length of the stream or text to upload.
	* @param {object}             [options]                                 The request options.
	* @param {bool}               [options.useTransactionalMD5]             Calculate and send/validate content MD5 for transactions.
	* @param {string}             [options.leaseId]                         The target blob lease identifier.
	* @param {string}             [options.transactionalContentMD5]         An MD5 hash of the block content. This hash is used to verify the integrity of the block during transport.
	* @param {AccessConditions}   [options.accessConditions]                The access conditions.
	* @param {LocationMode}       [options.locationMode]                    Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                       Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]             The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]        The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]        The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                       The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                       execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                 A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]               Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                       The default value is false.
	* @param {errorOrResponse}    callback                                  `error` will contain information
	*                                                                       if an error occurs; otherwise 
	*                                                                       `response` will contain information related to this operation.
	*/
	BlobService.prototype._createBlock = function (blockId, container, blob, content, stream, length, options, callback) {
	  var resourceName = createResourceName(container, blob);
	
	  var self = this;
	  var startCreateBlock = function () {
	    var webResource = WebResource.put(resourceName)
	      .withQueryOption(QueryStringConstants.COMP, 'block')
	      .withQueryOption(QueryStringConstants.BLOCK_ID, new Buffer(blockId).toString('base64'))
	      .withHeader(HeaderConstants.CONTENT_LENGTH, length);
	
	    BlobResult.setHeadersFromBlob(webResource, options);
	
	    var processResponseCallback = function (responseObject, next) {
	      var finalCallback = function (returnObject) {
	        callback(returnObject.error, returnObject.response);
	      };
	
	      next(responseObject, finalCallback);
	    };
	
	    if (!azureutil.objectIsNull(content)) {
	      self.performRequest(webResource, content, options, processResponseCallback);
	    } else {
	      self.performRequestOutputStream(webResource, stream, options, processResponseCallback);
	    }
	  };
	
	  if (azureutil.objectIsNull(options.transactionalContentMD5) && options.useTransactionalMD5) {
	    if (!azureutil.objectIsNull(content)) {
	      options.transactionalContentMD5 = azureutil.getContentMd5(content);
	      startCreateBlock();
	    } else {
	      azureutil.calculateMD5(stream, length, options, function (internalBuff, contentMD5) {
	        options.transactionalContentMD5 = contentMD5;
	        content = internalBuff;
	        length = internalBuff.length;
	        startCreateBlock();
	      });
	    }
	  } else {
	    startCreateBlock();
	  }
	};
	
	/**
	* Writes a blob by specifying the list of block IDs that make up the blob.
	* In order to be written as part of a blob, a block must have been successfully written to the server in a prior
	* createBlock operation.
	* Note: If no valid list is specified in the blockList parameter, blob would be updated with empty content,
	* i.e. existing blocks in the blob will be removed, this behavior is kept for backward compatibility consideration.
	*
	* @this {BlobService}
	* @param {string}             container                                     The container name.
	* @param {string}             blob                                          The blob name.
	* @param {object}             blockList                                     The wrapper for block ID list contains block IDs that make up the blob.
	*                                                                           Three kinds of list are provided, please choose one to use according to requirement.
	*                                                                           For more background knowledge, please refer to https://docs.microsoft.com/en-us/rest/api/storageservices/put-block-list
	* @param {string[]}           [blockList.LatestBlocks]                      The list contains block IDs that make up the blob sequentially.
	*                                                                           All the block IDs in this list will be specified within Latest element.
	*                                                                           Choose this list to contain block IDs indicates that the Blob service should first search
	*                                                                           the uncommitted block list, and then the committed block list for the named block.
	* @param {string[]}           [blockList.CommittedBlocks]                   The list contains block IDs that make up the blob sequentially.
	*                                                                           All the block IDs in this list will be specified within Committed element.
	*                                                                           Choose this list to contain block IDs indicates that the Blob service should only search
	*                                                                           the committed block list for the named block.
	* @param {string[]}           [blockList.UncommittedBlocks]                 The list contains block IDs that make up the blob sequentially.
	*                                                                           All the block IDs in this list will be specified within Uncommitted element.
	*                                                                           Choose this list to contain block IDs indicates that the Blob service should only search
	*                                                                           the uncommitted block list for the named block.
	* @param {object}             [options]                                     The request options.
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {string}             [options.leaseId]                             The target blob lease identifier.
	* @param {object}             [options.contentSettings]                     The content settings of the blob.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the blob. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the blob.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The Blob service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The blob's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The blob's MD5 hash.
	* @param {AccessConditions}   [options.accessConditions]                    The access conditions.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResult}      callback                                      `error` will contain information
	*                                                                           if an error occurs; otherwise `[result]{@link BlobResult}` will contain
	*                                                                           the blob information.
	*                                                                           `response` will contain information related to this operation.
	* @example
	* var azure = require('azure-storage');
	* var blobService = azure.createBlobService();
	* blobService.createBlockFromText("sampleBlockName", containerName, blobName, "sampleBlockContent", function(error) {
	*   assert.equal(error, null);
	*   // In this example, LatestBlocks is used, we hope the Blob service first search
	*   // the uncommitted block list, and then the committed block list for the named block "sampleBlockName",
	*   // and thus make sure the block is with latest content.
	*   blobService.commitBlocks(containerName, blobName, { LatestBlocks: ["sampleBlockName"] }, function(error) {
	*     assert.equal(error, null);
	*   });
	* });
	*
	 */
	BlobService.prototype.commitBlocks = function (container, blob, blockList, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('commitBlocks', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.object(blockList, 'blockList');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var blockListXml = BlockListResult.serialize(blockList);
	
	  var resourceName = createResourceName(container, blob);
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.put(resourceName)
	    .withQueryOption(QueryStringConstants.COMP, 'blocklist')
	    .withHeader(HeaderConstants.CONTENT_LENGTH, Buffer.byteLength(blockListXml))
	    .withBody(blockListXml);
	
	  BlobResult.setPropertiesFromBlob(webResource, options);
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.blobResult = new BlobResult(container, blob);
	    responseObject.blobResult.list = null;
	    if (!responseObject.error) {
	      responseObject.blobResult.getPropertiesFromHeaders(responseObject.response.headers);
	      responseObject.blobResult.list = blockList;
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.blobResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, webResource.body, options, processResponseCallback);
	};
	
	/**
	* Retrieves the list of blocks that have been uploaded as part of a block blob.
	*
	* @this {BlobService}
	* @param {string}             container                                   The container name.
	* @param {string}             blob                                        The blob name.
	* @param {BlockListFilter}    blocklisttype                               The type of block list to retrieve.
	* @param {object}             [options]                                   The request options.
	* @param {string}             [options.snapshotId]                        The source blob snapshot identifier.
	* @param {string}             [options.leaseId]                           The target blob lease identifier.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information
	*                                                                         if an error occurs; otherwise `result` will contain
	*                                                                         the blocklist information.
	*                                                                         `response` will contain information related to this operation.
	*/
	BlobService.prototype.listBlocks = function (container, blob, blocklisttype, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('listBlocks', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var resourceName = createResourceName(container, blob);
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.get(resourceName)
	    .withQueryOption(QueryStringConstants.COMP, 'blocklist')
	    .withQueryOption(QueryStringConstants.BLOCK_LIST_TYPE, blocklisttype)
	    .withQueryOption(QueryStringConstants.SNAPSHOT, options.snapshotId);
	
	  options.requestLocationMode = RequestLocationMode.PRIMARY_OR_SECONDARY;
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.blockListResult = null;
	    if (!responseObject.error) {
	      responseObject.blockListResult = BlockListResult.parse(responseObject.response.body.BlockList);
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.blockListResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Generate a random block id prefix
	*/
	BlobService.prototype.generateBlockIdPrefix = function () {
	  var prefix = Math.floor(Math.random() * 0x100000000).toString(16);
	  return azureutil.zeroPaddingString(prefix, 8);
	};
	
	/**
	* Get a block id according to prefix and block number
	*/
	BlobService.prototype.getBlockId = function (prefix, number) {
	  return prefix + '-' + azureutil.zeroPaddingString(number, 6);
	};
	
	// Append blob methods
	
	/**
	* Creates an empty append blob. If the blob already exists on the service, it will be overwritten.
	* To avoid overwriting and instead throw an error if the blob exists, please pass in an accessConditions parameter in the options object.
	*
	* @this {BlobService}
	* @param {string}             container                                     The container name.
	* @param {string}             blob                                          The blob name.
	* @param {object}             [options]                                     The request options.
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {string}             [options.leaseId]                             The target blob lease identifier.
	* @param {object}             [options.contentSettings]                     The content settings of the blob.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the blob. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the blob.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The Blob service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The blob's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The blob's MD5 hash.
	* @param {AccessConditions}   [options.accessConditions]                    The access conditions.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResponse}    callback                                      `error` will contain information
	*                                                                           if an error occurs; otherwise 
	*                                                                           `response` will contain information related to this operation.
	*/
	BlobService.prototype.createOrReplaceAppendBlob = function (container, blob, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('createOrReplaceAppendBlob', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  var resourceName = createResourceName(container, blob);
	
	  var webResource = WebResource.put(resourceName)
	    .withHeader(HeaderConstants.BLOB_TYPE, BlobConstants.BlobTypes.APPEND)
	    .withHeader(HeaderConstants.LEASE_ID, options.leaseId)
	    .withHeader(HeaderConstants.CONTENT_LENGTH, 0);
	
	  BlobResult.setHeadersFromBlob(webResource, options);
	
	  var processResponseCallback = function (responseObject, next) {
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Uploads an append blob from a stream. If the blob already exists on the service, it will be overwritten.
	* To avoid overwriting and instead throw an error if the blob exists, please pass in an accessConditions parameter in the options object.
	* This API should be used strictly in a single writer scenario because the API internally uses the append-offset conditional header to avoid duplicate blocks.
	* If you are guaranteed to have a single writer scenario, please look at options.absorbConditionalErrorsOnRetry and see if setting this flag to true is acceptable for you.
	* If you want to append data to an already existing blob, please look at appendFromStream.
	*
	* @this {BlobService}
	* @param {string}             container                                     The container name.
	* @param {string}             blob                                          The blob name.
	* @param (Stream)             stream                                        Stream to the data to store.
	* @param {int}                streamLength                                  The length of the stream to upload.
	* @param {object}             [options]                                     The request options.
	* @param {bool}               [options.absorbConditionalErrorsOnRetry]      Specifies whether to absorb the conditional error on retry.
	* @param {SpeedSummary}       [options.speedSummary]                        The download tracker objects.
	* @param {string}             [options.leaseId]                             The lease identifier. 
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {bool}               [options.storeBlobContentMD5]                 Specifies whether the blob's ContentMD5 header should be set on uploads. The default value is true for block blobs.
	* @param {bool}               [options.useTransactionalMD5]                 Calculate and send/validate content MD5 for transactions.
	* @param {object}             [options.contentSettings]                     The content settings of the blob.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the blob. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the blob.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The Blob service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The blob's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The blob's MD5 hash.
	* @param {AccessConditions}   [options.accessConditions]                    The access conditions.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResult}      callback                                      `error` will contain information
	*                                                                           if an error occurs; otherwise `[result]{@link BlobResult}` will contain
	*                                                                           the blob information.
	*                                                                           `response` will contain information related to this operation.
	* @return {SpeedSummary}
	*/
	BlobService.prototype.createAppendBlobFromStream = function (container, blob, stream, streamLength, optionsOrCallback, callback) {
	  return this._createBlobFromStream(container, blob, BlobConstants.BlobTypes.APPEND, stream, streamLength, optionsOrCallback, callback);
	};
	
	/**
	* Uploads an append blob from a text string. If the blob already exists on the service, it will be overwritten.
	* To avoid overwriting and instead throw an error if the blob exists, please pass in an accessConditions parameter in the options object.
	* This API should be used strictly in a single writer scenario because the API internally uses the append-offset conditional header to avoid duplicate blocks.
	* If you are guaranteed to have a single writer scenario, please look at options.absorbConditionalErrorsOnRetry and see if setting this flag to true is acceptable for you.
	* If you want to append data to an already existing blob, please look at appendFromText.
	*
	* @this {BlobService}
	* @param {string}             container                                     The container name.
	* @param {string}             blob                                          The blob name.
	* @param {string|object}      text                                          The blob text, as a string or in a Buffer.
	* @param {object}             [options]                                     The request options.
	* @param {bool}               [options.absorbConditionalErrorsOnRetry]      Specifies whether to absorb the conditional error on retry.
	* @param {string}             [options.leaseId]                             The lease identifier. 
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {bool}               [options.storeBlobContentMD5]                 Specifies whether the blob's ContentMD5 header should be set on uploads. The default value is true for block blobs.
	* @param {bool}               [options.useTransactionalMD5]                 Calculate and send/validate content MD5 for transactions.
	* @param {object}             [options.contentSettings]                     The content settings of the blob.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the blob. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the blob.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The Blob service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The blob's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The blob's MD5 hash.
	* @param {AccessConditions}   [options.accessConditions]                    The access conditions.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResult}      callback                                      `error` will contain information
	*                                                                           if an error occurs; otherwise `[result]{@link BlobResult}` will contain
	*                                                                           the blob information.
	*                                                                           `response` will contain information related to this operation.
	*/
	BlobService.prototype.createAppendBlobFromText = function (container, blob, text, optionsOrCallback, callback) {
	  return this._createBlobFromText(container, blob, BlobConstants.BlobTypes.APPEND, text, optionsOrCallback, callback);
	};
	
	/**
	* Provides a stream to write to a new append blob. If the blob already exists on the service, it will be overwritten.
	* To avoid overwriting and instead throw an error if the blob exists, please pass in an accessConditions parameter in the options object.
	* This API should be used strictly in a single writer scenario because the API internally uses the append-offset conditional header to avoid duplicate blocks.
	* If you are guaranteed to have a single writer scenario, please look at options.absorbConditionalErrorsOnRetry and see if setting this flag to true is acceptable for you.
	* Please note the `Stream` returned by this API should be used with piping.
	*
	* @this {BlobService}
	* @param {string}             container                                     The container name.
	* @param {string}             blob                                          The blob name.
	* @param {object}             [options]                                     The request options.
	* @param {bool}               [options.absorbConditionalErrorsOnRetry]      Specifies whether to absorb the conditional error on retry.
	* @param {string}             [options.leaseId]                             The lease identifier.
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {bool}               [options.storeBlobContentMD5]                 Specifies whether the blob's ContentMD5 header should be set on uploads. 
	*                                                                           The default value is false for page blobs and true for block blobs.
	* @param {bool}               [options.useTransactionalMD5]                 Calculate and send/validate content MD5 for transactions.
	* @param {object}             [options.contentSettings]                     The content settings of the blob.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the blob. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the blob.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The Blob service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The blob's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The blob's MD5 hash.
	* @param {AccessConditions}   [options.accessConditions]                    The access conditions.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResponse}    callback                                      The callback function.
	* @return {Writable}                                                        A Node.js Writable stream.
	* @example
	* var azure = require('azure-storage');
	* var blobService = azure.createBlobService();
	* var stream = fs.createReadStream(fileNameTarget).pipe(blobService.createWriteStreamToAppendBlob(containerName, blobName));
	*/
	BlobService.prototype.createWriteStreamToNewAppendBlob = function (container, blob, optionsOrCallback, callback) {
	  return this._createWriteStreamToBlob(container, blob, BlobConstants.BlobTypes.APPEND, 0, true, optionsOrCallback, callback);
	};
	
	/**
	* Provides a stream to write to an existing append blob. Assumes that the blob exists. 
	* If it does not, please create the blob using createAppendBlob before calling this method or use createWriteStreamToNewAppendBlob.
	* This API should be used strictly in a single writer scenario because the API internally uses the append-offset conditional header to avoid duplicate blocks.
	* If you are guaranteed to have a single writer scenario, please look at options.absorbConditionalErrorsOnRetry and see if setting this flag to true is acceptable for you.
	* Please note the `Stream` returned by this API should be used with piping.
	*
	* @this {BlobService}
	* @param {string}             container                                     The container name.
	* @param {string}             blob                                          The blob name.
	* @param {object}             [options]                                     The request options.
	* @param {bool}               [options.absorbConditionalErrorsOnRetry]      Specifies whether to absorb the conditional error on retry.
	* @param {string}             [options.leaseId]                             The lease identifier.
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {bool}               [options.storeBlobContentMD5]                 Specifies whether the blob's ContentMD5 header should be set on uploads. 
	*                                                                           The default value is false for page blobs and true for block blobs.
	* @param {bool}               [options.useTransactionalMD5]                 Calculate and send/validate content MD5 for transactions.
	* @param {object}             [options.contentSettings]                     The content settings of the blob.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the blob. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the blob.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The Blob service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The blob's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The blob's MD5 hash.
	* @param {AccessConditions}   [options.accessConditions]                    The access conditions.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResponse}    callback                                      The callback function.
	* @return {Writable}                                                        A Node.js Writable stream.
	* @example
	* var azure = require('azure-storage');
	* var blobService = azure.createBlobService();
	* var stream = fs.createReadStream(fileNameTarget).pipe(blobService.createWriteStreamToAppendBlob(containerName, blobName));
	*/
	BlobService.prototype.createWriteStreamToExistingAppendBlob = function (container, blob, optionsOrCallback, callback) {
	  return this._createWriteStreamToBlob(container, blob, BlobConstants.BlobTypes.APPEND, 0, false, optionsOrCallback, callback);
	};
	
	/**
	* Appends to an append blob from a stream. Assumes the blob already exists on the service.
	* This API should be used strictly in a single writer scenario because the API internally uses the append-offset conditional header to avoid duplicate blocks.
	* If you are guaranteed to have a single writer scenario, please look at options.absorbConditionalErrorsOnRetry and see if setting this flag to true is acceptable for you.
	*
	* @this {BlobService}
	* @param {string}             container                                     The container name.
	* @param {string}             blob                                          The blob name.
	* @param (Stream)             stream                                        Stream to the data to store.
	* @param {int}                streamLength                                  The length of the stream to upload.
	* @param {object}             [options]                                     The request options.
	* @param {bool}               [options.absorbConditionalErrorsOnRetry]      Specifies whether to absorb the conditional error on retry.
	* @param {SpeedSummary}       [options.speedSummary]                        The download tracker objects.
	* @param {string}             [options.leaseId]                             The lease identifier.
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {bool}               [options.useTransactionalMD5]                 Calculate and send/validate content MD5 for transactions.
	* @param {object}             [options.contentSettings]                     The content settings of the blob.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the blob. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the blob.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The Blob service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The blob's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The blob's MD5 hash.
	* @param {AccessConditions}   [options.accessConditions]                    The access conditions.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResult}      callback                                      `error` will contain information
	*                                                                           if an error occurs; otherwise `[result]{@link BlobResult}` will contain
	*                                                                           the blob information.
	*                                                                           `response` will contain information related to this operation.
	* @return {SpeedSummary}
	*/
	BlobService.prototype.appendFromStream = function (container, blob, stream, streamLength, optionsOrCallback, callback) {
	  var options;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { options = o; callback = c; });
	
	  validate.validateArgs('appendFromStream', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	    v.exists(stream, 'stream');
	    v.value(streamLength, 'streamLength');
	    v.callback(callback);
	  });
	
	  return this._uploadBlobFromStream(false, container, blob, BlobConstants.BlobTypes.APPEND, stream, streamLength, options, callback);
	};
	
	/**
	* Appends to an append blob from a text string. Assumes the blob already exists on the service.
	* This API should be used strictly in a single writer scenario because the API internally uses the append-offset conditional header to avoid duplicate blocks.
	* If you are guaranteed to have a single writer scenario, please look at options.absorbConditionalErrorsOnRetry and see if setting this flag to true is acceptable for you.
	*
	* @this {BlobService}
	* @param {string}             container                                     The container name.
	* @param {string}             blob                                          The blob name.
	* @param {string|object}      text                                          The blob text, as a string or in a Buffer.
	* @param {object}             [options]                                     The request options.
	* @param {bool}               [options.absorbConditionalErrorsOnRetry]      Specifies whether to absorb the conditional error on retry.
	* @param {string}             [options.leaseId]                             The lease identifier.
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {bool}               [options.storeBlobContentMD5]                 Specifies whether the blob's ContentMD5 header should be set on uploads. The default value is true for block blobs.
	* @param {bool}               [options.useTransactionalMD5]                 Calculate and send/validate content MD5 for transactions.
	* @param {object}             [options.contentSettings]                     The content settings of the blob.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the blob. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the blob.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The Blob service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The blob's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The blob's MD5 hash.
	* @param {AccessConditions}   [options.accessConditions]                    The access conditions.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResult}      callback                                      `error` will contain information
	*                                                                           if an error occurs; otherwise `[result]{@link BlobResult}` will contain
	*                                                                           the blob information.
	*                                                                           `response` will contain information related to this operation.
	*/
	BlobService.prototype.appendFromText = function (container, blob, text, optionsOrCallback, callback) {
	  return this._uploadBlobFromText(false, container, blob, BlobConstants.BlobTypes.APPEND, text, optionsOrCallback, callback);
	};
	
	
	/**
	* Creates a new block from a read stream to be appended to an append blob.
	* This API should be used strictly in a single writer scenario because the API internally uses the append-offset conditional header to avoid duplicate blocks.
	* If you are guaranteed to have a single writer scenario, please look at options.absorbConditionalErrorsOnRetry and see if setting this flag to true is acceptable for you.
	*
	* @this {BlobService}
	* @param {string}             container                                 The container name.
	* @param {string}             blob                                      The blob name.
	* @param {Readable}           readStream                                The Node.js Readable stream.
	* @param {int}                streamLength                              The stream length.
	* @param {object}             [options]                                 The request options.
	* @param {bool}               [options.absorbConditionalErrorsOnRetry]  Specifies whether to absorb the conditional error on retry.
	* @param {int}                [options.maxBlobSize]                     The max length in bytes allowed for the append blob to grow to.
	* @param {int}                [options.appendPosition]                  The number indicating the byte offset to check for. The append will succeed only if the end position of the blob is equal to this number.
	* @param {string}             [options.leaseId]                         The target blob lease identifier.
	* @param {string}             [options.transactionalContentMD5]         An MD5 hash of the block content. This hash is used to verify the integrity of the block during transport.
	* @param {AccessConditions}   [options.accessConditions]                The access conditions.
	* @param {LocationMode}       [options.locationMode]                    Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                       Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]             The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]        The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]        The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                       The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                       execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                 A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]               Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                       The default value is false.
	* @param {errorOrResult}      callback                                  `error` will contain information
	*                                                                      if an error occurs; otherwise `[result]{@link BlobResult}` will contain
	*                                                                      the blob information.
	*                                                                      `response` will contain information related to this operation.
	*/
	BlobService.prototype.appendBlockFromStream = function (container, blob, readStream, streamLength, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('appendBlockFromStream', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	    v.exists(readStream, 'readStream');
	    v.value(streamLength, 'streamLength');
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  if (streamLength > BlobConstants.MAX_APPEND_BLOB_BLOCK_SIZE) {
	    throw new RangeError(SR.INVALID_STREAM_LENGTH);
	  } else {
	    this._appendBlock(container, blob, null, readStream, streamLength, options, callback);
	  }
	};
	
	/**
	* Creates a new block from a text to be appended to an append blob.
	* This API should be used strictly in a single writer scenario because the API internally uses the append-offset conditional header to avoid duplicate blocks.
	* If you are guaranteed to have a single writer scenario, please look at options.absorbConditionalErrorsOnRetry and see if setting this flag to true is acceptable for you.
	*
	* @this {BlobService}
	* @param {string}             container                                 The container name.
	* @param {string}             blob                                      The blob name.
	* @param {string|object}      content                                   The block text, as a string or in a Buffer.
	* @param {object}             [options]                                 The request options.
	* @param {bool}               [options.absorbConditionalErrorsOnRetry]  Specifies whether to absorb the conditional error on retry.
	* @param {int}                [options.maxBlobSize]                     The max length in bytes allowed for the append blob to grow to.
	* @param {int}                [options.appendPosition]                  The number indicating the byte offset to check for. The append will succeed only if the end position of the blob is equal to this number.
	* @param {string}             [options.leaseId]                         The target blob lease identifier.
	* @param {string}             [options.transactionalContentMD5]         An MD5 hash of the block content. This hash is used to verify the integrity of the block during transport.
	* @param {AccessConditions}   [options.accessConditions]                The access conditions.
	* @param {LocationMode}       [options.locationMode]                    Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                       Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]             The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]        The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]        The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                       The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                       execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                 A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]               Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                       The default value is false.
	* @param {errorOrResponse}    callback                                  `error` will contain information
	*                                                                       if an error occurs; otherwise 
	*                                                                       `response` will contain information related to this operation.
	*/
	BlobService.prototype.appendBlockFromText = function (container, blob, content, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('appendBlockFromText', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var contentLength = (Buffer.isBuffer(content) ? content.length : Buffer.byteLength(content));
	  if (contentLength > BlobConstants.MAX_APPEND_BLOB_BLOCK_SIZE) {
	    throw new RangeError(SR.INVALID_TEXT_LENGTH);
	  } else {
	    this._appendBlock(container, blob, content, null, contentLength, options, callback);
	  }
	};
	
	// Private methods
	
	/**
	* Creates a new blob from a stream. If the blob already exists on the service, it will be overwritten.
	* To avoid overwriting and instead throw an error if the blob exists, please pass in an accessConditions parameter in the options object.
	*
	* @ignore
	*
	* @this {BlobService}
	* @param {string}             container                                     The container name.
	* @param {string}             blob                                          The blob name.
	* @param {BlobType}           blobType                                      The blob type.
	* @param (Stream)             stream                                        Stream to the data to store.
	* @param {int}                streamLength                                  The length of the stream to upload.
	* @param {object}             [options]                                     The request options.
	* @param {SpeedSummary}       [options.speedSummary]                        The upload tracker objects.
	* @param {bool}               [options.absorbConditionalErrorsOnRetry]      Specifies whether to absorb the conditional error on retry. (For append blob only)
	* @param {string}             [options.blockIdPrefix]                       The prefix to be used to generate the block id. (For block blob only)
	* @param {string}             [options.leaseId]                             The lease identifier.
	* @param {string}             [options.transactionalContentMD5]             The MD5 hash of the blob content. This hash is used to verify the integrity of the blob during transport.
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {int}                [options.parallelOperationThreadCount]        The number of parallel operations that may be performed when uploading.
	* @param {bool}               [options.storeBlobContentMD5]                 Specifies whether the blob's ContentMD5 header should be set on uploads. The default value is true for block blobs.
	* @param {bool}               [options.useTransactionalMD5]                 Calculate and send/validate content MD5 for transactions.
	* @param {string}             [options.blobTier]                            For page blobs on premium accounts only. Set the tier of the target blob. Refer to BlobUtilities.BlobTier.PremiumPageBlobTier.
	* @param {object}             [options.contentSettings]                     The content settings of the blob.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the blob. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the blob.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The Blob service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The blob's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The blob's MD5 hash.
	* @param {AccessConditions}   [options.accessConditions]                    The access conditions.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResult}      callback                                      The callback function.
	* @return {SpeedSummary}
	*/
	BlobService.prototype._createBlobFromStream = function (container, blob, blobType, stream, streamLength, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('_createBlobFromStream', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	    v.blobTypeIsValid(blobType);
	    v.exists(stream, 'stream');
	    v.value(streamLength, 'streamLength');
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  var self = this;
	  var creationCallback = function (createError, createBlob, createResponse) {
	    if (createError) {
	      callback(createError, createBlob, createResponse);
	    } else {
	      self._uploadBlobFromStream(true, container, blob, blobType, stream, streamLength, options, callback);
	    }
	  };
	
	  this._createBlob(container, blob, blobType, streamLength, options, creationCallback);
	
	  return options.speedSummary;
	};
	
	/**
	* Uploads a block blob or an append blob from a text string. If the blob already exists on the service, it will be overwritten.
	* To avoid overwriting and instead throw an error if the blob exists, please pass in an accessConditions parameter in the options object.
	*
	* @ignore
	* 
	* @this {BlobService}
	* @param {string}             container                                     The container name.
	* @param {string}             blob                                          The blob name.
	* @param {BlobType}           blobType                                      The blob type.
	* @param {string|buffer}      content                                       The blob text, as a string or in a Buffer.
	* @param {object}             [options]                                     The request options.
	* @param {bool}               [options.absorbConditionalErrorsOnRetry]      Specifies whether to absorb the conditional error on retry. (For append blob only)
	* @param {string}             [options.leaseId]                             The lease identifier.
	* @param {string}             [options.transactionalContentMD5]             The MD5 hash of the blob content. This hash is used to verify the integrity of the blob during transport.
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {bool}               [options.storeBlobContentMD5]                 Specifies whether the blob's ContentMD5 header should be set on uploads. The default value is true for block blobs.
	* @param {bool}               [options.useTransactionalMD5]                 Calculate and send/validate content MD5 for transactions.
	* @param {object}             [options.contentSettings]                     The content settings of the blob.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the blob. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the blob.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The Blob service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The blob's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The blob's MD5 hash.
	* @param {AccessConditions}   [options.accessConditions]                    The access conditions.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResult}      callback                                      `error` will contain information
	*                                                                           if an error occurs; otherwise `result` will contain
	*                                                                           information about the blob.
	*                                                                           `response` will contain information related to this operation.
	*/
	BlobService.prototype._createBlobFromText = function (container, blob, blobType, content, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('_createBlobFromText', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	    v.blobTypeIsValid(blobType);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  var self = this;
	  var creationCallback = function (createError, createBlob, createResponse) {
	    if (createError) {
	      callback(createError, createBlob, createResponse);
	    } else {
	      self._uploadBlobFromText(true, container, blob, blobType, content, options, callback);
	    }
	  };
	
	  var contentLength = azureutil.objectIsNull(content) ? 0 : ((Buffer.isBuffer(content) ? content.length : Buffer.byteLength(content)));
	  this._createBlob(container, blob, blobType, contentLength, options, creationCallback);
	
	  return options.speedSummary;
	};
	
	/**
	* Provides a stream to write to a block blob or an append blob.
	*
	* @ignore
	* 
	* @this {BlobService}
	* @param {string}             container                                     The container name.
	* @param {string}             blob                                          The blob name.
	* @param {BlobType}           blobType                                      The blob type.
	* @param {int}                length                                        The blob length.
	* @param {bool}               createNewBlob                                 Specifies whether create a new blob.
	* @param {object}             [options]                                     The request options.
	* @param {bool}               [options.absorbConditionalErrorsOnRetry]      Specifies whether to absorb the conditional error on retry. (For append blob only)
	* @param {string}             [options.blockSize]                           The size of each block. Maximum is 100MB. (For block blob only)
	* @param {string}             [options.blockIdPrefix]                       The prefix to be used to generate the block id. (For block blob only)
	* @param {string}             [options.leaseId]                             The lease identifier.
	* @param {string}             [options.transactionalContentMD5]             The MD5 hash of the blob content. This hash is used to verify the integrity of the blob during transport.
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {int}                [options.parallelOperationThreadCount]        The number of parallel operations that may be performed when uploading.
	* @param {bool}               [options.storeBlobContentMD5]                 Specifies whether the blob's ContentMD5 header should be set on uploads. 
	*                                                                           The default value is false for page blobs and true for block blobs.
	* @param {bool}               [options.useTransactionalMD5]                 Calculate and send/validate content MD5 for transactions.
	* @param {string}             [options.blobTier]                            For page blobs on premium accounts only. Set the tier of the target blob. Refer to BlobUtilities.BlobTier.PremiumPageBlobTier.
	* @param {object}             [options.contentSettings]                     The content settings of the blob.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the blob. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the blob.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The Blob service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The blob's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The blob's MD5 hash.
	* @param {AccessConditions}   [options.accessConditions]                    The access conditions.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResponse}    callback                                      The callback function.
	* @return {Writable}                                                        A Node.js Writable stream.
	*/
	BlobService.prototype._createWriteStreamToBlob = function (container, blob, blobType, length, createNewBlob, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('_createWriteStreamToBlob', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	    v.blobTypeIsValid(blobType);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  var sizeLimitation;
	  if (blobType === BlobConstants.BlobTypes.BLOCK) {
	    // default to true, unless explicitly set to false
	    options.storeBlobContentMD5 = options.storeBlobContentMD5 === false ? false : true;
	    sizeLimitation = options.blockSize || BlobConstants.DEFAULT_WRITE_BLOCK_SIZE_IN_BYTES;
	  } else if (blobType == BlobConstants.BlobTypes.PAGE) {
	    sizeLimitation = BlobConstants.DEFAULT_WRITE_PAGE_SIZE_IN_BYTES;
	  } else if (blobType == BlobConstants.BlobTypes.APPEND) {
	    sizeLimitation = BlobConstants.DEFAULT_WRITE_BLOCK_SIZE_IN_BYTES;
	  }
	
	  var stream = new ChunkStream({ calcContentMd5: options.storeBlobContentMD5 });
	  stream._highWaterMark = sizeLimitation;
	
	  stream.pause(); //Immediately pause the stream in order to wait for the destination to getting ready
	
	  var self = this;
	  var createCallback = function (createError, createBlob, createResponse) {
	    if (createError) {
	      if (callback) {
	        callback(createError, createBlob, createResponse);
	      }
	    } else {
	      self._uploadBlobFromStream(createNewBlob, container, blob, blobType, stream, null, options, function (error, blob, response) {
	        if (error) {
	          stream.emit('error', error);
	        }
	
	        if (callback) {
	          callback(error, blob, response);
	        }
	      });
	    }
	  };
	
	  if (createNewBlob === true) {
	    this._createBlob(container, blob, blobType, length, options, createCallback);
	  } else {
	    createCallback();
	  }
	
	  return stream;
	};
	
	/**
	* Upload blob content from a stream. Assumes the blob already exists.
	*
	* @ignore
	*
	* @this {BlobService}
	* @param {bool}               isNewBlob                                     Specifies whether the blob is newly created.
	* @param {string}             container                                     The container name.
	* @param {string}             blob                                          The blob name.
	* @param {BlobType}           blobType                                      The blob type.
	* @param (Stream)             stream                                        Stream to the data to store.
	* @param {int}                streamLength                                  The length of the stream to upload.
	* @param {object}             [options]                                     The request options.
	* @param {SpeedSummary}       [options.speedSummary]                        The upload tracker objects.
	* @param {bool}               [options.absorbConditionalErrorsOnRetry]      Specifies whether to absorb the conditional error on retry. (For append blob only)
	* @param {string}             [options.blockIdPrefix]                       The prefix to be used to generate the block id. (For block blob only)
	* @param {int}                [options.blockSize]                           The size of each block. Maximum is 100MB. (For block blob only)
	* @param {string}             [options.leaseId]                             The lease identifier.
	* @param {string}             [options.transactionalContentMD5]             The MD5 hash of the blob content. This hash is used to verify the integrity of the blob during transport.
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {int}                [options.parallelOperationThreadCount]        The number of parallel operations that may be performed when uploading.
	* @param {bool}               [options.storeBlobContentMD5]                 Specifies whether the blob's ContentMD5 header should be set on uploads. The default value is true for block blobs.
	* @param {bool}               [options.useTransactionalMD5]                 Calculate and send/validate content MD5 for transactions.
	* @param {object}             [options.contentSettings]                     The content settings of the blob.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the blob. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the blob.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The Blob service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The blob's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The blob's MD5 hash.
	* @param {AccessConditions}   [options.accessConditions]                    The access conditions.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResult}      callback                                      The callback function.
	* @return {SpeedSummary}
	*/
	BlobService.prototype._uploadBlobFromStream = function (isNewBlob, container, blob, blobType, stream, streamLength, optionsOrCallback, callback) {
	  var options;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { options = o; callback = c; });
	  options.speedSummary = options.speedSummary || new SpeedSummary(blob);
	
	  if (blobType === BlobConstants.BlobTypes.BLOCK) {
	    // default to true, unless explicitly set to false
	    options.storeBlobContentMD5 = options.storeBlobContentMD5 === false ? false : true;
	  }
	
	  stream.pause();
	
	  var self = this;
	  var startUpload = function () {
	    var putBlockBlobFromStream = function () {
	      if (streamLength > 0 && azureutil.objectIsNull(azureutil.tryGetValueChain(options, ['contentSettings', 'contentMD5'], null)) && options.storeBlobContentMD5) {
	        azureutil.calculateMD5(stream, Math.min(self.singleBlobPutThresholdInBytes, streamLength), options, function (internalBuff, contentMD5) {
	          azureutil.setObjectInnerPropertyValue(options, ['contentSettings', 'contentMD5'], contentMD5);
	          self._putBlockBlob(container, blob, internalBuff, null, internalBuff.length, options, callback);
	        });
	        stream.resume();
	      } else {
	        // Stream will resume when it has a pipe destination or a 'data' listener
	        self._putBlockBlob(container, blob, null, stream, streamLength, options, callback);
	      }
	    };
	
	    if (streamLength === null || streamLength >= self.singleBlobPutThresholdInBytes || blobType !== BlobConstants.BlobTypes.BLOCK) {
	      var chunkStream = new ChunkStreamWithStream(stream, { calcContentMd5: options.storeBlobContentMD5 });
	      self._uploadContentFromChunkStream(container, blob, blobType, chunkStream, streamLength, options, callback);
	    } else {
	      putBlockBlobFromStream();
	    }
	  };
	
	  if (!isNewBlob) {
	    if (options.storeBlobContentMD5 && blobType !== BlobConstants.BlobTypes.BLOCK) {
	      throw new Error(SR.MD5_NOT_POSSIBLE);
	    }
	
	    if (blobType === BlobConstants.BlobTypes.APPEND || options.accessConditions) {
	      // Do a getBlobProperties right at the beginning for existing blobs and use the user passed in access conditions. 
	      // So any pre-condition failure on the first block (in a strictly single writer scenario) is caught.
	      // This call also helps us get the append position to append to if the user hasn’t specified an access condition.
	      this.getBlobProperties(container, blob, options, function (error, properties, response) {
	        if (error && !(options.accessConditions && options.accessConditions.EtagNonMatch === '*' && response.statusCode === 400)) {
	          callback(error);
	        } else {
	          if (blobType === BlobConstants.BlobTypes.APPEND) {
	            options.appendPosition = properties.contentLength;
	          }
	
	          startUpload();
	        }
	      });
	    } else {
	      startUpload();
	    }
	  } else {
	    startUpload();
	  }
	
	  return options.speedSummary;
	};
	
	/**
	* Upload blob content from a text. Assumes the blob already exists.
	*
	* @ignore
	*
	* @this {BlobService}
	* @param {bool}               isNewBlob                                     Specifies whether the blob is newly created.
	* @param {string}             container                                     The container name.
	* @param {string}             blob                                          The blob name.
	* @param {BlobType}           blobType                                      The blob type.
	* @param (string)             content                                       The blob text, as a string or in a Buffer.
	* @param {object}             [options]                                     The request options.
	* @param {SpeedSummary}       [options.speedSummary]                        The upload tracker objects.
	* @param {bool}               [options.absorbConditionalErrorsOnRetry]      Specifies whether to absorb the conditional error on retry. (For append blob only)
	* @param {string}             [options.blockIdPrefix]                       The prefix to be used to generate the block id. (For block blob only)
	* @param {string}             [options.leaseId]                             The lease identifier.
	* @param {string}             [options.transactionalContentMD5]             The MD5 hash of the blob content. This hash is used to verify the integrity of the blob during transport.
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {int}                [options.parallelOperationThreadCount]        The number of parallel operations that may be performed when uploading.
	* @param {bool}               [options.storeBlobContentMD5]                 Specifies whether the blob's ContentMD5 header should be set on uploads. The default value is true for block blobs.
	* @param {bool}               [options.useTransactionalMD5]                 Calculate and send/validate content MD5 for transactions.
	* @param {object}             [options.contentSettings]                     The content settings of the blob.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the blob. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the blob.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The Blob service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The blob's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The blob's MD5 hash.
	* @param {AccessConditions}   [options.accessConditions]                    The access conditions.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResult}      callback                                      The callback function.
	* @return {SpeedSummary}
	*/
	BlobService.prototype._uploadBlobFromText = function (isNewBlob, container, blob, blobType, content, optionsOrCallback, callback) {
	  var options;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { options = o; callback = c; });
	  options.speedSummary = options.speedSummary || new SpeedSummary(blob);
	  options[HeaderConstants.CONTENT_TYPE] = (options.contentSettings && options.contentSettings.contentType) || 'text/plain;charset="utf-8"';
	
	  var self = this;
	  var startUpload = function () {
	    var operationFunc;
	    var length = azureutil.objectIsNull(content) ? 0 : (Buffer.isBuffer(content) ? content.length : Buffer.byteLength(content));
	
	    if (blobType === BlobConstants.BlobTypes.BLOCK) {
	      // default to true, unless explicitly set to false
	      options.storeBlobContentMD5 = options.storeBlobContentMD5 === false ? false : true;
	      operationFunc = self._putBlockBlob;
	
	      if (length > BlobConstants.MAX_SINGLE_UPLOAD_BLOB_SIZE_IN_BYTES) {
	        throw new RangeError(SR.INVALID_BLOB_LENGTH);
	      }
	    } else if (blobType === BlobConstants.BlobTypes.APPEND) {
	      operationFunc = self._appendBlock;
	
	      if (length > BlobConstants.MAX_APPEND_BLOB_BLOCK_SIZE) {
	        throw new RangeError(SR.INVALID_TEXT_LENGTH);
	      }
	    }
	
	    var finalCallback = function (error, blobResult, response) {
	      if (blobType !== BlobConstants.BlobTypes.BLOCK) {
	        self.setBlobProperties(container, blob, options.contentSettings, options, function (error, blob, response) {
	          blob = extend(false, blob, blobResult);
	          callback(error, blob, response);
	        });
	      } else {
	        callback(error, blobResult, response);
	      }
	    };
	
	    operationFunc.call(self, container, blob, content, null, length, options, finalCallback);
	  };
	
	  if (!isNewBlob) {
	    if (options.storeBlobContentMD5 && blobType !== BlobConstants.BlobTypes.BLOCK) {
	      throw new Error(SR.MD5_NOT_POSSIBLE);
	    }
	
	    if (blobType === BlobConstants.BlobTypes.APPEND || options.accessConditions) {
	      // Do a getBlobProperties right at the beginning for existing blobs and use the user passed in access conditions. 
	      // So any pre-condition failure on the first block (in a strictly single writer scenario) is caught.
	      // This call also helps us get the append position to append to if the user hasn’t specified an access condition.
	      this.getBlobProperties(container, blob, options, function (error, properties) {
	        if (error) {
	          callback(error);
	        } else {
	          if (blobType === BlobConstants.BlobTypes.APPEND) {
	            options.appendPosition = properties.contentLength;
	          }
	
	          startUpload();
	        }
	      });
	    }
	  } else {
	    if (!azureutil.objectIsNull(content) && azureutil.objectIsNull(azureutil.tryGetValueChain(options, ['contentSettings', 'contentMD5'], null)) && options.storeBlobContentMD5) {
	      azureutil.setObjectInnerPropertyValue(options, ['contentSettings', 'contentMD5'], azureutil.getContentMd5(content));
	    }
	    startUpload();
	  }
	};
	
	/**
	* Uploads a block blob from a stream.
	* @ignore
	*
	* @this {BlobService}
	* @param {string}             container                                     The container name.
	* @param {string}             blob                                          The blob name.
	* @param {string}             text                                          The blob text.
	* @param (Stream)             stream                                        Stream to the data to store.
	* @param {int}                length                                        The length of the stream or text to upload.
	* @param {object}             [options]                                     The request options.
	* @param {string}             [options.leaseId]                             The lease identifier.
	* @param {string}             [options.transactionalContentMD5]             The MD5 hash of the blob content. This hash is used to verify the integrity of the blob during transport.
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {bool}               [options.storeBlobContentMD5]                 Specifies whether the blob's ContentMD5 header should be set on uploads. The default value is true for block blobs.
	* @param {object}             [options.contentSettings]                     The content settings of the blob.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the blob. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the blob.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The Blob service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The blob's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The blob's MD5 hash.
	* @param {AccessConditions}   [options.accessConditions]                    The access conditions.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResult}      callback                                      `error` will contain information
	*                                                                           if an error occurs; otherwise `result` will contain
	*                                                                           information about the blob.
	*                                                                           `response` will contain information related to this operation.
	*/
	BlobService.prototype._putBlockBlob = function (container, blob, text, stream, length, options, callback) {
	  if (!options.speedSummary) {
	    options.speedSummary = new SpeedSummary(blob);
	  }
	
	  var speedSummary = options.speedSummary;
	  speedSummary.totalSize = length;
	
	  var resourceName = createResourceName(container, blob);
	  var webResource = WebResource.put(resourceName)
	    .withHeader(HeaderConstants.CONTENT_TYPE, 'application/octet-stream')
	    .withHeader(HeaderConstants.BLOB_TYPE, BlobConstants.BlobTypes.BLOCK)
	    .withHeader(HeaderConstants.CONTENT_LENGTH, length);
	
	  if (!azureutil.objectIsNull(text) && azureutil.objectIsNull(options.transactionalContentMD5) && options.useTransactionalMD5) {
	    options.transactionalContentMD5 = azureutil.getContentMd5(text);
	  }
	
	  BlobResult.setHeadersFromBlob(webResource, options);
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.blobResult = null;
	    if (!responseObject.error) {
	      responseObject.blobResult = new BlobResult(container, blob);
	      responseObject.blobResult.getPropertiesFromHeaders(responseObject.response.headers);
	      if (options.metadata) {
	        responseObject.blobResult.metadata = options.metadata;
	      }
	    }
	
	    var finalCallback = function (returnObject) {
	      if (!returnObject || !returnObject.error) {
	        speedSummary.increment(length);
	      }
	      callback(returnObject.error, returnObject.blobResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  if (!azureutil.objectIsNull(text)) {
	    this.performRequest(webResource, text, options, processResponseCallback);
	  } else {
	    this.performRequestOutputStream(webResource, stream, options, processResponseCallback);
	  }
	
	  return options.speedSummary;
	};
	
	/**
	* Appends a new block to an append blob.
	* 
	* @ignore
	*
	* @this {BlobService}
	* @param {string}             container                                 The container name.
	* @param {string}             blob                                      The blob name.
	* @param {string|buffer}      content                                   The block content.
	* @param (Stream)             stream                                    The stream to the data to store.
	* @param {int}                length                                    The length of the stream or content to upload.
	* @param {object}             [options]                                 The request options.
	* @param {bool}               [options.absorbConditionalErrorsOnRetry]  Specifies whether to absorb the conditional error on retry.
	* @param {int}                [options.maxBlobSize]                     The max length in bytes allowed for the append blob to grow to.
	* @param {int}                [options.appendPosition]                  The number indicating the byte offset to check for. The append will succeed only if the end position of the blob is equal to this number.
	* @param {string}             [options.leaseId]                         The target blob lease identifier.
	* @param {string}             [options.transactionalContentMD5]         The blob’s MD5 hash. This hash is used to verify the integrity of the blob during transport.
	* @param {bool}               [options.useTransactionalMD5]             Calculate and send/validate content MD5 for transactions.
	* @param {AccessConditions}   [options.accessConditions]                The access conditions.
	* @param {LocationMode}       [options.locationMode]                    Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                       Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]             The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]        The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]        The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                       The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                       execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                 A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]               Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                       The default value is false.
	* @param {errorOrResponse}    callback                                  `error` will contain information
	*                                                                       if an error occurs; otherwise 
	*                                                                       `response` will contain information related to this operation.
	*/
	BlobService.prototype._appendBlock = function (container, blob, content, stream, length, options, callback) {
	  var speedSummary = options.speedSummary || new SpeedSummary(blob);
	  speedSummary.totalSize = length;
	
	  var self = this;
	  var startAppendBlock = function () {
	    var resourceName = createResourceName(container, blob);
	
	    var webResource = WebResource.put(resourceName)
	      .withQueryOption(QueryStringConstants.COMP, 'appendblock')
	      .withHeader(HeaderConstants.CONTENT_LENGTH, length)
	      .withHeader(HeaderConstants.BLOB_CONDITION_MAX_SIZE, options.maxBlobSize)
	      .withHeader(HeaderConstants.BLOB_CONDITION_APPEND_POSITION, options.appendPosition);
	
	    BlobResult.setHeadersFromBlob(webResource, options);
	
	    var processResponseCallback = function (responseObject, next) {
	      responseObject.blobResult = null;
	      if (!responseObject.error) {
	        responseObject.blobResult = new BlobResult(container, blob);
	        responseObject.blobResult.getPropertiesFromHeaders(responseObject.response.headers);
	      }
	
	      var finalCallback = function (returnObject) {
	        if (!returnObject || !returnObject.error) {
	          speedSummary.increment(length);
	        }
	        callback(returnObject.error, returnObject.blobResult, returnObject.response);
	      };
	
	      next(responseObject, finalCallback);
	    };
	
	    if (!azureutil.objectIsNull(content)) {
	      self.performRequest(webResource, content, options, processResponseCallback);
	    } else {
	      self.performRequestOutputStream(webResource, stream, options, processResponseCallback);
	    }
	  };
	
	  if (azureutil.objectIsNull(options.transactionalContentMD5) && options.useTransactionalMD5) {
	    if (!azureutil.objectIsNull(content)) {
	      options.transactionalContentMD5 = azureutil.getContentMd5(content);
	      startAppendBlock();
	    } else {
	      azureutil.calculateMD5(stream, length, options, function (internalBuff, contentMD5) {
	        options.transactionalContentMD5 = contentMD5;
	        content = internalBuff;
	        length = internalBuff.length;
	        startAppendBlock();
	      });
	    }
	  } else {
	    startAppendBlock();
	  }
	
	  return options.speedSummary;
	};
	
	/**
	* Creates and dispatches lease requests.
	* @ignore
	* 
	* @this {BlobService}
	* @param {object}             webResource                             The web resource.
	* @param {string}             container                               The container name.
	* @param {string}             blob                                    The blob name.
	* @param {string}             leaseId                                 The lease identifier. Required to renew, change or release the lease.
	* @param {string}             leaseAction                             The lease action (BlobConstants.LeaseOperation.*). Required.
	* @param {object}             userOptions                             The request options.
	* @param {int}                [userOptions.leaseBreakPeriod]          The lease break period.
	* @param {string}             [userOptions.leaseDuration]             The lease duration. Default is never to expire.
	* @param {string}             [userOptions.proposedLeaseId]           The proposed lease identifier. This is required for the CHANGE lease action.
	* @param {LocationMode}       [userOptions.locationMode]              Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                     Please see StorageUtilities.LocationMode for the possible values.
	* @param {AccessConditions}   [options.accessConditions]              The access conditions.
	* @param {int}                [userOptions.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]      The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [userOptions.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                     The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                     execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]               A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]             Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                     The default value is false.
	* @param {Function(error, lease, response)}  callback                 `error` will contain information
	*                                                                     if an error occurs; otherwise `lease` will contain
	*                                                                     the lease information.
	*                                                                     `response` will contain information related to this operation.
	*/
	BlobService.prototype._leaseImpl = function (container, blob, leaseId, leaseAction, options, callback) {
	  var webResource;
	  if (!azureutil.objectIsNull(blob)) {
	    validate.validateArgs('_leaseImpl', function (v) {
	      v.string(blob, 'blob');
	    });
	    var resourceName = createResourceName(container, blob);
	    webResource = WebResource.put(resourceName);
	  } else {
	    webResource = WebResource.put(container)
	      .withQueryOption(QueryStringConstants.RESTYPE, 'container');
	  }
	
	  webResource.withQueryOption(QueryStringConstants.COMP, 'lease')
	    .withHeader(HeaderConstants.LEASE_ID, leaseId)
	    .withHeader(HeaderConstants.LEASE_ACTION, leaseAction.toLowerCase())
	    .withHeader(HeaderConstants.LEASE_BREAK_PERIOD, options.leaseBreakPeriod)
	    .withHeader(HeaderConstants.PROPOSED_LEASE_ID, options.proposedLeaseId)
	    .withHeader(HeaderConstants.LEASE_DURATION, options.leaseDuration);
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.leaseResult = null;
	    if (!responseObject.error) {
	      responseObject.leaseResult = new LeaseResult(container, blob);
	      responseObject.leaseResult.getPropertiesFromHeaders(responseObject.response.headers);
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.leaseResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Updates a page blob from text.
	* @ignore
	*
	* @this {BlobService}
	* @param {string}             container                                   The container name.
	* @param {string}             blob                                        The blob name.
	* @param {string}             text                                        The text string.
	* @param {Readable}           readStream                                  The Node.js Readable stream.
	* @param {int}                rangeStart                                  The range start.
	* @param {int}                rangeEnd                                    The range end.
	* @param {object}             [options]                                   The request options.
	* @param {string}             [options.leaseId]                           The target blob lease identifier.
	* @param {string}             [options.transactionalContentMD5]           An MD5 hash of the page content. This hash is used to verify the integrity of the page during transport. 
	* @param {AccessConditions}   [options.accessConditions]                  The access conditions.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {Function(error, pageBlob, response)}  callback                  `error` will contain information
	*                                                                         if an error occurs; otherwise `pageBlob` will contain
	*                                                                         the blob information.
	*                                                                         `response` will contain information related to this operation.
	*/
	BlobService.prototype._createPages = function (container, blob, text, readStream, rangeStart, rangeEnd, options, callback) {
	  var request = this._updatePageBlobPagesImpl(container, blob, rangeStart, rangeEnd, BlobConstants.PageWriteOptions.UPDATE, options);
	
	  // At this point, we have already validated that the range is less than 4MB. Therefore, we just need to calculate the contentMD5 if required.
	  // Even when this is called from the createPagesFromStream method, it is pre-buffered and called with text.
	  if (!azureutil.objectIsNull(text) && azureutil.objectIsNull(options.transactionalContentMD5) && options.useTransactionalMD5) {
	    request.withHeader(HeaderConstants.CONTENT_MD5, azureutil.getContentMd5(text));
	  }
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.blobResult = null;
	    if (!responseObject.error) {
	      responseObject.blobResult = new BlobResult(container, blob);
	      responseObject.blobResult.getPropertiesFromHeaders(responseObject.response.headers);
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.blobResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  if (!azureutil.objectIsNull(text)) {
	    this.performRequest(request, text, options, processResponseCallback);
	  } else {
	    this.performRequestOutputStream(request, readStream, options, processResponseCallback);
	  }
	};
	
	/**
	* @ignore
	*/
	BlobService.prototype._updatePageBlobPagesImpl = function (container, blob, rangeStart, rangeEnd, writeMethod, options) {
	  if (rangeStart && rangeStart % BlobConstants.PAGE_SIZE !== 0) {
	    throw new RangeError(SR.INVALID_PAGE_START_OFFSET);
	  }
	
	  if (rangeEnd && (rangeEnd + 1) % BlobConstants.PAGE_SIZE !== 0) {
	    throw new RangeError(SR.INVALID_PAGE_END_OFFSET);
	  }
	
	  // this is necessary if this is called from _uploadContentFromChunkStream->_createPages
	  if (!options) {
	    options = {};
	  }
	
	  options.rangeStart = rangeStart;
	  options.rangeEnd = rangeEnd;
	
	  options.contentLength = writeMethod === BlobConstants.PageWriteOptions.UPDATE ? (rangeEnd - rangeStart) + 1 : 0;
	
	  var resourceName = createResourceName(container, blob);
	  var webResource = WebResource.put(resourceName)
	    .withQueryOption(QueryStringConstants.COMP, 'page')
	    .withHeader(HeaderConstants.CONTENT_TYPE, 'application/octet-stream')
	    .withHeader(HeaderConstants.PAGE_WRITE, writeMethod);
	
	  BlobResult.setHeadersFromBlob(webResource, options);
	
	  return webResource;
	};
	
	/**
	* Uploads blob content from a stream.
	* For block blob, it creates a new block to be committed.
	* For page blob, it writes a range of pages.
	* For append blob, it appends a new block.
	*
	* @ignore
	*
	* @this {BlobService}
	* @param {string}             container                                     The container name.
	* @param {string}             blob                                          The blob name.
	* @param {string}             blobType                                      The blob type.
	* @param (Stream)             stream                                        Stream to the data to store.
	* @param {int}                streamLength                                  The length of the stream to upload.
	* @param {object|function}    [options]                                     The request options.
	* @param {SpeedSummary}       [options.speedSummary]                        The download tracker objects;
	* @param {int}                [options.parallelOperationThreadCount]        The number of parallel operations that may be performed when uploading.
	* @param {bool}               [options.absorbConditionalErrorsOnRetry]      Specifies whether to absorb the conditional error on retry. (For append blob only)
	* @param {int}                [options.maxBlobSize]                         The max length in bytes allowed for the append blob to grow to.
	* @param {int}                [options.appendPosition]                      The number indicating the byte offset to check for. The append will succeed only if the end position of the blob is equal to this number.
	* @param {bool}               [options.useTransactionalMD5]                 Calculate and send/validate content MD5 for transactions.
	* @param {string}             [options.blockIdPrefix]                       The prefix to be used to generate the block id. (For block blob only)
	* @param {int}                [options.blockSize]                           The size of each block. Maximum is 100MB. (For block blob only)
	* @param {string}             [options.leaseId]                             The lease identifier.
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {bool}               [options.storeBlobContentMD5]                 Specifies whether the blob's ContentMD5 header should be set on uploads.
	* @param {object}             [options.contentSettings]                     The content settings of the blob.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the blob. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the blob.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The Blob service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The blob's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The blob's MD5 hash.
	* @param {AccessConditions}   [options.accessConditions]                    The access conditions.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {function(error, null)}  callback                                  The callback function.
	* @return {SpeedSummary}
	*/
	
	BlobService.prototype._uploadContentFromChunkStream = function (container, blob, blobType, chunkStream, streamLength, options, callback) {
	  this.logger.debug(util.format('_uploadContentFromChunkStream for blob %s', blob));
	
	  var apiName;
	  var isBlockBlobUpload;
	  var isPageBlobUpload;
	  var isAppendBlobUpload;
	  var sizeLimitation;
	  var originalContentMD5 = azureutil.tryGetValueChain(options, ['contentSettings', 'contentMD5'], null);
	  var parallelOperationThreadCount = options.parallelOperationThreadCount || this.parallelOperationThreadCount;
	
	  if (blobType == BlobConstants.BlobTypes.BLOCK) {
	    apiName = 'createBlockFromText';
	    isBlockBlobUpload = true;
	
	    // BlockBlob can only have 50000 blocks in maximum
	    var minBlockSize = Math.ceil(streamLength / 50000);
	    if (options.blockSize) {
	      if (options.blockSize < minBlockSize) {
	        // options.blockSize is less than the minBlockSize, error callback        
	        var error = new ArgumentError('options.blockSize', util.format('The minimum blockSize is %s and the provided blockSize %s is too small.', minBlockSize, options.blockSize));
	        callback(error);
	        return;
	      } else {
	        sizeLimitation = options.blockSize;
	      }
	    } else {
	      // 4MB minimum for auto-calculated block size
	      sizeLimitation = Math.max(minBlockSize, BlobConstants.DEFAULT_WRITE_BLOCK_SIZE_IN_BYTES);
	    }
	  } else if (blobType == BlobConstants.BlobTypes.PAGE) {
	    apiName = '_createPages';
	    isPageBlobUpload = true;
	    sizeLimitation = BlobConstants.DEFAULT_WRITE_PAGE_SIZE_IN_BYTES;
	  } else if (blobType == BlobConstants.BlobTypes.APPEND) {
	    apiName = 'appendBlockFromText';
	    isAppendBlobUpload = true;
	    parallelOperationThreadCount = 1;
	    sizeLimitation = BlobConstants.DEFAULT_WRITE_BLOCK_SIZE_IN_BYTES;
	  } else {
	    var error = new ArgumentError('blobType', util.format('Unknown blob type %s', blobType));
	    callback(error);
	    return;
	  }
	
	  chunkStream._highWaterMark = sizeLimitation;
	
	  this._setOperationExpiryTime(options);
	
	  // initialize the speed summary
	  var speedSummary = options.speedSummary || new SpeedSummary(blob);
	  speedSummary.totalSize = streamLength;
	
	  // initialize chunk allocator
	  var allocator = new ChunkAllocator(sizeLimitation, parallelOperationThreadCount, { logger: this.logger });
	  chunkStream.setMemoryAllocator(allocator);
	  chunkStream.setOutputLength(streamLength);
	
	  // if this is a FileReadStream, set the allocator on that stream
	  if (chunkStream._stream && chunkStream._stream.setMemoryAllocator) {
	    var fileReadStreamAllocator = new ChunkAllocator(chunkStream._stream._highWaterMark, parallelOperationThreadCount, { logger: this.logger });      
	    chunkStream._stream.setMemoryAllocator(fileReadStreamAllocator);
	  }
	
	  // initialize batch operations
	  var batchOperations = new BatchOperation(apiName, {
	    callInOrder: isAppendBlobUpload,
	    callbackInOrder: isAppendBlobUpload,
	    logger: this.logger,
	    enableReuseSocket: this.defaultEnableReuseSocket,
	    operationMemoryUsage: sizeLimitation
	  });
	  batchOperations.setConcurrency(parallelOperationThreadCount);
	
	  // initialize options
	  var rangeOptions = {
	    leaseId: options.leaseId,
	    timeoutIntervalInMs: options.timeoutIntervalInMs,
	    clientRequestTimeoutInMs: options.clientRequestTimeoutInMs,
	    operationExpiryTime: options.operationExpiryTime,
	    maxBlobSize: options.maxBlobSize,
	    appendPosition: options.appendPosition || 0,
	    initialAppendPosition: options.appendPosition || 0,
	    absorbConditionalErrorsOnRetry: options.absorbConditionalErrorsOnRetry
	  };
	
	  // initialize block blob variables
	  var blockIdPrefix = options.blockIdPrefix || this.generateBlockIdPrefix();
	  var blockCount = 0;
	  var blockIds = [];
	  var blobResult = {};
	
	  var self = this;
	  chunkStream.on('data', function (data, range) {
	    var operation = null;
	    var full = false;
	    var autoIncrement = speedSummary.getAutoIncrementFunction(data.length);
	
	    if (data.length > sizeLimitation) {
	      throw new RangeError(util.format(SR.EXCEEDED_SIZE_LIMITATION, sizeLimitation, data.length));
	    }
	
	    if (options.useTransactionalMD5) {
	      //calculate content md5 for the current uploading block data
	      var contentMD5 = azureutil.getContentMd5(data);
	      rangeOptions.transactionalContentMD5 = contentMD5;
	    }
	
	    var checkLengthLimit = function () {
	      if (!streamLength) return true;
	      if (range.start >= streamLength) {
	        self.logger.debug(util.format('Stop uploading data from %s bytes to %s bytes to blob %s because of limit %s', range.start, range.end, blob, streamLength));
	        chunkStream.stop();
	        return false;
	      } else if (range.end >= streamLength) {
	        self.logger.debug(util.format('Clip uploading data from %s bytes to %s bytes to blob %s because of limit %s', range.start, range.end, blob, streamLength));
	        range.end = streamLength - 1;
	        data = data.slice(0, streamLength - range.start);
	        if (options.useTransactionalMD5) {
	          rangeOptions.transactionalContentMD5 = azureutil.getContentMd5(data);
	        }
	      }
	      return true;
	    };
	
	    var uploadBlockBlobChunk = function () {
	      if (!checkLengthLimit()) return;
	      var blockId = self.getBlockId(blockIdPrefix, blockCount);
	      blockIds.push(blockId);
	
	      operation = new BatchOperation.RestOperation(self, apiName, blockId, container, blob, data, rangeOptions, function (error) {
	        if (!error) {
	          autoIncrement();
	        } else {
	          self.logger.debug(util.format('Stop uploading data as error happens. Error: %s', util.inspect(error)));
	          chunkStream.stop();
	        }
	        allocator.releaseBuffer(data);
	        data = null;
	      });
	
	      blockCount++;
	    };
	
	    var uploadPageBlobChunk = function () {
	      if (!checkLengthLimit()) return;
	
	      if (azureutil.isBufferAllZero(data)) {
	        self.logger.debug(util.format('Skip upload data from %s bytes to %s bytes to blob %s', range.start, range.end, blob));
	        speedSummary.increment(data.length);
	      } else {
	        self.logger.debug(util.format('Upload data from %s bytes to %s bytes to blob %s', range.start, range.end, blob));
	        operation = new BatchOperation.RestOperation(self, apiName, container, blob, data, null, range.start, range.end, rangeOptions, function (error) {
	          if (!error) {
	            autoIncrement();
	          } else {
	            self.logger.debug(util.format('Stop uploading data as error happens. Error: %s', util.inspect(error)));
	            chunkStream.stop();
	          }
	          allocator.releaseBuffer(data);
	          data = null;
	        });
	      }
	    };
	
	    var uploadAppendBlobChunk = function () {
	      if (!checkLengthLimit()) return;
	
	      rangeOptions.appendPosition = Number(rangeOptions.initialAppendPosition) + Number(range.start);
	
	      // We cannot differentiate between max size condition failing only in the retry versus failing in the first attempt and retry.  
	      // So we will eliminate the latter and handle the former in the append operation callback.
	      if (options.maxBlobSize && rangeOptions.appendPosition + data.length > options.maxBlobSize) {
	        throw new Error(SR.MAX_BLOB_SIZE_CONDITION_NOT_MEET);
	      }
	
	      operation = new BatchOperation.RestOperation(self, apiName, container, blob, data, rangeOptions, function (error, currentBlob) {
	        if (!error) {
	          autoIncrement();
	        } else {
	          self.logger.debug(util.format('Stop uploading data as error happens. Error: %s', util.inspect(error)));
	          chunkStream.stop();
	        }
	        blobResult = currentBlob;
	        allocator.releaseBuffer(data);
	        data = null;
	      });
	    };
	
	    if (isBlockBlobUpload) {
	      uploadBlockBlobChunk();
	    } else if (isAppendBlobUpload) {
	      uploadAppendBlobChunk();
	    } else if (isPageBlobUpload) {
	      uploadPageBlobChunk();
	    }
	
	    if (operation) {
	      full = batchOperations.addOperation(operation);
	      operation = null;
	
	      if (full) {
	        self.logger.debug('File stream paused');
	        chunkStream.pause();
	      }
	    }
	  });
	
	  chunkStream.on('end', function () {
	    self.logger.debug(util.format('File read stream ended for blob %s', blob));
	    batchOperations.enableComplete();
	  });
	
	  batchOperations.on('drain', function () {
	    self.logger.debug('file stream resume');
	    chunkStream.resume();
	  });
	
	  batchOperations.on('end', function (error) {
	    self.logger.debug('batch operations commited');
	
	    speedSummary = null;
	    if (error) {
	      callback(error);
	      return;
	    }
	
	    if (originalContentMD5) {
	      options.contentSettings.contentMD5 = originalContentMD5;
	    } else if (options.storeBlobContentMD5) {
	      var contentMD5 = chunkStream.getContentMd5('base64');
	      azureutil.setObjectInnerPropertyValue(options, ['contentSettings', 'contentMD5'], contentMD5);
	    }
	
	    if (isBlockBlobUpload) {
	      //commit block list
	      var blockList = { 'UncommittedBlocks': blockIds };
	      self.commitBlocks(container, blob, blockList, options, function (error, blockList, response) {
	        self.logger.debug(util.format('Blob %s committed', blob));
	
	        if (error) {
	          chunkStream.finish();
	
	          callback(error);
	        } else {
	          blobResult['commmittedBlocks'] = blockIds;
	
	          chunkStream.finish();
	          callback(error, blobResult, response);
	        }
	      });
	    } else {
	      // upload page blob or append blob completely
	      var blobProperties = options.contentSettings;
	      self.setBlobProperties(container, blob, blobProperties, function (error, blob, response) {
	        chunkStream.finish();
	        blob = extend(false, blob, blobResult);
	        callback(error, blob, response);
	      });
	    }
	  });
	
	  return speedSummary;
	};
	
	/**
	* Checks whether or not a container exists on the service.
	* @ignore
	*
	* @this {BlobService}
	* @param {string}             container                                         The container name.
	* @param {string}             primaryOnly                                       If true, the request will be executed against the primary storage location.
	* @param {object}             [options]                                         The request options.
	* @param {string}             [options.leaseId]                                 The lease identifier.
	* @param {LocationMode}       [options.locationMode]                            Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                               Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                     The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]                The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]                The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                               The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                               execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                         A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                       Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                               The default value is false.
	* @param {Function(error, result, response)}  callback                          `error` will contain information
	*                                                                               if an error occurs; otherwise `result` will contain
	*                                                                               the container information including `exists` boolean member. 
	*                                                                               `response` will contain information related to this operation.
	*/
	BlobService.prototype._doesContainerExist = function (container, primaryOnly, options, callback) {
	  var webResource = WebResource.head(container)
	    .withQueryOption(QueryStringConstants.RESTYPE, 'container')
	    .withHeader(HeaderConstants.LEASE_ID, options.leaseId);
	
	  if (primaryOnly === false) {
	    options.requestLocationMode = RequestLocationMode.PRIMARY_OR_SECONDARY;
	  }
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.containerResult = new ContainerResult(container);
	    if (!responseObject.error) {
	      responseObject.containerResult.exists = true;
	      responseObject.containerResult.getPropertiesFromHeaders(responseObject.response.headers);
	
	    } else if (responseObject.error && responseObject.error.statusCode === Constants.HttpConstants.HttpResponseCodes.NotFound) {
	      responseObject.error = null;
	      responseObject.containerResult.exists = false;
	      responseObject.response.isSuccessful = true;
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.containerResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Checks whether or not a blob exists on the service.
	* @ignore
	*
	* @this {BlobService}
	* @param {string}             container                                         The container name.
	* @param {string}             blob                                              The blob name.
	* @param {string}             primaryOnly                                       If true, the request will be executed against the primary storage location.
	* @param {object}             [options]                                         The request options.
	* @param {string}             [options.snapshotId]                              The snapshot identifier.
	* @param {string}             [options.leaseId]                                 The lease identifier.
	* @param {LocationMode}       [options.locationMode]                            Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                               Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                     The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]                The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]                The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                               The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                               execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                         A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                       Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                               The default value is false.
	* @param {Function(error, result, response)}  callback                          `error` will contain information
	*                                                                               if an error occurs; otherwise `result` will contain 
	*                                                                               the blob information including `exists` boolean member. 
	*                                                                               `response` will contain information related to this operation.
	*/
	BlobService.prototype._doesBlobExist = function (container, blob, primaryOnly, options, callback) {
	  var resourceName = createResourceName(container, blob);
	  var webResource = WebResource.head(resourceName)
	    .withQueryOption(QueryStringConstants.SNAPSHOT, options.snapshotId)
	    .withHeader(HeaderConstants.LEASE_ID, options.leaseId);
	
	  if (primaryOnly === false) {
	    options.requestLocationMode = RequestLocationMode.PRIMARY_OR_SECONDARY;
	  }
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.blobResult = new BlobResult(container, blob);
	    if (!responseObject.error) {
	      responseObject.blobResult.exists = true;
	      responseObject.blobResult.getPropertiesFromHeaders(responseObject.response.headers);
	
	    } else if (responseObject.error && responseObject.error.statusCode === Constants.HttpConstants.HttpResponseCodes.NotFound) {
	      responseObject.error = null;
	      responseObject.blobResult.exists = false;
	      responseObject.response.isSuccessful = true;
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.blobResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* @ignore
	*/
	BlobService.prototype._setBlobPropertiesHelper = function (settings) {
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.blobResult = null;
	    if (!responseObject.error) {
	      responseObject.blobResult = new BlobResult(settings.container, settings.blob);
	      responseObject.blobResult.getPropertiesFromHeaders(responseObject.response.headers);
	    }
	
	    var finalCallback = function (returnObject) {
	      settings.callback(returnObject.error, returnObject.blobResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(settings.webResource, null, settings.options, processResponseCallback);
	};
	
	/**
	* @ignore
	*/
	BlobService.prototype._validateLengthAndMD5 = function (options, responseObject) {
	  var storedMD5 = responseObject.response.headers[Constants.HeaderConstants.CONTENT_MD5];
	  var contentLength;
	
	  if (!azureutil.objectIsNull(responseObject.response.headers[Constants.HeaderConstants.CONTENT_LENGTH])) {
	    contentLength = parseInt(responseObject.response.headers[Constants.HeaderConstants.CONTENT_LENGTH], 10);
	  }
	
	  // If the user has not specified this option, the default value should be false.
	  if (azureutil.objectIsNull(options.disableContentMD5Validation)) {
	    options.disableContentMD5Validation = false;
	  }
	
	  // None of the below cases should be retried. So set the error in every case so the retry policy filter handle knows that it shouldn't be retried.
	  if (options.disableContentMD5Validation === false && options.useTransactionalMD5 === true && azureutil.objectIsNull(storedMD5)) {
	    responseObject.error = new StorageError(SR.MD5_NOT_PRESENT_ERROR);
	    responseObject.retryable = false;
	  }
	
	  // Validate length and if required, MD5.
	  // If getBlobToText called this method, then the responseObject.length and responseObject.contentMD5 are not set. Calculate them first using responseObject.response.body and then validate.
	  if (azureutil.objectIsNull(responseObject.length)) {
	    if (typeof responseObject.response.body == 'string') {
	      responseObject.length = Buffer.byteLength(responseObject.response.body);
	    } else if (Buffer.isBuffer(responseObject.response.body)) {
	      responseObject.length = responseObject.response.body.length;
	    }
	  }
	
	  if (!azureutil.objectIsNull(contentLength) && responseObject.length !== contentLength) {
	    responseObject.error = new Error(SR.CONTENT_LENGTH_MISMATCH);
	    responseObject.retryable = false;
	  }
	
	  if (options.disableContentMD5Validation === false && azureutil.objectIsNull(responseObject.contentMD5)) {
	    responseObject.contentMD5 = azureutil.getContentMd5(responseObject.response.body);
	  }
	
	  if (options.disableContentMD5Validation === false && !azureutil.objectIsNull(storedMD5) && storedMD5 !== responseObject.contentMD5) {
	    responseObject.error = new Error(util.format(SR.HASH_MISMATCH, storedMD5, responseObject.contentMD5));
	    responseObject.retryable = false;
	  }
	};
	
	/**
	* @ignore
	*/
	BlobService.prototype._setRangeContentMD5Header = function (webResource, options) {
	  if (!azureutil.objectIsNull(options.rangeStart) && options.useTransactionalMD5) {
	    if (azureutil.objectIsNull(options.rangeEnd)) {
	      throw new ArgumentNullError('options.rangeEndHeader', util.format(SR.ARGUMENT_NULL_OR_EMPTY, options.rangeEndHeader));
	    }
	
	    var size = parseInt(options.rangeEnd, 10) - parseInt(options.rangeStart, 10) + 1;
	    if (size > BlobConstants.MAX_RANGE_GET_SIZE_WITH_MD5) {
	      throw new ArgumentError('options', SR.INVALID_RANGE_FOR_MD5);
	    } else {
	      webResource.withHeader(HeaderConstants.RANGE_GET_CONTENT_MD5, 'true');
	    }
	  }
	};
	
	/**
	* Downloads a blockblob, pageblob or appendblob into a range stream.
	* @ignore
	* @this {BlobService}
	* @param {string}             container                                   The container name.
	* @param {string}             blob                                        The blob name.
	* @param {string}             blobType                                    The type of blob to download: block blob, page blob or append blob.
	* @param {Writable}           writeStream                                 The Node.js Writable stream.
	* @param {object}             [options]                                   The request options.
	* @param {SpeedSummary}       [options.speedSummary]                      The download tracker objects.
	* @param {int}                [options.parallelOperationThreadCount]      The number of parallel operations that may be performed when uploading.
	* @param {string}             [options.snapshotId]                        The snapshot identifier.
	* @param {string}             [options.leaseId]                           The lease identifier.
	* @param {string}             [options.rangeStart]                        Return only the bytes of the blob in the specified range.
	* @param {string}             [options.rangeEnd]                          Return only the bytes of the blob in the specified range.
	* @param {AccessConditions}   [options.accessConditions]                  The access conditions.
	* @param {boolean}            [options.useTransactionalMD5]               When set to true, Calculate and send/validate content MD5 for transactions.
	* @param {boolean}            [options.disableContentMD5Validation]       When set to true, MD5 validation will be disabled when downloading blobs.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information if an error occurs; 
	*                                                                         otherwise `result` will contain the blob information.
	*                                                                         `response` will contain information related to this operation.
	* @return {SpeedSummary}
	*/
	BlobService.prototype._getBlobToRangeStream = function (container, blob, blobType, writeStream, optionsOrCallback, callback) {
	  var options;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { options = o; callback = c; });
	
	  validate.validateArgs('_getBlobToRangeStream', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	    v.blobNameIsValid(container, blob);
	    v.blobTypeIsValid(blobType);
	    v.callback(callback);
	  });
	
	  var rangeStream = null;
	  var isPageBlobDownload = true;
	
	  if (blobType == BlobConstants.BlobTypes.PAGE) {
	    rangeStream = new PageRangeStream(this, container, blob, options);
	  } else if (blobType == BlobConstants.BlobTypes.APPEND) {
	    rangeStream = new RangeStream(this, container, blob, options);
	    isPageBlobDownload = false;
	  } else if (blobType == BlobConstants.BlobTypes.BLOCK) {
	    rangeStream = new BlockRangeStream(this, container, blob, options);
	    isPageBlobDownload = false;
	  }
	
	  if (!options.speedSummary) {
	    options.speedSummary = new SpeedSummary(blob);
	  }
	
	  var speedSummary = options.speedSummary;
	  var parallelOperationThreadCount = options.parallelOperationThreadCount || this.parallelOperationThreadCount;
	  var batchOperations = new BatchOperation('getBlobInRanges', { callbackInOrder: true, logger: this.logger, enableReuseSocket: this.defaultEnableReuseSocket });
	  batchOperations.setConcurrency(parallelOperationThreadCount);
	
	  var self = this;
	  var checkMD5sum = !options.disableContentMD5Validation;
	  var md5Hash = null;
	  if (checkMD5sum) {
	    md5Hash = new Md5Wrapper().createMd5Hash();
	  }
	
	  var savedBlobResult = null;
	  var savedBlobResponse = null;
	
	  rangeStream.on('range', function (range) {
	    if (!speedSummary.totalSize) {
	      speedSummary.totalSize = rangeStream.rangeSize;
	    }
	
	    var requestOptions = {
	      rangeStart: range.start,
	      rangeEnd: range.end,
	      responseEncoding: null //Use Buffer to store the response data
	    };
	
	    var rangeSize = range.size;
	    requestOptions.timeoutIntervalInMs = options.timeoutIntervalInMs;
	    requestOptions.clientRequestTimeoutInMs = options.clientRequestTimeoutInMs;
	    requestOptions.useTransactionalMD5 = options.useTransactionalMD5;
	    requestOptions.snapshotId = options.snapshotId;
	
	    if (range.dataSize === 0) {
	      if (isPageBlobDownload) {
	        var autoIncrement = speedSummary.getAutoIncrementFunction(rangeSize);
	        //No operation to do and only wait for write zero to file in callback
	        var writeZeroOperation = new BatchOperation.CommonOperation(BatchOperation.noOperation, function (error) {
	          if (error) return;
	          var bufferAvailable = azureutil.writeZerosToStream(writeStream, rangeSize, md5Hash, autoIncrement);
	          //There is no need to pause the rangestream since we can perform http request and write disk at the same time
	          self.logger.debug(util.format('Write %s bytes Zero from %s to %s', rangeSize, range.start, range.end));
	          if (!bufferAvailable) {
	            self.logger.debug('Write stream is full and pause batch operation');
	            batchOperations.pause();
	          }
	        });
	        batchOperations.addOperation(writeZeroOperation);
	      } else {
	        self.logger.debug(util.format('Can not read %s bytes to %s bytes of blob %s', range.start, range.end, blob));
	      }
	      return;
	    }
	
	    if (range.start > range.end) {
	      return;
	    }
	
	    var operation = new BatchOperation.RestOperation(self, 'getBlobToText', container, blob, requestOptions, function (error, content, blobResult, response) {
	      if (!error) {
	        if (rangeSize !== content.length) {
	          self.logger.warn(util.format('Request %s bytes, but server returns %s bytes', rangeSize, content.length));
	        }
	        //Save one of the succeeded callback parameters and use them at the final callback
	        if (!savedBlobResult) {
	          savedBlobResult = blobResult;
	        }
	        if (!savedBlobResponse) {
	          savedBlobResponse = response;
	        }
	        var autoIncrement = speedSummary.getAutoIncrementFunction(content.length);
	        var bufferAvailable = writeStream.write(content, autoIncrement);
	        if (!bufferAvailable) {
	          self.logger.debug('Write stream is full and pause batch operation');
	          batchOperations.pause();
	        }
	        if (md5Hash) {
	          md5Hash.update(content);
	        }
	        content = null;
	      } else {
	        self.logger.debug(util.format('Stop downloading data as error happens. Error: %s', util.inspect(error)));
	        rangeStream.stop();
	      }
	    });
	
	    var full = batchOperations.addOperation(operation);
	    if (full) {
	      self.logger.debug('Pause range stream');
	      rangeStream.pause();
	    }
	  });
	
	  rangeStream.on('end', function () {
	    self.logger.debug('Range stream has ended.');
	    batchOperations.enableComplete();
	  });
	
	  batchOperations.on('drain', function () {
	    self.logger.debug('Resume range stream');
	    rangeStream.resume();
	  });
	
	  writeStream.on('drain', function () {
	    self.logger.debug('Resume batch operations');
	    batchOperations.resume();
	  });
	
	  batchOperations.on('end', function (error) {
	    self.logger.debug('Download completed!');
	    if (error) {
	      callback(error);
	      return;
	    } else {
	      writeStream.end(function () {
	        self.logger.debug('Write stream has ended');
	        if (!savedBlobResult) {
	          savedBlobResult = {};
	        }
	
	        azureutil.setObjectInnerPropertyValue(savedBlobResult, ['contentSettings', 'contentMD5'], azureutil.tryGetValueChain(options, ['contentSettings', 'contentMD5'], null));
	        savedBlobResult.clientSideContentMD5 = null;
	        if (md5Hash) {
	          savedBlobResult.clientSideContentMD5 = md5Hash.digest('base64');
	        }
	        callback(error, savedBlobResult, savedBlobResponse);
	      });
	    }
	  });
	
	  var listOptions = {
	    timeoutIntervalInMs: options.timeoutIntervalInMs,
	    clientRequestTimeoutInMs: options.clientRequestTimeoutInMs,
	    snapshotId: options.snapshotId,
	    leaseId: options.leaseId,
	    blockListFilter: BlobUtilities.BlockListFilter.COMMITTED
	  };
	
	  rangeStream.list(listOptions, function (error) {
	    callback(error);
	  });
	
	  return speedSummary;
	};
	
	/**
	* Downloads a blockblob or pageblob into a stream.
	* @ignore
	* @this {BlobService}
	* @param {string}             container                                   The container name.
	* @param {string}             blob                                        The blob name.
	* @param {Writable}           writeStream                                 The Node.js Writable stream.
	* @param {object}             [options]                                   The request options.
	* @param {string}             [options.snapshotId]                        The snapshot identifier.
	* @param {string}             [options.leaseId]                           The lease identifier.
	* @param {string}             [options.rangeStart]                        Return only the bytes of the blob in the specified range.
	* @param {string}             [options.rangeEnd]                          Return only the bytes of the blob in the specified range.
	* @param {AccessConditions}   [options.accessConditions]                  The access conditions.
	* @param {boolean}            [options.useTransactionalMD5]               When set to true, Calculate and send/validate content MD5 for transactions.
	* @param {boolean}            [options.disableContentMD5Validation]       When set to true, MD5 validation will be disabled when downloading blobs.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information if an error occurs; 
	*                                                                         otherwise `result` will contain the blob information.
	*                                                                         `response` will contain information related to this operation.
	*/
	BlobService.prototype._getBlobToStream = function (container, blob, writeStream, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  var resourceName = createResourceName(container, blob);
	  var webResource = WebResource.get(resourceName).withRawResponse();
	
	  var options = extend(true, {}, userOptions);
	  webResource.withQueryOption(QueryStringConstants.SNAPSHOT, options.snapshotId);
	
	  BlobResult.setHeadersFromBlob(webResource, options);
	
	  this._setRangeContentMD5Header(webResource, options);
	
	  var self = this;
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.blobResult = null;
	
	    if (!responseObject.error) {
	      responseObject.blobResult = new BlobResult(container, blob);
	      responseObject.blobResult.metadata = self.parseMetadataHeaders(responseObject.response.headers);
	      responseObject.blobResult.getPropertiesFromHeaders(responseObject.response.headers);
	
	      self._validateLengthAndMD5(options, responseObject);
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.blobResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequestInputStream(webResource, null, writeStream, options, processResponseCallback);
	};
	
	/**
	* Lists a segment containing a collection of blob items whose names begin with the specified prefix in the container.
	* @ignore
	* @this {BlobService}
	* @param {string}             container                           The container name.
	* @param {string}             prefix                              The prefix of the blob name.
	* @param {object}             currentToken                        A continuation token returned by a previous listing operation. Please use 'null' or 'undefined' if this is the first operation.
	* @param {ListBlobTypes}      listBlobType                        Specifies the item type of the results.
	* @param {object}             [options]                           The request options.
	* @param {int}                [options.maxResults]                Specifies the maximum number of blobs to return per call to Azure ServiceClient. This does NOT affect list size returned by this function. (maximum: 5000)
	* @param {string}             [options.include]                   Specifies that the response should include one or more of the following subsets: '', 'metadata', 'snapshots', 'uncommittedblobs', 'copy', 'deleted').
	*                                                                 Please find these values in BlobUtilities.BlobListingDetails. Multiple values can be added separated with a comma (,).
	* @param {LocationMode}       [options.locationMode]              Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                 Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                 The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                 execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]           A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]         Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                 The default value is false.
	* @param {errorOrResult}      callback                            `error` will contain information
	*                                                                 if an error occurs; otherwise `result` will contain
	*                                                                 the entries of blobs and the continuation token for the next listing operation.
	*                                                                 `response` will contain information related to this operation.
	*/
	BlobService.prototype._listBlobsOrDircotriesSegmentedWithPrefix = function (container, prefix, currentToken, listBlobType, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('listBlobsSegmented', function (v) {
	    v.string(container, 'container');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.get(container)
	    .withQueryOption(QueryStringConstants.RESTYPE, 'container')
	    .withQueryOption(QueryStringConstants.COMP, 'list')
	    .withQueryOption(QueryStringConstants.MAX_RESULTS, options.maxResults)
	    .withQueryOptions(options,
	    QueryStringConstants.DELIMITER,
	    QueryStringConstants.INCLUDE);
	
	  if (!azureutil.objectIsNull(currentToken)) {
	    webResource.withQueryOption(QueryStringConstants.MARKER, currentToken.nextMarker);
	  }
	
	  webResource.withQueryOption(QueryStringConstants.PREFIX, prefix);
	
	  options.requestLocationMode = azureutil.getNextListingLocationMode(currentToken);
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.listBlobsResult = null;
	    if (!responseObject.error) {
	      responseObject.listBlobsResult = {
	        entries: null,
	        continuationToken: null
	      };
	
	      responseObject.listBlobsResult.entries = [];
	      var results = [];
	
	      if (listBlobType == BlobConstants.ListBlobTypes.Directory && responseObject.response.body.EnumerationResults.Blobs.BlobPrefix) {
	        results = responseObject.response.body.EnumerationResults.Blobs.BlobPrefix;
	        if (!_.isArray(results)) {
	          results = [results];
	        }
	      } else if (listBlobType == BlobConstants.ListBlobTypes.Blob && responseObject.response.body.EnumerationResults.Blobs.Blob) {
	        results = responseObject.response.body.EnumerationResults.Blobs.Blob;
	        if (!_.isArray(results)) {
	          results = [results];
	        }
	      }
	
	      results.forEach(function (currentBlob) {
	        var blobResult = BlobResult.parse(currentBlob);
	        responseObject.listBlobsResult.entries.push(blobResult);
	      });
	
	      if (responseObject.response.body.EnumerationResults.NextMarker) {
	        responseObject.listBlobsResult.continuationToken = {
	          nextMarker: null,
	          targetLocation: null
	        };
	
	        responseObject.listBlobsResult.continuationToken.nextMarker = responseObject.response.body.EnumerationResults.NextMarker;
	        responseObject.listBlobsResult.continuationToken.targetLocation = responseObject.targetLocation;
	      }
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.listBlobsResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Create a new blob.
	* @ignore
	* 
	* @this {BlobService}
	* @param {string}             container                                The container name.
	* @param {string}             blob                                     The blob name.
	* @param {BlobType}           blobType                                 The blob type.
	* @param {int}                size                                     The blob size. 
	* @param {object}             [options]                                The request options.
	* @param {string}             [options.blobTier]                       For page blobs on premium accounts only. Set the tier of the target blob. Refer to BlobUtilities.BlobTier.PremiumPageBlobTier.
	* @param {errorOrResult}      callback                                 The callback which operates on the specific blob.
	*/
	BlobService.prototype._createBlob = function (container, blob, blobType, size, options, creationCallback) {
	  if (blobType == BlobConstants.BlobTypes.APPEND) {
	    this.createOrReplaceAppendBlob(container, blob, options, function (createError, createResponse) {
	      creationCallback(createError, null, createResponse);
	    });
	  } else if (blobType == BlobConstants.BlobTypes.PAGE) {
	    this.createPageBlob(container, blob, size, options, function (createError) {
	      creationCallback(createError);
	    });
	  } else if (blobType == BlobConstants.BlobTypes.BLOCK) {
	    creationCallback();
	  }
	};
	
	/**
	* The callback for {BlobService~getBlobToText}.
	* @typedef {function} BlobService~blobToText
	* @param {object} error      If an error occurs, the error information.
	* @param {string} text       The text returned from the blob.
	* @param {object} blockBlob  Information about the blob.
	* @param {object} response   Information related to this operation.
	*/
	
	BlobService.SpeedSummary = SpeedSummary;
	
	module.exports = BlobService;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Module dependencies.
	var azureCommon = __webpack_require__(78);
	var BlobService = __webpack_require__(285);
	var extend = __webpack_require__(26);
	var fs = __webpack_require__(92);
	var mime = __webpack_require__(343);
	
	var azureutil = azureCommon.util;
	var Constants = azureCommon.Constants;
	var FileReadStream = azureCommon.FileReadStream;
	var SpeedSummary = azureCommon.SpeedSummary;
	var validate = azureCommon.validate;
	var BlobConstants = Constants.BlobConstants;
	
	/**
	* Downloads a blob into a file.
	* (Not available in the JavaScript Client Library for Browsers)
	*
	* @this {BlobService}
	* @param {string}             container                                   The container name.
	* @param {string}             blob                                        The blob name.
	* @param {string}             localFileName                               The local path to the file to be downloaded.
	* @param {object}             [options]                                   The request options.
	* @param {boolean}            [options.skipSizeCheck]                     Skip the size check to perform direct download.
	*                                                                         Set the option to true for small blobs.
	*                                                                         Parallel download and speed summary won't work with this option on.
	* @param {SpeedSummary}       [options.speedSummary]                      The download tracker objects.
	* @param {int}                [options.parallelOperationThreadCount]      The number of parallel operations that may be performed when uploading.
	* @param {string}             [options.snapshotId]                        The snapshot identifier.
	* @param {string}             [options.leaseId]                           The lease identifier.
	* @param {string}             [options.rangeStart]                        Return only the bytes of the blob in the specified range.
	* @param {string}             [options.rangeEnd]                          Return only the bytes of the blob in the specified range.
	* @param {AccessConditions}   [options.accessConditions]                  The access conditions.
	* @param {boolean}            [options.useTransactionalMD5]               When set to true, Calculate and send/validate content MD5 for transactions.
	* @param {boolean}            [options.disableContentMD5Validation]       When set to true, MD5 validation will be disabled when downloading blobs.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information if an error occurs; 
	*                                                                         otherwise `[result]{@link BlobResult}` will contain the blob information.
	*                                                                         `response` will contain information related to this operation.
	* @return {SpeedSummary}
	* 
	* @example
	* var azure = require('azure-storage');
	* var blobService = azure.createBlobService();
	* blobService.getBlobToLocalFile('taskcontainer', 'task1', 'task1-download.txt', function(error, serverBlob) {
	*   if(!error) {
	*     // Blob available in serverBlob.blob variable
	*   }
	*/
	BlobService.prototype.getBlobToLocalFile = function (container, blob, localFileName, optionsOrCallback, callback) {
	  var options;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { options = o; callback = c; });
	
	  validate.validateArgs('getBlobToLocalFile', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.string(localFileName, 'localFileName');
	    v.containerNameIsValid(container);
	    v.callback(callback);
	  });
	  
	  return this._getBlobToLocalFile(container, blob, localFileName, options, callback);
	};
	
	/**
	* Uploads a page blob from file. If the blob already exists on the service, it will be overwritten.
	* To avoid overwriting and instead throw an error if the blob exists, please pass in an accessConditions parameter in the options object.
	* (Not available in the JavaScript Client Library for Browsers)
	*
	* @this {BlobService}
	* @param {string}             container                                           The container name.
	* @param {string}             blob                                                The blob name.
	* @param {string}             localFileName                                       The local path to the file to be uploaded.
	* @param {object}             [options]                                           The request options.
	* @param {SpeedSummary}       [options.speedSummary]                              The upload tracker objects.
	* @param {int}                [options.parallelOperationThreadCount]              The number of parallel operations that may be performed when uploading.
	* @param {string}             [options.leaseId]                                   The lease identifier.
	* @param {string}             [options.transactionalContentMD5]                   An MD5 hash of the blob content. This hash is used to verify the integrity of the blob during transport.
	* @param {object}             [options.metadata]                                  The metadata key/value pairs.
	* @param {bool}               [options.storeBlobContentMD5]                       Specifies whether the blob's ContentMD5 header should be set on uploads. 
	*                                                                                 The default value is false for page blobs.
	* @param {bool}               [options.useTransactionalMD5]                       Calculate and send/validate content MD5 for transactions.
	* @param {string}             [options.blobTier]                                  For page blobs on premium accounts only. Set the tier of the target blob. Refer to BlobUtilities.BlobTier.PremiumPageBlobTier.
	* @param {object}             [options.contentSettings]                           The content settings of the blob.
	* @param {string}             [options.contentSettings.contentType]               The MIME content type of the blob. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]           The content encodings that have been applied to the blob.
	* @param {string}             [options.contentSettings.contentLanguage]           The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]              The Blob service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]        The blob's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]                The blob's MD5 hash.
	* @param {AccessConditions}   [options.accessConditions]                          The access conditions.
	* @param {LocationMode}       [options.locationMode]                              Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                                 Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]                  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]                  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                                 The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                                 execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                           A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                         Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                                 The default value is false.
	* @param {errorOrResult}      callback                                            `error` will contain information
	*                                                                                 if an error occurs; otherwise `[result]{@link BlobResult}` will contain
	*                                                                                 the blob information.
	*                                                                                 `response` will contain information related to this operation.
	* @return {SpeedSummary}
	*/
	BlobService.prototype.createPageBlobFromLocalFile = function (container, blob, localFileName, optionsOrCallback, callback) {
	  return this._createBlobFromLocalFile(container, blob, BlobConstants.BlobTypes.PAGE, localFileName, optionsOrCallback, callback);
	};
	
	/**
	* Creates a new block blob. If the blob already exists on the service, it will be overwritten.
	* To avoid overwriting and instead throw an error if the blob exists, please pass in an accessConditions parameter in the options object.
	* (Not available in the JavaScript Client Library for Browsers)
	*
	* @this {BlobService}
	* @param {string}             container                                     The container name.
	* @param {string}             blob                                          The blob name.
	* @param {string}             localFileName                                 The local path to the file to be uploaded.
	* @param {object}             [options]                                     The request options.
	* @param {int}                [options.blockSize]                           The size of each block. Maximum is 100MB.
	* @param {string}             [options.blockIdPrefix]                       The prefix to be used to generate the block id.
	* @param {string}             [options.leaseId]                             The lease identifier.
	* @param {string}             [options.transactionalContentMD5]             The MD5 hash of the blob content. This hash is used to verify the integrity of the blob during transport.
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {int}                [options.parallelOperationThreadCount]        The number of parallel operations that may be performed when uploading.
	* @param {bool}               [options.storeBlobContentMD5]                 Specifies whether the blob's ContentMD5 header should be set on uploads. The default value is true for block blobs.
	* @param {object}             [options.contentSettings]                     The content settings of the blob.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the blob. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the blob.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The Blob service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The blob's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The blob's MD5 hash.
	* @param {AccessConditions}   [options.accessConditions]                    The access conditions.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResult}      callback                                      `error` will contain information
	*                                                                           if an error occurs; otherwise `[result]{@link BlobResult}` will contain
	*                                                                           the blob information.
	*                                                                           `response` will contain information related to this operation.
	* @return {SpeedSummary}
	*/
	BlobService.prototype.createBlockBlobFromLocalFile = function (container, blob, localFileName, optionsOrCallback, callback) {
	  return this._createBlobFromLocalFile(container, blob, BlobConstants.BlobTypes.BLOCK, localFileName, optionsOrCallback, callback);
	};
	
	/**
	* Creates a new append blob from a local file. If the blob already exists on the service, it will be overwritten.
	* To avoid overwriting and instead throw an error if the blob exists, please pass in an accessConditions parameter in the options object.
	* This API should be used strictly in a single writer scenario because the API internally uses the append-offset conditional header to avoid duplicate blocks.
	* If you are guaranteed to have a single writer scenario, please look at options.absorbConditionalErrorsOnRetry and see if setting this flag to true is acceptable for you.
	* If you want to append data to an already existing blob, please look at appendFromLocalFile.
	* (Not available in the JavaScript Client Library for Browsers)
	*
	* @this {BlobService}
	* @param {string}             container                                     The container name.
	* @param {string}             blob                                          The blob name.
	* @param {string}             localFileName                                 The local path to the file to be uploaded.
	* @param {object}             [options]                                     The request options.
	* @param {bool}               [options.absorbConditionalErrorsOnRetry]      Specifies whether to absorb the conditional error on retry.
	* @param {string}             [options.leaseId]                             The lease identifier. 
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {bool}               [options.storeBlobContentMD5]                 Specifies whether the blob's ContentMD5 header should be set on uploads. The default value is true for block blobs.
	* @param {bool}               [options.useTransactionalMD5]                 Calculate and send/validate content MD5 for transactions.
	* @param {object}             [options.contentSettings]                     The content settings of the blob.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the blob. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the blob.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The Blob service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The blob's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The blob's MD5 ahash.
	* @param {AccessConditions}   [options.accessConditions]                    The access conditions.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResult}      callback                                      `error` will contain information
	*                                                                           if an error occurs; otherwise `[result]{@link BlobResult}` will contain
	*                                                                           the blob information.
	*                                                                           `response` will contain information related to this operation.
	* @return {SpeedSummary}
	*/
	BlobService.prototype.createAppendBlobFromLocalFile = function (container, blob, localFileName, optionsOrCallback, callback) {
	  return this._createBlobFromLocalFile(container, blob, BlobConstants.BlobTypes.APPEND, localFileName, optionsOrCallback, callback);
	};
	
	/**
	* Appends to an append blob from a local file. Assumes the blob already exists on the service.
	* This API should be used strictly in a single writer scenario because the API internally uses the append-offset conditional header to avoid duplicate blocks.
	* If you are guaranteed to have a single writer scenario, please look at options.absorbConditionalErrorsOnRetry and see if setting this flag to true is acceptable for you.
	* (Not available in the JavaScript Client Library for Browsers)
	*
	* @this {BlobService}
	* @param {string}             container                                     The container name.
	* @param {string}             blob                                          The blob name.
	* @param {string}             localFileName                                 The local path to the file to be uploaded.
	* @param {object}             [options]                                     The request options.
	* @param {bool}               [options.absorbConditionalErrorsOnRetry]      Specifies whether to absorb the conditional error on retry.
	* @param {string}             [options.leaseId]                             The lease identifier.
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {object}             [options.contentSettings]                     The content settings of the blob.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the blob. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the blob.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The Blob service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The blob's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The blob's MD5 hash.
	* @param {AccessConditions}   [options.accessConditions]                    The access conditions.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResult}      callback                                      `error` will contain information
	*                                                                           if an error occurs; otherwise `[result]{@link BlobResult}` will contain
	*                                                                           the blob information.
	*                                                                           `response` will contain information related to this operation.
	* @return {SpeedSummary}
	*/
	BlobService.prototype.appendFromLocalFile = function (container, blob, localFileName, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	  
	  validate.validateArgs('appendFromLocalFile', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	    v.string(localFileName, 'localFileName');
	    v.callback(callback);
	  });
	  
	  var options = extend(true, {}, userOptions);
	  options.speedSummary = options.speedSummary || new SpeedSummary(blob);
	
	  var self = this;
	  fs.stat(localFileName, function (error, stat) {
	    if (error) {
	      callback(error);
	    } else {
	      var stream = new FileReadStream(localFileName, { calcContentMd5: options.storeBlobContentMD5 });
	      var streamCallback = function (appendError, blob, response) {
	        if (azureutil.objectIsFunction(stream.destroy)) {
	          stream.destroy();
	        }
	        callback(appendError, blob, response);
	      };
	      self._uploadBlobFromStream(false, container, blob, BlobConstants.BlobTypes.APPEND, stream, stat.size, options, streamCallback);
	    }
	  });
	  
	  return options.speedSummary;
	};
	
	// Private methods
	
	/**
	* Creates a new blob (Block/Page/Append). If the blob already exists on the service, it will be overwritten.
	* To avoid overwriting and instead throw an error if the blob exists, please pass in an accessConditions parameter in the options object.
	*
	* @ignore
	*
	* @this {BlobService}
	* @param {string}             container                                     The container name.
	* @param {string}             blob                                          The blob name.
	* @param {BlobType}           blobType                                      The blob type.
	* @param {string}             localFileName                                 The local path to the file to be uploaded.
	* @param {object}             [options]                                     The request options.
	* @param {bool}               [options.absorbConditionalErrorsOnRetry]      Specifies whether to absorb the conditional error on retry. (For append blob only)
	* @param {int}                [options.blockSize]                           The size of each block. Maximum is 100MB.
	* @param {string}             [options.blockIdPrefix]                       The prefix to be used to generate the block id. (For block blob only)
	* @param {string}             [options.leaseId]                             The lease identifier.
	* @param {string}             [options.transactionalContentMD5]             An MD5 hash of the blob content. This hash is used to verify the integrity of the blob during transport.
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {int}                [options.parallelOperationThreadCount]        The number of parallel operations that may be performed when uploading.
	* @param {bool}               [options.storeBlobContentMD5]                 Specifies whether the blob's ContentMD5 header should be set on uploads. The default value is true for block blobs.
	* @param {string}             [options.blobTier]                            For page blobs on premium accounts only. Set the tier of the target blob. Refer to BlobUtilities.BlobTier.PremiumPageBlobTier.
	* @param {object}             [options.contentSettings]                     The content settings of the blob.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the blob. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the blob.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The Blob service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The blob's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The MD5 hash of the blob content.
	* @param {AccessConditions}   [options.accessConditions]                    The access conditions.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResult}      callback                                      The callback function.
	*
	* @return {SpeedSummary}
	*
	*/
	BlobService.prototype._createBlobFromLocalFile = function (container, blob, blobType, localFileName, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	  
	  validate.validateArgs('_createBlobFromLocalFile', function (v) {
	    v.string(container, 'container');
	    v.string(blob, 'blob');
	    v.containerNameIsValid(container);
	    v.blobTypeIsValid(blobType);
	    v.string(localFileName, 'localFileName');
	    v.callback(callback);
	  });
	  
	  var options = extend(true, {}, userOptions);
	  options.speedSummary = options.speedSummary || new SpeedSummary(blob);
	
	  var self = this;
	  var size = 0;
	  
	  var creationCallback = function (createError, createBlob, createResponse) {
	    if (createError) {
	      callback(createError, createBlob, createResponse);
	    } else {
	      // Automatically detect the mime type
	      if(azureutil.tryGetValueChain(options, ['contentSettings','contentType'], undefined) === undefined) {
	        azureutil.setObjectInnerPropertyValue(options, ['contentSettings','contentType'], mime.lookup(localFileName));
	      }
	
	      var stream = new FileReadStream(localFileName, { calcContentMd5: options.storeBlobContentMD5 });
	      var streamCallback = function (createError, createBlob, createResponse) {
	        if (azureutil.objectIsFunction(stream.destroy)) {
	          stream.destroy();
	        }
	        callback(createError, createBlob, createResponse);
	      };
	      self._uploadBlobFromStream(true, container, blob, blobType, stream, size, options, streamCallback);
	    }
	  };
	
	  // Check the file size to determine the upload method: single request or chunks
	  fs.stat(localFileName, function (error, stat) {
	    if (error) {
	      callback(error);
	    } else {
	      size = stat.size;
	      self._createBlob(container, blob, blobType, size, options, creationCallback);
	    }
	  });
	  
	  return options.speedSummary;
	};
	
	/**
	* Downloads a blob into a file.
	* @ignore
	* @this {BlobService}
	* @param {string}             container                                   The container name.
	* @param {string}             blob                                        The blob name.
	* @param {string}             localFileName                               The local path to the file to be downloaded.
	* @param {object}             [options]                                   The request options.
	* @param {boolean}            [options.skipSizeCheck]                     Skip the size check to perform direct download.
	*                                                                         Set the option to true for small blobs.
	*                                                                         Parallel download and speed summary won't work with this option on.
	* @param {SpeedSummary}       [options.speedSummary]                      The download tracker objects.
	* @param {int}                [options.parallelOperationThreadCount]      The number of parallel operations that may be performed when uploading.
	* @param {string}             [options.snapshotId]                        The snapshot identifier.
	* @param {string}             [options.leaseId]                           The lease identifier.
	* @param {string}             [options.rangeStart]                        Return only the bytes of the blob in the specified range.
	* @param {string}             [options.rangeEnd]                          Return only the bytes of the blob in the specified range.
	* @param {AccessConditions}   [options.accessConditions]                  The access conditions.
	* @param {boolean}            [options.useTransactionalMD5]               When set to true, Calculate and send/validate content MD5 for transactions.
	* @param {boolean}            [options.disableContentMD5Validation]       When set to true, MD5 validation will be disabled when downloading blobs.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information if an error occurs; 
	*                                                                         otherwise `result` will contain the blob information.
	*                                                                         `response` will contain information related to this operation.
	* @return {SpeedSummary}
	* 
	*/
	BlobService.prototype._getBlobToLocalFile = function (container, blob, localFileName, optionsOrCallback, callback) {
	  var options;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { options = o; callback = c; });
	  options.speedSummary = options.speedSummary || new SpeedSummary(blob);
	  
	  var writeStream = fs.createWriteStream(localFileName, { 'highWaterMark': BlobConstants.MAX_QUEUED_WRITE_DISK_BUFFER_SIZE });
	  writeStream.on('error', function (error) {
	    callback(error);
	  });
	  
	  this.getBlobToStream(container, blob, writeStream, options, function (error, responseBlob, response) {
	    if (error) {
	      writeStream.end(function () {
	        // If the download failed from the beginning, remove the file.
	        if (fs.existsSync(localFileName) && writeStream.bytesWritten === 0) {
	          fs.unlinkSync(localFileName);
	        }
	        callback(error, responseBlob, response);
	      });
	    } else {
	      callback(error, responseBlob, response);
	    }
	  });
	  
	  return options.speedSummary;
	};
	
	module.exports = BlobService;

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	var Constants = __webpack_require__(12);
	var EventEmitter = __webpack_require__(14).EventEmitter;
	var BlobUtilities = __webpack_require__(51);
	
	/**
	* BlockBlob block range stream
	*/
	function BlockRangeStream(blobServiceClient, container, blob, options) {
	  this.blobServiceClient = blobServiceClient;
	  this.container = container;
	  this.blob = blob;
	  this._emitter = new EventEmitter();
	  this._paused = false;
	  this._emittedAll = false;
	  this._emittedRangeType = null;
	  this._emittedRangeIndex = null;
	  this._offset = 0;
	  this._rangelist = [];
	  this._isEmitting = false;
	  if (options.rangeStart) {
	    this._startOffset = options.rangeStart;
	  } else {
	    this._startOffset = 0;
	  }
	  if (options.rangeEnd) {
	    this._endOffset = options.rangeEnd;
	  } else {
	    this._endOffset = Number.MAX_VALUE;
	  }
	}
	
	/**
	* Add event listener
	*/
	BlockRangeStream.prototype.on = function (event, listener) {
	  this._emitter.on(event, listener);
	};
	
	/**
	* Get block list
	*/
	BlockRangeStream.prototype.list = function (options, callback) {
	  if (!options) {
	    options = {};
	  }
	  
	  if (!options.blockListFilter) {
	    options.blockListFilter = BlobUtilities.BlockListFilter.ALL;
	  }
	  
	  var self = this;
	  this.blobServiceClient.listBlocks(this.container, this.blob, options.blockListFilter, options, function (error, blocklist, response) {
	    if (error) {
	      callback(error);
	    } else {
	      var totalSize = parseInt(response.headers[Constants.HeaderConstants.BLOB_CONTENT_LENGTH], 10);
	      if (!blocklist.CommittedBlocks) {
	        //Convert single block blob to block blob range
	        var name = 'NODESDK_BLOCKBLOB_RANGESTREAM';
	        blocklist.CommittedBlocks = [{ Name : name, Size : totalSize }];
	      }
	      
	      self._rangelist = blocklist;
	      self._emitBlockList();
	      self = blocklist = null;
	    }
	  });
	};
	
	/**
	* Emit block ranges
	*/
	BlockRangeStream.prototype._emitBlockList = function () {
	  if (this._paused || this._emittedAll || this._isEmitting) return;
	  
	  var self = this;
	  this._getTypeList(function () {
	    self._rangelist = null;
	    self._emittedAll = true;
	    self._emitter.emit('end');
	  });
	};
	
	/**
	* Get the block type list
	*/
	BlockRangeStream.prototype._getTypeList = function (callback) {
	  this._isEmitting = true;
	  try {
	    var typeStart = false;
	    if (this._rangelist) {
	      for (var blockType in this._rangelist) {
	        if (this._rangelist.hasOwnProperty(blockType)) {
	          if (this._emittedRangeType === null || typeStart || this._emittedRangeType == blockType) {
	            this._emittedRangeType = blockType;
	            typeStart = true;
	          } else if (this._emittedRangeType !== blockType) {
	            continue;
	          }
	          
	          if (this._paused) {
	            return;
	          }
	          
	          this._emitBlockRange (blockType, callback);
	        }
	      }
	    }
	  } finally {
	    this._isEmitting = false;
	  }
	};
	
	/**
	* Get the block list
	*/
	BlockRangeStream.prototype._emitBlockRange  = function (blockType, callback) {
	  var blockList = this._rangelist[blockType];
	  var indexStart = false;
	  for (var blockIndex = 0; blockIndex < blockList.length; blockIndex++) {
	    if (this._emittedRangeIndex === null || indexStart || this._emittedRangeIndex === blockIndex) {
	      this._emittedRangeIndex = blockIndex;
	      indexStart = true;
	    } else if (this._emittedRangeIndex !== blockIndex) {
	      continue;
	    }
	    
	    if (this._paused) {
	      return;
	    }
	    
	    var range = blockList[blockIndex];
	    // follow the same naming convention of page ranges and json
	    range.name = range.Name;
	    range.type = blockType;
	    range.start = this._offset;
	    this._offset += parseInt(range.Size, 10);
	    range.end = this._offset - 1;
	    delete range.Name;
	    delete range.Size;
	    
	    if (range.start > this._endOffset) {
	      break;
	    } else if (range.end < this._startOffset) {
	      continue;
	    } else {
	      range.start = Math.max(range.start, this._startOffset);
	      range.end = Math.min(range.end, this._endOffset);
	      range.size = range.end - range.start + 1;
	      range.dataSize = range.size;
	      this._emitter.emit('range', range);
	    }
	  }
	
	  // remove the used range and avoid memory leak
	  this._rangelist[blockType] = null;
	
	  callback();
	};
	
	/**
	* Pause the stream
	*/
	BlockRangeStream.prototype.pause = function () {
	  this._paused = true;
	};
	
	/**
	* Resume the stream
	*/
	BlockRangeStream.prototype.resume = function () {
	  this._paused = false;
	  if (!this._isEmitting) {
	    this._emitBlockList();
	  }
	};
	
	/**
	* Stop the stream
	*/
	BlockRangeStream.prototype.stop = function () {
	  this.pause();
	  this._emittedAll = true;
	  this._emitter.emit('end');
	};
	
	module.exports = BlockRangeStream;


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	var util = __webpack_require__(4);
	var RangeStream = __webpack_require__(81);
	var Constants = __webpack_require__(12);
	
	/**
	* PageBlob page range stream
	*/
	function PageRangeStream(blobServiceClient, container, blob, options) {
	  PageRangeStream['super_'].call(this, blobServiceClient, container, blob, options);
	  
	  if (options.minRangeSize) {
	    this._minRangeSize = options.minRangeSize;
	  } else {
	    this._minRangeSize = Constants.BlobConstants.MIN_WRITE_PAGE_SIZE_IN_BYTES;
	  }
	  if (options.maxRangeSize) {
	    this._maxRangeSize = options.maxRangeSize;
	  } else {
	    this._maxRangeSize = Constants.BlobConstants.DEFAULT_WRITE_PAGE_SIZE_IN_BYTES;
	  }
	  this._lengthHeader = Constants.HeaderConstants.BLOB_CONTENT_LENGTH;
	  this._listFunc = blobServiceClient.listPageRanges;
	}
	
	util.inherits(PageRangeStream, RangeStream);
	
	module.exports = PageRangeStream;


/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Module dependencies.
	var _ = __webpack_require__(15);
	
	var azureCommon = __webpack_require__(8);
	var azureutil = azureCommon.util;
	var Constants = azureCommon.Constants;
	var HeaderConstants = Constants.HeaderConstants;
	
	/**
	* Creates a new BlobResult object.
	* @class
	* The BlobResult class is used to store the blob information.
	* 
	 * @property  {string}                      container                             The container name.
	 * @property  {string}                      name                                  The blob name.
	 * @property  {object}                      metadata                              The metadata key/value pair.
	 * @property  {string}                      etag                                  The etag.
	 * @property  {string}                      lastModified                          The date/time that the blob was last modified.
	 * @property  {string}                      contentLength                         The size of the blob in bytes.
	 * @property  {string}                      blobType                              The blob type.
	 * @property  {boolean}                     isIncrementalCopy                     If the blob is incremental copy blob.
	 * @property  {string}                      requestId                             The request id.
	 * @property  {string}                      sequenceNumber                        The current sequence number for a page blob.
	 * @property  {string}                      contentRange                          The content range.
	 * @property  {string}                      committedBlockCount                   The committed block count.
	 * @property  {string}                      serverEncrypted                       If the blob data and application metadata are completely encrypted using the specified algorithm. true/false.
	 * @property  {object}                      contentSettings                       The content settings.
	 * @property  {string}                      contentSettings.contentType           The content type.
	 * @property  {string}                      contentSettings.contentEncoding       The content encoding.
	 * @property  {string}                      contentSettings.contentLanguage       The content language.
	 * @property  {string}                      contentSettings.cacheControl          The cache control.
	 * @property  {string}                      contentSettings.contentDisposition    The content disposition.
	 * @property  {string}                      contentSettings.contentMD5            The content MD5 hash.
	 * @property  {object}                      lease                                 The lease information.
	 * @property  {string}                      lease.id                              The lease id.
	 * @property  {string}                      lease.status                          The lease status.
	 * @property  {string}                      lease.state                           The lease state.
	 * @property  {string}                      lease.duration                        The lease duration.
	 * @property  {object}                      copy                                  The copy information.
	 * @property  {string}                      copy.id                               The copy id.
	 * @property  {string}                      copy.status                           The copy status.
	 * @property  {string}                      copy.completionTime                   The copy completion time. 
	 * @property  {string}                      copy.statusDescription                The copy status description.
	 * @property  {string}                      copy.destinationSnapshot              The snapshot time of the last successful incremental copy snapshot for this blob.
	 * @property  {string}                      copy.progress                         The copy progress.
	 * @property  {string}                      copy.source                           The copy source.
	 * 
	* @constructor
	* @param {string} [container]  The container name.
	* @param {string} [name]       The blob name.
	*/
	function BlobResult(container, name) {
	  if (container) {
	    this.container = container;
	  }
	
	  if (name) {
	    this.name = name;
	  }
	}
	
	BlobResult.parse = function (blobXml) {
	  var blobResult = new BlobResult();
	  
	  for (var propertyName in blobXml) {
	    if (blobXml.hasOwnProperty(propertyName)) {
	      if (propertyName === 'Properties') {
	        //  Lift out the properties onto the main object to keep consistent across all APIs like: getBlobProperties
	        azureutil.setPropertyValueFromXML(blobResult, blobXml[propertyName], true);
	      } else if (propertyName === 'Metadata') {
	        var resultPropertyName = azureutil.normalizePropertyNameFromXML(propertyName);
	        blobResult[resultPropertyName] = {};
	        azureutil.setPropertyValueFromXML(blobResult[resultPropertyName], blobXml[propertyName], false);
	      } else {
	        blobResult[propertyName.toLowerCase()] = blobXml[propertyName];
	      }
	    }
	  }
	
	  if (blobResult.isIncrementalCopy !== undefined) {
	    blobResult.isIncrementalCopy = (blobResult.isIncrementalCopy === 'true');
	  }
	
	  // convert accessTierInferred to boolean type
	  if (blobResult.accessTierInferred !== undefined) {
	    blobResult.accessTierInferred = (blobResult.accessTierInferred === 'true');
	  }
	
	  if (blobResult.deleted !== undefined) {
	    blobResult.deleted = (blobResult.deleted == 'true');
	  }
	
	  if (blobResult.remainingRetentionDays !== undefined) {
	    blobResult.remainingRetentionDays = parseInt(blobResult.remainingRetentionDays);
	  }
	
	  return blobResult;
	};
	
	var headersForProperties = {
	  'lastModified': 'LAST_MODIFIED',
	  'etag': 'ETAG',
	  'sequenceNumber': 'SEQUENCE_NUMBER',
	  'blobType': 'BLOB_TYPE',
	  'contentLength': 'CONTENT_LENGTH',
	  'blobContentLength': 'BLOB_CONTENT_LENGTH',
	  'contentRange': 'CONTENT_RANGE',
	  'committedBlockCount': 'BLOB_COMMITTED_BLOCK_COUNT',
	  'serverEncrypted': 'SERVER_ENCRYPTED',
	  'requestId': 'REQUEST_ID',
	  
	  'range': 'RANGE',
	  'blobRange': 'STORAGE_RANGE',
	  'getContentMd5': 'RANGE_GET_CONTENT_MD5',
	  'acceptRanges': 'ACCEPT_RANGES',
	  'appendOffset': 'BLOB_APPEND_OFFSET',
	
	  'accessTier': 'ACCESS_TIER',
	  'accessTierChangeTime': 'ACCESS_TIER_CHANGE_TIME',  
	  'accessTierInferred': 'ACCESS_TIER_INFERRED',
	  'archiveStatus': 'ARCHIVE_STATUS',
	
	  'isIncrementalCopy': 'INCREMENTAL_COPY',
	  
	  // ContentSettings
	  'contentSettings.contentType': 'CONTENT_TYPE',
	  'contentSettings.contentEncoding': 'CONTENT_ENCODING',
	  'contentSettings.contentLanguage': 'CONTENT_LANGUAGE',
	  'contentSettings.cacheControl': 'CACHE_CONTROL',
	  'contentSettings.contentDisposition': 'CONTENT_DISPOSITION',
	  'contentSettings.contentMD5': 'CONTENT_MD5',
	
	  // Lease
	  'lease.id': 'LEASE_ID',
	  'lease.status': 'LEASE_STATUS',
	  'lease.duration': 'LEASE_DURATION',
	  'lease.state': 'LEASE_STATE',
	
	  // Copy
	  'copy.id': 'COPY_ID',
	  'copy.status': 'COPY_STATUS',
	  'copy.source': 'COPY_SOURCE',
	  'copy.progress': 'COPY_PROGRESS',
	  'copy.completionTime': 'COPY_COMPLETION_TIME',
	  'copy.statusDescription': 'COPY_STATUS_DESCRIPTION',
	  'copy.destinationSnapshot': 'COPY_DESTINATION_SNAPSHOT'
	};
	
	BlobResult.prototype.getPropertiesFromHeaders = function (headers) {
	  var self = this;
	
	  var setBlobPropertyFromHeaders = function (blobProperty, headerProperty) {
	    if (!azureutil.tryGetValueChain(self, blobProperty.split('.'), null) && headers[headerProperty.toLowerCase()]) {
	      azureutil.setObjectInnerPropertyValue(self, blobProperty.split('.'), headers[headerProperty.toLowerCase()]);
	      
	      if (blobProperty === 'copy.progress') {
	        var info = azureutil.parseCopyProgress(self.copy.progress);
	        self.copy.bytesCopied = parseInt(info.bytesCopied);
	        self.copy.totalBytes = parseInt(info.totalBytes);
	      }
	    }
	  };
	
	  // For range get, 'x-ms-blob-content-md5' indicate the overall MD5 of the blob. Try to set the contentMD5 using this header if it presents
	  setBlobPropertyFromHeaders('contentSettings.contentMD5', HeaderConstants.BLOB_CONTENT_MD5);
	  
	  _.chain(headersForProperties).pairs().each(function (pair) {
	    var property = pair[0];
	    var header = HeaderConstants[pair[1]];
	    setBlobPropertyFromHeaders(property, header);
	  });
	
	  // convert isIncrementalCopy to boolean type
	  if (self.isIncrementalCopy !== undefined) {
	    self.isIncrementalCopy = (self.isIncrementalCopy === 'true');
	  }
	
	  // convert accessTierInferred to boolean type  
	  if (self.accessTierInferred !== undefined) {
	    self.accessTierInferred = (self.accessTierInferred == 'true');
	  }
	};
	
	/**
	* This method sets the HTTP headers and is used by all methods except setBlobProperties and commitBlocks. Those 2 methods will set the x-ms-* headers using setPropertiesFromBlob.
	* @ignore
	*/
	BlobResult.setHeadersFromBlob = function (webResource, blob) {
	  var setHeaderPropertyFromBlob = function (headerProperty, blobProperty) {
	    var blobPropertyValue = azureutil.tryGetValueChain(blob, blobProperty.split('.'), null);
	    if (blobPropertyValue) {
	      webResource.withHeader(headerProperty, blobPropertyValue);
	    }
	  };
	
	  if (blob) {
	    // Content-Type
	    setHeaderPropertyFromBlob(HeaderConstants.BLOB_CONTENT_TYPE, 'contentSettings.contentType');
	
	    // Content-Encoding
	    setHeaderPropertyFromBlob(HeaderConstants.BLOB_CONTENT_ENCODING, 'contentSettings.contentEncoding');
	
	    // Content-Language
	    setHeaderPropertyFromBlob(HeaderConstants.BLOB_CONTENT_LANGUAGE, 'contentSettings.contentLanguage');
	
	    // Content-Disposition
	    setHeaderPropertyFromBlob(HeaderConstants.BLOB_CONTENT_DISPOSITION, 'contentSettings.contentDisposition');
	
	    // Cache-Control
	    setHeaderPropertyFromBlob(HeaderConstants.BLOB_CACHE_CONTROL, 'contentSettings.cacheControl');
	
	    // Blob's Content-MD5
	    setHeaderPropertyFromBlob(HeaderConstants.BLOB_CONTENT_MD5, 'contentSettings.contentMD5');
	
	    // Content-Length
	    setHeaderPropertyFromBlob(HeaderConstants.CONTENT_LENGTH, 'contentLength');
	
	    // transactional Content-MD5
	    setHeaderPropertyFromBlob(HeaderConstants.CONTENT_MD5, 'transactionalContentMD5');
	
	    // Range
	    if (!azureutil.objectIsNull(blob.rangeStart)) {
	      var range = 'bytes=' + blob.rangeStart + '-';
	
	      if (!azureutil.objectIsNull(blob.rangeEnd)) {
	        range += blob.rangeEnd;
	      }
	
	      webResource.withHeader(HeaderConstants.RANGE, range);
	    }
	
	    // Blob Type
	    setHeaderPropertyFromBlob(HeaderConstants.BLOB_TYPE, 'blobType');
	
	    // Lease id
	    setHeaderPropertyFromBlob(HeaderConstants.LEASE_ID, 'leaseId');
	
	    // Sequence number
	    setHeaderPropertyFromBlob(HeaderConstants.SEQUENCE_NUMBER, 'sequenceNumber');
	    setHeaderPropertyFromBlob(HeaderConstants.SEQUENCE_NUMBER_ACTION, 'sequenceNumberAction');
	
	    if (blob.metadata) {
	      webResource.addOptionalMetadataHeaders(blob.metadata);
	    }
	  }
	};
	
	/**
	* This method sets the x-ms-* headers and is used by setBlobProperties and commitBlocks. All other methods will set the regular HTTP headers using setHeadersFromBlob.
	* @ignore
	*/
	BlobResult.setPropertiesFromBlob = function (webResource, blob) {
	  var setHeaderPropertyFromBlob = function (headerProperty, blobProperty) {
	    var propertyValue = azureutil.tryGetValueChain(blob, blobProperty.split('.'), null);
	    if (propertyValue) {
	      webResource.withHeader(headerProperty, propertyValue);
	    }
	  };
	
	  if (blob) {
	    // Content-Type
	    setHeaderPropertyFromBlob(HeaderConstants.BLOB_CONTENT_TYPE, 'contentSettings.contentType');
	
	    // Content-Encoding
	    setHeaderPropertyFromBlob(HeaderConstants.BLOB_CONTENT_ENCODING, 'contentSettings.contentEncoding');
	
	    // Content-Language
	    setHeaderPropertyFromBlob(HeaderConstants.BLOB_CONTENT_LANGUAGE, 'contentSettings.contentLanguage');
	
	    // Content-Disposition
	    setHeaderPropertyFromBlob(HeaderConstants.BLOB_CONTENT_DISPOSITION, 'contentSettings.contentDisposition');
	
	    // Cache-Control
	    setHeaderPropertyFromBlob(HeaderConstants.BLOB_CACHE_CONTROL, 'contentSettings.cacheControl');
	
	    // Content-MD5
	    setHeaderPropertyFromBlob(HeaderConstants.BLOB_CONTENT_MD5, 'contentSettings.contentMD5');
	
	    // Lease id
	    setHeaderPropertyFromBlob(HeaderConstants.LEASE_ID, 'leaseId');
	
	    if (blob.metadata) {
	      webResource.addOptionalMetadataHeaders(blob.metadata);
	    }
	  }
	};
	
	module.exports = BlobResult;


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Module dependencies.
	var _ = __webpack_require__(15);
	
	var azureCommon = __webpack_require__(8);
	var xmlbuilder = azureCommon.xmlbuilder;
	var Constants = azureCommon.Constants;
	
	/**
	* Builds an XML representation for a block list.
	*
	* @param  {array}  The block list.
	* @return {string} The XML block list.
	*/
	exports.serialize = function (blockListJs) {
	  var blockListDoc = xmlbuilder.create();
	  blockListDoc = blockListDoc.begin(Constants.BlobConstants.BLOCK_LIST_ELEMENT, { version: '1.0', encoding: 'utf-8' });
	
	  if (_.isArray(blockListJs.LatestBlocks)) {
	    blockListJs.LatestBlocks.forEach(function (block) {
	      blockListDoc = blockListDoc.ele(Constants.BlobConstants.LATEST_ELEMENT)
	        .txt(new Buffer(block).toString('base64'))
	        .up();
	    });
	  }
	
	  if (_.isArray(blockListJs.CommittedBlocks)) {
	    blockListJs.CommittedBlocks.forEach(function (block) {
	      blockListDoc = blockListDoc.ele(Constants.BlobConstants.COMMITTED_ELEMENT)
	        .txt(new Buffer(block).toString('base64'))
	        .up();
	    });
	  }
	
	  if (_.isArray(blockListJs.UncommittedBlocks)) {
	    blockListJs.UncommittedBlocks.forEach(function (block) {
	      blockListDoc = blockListDoc.ele(Constants.BlobConstants.UNCOMMITTED_ELEMENT)
	        .txt(new Buffer(block).toString('base64'))
	        .up();
	    });
	  }
	
	  return blockListDoc.doc().toString();
	};
	
	exports.parse = function (blockListXml) {
	  var blockListResult = {};
	
	  if (blockListXml.CommittedBlocks && blockListXml.CommittedBlocks.Block) {
	    blockListResult.CommittedBlocks = blockListXml.CommittedBlocks.Block;
	    if (!_.isArray(blockListResult.CommittedBlocks)) {
	      blockListResult.CommittedBlocks = [blockListResult.CommittedBlocks];
	    }
	    blockListResult.CommittedBlocks.forEach(function(block) {
	      block.Name = new Buffer(block.Name, 'base64').toString();
	    });
	  }
	
	  if (blockListXml.UncommittedBlocks && blockListXml.UncommittedBlocks.Block) {
	    blockListResult.UncommittedBlocks = blockListXml.UncommittedBlocks.Block;
	    if (!_.isArray(blockListResult.UncommittedBlocks)) {
	      blockListResult.UncommittedBlocks = [blockListResult.UncommittedBlocks];
	    }
	    blockListResult.UncommittedBlocks.forEach(function(block) {
	      block.Name = new Buffer(block.Name, 'base64').toString();
	    });
	  }
	
	  return blockListResult;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Module dependencies.
	var azureCommon = __webpack_require__(8);
	var azureutil = azureCommon.util;
	var Constants = azureCommon.Constants;
	
	var HeaderConstants = Constants.HeaderConstants;
	var BlobUtilities = __webpack_require__(51);
	
	/**
	* Creates a new ContainerResult object.
	* @class
	* The ContainerResult class is used to store the container information.
	* 
	 * @property  {string}                      name                                  The container name.
	 * @property  {string}                      publicAccessLevel                     The public access level.
	 * @property  {object}                      metadata                              The metadata key/value pair.
	 * @property  {string}                      etag                                  The etag.
	 * @property  {string}                      lastModified                          The date/time that the container was last modified.
	 * @property  {string}                      requestId                             The request id.
	 * @property  {object}                      lease                                 The lease information.
	 * @property  {string}                      lease.status                          The lease status.
	 * @property  {string}                      lease.state                           The lease state.
	 * @property  {string}                      lease.duration                        The lease duration.
	 * 
	* @constructor
	* @param {string} [container]               The container name.
	* @param {string} [publicAccessLevel]       The public access level.
	*/
	function ContainerResult(name, publicAccessLevel) {
	  if (name) {
	    this.name = name;
	  }
	
	  if (publicAccessLevel) {
	    this.publicAccessLevel = publicAccessLevel;
	  }
	}
	
	ContainerResult.parse = function (containerXml) {
	  var containerResult = new ContainerResult();
	  
	  for (var propertyName in containerXml) {
	    if (containerXml.hasOwnProperty(propertyName)) {
	      if (propertyName === 'Properties') {
	        //  Lift out the properties onto the main object to keep consistent across all APIs like: getContainerProperties
	        azureutil.setPropertyValueFromXML(containerResult, containerXml[propertyName], true);
	      } else if (propertyName === 'Metadata') {
	        var resultPropertyName = azureutil.normalizePropertyNameFromXML(propertyName);
	        containerResult[resultPropertyName] = {};
	        azureutil.setPropertyValueFromXML(containerResult[resultPropertyName], containerXml[propertyName], false);
	      } else {
	        containerResult[propertyName.toLowerCase()] = containerXml[propertyName];
	      }
	    }
	  }
	
	  if (!containerResult.publicAccessLevel) {
	    containerResult.publicAccessLevel = BlobUtilities.BlobContainerPublicAccessType.OFF;
	  }
	
	  return containerResult;
	};
	
	ContainerResult.prototype.getPropertiesFromHeaders = function (headers) {
	  var self = this;
	  
	  var setContainerPropertyFromHeaders = function (containerProperty, headerProperty) {
	    if (!azureutil.tryGetValueChain(self, containerProperty.split('.'), null) && headers[headerProperty.toLowerCase()]) {
	      azureutil.setObjectInnerPropertyValue(self, containerProperty.split('.'), headers[headerProperty.toLowerCase()]);
	    }
	  };
	
	  setContainerPropertyFromHeaders('etag', HeaderConstants.ETAG);
	  setContainerPropertyFromHeaders('lastModified', HeaderConstants.LAST_MODIFIED);
	  setContainerPropertyFromHeaders('lease.status', HeaderConstants.LEASE_STATUS);
	  setContainerPropertyFromHeaders('lease.state', HeaderConstants.LEASE_STATE);
	  setContainerPropertyFromHeaders('lease.duration', HeaderConstants.LEASE_DURATION);
	  setContainerPropertyFromHeaders('requestId', HeaderConstants.REQUEST_ID);
	
	  if (!self.publicAccessLevel) {
	    self.publicAccessLevel = BlobUtilities.BlobContainerPublicAccessType.OFF;
	    if (headers[HeaderConstants.BLOB_PUBLIC_ACCESS]) {
	      self.publicAccessLevel = headers[HeaderConstants.BLOB_PUBLIC_ACCESS];
	    }
	  }
	
	  if (self.publicAccessLevel === 'true') {
	    // The container was marked for full public read access using a version prior to 2009-09-19.
	    self.publicAccessLevel = BlobUtilities.BlobContainerPublicAccessType.CONTAINER;
	  }
	};
	
	/**
	* The container ACL settings.
	* @typedef    {object}                        ContainerAclResult
	* @extends    {ContainerResult}
	* @property   {Object.<string, AccessPolicy>}    signedIdentifiers   The container ACL settings. See `[AccessPolicy]{@link AccessPolicy}` for detailed information.
	*/
	
	module.exports = ContainerResult;

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Module dependencies.
	var Constants = __webpack_require__(8).Constants;
	var HeaderConstants = Constants.HeaderConstants;
	
	
	/**
	* Creates a new LeaseResult object.
	* @class
	* The LeaseResult class is used to store the lease information.
	* 
	 * @property  {string}                      container                         The container name.
	 * @property  {string}                      blob                              The blob name.
	 * @property  {string}                      id                                The lease id.
	 * @property  {string}                      time                              Approximate time remaining in the lease period, in seconds.
	 * @property  {string}                      etag                              The etag.
	 * @property  {string}                      lastModified                      The date/time that the lease was last modified.
	 * 
	* @constructor
	* @param {string} [container]               The container name.
	* @param {string} [blob]                    The blob name.
	* @param {string} [id]                      The lease id.
	* @param {string} [time]                    Approximate time remaining in the lease period, in seconds.
	*/
	function LeaseResult(container, blob, id, time) {
	  if (container) {
	    this.container = container;
	  }
	
	  if (blob) {
	    this.blob = blob;
	  }
	
	  if (id) {
	    this.id = id;
	  }
	
	  if (time) {
	    this.time = time;
	  }
	}
	
	LeaseResult.prototype.getPropertiesFromHeaders = function (headers) {
	  var self = this;
	
	  if (!self['id'] && headers[HeaderConstants.LEASE_ID]) {
	    self['id'] = headers[HeaderConstants.LEASE_ID];
	  }
	
	  if (!self['time'] && headers[HeaderConstants.LEASE_TIME]) {
	    self['time'] = parseInt(headers[HeaderConstants.LEASE_TIME], 10);
	  }
	
	  self['etag'] = headers[HeaderConstants.ETAG];
	  self['lastModified'] = headers[HeaderConstants.LAST_MODIFIED.toLowerCase()];
	};
	
	module.exports = LeaseResult;

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Module dependencies.
	var qs = __webpack_require__(43);
	var url = __webpack_require__(33);
	var util = __webpack_require__(4);
	var _ = __webpack_require__(15);
	var extend = __webpack_require__(26);
	var path = __webpack_require__(388);
	
	var azureCommon = __webpack_require__(8);
	var Md5Wrapper = __webpack_require__(34);
	var azureutil = azureCommon.util;
	var SR = azureCommon.SR;
	var validate = azureCommon.validate;
	var SpeedSummary = azureCommon.SpeedSummary;
	var StorageServiceClient = azureCommon.StorageServiceClient;
	var WebResource = azureCommon.WebResource;
	
	// Constants
	var Constants = azureCommon.Constants;
	var FileConstants = Constants.FileConstants;
	var HeaderConstants = Constants.HeaderConstants;
	var HttpConstants = Constants.HttpConstants;
	var QueryStringConstants = Constants.QueryStringConstants;
	
	// Streams
	var BatchOperation = azureCommon.BatchOperation;
	var SpeedSummary = azureCommon.SpeedSummary;
	var ChunkAllocator = azureCommon.ChunkAllocator;
	var ChunkStream = azureCommon.ChunkStream;
	var ChunkStreamWithStream = azureCommon.ChunkStreamWithStream;
	var FileRangeStream = __webpack_require__(295);
	
	// Models requires
	var ShareResult = __webpack_require__(298);
	var DirectoryResult = __webpack_require__(296);
	var FileResult = __webpack_require__(297);
	var AclResult = azureCommon.AclResult;
	
	// Errors requires
	var errors = __webpack_require__(30);
	var ArgumentNullError = errors.ArgumentNullError;
	var ArgumentError = errors.ArgumentError;
	
	/**
	* Creates a new FileService object.
	* If no connection string or storageaccount and storageaccesskey are provided,
	* the AZURE_STORAGE_CONNECTION_STRING or AZURE_STORAGE_ACCOUNT and AZURE_STORAGE_ACCESS_KEY environment variables will be used.
	* @class
	* The FileService class is used to perform operations on the Microsoft Azure File Service.
	* The File Service provides storage for binary large objects, and provides functions for working with data stored in files.
	* 
	* For more information on the File Service, as well as task focused information on using it in a Node.js application, see
	* [How to Use the File Service from Node.js](http://azure.microsoft.com/en-us/documentation/articles/storage-nodejs-how-to-use-file-storage/).
	* The following defaults can be set on the file service.
	* defaultTimeoutIntervalInMs                          The default timeout interval, in milliseconds, to use for request made via the file service.
	* defaultEnableReuseSocket                            The default boolean value to enable socket reuse when uploading local files or streams.
	*                                                     If the Node.js version is lower than 0.10.x, socket reuse will always be turned off.
	* defaultClientRequestTimeoutInMs                     The default timeout of client requests, in milliseconds, to use for the request made via the file service.
	* defaultMaximumExecutionTimeInMs                     The default maximum execution time across all potential retries, for requests made via the file service.
	* defaultLocationMode                                 The default location mode for requests made via the file service.
	* parallelOperationThreadCount                        The number of parallel operations that may be performed when uploading a file.
	* useNagleAlgorithm                                   Determines whether the Nagle algorithm is used for requests made via the file service; true to use the  
	*                                                     Nagle algorithm; otherwise, false. The default value is false.
	* @constructor
	* @extends {StorageServiceClient}
	*
	* @param {string} [storageAccountOrConnectionString]  The storage account or the connection string.
	* @param {string} [storageAccessKey]                  The storage access key.
	* @param {string|object} [host]                       The host address. To define primary only, pass a string. 
	*                                                     Otherwise 'host.primaryHost' defines the primary host and 'host.secondaryHost' defines the secondary host.
	* @param {string} [sasToken]                          The Shared Access Signature token.
	* @param {string} [endpointSuffix]                    The endpoint suffix.
	*/
	function FileService(storageAccountOrConnectionString, storageAccessKey, host, sasToken, endpointSuffix) {
	  var storageServiceSettings = StorageServiceClient.getStorageSettings(storageAccountOrConnectionString, storageAccessKey, host, sasToken, endpointSuffix);
	
	  FileService['super_'].call(this,
	    storageServiceSettings._name,
	    storageServiceSettings._key,
	    storageServiceSettings._fileEndpoint,
	    storageServiceSettings._usePathStyleUri,
	    storageServiceSettings._sasToken);
	
	  this.defaultEnableReuseSocket = Constants.DEFAULT_ENABLE_REUSE_SOCKET;
	  this.singleFileThresholdInBytes = FileConstants.DEFAULT_SINGLE_FILE_GET_THRESHOLD_IN_BYTES;
	  this.parallelOperationThreadCount = Constants.DEFAULT_PARALLEL_OPERATION_THREAD_COUNT;
	}
	
	util.inherits(FileService, StorageServiceClient);
	
	// Utility methods
	
	/**
	* Create resource name
	* @ignore
	*
	* @param {string} share          Share name
	* @param {string} [directory]    Directory name
	* @param {string} [file]         File name
	* @return {string} The encoded resource name.
	*/
	function createResourceName(share, directory, file, forSAS) {
	  var encode = function(name) {
	    if (name && !forSAS) {
	      name = encodeURIComponent(name);
	      name = name.replace(/%2F/g, '/');
	      name = name.replace(/%5C/g, '/');
	      name = name.replace(/\+/g, '%20');
	    }
	    return name;
	  };
	
	  var name = share;
	
	  if (directory) {
	    // if directory does not start with '/', add it
	    if (directory[0] !== '/') {
	      name += ('/');
	    }
	
	    name += encode(directory);
	  } 
	
	  if (file) {
	    // if the current path does not end with '/', add it
	    if (name[name.length - 1] !== '/') {
	      name += ('/');
	    }
	    
	    name += encode(file);
	  }
	
	  return path.normalize(name).replace(/\\/g, '/');
	}
	
	// File service methods
	
	/**
	* Gets the properties of a storage account's File service, including Azure Storage Analytics.
	*
	* @this {FileService}
	* @param {object}       [options]                               The request options.
	* @param {LocationMode} [options.locationMode]                  Specifies the location mode used to decide which location the request should be sent to. 
	*                                                               Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}          [options.timeoutIntervalInMs]           The server timeout interval, in milliseconds, to use for the request.
	* @param {int}          [options.clientRequestTimeoutInMs]      The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}          [options.maximumExecutionTimeInMs]      The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                               The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                               execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}       [options.clientRequestId]               A string that represents the client request ID with a 1KB character limit.
	* @param {bool}         [options.useNagleAlgorithm]             Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                               The default value is false.
	* @param {errorOrResult}  callback                              `error` will contain information if an error occurs; otherwise, `[result]{@link ServiceProperties}` will contain the properties 
	*                                                               and `response` will contain information related to this operation.
	*/
	FileService.prototype.getServiceProperties = function (optionsOrCallback, callback) {
	  return this.getAccountServiceProperties(optionsOrCallback, callback);
	};
	
	/**
	* Sets the properties of a storage account's File service, including Azure Storage Analytics.
	* You can also use this operation to set the default request version for all incoming requests that do not have a version specified.
	*
	* @this {FileService}
	* @param {object}             serviceProperties                        The service properties.
	* @param {object}             [options]                                The request options.
	* @param {LocationMode}       [options.locationMode]                   Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                      Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]            The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]       The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]       The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                      The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                      execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]              Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                      The default value is false.
	* @param {errorOrResponse}    callback                                 `error` will contain information
	*                                                                      if an error occurs; otherwise, `response`
	*                                                                      will contain information related to this operation.
	*/
	FileService.prototype.setServiceProperties = function (serviceProperties, optionsOrCallback, callback) {
	  return this.setAccountServiceProperties(serviceProperties, optionsOrCallback, callback);
	};
	
	// Share methods
	
	/**
	* Lists a segment containing a collection of share items under the specified account.
	*
	* @this {FileService}
	* @param {object}             currentToken                                A continuation token returned by a previous listing operation. Please use 'null' or 'undefined' if this is the first operation.
	* @param {object}             [options]                                   The request options.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.maxResults]                        Specifies the maximum number of shares to return per call to Azure storage.
	* @param {string}             [options.include]                           Include this parameter to specify that the share's metadata be returned as part of the response body. (allowed values: '', 'metadata', 'snapshots' or any combination of them)
	*                                                                         **Note** that all metadata names returned from the server will be converted to lower case by NodeJS itself as metadata is set via HTTP headers and HTTP header names are case insensitive.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information
	*                                                                         if an error occurs; otherwise `result` will contain `entries` and `continuationToken`. 
	*                                                                         `entries`  gives a list of `[shares]{@link ShareResult}` and the `continuationToken` is used for the next listing operation.
	*                                                                         `response` will contain information related to this operation.
	*/
	FileService.prototype.listSharesSegmented = function (currentToken, optionsOrCallback, callback) {
	  this.listSharesSegmentedWithPrefix(null /* prefix */, currentToken, optionsOrCallback, callback);
	};
	
	/**
	* Lists a segment containing a collection of share items whose names begin with the specified prefix under the specified account.
	*
	* @this {FileService}
	* @param {string}             prefix                                      The prefix of the share name.
	* @param {object}             currentToken                                A continuation token returned by a previous listing operation. Please use 'null' or 'undefined' if this is the first operation.
	* @param {object}             [options]                                   The request options.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {string}             [options.prefix]                            Filters the results to return only shares whose name begins with the specified prefix.
	* @param {int}                [options.maxResults]                        Specifies the maximum number of shares to return per call to Azure storage.
	* @param {string}             [options.include]                           Include this parameter to specify that the share's metadata be returned as part of the response body. (allowed values: '', 'metadata', 'snapshots' or any combination of them)
	*                                                                         **Note** that all metadata names returned from the server will be converted to lower case by NodeJS itself as metadata is set via HTTP headers and HTTP header names are case insensitive.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information
	*                                                                         if an error occurs; otherwise `result` will contain `entries` and `continuationToken`. 
	*                                                                         `entries`  gives a list of `[shares]{@link ShareResult}` and the `continuationToken` is used for the next listing operation.
	*                                                                         `response` will contain information related to this operation.
	*/
	FileService.prototype.listSharesSegmentedWithPrefix = function (prefix, currentToken, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	  
	  validate.validateArgs('listShares', function (v) {
	    v.callback(callback);
	  });
	  
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.get()
	    .withQueryOption(QueryStringConstants.COMP, 'list')
	    .withQueryOption(QueryStringConstants.MAX_RESULTS, options.maxResults)
	    .withQueryOption(QueryStringConstants.INCLUDE, options.include);
	  
	  if (!azureutil.objectIsNull(currentToken)) {
	    webResource.withQueryOption(QueryStringConstants.MARKER, currentToken.nextMarker);
	  }
	  
	  webResource.withQueryOption(QueryStringConstants.PREFIX, prefix);
	  
	  //options.requestLocationMode = azureutil.getNextListingLocationMode(currentToken);
	  
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.listSharesResult = null;
	    
	    if (!responseObject.error) {
	      responseObject.listSharesResult = {
	        entries: null,
	        continuationToken: null
	      };
	      responseObject.listSharesResult.entries = [];
	      
	      var shares = [];
	      
	      if (responseObject.response.body.EnumerationResults.Shares && responseObject.response.body.EnumerationResults.Shares.Share) {
	        shares = responseObject.response.body.EnumerationResults.Shares.Share;
	        if (!_.isArray(shares)) {
	          shares = [shares];
	        }
	      }
	      
	      shares.forEach(function (currentShare) {
	        var shareResult = ShareResult.parse(currentShare);
	        responseObject.listSharesResult.entries.push(shareResult);
	      });
	      
	      if (responseObject.response.body.EnumerationResults.NextMarker) {
	        responseObject.listSharesResult.continuationToken = {
	          nextMarker: null,
	          targetLocation: null
	        };
	        
	        responseObject.listSharesResult.continuationToken.nextMarker = responseObject.response.body.EnumerationResults.NextMarker;
	        responseObject.listSharesResult.continuationToken.targetLocation = responseObject.targetLocation;
	      }
	    }
	    
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.listSharesResult, returnObject.response);
	    };
	    
	    next(responseObject, finalCallback);
	  };
	  
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Checks whether or not a share exists on the service.
	*
	* @this {FileService}
	* @param {string}             share                                   The share name.
	* @param {object}             [options]                               The request options.
	* @param {string}             [options.shareSnapshotId]               The snapshot identifier of the share.
	* @param {LocationMode}       [options.locationMode]                  Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                     Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]           The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]      The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]      The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                     The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                     execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]               A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]             Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                     The default value is false.
	* @param {errorOrResult}      callback                                `error` will contain information
	*                                                                     if an error occurs; otherwise `[result]{@link ShareResult}` will contain
	*                                                                     the share information including `exists` boolean member. 
	*                                                                     `response` will contain information related to this operation.
	*/
	FileService.prototype.doesShareExist = function (share, optionsOrCallback, callback) {
	  this._doesShareExist(share, false, optionsOrCallback, callback);
	};
	
	/**
	* Creates a new share under the specified account.
	* If a share with the same name already exists, the operation fails.
	*
	* @this {FileService}
	* @param {string}             share                               The share name.
	* @param {object}             [options]                           The request options.
	* @param {int}                [options.quota]                     Specifies the maximum size of the share, in gigabytes.
	* @param {LocationMode}       [options.locationMode]              Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                 Please see StorageUtilities.LocationMode for the possible values.
	* @param {object}             [options.metadata]                  The metadata key/value pairs.
	* @param {int}                [options.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                 The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                 execution time is checked intermittently while performing requests, and before executing retries.   
	* @param {string}             [options.clientRequestId]           A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]         Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                 The default value is false.
	* @param {errorOrResult}      callback                            `error` will contain information
	*                                                                 if an error occurs; otherwise `[result]{@link ShareResult}` will contain
	*                                                                 the share information.
	*                                                                 `response` will contain information related to this operation.
	*/
	FileService.prototype.createShare = function (share, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('createShare', function (v) {
	    v.string(share, 'share');
	    v.shareNameIsValid(share);
	    v.shareQuotaIsValid(userOptions.quota);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.put(share)
	    .withQueryOption(QueryStringConstants.RESTYPE, 'share')
	    .withHeader(HeaderConstants.SHARE_QUOTA, options.quota);
	
	  webResource.addOptionalMetadataHeaders(options.metadata);
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.shareResult = null;
	    if (!responseObject.error) {
	      responseObject.shareResult = new ShareResult(share);
	      responseObject.shareResult.getPropertiesFromHeaders(responseObject.response.headers);
	
	      if (options.metadata) {
	        responseObject.shareResult.metadata = options.metadata;
	      }
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.shareResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Creates a share snapshot.
	*
	* @this {FileService}
	* @param {string}             share                               The share name.
	* @param {object}             [options]                           The request options.
	* @param {LocationMode}       [options.locationMode]              Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                 Please see StorageUtilities.LocationMode for the possible values.
	* @param {object}             [options.metadata]                  The metadata key/value pairs.
	* @param {int}                [options.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                 The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                 execution time is checked intermittently while performing requests, and before executing retries.   
	* @param {string}             [options.clientRequestId]           A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]         Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                 The default value is false.
	* @param {errorOrResult}      callback                            `error` will contain information
	*                                                                 if an error occurs; otherwise `result` will contain
	*                                                                 the ID of the snapshot.
	*                                                                 `response` will contain information related to this operation.
	*/
	FileService.prototype.createShareSnapshot = function (share, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('createShareSnapshot', function (v) {
	    v.string(share, 'share');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.put(share)
	    .withQueryOption(QueryStringConstants.RESTYPE, 'share')
	    .withQueryOption(QueryStringConstants.COMP, QueryStringConstants.SNAPSHOT);
	  webResource.addOptionalMetadataHeaders(options.metadata);
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.snapshotId = null;
	    if (!responseObject.error) {
	      responseObject.snapshotId = responseObject.response.headers[HeaderConstants.SNAPSHOT];
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.snapshotId, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Creates a new share under the specified account if the share does not exists.
	*
	* @this {FileService}
	* @param {string}             share                                     The share name.
	* @param {object}             [options]                                 The request options.
	* @param {LocationMode}       [options.locationMode]                    Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                       Please see StorageUtilities.LocationMode for the possible values.
	* @param {object}             [options.metadata]                        The metadata key/value pairs.
	* @param {int}                [options.timeoutIntervalInMs]             The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]        The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]        The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                       The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                       execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                 A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]               Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                       The default value is false.
	* @param {errorOrResult}      callback                                  `error` will contain information
	*                                                                       if an error occurs; otherwise `[result]{@link ShareResult}` will contain
	*                                                                       the share information including `created` boolean member.
	*                                                                       `response` will contain information related to this operation.
	*
	* @example
	* var azure = require('azure-storage');
	* var FileService = azure.createFileService();
	* FileService.createShareIfNotExists('taskshare', function(error) {
	*   if(!error) {
	*     // Share created or already existed
	*   }
	* }); 
	*/
	FileService.prototype.createShareIfNotExists = function (share, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('createShareIfNotExists', function (v) {
	    v.string(share, 'share');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  delete options.shareSnapshotId;
	
	  var self = this;
	  self._doesShareExist(share, true, options, function(error, result, response) {
	    var exists = result.exists;
	    result.created = false;
	    delete result.exists;
	    
	    if(error){
	      callback(error, result, response);
	    } else if (exists) {
	      response.isSuccessful = true;
	      callback(error, result, response);
	    } else {
	      self.createShare(share, options, function (createError, responseShare, createResponse) {
	        if(!createError){
	          responseShare.created = true;
	        }
	        else if (createError && createError.statusCode === HttpConstants.HttpResponseCodes.Conflict && createError.code === Constants.FileErrorCodeStrings.SHARE_ALREADY_EXISTS) {
	          // If it was created before, there was no actual error.
	          createError = null;
	          createResponse.isSuccessful = true;
	        }
	
	        callback(createError, responseShare, createResponse);
	      });
	    }
	  });
	};
	
	/**
	* Retrieves a share and its properties from a specified account.
	* **Note** that all metadata names returned from the server will be converted to lower case by NodeJS itself as metadata is set via HTTP headers and HTTP header names are case insensitive.
	
	
	*
	* @this {FileService}
	* @param {string}             share                               The share name.
	* @param {object}             [options]                           The request options.
	* @param {string}             [options.shareSnapshotId]           The snapshot identifier of the share.
	* @param {LocationMode}       [options.locationMode]              Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                 Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                 The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                 execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]           A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]         Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                 The default value is false.
	* @param {errorOrResult}      callback                            `error` will contain information
	*                                                                 if an error occurs; otherwise `[result]{@link ShareResult}` will contain
	*                                                                 information for the share.
	*                                                                 `response` will contain information related to this operation.
	*/
	FileService.prototype.getShareProperties = function (share, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('getShareProperties', function (v) {
	    v.string(share, 'share');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.head(share)
	    .withQueryOption(QueryStringConstants.RESTYPE, 'share')
	    .withQueryOption(QueryStringConstants.SHARE_SNAPSHOT, options.shareSnapshotId);
	
	  //options.requestLocationMode = Constants.RequestLocationMode.PRIMARY_OR_SECONDARY;
	
	  var self = this;
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.shareResult = null;
	    if (!responseObject.error) {
	      responseObject.shareResult = new ShareResult(share);
	      responseObject.shareResult.metadata = self.parseMetadataHeaders(responseObject.response.headers);
	      responseObject.shareResult.getPropertiesFromHeaders(responseObject.response.headers);
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.shareResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Sets the properties for the specified share.
	*
	* @this {FileService}
	* @param {string}             share                                       The share name.
	* @param {object}             [properties]                                The share properties to set.
	* @param {string|int}         [properties.quota]                          Specifies the maximum size of the share, in gigabytes.
	* @param {object}             [options]                                   The request options.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information
	*                                                                         if an error occurs; otherwise `[share]{@link ShareResult}` will contain
	*                                                                         information about the share.
	*                                                                         `response` will contain information related to this operation.
	*/
	FileService.prototype.setShareProperties = function (share, properties, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	  
	  validate.validateArgs('setShareProperties', function (v) {
	    v.string(share, 'share');
	    v.shareNameIsValid(share);
	    v.shareQuotaIsValid(userOptions.quota);
	    v.callback(callback);
	  });
	  
	  var options = extend(true, properties, userOptions);
	  var resourceName = createResourceName(share);
	  var webResource = WebResource.put(resourceName)
	    .withQueryOption(QueryStringConstants.RESTYPE, 'share')
	    .withQueryOption(QueryStringConstants.COMP, 'properties')
	    .withHeader(HeaderConstants.SHARE_QUOTA, options.quota);
	  
	  FileResult.setProperties(webResource, options);
	  
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.shareResult = null;
	    if (!responseObject.error) {
	      responseObject.shareResult = new ShareResult(share);
	      responseObject.shareResult.getPropertiesFromHeaders(responseObject.response.headers);
	    }
	    
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.shareResult, returnObject.response);
	    };
	    
	    next(responseObject, finalCallback);
	  };
	  
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Gets the share statistics for a share.
	*
	* @this {FileService}
	* @param {string}           share                                   The share name.
	* @param {object}           [options]                               The request options.
	* @param {LocationMode}     [options.locationMode]                  Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                   Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}              [options.timeoutIntervalInMs]           The timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]    The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}              [options.maximumExecutionTimeInMs]      The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                   The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                   execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}           [options.clientRequestId]               A string that represents the client request ID with a 1KB character limit.
	* @param {bool}             [options.useNagleAlgorithm]             Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                   The default value is false.
	* @param {errorOrResult}    callback                                `error` will contain information if an error occurs; otherwise, `[result]{@link ServiceStats}` will contain the stats and 
	*                                                                   `response` will contain information related to this operation.
	*/
	FileService.prototype.getShareStats = function (share, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	  
	  validate.validateArgs('getShareStats', function (v) {
	    v.callback(callback);
	  });
	  
	  var options = extend(true, {}, userOptions);
	  var resourceName = createResourceName(share);
	  var webResource = WebResource.get(resourceName)
	    .withQueryOption(QueryStringConstants.RESTYPE, 'share')
	    .withQueryOption(QueryStringConstants.COMP, 'stats');
	  
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.shareResult = null;
	    if (!responseObject.error) {
	      responseObject.shareResult = ShareResult.parse(responseObject.response.body, share);
	      responseObject.shareResult.getPropertiesFromHeaders(responseObject.response.headers);
	    }
	    
	    // function to be called after all filters
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.shareResult, returnObject.response);
	    };
	    
	    // call the first filter
	    next(responseObject, finalCallback);
	  };
	  
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	
	/**
	* Returns all user-defined metadata for the share.
	* **Note** that all metadata names returned from the server will be converted to lower case by NodeJS itself as metadata is set via HTTP headers and HTTP header names are case insensitive.
	*
	* @this {FileService}
	* @param {string}             share                                     The share name.
	* @param {object}             [options]                                 The request options.
	* @param {string}             [options.shareSnapshotId]                 The snapshot identifier of the share.
	* @param {LocationMode}       [options.locationMode]                    Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                       Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]             The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]        The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]        The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                       The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                       execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                 A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]               Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                       The default value is false.
	* @param {errorOrResult}      callback                                  `error` will contain information
	*                                                                       if an error occurs; otherwise `[result]{@link ShareResult}` will contain
	*                                                                       information for the share.
	*                                                                       `response` will contain information related to this operation.
	*/
	FileService.prototype.getShareMetadata = function (share, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('getShareMetadata', function (v) {
	    v.string(share, 'share');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.head(share)
	    .withQueryOption(QueryStringConstants.RESTYPE, 'share')
	    .withQueryOption(QueryStringConstants.COMP, 'metadata')
	    .withQueryOption(QueryStringConstants.SHARE_SNAPSHOT, options.shareSnapshotId);
	
	  var self = this;
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.shareResult = null;
	    if (!responseObject.error) {
	      responseObject.shareResult = new ShareResult(share);
	      responseObject.shareResult.metadata = self.parseMetadataHeaders(responseObject.response.headers);
	      responseObject.shareResult.getPropertiesFromHeaders(responseObject.response.headers);
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.shareResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Sets the share's metadata.
	*
	* Calling the Set Share Metadata operation overwrites all existing metadata that is associated with the share.
	* It's not possible to modify an individual name/value pair.
	*
	* @this {FileService}
	* @param {string}             share                               The share name.
	* @param {object}             metadata                            The metadata key/value pairs.
	* @param {object}             [options]                           The request options.
	* @param {LocationMode}       [options.locationMode]              Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                 Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                 The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                 execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]           A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]         Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                 The default value is false.
	* @param {errorOrResponse}  callback                              `error` will contain information
	*                                                                 if an error occurs; otherwise 
	*                                                                 `response` will contain information related to this operation.
	*/
	FileService.prototype.setShareMetadata = function (share, metadata, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('setShareMetadata', function (v) {
	    v.string(share, 'share');
	    v.object(metadata, 'metadata');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.put(share)
	    .withQueryOption(QueryStringConstants.RESTYPE, 'share')
	    .withQueryOption(QueryStringConstants.COMP, 'metadata');
	
	  webResource.addOptionalMetadataHeaders(metadata);
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.shareResult = null;
	    if (!responseObject.error) {
	      responseObject.shareResult = new ShareResult(share);
	      responseObject.shareResult.getPropertiesFromHeaders(responseObject.response.headers);
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.shareResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Gets the share's ACL.
	*
	* @this {FileService}
	* @param {string}             share                               The share name.
	* @param {object}             [options]                           The request options.
	* @param {LocationMode}       [options.locationMode]              Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                 Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                 The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                 execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]           A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]         Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                 The default value is false.
	* @param {errorOrResult}      callback                            `error` will contain information
	*                                                                 if an error occurs; otherwise `[result]{@link ShareAclResult}` will contain
	*                                                                 information for the share.
	*                                                                 `response` will contain information related to this operation.
	*/
	FileService.prototype.getShareAcl = function (share, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	  
	  validate.validateArgs('getShareAcl', function (v) {
	    v.string(share, 'share');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	  
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.get(share)
	    .withQueryOption(QueryStringConstants.RESTYPE, 'share')
	    .withQueryOption(QueryStringConstants.COMP, 'acl');
	  
	  options.requestLocationMode = Constants.RequestLocationMode.PRIMARY_OR_SECONDARY;
	  
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.shareResult = null;
	    if (!responseObject.error) {
	      responseObject.shareResult = new ShareResult(share);
	      responseObject.shareResult.getPropertiesFromHeaders(responseObject.response.headers);
	      responseObject.shareResult.signedIdentifiers = AclResult.parse(responseObject.response.body);
	    }
	    
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.shareResult, returnObject.response);
	    };
	    
	    next(responseObject, finalCallback);
	  };
	  
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Updates the share's ACL.
	*
	* @this {FileService}
	* @param {string}                         share                               The share name.
	* @param {Object.<string, AccessPolicy>}  signedIdentifiers                   The share ACL settings. See `[AccessPolicy]{@link AccessPolicy}` for detailed information.
	* @param {object}                         [options]                           The request options.
	* @param {int}                            [options.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                            [options.clientRequestTimeoutInMs]  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                            [options.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                             The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                             execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}                         [options.clientRequestId]           A string that represents the client request ID with a 1KB character limit.
	* @param {bool}                           [options.useNagleAlgorithm]         Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                             The default value is false.
	* @param {errorOrResult}                  callback                            `error` will contain information
	*                                                                             if an error occurs; otherwise `[result]{@link ShareAclResult}` will contain
	*                                                                             information for the share.
	*                                                                             `response` will contain information related to this operation.
	*/
	FileService.prototype.setShareAcl = function (share, signedIdentifiers, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	  
	  validate.validateArgs('setShareAcl', function (v) {
	    v.string(share, 'share');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	  
	  var options = extend(true, {}, userOptions);
	  
	  var policies = null;
	  if (signedIdentifiers) {
	    if(_.isArray(signedIdentifiers)) {
	      throw new TypeError(SR.INVALID_SIGNED_IDENTIFIERS);
	    }
	    policies = AclResult.serialize(signedIdentifiers);
	  }
	  
	  var webResource = WebResource.put(share)
	    .withQueryOption(QueryStringConstants.RESTYPE, 'share')
	    .withQueryOption(QueryStringConstants.COMP, 'acl')
	    .withHeader(HeaderConstants.CONTENT_LENGTH, !azureutil.objectIsNull(policies) ? Buffer.byteLength(policies) : 0)
	    .withBody(policies);
	  
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.shareResult = null;
	    if (!responseObject.error) {
	      responseObject.shareResult = new ShareResult(share);
	      responseObject.shareResult.getPropertiesFromHeaders(responseObject.response.headers);
	      if (signedIdentifiers) {
	        responseObject.shareResult.signedIdentifiers = signedIdentifiers;
	      }
	    }
	    
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.shareResult, returnObject.response);
	    };
	    
	    next(responseObject, finalCallback);
	  };
	  
	  this.performRequest(webResource, webResource.body, options, processResponseCallback);
	};
	
	/**
	* Marks the specified share for deletion.
	* The share and any files contained within it are later deleted during garbage collection.
	*
	* @this {FileService}
	* @param {string}             share                               The share name.
	* @param {object}             [options]                           The request options.
	* @param {string}             [options.deleteSnapshots]           The snapshot delete option. See azure.FileUtilities.ShareSnapshotDeleteOptions.*. 
	* @param {string}             [options.shareSnapshotId]           The share snapshot identifier.
	* @param {LocationMode}       [options.locationMode]              Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                 Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                 The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                 execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]           A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]         Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                 The default value is false.
	* @param {errorOrResponse}  callback                              `error` will contain information
	*                                                                 if an error occurs; otherwise
	*                                                                 `response` will contain information related to this operation.
	*/
	FileService.prototype.deleteShare = function (share, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('deleteShare', function (v) {
	    v.string(share, 'share');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  if (!azureutil.objectIsNull(options.shareSnapshotId) && !azureutil.objectIsNull(options.deleteSnapshots)) {
	    throw new ArgumentError('options', SR.INVALID_DELETE_SNAPSHOT_OPTION);
	  }
	
	  var webResource = WebResource.del(share)
	    .withQueryOption(QueryStringConstants.RESTYPE, 'share')
	    .withQueryOption(QueryStringConstants.SHARE_SNAPSHOT, options.shareSnapshotId)
	    .withHeader(HeaderConstants.DELETE_SNAPSHOT, options.deleteSnapshots);
	
	  var processResponseCallback = function (responseObject, next) {
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Marks the specified share for deletion if it exists.
	* The share and any files contained within it are later deleted during garbage collection.
	*
	* @this {FileService}
	* @param {string}             share                               The share name.
	* @param {object}             [options]                           The request options.
	* @param {string}             [options.deleteSnapshots]           The snapshot delete option. See azure.FileUtilities.ShareSnapshotDeleteOptions.*. 
	* @param {string}             [options.shareSnapshotId]           The share snapshot identifier.
	* @param {LocationMode}       [options.locationMode]              Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                 Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                 The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                 execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]           A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]         Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                 The default value is false.
	* @param {errorOrResult}      callback                            `error` will contain information
	*                                                                 if an error occurs; otherwise `result` will 
	*                                                                 be true if the share exists and was deleted, or false if the share
	*                                                                 did not exist.
	*                                                                 `response` will contain information related to this operation.
	*/
	FileService.prototype.deleteShareIfExists = function (share, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('deleteShareIfExists', function (v) {
	    v.string(share, 'share');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var self = this;
	  self._doesShareExist(share, true, options, function (error, result, response) {
	    if(error){
	      callback(error, result.exists, response);
	    } else if (!result.exists) {
	      response.isSuccessful = true;
	      callback(error, false, response);
	    } else {
	      self.deleteShare(share, options, function (deleteError, deleteResponse) {
	        var deleted;
	        if (!deleteError){
	          deleted = true;
	        } else if (deleteError && deleteError.statuscode === HttpConstants.HttpResponseCodes.NotFound && deleteError.code === Constants.FileErrorCodeStrings.SHARE_NOT_FOUND) {
	          // If it was deleted already, there was no actual error.
	          deleted = false;
	          deleteError = null;
	          deleteResponse.isSuccessful = true;
	        }
	
	        callback(deleteError, deleted, deleteResponse);
	      });
	    }
	  });
	};
	
	// Directory methods
	
	/**
	* Checks whether or not a directory exists on the service.
	*
	* @this {FileService}
	* @param {string}             share                                   The share name.
	* @param {string}             directory                               The directory name. Use '' to refer to the base directory.
	* @param {object}             [options]                               The request options.
	* @param {string}             [options.shareSnapshotId]               The share snapshot identifier.
	* @param {LocationMode}       [options.locationMode]                  Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                     Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]           The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]      The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]      The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                     The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                     execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]               A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]             Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                     The default value is false.
	* @param {errorOrResult}      callback                                `error` will contain information
	*                                                                     if an error occurs; otherwise `[result]{@link DirectoryResult}` will contain
	*                                                                     the directory information including `exists` boolean member.
	*                                                                     `response` will contain information related to this operation.
	*/
	FileService.prototype.doesDirectoryExist = function (share, directory, optionsOrCallback, callback) {
	  this._doesDirectoryExist(share, directory, false, optionsOrCallback, callback);
	};
	
	/**
	* Creates a new directory under the specified account.
	* If a directory with the same name already exists, the operation fails.
	*
	* @this {FileService}
	* @param {string}             share                               The share name.
	* @param {string}             directory                           The directory name.
	* @param {object}             [options]                           The request options.
	* @param {object}             [options.metadata]                  The metadata key/value pairs.
	* @param {LocationMode}       [options.locationMode]              Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                 Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                 The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                 execution time is checked intermittently while performing requests, and before executing retries.    
	* @param {string}             [options.clientRequestId]           A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]         Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                 The default value is false.
	* @param {errorOrResult}      callback                            `error` will contain information
	*                                                                 if an error occurs; otherwise `[result]{@link DirectoryResult}` will contain
	*                                                                 the directory information.
	*                                                                 `response` will contain information related to this operation.
	*/
	FileService.prototype.createDirectory = function (share, directory, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('createDirectory', function (v) {
	    v.string(share, 'share');
	    v.string(directory, 'directory');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.put(createResourceName(share, directory))
	    .withQueryOption(QueryStringConstants.RESTYPE, 'directory');
	
	  webResource.addOptionalMetadataHeaders(options.metadata);
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.directoryResult = null;
	    if (!responseObject.error) {
	      responseObject.directoryResult = new DirectoryResult(directory);
	      responseObject.directoryResult.getPropertiesFromHeaders(responseObject.response.headers);
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.directoryResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Creates a new directory under the specified account if the directory does not exists.
	*
	* @this {FileService}
	* @param {string}             share                                     The share name.
	* @param {string}             directory                                 The directory name.
	* @param {object}             [options]                                 The request options.
	* @param {object}             [options.metadata]                        The metadata key/value pairs.
	* @param {LocationMode}       [options.locationMode]                    Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                       Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]             The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]        The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]        The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                       The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                       execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                 A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]               Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                       The default value is false.
	* @param {errorOrResult}      callback                                  `error` will contain information
	*                                                                       if an error occurs; otherwise `[result]{@link DirectoryResult}` will contain
	*                                                                       the directory information including `created` boolean member.
	*                                                                       already exists.
	*                                                                       `response` will contain information related to this operation.
	*
	* @example
	* var azure = require('azure-storage');
	* var FileService = azure.createFileService();
	* FileService.createDirectoryIfNotExists('taskshare', taskdirectory', function(error) {
	*   if(!error) {
	*     // Directory created or already existed
	*   }
	* }); 
	*/
	FileService.prototype.createDirectoryIfNotExists = function (share, directory, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('createDirectoryIfNotExists', function (v) {
	    v.string(share, 'share');
	    v.string(directory, 'directory');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  delete options.shareSnapshotId;
	  
	  var self = this;
	  self._doesDirectoryExist(share, directory, true, options, function(error, result, response) {
	    var exists = result.exists;
	    result.created = false;
	    delete result.exists;
	    
	    if(error){
	      callback(error, result, response);
	    } else if (exists) {
	      response.isSuccessful = true;
	      callback(error, result, response);
	    } else {
	      self.createDirectory(share, directory, options, function (createError, responseDirectory, createResponse) {
	        if(!createError){
	          responseDirectory.created = true;
	        }
	        else if (createError && createError.statusCode === HttpConstants.HttpResponseCodes.Conflict && createError.code === Constants.StorageErrorCodeStrings.RESOURCE_ALREADY_EXISTS) {
	          // If it was created before, there was no actual error.
	          createError = null;
	          createResponse.isSuccessful = true;
	        }
	
	        callback(createError, responseDirectory, createResponse);
	      });
	    }
	  });
	};
	
	/**
	* Retrieves a directory and its properties from a specified account.
	* **Note** that all metadata names returned from the server will be converted to lower case by NodeJS itself as metadata is set via HTTP headers and HTTP header names are case insensitive.
	*
	* @this {FileService}
	* @param {string}             share                               The share name.
	* @param {string}             directory                           The directory name. Use '' to refer to the base directory.
	* @param {object}             [options]                           The request options.
	* @param {string}             [options.shareSnapshotId]           The snapshot identifier of the share.
	* @param {LocationMode}       [options.locationMode]              Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                 Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                 The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                 execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]           A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]         Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                 The default value is false.
	* @param {errorOrResult}      callback                            `error` will contain information
	*                                                                 if an error occurs; otherwise `[result]{@link DirectoryResult}` will contain
	*                                                                 information for the directory.
	*                                                                 `response` will contain information related to this operation.
	*/
	FileService.prototype.getDirectoryProperties = function (share, directory, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('getDirectoryProperties', function (v) {
	    v.string(share, 'share');
	    v.stringAllowEmpty(directory, 'directory');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.head(createResourceName(share, directory))
	    .withQueryOption(QueryStringConstants.RESTYPE, 'directory')
	    .withQueryOption(QueryStringConstants.SHARE_SNAPSHOT, options.shareSnapshotId);
	    
	  var self = this;
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.directoryResult = null;
	    if (!responseObject.error) {
	      responseObject.directoryResult = new DirectoryResult(directory);
	      responseObject.directoryResult.metadata = self.parseMetadataHeaders(responseObject.response.headers);
	      responseObject.directoryResult.getPropertiesFromHeaders(responseObject.response.headers);
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.directoryResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Marks the specified directory for deletion. The directory must be empty before it can be deleted.
	*
	* @this {FileService}
	* @param {string}             share                               The share name.
	* @param {string}             directory                           The directory name.
	* @param {object}             [options]                           The request options.
	* @param {LocationMode}       [options.locationMode]              Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                 Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                 The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                 execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]           A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]         Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                 The default value is false.
	* @param {errorOrResponse}  callback                              `error` will contain information
	*                                                                 if an error occurs; otherwise
	*                                                                 `response` will contain information related to this operation.
	*/
	FileService.prototype.deleteDirectory = function (share, directory, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('deleteDirectory', function (v) {
	    v.string(share, 'share');
	    v.string(directory, 'directory');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.del(createResourceName(share, directory))
	    .withQueryOption(QueryStringConstants.RESTYPE, 'directory');
	  
	  var processResponseCallback = function (responseObject, next) {
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Marks the specified directory for deletion if it exists. The directory must be empty before it can be deleted.
	*
	* @this {FileService}
	* @param {string}             share                               The share name.
	* @param {string}             directory                           The directory name.
	* @param {object}             [options]                           The request options.
	* @param {LocationMode}       [options.locationMode]              Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                 Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                 The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                 execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]           A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]         Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                 The default value is false.
	* @param {errorOrResult}      callback                            `error` will contain information
	*                                                                 if an error occurs; otherwise `result` will 
	*                                                                 be true if the directory exists and was deleted, or false if the directory
	*                                                                 did not exist.
	*                                                                 `response` will contain information related to this operation.
	*/
	FileService.prototype.deleteDirectoryIfExists = function (share, directory, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('deleteDirectoryIfExists', function (v) {
	    v.string(share, 'share');
	    v.string(directory, 'directory');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  delete options.shareSnapshotId;
	
	  var self = this;
	  self._doesDirectoryExist(share, directory, true, options, function(error, result, response) {
	    if(error){
	      callback(error, result.exists, response);
	    } else if (!result.exists) {
	      response.isSuccessful = true;
	      callback(error, false, response);
	    } else {
	      self.deleteDirectory(share, directory, options, function (deleteError, deleteResponse) {
	        var deleted;
	        if (!deleteError){
	          deleted = true;
	        } else if (deleteError && deleteError.statuscode === HttpConstants.HttpResponseCodes.NotFound && deleteError.code === Constants.StorageErrorCodeStrings.RESOURCE_NOT_FOUND) {
	          // If it was deleted already, there was no actual error.
	          deleted = false;
	          deleteError = null;
	          deleteResponse.isSuccessful = true;
	        }
	
	        callback(deleteError, deleted, deleteResponse);
	      });
	    }
	  });
	};
	
	/**
	* Lists a segment containing a collection of file items in the directory.
	*
	* @this {FileService}
	* @param {string}             share                               The share name.
	* @param {string}             directory                           The directory name. Use '' to refer to the base directory.
	* @param {object}             currentToken                        A continuation token returned by a previous listing operation. Please use 'null' or 'undefined' if this is the first operation.
	* @param {object}             [options]                           The request options.
	* @param {string}             [options.shareSnapshotId]           The snapshot identifier of the share.
	* @param {int}                [options.maxResults]                Specifies the maximum number of files to return per call to Azure ServiceClient. This does NOT affect list size returned by this function. (maximum: 5000)
	* @param {LocationMode}       [options.locationMode]              Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                 Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                 The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                 execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]           A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]         Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                 The default value is false.
	* @param {errorOrResult}      callback                            `error` will contain information
	*                                                                 if an error occurs; otherwise `result` will contain
	*                                                                 entries.files which contains a list of `[files]{@link FileResult}`, entries.directories which contains a list of `[directories]{@link DirectoryResult}` and the continuationToken for the next listing operation.
	*                                                                 `response` will contain information related to this operation.
	*/
	FileService.prototype.listFilesAndDirectoriesSegmented = function (share, directory, currentToken, optionsOrCallback, callback) {
	  this.listFilesAndDirectoriesSegmentedWithPrefix(share, directory, null /*prefix*/, currentToken, optionsOrCallback, callback);
	};
	
	
	/**
	* Lists a segment containing a collection of file items in the directory.
	*
	* @this {FileService}
	* @param {string}             share                               The share name.
	* @param {string}             directory                           The directory name. Use '' to refer to the base directory.
	* @param {string}             prefix                              The prefix of the directory/files name.
	* @param {object}             currentToken                        A continuation token returned by a previous listing operation. Please use 'null' or 'undefined' if this is the first operation.
	* @param {object}             [options]                           The request options.
	* @param {string}             [options.shareSnapshotId]           The snapshot identifier of the share.
	* @param {int}                [options.maxResults]                Specifies the maximum number of files to return per call to Azure ServiceClient. This does NOT affect list size returned by this function. (maximum: 5000)
	* @param {LocationMode}       [options.locationMode]              Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                 Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                 The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                 execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]           A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]         Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                 The default value is false.
	* @param {errorOrResult}      callback                            `error` will contain information
	*                                                                 if an error occurs; otherwise `result` will contain
	*                                                                 entries.files which contains a list of `[files]{@link FileResult}`, entries.directories which contains a list of `[directories]{@link DirectoryResult}` and the continuationToken for the next listing operation.
	*                                                                 `response` will contain information related to this operation.
	*/
	FileService.prototype.listFilesAndDirectoriesSegmentedWithPrefix = function (share, directory, prefix, currentToken, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('listFilesSegmented', function (v) {
	    v.string(share, 'share');
	    v.stringAllowEmpty(directory, 'directory');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.get(createResourceName(share, directory))
	    .withQueryOption(QueryStringConstants.RESTYPE, 'directory')
	    .withQueryOption(QueryStringConstants.COMP, 'list')
	    .withQueryOption(QueryStringConstants.MAX_RESULTS, options.maxResults)
	    .withQueryOption(QueryStringConstants.SHARE_SNAPSHOT, options.shareSnapshotId);
	
	  if (!azureutil.objectIsNull(currentToken)) {
	    webResource.withQueryOption(QueryStringConstants.MARKER, currentToken.nextMarker);
	  }
	
	  webResource.withQueryOption(QueryStringConstants.PREFIX, prefix);
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.listResult = null;
	    if (!responseObject.error) {
	      responseObject.listResult = {
	        entries: null,
	        continuationToken: null
	      };
	
	      responseObject.listResult.entries = {};
	      responseObject.listResult.entries.files = [];
	      responseObject.listResult.entries.directories = [];
	      var files = [];
	      var directories = [];
	
	      // parse files
	      if (responseObject.response.body.EnumerationResults.Entries.File) {
	        files = responseObject.response.body.EnumerationResults.Entries.File;
	        if (!_.isArray(files)) {
	          files = [ files ];
	        }
	      }
	
	      files.forEach(function (currentFile) {
	        var fileResult = FileResult.parse(currentFile);
	        responseObject.listResult.entries.files.push(fileResult);
	      });
	
	      // parse directories
	      if (responseObject.response.body.EnumerationResults.Entries.Directory) {
	        directories = responseObject.response.body.EnumerationResults.Entries.Directory;
	        if (!_.isArray(directories)) {
	          directories = [ directories ];
	        }
	      }
	
	      directories.forEach(function (currentDirectory) {
	        var directoryResult = DirectoryResult.parse(currentDirectory);
	        responseObject.listResult.entries.directories.push(directoryResult);
	      });
	
	      // parse continuation token
	      if(responseObject.response.body.EnumerationResults.NextMarker) {
	        responseObject.listResult.continuationToken = {
	          nextMarker: null,
	          targetLocation: null
	        };
	
	        responseObject.listResult.continuationToken.nextMarker = responseObject.response.body.EnumerationResults.NextMarker;
	        responseObject.listResult.continuationToken.targetLocation = responseObject.targetLocation;
	      }
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.listResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Returns all user-defined metadata for the specified directory.
	* **Note** that all metadata names returned from the server will be converted to lower case by NodeJS itself as metadata is set via HTTP headers and HTTP header names are case insensitive.
	*
	* @this {FileService}
	* @param {string}             share                                       The share name.
	* @param {string}             directory                                   The directory name. Use '' to refer to the base directory.
	* @param {object}             [options]                                   The request options.
	* @param {string}             [options.shareSnapshotId]                   The snapshot identifier of the share.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information
	*                                                                         if an error occurs; otherwise `[result]{@link DirectoryResult}` will contain
	*                                                                         information about the directory.
	*                                                                         `response` will contain information related to this operation.
	*/
	FileService.prototype.getDirectoryMetadata = function (share, directory, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	  
	  validate.validateArgs('getDirectoryMetadata', function (v) {
	    v.string(share, 'share');
	    v.stringAllowEmpty(directory, 'directory');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	  
	  var options = extend(true, {}, userOptions);
	  var resourceName = createResourceName(share, directory);
	  var webResource = WebResource.head(resourceName)
	    .withQueryOption(QueryStringConstants.RESTYPE, 'directory')
	    .withQueryOption(QueryStringConstants.COMP, 'metadata')
	    .withQueryOption(QueryStringConstants.SHARE_SNAPSHOT, options.shareSnapshotId);
	
	  var self = this;
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.directoryResult = null;
	    if (!responseObject.error) {
	      responseObject.directoryResult = new DirectoryResult(directory);
	      responseObject.directoryResult.metadata = self.parseMetadataHeaders(responseObject.response.headers);
	      responseObject.directoryResult.getPropertiesFromHeaders(responseObject.response.headers);
	    }
	    
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.directoryResult, returnObject.response);
	    };
	    
	    next(responseObject, finalCallback);
	  };
	  
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Sets user-defined metadata for the specified directory as one or more name-value pairs 
	*
	* @this {FileService}
	* @param {string}             share                                       The share name.
	* @param {string}             directory                                   The directory name. Use '' to refer to the base directory.
	* @param {object}             metadata                                    The metadata key/value pairs.
	* @param {object}             [options]                                   The request options.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information
	*                                                                         if an error occurs; otherwise `[result]{@link DirectoryResult}` will contain
	*                                                                         information on the directory.
	*                                                                         `response` will contain information related to this operation.
	*/
	FileService.prototype.setDirectoryMetadata = function (share, directory, metadata, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	  
	  validate.validateArgs('setDirectoryMetadata', function (v) {
	    v.string(share, 'share');
	    v.stringAllowEmpty(directory, 'directory');
	    v.shareNameIsValid(share);
	    v.object(metadata, 'metadata');
	    v.callback(callback);
	  });
	  
	  var options = extend(true, {}, userOptions);
	  var resourceName = createResourceName(share, directory);
	  var webResource = WebResource.put(resourceName)
	    .withQueryOption(QueryStringConstants.RESTYPE, 'directory')
	    .withQueryOption(QueryStringConstants.COMP, 'metadata');
	  
	  webResource.addOptionalMetadataHeaders(metadata);
	  
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.directoryResult = null;
	    if (!responseObject.error) {
	      responseObject.directoryResult = new DirectoryResult(directory);
	      responseObject.directoryResult.getPropertiesFromHeaders(responseObject.response.headers);
	    }
	    
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.directoryResult, returnObject.response);
	    };
	    
	    next(responseObject, finalCallback);
	  };
	  
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	// File methods
	
	/**
	* Retrieves a shared access signature token.
	*
	* @this {FileService}
	* @param {string}                   share                                               The share name.
	* @param {string}                   [directory]                                         The directory name. Use '' to refer to the base directory.
	* @param {string}                   [file]                                              The file name.
	* @param {object}                   sharedAccessPolicy                                  The shared access policy.
	* @param {string}                   [sharedAccessPolicy.Id]                             The signed identifier.
	* @param {object}                   [sharedAccessPolicy.AccessPolicy.Permissions]       The permission type.
	* @param {date|string}              [sharedAccessPolicy.AccessPolicy.Start]             The time at which the Shared Access Signature becomes valid (The UTC value will be used).
	* @param {date|string}              [sharedAccessPolicy.AccessPolicy.Expiry]            The time at which the Shared Access Signature becomes expired (The UTC value will be used).
	* @param {string}                   [sharedAccessPolicy.AccessPolicy.IPAddressOrRange]  An IP address or a range of IP addresses from which to accept requests. When specifying a range, note that the range is inclusive.
	* @param {string}                   [sharedAccessPolicy.AccessPolicy.Protocols]         The protocols permitted for a request made with the account SAS. 
	*                                                                                       Possible values are both HTTPS and HTTP (https,http) or HTTPS only (https). The default value is https,http.
	* @param {object}                   [headers]                                           The optional header values to set for a file returned wth this SAS.
	* @param {string}                   [headers.cacheControl]                              The optional value of the Cache-Control response header to be returned when this SAS is used.
	* @param {string}                   [headers.contentType]                               The optional value of the Content-Type response header to be returned when this SAS is used.
	* @param {string}                   [headers.contentEncoding]                           The optional value of the Content-Encoding response header to be returned when this SAS is used.
	* @param {string}                   [headers.contentLanguage]                           The optional value of the Content-Language response header to be returned when this SAS is used.
	* @param {string}                   [headers.contentDisposition]                        The optional value of the Content-Disposition response header to be returned when this SAS is used.
	* @return {string}                                                                      The shared access signature query string. Note this string does not contain the leading "?".
	*/
	FileService.prototype.generateSharedAccessSignature = function (share, directory, file, sharedAccessPolicy, headers) {
	  // check if the FileService is able to generate a shared access signature
	  if (!this.storageCredentials || !this.storageCredentials.generateSignedQueryString) {
	    throw new Error(SR.CANNOT_CREATE_SAS_WITHOUT_ACCOUNT_KEY);
	  }
	
	  // Validate share name. File name is optional.
	  validate.validateArgs('generateSharedAccessSignature', function (v) {
	    v.string(share, 'share');
	    v.shareNameIsValid(share);
	    v.object(sharedAccessPolicy, 'sharedAccessPolicy');
	  });
	
	  var resourceType = FileConstants.ResourceTypes.SHARE;
	  if (file) {
	    validate.validateArgs('generateSharedAccessSignature', function (v) {
	      v.stringAllowEmpty(directory, 'directory');
	      v.string(file, 'file');
	    });
	    resourceType = FileConstants.ResourceTypes.FILE;
	  } else {
	    directory = ''; // If file is not set, directory is not a part of the string to sign.
	  }
	
	  if (sharedAccessPolicy.AccessPolicy) {
	    if (!azureutil.objectIsNull(sharedAccessPolicy.AccessPolicy.Start)) {
	      if (!_.isDate(sharedAccessPolicy.AccessPolicy.Start)) {
	        sharedAccessPolicy.AccessPolicy.Start = new Date(sharedAccessPolicy.AccessPolicy.Start);
	      }
	 
	      sharedAccessPolicy.AccessPolicy.Start = azureutil.truncatedISO8061Date(sharedAccessPolicy.AccessPolicy.Start);
	    }
	
	    if (!azureutil.objectIsNull(sharedAccessPolicy.AccessPolicy.Expiry)) {
	      if (!_.isDate(sharedAccessPolicy.AccessPolicy.Expiry)) {
	        sharedAccessPolicy.AccessPolicy.Expiry = new Date(sharedAccessPolicy.AccessPolicy.Expiry);
	      }
	
	      sharedAccessPolicy.AccessPolicy.Expiry = azureutil.truncatedISO8061Date(sharedAccessPolicy.AccessPolicy.Expiry);
	    }
	  }
	
	  var resourceName = createResourceName(share, directory, file, true);
	  return this.storageCredentials.generateSignedQueryString(Constants.ServiceType.File, resourceName, sharedAccessPolicy, null, { headers: headers, resourceType: resourceType });
	};
	
	/**
	* Retrieves a file or directory URL.
	*
	* @param {string}                   share                    The share name.
	* @param {string}                   directory                The directory name. Use '' to refer to the base directory.
	* @param {string}                   [file]                   The file name. File names may not start or end with the delimiter '/'.
	* @param {string}                   [sasToken]               The Shared Access Signature token.
	* @param {boolean}                  [primary]                A boolean representing whether to use the primary or the secondary endpoint.
	* @param {string}                   [shareSnapshotId]        The snapshot identifier of the share.
	* @return {string}                                           The formatted URL string.
	* @example
	* var azure = require('azure-storage');
	* var fileService = azure.createFileService();
	* var sharedAccessPolicy = {
	*   AccessPolicy: {
	*     Permissions: azure.FileUtilities.SharedAccessPermissions.READ,
	*     Start: startDate,
	*     Expiry: expiryDate
	*   },
	* };
	* 
	* var sasToken = fileService.generateSharedAccessSignature(shareName, directoryName, fileName, sharedAccessPolicy);
	* var url = fileService.getUrl(shareName, directoryName, fileName, sasToken, true);
	*/
	FileService.prototype.getUrl = function (share, directory, file, sasToken, primary, shareSnapshotId) {
	  validate.validateArgs('getUrl', function (v) {
	    v.string(share, 'share');
	    v.stringAllowEmpty(directory, 'directory');
	    v.shareNameIsValid(share);
	  });
	
	  var host;
	  if(!azureutil.objectIsNull(primary) && primary === false) {
	    host = this.host.secondaryHost;
	  } else {
	    host = this.host.primaryHost;
	  }
	  host = azureutil.trimPortFromUri(host);
	  if(host && host.lastIndexOf('/') !== (host.length - 1)){
	    host = host + '/';
	  }
	
	  var name = createResourceName(share, directory, file);
	  var query = qs.parse(sasToken);
	  if(shareSnapshotId) {
	    query[QueryStringConstants.SHARE_SNAPSHOT] = shareSnapshotId;
	  }
	  return url.resolve(host, url.format({pathname: this._getPath(name), query: query}));
	};
	
	/**
	* Returns all user-defined metadata, standard HTTP properties, and system properties for the file.
	* It does not return or modify the content of the file.
	* **Note** that all metadata names returned from the server will be converted to lower case by NodeJS itself as metadata is set via HTTP headers and HTTP header names are case insensitive.
	*
	* @this {FileService}
	* @param {string}             share                                       The share name.
	* @param {string}             directory                                   The directory name. Use '' to refer to the base directory.
	* @param {string}             file                                        The file name. File names may not start or end with the delimiter '/'.
	* @param {object}             [options]                                   The request options.
	* @param {string}             [options.shareSnapshotId]                   The snapshot identifier of the share.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information
	*                                                                         if an error occurs; otherwise `[result]{@link FileResult}` will contain
	*                                                                         information about the file.
	*                                                                         `response` will contain information related to this operation.
	*/
	FileService.prototype.getFileProperties = function (share, directory, file, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('getFileProperties', function (v) {
	    v.string(share, 'share');
	    v.stringAllowEmpty(directory, 'directory');
	    v.string(file, 'file');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var resourceName = createResourceName(share, directory, file);
	  var webResource = WebResource.head(resourceName)
	    .withQueryOption(QueryStringConstants.SHARE_SNAPSHOT, options.shareSnapshotId);
	
	  var self = this;
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.fileResult = null;
	    if (!responseObject.error) {
	      responseObject.fileResult = new FileResult(share, directory, file);
	      responseObject.fileResult.metadata = self.parseMetadataHeaders(responseObject.response.headers);
	      responseObject.fileResult.getPropertiesFromHeaders(responseObject.response.headers, true);
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.fileResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Returns all user-defined metadata for the specified file.
	* It does not modify or return the content of the file.
	* **Note** that all metadata names returned from the server will be converted to lower case by NodeJS itself as metadata is set via HTTP headers and HTTP header names are case insensitive.
	*
	* @this {FileService}
	* @param {string}             share                                       The share name.
	* @param {string}             directory                                   The directory name. Use '' to refer to the base directory.
	* @param {string}             file                                        The file name. File names may not start or end with the delimiter '/'.
	* @param {object}             [options]                                   The request options.
	* @param {string}             [options.shareSnapshotId]                   The snapshot identifier of the share.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information
	*                                                                         if an error occurs; otherwise `[result]{@link FileResult}` will contain
	*                                                                         information about the file.
	*                                                                         `response` will contain information related to this operation.
	*/
	FileService.prototype.getFileMetadata = function (share, directory, file, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('getFileMetadata', function (v) {
	    v.string(share, 'share');
	    v.stringAllowEmpty(directory, 'directory');
	    v.string(file, 'file');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var resourceName = createResourceName(share, directory, file);
	  var webResource = WebResource.head(resourceName)
	    .withQueryOption(QueryStringConstants.COMP, 'metadata')
	    .withQueryOption(QueryStringConstants.SHARE_SNAPSHOT, options.shareSnapshotId);
	
	  var self = this;
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.fileResult = null;
	    if (!responseObject.error) {
	      responseObject.fileResult = new FileResult(share, directory, file);
	      responseObject.fileResult.metadata = self.parseMetadataHeaders(responseObject.response.headers);
	      responseObject.fileResult.getPropertiesFromHeaders(responseObject.response.headers);
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.fileResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Sets user-defined properties for the specified file.
	* It does not modify or return the content of the file.
	*
	* @this {FileService}
	* @param {string}             share                                       The share name.
	* @param {string}             directory                                   The directory name. Use '' to refer to the base directory.
	* @param {string}             file                                        The file name. File names may not start or end with the delimiter '/'.
	* @param {object}             [properties]                                The file properties to set.
	* @param {string}             [properties.contentType]                    The MIME content type of the file. The default type is application/octet-stream.
	* @param {string}             [properties.contentEncoding]                The content encodings that have been applied to the file.
	* @param {string}             [properties.contentLanguage]                The natural languages used by this resource.
	* @param {string}             [properties.cacheControl]                   The file's cache control.
	* @param {string}             [properties.contentDisposition]             The file's content disposition.
	* @param {string}             [properties.contentLength]                  Resizes a file to the specified size. If the specified byte value is less than the current size of the file, 
	*                                                                         then all ranges above the specified byte value are cleared.
	* @param {string}             [properties.contentMD5]                     The file's MD5 hash.
	* @param {object}             [options]                                   The request options.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information
	*                                                                         if an error occurs; otherwise `[result]{@link FileResult}` will contain
	*                                                                         information about the file.
	*                                                                         `response` will contain information related to this operation.
	*/
	FileService.prototype.setFileProperties = function (share, directory, file, properties, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('setFileProperties', function (v) {
	    v.string(share, 'share');
	    v.stringAllowEmpty(directory, 'directory');
	    v.string(file, 'file');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {contentSettings: properties, contentLength: properties.contentLength }, userOptions);
	  var resourceName = createResourceName(share, directory, file);
	  var webResource = WebResource.put(resourceName)
	    .withQueryOption(QueryStringConstants.COMP, 'properties');
	
	  FileResult.setProperties(webResource, options);
	
	  var processResponseCallback = function(responseObject, next) {
	    responseObject.fileResult = null;
	    if (!responseObject.error) {
	      responseObject.fileResult = new FileResult(share, directory, file);
	      responseObject.fileResult.getPropertiesFromHeaders(responseObject.response.headers);
	    }
	    
	    var finalCallback = function(returnObject) {
	      callback(returnObject.error, returnObject.fileResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	  
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Sets user-defined metadata for the specified file as one or more name-value pairs 
	* It does not modify or return the content of the file.
	*
	* @this {FileService}
	* @param {string}             share                                       The share name.
	* @param {string}             directory                                   The directory name. Use '' to refer to the base directory.
	* @param {string}             file                                        The file name. File names may not start or end with the delimiter '/'.
	* @param {object}             metadata                                    The metadata key/value pairs.
	* @param {object}             [options]                                   The request options.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information
	*                                                                         if an error occurs; otherwise `[result]{@link FileResult}` will contain
	*                                                                         information on the file.
	*                                                                         `response` will contain information related to this operation.
	*/
	FileService.prototype.setFileMetadata = function (share, directory, file, metadata, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('setFileMetadata', function (v) {
	    v.string(share, 'share');
	    v.stringAllowEmpty(directory, 'directory');
	    v.string(file, 'file');
	    v.shareNameIsValid(share);
	    v.object(metadata, 'metadata');
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var resourceName = createResourceName(share, directory, file);
	  var webResource = WebResource.put(resourceName)
	    .withQueryOption(QueryStringConstants.COMP, 'metadata');
	
	  webResource.addOptionalMetadataHeaders(metadata);
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.fileResult = null;
	    if (!responseObject.error) {
	      responseObject.fileResult = new FileResult(share, directory, file);
	      responseObject.fileResult.getPropertiesFromHeaders(responseObject.response.headers);
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.fileResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Resizes a file.
	*
	* @this {FileService}
	* @param {string}               share                                       The share name.
	* @param {string}               directory                                   The directory name. Use '' to refer to the base directory.
	* @param {string}               file                                        The file name. File names may not start or end with the delimiter '/'.
	* @param {String}               size                                        The size of the file, in bytes.
	* @param {object}               [options]                                   The request options.
	* @param {int}                  [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                  [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                  [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}               [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}                 [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResult}        callback                                    `error` will contain information
	*                                                                           if an error occurs; otherwise `[result]{@link FileResult}` will contain
	*                                                                           information about the file.
	*                                                                           `response` will contain information related to this operation.
	*/
	FileService.prototype.resizeFile = function (share, directory, file, size, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('resizeFile', function (v) {
	    v.string(share, 'share');
	    v.stringAllowEmpty(directory, 'directory');
	    v.string(file, 'file');
	    v.shareNameIsValid(share);
	    v.value(size);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var resourceName = createResourceName(share, directory, file);
	  var webResource = WebResource.put(resourceName)
	    .withQueryOption(QueryStringConstants.COMP, 'properties');
	
	  webResource.withHeader(HeaderConstants.FILE_CONTENT_LENGTH, size);
	
	  var processResponseCallback = function(responseObject, next) {
	    responseObject.fileResult = null;
	    if (!responseObject.error) {
	      responseObject.fileResult = new FileResult(share, directory, file);
	      responseObject.fileResult.getPropertiesFromHeaders(responseObject.response.headers);
	    }
	    
	    var finalCallback = function(returnObject) {
	      callback(returnObject.error, returnObject.fileResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	  
	  this.performRequest(webResource, null, options, processResponseCallback);  
	};
	
	/**
	* Checks whether or not a file exists on the service.
	*
	* @this {FileService}
	* @param {string}             share                                   The share name.
	* @param {string}             directory                               The directory name. Use '' to refer to the base directory.
	* @param {string}             file                                    The file name. File names may not start or end with the delimiter '/'.
	* @param {object}             [options]                               The request options.
	* @param {string}             [options.shareSnapshotId]               The snapshot identifier of the share.
	* @param {LocationMode}       [options.locationMode]                  Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                     Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]           The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]      The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]      The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                     The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                     execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]               A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]             Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                     The default value is false.
	* @param {Function(error, result, response)}  callback                `error` will contain information
	*                                                                     if an error occurs; otherwise `[result]{@link FileResult}` will contain
	*                                                                     the file information including the `exists` boolean member. 
	*                                                                     `response` will contain information related to this operation.
	*/
	FileService.prototype.doesFileExist = function (share, directory, file, optionsOrCallback, callback) {
	  this._doesFileExist(share, directory, file, false, optionsOrCallback, callback);
	};
	
	/**
	* Creates a file of the specified length. If the file already exists on the service, it will be overwritten.
	*
	* @this {FileService}
	* @param {string}             share                                         The share name.
	* @param {string}             directory                                     The directory name. Use '' to refer to the base directory.
	* @param {string}             file                                          The file name. File names may not start or end with the delimiter '/'.
	* @param {int}                length                                        The length of the file in bytes.
	* @param {object}             [options]                                     The request options.
	* @param {object}             [options.contentSettings]                     The file's content settings.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the file. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the file.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The file service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The file's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The file's MD5 hash.
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResult}      callback                                      `error` will contain information
	*                                                                           if an error occurs; otherwise `[result]{@link FileResult}` will contain
	*                                                                           the file information.
	*                                                                           `response` will contain information related to this operation.
	*/
	FileService.prototype.createFile = function (share, directory, file, length, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	  validate.validateArgs('createFile', function (v) {
	    v.string(share, 'share');
	    v.stringAllowEmpty(directory, 'directory');
	    v.string(file, 'file');
	    v.shareNameIsValid(share);
	    v.value(length);
	    v.callback(callback);
	  });
	
	  var resourceName = createResourceName(share, directory, file);
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.put(resourceName)
	    .withHeader(HeaderConstants.TYPE, 'file')
	    .withHeader(HeaderConstants.FILE_CONTENT_LENGTH, length);
	
	  FileResult.setProperties(webResource, options);
	
	  var processResponseCallback = function(responseObject, next) {
	    responseObject.fileResult = null;
	    if (!responseObject.error) {
	      responseObject.fileResult = new FileResult(share, directory, file);
	      responseObject.fileResult.getPropertiesFromHeaders(responseObject.response.headers);
	    }
	    
	    var finalCallback = function(returnObject) {
	      callback(returnObject.error, returnObject.fileResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Marks the specified file for deletion. The file is later deleted during garbage collection.
	*
	* @this {FileService}
	* @param {string}             share                                       The share name.
	* @param {string}             directory                                   The directory name. Use '' to refer to the base directory.
	* @param {string}             file                                        The file name. File names may not start or end with the delimiter '/'.
	* @param {object}             [options]                                   The request options.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResponse}  callback                                      `error` will contain information
	*                                                                         if an error occurs; `response` will contain information related to this operation.
	*/
	FileService.prototype.deleteFile = function (share, directory, file, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('deleteFile', function (v) {
	    v.string(share, 'share');
	    v.stringAllowEmpty(directory, 'directory');
	    v.string(file, 'file');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var resourceName = createResourceName(share, directory, file);
	  var webResource = WebResource.del(resourceName);
	
	  var processResponseCallback = function (responseObject, next) {
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Marks the specified file for deletion if it exists. The file is later deleted during garbage collection.
	*
	* @this {FileService}
	* @param {string}             share                               The share name.
	* @param {string}             directory                           The directory name. Use '' to refer to the base directory.
	* @param {string}             file                                The file name. File names may not start or end with the delimiter '/'. 
	* @param {object}             [options]                           The request options.
	* @param {LocationMode}       [options.locationMode]              Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                 Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                 The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                 execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]           A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]         Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                 The default value is false.
	* @param {errorOrResult}      callback                            `error` will contain information
	*                                                                 if an error occurs; otherwise `result` will
	*                                                                 be true if the file was deleted, or false if the file
	*                                                                 does not exist.
	*                                                                 `response` will contain information related to this operation.
	*/
	FileService.prototype.deleteFileIfExists = function (share, directory, file, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('deleteFileIfExists', function (v) {
	    v.string(share, 'share');
	    v.stringAllowEmpty(directory, 'directory');
	    v.string(file, 'file');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  delete options.shareSnapshotId;
	
	  var self = this;
	  self._doesFileExist(share, directory, file, true, options, function(error, result, response) {
	    if(error){
	      callback(error, result.exists, response);
	    } else if (!result.exists) {
	      response.isSuccessful = true;
	      callback(error, false, response);
	    } else {
	      self.deleteFile(share, directory, file, options, function (deleteError, deleteResponse) {
	        var deleted;
	        if (!deleteError){
	          deleted = true;
	        } else if (deleteError && deleteError.statusCode === Constants.HttpConstants.HttpResponseCodes.NotFound && deleteError.code === Constants.FileErrorCodeStrings.FILE_NOT_FOUND) {
	          // If it was deleted already, there was no actual error.
	          deleted = false;
	          deleteError = null;
	          deleteResponse.isSuccessful = true;
	        }
	
	        callback(deleteError, deleted, deleteResponse);
	      });
	    }
	  });
	};
	
	/**
	* Downloads a file into a text string.
	*
	* @this {FileService}
	* @param {string}             share                                       The share name.
	* @param {string}             directory                                   The directory name. Use '' to refer to the base directory.
	* @param {string}             file                                        The file name. File names may not start or end with the delimiter '/'.
	* @param {object}             [options]                                   The request options.
	* @param {string}             [options.shareSnapshotId]                   The snapshot identifier of the share.
	* @param {int}                [options.rangeStart]                        The range start.
	* @param {int}                [options.rangeEnd]                          The range end.
	* @param {boolean}            [options.disableContentMD5Validation]       When set to true, MD5 validation will be disabled when downloading files.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {FileService~FileToText}  callback                               `error` will contain information
	*                                                                         if an error occurs; otherwise `text` will contain the file contents,
	*                                                                         and `[file]{@link FileResult}` will contain the file information.
	*                                                                         `response` will contain information related to this operation.
	*/
	FileService.prototype.getFileToText = function (share, directory, file, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('getFileToText', function (v) {
	    v.string(share, 'share');
	    v.stringAllowEmpty(directory, 'directory');
	    v.string(file, 'file');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var resourceName = createResourceName(share, directory, file);
	  var webResource = WebResource.get(resourceName)
	    .withQueryOption(QueryStringConstants.SHARE_SNAPSHOT, options.shareSnapshotId)
	    .withRawResponse();
	
	  FileResult.setHeaders(webResource, options);
	  this._setRangeContentMD5Header(webResource, options);
	
	  var self = this;
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.text = null;
	    responseObject.fileResult = null;
	
	    if (!responseObject.error) {
	      responseObject.fileResult = new FileResult(share, directory, file);
	      responseObject.fileResult.getPropertiesFromHeaders(responseObject.response.headers, true);
	      responseObject.fileResult.metadata = self.parseMetadataHeaders(responseObject.response.headers);
	      responseObject.text = responseObject.response.body;
	
	      self._validateLengthAndMD5(options, responseObject);
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.text, returnObject.fileResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Provides a stream to read from a file.
	*
	* @this {FileService}
	* @param {string}             share                                       The share name.
	* @param {string}             directory                                   The directory name. Use '' to refer to the base directory.
	* @param {string}             file                                        The file name. File names may not start or end with the delimiter '/'.
	* @param {object}             [options]                                   The request options.
	* @param {string}             [options.shareSnapshotId]                   The snapshot identifier of the share.
	* @param {string}             [options.rangeStart]                        Return only the bytes of the file in the specified range.
	* @param {string}             [options.rangeEnd]                          Return only the bytes of the file in the specified range.
	* @param {boolean}            [options.useTransactionalMD5]               When set to true, Calculate and send/validate content MD5 for transactions.
	* @param {boolean}            [options.disableContentMD5Validation]       When set to true, MD5 validation will be disabled when downloading files.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information if an error occurs; 
	*                                                                         otherwise `[result]{@link FileResult}` will contain the file information.
	*                                                                         `response` will contain information related to this operation.
	* @return {Readable}                                                      A Node.js Readable stream.
	* @example
	* var azure = require('azure-storage');
	* var fileService = azure.createFileService();
	* var writable = fs.createWriteStream(destinationFileNameTarget);
	* fileService.createReadStream(shareName, directoryName, fileName).pipe(writable);
	*/
	FileService.prototype.createReadStream = function (share, directory, file, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('createReadStream', function (v) {
	    v.string(share, 'share');
	    v.stringAllowEmpty(directory, 'directory');
	    v.string(file, 'file');
	    v.shareNameIsValid(share);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  var readStream = new ChunkStream(options);
	  this.getFileToStream(share, directory, file, readStream, options, function (error, fileResponse, response) {
	    if(error) {
	      readStream.emit('error', error);
	    }
	
	    if(callback) {
	      callback(error, fileResponse, response);
	    }
	  });
	
	  return readStream;
	};
	
	/**
	* Downloads a file into a stream.
	*
	* @this {FileService}
	* @param {string}             share                                       The share name.
	* @param {string}             directory                                   The directory name. Use '' to refer to the base directory.
	* @param {string}             file                                        The file name. File names may not start or end with the delimiter '/'.
	* @param {Writable}           writeStream                                 The Node.js Writable stream.
	* @param {object}             [options]                                   The request options.
	* @param {string}             [options.shareSnapshotId]                   The snapshot identifier of the share.
	* @param {boolean}            [options.skipSizeCheck]                     Skip the size check to perform direct download.
	*                                                                         Set the option to true for small files.
	*                                                                         Parallel download and speed summary won't work with this option on.
	* @param {SpeedSummary}       [options.speedSummary]                      The download tracker objects.
	* @param {int}                [options.parallelOperationThreadCount]      The number of parallel operations that may be performed when uploading.
	* @param {string}             [options.rangeStart]                        Return only the bytes of the file in the specified range.
	* @param {string}             [options.rangeEnd]                          Return only the bytes of the file in the specified range. 
	* @param {boolean}            [options.useTransactionalMD5]               When set to true, Calculate and send/validate content MD5 for transactions.
	* @param {boolean}            [options.disableContentMD5Validation]       When set to true, MD5 validation will be disabled when downloading files.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information if an error occurs; 
	*                                                                         otherwise `[result]{@link FileResult}` will contain the file information.
	*                                                                         `response` will contain information related to this operation.
	* @return {SpeedSummary}
	* 
	*
	* @example
	* var azure = require('azure-storage');
	* var FileService = azure.createFileService();
	* FileService.getFileToStream('taskshare', taskdirectory', 'task1', fs.createWriteStream('task1-download.txt'), function(error, serverFile) {
	*   if(!error) {
	*     // file available in serverFile.file variable
	*   }
	* }); 
	*/
	FileService.prototype.getFileToStream = function (share, directory, file, writeStream, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	  userOptions.speedSummary = userOptions.speedSummary || new SpeedSummary(file);  
	  
	  validate.validateArgs('getFileToStream', function (v) {
	    v.string(share, 'share');
	    v.stringAllowEmpty(directory, 'directory');
	    v.string(file, 'file');
	    v.object(writeStream, 'writeStream');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  var propertiesRequestOptions = {
	    timeoutIntervalInMs : options.timeoutIntervalInMs,
	    clientRequestTimeoutInMs : options.clientRequestTimeoutInMs,
	    accessConditions : options.accessConditions,
	    shareSnapshotId : options.shareSnapshotId
	  };
	  
	  if (options.skipSizeCheck) {
	    this._getFileToStream(share, directory, file, writeStream, options, callback);
	  } else {
	    var self = this;
	    this.getFileProperties(share, directory, file, propertiesRequestOptions, function (error, properties) {
	      if (error) {
	        callback(error);
	      } else {
	        var size;
	        if (options.rangeStart) {
	          var endOffset = properties.contentLength - 1;
	          var end = options.rangeEnd ? Math.min(options.rangeEnd, endOffset) : endOffset;
	          size = end - options.rangeStart + 1;
	        } else {
	          size = properties.contentLength;
	        }
	        options.speedSummary.totalSize = size;
	        
	        if (size > self.singleFileThresholdInBytes) {
	          azureutil.setObjectInnerPropertyValue(options, ['contentSettings', 'contentMD5'], azureutil.tryGetValueChain(properties, ['contentSettings', 'contentMD5'], null));
	          self._getFileToRangeStream(share, directory, file, writeStream, options, callback);
	        } else {
	          self._getFileToStream(share, directory, file, writeStream, options, callback);
	        }
	      }
	    });
	  }
	  
	  return options.speedSummary;
	};
	
	/**
	* Lists file ranges. Lists all of the ranges by default, or only the ranges over a specific range of bytes if rangeStart and rangeEnd are specified.
	*
	* @this {FileService}
	* @param {string}             share                                       The share name.
	* @param {string}             directory                                   The directory name. Use '' to refer to the base directory.
	* @param {string}             file                                        The file name. File names may not start or end with the delimiter '/'.
	* @param {object}             [options]                                   The request options.
	* @param {string}             [options.shareSnapshotId]                   The snapshot identifier of the share.
	* @param {int}                [options.rangeStart]                        The range start.
	* @param {int}                [options.rangeEnd]                          The range end.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information
	*                                                                         if an error occurs; otherwise `[result]{@link FileResult}` will contain
	*                                                                         the range information.
	*                                                                         `response` will contain information related to this operation.
	*/
	FileService.prototype.listRanges = function (share, directory, file, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('listRanges', function (v) {
	    v.string(share, 'share');
	    v.stringAllowEmpty(directory, 'directory');
	    v.string(file, 'file');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	
	  var resourceName = createResourceName(share, directory, file);
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.get(resourceName)
	    .withQueryOption(QueryStringConstants.COMP, 'rangelist')
	    .withQueryOption(QueryStringConstants.SHARE_SNAPSHOT, options.shareSnapshotId);
	
	  FileResult.setHeaders(webResource, options);
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.ranges = null;
	    if (!responseObject.error) {
	      responseObject.ranges = [];
	
	      var ranges = [];
	      if (responseObject.response.body.Ranges.Range) {
	        ranges = responseObject.response.body.Ranges.Range;
	
	        if (!_.isArray(ranges)) {
	          ranges = [ ranges ];
	        }
	      }
	
	      ranges.forEach(function (fileRange) {
	        var range = {
	          start: parseInt(fileRange.Start, 10),
	          end: parseInt(fileRange.End, 10)
	        };
	
	        responseObject.ranges.push(range);
	      });
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.ranges, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Clears a range. Clears all of the ranges by default, or only the ranges over a specific range of bytes if rangeStart and rangeEnd are specified.
	*
	* @this {FileService}
	* @param {string}             share                                       The share name.
	* @param {string}             directory                                   The directory name. Use '' to refer to the base directory.
	* @param {string}             file                                        The file name. File names may not start or end with the delimiter '/'.
	* @param {int}                rangeStart                                  The range start.
	* @param {int}                rangeEnd                                    The range end.
	* @param {object}             [options]                                   The request options.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information
	*                                                                         if an error occurs; otherwise `[result]{@link FileResult}` will contain
	*                                                                         the directory information.
	*                                                                        `response` will contain information related to this operation.
	*/
	FileService.prototype.clearRange = function (share, directory, file, rangeStart, rangeEnd, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('clearRange', function (v) {
	    v.string(share, 'share');
	    v.stringAllowEmpty(directory, 'directory');
	    v.string(file, 'file');
	    v.shareNameIsValid(share);
	    v.value(rangeStart);
	    v.value(rangeEnd);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var request = this._updateFilesImpl(share, directory, file, rangeStart, rangeEnd, FileConstants.RangeWriteOptions.CLEAR, options);
	
	  var processResponseCallback = function(responseObject, next) {
	    responseObject.fileResult = null;
	    if (!responseObject.error) {
	      responseObject.fileResult = new FileResult(share, directory, file);
	      responseObject.fileResult.getPropertiesFromHeaders(responseObject.response.headers);
	    }
	    
	    var finalCallback = function(returnObject) {
	      callback(returnObject.error, returnObject.fileResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(request, null, options, processResponseCallback);
	};
	
	/**
	* Updates a range from a stream.
	*
	* @this {FileService}
	* @param {string}             share                                       The share name.
	* @param {string}             directory                                   The directory name. Use '' to refer to the base directory.
	* @param {string}             file                                        The file name. File names may not start or end with the delimiter '/'.
	* @param {Readable}           readStream                                  The Node.js Readable stream.
	* @param {int}                rangeStart                                  The range start.
	* @param {int}                rangeEnd                                    The range end.
	* @param {object}             [options]                                   The request options.
	* @param {bool}               [options.useTransactionalMD5]               Calculate and send/validate content MD5 for transactions.
	* @param {string}             [options.transactionalContentMD5]           An optional hash value used to ensure transactional integrity for the page. 
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information
	*                                                                         if an error occurs; otherwise `[result]{@link FileResult}` will contain
	*                                                                         the file information.
	*                                                                         `response` will contain information related to this operation.
	*/
	FileService.prototype.createRangesFromStream = function (share, directory, file, readStream, rangeStart, rangeEnd, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('createRangesFromStream', function (v) {
	    v.string(share, 'share');
	    v.stringAllowEmpty(directory, 'directory');
	    v.string(file, 'file');
	    v.object(readStream, 'readStream');
	    v.shareNameIsValid(share);
	    v.value(rangeStart);
	    v.value(rangeEnd);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var requiresContentMD5 = azureutil.objectIsNull(options.transactionalContentMD5) && options.useTransactionalMD5 === true;
	
	  var length = (rangeEnd - rangeStart) + 1;
	  if(length > FileConstants.MAX_UPDATE_FILE_SIZE) {
	    throw new Error(SR.INVALID_FILE_RANGE_FOR_UPDATE);
	  }
	
	  var self = this;
	  if (requiresContentMD5) {
	    azureutil.calculateMD5(readStream, length, options, function(internalBuff, contentMD5) {
	      options.transactionalContentMD5 = contentMD5;
	      self._createRanges(share, directory, file, internalBuff, null /* stream */, rangeStart, rangeEnd, options, callback);
	    });
	  } else {
	    self._createRanges(share, directory, file, null /* text */, readStream, rangeStart, rangeEnd, options, callback);
	  }
	};
	
	/**
	* Uploads a file from a text string. If the file already exists on the service, it will be overwritten.
	*
	* @this {FileService}
	* @param {string}             share                                         The share name.
	* @param {string}             directory                                     The directory name. Use '' to refer to the base directory.
	* @param {string}             file                                          The file name. File names may not start or end with the delimiter '/'.
	* @param {string|object}      text                                          The file text, as a string or in a Buffer.
	* @param {object}             [options]                                     The request options.
	* @param {SpeedSummary}       [options.speedSummary]                        The upload tracker objects;
	* @param {bool}               [options.storeFileContentMD5]                 Specifies whether the file's ContentMD5 header should be set on uploads. 
	*                                                                           The default value is false for files.
	* @param {bool}               [options.useTransactionalMD5]                 Calculate and send/validate content MD5 for transactions.
	* @param {object}             [options.contentSettings]                     The file's content settings.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the file. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the file.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The file service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The file's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The file's MD5 hash.
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {FileService~FileToText}  callback                                 `error` will contain information
	*                                                                           if an error occurs; otherwise `text` will contain the file contents,
	*                                                                           and `[file]{@link FileResult}` will contain the file information.
	*                                                                           `response` will contain information related to this operation.
	* @example
	* var azure = require('azure-storage');
	* var fileService = azure.createFileService();
	*
	* var text = 'Hello World!';
	*
	* fileService.createFileFromText('taskshare', 'taskdirectory', 'taskfile', text, function(error, result, response) {
	*   if (!error) {
	*     // file created
	*   }
	* });
	*/
	FileService.prototype.createFileFromText = function (share, directory, file, text, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('createFileFromText', function (v) {
	    v.string(share, 'share');
	    v.stringAllowEmpty(directory, 'directory');
	    v.string(file, 'file');
	    v.exists(text, 'text');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  var length = Buffer.isBuffer(text) ? text.length : Buffer.byteLength(text);
	  if (length > FileConstants.MAX_UPDATE_FILE_SIZE) {
	    throw new Error(SR.INVALID_FILE_LENGTH);
	  }
	
	  if(options.storeFileContentMD5 && azureutil.objectIsNull(azureutil.tryGetValueChain(options, ['contentSettings', 'contentMD5'], null))) {
	     azureutil.setObjectInnerPropertyValue(options, ['contentSettings', 'contentMD5'], azureutil.getContentMd5(text));
	  }
	
	  var self = this;
	  this.createFile(share, directory, file, length, options, function(error) {
	    if(error) {
	      callback(error);
	    }
	    else {
	      self._createRanges(share, directory, file, text, null, 0, length - 1, options, callback);
	    }
	  });
	};
	
	/**
	* Uploads a file from a stream. If the file already exists on the service, it will be overwritten.
	*
	* @this {FileService}
	* @param {string}             share                                         The share name.
	* @param {string}             directory                                     The directory name. Use '' to refer to the base directory.
	* @param {string}             file                                          The file name. File names may not start or end with the delimiter '/'. 
	* @param (Stream)             stream                                        Stream to the data to store.
	* @param {int}                streamLength                                  The length of the stream to upload.
	* @param {object}             [options]                                     The request options.
	* @param {SpeedSummary}       [options.speedSummary]                        The download tracker objects;
	* @param {bool}               [options.storeFileContentMD5]                 Specifies whether the file's ContentMD5 header should be set on uploads. 
	*                                                                           The default value is false for files.
	* @param {bool}               [options.useTransactionalMD5]                 Calculate and send/validate content MD5 for transactions.
	* @param {object}             [options.contentSettings]                     The file's content settings.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the file. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the file.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The file service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The file's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The file's MD5 hash.
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResult}      callback                                      `error` will contain information if an error occurs; 
	*                                                                           otherwise `[result]{@link FileResult}` will contain the file information.
	*                                                                           `response` will contain information related to this operation.
	* @return {SpeedSummary}
	* @example
	* var stream = require('stream');
	* var azure = require('azure-storage');
	* var fileService = azure.createFileService();
	*
	* var fileStream = new stream.Readable();
	* fileStream.push(myFileBuffer);
	* fileStream.push(null);
	*
	* fileService.createFileFromStream('taskshare', 'taskdirectory', 'taskfile', fileStream, myFileBuffer.length, function(error, result, response) {
	*   if (!error) {
	*     // file uploaded
	*   }
	* });
	*/
	FileService.prototype.createFileFromStream = function(share, directory, file, stream, streamLength, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('createFileFromStream', function (v) {
	    v.string(share, 'share');
	    v.stringAllowEmpty(directory, 'directory');
	    v.string(file, 'file');
	    v.object(stream, 'stream');
	    v.value(streamLength, 'streamLength');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  options.speedSummary = options.speedSummary || new SpeedSummary(file);
	
	  stream.pause(); // Immediately pause the stream in order to compatible with Node v0.8
	
	  var self = this;
	  this.createFile(share, directory, file, streamLength, options, function(error) {
	    if(error) {
	      callback(error);
	    } else {
	      var chunkStream = new ChunkStreamWithStream(stream, {calcContentMd5: options.storeFileContentMD5});
	      self._createFileFromChunkStream(share, directory, file, chunkStream, streamLength, options, callback);
	    }
	  });
	
	  return options.speedSummary;
	};
	
	/**
	* Provides a stream to write to a file. Assumes that the file exists. 
	* If it does not, please create the file using createFile before calling this method or use createWriteStreamNewFile.
	* Please note the `Stream` returned by this API should be used with piping.
	*
	* @this {FileService}
	* @param {string}             share                                         The share name.
	* @param {string}             directory                                     The directory name. Use '' to refer to the base directory.
	* @param {string}             file                                          The file name. File names may not start or end with the delimiter '/'.
	* @param {object}             [options]                                     The request options.
	* @param {SpeedSummary}       [options.speedSummary]                        The download tracker objects;
	* @param {bool}               [options.storeFileContentMD5]                 Specifies whether the file's ContentMD5 header should be set on uploads. 
	*                                                                           The default value is false for files.
	* @param {bool}               [options.useTransactionalMD5]                 Calculate and send/validate content MD5 for transactions.
	* @param {object}             [options.contentSettings]                     The file's content settings.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the file. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the file.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The file service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The file's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The file's MD5 hash.
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResult}      callback                                      `error` will contain information if an error occurs; 
	*                                                                           otherwise `[result]{@link FileResult}` will contain the file information.
	*                                                                           `response` will contain information related to this operation.
	* @return {Writable}                                                        A Node.js Writable stream.
	* @example
	* var azure = require('azure-storage');
	* var FileService = azure.createFileService();
	* FileService.createFile(shareName, directoryName, fileName, 1024, function (err) {
	*   // Pipe file to a file
	*   var stream = fs.createReadStream(fileNameTarget).pipe(FileService.createWriteStreamToExistingFile(shareName, directoryName, fileName));
	* });
	*/
	FileService.prototype.createWriteStreamToExistingFile = function (share, directory, file, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('createWriteStreamToExistingFile', function (v) {
	    v.string(share, 'share');
	    v.stringAllowEmpty(directory, 'directory');
	    v.string(file, 'file');
	    v.shareNameIsValid(share);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  var stream = new ChunkStream({calcContentMd5: options.storeFileContentMD5});
	  this._createFileFromChunkStream(share, directory, file, stream, null, options, function (error, file, response) {
	    if(error) {
	      stream.emit('error', error);
	    }
	
	    if (callback) {
	      callback(error, file, response);
	    }
	  });
	
	  return stream;
	};
	
	/**
	* Provides a stream to write to a file. Creates the file before writing data.
	* Please note the `Stream` returned by this API should be used with piping.
	*
	* @this {FileService}
	* @param {string}             share                                         The share name.
	* @param {string}             directory                                     The directory name. Use '' to refer to the base directory.
	* @param {string}             file                                          The file name. File names may not start or end with the delimiter '/'.
	* @param {string}             length                                        The file length.
	* @param {object}             [options]                                     The request options.
	* @param {SpeedSummary}       [options.speedSummary]                        The download tracker objects;
	* @param {bool}               [options.storeFileContentMD5]                 Specifies whether the file's ContentMD5 header should be set on uploads. 
	*                                                                           The default value is false for files.
	* @param {bool}               [options.useTransactionalMD5]                 Calculate and send/validate content MD5 for transactions.
	* @param {object}             [options.contentSettings]                     The file's content settings.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the file. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the file.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The file service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The file's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The file's MD5 hash.
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResult}      callback                                      `error` will contain information if an error occurs; 
	*                                                                           otherwise `[result]{@link FileResult}` will contain the file information.
	*                                                                           `response` will contain information related to this operation.
	* @return {Writable}                                                        A Node.js Writable stream.
	* @example
	* var azure = require('azure-storage');
	* var FileService = azure.createFileService();
	* var stream = fs.createReadStream(fileNameTarget).pipe(FileService.createWriteStreamToNewFile(shareName, directoryName, fileName));
	*/
	FileService.prototype.createWriteStreamToNewFile = function (share, directory, file, length, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('createWriteStreamToNewFile', function (v) {
	    v.string(share, 'share');
	    v.stringAllowEmpty(directory, 'directory');
	    v.string(file, 'file');
	    v.value(length, 'length');
	    v.shareNameIsValid(share);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  var stream = new ChunkStream({calcContentMd5: options.storeFileContentMD5});
	  stream.pause();
	  
	  var self = this;
	  this.createFile(share, directory, file, length, options, function(error) {
	    if(error) {
	      stream.emit('error', error);
	      callback(error);
	    }
	    else {
	      stream.resume();
	      self._createFileFromChunkStream(share, directory, file, stream, null, options, function (error, file, response) {
	        if(error) {
	          stream.emit('error', error);
	        }
	
	        if (callback) {
	          callback(error, file, response);
	        }
	      });
	    }
	  });
	  
	  return stream;
	};
	
	/**
	* Starts to copy a file to a destination within the storage account.
	*
	* @this {FileService}
	* @param {string}             sourceUri                                 The source file or blob URI.
	* @param {string}             targetShare                               The target share name.
	* @param {string}             targetDirectory                           The target directory name.
	* @param {string}             targetFile                                The target file name.
	* @param {object}             [options]                                 The request options.
	* @param {object}             [options.metadata]                        The target file metadata key/value pairs.
	* @param {AccessConditions}   [options.accessConditions]                The access conditions.
	* @param {AccessConditions}   [options.sourceAccessConditions]          The source access conditions.
	* @param {LocationMode}       [options.locationMode]                    Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                       Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]             The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]        The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]        The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                       The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                       execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                 A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]               Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                       The default value is false.
	* @param {errorOrResult}      callback                                  `error` will contain information if an error occurs; 
	*                                                                       otherwise `[result]{@link FileResult}` will contain the file information.
	*                                                                       `response` will contain information related to this operation.
	*/
	FileService.prototype.startCopyFile = function (sourceUri, targetShare, targetDirectory, targetFile, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	  
	  validate.validateArgs('startCopyFile', function (v) {
	    v.string(targetShare, 'targetShare');
	    v.stringAllowEmpty(targetDirectory, 'targetDirectory');
	    v.string(targetFile, 'targetFile');
	    v.shareNameIsValid(targetShare);
	    v.callback(callback);
	  });
	  
	  var targetResourceName = createResourceName(targetShare, targetDirectory, targetFile);
	  
	  var options = extend(true, {}, userOptions);
	  
	  var webResource = WebResource.put(targetResourceName)
	    .withHeader(HeaderConstants.COPY_SOURCE, sourceUri)
	    .addOptionalMetadataHeaders(options.metadata);
	  
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.fileResult = null;
	    if (!responseObject.error) {
	      responseObject.fileResult = new FileResult(targetShare, targetDirectory, targetFile);
	      responseObject.fileResult.getPropertiesFromHeaders(responseObject.response.headers, true);
	      
	      if (options.metadata) {
	        responseObject.fileResult.metadata = options.metadata;
	      }
	    }
	    
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.fileResult, returnObject.response);
	    };
	    
	    next(responseObject, finalCallback);
	  };
	  
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Abort a file copy operation.
	*
	* @this {FileService}
	* @param {string}             share                                     The destination share name.
	* @param {string}             directory                                 The destination directory name.
	* @param {string}             file                                      The destination file name.
	* @param {string}             copyId                                    The copy operation identifier.
	* @param {object}             [options]                                 The request options.
	* @param {LocationMode}       [options.locationMode]                    Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                       Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]             The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]        The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]        The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                       The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                       execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                 A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]               Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                       The default value is false.
	* @param {errorOrResult}      callback                                  `error` will contain information if an error occurs; 
	*                                                                       otherwise `[result]{@link FileResult}` will contain the file information.
	*                                                                       `response` will contain information related to this operation.
	*/
	FileService.prototype.abortCopyFile = function (share, directory, file, copyId, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	  
	  validate.validateArgs('abortCopyFile', function (v) {
	    v.string(share, 'share');
	    v.stringAllowEmpty(directory, 'directory');
	    v.string(file, 'file');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	  
	  var resourceName = createResourceName(share, directory, file);
	  
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.put(resourceName)
	    .withQueryOption(QueryStringConstants.COPY_ID, copyId)
	    .withQueryOption(QueryStringConstants.COMP, 'copy')
	    .withHeader(HeaderConstants.COPY_ACTION, 'abort');
	  
	  var processResponseCallback = function (responseObject, next) {
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.response);
	    };
	    
	    next(responseObject, finalCallback);
	  };
	  
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	// Internal Methods
	
	/**
	* Updates a file from text.
	* @ignore
	*
	* @this {FileService}
	* @param {string}             share                                       The share name.
	* @param {string}             directory                                   The directory name. Use '' to refer to the base directory.
	* @param {string}             file                                        The file name. File names may not start or end with the delimiter '/'.
	* @param {string}             text                                        The text string.
	* @param {Readable}           readStream                                  The Node.js Readable stream.
	* @param {int}                rangeStart                                  The range start.
	* @param {int}                rangeEnd                                    The range end.
	* @param {object}             [options]                                   The request options.
	* @param {bool}               [options.useTransactionalMD5]               Calculate and send/validate content MD5 for transactions.
	* @param {bool}               [options.transactionalContentMD5]           An MD5 hash of the content. This hash is used to verify the integrity of the data during transport.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {Function(error, file, response)}  callback                      `error` will contain information
	*                                                                         if an error occurs; otherwise `file` will contain
	*                                                                         the file information.
	*                                                                         `response` will contain information related to this operation.
	*/
	FileService.prototype._createRanges = function (share, directory, file, text, readStream, rangeStart, rangeEnd, options, callback) {
	var request = this._updateFilesImpl(share, directory, file, rangeStart, rangeEnd, FileConstants.RangeWriteOptions.UPDATE, options);
	
	  // At this point, we have already validated that the range is less than 4MB. Therefore, we just need to calculate the contentMD5 if required.
	  if(!azureutil.objectIsNull(text) && azureutil.objectIsNull(options.transactionalContentMD5) && options.useTransactionalMD5 === true) {
	    request.withHeader(HeaderConstants.CONTENT_MD5, azureutil.getContentMd5(text));
	  }
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.fileResult = null;
	    if (!responseObject.error) {
	      responseObject.fileResult = new FileResult(share, directory, file);
	      responseObject.fileResult.getPropertiesFromHeaders(responseObject.response.headers);
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.fileResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  if(!azureutil.objectIsNull(text)) {
	    this.performRequest(request, text, options, processResponseCallback);
	  } else {
	    this.performRequestOutputStream(request, readStream, options, processResponseCallback);
	  }
	};
	
	/**
	* Uploads a file from a stream.
	* @ignore
	*
	* @this {FileService}
	* @param {string}             share                                         The share name.
	* @param {string}             directory                                     The directory name. Use '' to refer to the base directory.
	* @param {string}             file                                          The file name. File names may not start or end with the delimiter '/'.
	* @param (Stream)             stream                                        Stream to the data to store.
	* @param {int}                streamLength                                  The length of the stream to upload.
	* @param {object|function}    [options]                                     The request options.
	* @param {SpeedSummary}       [options.speedSummary]                        The download tracker objects;
	* @param {int}                [options.parallelOperationThreadCount]        The number of parallel operations that may be performed when uploading.
	* @param {bool}               [options.useTransactionalMD5]                 Calculate and send/validate content MD5 for transactions.
	* @param {bool}               [options.storeFileContentMD5]                 Specifies whether the file's ContentMD5 header should be set on uploads.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the file. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the file.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The file service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The file's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The MD5 hash of the file content.
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {function(error, null)}  callback                                  The callback function.
	* @return {SpeedSummary}
	*/
	FileService.prototype._createFileFromChunkStream = function(share, directory, file, chunkStream, streamLength, options, callback) {
	  this.logger.debug(util.format('_createFileFromChunkStream for file %s', file));
	
	  var apiName = '_createRanges';
	  var sizeLimitation = FileConstants.DEFAULT_WRITE_SIZE_IN_BYTES;
	  var originalContentMD5 = azureutil.tryGetValueChain(options, ['contentSettings', 'contentMD5'], null);
	
	  this._setOperationExpiryTime(options);
	
	  // initialize the speed summary
	  var speedSummary = options.speedSummary || new SpeedSummary();
	  speedSummary.totalSize = streamLength;
	
	  var parallelOperationThreadCount = options.parallelOperationThreadCount || this.parallelOperationThreadCount;
	
	  // initialize chunk allocator
	  var allocator = new ChunkAllocator(sizeLimitation, parallelOperationThreadCount, { logger: this.logger });
	
	  // if this is a FileReadStream, set the allocator on that stream
	  if (chunkStream._stream && chunkStream._stream.setMemoryAllocator) {
	    chunkStream._stream.setMemoryAllocator(allocator);
	  }
	
	  // initialize batch operations
	  var batchOperations = new BatchOperation(apiName, { logger : this.logger, enableReuseSocket : this.defaultEnableReuseSocket});
	  batchOperations.setConcurrency(parallelOperationThreadCount);
	
	  // initialize options
	  var rangeOptions = {
	    timeoutIntervalInMs: options.timeoutIntervalInMs,
	    clientRequestTimeoutInMs: options.clientRequestTimeoutInMs,
	    operationExpiryTime: options.operationExpiryTime
	  };
	
	  var self = this;
	  chunkStream.on('data', function (data, range) {
	    var operation = null;
	    var full = false;
	    var autoIncrement = speedSummary.getAutoIncrementFunction(data.length);
	
	    if(data.length > sizeLimitation) {
	      throw new Error(util.format(SR.EXCEEDED_SIZE_LIMITATION, sizeLimitation, data.length));
	    }
	
	    if (options.useTransactionalMD5) {
	      //calculate content md5 for the current uploading block data
	      var contentMD5 = azureutil.getContentMd5(data);
	      rangeOptions.transactionalContentMD5 = contentMD5;
	    }
	
	    if (azureutil.isBufferAllZero(data)) {
	      self.logger.debug(util.format('Skip upload data from %s bytes to %s bytes to file %s', range.start, range.end, file));
	      speedSummary.increment(data.length);
	    } else {
	      operation = new BatchOperation.RestOperation(self, apiName, share, directory, file, data, null, range.start, range.end, rangeOptions, function (error) {
	        if(!error) {
	          autoIncrement();
	        } else {
	          self.logger.debug(util.format('Stop downloading data as error happens. Error: %s', util.inspect(error)));
	          chunkStream.stop();
	        }
	
	        allocator.releaseBuffer(data);
	        data = null;
	      });
	    }
	
	    if (operation) {
	      full = batchOperations.addOperation(operation);
	      operation = null;
	
	      if(full) {
	        self.logger.debug('file stream paused');
	        chunkStream.pause();
	      }
	    }
	  });
	
	  chunkStream.on('end', function () {
	    self.logger.debug(util.format('File read stream ended for file %s', file));
	    batchOperations.enableComplete();
	  });
	
	  batchOperations.on('drain', function () {
	    self.logger.debug('File stream resume');
	    chunkStream.resume();
	  });
	
	  batchOperations.on('end', function (error) {
	    self.logger.debug('batch operations commited');
	 
	    if (error) {
	      callback(error);
	      return;
	    }
	
	    if (originalContentMD5) {
	      options.contentSettings.contentMD5 = originalContentMD5;
	    } else if (options.storeFileContentMD5) {
	      azureutil.setObjectInnerPropertyValue(options, ['contentSettings', 'contentMD5'], chunkStream.getContentMd5('base64'));
	    }
	
	    // upload file completely
	    var fileProperties = extend(false, options.contentSettings, { contentLength: options.streamLength });
	    self.setFileProperties(share, directory, file, fileProperties, function (error, file, response) {
	      chunkStream.finish();
	      callback(error, file, response);
	    });
	  });
	
	  return speedSummary;
	};
	
	/**
	* Downloads a file into a stream.
	* @ignore
	*
	* @this {FileService}
	* @param {string}             share                                       The share name.
	* @param {string}             directory                                   The directory name. Use '' to refer to the base directory.
	* @param {string}             file                                        The file name. File names may not start or end with the delimiter '/'.
	* @param {Writable}           writeStream                                 The Node.js Writable stream.
	* @param {object}             [options]                                   The request options.
	* @param {string}             [options.shareSnapshotId]                   The snapshot identifier of the share.
	* @param {string}             [options.rangeStart]                        Return only the bytes of the file in the specified range.
	* @param {string}             [options.rangeEnd]                          Return only the bytes of the file in the specified range. 
	* @param {boolean}            [options.useTransactionalMD5]               When set to true, Calculate and send/validate content MD5 for transactions.
	* @param {boolean}            [options.disableContentMD5Validation]       When set to true, MD5 validation will be disabled when downloading files.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information if an error occurs; 
	*                                                                         otherwise `result` will contain the file information.
	*                                                                         `response` will contain information related to this operation.
	*
	* @return {SpeedSummary}
	*/
	FileService.prototype._getFileToStream = function (share, directory, file, writeStream, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('_getFileToStream', function (v) {
	    v.string(share, 'share');
	    v.stringAllowEmpty(directory, 'directory');
	    v.string(file, 'file');
	    v.object(writeStream, 'writeStream');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var resourceName = createResourceName(share, directory, file);
	  var webResource = WebResource.get(resourceName)
	    .withQueryOption(QueryStringConstants.SHARE_SNAPSHOT, options.shareSnapshotId)
	    .withRawResponse();
	
	  FileResult.setHeaders(webResource, options);
	  this._setRangeContentMD5Header(webResource, options);
	
	  var self = this;
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.fileResult = null;
	
	    if (!responseObject.error) {
	      responseObject.fileResult = new FileResult(share, directory, file);
	      responseObject.fileResult.metadata = self.parseMetadataHeaders(responseObject.response.headers);
	      responseObject.fileResult.getPropertiesFromHeaders(responseObject.response.headers, true);
	
	      self._validateLengthAndMD5(options, responseObject);
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.fileResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequestInputStream(webResource, null, writeStream, options, processResponseCallback);
	};
	
	/**
	* Downloads a file into a range stream.
	* @ignore
	*
	* @this {FileService}
	* @param {string}             share                                       The share name.
	* @param {string}             directory                                   The directory name. Use '' to refer to the base directory.
	* @param {string}             file                                        The file name. File names may not start or end with the delimiter '/'.
	* @param {Writable}           writeStream                                 The Node.js Writable stream.
	* @param {object}             [options]                                   The request options.
	* @param {int}                [options.parallelOperationThreadCount]      The number of parallel operations that may be performed when uploading.
	* @param {string}             [options.rangeStart]                        Return only the bytes of the file in the specified range.
	* @param {string}             [options.rangeEnd]                          Return only the bytes of the file in the specified range. 
	* @param {boolean}            [options.useTransactionalMD5]               When set to true, Calculate and send/validate content MD5 for transactions.
	* @param {boolean}            [options.disableContentMD5Validation]       When set to true, MD5 validation will be disabled when downloading files.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information if an error occurs; 
	*                                                                         otherwise `result` will contain the file information.
	*                                                                         `response` will contain information related to this operation.
	*
	* @return {SpeedSummary}
	*/
	FileService.prototype._getFileToRangeStream = function (share, directory, file, writeStream, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('_getFileToRangeStream', function (v) {
	    v.string(share, 'share');
	    v.stringAllowEmpty(directory, 'directory');
	    v.string(file, 'file');
	    v.object(writeStream, 'writeStream');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	
	  var speedSummary = userOptions.speedSummary || new SpeedSummary(file);
	  var parallelOperationThreadCount = userOptions.parallelOperationThreadCount || this.parallelOperationThreadCount;
	  var batchOperations = new BatchOperation('getfile', { callbackInOrder: true, logger : this.logger, enableReuseSocket : this.defaultEnableReuseSocket });
	  batchOperations.setConcurrency(parallelOperationThreadCount);
	
	  var rangeStream = new FileRangeStream(this, share, directory, file, userOptions);
	
	  var self = this;
	  var checkMD5sum = !userOptions.disableContentMD5Validation;
	  var md5Hash = null;
	  if (checkMD5sum) {
	    md5Hash = new Md5Wrapper().createMd5Hash();
	  }
	
	  var savedFileResult = null;
	  var savedFileResponse = null;
	
	  rangeStream.on('range', function (range) {
	    if (!speedSummary.totalSize) {
	      speedSummary.totalSize = rangeStream.rangeSize;
	    }
	
	    var requestOptions = {
	      rangeStart : range.start,
	      rangeEnd : range.end,
	      responseEncoding : null //Use Buffer to store the response data
	    };
	
	    var rangeSize = range.size;
	    requestOptions.shareSnapshotId = userOptions.shareSnapshotId;
	    requestOptions.timeoutIntervalInMs = userOptions.timeoutIntervalInMs;
	    requestOptions.clientRequestTimeoutInMs = userOptions.clientRequestTimeoutInMs;
	    requestOptions.useTransactionalMD5 = userOptions.useTransactionalMD5;
	
	    if (range.dataSize === 0) {
	      var autoIncrement = speedSummary.getAutoIncrementFunction(rangeSize);
	      //No operation to do and only wait for write zero to file in callback
	      var writeZeroOperation = new BatchOperation.CommonOperation(BatchOperation.noOperation, function (error) {
	        if (error) return;
	        var bufferAvailable = azureutil.writeZerosToStream(writeStream, rangeSize, md5Hash, autoIncrement);
	        //There is no need to pause the rangestream since we can perform http request and write disk at the same time
	        self.logger.debug(util.format('Write %s bytes Zero from %s to %s', rangeSize, range.start, range.end));
	        if (!bufferAvailable) {
	          self.logger.debug('Write stream is full and pause batch operation');
	          batchOperations.pause();
	        }
	      });
	      batchOperations.addOperation(writeZeroOperation);
	      return;
	    }
	      
	    if (range.start > range.end) {
	      return;
	    }
	      
	    var operation = new BatchOperation.RestOperation(self, 'getFileToText', share, directory, file, requestOptions, function (error, content, fileResult, response) {
	      if (!error) {
	        if (rangeSize !== content.length) {
	          self.logger.warn(util.format('Request %s bytes, but server returns %s bytes', rangeSize, content.length));
	        }
	        //Save one of the succeeded callback parameters and use them at the final callback
	        if (!savedFileResult) {
	          savedFileResult = fileResult;
	        }
	        if (!savedFileResponse) {
	          savedFileResponse = response;
	        }
	        var autoIncrement = speedSummary.getAutoIncrementFunction(content.length);
	        var bufferAvailable = writeStream.write(content, autoIncrement);
	        if (!bufferAvailable) {
	          self.logger.debug('Write stream is full and pause batch operation');
	          batchOperations.pause();
	        }
	        if (md5Hash) {
	          md5Hash.update(content);
	        }
	        content = null;
	      } else {
	        self.logger.debug(util.format('Stop downloading data as error happens. Error: %s', util.inspect(error)));
	        rangeStream.stop();
	      }
	    });
	
	    var full = batchOperations.addOperation(operation);
	    if (full) {
	      self.logger.debug('Pause range stream');
	      rangeStream.pause();
	    }    
	  });
	  
	  rangeStream.on('end', function () {
	    self.logger.debug('Range stream has ended.');
	    batchOperations.enableComplete();
	  });
	  
	  batchOperations.on('drain', function () {
	    self.logger.debug('Resume range stream');
	    rangeStream.resume();
	  });
	  
	  writeStream.on('drain', function () {
	    self.logger.debug('Resume batch operations');
	    batchOperations.resume();
	  });
	  
	  batchOperations.on('end', function (error) {
	    self.logger.debug('Download completed!');
	    if (error) {
	      callback(error);
	    } else {
	      writeStream.end(function () {
	        self.logger.debug('Write stream has ended');
	        if (!savedFileResult) {
	          savedFileResult = {};
	        }
	        azureutil.setObjectInnerPropertyValue(savedFileResult, ['contentSettings', 'contentMD5'], azureutil.tryGetValueChain(userOptions, ['contentSettings', 'contentMD5'], null));
	        savedFileResult.clientSideContentMD5 = null;
	        if (md5Hash) {
	          savedFileResult.clientSideContentMD5 = md5Hash.digest('base64');
	        }
	        callback(error, savedFileResult, savedFileResponse);
	      });
	    }
	  });
	  
	  var listOptions = {
	    timeoutIntervalInMs : userOptions.timeoutIntervalInMs,
	    clientRequestTimeoutInMs : userOptions.clientRequestTimeoutInMs,
	  };
	  
	  rangeStream.list(listOptions);
	  return speedSummary;
	};
	
	/**
	* @ignore
	*/
	FileService.prototype._setRangeContentMD5Header = function (webResource, options) {
	  if(!azureutil.objectIsNull(options.rangeStart) && options.useTransactionalMD5) {
	    if(azureutil.objectIsNull(options.rangeEnd)) {
	      throw new ArgumentNullError(util.format(SR.ARGUMENT_NULL_OR_EMPTY, options.rangeEndHeader));
	    }
	
	    var size = parseInt(options.rangeEnd, 10) - parseInt(options.rangeStart, 10) + 1;
	    if (size > FileConstants.MAX_RANGE_GET_SIZE_WITH_MD5) {
	      throw new Error(SR.INVALID_RANGE_FOR_MD5);
	    } else {
	      webResource.withHeader(HeaderConstants.RANGE_GET_CONTENT_MD5, 'true');
	    }
	  }
	};
	
	/**
	* @ignore
	*/
	FileService.prototype._updateFilesImpl = function (share, directory, file, rangeStart, rangeEnd, writeMethod, options) {
	  var resourceName = createResourceName(share, directory, file);
	  var webResource = WebResource.put(resourceName)
	    .withQueryOption(QueryStringConstants.COMP, 'range')
	    .withHeader(HeaderConstants.CONTENT_TYPE, 'application/octet-stream')
	    .withHeader(HeaderConstants.FILE_WRITE, writeMethod);
	
	  options.rangeStart = rangeStart;
	  options.rangeEnd = rangeEnd;
	
	  FileResult.setHeaders(webResource, options); 
	
	  if(writeMethod === FileConstants.RangeWriteOptions.UPDATE) {
	    var size = (rangeEnd - rangeStart) + 1;
	    webResource.withHeader(HeaderConstants.CONTENT_LENGTH, size);
	  } else {
	    webResource.withHeader(HeaderConstants.CONTENT_LENGTH, 0);
	  }
	
	  return webResource;
	};
	
	/**
	* @ignore
	*/
	FileService.prototype._validateLengthAndMD5 = function (options, responseObject) {
	  var storedMD5 = responseObject.response.headers[Constants.HeaderConstants.CONTENT_MD5];
	  var contentLength;
	
	  if (!azureutil.objectIsNull(responseObject.response.headers[Constants.HeaderConstants.CONTENT_LENGTH])) {
	    contentLength = parseInt(responseObject.response.headers[Constants.HeaderConstants.CONTENT_LENGTH], 10);
	  }
	
	  // If the user has not specified this option, the default value should be false.
	  if(azureutil.objectIsNull(options.disableContentMD5Validation)) {
	    options.disableContentMD5Validation = false;
	  }
	
	  // None of the below cases should be retried. So set the error in every case so the retry policy filter handle knows that it shouldn't be retried.
	  if (options.disableContentMD5Validation === false && options.useTransactionalMD5 === true && azureutil.objectIsNull(storedMD5)) {
	    responseObject.error = new Error(SR.MD5_NOT_PRESENT_ERROR);
	    responseObject.retryable = false;
	  }
	
	  // Validate length and if required, MD5.
	  // If getFileToText called this method, then the responseObject.length and responseObject.contentMD5 are not set. Calculate them first using responseObject.response.body and then validate.
	  if(azureutil.objectIsNull(responseObject.length)) {
	    if (typeof responseObject.response.body == 'string') {
	      responseObject.length = Buffer.byteLength(responseObject.response.body);
	    } else if (Buffer.isBuffer(responseObject.response.body)) {
	      responseObject.length = responseObject.response.body.length;
	    }
	  }
	
	  if(!azureutil.objectIsNull(contentLength) && responseObject.length !== contentLength) {
	    responseObject.error = new Error(SR.CONTENT_LENGTH_MISMATCH);
	    responseObject.retryable = false;
	  }
	
	  if(options.disableContentMD5Validation === false && azureutil.objectIsNull(responseObject.contentMD5)) {
	    responseObject.contentMD5 = azureutil.getContentMd5(responseObject.response.body);
	  }
	
	  if (options.disableContentMD5Validation === false && !azureutil.objectIsNull(storedMD5) && storedMD5 !== responseObject.contentMD5) {
	    responseObject.error = new Error(util.format(SR.HASH_MISMATCH, storedMD5, responseObject.contentMD5));
	    responseObject.retryable = false;
	  }
	};
	
	/**
	* Checks whether or not a file exists on the service.
	* @ignore
	*
	* @this {FileService}
	* @param {string}             share                                             The share name.
	* @param {string}             directory                                         The directory name. Use '' to refer to the base directory.
	* @param {string}             file                                              The file name. File names may not start or end with the delimiter '/'.
	* @param {string}             primaryOnly                                       If true, the request will be executed against the primary storage location.
	* @param {object}             [options]                                         The request options.
	* @param {string}             [options.shareSnapshotId]                         The snapshot identifier of the share.
	* @param {LocationMode}       [options.locationMode]                            Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                               Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                     The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]                The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]                The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                               The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                               execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                         A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                       Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                               The default value is false.
	* @param {Function(error, result, response)}  callback                          `error` will contain information
	*                                                                               if an error occurs; otherwise `result` will contain
	*                                                                               the file information including the `exists` boolean member.
	*                                                                               `response` will contain information related to this operation.
	*/
	FileService.prototype._doesFileExist = function (share, directory, file, primaryOnly, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('FileExists', function (v) {
	    v.string(share, 'share');
	    v.stringAllowEmpty(directory, 'directory');
	    v.string(file, 'file');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  var resourceName = createResourceName(share, directory, file);
	  var webResource = WebResource.head(resourceName)
	    .withQueryOption(QueryStringConstants.SHARE_SNAPSHOT, options.shareSnapshotId);
	
	  /*if(primaryOnly === false) {
	    options.requestLocationMode = RequestLocationMode.PRIMARY_OR_SECONDARY;
	  }*/
	  
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.fileResult = new FileResult(share, directory, file);
	    if (!responseObject.error) {
	      responseObject.fileResult.exists = true;
	      responseObject.fileResult.getPropertiesFromHeaders(responseObject.response.headers);
	      
	    } else if (responseObject.error && responseObject.error.statusCode === Constants.HttpConstants.HttpResponseCodes.NotFound) {
	      responseObject.error = null;
	      responseObject.fileResult.exists = false;
	      responseObject.response.isSuccessful = true;
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.fileResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Checks whether or not a directory exists on the service.
	* @ignore
	*
	* @this {FileService}
	* @param {string}             share                                             The share name.
	* @param {string}             directory                                         The directory name. Use '' to refer to the base directory.
	* @param {string}             primaryOnly                                       If true, the request will be executed against the primary storage location.
	* @param {object}             [options]                                         The request options.
	* @param {string}             [options.shareSnapshotId]                         The share snapshot identifier.
	* @param {LocationMode}       [options.locationMode]                            Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                               Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                     The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]                The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]                The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                               The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                               execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                         A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                       Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                               The default value is false.
	* @param {Function(error, result, response)}  callback                          `error` will contain information
	*                                                                               if an error occurs; otherwise `result` will contain
	*                                                                               the directory information including `exists` boolean member. 
	*                                                                               `response` will contain information related to this operation.
	*/
	FileService.prototype._doesDirectoryExist = function (share, directory, primaryOnly, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('directoryExists', function (v) {
	    v.string(share, 'share');
	    v.stringAllowEmpty(directory, 'directory');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.head(createResourceName(share, directory))
	    .withQueryOption(QueryStringConstants.RESTYPE, 'directory')
	    .withQueryOption(QueryStringConstants.SHARE_SNAPSHOT, options.shareSnapshotId);
	
	  /*if(primaryOnly === false) {
	    options.requestLocationMode = RequestLocationMode.PRIMARY_OR_SECONDARY;
	  }*/
	    
	  var self = this;
	  var processResponseCallback = function(responseObject, next){
	    responseObject.directoryResult = new DirectoryResult(directory);
	    responseObject.directoryResult.exists = false;
	    
	    if (!responseObject.error) {
	      responseObject.directoryResult.exists = true;
	      responseObject.directoryResult.metadata = self.parseMetadataHeaders(responseObject.response.headers);
	      responseObject.directoryResult.getPropertiesFromHeaders(responseObject.response.headers);
	      
	    } else if (responseObject.error && responseObject.error.statusCode === Constants.HttpConstants.HttpResponseCodes.NotFound) {
	      responseObject.error = null;
	      responseObject.response.isSuccessful = true;
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.directoryResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Checks whether or not a share exists on the service.
	* @ignore
	*
	* @this {FileService}
	* @param {string}             share                                   The share name.
	* @param {string}             [options.shareSnapshotId]               The share snapshot identifier.
	* @param {string}             primaryOnly                             If true, the request will be executed against the primary storage location.
	* @param {object}             [options]                               The request options.
	* @param {LocationMode}       [options.locationMode]                  Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                     Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]           The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]      The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]      The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                     The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                     execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]               A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]             Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                     The default value is false.
	* @param {Function(error, result, response)}      callback            `error` will contain information
	*                                                                     if an error occurs; otherwise `result` will contain
	*                                                                     the share information including `exists` boolean member.
	*                                                                     `response` will contain information related to this operation.
	*/
	FileService.prototype._doesShareExist = function (share, primaryOnly, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('shareExists', function (v) {
	    v.string(share, 'share');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.head(share)
	    .withQueryOption(QueryStringConstants.RESTYPE, 'share')
	    .withQueryOption(QueryStringConstants.SHARE_SNAPSHOT, options.shareSnapshotId);
	
	  /*if(primaryOnly === false) {
	    options.requestLocationMode = RequestLocationMode.PRIMARY_OR_SECONDARY;
	  }*/
	  
	  var processResponseCallback = function(responseObject, next){
	    responseObject.shareResult = new ShareResult(share);
	    responseObject.shareResult.exists = false;
	    
	    if (!responseObject.error) {
	      responseObject.shareResult.exists = true;
	      responseObject.shareResult.getPropertiesFromHeaders(responseObject.response.headers);
	      
	    } else if (responseObject.error && responseObject.error.statusCode === Constants.HttpConstants.HttpResponseCodes.NotFound) {
	      responseObject.error = null;
	      responseObject.response.isSuccessful = true;
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.shareResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* The callback for {FileService~getFileToText}.
	* @typedef {function} FileService~FileToText
	* @param {object} error      If an error occurs, the error information.
	* @param {string} text       The text returned from the file.
	* @param {object} file       Information about the file.
	* @param {object} response   Information related to this operation.
	*/
	
	FileService.SpeedSummary = SpeedSummary;
	
	module.exports = FileService;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Module dependencies.
	var azureCommon = __webpack_require__(78);
	var extend = __webpack_require__(26);
	var fs = __webpack_require__(92);
	var FileService = __webpack_require__(293);
	
	var azureutil = azureCommon.util;
	var FileReadStream = azureCommon.FileReadStream;
	var SpeedSummary = azureCommon.SpeedSummary;
	var validate = azureCommon.validate;
	
	/**
	* Downloads an Azure file into a file.
	* (Not available in the JavaScript Client Library for Browsers)
	*
	* @this {FileService}
	* @param {string}             share                                       The share name.
	* @param {string}             directory                                   The directory name. Use '' to refer to the base directory.
	* @param {string}             file                                        The file name. File names may not start or end with the delimiter '/'.
	* @param {string}             localFileName                               The local path to the file to be downloaded.
	* @param {object}             [options]                                   The request options.
	* @param {string}             [options.shareSnapshotId]                   The snapshot identifier of the share.
	* @param {boolean}            [options.skipSizeCheck]                     Skip the size check to perform direct download.
	*                                                                         Set the option to true for small files.
	*                                                                         Parallel download and speed summary won't work with this option on.
	* @param {SpeedSummary}       [options.speedSummary]                      The download tracker objects.
	* @param {int}                [options.parallelOperationThreadCount]      The number of parallel operations that may be performed when uploading.
	* @param {string}             [options.rangeStart]                        Return only the bytes of the file in the specified range.
	* @param {string}             [options.rangeEnd]                          Return only the bytes of the file in the specified range.
	* @param {boolean}            [options.useTransactionalMD5]               When set to true, Calculate and send/validate content MD5 for transactions.
	* @param {boolean}            [options.disableContentMD5Validation]       When set to true, MD5 validation will be disabled when downloading files.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information if an error occurs; 
	*                                                                         otherwise `[result]{@link FileResult}` will contain the file information.
	*                                                                         `response` will contain information related to this operation.
	* @return {SpeedSummary}
	* 
	* @example
	* var azure = require('azure-storage');
	* var FileService = azure.createFileService();
	* FileService.getFileToLocalFile('taskshare', taskdirectory', 'task1', 'task1-download.txt', function(error, serverFile) {
	*   if(!error) {
	*     // file available in serverFile.file variable
	*   }
	*/
	FileService.prototype.getFileToLocalFile = function (share, directory, file, localFileName, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	  userOptions.speedSummary = userOptions.speedSummary || new SpeedSummary(file);
	
	  validate.validateArgs('getFileToLocalFile', function (v) {
	    v.string(share, 'share');
	    v.stringAllowEmpty(directory, 'directory');
	    v.string(file, 'file');
	    v.string(localFileName, 'localFileName');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  var writeStream = fs.createWriteStream(localFileName);
	  writeStream.on('error', function (error) {
	    callback(error);
	  });
	
	  this.getFileToStream(share, directory, file, writeStream, options, function (error, responseFile, response) {
	    if (error) {
	      writeStream.end(function () {
	        // If the download failed from the beginning, remove the file.
	        if (fs.existsSync(localFileName) && writeStream.bytesWritten === 0) {
	          fs.unlinkSync(localFileName);
	        }
	        callback(error, responseFile, response);
	      });
	    } else {
	      callback(error, responseFile, response);
	    }
	  });
	  
	  return options.speedSummary;
	};
	
	
	/**
	* Uploads a file to storage from a local file. If the file already exists on the service, it will be overwritten.
	* (Not available in the JavaScript Client Library for Browsers)
	*
	* @this {FileService}
	* @param {string}             share                                         The share name.
	* @param {string}             directory                                     The directory name. Use '' to refer to the base directory.
	* @param {string}             file                                          The file name. File names may not start or end with the delimiter '/'.
	* @param (string)             localFileName                                 The local path to the file to be uploaded.
	* @param {object}             [options]                                     The request options.
	* @param {SpeedSummary}       [options.speedSummary]                        The download tracker objects;
	* @param {bool}               [options.storeFileContentMD5]                 Specifies whether the file's ContentMD5 header should be set on uploads. 
	*                                                                           The default value is false for files.
	* @param {bool}               [options.useTransactionalMD5]                 Calculate and send/validate content MD5 for transactions.
	* @param {object}             [options.contentSettings]                     The file's content settings.
	* @param {string}             [options.contentSettings.contentType]         The MIME content type of the file. The default type is application/octet-stream.
	* @param {string}             [options.contentSettings.contentEncoding]     The content encodings that have been applied to the file.
	* @param {string}             [options.contentSettings.contentLanguage]     The natural languages used by this resource.
	* @param {string}             [options.contentSettings.cacheControl]        The file service stores this value but does not use or modify it.
	* @param {string}             [options.contentSettings.contentDisposition]  The file's content disposition.
	* @param {string}             [options.contentSettings.contentMD5]          The file's MD5 hash.
	* @param {object}             [options.metadata]                            The metadata key/value pairs.
	* @param {LocationMode}       [options.locationMode]                        Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                           Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                 The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]            The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]            The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                           The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                           execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                     A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                   Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                           The default value is false.
	* @param {errorOrResult}      callback                                      `error` will contain information if an error occurs; 
	*                                                                           otherwise `[result]{@link FileResult}` will contain the file information.
	*                                                                           `response` will contain information related to this operation.
	* @return {SpeedSummary}
	*/
	FileService.prototype.createFileFromLocalFile = function (share, directory, file, localFileName, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('createFileFromLocalFile', function (v) {
	    v.string(share, 'share');
	    v.stringAllowEmpty(directory, 'directory');
	    v.string(file, 'file');
	    v.string(localFileName, 'localFileName');
	    v.shareNameIsValid(share);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  options.speedSummary = options.speedSummary || new SpeedSummary(file);
	
	  var self = this;
	  fs.stat(localFileName, function(error, stat) {
	    if (error) {
	      callback(error);
	    } else {
	      self.createFile(share, directory, file, stat.size, options, function(error) {
	        if(error) {
	          callback(error);
	        } else {
	          var stream = new FileReadStream(localFileName, {calcContentMd5: options.storeFileContentMD5});
	          self._createFileFromChunkStream(share, directory, file, stream, stat.size, options, callback);
	        }
	      });
	    }
	  });
	
	  return options.speedSummary;
	};
	
	module.exports = FileService;

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	var util = __webpack_require__(4);
	var RangeStream = __webpack_require__(81);
	var Constants = __webpack_require__(12);
	
	/**
	* File range stream
	*/
	function FileRangeStream(fileServiceClient, share, directory, file, options) {
	  FileRangeStream['super_'].call(this, fileServiceClient, null, null, options);
	    
	  this._lengthHeader = Constants.HeaderConstants.FILE_CONTENT_LENGTH;
	  if (options.minRangeSize) {
	    this._minRangeSize = options.minRangeSize;
	  } else {
	    this._minRangeSize = Constants.FileConstants.MIN_WRITE_FILE_SIZE_IN_BYTES;
	  }
	  if (options.maxRangeSize) {
	    this._maxRangeSize = options.maxRangeSize;
	  } else {
	    this._maxRangeSize = Constants.FileConstants.DEFAULT_WRITE_SIZE_IN_BYTES;
	  }
	  this._listFunc = fileServiceClient.listRanges;
	  this._resourcePath.push(share);
	  this._resourcePath.push(directory);
	  this._resourcePath.push(file);
	}
	
	util.inherits(FileRangeStream, RangeStream);
	
	module.exports = FileRangeStream;


/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Module dependencies.
	var HeaderConstants = __webpack_require__(8).Constants.HeaderConstants;
	
	/**
	* Creates a new DirectoryResult object.
	* @class
	* The DirectoryResult class is used to store the directory information.
	* 
	 * @property  {string}                      name                                  The container name.
	 * @property  {object}                      metadata                              The metadata key/value pair.
	 * @property  {string}                      etag                                  The etag.
	 * @property  {string}                      lastModified                          The date/time that the directory was last modified.
	 * @property  {string}                      requestId                             The request id.
	 * @property  {string}                      serverEncrypted                       If the directory metadata is completely encrypted using the specified algorithm. true/false.
	 *
	* @constructor
	* @param {string} [name]                    The directory name.
	*/
	function DirectoryResult(name) {
	  this.name = name;
	}
	
	DirectoryResult.parse = function (dirXml) {
	  return new DirectoryResult(dirXml.Name);
	};
	
	DirectoryResult.prototype.getPropertiesFromHeaders = function (headers) {
	  var self = this;
	
	  var setDirectoryPropertyFromHeaders = function (directoryProperty, headerProperty) {
	    if (!self[directoryProperty] && headers[headerProperty.toLowerCase()]) {
	      self[directoryProperty] = headers[headerProperty.toLowerCase()];
	    }
	  };
	
	  setDirectoryPropertyFromHeaders('etag', HeaderConstants.ETAG);
	  setDirectoryPropertyFromHeaders('lastModified', HeaderConstants.LAST_MODIFIED);
	  setDirectoryPropertyFromHeaders('requestId', HeaderConstants.REQUEST_ID);
	  setDirectoryPropertyFromHeaders('serverEncrypted', HeaderConstants.SERVER_ENCRYPTED);
	};
	
	module.exports = DirectoryResult;

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Module dependencies.
	var _ = __webpack_require__(15);
	
	var azureCommon = __webpack_require__(8);
	var azureutil = azureCommon.util;
	var Constants = azureCommon.Constants;
	var HeaderConstants = Constants.HeaderConstants;
	
	/**
	* Creates a new FileResult object.
	* @class
	* The FileResult class is used to store the file information.
	* 
	 * @property  {string}                      share                                 The share name.
	 * @property  {string}                      directory                             The directory name.
	 * @property  {string}                      name                                  The file name.
	 * @property  {object}                      metadata                              The metadata key/value pair.
	 * @property  {string}                      etag                                  The etag.
	 * @property  {string}                      lastModified                          The date/time that the file was last modified.
	 * @property  {string}                      requestId                             The request id.
	 * @property  {string}                      acceptRanges                          The accept ranges.
	 * @property  {string}                      serverEncrypted                       If the file data and application metadata are completely encrypted using the specified algorithm. true/false.
	 * @property  {string}                      contentRange                          The content range
	 * @property  {string}                      contentLength                         The size of the file in bytes.
	 * @property  {object}                      contentSettings                       The content settings.
	 * @property  {string}                      contentSettings.contentType           The content type.
	 * @property  {string}                      contentSettings.contentEncoding       The content encoding.
	 * @property  {string}                      contentSettings.contentLanguage       The content language.
	 * @property  {string}                      contentSettings.cacheControl          The cache control.
	 * @property  {string}                      contentSettings.contentDisposition    The content disposition.
	 * @property  {string}                      contentSettings.contentMD5            The content MD5 hash.
	 * @property  {object}                      copy                                  The copy information.
	 * @property  {string}                      copy.id                               The copy id.
	 * @property  {string}                      copy.status                           The copy status.
	 * @property  {string}                      copy.completionTime                   The copy completion time. 
	 * @property  {string}                      copy.statusDescription                The copy status description.
	 * @property  {string}                      copy.progress                         The copy progress.
	 * @property  {string}                      copy.source                           The copy source.
	 * 
	* @constructor
	* @param {string} [share]      The share name.
	* @param {string} [directory]  The directory name.
	* @param {string} [name]       The file name.
	*/
	function FileResult(share, directory, name) {
	  this.share = share;
	  this.directory = directory;
	  this.name = name;
	}
	
	FileResult.parse = function (entryXml) {
	  var listResult = new FileResult();
	  for (var propertyName in entryXml) {
	    if (propertyName === 'Properties') {
	      //  Lift out the properties onto the main object to keep consistent across all APIs like: getFileProperties
	        azureutil.setPropertyValueFromXML(listResult, entryXml[propertyName], true);
	    } else {
	      listResult[propertyName.toLowerCase()] = entryXml[propertyName];
	    }
	  }
	
	  return listResult;
	};
	
	var responseHeaders = {
	  'acceptRanges': 'ACCEPT_RANGES',
	  'contentLength': 'CONTENT_LENGTH',
	  'contentRange': 'CONTENT_RANGE',
	
	  'contentSettings.contentType': 'CONTENT_TYPE',
	  'contentSettings.contentEncoding': 'CONTENT_ENCODING',
	  'contentSettings.contentLanguage': 'CONTENT_LANGUAGE',
	  'contentSettings.cacheControl': 'CACHE_CONTROL',
	  'contentSettings.contentDisposition': 'CONTENT_DISPOSITION',
	  'contentSettings.contentMD5': 'CONTENT_MD5',
	  'contentSettings.fileContentMD5': 'FILE_CONTENT_MD5',
	  
	  'copy.id': 'COPY_ID',
	  'copy.status': 'COPY_STATUS',
	  'copy.source': 'COPY_SOURCE',
	  'copy.progress': 'COPY_PROGRESS',
	  'copy.completionTime': 'COPY_COMPLETION_TIME',
	  'copy.statusDescription': 'COPY_STATUS_DESCRIPTION'
	};
	
	FileResult.prototype.getPropertiesFromHeaders = function (headers, content) {
	  var self = this;
	  
	  var setFilePropertyFromHeaders = function (fileProperty, headerProperty) {
	    if (!azureutil.tryGetValueChain(self, fileProperty.split('.'), null) && headers[headerProperty.toLowerCase()]) {
	      azureutil.setObjectInnerPropertyValue(self, fileProperty.split('.'), headers[headerProperty.toLowerCase()]);
	      
	      if (fileProperty === 'copy.progress') {
	        var info = azureutil.parseCopyProgress(self.copy.progress);
	        self.copy.bytesCopied = parseInt(info.bytesCopied);
	        self.copy.totalBytes = parseInt(info.totalBytes);
	      }
	    }
	  };
	   
	  // For range get, 'x-ms-content-md5' indicate the overall MD5 of the file. Try to set the contentMD5 using this header if it presents
	  setFilePropertyFromHeaders('contentSettings.contentMD5', HeaderConstants.FILE_CONTENT_MD5);
	
	  setFilePropertyFromHeaders('etag', HeaderConstants.ETAG);
	  setFilePropertyFromHeaders('lastModified', HeaderConstants.LAST_MODIFIED);
	  setFilePropertyFromHeaders('requestId', HeaderConstants.REQUEST_ID);
	  setFilePropertyFromHeaders('serverEncrypted', HeaderConstants.SERVER_ENCRYPTED);
	
	  if (content) {
	     _.chain(responseHeaders).pairs().each(function (pair) {
	      var property = pair[0];
	      var header = HeaderConstants[pair[1]];
	      setFilePropertyFromHeaders(property, header);
	    });
	
	   }
	};
	
	/**
	* This method sets the HTTP headers and is used by all methods except setFileProperties and createFile. 
	* Those methods will set the x-ms-* headers using setProperties.
	*/
	FileResult.setHeaders = function (webResource, options) {
	  var setHeaderProperty = function (headerProperty, fileProperty) {
	    var propertyValue = azureutil.tryGetValueChain(options, fileProperty.split('.'), null);
	    if (propertyValue) {
	      webResource.withHeader(headerProperty, propertyValue);
	    }
	  };
	
	  if (options) {
	    // Content-MD5
	    setHeaderProperty(HeaderConstants.CONTENT_MD5, 'transactionalContentMD5');
	
	    // Content-Length
	    setHeaderProperty(HeaderConstants.CONTENT_LENGTH, 'contentLength');
	
	    // Range
	    if (!azureutil.objectIsNull(options.rangeStart)) {
	      var range = 'bytes=' + options.rangeStart + '-';
	
	      if (!azureutil.objectIsNull(options.rangeEnd)) {
	        range += options.rangeEnd;
	      }
	
	      webResource.withHeader(HeaderConstants.STORAGE_RANGE, range);
	    }   
	  }
	};
	
	/**
	* This method sets the x-ms-* headers and is used by setFileProperties and createFile. 
	* All other methods will set the regular HTTP headers using setHeaders.
	*/
	FileResult.setProperties = function (webResource, options) {
	  var setHeaderProperty = function (headerProperty, fileProperty) {
	    var propertyValue = azureutil.tryGetValueChain(options, fileProperty.split('.'), null);
	    if (propertyValue) {
	      webResource.withHeader(headerProperty, propertyValue);
	    }
	  };
	
	  if (options) {
	    // Content-Length
	    setHeaderProperty(HeaderConstants.FILE_CONTENT_LENGTH, 'contentLength');
	    
	    // Content-Type
	    setHeaderProperty(HeaderConstants.FILE_CONTENT_TYPE, 'contentSettings.contentType');
	
	    // Content-Encoding
	    setHeaderProperty(HeaderConstants.FILE_CONTENT_ENCODING, 'contentSettings.contentEncoding');
	
	    // Content-Language
	    setHeaderProperty(HeaderConstants.FILE_CONTENT_LANGUAGE, 'contentSettings.contentLanguage');
	
	    // Content-Disposition
	    setHeaderProperty(HeaderConstants.FILE_CONTENT_DISPOSITION, 'contentSettings.contentDisposition');
	
	    // Cache-Control
	    setHeaderProperty(HeaderConstants.FILE_CACHE_CONTROL, 'contentSettings.cacheControl');
	
	    // Content-MD5
	    setHeaderProperty(HeaderConstants.FILE_CONTENT_MD5, 'contentSettings.contentMD5');
	
	    if (options.metadata) {
	      webResource.addOptionalMetadataHeaders(options.metadata);
	    }
	  }
	};
	
	module.exports = FileResult;

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Module dependencies.
	var azureCommon = __webpack_require__(8);
	var azureutil = azureCommon.util;
	var Constants = azureCommon.Constants;
	var HeaderConstants = Constants.HeaderConstants;
	
	/**
	* Creates a new ShareResult object.
	* @class
	* The ShareResult class is used to store the share information.
	* 
	 * @property  {string}                      name                                  The share name.
	 * @property  {object}                      metadata                              The metadata key/value pair.
	 * @property  {string}                      etag                                  The etag.
	 * @property  {string}                      lastModified                          The date/time that the share was last modified.
	 * @property  {string}                      requestId                             The request id.
	 * @property  {string}                      quota                                 The share quota.
	 * 
	* @constructor
	* @param {string} [name]                    The share name.
	*/
	function ShareResult(name) {
	  this.name = name;
	}
	
	ShareResult.parse = function (shareXml, name) {
	  var shareResult = new ShareResult(name);
	  for (var propertyName in shareXml) {
	    if (shareXml.hasOwnProperty(propertyName)) {
	      if (propertyName === 'Properties') {
	        //  Lift out the properties onto the main object to keep consistent across all APIs like: getShareProperties
	        azureutil.setPropertyValueFromXML(shareResult, shareXml[propertyName], true);
	      } else if (propertyName === 'Metadata' || propertyName === 'ShareStats') {
	        var resultPropertyName = azureutil.normalizePropertyNameFromXML(propertyName);
	        shareResult[resultPropertyName] = {};
	        azureutil.setPropertyValueFromXML(shareResult[resultPropertyName], shareXml[propertyName], propertyName === 'ShareStats');
	      } else {
	        shareResult[propertyName.toLowerCase()] = shareXml[propertyName];
	      }
	    }
	  }
	
	  return shareResult;
	};
	
	ShareResult.prototype.getPropertiesFromHeaders = function (headers) {
	  var self = this;
	
	  var setSharePropertyFromHeaders = function (shareProperty, headerProperty) {
	    if (!self[shareProperty] && headers[headerProperty.toLowerCase()]) {
	      self[shareProperty] = headers[headerProperty.toLowerCase()];
	    }
	  };
	
	  setSharePropertyFromHeaders('etag', HeaderConstants.ETAG);
	  setSharePropertyFromHeaders('lastModified', HeaderConstants.LAST_MODIFIED);
	  setSharePropertyFromHeaders('requestId', HeaderConstants.REQUEST_ID);
	  setSharePropertyFromHeaders('quota', HeaderConstants.SHARE_QUOTA);
	};
	
	/**
	* The share ACL settings.
	* @typedef    {object}                ShareAclResult
	* @extends    {ShareAclResult}
	* @property   {Object.<string, AccessPolicy>}    signedIdentifiers   The container ACL settings. See `[AccessPolicy]{@link AccessPolicy}` for detailed information.
	*/
	
	module.exports = ShareResult;

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Module dependencies.
	var azureCommon = __webpack_require__(8);
	var azureutil = azureCommon.util;
	var xmlbuilder = azureCommon.xmlbuilder;
	var Constants = azureCommon.Constants;
	
	var HeaderConstants = Constants.HeaderConstants;
	
	/**
	* Creates a new QueueMessageResult object.
	* @class
	* The QueueMessageResult class is used to store the queue message information.
	* 
	* @property   {string}                      queue                           The queue name.
	* @property   {string}                      messageId                       The message id.
	* @property   {string}                      popReceipt                      The pop receipt.
	* @property   {string}                      messageText                     The message text.
	* @property   {string}                      timeNextVisible                 The time next visible.
	* @property   {string}                      insertionTime                   The insertion time.
	* @property   {string}                      expirationTime                  The expiration time.
	* @property   {number}                      dequeueCount                    The dequeue count.
	 * 
	* @constructor
	* @param {string} [queue]                   The queue name.
	* @param {string} [messageId]               The message id.
	* @param {string} [popReceipt]              The pop receipt.
	*/
	function QueueMessageResult(queue, messageId, popReceipt) {
	  if (queue) {
	    this.queue = queue;
	  }
	
	  if (messageId) {
	    this.messageId = messageId;
	  }
	
	  if (popReceipt) {
	    this.popReceipt = popReceipt;
	  }
	}
	
	/**
	* Builds an XML representation for a queue message
	*
	* @param  {string}  messageJs    The queue message.
	* @param  {QueueMessageEncoder}  The message encoder.
	* @return {string} The XML queue message.
	*/
	QueueMessageResult.serialize = function (messageJs, encoder) {
	  var doc = xmlbuilder.create();
	  doc = doc.begin(Constants.QueueConstants.QUEUE_MESSAGE_ELEMENT, { version: '1.0', encoding: 'utf-8' });
	
	  if (messageJs) {
	    var message;
	    if (encoder !== null && encoder !== undefined) {
	      message = encoder.encode(messageJs);
	    } else {
	      message = messageJs;
	    }
	    
	    doc.ele(Constants.QueueConstants.MESSAGE_TEXT_ELEMENT)
	        .txt(message)
	      .up();
	  } else {
	    doc.ele(Constants.QueueConstants.MESSAGE_TEXT_ELEMENT).up();
	  }
	
	  return doc.doc().toString();
	};
	
	
	/**
	* Pase the XML representation of a queue message to a QueueMessageResult object.
	*
	* @param  {Object}  messageXml   The XML representation of the queue message.
	* @param  {QueueMessageEncoder}  The message encoder.
	* @return {QueueMessageResult}   The QueueMessageResult object.
	*/
	QueueMessageResult.parse = function (messageXml, encoder) {
	  var queueMessageResult = new QueueMessageResult();
	  for (var property in messageXml) {
	    if (property === Constants.QueueConstants.MESSAGE_TEXT_ELEMENT) {
	      if (encoder !== null && encoder !== undefined) {
	        queueMessageResult.messageText = encoder.decode(messageXml[property]);
	      } else {
	        queueMessageResult.messageText = messageXml[property];
	      }
	    } else {
	      var resultPropertyName = azureutil.normalizePropertyNameFromXML(property);
	      queueMessageResult[resultPropertyName] = messageXml[property];
	    }
	  }
	
	  // Convert dequeueCount to number
	  if (queueMessageResult.dequeueCount) {
	    queueMessageResult.dequeueCount = parseInt(queueMessageResult.dequeueCount);
	  }
	
	  return queueMessageResult;
	};
	
	QueueMessageResult.prototype.getPropertiesFromHeaders = function (headers) {
	  var self = this;
	
	  var setmessagePropertyFromHeaders = function (messageProperty, headerProperty) {
	    if (!self[messageProperty] && headers[headerProperty.toLowerCase()]) {
	      self[messageProperty] = headers[headerProperty.toLowerCase()];
	    }
	  };
	
	  setmessagePropertyFromHeaders('popReceipt', HeaderConstants.POP_RECEIPT);
	  setmessagePropertyFromHeaders('timeNextVisible', HeaderConstants.TIME_NEXT_VISIBLE);
	};
	
	module.exports = QueueMessageResult;

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Module dependencies.
	var Constants = __webpack_require__(8).Constants;
	var HeaderConstants = Constants.HeaderConstants;
	
	/**
	* Creates a new QueueResult object.
	* @class
	* The QueueResult class is used to store the queue information.
	* 
	* @property   {string}                      name                                  The queue name.
	* @property   {object}                      metadata                              The metadata key/value pair.
	* @property   {number}                      approximateMessageCount               The approximate number of messages in the queue. This number is not lower than the actual number of messages in the queue, but could be higher.
	* @property   {Object.<string, AccessPolicy>}  signedIdentifiers                     The container ACL settings. See `[AccessPolicy]{@link AccessPolicy}` for detailed information.
	 * 
	* @constructor
	* @param {string} [name]                    The queue name.
	* @param {string} [metadata]                The metadata key/value pair.
	*/
	function QueueResult(name, metadata) {
	  if (name) {
	    this.name = name;
	  }
	
	  if (metadata) {
	    this.metadata = metadata;
	  }
	}
	
	QueueResult.parse = function (messageXml) {
	  var queueResult = new QueueResult();
	  for (var property in messageXml) {
	    if (messageXml.hasOwnProperty(property)) {
	      queueResult[property.toLowerCase()] = messageXml[property];
	    }
	  }
	
	  return queueResult;
	};
	
	QueueResult.prototype.getPropertiesFromHeaders = function (headers) {
	  var self = this;
	
	  var setPropertyFromHeaders = function (queueProperty, headerProperty, typeConverterFunc) {
	    if (!self[queueProperty] && headers[headerProperty.toLowerCase()]) {
	      if(typeConverterFunc) {
	        self[queueProperty] = typeConverterFunc(headers[headerProperty.toLowerCase()]);
	      } else{
	        self[queueProperty] = headers[headerProperty.toLowerCase()];
	      }
	    }
	  };
	
	  setPropertyFromHeaders('approximateMessageCount', HeaderConstants.APPROXIMATE_MESSAGES_COUNT, parseInt);
	};
	
	module.exports = QueueResult;

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Module dependencies.
	var util = __webpack_require__(4);
	var _ = __webpack_require__(15);
	var extend = __webpack_require__(26);
	
	var azureCommon = __webpack_require__(8);
	var azureutil = azureCommon.util;
	var SR = azureCommon.SR;
	var validate = azureCommon.validate;
	
	var StorageServiceClient = azureCommon.StorageServiceClient;
	var WebResource = azureCommon.WebResource;
	var Constants = azureCommon.Constants;
	var QueryStringConstants = Constants.QueryStringConstants;
	var HeaderConstants = Constants.HeaderConstants;
	var RequestLocationMode = Constants.RequestLocationMode;
	
	// Models requires
	var QueueResult = __webpack_require__(300);
	var AclResult = azureCommon.AclResult;
	var QueueMessageResult = __webpack_require__(299);
	var QueueMessageEncoder = __webpack_require__(140);
	var ServiceStatsParser = azureCommon.ServiceStatsParser;
	
	/**
	* Creates a new QueueService object.
	* If no connection string or storageaccount and storageaccesskey are provided,
	* the AZURE_STORAGE_CONNECTION_STRING or AZURE_STORAGE_ACCOUNT and AZURE_STORAGE_ACCESS_KEY environment variables will be used.
	* @class
	* The QueueService class is used to perform operations on the Microsoft Azure Queue Service.
	* 
	* For more information on using the Queue Service, as well as task focused information on using it from a Node.js application, see
	* [How to Use the Queue Service from Node.js](http://azure.microsoft.com/en-us/documentation/articles/storage-nodejs-how-to-use-queues/).
	* The following defaults can be set on the Queue service.
	* messageEncoder                                      The message encoder to specify how QueueService encodes and decodes the queue message. Default is `[TextXmlQueueMessageEncoder]{@link TextXmlQueueMessageEncoder}`.
	* defaultTimeoutIntervalInMs                          The default timeout interval, in milliseconds, to use for request made via the Queue service.
	* defaultClientRequestTimeoutInMs                     The default timeout of client requests, in milliseconds, to use for the request made via the Queue service.
	* defaultMaximumExecutionTimeInMs                     The default maximum execution time across all potential retries, for requests made via the Queue service.
	* defaultLocationMode                                 The default location mode for requests made via the Queue service.
	* useNagleAlgorithm                                   Determines whether the Nagle algorithm is used for requests made via the Queue service; true to use the  
	*                                                     Nagle algorithm; otherwise, false. The default value is false.
	* @constructor
	* @augments {StorageServiceClient}
	*
	* @param {string} [storageAccountOrConnectionString]  The storage account or the connection string.
	* @param {string} [storageAccessKey]                  The storage access key.
	* @param {string|object} [host]                       The host address. To define primary only, pass a string. 
	*                                                     Otherwise 'host.primaryHost' defines the primary host and 'host.secondaryHost' defines the secondary host.
	* @param {string} [sasToken]                          The Shared Access Signature token.
	* @param {string} [endpointSuffix]                    The endpoint suffix.
	*/
	function QueueService(storageAccountOrConnectionString, storageAccessKey, host, sasToken, endpointSuffix) {
	  var storageServiceSettings = StorageServiceClient.getStorageSettings(storageAccountOrConnectionString, storageAccessKey, host, sasToken, endpointSuffix);
	
	  QueueService['super_'].call(this,
	    storageServiceSettings._name,
	    storageServiceSettings._key,
	    storageServiceSettings._queueEndpoint,
	    storageServiceSettings._usePathStyleUri,
	    storageServiceSettings._sasToken);
	
	  if (this.anonymous) {
	    throw new Error(SR.ANONYMOUS_ACCESS_BLOBSERVICE_ONLY);
	  }
	  
	  /**
	   * @property {boolean} QueueService#messageEncoder
	   * @defaultvalue      {QueueMessageEncoder}     `[TextXmlQueueMessageEncoder]{@link TextXmlQueueMessageEncoder}`.
	   * The message encoder to specify how QueueService encodes and decodes the queue message. Default is `[TextXmlQueueMessageEncoder]{@link TextXmlQueueMessageEncoder}`.
	   */
	  this.messageEncoder = new QueueMessageEncoder.TextXmlQueueMessageEncoder();
	}
	
	util.inherits(QueueService, StorageServiceClient);
	
	/**
	* Gets the service stats for a storage account’s Queue service.
	*
	* @this {QueueService}
	* @param {object}       [options]                                         The request options.
	* @param {LocationMode} [options.locationMode]                            Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}          [options.timeoutIntervalInMs]                     The server timeout interval, in milliseconds, to use for the request.
	* @param {int}          [options.clientRequestTimeoutInMs]                The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}          [options.maximumExecutionTimeInMs]                The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}       [options.clientRequestId]                         A string that represents the client request ID with a 1KB character limit.
	* @param {bool}         [options.useNagleAlgorithm]                       Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}  callback                                        `error` will contain information
	*                                                                         if an error occurs; otherwise, `[result]{@link ServiceStats}`
	*                                                                         will contain the stats and `response`
	*                                                                         will contain information related to this operation.
	*/
	QueueService.prototype.getServiceStats = function (optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('getServiceStats', function (v) {
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.get()
	    .withQueryOption(QueryStringConstants.COMP, 'stats')
	    .withQueryOption(QueryStringConstants.RESTYPE, 'service');
	
	  options.requestLocationMode = RequestLocationMode.PRIMARY_OR_SECONDARY;
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.serviceStatsResult = null;
	    if (!responseObject.error) {
	      responseObject.serviceStatsResult = ServiceStatsParser.parse(responseObject.response.body.StorageServiceStats);
	    }
	
	    // function to be called after all filters
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.serviceStatsResult, returnObject.response);
	    };
	
	    // call the first filter
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Gets the properties of a storage account’s Queue service, including Microsoft Azure Storage Analytics.
	*
	* @this {QueueService}
	* @param {object}             [options]                                 The request options.
	* @param {LocationMode}       [options.locationMode]                    Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                       Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]             The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]        The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]        The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                       The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                       execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                 A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]               Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                       The default value is false.
	* @param {errorOrResult}  callback                                      `error` will contain information
	*                                                                       if an error occurs; otherwise, `[result]{@link ServiceProperties}`
	*                                                                       will contain the properties and `response`
	*                                                                       will contain information related to this operation.
	*/
	QueueService.prototype.getServiceProperties = function (optionsOrCallback, callback) {
	  return this.getAccountServiceProperties(optionsOrCallback, callback);
	};
	
	/**
	* Sets the properties of a storage account’s Queue service, including Microsoft Azure Storage Analytics.
	* You can also use this operation to set the default request version for all incoming requests that do not have a version specified.
	*
	* @this {QueueService}
	* @param {object}             serviceProperties                        The service properties.
	* @param {object}             [options]                                The request options.
	* @param {LocationMode}       [options.locationMode]                   Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                      Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]            The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]       The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]       The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                      The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                      execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]              Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                      The default value is false.
	* @param {errorOrResponse}  callback                                   `error` will contain information
	*                                                                      if an error occurs; otherwise, `response`
	*                                                                      will contain information related to this operation.
	*/
	QueueService.prototype.setServiceProperties = function (serviceProperties, optionsOrCallback, callback) {
	  return this.setAccountServiceProperties(serviceProperties, optionsOrCallback, callback);
	};
	
	/**
	* Lists a segment containing a collection of queue items whose names begin with the specified prefix under the given account.
	*
	* @this {QueueService}
	* @param {object}             currentToken                                A continuation token returned by a previous listing operation. Please use 'null' or 'undefined' if this is the first operation.
	* @param {object}             [options]                                   The request options.
	* @param {int}                [options.maxResults]                        Specifies the maximum number of queues to return per call to Azure storage. This does NOT affect list size returned by this function. (maximum: 5000)
	* @param {string}             [options.include]                           Include this parameter to specify that the queue's metadata be returned as part of the response body. (allowed values: '', 'metadata')
	*                                                                         **Note** that all metadata names returned from the server will be converted to lower case by NodeJS itself as metadata is set via HTTP headers and HTTP header names are case insensitive.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}  callback                                        `error` will contain information
	*                                                                         if an error occurs; otherwise `result` will contain `entries` and `continuationToken`. 
	*                                                                         `entries`  gives a list of `[queues]{@link QueueResult}` and the `continuationToken` is used for the next listing operation.
	*                                                                         `response` will contain information related to this operation.
	*/
	QueueService.prototype.listQueuesSegmented = function (currentToken, optionsOrCallback, callback) {
	  this.listQueuesSegmentedWithPrefix(null /* prefix */, currentToken, optionsOrCallback, callback);
	};
	
	/**
	* Lists a segment containing a collection of queue items  under the given account.
	*
	* @this {QueueService}
	* @param {string}             prefix                                      The prefix of the queue name.
	* @param {object}             currentToken                                A continuation token returned by a previous listing operation. Please use 'null' or 'undefined' if this is the first operation.* @param {string}             [options.prefix]                  Filters the results to return only queues whose name begins with the specified prefix.
	* @param {object}             [options]                                   The request options.
	* @param {string}             [options.marker]                            String value that identifies the portion of the list to be returned with the next list operation.
	* @param {int}                [options.maxResults]                        Specifies the maximum number of queues to return per call to Azure storage. This does NOT affect list size returned by this function. (maximum: 5000)
	* @param {string}             [options.include]                           Include this parameter to specify that the queue's metadata be returned as part of the response body. (allowed values: '', 'metadata')
	*                                                                         **Note** that all metadata names returned from the server will be converted to lower case by NodeJS itself as metadata is set via HTTP headers and HTTP header names are case insensitive.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}  callback                                        `error` will contain information
	*                                                                         if an error occurs; otherwise `result` will contain `entries` and `continuationToken`. 
	*                                                                         `entries`  gives a list of `[queues]{@link QueueResult}` and the `continuationToken` is used for the next listing operation.
	*                                                                         `response` will contain information related to this operation.
	*/
	QueueService.prototype.listQueuesSegmentedWithPrefix = function (prefix, currentToken, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('listQueuesSegmentedWithPrefix', function (v) {
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.get();
	  webResource.withQueryOption(QueryStringConstants.COMP, 'list')
	    .withQueryOption(QueryStringConstants.MAX_RESULTS, options.maxResults)
	    .withQueryOption(QueryStringConstants.INCLUDE, options.include)
	    .withQueryOption(QueryStringConstants.PREFIX, prefix);
	
	  if(!azureutil.objectIsNull(currentToken)) {
	    webResource.withQueryOption(QueryStringConstants.MARKER, currentToken.nextMarker);
	  }
	
	  options.requestLocationMode = azureutil.getNextListingLocationMode(currentToken);
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.listQueuesResult = null;
	
	    if (!responseObject.error) {
	      responseObject.listQueuesResult = {
	        entries: null,
	        continuationToken: null
	      };
	      responseObject.listQueuesResult.entries = [];
	      var queues = [];
	
	      if (responseObject.response.body.EnumerationResults.Queues && responseObject.response.body.EnumerationResults.Queues.Queue) {
	        queues = responseObject.response.body.EnumerationResults.Queues.Queue;
	
	        if (!_.isArray(queues)) {
	          queues = [ queues ];
	        }
	
	        queues.forEach(function (currentQueue) {
	          var queueResult = QueueResult.parse(currentQueue);
	          responseObject.listQueuesResult.entries.push(queueResult);
	        });
	
	        if(responseObject.response.body.EnumerationResults.NextMarker) {
	          responseObject.listQueuesResult.continuationToken = {
	            nextMarker: null,
	            targetLocation: null
	          };
	
	          responseObject.listQueuesResult.continuationToken.nextMarker = responseObject.response.body.EnumerationResults.NextMarker;
	          responseObject.listQueuesResult.continuationToken.targetLocation = responseObject.targetLocation;
	        }
	      }
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.listQueuesResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Checks to see if a queue exists.
	*
	* @this {QueueService}
	* @param {string}             queue                                       The queue name.
	* @param {object}             [options]                                   The request options.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {Function(error, result, response)}  callback                    `error` will contain information
	*                                                                         if an error occurs; otherwise, `[result]{@link QueueResult}` will contain
	*                                                                         the queue information including `exists` boolean member.
	*                                                                         `response` will contain information related to this operation.
	*/
	QueueService.prototype.doesQueueExist = function (queue, optionsOrCallback, callback) {
	  this._doesQueueExist(queue, false, optionsOrCallback, callback);
	};
	
	/**
	* Creates a new queue under the given account.
	*
	* @this {QueueService}
	* @param {string}             queue                                       The queue name.
	* @param {object}             [options]                                   The request options.
	* @param {object}             [options.metadata]                          The metadata key/value pairs.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}  callback                                        `error` will contain information
	*                                                                         if an error occurs; otherwise `[result]{@link QueueResult}` will contain
	*                                                                         the queue information.
	*                                                                         `response` will contain information related to this operation.
	*/
	QueueService.prototype.createQueue = function (queue, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('createQueue', function (v) {
	    v.string(queue, 'queue');
	    v.queueNameIsValid(queue);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.put(queue);
	  if (options) {
	    webResource.addOptionalMetadataHeaders(options.metadata);
	  }
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.queueResult = null;
	    if (!responseObject.error) {
	      responseObject.queueResult = new QueueResult(queue);
	      if (options && options.metadata) {
	        responseObject.queueResult.metadata = options.metadata;
	      }
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.queueResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Creates a new queue under the given account if it doesn't exist.
	*
	* @this {QueueService}
	* @param {string}             queue                                       The queue name.
	* @param {object}             [options]                                   The request options.
	* @param {object}             [options.metadata]                          The metadata key/value pairs.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}  callback                                       `error` will contain information
	*                                                                         if an error occurs; otherwise `[result]{@link QueueResult}` will contain 
	*                                                                         the queue information including `created` boolean member and 
	*                                                                         `response` will contain information related to this operation.
	*
	* @example
	* var azure = require('azure-storage');
	* var queueService = azure.createQueueService();
	* queueService.createQueueIfNotExists('taskqueue', function(error) {
	*   if(!error) {
	*     // Queue created or exists
	*   }
	* }); 
	*/
	QueueService.prototype.createQueueIfNotExists = function (queue, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('createQueueIfNotExists', function (v) {
	    v.string(queue, 'queue');
	    v.queueNameIsValid(queue);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var self = this;
	  self._doesQueueExist(queue, true, options, function(error, result, response) {
	    var exists = result.exists;
	    result.created = false;
	    delete result.exists;
	    
	    if (error) {
	      callback(error, result, response);
	    } else if (exists) {
	      response.isSuccessful = true;
	      callback(error, result, response);
	    } else {
	      self.createQueue(queue, options, function(createError, responseQueue, createResponse) {
	        if (!createError) {
	          responseQueue.created = true;
	        }
	        else if (createError && createError.statusCode === Constants.HttpConstants.HttpResponseCodes.Conflict && createError.code === Constants.QueueErrorCodeStrings.QUEUE_ALREADY_EXISTS) {
	          createError = null;
	          responseQueue.created = false;
	          createResponse.isSuccessful = true;
	        }
	
	        callback(createError, responseQueue, createResponse);
	      });
	    }
	  });
	};
	
	/**
	* Permanently deletes the specified queue.
	*
	* @this {QueueService}
	* @param {string}             queue                                       The queue name.
	* @param {object}             [options]                                   The request options.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResponse}  callback                                      `error` will contain information if an error occurs; 
	*                                                                         `response` will contain information related to this operation.
	*/
	QueueService.prototype.deleteQueue = function (queue, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('deleteQueue', function (v) {
	    v.string(queue, 'queue');
	    v.queueNameIsValid(queue);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.del(queue);
	  var processResponseCallback = function (responseObject, next) {
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Permanently deletes the specified queue if it exists.
	*
	* @this {QueueService}
	* @param {string}             queue                                       The queue name.
	* @param {object}             [options]                                   The request options.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}  callback                                        `error` will contain information
	*                                                                         if an error occurs; otherwise `result` will contain
	*                                                                         'true' if the queue was deleted and 'false' if the queue did not exist.
	*                                                                         `response` will contain information related to this operation.
	*/
	QueueService.prototype.deleteQueueIfExists = function (queue, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('deleteQueueIfExists', function (v) {
	    v.string(queue, 'queue');
	    v.queueNameIsValid(queue);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var self = this;
	  self._doesQueueExist(queue, true, options, function existsCallback(error, existsResult, response) {
	    if (error) {
	      callback(error, existsResult.exists, response);
	    } else if (!existsResult.exists) {
	      response.isSuccessful = true;
	      callback(error, false, response);
	    } else {
	      self.deleteQueue(queue, options, function(deleteError, deleteResponse) {
	        var deleted;
	        if (!deleteError) {
	          deleted = true;
	        } else if (deleteError && deleteError.statusCode === Constants.HttpConstants.HttpResponseCodes.NotFound && deleteError.code === Constants.QueueErrorCodeStrings.QUEUE_NOT_FOUND) {
	          deleted = false;
	          deleteError = null;
	          deleteResponse.isSuccessful = true;
	        }
	
	        callback(deleteError, deleted, deleteResponse);
	      });
	    }
	  });
	};
	
	/**
	* Returns queue properties, including user-defined metadata.
	* **Note** that all metadata names returned from the server will be converted to lower case by NodeJS itself as metadata is set via HTTP headers and HTTP header names are case insensitive.
	*
	* @this {QueueService}
	* @param {string}             queue                                       The queue name.
	* @param {object}             [options]                                   The request options.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}  callback                                        `error` will contain information
	*                                                                         if an error occurs; otherwise `[result]{@link QueueResult}` will contain
	*                                                                         the queue information.
	*                                                                         `response` will contain information related to this operation.
	*/
	QueueService.prototype.getQueueMetadata = function (queue, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('getQueueMetadata', function (v) {
	    v.string(queue, 'queue');
	    v.queueNameIsValid(queue);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.get(queue)
	    .withQueryOption(QueryStringConstants.COMP, 'metadata');
	
	  options.requestLocationMode = Constants.RequestLocationMode.PRIMARY_OR_SECONDARY;
	
	  var self = this;
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.queueResult = null;
	    if (!responseObject.error) {
	      responseObject.queueResult = new QueueResult(queue);
	      responseObject.queueResult.metadata = self.parseMetadataHeaders(responseObject.response.headers);
	      responseObject.queueResult.getPropertiesFromHeaders(responseObject.response.headers);
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.queueResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Sets user-defined metadata on the specified queue. Metadata is associated with the queue as name-value pairs.
	*
	* @this {QueueService}
	* @param {string}             queue                                       The queue name.
	* @param {object}             metadata                                    The metadata key/value pairs.
	* @param {object}             [options]                                   The request options.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}  callback                                        `error` will contain information
	*                                                                         if an error occurs; otherwise `[result]{@link QueueResult}` will contain
	*                                                                         the queue information.
	*                                                                         `response` will contain information related to this operation.
	*/
	QueueService.prototype.setQueueMetadata = function (queue, metadata, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('setQueueMetadata', function (v) {
	    v.string(queue, 'queue');
	    v.queueNameIsValid(queue);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.put(queue)
	    .withQueryOption(QueryStringConstants.COMP, 'metadata')
	    .addOptionalMetadataHeaders(metadata);
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.queueResult = null;
	    if (!responseObject.error) {
	      responseObject.queueResult = new QueueResult(queue, metadata);
	      responseObject.queueResult.getPropertiesFromHeaders(responseObject.response.headers);
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.queueResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Adds a new message to the back of the message queue. 
	* The encoded message can be up to 64KB in size for versions 2011-08-18 and newer, or 8KB in size for previous versions. 
	* Unencoded messages must be in a format that can be included in an XML request with UTF-8 encoding. 
	* Queue messages are encoded using the `[TextXmlQueueMessageEncoder]{@link TextXmlQueueMessageEncoder}`. See queueService.messageEncoder to set encoder defaults. 
	* 
	* @this {QueueService}
	* @param {string}             queue                                       The queue name.
	* @param {string|Buffer}      messageText                                 The message text.
	* @param {object}             [options]                                   The request options.
	* @param {int}                [options.messageTimeToLive]                 The time-to-live interval for the message, in seconds. The maximum time-to-live allowed is 7 days. If this parameter is omitted, the default time-to-live is 7 days
	* @param {int}                [options.visibilityTimeout]                 Specifies the new visibility timeout value, in seconds, relative to server time. The new value must be larger than or equal to 0, and cannot be larger than 7 days. The visibility timeout of a message cannot be set to a value later than the expiry time. visibilitytimeout should be set to a value smaller than the time-to-live value.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}      callback                                    `error` will contain information
	*                                                                         if an error occurs; otherwise `[result]{@link QueueMessageResult}` will contain
	*                                                                         the message.
	*                                                                         `response` will contain information related to this operation.
	*
	* @example
	* var azure = require('azure-storage');
	* var queueService = azure.createQueueService();
	* queueService.createMessage('taskqueue', 'Hello world!', function(error) {
	*   if(!error) {
	*     // Message inserted
	*   }
	* });
	*/
	QueueService.prototype.createMessage = function (queue, messageText, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('createMessage', function (v) {
	    v.string(queue, 'queue');
	    v.queueNameIsValid(queue);
	    v.callback(callback);
	  });
	
	  var xmlMessageDescriptor = QueueMessageResult.serialize(messageText, this.messageEncoder);
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.post(queue + '/messages')
	    .withHeader(HeaderConstants.CONTENT_TYPE, 'application/atom+xml;charset="utf-8"')
	    .withHeader(HeaderConstants.CONTENT_LENGTH, Buffer.byteLength(xmlMessageDescriptor, 'utf8'))
	    .withQueryOption(QueryStringConstants.MESSAGE_TTL, options.messageTimeToLive)
	    .withQueryOption(QueryStringConstants.VISIBILITY_TIMEOUT, options.visibilityTimeout)
	    .withBody(xmlMessageDescriptor);
	
	  var messageEncoder = this.messageEncoder;
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.queueMessageResults = [];
	
	    if (responseObject.response && responseObject.response.body && responseObject.response.body.QueueMessagesList && responseObject.response.body.QueueMessagesList.QueueMessage) {
	      var messages = responseObject.response.body.QueueMessagesList.QueueMessage;
	
	      if (!_.isArray(messages)) {
	        messages = [ messages ];
	      }
	
	      messages.forEach(function (message) {
	        var queueMessageResult = QueueMessageResult.parse(message, messageEncoder);
	        responseObject.queueMessageResults.push(queueMessageResult);
	      });
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, responseObject.queueMessageResults[0], returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, webResource.body, options, processResponseCallback);
	};
	
	/**
	* Retrieve messages from the queue and makes them invisible to other consumers.
	*
	* @this {QueueService}
	* @param {string}             queue                                       The queue name.
	* @param {object}             [options]                                   The request options.
	* @param {int}                [options.numOfMessages]                     A nonzero integer value that specifies the number of messages to retrieve from the queue, up to a maximum of 32. By default, a single message is retrieved from the queue with this operation.
	* @param {int}                [options.visibilityTimeout]                 Required if not peek only. Specifies the new visibility timeout value, in seconds, relative to server time. The new value must be larger than or equal to 0, and cannot be larger than 7 days. The visibility timeout of a message can be set to a value later than the expiry time.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}  callback                                        `error` will contain information
	*                                                                         if an error occurs; otherwise `result` will contain
	*                                                                         a list of `[messages]{@link QueueMessageResult}`.
	*                                                                         `response` will contain information related to this operation.
	*
	* @example
	* var azure = require('azure-storage');
	* var queueService = azure.createQueueService();
	* var queueName = 'taskqueue';
	* queueService.getMessages(queueName, function(error, serverMessages) {
	*   if(!error) {
	*     // Process the message in less than 30 seconds, the message
	*     // text is available in serverMessages[0].messagetext
	*     queueService.deleteMessage(queueName, serverMessages[0].messageId, serverMessages[0].popReceipt, function(error) {
	*       if(!error){
	*           // Message deleted
	*       }
	*     });
	*   }
	* });
	*/
	QueueService.prototype.getMessages = function (queue, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('getMessages', function (v) {
	    v.string(queue, 'queue');
	    v.queueNameIsValid(queue);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  delete options.peekOnly;
	  
	  this._getOrPeekMessages(queue, options, callback);
	};
	
	/**
	* Retrieves a message from the queue and makes it invisible to other consumers.
	*
	* @this {QueueService}
	* @param {string}             queue                                       The queue name.
	* @param {object}             [options]                                   The request options.
	* @param {int}                [options.visibilityTimeout]                 Required if not peek only. Specifies the new visibility timeout value, in seconds, relative to server time. The new value must be larger than or equal to 0, and cannot be larger than 7 days. The visibility timeout of a message can be set to a value later than the expiry time.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}  callback                                        `error` will contain information
	*                                                                         if an error occurs; otherwise `[result]{@link QueueMessageResult}` will contain
	*                                                                         the message.
	*                                                                         `response` will contain information related to this operation.
	*
	* @example
	* var azure = require('azure-storage');
	* var queueService = azure.createQueueService();
	* var queueName = 'taskqueue';
	* queueService.getMessage(queueName, function(error, serverMessage) {
	*   if(!error) {
	*     // Process the message in less than 30 seconds, the message
	*     // text is available in serverMessage.messagetext
	*     queueService.deleteMessage(queueName, serverMessage.messageId, serverMessage.popReceipt, function(error) {
	*       if(!error){
	*           // Message deleted
	*       }
	*     });
	*   }
	* });
	*/
	QueueService.prototype.getMessage = function (queue, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('getMessage', function (v) {
	    v.string(queue, 'queue');
	    v.queueNameIsValid(queue);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  options.numOfMessages = 1;
	  
	  var finalCallback = function(error, messages, response){
	    var message;
	    if(messages && messages.length > 0){
	      message = messages[0];
	    }
	    
	    callback(error, message, response);
	  };
	  
	  this.getMessages(queue, options, finalCallback);
	};
	
	/**
	* Retrieves messages from the front of the queue, without changing the messages visibility.
	*
	* @this {QueueService}
	* @param {string}             queue                                       The queue name.
	* @param {object}             [options]                                   The request options.
	* @param {int}                [options.numOfMessages]                     A nonzero integer value that specifies the number of messages to retrieve from the queue, up to a maximum of 32. By default, a single message is retrieved from the queue with this operation.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}  callback                                        `error` will contain information
	*                                                                         if an error occurs; otherwise `result` will contain
	*                                                                         `[messages]{@link QueueMessageResult}`.
	*                                                                         `response` will contain information related to this operation.
	*/
	QueueService.prototype.peekMessages = function (queue, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('peekMessages', function (v) {
	    v.string(queue, 'queue');
	    v.queueNameIsValid(queue);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  options.peekOnly = true;
	  delete options.visibilityTimeout;
	  
	  this._getOrPeekMessages(queue, options, callback);
	};
	
	/**
	* Retrieves a message from the front of the queue, without changing the message visibility.
	*
	* @this {QueueService}
	* @param {string}             queue                                       The queue name.
	* @param {object}             [options]                                   The request options.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}  callback                                        `error` will contain information
	*                                                                         if an error occurs; otherwise `[result]{@link QueueMessageResult}` will contain
	*                                                                         the message.
	*                                                                         `response` will contain information related to this operation.
	*/
	QueueService.prototype.peekMessage = function (queue, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('peekMessage', function (v) {
	    v.string(queue, 'queue');
	    v.queueNameIsValid(queue);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  options.numOfMessages = 1;
	  
	  var finalCallback = function(error, messages, response){
	    var message;
	    if(messages && messages.length > 0){
	      message = messages[0];
	    }
	    
	    callback(error, message, response);
	  };
	  
	  this.peekMessages(queue, options, finalCallback);
	};
	
	/**
	* Deletes a specified message from the queue.
	*
	* @this {QueueService}
	* @param {string}             queue                                       The queue name.
	* @param {string}             messageId                                   The message identifier of the message to delete.
	* @param {string}             popReceipt                                  A valid pop receipt value returned from an earlier call to the Get Messages or Update Message operation
	* @param {object}             [options]                                   The request options.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResponse}  callback                                      `error` will contain information if an error occurs; 
	*                                                                         `response` will contain information related to this operation.
	*/
	QueueService.prototype.deleteMessage = function (queue, messageId, popReceipt, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('deleteMessage', function (v) {
	    v.string(queue, 'queue');
	    v.queueNameIsValid(queue);
	    v.callback(callback);
	  });
	
	  if (azureutil.objectIsNull(popReceipt)) {
	    throw new Error(SR.INVALID_POP_RECEIPT);
	  }
	
	  if (azureutil.objectIsNull(messageId)) {
	    throw new Error(SR.INVALID_MESSAGE_ID);
	  }
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.del(queue + '/messages/' + messageId)
	    .withQueryOption(QueryStringConstants.POP_RECEIPT, popReceipt, null, true);
	
	  var processResponseCallback = function (responseObject, next) {
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Clears all messages from the queue.
	*
	* @this {QueueService}
	* @param {string}             queue                                       The queue name.
	* @param {object}             [options]                                   The request options.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResponse}  callback                                      `error` will contain information
	*                                                                         if an error occurs; otherwise 
	*                                                                         `response` will contain information related to this operation.
	*/
	QueueService.prototype.clearMessages = function (queue, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('clearMessages', function (v) {
	    v.string(queue, 'queue');
	    v.queueNameIsValid(queue);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.del(queue + '/messages');
	
	  var processResponseCallback = function (responseObject, next) {
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Updates the visibility timeout of a message. You can also use this operation to update the contents of a message.
	* A message must be in a format that can be included in an XML request with UTF-8 encoding, and the encoded message can be up to 64KB in size.
	*
	* @this {QueueService}
	* @param {string}             queue                                       The queue name.
	* @param {string}             messageId                                   The message identifier of the message to update.
	* @param {string}             popReceipt                                  A valid pop receipt value returned from an earlier call to the Get Messages or Update Message operation
	* @param {int}                visibilityTimeout                           Specifies the new visibility timeout value, in seconds, relative to server time. The new value must be larger than or equal to 0, and cannot be larger than 7 days. The visibility timeout of a message can be set to a value later than the expiry time.
	* @param {object}             [options]                                   The request options.
	* @param {object}             [options.messageText]                       The new message text.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}  callback                                        `error` will contain information
	*                                                                         if an error occurs; otherwise `[result]{@link QueueMessageResult}` will contain
	*                                                                         the message result information.
	*                                                                         `response` will contain information related to this operation.
	*/
	QueueService.prototype.updateMessage = function (queue, messageId, popReceipt, visibilityTimeout, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('updateMessage', function (v) {
	    v.string(queue, 'queue');
	    v.queueNameIsValid(queue);
	    v.callback(callback);
	  });
	
	  if (azureutil.objectIsNull(popReceipt)) {
	    throw new Error(SR.INVALID_POP_RECEIPT);
	  }
	
	  if (azureutil.objectIsNull(messageId)) {
	    throw new Error(SR.INVALID_MESSAGE_ID);
	  }
	
	  var options = extend(true, {}, userOptions);
	  var content = null;
	  if (options.messageText) {
	    content = QueueMessageResult.serialize(options.messageText, this.messageEncoder);
	  }
	
	  var contentLength = content ? Buffer.byteLength(content, 'utf8') : 0;
	
	  var webResource = WebResource.put(queue + '/messages/' + messageId)
	    .withHeader(HeaderConstants.CONTENT_TYPE, 'application/atom+xml;charset="utf-8"')
	    .withHeader(HeaderConstants.CONTENT_LENGTH, contentLength)
	    .withQueryOption(QueryStringConstants.POP_RECEIPT, popReceipt, null, true)
	    .withQueryOption(QueryStringConstants.VISIBILITY_TIMEOUT, visibilityTimeout)
	    .withBody(content);
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.queueMessageResult = null;
	    if (!responseObject.error) {
	      responseObject.queueMessageResult = new QueueMessageResult(queue, messageId);
	      responseObject.queueMessageResult.getPropertiesFromHeaders(responseObject.response.headers);
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.queueMessageResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, webResource.body, options, processResponseCallback);
	};
	
	/**
	* Gets the queue's ACL.
	*
	* @this {QueueService}
	* @param {string}             queue                                       The queue name.
	* @param {object}             [options]                                   The request options.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}  callback                                        `error` will contain information
	*                                                                         if an error occurs; otherwise `[result]{@link QueueResult}` will contain
	*                                                                         information for the queue.
	*                                                                         `response` will contain information related to this operation.
	*/
	QueueService.prototype.getQueueAcl = function (queue, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('getQueueAcl', function (v) {
	    v.string(queue, 'queue');
	    v.queueNameIsValid(queue);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.get(queue)
	    .withQueryOption(QueryStringConstants.COMP, 'acl');
	
	  options.requestLocationMode = Constants.RequestLocationMode.PRIMARY_OR_SECONDARY;
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.queueResult = null;
	    if (!responseObject.error) {
	      responseObject.queueResult = new QueueResult(queue);
	      responseObject.queueResult.getPropertiesFromHeaders(responseObject.response.headers);
	      responseObject.queueResult.signedIdentifiers = AclResult.parse(responseObject.response.body);
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.queueResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Updates the queue's ACL.
	*
	* @this {QueueService}
	* @param {string}                             queue                                       The queue name.
	* @property   {Object.<string, AccessPolicy>}    signedIdentifiers                           The container ACL settings. See `[AccessPolicy]{@link AccessPolicy}` for detailed information.
	* @param {object}                             [options]                                   The request options.
	* @param {LocationMode}                       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}                             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}                               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                                         The default value is false.
	* @param {errorOrResult}  callback                                                        `error` will contain information
	*                                                                                         if an error occurs; otherwise `[result]{@link QueueResult}` will contain
	*                                                                                         information for the queue.
	*                                                                                         `response` will contain information related to this operation.
	* @example
	* var azure = require('azure-storage');
	* var SharedAccessPermissions = azure.QueueUtilities.SharedAccessPermissions;
	* var queueService = azure.createQueueService();
	* var sharedAccessPolicies = [
	* {AccessPolicy: {
	*     Permissions: PROCESS,
	*     Start: startDate,
	*     Expiry: expiryDate
	*   },
	*   Id: processOnly,
	* },
	* {AccessPolicy: {
	*     Permissions: SharedAccessPermissions.PROCESS + SharedAccessPermissions.DELETE,
	*     Start: startDate,
	*     Expiry: expiryDate
	*   },
	*   Id: processAndDelete,
	* }];
	* 
	* queueService.setQueueAcl(queueName, sharedAccessPolicies, function(error, queueResult, response) {
	*     // do whatever
	* });
	*/
	QueueService.prototype.setQueueAcl = function (queue, signedIdentifiers, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('setQueueAcl', function (v) {
	    v.string(queue, 'queue');
	    v.queueNameIsValid(queue);
	    v.callback(callback);
	  });
	  
	  var options = extend(true, {}, userOptions);
	
	  var policies = null;
	  if (signedIdentifiers) {
	    if(_.isArray(signedIdentifiers)) {
	      throw new TypeError(SR.INVALID_SIGNED_IDENTIFIERS);
	    }
	    policies = AclResult.serialize(signedIdentifiers);
	  }
	
	  var webResource = WebResource.put(queue)
	    .withQueryOption(QueryStringConstants.COMP, 'acl')
	    .withHeader(HeaderConstants.CONTENT_LENGTH, !azureutil.objectIsNull(policies) ? Buffer.byteLength(policies) : 0)
	    .withBody(policies);
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.containerResult = null;
	    if (!responseObject.error) {
	      responseObject.queueResult = new QueueResult(queue);
	      responseObject.queueResult.getPropertiesFromHeaders(responseObject.response.headers);
	      if (signedIdentifiers) {
	        responseObject.queueResult.signedIdentifiers = signedIdentifiers;
	      }
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.queueResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, webResource.body, options, processResponseCallback);
	};
	
	/**
	* Retrieves a shared access signature token.
	*
	* @this {QueueService}
	* @param {string}                   queue                                               The queue name.
	* @param {object}                   sharedAccessPolicy                                  The shared access policy.
	* @param {string}                   [sharedAccessPolicy.Id]                             The signed identifier.
	* @param {object}                   [sharedAccessPolicy.AccessPolicy.Permissions]       The permission type.
	* @param {date|string}              [sharedAccessPolicy.AccessPolicy.Start]             The time at which the Shared Access Signature becomes valid (The UTC value will be used).
	* @param {date|string}              [sharedAccessPolicy.AccessPolicy.Expiry]            The time at which the Shared Access Signature becomes expired (The UTC value will be used).
	* @param {string}                   [sharedAccessPolicy.AccessPolicy.IPAddressOrRange]  An IP address or a range of IP addresses from which to accept requests. When specifying a range, note that the range is inclusive.
	* @param {string}                   sharedAccessPolicy.AccessPolicy.Protocols           The protocols permitted for a request made with the account SAS. 
	*                                                                                       Possible values are both HTTPS and HTTP (https,http) or HTTPS only (https). The default value is https,http.
	* @return {string}                                                                      The shared access signature query string. Note this string does not contain the leading "?".
	*/
	QueueService.prototype.generateSharedAccessSignature = function (queue, sharedAccessPolicy) {
	  // check if the QueueService is able to generate a shared access signature
	  if (!this.storageCredentials || !this.storageCredentials.generateSignedQueryString) {
	    throw new Error(SR.CANNOT_CREATE_SAS_WITHOUT_ACCOUNT_KEY);
	  }
	
	  validate.validateArgs('generateSharedAccessSignature', function (v) {
	    v.string(queue, 'queue');
	    v.queueNameIsValid(queue);
	    v.object(sharedAccessPolicy, 'sharedAccessPolicy');
	  });
	
	  return this.storageCredentials.generateSignedQueryString(Constants.ServiceType.Queue, queue, sharedAccessPolicy, null);
	};
	
	/**
	* Checks to see if a queue exists.
	* @ignore
	*
	* @this {QueueService}
	* @param {string}             queue                                       The queue name.
	* @param {string}             primaryOnly                                 If true, the request will be executed against the primary storage location.
	* @param {object}             [options]                                   The request options.
	* @param {LocationMode}       [options.locationMode]                      Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]               The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]          The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]          The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                   A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                 Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {Function(error, result, response)}         callback             `error` will contain information
	*                                                                         if an error occurs; otherwise, `result` will contain
	*                                                                         the queue information including `exists` boolean member
	*                                                                         and `response` will contain information related to this operation.
	*
	*/
	QueueService.prototype._doesQueueExist = function (queue, primaryOnly, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('doesQueueExist', function(v) {
	    v.string(queue, 'queue');
	    v.queueNameIsValid(queue);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  var webResource = WebResource.head(queue)
	    .withQueryOption(QueryStringConstants.COMP, 'metadata');
	
	  if(primaryOnly === false) {
	    options.requestLocationMode = RequestLocationMode.PRIMARY_OR_SECONDARY;
	  }
	
	  var processResponseCallback = function(responseObject, next) {
	    responseObject.queueResult = new QueueResult(queue);
	    responseObject.queueResult.exists = false;
	    
	    if (!responseObject.error) {
	      responseObject.queueResult.exists = true;
	      responseObject.queueResult.getPropertiesFromHeaders(responseObject.response.headers);
	      
	    } else if (responseObject.error && responseObject.error.statusCode === Constants.HttpConstants.HttpResponseCodes.NotFound) {
	      responseObject.error = null;
	      responseObject.queueResult.exists = false;
	      responseObject.response.isSuccessful = true;
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.queueResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	 * @ignore
	 */
	QueueService.prototype._getOrPeekMessages = function (queue, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('_getOrPeekMessages', function (v) {
	    v.string(queue, 'queue');
	    v.queueNameIsValid(queue);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  if (!options.numOfMessages) {
	    options.numOfMessages = 1;
	  }
	
	  var webResource = WebResource.get(queue + '/messages')
	    .withQueryOption(QueryStringConstants.NUM_OF_MESSAGES, options.numOfMessages)
	    .withQueryOption(QueryStringConstants.VISIBILITY_TIMEOUT, options.visibilityTimeout)
	    .withQueryOption(QueryStringConstants.PEEK_ONLY, options.peekOnly);
	
	  if (options.peekOnly) {
	    // For peek message, it's a read-only action and can be performed against secondary endpoint.
	    options.requestLocationMode = RequestLocationMode.PRIMARY_OR_SECONDARY;
	  }
	
	
	  var messageEncoder = this.messageEncoder;
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.queueMessageResults = null;
	
	    if (!responseObject.error) {
	      responseObject.queueMessageResults = [];
	
	      if (responseObject.response.body.QueueMessagesList && responseObject.response.body.QueueMessagesList.QueueMessage) {
	        var messages = responseObject.response.body.QueueMessagesList.QueueMessage;
	
	        if (!_.isArray(messages)) {
	          messages = [ messages ];
	        }
	
	        messages.forEach(function (message) {
	          var queueMessageResult = QueueMessageResult.parse(message, messageEncoder);
	          responseObject.queueMessageResults.push(queueMessageResult);
	        });
	      }
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.queueMessageResults, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Retrieves a queue URL.
	*
	* @param {string}                   queue                    The queue name.
	* @param {string}                   [sasToken]               The Shared Access Signature token.
	* @param {boolean}                  [primary]                A boolean representing whether to use the primary or the secondary endpoint.
	* @return {string}                                           The formatted URL string.
	* @example
	* var azure = require('azure-storage');
	* var queueService = azure.createQueueService();
	* var sharedAccessPolicy = {
	*   AccessPolicy: {
	*     Permissions: azure.QueueUtilities.SharedAccessPermissions.READ,
	*     Start: startDate,
	*     Expiry: expiryDate
	*   },
	* };
	* 
	* var sasToken = queueService.generateSharedAccessSignature(queue, sharedAccessPolicy);
	* var sasUrl = queueService.getUrl(queue, sasToken);
	*/
	QueueService.prototype.getUrl = function (queue, sasToken, primary) {
	  validate.validateArgs('getUrl', function (v) {
	    v.string(queue, 'queue');
	    v.queueNameIsValid(queue);
	  });
	
	  return this._getUrl(queue, sasToken, primary);
	};
	
	module.exports = QueueService;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 302 */
/***/ function(module, exports) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Expose 'QueueUtilities'.
	exports = module.exports;
	
	/**
	* Defines enums for use with the Queue service.
	* @namespace QueueUtilities
	*/
	var QueueUtilities = {
		/**
	  * Permission types.
	  *
	  * @const
	  * @enum {string}
	  */
	  SharedAccessPermissions: {
	    READ: 'r',
	    ADD: 'a',
	    UPDATE: 'u',
	    PROCESS: 'p'
	  }
	};
	
	module.exports = QueueUtilities;

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Module dependencies.
	var util = __webpack_require__(4);
	var azureCommon = __webpack_require__(8);
	var SharedKey = azureCommon.SharedKey;
	var azureutil = azureCommon.util;
	var Constants = azureCommon.Constants;
	var HeaderConstants = Constants.HeaderConstants;
	var QueryStringConstants = Constants.QueryStringConstants;
	
	/**
	* Creates a new SharedKeyTable object.
	*
	* @constructor
	* @param {string} storageAccount    The storage account.
	* @param {string} storageAccessKey  The storage account's access key.
	* @param {bool}   usePathStyleUri   Boolean value indicating if the path, or the hostname, should include the storage account.
	*/
	function SharedKeyTable(storageAccount, storageAccessKey, usePathStyleUri) {
	  SharedKeyTable['super_'].call(this,
	    storageAccount,
	    storageAccessKey,
	    usePathStyleUri);
	}
	
	util.inherits(SharedKeyTable, SharedKey);
	
	/**
	* Signs a request with the Authentication header.
	*
	* @param {WebResource} The webresource to be signed.
	* @param {function(error)}  callback  The callback function.
	*/
	SharedKeyTable.prototype.signRequest = function (webResource, callback) {
	  var getvalueToAppend = function (value) {
	    if (azureutil.objectIsNull(value)) {
	      return '\n';
	    } else {
	      return value + '\n';
	    }
	  };
	
	  var stringToSign =
	      webResource.method + '\n' +
	      getvalueToAppend(webResource.headers[HeaderConstants.CONTENT_MD5]) +
	      getvalueToAppend(webResource.headers[HeaderConstants.CONTENT_TYPE]) +
	      getvalueToAppend(webResource.headers[HeaderConstants.MS_DATE]) +
	      this._getCanonicalizedResource(webResource);
	
	  var signature = this.signer.sign(stringToSign);
	
	  webResource.withHeader(HeaderConstants.AUTHORIZATION, 'SharedKey ' + this.storageAccount + ':' + signature);
	  callback(null);
	};
	
	/*
	* Retrieves the webresource's canonicalized resource string.
	* @param {WebResource} webResource The webresource to get the canonicalized resource string from.
	* @return {string} The canonicalized resource string.
	*/
	SharedKeyTable.prototype._getCanonicalizedResource = function (webResource) {
	  var path = '/';
	  if (webResource.path) {
	    path = webResource.path;
	  }
	
	  var canonicalizedResource = '/' + this.storageAccount + path;
	
	  var queryStringValues = webResource.queryString;
	  if (queryStringValues[QueryStringConstants.COMP]) {
	    canonicalizedResource += '?comp=' + queryStringValues[QueryStringConstants.COMP];
	  }
	
	  return canonicalizedResource;
	};
	
	module.exports = SharedKeyTable;

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Module dependencies.
	var azureCommon = __webpack_require__(8);
	var Md5Wrapper = __webpack_require__(34);
	var StorageServiceClient = azureCommon.StorageServiceClient;
	var WebResource = azureCommon.WebResource;
	var Constants = azureCommon.Constants;
	var HeaderConstants = Constants.HeaderConstants;
	var TableConstants = Constants.TableConstants;
	
	var RequestHandler = __webpack_require__(143);
	var entityResult = __webpack_require__(83);
	
	/**
	* Creates a new BatchResult.
	*
	* @param {TableService}      tableService    The table service.
	* @param {string}            table           The table name.
	* @param {array}             operations      The array of batch operations.
	* @constructor
	* @ignore
	*/
	function BatchResult(tableService, table, operations) {
	  this.tableService = tableService;
	  this.table = table;
	  this.operations = operations;
	  this.batchBoundary = 'batch_' + BatchResult._getBoundary();
	  this.changesetBoundary = 'changeset_' + BatchResult._getBoundary();
	}
	
	/**
	* Gets a boundary string.
	*
	* @return {string}   The boundary string.
	* @ignore
	*/
	BatchResult._getBoundary = function () {
	  return (new Md5Wrapper().createMd5Hash()).update('' + (new Date()).getTime()).digest('hex');
	};
	
	/**
	* Constructs the batch web request.
	*
	* @return {WebResource}   The batch WebResource.
	* @ignore
	*/
	BatchResult.prototype.constructWebResource = function () {
	  var webResource = WebResource.post('$batch')
	    .withRawResponse(true);
	
	  webResource.withHeader(HeaderConstants.CONTENT_TYPE, 'multipart/mixed; charset="utf-8"; boundary=' + this.batchBoundary);
	  webResource.withHeader(HeaderConstants.DATA_SERVICE_VERSION, '3.0;');
	  webResource.withHeader(HeaderConstants.MAX_DATA_SERVICE_VERSION, '3.0;NetFx');
	
	  return webResource;
	};
	
	/**
	* Serializes the batch web body.
	*
	* @return {string}      The serialized batch content.
	* @ignore
	*/
	BatchResult.prototype.serialize = function () {
	  var body = '--' + this.batchBoundary + '\n';
	  
	  if (this.operations.length === 1 && this.operations[0].type === TableConstants.Operations.RETRIEVE) {
	    body += HeaderConstants.CONTENT_TYPE + ': application/http\n';
	    body += HeaderConstants.CONTENT_TRANSFER_ENCODING + ': binary\n\n';
	    body += this._serializeOperation(this.operations[0]);
	  } else {
	    body += HeaderConstants.CONTENT_TYPE + ': multipart/mixed;charset="utf-8";boundary=' + this.changesetBoundary + '\n\n';
	
	    for (var i = 0; i < this.operations.length; i++) {
	      body += '--' + this.changesetBoundary + '\n';
	      body += HeaderConstants.CONTENT_TYPE + ': application/http\n';
	      body += HeaderConstants.CONTENT_TRANSFER_ENCODING + ': binary\n\n';
	      body += this._serializeOperation(this.operations[i], i) + '\n';
	    }
	    body += '--' + this.changesetBoundary + '--\n';
	  } 
	  body += '--' + this.batchBoundary + '--';
	
	  return body;
	};
	
	/**
	* Serializes a request within the batch.
	*
	* @param {object}       The operation to serialize.  
	* @param {number}       The index of the operation in the operations arrray.
	* @return {string}      The serialized operation content.
	* @ignore
	*/
	BatchResult.prototype._serializeOperation = function (operation, count) {
	  operation.options.payloadFormat = operation.options.payloadFormat || this.tableService.defaultPayloadFormat;
	  var webResource = RequestHandler.constructEntityWebResource(operation.type, this.table, operation.entity, operation.options);
	
	  if (count) {
	    webResource.headers[HeaderConstants.CONTENT_ID] = count;
	  }
	
	  if (webResource.headers[HeaderConstants.CONTENT_TYPE]) {
	    webResource.headers[HeaderConstants.CONTENT_TYPE] += 'type=entry';
	  }
	
	  this.tableService._setRequestUrl(webResource);
	
	  var content = webResource.method + ' ' + webResource.uri + ' HTTP/1.1\n';
	
	  Object.keys(webResource.headers).forEach(function (header) {
	    content += header + ': ' + webResource.headers[header] + '\n';
	  });
	
	  content += '\n';
	  content += webResource.body || '';
	
	  return content;
	};
	
	/**
	* Parses a batch response.
	*
	* @param {object} responseObject    The response object for the batch request.
	* @return {array} An array with the processed / parsed responses.
	*/
	BatchResult.prototype.parse = function (responseObject) {
	  var responses = null;
	  if (responseObject && responseObject.response && responseObject.response.body &&
	      typeof responseObject.response.body === 'string') {
	    responses = [];
	    var rawResponses = responseObject.response.body.split(TableConstants.CHANGESET_DELIMITER);
	
	    if(rawResponses.length === 1) {
	      rawResponses = responseObject.response.body.split(TableConstants.BATCH_DELIMITER);
	    }
	
	    var self = this;
	    rawResponses.forEach(function (rawResponse) {
	      // Find HTTP/1.1 CODE line
	      var httpLocation = rawResponse.indexOf('HTTP/1.1');
	      if (httpLocation !== -1) {
	        rawResponse = rawResponse.substring(httpLocation);
	
	        // valid response
	        var response = self._parseOperation(rawResponse);
	        responses.push(response);
	      }
	    });
	  }
	
	  return responses;
	};
	
	/**
	* Parses a partial response.
	*
	* @param {string}      rawResponse      The raw, unparsed, http response from the server for the batch response.
	* @return {object}      A response object.
	*/
	BatchResult.prototype._parseOperation = function (rawResponse) {
	  var responseObject = {
	    error: null,
	    response: { }
	  };
	
	  // Split into multiple lines and process them
	  var responseLines = rawResponse.split('\r\n');
	
	  if (responseLines.length > 0) {
	    // Retrieve response code
	    var headers = responseLines.shift().split(' ');
	    if (headers.length >= 2) {
	      responseObject.response.statusCode = parseInt(headers[1]);
	      responseObject.response.isSuccessful = WebResource.validResponse(responseObject.response.statusCode);
	    }
	
	    // Populate headers
	    responseObject.response.headers = { };
	    responseObject.response.body = '';
	
	    var isBody = false;
	    responseLines.forEach(function (line) {
	      if (line === '' && !isBody) {
	        isBody = true;
	      } else if (isBody) {
	        responseObject.response.body += line;
	      } else {
	        var headerSplit = line.indexOf(':');
	        if (headerSplit !== -1) {
	          responseObject.response.headers[line.substring(0, headerSplit).trim().toLowerCase()] = line.substring(headerSplit + 1).trim();
	        }
	      }
	    });
	
	    StorageServiceClient._parseResponse(responseObject.response, this.tableService.xml2jsSettings);
	    if (!responseObject.response.isSuccessful) {
	      responseObject.error = StorageServiceClient._normalizeError(responseObject.response.body, responseObject.response);
	    }
	
	    if (!responseObject.error) {
	      var index = responseObject.response.headers[HeaderConstants.CONTENT_ID] || 0;
	      var propertyResolver;
	      var entityResolver;
	      if (index && this.operations[index]) {
	        var options = this.operations[index].options;
	        propertyResolver = options.propertyResolver;
	        entityResolver = options.entityResolver;
	      } 
	      responseObject.entity = entityResult.parseEntity(responseObject.response, propertyResolver, entityResolver);
	    }
	  }
	
	  return responseObject;
	};
	
	module.exports = BatchResult;

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Module dependencies.
	var odataHandler = __webpack_require__(142);
	
	function TableResult(name) {
	  this.name = name;
	}
	
	TableResult.serialize = function (tableName) {
	  return JSON.stringify({ TableName: tableName });
	};
	
	TableResult.parse = function (response) {
	  var result = null;
	  if (response.body) {
	    result = odataHandler.parseJsonTables(response.body);
	  }
	
	  return result;
	};
	
	exports = module.exports = TableResult;

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Module dependencies.
	var extend = __webpack_require__(26);
	
	var azureCommon = __webpack_require__(8);
	var SR = azureCommon.SR;
	var validate = azureCommon.validate;
	var Constants = azureCommon.Constants;
	var TableConstants = Constants.TableConstants;
	
	/**
	* Creates a new TableBatch.
	*
	* @constructor
	*/
	function TableBatch() {
	  this.operations = [];
	  this.pk = null;
	  this.retrieve = false;
	}
	
	/**
	* Removes all of the operations from the batch.
	*/
	TableBatch.prototype.clear = function () {
	  this.operations = [];
	};
	
	/**
	* Returns a boolean value indicating weather there are operations in the batch.
	*
	* @return {Boolean} True if there are operations queued up; false otherwise.
	*/
	TableBatch.prototype.hasOperations = function () {
	  return this.operations.length > 0;
	};
	
	/**
	* Returns the number of operations in the batch.
	*
	* @return {number} The number of operations in the batch.
	*/
	TableBatch.prototype.size = function () {
	  return this.operations.length;
	};
	
	/**
	* Adds a retrieve operation to the batch. Note that this must be the only operation in the batch.
	*
	* @param {string}             partitionKey                                    The partition key.
	* @param {string}             rowKey                                          The row key.
	* @param {object}             [options]                                       The request options.
	* @param {string}             [options.payloadFormat]                         The payload format to use for the request.
	* @param {TableService~propertyResolver}  [options.propertyResolver]  The property resolver. Given the partition key, row key, property name, property value,
	*                                                                             and the property Edm type if given by the service, returns the Edm type of the property.
	* @param {Function(entity)} [options.entityResolver]                          The entity resolver. Given the single entity returned by the query, returns a modified object.
	*/
	TableBatch.prototype.retrieveEntity = function (partitionKey, rowKey, options) {
	  var entity = { PartitionKey: {_: partitionKey, $: 'Edm.String'},
	    RowKey: {_: rowKey, $: 'Edm.String'},
	  };
	  this.addOperation(TableConstants.Operations.RETRIEVE, entity, options);
	};
	
	/**
	* Adds an insert operation to the batch.
	*
	* @param {object}             entity                                          The entity.
	* @param {object}             [options]                                       The request options.
	* @param {string}             [options.echoContent]                           Whether or not to return the entity upon a successful insert. Inserts only, default to false.
	* @param {string}             [options.payloadFormat]                         The payload format to use for the request.
	* @param {TableService~propertyResolver}  [options.propertyResolver]  The property resolver. Only applied if echoContent is true. Given the partition key, row key, property name, 
	*                                                                             property value, and the property Edm type if given by the service, returns the Edm type of the property.
	* @param {Function(entity)} [options.entityResolver]                          The entity resolver. Only applied if echoContent is true. Given the single entity returned by the insert, returns 
	*                                                                             a modified object.
	*/
	TableBatch.prototype.insertEntity = function (entity, options) {
	  this.addOperation(TableConstants.Operations.INSERT, entity, options);
	};
	
	/**
	* Adds a delete operation to the batch.
	*
	* @param {object}             entity              The entity.
	*/
	TableBatch.prototype.deleteEntity = function (entity) {
	  this.addOperation(TableConstants.Operations.DELETE, entity);
	};
	
	/**
	* Adds a merge operation to the batch.
	*
	* @param {object}             entity              The entity.
	*/
	TableBatch.prototype.mergeEntity = function (entity) {
	  this.addOperation(TableConstants.Operations.MERGE, entity);
	};
	
	/**
	* Adds an replace operation to the batch.
	*
	* @param {object}             entity              The entity.
	*/
	TableBatch.prototype.replaceEntity = function (entity) {
	  this.addOperation(TableConstants.Operations.REPLACE, entity);
	};
	
	/**
	* Adds an insert or replace operation to the batch.
	*
	* @param {object}             entity              The entity.
	*/
	TableBatch.prototype.insertOrReplaceEntity = function (entity) {
	  this.addOperation(TableConstants.Operations.INSERT_OR_REPLACE, entity);
	};
	
	/**
	* Adds an insert or merge operation to the batch.
	*
	* @param {object}             entity              The entity.
	*/
	TableBatch.prototype.insertOrMergeEntity = function (entity) {
	  this.addOperation(TableConstants.Operations.INSERT_OR_MERGE, entity);
	};
	
	/**
	* Adds an operation to the batch after performing checks.
	*
	* @param {string}             operationType       The type of operation to perform. See Constants.TableConstants.Operations
	* @param {object}             entity              The entity.
	* @param {object}             [options]                                       The request options.
	*/
	TableBatch.prototype.addOperation = function (operationType, entity, options) {
	  validate.validateArgs('addOperation', function (v) {
	    v.object(entity, 'entity');
	    v.object(entity.PartitionKey, 'entity.PartitionKey');
	    v.object(entity.RowKey, 'entity.RowKey');
	    v.stringAllowEmpty(entity.PartitionKey._, 'entity.PartitionKey._');
	    v.stringAllowEmpty(entity.RowKey._, 'entity.RowKey._');
	  });
	
	  if(this.operations.length >= 100) {
	    throw new Error(SR.BATCH_TOO_LARGE);
	  }
	
	  if (operationType === TableConstants.Operations.RETRIEVE) {
	    if(this.hasOperations()) {
	      throw new Error(SR.BATCH_ONE_RETRIEVE);
	    } else {
	      this.retrieve = true;
	    }
	  } else if (this.retrieve) {
	    throw new Error(SR.BATCH_ONE_RETRIEVE);
	  }
	
	  if (!this.hasOperations()) {
	    this.pk = entity.PartitionKey._;
	  } else if (entity.PartitionKey._ !== this.pk) {
	    throw new Error(SR.BATCH_ONE_PARTITION_KEY);
	  }
	
	  var copiedOptions = extend(true, {}, options);
	  this.operations.push({type: operationType, entity: entity, options: copiedOptions});
	};
	
	/**
	* Gets an operation from the batch. Returns null if the index does not exist.
	*
	* @param {number}             index           The index in the operations array at which to remove an element.
	* @return {object}                            The removed operation.
	*/
	TableBatch.prototype.getOperation = function (index) {
	  return this.operations[index];
	};
	
	/**
	* Removes an operation from the batch. Returns null if the index does not exist.
	*
	* @param {number}             index           The index in the operations array at which to remove an element.
	* @return {object}                            The removed operation.
	*/
	TableBatch.prototype.removeOperation = function (index) {
	  var operation = this.operations.splice(index, 1)[0];
	
	  // if the array is empty, unlock the partition key
	  if (!this.hasOperations()) {
	    this.pk = null;
	    this.retrieve = false;
	  }
	
	  return operation;
	};
	
	module.exports = TableBatch;


/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// 
	// Copyright (c) Microsoft and contributors.  All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// 
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// 
	
	// Module dependencies.
	var util = __webpack_require__(4);
	var extend = __webpack_require__(26);
	var _ = __webpack_require__(15);
	
	var azureCommon = __webpack_require__(8);
	var azureutil = azureCommon.util;
	var validate = azureCommon.validate;
	var SR = azureCommon.SR;
	var StorageServiceClient = azureCommon.StorageServiceClient;
	var SharedKeyTable = __webpack_require__(303);
	var RequestHandler = __webpack_require__(143);
	var TableQuery = __webpack_require__(144);
	var WebResource = azureCommon.WebResource;
	var Constants = azureCommon.Constants;
	var QueryStringConstants = Constants.QueryStringConstants;
	var HeaderConstants = Constants.HeaderConstants;
	var TableConstants = Constants.TableConstants;
	var RequestLocationMode = Constants.RequestLocationMode;
	
	// Models requires
	var TableResult = __webpack_require__(305);
	var entityResult = __webpack_require__(83);
	var BatchResult = __webpack_require__(304);
	var ServiceStatsParser = azureCommon.ServiceStatsParser;
	var AclResult = azureCommon.AclResult;
	var TableUtilities = __webpack_require__(52);
	
	/**
	* Creates a new TableService object.
	* If no connection string or storageaccount and storageaccesskey are provided,
	* the AZURE_STORAGE_CONNECTION_STRING or AZURE_STORAGE_ACCOUNT and AZURE_STORAGE_ACCESS_KEY environment variables will be used.
	* @class
	* The TableService object allows you to peform management operations with the Microsoft Azure Table Service.
	* The Table Service stores data in rows of key-value pairs. A table is composed of multiple rows, and each row
	* contains key-value pairs. There is no schema, so each row in a table may store a different set of keys.
	*
	* For more information on the Table Service, as well as task focused information on using it from a Node.js application, see
	* [How to Use the Table Service from Node.js](http://azure.microsoft.com/en-us/documentation/articles/storage-nodejs-how-to-use-table-storage/).
	* The following defaults can be set on the Table service.
	* defaultTimeoutIntervalInMs                          The default timeout interval, in milliseconds, to use for request made via the Table service.
	* defaultClientRequestTimeoutInMs                     The default timeout of client requests, in milliseconds, to use for the request made via the Table service.
	* defaultMaximumExecutionTimeInMs                     The default maximum execution time across all potential retries, for requests made via the Table service.
	* defaultLocationMode                                 The default location mode for requests made via the Table service.
	* defaultPayloadFormat                                The default payload format for requests made via the Table service.
	* useNagleAlgorithm                                   Determines whether the Nagle algorithm is used for requests made via the Table service.; true to use the  
	*                                                     Nagle algorithm; otherwise, false. The default value is false.
	* @constructor
	* @extends {StorageServiceClient}
	*
	* @param {string} [storageAccountOrConnectionString]  The storage account or the connection string.
	* @param {string} [storageAccessKey]                  The storage access key.
	* @param {string|object} [host]                       The host address. To define primary only, pass a string. 
	*                                                     Otherwise 'host.primaryHost' defines the primary host and 'host.secondaryHost' defines the secondary host.
	* @param {string} [sasToken]                          The Shared Access Signature token.
	* @param {string} [endpointSuffix]                    The endpoint suffix.
	*/
	function TableService(storageAccountOrConnectionString, storageAccessKey, host, sasToken, endpointSuffix) {
	  var storageServiceSettings = StorageServiceClient.getStorageSettings(storageAccountOrConnectionString, storageAccessKey, host, sasToken, endpointSuffix);
	
	  TableService['super_'].call(this,
	    storageServiceSettings._name,
	    storageServiceSettings._key,
	    storageServiceSettings._tableEndpoint,
	    storageServiceSettings._usePathStyleUri,
	    storageServiceSettings._sasToken);
	
	  if (this.anonymous) {
	    throw new Error(SR.ANONYMOUS_ACCESS_BLOBSERVICE_ONLY);
	  }
	
	  if(this.storageAccount && this.storageAccessKey) {
	    this.storageCredentials = new SharedKeyTable(this.storageAccount, this.storageAccessKey, this.usePathStyleUri);
	  }
	
	  this.defaultPayloadFormat = TableUtilities.PayloadFormat.MINIMAL_METADATA;
	}
	
	util.inherits(TableService, StorageServiceClient);
	
	// Table service methods
	
	/**
	* Gets the service stats for a storage account’s Table service.
	*
	* @this {TableService}
	* @param {object}         [options]                                       The request options.
	* @param {LocationMode}   [options.locationMode]                          Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                         Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}            [options.timeoutIntervalInMs]                   The server timeout interval, in milliseconds, to use for the request.
	* @param {int}            [options.clientRequestTimeoutInMs]              The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}            [options.maximumExecutionTimeInMs]              The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                         The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                         execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}         [options.clientRequestId]                       A string that represents the client request ID with a 1KB character limit.
	* @param {bool}           [options.useNagleAlgorithm]                     Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                         The default value is false.
	* @param {errorOrResult}  callback                                        `error` will contain information if an error occurs; 
	*                                                                         otherwise `[result]{@link ServiceStats}` will contain the stats.
	*                                                                         `response` will contain information related to this operation.
	*/
	TableService.prototype.getServiceStats = function (optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('getServiceStats', function (v) {
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  options.requestLocationMode = Constants.RequestLocationMode.PRIMARY_OR_SECONDARY;
	
	  var webResource = WebResource.get()
	    .withQueryOption(QueryStringConstants.COMP, 'stats')
	    .withQueryOption(QueryStringConstants.RESTYPE, 'service');
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.serviceStatsResult = null;
	    if (!responseObject.error) {
	      responseObject.serviceStatsResult = ServiceStatsParser.parse(responseObject.response.body.StorageServiceStats);
	    }
	
	    // function to be called after all filters
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.serviceStatsResult, returnObject.response);
	    };
	
	    // call the first filter
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Gets the properties of a storage account’s Table service, including Azure Storage Analytics.
	*
	* @this {TableService}
	* @param {object}             [options]                                    The request options.
	* @param {LocationMode}       [options.locationMode]                       Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                          Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]           The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]           The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                          The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                          execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                    A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                  Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                          The default value is false.
	* @param {errorOrResult}  callback                                         `error` will contain information if an error occurs; 
	*                                                                          otherwise `[result]{@link ServiceProperties}` will contain the properties.
	*                                                                         `response` will contain information related to this operation.
	*/
	TableService.prototype.getServiceProperties = function (optionsOrCallback, callback) {
	  return this.getAccountServiceProperties(optionsOrCallback, callback);
	};
	
	/**
	* Sets the properties of a storage account’s Table service, including Azure Storage Analytics.
	* You can also use this operation to set the default request version for all incoming requests that do not have a version specified.
	*
	* @this {TableService}
	* @param {object}             serviceProperties                            The service properties.
	* @param {object}             [options]                                    The request options.
	* @param {LocationMode}       [options.locationMode]                       Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                          Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]           The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]           The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                          The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                          execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                    A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                  Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                          The default value is false.
	* @param {errorOrResponse}  callback                                       `error` will contain information if an error occurs; 
	*                                                                          `response` will contain information related to this operation.
	*/
	TableService.prototype.setServiceProperties = function (serviceProperties, optionsOrCallback, callback) {
	  return this.setAccountServiceProperties(serviceProperties, optionsOrCallback, callback);
	};
	
	/**
	* Lists a segment containing a collection of table items under the specified account.
	*
	* @this {TableService}
	* @param {object}             currentToken                                      A continuation token returned by a previous listing operation. Please use 'null' or 'undefined' if this is the first operation.
	* @param {object}             [options]                                         The create options or callback function.
	* @param {int}                [options.maxResults]                              Specifies the maximum number of tables to return per call to Azure ServiceClient. 
	* @param {LocationMode}       [options.locationMode]                            Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                               Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                     The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]                The timeout of client requests, in milliseconds, to use for the request.
	* @param {string}             [options.payloadFormat]                           The payload format to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]                The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                               The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                               execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                         A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                       Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                               The default value is false.
	* @param {errorOrResult}  callback                                              `error` will contain information if an error occurs; 
	*                                                                               otherwise `result` will contain `entries` and `continuationToken`. 
	*                                                                               `entries`  gives a list of tables and the `continuationToken` is used for the next listing operation.
	*                                                                               `response` will contain information related to this operation.
	*/
	TableService.prototype.listTablesSegmented = function (currentToken, optionsOrCallback, callback) {
	  this.listTablesSegmentedWithPrefix(null /* prefix */, currentToken, optionsOrCallback, callback);
	};
	
	/**
	* Lists a segment containing a collection of table items under the specified account.
	*
	* @this {TableService}
	* @param {string}             prefix                                            The prefix of the table name.
	* @param {object}             currentToken                                      A continuation token returned by a previous listing operation. Please use 'null' or 'undefined' if this is the first operation.
	* @param {object}             [options]                                         The create options or callback function.
	* @param {int}                [options.maxResults]                              Specifies the maximum number of tables to return per call to Azure ServiceClient. 
	* @param {LocationMode}       [options.locationMode]                            Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                               Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                     The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]                The timeout of client requests, in milliseconds, to use for the request.
	* @param {string}             [options.payloadFormat]                           The payload format to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]                The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                               The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                               execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                         A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                       Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                               The default value is false.
	* @param {errorOrResult}  callback                                              `error` will contain information if an error occurs; 
	*                                                                               otherwise `result` will contain `entries` and `continuationToken`. 
	*                                                                               `entries`  gives a list of tables and the `continuationToken` is used for the next listing operation.
	*                                                                               `response` will contain information related to this operation.
	*/
	TableService.prototype.listTablesSegmentedWithPrefix = function (prefix, currentToken, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('listTables', function (v) {
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  options.payloadFormat = options.payloadFormat || this.defaultPayloadFormat;
	
	  var webResource = WebResource.get(TableConstants.TABLE_SERVICE_TABLE_NAME);
	  RequestHandler.setTableRequestHeadersAndBody(webResource, null, options.payloadFormat);
	
	  if(!azureutil.objectIsNull(currentToken)) {
	    webResource.withQueryOption(TableConstants.NEXT_TABLE_NAME, currentToken.nextTableName);
	  }
	
	  if(!azureutil.objectIsNull(prefix)) {
	    var query = new TableQuery()
	      .where(TableConstants.TABLE_NAME + ' >= ?', prefix)
	      .and(TableConstants.TABLE_NAME + ' < ?', prefix + '{');
	    
	    webResource.withQueryOption(QueryStringConstants.FILTER, query.toQueryObject().$filter);
	  }
	
	  if(!azureutil.objectIsNull(options.maxResults)) {
	    var query = new TableQuery().top(options.maxResults);
	    webResource.withQueryOption(QueryStringConstants.TOP, query.toQueryObject().$top);
	  }
	
	  options.requestLocationMode = azureutil.getNextListingLocationMode(currentToken);
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.listTablesResult = null;
	
	    if (!responseObject.error) {
	      responseObject.listTablesResult = {
	        entries: null,
	        continuationToken: null
	      };
	      responseObject.listTablesResult.entries = TableResult.parse(responseObject.response);
	
	      if (responseObject.response.headers[TableConstants.CONTINUATION_NEXT_TABLE_NAME] &&
	      !azureutil.objectIsEmpty(responseObject.response.headers[TableConstants.CONTINUATION_NEXT_TABLE_NAME])) {
	        responseObject.listTablesResult.continuationToken = {
	          nextTableName: null,
	          targetLocation: null
	        };
	
	        responseObject.listTablesResult.continuationToken.nextTableName = responseObject.response.headers[TableConstants.CONTINUATION_NEXT_TABLE_NAME];
	        responseObject.listTablesResult.continuationToken.targetLocation = responseObject.targetLocation;
	      }
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.listTablesResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	// Table Methods
	
	/**
	* Gets the table's ACL.
	*
	* @this {TableService}
	* @param {string}             table                                        The table name.
	* @param {object}             [options]                                    The request options.
	* @param {LocationMode}       [options.locationMode]                       Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                          Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]           The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]           The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                          The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                          execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                    A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                  Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                          The default value is false.
	* @param {errorOrResult}  callback                                         `error` will contain information if an error occurs; 
	*                                                                          otherwise `result` will contain the ACL information for the table. See `[AccessPolicy]{@link AccessPolicy}` for detailed information.
	*                                                                          `response` will contain information related to this operation.
	*/
	TableService.prototype.getTableAcl = function (table, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('getTableAcl', function (v) {
	    v.string(table, 'table');
	    v.tableNameIsValid(table);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  options.requestLocationMode = Constants.RequestLocationMode.PRIMARY_OR_SECONDARY;
	
	  var webResource = WebResource.get(table)
	    .withQueryOption(QueryStringConstants.COMP, 'acl');
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.tableResult = null;
	    if (!responseObject.error) {
	      responseObject.tableResult = new TableResult(table);
	      responseObject.tableResult.signedIdentifiers = AclResult.parse(responseObject.response.body);
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.tableResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Updates the table's ACL.
	*
	* @this {TableService}
	* @param {string}                                 table                                        The table name.
	* @param {Object.<string, AccessPolicy>}             signedIdentifiers                            The table ACL settings. See `[AccessPolicy]{@link AccessPolicy}` for detailed information.
	* @param {object}                                 [options]                                    The request options.
	* @param {LocationMode}                           [options.locationMode]                       Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                                              Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                                    [options.timeoutIntervalInMs]                The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                                    [options.clientRequestTimeoutInMs]           The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                                    [options.maximumExecutionTimeInMs]           The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                                              The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                                              execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}                                 [options.clientRequestId]                    A string that represents the client request ID with a 1KB character limit.
	* @param {bool}                                   [options.useNagleAlgorithm]                  Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                                              The default value is false.
	* @param {errorOrResult}                          callback                                     `error` will contain information if an error occurs; 
	*                                                                                              otherwise `result` will contain information for the table.
	*                                                                                              `response` will contain information related to this operation.
	*/
	TableService.prototype.setTableAcl = function (table, signedIdentifiers, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('setTableAcl', function (v) {
	    v.string(table, 'table');
	    v.tableNameIsValid(table);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  var policies = null;
	  if (signedIdentifiers) {
	    if(_.isArray(signedIdentifiers)) {
	      throw new TypeError(SR.INVALID_SIGNED_IDENTIFIERS);
	    }
	    policies = AclResult.serialize(signedIdentifiers);
	  }
	
	  var webResource = WebResource.put(table)
	    .withQueryOption(QueryStringConstants.COMP, 'acl')
	    .withHeader(HeaderConstants.CONTENT_LENGTH, !azureutil.objectIsNull(policies) ? Buffer.byteLength(policies) : 0)
	    .withBody(policies);
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.tableResult = null;
	    if (!responseObject.error) {
	
	      // SetTableAcl doesn't actually return anything in the response
	      responseObject.tableResult = new TableResult(table);
	      if (signedIdentifiers) {
	        responseObject.tableResult.signedIdentifiers = signedIdentifiers;
	      }
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.tableResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, webResource.body, options, processResponseCallback);
	};
	
	/**
	* Retrieves a shared access signature token.
	*
	* @this {TableService}
	* @param {string}                   table                                               The table name.
	* @param {object}                   sharedAccessPolicy                                  The shared access policy.
	* @param {string}                   [sharedAccessPolicy.Id]                             The signed identifier.
	* @param {object}                   [sharedAccessPolicy.AccessPolicy.Permissions]       The permission type.
	* @param {date|string}              [sharedAccessPolicy.AccessPolicy.Start]             The time at which the Shared Access Signature becomes valid (The UTC value will be used).
	* @param {date|string}              [sharedAccessPolicy.AccessPolicy.Expiry]            The time at which the Shared Access Signature becomes expired (The UTC value will be used).
	* @param {string}                   [sharedAccessPolicy.AccessPolicy.IPAddressOrRange]  An IP address or a range of IP addresses from which to accept requests. When specifying a range, note that the range is inclusive.
	* @param {string}                   [sharedAccessPolicy.AccessPolicy.Protocols]         The protocols permitted for a request made with the account SAS. 
	*                                                                                       Possible values are both HTTPS and HTTP (https,http) or HTTPS only (https). The default value is https,http.
	* @param {string}                   [sharedAccessPolicy.AccessPolicy.StartPk]           The starting Partition Key for which the SAS will be valid.
	* @param {string}                   [sharedAccessPolicy.AccessPolicy.EndPk]             The ending Partition Key for which the SAS will be valid.
	* @param {string}                   [sharedAccessPolicy.AccessPolicy.StartRk]           The starting Row Key for which the SAS will be valid.
	* @param {string}                   [sharedAccessPolicy.AccessPolicy.EndRk]             The ending Row Key for which the SAS will be valid.
	* @return {object}                                                                      An object with the shared access signature.
	*/
	TableService.prototype.generateSharedAccessSignature = function (table, sharedAccessPolicy) {
	  // check if the TableService is able to generate a shared access signature
	  if (!this.storageCredentials || !this.storageCredentials.generateSignedQueryString) {
	    throw new Error(SR.CANNOT_CREATE_SAS_WITHOUT_ACCOUNT_KEY);
	  }
	
	  validate.validateArgs('generateSharedAccessSignature', function (v) {
	    v.string(table, 'table');
	    v.tableNameIsValid(table);
	    v.object(sharedAccessPolicy, 'sharedAccessPolicy');
	  });
	  
	  var lowerCasedTableName = table.toLowerCase();
	  return this.storageCredentials.generateSignedQueryString(Constants.ServiceType.Table, lowerCasedTableName, sharedAccessPolicy, null, { tableName: lowerCasedTableName });
	};
	
	/**
	* Checks whether or not a table exists on the service.
	*
	* @this {TableService}
	* @param {string}             table                                   The table name.
	* @param {object}             [options]                               The request options.
	* @param {LocationMode}       [options.locationMode]                  Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                     Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]           The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]      The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]      The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                     The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                     execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]               A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]             Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                     The default value is false.
	* @param {errorOrResult}  callback                                    `error` will contain information if an error occurs; 
	*                                                                     otherwise `result` will contain the table information including `exists` boolean member. 
	*                                                                     `response` will contain information related to this operation.
	*/
	TableService.prototype.doesTableExist = function (table, optionsOrCallback, callback) {
	  this._doesTableExist(table, false, optionsOrCallback, callback);
	};
	
	/**
	* Creates a new table within a storage account.
	*
	* @this {TableService}
	* @param {string}             table                                   The table name.
	* @param {object}             [options]                               The request options.
	* @param {LocationMode}       [options.locationMode]                  Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                     Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]           The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]      The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]      The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                     The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                     execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]               A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]             Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                     The default value is false.
	* @param {errorOrResult}  callback                                    `error` will contain information if an error occurs; 
	*                                                                     otherwise `result` will contain the new table information.
	*                                                                     `response` will contain information related to this operation.
	*/
	TableService.prototype.createTable = function (table, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('createTable', function (v) {
	    v.string(table, 'table');
	    v.tableNameIsValid(table);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  var tableDescriptor = TableResult.serialize(table);
	
	  var webResource = WebResource.post('Tables')
	    .withHeader(HeaderConstants.PREFER, HeaderConstants.PREFER_NO_CONTENT);
	
	  RequestHandler.setTableRequestHeadersAndBody(webResource, tableDescriptor, this.defaultPayloadFormat);
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.tableResponse = {};
	    responseObject.tableResponse.isSuccessful = responseObject.error ? false : true;
	    responseObject.tableResponse.statusCode = responseObject.response.statusCode;
	    if (!responseObject.error) {
	      responseObject.tableResponse.TableName = table;
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.tableResponse, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, webResource.body, options, processResponseCallback);
	};
	
	/**
	* Creates a new table within a storage account if it does not exists.
	*
	* @this {TableService}
	* @param {string}             table                                   The table name.
	* @param {object}             [options]                               The request options.
	* @param {LocationMode}       [options.locationMode]                  Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                     Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]           The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]      The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]      The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                     The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                     execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]               A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]             Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                     The default value is false.
	* @param {errorOrResult}  callback                                    `error` will contain information if an error occurs; 
	*                                                                     `result` will contain the table information including `created` boolean member
	*                                                                     `response` will contain information related to this operation.
	*
	* @example
	* var azure = require('azure-storage');
	* var tableService = azure.createTableService();
	* tableService.createTableIfNotExists('tasktable', function(error) {
	*   if(!error) { 
	*     // Table created or exists
	*   }
	* });
	*/
	TableService.prototype.createTableIfNotExists = function (table, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('createTableIfNotExists', function (v) {
	    v.string(table, 'table');
	    v.tableNameIsValid(table);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  var self = this;
	  self._doesTableExist(table, true, options, function(error, result, response) {
	    var exists = result.exists;
	    result.created = false;
	    delete result.exists;
	    
	    if (error) {
	      callback(error, result, response);
	    } else if (exists) {
	      response.isSuccessful = true;
	      callback(error, result, response);
	    } else {
	      self.createTable(table, options, function(createError, createResult, response) {
	        if (!createError) {
	          createResult.created = true;
	        }
	        else if (createError && createError.statusCode === Constants.HttpConstants.HttpResponseCodes.Conflict && createError.code === Constants.TableErrorCodeStrings.TABLE_ALREADY_EXISTS) {
	          createError = null;
	          createResult.created = false;
	          createResult.isSuccessful = true;
	        }
	        callback(createError, createResult, response);
	      });
	    }
	  });
	};
	
	/**
	* Deletes a table from a storage account.
	*
	* @this {TableService}
	* @param {string}             table                                   The table name.
	* @param {object}             [options]                               The request options.
	* @param {LocationMode}       [options.locationMode]                  Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                     Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]           The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]      The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]      The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                     The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                     execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]               A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]             Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                     The default value is false.
	* @param {errorOrResponse}  callback                                  `error` will contain information if an error occurs;
	*                                                                     `response` will contain information related to this operation.
	*/
	TableService.prototype.deleteTable = function (table, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('deleteTable', function (v) {
	    v.string(table, 'table');
	    v.tableNameIsValid(table);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  var webResource = WebResource.del('Tables(\'' + table + '\')');
	  RequestHandler.setTableRequestHeadersAndBody(webResource, null, this.defaultPayloadFormat);
	
	  var processResponseCallback = function (responseObject, next) {
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Deletes a table from a storage account, if it exists.
	*
	* @this {TableService}
	* @param {string}             table                                   The table name.
	* @param {object}             [options]                               The request options.
	* @param {LocationMode}       [options.locationMode]                  Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                     Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]           The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]      The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]      The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                     The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                     execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]               A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]             Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                     The default value is false.
	* @param {errorOrResult}  callback                                    `error` will contain information if an error occurs; 
	*                                                                     `result` will be `true` if table was deleted, false otherwise
	*                                                                     `response` will contain information related to this operation.
	*/
	TableService.prototype.deleteTableIfExists = function (table, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('deleteTableIfExists', function (v) {
	    v.string(table, 'table');
	    v.tableNameIsValid(table);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	
	  var self = this;
	  self._doesTableExist(table, true, options, function(error, result, response) {
	    if (error) {
	      callback(error, result.exists, response);
	    } else if (!result.exists) {
	      response.isSuccessful = true;
	      callback(error, false, response);
	    } else {
	      self.deleteTable(table, options, function(deleteError, deleteResponse) {
	        var deleted;
	        if (!deleteError) {
	          deleted = true;
	        } else if (deleteError && deleteError.statusCode === Constants.HttpConstants.HttpResponseCodes.NotFound && deleteError.code === Constants.StorageErrorCodeStrings.RESOURCE_NOT_FOUND) {
	          deleted = false;
	          deleteError = null;
	          deleteResponse.isSuccessful = true;
	        }
	
	        callback(deleteError, deleted, deleteResponse);
	      });
	    }
	  });
	};
	
	// Table Entity Methods
	
	/**
	* Queries data in a table. To retrieve a single entity by partition key and row key, use retrieve entity.
	*
	* @this {TableService}
	* @param {string}             table                                                The table name.
	* @param {TableQuery}         tableQuery                                           The query to perform. Use null, undefined, or new TableQuery() to get all of the entities in the table.
	* @param {object}             currentToken                                         A continuation token returned by a previous listing operation. 
	*                                                                                  Please use 'null' or 'undefined' if this is the first operation.
	* @param {object}             [options]                                            The request options.
	* @param {LocationMode}       [options.locationMode]                               Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                                  Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                        The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]                   The timeout of client requests, in milliseconds, to use for the request.
	* @param {string}             [options.payloadFormat]                              The payload format to use for the request.
	* @param {bool}               [options.autoResolveProperties]                      If true, guess at all property types.
	* @param {int}                [options.maximumExecutionTimeInMs]                   The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                                  The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                                  execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                            A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                          Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                                  The default value is false.
	* @param {Function(entity)} [options.entityResolver]                               The entity resolver. Given a single entity returned by the query, returns a modified object which is added to 
	*                                                                                  the entities array.
	* @param {TableService~propertyResolver}  [options.propertyResolver]               The property resolver. Given the partition key, row key, property name, property value,
	*                                                                                  and the property Edm type if given by the service, returns the Edm type of the property.
	* @param {TableService~queryResponse} callback                                     `error` will contain information if an error occurs; 
	*                                                                                  otherwise `entities` will contain the entities returned by the query. 
	*                                                                                  If more matching entities exist, and could not be returned,
	*                                                                                  `queryResultContinuation` will contain a continuation token that can be used
	*                                                                                  to retrieve the next set of results.
	*                                                                                  `response` will contain information related to this operation.
	*
	* The logic for returning entity types can get complicated.  Here is the algorithm used:
	* ```
	* var propertyType;
	*
	* if (propertyResovler) {                      // If the caller provides a propertyResolver in the options, use it
	*   propertyType = propertyResolver(partitionKey, rowKey, propertyName, propertyValue, propertyTypeFromService);
	* } else if (propertyTypeFromService) {        // If the service provides us a property type, use it.  See below for an explanation of when this will and won't occur.
	*   propertyType = propertyTypeFromService;
	* } else if (autoResolveProperties) {          // If options.autoResolveProperties is set to true
	*   if (javascript type is string) {           // See below for an explanation of how and why autoResolveProperties works as it does.
	*     propertyType = 'Edm.String';
	*   } else if (javascript type is boolean) {
	*     propertyType = 'Edm.Boolean';
	*   }
	* }
	*
	* if (propertyType) {
	*   // Set the property type on the property.
	* } else {
	*   // Property gets no EdmType. 
	* }
	* ```
	* Notes:
	* 
	* * The service only provides a type if JsonFullMetadata or JsonMinimalMetadata is used, and if the type is Int64, Guid, Binary, or DateTime.
	* * Explanation of autoResolveProperties:
	*     * String gets correctly resolved to 'Edm.String'.
	*     * Int64, Guid, Binary, and DateTime all get resolved to 'Edm.String.'  This only happens if JsonNoMetadata is used (otherwise the service will provide the propertyType in a prior step).
	*     * Boolean gets correctly resolved to 'Edm.Boolean'.
	*     * For both Int32 and Double, no type information is returned, even in the case of autoResolveProperties = true.  This is due to an
	*          inability to distinguish between the two in certain cases.
	*
	* @example
	* var azure = require('azure-storage');
	* var tableService = azure.createTableService();
	* // tasktable should already exist and have entities
	* 
	* // returns all entities in tasktable, and a continuation token for the next page of results if necessary
	* tableService.queryEntities('tasktable', null, null \/*currentToken*\/, function(error, result) {
	*   if(!error) { 
	*     var entities = result.entities;
	*     // do stuff with the returned entities if there are any
	*   }
	* });
	* 
	* // returns field1 and field2 of the entities in tasktable, and a continuation token for the next page of results if necessary
	* var tableQuery = new TableQuery().select('field1', 'field2');
	* tableService.queryEntities('tasktable', tableQuery, null \/*currentToken*\/, function(error, result) {
	*   if(!error) { 
	*     var entities = result.entities;
	*     // do stuff with the returned entities if there are any
	*   }
	* });
	*/
	TableService.prototype.queryEntities = function (table, tableQuery, currentToken, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('queryEntities', function (v) {
	    v.string(table, 'table');
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  options.payloadFormat = options.payloadFormat || this.defaultPayloadFormat;
	
	  var webResource = WebResource.get(table);
	  RequestHandler.setTableRequestHeadersAndBody(webResource, null, options.payloadFormat);
	
	  if (tableQuery) {
	    var queryString = tableQuery.toQueryObject();
	    Object.keys(queryString).forEach(function (queryStringName) {
	      webResource.withQueryOption(queryStringName, queryString[queryStringName]);
	    });
	  }
	
	  if(!azureutil.objectIsNull(currentToken)) {
	    webResource.withQueryOption(TableConstants.NEXT_PARTITION_KEY, currentToken.nextPartitionKey);
	    webResource.withQueryOption(TableConstants.NEXT_ROW_KEY, currentToken.nextRowKey);
	  }
	
	  options.requestLocationMode = azureutil.getNextListingLocationMode(currentToken);
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.queryEntitiesResult = null;
	    if (!responseObject.error) {
	      responseObject.queryEntitiesResult = {
	        entries: null,
	        continuationToken: null
	      };
	
	      // entries
	      responseObject.queryEntitiesResult.entries = entityResult.parseQuery(responseObject.response, options.autoResolveProperties, options.propertyResolver, options.entityResolver);
	
	      // continuation token
	      var continuationToken = {
	          nextPartitionKey: responseObject.response.headers[TableConstants.CONTINUATION_NEXT_PARTITION_KEY],
	          nextRowKey: responseObject.response.headers[TableConstants.CONTINUATION_NEXT_ROW_KEY],
	          targetLocation: responseObject.targetLocation
	        };
	
	      if (!azureutil.IsNullOrEmptyOrUndefinedOrWhiteSpace(continuationToken.nextPartitionKey)) {
	        responseObject.queryEntitiesResult.continuationToken = continuationToken;
	      }
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.queryEntitiesResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Retrieves an entity from a table.
	*
	* @this {TableService}
	* @param {string}             table                                           The table name.
	* @param {string}             partitionKey                                    The partition key.
	* @param {string}             rowKey                                          The row key.
	* @param {object}             [options]                                       The request options.
	* @param {LocationMode}       [options.locationMode]                          Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                             Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                   The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]              The timeout of client requests, in milliseconds, to use for the request.
	* @param {string}             [options.payloadFormat]                         The payload format to use for the request.
	* @param {bool}               [options.autoResolveProperties]                 If true, guess at all property types.
	* @param {int}                [options.maximumExecutionTimeInMs]              The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                             The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                             execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                       A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                     Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                             The default value is false.
	* @param {TableService~propertyResolver}  [options.propertyResolver]          The property resolver. Given the partition key, row key, property name, property value,
	*                                                                             and the property Edm type if given by the service, returns the Edm type of the property.
	* @param {Function(entity)} [options.entityResolver]                          The entity resolver. Given the single entity returned by the query, returns a modified object.
	* @param {errorOrResult}  callback                                            `error` will contain information if an error occurs; 
	*                                                                             otherwise `result` will be the matching entity.
	*                                                                             `response` will contain information related to this operation.
	*
	* The logic for returning entity types can get complicated.  Here is the algorithm used:
	* ```
	* var propertyType;
	*
	* if (propertyResovler) {                      // If the caller provides a propertyResolver in the options, use it
	*   propertyType = propertyResolver(partitionKey, rowKey, propertyName, propertyValue, propertyTypeFromService);
	* } else if (propertyTypeFromService) {        // If the service provides us a property type, use it.  See below for an explanation of when this will and won't occur.
	*   propertyType = propertyTypeFromService;
	* } else if (autoResolveProperties) {          // If options.autoResolveProperties is set to true
	*   if (javascript type is string) {           // See below for an explanation of how and why autoResolveProperties works as it does.
	*     propertyType = 'Edm.String';
	*   } else if (javascript type is boolean) {
	*     propertyType = 'Edm.Boolean';
	*   }
	* }
	*
	* if (propertyType) {
	*   // Set the property type on the property.
	* } else {
	*   // Property gets no EdmType. 
	* }
	* ```
	* Notes:
	* 
	* * The service only provides a type if JsonFullMetadata or JsonMinimalMetadata is used, and if the type is Int64, Guid, Binary, or DateTime.
	* * Explanation of autoResolveProperties:
	*     * String gets correctly resolved to 'Edm.String'.
	*     * Int64, Guid, Binary, and DateTime all get resolved to 'Edm.String.'  This only happens if JsonNoMetadata is used (otherwise the service will provide the propertyType in a prior step).
	*     * Boolean gets correctly resolved to 'Edm.Boolean'.
	*     * For both Int32 and Double, no type information is returned, even in the case of autoResolveProperties = true.  This is due to an
	*          inability to distinguish between the two in certain cases.
	*
	* @example
	* var azure = require('azure-storage');
	* var tableService = azure.createTableService();
	* tableService.retrieveEntity('tasktable', 'tasksSeattle', '1', function(error, serverEntity) {
	*   if(!error) {
	*     // Entity available in serverEntity variable
	*   }
	* });
	*/
	TableService.prototype.retrieveEntity = function (table, partitionKey, rowKey, optionsOrCallback, callback) {
	  var entityDescriptor = { PartitionKey: {_: partitionKey, $: 'Edm.String'},
	    RowKey: {_: rowKey, $: 'Edm.String'},
	  };
	
	  validate.validateArgs('retrieveEntity', function (v) {
	    v.stringAllowEmpty(partitionKey, 'partitionKey');
	    v.stringAllowEmpty(rowKey, 'rowKey');
	  });
	
	  this._performEntityOperation(TableConstants.Operations.RETRIEVE, table, entityDescriptor, optionsOrCallback, callback);
	};
	
	/**
	* Inserts a new entity into a table.
	*
	* @this {TableService}
	* @param {string}             table                                           The table name.
	* @param {object}             entityDescriptor                                The entity descriptor.
	* @param {object}             [options]                                       The request options.
	* @param {string}             [options.echoContent]                           Whether or not to return the entity upon a successful insert. Default to false.
	* @param {string}             [options.payloadFormat]                         The payload format to use in the response, if options.echoContent is true.
	* @param {LocationMode}       [options.locationMode]                          Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                             Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                   The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]              The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]              The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                             The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                             execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                       A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                     Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                             The default value is false.
	* @param {TableService~propertyResolver}  [options.propertyResolver]          The property resolver. Only applied if echoContent is true. Given the partition key, row key, property name, 
	*                                                                             property value, and the property Edm type if given by the service, returns the Edm type of the property.
	* @param {Function(entity)} [options.entityResolver]                          The entity resolver. Only applied if echoContent is true. Given the single entity returned by the insert, returns 
	*                                                                             a modified object.
	* @param {errorOrResult}  callback                                            `error` will contain information if an error occurs; 
	*                                                                             otherwise `result` will contain the entity information.
	*                                                                             `response` will contain information related to this operation.
	*
	* @example
	* var azure = require('azure-storage');
	* var tableService = azure.createTableService();
	* var task1 = {
	*   PartitionKey : {'_': 'tasksSeattle', '$':'Edm.String'},
	*   RowKey: {'_': '1', '$':'Edm.String'},
	*   Description: {'_': 'Take out the trash', '$':'Edm.String'},
	*   DueDate: {'_': new Date(2011, 12, 14, 12), '$':'Edm.DateTime'}
	* };
	* tableService.insertEntity('tasktable', task1, function(error) {
	*   if(!error) {
	*     // Entity inserted
	*   }
	* }); 
	*/
	TableService.prototype.insertEntity = function (table, entityDescriptor, optionsOrCallback, callback) {
	  this._performEntityOperation(TableConstants.Operations.INSERT, table, entityDescriptor, optionsOrCallback, callback);
	};
	
	/**
	* Inserts or updates a new entity into a table.
	*
	* @this {TableService}
	* @param {string}             table                                   The table name.
	* @param {object}             entityDescriptor                        The entity descriptor.
	* @param {object}             [options]                               The request options.
	* @param {LocationMode}       [options.locationMode]                  Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                     Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]           The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]      The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]      The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                     The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                     execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]               A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]             Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                     The default value is false.
	* @param {errorOrResult}  callback                                    `error` will contain information if an error occurs; 
	*                                                                     otherwise `result` will contain the entity information.
	*                                                                     `response` will contain information related to this operation.
	*/
	TableService.prototype.insertOrReplaceEntity = function (table, entityDescriptor, optionsOrCallback, callback) {
	  this._performEntityOperation(TableConstants.Operations.INSERT_OR_REPLACE, table, entityDescriptor, optionsOrCallback, callback);
	};
	
	/**
	* Replaces an existing entity within a table. To replace conditionally based on etag, set entity['.metadata']['etag'].
	*
	* @this {TableService}
	* @param {string}             table                                   The table name.
	* @param {object}             entityDescriptor                        The entity descriptor.
	* @param {object}             [options]                               The request options.
	* @param {LocationMode}       [options.locationMode]                  Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                     Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]           The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]      The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]      The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                     The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                     execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]               A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]             Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                     The default value is false.
	* @param {errorOrResult}  callback                                    `error` will contain information if an error occurs; 
	*                                                                     otherwise `result` will contain the entity information.
	*                                                                     `response` will contain information related to this operation.
	*/
	TableService.prototype.replaceEntity = function (table, entityDescriptor, optionsOrCallback, callback) {
	  this._performEntityOperation(TableConstants.Operations.REPLACE, table, entityDescriptor, optionsOrCallback, callback);
	};
	
	/**
	* Updates an existing entity within a table by merging new property values into the entity. To merge conditionally based on etag, set entity['.metadata']['etag'].
	*
	* @this {TableService}
	* @param {string}             table                                   The table name.
	* @param {object}             entityDescriptor                        The entity descriptor. 
	* @param {object}             [options]                               The request options.
	* @param {LocationMode}       [options.locationMode]                  Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                     Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]           The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]      The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]      The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                     The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                     execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]               A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]             Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                     The default value is false.
	* @param {errorOrResult}  callback                                    `error` will contain information if an error occurs; 
	*                                                                     otherwise `result` will contain the entity information.
	*                                                                     response` will contain information related to this operation.
	*/
	TableService.prototype.mergeEntity = function (table, entityDescriptor, optionsOrCallback, callback) {
	  this._performEntityOperation(TableConstants.Operations.MERGE, table, entityDescriptor, optionsOrCallback, callback);
	};
	
	/**
	* Inserts or updates an existing entity within a table by merging new property values into the entity.
	*
	* @this {TableService}
	* @param {string}             table                                   The table name.
	* @param {object}             entityDescriptor                        The entity descriptor.
	* @param {object}             [options]                               The request options.
	* @param {LocationMode}       [options.locationMode]                  Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                     Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]           The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]      The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]      The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                     The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                     execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]               A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]             Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                     The default value is false.
	* @param {errorOrResult}  callback                                    `error` will contain information if an error occurs; 
	*                                                                     otherwise `result` will contain the entity information.
	*                                                                     `response` will contain information related to this operation.
	*/
	TableService.prototype.insertOrMergeEntity = function (table, entityDescriptor, optionsOrCallback, callback) {
	  this._performEntityOperation(TableConstants.Operations.INSERT_OR_MERGE, table, entityDescriptor, optionsOrCallback, callback);
	};
	
	/**
	* Deletes an entity within a table. To delete conditionally based on etag, set entity['.metadata']['etag'].
	*
	* @this {TableService}
	* @param {string}             table                                   The table name.
	* @param {object}             entityDescriptor                        The entity descriptor.
	* @param {object}             [options]                               The request options.
	* @param {LocationMode}       [options.locationMode]                  Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                     Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]           The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]      The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]      The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                     The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                     execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]               A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]             Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                     The default value is false.
	* @param {errorOrResponse}  callback                                  `error` will contain information if an error occurs; 
	*                                                                     `response` will contain information related to this operation.
	*/
	TableService.prototype.deleteEntity = function (table, entityDescriptor, optionsOrCallback, callback) {
	  this._performEntityOperation(TableConstants.Operations.DELETE, table, entityDescriptor, optionsOrCallback, callback);
	};
	
	/**
	* Executes the operations in the batch.
	*
	* @this {TableService}
	* @param {string}             table                                           The table name.
	* @param {TableBatch}         batch                                           The table batch to execute.
	* @param {object}             [options]                                       The create options or callback function.
	* @param {LocationMode}       [options.locationMode]                          Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                             Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]                   The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]              The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]              The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                             The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                             execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]                       A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]                     Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                             The default value is false.
	* @param {errorOrResult}  callback                                            `error` will contain information if an error occurs; 
	*                                                                             otherwise `result` will contain responses for each operation executed in the batch;
	*                                                                             `result.entity` will contain the entity information for each operation executed.
	*                                                                             `result.response` will contain the response for each operations executed.
	*                                                                             `response` will contain information related to this operation.
	*/
	TableService.prototype.executeBatch = function (table, batch, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('executeBatch', function (v) {
	    v.string(table, 'table');
	    v.tableNameIsValid(table);
	    v.object(batch, 'batch');
	    v.callback(callback);
	  });
	
	  if(!batch.hasOperations()) {
	    throw new Error(SR.EMPTY_BATCH);
	  }
	
	  var options = extend(true, {}, userOptions);
	
	  var batchResult = new BatchResult(this, table, batch.operations);
	  var webResource = batchResult.constructWebResource();
	
	  var body = batchResult.serialize();
	  webResource.withBody(body);
	  webResource.withHeader(HeaderConstants.CONTENT_LENGTH, Buffer.byteLength(body, 'utf8'));
	
	  var processResponseCallback = function (responseObject, next) {
	    var responseObjects = batchResult.parse(responseObject);
	
	    var noError = true;
	    // if the batch was unsuccesful, there will be a single response indicating the error
	    if (responseObjects && responseObjects.length > 0) {
	      responseObjects.forEach(function(item){
	        if(noError && !item.response.isSuccessful){
	          responseObject = item;
	          noError = false;
	        }
	      });
	    }
	    
	    if (noError) {
	      responseObject.operationResponses = responseObjects;
	    }
	
	    var finalCallback = function (returnObject) {
	      // perform final callback
	      callback(returnObject.error, returnObject.operationResponses, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, webResource.body, options, processResponseCallback);
	};
	
	// Private methods
	
	/**
	* Checks whether or not a table exists on the service.
	* @ignore
	*
	* @this {TableService}
	* @param {string}             table                                   The table name.
	* @param {string}             primaryOnly                             If true, the request will be executed against the primary storage location.
	* @param {object}             [options]                               The request options.
	* @param {LocationMode}       [options.locationMode]                  Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                     Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]           The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]      The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]      The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                     The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                     execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]               A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]             Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                     The default value is false.
	* @param {Function(error, result, response)}  callback                `error` will contain information if an error occurs; 
	*                                                                     otherwise `result` will contain
	*                                                                     the table information including `exists` boolean member. 
	*                                                                     `response` will contain information related to this operation.
	*/
	TableService.prototype._doesTableExist = function (table, primaryOnly, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('doesTableExist', function (v) {
	    v.string(table, 'table');
	    v.tableNameIsValid(table);
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  
	  if(primaryOnly === false) {
	    options.requestLocationMode = RequestLocationMode.PRIMARY_OR_SECONDARY;
	  }
	
	  var webResource = WebResource.get('Tables(\'' + table + '\')');
	  webResource.withHeader(HeaderConstants.ACCEPT, this.defaultPayloadFormat);
	
	  var processResponseCallback = function (responseObject, next) {
	    responseObject.tableResult = {};
	    responseObject.tableResult.isSuccessful = responseObject.error ? false : true;
	    responseObject.tableResult.statusCode = responseObject.response === null || responseObject.response === undefined ? undefined : responseObject.response.statusCode;
	    responseObject.tableResult.TableName = table;
	    
	    if(!responseObject.error){
	      responseObject.tableResult.exists = true;
	    } else if (responseObject.error && responseObject.error.statusCode === Constants.HttpConstants.HttpResponseCodes.NotFound) {
	      responseObject.error = null;
	      responseObject.tableResult.exists = false;
	      responseObject.response.isSuccessful = true;
	    }
	
	    var finalCallback = function (returnObject) {
	      callback(returnObject.error, returnObject.tableResult, returnObject.response);
	    };
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, null, options, processResponseCallback);
	};
	
	/**
	* Performs a table operation.
	*
	* @this {TableService}
	* @param {string}             operation                           The operation to perform.
	* @param {string}             table                               The table name.
	* @param {object}             entityDescriptor                    The entity descriptor.
	* @param {object}             [options]                           The create options or callback function.
	* @param {string}             [options.echoContent]               Whether or not to return the entity upon a successful insert. Default to false.
	* @param {string}             [options.payloadFormat]             The payload format to use for the request.
	* @param {LocationMode}       [options.locationMode]              Specifies the location mode used to decide which location the request should be sent to. 
	*                                                                 Please see StorageUtilities.LocationMode for the possible values.
	* @param {int}                [options.timeoutIntervalInMs]       The server timeout interval, in milliseconds, to use for the request.
	* @param {int}                [options.clientRequestTimeoutInMs]  The timeout of client requests, in milliseconds, to use for the request.
	* @param {int}                [options.maximumExecutionTimeInMs]  The maximum execution time, in milliseconds, across all potential retries, to use when making this request.
	*                                                                 The maximum execution time interval begins at the time that the client begins building the request. The maximum
	*                                                                 execution time is checked intermittently while performing requests, and before executing retries.
	* @param {string}             [options.clientRequestId]           A string that represents the client request ID with a 1KB character limit.
	* @param {bool}               [options.useNagleAlgorithm]         Determines whether the Nagle algorithm is used; true to use the Nagle algorithm; otherwise, false.
	*                                                                 The default value is false.
	* @param {errorOrResult}  callback                                `error` will contain information if an error occurs; 
	*                                                                 otherwise `entity` will contain the entity information.
	*                                                                 `response` will contain information related to this operation.
	* @ignore
	*/
	TableService.prototype._performEntityOperation = function (operation, table, entityDescriptor, optionsOrCallback, callback) {
	  var userOptions;
	  azureutil.normalizeArgs(optionsOrCallback, callback, function (o, c) { userOptions = o; callback = c; });
	
	  validate.validateArgs('entityOperation', function (v) {
	    v.string(table, 'table');
	    v.tableNameIsValid(table);
	    v.object(entityDescriptor, 'entityDescriptor');
	
	    if(typeof entityDescriptor.PartitionKey !== 'string') {
	      v.object(entityDescriptor.PartitionKey, 'entityDescriptor.PartitionKey');
	      v.stringAllowEmpty(entityDescriptor.PartitionKey._, 'entityDescriptor.PartitionKey._');
	    }
	    
	    if(typeof entityDescriptor.RowKey !== 'string') {
	      v.object(entityDescriptor.RowKey, 'entityDescriptor.RowKey');
	      v.stringAllowEmpty(entityDescriptor.RowKey._, 'entityDescriptor.RowKey._');
	    }
	    v.callback(callback);
	  });
	
	  var options = extend(true, {}, userOptions);
	  options.payloadFormat = options.payloadFormat || this.defaultPayloadFormat;
	
	  var webResource = RequestHandler.constructEntityWebResource(operation, table, entityDescriptor, options);
	
	  var processResponseCallback = function (responseObject, next) {
	    var finalCallback;
	    if (operation === TableConstants.Operations.DELETE) {
	      finalCallback = function (returnObject) {
	        callback(returnObject.error, returnObject.response);
	      };
	    } else {
	      responseObject.entityResponse = null;
	      if (!responseObject.error) {
	        responseObject.entityResponse = entityResult.parseEntity(responseObject.response, options.autoResolveProperties, options.propertyResolver, options.entityResolver);
	      }
	
	      finalCallback = function (returnObject) {
	        callback(returnObject.error, returnObject.entityResponse, returnObject.response);
	      };
	    }
	
	    next(responseObject, finalCallback);
	  };
	
	  this.performRequest(webResource, webResource.body, options, processResponseCallback);
	};
	
	/**
	* Retrieves a table URL.
	*
	* @param {string}                   table                    The table name.
	* @param {string}                   [sasToken]               The Shared Access Signature token.
	* @param {boolean}                  [primary]                A boolean representing whether to use the primary or the secondary endpoint.
	* @return {string}                                           The formatted URL string.
	* @example
	* var azure = require('azure-storage');
	* var tableService = azure.createTableService();
	* var sharedAccessPolicy = {
	*   AccessPolicy: {
	*     Permissions: azure.TableUtilities.SharedAccessPermissions.QUERY,
	*     Start: startDate,
	*     Expiry: expiryDate
	*   },
	* };
	* 
	* var sasToken = tableService.generateSharedAccessSignature(table, sharedAccessPolicy);
	* var sasUrl = tableService.getUrl(table, sasToken);
	*/
	TableService.prototype.getUrl = function (table, sasToken, primary) {
	  validate.validateArgs('getUrl', function (v) {
	    v.string(table, 'table');
	    v.tableNameIsValid(table);
	  });
	
	  return this._getUrl(table, sasToken, primary);
	};
	
	/**
	* Given the partition key, row key, property name, property value,
	* and the property Edm type if given by the service, returns the Edm type of the property.
	* @typedef {function} TableService~propertyResolver
	* @param {object} pk  The partition key.
	* @param {object} rk  The row key.
	* @param {string} name  The property name.
	* @param {object} value The property value.
	* @param {string} type  The EDM type.
	*/
	
	/** 
	* Returns entities matched by a query.
	* @callback TableService~queryResponse                                                                                
	* @param {object} error                     If an error occurs, the error information.
	* @param {object} entities                  The entities returned by the query.
	* @param {object} queryResultContinuation   If more matching entities exist, and could not be returned,
	*                                           a continuation token that can be used to retrieve more results.
	* @param {object} response                  Information related to this operation.
	*/
	
	module.exports = TableService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _localization = __webpack_require__(36);
	
	var _localization2 = _interopRequireDefault(_localization);
	
	var _telemetry = __webpack_require__(35);
	
	__webpack_require__(37);
	
	var _banner = __webpack_require__(324);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _helpOverlay = __webpack_require__(329);
	
	var _helpOverlay2 = _interopRequireDefault(_helpOverlay);
	
	var _controlBar = __webpack_require__(327);
	
	var _controlBar2 = _interopRequireDefault(_controlBar);
	
	var _console = __webpack_require__(326);
	
	var _console2 = _interopRequireDefault(_console);
	
	var _editor = __webpack_require__(328);
	
	var _editor2 = _interopRequireDefault(_editor);
	
	var _project = __webpack_require__(330);
	
	var _project2 = _interopRequireDefault(_project);
	
	var _board = __webpack_require__(325);
	
	var _board2 = _interopRequireDefault(_board);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import 'bootstrap/dist/css/bootstrap.css';
	
	
	var App = function (_Component) {
	    _inherits(App, _Component);
	
	    function App(props) {
	        _classCallCheck(this, App);
	
	        var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));
	
	        _this.reportPosition = function () {
	            var _this$refs$rightConta = _this.refs.rightContainer.getBoundingClientRect(),
	                top = _this$refs$rightConta.top,
	                left = _this$refs$rightConta.left,
	                right = _this$refs$rightConta.right,
	                bottom = _this$refs$rightConta.bottom,
	                width = _this$refs$rightConta.width,
	                height = _this$refs$rightConta.height;
	
	            _this.props.setComponentSize({
	                top: top, left: left, right: right, bottom: bottom, width: width, height: height,
	                dotX: -100,
	                dotY: -100
	            });
	        };
	
	        _this.onResize = function () {
	            _this.reportPosition();
	        };
	
	        (0, _telemetry.tracePageView)();
	        (0, _telemetry.tracePageViewAI)();
	        return _this;
	    }
	
	    _createClass(App, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (!localStorage.getItem('disable-help')) {
	                localStorage.setItem('disable-help', '1');
	                this.props.openGuide();
	            }
	            this.reportPosition();
	            window.addEventListener("resize", this.onResize);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener("resize", this.onResize);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'main' },
	                _react2.default.createElement(_banner2.default, null),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'main-container' },
	                    _react2.default.createElement(_project2.default, null),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'center-container' },
	                        _react2.default.createElement(_controlBar2.default, null),
	                        _react2.default.createElement(_editor2.default, null)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { ref: 'rightContainer', className: 'right-container ' + (this.props.highlight && 'highlight') },
	                        _react2.default.createElement(_board2.default, null),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'get-a-kit' },
	                            _react2.default.createElement(
	                                'a',
	                                { onClick: _telemetry.traceEvent.bind(this, 'buy-clicked'), className: 'no-underline', target: '_blank', href: _localization2.default.getLocalizedString().buyLink },
	                                _localization2.default.getLocalizedString().getAKitButton
	                            )
	                        ),
	                        _react2.default.createElement(_console2.default, null)
	                    )
	                ),
	                _react2.default.createElement(_helpOverlay2.default, null)
	            );
	        }
	    }]);
	
	    return App;
	}(_react.Component);
	
	exports.default = App;

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpButton = __webpack_require__(314);
	
	var _helpButton2 = _interopRequireDefault(_helpButton);
	
	var _localization = __webpack_require__(36);
	
	var _localization2 = _interopRequireDefault(_localization);
	
	var _telemetry = __webpack_require__(35);
	
	__webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import rpiLogo from '../img/rpi-logo.png'
	
	
	var Banner = function (_Component) {
	  _inherits(Banner, _Component);
	
	  function Banner() {
	    _classCallCheck(this, Banner);
	
	    return _possibleConstructorReturn(this, (Banner.__proto__ || Object.getPrototypeOf(Banner)).apply(this, arguments));
	  }
	
	  _createClass(Banner, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'banner' },
	        _react2.default.createElement(
	          'span',
	          null,
	          window.innerWidth <= 768 ? _localization2.default.getLocalizedString().pageTitleMobile : _localization2.default.getLocalizedString().pageTitle
	        ),
	        _react2.default.createElement(_helpButton2.default, {
	          switchGuide: this.props.switchGuide }),
	        _react2.default.createElement(
	          'a',
	          { onClick: _telemetry.traceEvent.bind(this, 'buy-clicked'), className: 'no-underline banner-button buy-link', target: '_blank', href: _localization2.default.getLocalizedString().buyLink },
	          _react2.default.createElement('i', { className: 'fa fa-shopping-cart', 'aria-hidden': 'true' }),
	          _localization2.default.getLocalizedString().buyButton
	        )
	      );
	    }
	  }]);
	
	  return Banner;
	}(_react.Component);
	
	exports.default = Banner;

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactKonva = __webpack_require__(39);
	
	__webpack_require__(37);
	
	var _led = __webpack_require__(318);
	
	var _led2 = _interopRequireDefault(_led);
	
	var _button = __webpack_require__(316);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _reset = __webpack_require__(321);
	
	var _reset2 = _interopRequireDefault(_reset);
	
	var _oled = __webpack_require__(320);
	
	var _oled2 = _interopRequireDefault(_oled);
	
	var _hts = __webpack_require__(317);
	
	var _hts2 = _interopRequireDefault(_hts);
	
	var _lsm6dsl = __webpack_require__(319);
	
	var _lsm6dsl2 = _interopRequireDefault(_lsm6dsl);
	
	var _devkitBoard = __webpack_require__(524);
	
	var _devkitBoard2 = _interopRequireDefault(_devkitBoard);
	
	var _immutable = __webpack_require__(21);
	
	var _sensorName = __webpack_require__(146);
	
	var sensorName = _interopRequireWildcard(_sensorName);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Board = function (_Component) {
	    _inherits(Board, _Component);
	
	    function Board(props) {
	        _classCallCheck(this, Board);
	
	        var _this = _possibleConstructorReturn(this, (Board.__proto__ || Object.getPrototypeOf(Board)).call(this, props));
	
	        _this.elasticEaseOut = function (t, b, c, d, a, p) {
	            // added s = 0
	            var s = 0;
	            if (t === 0) {
	                return b;
	            }
	            // eslint-disable-next-line no-cond-assign
	            if ((t /= d) === 1) {
	                return b + c;
	            }
	            if (!p) {
	                p = d * 0.3;
	            }
	            if (!a || a < Math.abs(c)) {
	                a = c;
	                s = p / 4;
	            } else {
	                s = p / (2 * Math.PI) * Math.asin(c / a);
	            }
	            return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
	        };
	
	        _this.throttle = function (fn, delay, mustRunDelay) {
	            var timer = null;
	            var t_start;
	            return function () {
	                var context = this,
	                    args = arguments,
	                    t_curr = +new Date();
	                clearTimeout(timer);
	                if (!t_start) {
	                    t_start = t_curr;
	                }
	                if (t_curr - t_start >= mustRunDelay) {
	                    fn.apply(context, args);
	                    t_start = t_curr;
	                } else {
	                    timer = setTimeout(function () {
	                        fn.apply(context, args);
	                    }, delay);
	                }
	            };
	        };
	
	        _this.setSelfSize = function () {
	            var cHeight = _this.stage.domNode.offsetHeight;
	            var cWidth = _this.stage.domNode.offsetWidth;
	            var bHeight = cHeight * 0.8;
	            var bWidth = bHeight / 611.0 * 400.0;
	            var st = _this.stage.getStage();
	            st.height(cHeight);
	            st.width(cWidth);
	            _this.setState(function () {
	                return {
	                    board: {
	                        cWidth: cWidth,
	                        cHeight: cHeight,
	                        bWidth: bWidth,
	                        bHeight: bHeight
	                    },
	                    selfX: (cWidth - bWidth) / 2,
	                    selfY: (cHeight - bHeight) / 2
	                };
	            });
	        };
	
	        _this.onResize = function () {
	            _this.setSelfSize();
	        };
	
	        _this.element = {};
	        _this.state = {
	            boardImage: null,
	            board: {
	                cWidth: 0,
	                cHeight: 0,
	                bWidth: 0,
	                bHeight: 0
	            },
	            selfX: 0,
	            selfY: 0
	        };
	        return _this;
	    }
	
	    _createClass(Board, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            window.addEventListener("resize", this.onResize);
	            this.setSelfSize();
	            var image = new window.Image();
	            image.src = _devkitBoard2.default;
	            image.onload = function () {
	                _this2.setState({
	                    boardImage: image
	                });
	            };
	            this.element.board.on('dragstart', function () {
	                _this2.element.image.to({
	                    duration: 0.2,
	                    // scaleX: shape.getAttr('startScale'),
	                    // scaleY: shape.getAttr('startScale'),
	                    shadowOffsetX: 10,
	                    shadowOffsetY: 10
	                });
	                _this2.props.setSensorData(sensorName.LSM6DSL, (0, _immutable.Map)({
	                    inMotion: true
	                }));
	            });
	            this.element.board.on('dragmove', function () {
	                _this2.setState(function () {
	                    return {
	                        selfX: _this2.element.board.attrs.x,
	                        selfY: _this2.element.board.attrs.y
	                    };
	                });
	                _this2.selfX = _this2.element.board.attrs.x;
	                _this2.selfY = _this2.element.board.attrs.y;
	                _this2.props.setSensorData(sensorName.LSM6DSL, (0, _immutable.Map)({
	                    x: _this2.element.board.attrs.x,
	                    y: _this2.element.board.attrs.y,
	                    inMotion: true
	                }));
	            });
	            this.element.board.on('dragend', function () {
	                _this2.element.image.to({
	                    duration: 0.5,
	                    easing: _this2.elasticEaseOut,
	                    // scaleX: shape.getAttr('startScale'),
	                    // scaleY: shape.getAttr('startScale'),
	                    shadowOffsetX: 0,
	                    shadowOffsetY: 0
	                });
	                _this2.props.setSensorData(sensorName.LSM6DSL, (0, _immutable.Map)({
	                    inMotion: false
	                }));
	            });
	            if (!window.devkitPlayground) {
	                window.devkitPlayground = Object.assign({}, this.element);
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener("resize", this.onResize);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                _reactKonva.Stage,
	                { ref: function ref(el) {
	                        _this3.stage = el;
	                    }, className: 'board-container', width: this.state.board.cWidth, height: this.state.board.cHeight },
	                _react2.default.createElement(
	                    _reactKonva.Layer,
	                    null,
	                    _react2.default.createElement(
	                        _reactKonva.Group,
	                        { ref: function ref(el) {
	                                _this3.element.board = el;
	                            }, draggable: true, x: this.state.selfX, y: this.state.selfY, width: this.state.board.bWidth, height: this.state.board.bHeight },
	                        _react2.default.createElement(_reactKonva.Image, { shadowBlur: 10, ref: function ref(el) {
	                                _this3.element.image = el;
	                            }, width: this.state.board.bWidth, height: this.state.board.bHeight, image: this.state.boardImage }),
	                        _react2.default.createElement(_oled2.default, { switchOn: this.props.switchOn, ref: function ref(el) {
	                                _this3.element.oled = el;
	                            }, sensorName: sensorName.OLED, x: 0.2776 * this.state.board.bWidth, y: 0.5687 * this.state.board.bHeight,
	                            w: 0.4522 * this.state.board.bWidth, h: 0.4522 * this.state.board.bWidth * 0.5 }),
	                        _react2.default.createElement(_button2.default, { setSensorData: this.props.setSensorData, ref: function ref(el) {
	                                _this3.element.buttonA = el;
	                            }, data: this.props.sensor.get(sensorName.BUTTON_A), sensorName: sensorName.BUTTON_A, x: 0.1325 * this.state.board.bWidth, y: 0.6180 * this.state.board.bHeight, r: 0.0320 * this.state.board.bWidth }),
	                        _react2.default.createElement(_button2.default, { setSensorData: this.props.setSensorData, ref: function ref(el) {
	                                _this3.element.buttonB = el;
	                            }, data: this.props.sensor.get(sensorName.BUTTON_B), sensorName: sensorName.BUTTON_B, x: 0.8710 * this.state.board.bWidth, y: 0.6200 * this.state.board.bHeight, r: 0.0320 * this.state.board.bWidth }),
	                        _react2.default.createElement(_led2.default, { switchOn: this.props.switchOn, setSensorData: this.props.setSensorData, ref: function ref(el) {
	                                _this3.element.led = el;
	                            }, data: this.props.sensor.get(sensorName.LED), sensorName: sensorName.LED, x: 0.1274 * this.state.board.bWidth, y: 0.7371 * this.state.board.bHeight, r: 0.0232 * this.state.board.bWidth }),
	                        _react2.default.createElement(_hts2.default, { setSensorData: this.props.setSensorData, ref: function ref(el) {
	                                _this3.element.hts221 = el;
	                            }, data: this.props.sensor.get(sensorName.HTS221), sensorName: sensorName.HTS221, x: 0.26 * this.state.board.bWidth, y: 0.8136 * this.state.board.bHeight,
	                            w: 0.09 * this.state.board.bWidth, h: 0.0353 * this.state.board.bHeight }),
	                        _react2.default.createElement(_lsm6dsl2.default, { setSensorData: this.props.setSensorData, ref: function ref(el) {
	                                _this3.element.lsm6dsl = el;
	                            }, data: this.props.sensor.get(sensorName.LSM6DSL), sensorName: sensorName.LSM6DSL, x: 0.45 * this.state.board.bWidth, y: 0.8136 * this.state.board.bHeight,
	                            w: 0.11 * this.state.board.bWidth, h: 0.0353 * this.state.board.bHeight }),
	                        _react2.default.createElement(_reset2.default, { resetBoard: this.props.resetBoard, x: 0.9323 * this.state.board.bWidth, y: 0.2408 * this.state.board.bHeight, r: 0.0267 * this.state.board.bWidth })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Board;
	}(_react.Component);
	
	exports.default = Board;

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(167);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactConsoleComponent = __webpack_require__(411);
	
	var _reactConsoleComponent2 = _interopRequireDefault(_reactConsoleComponent);
	
	__webpack_require__(353);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MyConsole = function (_Component) {
	    _inherits(MyConsole, _Component);
	
	    function MyConsole() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, MyConsole);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MyConsole.__proto__ || Object.getPrototypeOf(MyConsole)).call.apply(_ref, [this].concat(args))), _this), _this.writeLine = function (msg) {
	            if (!msg) {
	                return;
	            }
	            _this.myConsole.acceptLine();
	            _this.myConsole.log(msg);
	            _this.myConsole.return();
	        }, _this.echo = function (text) {
	            if (text.trim() === 'npm start') {
	                _this.props.onStart();
	            } else {
	                _this.myConsole.return();
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(MyConsole, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            this.writeLine(this.props.message.substring(prevProps.message.length));
	            this.writeLine(this.props.error);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.mj = _reactDom2.default.findDOMNode(this.myConsole);
	            var height = _reactDom2.default.findDOMNode(this.myConsole).getBoundingClientRect().height;
	            _reactDom2.default.findDOMNode(this.myConsole).style.height = height + "px";
	        }
	    }, {
	        key: 'promptLabel',
	        value: function promptLabel() {
	            return '';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'showConsole' },
	                _react2.default.createElement(_reactConsoleComponent2.default, { ref: function ref(Console) {
	                        _this2.myConsole = Console;
	                    },
	                    handler: function handler() {},
	                    promptLabel: this.promptLabel,
	                    value: this.props.error,
	                    autofocus: false,
	                    welcomeMessage: this.props.welcomeMessage
	                })
	            );
	        }
	    }]);
	
	    return MyConsole;
	}(_react.Component);
	
	exports.default = MyConsole;

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _localization = __webpack_require__(36);
	
	var _localization2 = _interopRequireDefault(_localization);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import {Glyphicon} from 'react-bootstrap';
	
	
	var ControlBar = function (_Component) {
	    _inherits(ControlBar, _Component);
	
	    function ControlBar() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ControlBar);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ControlBar.__proto__ || Object.getPrototypeOf(ControlBar)).call.apply(_ref, [this].concat(args))), _this), _this.reportPosition = function () {
	            var _this$refs$controlBar = _this.refs.controlBar.getBoundingClientRect(),
	                top = _this$refs$controlBar.top,
	                left = _this$refs$controlBar.left,
	                right = _this$refs$controlBar.right,
	                bottom = _this$refs$controlBar.bottom,
	                width = _this$refs$controlBar.width,
	                height = _this$refs$controlBar.height;
	
	            var dotX = right - 120;
	            var dotY = top + height / 2;
	            _this.props.setComponentSize({
	                top: top, left: left, right: right, bottom: bottom, width: width, height: height, dotX: dotX, dotY: dotY
	            });
	        }, _this.onResize = function () {
	            _this.reportPosition();
	        }, _this.handleClick = function () {
	            if (_this.props.isSampleRunning) {
	                _this.props.stopSample();
	            } else {
	                _this.props.runSample();
	                if (_this.props.highlight) {
	                    _this.props.switchGuide();
	                }
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ControlBar, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.reportPosition();
	            window.addEventListener("resize", this.onResize);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener("resize", this.onResize);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { ref: 'controlBar', className: 'controlBar ' + (this.props.highlight && 'highlight') },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'run-button ' + (this.props.isSampleRunning ? 'stop' : ''), onClick: this.handleClick },
	                    _react2.default.createElement('i', { className: 'fa ' + (this.props.isSampleRunning ? 'fa-stop' : 'fa-play'), 'aria-hidden': 'true' }),
	                    this.props.isSampleRunning ? _localization2.default.getLocalizedString().stopButton : _localization2.default.getLocalizedString().runButton
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'run-info' },
	                    this.props.runningInfo
	                )
	            );
	        }
	    }]);
	
	    return ControlBar;
	}(_react.Component);
	
	exports.default = ControlBar;

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoadScript = __webpack_require__(475);
	
	var _reactLoadScript2 = _interopRequireDefault(_reactLoadScript);
	
	__webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Editor = function (_Component) {
	    _inherits(Editor, _Component);
	
	    function Editor(props) {
	        _classCallCheck(this, Editor);
	
	        var _this = _possibleConstructorReturn(this, (Editor.__proto__ || Object.getPrototypeOf(Editor)).call(this, props));
	
	        _this.reportPosition = function () {
	            var _this$refs$editor$get = _this.refs.editor.getBoundingClientRect(),
	                top = _this$refs$editor$get.top,
	                left = _this$refs$editor$get.left,
	                right = _this$refs$editor$get.right,
	                bottom = _this$refs$editor$get.bottom,
	                width = _this$refs$editor$get.width,
	                height = _this$refs$editor$get.height;
	
	            var dotY = -100;
	            var dotX = -100;
	            _this.props.setComponentSize({
	                top: top, left: left, right: right, bottom: bottom, width: width, height: height, dotX: dotX, dotY: dotY
	            });
	        };
	
	        _this.editorDidMount = function () {
	            window.require(['vs/editor/editor.main'], function () {
	                _this.editor = window.monaco.editor.create(document.getElementById('editor-container'), {
	                    value: _this.props.data,
	                    language: _this.props.language,
	                    readOnly: true,
	                    folding: true
	                });
	                _this.setState({
	                    loading: false
	                });
	            });
	        };
	
	        _this.onResize = function () {
	            _this.editor.layout();
	            _this.reportPosition();
	        };
	
	        _this.state = {
	            loading: true
	        };
	        return _this;
	    }
	
	    _createClass(Editor, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if ((prevProps.data !== this.props.data || prevProps.language !== this.props.language) && this.editor) {
	                // store editor focus state
	                var hasFocus = this.editor.isFocused();
	                // save editor UI state
	                var currentEditorState = this.editor.saveViewState();
	                sessionStorage.setItem(prevProps.uniqueId, JSON.stringify(currentEditorState));
	                // reconfigure editor
	                this.editor.setValue(this.props.data);
	                this.editor.updateOptions({
	                    language: this.props.language
	                });
	                // restore editor UI state for current model (if already saved)
	                var oldEditorState = sessionStorage.getItem(this.props.uniqueId);
	                if (oldEditorState) {
	                    this.editor.restoreViewState(JSON.parse(oldEditorState));
	                } else {
	                    this.editor.setScrollPosition({ scrollTop: 0 });
	                }
	                // restore focus
	                if (hasFocus) {
	                    this.editor.focus();
	                }
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.reportPosition();
	            window.addEventListener("resize", this.onResize);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener("resize", this.onResize);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var loadComponent = _react2.default.createElement(
	                'div',
	                { className: 'loading' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'spinner-label' },
	                    ' Loading editor '
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'spinner' },
	                    _react2.default.createElement('div', { className: 'rect1' }),
	                    _react2.default.createElement('div', { className: 'rect2' }),
	                    _react2.default.createElement('div', { className: 'rect3' }),
	                    _react2.default.createElement('div', { className: 'rect4' }),
	                    _react2.default.createElement('div', { className: 'rect5' })
	                )
	            );
	            var editorComponent = _react2.default.createElement(
	                'div',
	                { ref: 'editor', id: 'editor-container', className: 'editor-container ' + (this.props.highlight && 'highlight') },
	                this.state.loading && loadComponent,
	                _react2.default.createElement(_reactLoadScript2.default, {
	                    url: 'vs/loader.js',
	                    onLoad: this.editorDidMount
	                })
	            );
	            return editorComponent;
	        }
	    }]);
	
	    return Editor;
	}(_react.Component);
	
	exports.default = Editor;

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _telemetry = __webpack_require__(35);
	
	__webpack_require__(37);
	
	var _localization = __webpack_require__(36);
	
	var _localization2 = _interopRequireDefault(_localization);
	
	var _guide = __webpack_require__(32);
	
	var GUIDE = _interopRequireWildcard(_guide);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HelpButton = function (_Component) {
	  _inherits(HelpButton, _Component);
	
	  function HelpButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HelpButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HelpButton.__proto__ || Object.getPrototypeOf(HelpButton)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function () {
	      _this.props.switchGuide(GUIDE.PROJECT);
	      (0, _telemetry.traceEvent)('help-open');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(HelpButton, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        { className: 'banner-button', onClick: this.onClick },
	        _react2.default.createElement('i', { className: 'fa fa-question-circle', 'aria-hidden': 'true' }),
	        _localization2.default.getLocalizedString().helpButton
	      );
	    }
	  }]);
	
	  return HelpButton;
	}(_react.Component);
	
	exports.default = HelpButton;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _telemetry = __webpack_require__(35);
	
	__webpack_require__(37);
	
	var _localization = __webpack_require__(36);
	
	var _localization2 = _interopRequireDefault(_localization);
	
	var _step = __webpack_require__(526);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _step3 = __webpack_require__(527);
	
	var _step4 = _interopRequireDefault(_step3);
	
	var _step5 = __webpack_require__(528);
	
	var _step6 = _interopRequireDefault(_step5);
	
	var _step7 = __webpack_require__(529);
	
	var _step8 = _interopRequireDefault(_step7);
	
	var _step9 = __webpack_require__(530);
	
	var _step10 = _interopRequireDefault(_step9);
	
	var _shake = __webpack_require__(525);
	
	var _shake2 = _interopRequireDefault(_shake);
	
	var _guide = __webpack_require__(32);
	
	var GUIDE = _interopRequireWildcard(_guide);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ARROW_WIDTH = 20;
	var ARROW_PADDING = 5;
	var DOT_RADIUS = 10;
	var GUIDE_WIDTH = 544;
	
	var GuideModal = function (_Component) {
	    _inherits(GuideModal, _Component);
	
	    function GuideModal() {
	        _classCallCheck(this, GuideModal);
	
	        return _possibleConstructorReturn(this, (GuideModal.__proto__ || Object.getPrototypeOf(GuideModal)).apply(this, arguments));
	    }
	
	    _createClass(GuideModal, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                x = _props.x,
	                y = _props.y,
	                textTitle = _props.textTitle,
	                textContent = _props.textContent,
	                image = _props.image;
	
	            return _react2.default.createElement(
	                'div',
	                { style: { top: y, left: x, flexFlow: this.props.reverse && 'row-reverse' }, className: 'guide-modal' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'guide-text-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'guide-text' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'guide-text-title' },
	                            textTitle
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'guide-text-content' },
	                            textContent
	                        ),
	                        this.props.externalLink && _react2.default.createElement(
	                            'div',
	                            { className: 'guide-external-link' },
	                            _react2.default.createElement(
	                                'a',
	                                { target: '_blank', href: this.props.externalLink.link, className: 'link' },
	                                this.props.externalLink.text
	                            )
	                        ),
	                        this.props.nextStep && _react2.default.createElement(
	                            'div',
	                            { className: 'guide-next-step', style: this.props.nextStepOnLeft ? { flexFlow: "row" } : {} },
	                            _react2.default.createElement(
	                                'span',
	                                { onClick: this.props.nextStep, className: 'step' },
	                                this.props.nextStepText ? this.props.nextStepText : _localization2.default.getLocalizedString().guideNextStep
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'guide-picture' },
	                    _react2.default.createElement('img', { alt: _localization2.default.getLocalizedString().guideStepBoardImageTitle, src: image })
	                )
	            );
	        }
	    }]);
	
	    return GuideModal;
	}(_react.Component);
	
	var GuideArrow = function (_Component2) {
	    _inherits(GuideArrow, _Component2);
	
	    function GuideArrow() {
	        _classCallCheck(this, GuideArrow);
	
	        return _possibleConstructorReturn(this, (GuideArrow.__proto__ || Object.getPrototypeOf(GuideArrow)).apply(this, arguments));
	    }
	
	    _createClass(GuideArrow, [{
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                x = _props2.x,
	                y = _props2.y,
	                position = _props2.position;
	
	            var style = void 0;
	            if (position === 3) {
	                style = {
	                    top: y,
	                    left: x,
	                    borderTopWidth: 15,
	                    borderRightWidth: 20,
	                    borderBottomWidth: 15,
	                    borderLeftWidth: 0,
	                    borderTopColor: 'transparent',
	                    borderRightColor: 'white',
	                    borderBottomColor: 'transparent',
	                    borderLeftColor: 'transparent'
	                };
	            } else if (position === 0) {
	                style = {
	                    top: y,
	                    left: x,
	                    borderTopWidth: 0,
	                    borderRightWidth: 15,
	                    borderBottomWidth: 20,
	                    borderLeftWidth: 15,
	                    borderTopColor: 'transparent',
	                    borderRightColor: 'transparent',
	                    borderBottomColor: 'white',
	                    borderLeftColor: 'transparent'
	                };
	            } else if (position === 1) {
	                style = {
	                    top: y,
	                    left: x,
	                    borderTopWidth: 15,
	                    borderRightWidth: 0,
	                    borderBottomWidth: 15,
	                    borderLeftWidth: 20,
	                    borderTopColor: 'transparent',
	                    borderRightColor: 'transparent',
	                    borderBottomColor: 'transparent',
	                    borderLeftColor: 'white'
	                };
	            }
	            return _react2.default.createElement('div', { style: style, className: 'guide-arrow' });
	        }
	    }]);
	
	    return GuideArrow;
	}(_react.Component);
	
	var HelpOverlay = function (_Component3) {
	    _inherits(HelpOverlay, _Component3);
	
	    function HelpOverlay() {
	        var _ref;
	
	        var _temp, _this3, _ret;
	
	        _classCallCheck(this, HelpOverlay);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this3 = _possibleConstructorReturn(this, (_ref = HelpOverlay.__proto__ || Object.getPrototypeOf(HelpOverlay)).call.apply(_ref, [this].concat(args))), _this3), _this3.onClose = function () {
	            _this3.props.toggleHelpState();
	            if (_this3.state.step === _this3.state.numOfSteps - 1) {
	                (0, _telemetry.traceEvent)('help-complete');
	            }
	            _this3.setState(function () {
	                return {
	                    step: 0,
	                    subStep: 0
	                };
	            });
	        }, _temp), _possibleConstructorReturn(_this3, _ret);
	    }
	
	    _createClass(HelpOverlay, [{
	        key: 'render',
	        value: function render() {
	            var _props3 = this.props,
	                guideId = _props3.guideId,
	                guidePosition = _props3.guidePosition;
	
	            if (!guidePosition) {
	                return null;
	            }
	            var displayModule = void 0;
	            if (guideId === GUIDE.PROJECT) {
	                displayModule = _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(GuideModal, { x: guidePosition.left + guidePosition.width + ARROW_WIDTH + ARROW_PADDING,
	                        y: guidePosition.top,
	                        textTitle: _localization2.default.getLocalizedString().guideStepFileTitle,
	                        textContent: _localization2.default.getLocalizedString().guideStepFileDetail,
	                        image: _step2.default }),
	                    _react2.default.createElement(GuideArrow, { x: guidePosition.left + guidePosition.width + ARROW_PADDING,
	                        y: guidePosition.top + 50,
	                        position: 3 })
	                );
	            } else if (guideId === GUIDE.EDITOR) {
	                displayModule = _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(GuideModal, { x: guidePosition.left + guidePosition.width + ARROW_WIDTH + ARROW_PADDING,
	                        y: guidePosition.top,
	                        textTitle: _localization2.default.getLocalizedString().guideStepCodeTitle,
	                        textContent: _localization2.default.getLocalizedString().guideStepCodeDetail,
	                        nextStep: this.props.switchGuide.bind(this, GUIDE.EDITOR + 1),
	                        image: _step4.default }),
	                    _react2.default.createElement(GuideArrow, { x: guidePosition.left + guidePosition.width + ARROW_PADDING,
	                        y: guidePosition.top + 50,
	                        position: 3 })
	                );
	            } else if (guideId === GUIDE.CONFIG_CLOUD) {
	                displayModule = _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(GuideModal, { x: guidePosition.left + guidePosition.width + ARROW_WIDTH + ARROW_PADDING,
	                        y: guidePosition.top,
	                        textTitle: _localization2.default.getLocalizedString().guideStepDeployTitle,
	                        textContent: _localization2.default.getLocalizedString().guideStepDeployDetail,
	                        externalLink: { text: _localization2.default.getLocalizedString().guideStepDeployLinkName, link: _localization2.default.getLocalizedString().guideStepDeployLinkHref },
	                        image: _step6.default }),
	                    _react2.default.createElement(GuideArrow, { x: guidePosition.left + guidePosition.width + ARROW_PADDING,
	                        y: guidePosition.top + 50,
	                        position: 3 })
	                );
	            } else if (guideId === GUIDE.CONFIG_LOCAL) {
	                displayModule = _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(GuideModal, { x: guidePosition.left + guidePosition.width + ARROW_WIDTH + ARROW_PADDING,
	                        y: guidePosition.top,
	                        textTitle: _localization2.default.getLocalizedString().guideStepFillCSTitle,
	                        textContent: _localization2.default.getLocalizedString().guideStepFillCSDetail,
	                        externalLink: { text: _localization2.default.getLocalizedString().guideStepFillCSLinkName, link: _localization2.default.getLocalizedString().guideStepFillCSLinkHref },
	                        image: _step8.default }),
	                    _react2.default.createElement(GuideArrow, { x: guidePosition.left + guidePosition.width + ARROW_PADDING,
	                        y: guidePosition.top + 50,
	                        position: 3 })
	                );
	            } else if (guideId === GUIDE.CONFIG_ERROR) {
	                displayModule = _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(GuideModal, { x: guidePosition.left + guidePosition.width + ARROW_WIDTH + ARROW_PADDING,
	                        y: guidePosition.top,
	                        textTitle: _localization2.default.getLocalizedString().guideStepFillCSErrorTitle,
	                        textContent: _localization2.default.getLocalizedString().guideStepFillCSErrorDetail,
	                        externalLink: { text: _localization2.default.getLocalizedString().guideStepFillCSErrorLinkName, link: _localization2.default.getLocalizedString().guideStepFillCSErrorLinkHref },
	                        image: _step8.default }),
	                    _react2.default.createElement(GuideArrow, { x: guidePosition.left + guidePosition.width + ARROW_PADDING,
	                        y: guidePosition.top + 50,
	                        position: 3 })
	                );
	            } else if (guideId === GUIDE.CONTROL_BAR) {
	                displayModule = _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(GuideModal, { x: guidePosition.left + guidePosition.width - 100,
	                        y: guidePosition.top + 40 + ARROW_WIDTH + ARROW_PADDING,
	                        textTitle: _localization2.default.getLocalizedString().guideStepRunTitle,
	                        textContent: _localization2.default.getLocalizedString().guideStepRunDetail,
	                        image: _step4.default }),
	                    _react2.default.createElement(GuideArrow, { x: guidePosition.left + guidePosition.width - 80,
	                        y: guidePosition.top + 40 + ARROW_PADDING,
	                        position: 0 })
	                );
	            } else if (guideId === GUIDE.BOARD) {
	                displayModule = _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(GuideModal, { x: guidePosition.left - GUIDE_WIDTH - ARROW_WIDTH - ARROW_PADDING,
	                        y: guidePosition.top + 200,
	                        reverse: true,
	                        textTitle: _localization2.default.getLocalizedString().guideStepBoardTitle,
	                        textContent: _localization2.default.getLocalizedString().guideStepBoardDetail,
	                        externalLink: { text: _localization2.default.getLocalizedString().getAKitButton, link: _localization2.default.getLocalizedString().buyLink },
	                        nextStep: this.props.switchGuide.bind(this, GUIDE.CLOSE),
	                        nextStepOnLeft: true,
	                        nextStepText: 'I\'m done',
	                        image: _step10.default }),
	                    _react2.default.createElement(GuideArrow, { x: guidePosition.left - ARROW_WIDTH - ARROW_PADDING,
	                        y: guidePosition.top + 250,
	                        position: 1 })
	                );
	            }
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'overlay', style: { display: guideId === GUIDE.CLOSE ? "none" : "flex" } },
	                    displayModule,
	                    _react2.default.createElement(
	                        'span',
	                        { onClick: this.props.switchGuide.bind(this, GUIDE.CLOSE), className: 'close-guide' },
	                        _react2.default.createElement('i', { className: 'fa fa-times', 'aria-hidden': 'true' }),
	                        _localization2.default.getLocalizedString().guideTurnOff
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'guide-dot', style: { display: guideId === GUIDE.CLOSE ? "none" : "block", top: guidePosition.dotY - DOT_RADIUS, left: guidePosition.dotX - DOT_RADIUS } },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'guide-outer-dot' },
	                        _react2.default.createElement('span', { className: 'guide-inner-dot' })
	                    )
	                ),
	                _react2.default.createElement('img', { className: 'shake-icon', style: { display: guideId !== GUIDE.BOARD ? "none" : "block", left: guidePosition.left + 10, top: guidePosition.top + 10 }, src: _shake2.default, alt: _localization2.default.getLocalizedString().guideStepShakeImageTitle })
	            );
	        }
	    }]);
	
	    return HelpOverlay;
	}(_react.Component);
	
	exports.default = HelpOverlay;

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactKonva = __webpack_require__(39);
	
	var _immutable = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Button = function (_React$Component) {
	    _inherits(Button, _React$Component);
	
	    function Button() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Button);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Button.__proto__ || Object.getPrototypeOf(Button)).call.apply(_ref, [this].concat(args))), _this), _this.handleDown = function () {
	            _this.props.setSensorData(_this.props.sensorName, (0, _immutable.Map)({
	                down: true
	            }));
	        }, _this.handleUp = function () {
	            _this.props.setSensorData(_this.props.sensorName, (0, _immutable.Map)({
	                down: false
	            }));
	        }, _this.getSwitch = function () {
	            return _this.props.data.get('down');
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Button, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_reactKonva.Circle, {
	                x: this.props.x, y: this.props.y, radius: this.props.r, fill: this.props.data.get('down') ? "black" : "",
	                onMouseDown: this.handleDown, onMouseUp: this.handleUp
	            });
	        }
	    }]);
	
	    return Button;
	}(_react2.default.Component);
	
	exports.default = Button;

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactKonva = __webpack_require__(39);
	
	var _immutable = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HTS221 = function (_React$Component) {
	    _inherits(HTS221, _React$Component);
	
	    function HTS221() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, HTS221);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HTS221.__proto__ || Object.getPrototypeOf(HTS221)).call.apply(_ref, [this].concat(args))), _this), _this.random = function (min, max) {
	            return Math.random() * (max - min) + min;
	        }, _this.getTempature = function () {
	            var newTempature = _this.random(20, 32).toFixed(2);
	            _this.props.setSensorData(_this.props.sensorName, (0, _immutable.Map)({
	                temperature: newTempature
	            }));
	            return newTempature;
	        }, _this.getHumidity = function () {
	            var newHumidity = _this.random(60, 80).toFixed(2);
	            _this.props.setSensorData(_this.props.sensorName, (0, _immutable.Map)({
	                humidity: newHumidity
	            }));
	            return newHumidity;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(HTS221, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_reactKonva.Group, null);
	        }
	    }]);
	
	    return HTS221;
	}(_react2.default.Component);
	
	exports.default = HTS221;

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactKonva = __webpack_require__(39);
	
	var _immutable = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LED = function (_React$Component) {
	    _inherits(LED, _React$Component);
	
	    function LED() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, LED);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LED.__proto__ || Object.getPrototypeOf(LED)).call.apply(_ref, [this].concat(args))), _this), _this.setColor = function (r, g, b) {
	            _this.props.setSensorData(_this.props.sensorName, (0, _immutable.Map)({
	                r: r,
	                g: g,
	                b: b,
	                on: true
	            }));
	        }, _this.componentToHex = function (c) {
	            var hex = c.toString(16);
	            return hex.length === 1 ? "0" + hex : hex;
	        }, _this.turnOff = function () {
	            _this.props.setSensorData(_this.props.sensorName, (0, _immutable.Map)({
	                on: false
	            }));
	        }, _this.rgbToHex = function (r, g, b) {
	            return "#" + _this.componentToHex(r) + _this.componentToHex(g) + _this.componentToHex(b);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(LED, [{
	        key: 'render',
	        value: function render() {
	            var colorHex = this.rgbToHex(this.props.data.get('r'), this.props.data.get('g'), this.props.data.get('b'));
	            return _react2.default.createElement(_reactKonva.Circle, {
	                x: this.props.x, y: this.props.y, radius: this.props.r,
	                fill: this.props.data.get('on') && this.props.switchOn ? colorHex : "white"
	            });
	        }
	    }]);
	
	    return LED;
	}(_react2.default.Component);
	
	exports.default = LED;

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactKonva = __webpack_require__(39);
	
	var _immutable = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LSM6DSL = function (_React$Component) {
	    _inherits(LSM6DSL, _React$Component);
	
	    function LSM6DSL() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, LSM6DSL);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LSM6DSL.__proto__ || Object.getPrototypeOf(LSM6DSL)).call.apply(_ref, [this].concat(args))), _this), _this.clearDistance = function () {
	            _this.props.setSensorData(_this.props.sensorName, (0, _immutable.Map)({
	                distance: 0
	            }));
	        }, _this.getDistance = function () {
	            return _this.props.data.get('distance');
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(LSM6DSL, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            // setInterval(()=>console.log(this.props.data.get('distance')),300);
	            // setInterval(()=>console.log(this.props.data.get('inMotion')),300);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_reactKonva.Group, null);
	        }
	    }]);
	
	    return LSM6DSL;
	}(_react2.default.Component);
	
	exports.default = LSM6DSL;

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactKonva = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var XX = 128;
	var YY = 64;
	var font = [[0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00], [0x00, 0x00, 0x00, 0xF8, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x33, 0x30, 0x00, 0x00, 0x00], [0x00, 0x10, 0x0C, 0x06, 0x10, 0x0C, 0x06, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00], [0x40, 0xC0, 0x78, 0x40, 0xC0, 0x78, 0x40, 0x00, 0x04, 0x3F, 0x04, 0x04, 0x3F, 0x04, 0x04, 0x00], [0x00, 0x70, 0x88, 0xFC, 0x08, 0x30, 0x00, 0x00, 0x00, 0x18, 0x20, 0xFF, 0x21, 0x1E, 0x00, 0x00], [0xF0, 0x08, 0xF0, 0x00, 0xE0, 0x18, 0x00, 0x00, 0x00, 0x21, 0x1C, 0x03, 0x1E, 0x21, 0x1E, 0x00], [0x00, 0xF0, 0x08, 0x88, 0x70, 0x00, 0x00, 0x00, 0x1E, 0x21, 0x23, 0x24, 0x19, 0x27, 0x21, 0x10], [0x10, 0x16, 0x0E, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00], [0x00, 0x00, 0x00, 0xE0, 0x18, 0x04, 0x02, 0x00, 0x00, 0x00, 0x00, 0x07, 0x18, 0x20, 0x40, 0x00], [0x00, 0x02, 0x04, 0x18, 0xE0, 0x00, 0x00, 0x00, 0x00, 0x40, 0x20, 0x18, 0x07, 0x00, 0x00, 0x00], [0x40, 0x40, 0x80, 0xF0, 0x80, 0x40, 0x40, 0x00, 0x02, 0x02, 0x01, 0x0F, 0x01, 0x02, 0x02, 0x00], [0x00, 0x00, 0x00, 0xF0, 0x00, 0x00, 0x00, 0x00, 0x01, 0x01, 0x01, 0x1F, 0x01, 0x01, 0x01, 0x00], [0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x80, 0xB0, 0x70, 0x00, 0x00, 0x00, 0x00, 0x00], [0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x01, 0x01, 0x01, 0x01, 0x01, 0x01], [0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x30, 0x30, 0x00, 0x00, 0x00, 0x00, 0x00], [0x00, 0x00, 0x00, 0x00, 0x80, 0x60, 0x18, 0x04, 0x00, 0x60, 0x18, 0x06, 0x01, 0x00, 0x00, 0x00], [0x00, 0xE0, 0x10, 0x08, 0x08, 0x10, 0xE0, 0x00, 0x00, 0x0F, 0x10, 0x20, 0x20, 0x10, 0x0F, 0x00], [0x00, 0x10, 0x10, 0xF8, 0x00, 0x00, 0x00, 0x00, 0x00, 0x20, 0x20, 0x3F, 0x20, 0x20, 0x00, 0x00], [0x00, 0x70, 0x08, 0x08, 0x08, 0x88, 0x70, 0x00, 0x00, 0x30, 0x28, 0x24, 0x22, 0x21, 0x30, 0x00], [0x00, 0x30, 0x08, 0x88, 0x88, 0x48, 0x30, 0x00, 0x00, 0x18, 0x20, 0x20, 0x20, 0x11, 0x0E, 0x00], [0x00, 0x00, 0xC0, 0x20, 0x10, 0xF8, 0x00, 0x00, 0x00, 0x07, 0x04, 0x24, 0x24, 0x3F, 0x24, 0x00], [0x00, 0xF8, 0x08, 0x88, 0x88, 0x08, 0x08, 0x00, 0x00, 0x19, 0x21, 0x20, 0x20, 0x11, 0x0E, 0x00], [0x00, 0xE0, 0x10, 0x88, 0x88, 0x18, 0x00, 0x00, 0x00, 0x0F, 0x11, 0x20, 0x20, 0x11, 0x0E, 0x00], [0x00, 0x38, 0x08, 0x08, 0xC8, 0x38, 0x08, 0x00, 0x00, 0x00, 0x00, 0x3F, 0x00, 0x00, 0x00, 0x00], [0x00, 0x70, 0x88, 0x08, 0x08, 0x88, 0x70, 0x00, 0x00, 0x1C, 0x22, 0x21, 0x21, 0x22, 0x1C, 0x00], [0x00, 0xE0, 0x10, 0x08, 0x08, 0x10, 0xE0, 0x00, 0x00, 0x00, 0x31, 0x22, 0x22, 0x11, 0x0F, 0x00], [0x00, 0x00, 0x00, 0xC0, 0xC0, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x30, 0x30, 0x00, 0x00, 0x00], [0x00, 0x00, 0x00, 0x80, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x80, 0x60, 0x00, 0x00, 0x00, 0x00], [0x00, 0x00, 0x80, 0x40, 0x20, 0x10, 0x08, 0x00, 0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x00], [0x40, 0x40, 0x40, 0x40, 0x40, 0x40, 0x40, 0x00, 0x04, 0x04, 0x04, 0x04, 0x04, 0x04, 0x04, 0x00], [0x00, 0x08, 0x10, 0x20, 0x40, 0x80, 0x00, 0x00, 0x00, 0x20, 0x10, 0x08, 0x04, 0x02, 0x01, 0x00], [0x00, 0x70, 0x48, 0x08, 0x08, 0x08, 0xF0, 0x00, 0x00, 0x00, 0x00, 0x30, 0x36, 0x01, 0x00, 0x00], [0xC0, 0x30, 0xC8, 0x28, 0xE8, 0x10, 0xE0, 0x00, 0x07, 0x18, 0x27, 0x24, 0x23, 0x14, 0x0B, 0x00], [0x00, 0x00, 0xC0, 0x38, 0xE0, 0x00, 0x00, 0x00, 0x20, 0x3C, 0x23, 0x02, 0x02, 0x27, 0x38, 0x20], [0x08, 0xF8, 0x88, 0x88, 0x88, 0x70, 0x00, 0x00, 0x20, 0x3F, 0x20, 0x20, 0x20, 0x11, 0x0E, 0x00], [0xC0, 0x30, 0x08, 0x08, 0x08, 0x08, 0x38, 0x00, 0x07, 0x18, 0x20, 0x20, 0x20, 0x10, 0x08, 0x00], [0x08, 0xF8, 0x08, 0x08, 0x08, 0x10, 0xE0, 0x00, 0x20, 0x3F, 0x20, 0x20, 0x20, 0x10, 0x0F, 0x00], [0x08, 0xF8, 0x88, 0x88, 0xE8, 0x08, 0x10, 0x00, 0x20, 0x3F, 0x20, 0x20, 0x23, 0x20, 0x18, 0x00], [0x08, 0xF8, 0x88, 0x88, 0xE8, 0x08, 0x10, 0x00, 0x20, 0x3F, 0x20, 0x00, 0x03, 0x00, 0x00, 0x00], [0xC0, 0x30, 0x08, 0x08, 0x08, 0x38, 0x00, 0x00, 0x07, 0x18, 0x20, 0x20, 0x22, 0x1E, 0x02, 0x00], [0x08, 0xF8, 0x08, 0x00, 0x00, 0x08, 0xF8, 0x08, 0x20, 0x3F, 0x21, 0x01, 0x01, 0x21, 0x3F, 0x20], [0x00, 0x08, 0x08, 0xF8, 0x08, 0x08, 0x00, 0x00, 0x00, 0x20, 0x20, 0x3F, 0x20, 0x20, 0x00, 0x00], [0x00, 0x00, 0x08, 0x08, 0xF8, 0x08, 0x08, 0x00, 0xC0, 0x80, 0x80, 0x80, 0x7F, 0x00, 0x00, 0x00], [0x08, 0xF8, 0x88, 0xC0, 0x28, 0x18, 0x08, 0x00, 0x20, 0x3F, 0x20, 0x01, 0x26, 0x38, 0x20, 0x00], [0x08, 0xF8, 0x08, 0x00, 0x00, 0x00, 0x00, 0x00, 0x20, 0x3F, 0x20, 0x20, 0x20, 0x20, 0x30, 0x00], [0x08, 0xF8, 0xF8, 0x00, 0xF8, 0xF8, 0x08, 0x00, 0x20, 0x3F, 0x00, 0x3F, 0x00, 0x3F, 0x20, 0x00], [0x08, 0xF8, 0x30, 0xC0, 0x00, 0x08, 0xF8, 0x08, 0x20, 0x3F, 0x20, 0x00, 0x07, 0x18, 0x3F, 0x00], [0xE0, 0x10, 0x08, 0x08, 0x08, 0x10, 0xE0, 0x00, 0x0F, 0x10, 0x20, 0x20, 0x20, 0x10, 0x0F, 0x00], [0x08, 0xF8, 0x08, 0x08, 0x08, 0x08, 0xF0, 0x00, 0x20, 0x3F, 0x21, 0x01, 0x01, 0x01, 0x00, 0x00], [0xE0, 0x10, 0x08, 0x08, 0x08, 0x10, 0xE0, 0x00, 0x0F, 0x18, 0x24, 0x24, 0x38, 0x50, 0x4F, 0x00], [0x08, 0xF8, 0x88, 0x88, 0x88, 0x88, 0x70, 0x00, 0x20, 0x3F, 0x20, 0x00, 0x03, 0x0C, 0x30, 0x20], [0x00, 0x70, 0x88, 0x08, 0x08, 0x08, 0x38, 0x00, 0x00, 0x38, 0x20, 0x21, 0x21, 0x22, 0x1C, 0x00], [0x18, 0x08, 0x08, 0xF8, 0x08, 0x08, 0x18, 0x00, 0x00, 0x00, 0x20, 0x3F, 0x20, 0x00, 0x00, 0x00], [0x08, 0xF8, 0x08, 0x00, 0x00, 0x08, 0xF8, 0x08, 0x00, 0x1F, 0x20, 0x20, 0x20, 0x20, 0x1F, 0x00], [0x08, 0x78, 0x88, 0x00, 0x00, 0xC8, 0x38, 0x08, 0x00, 0x00, 0x07, 0x38, 0x0E, 0x01, 0x00, 0x00], [0xF8, 0x08, 0x00, 0xF8, 0x00, 0x08, 0xF8, 0x00, 0x03, 0x3C, 0x07, 0x00, 0x07, 0x3C, 0x03, 0x00], [0x08, 0x18, 0x68, 0x80, 0x80, 0x68, 0x18, 0x08, 0x20, 0x30, 0x2C, 0x03, 0x03, 0x2C, 0x30, 0x20], [0x08, 0x38, 0xC8, 0x00, 0xC8, 0x38, 0x08, 0x00, 0x00, 0x00, 0x20, 0x3F, 0x20, 0x00, 0x00, 0x00], [0x10, 0x08, 0x08, 0x08, 0xC8, 0x38, 0x08, 0x00, 0x20, 0x38, 0x26, 0x21, 0x20, 0x20, 0x18, 0x00], [0x00, 0x00, 0x00, 0xFE, 0x02, 0x02, 0x02, 0x00, 0x00, 0x00, 0x00, 0x7F, 0x40, 0x40, 0x40, 0x00], [0x00, 0x0C, 0x30, 0xC0, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x06, 0x38, 0xC0, 0x00], [0x00, 0x02, 0x02, 0x02, 0xFE, 0x00, 0x00, 0x00, 0x00, 0x40, 0x40, 0x40, 0x7F, 0x00, 0x00, 0x00], [0x00, 0x00, 0x04, 0x02, 0x02, 0x02, 0x04, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00], [0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x80, 0x80, 0x80, 0x80, 0x80, 0x80, 0x80, 0x80], [0x00, 0x02, 0x02, 0x04, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00], [0x00, 0x00, 0x80, 0x80, 0x80, 0x80, 0x00, 0x00, 0x00, 0x19, 0x24, 0x22, 0x22, 0x22, 0x3F, 0x20], [0x08, 0xF8, 0x00, 0x80, 0x80, 0x00, 0x00, 0x00, 0x00, 0x3F, 0x11, 0x20, 0x20, 0x11, 0x0E, 0x00], [0x00, 0x00, 0x00, 0x80, 0x80, 0x80, 0x00, 0x00, 0x00, 0x0E, 0x11, 0x20, 0x20, 0x20, 0x11, 0x00], [0x00, 0x00, 0x00, 0x80, 0x80, 0x88, 0xF8, 0x00, 0x00, 0x0E, 0x11, 0x20, 0x20, 0x10, 0x3F, 0x20], [0x00, 0x00, 0x80, 0x80, 0x80, 0x80, 0x00, 0x00, 0x00, 0x1F, 0x22, 0x22, 0x22, 0x22, 0x13, 0x00], [0x00, 0x80, 0x80, 0xF0, 0x88, 0x88, 0x88, 0x18, 0x00, 0x20, 0x20, 0x3F, 0x20, 0x20, 0x00, 0x00], [0x00, 0x00, 0x80, 0x80, 0x80, 0x80, 0x80, 0x00, 0x00, 0x6B, 0x94, 0x94, 0x94, 0x93, 0x60, 0x00], [0x08, 0xF8, 0x00, 0x80, 0x80, 0x80, 0x00, 0x00, 0x20, 0x3F, 0x21, 0x00, 0x00, 0x20, 0x3F, 0x20], [0x00, 0x80, 0x98, 0x98, 0x00, 0x00, 0x00, 0x00, 0x00, 0x20, 0x20, 0x3F, 0x20, 0x20, 0x00, 0x00], [0x00, 0x00, 0x00, 0x80, 0x98, 0x98, 0x00, 0x00, 0x00, 0xC0, 0x80, 0x80, 0x80, 0x7F, 0x00, 0x00], [0x08, 0xF8, 0x00, 0x00, 0x80, 0x80, 0x80, 0x00, 0x20, 0x3F, 0x24, 0x02, 0x2D, 0x30, 0x20, 0x00], [0x00, 0x08, 0x08, 0xF8, 0x00, 0x00, 0x00, 0x00, 0x00, 0x20, 0x20, 0x3F, 0x20, 0x20, 0x00, 0x00], [0x80, 0x80, 0x80, 0x80, 0x80, 0x80, 0x80, 0x00, 0x20, 0x3F, 0x20, 0x00, 0x3F, 0x20, 0x00, 0x3F], [0x80, 0x80, 0x00, 0x80, 0x80, 0x80, 0x00, 0x00, 0x20, 0x3F, 0x21, 0x00, 0x00, 0x20, 0x3F, 0x20], [0x00, 0x00, 0x80, 0x80, 0x80, 0x80, 0x00, 0x00, 0x00, 0x1F, 0x20, 0x20, 0x20, 0x20, 0x1F, 0x00], [0x80, 0x80, 0x00, 0x80, 0x80, 0x00, 0x00, 0x00, 0x80, 0xFF, 0xA1, 0x20, 0x20, 0x11, 0x0E, 0x00], [0x00, 0x00, 0x00, 0x80, 0x80, 0x80, 0x80, 0x00, 0x00, 0x0E, 0x11, 0x20, 0x20, 0xA0, 0xFF, 0x80], [0x80, 0x80, 0x80, 0x00, 0x80, 0x80, 0x80, 0x00, 0x20, 0x20, 0x3F, 0x21, 0x20, 0x00, 0x01, 0x00], [0x00, 0x00, 0x80, 0x80, 0x80, 0x80, 0x80, 0x00, 0x00, 0x33, 0x24, 0x24, 0x24, 0x24, 0x19, 0x00], [0x00, 0x80, 0x80, 0xE0, 0x80, 0x80, 0x00, 0x00, 0x00, 0x00, 0x00, 0x1F, 0x20, 0x20, 0x00, 0x00], [0x80, 0x80, 0x00, 0x00, 0x00, 0x80, 0x80, 0x00, 0x00, 0x1F, 0x20, 0x20, 0x20, 0x10, 0x3F, 0x20], [0x80, 0x80, 0x80, 0x00, 0x00, 0x80, 0x80, 0x80, 0x00, 0x01, 0x0E, 0x30, 0x08, 0x06, 0x01, 0x00], [0x80, 0x80, 0x00, 0x80, 0x00, 0x80, 0x80, 0x80, 0x0F, 0x30, 0x0C, 0x03, 0x0C, 0x30, 0x0F, 0x00], [0x00, 0x80, 0x80, 0x00, 0x80, 0x80, 0x80, 0x00, 0x00, 0x20, 0x31, 0x2E, 0x0E, 0x31, 0x20, 0x00], [0x80, 0x80, 0x80, 0x00, 0x00, 0x80, 0x80, 0x80, 0x80, 0x81, 0x8E, 0x70, 0x18, 0x06, 0x01, 0x00], [0x00, 0x80, 0x80, 0x80, 0x80, 0x80, 0x80, 0x00, 0x00, 0x21, 0x30, 0x2C, 0x22, 0x21, 0x30, 0x00], [0x00, 0x00, 0x00, 0x00, 0x80, 0x7C, 0x02, 0x02, 0x00, 0x00, 0x00, 0x00, 0x00, 0x3F, 0x40, 0x40], [0x00, 0x00, 0x00, 0x00, 0xFF, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0xFF, 0x00, 0x00, 0x00], [0x00, 0x02, 0x02, 0x7C, 0x80, 0x00, 0x00, 0x00, 0x00, 0x40, 0x40, 0x3F, 0x00, 0x00, 0x00, 0x00], [0x00, 0x06, 0x01, 0x01, 0x02, 0x02, 0x04, 0x04, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00]];
	
	var OLED = function (_React$Component) {
	    _inherits(OLED, _React$Component);
	
	    function OLED(props) {
	        _classCallCheck(this, OLED);
	
	        console.log('constructor called');
	
	        var _this = _possibleConstructorReturn(this, (OLED.__proto__ || Object.getPrototypeOf(OLED)).call(this, props));
	
	        _this._fillRect = function (x, y, w, h) {
	            for (var i = x; i < x + w; i++) {
	                for (var j = y; j < y + h; j++) {
	                    _this.pixels[j * XX + i] = true;
	                }
	            }
	        };
	
	        _this._clearRect = function (x, y, w, h) {
	            for (var i = x; i < x + w; i++) {
	                for (var j = y; j < y + h; j++) {
	                    _this.pixels[j * XX + i] = false;
	                }
	            }
	        };
	
	        _this.draw = function (x, y, x0, y0, bmp) {
	            var external = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
	
	            var w = x0 - x;
	            for (var i = 0; i < bmp.length; i++) {
	                var _y,
	                    _x = i % w + x,
	                    _p = bmp[i];
	
	                for (var j = 0; j < 8; j++) {
	                    _y = (y + Math.floor(i / w)) * 8 + j;
	                    if (_y >= y0 * 8) {
	                        return;
	                    }
	                    // if (_y >= 16) {
	                    //     this._setFillStyle('#00ffff');
	                    // } else {
	                    //     this._setFillStyle('#ffc000');
	                    // }
	
	                    if (_p % 2) {
	                        _this._fillRect(_x, _y, 1, 1);
	                    } else {
	                        _this._clearRect(_x, _y, 1, 1);
	                    }
	                    _p >>= 1;
	                }
	            }
	            if (external) {
	                _this.shape.draw();
	            }
	        };
	
	        _this.printChar = function (x, y, char) {
	            var charArray = ' !"#$%&\'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~';
	            var index = charArray.indexOf(char);
	            if (index === -1) {
	                index = 31;
	            }
	
	            var pixel = font[index];
	            _this.draw(x * 8, y * 2, x * 8 + 8, y * 2 + 2, pixel, false);
	        };
	
	        _this.print = function (line, str, wrap) {
	            if (typeof line !== 'number') {
	                str = line;
	                wrap = str;
	                line = 0;
	            }
	            _this._clearRect(0, line * YY / 4, XX, (line + 1) * YY / 4);
	
	            var c = 0;
	            for (var i = 0; i < str.length; i++) {
	                if ((str[i] === '\n' || c >= 16) && wrap) {
	                    line++;
	                    _this._clearRect(0, line * YY / 4, XX, (line + 1) * YY / 4);
	                    c = 0;
	                    if (c >= 16) {
	                        i--;
	                    }
	                } else {
	                    if (c >= 16 || line >= 4) {
	                        continue;
	                    }
	                    _this.printChar(c++, line, str[i]);
	                }
	            }
	            _this.shape.draw();
	        };
	
	        _this.clean = function () {
	            _this._clearRect(0, 0, 128, 64);
	            _this.shape.draw();
	        };
	
	        _this.initDraw = function (canvasContext) {
	            // let start = +new Date();
	            var p = _this.props.w / XX;
	            if (window.Konva.SceneContext.prototype.isPrototypeOf(canvasContext)) {
	                canvasContext.fillStyle = "#2d2d2d";
	                canvasContext.fillRect(0, 0, XX * p, YY * p);
	                if (_this.props.switchOn) {
	                    canvasContext.fillStyle = "#ffc000";
	                    for (var j = 0; j < YY / 4; j++) {
	                        for (var i = 0; i < XX; i++) {
	                            if (_this.pixels[j * XX + i]) {
	                                canvasContext.fillRect(i * p, j * p, p, p);
	                            }
	                        }
	                    }
	                    canvasContext.fillStyle = "#00ffff";
	                    for (var _j = YY / 4; _j < YY; _j++) {
	                        for (var _i = 0; _i < XX; _i++) {
	                            if (_this.pixels[_j * XX + _i]) {
	                                canvasContext.fillRect(_i * p, _j * p, p, p);
	                            }
	                        }
	                    }
	                } else {
	                    _this.pixels.fill(false);
	                }
	            }
	            // console.log('render end, ' + (+new Date() - start));
	        };
	
	        _this.drawQueue = [];
	        _this.pixels = new Array(XX * YY);
	        _this.pixels.fill(false);
	        return _this;
	    }
	
	    _createClass(OLED, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.mj2 = this.shape;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(_reactKonva.Shape, { ref: function ref(el) {
	                    _this2.shape = el;
	                }, sceneFunc: this.initDraw, x: this.props.x, y: this.props.y, width: this.props.w, height: this.props.h });
	        }
	    }]);
	
	    return OLED;
	}(_react2.default.Component);
	
	exports.default = OLED;

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactKonva = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Reset = function (_React$Component) {
	    _inherits(Reset, _React$Component);
	
	    function Reset() {
	        _classCallCheck(this, Reset);
	
	        return _possibleConstructorReturn(this, (Reset.__proto__ || Object.getPrototypeOf(Reset)).apply(this, arguments));
	    }
	
	    _createClass(Reset, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_reactKonva.Circle, {
	                x: this.props.x, y: this.props.y, radius: this.props.r,
	                onMouseDown: this.props.resetBoard
	            });
	        }
	    }]);
	
	    return Reset;
	}(_react2.default.Component);
	
	exports.default = Reset;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(21);
	
	var _telemetry = __webpack_require__(35);
	
	var _localization = __webpack_require__(36);
	
	var _localization2 = _interopRequireDefault(_localization);
	
	__webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Project = function (_Component) {
	    _inherits(Project, _Component);
	
	    function Project(props) {
	        _classCallCheck(this, Project);
	
	        var _this = _possibleConstructorReturn(this, (Project.__proto__ || Object.getPrototypeOf(Project)).call(this, props));
	
	        _this.reportPosition = function () {
	            {
	                var _this$refs$project$ge = _this.refs.project.getBoundingClientRect(),
	                    top = _this$refs$project$ge.top,
	                    left = _this$refs$project$ge.left,
	                    right = _this$refs$project$ge.right,
	                    bottom = _this$refs$project$ge.bottom,
	                    width = _this$refs$project$ge.width,
	                    height = _this$refs$project$ge.height;
	
	                var firstFileSize = _this.firstFileRef.getBoundingClientRect();
	                var dotX = firstFileSize.left + firstFileSize.width / 2;
	                var dotY = firstFileSize.top + firstFileSize.height / 2;
	                _this.props.setProjectComponentSize({
	                    top: top, left: left, right: right, bottom: bottom, width: width, height: height, dotX: dotX, dotY: dotY
	                });
	            }
	            {
	                var _this$refs$configClou = _this.refs.configCloud.getBoundingClientRect(),
	                    _top = _this$refs$configClou.top,
	                    _left = _this$refs$configClou.left,
	                    _right = _this$refs$configClou.right,
	                    _bottom = _this$refs$configClou.bottom,
	                    _width = _this$refs$configClou.width,
	                    _height = _this$refs$configClou.height;
	
	                var _dotX = _left + _width / 2 - 20;
	                var _dotY = _top + _height / 2;
	                _this.props.setConfigCloudComponentSize({
	                    top: _top, left: _left, right: _right, bottom: _bottom, width: _width, height: _height, dotX: _dotX, dotY: _dotY
	                });
	            }{
	                var _this$refs$configLoca = _this.refs.configLocal.getBoundingClientRect(),
	                    _top2 = _this$refs$configLoca.top,
	                    _left2 = _this$refs$configLoca.left,
	                    _right2 = _this$refs$configLoca.right,
	                    _bottom2 = _this$refs$configLoca.bottom,
	                    _width2 = _this$refs$configLoca.width,
	                    _height2 = _this$refs$configLoca.height;
	
	                var csInput = _this.connectionStringInput.getBoundingClientRect();
	                var _dotX2 = csInput.right - 20;
	                var _dotY2 = csInput.top + csInput.height / 2;
	                _this.props.setConfigLocalComponentSize({
	                    top: _top2, left: _left2, right: _right2, bottom: _bottom2, width: _width2, height: _height2, dotX: _dotX2, dotY: _dotY2
	                });
	            }
	        };
	
	        _this.onResize = function () {
	            _this.reportPosition();
	        };
	
	        _this.toggleFolderCollapsed = function (folderName) {
	            _this.setState(function (prev) {
	                return {
	                    folders: Object.assign(prev.folders, _defineProperty({}, folderName, !prev.folders[folderName]))
	                };
	            });
	        };
	
	        _this.toggleProjectSelectorCollapsed = function () {
	            _this.setState(function (prev) {
	                return {
	                    collapseProjectSelector: !prev.collapseProjectSelector
	                };
	            });
	        };
	
	        _this.fileClicked = function (path) {
	            _this.setState(function () {
	                return {
	                    selectedFilePath: path
	                };
	            });
	            _this.props.setEditorPath(path);
	            if (_this.props.highlightProject) {
	                _this.props.nextGuideAfterProject();
	            }
	        };
	
	        _this.handleChange = function (key, event) {
	            var newConfig = Object.assign({}, _this.state.config, _defineProperty({}, key, event.target.value));
	            var configureChanged = !(0, _immutable.is)(_this.props.project.get('config'), (0, _immutable.Map)(newConfig));
	            _this.setState(function (prev) {
	                return {
	                    configureChanged: configureChanged,
	                    config: newConfig
	                };
	            });
	            if (_this.props.highlightConfigLocal || _this.props.highlightError) {
	                var _this$refs$configLoca2 = _this.refs.configLocal.getBoundingClientRect(),
	                    top = _this$refs$configLoca2.top,
	                    left = _this$refs$configLoca2.left,
	                    right = _this$refs$configLoca2.right,
	                    bottom = _this$refs$configLoca2.bottom,
	                    width = _this$refs$configLoca2.width,
	                    height = _this$refs$configLoca2.height;
	
	                var saveIcon = _this.refs.saveConfig.getBoundingClientRect();
	                var dotX = saveIcon.left + saveIcon.width / 2;
	                var dotY = saveIcon.bottom;
	                _this.props.setConfigLocalComponentSize({
	                    top: top, left: left, right: right, bottom: bottom, width: width, height: height, dotX: dotX, dotY: dotY
	                });
	                _this.connectionStringInput.style.animation = null;
	            }
	        };
	
	        _this.revertConfig = function () {
	            _this.setState(function () {
	                return {
	                    configureChanged: false,
	                    config: _this.props.project.get('config').toJS()
	                };
	            });
	        };
	
	        _this.saveConfig = function () {
	            if (!/^HostName=([^;]*);DeviceId=([^;]*);SharedAccessKey=(.*)$/.test(_this.state.config.connectionString)) {
	                _this.setState({ csError: true });
	                if (_this.props.highlightConfigLocal) {
	                    _this.props.nextGuideForConfigError();
	
	                    var _this$refs$configLoca3 = _this.refs.configLocal.getBoundingClientRect(),
	                        top = _this$refs$configLoca3.top,
	                        left = _this$refs$configLoca3.left,
	                        right = _this$refs$configLoca3.right,
	                        bottom = _this$refs$configLoca3.bottom,
	                        width = _this$refs$configLoca3.width,
	                        height = _this$refs$configLoca3.height;
	
	                    var csInput = _this.connectionStringInput.getBoundingClientRect();
	                    var dotX = csInput.right - 20;
	                    var dotY = csInput.top + csInput.height / 2;
	                    _this.props.setConfigLocalComponentSize({
	                        top: top, left: left, right: right, bottom: bottom, width: width, height: height, dotX: dotX, dotY: dotY
	                    });
	                }
	                return;
	            }
	            if (_this.props.project.get('config').get('connectionString') !== _this.state.config) {
	                (0, _telemetry.traceEvent)('cs-filled');
	            }
	            _this.props.setProjectConfig(_this.state.config);
	            _this.setState(function () {
	                return {
	                    csError: false,
	                    configureChanged: false
	                };
	            });
	            if (_this.props.highlightConfigLocal || _this.props.highlightError) {
	                _this.props.nextGuideAfterConfigLocal();
	            }
	            _this.connectionStringInput.style.animation = null;
	        };
	
	        _this.deployClick = function () {
	            (0, _telemetry.traceEvent)('deploy-clicked');
	            if (_this.props.highlightConfigCloud) {
	                _this.props.nextGuideAfterConfigCloud();
	            }
	        };
	
	        _this.csFocus = function () {
	            {
	                var _this$refs$configLoca4 = _this.refs.configLocal.getBoundingClientRect(),
	                    top = _this$refs$configLoca4.top,
	                    left = _this$refs$configLoca4.left,
	                    right = _this$refs$configLoca4.right,
	                    bottom = _this$refs$configLoca4.bottom,
	                    width = _this$refs$configLoca4.width,
	                    height = _this$refs$configLoca4.height;
	
	                var dotX = -100;
	                var dotY = -100;
	                _this.props.setConfigLocalComponentSize({
	                    top: top, left: left, right: right, bottom: bottom, width: width, height: height, dotX: dotX, dotY: dotY
	                });
	            }
	            console.log(_this.connectionStringInput.style);
	            _this.connectionStringInput.style.animation = "border-glow 1.5s linear infinite";
	        };
	
	        var file = _this.props.project.get('files').findEntry(function (v) {
	            return v.get('type') === 'file';
	        });
	        _this.firstFile = file[0];
	        _this.state = {
	            folders: {}, // collapsed,
	            collapseProjectSelector: true,
	            selectedFilePath: (0, _immutable.List)().push(file[0]),
	            configureChanged: false,
	            config: _this.props.project.get('config').toJS(),
	            csError: false,
	            withGuideCsFocus: false
	        };
	        _this.initState(_this.state.folders, _this.props.project.get('files'), true);
	        return _this;
	    }
	
	    _createClass(Project, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            var _this2 = this;
	
	            console.log(this.refs.project.getBoundingClientRect().width);
	            if (!(0, _immutable.is)(prevProps.project, this.props.project)) {
	                var file = this.props.project.get('files').findEntry(function (v) {
	                    return v.get('type') === 'file';
	                });
	                this.setState(function () {
	                    return {
	                        config: _this2.props.project.get('config').toJS(),
	                        selectedFilePath: (0, _immutable.List)().push(file[0])
	                    };
	                });
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.reportPosition();
	            window.addEventListener("resize", this.onResize);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener("resize", this.onResize);
	        }
	    }, {
	        key: 'initState',
	        value: function initState(state, files, root, folderName) {
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = files[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var _ref = _step.value;
	
	                    var _ref2 = _slicedToArray(_ref, 2);
	
	                    var k = _ref2[0];
	                    var v = _ref2[1];
	
	                    if (v.get('type') === 'directory') {
	                        this.initState(state, v.get('data'), false, k);
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            if (!root) {
	                state[folderName] = true;
	                state.another = 1234;
	            }
	        }
	    }, {
	        key: 'renderProjects',
	        value: function renderProjects(allProjects) {
	            var items = [];
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = allProjects[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var _ref3 = _step2.value;
	
	                    var _ref4 = _slicedToArray(_ref3, 2);
	
	                    var k = _ref4[0];
	                    var v = _ref4[1];
	
	                    items.push(_react2.default.createElement(
	                        'div',
	                        { key: k, className: 'project-item', onClick: this.props.selectProject.bind(this, k) },
	                        v.get('displayName')
	                    ));
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            return items;
	        }
	    }, {
	        key: 'renderFile',
	        value: function renderFile(key, value, path) {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { ref: function ref(el) {
	                        if (path.size === 1 && path.get(0) === _this3.firstFile) _this3.firstFileRef = el;
	                    }, key: key, onClick: this.fileClicked.bind(this, path), className: 'project-file ' + ((0, _immutable.is)(this.state.selectedFilePath, path) ? 'project-file-selected' : '') },
	                key
	            );
	        }
	    }, {
	        key: 'renderItems',
	        value: function renderItems(files, root, folderName) {
	            var path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (0, _immutable.List)();
	
	            var items = [];
	            var _iteratorNormalCompletion3 = true;
	            var _didIteratorError3 = false;
	            var _iteratorError3 = undefined;
	
	            try {
	                for (var _iterator3 = files[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                    var _ref5 = _step3.value;
	
	                    var _ref6 = _slicedToArray(_ref5, 2);
	
	                    var k = _ref6[0];
	                    var v = _ref6[1];
	
	                    if (v.get('type') === 'file') {
	                        items.push(this.renderFile(k, v, path.push(k)));
	                    } else if (v.get('type') === 'directory') {
	                        items.push(this.renderItems(v.get('data'), false, k, path.push(k, 'data')));
	                    }
	                }
	            } catch (err) {
	                _didIteratorError3 = true;
	                _iteratorError3 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                        _iterator3.return();
	                    }
	                } finally {
	                    if (_didIteratorError3) {
	                        throw _iteratorError3;
	                    }
	                }
	            }
	
	            if (root) {
	                return items;
	            } else {
	                return _react2.default.createElement(
	                    'div',
	                    { key: 'project-folder-container', className: 'project-folder-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { onClick: this.toggleFolderCollapsed.bind(this, folderName), className: 'project-folder ' + (this.state.folders[folderName] ? "hide-items" : "show-items") },
	                        _react2.default.createElement('span', { className: this.state.folders[folderName] ? "folder-icon-collapsed" : "folder-icon-expanded" }),
	                        folderName
	                    ),
	                    items
	                );
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var deployItem = void 0;
	            if (this.props.project.has('deployLink')) {
	                deployItem = _react2.default.createElement(
	                    'div',
	                    { ref: 'configCloud', className: 'configure-deploy-link' },
	                    _react2.default.createElement(
	                        'a',
	                        { onClick: this.deployClick, target: '_blank', className: '' + (this.props.highlightConfigCloud && 'highlight'), href: this.props.project.get('deployLink') },
	                        _react2.default.createElement('i', { className: 'fa fa-cloud-upload', 'aria-hidden': 'true' }),
	                        _localization2.default.getLocalizedString().deployButton
	                    )
	                );
	            }
	            var configureItems = [];
	            // eslint-disable-next-line no-unused-vars
	
	            var _loop = function _loop(k, v) {
	                configureItems.push(_react2.default.createElement(
	                    'div',
	                    { key: k, className: 'configure-item' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'configure-item-key' },
	                        k
	                    ),
	                    _react2.default.createElement('input', { ref: function ref(el) {
	                            if (k === 'connectionString') _this4.connectionStringInput = el;
	                        }, type: 'text',
	                        onFocus: k === 'connectionString' && (_this4.props.highlightConfigLocal || _this4.props.highlightError) && _this4.csFocus,
	                        className: 'configure-item-value ' + (k === 'connectionString' && _this4.state.csError && 'cs-error'),
	                        value: _this4.state.config[k],
	                        onChange: _this4.handleChange.bind(_this4, k) })
	                ));
	            };
	
	            var _iteratorNormalCompletion4 = true;
	            var _didIteratorError4 = false;
	            var _iteratorError4 = undefined;
	
	            try {
	                for (var _iterator4 = this.props.project.get('config')[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                    var _ref7 = _step4.value;
	
	                    var _ref8 = _slicedToArray(_ref7, 2);
	
	                    var k = _ref8[0];
	                    var v = _ref8[1];
	
	                    _loop(k, v);
	                }
	            } catch (err) {
	                _didIteratorError4 = true;
	                _iteratorError4 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                        _iterator4.return();
	                    }
	                } finally {
	                    if (_didIteratorError4) {
	                        throw _iteratorError4;
	                    }
	                }
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'project-container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'current-project ' + (this.state.collapseProjectSelector ? "hide-items" : "show-items"), onClick: this.toggleProjectSelectorCollapsed },
	                    _react2.default.createElement('i', { className: 'fa ' + (this.state.collapseProjectSelector ? "fa-caret-down" : "fa-caret-up"), 'aria-hidden': 'true' }),
	                    this.props.project.get('displayName'),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'project-items-container' },
	                        this.renderProjects(this.props.allProjects)
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { ref: 'project', className: 'project-explorer ' + (this.props.highlightProject && 'highlight') },
	                    this.renderItems(this.props.project.get('files'), true)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { ref: 'configLocal', className: 'configure-container ' + ((this.props.highlightConfigLocal || this.props.highlightConfigCloud || this.props.highlightError) && 'highlight') },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'configure-container-header' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'configure-container-title' },
	                            'Configure'
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'configure-button ' + (this.state.configureChanged ? '' : 'hide') },
	                            _react2.default.createElement(
	                                'span',
	                                { ref: 'saveConfig', onClick: this.saveConfig },
	                                _react2.default.createElement('i', { className: 'fa fa-floppy-o', 'aria-hidden': 'true' })
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                { onClick: this.revertConfig },
	                                _react2.default.createElement('i', { className: 'fa fa-undo', 'aria-hidden': 'true' })
	                            )
	                        )
	                    ),
	                    deployItem,
	                    configureItems
	                )
	            );
	        }
	    }]);
	
	    return Project;
	}(_react.Component);
	
	exports.default = Project;

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(28);
	
	var _app = __webpack_require__(308);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _actions = __webpack_require__(31);
	
	var _guide = __webpack_require__(32);
	
	var GUIDE = _interopRequireWildcard(_guide);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        highlight: state.main.get('guideId') === GUIDE.BOARD
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        setComponentSize: function setComponentSize(size) {
	            (0, _actions.setComponentSize)(dispatch, GUIDE.BOARD, size);
	        },
	        openGuide: function openGuide() {
	            (0, _actions.switchGuide)(dispatch, 0);
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_app2.default);

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(28);
	
	var _banner = __webpack_require__(309);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _actions = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        switchGuide: function switchGuide(id) {
	            (0, _actions.switchGuide)(dispatch, id);
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(_banner2.default);

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(28);
	
	var _board = __webpack_require__(310);
	
	var _board2 = _interopRequireDefault(_board);
	
	var _actions = __webpack_require__(31);
	
	var _sampleRunner = __webpack_require__(147);
	
	var _sampleRunner2 = _interopRequireDefault(_sampleRunner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        switchOn: state.board.get('switchOn'),
	        sensor: state.board.get('sensor')
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        setSensorData: function setSensorData(sensor, data) {
	            (0, _actions.setSensorData)(dispatch, sensor, data);
	        },
	        resetBoard: function resetBoard() {
	            _sampleRunner2.default.getInstance().stop();
	            (0, _actions.stopSample)(dispatch);
	            setTimeout(function () {
	                (0, _actions.runSample)(dispatch);
	                _sampleRunner2.default.getInstance().run(_actions.appendConsoleLog.bind(undefined, dispatch), _actions.appendConsoleLog.bind(undefined, dispatch));
	            }, 300);
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_board2.default);

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(28);
	
	var _console = __webpack_require__(311);
	
	var _console2 = _interopRequireDefault(_console);
	
	var _localization = __webpack_require__(36);
	
	var _localization2 = _interopRequireDefault(_localization);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        message: state.main.get('consoleMessage'),
	        welcomeMessage: _localization2.default.getLocalizedString().consoleWelcomeMessage
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(_console2.default);

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(28);
	
	var _controlBar = __webpack_require__(312);
	
	var _controlBar2 = _interopRequireDefault(_controlBar);
	
	var _actions = __webpack_require__(31);
	
	var _sampleRunner = __webpack_require__(147);
	
	var _sampleRunner2 = _interopRequireDefault(_sampleRunner);
	
	var _guide = __webpack_require__(32);
	
	var GUIDE = _interopRequireWildcard(_guide);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        isSampleRunning: state.main.get('isSampleRunning'),
	        runningInfo: state.main.get('runningInfo'),
	        highlight: state.main.get('guideId') === GUIDE.CONTROL_BAR
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        runSample: function runSample() {
	            var result = _sampleRunner2.default.getInstance().run(_actions.appendConsoleLog.bind(undefined, dispatch), _actions.appendConsoleLog.bind(undefined, dispatch));
	            if (result === 0) {
	                (0, _actions.runSample)(dispatch);
	            }
	        },
	        stopSample: function stopSample() {
	            _sampleRunner2.default.getInstance().stop();
	            (0, _actions.stopSample)(dispatch);
	        },
	        setComponentSize: function setComponentSize(size) {
	            (0, _actions.setComponentSize)(dispatch, GUIDE.CONTROL_BAR, size);
	        },
	        switchGuide: function switchGuide() {
	            (0, _actions.switchGuide)(dispatch, GUIDE.CONTROL_BAR + 1);
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_controlBar2.default);

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(28);
	
	var _editor = __webpack_require__(313);
	
	var _editor2 = _interopRequireDefault(_editor);
	
	var _actions = __webpack_require__(31);
	
	var _guide = __webpack_require__(32);
	
	var GUIDE = _interopRequireWildcard(_guide);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        data: state.project.get('codeInEditor'),
	        language: state.project.get('codeLanguage'),
	        uniqueId: state.project.get('codeUniqueId'),
	        highlight: state.main.get('guideId') === GUIDE.EDITOR
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        setComponentSize: function setComponentSize(size) {
	            (0, _actions.setComponentSize)(dispatch, GUIDE.EDITOR, size);
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_editor2.default);

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(28);
	
	var _helpOverlay = __webpack_require__(315);
	
	var _helpOverlay2 = _interopRequireDefault(_helpOverlay);
	
	var _actions = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        guideId: state.main.get('guideId'),
	        guidePosition: state.main.get('guidePosition').get(state.main.get('guideId'))
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        switchGuide: function switchGuide(id) {
	            (0, _actions.switchGuide)(dispatch, id);
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_helpOverlay2.default);

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(28);
	
	var _project = __webpack_require__(322);
	
	var _project2 = _interopRequireDefault(_project);
	
	var _actions = __webpack_require__(31);
	
	var _guide = __webpack_require__(32);
	
	var GUIDE = _interopRequireWildcard(_guide);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        project: state.project.get('currentProject'),
	        allProjects: state.project.get('projects'),
	        highlightProject: state.main.get('guideId') === GUIDE.PROJECT,
	        highlightConfigCloud: state.main.get('guideId') === GUIDE.CONFIG_CLOUD,
	        highlightConfigLocal: state.main.get('guideId') === GUIDE.CONFIG_LOCAL,
	        highlightError: state.main.get('guideId') === GUIDE.CONFIG_ERROR
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        setEditorPath: function setEditorPath(path) {
	            (0, _actions.setEditorPath)(dispatch, path);
	        },
	        selectProject: function selectProject(name) {
	            (0, _actions.selectProject)(dispatch, name);
	        },
	        setProjectConfig: function setProjectConfig(config) {
	            (0, _actions.setProjectConfig)(dispatch, config);
	        },
	        nextGuideAfterProject: function nextGuideAfterProject() {
	            (0, _actions.switchGuide)(dispatch, GUIDE.PROJECT + 1);
	        },
	        nextGuideAfterConfigCloud: function nextGuideAfterConfigCloud() {
	            (0, _actions.switchGuide)(dispatch, GUIDE.CONFIG_CLOUD + 1);
	        },
	        nextGuideAfterConfigLocal: function nextGuideAfterConfigLocal() {
	            (0, _actions.switchGuide)(dispatch, GUIDE.CONFIG_LOCAL + 1);
	        },
	        nextGuideForConfigError: function nextGuideForConfigError() {
	            (0, _actions.switchGuide)(dispatch, GUIDE.CONFIG_ERROR);
	        },
	        setProjectComponentSize: function setProjectComponentSize(size) {
	            (0, _actions.setComponentSize)(dispatch, GUIDE.PROJECT, size);
	        },
	        setConfigCloudComponentSize: function setConfigCloudComponentSize(size) {
	            (0, _actions.setComponentSize)(dispatch, GUIDE.CONFIG_CLOUD, size);
	        },
	        setConfigLocalComponentSize: function setConfigLocalComponentSize(size) {
	            (0, _actions.setComponentSize)(dispatch, GUIDE.CONFIG_LOCAL, size);
	            (0, _actions.setComponentSize)(dispatch, GUIDE.CONFIG_ERROR, size);
	        }
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_project2.default);

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _events = __webpack_require__(14);
	
	var _azureIotCommon = __webpack_require__(121);
	
	var _querystring = __webpack_require__(43);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	var _url = __webpack_require__(33);
	
	var _url2 = _interopRequireDefault(_url);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TOPIC_METHODS_SUBSCRIBE = "$iothub/methods/POST/#";
	
	var MqttReceiver = function (_EventEmitter) {
	  _inherits(MqttReceiver, _EventEmitter);
	
	  function MqttReceiver(mqttClient, topicMessage) {
	    _classCallCheck(this, MqttReceiver);
	
	    var _this = _possibleConstructorReturn(this, (MqttReceiver.__proto__ || Object.getPrototypeOf(MqttReceiver)).call(this));
	
	    _this._client = mqttClient;
	    _this._topics = {
	      'message': {
	        name: topicMessage,
	        listenersCount: 0,
	        subscribeInProgress: false,
	        subscribed: false,
	        topicMatchRegex: /^devices\/.*\/messages\/devicebound\/.*$/,
	        handler: _this._onC2DMessage.bind(_this)
	      },
	      'method': {
	        name: TOPIC_METHODS_SUBSCRIBE,
	        listenersCount: 0,
	        subscribeInProgress: false,
	        subscribed: false,
	        topicMatchRegex: /^\$iothub\/methods\/POST\/.*$/,
	        handler: _this._onDeviceMethod.bind(_this)
	      }
	    };
	
	    _this._setupSubscription = _this._setupSubscription.bind(_this);
	    _this._removeSubscription = _this._removeSubscription.bind(_this);
	    _this._dispatchMqttMessage = _this._dispatchMqttMessage.bind(_this);
	    _this._onC2DMessage = _this._dispatchMqttMessage.bind(_this);
	    _this.onDeviceMethod = _this.onDeviceMethod.bind(_this);
	    _this._onDeviceMethod = _this._onDeviceMethod.bind(_this);
	
	    _this._client.onMessageArrived = _this._dispatchMqttMessage;
	
	    _this.on('newListener', function (eventName) {
	      var topic;
	      if (eventName === 'message') {
	        topic = this._topics['message'];
	      } else if (eventName.indexOf('method') === 0) {
	        topic = this._topics['method'];
	      }
	
	      if (!topic) {
	        return;
	      }
	
	      if (topic.subscribed || topic.subscribeInProgress) {
	        return;
	      }
	
	      this._setupSubscription(topic);
	    });
	    return _this;
	  }
	
	  _createClass(MqttReceiver, [{
	    key: '_setupSubscription',
	    value: function _setupSubscription(topic) {
	      topic.subscribeInProgress = true;
	      this._client.subscribe(topic.name, { qos: 0 });
	      topic.subscribeInProgress = false;
	      topic.subscribed = true;
	    }
	  }, {
	    key: '_removeSubscription',
	    value: function _removeSubscription(topic) {
	      throw new Error('not suppport _removeSubscription yet');
	    }
	  }, {
	    key: '_dispatchMqttMessage',
	    value: function _dispatchMqttMessage(messages) {
	      var topic = messages.destinationName;
	      var payload = messages.payloadString;
	
	      if (this._topics.message.topicMatchRegex.test(topic)) {
	        this._topics.message.handler(topic, payload);
	      } else if (this._topics.method.topicMatchRegex.test(topic)) {
	        this._topics.method.handler(topic, payload);
	      }
	    }
	  }, {
	    key: '_onC2DMessage',
	    value: function _onC2DMessage(topic, payload) {
	      var msg = new _azureIotCommon.Message(payload);
	
	      var topicParts = topic.split('/');
	      if (topicParts[4]) {
	        var keyValuePairs = topicParts[4].split('&');
	
	        for (var i = 0; i < keyValuePairs.length; i++) {
	          var keyValuePair = keyValuePairs[i].split('=');
	          var k = decodeURIComponent(keyValuePair[0]);
	          var v = decodeURIComponent(keyValuePair[1]);
	
	          switch (k) {
	            case '$.mid':
	              msg.messageId = v;
	              break;
	            case '$.to':
	              msg.to = v;
	              break;
	            case '$.exp':
	              msg.expiryTimeUtc = v;
	              break;
	            case '$.cid':
	              msg.correlationId = v;
	              break;
	            case '$.uid':
	              msg.userId = v;
	              break;
	            default:
	              msg.properties.add(k, v);
	              break;
	          }
	        }
	      }
	
	      this.emit('message', msg);
	    }
	  }, {
	    key: '_parseMessage',
	    value: function _parseMessage(topic, body) {
	      var url, path, query;
	      try {
	        url = _url2.default.parse(topic);
	        path = url.path.split('/');
	        query = _querystring2.default.parse(url.query);
	      } catch (err) {
	        return undefined;
	      }
	
	      // if the topic has a querystring then 'path' will include it; so
	      // we strip it out
	      var lastPathComponent = path[path.length - 1];
	      if (lastPathComponent.indexOf('?') !== -1) {
	        path[path.length - 1] = lastPathComponent.substr(0, lastPathComponent.indexOf('?'));
	      }
	
	      if (path.length > 0 && path[0] === '$iothub') {
	        var message = {};
	        if (path.length > 1 && path[1].length > 0) {
	          var mod = message[path[1]] = {};
	
	          // parse the request ID if there is one
	          if (!!query.$rid) {
	            message.requestId = query.$rid;
	          }
	
	          // parse the other properties properties (excluding $rid)
	          message.properties = query;
	          delete message.properties.$rid;
	
	          // save the body
	          message.body = body;
	
	          // parse the verb
	          if (path.length > 2 && path[2].length > 0) {
	            mod.verb = path[2];
	
	            //  $iothub/methods/POST/{method name}?$rid={request id}&{serialized properties}
	            if (path.length > 3 && path[3].length > 0) {
	              mod.methodName = path[3];
	            } else {
	              throw new Error('Device method call\'s MQTT topic name does not include the method name.');
	            }
	          }
	        }
	
	        return message;
	      }
	    }
	  }, {
	    key: 'onDeviceMethod',
	    value: function onDeviceMethod(methodName, callback) {
	      this.on('method_' + methodName, callback);
	    }
	  }, {
	    key: '_onDeviceMethod',
	    value: function _onDeviceMethod(topic, payload) {
	      var message = this._parseMessage(topic, payload);
	
	      if (message) {
	        this.emit('method_' + message.methods.methodName, message);
	      }
	    }
	  }]);
	
	  return MqttReceiver;
	}(_events.EventEmitter);
	
	exports.default = MqttReceiver;

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _pahoMqtt = __webpack_require__(594);
	
	var _pahoMqtt2 = _interopRequireDefault(_pahoMqtt);
	
	var _azureIotCommon = __webpack_require__(121);
	
	var _events = __webpack_require__(14);
	
	var _telemetry = __webpack_require__(35);
	
	var _mqttReceiver = __webpack_require__(331);
	
	var _mqttReceiver2 = _interopRequireDefault(_mqttReceiver);
	
	var _util = __webpack_require__(4);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TOPIC_RESPONSE_PUBLISH_FORMAT = "$iothub/%s/res/%d/?$rid=%s";
	
	var MQTT = function (_EventEmitter) {
	  _inherits(MQTT, _EventEmitter);
	
	  function MQTT(config) {
	    _classCallCheck(this, MQTT);
	
	    var _this = _possibleConstructorReturn(this, (MQTT.__proto__ || Object.getPrototypeOf(MQTT)).call(this));
	
	    _this.config = config;
	    _this.client = new _pahoMqtt2.default.MQTT.Client('wss://' + config.host + ':443/$iothub/websocket?iothub-no-client-cert=true', config.deviceId);
	    _this.client.onConnectionLost = _this.onConnectionLost;
	    _this.D2CPoint = 'devices/' + config.deviceId + '/messages/events/';
	    _this.C2DPoint = 'devices/' + config.deviceId + '/messages/devicebound/#';
	    return _this;
	  }
	
	  /**
	   * Interface as azure-iot-sdk-node
	   * ref: https://github.com/Azure/azure-iot-sdk-node/blob/be0ad986b2d8e85d135425b113acb6c1e9815cda/device/transport/mqtt/src/mqtt.ts
	   */
	
	
	  _createClass(MQTT, [{
	    key: 'connect',
	    value: function connect(cb) {
	      var onConnect = function () {
	        if (this.interruptConnect) {
	          this.disconnect();
	          return;
	        }
	        this.connected = true;
	        (0, _telemetry.traceEvent)('connect-success');
	        cb();
	      }.bind(this);
	
	      var onFail = function onFail(err) {
	        this.connected = false;
	        cb(err);
	      };
	
	      if (this.connected) {
	        cb();
	        return;
	      }
	
	      var option = {
	        timeout: 3,
	        cleanSession: true,
	        mqttVersion: 4,
	        useSSL: true,
	        onSuccess: onConnect,
	        onFailure: onFail,
	        keepAliveInterval: 60,
	        userName: this.config.host + '/' + this.config.deviceId + '/api-version=2016-11-14&DeviceClientType=' + MQTT.getClientType(),
	        password: this.config.sharedAccessSignature
	      };
	
	      this.client.connect(option);
	    }
	  }, {
	    key: 'sendEvent',
	    value: function sendEvent(message, cb) {
	      if (!message) {
	        cb('message is empty');
	      }
	      if (!this.connected) {
	        cb('Not connected');
	        return;
	      }
	      var queries = [];
	      for (var i = 0; i < message.properties.propertyList.length; i++) {
	        queries.push(message.properties.propertyList[i].key + '=' + message.properties.propertyList[i].value);
	      }
	
	      this.publish(message.data.toString(), this.D2CPoint + queries.join('&'));
	      cb();
	    }
	  }, {
	    key: 'disconnect',
	    value: function disconnect() {
	      if (!this.connected) {
	        this.interruptConnect = true;
	        return;
	      }
	      this.client.disconnect();
	      this.connected = false;
	    }
	  }, {
	    key: 'getReceiver',
	    value: function getReceiver(cb) {
	      if (!this._receiver) {
	        this._receiver = new _mqttReceiver2.default(this.client, this.C2DPoint);
	      }
	
	      cb(null, this._receiver);
	    }
	  }, {
	    key: 'complete',
	    value: function complete(message, cb) {
	      cb(null, new _azureIotCommon.results.MessageCompleted());
	    }
	  }, {
	    key: 'reject',
	    value: function reject() {
	      throw new Error('the MQTT transport does not support rejecting messages.');
	    }
	  }, {
	    key: 'abandon',
	    value: function abandon() {
	      throw new Error('The MQTT transport does not support abandoning messages.');
	    }
	  }, {
	    key: 'updateSharedAccessSignature',
	    value: function updateSharedAccessSignature(sharedAccessSignature, cb) {
	      this.disconnect();
	      this.config.sharedAccessSignature = sharedAccessSignature;
	      cb(null, new _azureIotCommon.results.SharedAccessSignatureUpdated(true));
	    }
	  }, {
	    key: 'setOptions',
	    value: function setOptions(options, done) {
	      if (!options) {
	        throw new Error('The options parameter can not be \'' + options + '\'');
	      }
	
	      if (this.config.sharedAccessSignature && options.cert) {
	        throw new Error('Cannot set x509 options on a device that uses symmetric key authentication.');
	      }
	
	      this.config.x509 = {
	        cert: options.cert,
	        key: options.key,
	        passphrase: options.passphrase
	      };
	
	      if (done) {
	        done(null);
	      }
	    }
	  }, {
	    key: 'sendTwinRequest',
	    value: function sendTwinRequest(method, resource, properties, body, cb) {
	      throw new Error('not supported sendTwinRequest');
	    }
	  }, {
	    key: 'validateResponse',
	    value: function validateResponse(response) {
	      if (!response) {
	        throw new Error('Parameter \'response\' is falsy');
	      }
	      if (!response.requestId) {
	        throw new Error('Parameter \'response.requestId\' is falsy');
	      }
	      if (typeof response.requestId === 'string' && response.requestId.length === 0) {
	        throw new Error('Parameter \'response.requestId\' is an empty string');
	      }
	      if (typeof response.requestId !== 'string') {
	        throw new Error('Parameter \'response.requestId\' is not a string.');
	      }
	      if (!response.status) {
	        throw new Error('Parameter \'response.status\' is falsy');
	      }
	      if (typeof response.status !== 'number') {
	        throw new Error('Parameter \'response.status\' is not a number');
	      }
	    }
	  }, {
	    key: 'sendMethodResponse',
	    value: function sendMethodResponse(response, cb) {
	      this.validateResponse(response);
	      var topicName = _util2.default.format(TOPIC_RESPONSE_PUBLISH_FORMAT, 'methods', response.status, response.requestId);
	      this.publish(JSON.stringify(response.payload), topicName);
	    }
	  }, {
	    key: 'getTwinReceiver',
	    value: function getTwinReceiver(cb) {
	      throw new Error('not supported getTwinReceiver');
	    }
	
	    /**
	     * Private method
	     */
	
	  }, {
	    key: 'onConnectionLost',
	    value: function onConnectionLost() {
	      return;
	    }
	  }, {
	    key: 'publish',
	    value: function publish(message, destination) {
	      var mqttMsg = new _pahoMqtt2.default.MQTT.Message(message);
	      mqttMsg.destinationName = destination;
	      mqttMsg.qos = 1;
	      mqttMsg.retained = false;
	
	      this.client.send(mqttMsg);
	    }
	  }], [{
	    key: 'getClientType',
	    value: function getClientType() {
	      return encodeURIComponent(_telemetry.userProperties.project + '/' + _telemetry.userProperties.version + '/' + _telemetry.userProperties.userId);
	    }
	  }]);
	
	  return MQTT;
	}(_events.EventEmitter);
	
	exports.default = MQTT;

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getAllProjects = undefined;
	
	var _immutable = __webpack_require__(21);
	
	var _localStorageKeys = __webpack_require__(145);
	
	var CONSTANTS = _interopRequireWildcard(_localStorageKeys);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var createHash = function createHash() {
		return Math.random().toString(36).substring(7);
	};
	
	var getAllProjects = exports.getAllProjects = function getAllProjects() {
		return (0, _immutable.Map)({
			GetStarted: (0, _immutable.Map)({
				jsCode: __webpack_require__(403),
				displayName: "Get Started",
				config: (0, _immutable.Map)({
					connectionString: localStorage.getItem(CONSTANTS.GETSTARTED_CONNECTIONSTRING) ? localStorage.getItem(CONSTANTS.GETSTARTED_CONNECTIONSTRING) : ""
				}),
				files: (0, _immutable.Map)({
					"GetStarted.ino": (0, _immutable.Map)({
						id: createHash(),
						type: "file",
						format: "cpp",
						data: __webpack_require__(399)
					}),
					"iothub_client_sample_mqtt.h": (0, _immutable.Map)({
						id: createHash(),
						type: "file",
						format: "cpp",
						data: __webpack_require__(402)
					}),
					"iothub_client_sample_mqtt.cpp": (0, _immutable.Map)({
						id: createHash(),
						type: "file",
						format: "cpp",
						data: __webpack_require__(401)
					}),
					"utility.h": (0, _immutable.Map)({
						id: createHash(),
						type: "file",
						format: "cpp",
						data: __webpack_require__(405)
					}),
					"utility.cpp": (0, _immutable.Map)({
						id: createHash(),
						type: "file",
						format: "cpp",
						data: __webpack_require__(404)
					}),
					"config.h": (0, _immutable.Map)({
						id: createHash(),
						type: "file",
						format: "cpp",
						data: __webpack_require__(400)
					})
				})
			}),
			ShakeShake: (0, _immutable.Map)({
				jsCode: __webpack_require__(409),
				displayName: "Shake Shake",
				config: (0, _immutable.Map)({
					connectionString: localStorage.getItem(CONSTANTS.SHAKESHAKE_CONNECTIONSTRING) ? localStorage.getItem(CONSTANTS.SHAKESHAKE_CONNECTIONSTRING) : "",
					topic: localStorage.getItem(CONSTANTS.SHAKESHAKE_TOPIC) ? localStorage.getItem(CONSTANTS.SHAKESHAKE_TOPIC) : "song"
				}),
				deployLink: "https://portal.azure.com/#create/Microsoft.Template/uri/https%3A%2F%2Fraw.githubusercontent.com%2FAzure-Samples%2Fiot-devkit-web-simulator%2Fsource%2Fsrc%2Fdata%2FShakeShake%2FazureDeploy.json",
				files: (0, _immutable.Map)({
					"azureFunction": (0, _immutable.Map)({
						type: "directory",
						data: (0, _immutable.Map)({
							"function.json": (0, _immutable.Map)({
								id: createHash(),
								type: "file",
								format: "json",
								data: __webpack_require__(397)
							}),
							"run.csx": (0, _immutable.Map)({
								id: createHash(),
								type: "file",
								format: "csharp",
								data: __webpack_require__(408)
							}),
							"project.json": (0, _immutable.Map)({
								id: createHash(),
								type: "file",
								format: "json",
								data: __webpack_require__(398)
							})
						})
					}),
					"ShakeShake.ino": (0, _immutable.Map)({
						id: createHash(),
						type: "file",
						format: "cpp",
						data: localStorage.getItem(CONSTANTS.SHAKESHAKE_TOPIC) ? __webpack_require__(166).replace(/("{\\"topic\\":\\")[^\\]*(\\"}";)/, '$1' + localStorage.getItem(CONSTANTS.SHAKESHAKE_TOPIC) + '$2') : __webpack_require__(166)
					}),
					"ShakeUI.h": (0, _immutable.Map)({
						id: createHash(),
						type: "file",
						format: "cpp",
						data: __webpack_require__(407)
					}),
					"ShakeUI.cpp": (0, _immutable.Map)({
						id: createHash(),
						type: "file",
						format: "cpp",
						data: __webpack_require__(406)
					})
				})
			})
		});
	};

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Map;
	
	var _actionTypes = __webpack_require__(53);
	
	var _immutable = __webpack_require__(21);
	
	var _sensorName = __webpack_require__(146);
	
	var sensorName = _interopRequireWildcard(_sensorName);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = (0, _immutable.Map)({
	    switchOn: false,
	    sensor: (0, _immutable.Map)((_Map = {}, _defineProperty(_Map, sensorName.BUTTON_A, (0, _immutable.Map)({
	        down: false
	    })), _defineProperty(_Map, sensorName.BUTTON_B, (0, _immutable.Map)({
	        down: false
	    })), _defineProperty(_Map, sensorName.HTS221, (0, _immutable.Map)({
	        temperature: 0,
	        humidity: 0
	    })), _defineProperty(_Map, sensorName.LED, (0, _immutable.Map)({
	        on: false,
	        r: 0,
	        g: 0,
	        b: 0
	    })), _defineProperty(_Map, sensorName.LSM6DSL, (0, _immutable.Map)({
	        x: 0,
	        y: 0,
	        z: 0,
	        distance: 0,
	        inMotion: false
	    })), _defineProperty(_Map, sensorName.OLED, (0, _immutable.Map)({
	        "0": "",
	        "1": "",
	        "2": "",
	        "3": ""
	    })), _Map))
	});
	
	var board = function board() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actionTypes.SWITCH_ON_OFF_BOARD:
	            if (action.data) {
	                return state.set('switchOn', action.data);
	            } else {
	                return initialState;
	            }
	        case _actionTypes.SET_SENSOR_DATA:
	            if (action.sensor === sensorName.LSM6DSL) {
	                var current = state.getIn(['sensor', sensorName.LSM6DSL]);
	                if (!current.get('inMotion') && action.data.get('inMotion')) {
	                    return state.updateIn(['sensor', action.sensor], function (value) {
	                        return value.merge(action.data.set('distance', 0));
	                    });
	                } else if (current.get('inMotion') && action.data.get('inMotion')) {
	                    return state.updateIn(['sensor', action.sensor, 'distance'], function (value) {
	                        return value + (Math.abs(current.get('x') - action.data.get('x')) + Math.abs(current.get('y') - action.data.get('y')));
	                    }).updateIn(['sensor', action.sensor], function (value) {
	                        return value.merge(action.data);
	                    });
	                } else {
	                    return state.updateIn(['sensor', action.sensor], function (value) {
	                        return value.merge(action.data);
	                    });
	                }
	            } else {
	                var t = state.updateIn(['sensor', action.sensor], function (value) {
	                    return value.merge(action.data);
	                });
	                return t;
	            }
	        default:
	            return state;
	    }
	};
	
	exports.default = board;

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _actionTypes = __webpack_require__(53);
	
	var _immutable = __webpack_require__(21);
	
	var initialState = (0, _immutable.Map)({
	    showHelp: false
	});
	
	var help = function help() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actionTypes.SWITCH_HELP:
	            return state.set('showHelp', action.data);
	        default:
	            return state;
	    }
	};
	
	exports.default = help;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(113);
	
	var _main = __webpack_require__(337);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _help = __webpack_require__(335);
	
	var _help2 = _interopRequireDefault(_help);
	
	var _board = __webpack_require__(334);
	
	var _board2 = _interopRequireDefault(_board);
	
	var _project = __webpack_require__(338);
	
	var _project2 = _interopRequireDefault(_project);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	    main: _main2.default,
	    help: _help2.default,
	    board: _board2.default,
	    project: _project2.default
	});

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _actionTypes = __webpack_require__(53);
	
	var _guide = __webpack_require__(32);
	
	var GUIDE = _interopRequireWildcard(_guide);
	
	var _immutable = __webpack_require__(21);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = (0, _immutable.Map)({
	    isSampleRunning: false,
	    runningInfo: "",
	    consoleMessage: "",
	    guideId: GUIDE.CLOSE,
	    guidePosition: (0, _immutable.List)(new Array(GUIDE.END))
	});
	
	var main = function main() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _actionTypes.RUN_SAMPLE:
	            return state.set('isSampleRunning', true);
	        case _actionTypes.STOP_SAMPLE:
	            return state.set('isSampleRunning', false);
	        case _actionTypes.APPEND_CONSOLE_LOG:
	            return state.update('consoleMessage', function (value) {
	                return value + action.data;
	            });
	        case _actionTypes.SHOW_RUNNING_INFO:
	            return state.set('runningInfo', action.data);
	        case _actionTypes.SWITCH_HELP:
	            return state.set('guideId', action.data);
	        case _actionTypes.SET_COMPONENT_SIZE:
	            return state.update('guidePosition', function (oriList) {
	                return oriList.set(action.id, action.size);
	            });
	        default:
	            return state;
	    }
	};
	
	exports.default = main;

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _actionTypes = __webpack_require__(53);
	
	var _immutable = __webpack_require__(21);
	
	var _projectFactory = __webpack_require__(333);
	
	var _localStorageKeys = __webpack_require__(145);
	
	var CONSTANTS = _interopRequireWildcard(_localStorageKeys);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var getCodeInFirstFile = function getCodeInFirstFile(project) {
	    // eslint-disable-next-line no-unused-vars
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = project.get('files')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var _ref = _step.value;
	
	            var _ref2 = _slicedToArray(_ref, 2);
	
	            var k = _ref2[0];
	            var v = _ref2[1];
	
	            if (v.get('type') === 'file') {
	                return [v.get('data'), v.get('format'), v.get('id')];
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	};
	
	var allProjects = (0, _projectFactory.getAllProjects)();
	var initProject = allProjects.get('ShakeShake');
	var codeInEditor = void 0;
	var codeLanguage = void 0;
	var codeUniqueId = void 0;
	
	var _getCodeInFirstFile = getCodeInFirstFile(initProject);
	
	var _getCodeInFirstFile2 = _slicedToArray(_getCodeInFirstFile, 3);
	
	codeInEditor = _getCodeInFirstFile2[0];
	codeLanguage = _getCodeInFirstFile2[1];
	codeUniqueId = _getCodeInFirstFile2[2];
	
	var initialState = (0, _immutable.Map)({
	    codeInEditor: codeInEditor,
	    codeLanguage: codeLanguage,
	    codeUniqueId: codeUniqueId,
	    currentProject: initProject,
	    projects: allProjects
	});
	
	var project = function project() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    if (action.type === _actionTypes.SET_EDITOR_PATH) {
	        var file = state.getIn(['currentProject', 'files'].concat(_toConsumableArray(action.path)));
	        return state.merge((0, _immutable.Map)({
	            codeInEditor: file.get('data'),
	            codeLanguage: file.get('format'),
	            codeUniqueId: file.get('id')
	        }));
	    } else if (action.type === _actionTypes.SELECT_PROJECT) {
	        var currentProject = state.getIn(['projects', action.data]);
	        console.log(currentProject);
	        if (!currentProject) {
	            return state;
	        }
	        var _codeInEditor = void 0;
	        var _codeLanguage = void 0;
	        var _codeUniqueId = void 0;
	
	        var _getCodeInFirstFile3 = getCodeInFirstFile(currentProject);
	
	        var _getCodeInFirstFile4 = _slicedToArray(_getCodeInFirstFile3, 3);
	
	        _codeInEditor = _getCodeInFirstFile4[0];
	        _codeLanguage = _getCodeInFirstFile4[1];
	        _codeUniqueId = _getCodeInFirstFile4[2];
	
	        return state.merge((0, _immutable.Map)({
	            currentProject: currentProject,
	            codeInEditor: _codeInEditor,
	            codeLanguage: _codeLanguage,
	            codeUniqueId: _codeUniqueId
	        }));
	    } else if (action.type === _actionTypes.SET_PROJECT_CONFIG) {
	        var _currentProject = state.get('currentProject');
	        var updatedProject = _currentProject.update('config', function (map) {
	            return map.merge(action.data);
	        });
	        var currentProjectName = state.get('projects').findEntry(function (v) {
	            return (0, _immutable.is)(v, _currentProject);
	        })[0];
	        if (currentProjectName === "ShakeShake") {
	            updatedProject = updatedProject.updateIn(['files', 'ShakeShake.ino', 'data'], function (value) {
	                return value.replace(/("{\\"topic\\":\\")[^\\]*(\\"}";)/, '$1' + action.data.topic + '$2');
	            });
	            localStorage.setItem(CONSTANTS.SHAKESHAKE_CONNECTIONSTRING, action.data.connectionString);
	            localStorage.setItem(CONSTANTS.SHAKESHAKE_TOPIC, action.data.topic);
	        } else if (currentProjectName === "GetStarted") {
	            localStorage.setItem(CONSTANTS.GETSTARTED_CONNECTIONSTRING, action.data.connectionString);
	        }
	        if (state.get('codeInEditor') === state.getIn(['currentProject', 'files', 'ShakeShake.ino', 'data'])) {
	            return state.set('currentProject', updatedProject).setIn(['projects', currentProjectName], updatedProject).set('codeInEditor', updatedProject.getIn(['files', 'ShakeShake.ino', 'data']));
	        } else {
	            return state.set('currentProject', updatedProject).setIn(['projects', currentProjectName], updatedProject);
	        }
	    } else {
	        return state;
	    }
	};
	
	exports.default = project;

/***/ },
/* 339 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  for (var i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(
	      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
	    ))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(85);
	var Transform = __webpack_require__(86);
	var inherits = __webpack_require__(13);
	var modes = __webpack_require__(87);
	var StreamCipher = __webpack_require__(154);
	var ebtk = __webpack_require__(148);
	
	inherits(Decipher, Transform);
	function Decipher(mode, key, iv) {
	  if (!(this instanceof Decipher)) {
	    return new Decipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._last = void 0;
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Decipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.decrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Decipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  if (!chunk) {
	    return next;
	  }
	
	  this.push(unpad(this._mode.decrypt(this, chunk)));
	
	  next();
	};
	
	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 16) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  if (this.cache.length) {
	    return this.cache;
	  }
	};
	function unpad(last) {
	  var padded = last[15];
	  if (padded === 16) {
	    return;
	  }
	  return last.slice(0, 16 - padded);
	}
	
	var modelist = {
	  ECB: __webpack_require__(152),
	  CBC: __webpack_require__(149),
	  CFB: __webpack_require__(150),
	  OFB: __webpack_require__(153),
	  CTR: __webpack_require__(151)
	};
	
	module.exports = function (crypto) {
	  function createDecipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv, true);
	    }
	    return new Decipher(modelist[config.mode], password, iv);
	  }
	
	  function createDecipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createDecipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createDecipher: createDecipher,
	    createDecipheriv: createDecipheriv
	  };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(85);
	var Transform = __webpack_require__(86);
	var inherits = __webpack_require__(13);
	var modes = __webpack_require__(87);
	var ebtk = __webpack_require__(148);
	var StreamCipher = __webpack_require__(154);
	inherits(Cipher, Transform);
	function Cipher(mode, key, iv) {
	  if (!(this instanceof Cipher)) {
	    return new Cipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Cipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.encrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Cipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  this.push(this._mode.encrypt(this, chunk));
	  this._cipher.scrub();
	  next();
	};
	
	
	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 15) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  var len = 16 - this.cache.length;
	  var padBuff = new Buffer(len);
	
	  var i = -1;
	  while (++i < len) {
	    padBuff.writeUInt8(len, i);
	  }
	  var out = Buffer.concat([this.cache, padBuff]);
	  return out;
	};
	var modelist = {
	  ECB: __webpack_require__(152),
	  CBC: __webpack_require__(149),
	  CFB: __webpack_require__(150),
	  OFB: __webpack_require__(153),
	  CTR: __webpack_require__(151)
	};
	module.exports = function (crypto) {
	  function createCipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv);
	    }
	    return new Cipher(modelist[config.mode], password, iv);
	  }
	  function createCipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createCipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createCipher: createCipher,
	    createCipheriv: createCipheriv
	  };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function (crypto, exports) {
	  exports = exports || {};
	  var ciphers = __webpack_require__(341)(crypto);
	  exports.createCipher = ciphers.createCipher;
	  exports.createCipheriv = ciphers.createCipheriv;
	  var deciphers = __webpack_require__(340)(crypto);
	  exports.createDecipher = deciphers.createDecipher;
	  exports.createDecipheriv = deciphers.createDecipheriv;
	  var modes = __webpack_require__(87);
	  function listCiphers () {
	    return Object.keys(modes);
	  }
	  exports.listCiphers = listCiphers;
	};
	


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	//this file was generated
	"use strict"
	var mime = module.exports = {
	    lookup: function (path, fallback) {
	  var ext = path.replace(/.*[\.\/]/, '').toLowerCase();
	
	  return this.types[ext] || fallback || this.default_type;
	}
	  , default_type: "application/octet-stream"
	  , types: {
	  "123": "application/vnd.lotus-1-2-3",
	  "ez": "application/andrew-inset",
	  "aw": "application/applixware",
	  "atom": "application/atom+xml",
	  "atomcat": "application/atomcat+xml",
	  "atomsvc": "application/atomsvc+xml",
	  "ccxml": "application/ccxml+xml",
	  "cdmia": "application/cdmi-capability",
	  "cdmic": "application/cdmi-container",
	  "cdmid": "application/cdmi-domain",
	  "cdmio": "application/cdmi-object",
	  "cdmiq": "application/cdmi-queue",
	  "cu": "application/cu-seeme",
	  "davmount": "application/davmount+xml",
	  "dbk": "application/docbook+xml",
	  "dssc": "application/dssc+der",
	  "xdssc": "application/dssc+xml",
	  "ecma": "application/ecmascript",
	  "emma": "application/emma+xml",
	  "epub": "application/epub+zip",
	  "exi": "application/exi",
	  "pfr": "application/font-tdpfr",
	  "gml": "application/gml+xml",
	  "gpx": "application/gpx+xml",
	  "gxf": "application/gxf",
	  "stk": "application/hyperstudio",
	  "ink": "application/inkml+xml",
	  "inkml": "application/inkml+xml",
	  "ipfix": "application/ipfix",
	  "jar": "application/java-archive",
	  "ser": "application/java-serialized-object",
	  "class": "application/java-vm",
	  "js": "application/javascript",
	  "json": "application/json",
	  "jsonml": "application/jsonml+json",
	  "lostxml": "application/lost+xml",
	  "hqx": "application/mac-binhex40",
	  "cpt": "application/mac-compactpro",
	  "mads": "application/mads+xml",
	  "mrc": "application/marc",
	  "mrcx": "application/marcxml+xml",
	  "ma": "application/mathematica",
	  "nb": "application/mathematica",
	  "mb": "application/mathematica",
	  "mathml": "application/mathml+xml",
	  "mbox": "application/mbox",
	  "mscml": "application/mediaservercontrol+xml",
	  "metalink": "application/metalink+xml",
	  "meta4": "application/metalink4+xml",
	  "mets": "application/mets+xml",
	  "mods": "application/mods+xml",
	  "m21": "application/mp21",
	  "mp21": "application/mp21",
	  "mp4s": "application/mp4",
	  "doc": "application/msword",
	  "dot": "application/msword",
	  "mxf": "application/mxf",
	  "bin": "application/octet-stream",
	  "dms": "application/octet-stream",
	  "lrf": "application/octet-stream",
	  "mar": "application/octet-stream",
	  "so": "application/octet-stream",
	  "dist": "application/octet-stream",
	  "distz": "application/octet-stream",
	  "pkg": "application/octet-stream",
	  "bpk": "application/octet-stream",
	  "dump": "application/octet-stream",
	  "elc": "application/octet-stream",
	  "deploy": "application/octet-stream",
	  "oda": "application/oda",
	  "opf": "application/oebps-package+xml",
	  "ogx": "application/ogg",
	  "omdoc": "application/omdoc+xml",
	  "onetoc": "application/onenote",
	  "onetoc2": "application/onenote",
	  "onetmp": "application/onenote",
	  "onepkg": "application/onenote",
	  "oxps": "application/oxps",
	  "xer": "application/patch-ops-error+xml",
	  "pdf": "application/pdf",
	  "pgp": "application/pgp-encrypted",
	  "asc": "application/pgp-signature",
	  "sig": "application/pgp-signature",
	  "prf": "application/pics-rules",
	  "p10": "application/pkcs10",
	  "p7m": "application/pkcs7-mime",
	  "p7c": "application/pkcs7-mime",
	  "p7s": "application/pkcs7-signature",
	  "p8": "application/pkcs8",
	  "ac": "application/pkix-attr-cert",
	  "cer": "application/pkix-cert",
	  "crl": "application/pkix-crl",
	  "pkipath": "application/pkix-pkipath",
	  "pki": "application/pkixcmp",
	  "pls": "application/pls+xml",
	  "ai": "application/postscript",
	  "eps": "application/postscript",
	  "ps": "application/postscript",
	  "cww": "application/prs.cww",
	  "pskcxml": "application/pskc+xml",
	  "rdf": "application/rdf+xml",
	  "rif": "application/reginfo+xml",
	  "rnc": "application/relax-ng-compact-syntax",
	  "rl": "application/resource-lists+xml",
	  "rld": "application/resource-lists-diff+xml",
	  "rs": "application/rls-services+xml",
	  "gbr": "application/rpki-ghostbusters",
	  "mft": "application/rpki-manifest",
	  "roa": "application/rpki-roa",
	  "rsd": "application/rsd+xml",
	  "rss": "application/rss+xml",
	  "rtf": "application/rtf",
	  "sbml": "application/sbml+xml",
	  "scq": "application/scvp-cv-request",
	  "scs": "application/scvp-cv-response",
	  "spq": "application/scvp-vp-request",
	  "spp": "application/scvp-vp-response",
	  "sdp": "application/sdp",
	  "setpay": "application/set-payment-initiation",
	  "setreg": "application/set-registration-initiation",
	  "shf": "application/shf+xml",
	  "smi": "application/smil+xml",
	  "smil": "application/smil+xml",
	  "rq": "application/sparql-query",
	  "srx": "application/sparql-results+xml",
	  "gram": "application/srgs",
	  "grxml": "application/srgs+xml",
	  "sru": "application/sru+xml",
	  "ssdl": "application/ssdl+xml",
	  "ssml": "application/ssml+xml",
	  "tei": "application/tei+xml",
	  "teicorpus": "application/tei+xml",
	  "tfi": "application/thraud+xml",
	  "tsd": "application/timestamped-data",
	  "plb": "application/vnd.3gpp.pic-bw-large",
	  "psb": "application/vnd.3gpp.pic-bw-small",
	  "pvb": "application/vnd.3gpp.pic-bw-var",
	  "tcap": "application/vnd.3gpp2.tcap",
	  "pwn": "application/vnd.3m.post-it-notes",
	  "aso": "application/vnd.accpac.simply.aso",
	  "imp": "application/vnd.accpac.simply.imp",
	  "acu": "application/vnd.acucobol",
	  "atc": "application/vnd.acucorp",
	  "acutc": "application/vnd.acucorp",
	  "air": "application/vnd.adobe.air-application-installer-package+zip",
	  "fcdt": "application/vnd.adobe.formscentral.fcdt",
	  "fxp": "application/vnd.adobe.fxp",
	  "fxpl": "application/vnd.adobe.fxp",
	  "xdp": "application/vnd.adobe.xdp+xml",
	  "xfdf": "application/vnd.adobe.xfdf",
	  "ahead": "application/vnd.ahead.space",
	  "azf": "application/vnd.airzip.filesecure.azf",
	  "azs": "application/vnd.airzip.filesecure.azs",
	  "azw": "application/vnd.amazon.ebook",
	  "acc": "application/vnd.americandynamics.acc",
	  "ami": "application/vnd.amiga.ami",
	  "apk": "application/vnd.android.package-archive",
	  "cii": "application/vnd.anser-web-certificate-issue-initiation",
	  "fti": "application/vnd.anser-web-funds-transfer-initiation",
	  "atx": "application/vnd.antix.game-component",
	  "mpkg": "application/vnd.apple.installer+xml",
	  "m3u8": "application/vnd.apple.mpegurl",
	  "swi": "application/vnd.aristanetworks.swi",
	  "iota": "application/vnd.astraea-software.iota",
	  "aep": "application/vnd.audiograph",
	  "mpm": "application/vnd.blueice.multipass",
	  "bmi": "application/vnd.bmi",
	  "rep": "application/vnd.businessobjects",
	  "cdxml": "application/vnd.chemdraw+xml",
	  "mmd": "application/vnd.chipnuts.karaoke-mmd",
	  "cdy": "application/vnd.cinderella",
	  "cla": "application/vnd.claymore",
	  "rp9": "application/vnd.cloanto.rp9",
	  "c4g": "application/vnd.clonk.c4group",
	  "c4d": "application/vnd.clonk.c4group",
	  "c4f": "application/vnd.clonk.c4group",
	  "c4p": "application/vnd.clonk.c4group",
	  "c4u": "application/vnd.clonk.c4group",
	  "c11amc": "application/vnd.cluetrust.cartomobile-config",
	  "c11amz": "application/vnd.cluetrust.cartomobile-config-pkg",
	  "csp": "application/vnd.commonspace",
	  "cdbcmsg": "application/vnd.contact.cmsg",
	  "cmc": "application/vnd.cosmocaller",
	  "clkx": "application/vnd.crick.clicker",
	  "clkk": "application/vnd.crick.clicker.keyboard",
	  "clkp": "application/vnd.crick.clicker.palette",
	  "clkt": "application/vnd.crick.clicker.template",
	  "clkw": "application/vnd.crick.clicker.wordbank",
	  "wbs": "application/vnd.criticaltools.wbs+xml",
	  "pml": "application/vnd.ctc-posml",
	  "ppd": "application/vnd.cups-ppd",
	  "car": "application/vnd.curl.car",
	  "pcurl": "application/vnd.curl.pcurl",
	  "dart": "application/vnd.dart",
	  "rdz": "application/vnd.data-vision.rdz",
	  "uvf": "application/vnd.dece.data",
	  "uvvf": "application/vnd.dece.data",
	  "uvd": "application/vnd.dece.data",
	  "uvvd": "application/vnd.dece.data",
	  "uvt": "application/vnd.dece.ttml+xml",
	  "uvvt": "application/vnd.dece.ttml+xml",
	  "uvx": "application/vnd.dece.unspecified",
	  "uvvx": "application/vnd.dece.unspecified",
	  "uvz": "application/vnd.dece.zip",
	  "uvvz": "application/vnd.dece.zip",
	  "fe_launch": "application/vnd.denovo.fcselayout-link",
	  "dna": "application/vnd.dna",
	  "mlp": "application/vnd.dolby.mlp",
	  "dpg": "application/vnd.dpgraph",
	  "dfac": "application/vnd.dreamfactory",
	  "kpxx": "application/vnd.ds-keypoint",
	  "ait": "application/vnd.dvb.ait",
	  "svc": "application/vnd.dvb.service",
	  "geo": "application/vnd.dynageo",
	  "mag": "application/vnd.ecowin.chart",
	  "nml": "application/vnd.enliven",
	  "esf": "application/vnd.epson.esf",
	  "msf": "application/vnd.epson.msf",
	  "qam": "application/vnd.epson.quickanime",
	  "slt": "application/vnd.epson.salt",
	  "ssf": "application/vnd.epson.ssf",
	  "es3": "application/vnd.eszigno3+xml",
	  "et3": "application/vnd.eszigno3+xml",
	  "ez2": "application/vnd.ezpix-album",
	  "ez3": "application/vnd.ezpix-package",
	  "fdf": "application/vnd.fdf",
	  "mseed": "application/vnd.fdsn.mseed",
	  "seed": "application/vnd.fdsn.seed",
	  "dataless": "application/vnd.fdsn.seed",
	  "gph": "application/vnd.flographit",
	  "ftc": "application/vnd.fluxtime.clip",
	  "fm": "application/vnd.framemaker",
	  "frame": "application/vnd.framemaker",
	  "maker": "application/vnd.framemaker",
	  "book": "application/vnd.framemaker",
	  "fnc": "application/vnd.frogans.fnc",
	  "ltf": "application/vnd.frogans.ltf",
	  "fsc": "application/vnd.fsc.weblaunch",
	  "oas": "application/vnd.fujitsu.oasys",
	  "oa2": "application/vnd.fujitsu.oasys2",
	  "oa3": "application/vnd.fujitsu.oasys3",
	  "fg5": "application/vnd.fujitsu.oasysgp",
	  "bh2": "application/vnd.fujitsu.oasysprs",
	  "ddd": "application/vnd.fujixerox.ddd",
	  "xdw": "application/vnd.fujixerox.docuworks",
	  "xbd": "application/vnd.fujixerox.docuworks.binder",
	  "fzs": "application/vnd.fuzzysheet",
	  "txd": "application/vnd.genomatix.tuxedo",
	  "ggb": "application/vnd.geogebra.file",
	  "ggt": "application/vnd.geogebra.tool",
	  "gex": "application/vnd.geometry-explorer",
	  "gre": "application/vnd.geometry-explorer",
	  "gxt": "application/vnd.geonext",
	  "g2w": "application/vnd.geoplan",
	  "g3w": "application/vnd.geospace",
	  "gmx": "application/vnd.gmx",
	  "kml": "application/vnd.google-earth.kml+xml",
	  "kmz": "application/vnd.google-earth.kmz",
	  "gqf": "application/vnd.grafeq",
	  "gqs": "application/vnd.grafeq",
	  "gac": "application/vnd.groove-account",
	  "ghf": "application/vnd.groove-help",
	  "gim": "application/vnd.groove-identity-message",
	  "grv": "application/vnd.groove-injector",
	  "gtm": "application/vnd.groove-tool-message",
	  "tpl": "application/vnd.groove-tool-template",
	  "vcg": "application/vnd.groove-vcard",
	  "hal": "application/vnd.hal+xml",
	  "zmm": "application/vnd.handheld-entertainment+xml",
	  "hbci": "application/vnd.hbci",
	  "les": "application/vnd.hhe.lesson-player",
	  "hpgl": "application/vnd.hp-hpgl",
	  "hpid": "application/vnd.hp-hpid",
	  "hps": "application/vnd.hp-hps",
	  "jlt": "application/vnd.hp-jlyt",
	  "pcl": "application/vnd.hp-pcl",
	  "pclxl": "application/vnd.hp-pclxl",
	  "sfd-hdstx": "application/vnd.hydrostatix.sof-data",
	  "mpy": "application/vnd.ibm.minipay",
	  "afp": "application/vnd.ibm.modcap",
	  "listafp": "application/vnd.ibm.modcap",
	  "list3820": "application/vnd.ibm.modcap",
	  "irm": "application/vnd.ibm.rights-management",
	  "sc": "application/vnd.ibm.secure-container",
	  "icc": "application/vnd.iccprofile",
	  "icm": "application/vnd.iccprofile",
	  "igl": "application/vnd.igloader",
	  "ivp": "application/vnd.immervision-ivp",
	  "ivu": "application/vnd.immervision-ivu",
	  "igm": "application/vnd.insors.igm",
	  "xpw": "application/vnd.intercon.formnet",
	  "xpx": "application/vnd.intercon.formnet",
	  "i2g": "application/vnd.intergeo",
	  "qbo": "application/vnd.intu.qbo",
	  "qfx": "application/vnd.intu.qfx",
	  "rcprofile": "application/vnd.ipunplugged.rcprofile",
	  "irp": "application/vnd.irepository.package+xml",
	  "xpr": "application/vnd.is-xpr",
	  "fcs": "application/vnd.isac.fcs",
	  "jam": "application/vnd.jam",
	  "rms": "application/vnd.jcp.javame.midlet-rms",
	  "jisp": "application/vnd.jisp",
	  "joda": "application/vnd.joost.joda-archive",
	  "ktz": "application/vnd.kahootz",
	  "ktr": "application/vnd.kahootz",
	  "karbon": "application/vnd.kde.karbon",
	  "chrt": "application/vnd.kde.kchart",
	  "kfo": "application/vnd.kde.kformula",
	  "flw": "application/vnd.kde.kivio",
	  "kon": "application/vnd.kde.kontour",
	  "kpr": "application/vnd.kde.kpresenter",
	  "kpt": "application/vnd.kde.kpresenter",
	  "ksp": "application/vnd.kde.kspread",
	  "kwd": "application/vnd.kde.kword",
	  "kwt": "application/vnd.kde.kword",
	  "htke": "application/vnd.kenameaapp",
	  "kia": "application/vnd.kidspiration",
	  "kne": "application/vnd.kinar",
	  "knp": "application/vnd.kinar",
	  "skp": "application/vnd.koan",
	  "skd": "application/vnd.koan",
	  "skt": "application/vnd.koan",
	  "skm": "application/vnd.koan",
	  "sse": "application/vnd.kodak-descriptor",
	  "lasxml": "application/vnd.las.las+xml",
	  "lbd": "application/vnd.llamagraphics.life-balance.desktop",
	  "lbe": "application/vnd.llamagraphics.life-balance.exchange+xml",
	  "apr": "application/vnd.lotus-approach",
	  "pre": "application/vnd.lotus-freelance",
	  "nsf": "application/vnd.lotus-notes",
	  "org": "application/vnd.lotus-organizer",
	  "scm": "application/vnd.lotus-screencam",
	  "lwp": "application/vnd.lotus-wordpro",
	  "portpkg": "application/vnd.macports.portpkg",
	  "mcd": "application/vnd.mcd",
	  "mc1": "application/vnd.medcalcdata",
	  "cdkey": "application/vnd.mediastation.cdkey",
	  "mwf": "application/vnd.mfer",
	  "mfm": "application/vnd.mfmp",
	  "flo": "application/vnd.micrografx.flo",
	  "igx": "application/vnd.micrografx.igx",
	  "mif": "application/vnd.mif",
	  "daf": "application/vnd.mobius.daf",
	  "dis": "application/vnd.mobius.dis",
	  "mbk": "application/vnd.mobius.mbk",
	  "mqy": "application/vnd.mobius.mqy",
	  "msl": "application/vnd.mobius.msl",
	  "plc": "application/vnd.mobius.plc",
	  "txf": "application/vnd.mobius.txf",
	  "mpn": "application/vnd.mophun.application",
	  "mpc": "application/vnd.mophun.certificate",
	  "xul": "application/vnd.mozilla.xul+xml",
	  "cil": "application/vnd.ms-artgalry",
	  "cab": "application/vnd.ms-cab-compressed",
	  "xls": "application/vnd.ms-excel",
	  "xlm": "application/vnd.ms-excel",
	  "xla": "application/vnd.ms-excel",
	  "xlc": "application/vnd.ms-excel",
	  "xlt": "application/vnd.ms-excel",
	  "xlw": "application/vnd.ms-excel",
	  "xlam": "application/vnd.ms-excel.addin.macroenabled.12",
	  "xlsb": "application/vnd.ms-excel.sheet.binary.macroenabled.12",
	  "xlsm": "application/vnd.ms-excel.sheet.macroenabled.12",
	  "xltm": "application/vnd.ms-excel.template.macroenabled.12",
	  "eot": "application/vnd.ms-fontobject",
	  "chm": "application/vnd.ms-htmlhelp",
	  "ims": "application/vnd.ms-ims",
	  "lrm": "application/vnd.ms-lrm",
	  "thmx": "application/vnd.ms-officetheme",
	  "cat": "application/vnd.ms-pki.seccat",
	  "stl": "application/vnd.ms-pki.stl",
	  "ppt": "application/vnd.ms-powerpoint",
	  "pps": "application/vnd.ms-powerpoint",
	  "pot": "application/vnd.ms-powerpoint",
	  "ppam": "application/vnd.ms-powerpoint.addin.macroenabled.12",
	  "pptm": "application/vnd.ms-powerpoint.presentation.macroenabled.12",
	  "sldm": "application/vnd.ms-powerpoint.slide.macroenabled.12",
	  "ppsm": "application/vnd.ms-powerpoint.slideshow.macroenabled.12",
	  "potm": "application/vnd.ms-powerpoint.template.macroenabled.12",
	  "mpp": "application/vnd.ms-project",
	  "mpt": "application/vnd.ms-project",
	  "docm": "application/vnd.ms-word.document.macroenabled.12",
	  "dotm": "application/vnd.ms-word.template.macroenabled.12",
	  "wps": "application/vnd.ms-works",
	  "wks": "application/vnd.ms-works",
	  "wcm": "application/vnd.ms-works",
	  "wdb": "application/vnd.ms-works",
	  "wpl": "application/vnd.ms-wpl",
	  "xps": "application/vnd.ms-xpsdocument",
	  "mseq": "application/vnd.mseq",
	  "mus": "application/vnd.musician",
	  "msty": "application/vnd.muvee.style",
	  "taglet": "application/vnd.mynfc",
	  "nlu": "application/vnd.neurolanguage.nlu",
	  "ntf": "application/vnd.nitf",
	  "nitf": "application/vnd.nitf",
	  "nnd": "application/vnd.noblenet-directory",
	  "nns": "application/vnd.noblenet-sealer",
	  "nnw": "application/vnd.noblenet-web",
	  "ngdat": "application/vnd.nokia.n-gage.data",
	  "n-gage": "application/vnd.nokia.n-gage.symbian.install",
	  "rpst": "application/vnd.nokia.radio-preset",
	  "rpss": "application/vnd.nokia.radio-presets",
	  "edm": "application/vnd.novadigm.edm",
	  "edx": "application/vnd.novadigm.edx",
	  "ext": "application/vnd.novadigm.ext",
	  "odc": "application/vnd.oasis.opendocument.chart",
	  "otc": "application/vnd.oasis.opendocument.chart-template",
	  "odb": "application/vnd.oasis.opendocument.database",
	  "odf": "application/vnd.oasis.opendocument.formula",
	  "odft": "application/vnd.oasis.opendocument.formula-template",
	  "odg": "application/vnd.oasis.opendocument.graphics",
	  "otg": "application/vnd.oasis.opendocument.graphics-template",
	  "odi": "application/vnd.oasis.opendocument.image",
	  "oti": "application/vnd.oasis.opendocument.image-template",
	  "odp": "application/vnd.oasis.opendocument.presentation",
	  "otp": "application/vnd.oasis.opendocument.presentation-template",
	  "ods": "application/vnd.oasis.opendocument.spreadsheet",
	  "ots": "application/vnd.oasis.opendocument.spreadsheet-template",
	  "odt": "application/vnd.oasis.opendocument.text",
	  "odm": "application/vnd.oasis.opendocument.text-master",
	  "ott": "application/vnd.oasis.opendocument.text-template",
	  "oth": "application/vnd.oasis.opendocument.text-web",
	  "xo": "application/vnd.olpc-sugar",
	  "dd2": "application/vnd.oma.dd2+xml",
	  "oxt": "application/vnd.openofficeorg.extension",
	  "pptx": "application/vnd.openxmlformats-officedocument.presentationml.presentation",
	  "sldx": "application/vnd.openxmlformats-officedocument.presentationml.slide",
	  "ppsx": "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
	  "potx": "application/vnd.openxmlformats-officedocument.presentationml.template",
	  "xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	  "xltx": "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
	  "docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
	  "dotx": "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
	  "mgp": "application/vnd.osgeo.mapguide.package",
	  "dp": "application/vnd.osgi.dp",
	  "esa": "application/vnd.osgi.subsystem",
	  "pdb": "application/vnd.palm",
	  "pqa": "application/vnd.palm",
	  "oprc": "application/vnd.palm",
	  "paw": "application/vnd.pawaafile",
	  "str": "application/vnd.pg.format",
	  "ei6": "application/vnd.pg.osasli",
	  "efif": "application/vnd.picsel",
	  "wg": "application/vnd.pmi.widget",
	  "plf": "application/vnd.pocketlearn",
	  "pbd": "application/vnd.powerbuilder6",
	  "box": "application/vnd.previewsystems.box",
	  "mgz": "application/vnd.proteus.magazine",
	  "qps": "application/vnd.publishare-delta-tree",
	  "ptid": "application/vnd.pvi.ptid1",
	  "qxd": "application/vnd.quark.quarkxpress",
	  "qxt": "application/vnd.quark.quarkxpress",
	  "qwd": "application/vnd.quark.quarkxpress",
	  "qwt": "application/vnd.quark.quarkxpress",
	  "qxl": "application/vnd.quark.quarkxpress",
	  "qxb": "application/vnd.quark.quarkxpress",
	  "bed": "application/vnd.realvnc.bed",
	  "mxl": "application/vnd.recordare.musicxml",
	  "musicxml": "application/vnd.recordare.musicxml+xml",
	  "cryptonote": "application/vnd.rig.cryptonote",
	  "cod": "application/vnd.rim.cod",
	  "rm": "application/vnd.rn-realmedia",
	  "rmvb": "application/vnd.rn-realmedia-vbr",
	  "link66": "application/vnd.route66.link66+xml",
	  "st": "application/vnd.sailingtracker.track",
	  "see": "application/vnd.seemail",
	  "sema": "application/vnd.sema",
	  "semd": "application/vnd.semd",
	  "semf": "application/vnd.semf",
	  "ifm": "application/vnd.shana.informed.formdata",
	  "itp": "application/vnd.shana.informed.formtemplate",
	  "iif": "application/vnd.shana.informed.interchange",
	  "ipk": "application/vnd.shana.informed.package",
	  "twd": "application/vnd.simtech-mindmapper",
	  "twds": "application/vnd.simtech-mindmapper",
	  "mmf": "application/vnd.smaf",
	  "teacher": "application/vnd.smart.teacher",
	  "sdkm": "application/vnd.solent.sdkm+xml",
	  "sdkd": "application/vnd.solent.sdkm+xml",
	  "dxp": "application/vnd.spotfire.dxp",
	  "sfs": "application/vnd.spotfire.sfs",
	  "sdc": "application/vnd.stardivision.calc",
	  "sda": "application/vnd.stardivision.draw",
	  "sdd": "application/vnd.stardivision.impress",
	  "smf": "application/vnd.stardivision.math",
	  "sdw": "application/vnd.stardivision.writer",
	  "vor": "application/vnd.stardivision.writer",
	  "sgl": "application/vnd.stardivision.writer-global",
	  "smzip": "application/vnd.stepmania.package",
	  "sm": "application/vnd.stepmania.stepchart",
	  "sxc": "application/vnd.sun.xml.calc",
	  "stc": "application/vnd.sun.xml.calc.template",
	  "sxd": "application/vnd.sun.xml.draw",
	  "std": "application/vnd.sun.xml.draw.template",
	  "sxi": "application/vnd.sun.xml.impress",
	  "sti": "application/vnd.sun.xml.impress.template",
	  "sxm": "application/vnd.sun.xml.math",
	  "sxw": "application/vnd.sun.xml.writer",
	  "sxg": "application/vnd.sun.xml.writer.global",
	  "stw": "application/vnd.sun.xml.writer.template",
	  "sus": "application/vnd.sus-calendar",
	  "susp": "application/vnd.sus-calendar",
	  "svd": "application/vnd.svd",
	  "sis": "application/vnd.symbian.install",
	  "sisx": "application/vnd.symbian.install",
	  "xsm": "application/vnd.syncml+xml",
	  "bdm": "application/vnd.syncml.dm+wbxml",
	  "xdm": "application/vnd.syncml.dm+xml",
	  "tao": "application/vnd.tao.intent-module-archive",
	  "pcap": "application/vnd.tcpdump.pcap",
	  "cap": "application/vnd.tcpdump.pcap",
	  "dmp": "application/vnd.tcpdump.pcap",
	  "tmo": "application/vnd.tmobile-livetv",
	  "tpt": "application/vnd.trid.tpt",
	  "mxs": "application/vnd.triscape.mxs",
	  "tra": "application/vnd.trueapp",
	  "ufd": "application/vnd.ufdl",
	  "ufdl": "application/vnd.ufdl",
	  "utz": "application/vnd.uiq.theme",
	  "umj": "application/vnd.umajin",
	  "unityweb": "application/vnd.unity",
	  "uoml": "application/vnd.uoml+xml",
	  "vcx": "application/vnd.vcx",
	  "vsd": "application/vnd.visio",
	  "vst": "application/vnd.visio",
	  "vss": "application/vnd.visio",
	  "vsw": "application/vnd.visio",
	  "vis": "application/vnd.visionary",
	  "vsf": "application/vnd.vsf",
	  "wbxml": "application/vnd.wap.wbxml",
	  "wmlc": "application/vnd.wap.wmlc",
	  "wmlsc": "application/vnd.wap.wmlscriptc",
	  "wtb": "application/vnd.webturbo",
	  "nbp": "application/vnd.wolfram.player",
	  "wpd": "application/vnd.wordperfect",
	  "wqd": "application/vnd.wqd",
	  "stf": "application/vnd.wt.stf",
	  "xar": "application/vnd.xara",
	  "xfdl": "application/vnd.xfdl",
	  "hvd": "application/vnd.yamaha.hv-dic",
	  "hvs": "application/vnd.yamaha.hv-script",
	  "hvp": "application/vnd.yamaha.hv-voice",
	  "osf": "application/vnd.yamaha.openscoreformat",
	  "osfpvg": "application/vnd.yamaha.openscoreformat.osfpvg+xml",
	  "saf": "application/vnd.yamaha.smaf-audio",
	  "spf": "application/vnd.yamaha.smaf-phrase",
	  "cmp": "application/vnd.yellowriver-custom-menu",
	  "zir": "application/vnd.zul",
	  "zirz": "application/vnd.zul",
	  "zaz": "application/vnd.zzazz.deck+xml",
	  "vxml": "application/voicexml+xml",
	  "wgt": "application/widget",
	  "hlp": "application/winhlp",
	  "wsdl": "application/wsdl+xml",
	  "wspolicy": "application/wspolicy+xml",
	  "7z": "application/x-7z-compressed",
	  "abw": "application/x-abiword",
	  "ace": "application/x-ace-compressed",
	  "dmg": "application/x-apple-diskimage",
	  "aab": "application/x-authorware-bin",
	  "x32": "application/x-authorware-bin",
	  "u32": "application/x-authorware-bin",
	  "vox": "application/x-authorware-bin",
	  "aam": "application/x-authorware-map",
	  "aas": "application/x-authorware-seg",
	  "bcpio": "application/x-bcpio",
	  "torrent": "application/x-bittorrent",
	  "blb": "application/x-blorb",
	  "blorb": "application/x-blorb",
	  "bz": "application/x-bzip",
	  "bz2": "application/x-bzip2",
	  "boz": "application/x-bzip2",
	  "cbr": "application/x-cbr",
	  "cba": "application/x-cbr",
	  "cbt": "application/x-cbr",
	  "cbz": "application/x-cbr",
	  "cb7": "application/x-cbr",
	  "vcd": "application/x-cdlink",
	  "cfs": "application/x-cfs-compressed",
	  "chat": "application/x-chat",
	  "pgn": "application/x-chess-pgn",
	  "nsc": "application/x-conference",
	  "cpio": "application/x-cpio",
	  "csh": "application/x-csh",
	  "deb": "application/x-debian-package",
	  "udeb": "application/x-debian-package",
	  "dgc": "application/x-dgc-compressed",
	  "dir": "application/x-director",
	  "dcr": "application/x-director",
	  "dxr": "application/x-director",
	  "cst": "application/x-director",
	  "cct": "application/x-director",
	  "cxt": "application/x-director",
	  "w3d": "application/x-director",
	  "fgd": "application/x-director",
	  "swa": "application/x-director",
	  "wad": "application/x-doom",
	  "ncx": "application/x-dtbncx+xml",
	  "dtb": "application/x-dtbook+xml",
	  "res": "application/x-dtbresource+xml",
	  "dvi": "application/x-dvi",
	  "evy": "application/x-envoy",
	  "eva": "application/x-eva",
	  "bdf": "application/x-font-bdf",
	  "gsf": "application/x-font-ghostscript",
	  "psf": "application/x-font-linux-psf",
	  "otf": "application/x-font-otf",
	  "pcf": "application/x-font-pcf",
	  "snf": "application/x-font-snf",
	  "ttf": "application/x-font-ttf",
	  "ttc": "application/x-font-ttf",
	  "pfa": "application/x-font-type1",
	  "pfb": "application/x-font-type1",
	  "pfm": "application/x-font-type1",
	  "afm": "application/x-font-type1",
	  "woff": "application/x-font-woff",
	  "arc": "application/x-freearc",
	  "spl": "application/x-futuresplash",
	  "gca": "application/x-gca-compressed",
	  "ulx": "application/x-glulx",
	  "gnumeric": "application/x-gnumeric",
	  "gramps": "application/x-gramps-xml",
	  "gtar": "application/x-gtar",
	  "hdf": "application/x-hdf",
	  "install": "application/x-install-instructions",
	  "iso": "application/x-iso9660-image",
	  "jnlp": "application/x-java-jnlp-file",
	  "latex": "application/x-latex",
	  "lzh": "application/x-lzh-compressed",
	  "lha": "application/x-lzh-compressed",
	  "mie": "application/x-mie",
	  "prc": "application/x-mobipocket-ebook",
	  "mobi": "application/x-mobipocket-ebook",
	  "application": "application/x-ms-application",
	  "lnk": "application/x-ms-shortcut",
	  "wmd": "application/x-ms-wmd",
	  "wmz": "application/x-msmetafile",
	  "xbap": "application/x-ms-xbap",
	  "mdb": "application/x-msaccess",
	  "obd": "application/x-msbinder",
	  "crd": "application/x-mscardfile",
	  "clp": "application/x-msclip",
	  "exe": "application/x-msdownload",
	  "dll": "application/x-msdownload",
	  "com": "application/x-msdownload",
	  "bat": "application/x-msdownload",
	  "msi": "application/x-msdownload",
	  "mvb": "application/x-msmediaview",
	  "m13": "application/x-msmediaview",
	  "m14": "application/x-msmediaview",
	  "wmf": "application/x-msmetafile",
	  "emf": "application/x-msmetafile",
	  "emz": "application/x-msmetafile",
	  "mny": "application/x-msmoney",
	  "pub": "application/x-mspublisher",
	  "scd": "application/x-msschedule",
	  "trm": "application/x-msterminal",
	  "wri": "application/x-mswrite",
	  "nc": "application/x-netcdf",
	  "cdf": "application/x-netcdf",
	  "nzb": "application/x-nzb",
	  "p12": "application/x-pkcs12",
	  "pfx": "application/x-pkcs12",
	  "p7b": "application/x-pkcs7-certificates",
	  "spc": "application/x-pkcs7-certificates",
	  "p7r": "application/x-pkcs7-certreqresp",
	  "rar": "application/x-rar-compressed",
	  "ris": "application/x-research-info-systems",
	  "sh": "application/x-sh",
	  "shar": "application/x-shar",
	  "swf": "application/x-shockwave-flash",
	  "xap": "application/x-silverlight-app",
	  "sql": "application/x-sql",
	  "sit": "application/x-stuffit",
	  "sitx": "application/x-stuffitx",
	  "srt": "application/x-subrip",
	  "sv4cpio": "application/x-sv4cpio",
	  "sv4crc": "application/x-sv4crc",
	  "t3": "application/x-t3vm-image",
	  "gam": "application/x-tads",
	  "tar": "application/x-tar",
	  "tcl": "application/x-tcl",
	  "tex": "application/x-tex",
	  "tfm": "application/x-tex-tfm",
	  "texinfo": "application/x-texinfo",
	  "texi": "application/x-texinfo",
	  "obj": "application/x-tgif",
	  "ustar": "application/x-ustar",
	  "src": "application/x-wais-source",
	  "der": "application/x-x509-ca-cert",
	  "crt": "application/x-x509-ca-cert",
	  "fig": "application/x-xfig",
	  "xlf": "application/x-xliff+xml",
	  "xpi": "application/x-xpinstall",
	  "xz": "application/x-xz",
	  "z1": "application/x-zmachine",
	  "z2": "application/x-zmachine",
	  "z3": "application/x-zmachine",
	  "z4": "application/x-zmachine",
	  "z5": "application/x-zmachine",
	  "z6": "application/x-zmachine",
	  "z7": "application/x-zmachine",
	  "z8": "application/x-zmachine",
	  "xaml": "application/xaml+xml",
	  "xdf": "application/xcap-diff+xml",
	  "xenc": "application/xenc+xml",
	  "xhtml": "application/xhtml+xml",
	  "xht": "application/xhtml+xml",
	  "xml": "application/xml",
	  "xsl": "application/xml",
	  "dtd": "application/xml-dtd",
	  "xop": "application/xop+xml",
	  "xpl": "application/xproc+xml",
	  "xslt": "application/xslt+xml",
	  "xspf": "application/xspf+xml",
	  "mxml": "application/xv+xml",
	  "xhvml": "application/xv+xml",
	  "xvml": "application/xv+xml",
	  "xvm": "application/xv+xml",
	  "yang": "application/yang",
	  "yin": "application/yin+xml",
	  "zip": "application/zip",
	  "adp": "audio/adpcm",
	  "au": "audio/basic",
	  "snd": "audio/basic",
	  "mid": "audio/midi",
	  "midi": "audio/midi",
	  "kar": "audio/midi",
	  "rmi": "audio/midi",
	  "mp4a": "audio/mp4",
	  "mpga": "audio/mpeg",
	  "mp2": "audio/mpeg",
	  "mp2a": "audio/mpeg",
	  "mp3": "audio/mpeg",
	  "m2a": "audio/mpeg",
	  "m3a": "audio/mpeg",
	  "oga": "audio/ogg",
	  "ogg": "audio/ogg",
	  "spx": "audio/ogg",
	  "s3m": "audio/s3m",
	  "sil": "audio/silk",
	  "uva": "audio/vnd.dece.audio",
	  "uvva": "audio/vnd.dece.audio",
	  "eol": "audio/vnd.digital-winds",
	  "dra": "audio/vnd.dra",
	  "dts": "audio/vnd.dts",
	  "dtshd": "audio/vnd.dts.hd",
	  "lvp": "audio/vnd.lucent.voice",
	  "pya": "audio/vnd.ms-playready.media.pya",
	  "ecelp4800": "audio/vnd.nuera.ecelp4800",
	  "ecelp7470": "audio/vnd.nuera.ecelp7470",
	  "ecelp9600": "audio/vnd.nuera.ecelp9600",
	  "rip": "audio/vnd.rip",
	  "weba": "audio/webm",
	  "aac": "audio/x-aac",
	  "aif": "audio/x-aiff",
	  "aiff": "audio/x-aiff",
	  "aifc": "audio/x-aiff",
	  "caf": "audio/x-caf",
	  "flac": "audio/x-flac",
	  "mka": "audio/x-matroska",
	  "m3u": "audio/x-mpegurl",
	  "wax": "audio/x-ms-wax",
	  "wma": "audio/x-ms-wma",
	  "ram": "audio/x-pn-realaudio",
	  "ra": "audio/x-pn-realaudio",
	  "rmp": "audio/x-pn-realaudio-plugin",
	  "wav": "audio/x-wav",
	  "xm": "audio/xm",
	  "cdx": "chemical/x-cdx",
	  "cif": "chemical/x-cif",
	  "cmdf": "chemical/x-cmdf",
	  "cml": "chemical/x-cml",
	  "csml": "chemical/x-csml",
	  "xyz": "chemical/x-xyz",
	  "bmp": "image/bmp",
	  "cgm": "image/cgm",
	  "g3": "image/g3fax",
	  "gif": "image/gif",
	  "ief": "image/ief",
	  "jpeg": "image/jpeg",
	  "jpg": "image/jpeg",
	  "jpe": "image/jpeg",
	  "ktx": "image/ktx",
	  "png": "image/png",
	  "btif": "image/prs.btif",
	  "sgi": "image/sgi",
	  "svg": "image/svg+xml",
	  "svgz": "image/svg+xml",
	  "tiff": "image/tiff",
	  "tif": "image/tiff",
	  "psd": "image/vnd.adobe.photoshop",
	  "uvi": "image/vnd.dece.graphic",
	  "uvvi": "image/vnd.dece.graphic",
	  "uvg": "image/vnd.dece.graphic",
	  "uvvg": "image/vnd.dece.graphic",
	  "sub": "text/vnd.dvb.subtitle",
	  "djvu": "image/vnd.djvu",
	  "djv": "image/vnd.djvu",
	  "dwg": "image/vnd.dwg",
	  "dxf": "image/vnd.dxf",
	  "fbs": "image/vnd.fastbidsheet",
	  "fpx": "image/vnd.fpx",
	  "fst": "image/vnd.fst",
	  "mmr": "image/vnd.fujixerox.edmics-mmr",
	  "rlc": "image/vnd.fujixerox.edmics-rlc",
	  "mdi": "image/vnd.ms-modi",
	  "wdp": "image/vnd.ms-photo",
	  "npx": "image/vnd.net-fpx",
	  "wbmp": "image/vnd.wap.wbmp",
	  "xif": "image/vnd.xiff",
	  "webp": "image/webp",
	  "3ds": "image/x-3ds",
	  "ras": "image/x-cmu-raster",
	  "cmx": "image/x-cmx",
	  "fh": "image/x-freehand",
	  "fhc": "image/x-freehand",
	  "fh4": "image/x-freehand",
	  "fh5": "image/x-freehand",
	  "fh7": "image/x-freehand",
	  "ico": "image/x-icon",
	  "sid": "image/x-mrsid-image",
	  "pcx": "image/x-pcx",
	  "pic": "image/x-pict",
	  "pct": "image/x-pict",
	  "pnm": "image/x-portable-anymap",
	  "pbm": "image/x-portable-bitmap",
	  "pgm": "image/x-portable-graymap",
	  "ppm": "image/x-portable-pixmap",
	  "rgb": "image/x-rgb",
	  "tga": "image/x-tga",
	  "xbm": "image/x-xbitmap",
	  "xpm": "image/x-xpixmap",
	  "xwd": "image/x-xwindowdump",
	  "eml": "message/rfc822",
	  "mime": "message/rfc822",
	  "igs": "model/iges",
	  "iges": "model/iges",
	  "msh": "model/mesh",
	  "mesh": "model/mesh",
	  "silo": "model/mesh",
	  "dae": "model/vnd.collada+xml",
	  "dwf": "model/vnd.dwf",
	  "gdl": "model/vnd.gdl",
	  "gtw": "model/vnd.gtw",
	  "mts": "model/vnd.mts",
	  "vtu": "model/vnd.vtu",
	  "wrl": "model/vrml",
	  "vrml": "model/vrml",
	  "x3db": "model/x3d+binary",
	  "x3dbz": "model/x3d+binary",
	  "x3dv": "model/x3d+vrml",
	  "x3dvz": "model/x3d+vrml",
	  "x3d": "model/x3d+xml",
	  "x3dz": "model/x3d+xml",
	  "appcache": "text/cache-manifest",
	  "ics": "text/calendar",
	  "ifb": "text/calendar",
	  "css": "text/css",
	  "csv": "text/csv",
	  "html": "text/html",
	  "htm": "text/html",
	  "n3": "text/n3",
	  "txt": "text/plain",
	  "text": "text/plain",
	  "conf": "text/plain",
	  "def": "text/plain",
	  "list": "text/plain",
	  "log": "text/plain",
	  "in": "text/plain",
	  "dsc": "text/prs.lines.tag",
	  "rtx": "text/richtext",
	  "sgml": "text/sgml",
	  "sgm": "text/sgml",
	  "tsv": "text/tab-separated-values",
	  "t": "text/troff",
	  "tr": "text/troff",
	  "roff": "text/troff",
	  "man": "text/troff",
	  "me": "text/troff",
	  "ms": "text/troff",
	  "ttl": "text/turtle",
	  "uri": "text/uri-list",
	  "uris": "text/uri-list",
	  "urls": "text/uri-list",
	  "vcard": "text/vcard",
	  "curl": "text/vnd.curl",
	  "dcurl": "text/vnd.curl.dcurl",
	  "scurl": "text/vnd.curl.scurl",
	  "mcurl": "text/vnd.curl.mcurl",
	  "fly": "text/vnd.fly",
	  "flx": "text/vnd.fmi.flexstor",
	  "gv": "text/vnd.graphviz",
	  "3dml": "text/vnd.in3d.3dml",
	  "spot": "text/vnd.in3d.spot",
	  "jad": "text/vnd.sun.j2me.app-descriptor",
	  "wml": "text/vnd.wap.wml",
	  "wmls": "text/vnd.wap.wmlscript",
	  "s": "text/x-asm",
	  "asm": "text/x-asm",
	  "c": "text/x-c",
	  "cc": "text/x-c",
	  "cxx": "text/x-c",
	  "cpp": "text/x-c",
	  "h": "text/x-c",
	  "hh": "text/x-c",
	  "dic": "text/x-c",
	  "f": "text/x-fortran",
	  "for": "text/x-fortran",
	  "f77": "text/x-fortran",
	  "f90": "text/x-fortran",
	  "java": "text/x-java-source",
	  "opml": "text/x-opml",
	  "p": "text/x-pascal",
	  "pas": "text/x-pascal",
	  "nfo": "text/x-nfo",
	  "etx": "text/x-setext",
	  "sfv": "text/x-sfv",
	  "uu": "text/x-uuencode",
	  "vcs": "text/x-vcalendar",
	  "vcf": "text/x-vcard",
	  "3gp": "video/3gpp",
	  "3g2": "video/3gpp2",
	  "h261": "video/h261",
	  "h263": "video/h263",
	  "h264": "video/h264",
	  "jpgv": "video/jpeg",
	  "jpm": "video/jpm",
	  "jpgm": "video/jpm",
	  "mj2": "video/mj2",
	  "mjp2": "video/mj2",
	  "mp4": "video/mp4",
	  "mp4v": "video/mp4",
	  "mpg4": "video/mp4",
	  "mpeg": "video/mpeg",
	  "mpg": "video/mpeg",
	  "mpe": "video/mpeg",
	  "m1v": "video/mpeg",
	  "m2v": "video/mpeg",
	  "ogv": "video/ogg",
	  "qt": "video/quicktime",
	  "mov": "video/quicktime",
	  "uvh": "video/vnd.dece.hd",
	  "uvvh": "video/vnd.dece.hd",
	  "uvm": "video/vnd.dece.mobile",
	  "uvvm": "video/vnd.dece.mobile",
	  "uvp": "video/vnd.dece.pd",
	  "uvvp": "video/vnd.dece.pd",
	  "uvs": "video/vnd.dece.sd",
	  "uvvs": "video/vnd.dece.sd",
	  "uvv": "video/vnd.dece.video",
	  "uvvv": "video/vnd.dece.video",
	  "dvb": "video/vnd.dvb.file",
	  "fvt": "video/vnd.fvt",
	  "mxu": "video/vnd.mpegurl",
	  "m4u": "video/vnd.mpegurl",
	  "pyv": "video/vnd.ms-playready.media.pyv",
	  "uvu": "video/vnd.uvvu.mp4",
	  "uvvu": "video/vnd.uvvu.mp4",
	  "viv": "video/vnd.vivo",
	  "webm": "video/webm",
	  "f4v": "video/x-f4v",
	  "fli": "video/x-fli",
	  "flv": "video/x-flv",
	  "m4v": "video/x-m4v",
	  "mkv": "video/x-matroska",
	  "mk3d": "video/x-matroska",
	  "mks": "video/x-matroska",
	  "mng": "video/x-mng",
	  "asf": "video/x-ms-asf",
	  "asx": "video/x-ms-asf",
	  "vob": "video/x-ms-vob",
	  "wm": "video/x-ms-wm",
	  "wmv": "video/x-ms-wmv",
	  "wmx": "video/x-ms-wmx",
	  "wvx": "video/x-ms-wvx",
	  "avi": "video/x-msvideo",
	  "movie": "video/x-sgi-movie",
	  "smv": "video/x-smv",
	  "ice": "x-conference/x-cooltalk",
	  "vtt": "text/vtt",
	  "crx": "application/x-chrome-extension",
	  "htc": "text/x-component",
	  "manifest": "text/cache-manifest",
	  "buffer": "application/octet-stream",
	  "m4p": "application/mp4",
	  "m4a": "audio/mp4",
	  "ts": "video/MP2T",
	  "event-stream": "text/event-stream",
	  "webapp": "application/x-web-app-manifest+json",
	  "lua": "text/x-lua",
	  "luac": "application/x-lua-bytecode",
	  "markdown": "text/x-markdown",
	  "md": "text/x-markdown",
	  "mkd": "text/x-markdown"
	}
	  , extensions: {
	  "application/andrew-inset": "ez",
	  "application/applixware": "aw",
	  "application/atom+xml": "atom",
	  "application/atomcat+xml": "atomcat",
	  "application/atomsvc+xml": "atomsvc",
	  "application/ccxml+xml": "ccxml",
	  "application/cdmi-capability": "cdmia",
	  "application/cdmi-container": "cdmic",
	  "application/cdmi-domain": "cdmid",
	  "application/cdmi-object": "cdmio",
	  "application/cdmi-queue": "cdmiq",
	  "application/cu-seeme": "cu",
	  "application/davmount+xml": "davmount",
	  "application/docbook+xml": "dbk",
	  "application/dssc+der": "dssc",
	  "application/dssc+xml": "xdssc",
	  "application/ecmascript": "ecma",
	  "application/emma+xml": "emma",
	  "application/epub+zip": "epub",
	  "application/exi": "exi",
	  "application/font-tdpfr": "pfr",
	  "application/gml+xml": "gml",
	  "application/gpx+xml": "gpx",
	  "application/gxf": "gxf",
	  "application/hyperstudio": "stk",
	  "application/inkml+xml": "ink",
	  "application/ipfix": "ipfix",
	  "application/java-archive": "jar",
	  "application/java-serialized-object": "ser",
	  "application/java-vm": "class",
	  "application/javascript": "js",
	  "application/json": "json",
	  "application/jsonml+json": "jsonml",
	  "application/lost+xml": "lostxml",
	  "application/mac-binhex40": "hqx",
	  "application/mac-compactpro": "cpt",
	  "application/mads+xml": "mads",
	  "application/marc": "mrc",
	  "application/marcxml+xml": "mrcx",
	  "application/mathematica": "ma",
	  "application/mathml+xml": "mathml",
	  "application/mbox": "mbox",
	  "application/mediaservercontrol+xml": "mscml",
	  "application/metalink+xml": "metalink",
	  "application/metalink4+xml": "meta4",
	  "application/mets+xml": "mets",
	  "application/mods+xml": "mods",
	  "application/mp21": "m21",
	  "application/mp4": "mp4s",
	  "application/msword": "doc",
	  "application/mxf": "mxf",
	  "application/octet-stream": "bin",
	  "application/oda": "oda",
	  "application/oebps-package+xml": "opf",
	  "application/ogg": "ogx",
	  "application/omdoc+xml": "omdoc",
	  "application/onenote": "onetoc",
	  "application/oxps": "oxps",
	  "application/patch-ops-error+xml": "xer",
	  "application/pdf": "pdf",
	  "application/pgp-encrypted": "pgp",
	  "application/pgp-signature": "asc",
	  "application/pics-rules": "prf",
	  "application/pkcs10": "p10",
	  "application/pkcs7-mime": "p7m",
	  "application/pkcs7-signature": "p7s",
	  "application/pkcs8": "p8",
	  "application/pkix-attr-cert": "ac",
	  "application/pkix-cert": "cer",
	  "application/pkix-crl": "crl",
	  "application/pkix-pkipath": "pkipath",
	  "application/pkixcmp": "pki",
	  "application/pls+xml": "pls",
	  "application/postscript": "ai",
	  "application/prs.cww": "cww",
	  "application/pskc+xml": "pskcxml",
	  "application/rdf+xml": "rdf",
	  "application/reginfo+xml": "rif",
	  "application/relax-ng-compact-syntax": "rnc",
	  "application/resource-lists+xml": "rl",
	  "application/resource-lists-diff+xml": "rld",
	  "application/rls-services+xml": "rs",
	  "application/rpki-ghostbusters": "gbr",
	  "application/rpki-manifest": "mft",
	  "application/rpki-roa": "roa",
	  "application/rsd+xml": "rsd",
	  "application/rss+xml": "rss",
	  "application/rtf": "rtf",
	  "application/sbml+xml": "sbml",
	  "application/scvp-cv-request": "scq",
	  "application/scvp-cv-response": "scs",
	  "application/scvp-vp-request": "spq",
	  "application/scvp-vp-response": "spp",
	  "application/sdp": "sdp",
	  "application/set-payment-initiation": "setpay",
	  "application/set-registration-initiation": "setreg",
	  "application/shf+xml": "shf",
	  "application/smil+xml": "smi",
	  "application/sparql-query": "rq",
	  "application/sparql-results+xml": "srx",
	  "application/srgs": "gram",
	  "application/srgs+xml": "grxml",
	  "application/sru+xml": "sru",
	  "application/ssdl+xml": "ssdl",
	  "application/ssml+xml": "ssml",
	  "application/tei+xml": "tei",
	  "application/thraud+xml": "tfi",
	  "application/timestamped-data": "tsd",
	  "application/vnd.3gpp.pic-bw-large": "plb",
	  "application/vnd.3gpp.pic-bw-small": "psb",
	  "application/vnd.3gpp.pic-bw-var": "pvb",
	  "application/vnd.3gpp2.tcap": "tcap",
	  "application/vnd.3m.post-it-notes": "pwn",
	  "application/vnd.accpac.simply.aso": "aso",
	  "application/vnd.accpac.simply.imp": "imp",
	  "application/vnd.acucobol": "acu",
	  "application/vnd.acucorp": "atc",
	  "application/vnd.adobe.air-application-installer-package+zip": "air",
	  "application/vnd.adobe.formscentral.fcdt": "fcdt",
	  "application/vnd.adobe.fxp": "fxp",
	  "application/vnd.adobe.xdp+xml": "xdp",
	  "application/vnd.adobe.xfdf": "xfdf",
	  "application/vnd.ahead.space": "ahead",
	  "application/vnd.airzip.filesecure.azf": "azf",
	  "application/vnd.airzip.filesecure.azs": "azs",
	  "application/vnd.amazon.ebook": "azw",
	  "application/vnd.americandynamics.acc": "acc",
	  "application/vnd.amiga.ami": "ami",
	  "application/vnd.android.package-archive": "apk",
	  "application/vnd.anser-web-certificate-issue-initiation": "cii",
	  "application/vnd.anser-web-funds-transfer-initiation": "fti",
	  "application/vnd.antix.game-component": "atx",
	  "application/vnd.apple.installer+xml": "mpkg",
	  "application/vnd.apple.mpegurl": "m3u8",
	  "application/vnd.aristanetworks.swi": "swi",
	  "application/vnd.astraea-software.iota": "iota",
	  "application/vnd.audiograph": "aep",
	  "application/vnd.blueice.multipass": "mpm",
	  "application/vnd.bmi": "bmi",
	  "application/vnd.businessobjects": "rep",
	  "application/vnd.chemdraw+xml": "cdxml",
	  "application/vnd.chipnuts.karaoke-mmd": "mmd",
	  "application/vnd.cinderella": "cdy",
	  "application/vnd.claymore": "cla",
	  "application/vnd.cloanto.rp9": "rp9",
	  "application/vnd.clonk.c4group": "c4g",
	  "application/vnd.cluetrust.cartomobile-config": "c11amc",
	  "application/vnd.cluetrust.cartomobile-config-pkg": "c11amz",
	  "application/vnd.commonspace": "csp",
	  "application/vnd.contact.cmsg": "cdbcmsg",
	  "application/vnd.cosmocaller": "cmc",
	  "application/vnd.crick.clicker": "clkx",
	  "application/vnd.crick.clicker.keyboard": "clkk",
	  "application/vnd.crick.clicker.palette": "clkp",
	  "application/vnd.crick.clicker.template": "clkt",
	  "application/vnd.crick.clicker.wordbank": "clkw",
	  "application/vnd.criticaltools.wbs+xml": "wbs",
	  "application/vnd.ctc-posml": "pml",
	  "application/vnd.cups-ppd": "ppd",
	  "application/vnd.curl.car": "car",
	  "application/vnd.curl.pcurl": "pcurl",
	  "application/vnd.dart": "dart",
	  "application/vnd.data-vision.rdz": "rdz",
	  "application/vnd.dece.data": "uvf",
	  "application/vnd.dece.ttml+xml": "uvt",
	  "application/vnd.dece.unspecified": "uvx",
	  "application/vnd.dece.zip": "uvz",
	  "application/vnd.denovo.fcselayout-link": "fe_launch",
	  "application/vnd.dna": "dna",
	  "application/vnd.dolby.mlp": "mlp",
	  "application/vnd.dpgraph": "dpg",
	  "application/vnd.dreamfactory": "dfac",
	  "application/vnd.ds-keypoint": "kpxx",
	  "application/vnd.dvb.ait": "ait",
	  "application/vnd.dvb.service": "svc",
	  "application/vnd.dynageo": "geo",
	  "application/vnd.ecowin.chart": "mag",
	  "application/vnd.enliven": "nml",
	  "application/vnd.epson.esf": "esf",
	  "application/vnd.epson.msf": "msf",
	  "application/vnd.epson.quickanime": "qam",
	  "application/vnd.epson.salt": "slt",
	  "application/vnd.epson.ssf": "ssf",
	  "application/vnd.eszigno3+xml": "es3",
	  "application/vnd.ezpix-album": "ez2",
	  "application/vnd.ezpix-package": "ez3",
	  "application/vnd.fdf": "fdf",
	  "application/vnd.fdsn.mseed": "mseed",
	  "application/vnd.fdsn.seed": "seed",
	  "application/vnd.flographit": "gph",
	  "application/vnd.fluxtime.clip": "ftc",
	  "application/vnd.framemaker": "fm",
	  "application/vnd.frogans.fnc": "fnc",
	  "application/vnd.frogans.ltf": "ltf",
	  "application/vnd.fsc.weblaunch": "fsc",
	  "application/vnd.fujitsu.oasys": "oas",
	  "application/vnd.fujitsu.oasys2": "oa2",
	  "application/vnd.fujitsu.oasys3": "oa3",
	  "application/vnd.fujitsu.oasysgp": "fg5",
	  "application/vnd.fujitsu.oasysprs": "bh2",
	  "application/vnd.fujixerox.ddd": "ddd",
	  "application/vnd.fujixerox.docuworks": "xdw",
	  "application/vnd.fujixerox.docuworks.binder": "xbd",
	  "application/vnd.fuzzysheet": "fzs",
	  "application/vnd.genomatix.tuxedo": "txd",
	  "application/vnd.geogebra.file": "ggb",
	  "application/vnd.geogebra.tool": "ggt",
	  "application/vnd.geometry-explorer": "gex",
	  "application/vnd.geonext": "gxt",
	  "application/vnd.geoplan": "g2w",
	  "application/vnd.geospace": "g3w",
	  "application/vnd.gmx": "gmx",
	  "application/vnd.google-earth.kml+xml": "kml",
	  "application/vnd.google-earth.kmz": "kmz",
	  "application/vnd.grafeq": "gqf",
	  "application/vnd.groove-account": "gac",
	  "application/vnd.groove-help": "ghf",
	  "application/vnd.groove-identity-message": "gim",
	  "application/vnd.groove-injector": "grv",
	  "application/vnd.groove-tool-message": "gtm",
	  "application/vnd.groove-tool-template": "tpl",
	  "application/vnd.groove-vcard": "vcg",
	  "application/vnd.hal+xml": "hal",
	  "application/vnd.handheld-entertainment+xml": "zmm",
	  "application/vnd.hbci": "hbci",
	  "application/vnd.hhe.lesson-player": "les",
	  "application/vnd.hp-hpgl": "hpgl",
	  "application/vnd.hp-hpid": "hpid",
	  "application/vnd.hp-hps": "hps",
	  "application/vnd.hp-jlyt": "jlt",
	  "application/vnd.hp-pcl": "pcl",
	  "application/vnd.hp-pclxl": "pclxl",
	  "application/vnd.hydrostatix.sof-data": "sfd-hdstx",
	  "application/vnd.ibm.minipay": "mpy",
	  "application/vnd.ibm.modcap": "afp",
	  "application/vnd.ibm.rights-management": "irm",
	  "application/vnd.ibm.secure-container": "sc",
	  "application/vnd.iccprofile": "icc",
	  "application/vnd.igloader": "igl",
	  "application/vnd.immervision-ivp": "ivp",
	  "application/vnd.immervision-ivu": "ivu",
	  "application/vnd.insors.igm": "igm",
	  "application/vnd.intercon.formnet": "xpw",
	  "application/vnd.intergeo": "i2g",
	  "application/vnd.intu.qbo": "qbo",
	  "application/vnd.intu.qfx": "qfx",
	  "application/vnd.ipunplugged.rcprofile": "rcprofile",
	  "application/vnd.irepository.package+xml": "irp",
	  "application/vnd.is-xpr": "xpr",
	  "application/vnd.isac.fcs": "fcs",
	  "application/vnd.jam": "jam",
	  "application/vnd.jcp.javame.midlet-rms": "rms",
	  "application/vnd.jisp": "jisp",
	  "application/vnd.joost.joda-archive": "joda",
	  "application/vnd.kahootz": "ktz",
	  "application/vnd.kde.karbon": "karbon",
	  "application/vnd.kde.kchart": "chrt",
	  "application/vnd.kde.kformula": "kfo",
	  "application/vnd.kde.kivio": "flw",
	  "application/vnd.kde.kontour": "kon",
	  "application/vnd.kde.kpresenter": "kpr",
	  "application/vnd.kde.kspread": "ksp",
	  "application/vnd.kde.kword": "kwd",
	  "application/vnd.kenameaapp": "htke",
	  "application/vnd.kidspiration": "kia",
	  "application/vnd.kinar": "kne",
	  "application/vnd.koan": "skp",
	  "application/vnd.kodak-descriptor": "sse",
	  "application/vnd.las.las+xml": "lasxml",
	  "application/vnd.llamagraphics.life-balance.desktop": "lbd",
	  "application/vnd.llamagraphics.life-balance.exchange+xml": "lbe",
	  "application/vnd.lotus-1-2-3": "123",
	  "application/vnd.lotus-approach": "apr",
	  "application/vnd.lotus-freelance": "pre",
	  "application/vnd.lotus-notes": "nsf",
	  "application/vnd.lotus-organizer": "org",
	  "application/vnd.lotus-screencam": "scm",
	  "application/vnd.lotus-wordpro": "lwp",
	  "application/vnd.macports.portpkg": "portpkg",
	  "application/vnd.mcd": "mcd",
	  "application/vnd.medcalcdata": "mc1",
	  "application/vnd.mediastation.cdkey": "cdkey",
	  "application/vnd.mfer": "mwf",
	  "application/vnd.mfmp": "mfm",
	  "application/vnd.micrografx.flo": "flo",
	  "application/vnd.micrografx.igx": "igx",
	  "application/vnd.mif": "mif",
	  "application/vnd.mobius.daf": "daf",
	  "application/vnd.mobius.dis": "dis",
	  "application/vnd.mobius.mbk": "mbk",
	  "application/vnd.mobius.mqy": "mqy",
	  "application/vnd.mobius.msl": "msl",
	  "application/vnd.mobius.plc": "plc",
	  "application/vnd.mobius.txf": "txf",
	  "application/vnd.mophun.application": "mpn",
	  "application/vnd.mophun.certificate": "mpc",
	  "application/vnd.mozilla.xul+xml": "xul",
	  "application/vnd.ms-artgalry": "cil",
	  "application/vnd.ms-cab-compressed": "cab",
	  "application/vnd.ms-excel": "xls",
	  "application/vnd.ms-excel.addin.macroenabled.12": "xlam",
	  "application/vnd.ms-excel.sheet.binary.macroenabled.12": "xlsb",
	  "application/vnd.ms-excel.sheet.macroenabled.12": "xlsm",
	  "application/vnd.ms-excel.template.macroenabled.12": "xltm",
	  "application/vnd.ms-fontobject": "eot",
	  "application/vnd.ms-htmlhelp": "chm",
	  "application/vnd.ms-ims": "ims",
	  "application/vnd.ms-lrm": "lrm",
	  "application/vnd.ms-officetheme": "thmx",
	  "application/vnd.ms-pki.seccat": "cat",
	  "application/vnd.ms-pki.stl": "stl",
	  "application/vnd.ms-powerpoint": "ppt",
	  "application/vnd.ms-powerpoint.addin.macroenabled.12": "ppam",
	  "application/vnd.ms-powerpoint.presentation.macroenabled.12": "pptm",
	  "application/vnd.ms-powerpoint.slide.macroenabled.12": "sldm",
	  "application/vnd.ms-powerpoint.slideshow.macroenabled.12": "ppsm",
	  "application/vnd.ms-powerpoint.template.macroenabled.12": "potm",
	  "application/vnd.ms-project": "mpp",
	  "application/vnd.ms-word.document.macroenabled.12": "docm",
	  "application/vnd.ms-word.template.macroenabled.12": "dotm",
	  "application/vnd.ms-works": "wps",
	  "application/vnd.ms-wpl": "wpl",
	  "application/vnd.ms-xpsdocument": "xps",
	  "application/vnd.mseq": "mseq",
	  "application/vnd.musician": "mus",
	  "application/vnd.muvee.style": "msty",
	  "application/vnd.mynfc": "taglet",
	  "application/vnd.neurolanguage.nlu": "nlu",
	  "application/vnd.nitf": "ntf",
	  "application/vnd.noblenet-directory": "nnd",
	  "application/vnd.noblenet-sealer": "nns",
	  "application/vnd.noblenet-web": "nnw",
	  "application/vnd.nokia.n-gage.data": "ngdat",
	  "application/vnd.nokia.n-gage.symbian.install": "n-gage",
	  "application/vnd.nokia.radio-preset": "rpst",
	  "application/vnd.nokia.radio-presets": "rpss",
	  "application/vnd.novadigm.edm": "edm",
	  "application/vnd.novadigm.edx": "edx",
	  "application/vnd.novadigm.ext": "ext",
	  "application/vnd.oasis.opendocument.chart": "odc",
	  "application/vnd.oasis.opendocument.chart-template": "otc",
	  "application/vnd.oasis.opendocument.database": "odb",
	  "application/vnd.oasis.opendocument.formula": "odf",
	  "application/vnd.oasis.opendocument.formula-template": "odft",
	  "application/vnd.oasis.opendocument.graphics": "odg",
	  "application/vnd.oasis.opendocument.graphics-template": "otg",
	  "application/vnd.oasis.opendocument.image": "odi",
	  "application/vnd.oasis.opendocument.image-template": "oti",
	  "application/vnd.oasis.opendocument.presentation": "odp",
	  "application/vnd.oasis.opendocument.presentation-template": "otp",
	  "application/vnd.oasis.opendocument.spreadsheet": "ods",
	  "application/vnd.oasis.opendocument.spreadsheet-template": "ots",
	  "application/vnd.oasis.opendocument.text": "odt",
	  "application/vnd.oasis.opendocument.text-master": "odm",
	  "application/vnd.oasis.opendocument.text-template": "ott",
	  "application/vnd.oasis.opendocument.text-web": "oth",
	  "application/vnd.olpc-sugar": "xo",
	  "application/vnd.oma.dd2+xml": "dd2",
	  "application/vnd.openofficeorg.extension": "oxt",
	  "application/vnd.openxmlformats-officedocument.presentationml.presentation": "pptx",
	  "application/vnd.openxmlformats-officedocument.presentationml.slide": "sldx",
	  "application/vnd.openxmlformats-officedocument.presentationml.slideshow": "ppsx",
	  "application/vnd.openxmlformats-officedocument.presentationml.template": "potx",
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.template": "xltx",
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.template": "dotx",
	  "application/vnd.osgeo.mapguide.package": "mgp",
	  "application/vnd.osgi.dp": "dp",
	  "application/vnd.osgi.subsystem": "esa",
	  "application/vnd.palm": "pdb",
	  "application/vnd.pawaafile": "paw",
	  "application/vnd.pg.format": "str",
	  "application/vnd.pg.osasli": "ei6",
	  "application/vnd.picsel": "efif",
	  "application/vnd.pmi.widget": "wg",
	  "application/vnd.pocketlearn": "plf",
	  "application/vnd.powerbuilder6": "pbd",
	  "application/vnd.previewsystems.box": "box",
	  "application/vnd.proteus.magazine": "mgz",
	  "application/vnd.publishare-delta-tree": "qps",
	  "application/vnd.pvi.ptid1": "ptid",
	  "application/vnd.quark.quarkxpress": "qxd",
	  "application/vnd.realvnc.bed": "bed",
	  "application/vnd.recordare.musicxml": "mxl",
	  "application/vnd.recordare.musicxml+xml": "musicxml",
	  "application/vnd.rig.cryptonote": "cryptonote",
	  "application/vnd.rim.cod": "cod",
	  "application/vnd.rn-realmedia": "rm",
	  "application/vnd.rn-realmedia-vbr": "rmvb",
	  "application/vnd.route66.link66+xml": "link66",
	  "application/vnd.sailingtracker.track": "st",
	  "application/vnd.seemail": "see",
	  "application/vnd.sema": "sema",
	  "application/vnd.semd": "semd",
	  "application/vnd.semf": "semf",
	  "application/vnd.shana.informed.formdata": "ifm",
	  "application/vnd.shana.informed.formtemplate": "itp",
	  "application/vnd.shana.informed.interchange": "iif",
	  "application/vnd.shana.informed.package": "ipk",
	  "application/vnd.simtech-mindmapper": "twd",
	  "application/vnd.smaf": "mmf",
	  "application/vnd.smart.teacher": "teacher",
	  "application/vnd.solent.sdkm+xml": "sdkm",
	  "application/vnd.spotfire.dxp": "dxp",
	  "application/vnd.spotfire.sfs": "sfs",
	  "application/vnd.stardivision.calc": "sdc",
	  "application/vnd.stardivision.draw": "sda",
	  "application/vnd.stardivision.impress": "sdd",
	  "application/vnd.stardivision.math": "smf",
	  "application/vnd.stardivision.writer": "sdw",
	  "application/vnd.stardivision.writer-global": "sgl",
	  "application/vnd.stepmania.package": "smzip",
	  "application/vnd.stepmania.stepchart": "sm",
	  "application/vnd.sun.xml.calc": "sxc",
	  "application/vnd.sun.xml.calc.template": "stc",
	  "application/vnd.sun.xml.draw": "sxd",
	  "application/vnd.sun.xml.draw.template": "std",
	  "application/vnd.sun.xml.impress": "sxi",
	  "application/vnd.sun.xml.impress.template": "sti",
	  "application/vnd.sun.xml.math": "sxm",
	  "application/vnd.sun.xml.writer": "sxw",
	  "application/vnd.sun.xml.writer.global": "sxg",
	  "application/vnd.sun.xml.writer.template": "stw",
	  "application/vnd.sus-calendar": "sus",
	  "application/vnd.svd": "svd",
	  "application/vnd.symbian.install": "sis",
	  "application/vnd.syncml+xml": "xsm",
	  "application/vnd.syncml.dm+wbxml": "bdm",
	  "application/vnd.syncml.dm+xml": "xdm",
	  "application/vnd.tao.intent-module-archive": "tao",
	  "application/vnd.tcpdump.pcap": "pcap",
	  "application/vnd.tmobile-livetv": "tmo",
	  "application/vnd.trid.tpt": "tpt",
	  "application/vnd.triscape.mxs": "mxs",
	  "application/vnd.trueapp": "tra",
	  "application/vnd.ufdl": "ufd",
	  "application/vnd.uiq.theme": "utz",
	  "application/vnd.umajin": "umj",
	  "application/vnd.unity": "unityweb",
	  "application/vnd.uoml+xml": "uoml",
	  "application/vnd.vcx": "vcx",
	  "application/vnd.visio": "vsd",
	  "application/vnd.visionary": "vis",
	  "application/vnd.vsf": "vsf",
	  "application/vnd.wap.wbxml": "wbxml",
	  "application/vnd.wap.wmlc": "wmlc",
	  "application/vnd.wap.wmlscriptc": "wmlsc",
	  "application/vnd.webturbo": "wtb",
	  "application/vnd.wolfram.player": "nbp",
	  "application/vnd.wordperfect": "wpd",
	  "application/vnd.wqd": "wqd",
	  "application/vnd.wt.stf": "stf",
	  "application/vnd.xara": "xar",
	  "application/vnd.xfdl": "xfdl",
	  "application/vnd.yamaha.hv-dic": "hvd",
	  "application/vnd.yamaha.hv-script": "hvs",
	  "application/vnd.yamaha.hv-voice": "hvp",
	  "application/vnd.yamaha.openscoreformat": "osf",
	  "application/vnd.yamaha.openscoreformat.osfpvg+xml": "osfpvg",
	  "application/vnd.yamaha.smaf-audio": "saf",
	  "application/vnd.yamaha.smaf-phrase": "spf",
	  "application/vnd.yellowriver-custom-menu": "cmp",
	  "application/vnd.zul": "zir",
	  "application/vnd.zzazz.deck+xml": "zaz",
	  "application/voicexml+xml": "vxml",
	  "application/widget": "wgt",
	  "application/winhlp": "hlp",
	  "application/wsdl+xml": "wsdl",
	  "application/wspolicy+xml": "wspolicy",
	  "application/x-7z-compressed": "7z",
	  "application/x-abiword": "abw",
	  "application/x-ace-compressed": "ace",
	  "application/x-apple-diskimage": "dmg",
	  "application/x-authorware-bin": "aab",
	  "application/x-authorware-map": "aam",
	  "application/x-authorware-seg": "aas",
	  "application/x-bcpio": "bcpio",
	  "application/x-bittorrent": "torrent",
	  "application/x-blorb": "blb",
	  "application/x-bzip": "bz",
	  "application/x-bzip2": "bz2",
	  "application/x-cbr": "cbr",
	  "application/x-cdlink": "vcd",
	  "application/x-cfs-compressed": "cfs",
	  "application/x-chat": "chat",
	  "application/x-chess-pgn": "pgn",
	  "application/x-conference": "nsc",
	  "application/x-cpio": "cpio",
	  "application/x-csh": "csh",
	  "application/x-debian-package": "deb",
	  "application/x-dgc-compressed": "dgc",
	  "application/x-director": "dir",
	  "application/x-doom": "wad",
	  "application/x-dtbncx+xml": "ncx",
	  "application/x-dtbook+xml": "dtb",
	  "application/x-dtbresource+xml": "res",
	  "application/x-dvi": "dvi",
	  "application/x-envoy": "evy",
	  "application/x-eva": "eva",
	  "application/x-font-bdf": "bdf",
	  "application/x-font-ghostscript": "gsf",
	  "application/x-font-linux-psf": "psf",
	  "application/x-font-otf": "otf",
	  "application/x-font-pcf": "pcf",
	  "application/x-font-snf": "snf",
	  "application/x-font-ttf": "ttf",
	  "application/x-font-type1": "pfa",
	  "application/x-font-woff": "woff",
	  "application/x-freearc": "arc",
	  "application/x-futuresplash": "spl",
	  "application/x-gca-compressed": "gca",
	  "application/x-glulx": "ulx",
	  "application/x-gnumeric": "gnumeric",
	  "application/x-gramps-xml": "gramps",
	  "application/x-gtar": "gtar",
	  "application/x-hdf": "hdf",
	  "application/x-install-instructions": "install",
	  "application/x-iso9660-image": "iso",
	  "application/x-java-jnlp-file": "jnlp",
	  "application/x-latex": "latex",
	  "application/x-lzh-compressed": "lzh",
	  "application/x-mie": "mie",
	  "application/x-mobipocket-ebook": "prc",
	  "application/x-ms-application": "application",
	  "application/x-ms-shortcut": "lnk",
	  "application/x-ms-wmd": "wmd",
	  "application/x-ms-wmz": "wmz",
	  "application/x-ms-xbap": "xbap",
	  "application/x-msaccess": "mdb",
	  "application/x-msbinder": "obd",
	  "application/x-mscardfile": "crd",
	  "application/x-msclip": "clp",
	  "application/x-msdownload": "exe",
	  "application/x-msmediaview": "mvb",
	  "application/x-msmetafile": "wmf",
	  "application/x-msmoney": "mny",
	  "application/x-mspublisher": "pub",
	  "application/x-msschedule": "scd",
	  "application/x-msterminal": "trm",
	  "application/x-mswrite": "wri",
	  "application/x-netcdf": "nc",
	  "application/x-nzb": "nzb",
	  "application/x-pkcs12": "p12",
	  "application/x-pkcs7-certificates": "p7b",
	  "application/x-pkcs7-certreqresp": "p7r",
	  "application/x-rar-compressed": "rar",
	  "application/x-research-info-systems": "ris",
	  "application/x-sh": "sh",
	  "application/x-shar": "shar",
	  "application/x-shockwave-flash": "swf",
	  "application/x-silverlight-app": "xap",
	  "application/x-sql": "sql",
	  "application/x-stuffit": "sit",
	  "application/x-stuffitx": "sitx",
	  "application/x-subrip": "srt",
	  "application/x-sv4cpio": "sv4cpio",
	  "application/x-sv4crc": "sv4crc",
	  "application/x-t3vm-image": "t3",
	  "application/x-tads": "gam",
	  "application/x-tar": "tar",
	  "application/x-tcl": "tcl",
	  "application/x-tex": "tex",
	  "application/x-tex-tfm": "tfm",
	  "application/x-texinfo": "texinfo",
	  "application/x-tgif": "obj",
	  "application/x-ustar": "ustar",
	  "application/x-wais-source": "src",
	  "application/x-x509-ca-cert": "der",
	  "application/x-xfig": "fig",
	  "application/x-xliff+xml": "xlf",
	  "application/x-xpinstall": "xpi",
	  "application/x-xz": "xz",
	  "application/x-zmachine": "z1",
	  "application/xaml+xml": "xaml",
	  "application/xcap-diff+xml": "xdf",
	  "application/xenc+xml": "xenc",
	  "application/xhtml+xml": "xhtml",
	  "application/xml": "xml",
	  "application/xml-dtd": "dtd",
	  "application/xop+xml": "xop",
	  "application/xproc+xml": "xpl",
	  "application/xslt+xml": "xslt",
	  "application/xspf+xml": "xspf",
	  "application/xv+xml": "mxml",
	  "application/yang": "yang",
	  "application/yin+xml": "yin",
	  "application/zip": "zip",
	  "audio/adpcm": "adp",
	  "audio/basic": "au",
	  "audio/midi": "mid",
	  "audio/mp4": "mp4a",
	  "audio/mpeg": "mpga",
	  "audio/ogg": "oga",
	  "audio/s3m": "s3m",
	  "audio/silk": "sil",
	  "audio/vnd.dece.audio": "uva",
	  "audio/vnd.digital-winds": "eol",
	  "audio/vnd.dra": "dra",
	  "audio/vnd.dts": "dts",
	  "audio/vnd.dts.hd": "dtshd",
	  "audio/vnd.lucent.voice": "lvp",
	  "audio/vnd.ms-playready.media.pya": "pya",
	  "audio/vnd.nuera.ecelp4800": "ecelp4800",
	  "audio/vnd.nuera.ecelp7470": "ecelp7470",
	  "audio/vnd.nuera.ecelp9600": "ecelp9600",
	  "audio/vnd.rip": "rip",
	  "audio/webm": "weba",
	  "audio/x-aac": "aac",
	  "audio/x-aiff": "aif",
	  "audio/x-caf": "caf",
	  "audio/x-flac": "flac",
	  "audio/x-matroska": "mka",
	  "audio/x-mpegurl": "m3u",
	  "audio/x-ms-wax": "wax",
	  "audio/x-ms-wma": "wma",
	  "audio/x-pn-realaudio": "ram",
	  "audio/x-pn-realaudio-plugin": "rmp",
	  "audio/x-wav": "wav",
	  "audio/xm": "xm",
	  "chemical/x-cdx": "cdx",
	  "chemical/x-cif": "cif",
	  "chemical/x-cmdf": "cmdf",
	  "chemical/x-cml": "cml",
	  "chemical/x-csml": "csml",
	  "chemical/x-xyz": "xyz",
	  "image/bmp": "bmp",
	  "image/cgm": "cgm",
	  "image/g3fax": "g3",
	  "image/gif": "gif",
	  "image/ief": "ief",
	  "image/jpeg": "jpeg",
	  "image/ktx": "ktx",
	  "image/png": "png",
	  "image/prs.btif": "btif",
	  "image/sgi": "sgi",
	  "image/svg+xml": "svg",
	  "image/tiff": "tiff",
	  "image/vnd.adobe.photoshop": "psd",
	  "image/vnd.dece.graphic": "uvi",
	  "image/vnd.dvb.subtitle": "sub",
	  "image/vnd.djvu": "djvu",
	  "image/vnd.dwg": "dwg",
	  "image/vnd.dxf": "dxf",
	  "image/vnd.fastbidsheet": "fbs",
	  "image/vnd.fpx": "fpx",
	  "image/vnd.fst": "fst",
	  "image/vnd.fujixerox.edmics-mmr": "mmr",
	  "image/vnd.fujixerox.edmics-rlc": "rlc",
	  "image/vnd.ms-modi": "mdi",
	  "image/vnd.ms-photo": "wdp",
	  "image/vnd.net-fpx": "npx",
	  "image/vnd.wap.wbmp": "wbmp",
	  "image/vnd.xiff": "xif",
	  "image/webp": "webp",
	  "image/x-3ds": "3ds",
	  "image/x-cmu-raster": "ras",
	  "image/x-cmx": "cmx",
	  "image/x-freehand": "fh",
	  "image/x-icon": "ico",
	  "image/x-mrsid-image": "sid",
	  "image/x-pcx": "pcx",
	  "image/x-pict": "pic",
	  "image/x-portable-anymap": "pnm",
	  "image/x-portable-bitmap": "pbm",
	  "image/x-portable-graymap": "pgm",
	  "image/x-portable-pixmap": "ppm",
	  "image/x-rgb": "rgb",
	  "image/x-tga": "tga",
	  "image/x-xbitmap": "xbm",
	  "image/x-xpixmap": "xpm",
	  "image/x-xwindowdump": "xwd",
	  "message/rfc822": "eml",
	  "model/iges": "igs",
	  "model/mesh": "msh",
	  "model/vnd.collada+xml": "dae",
	  "model/vnd.dwf": "dwf",
	  "model/vnd.gdl": "gdl",
	  "model/vnd.gtw": "gtw",
	  "model/vnd.mts": "mts",
	  "model/vnd.vtu": "vtu",
	  "model/vrml": "wrl",
	  "model/x3d+binary": "x3db",
	  "model/x3d+vrml": "x3dv",
	  "model/x3d+xml": "x3d",
	  "text/cache-manifest": "appcache",
	  "text/calendar": "ics",
	  "text/css": "css",
	  "text/csv": "csv",
	  "text/html": "html",
	  "text/n3": "n3",
	  "text/plain": "txt",
	  "text/prs.lines.tag": "dsc",
	  "text/richtext": "rtx",
	  "text/sgml": "sgml",
	  "text/tab-separated-values": "tsv",
	  "text/troff": "t",
	  "text/turtle": "ttl",
	  "text/uri-list": "uri",
	  "text/vcard": "vcard",
	  "text/vnd.curl": "curl",
	  "text/vnd.curl.dcurl": "dcurl",
	  "text/vnd.curl.scurl": "scurl",
	  "text/vnd.curl.mcurl": "mcurl",
	  "text/vnd.dvb.subtitle": "sub",
	  "text/vnd.fly": "fly",
	  "text/vnd.fmi.flexstor": "flx",
	  "text/vnd.graphviz": "gv",
	  "text/vnd.in3d.3dml": "3dml",
	  "text/vnd.in3d.spot": "spot",
	  "text/vnd.sun.j2me.app-descriptor": "jad",
	  "text/vnd.wap.wml": "wml",
	  "text/vnd.wap.wmlscript": "wmls",
	  "text/x-asm": "s",
	  "text/x-c": "c",
	  "text/x-fortran": "f",
	  "text/x-java-source": "java",
	  "text/x-opml": "opml",
	  "text/x-pascal": "p",
	  "text/x-nfo": "nfo",
	  "text/x-setext": "etx",
	  "text/x-sfv": "sfv",
	  "text/x-uuencode": "uu",
	  "text/x-vcalendar": "vcs",
	  "text/x-vcard": "vcf",
	  "video/3gpp": "3gp",
	  "video/3gpp2": "3g2",
	  "video/h261": "h261",
	  "video/h263": "h263",
	  "video/h264": "h264",
	  "video/jpeg": "jpgv",
	  "video/jpm": "jpm",
	  "video/mj2": "mj2",
	  "video/mp4": "mp4",
	  "video/mpeg": "mpeg",
	  "video/ogg": "ogv",
	  "video/quicktime": "qt",
	  "video/vnd.dece.hd": "uvh",
	  "video/vnd.dece.mobile": "uvm",
	  "video/vnd.dece.pd": "uvp",
	  "video/vnd.dece.sd": "uvs",
	  "video/vnd.dece.video": "uvv",
	  "video/vnd.dvb.file": "dvb",
	  "video/vnd.fvt": "fvt",
	  "video/vnd.mpegurl": "mxu",
	  "video/vnd.ms-playready.media.pyv": "pyv",
	  "video/vnd.uvvu.mp4": "uvu",
	  "video/vnd.vivo": "viv",
	  "video/webm": "webm",
	  "video/x-f4v": "f4v",
	  "video/x-fli": "fli",
	  "video/x-flv": "flv",
	  "video/x-m4v": "m4v",
	  "video/x-matroska": "mkv",
	  "video/x-mng": "mng",
	  "video/x-ms-asf": "asf",
	  "video/x-ms-vob": "vob",
	  "video/x-ms-wm": "wm",
	  "video/x-ms-wmv": "wmv",
	  "video/x-ms-wmx": "wmx",
	  "video/x-ms-wvx": "wvx",
	  "video/x-msvideo": "avi",
	  "video/x-sgi-movie": "movie",
	  "video/x-smv": "smv",
	  "x-conference/x-cooltalk": "ice",
	  "text/vtt": "vtt",
	  "application/x-chrome-extension": "crx",
	  "text/x-component": "htc",
	  "video/MP2T": "ts",
	  "text/event-stream": "event-stream",
	  "application/x-web-app-manifest+json": "webapp",
	  "text/x-lua": "lua",
	  "application/x-lua-bytecode": "luac",
	  "text/x-markdown": "markdown"
	}
	  , extension: function (mimeType) {
	  var type = mimeType.match(/^\s*([^;\s]*)(?:;|\s|$)/)[1].toLowerCase();
	  return this.extensions[type];
	}
	  , define: function (map) {
	  for (var type in map) {
	    var exts = map[type];
	
	    for (var i = 0; i < exts.length; i++) {
	      if (false) {
	        console.warn(this._loading.replace(/.*\//, ''), 'changes "' + exts[i] + '" extension type from ' +
	          this.types[exts] + ' to ' + type);
	      }
	
	      this.types[exts[i]] = type;
	    }
	
	    // Default extension is the first one we encounter
	    if (!this.extensions[type]) {
	      this.extensions[type] = exts[0];
	    }
	  }
	}
	  , charsets: {lookup: function (mimeType, fallback) {
	    // Assume text types are utf8
	    return (/^text\//).test(mimeType) ? 'UTF-8' : fallback;
	  }}
	}
	mime.types.constructor = undefined
	mime.extensions.constructor = undefined

/***/ },
/* 344 */
/***/ function(module, exports) {

	module.exports = {
	  "100": "Continue",
	  "101": "Switching Protocols",
	  "102": "Processing",
	  "200": "OK",
	  "201": "Created",
	  "202": "Accepted",
	  "203": "Non-Authoritative Information",
	  "204": "No Content",
	  "205": "Reset Content",
	  "206": "Partial Content",
	  "207": "Multi-Status",
	  "208": "Already Reported",
	  "226": "IM Used",
	  "300": "Multiple Choices",
	  "301": "Moved Permanently",
	  "302": "Found",
	  "303": "See Other",
	  "304": "Not Modified",
	  "305": "Use Proxy",
	  "307": "Temporary Redirect",
	  "308": "Permanent Redirect",
	  "400": "Bad Request",
	  "401": "Unauthorized",
	  "402": "Payment Required",
	  "403": "Forbidden",
	  "404": "Not Found",
	  "405": "Method Not Allowed",
	  "406": "Not Acceptable",
	  "407": "Proxy Authentication Required",
	  "408": "Request Timeout",
	  "409": "Conflict",
	  "410": "Gone",
	  "411": "Length Required",
	  "412": "Precondition Failed",
	  "413": "Payload Too Large",
	  "414": "URI Too Long",
	  "415": "Unsupported Media Type",
	  "416": "Range Not Satisfiable",
	  "417": "Expectation Failed",
	  "418": "I'm a teapot",
	  "421": "Misdirected Request",
	  "422": "Unprocessable Entity",
	  "423": "Locked",
	  "424": "Failed Dependency",
	  "425": "Unordered Collection",
	  "426": "Upgrade Required",
	  "428": "Precondition Required",
	  "429": "Too Many Requests",
	  "431": "Request Header Fields Too Large",
	  "451": "Unavailable For Legal Reasons",
	  "500": "Internal Server Error",
	  "501": "Not Implemented",
	  "502": "Bad Gateway",
	  "503": "Service Unavailable",
	  "504": "Gateway Timeout",
	  "505": "HTTP Version Not Supported",
	  "506": "Variant Also Negotiates",
	  "507": "Insufficient Storage",
	  "508": "Loop Detected",
	  "509": "Bandwidth Limit Exceeded",
	  "510": "Not Extended",
	  "511": "Network Authentication Required"
	}


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(9);
	var factory = __webpack_require__(155);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(156)
	
	var zeroBuffer = new Buffer(128)
	zeroBuffer.fill(0)
	
	module.exports = Hmac
	
	function Hmac (alg, key) {
	  if(!(this instanceof Hmac)) return new Hmac(alg, key)
	  this._opad = opad
	  this._alg = alg
	
	  var blocksize = (alg === 'sha512') ? 128 : 64
	
	  key = this._key = !Buffer.isBuffer(key) ? new Buffer(key) : key
	
	  if(key.length > blocksize) {
	    key = createHash(alg).update(key).digest()
	  } else if(key.length < blocksize) {
	    key = Buffer.concat([key, zeroBuffer], blocksize)
	  }
	
	  var ipad = this._ipad = new Buffer(blocksize)
	  var opad = this._opad = new Buffer(blocksize)
	
	  for(var i = 0; i < blocksize; i++) {
	    ipad[i] = key[i] ^ 0x36
	    opad[i] = key[i] ^ 0x5C
	  }
	
	  this._hash = createHash(alg).update(ipad)
	}
	
	Hmac.prototype.update = function (data, enc) {
	  this._hash.update(data, enc)
	  return this
	}
	
	Hmac.prototype.digest = function (enc) {
	  var h = this._hash.digest()
	  return createHash(this._alg).update(this._opad).update(h).digest(enc)
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var intSize = 4;
	var zeroBuffer = new Buffer(intSize); zeroBuffer.fill(0);
	var chrsz = 8;
	
	function toArray(buf, bigEndian) {
	  if ((buf.length % intSize) !== 0) {
	    var len = buf.length + (intSize - (buf.length % intSize));
	    buf = Buffer.concat([buf, zeroBuffer], len);
	  }
	
	  var arr = [];
	  var fn = bigEndian ? buf.readInt32BE : buf.readInt32LE;
	  for (var i = 0; i < buf.length; i += intSize) {
	    arr.push(fn.call(buf, i));
	  }
	  return arr;
	}
	
	function toBuffer(arr, size, bigEndian) {
	  var buf = new Buffer(size);
	  var fn = bigEndian ? buf.writeInt32BE : buf.writeInt32LE;
	  for (var i = 0; i < arr.length; i++) {
	    fn.call(buf, arr[i], i * 4, true);
	  }
	  return buf;
	}
	
	function hash(buf, fn, hashSize, bigEndian) {
	  if (!Buffer.isBuffer(buf)) buf = new Buffer(buf);
	  var arr = fn(toArray(buf, bigEndian), buf.length * chrsz);
	  return toBuffer(arr, hashSize, bigEndian);
	}
	
	module.exports = { hash: hash };
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	
	var helpers = __webpack_require__(347);
	
	/*
	 * Calculate the MD5 of an array of little-endian words, and a bit length
	 */
	function core_md5(x, len)
	{
	  /* append padding */
	  x[len >> 5] |= 0x80 << ((len) % 32);
	  x[(((len + 64) >>> 9) << 4) + 14] = len;
	
	  var a =  1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d =  271733878;
	
	  for(var i = 0; i < x.length; i += 16)
	  {
	    var olda = a;
	    var oldb = b;
	    var oldc = c;
	    var oldd = d;
	
	    a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
	    d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
	    c = md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
	    b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
	    a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
	    d = md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
	    c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
	    b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
	    a = md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
	    d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
	    c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
	    b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
	    a = md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
	    d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
	    c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
	    b = md5_ff(b, c, d, a, x[i+15], 22,  1236535329);
	
	    a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
	    d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
	    c = md5_gg(c, d, a, b, x[i+11], 14,  643717713);
	    b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
	    a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
	    d = md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
	    c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
	    b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
	    a = md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
	    d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
	    c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
	    b = md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
	    a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
	    d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
	    c = md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
	    b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);
	
	    a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
	    d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
	    c = md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
	    b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
	    a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
	    d = md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
	    c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
	    b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
	    a = md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
	    d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
	    c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
	    b = md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
	    a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
	    d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
	    c = md5_hh(c, d, a, b, x[i+15], 16,  530742520);
	    b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);
	
	    a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
	    d = md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
	    c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
	    b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
	    a = md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
	    d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
	    c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
	    b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
	    a = md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
	    d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
	    c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
	    b = md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
	    a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
	    d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
	    c = md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
	    b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);
	
	    a = safe_add(a, olda);
	    b = safe_add(b, oldb);
	    c = safe_add(c, oldc);
	    d = safe_add(d, oldd);
	  }
	  return Array(a, b, c, d);
	
	}
	
	/*
	 * These functions implement the four basic operations the algorithm uses.
	 */
	function md5_cmn(q, a, b, x, s, t)
	{
	  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s),b);
	}
	function md5_ff(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
	}
	function md5_gg(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
	}
	function md5_hh(a, b, c, d, x, s, t)
	{
	  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
	}
	function md5_ii(a, b, c, d, x, s, t)
	{
	  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
	}
	
	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	function safe_add(x, y)
	{
	  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return (msw << 16) | (lsw & 0xFFFF);
	}
	
	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	function bit_rol(num, cnt)
	{
	  return (num << cnt) | (num >>> (32 - cnt));
	}
	
	module.exports = function md5(buf) {
	  return helpers.hash(buf, core_md5, 16);
	};


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	var pbkdf2Export = __webpack_require__(389)
	
	module.exports = function (crypto, exports) {
	  exports = exports || {}
	
	  var exported = pbkdf2Export(crypto)
	
	  exports.pbkdf2 = exported.pbkdf2
	  exports.pbkdf2Sync = exported.pbkdf2Sync
	
	  return exports
	}


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, Buffer) {(function() {
	  var g = ('undefined' === typeof window ? global : window) || {}
	  _crypto = (
	    g.crypto || g.msCrypto || __webpack_require__(595)
	  )
	  module.exports = function(size) {
	    // Modern Browsers
	    if(_crypto.getRandomValues) {
	      var bytes = new Buffer(size); //in browserify, this is an extended Uint8Array
	      /* This will not work in older browsers.
	       * See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
	       */
	    
	      _crypto.getRandomValues(bytes);
	      return bytes;
	    }
	    else if (_crypto.randomBytes) {
	      return _crypto.randomBytes(size)
	    }
	    else
	      throw new Error(
	        'secure random number generation not supported by this browser\n'+
	        'use chrome, FireFox or Internet Explorer 11'
	      )
	  }
	}())
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(2).Buffer))

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(387);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * https://github.com/es-shims/es5-shim
	 * @license es5-shim Copyright 2009-2015 by contributors, MIT License
	 * see https://github.com/es-shims/es5-shim/blob/master/LICENSE
	 */
	
	// vim: ts=4 sts=4 sw=4 expandtab
	
	// Add semicolon to prevent IIFE from being passed as argument to concatenated code.
	;
	
	// UMD (Universal Module Definition)
	// see https://github.com/umdjs/umd/blob/master/templates/returnExports.js
	(function (root, factory) {
	    'use strict';
	
	    /* global define, exports, module */
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        // Node. Does not work with strict CommonJS, but
	        // only CommonJS-like enviroments that support module.exports,
	        // like Node.
	        module.exports = factory();
	    } else {
	        // Browser globals (root is window)
	        root.returnExports = factory();
	    }
	}(this, function () {
	    /**
	     * Brings an environment as close to ECMAScript 5 compliance
	     * as is possible with the facilities of erstwhile engines.
	     *
	     * Annotated ES5: http://es5.github.com/ (specific links below)
	     * ES5 Spec: http://www.ecma-international.org/publications/files/ECMA-ST/Ecma-262.pdf
	     * Required reading: http://javascriptweblog.wordpress.com/2011/12/05/extending-javascript-natives/
	     */
	
	    // Shortcut to an often accessed properties, in order to avoid multiple
	    // dereference that costs universally. This also holds a reference to known-good
	    // functions.
	    var $Array = Array;
	    var ArrayPrototype = $Array.prototype;
	    var $Object = Object;
	    var ObjectPrototype = $Object.prototype;
	    var $Function = Function;
	    var FunctionPrototype = $Function.prototype;
	    var $String = String;
	    var StringPrototype = $String.prototype;
	    var $Number = Number;
	    var NumberPrototype = $Number.prototype;
	    var array_slice = ArrayPrototype.slice;
	    var array_splice = ArrayPrototype.splice;
	    var array_push = ArrayPrototype.push;
	    var array_unshift = ArrayPrototype.unshift;
	    var array_concat = ArrayPrototype.concat;
	    var array_join = ArrayPrototype.join;
	    var call = FunctionPrototype.call;
	    var apply = FunctionPrototype.apply;
	    var max = Math.max;
	    var min = Math.min;
	
	    // Having a toString local variable name breaks in Opera so use to_string.
	    var to_string = ObjectPrototype.toString;
	
	    /* global Symbol */
	    /* eslint-disable one-var-declaration-per-line, no-redeclare, max-statements-per-line */
	    var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	    var isCallable; /* inlined from https://npmjs.com/is-callable */ var fnToStr = Function.prototype.toString, constructorRegex = /^\s*class /, isES6ClassFn = function isES6ClassFn(value) { try { var fnStr = fnToStr.call(value); var singleStripped = fnStr.replace(/\/\/.*\n/g, ''); var multiStripped = singleStripped.replace(/\/\*[.\s\S]*\*\//g, ''); var spaceStripped = multiStripped.replace(/\n/mg, ' ').replace(/ {2}/g, ' '); return constructorRegex.test(spaceStripped); } catch (e) { return false; /* not a function */ } }, tryFunctionObject = function tryFunctionObject(value) { try { if (isES6ClassFn(value)) { return false; } fnToStr.call(value); return true; } catch (e) { return false; } }, fnClass = '[object Function]', genClass = '[object GeneratorFunction]', isCallable = function isCallable(value) { if (!value) { return false; } if (typeof value !== 'function' && typeof value !== 'object') { return false; } if (hasToStringTag) { return tryFunctionObject(value); } if (isES6ClassFn(value)) { return false; } var strClass = to_string.call(value); return strClass === fnClass || strClass === genClass; };
	
	    var isRegex; /* inlined from https://npmjs.com/is-regex */ var regexExec = RegExp.prototype.exec, tryRegexExec = function tryRegexExec(value) { try { regexExec.call(value); return true; } catch (e) { return false; } }, regexClass = '[object RegExp]'; isRegex = function isRegex(value) { if (typeof value !== 'object') { return false; } return hasToStringTag ? tryRegexExec(value) : to_string.call(value) === regexClass; };
	    var isString; /* inlined from https://npmjs.com/is-string */ var strValue = String.prototype.valueOf, tryStringObject = function tryStringObject(value) { try { strValue.call(value); return true; } catch (e) { return false; } }, stringClass = '[object String]'; isString = function isString(value) { if (typeof value === 'string') { return true; } if (typeof value !== 'object') { return false; } return hasToStringTag ? tryStringObject(value) : to_string.call(value) === stringClass; };
	    /* eslint-enable one-var-declaration-per-line, no-redeclare, max-statements-per-line */
	
	    /* inlined from http://npmjs.com/define-properties */
	    var supportsDescriptors = $Object.defineProperty && (function () {
	        try {
	            var obj = {};
	            $Object.defineProperty(obj, 'x', { enumerable: false, value: obj });
	            for (var _ in obj) { // jscs:ignore disallowUnusedVariables
	                return false;
	            }
	            return obj.x === obj;
	        } catch (e) { /* this is ES3 */
	            return false;
	        }
	    }());
	    var defineProperties = (function (has) {
	        // Define configurable, writable, and non-enumerable props
	        // if they don't exist.
	        var defineProperty;
	        if (supportsDescriptors) {
	            defineProperty = function (object, name, method, forceAssign) {
	                if (!forceAssign && (name in object)) {
	                    return;
	                }
	                $Object.defineProperty(object, name, {
	                    configurable: true,
	                    enumerable: false,
	                    writable: true,
	                    value: method
	                });
	            };
	        } else {
	            defineProperty = function (object, name, method, forceAssign) {
	                if (!forceAssign && (name in object)) {
	                    return;
	                }
	                object[name] = method;
	            };
	        }
	        return function defineProperties(object, map, forceAssign) {
	            for (var name in map) {
	                if (has.call(map, name)) {
	                    defineProperty(object, name, map[name], forceAssign);
	                }
	            }
	        };
	    }(ObjectPrototype.hasOwnProperty));
	
	    //
	    // Util
	    // ======
	    //
	
	    /* replaceable with https://npmjs.com/package/es-abstract /helpers/isPrimitive */
	    var isPrimitive = function isPrimitive(input) {
	        var type = typeof input;
	        return input === null || (type !== 'object' && type !== 'function');
	    };
	
	    var isActualNaN = $Number.isNaN || function isActualNaN(x) {
	        return x !== x;
	    };
	
	    var ES = {
	        // ES5 9.4
	        // http://es5.github.com/#x9.4
	        // http://jsperf.com/to-integer
	        /* replaceable with https://npmjs.com/package/es-abstract ES5.ToInteger */
	        ToInteger: function ToInteger(num) {
	            var n = +num;
	            if (isActualNaN(n)) {
	                n = 0;
	            } else if (n !== 0 && n !== (1 / 0) && n !== -(1 / 0)) {
	                n = (n > 0 || -1) * Math.floor(Math.abs(n));
	            }
	            return n;
	        },
	
	        /* replaceable with https://npmjs.com/package/es-abstract ES5.ToPrimitive */
	        ToPrimitive: function ToPrimitive(input) {
	            var val, valueOf, toStr;
	            if (isPrimitive(input)) {
	                return input;
	            }
	            valueOf = input.valueOf;
	            if (isCallable(valueOf)) {
	                val = valueOf.call(input);
	                if (isPrimitive(val)) {
	                    return val;
	                }
	            }
	            toStr = input.toString;
	            if (isCallable(toStr)) {
	                val = toStr.call(input);
	                if (isPrimitive(val)) {
	                    return val;
	                }
	            }
	            throw new TypeError();
	        },
	
	        // ES5 9.9
	        // http://es5.github.com/#x9.9
	        /* replaceable with https://npmjs.com/package/es-abstract ES5.ToObject */
	        ToObject: function (o) {
	            if (o == null) { // this matches both null and undefined
	                throw new TypeError("can't convert " + o + ' to object');
	            }
	            return $Object(o);
	        },
	
	        /* replaceable with https://npmjs.com/package/es-abstract ES5.ToUint32 */
	        ToUint32: function ToUint32(x) {
	            return x >>> 0;
	        }
	    };
	
	    //
	    // Function
	    // ========
	    //
	
	    // ES-5 15.3.4.5
	    // http://es5.github.com/#x15.3.4.5
	
	    var Empty = function Empty() {};
	
	    defineProperties(FunctionPrototype, {
	        bind: function bind(that) { // .length is 1
	            // 1. Let Target be the this value.
	            var target = this;
	            // 2. If IsCallable(Target) is false, throw a TypeError exception.
	            if (!isCallable(target)) {
	                throw new TypeError('Function.prototype.bind called on incompatible ' + target);
	            }
	            // 3. Let A be a new (possibly empty) internal list of all of the
	            //   argument values provided after thisArg (arg1, arg2 etc), in order.
	            // XXX slicedArgs will stand in for "A" if used
	            var args = array_slice.call(arguments, 1); // for normal call
	            // 4. Let F be a new native ECMAScript object.
	            // 11. Set the [[Prototype]] internal property of F to the standard
	            //   built-in Function prototype object as specified in 15.3.3.1.
	            // 12. Set the [[Call]] internal property of F as described in
	            //   15.3.4.5.1.
	            // 13. Set the [[Construct]] internal property of F as described in
	            //   15.3.4.5.2.
	            // 14. Set the [[HasInstance]] internal property of F as described in
	            //   15.3.4.5.3.
	            var bound;
	            var binder = function () {
	
	                if (this instanceof bound) {
	                    // 15.3.4.5.2 [[Construct]]
	                    // When the [[Construct]] internal method of a function object,
	                    // F that was created using the bind function is called with a
	                    // list of arguments ExtraArgs, the following steps are taken:
	                    // 1. Let target be the value of F's [[TargetFunction]]
	                    //   internal property.
	                    // 2. If target has no [[Construct]] internal method, a
	                    //   TypeError exception is thrown.
	                    // 3. Let boundArgs be the value of F's [[BoundArgs]] internal
	                    //   property.
	                    // 4. Let args be a new list containing the same values as the
	                    //   list boundArgs in the same order followed by the same
	                    //   values as the list ExtraArgs in the same order.
	                    // 5. Return the result of calling the [[Construct]] internal
	                    //   method of target providing args as the arguments.
	
	                    var result = apply.call(
	                        target,
	                        this,
	                        array_concat.call(args, array_slice.call(arguments))
	                    );
	                    if ($Object(result) === result) {
	                        return result;
	                    }
	                    return this;
	
	                } else {
	                    // 15.3.4.5.1 [[Call]]
	                    // When the [[Call]] internal method of a function object, F,
	                    // which was created using the bind function is called with a
	                    // this value and a list of arguments ExtraArgs, the following
	                    // steps are taken:
	                    // 1. Let boundArgs be the value of F's [[BoundArgs]] internal
	                    //   property.
	                    // 2. Let boundThis be the value of F's [[BoundThis]] internal
	                    //   property.
	                    // 3. Let target be the value of F's [[TargetFunction]] internal
	                    //   property.
	                    // 4. Let args be a new list containing the same values as the
	                    //   list boundArgs in the same order followed by the same
	                    //   values as the list ExtraArgs in the same order.
	                    // 5. Return the result of calling the [[Call]] internal method
	                    //   of target providing boundThis as the this value and
	                    //   providing args as the arguments.
	
	                    // equiv: target.call(this, ...boundArgs, ...args)
	                    return apply.call(
	                        target,
	                        that,
	                        array_concat.call(args, array_slice.call(arguments))
	                    );
	
	                }
	
	            };
	
	            // 15. If the [[Class]] internal property of Target is "Function", then
	            //     a. Let L be the length property of Target minus the length of A.
	            //     b. Set the length own property of F to either 0 or L, whichever is
	            //       larger.
	            // 16. Else set the length own property of F to 0.
	
	            var boundLength = max(0, target.length - args.length);
	
	            // 17. Set the attributes of the length own property of F to the values
	            //   specified in 15.3.5.1.
	            var boundArgs = [];
	            for (var i = 0; i < boundLength; i++) {
	                array_push.call(boundArgs, '$' + i);
	            }
	
	            // XXX Build a dynamic function with desired amount of arguments is the only
	            // way to set the length property of a function.
	            // In environments where Content Security Policies enabled (Chrome extensions,
	            // for ex.) all use of eval or Function costructor throws an exception.
	            // However in all of these environments Function.prototype.bind exists
	            // and so this code will never be executed.
	            bound = $Function('binder', 'return function (' + array_join.call(boundArgs, ',') + '){ return binder.apply(this, arguments); }')(binder);
	
	            if (target.prototype) {
	                Empty.prototype = target.prototype;
	                bound.prototype = new Empty();
	                // Clean up dangling references.
	                Empty.prototype = null;
	            }
	
	            // TODO
	            // 18. Set the [[Extensible]] internal property of F to true.
	
	            // TODO
	            // 19. Let thrower be the [[ThrowTypeError]] function Object (13.2.3).
	            // 20. Call the [[DefineOwnProperty]] internal method of F with
	            //   arguments "caller", PropertyDescriptor {[[Get]]: thrower, [[Set]]:
	            //   thrower, [[Enumerable]]: false, [[Configurable]]: false}, and
	            //   false.
	            // 21. Call the [[DefineOwnProperty]] internal method of F with
	            //   arguments "arguments", PropertyDescriptor {[[Get]]: thrower,
	            //   [[Set]]: thrower, [[Enumerable]]: false, [[Configurable]]: false},
	            //   and false.
	
	            // TODO
	            // NOTE Function objects created using Function.prototype.bind do not
	            // have a prototype property or the [[Code]], [[FormalParameters]], and
	            // [[Scope]] internal properties.
	            // XXX can't delete prototype in pure-js.
	
	            // 22. Return F.
	            return bound;
	        }
	    });
	
	    // _Please note: Shortcuts are defined after `Function.prototype.bind` as we
	    // use it in defining shortcuts.
	    var owns = call.bind(ObjectPrototype.hasOwnProperty);
	    var toStr = call.bind(ObjectPrototype.toString);
	    var arraySlice = call.bind(array_slice);
	    var arraySliceApply = apply.bind(array_slice);
	    /* globals document */
	    if (typeof document === 'object' && document && document.documentElement) {
	        try {
	            arraySlice(document.documentElement.childNodes);
	        } catch (e) {
	            var origArraySlice = arraySlice;
	            var origArraySliceApply = arraySliceApply;
	            arraySlice = function arraySliceIE(arr) {
	                var r = [];
	                var i = arr.length;
	                while (i-- > 0) {
	                    r[i] = arr[i];
	                }
	                return origArraySliceApply(r, origArraySlice(arguments, 1));
	            };
	            arraySliceApply = function arraySliceApplyIE(arr, args) {
	                return origArraySliceApply(arraySlice(arr), args);
	            };
	        }
	    }
	    var strSlice = call.bind(StringPrototype.slice);
	    var strSplit = call.bind(StringPrototype.split);
	    var strIndexOf = call.bind(StringPrototype.indexOf);
	    var pushCall = call.bind(array_push);
	    var isEnum = call.bind(ObjectPrototype.propertyIsEnumerable);
	    var arraySort = call.bind(ArrayPrototype.sort);
	
	    //
	    // Array
	    // =====
	    //
	
	    var isArray = $Array.isArray || function isArray(obj) {
	        return toStr(obj) === '[object Array]';
	    };
	
	    // ES5 15.4.4.12
	    // http://es5.github.com/#x15.4.4.13
	    // Return len+argCount.
	    // [bugfix, ielt8]
	    // IE < 8 bug: [].unshift(0) === undefined but should be "1"
	    var hasUnshiftReturnValueBug = [].unshift(0) !== 1;
	    defineProperties(ArrayPrototype, {
	        unshift: function () {
	            array_unshift.apply(this, arguments);
	            return this.length;
	        }
	    }, hasUnshiftReturnValueBug);
	
	    // ES5 15.4.3.2
	    // http://es5.github.com/#x15.4.3.2
	    // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/isArray
	    defineProperties($Array, { isArray: isArray });
	
	    // The IsCallable() check in the Array functions
	    // has been replaced with a strict check on the
	    // internal class of the object to trap cases where
	    // the provided function was actually a regular
	    // expression literal, which in V8 and
	    // JavaScriptCore is a typeof "function".  Only in
	    // V8 are regular expression literals permitted as
	    // reduce parameters, so it is desirable in the
	    // general case for the shim to match the more
	    // strict and common behavior of rejecting regular
	    // expressions.
	
	    // ES5 15.4.4.18
	    // http://es5.github.com/#x15.4.4.18
	    // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/array/forEach
	
	    // Check failure of by-index access of string characters (IE < 9)
	    // and failure of `0 in boxedString` (Rhino)
	    var boxedString = $Object('a');
	    var splitString = boxedString[0] !== 'a' || !(0 in boxedString);
	
	    var properlyBoxesContext = function properlyBoxed(method) {
	        // Check node 0.6.21 bug where third parameter is not boxed
	        var properlyBoxesNonStrict = true;
	        var properlyBoxesStrict = true;
	        var threwException = false;
	        if (method) {
	            try {
	                method.call('foo', function (_, __, context) {
	                    if (typeof context !== 'object') {
	                        properlyBoxesNonStrict = false;
	                    }
	                });
	
	                method.call([1], function () {
	                    'use strict';
	
	                    properlyBoxesStrict = typeof this === 'string';
	                }, 'x');
	            } catch (e) {
	                threwException = true;
	            }
	        }
	        return !!method && !threwException && properlyBoxesNonStrict && properlyBoxesStrict;
	    };
	
	    defineProperties(ArrayPrototype, {
	        forEach: function forEach(callbackfn/*, thisArg*/) {
	            var object = ES.ToObject(this);
	            var self = splitString && isString(this) ? strSplit(this, '') : object;
	            var i = -1;
	            var length = ES.ToUint32(self.length);
	            var T;
	            if (arguments.length > 1) {
	                T = arguments[1];
	            }
	
	            // If no callback function or if callback is not a callable function
	            if (!isCallable(callbackfn)) {
	                throw new TypeError('Array.prototype.forEach callback must be a function');
	            }
	
	            while (++i < length) {
	                if (i in self) {
	                    // Invoke the callback function with call, passing arguments:
	                    // context, property value, property key, thisArg object
	                    if (typeof T === 'undefined') {
	                        callbackfn(self[i], i, object);
	                    } else {
	                        callbackfn.call(T, self[i], i, object);
	                    }
	                }
	            }
	        }
	    }, !properlyBoxesContext(ArrayPrototype.forEach));
	
	    // ES5 15.4.4.19
	    // http://es5.github.com/#x15.4.4.19
	    // https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/map
	    defineProperties(ArrayPrototype, {
	        map: function map(callbackfn/*, thisArg*/) {
	            var object = ES.ToObject(this);
	            var self = splitString && isString(this) ? strSplit(this, '') : object;
	            var length = ES.ToUint32(self.length);
	            var result = $Array(length);
	            var T;
	            if (arguments.length > 1) {
	                T = arguments[1];
	            }
	
	            // If no callback function or if callback is not a callable function
	            if (!isCallable(callbackfn)) {
	                throw new TypeError('Array.prototype.map callback must be a function');
	            }
	
	            for (var i = 0; i < length; i++) {
	                if (i in self) {
	                    if (typeof T === 'undefined') {
	                        result[i] = callbackfn(self[i], i, object);
	                    } else {
	                        result[i] = callbackfn.call(T, self[i], i, object);
	                    }
	                }
	            }
	            return result;
	        }
	    }, !properlyBoxesContext(ArrayPrototype.map));
	
	    // ES5 15.4.4.20
	    // http://es5.github.com/#x15.4.4.20
	    // https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/filter
	    defineProperties(ArrayPrototype, {
	        filter: function filter(callbackfn/*, thisArg*/) {
	            var object = ES.ToObject(this);
	            var self = splitString && isString(this) ? strSplit(this, '') : object;
	            var length = ES.ToUint32(self.length);
	            var result = [];
	            var value;
	            var T;
	            if (arguments.length > 1) {
	                T = arguments[1];
	            }
	
	            // If no callback function or if callback is not a callable function
	            if (!isCallable(callbackfn)) {
	                throw new TypeError('Array.prototype.filter callback must be a function');
	            }
	
	            for (var i = 0; i < length; i++) {
	                if (i in self) {
	                    value = self[i];
	                    if (typeof T === 'undefined' ? callbackfn(value, i, object) : callbackfn.call(T, value, i, object)) {
	                        pushCall(result, value);
	                    }
	                }
	            }
	            return result;
	        }
	    }, !properlyBoxesContext(ArrayPrototype.filter));
	
	    // ES5 15.4.4.16
	    // http://es5.github.com/#x15.4.4.16
	    // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/every
	    defineProperties(ArrayPrototype, {
	        every: function every(callbackfn/*, thisArg*/) {
	            var object = ES.ToObject(this);
	            var self = splitString && isString(this) ? strSplit(this, '') : object;
	            var length = ES.ToUint32(self.length);
	            var T;
	            if (arguments.length > 1) {
	                T = arguments[1];
	            }
	
	            // If no callback function or if callback is not a callable function
	            if (!isCallable(callbackfn)) {
	                throw new TypeError('Array.prototype.every callback must be a function');
	            }
	
	            for (var i = 0; i < length; i++) {
	                if (i in self && !(typeof T === 'undefined' ? callbackfn(self[i], i, object) : callbackfn.call(T, self[i], i, object))) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }, !properlyBoxesContext(ArrayPrototype.every));
	
	    // ES5 15.4.4.17
	    // http://es5.github.com/#x15.4.4.17
	    // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/some
	    defineProperties(ArrayPrototype, {
	        some: function some(callbackfn/*, thisArg */) {
	            var object = ES.ToObject(this);
	            var self = splitString && isString(this) ? strSplit(this, '') : object;
	            var length = ES.ToUint32(self.length);
	            var T;
	            if (arguments.length > 1) {
	                T = arguments[1];
	            }
	
	            // If no callback function or if callback is not a callable function
	            if (!isCallable(callbackfn)) {
	                throw new TypeError('Array.prototype.some callback must be a function');
	            }
	
	            for (var i = 0; i < length; i++) {
	                if (i in self && (typeof T === 'undefined' ? callbackfn(self[i], i, object) : callbackfn.call(T, self[i], i, object))) {
	                    return true;
	                }
	            }
	            return false;
	        }
	    }, !properlyBoxesContext(ArrayPrototype.some));
	
	    // ES5 15.4.4.21
	    // http://es5.github.com/#x15.4.4.21
	    // https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/reduce
	    var reduceCoercesToObject = false;
	    if (ArrayPrototype.reduce) {
	        reduceCoercesToObject = typeof ArrayPrototype.reduce.call('es5', function (_, __, ___, list) {
	            return list;
	        }) === 'object';
	    }
	    defineProperties(ArrayPrototype, {
	        reduce: function reduce(callbackfn/*, initialValue*/) {
	            var object = ES.ToObject(this);
	            var self = splitString && isString(this) ? strSplit(this, '') : object;
	            var length = ES.ToUint32(self.length);
	
	            // If no callback function or if callback is not a callable function
	            if (!isCallable(callbackfn)) {
	                throw new TypeError('Array.prototype.reduce callback must be a function');
	            }
	
	            // no value to return if no initial value and an empty array
	            if (length === 0 && arguments.length === 1) {
	                throw new TypeError('reduce of empty array with no initial value');
	            }
	
	            var i = 0;
	            var result;
	            if (arguments.length >= 2) {
	                result = arguments[1];
	            } else {
	                do {
	                    if (i in self) {
	                        result = self[i++];
	                        break;
	                    }
	
	                    // if array contains no values, no initial value to return
	                    if (++i >= length) {
	                        throw new TypeError('reduce of empty array with no initial value');
	                    }
	                } while (true);
	            }
	
	            for (; i < length; i++) {
	                if (i in self) {
	                    result = callbackfn(result, self[i], i, object);
	                }
	            }
	
	            return result;
	        }
	    }, !reduceCoercesToObject);
	
	    // ES5 15.4.4.22
	    // http://es5.github.com/#x15.4.4.22
	    // https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/reduceRight
	    var reduceRightCoercesToObject = false;
	    if (ArrayPrototype.reduceRight) {
	        reduceRightCoercesToObject = typeof ArrayPrototype.reduceRight.call('es5', function (_, __, ___, list) {
	            return list;
	        }) === 'object';
	    }
	    defineProperties(ArrayPrototype, {
	        reduceRight: function reduceRight(callbackfn/*, initial*/) {
	            var object = ES.ToObject(this);
	            var self = splitString && isString(this) ? strSplit(this, '') : object;
	            var length = ES.ToUint32(self.length);
	
	            // If no callback function or if callback is not a callable function
	            if (!isCallable(callbackfn)) {
	                throw new TypeError('Array.prototype.reduceRight callback must be a function');
	            }
	
	            // no value to return if no initial value, empty array
	            if (length === 0 && arguments.length === 1) {
	                throw new TypeError('reduceRight of empty array with no initial value');
	            }
	
	            var result;
	            var i = length - 1;
	            if (arguments.length >= 2) {
	                result = arguments[1];
	            } else {
	                do {
	                    if (i in self) {
	                        result = self[i--];
	                        break;
	                    }
	
	                    // if array contains no values, no initial value to return
	                    if (--i < 0) {
	                        throw new TypeError('reduceRight of empty array with no initial value');
	                    }
	                } while (true);
	            }
	
	            if (i < 0) {
	                return result;
	            }
	
	            do {
	                if (i in self) {
	                    result = callbackfn(result, self[i], i, object);
	                }
	            } while (i--);
	
	            return result;
	        }
	    }, !reduceRightCoercesToObject);
	
	    // ES5 15.4.4.14
	    // http://es5.github.com/#x15.4.4.14
	    // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/indexOf
	    var hasFirefox2IndexOfBug = ArrayPrototype.indexOf && [0, 1].indexOf(1, 2) !== -1;
	    defineProperties(ArrayPrototype, {
	        indexOf: function indexOf(searchElement/*, fromIndex */) {
	            var self = splitString && isString(this) ? strSplit(this, '') : ES.ToObject(this);
	            var length = ES.ToUint32(self.length);
	
	            if (length === 0) {
	                return -1;
	            }
	
	            var i = 0;
	            if (arguments.length > 1) {
	                i = ES.ToInteger(arguments[1]);
	            }
	
	            // handle negative indices
	            i = i >= 0 ? i : max(0, length + i);
	            for (; i < length; i++) {
	                if (i in self && self[i] === searchElement) {
	                    return i;
	                }
	            }
	            return -1;
	        }
	    }, hasFirefox2IndexOfBug);
	
	    // ES5 15.4.4.15
	    // http://es5.github.com/#x15.4.4.15
	    // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/lastIndexOf
	    var hasFirefox2LastIndexOfBug = ArrayPrototype.lastIndexOf && [0, 1].lastIndexOf(0, -3) !== -1;
	    defineProperties(ArrayPrototype, {
	        lastIndexOf: function lastIndexOf(searchElement/*, fromIndex */) {
	            var self = splitString && isString(this) ? strSplit(this, '') : ES.ToObject(this);
	            var length = ES.ToUint32(self.length);
	
	            if (length === 0) {
	                return -1;
	            }
	            var i = length - 1;
	            if (arguments.length > 1) {
	                i = min(i, ES.ToInteger(arguments[1]));
	            }
	            // handle negative indices
	            i = i >= 0 ? i : length - Math.abs(i);
	            for (; i >= 0; i--) {
	                if (i in self && searchElement === self[i]) {
	                    return i;
	                }
	            }
	            return -1;
	        }
	    }, hasFirefox2LastIndexOfBug);
	
	    // ES5 15.4.4.12
	    // http://es5.github.com/#x15.4.4.12
	    var spliceNoopReturnsEmptyArray = (function () {
	        var a = [1, 2];
	        var result = a.splice();
	        return a.length === 2 && isArray(result) && result.length === 0;
	    }());
	    defineProperties(ArrayPrototype, {
	        // Safari 5.0 bug where .splice() returns undefined
	        splice: function splice(start, deleteCount) {
	            if (arguments.length === 0) {
	                return [];
	            } else {
	                return array_splice.apply(this, arguments);
	            }
	        }
	    }, !spliceNoopReturnsEmptyArray);
	
	    var spliceWorksWithEmptyObject = (function () {
	        var obj = {};
	        ArrayPrototype.splice.call(obj, 0, 0, 1);
	        return obj.length === 1;
	    }());
	    defineProperties(ArrayPrototype, {
	        splice: function splice(start, deleteCount) {
	            if (arguments.length === 0) {
	                return [];
	            }
	            var args = arguments;
	            this.length = max(ES.ToInteger(this.length), 0);
	            if (arguments.length > 0 && typeof deleteCount !== 'number') {
	                args = arraySlice(arguments);
	                if (args.length < 2) {
	                    pushCall(args, this.length - start);
	                } else {
	                    args[1] = ES.ToInteger(deleteCount);
	                }
	            }
	            return array_splice.apply(this, args);
	        }
	    }, !spliceWorksWithEmptyObject);
	    var spliceWorksWithLargeSparseArrays = (function () {
	        // Per https://github.com/es-shims/es5-shim/issues/295
	        // Safari 7/8 breaks with sparse arrays of size 1e5 or greater
	        var arr = new $Array(1e5);
	        // note: the index MUST be 8 or larger or the test will false pass
	        arr[8] = 'x';
	        arr.splice(1, 1);
	        // note: this test must be defined *after* the indexOf shim
	        // per https://github.com/es-shims/es5-shim/issues/313
	        return arr.indexOf('x') === 7;
	    }());
	    var spliceWorksWithSmallSparseArrays = (function () {
	        // Per https://github.com/es-shims/es5-shim/issues/295
	        // Opera 12.15 breaks on this, no idea why.
	        var n = 256;
	        var arr = [];
	        arr[n] = 'a';
	        arr.splice(n + 1, 0, 'b');
	        return arr[n] === 'a';
	    }());
	    defineProperties(ArrayPrototype, {
	        splice: function splice(start, deleteCount) {
	            var O = ES.ToObject(this);
	            var A = [];
	            var len = ES.ToUint32(O.length);
	            var relativeStart = ES.ToInteger(start);
	            var actualStart = relativeStart < 0 ? max((len + relativeStart), 0) : min(relativeStart, len);
	            var actualDeleteCount = min(max(ES.ToInteger(deleteCount), 0), len - actualStart);
	
	            var k = 0;
	            var from;
	            while (k < actualDeleteCount) {
	                from = $String(actualStart + k);
	                if (owns(O, from)) {
	                    A[k] = O[from];
	                }
	                k += 1;
	            }
	
	            var items = arraySlice(arguments, 2);
	            var itemCount = items.length;
	            var to;
	            if (itemCount < actualDeleteCount) {
	                k = actualStart;
	                var maxK = len - actualDeleteCount;
	                while (k < maxK) {
	                    from = $String(k + actualDeleteCount);
	                    to = $String(k + itemCount);
	                    if (owns(O, from)) {
	                        O[to] = O[from];
	                    } else {
	                        delete O[to];
	                    }
	                    k += 1;
	                }
	                k = len;
	                var minK = len - actualDeleteCount + itemCount;
	                while (k > minK) {
	                    delete O[k - 1];
	                    k -= 1;
	                }
	            } else if (itemCount > actualDeleteCount) {
	                k = len - actualDeleteCount;
	                while (k > actualStart) {
	                    from = $String(k + actualDeleteCount - 1);
	                    to = $String(k + itemCount - 1);
	                    if (owns(O, from)) {
	                        O[to] = O[from];
	                    } else {
	                        delete O[to];
	                    }
	                    k -= 1;
	                }
	            }
	            k = actualStart;
	            for (var i = 0; i < items.length; ++i) {
	                O[k] = items[i];
	                k += 1;
	            }
	            O.length = len - actualDeleteCount + itemCount;
	
	            return A;
	        }
	    }, !spliceWorksWithLargeSparseArrays || !spliceWorksWithSmallSparseArrays);
	
	    var originalJoin = ArrayPrototype.join;
	    var hasStringJoinBug;
	    try {
	        hasStringJoinBug = Array.prototype.join.call('123', ',') !== '1,2,3';
	    } catch (e) {
	        hasStringJoinBug = true;
	    }
	    if (hasStringJoinBug) {
	        defineProperties(ArrayPrototype, {
	            join: function join(separator) {
	                var sep = typeof separator === 'undefined' ? ',' : separator;
	                return originalJoin.call(isString(this) ? strSplit(this, '') : this, sep);
	            }
	        }, hasStringJoinBug);
	    }
	
	    var hasJoinUndefinedBug = [1, 2].join(undefined) !== '1,2';
	    if (hasJoinUndefinedBug) {
	        defineProperties(ArrayPrototype, {
	            join: function join(separator) {
	                var sep = typeof separator === 'undefined' ? ',' : separator;
	                return originalJoin.call(this, sep);
	            }
	        }, hasJoinUndefinedBug);
	    }
	
	    var pushShim = function push(item) {
	        var O = ES.ToObject(this);
	        var n = ES.ToUint32(O.length);
	        var i = 0;
	        while (i < arguments.length) {
	            O[n + i] = arguments[i];
	            i += 1;
	        }
	        O.length = n + i;
	        return n + i;
	    };
	
	    var pushIsNotGeneric = (function () {
	        var obj = {};
	        var result = Array.prototype.push.call(obj, undefined);
	        return result !== 1 || obj.length !== 1 || typeof obj[0] !== 'undefined' || !owns(obj, 0);
	    }());
	    defineProperties(ArrayPrototype, {
	        push: function push(item) {
	            if (isArray(this)) {
	                return array_push.apply(this, arguments);
	            }
	            return pushShim.apply(this, arguments);
	        }
	    }, pushIsNotGeneric);
	
	    // This fixes a very weird bug in Opera 10.6 when pushing `undefined
	    var pushUndefinedIsWeird = (function () {
	        var arr = [];
	        var result = arr.push(undefined);
	        return result !== 1 || arr.length !== 1 || typeof arr[0] !== 'undefined' || !owns(arr, 0);
	    }());
	    defineProperties(ArrayPrototype, { push: pushShim }, pushUndefinedIsWeird);
	
	    // ES5 15.2.3.14
	    // http://es5.github.io/#x15.4.4.10
	    // Fix boxed string bug
	    defineProperties(ArrayPrototype, {
	        slice: function (start, end) {
	            var arr = isString(this) ? strSplit(this, '') : this;
	            return arraySliceApply(arr, arguments);
	        }
	    }, splitString);
	
	    var sortIgnoresNonFunctions = (function () {
	        try {
	            [1, 2].sort(null);
	        } catch (e) {
	            try {
	                [1, 2].sort({});
	            } catch (e2) {
	                return false;
	            }
	        }
	        return true;
	    }());
	    var sortThrowsOnRegex = (function () {
	        // this is a problem in Firefox 4, in which `typeof /a/ === 'function'`
	        try {
	            [1, 2].sort(/a/);
	            return false;
	        } catch (e) {}
	        return true;
	    }());
	    var sortIgnoresUndefined = (function () {
	        // applies in IE 8, for one.
	        try {
	            [1, 2].sort(undefined);
	            return true;
	        } catch (e) {}
	        return false;
	    }());
	    defineProperties(ArrayPrototype, {
	        sort: function sort(compareFn) {
	            if (typeof compareFn === 'undefined') {
	                return arraySort(this);
	            }
	            if (!isCallable(compareFn)) {
	                throw new TypeError('Array.prototype.sort callback must be a function');
	            }
	            return arraySort(this, compareFn);
	        }
	    }, sortIgnoresNonFunctions || !sortIgnoresUndefined || !sortThrowsOnRegex);
	
	    //
	    // Object
	    // ======
	    //
	
	    // ES5 15.2.3.14
	    // http://es5.github.com/#x15.2.3.14
	
	    // http://whattheheadsaid.com/2010/10/a-safer-object-keys-compatibility-implementation
	    var hasDontEnumBug = !isEnum({ 'toString': null }, 'toString'); // jscs:ignore disallowQuotedKeysInObjects
	    var hasProtoEnumBug = isEnum(function () {}, 'prototype');
	    var hasStringEnumBug = !owns('x', '0');
	    var equalsConstructorPrototype = function (o) {
	        var ctor = o.constructor;
	        return ctor && ctor.prototype === o;
	    };
	    var excludedKeys = {
	        $window: true,
	        $console: true,
	        $parent: true,
	        $self: true,
	        $frame: true,
	        $frames: true,
	        $frameElement: true,
	        $webkitIndexedDB: true,
	        $webkitStorageInfo: true,
	        $external: true,
	        $width: true,
	        $height: true,
	        $top: true,
	        $localStorage: true
	    };
	    var hasAutomationEqualityBug = (function () {
	        /* globals window */
	        if (typeof window === 'undefined') {
	            return false;
	        }
	        for (var k in window) {
	            try {
	                if (!excludedKeys['$' + k] && owns(window, k) && window[k] !== null && typeof window[k] === 'object') {
	                    equalsConstructorPrototype(window[k]);
	                }
	            } catch (e) {
	                return true;
	            }
	        }
	        return false;
	    }());
	    var equalsConstructorPrototypeIfNotBuggy = function (object) {
	        if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
	            return equalsConstructorPrototype(object);
	        }
	        try {
	            return equalsConstructorPrototype(object);
	        } catch (e) {
	            return false;
	        }
	    };
	    var dontEnums = [
	        'toString',
	        'toLocaleString',
	        'valueOf',
	        'hasOwnProperty',
	        'isPrototypeOf',
	        'propertyIsEnumerable',
	        'constructor'
	    ];
	    var dontEnumsLength = dontEnums.length;
	
	    // taken directly from https://github.com/ljharb/is-arguments/blob/master/index.js
	    // can be replaced with require('is-arguments') if we ever use a build process instead
	    var isStandardArguments = function isArguments(value) {
	        return toStr(value) === '[object Arguments]';
	    };
	    var isLegacyArguments = function isArguments(value) {
	        return value !== null
	            && typeof value === 'object'
	            && typeof value.length === 'number'
	            && value.length >= 0
	            && !isArray(value)
	            && isCallable(value.callee);
	    };
	    var isArguments = isStandardArguments(arguments) ? isStandardArguments : isLegacyArguments;
	
	    defineProperties($Object, {
	        keys: function keys(object) {
	            var isFn = isCallable(object);
	            var isArgs = isArguments(object);
	            var isObject = object !== null && typeof object === 'object';
	            var isStr = isObject && isString(object);
	
	            if (!isObject && !isFn && !isArgs) {
	                throw new TypeError('Object.keys called on a non-object');
	            }
	
	            var theKeys = [];
	            var skipProto = hasProtoEnumBug && isFn;
	            if ((isStr && hasStringEnumBug) || isArgs) {
	                for (var i = 0; i < object.length; ++i) {
	                    pushCall(theKeys, $String(i));
	                }
	            }
	
	            if (!isArgs) {
	                for (var name in object) {
	                    if (!(skipProto && name === 'prototype') && owns(object, name)) {
	                        pushCall(theKeys, $String(name));
	                    }
	                }
	            }
	
	            if (hasDontEnumBug) {
	                var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	                for (var j = 0; j < dontEnumsLength; j++) {
	                    var dontEnum = dontEnums[j];
	                    if (!(skipConstructor && dontEnum === 'constructor') && owns(object, dontEnum)) {
	                        pushCall(theKeys, dontEnum);
	                    }
	                }
	            }
	            return theKeys;
	        }
	    });
	
	    var keysWorksWithArguments = $Object.keys && (function () {
	        // Safari 5.0 bug
	        return $Object.keys(arguments).length === 2;
	    }(1, 2));
	    var keysHasArgumentsLengthBug = $Object.keys && (function () {
	        var argKeys = $Object.keys(arguments);
	        return arguments.length !== 1 || argKeys.length !== 1 || argKeys[0] !== 1;
	    }(1));
	    var originalKeys = $Object.keys;
	    defineProperties($Object, {
	        keys: function keys(object) {
	            if (isArguments(object)) {
	                return originalKeys(arraySlice(object));
	            } else {
	                return originalKeys(object);
	            }
	        }
	    }, !keysWorksWithArguments || keysHasArgumentsLengthBug);
	
	    //
	    // Date
	    // ====
	    //
	
	    var hasNegativeMonthYearBug = new Date(-3509827329600292).getUTCMonth() !== 0;
	    var aNegativeTestDate = new Date(-1509842289600292);
	    var aPositiveTestDate = new Date(1449662400000);
	    var hasToUTCStringFormatBug = aNegativeTestDate.toUTCString() !== 'Mon, 01 Jan -45875 11:59:59 GMT';
	    var hasToDateStringFormatBug;
	    var hasToStringFormatBug;
	    var timeZoneOffset = aNegativeTestDate.getTimezoneOffset();
	    if (timeZoneOffset < -720) {
	        hasToDateStringFormatBug = aNegativeTestDate.toDateString() !== 'Tue Jan 02 -45875';
	        hasToStringFormatBug = !(/^Thu Dec 10 2015 \d\d:\d\d:\d\d GMT[-+]\d\d\d\d(?: |$)/).test(String(aPositiveTestDate));
	    } else {
	        hasToDateStringFormatBug = aNegativeTestDate.toDateString() !== 'Mon Jan 01 -45875';
	        hasToStringFormatBug = !(/^Wed Dec 09 2015 \d\d:\d\d:\d\d GMT[-+]\d\d\d\d(?: |$)/).test(String(aPositiveTestDate));
	    }
	
	    var originalGetFullYear = call.bind(Date.prototype.getFullYear);
	    var originalGetMonth = call.bind(Date.prototype.getMonth);
	    var originalGetDate = call.bind(Date.prototype.getDate);
	    var originalGetUTCFullYear = call.bind(Date.prototype.getUTCFullYear);
	    var originalGetUTCMonth = call.bind(Date.prototype.getUTCMonth);
	    var originalGetUTCDate = call.bind(Date.prototype.getUTCDate);
	    var originalGetUTCDay = call.bind(Date.prototype.getUTCDay);
	    var originalGetUTCHours = call.bind(Date.prototype.getUTCHours);
	    var originalGetUTCMinutes = call.bind(Date.prototype.getUTCMinutes);
	    var originalGetUTCSeconds = call.bind(Date.prototype.getUTCSeconds);
	    var originalGetUTCMilliseconds = call.bind(Date.prototype.getUTCMilliseconds);
	    var dayName = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	    var monthName = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	    var daysInMonth = function daysInMonth(month, year) {
	        return originalGetDate(new Date(year, month, 0));
	    };
	
	    defineProperties(Date.prototype, {
	        getFullYear: function getFullYear() {
	            if (!this || !(this instanceof Date)) {
	                throw new TypeError('this is not a Date object.');
	            }
	            var year = originalGetFullYear(this);
	            if (year < 0 && originalGetMonth(this) > 11) {
	                return year + 1;
	            }
	            return year;
	        },
	        getMonth: function getMonth() {
	            if (!this || !(this instanceof Date)) {
	                throw new TypeError('this is not a Date object.');
	            }
	            var year = originalGetFullYear(this);
	            var month = originalGetMonth(this);
	            if (year < 0 && month > 11) {
	                return 0;
	            }
	            return month;
	        },
	        getDate: function getDate() {
	            if (!this || !(this instanceof Date)) {
	                throw new TypeError('this is not a Date object.');
	            }
	            var year = originalGetFullYear(this);
	            var month = originalGetMonth(this);
	            var date = originalGetDate(this);
	            if (year < 0 && month > 11) {
	                if (month === 12) {
	                    return date;
	                }
	                var days = daysInMonth(0, year + 1);
	                return (days - date) + 1;
	            }
	            return date;
	        },
	        getUTCFullYear: function getUTCFullYear() {
	            if (!this || !(this instanceof Date)) {
	                throw new TypeError('this is not a Date object.');
	            }
	            var year = originalGetUTCFullYear(this);
	            if (year < 0 && originalGetUTCMonth(this) > 11) {
	                return year + 1;
	            }
	            return year;
	        },
	        getUTCMonth: function getUTCMonth() {
	            if (!this || !(this instanceof Date)) {
	                throw new TypeError('this is not a Date object.');
	            }
	            var year = originalGetUTCFullYear(this);
	            var month = originalGetUTCMonth(this);
	            if (year < 0 && month > 11) {
	                return 0;
	            }
	            return month;
	        },
	        getUTCDate: function getUTCDate() {
	            if (!this || !(this instanceof Date)) {
	                throw new TypeError('this is not a Date object.');
	            }
	            var year = originalGetUTCFullYear(this);
	            var month = originalGetUTCMonth(this);
	            var date = originalGetUTCDate(this);
	            if (year < 0 && month > 11) {
	                if (month === 12) {
	                    return date;
	                }
	                var days = daysInMonth(0, year + 1);
	                return (days - date) + 1;
	            }
	            return date;
	        }
	    }, hasNegativeMonthYearBug);
	
	    defineProperties(Date.prototype, {
	        toUTCString: function toUTCString() {
	            if (!this || !(this instanceof Date)) {
	                throw new TypeError('this is not a Date object.');
	            }
	            var day = originalGetUTCDay(this);
	            var date = originalGetUTCDate(this);
	            var month = originalGetUTCMonth(this);
	            var year = originalGetUTCFullYear(this);
	            var hour = originalGetUTCHours(this);
	            var minute = originalGetUTCMinutes(this);
	            var second = originalGetUTCSeconds(this);
	            return dayName[day] + ', '
	                + (date < 10 ? '0' + date : date) + ' '
	                + monthName[month] + ' '
	                + year + ' '
	                + (hour < 10 ? '0' + hour : hour) + ':'
	                + (minute < 10 ? '0' + minute : minute) + ':'
	                + (second < 10 ? '0' + second : second) + ' GMT';
	        }
	    }, hasNegativeMonthYearBug || hasToUTCStringFormatBug);
	
	    // Opera 12 has `,`
	    defineProperties(Date.prototype, {
	        toDateString: function toDateString() {
	            if (!this || !(this instanceof Date)) {
	                throw new TypeError('this is not a Date object.');
	            }
	            var day = this.getDay();
	            var date = this.getDate();
	            var month = this.getMonth();
	            var year = this.getFullYear();
	            return dayName[day] + ' '
	                + monthName[month] + ' '
	                + (date < 10 ? '0' + date : date) + ' '
	                + year;
	        }
	    }, hasNegativeMonthYearBug || hasToDateStringFormatBug);
	
	    // can't use defineProperties here because of toString enumeration issue in IE <= 8
	    if (hasNegativeMonthYearBug || hasToStringFormatBug) {
	        Date.prototype.toString = function toString() {
	            if (!this || !(this instanceof Date)) {
	                throw new TypeError('this is not a Date object.');
	            }
	            var day = this.getDay();
	            var date = this.getDate();
	            var month = this.getMonth();
	            var year = this.getFullYear();
	            var hour = this.getHours();
	            var minute = this.getMinutes();
	            var second = this.getSeconds();
	            var timezoneOffset = this.getTimezoneOffset();
	            var hoursOffset = Math.floor(Math.abs(timezoneOffset) / 60);
	            var minutesOffset = Math.floor(Math.abs(timezoneOffset) % 60);
	            return dayName[day] + ' '
	                + monthName[month] + ' '
	                + (date < 10 ? '0' + date : date) + ' '
	                + year + ' '
	                + (hour < 10 ? '0' + hour : hour) + ':'
	                + (minute < 10 ? '0' + minute : minute) + ':'
	                + (second < 10 ? '0' + second : second) + ' GMT'
	                + (timezoneOffset > 0 ? '-' : '+')
	                + (hoursOffset < 10 ? '0' + hoursOffset : hoursOffset)
	                + (minutesOffset < 10 ? '0' + minutesOffset : minutesOffset);
	        };
	        if (supportsDescriptors) {
	            $Object.defineProperty(Date.prototype, 'toString', {
	                configurable: true,
	                enumerable: false,
	                writable: true
	            });
	        }
	    }
	
	    // ES5 15.9.5.43
	    // http://es5.github.com/#x15.9.5.43
	    // This function returns a String value represent the instance in time
	    // represented by this Date object. The format of the String is the Date Time
	    // string format defined in 15.9.1.15. All fields are present in the String.
	    // The time zone is always UTC, denoted by the suffix Z. If the time value of
	    // this object is not a finite Number a RangeError exception is thrown.
	    var negativeDate = -62198755200000;
	    var negativeYearString = '-000001';
	    var hasNegativeDateBug = Date.prototype.toISOString && new Date(negativeDate).toISOString().indexOf(negativeYearString) === -1; // eslint-disable-line max-len
	    var hasSafari51DateBug = Date.prototype.toISOString && new Date(-1).toISOString() !== '1969-12-31T23:59:59.999Z';
	
	    var getTime = call.bind(Date.prototype.getTime);
	
	    defineProperties(Date.prototype, {
	        toISOString: function toISOString() {
	            if (!isFinite(this) || !isFinite(getTime(this))) {
	                // Adope Photoshop requires the second check.
	                throw new RangeError('Date.prototype.toISOString called on non-finite value.');
	            }
	
	            var year = originalGetUTCFullYear(this);
	
	            var month = originalGetUTCMonth(this);
	            // see https://github.com/es-shims/es5-shim/issues/111
	            year += Math.floor(month / 12);
	            month = ((month % 12) + 12) % 12;
	
	            // the date time string format is specified in 15.9.1.15.
	            var result = [
	                month + 1,
	                originalGetUTCDate(this),
	                originalGetUTCHours(this),
	                originalGetUTCMinutes(this),
	                originalGetUTCSeconds(this)
	            ];
	            year = (
	                (year < 0 ? '-' : (year > 9999 ? '+' : ''))
	                + strSlice('00000' + Math.abs(year), (0 <= year && year <= 9999) ? -4 : -6)
	            );
	
	            for (var i = 0; i < result.length; ++i) {
	                // pad months, days, hours, minutes, and seconds to have two digits.
	                result[i] = strSlice('00' + result[i], -2);
	            }
	            // pad milliseconds to have three digits.
	            return (
	                year + '-' + arraySlice(result, 0, 2).join('-')
	                + 'T' + arraySlice(result, 2).join(':') + '.'
	                + strSlice('000' + originalGetUTCMilliseconds(this), -3) + 'Z'
	            );
	        }
	    }, hasNegativeDateBug || hasSafari51DateBug);
	
	    // ES5 15.9.5.44
	    // http://es5.github.com/#x15.9.5.44
	    // This function provides a String representation of a Date object for use by
	    // JSON.stringify (15.12.3).
	    var dateToJSONIsSupported = (function () {
	        try {
	            return Date.prototype.toJSON
	                && new Date(NaN).toJSON() === null
	                && new Date(negativeDate).toJSON().indexOf(negativeYearString) !== -1
	                && Date.prototype.toJSON.call({ // generic
	                    toISOString: function () { return true; }
	                });
	        } catch (e) {
	            return false;
	        }
	    }());
	    if (!dateToJSONIsSupported) {
	        Date.prototype.toJSON = function toJSON(key) {
	            // When the toJSON method is called with argument key, the following
	            // steps are taken:
	
	            // 1.  Let O be the result of calling ToObject, giving it the this
	            // value as its argument.
	            // 2. Let tv be ES.ToPrimitive(O, hint Number).
	            var O = $Object(this);
	            var tv = ES.ToPrimitive(O);
	            // 3. If tv is a Number and is not finite, return null.
	            if (typeof tv === 'number' && !isFinite(tv)) {
	                return null;
	            }
	            // 4. Let toISO be the result of calling the [[Get]] internal method of
	            // O with argument "toISOString".
	            var toISO = O.toISOString;
	            // 5. If IsCallable(toISO) is false, throw a TypeError exception.
	            if (!isCallable(toISO)) {
	                throw new TypeError('toISOString property is not callable');
	            }
	            // 6. Return the result of calling the [[Call]] internal method of
	            //  toISO with O as the this value and an empty argument list.
	            return toISO.call(O);
	
	            // NOTE 1 The argument is ignored.
	
	            // NOTE 2 The toJSON function is intentionally generic; it does not
	            // require that its this value be a Date object. Therefore, it can be
	            // transferred to other kinds of objects for use as a method. However,
	            // it does require that any such object have a toISOString method. An
	            // object is free to use the argument key to filter its
	            // stringification.
	        };
	    }
	
	    // ES5 15.9.4.2
	    // http://es5.github.com/#x15.9.4.2
	    // based on work shared by Daniel Friesen (dantman)
	    // http://gist.github.com/303249
	    var supportsExtendedYears = Date.parse('+033658-09-27T01:46:40.000Z') === 1e15;
	    var acceptsInvalidDates = !isNaN(Date.parse('2012-04-04T24:00:00.500Z')) || !isNaN(Date.parse('2012-11-31T23:59:59.000Z')) || !isNaN(Date.parse('2012-12-31T23:59:60.000Z'));
	    var doesNotParseY2KNewYear = isNaN(Date.parse('2000-01-01T00:00:00.000Z'));
	    if (doesNotParseY2KNewYear || acceptsInvalidDates || !supportsExtendedYears) {
	        // XXX global assignment won't work in embeddings that use
	        // an alternate object for the context.
	        /* global Date: true */
	        var maxSafeUnsigned32Bit = Math.pow(2, 31) - 1;
	        var hasSafariSignedIntBug = isActualNaN(new Date(1970, 0, 1, 0, 0, 0, maxSafeUnsigned32Bit + 1).getTime());
	        // eslint-disable-next-line no-implicit-globals, no-global-assign
	        Date = (function (NativeDate) {
	            // Date.length === 7
	            var DateShim = function Date(Y, M, D, h, m, s, ms) {
	                var length = arguments.length;
	                var date;
	                if (this instanceof NativeDate) {
	                    var seconds = s;
	                    var millis = ms;
	                    if (hasSafariSignedIntBug && length >= 7 && ms > maxSafeUnsigned32Bit) {
	                        // work around a Safari 8/9 bug where it treats the seconds as signed
	                        var msToShift = Math.floor(ms / maxSafeUnsigned32Bit) * maxSafeUnsigned32Bit;
	                        var sToShift = Math.floor(msToShift / 1e3);
	                        seconds += sToShift;
	                        millis -= sToShift * 1e3;
	                    }
	                    date = length === 1 && $String(Y) === Y // isString(Y)
	                        // We explicitly pass it through parse:
	                        ? new NativeDate(DateShim.parse(Y))
	                        // We have to manually make calls depending on argument
	                        // length here
	                        : length >= 7 ? new NativeDate(Y, M, D, h, m, seconds, millis)
	                            : length >= 6 ? new NativeDate(Y, M, D, h, m, seconds)
	                                : length >= 5 ? new NativeDate(Y, M, D, h, m)
	                                    : length >= 4 ? new NativeDate(Y, M, D, h)
	                                        : length >= 3 ? new NativeDate(Y, M, D)
	                                            : length >= 2 ? new NativeDate(Y, M)
	                                                : length >= 1 ? new NativeDate(Y instanceof NativeDate ? +Y : Y)
	                                                    : new NativeDate();
	                } else {
	                    date = NativeDate.apply(this, arguments);
	                }
	                if (!isPrimitive(date)) {
	                    // Prevent mixups with unfixed Date object
	                    defineProperties(date, { constructor: DateShim }, true);
	                }
	                return date;
	            };
	
	            // 15.9.1.15 Date Time String Format.
	            var isoDateExpression = new RegExp('^'
	                + '(\\d{4}|[+-]\\d{6})' // four-digit year capture or sign + 6-digit extended year
	                + '(?:-(\\d{2})' // optional month capture
	                + '(?:-(\\d{2})' // optional day capture
	                + '(?:' // capture hours:minutes:seconds.milliseconds
	                    + 'T(\\d{2})' // hours capture
	                    + ':(\\d{2})' // minutes capture
	                    + '(?:' // optional :seconds.milliseconds
	                        + ':(\\d{2})' // seconds capture
	                        + '(?:(\\.\\d{1,}))?' // milliseconds capture
	                    + ')?'
	                + '(' // capture UTC offset component
	                    + 'Z|' // UTC capture
	                    + '(?:' // offset specifier +/-hours:minutes
	                        + '([-+])' // sign capture
	                        + '(\\d{2})' // hours offset capture
	                        + ':(\\d{2})' // minutes offset capture
	                    + ')'
	                + ')?)?)?)?'
	            + '$');
	
	            var months = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334, 365];
	
	            var dayFromMonth = function dayFromMonth(year, month) {
	                var t = month > 1 ? 1 : 0;
	                return (
	                    months[month]
	                    + Math.floor((year - 1969 + t) / 4)
	                    - Math.floor((year - 1901 + t) / 100)
	                    + Math.floor((year - 1601 + t) / 400)
	                    + (365 * (year - 1970))
	                );
	            };
	
	            var toUTC = function toUTC(t) {
	                var s = 0;
	                var ms = t;
	                if (hasSafariSignedIntBug && ms > maxSafeUnsigned32Bit) {
	                    // work around a Safari 8/9 bug where it treats the seconds as signed
	                    var msToShift = Math.floor(ms / maxSafeUnsigned32Bit) * maxSafeUnsigned32Bit;
	                    var sToShift = Math.floor(msToShift / 1e3);
	                    s += sToShift;
	                    ms -= sToShift * 1e3;
	                }
	                return $Number(new NativeDate(1970, 0, 1, 0, 0, s, ms));
	            };
	
	            // Copy any custom methods a 3rd party library may have added
	            for (var key in NativeDate) {
	                if (owns(NativeDate, key)) {
	                    DateShim[key] = NativeDate[key];
	                }
	            }
	
	            // Copy "native" methods explicitly; they may be non-enumerable
	            defineProperties(DateShim, {
	                now: NativeDate.now,
	                UTC: NativeDate.UTC
	            }, true);
	            DateShim.prototype = NativeDate.prototype;
	            defineProperties(DateShim.prototype, { constructor: DateShim }, true);
	
	            // Upgrade Date.parse to handle simplified ISO 8601 strings
	            var parseShim = function parse(string) {
	                var match = isoDateExpression.exec(string);
	                if (match) {
	                    // parse months, days, hours, minutes, seconds, and milliseconds
	                    // provide default values if necessary
	                    // parse the UTC offset component
	                    var year = $Number(match[1]),
	                        month = $Number(match[2] || 1) - 1,
	                        day = $Number(match[3] || 1) - 1,
	                        hour = $Number(match[4] || 0),
	                        minute = $Number(match[5] || 0),
	                        second = $Number(match[6] || 0),
	                        millisecond = Math.floor($Number(match[7] || 0) * 1000),
	                        // When time zone is missed, local offset should be used
	                        // (ES 5.1 bug)
	                        // see https://bugs.ecmascript.org/show_bug.cgi?id=112
	                        isLocalTime = Boolean(match[4] && !match[8]),
	                        signOffset = match[9] === '-' ? 1 : -1,
	                        hourOffset = $Number(match[10] || 0),
	                        minuteOffset = $Number(match[11] || 0),
	                        result;
	                    var hasMinutesOrSecondsOrMilliseconds = minute > 0 || second > 0 || millisecond > 0;
	                    if (
	                        hour < (hasMinutesOrSecondsOrMilliseconds ? 24 : 25)
	                        && minute < 60 && second < 60 && millisecond < 1000
	                        && month > -1 && month < 12 && hourOffset < 24
	                        && minuteOffset < 60 // detect invalid offsets
	                        && day > -1
	                        && day < (dayFromMonth(year, month + 1) - dayFromMonth(year, month))
	                    ) {
	                        result = (
	                            ((dayFromMonth(year, month) + day) * 24)
	                            + hour
	                            + (hourOffset * signOffset)
	                        ) * 60;
	                        result = ((
	                            ((result + minute + (minuteOffset * signOffset)) * 60)
	                            + second
	                        ) * 1000) + millisecond;
	                        if (isLocalTime) {
	                            result = toUTC(result);
	                        }
	                        if (-8.64e15 <= result && result <= 8.64e15) {
	                            return result;
	                        }
	                    }
	                    return NaN;
	                }
	                return NativeDate.parse.apply(this, arguments);
	            };
	            defineProperties(DateShim, { parse: parseShim });
	
	            return DateShim;
	        }(Date));
	        /* global Date: false */
	    }
	
	    // ES5 15.9.4.4
	    // http://es5.github.com/#x15.9.4.4
	    if (!Date.now) {
	        Date.now = function now() {
	            return new Date().getTime();
	        };
	    }
	
	    //
	    // Number
	    // ======
	    //
	
	    // ES5.1 15.7.4.5
	    // http://es5.github.com/#x15.7.4.5
	    var hasToFixedBugs = NumberPrototype.toFixed && (
	        (0.00008).toFixed(3) !== '0.000'
	        || (0.9).toFixed(0) !== '1'
	        || (1.255).toFixed(2) !== '1.25'
	        || (1000000000000000128).toFixed(0) !== '1000000000000000128'
	    );
	
	    var toFixedHelpers = {
	        base: 1e7,
	        size: 6,
	        data: [0, 0, 0, 0, 0, 0],
	        multiply: function multiply(n, c) {
	            var i = -1;
	            var c2 = c;
	            while (++i < toFixedHelpers.size) {
	                c2 += n * toFixedHelpers.data[i];
	                toFixedHelpers.data[i] = c2 % toFixedHelpers.base;
	                c2 = Math.floor(c2 / toFixedHelpers.base);
	            }
	        },
	        divide: function divide(n) {
	            var i = toFixedHelpers.size;
	            var c = 0;
	            while (--i >= 0) {
	                c += toFixedHelpers.data[i];
	                toFixedHelpers.data[i] = Math.floor(c / n);
	                c = (c % n) * toFixedHelpers.base;
	            }
	        },
	        numToString: function numToString() {
	            var i = toFixedHelpers.size;
	            var s = '';
	            while (--i >= 0) {
	                if (s !== '' || i === 0 || toFixedHelpers.data[i] !== 0) {
	                    var t = $String(toFixedHelpers.data[i]);
	                    if (s === '') {
	                        s = t;
	                    } else {
	                        s += strSlice('0000000', 0, 7 - t.length) + t;
	                    }
	                }
	            }
	            return s;
	        },
	        pow: function pow(x, n, acc) {
	            return (n === 0 ? acc : (n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc)));
	        },
	        log: function log(x) {
	            var n = 0;
	            var x2 = x;
	            while (x2 >= 4096) {
	                n += 12;
	                x2 /= 4096;
	            }
	            while (x2 >= 2) {
	                n += 1;
	                x2 /= 2;
	            }
	            return n;
	        }
	    };
	
	    var toFixedShim = function toFixed(fractionDigits) {
	        var f, x, s, m, e, z, j, k;
	
	        // Test for NaN and round fractionDigits down
	        f = $Number(fractionDigits);
	        f = isActualNaN(f) ? 0 : Math.floor(f);
	
	        if (f < 0 || f > 20) {
	            throw new RangeError('Number.toFixed called with invalid number of decimals');
	        }
	
	        x = $Number(this);
	
	        if (isActualNaN(x)) {
	            return 'NaN';
	        }
	
	        // If it is too big or small, return the string value of the number
	        if (x <= -1e21 || x >= 1e21) {
	            return $String(x);
	        }
	
	        s = '';
	
	        if (x < 0) {
	            s = '-';
	            x = -x;
	        }
	
	        m = '0';
	
	        if (x > 1e-21) {
	            // 1e-21 < x < 1e21
	            // -70 < log2(x) < 70
	            e = toFixedHelpers.log(x * toFixedHelpers.pow(2, 69, 1)) - 69;
	            z = (e < 0 ? x * toFixedHelpers.pow(2, -e, 1) : x / toFixedHelpers.pow(2, e, 1));
	            z *= 0x10000000000000; // Math.pow(2, 52);
	            e = 52 - e;
	
	            // -18 < e < 122
	            // x = z / 2 ^ e
	            if (e > 0) {
	                toFixedHelpers.multiply(0, z);
	                j = f;
	
	                while (j >= 7) {
	                    toFixedHelpers.multiply(1e7, 0);
	                    j -= 7;
	                }
	
	                toFixedHelpers.multiply(toFixedHelpers.pow(10, j, 1), 0);
	                j = e - 1;
	
	                while (j >= 23) {
	                    toFixedHelpers.divide(1 << 23);
	                    j -= 23;
	                }
	
	                toFixedHelpers.divide(1 << j);
	                toFixedHelpers.multiply(1, 1);
	                toFixedHelpers.divide(2);
	                m = toFixedHelpers.numToString();
	            } else {
	                toFixedHelpers.multiply(0, z);
	                toFixedHelpers.multiply(1 << (-e), 0);
	                m = toFixedHelpers.numToString() + strSlice('0.00000000000000000000', 2, 2 + f);
	            }
	        }
	
	        if (f > 0) {
	            k = m.length;
	
	            if (k <= f) {
	                m = s + strSlice('0.0000000000000000000', 0, f - k + 2) + m;
	            } else {
	                m = s + strSlice(m, 0, k - f) + '.' + strSlice(m, k - f);
	            }
	        } else {
	            m = s + m;
	        }
	
	        return m;
	    };
	    defineProperties(NumberPrototype, { toFixed: toFixedShim }, hasToFixedBugs);
	
	    var hasToPrecisionUndefinedBug = (function () {
	        try {
	            return 1.0.toPrecision(undefined) === '1';
	        } catch (e) {
	            return true;
	        }
	    }());
	    var originalToPrecision = NumberPrototype.toPrecision;
	    defineProperties(NumberPrototype, {
	        toPrecision: function toPrecision(precision) {
	            return typeof precision === 'undefined' ? originalToPrecision.call(this) : originalToPrecision.call(this, precision);
	        }
	    }, hasToPrecisionUndefinedBug);
	
	    //
	    // String
	    // ======
	    //
	
	    // ES5 15.5.4.14
	    // http://es5.github.com/#x15.5.4.14
	
	    // [bugfix, IE lt 9, firefox 4, Konqueror, Opera, obscure browsers]
	    // Many browsers do not split properly with regular expressions or they
	    // do not perform the split correctly under obscure conditions.
	    // See http://blog.stevenlevithan.com/archives/cross-browser-split
	    // I've tested in many browsers and this seems to cover the deviant ones:
	    //    'ab'.split(/(?:ab)*/) should be ["", ""], not [""]
	    //    '.'.split(/(.?)(.?)/) should be ["", ".", "", ""], not ["", ""]
	    //    'tesst'.split(/(s)*/) should be ["t", undefined, "e", "s", "t"], not
	    //       [undefined, "t", undefined, "e", ...]
	    //    ''.split(/.?/) should be [], not [""]
	    //    '.'.split(/()()/) should be ["."], not ["", "", "."]
	
	    if (
	        'ab'.split(/(?:ab)*/).length !== 2
	        || '.'.split(/(.?)(.?)/).length !== 4
	        || 'tesst'.split(/(s)*/)[1] === 't'
	        || 'test'.split(/(?:)/, -1).length !== 4
	        || ''.split(/.?/).length
	        || '.'.split(/()()/).length > 1
	    ) {
	        (function () {
	            var compliantExecNpcg = typeof (/()??/).exec('')[1] === 'undefined'; // NPCG: nonparticipating capturing group
	            var maxSafe32BitInt = Math.pow(2, 32) - 1;
	
	            StringPrototype.split = function (separator, limit) {
	                var string = String(this);
	                if (typeof separator === 'undefined' && limit === 0) {
	                    return [];
	                }
	
	                // If `separator` is not a regex, use native split
	                if (!isRegex(separator)) {
	                    return strSplit(this, separator, limit);
	                }
	
	                var output = [];
	                var flags = (separator.ignoreCase ? 'i' : '')
	                            + (separator.multiline ? 'm' : '')
	                            + (separator.unicode ? 'u' : '') // in ES6
	                            + (separator.sticky ? 'y' : ''), // Firefox 3+ and ES6
	                    lastLastIndex = 0,
	                    // Make `global` and avoid `lastIndex` issues by working with a copy
	                    separator2, match, lastIndex, lastLength;
	                var separatorCopy = new RegExp(separator.source, flags + 'g');
	                if (!compliantExecNpcg) {
	                    // Doesn't need flags gy, but they don't hurt
	                    separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	                }
	                /* Values for `limit`, per the spec:
	                 * If undefined: 4294967295 // maxSafe32BitInt
	                 * If 0, Infinity, or NaN: 0
	                 * If positive number: limit = Math.floor(limit); if (limit > 4294967295) limit -= 4294967296;
	                 * If negative number: 4294967296 - Math.floor(Math.abs(limit))
	                 * If other: Type-convert, then use the above rules
	                 */
	                var splitLimit = typeof limit === 'undefined' ? maxSafe32BitInt : ES.ToUint32(limit);
	                match = separatorCopy.exec(string);
	                while (match) {
	                    // `separatorCopy.lastIndex` is not reliable cross-browser
	                    lastIndex = match.index + match[0].length;
	                    if (lastIndex > lastLastIndex) {
	                        pushCall(output, strSlice(string, lastLastIndex, match.index));
	                        // Fix browsers whose `exec` methods don't consistently return `undefined` for
	                        // nonparticipating capturing groups
	                        if (!compliantExecNpcg && match.length > 1) {
	                            /* eslint-disable no-loop-func */
	                            match[0].replace(separator2, function () {
	                                for (var i = 1; i < arguments.length - 2; i++) {
	                                    if (typeof arguments[i] === 'undefined') {
	                                        match[i] = void 0;
	                                    }
	                                }
	                            });
	                            /* eslint-enable no-loop-func */
	                        }
	                        if (match.length > 1 && match.index < string.length) {
	                            array_push.apply(output, arraySlice(match, 1));
	                        }
	                        lastLength = match[0].length;
	                        lastLastIndex = lastIndex;
	                        if (output.length >= splitLimit) {
	                            break;
	                        }
	                    }
	                    if (separatorCopy.lastIndex === match.index) {
	                        separatorCopy.lastIndex++; // Avoid an infinite loop
	                    }
	                    match = separatorCopy.exec(string);
	                }
	                if (lastLastIndex === string.length) {
	                    if (lastLength || !separatorCopy.test('')) {
	                        pushCall(output, '');
	                    }
	                } else {
	                    pushCall(output, strSlice(string, lastLastIndex));
	                }
	                return output.length > splitLimit ? arraySlice(output, 0, splitLimit) : output;
	            };
	        }());
	
	    // [bugfix, chrome]
	    // If separator is undefined, then the result array contains just one String,
	    // which is the this value (converted to a String). If limit is not undefined,
	    // then the output array is truncated so that it contains no more than limit
	    // elements.
	    // "0".split(undefined, 0) -> []
	    } else if ('0'.split(void 0, 0).length) {
	        StringPrototype.split = function split(separator, limit) {
	            if (typeof separator === 'undefined' && limit === 0) {
	                return [];
	            }
	            return strSplit(this, separator, limit);
	        };
	    }
	
	    var str_replace = StringPrototype.replace;
	    var replaceReportsGroupsCorrectly = (function () {
	        var groups = [];
	        'x'.replace(/x(.)?/g, function (match, group) {
	            pushCall(groups, group);
	        });
	        return groups.length === 1 && typeof groups[0] === 'undefined';
	    }());
	
	    if (!replaceReportsGroupsCorrectly) {
	        StringPrototype.replace = function replace(searchValue, replaceValue) {
	            var isFn = isCallable(replaceValue);
	            var hasCapturingGroups = isRegex(searchValue) && (/\)[*?]/).test(searchValue.source);
	            if (!isFn || !hasCapturingGroups) {
	                return str_replace.call(this, searchValue, replaceValue);
	            } else {
	                var wrappedReplaceValue = function (match) {
	                    var length = arguments.length;
	                    var originalLastIndex = searchValue.lastIndex;
	                    searchValue.lastIndex = 0;
	                    var args = searchValue.exec(match) || [];
	                    searchValue.lastIndex = originalLastIndex;
	                    pushCall(args, arguments[length - 2], arguments[length - 1]);
	                    return replaceValue.apply(this, args);
	                };
	                return str_replace.call(this, searchValue, wrappedReplaceValue);
	            }
	        };
	    }
	
	    // ECMA-262, 3rd B.2.3
	    // Not an ECMAScript standard, although ECMAScript 3rd Edition has a
	    // non-normative section suggesting uniform semantics and it should be
	    // normalized across all browsers
	    // [bugfix, IE lt 9] IE < 9 substr() with negative value not working in IE
	    var string_substr = StringPrototype.substr;
	    var hasNegativeSubstrBug = ''.substr && '0b'.substr(-1) !== 'b';
	    defineProperties(StringPrototype, {
	        substr: function substr(start, length) {
	            var normalizedStart = start;
	            if (start < 0) {
	                normalizedStart = max(this.length + start, 0);
	            }
	            return string_substr.call(this, normalizedStart, length);
	        }
	    }, hasNegativeSubstrBug);
	
	    // ES5 15.5.4.20
	    // whitespace from: http://es5.github.io/#x15.5.4.20
	    var ws = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003'
	        + '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028'
	        + '\u2029\uFEFF';
	    var zeroWidth = '\u200b';
	    var wsRegexChars = '[' + ws + ']';
	    var trimBeginRegexp = new RegExp('^' + wsRegexChars + wsRegexChars + '*');
	    var trimEndRegexp = new RegExp(wsRegexChars + wsRegexChars + '*$');
	    var hasTrimWhitespaceBug = StringPrototype.trim && (ws.trim() || !zeroWidth.trim());
	    defineProperties(StringPrototype, {
	        // http://blog.stevenlevithan.com/archives/faster-trim-javascript
	        // http://perfectionkills.com/whitespace-deviations/
	        trim: function trim() {
	            if (typeof this === 'undefined' || this === null) {
	                throw new TypeError("can't convert " + this + ' to object');
	            }
	            return $String(this).replace(trimBeginRegexp, '').replace(trimEndRegexp, '');
	        }
	    }, hasTrimWhitespaceBug);
	    var trim = call.bind(String.prototype.trim);
	
	    var hasLastIndexBug = StringPrototype.lastIndexOf && 'abcあい'.lastIndexOf('あい', 2) !== -1;
	    defineProperties(StringPrototype, {
	        lastIndexOf: function lastIndexOf(searchString) {
	            if (typeof this === 'undefined' || this === null) {
	                throw new TypeError("can't convert " + this + ' to object');
	            }
	            var S = $String(this);
	            var searchStr = $String(searchString);
	            var numPos = arguments.length > 1 ? $Number(arguments[1]) : NaN;
	            var pos = isActualNaN(numPos) ? Infinity : ES.ToInteger(numPos);
	            var start = min(max(pos, 0), S.length);
	            var searchLen = searchStr.length;
	            var k = start + searchLen;
	            while (k > 0) {
	                k = max(0, k - searchLen);
	                var index = strIndexOf(strSlice(S, k, start + searchLen), searchStr);
	                if (index !== -1) {
	                    return k + index;
	                }
	            }
	            return -1;
	        }
	    }, hasLastIndexBug);
	
	    var originalLastIndexOf = StringPrototype.lastIndexOf;
	    defineProperties(StringPrototype, {
	        lastIndexOf: function lastIndexOf(searchString) {
	            return originalLastIndexOf.apply(this, arguments);
	        }
	    }, StringPrototype.lastIndexOf.length !== 1);
	
	    // ES-5 15.1.2.2
	    // eslint-disable-next-line radix
	    if (parseInt(ws + '08') !== 8 || parseInt(ws + '0x16') !== 22) {
	        /* global parseInt: true */
	        parseInt = (function (origParseInt) {
	            var hexRegex = /^[-+]?0[xX]/;
	            return function parseInt(str, radix) {
	                if (typeof str === 'symbol') {
	                    // handle Symbols in node 8.3/8.4
	                    // eslint-disable-next-line no-implicit-coercion, no-unused-expressions
	                    '' + str; // jscs:ignore disallowImplicitTypeConversion
	                }
	
	                var string = trim(String(str));
	                var defaultedRadix = $Number(radix) || (hexRegex.test(string) ? 16 : 10);
	                return origParseInt(string, defaultedRadix);
	            };
	        }(parseInt));
	    }
	
	    // https://es5.github.io/#x15.1.2.3
	    if (1 / parseFloat('-0') !== -Infinity) {
	        /* global parseFloat: true */
	        parseFloat = (function (origParseFloat) {
	            return function parseFloat(string) {
	                var inputString = trim(String(string));
	                var result = origParseFloat(inputString);
	                return result === 0 && strSlice(inputString, 0, 1) === '-' ? -0 : result;
	            };
	        }(parseFloat));
	    }
	
	    if (String(new RangeError('test')) !== 'RangeError: test') {
	        var errorToStringShim = function toString() {
	            if (typeof this === 'undefined' || this === null) {
	                throw new TypeError("can't convert " + this + ' to object');
	            }
	            var name = this.name;
	            if (typeof name === 'undefined') {
	                name = 'Error';
	            } else if (typeof name !== 'string') {
	                name = $String(name);
	            }
	            var msg = this.message;
	            if (typeof msg === 'undefined') {
	                msg = '';
	            } else if (typeof msg !== 'string') {
	                msg = $String(msg);
	            }
	            if (!name) {
	                return msg;
	            }
	            if (!msg) {
	                return name;
	            }
	            return name + ': ' + msg;
	        };
	        // can't use defineProperties here because of toString enumeration issue in IE <= 8
	        Error.prototype.toString = errorToStringShim;
	    }
	
	    if (supportsDescriptors) {
	        var ensureNonEnumerable = function (obj, prop) {
	            if (isEnum(obj, prop)) {
	                var desc = Object.getOwnPropertyDescriptor(obj, prop);
	                if (desc.configurable) {
	                    desc.enumerable = false;
	                    Object.defineProperty(obj, prop, desc);
	                }
	            }
	        };
	        ensureNonEnumerable(Error.prototype, 'message');
	        if (Error.prototype.message !== '') {
	            Error.prototype.message = '';
	        }
	        ensureNonEnumerable(Error.prototype, 'name');
	    }
	
	    if (String(/a/mig) !== '/a/gim') {
	        var regexToString = function toString() {
	            var str = '/' + this.source + '/';
	            if (this.global) {
	                str += 'g';
	            }
	            if (this.ignoreCase) {
	                str += 'i';
	            }
	            if (this.multiline) {
	                str += 'm';
	            }
	            return str;
	        };
	        // can't use defineProperties here because of toString enumeration issue in IE <= 8
	        RegExp.prototype.toString = regexToString;
	    }
	}));


/***/ },
/* 353 */
37,
/* 354 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(354);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(364);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(17);
	
	var createArrayFromMixed = __webpack_require__(357);
	var getMarkupWrap = __webpack_require__(359);
	var invariant = __webpack_require__(3);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(17);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 360 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 361 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(361);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 363 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(363);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 365 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	var Buffer = __webpack_require__(59).Buffer
	var Transform = __webpack_require__(20).Transform
	var inherits = __webpack_require__(13)
	
	function throwIfNotStringOrBuffer (val, prefix) {
	  if (!Buffer.isBuffer(val) && typeof val !== 'string') {
	    throw new TypeError(prefix + ' must be a string or a buffer')
	  }
	}
	
	function HashBase (blockSize) {
	  Transform.call(this)
	
	  this._block = Buffer.allocUnsafe(blockSize)
	  this._blockSize = blockSize
	  this._blockOffset = 0
	  this._length = [0, 0, 0, 0]
	
	  this._finalized = false
	}
	
	inherits(HashBase, Transform)
	
	HashBase.prototype._transform = function (chunk, encoding, callback) {
	  var error = null
	  try {
	    this.update(chunk, encoding)
	  } catch (err) {
	    error = err
	  }
	
	  callback(error)
	}
	
	HashBase.prototype._flush = function (callback) {
	  var error = null
	  try {
	    this.push(this.digest())
	  } catch (err) {
	    error = err
	  }
	
	  callback(error)
	}
	
	HashBase.prototype.update = function (data, encoding) {
	  throwIfNotStringOrBuffer(data, 'Data')
	  if (this._finalized) throw new Error('Digest already called')
	  if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding)
	
	  // consume data
	  var block = this._block
	  var offset = 0
	  while (this._blockOffset + data.length - offset >= this._blockSize) {
	    for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++]
	    this._update()
	    this._blockOffset = 0
	  }
	  while (offset < data.length) block[this._blockOffset++] = data[offset++]
	
	  // update length
	  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
	    this._length[j] += carry
	    carry = (this._length[j] / 0x0100000000) | 0
	    if (carry > 0) this._length[j] -= 0x0100000000 * carry
	  }
	
	  return this
	}
	
	HashBase.prototype._update = function () {
	  throw new Error('_update is not implemented')
	}
	
	HashBase.prototype.digest = function (encoding) {
	  if (this._finalized) throw new Error('Digest already called')
	  this._finalized = true
	
	  var digest = this._digest()
	  if (encoding !== undefined) digest = digest.toString(encoding)
	
	  // reset state
	  this._block.fill(0)
	  this._blockOffset = 0
	  for (var i = 0; i < 4; ++i) this._length[i] = 0
	
	  return digest
	}
	
	HashBase.prototype._digest = function () {
	  throw new Error('_digest is not implemented')
	}
	
	module.exports = HashBase


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ },
/* 368 */
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	// The MIT License (MIT)
	//
	// Copyright (c) 2016 Yang Xia
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in all
	// copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	// SOFTWARE.
	
	'use strict';
	
	var util = __webpack_require__(4);
	var JsonParser = __webpack_require__(373);
	
	exports = module.exports;
	util.inherits(Parser, JsonParser);
	
	/**
	* Parser Instructor
	*/
	function Parser() {
	  this.internalParser = new JsonParser();
	  this.originalOnToken = this.internalParser.onToken;
	  this.internalParser.onToken = onToken.bind(this);
	  return this.internalParser;
	}
	
	/**
	* Handles the EDM types in the JSON object
	*   1. Number will be treated as Edm.Int32 by default
	*   2. Literal value 1.0 will be treated as Edm.Double
	*   3. Others will be handled according to the literal value
	*/
	var onToken = function (token, value) {
	  var self = this;
	  var emitString = false;
	  function additionalEmit(additionalKey, additionalValue) {
	    var oldKey = self.internalParser.key;
	    self.internalParser.key = additionalKey;
	    self.internalParser.onValue(additionalValue);
	    self.internalParser.key = oldKey;
	  }
	
	  if (token === JsonParser.C.STRING ||
	  token === JsonParser.C.NUMBER ||
	  token === JsonParser.C.TRUE ||
	  token === JsonParser.C.FALSE ||
	  token === JsonParser.C.NULL) {
	    // Parser will emit value in these cases
	    if (typeof value === 'number' && 
	    this.internalParser.string.indexOf('.') != -1 && 
	    parseInt(this.internalParser.string) === value &&
	    this.internalParser.mode !== JsonParser.C.ARRAY) {
	      var typeKey = this.internalParser.key + '@odata.type';
	      if (this.internalParser.value) {
	        this.internalParser.value[typeKey] = 'Edm.Double';
	      }
	      additionalEmit(typeKey, 'Edm.Double');
	      
	      // Determine whether return raw string to avoid losing precision
	      emitString = this.internalParser.string !== value.toString();
	    }
	  }
	  if (emitString) {
	    this.originalOnToken.call(this.internalParser, token, this.internalParser.string);
	  } else {
	    this.originalOnToken.call(this.internalParser, token, value);
	  }
	};
	
	Parser.C = JsonParser.C;
	module.exports = Parser;

/***/ },
/* 371 */
/***/ function(module, exports) {

	module.exports = {
		"_args": [
			[
				{
					"raw": "azure-iot-device@1.1.7",
					"scope": null,
					"escapedName": "azure-iot-device",
					"name": "azure-iot-device",
					"rawSpec": "1.1.7",
					"spec": "1.1.7",
					"type": "version"
				},
				"C:\\projects\\iot-devkit-web-simulator"
			]
		],
		"_from": "azure-iot-device@1.1.7",
		"_id": "azure-iot-device@1.1.7",
		"_inCache": true,
		"_location": "/azure-iot-device",
		"_nodeVersion": "6.9.5",
		"_npmOperationalInternal": {
			"host": "packages-18-east.internal.npmjs.com",
			"tmp": "tmp/azure-iot-device-1.1.7.tgz_1488221056434_0.8069348027929664"
		},
		"_npmUser": {
			"name": "windowsazure",
			"email": "azuresdk@outlook.com"
		},
		"_npmVersion": "3.10.10",
		"_phantomChildren": {
			"crypto": "0.0.3"
		},
		"_requested": {
			"raw": "azure-iot-device@1.1.7",
			"scope": null,
			"escapedName": "azure-iot-device",
			"name": "azure-iot-device",
			"rawSpec": "1.1.7",
			"spec": "1.1.7",
			"type": "version"
		},
		"_requiredBy": [
			"/"
		],
		"_resolved": "https://registry.npmjs.org/azure-iot-device/-/azure-iot-device-1.1.7.tgz",
		"_shasum": "faad0095b7c6e758cbfd4d42aae1db35dabf72ea",
		"_shrinkwrap": null,
		"_spec": "azure-iot-device@1.1.7",
		"_where": "C:\\projects\\iot-devkit-web-simulator",
		"author": {
			"name": "Microsoft Corporation"
		},
		"bugs": {
			"url": "https://github.com/Azure/azure-iot-sdk-node/issues"
		},
		"dependencies": {
			"azure-iot-common": "1.1.5",
			"azure-iot-http-base": "1.1.5",
			"azure-storage": "^2.0.0",
			"debug": "^2.6.0",
			"es5-shim": "^4.5.9",
			"lodash": "^4.17.4",
			"machina": "^2.0.0",
			"traverse": "^0.6.6"
		},
		"description": "Azure IoT device SDK",
		"devDependencies": {
			"chai": "^3.5.0",
			"istanbul": "^0.4.5",
			"jshint": "^2.9.4",
			"mocha": "^3.2.0",
			"sinon": "^1.17.7",
			"tslint": "^3.14.0",
			"typescript": "^1.8.10"
		},
		"directories": {},
		"dist": {
			"shasum": "faad0095b7c6e758cbfd4d42aae1db35dabf72ea",
			"tarball": "https://registry.npmjs.org/azure-iot-device/-/azure-iot-device-1.1.7.tgz"
		},
		"engines": {
			"node": ">= 0.10"
		},
		"homepage": "https://github.com/Azure/azure-iot-sdk-node#readme",
		"license": "MIT",
		"main": "device.js",
		"maintainers": [
			{
				"name": "windowsazure",
				"email": "azuresdk@outlook.com"
			}
		],
		"name": "azure-iot-device",
		"optionalDependencies": {},
		"readme": "ERROR: No README data found!",
		"repository": {
			"type": "git",
			"url": "git+https://github.com/Azure/azure-iot-sdk-node.git"
		},
		"scripts": {
			"alltest": "istanbul cover node_modules/mocha/bin/_mocha -- --reporter spec \"test/**/_*_test*.js\"",
			"alltest-min": "istanbul cover --report none node_modules/mocha/bin/_mocha -- --reporter dot \"test/**/_*_test*.js\"",
			"check-cover": "istanbul check-coverage --statements 98 --branches 94 --functions 98 --lines 98",
			"ci": "npm -s run lint && npm -s run alltest-min && npm -s run check-cover",
			"lint": "jshint --show-non-errors . && tslint -c ../../tslint.json \"{lib,.}/*.ts\"",
			"test": "npm -s run lint && npm -s run unittest",
			"unittest": "istanbul cover node_modules/mocha/bin/_mocha -- --reporter spec \"test/**/_*_test.js\"",
			"unittest-min": "istanbul cover --report none node_modules/mocha/bin/_mocha -- --reporter dot \"test/**/_*_test.js\""
		},
		"typings": "device.d.ts",
		"version": "1.1.7"
	};

/***/ },
/* 372 */
/***/ function(module, exports) {

	module.exports = {
		"name": "raspberry-pi-web-simulator",
		"version": "0.1.0",
		"private": true,
		"dependencies": {
			"applicationinsights-js": "^1.0.9",
			"azure-iot-common": "^1.1.6",
			"azure-iot-device": "1.1.7",
			"bootstrap": "^3.3.7",
			"fabric": "^1.7.16",
			"immutable": "^3.8.1",
			"konva": "^1.6.3",
			"monaco-editor": "^0.10.0",
			"node-sass": "^4.5.3",
			"nuclear-js": "^1.4.0",
			"paho-mqtt": "^1.0.3",
			"react": "^15.6.1",
			"react-bootstrap": "^0.30.9",
			"react-console-component": "^0.6.1",
			"react-dom": "^15.5.4",
			"react-ga": "^2.2.0",
			"react-konva": "~1.1.6",
			"react-load-script": "0.0.6",
			"react-localization": "^0.1.0",
			"react-redux": "^5.0.6",
			"redux": "^3.7.2",
			"sass-loader": "^6.0.6",
			"uuid": "^3.0.1"
		},
		"devDependencies": {
			"autoprefixer": "6.7.2",
			"babel-core": "6.22.1",
			"babel-eslint": "7.1.1",
			"babel-jest": "18.0.0",
			"babel-loader": "6.2.10",
			"babel-preset-react-app": "^2.2.0",
			"babel-runtime": "^6.20.0",
			"browserify-fs": "^1.0.0",
			"case-sensitive-paths-webpack-plugin": "1.1.4",
			"chalk": "1.1.3",
			"connect-history-api-fallback": "1.3.0",
			"copy-webpack-plugin": "^4.0.1",
			"cross-spawn": "4.0.2",
			"css-loader": "0.26.1",
			"detect-port": "1.1.0",
			"dotenv": "2.0.0",
			"eslint": "3.16.1",
			"eslint-config-react-app": "^0.6.2",
			"eslint-loader": "1.6.0",
			"eslint-plugin-flowtype": "2.21.0",
			"eslint-plugin-import": "2.0.1",
			"eslint-plugin-jsx-a11y": "4.0.0",
			"eslint-plugin-react": "6.4.1",
			"extract-text-webpack-plugin": "1.0.1",
			"file-loader": "0.10.0",
			"fs-extra": "0.30.0",
			"html-webpack-plugin": "2.24.0",
			"http-proxy-middleware": "0.17.3",
			"jest": "18.1.0",
			"json-loader": "0.5.4",
			"object-assign": "4.1.1",
			"postcss-loader": "1.2.2",
			"promise": "7.1.1",
			"raw-loader": "^0.5.1",
			"react-dev-utils": "^0.5.2",
			"style-loader": "0.13.1",
			"url-loader": "0.5.7",
			"webpack": "1.14.0",
			"webpack-dev-server": "1.16.2",
			"webpack-manifest-plugin": "1.1.0",
			"whatwg-fetch": "2.0.2"
		},
		"scripts": {
			"start": "node scripts/build.js",
			"dev": "node scripts/start.js",
			"test": "node scripts/test.js --env=jsdom"
		},
		"homepage": ".",
		"jest": {
			"collectCoverageFrom": [
				"src/**/*.{js,jsx}"
			],
			"setupFiles": [
				"<rootDir>/config/polyfills.js"
			],
			"testPathIgnorePatterns": [
				"<rootDir>[/\\\\](build|docs|node_modules|scripts)[/\\\\]"
			],
			"testEnvironment": "node",
			"testURL": "http://localhost",
			"transform": {
				"^.+\\.(js|jsx)$": "<rootDir>/node_modules/babel-jest",
				"^.+\\.css$": "<rootDir>/config/jest/cssTransform.js",
				"^(?!.*\\.(js|jsx|css|json)$)": "<rootDir>/config/jest/fileTransform.js"
			},
			"transformIgnorePatterns": [
				"[/\\\\]node_modules[/\\\\].+\\.(js|jsx)$"
			],
			"moduleNameMapper": {
				"^react-native$": "react-native-web"
			}
		},
		"babel": {
			"presets": [
				"react-app"
			]
		},
		"eslintConfig": {
			"extends": "react-app"
		}
	};

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*global Buffer*/
	// Named constants with unique integer values
	var C = {};
	// Tokens
	var LEFT_BRACE    = C.LEFT_BRACE    = 0x1;
	var RIGHT_BRACE   = C.RIGHT_BRACE   = 0x2;
	var LEFT_BRACKET  = C.LEFT_BRACKET  = 0x3;
	var RIGHT_BRACKET = C.RIGHT_BRACKET = 0x4;
	var COLON         = C.COLON         = 0x5;
	var COMMA         = C.COMMA         = 0x6;
	var TRUE          = C.TRUE          = 0x7;
	var FALSE         = C.FALSE         = 0x8;
	var NULL          = C.NULL          = 0x9;
	var STRING        = C.STRING        = 0xa;
	var NUMBER        = C.NUMBER        = 0xb;
	// Tokenizer States
	var START   = C.START   = 0x11;
	var STOP    = C.STOP    = 0x12;
	var TRUE1   = C.TRUE1   = 0x21;
	var TRUE2   = C.TRUE2   = 0x22;
	var TRUE3   = C.TRUE3   = 0x23;
	var FALSE1  = C.FALSE1  = 0x31;
	var FALSE2  = C.FALSE2  = 0x32;
	var FALSE3  = C.FALSE3  = 0x33;
	var FALSE4  = C.FALSE4  = 0x34;
	var NULL1   = C.NULL1   = 0x41;
	var NULL2   = C.NULL2   = 0x42;
	var NULL3   = C.NULL3   = 0x43;
	var NUMBER1 = C.NUMBER1 = 0x51;
	var NUMBER3 = C.NUMBER3 = 0x53;
	var STRING1 = C.STRING1 = 0x61;
	var STRING2 = C.STRING2 = 0x62;
	var STRING3 = C.STRING3 = 0x63;
	var STRING4 = C.STRING4 = 0x64;
	var STRING5 = C.STRING5 = 0x65;
	var STRING6 = C.STRING6 = 0x66;
	// Parser States
	var VALUE   = C.VALUE   = 0x71;
	var KEY     = C.KEY     = 0x72;
	// Parser Modes
	var OBJECT  = C.OBJECT  = 0x81;
	var ARRAY   = C.ARRAY   = 0x82;
	
	
	function Parser() {
	  this.tState = START;
	  this.value = undefined;
	
	  this.string = undefined; // string data
	  this.unicode = undefined; // unicode escapes
	
	  this.key = undefined;
	  this.mode = undefined;
	  this.stack = [];
	  this.state = VALUE;
	  this.bytes_remaining = 0; // number of bytes remaining in multi byte utf8 char to read after split boundary
	  this.bytes_in_sequence = 0; // bytes in multi byte utf8 char to read
	  this.temp_buffs = { "2": new Buffer(2), "3": new Buffer(3), "4": new Buffer(4) }; // for rebuilding chars split before boundary is reached
	
	  // Stream offset
	  this.offset = -1;
	}
	
	// Slow code to string converter (only used when throwing syntax errors)
	Parser.toknam = function (code) {
	  var keys = Object.keys(C);
	  for (var i = 0, l = keys.length; i < l; i++) {
	    var key = keys[i];
	    if (C[key] === code) { return key; }
	  }
	  return code && ("0x" + code.toString(16));
	};
	
	var proto = Parser.prototype;
	proto.onError = function (err) { throw err; };
	proto.charError = function (buffer, i) {
	  this.tState = STOP;
	  this.onError(new Error("Unexpected " + JSON.stringify(String.fromCharCode(buffer[i])) + " at position " + i + " in state " + Parser.toknam(this.tState)));
	};
	proto.write = function (buffer) {
	  if (typeof buffer === "string") buffer = new Buffer(buffer);
	  var n;
	  for (var i = 0, l = buffer.length; i < l; i++) {
	    if (this.tState === START){
	      n = buffer[i];
	      this.offset++;
	      if(n === 0x7b){ this.onToken(LEFT_BRACE, "{"); // {
	      }else if(n === 0x7d){ this.onToken(RIGHT_BRACE, "}"); // }
	      }else if(n === 0x5b){ this.onToken(LEFT_BRACKET, "["); // [
	      }else if(n === 0x5d){ this.onToken(RIGHT_BRACKET, "]"); // ]
	      }else if(n === 0x3a){ this.onToken(COLON, ":");  // :
	      }else if(n === 0x2c){ this.onToken(COMMA, ","); // ,
	      }else if(n === 0x74){ this.tState = TRUE1;  // t
	      }else if(n === 0x66){ this.tState = FALSE1;  // f
	      }else if(n === 0x6e){ this.tState = NULL1; // n
	      }else if(n === 0x22){ this.string = ""; this.tState = STRING1; // "
	      }else if(n === 0x2d){ this.string = "-"; this.tState = NUMBER1; // -
	      }else{
	        if (n >= 0x30 && n < 0x40) { // 1-9
	          this.string = String.fromCharCode(n); this.tState = NUMBER3;
	        } else if (n === 0x20 || n === 0x09 || n === 0x0a || n === 0x0d) {
	          // whitespace
	        } else {
	          return this.charError(buffer, i);
	        }
	      }
	    }else if (this.tState === STRING1){ // After open quote
	      n = buffer[i]; // get current byte from buffer
	      // check for carry over of a multi byte char split between data chunks
	      // & fill temp buffer it with start of this data chunk up to the boundary limit set in the last iteration
	      if (this.bytes_remaining > 0) {
	        for (var j = 0; j < this.bytes_remaining; j++) {
	          this.temp_buffs[this.bytes_in_sequence][this.bytes_in_sequence - this.bytes_remaining + j] = buffer[j];
	        }
	        this.string += this.temp_buffs[this.bytes_in_sequence].toString();
	        this.bytes_in_sequence = this.bytes_remaining = 0;
	        i = i + j - 1;
	      } else if (this.bytes_remaining === 0 && n >= 128) { // else if no remainder bytes carried over, parse multi byte (>=128) chars one at a time
	        if (n <= 193 || n > 244) {
	          return this.onError(new Error("Invalid UTF-8 character at position " + i + " in state " + Parser.toknam(this.tState)));
	        }
	        if ((n >= 194) && (n <= 223)) this.bytes_in_sequence = 2;
	        if ((n >= 224) && (n <= 239)) this.bytes_in_sequence = 3;
	        if ((n >= 240) && (n <= 244)) this.bytes_in_sequence = 4;
	        if ((this.bytes_in_sequence + i) > buffer.length) { // if bytes needed to complete char fall outside buffer length, we have a boundary split
	          for (var k = 0; k <= (buffer.length - 1 - i); k++) {
	            this.temp_buffs[this.bytes_in_sequence][k] = buffer[i + k]; // fill temp buffer of correct size with bytes available in this chunk
	          }
	          this.bytes_remaining = (i + this.bytes_in_sequence) - buffer.length;
	          i = buffer.length - 1;
	        } else {
	          this.string += buffer.slice(i, (i + this.bytes_in_sequence)).toString();
	          i = i + this.bytes_in_sequence - 1;
	        }
	      } else if (n === 0x22) { this.tState = START; this.onToken(STRING, this.string); this.offset += Buffer.byteLength(this.string, 'utf8') + 1; this.string = undefined; }
	      else if (n === 0x5c) { this.tState = STRING2; }
	      else if (n >= 0x20) { this.string += String.fromCharCode(n); }
	      else {
	          return this.charError(buffer, i);
	      }
	    }else if (this.tState === STRING2){ // After backslash
	      n = buffer[i];
	      if(n === 0x22){ this.string += "\""; this.tState = STRING1;
	      }else if(n === 0x5c){ this.string += "\\"; this.tState = STRING1; 
	      }else if(n === 0x2f){ this.string += "\/"; this.tState = STRING1; 
	      }else if(n === 0x62){ this.string += "\b"; this.tState = STRING1; 
	      }else if(n === 0x66){ this.string += "\f"; this.tState = STRING1; 
	      }else if(n === 0x6e){ this.string += "\n"; this.tState = STRING1; 
	      }else if(n === 0x72){ this.string += "\r"; this.tState = STRING1; 
	      }else if(n === 0x74){ this.string += "\t"; this.tState = STRING1; 
	      }else if(n === 0x75){ this.unicode = ""; this.tState = STRING3;
	      }else{ 
	        return this.charError(buffer, i); 
	      }
	    }else if (this.tState === STRING3 || this.tState === STRING4 || this.tState === STRING5 || this.tState === STRING6){ // unicode hex codes
	      n = buffer[i];
	      // 0-9 A-F a-f
	      if ((n >= 0x30 && n < 0x40) || (n > 0x40 && n <= 0x46) || (n > 0x60 && n <= 0x66)) {
	        this.unicode += String.fromCharCode(n);
	        if (this.tState++ === STRING6) {
	          this.string += String.fromCharCode(parseInt(this.unicode, 16));
	          this.unicode = undefined;
	          this.tState = STRING1; 
	        }
	      } else {
	        return this.charError(buffer, i);
	      }
	    } else if (this.tState === NUMBER1 || this.tState === NUMBER3) {
	        n = buffer[i];
	
	        switch (n) {
	          case 0x30: // 0
	          case 0x31: // 1
	          case 0x32: // 2
	          case 0x33: // 3
	          case 0x34: // 4
	          case 0x35: // 5
	          case 0x36: // 6
	          case 0x37: // 7
	          case 0x38: // 8
	          case 0x39: // 9
	          case 0x2e: // .
	          case 0x65: // e
	          case 0x45: // E
	          case 0x2b: // +
	          case 0x2d: // -
	            this.string += String.fromCharCode(n);
	            this.tState = NUMBER3;
	            break;
	          default:
	            this.tState = START;
	            var result = Number(this.string);
	
	            if (isNaN(result)){
	              return this.charError(buffer, i);
	            }
	
	            if ((this.string.match(/[0-9]+/) == this.string) && (result.toString() != this.string)) {
	              // Long string of digits which is an ID string and not valid and/or safe JavaScript integer Number
	              this.onToken(STRING, this.string);
	            } else {
	              this.onToken(NUMBER, result);
	            }
	
	            this.offset += this.string.length - 1;
	            this.string = undefined;
	            i--;
	            break;
	        }
	    }else if (this.tState === TRUE1){ // r
	      if (buffer[i] === 0x72) { this.tState = TRUE2; }
	      else { return this.charError(buffer, i); }
	    }else if (this.tState === TRUE2){ // u
	      if (buffer[i] === 0x75) { this.tState = TRUE3; }
	      else { return this.charError(buffer, i); }
	    }else if (this.tState === TRUE3){ // e
	      if (buffer[i] === 0x65) { this.tState = START; this.onToken(TRUE, true); this.offset+= 3; }
	      else { return this.charError(buffer, i); }
	    }else if (this.tState === FALSE1){ // a
	      if (buffer[i] === 0x61) { this.tState = FALSE2; }
	      else { return this.charError(buffer, i); }
	    }else if (this.tState === FALSE2){ // l
	      if (buffer[i] === 0x6c) { this.tState = FALSE3; }
	      else { return this.charError(buffer, i); }
	    }else if (this.tState === FALSE3){ // s
	      if (buffer[i] === 0x73) { this.tState = FALSE4; }
	      else { return this.charError(buffer, i); }
	    }else if (this.tState === FALSE4){ // e
	      if (buffer[i] === 0x65) { this.tState = START; this.onToken(FALSE, false); this.offset+= 4; }
	      else { return this.charError(buffer, i); }
	    }else if (this.tState === NULL1){ // u
	      if (buffer[i] === 0x75) { this.tState = NULL2; }
	      else { return this.charError(buffer, i); }
	    }else if (this.tState === NULL2){ // l
	      if (buffer[i] === 0x6c) { this.tState = NULL3; }
	      else { return this.charError(buffer, i); }
	    }else if (this.tState === NULL3){ // l
	      if (buffer[i] === 0x6c) { this.tState = START; this.onToken(NULL, null); this.offset += 3; }
	      else { return this.charError(buffer, i); }
	    }
	  }
	};
	proto.onToken = function (token, value) {
	  // Override this to get events
	};
	
	proto.parseError = function (token, value) {
	  this.tState = STOP;
	  this.onError(new Error("Unexpected " + Parser.toknam(token) + (value ? ("(" + JSON.stringify(value) + ")") : "") + " in state " + Parser.toknam(this.state)));
	};
	proto.push = function () {
	  this.stack.push({value: this.value, key: this.key, mode: this.mode});
	};
	proto.pop = function () {
	  var value = this.value;
	  var parent = this.stack.pop();
	  this.value = parent.value;
	  this.key = parent.key;
	  this.mode = parent.mode;
	  this.emit(value);
	  if (!this.mode) { this.state = VALUE; }
	};
	proto.emit = function (value) {
	  if (this.mode) { this.state = COMMA; }
	  this.onValue(value);
	};
	proto.onValue = function (value) {
	  // Override me
	};  
	proto.onToken = function (token, value) {
	  if(this.state === VALUE){
	    if(token === STRING || token === NUMBER || token === TRUE || token === FALSE || token === NULL){
	      if (this.value) {
	        this.value[this.key] = value;
	      }
	      this.emit(value);  
	    }else if(token === LEFT_BRACE){
	      this.push();
	      if (this.value) {
	        this.value = this.value[this.key] = {};
	      } else {
	        this.value = {};
	      }
	      this.key = undefined;
	      this.state = KEY;
	      this.mode = OBJECT;
	    }else if(token === LEFT_BRACKET){
	      this.push();
	      if (this.value) {
	        this.value = this.value[this.key] = [];
	      } else {
	        this.value = [];
	      }
	      this.key = 0;
	      this.mode = ARRAY;
	      this.state = VALUE;
	    }else if(token === RIGHT_BRACE){
	      if (this.mode === OBJECT) {
	        this.pop();
	      } else {
	        return this.parseError(token, value);
	      }
	    }else if(token === RIGHT_BRACKET){
	      if (this.mode === ARRAY) {
	        this.pop();
	      } else {
	        return this.parseError(token, value);
	      }
	    }else{
	      return this.parseError(token, value);
	    }
	  }else if(this.state === KEY){
	    if (token === STRING) {
	      this.key = value;
	      this.state = COLON;
	    } else if (token === RIGHT_BRACE) {
	      this.pop();
	    } else {
	      return this.parseError(token, value);
	    }
	  }else if(this.state === COLON){
	    if (token === COLON) { this.state = VALUE; }
	    else { return this.parseError(token, value); }
	  }else if(this.state === COMMA){
	    if (token === COMMA) { 
	      if (this.mode === ARRAY) { this.key++; this.state = VALUE; }
	      else if (this.mode === OBJECT) { this.state = KEY; }
	
	    } else if (token === RIGHT_BRACKET && this.mode === ARRAY || token === RIGHT_BRACE && this.mode === OBJECT) {
	      this.pop();
	    } else {
	      return this.parseError(token, value);
	    }
	  }else{
	    return this.parseError(token, value);
	  }
	};
	
	Parser.C = C;
	
	module.exports = Parser;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	 * Konva JavaScript Framework v1.7.6
	 * http://konvajs.github.io/
	 * Licensed under the MIT or GPL Version 2 licenses.
	 * Date: Wed Nov 01 2017
	 *
	 * Original work Copyright (C) 2011 - 2013 by Eric Rowell (KineticJS)
	 * Modified work Copyright (C) 2014 - 2017 by Anton Lavrenov (Konva)
	 *
	 * @license
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 * THE SOFTWARE.
	 */
	
	// runtime check for already included Konva
	(function() {
	  'use strict';
	  /**
	     * @namespace Konva
	     */
	
	  var PI_OVER_180 = Math.PI / 180;
	
	  var Konva = {
	    // public
	    version: '1.7.6',
	
	    // private
	    stages: [],
	    idCounter: 0,
	    ids: {},
	    names: {},
	    shapes: {},
	    listenClickTap: false,
	    inDblClickWindow: false,
	
	    isBrowser:
	      typeof window !== 'undefined' &&
	      // browser case
	      ({}.toString.call(window) === '[object Window]' ||
	        // electron case
	        {}.toString.call(window) === '[object global]'),
	
	    // configurations
	    enableTrace: false,
	    traceArrMax: 100,
	    dblClickWindow: 400,
	    /**
	         * Global pixel ratio configuration. KonvaJS automatically detect pixel ratio of current device.
	         * But you may override such property, if you want to use your value.
	         * @property pixelRatio
	         * @default undefined
	         * @memberof Konva
	         * @example
	         * Konva.pixelRatio = 1;
	         */
	    pixelRatio: undefined,
	    /**
	         * Drag distance property. If you start to drag a node you may want to wait until pointer is moved to some distance from start point,
	         * only then start dragging. Default is 3px.
	         * @property dragDistance
	         * @default 0
	         * @memberof Konva
	         * @example
	         * Konva.dragDistance = 10;
	         */
	    dragDistance: 3,
	    /**
	         * Use degree values for angle properties. You may set this property to false if you want to use radiant values.
	         * @property angleDeg
	         * @default true
	         * @memberof Konva
	         * @example
	         * node.rotation(45); // 45 degrees
	         * Konva.angleDeg = false;
	         * node.rotation(Math.PI / 2); // PI/2 radian
	         */
	    angleDeg: true,
	    /**
	         * Show different warnings about errors or wrong API usage
	         * @property showWarnings
	         * @default true
	         * @memberof Konva
	         * @example
	         * Konva.showWarnings = false;
	         */
	    showWarnings: true,
	
	    /**
	         * @namespace Filters
	         * @memberof Konva
	         */
	    Filters: {},
	
	    /**
	         * returns whether or not drag and drop is currently active
	         * @method
	         * @memberof Konva
	         */
	    isDragging: function() {
	      var dd = Konva.DD;
	
	      // if DD is not included with the build, then
	      // drag and drop is not even possible
	      if (dd) {
	        return dd.isDragging;
	      }
	      return false;
	    },
	    /**
	        * returns whether or not a drag and drop operation is ready, but may
	        *  not necessarily have started
	        * @method
	        * @memberof Konva
	        */
	    isDragReady: function() {
	      var dd = Konva.DD;
	
	      // if DD is not included with the build, then
	      // drag and drop is not even possible
	      if (dd) {
	        return !!dd.node;
	      }
	      return false;
	    },
	    _addId: function(node, id) {
	      if (id !== undefined) {
	        this.ids[id] = node;
	      }
	    },
	    _removeId: function(id) {
	      if (id !== undefined) {
	        delete this.ids[id];
	      }
	    },
	    _addName: function(node, name) {
	      if (name) {
	        if (!this.names[name]) {
	          this.names[name] = [];
	        }
	        this.names[name].push(node);
	      }
	    },
	    _removeName: function(name, _id) {
	      if (!name) {
	        return;
	      }
	      var nodes = this.names[name];
	      if (!nodes) {
	        return;
	      }
	      for (var n = 0; n < nodes.length; n++) {
	        var no = nodes[n];
	        if (no._id === _id) {
	          nodes.splice(n, 1);
	        }
	      }
	      if (nodes.length === 0) {
	        delete this.names[name];
	      }
	    },
	    getAngle: function(angle) {
	      return this.angleDeg ? angle * PI_OVER_180 : angle;
	    },
	    _detectIE: function(ua) {
	      var msie = ua.indexOf('msie ');
	      if (msie > 0) {
	        // IE 10 or older => return version number
	        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	      }
	
	      var trident = ua.indexOf('trident/');
	      if (trident > 0) {
	        // IE 11 => return version number
	        var rv = ua.indexOf('rv:');
	        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	      }
	
	      var edge = ua.indexOf('edge/');
	      if (edge > 0) {
	        // Edge (IE 12+) => return version number
	        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	      }
	
	      // other browser
	      return false;
	    },
	    _parseUA: function(userAgent) {
	      var ua = userAgent.toLowerCase(),
	        // jQuery UA regex
	        match =
	          /(chrome)[ /]([\w.]+)/.exec(ua) ||
	          /(webkit)[ /]([\w.]+)/.exec(ua) ||
	          /(opera)(?:.*version|)[ /]([\w.]+)/.exec(ua) ||
	          /(msie) ([\w.]+)/.exec(ua) ||
	          (ua.indexOf('compatible') < 0 &&
	            /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua)) ||
	          [],
	        // adding mobile flag as well
	        mobile = !!userAgent.match(
	          /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i
	        ),
	        ieMobile = !!userAgent.match(/IEMobile/i);
	
	      return {
	        browser: match[1] || '',
	        version: match[2] || '0',
	        isIE: Konva._detectIE(ua),
	        // adding mobile flab
	        mobile: mobile,
	        ieMobile: ieMobile // If this is true (i.e., WP8), then Konva touch events are executed instead of equivalent Konva mouse events
	      };
	    },
	    // user agent
	    UA: undefined
	  };
	
	  var glob =
	    typeof global !== 'undefined'
	      ? global
	      : typeof window !== 'undefined'
	        ? window
	        : typeof WorkerGlobalScope !== 'undefined' ? self : {};
	
	  Konva.UA = Konva._parseUA((glob.navigator && glob.navigator.userAgent) || '');
	
	  if (glob.Konva) {
	    console.error(
	      'Konva instance is already exist in current eviroment. ' +
	        'Please use only one instance.'
	    );
	  }
	  glob.Konva = Konva;
	  Konva.global = glob;
	  Konva.window = glob;
	  Konva.document = glob.document;
	
	  if (true) {
	    module.exports = Konva;
	  } else if (typeof define === 'function' && define.amd) {
	    // AMD. Register as an anonymous module.
	    define(function() {
	      return Konva;
	    });
	  }
	})();
	
	/*eslint-disable  eqeqeq, no-cond-assign, no-empty*/
	(function() {
	  'use strict';
	  /**
	     * Collection constructor.  Collection extends
	     *  Array.  This class is used in conjunction with {@link Konva.Container#get}
	     * @constructor
	     * @memberof Konva
	     */
	  Konva.Collection = function() {
	    var args = [].slice.call(arguments),
	      length = args.length,
	      i = 0;
	
	    this.length = length;
	    for (; i < length; i++) {
	      this[i] = args[i];
	    }
	    return this;
	  };
	  Konva.Collection.prototype = [];
	  /**
	     * iterate through node array and run a function for each node.
	     *  The node and index is passed into the function
	     * @method
	     * @memberof Konva.Collection.prototype
	     * @param {Function} func
	     * @example
	     * // get all nodes with name foo inside layer, and set x to 10 for each
	     * layer.get('.foo').each(function(shape, n) {
	     *   shape.setX(10);
	     * });
	     */
	  Konva.Collection.prototype.each = function(func) {
	    for (var n = 0; n < this.length; n++) {
	      func(this[n], n);
	    }
	  };
	  /**
	     * convert collection into an array
	     * @method
	     * @memberof Konva.Collection.prototype
	     */
	  Konva.Collection.prototype.toArray = function() {
	    var arr = [],
	      len = this.length,
	      n;
	
	    for (n = 0; n < len; n++) {
	      arr.push(this[n]);
	    }
	    return arr;
	  };
	  /**
	     * convert array into a collection
	     * @method
	     * @memberof Konva.Collection
	     * @param {Array} arr
	     */
	  Konva.Collection.toCollection = function(arr) {
	    var collection = new Konva.Collection(),
	      len = arr.length,
	      n;
	
	    for (n = 0; n < len; n++) {
	      collection.push(arr[n]);
	    }
	    return collection;
	  };
	
	  // map one method by it's name
	  Konva.Collection._mapMethod = function(methodName) {
	    Konva.Collection.prototype[methodName] = function() {
	      var len = this.length,
	        i;
	
	      var args = [].slice.call(arguments);
	      for (i = 0; i < len; i++) {
	        this[i][methodName].apply(this[i], args);
	      }
	
	      return this;
	    };
	  };
	
	  Konva.Collection.mapMethods = function(constructor) {
	    var prot = constructor.prototype;
	    for (var methodName in prot) {
	      Konva.Collection._mapMethod(methodName);
	    }
	  };
	
	  /*
	    * Last updated November 2011
	    * By Simon Sarris
	    * www.simonsarris.com
	    * sarris@acm.org
	    *
	    * Free to use and distribute at will
	    * So long as you are nice to people, etc
	    */
	
	  /*
	    * The usage of this class was inspired by some of the work done by a forked
	    * project, KineticJS-Ext by Wappworks, which is based on Simon's Transform
	    * class.  Modified by Eric Rowell
	    */
	
	  /**
	     * Transform constructor
	     * @constructor
	     * @param {Array} [m] Optional six-element matrix
	     * @memberof Konva
	     */
	  Konva.Transform = function(m) {
	    this.m = (m && m.slice()) || [1, 0, 0, 1, 0, 0];
	  };
	
	  Konva.Transform.prototype = {
	    /**
	         * Copy Konva.Transform object
	         * @method
	         * @memberof Konva.Transform.prototype
	         * @returns {Konva.Transform}
	         */
	    copy: function() {
	      return new Konva.Transform(this.m);
	    },
	    /**
	         * Transform point
	         * @method
	         * @memberof Konva.Transform.prototype
	         * @param {Object} point 2D point(x, y)
	         * @returns {Object} 2D point(x, y)
	         */
	    point: function(point) {
	      var m = this.m;
	      return {
	        x: m[0] * point.x + m[2] * point.y + m[4],
	        y: m[1] * point.x + m[3] * point.y + m[5]
	      };
	    },
	    /**
	         * Apply translation
	         * @method
	         * @memberof Konva.Transform.prototype
	         * @param {Number} x
	         * @param {Number} y
	         * @returns {Konva.Transform}
	         */
	    translate: function(x, y) {
	      this.m[4] += this.m[0] * x + this.m[2] * y;
	      this.m[5] += this.m[1] * x + this.m[3] * y;
	      return this;
	    },
	    /**
	         * Apply scale
	         * @method
	         * @memberof Konva.Transform.prototype
	         * @param {Number} sx
	         * @param {Number} sy
	         * @returns {Konva.Transform}
	         */
	    scale: function(sx, sy) {
	      this.m[0] *= sx;
	      this.m[1] *= sx;
	      this.m[2] *= sy;
	      this.m[3] *= sy;
	      return this;
	    },
	    /**
	         * Apply rotation
	         * @method
	         * @memberof Konva.Transform.prototype
	         * @param {Number} rad  Angle in radians
	         * @returns {Konva.Transform}
	         */
	    rotate: function(rad) {
	      var c = Math.cos(rad);
	      var s = Math.sin(rad);
	      var m11 = this.m[0] * c + this.m[2] * s;
	      var m12 = this.m[1] * c + this.m[3] * s;
	      var m21 = this.m[0] * -s + this.m[2] * c;
	      var m22 = this.m[1] * -s + this.m[3] * c;
	      this.m[0] = m11;
	      this.m[1] = m12;
	      this.m[2] = m21;
	      this.m[3] = m22;
	      return this;
	    },
	    /**
	         * Returns the translation
	         * @method
	         * @memberof Konva.Transform.prototype
	         * @returns {Object} 2D point(x, y)
	         */
	    getTranslation: function() {
	      return {
	        x: this.m[4],
	        y: this.m[5]
	      };
	    },
	    /**
	         * Apply skew
	         * @method
	         * @memberof Konva.Transform.prototype
	         * @param {Number} sx
	         * @param {Number} sy
	         * @returns {Konva.Transform}
	         */
	    skew: function(sx, sy) {
	      var m11 = this.m[0] + this.m[2] * sy;
	      var m12 = this.m[1] + this.m[3] * sy;
	      var m21 = this.m[2] + this.m[0] * sx;
	      var m22 = this.m[3] + this.m[1] * sx;
	      this.m[0] = m11;
	      this.m[1] = m12;
	      this.m[2] = m21;
	      this.m[3] = m22;
	      return this;
	    },
	    /**
	         * Transform multiplication
	         * @method
	         * @memberof Konva.Transform.prototype
	         * @param {Konva.Transform} matrix
	         * @returns {Konva.Transform}
	         */
	    multiply: function(matrix) {
	      var m11 = this.m[0] * matrix.m[0] + this.m[2] * matrix.m[1];
	      var m12 = this.m[1] * matrix.m[0] + this.m[3] * matrix.m[1];
	
	      var m21 = this.m[0] * matrix.m[2] + this.m[2] * matrix.m[3];
	      var m22 = this.m[1] * matrix.m[2] + this.m[3] * matrix.m[3];
	
	      var dx = this.m[0] * matrix.m[4] + this.m[2] * matrix.m[5] + this.m[4];
	      var dy = this.m[1] * matrix.m[4] + this.m[3] * matrix.m[5] + this.m[5];
	
	      this.m[0] = m11;
	      this.m[1] = m12;
	      this.m[2] = m21;
	      this.m[3] = m22;
	      this.m[4] = dx;
	      this.m[5] = dy;
	      return this;
	    },
	    /**
	         * Invert the matrix
	         * @method
	         * @memberof Konva.Transform.prototype
	         * @returns {Konva.Transform}
	         */
	    invert: function() {
	      var d = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]);
	      var m0 = this.m[3] * d;
	      var m1 = -this.m[1] * d;
	      var m2 = -this.m[2] * d;
	      var m3 = this.m[0] * d;
	      var m4 = d * (this.m[2] * this.m[5] - this.m[3] * this.m[4]);
	      var m5 = d * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
	      this.m[0] = m0;
	      this.m[1] = m1;
	      this.m[2] = m2;
	      this.m[3] = m3;
	      this.m[4] = m4;
	      this.m[5] = m5;
	      return this;
	    },
	    /**
	         * return matrix
	         * @method
	         * @memberof Konva.Transform.prototype
	         */
	    getMatrix: function() {
	      return this.m;
	    },
	    /**
	         * set to absolute position via translation
	         * @method
	         * @memberof Konva.Transform.prototype
	         * @returns {Konva.Transform}
	         * @author ericdrowell
	         */
	    setAbsolutePosition: function(x, y) {
	      var m0 = this.m[0],
	        m1 = this.m[1],
	        m2 = this.m[2],
	        m3 = this.m[3],
	        m4 = this.m[4],
	        m5 = this.m[5],
	        yt = (m0 * (y - m5) - m1 * (x - m4)) / (m0 * m3 - m1 * m2),
	        xt = (x - m4 - m2 * yt) / m0;
	
	      return this.translate(xt, yt);
	    }
	  };
	
	  // CONSTANTS
	  var CONTEXT_2D = '2d',
	    OBJECT_ARRAY = '[object Array]',
	    OBJECT_NUMBER = '[object Number]',
	    OBJECT_STRING = '[object String]',
	    PI_OVER_DEG180 = Math.PI / 180,
	    DEG180_OVER_PI = 180 / Math.PI,
	    HASH = '#',
	    EMPTY_STRING = '',
	    ZERO = '0',
	    KONVA_WARNING = 'Konva warning: ',
	    KONVA_ERROR = 'Konva error: ',
	    RGB_PAREN = 'rgb(',
	    COLORS = {
	      aliceblue: [240, 248, 255],
	      antiquewhite: [250, 235, 215],
	      aqua: [0, 255, 255],
	      aquamarine: [127, 255, 212],
	      azure: [240, 255, 255],
	      beige: [245, 245, 220],
	      bisque: [255, 228, 196],
	      black: [0, 0, 0],
	      blanchedalmond: [255, 235, 205],
	      blue: [0, 0, 255],
	      blueviolet: [138, 43, 226],
	      brown: [165, 42, 42],
	      burlywood: [222, 184, 135],
	      cadetblue: [95, 158, 160],
	      chartreuse: [127, 255, 0],
	      chocolate: [210, 105, 30],
	      coral: [255, 127, 80],
	      cornflowerblue: [100, 149, 237],
	      cornsilk: [255, 248, 220],
	      crimson: [220, 20, 60],
	      cyan: [0, 255, 255],
	      darkblue: [0, 0, 139],
	      darkcyan: [0, 139, 139],
	      darkgoldenrod: [184, 132, 11],
	      darkgray: [169, 169, 169],
	      darkgreen: [0, 100, 0],
	      darkgrey: [169, 169, 169],
	      darkkhaki: [189, 183, 107],
	      darkmagenta: [139, 0, 139],
	      darkolivegreen: [85, 107, 47],
	      darkorange: [255, 140, 0],
	      darkorchid: [153, 50, 204],
	      darkred: [139, 0, 0],
	      darksalmon: [233, 150, 122],
	      darkseagreen: [143, 188, 143],
	      darkslateblue: [72, 61, 139],
	      darkslategray: [47, 79, 79],
	      darkslategrey: [47, 79, 79],
	      darkturquoise: [0, 206, 209],
	      darkviolet: [148, 0, 211],
	      deeppink: [255, 20, 147],
	      deepskyblue: [0, 191, 255],
	      dimgray: [105, 105, 105],
	      dimgrey: [105, 105, 105],
	      dodgerblue: [30, 144, 255],
	      firebrick: [178, 34, 34],
	      floralwhite: [255, 255, 240],
	      forestgreen: [34, 139, 34],
	      fuchsia: [255, 0, 255],
	      gainsboro: [220, 220, 220],
	      ghostwhite: [248, 248, 255],
	      gold: [255, 215, 0],
	      goldenrod: [218, 165, 32],
	      gray: [128, 128, 128],
	      green: [0, 128, 0],
	      greenyellow: [173, 255, 47],
	      grey: [128, 128, 128],
	      honeydew: [240, 255, 240],
	      hotpink: [255, 105, 180],
	      indianred: [205, 92, 92],
	      indigo: [75, 0, 130],
	      ivory: [255, 255, 240],
	      khaki: [240, 230, 140],
	      lavender: [230, 230, 250],
	      lavenderblush: [255, 240, 245],
	      lawngreen: [124, 252, 0],
	      lemonchiffon: [255, 250, 205],
	      lightblue: [173, 216, 230],
	      lightcoral: [240, 128, 128],
	      lightcyan: [224, 255, 255],
	      lightgoldenrodyellow: [250, 250, 210],
	      lightgray: [211, 211, 211],
	      lightgreen: [144, 238, 144],
	      lightgrey: [211, 211, 211],
	      lightpink: [255, 182, 193],
	      lightsalmon: [255, 160, 122],
	      lightseagreen: [32, 178, 170],
	      lightskyblue: [135, 206, 250],
	      lightslategray: [119, 136, 153],
	      lightslategrey: [119, 136, 153],
	      lightsteelblue: [176, 196, 222],
	      lightyellow: [255, 255, 224],
	      lime: [0, 255, 0],
	      limegreen: [50, 205, 50],
	      linen: [250, 240, 230],
	      magenta: [255, 0, 255],
	      maroon: [128, 0, 0],
	      mediumaquamarine: [102, 205, 170],
	      mediumblue: [0, 0, 205],
	      mediumorchid: [186, 85, 211],
	      mediumpurple: [147, 112, 219],
	      mediumseagreen: [60, 179, 113],
	      mediumslateblue: [123, 104, 238],
	      mediumspringgreen: [0, 250, 154],
	      mediumturquoise: [72, 209, 204],
	      mediumvioletred: [199, 21, 133],
	      midnightblue: [25, 25, 112],
	      mintcream: [245, 255, 250],
	      mistyrose: [255, 228, 225],
	      moccasin: [255, 228, 181],
	      navajowhite: [255, 222, 173],
	      navy: [0, 0, 128],
	      oldlace: [253, 245, 230],
	      olive: [128, 128, 0],
	      olivedrab: [107, 142, 35],
	      orange: [255, 165, 0],
	      orangered: [255, 69, 0],
	      orchid: [218, 112, 214],
	      palegoldenrod: [238, 232, 170],
	      palegreen: [152, 251, 152],
	      paleturquoise: [175, 238, 238],
	      palevioletred: [219, 112, 147],
	      papayawhip: [255, 239, 213],
	      peachpuff: [255, 218, 185],
	      peru: [205, 133, 63],
	      pink: [255, 192, 203],
	      plum: [221, 160, 203],
	      powderblue: [176, 224, 230],
	      purple: [128, 0, 128],
	      rebeccapurple: [102, 51, 153],
	      red: [255, 0, 0],
	      rosybrown: [188, 143, 143],
	      royalblue: [65, 105, 225],
	      saddlebrown: [139, 69, 19],
	      salmon: [250, 128, 114],
	      sandybrown: [244, 164, 96],
	      seagreen: [46, 139, 87],
	      seashell: [255, 245, 238],
	      sienna: [160, 82, 45],
	      silver: [192, 192, 192],
	      skyblue: [135, 206, 235],
	      slateblue: [106, 90, 205],
	      slategray: [119, 128, 144],
	      slategrey: [119, 128, 144],
	      snow: [255, 255, 250],
	      springgreen: [0, 255, 127],
	      steelblue: [70, 130, 180],
	      tan: [210, 180, 140],
	      teal: [0, 128, 128],
	      thistle: [216, 191, 216],
	      transparent: [255, 255, 255, 0],
	      tomato: [255, 99, 71],
	      turquoise: [64, 224, 208],
	      violet: [238, 130, 238],
	      wheat: [245, 222, 179],
	      white: [255, 255, 255],
	      whitesmoke: [245, 245, 245],
	      yellow: [255, 255, 0],
	      yellowgreen: [154, 205, 5]
	    },
	    RGB_REGEX = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/;
	
	  /**
	     * @namespace Util
	     * @memberof Konva
	     */
	  Konva.Util = {
	    /*
	         * cherry-picked utilities from underscore.js
	         */
	    _isElement: function(obj) {
	      return !!(obj && obj.nodeType == 1);
	    },
	    _isFunction: function(obj) {
	      return !!(obj && obj.constructor && obj.call && obj.apply);
	    },
	    _isObject: function(obj) {
	      return !!obj && obj.constructor === Object;
	    },
	    _isArray: function(obj) {
	      return Object.prototype.toString.call(obj) === OBJECT_ARRAY;
	    },
	    _isNumber: function(obj) {
	      return Object.prototype.toString.call(obj) === OBJECT_NUMBER;
	    },
	    _isString: function(obj) {
	      return Object.prototype.toString.call(obj) === OBJECT_STRING;
	    },
	    // Returns a function, that, when invoked, will only be triggered at most once
	    // during a given window of time. Normally, the throttled function will run
	    // as much as it can, without ever going more than once per `wait` duration;
	    // but if you'd like to disable the execution on the leading edge, pass
	    // `{leading: false}`. To disable execution on the trailing edge, ditto.
	    _throttle: function(func, wait, opts) {
	      var context, args, result;
	      var timeout = null;
	      var previous = 0;
	      var options = opts || {};
	      var later = function() {
	        previous = options.leading === false ? 0 : new Date().getTime();
	        timeout = null;
	        result = func.apply(context, args);
	        context = args = null;
	      };
	      return function() {
	        var now = new Date().getTime();
	        if (!previous && options.leading === false) {
	          previous = now;
	        }
	        var remaining = wait - (now - previous);
	        context = this;
	        args = arguments;
	        if (remaining <= 0) {
	          clearTimeout(timeout);
	          timeout = null;
	          previous = now;
	          result = func.apply(context, args);
	          context = args = null;
	        } else if (!timeout && options.trailing !== false) {
	          timeout = setTimeout(later, remaining);
	        }
	        return result;
	      };
	    },
	    /*
	         * other utils
	         */
	    _hasMethods: function(obj) {
	      var names = [],
	        key;
	
	      for (key in obj) {
	        if (!obj.hasOwnProperty(key)) {
	          continue;
	        }
	        if (this._isFunction(obj[key])) {
	          names.push(key);
	        }
	      }
	      return names.length > 0;
	    },
	    isValidSelector: function(selector) {
	      if (typeof selector !== 'string') {
	        return false;
	      }
	      var firstChar = selector[0];
	      return (
	        firstChar === '#' ||
	        firstChar === '.' ||
	        firstChar === firstChar.toUpperCase()
	      );
	    },
	    createCanvasElement: function() {
	      var canvas = Konva.isBrowser
	        ? Konva.document.createElement('canvas')
	        : new Konva._nodeCanvas();
	      // on some environments canvas.style is readonly
	      try {
	        canvas.style = canvas.style || {};
	      } catch (e) {}
	      return canvas;
	    },
	    _isInDocument: function(el) {
	      while ((el = el.parentNode)) {
	        if (el == Konva.document) {
	          return true;
	        }
	      }
	      return false;
	    },
	    _simplifyArray: function(arr) {
	      var retArr = [],
	        len = arr.length,
	        util = Konva.Util,
	        n,
	        val;
	
	      for (n = 0; n < len; n++) {
	        val = arr[n];
	        if (util._isNumber(val)) {
	          val = Math.round(val * 1000) / 1000;
	        } else if (!util._isString(val)) {
	          val = val.toString();
	        }
	
	        retArr.push(val);
	      }
	
	      return retArr;
	    },
	    /*
	         * arg can be an image object or image data
	         */
	    _getImage: function(arg, callback) {
	      var imageObj, canvas;
	
	      // if arg is null or undefined
	      if (!arg) {
	        callback(null);
	      } else if (this._isElement(arg)) {
	        // if arg is already an image object
	        callback(arg);
	      } else if (this._isString(arg)) {
	        // if arg is a string, then it's a data url
	        imageObj = new Konva.window.Image();
	        imageObj.onload = function() {
	          callback(imageObj);
	        };
	        imageObj.src = arg;
	      } else if (arg.data) {
	        //if arg is an object that contains the data property, it's an image object
	        canvas = Konva.Util.createCanvasElement();
	        canvas.width = arg.width;
	        canvas.height = arg.height;
	        var _context = canvas.getContext(CONTEXT_2D);
	        _context.putImageData(arg, 0, 0);
	        this._getImage(canvas.toDataURL(), callback);
	      } else {
	        callback(null);
	      }
	    },
	    _getRGBAString: function(obj) {
	      var red = obj.red || 0,
	        green = obj.green || 0,
	        blue = obj.blue || 0,
	        alpha = obj.alpha || 1;
	
	      return ['rgba(', red, ',', green, ',', blue, ',', alpha, ')'].join(
	        EMPTY_STRING
	      );
	    },
	    _rgbToHex: function(r, g, b) {
	      return ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
	    },
	    _hexToRgb: function(hex) {
	      hex = hex.replace(HASH, EMPTY_STRING);
	      var bigint = parseInt(hex, 16);
	      return {
	        r: (bigint >> 16) & 255,
	        g: (bigint >> 8) & 255,
	        b: bigint & 255
	      };
	    },
	    /**
	         * return random hex color
	         * @method
	         * @memberof Konva.Util.prototype
	         */
	    getRandomColor: function() {
	      var randColor = ((Math.random() * 0xffffff) << 0).toString(16);
	      while (randColor.length < 6) {
	        randColor = ZERO + randColor;
	      }
	      return HASH + randColor;
	    },
	    /**
	         * return value with default fallback
	         * @method
	         * @memberof Konva.Util.prototype
	         */
	    get: function(val, def) {
	      if (val === undefined) {
	        return def;
	      } else {
	        return val;
	      }
	    },
	    /**
	         * get RGB components of a color
	         * @method
	         * @memberof Konva.Util.prototype
	         * @param {String} color
	         * @example
	         * // each of the following examples return {r:0, g:0, b:255}
	         * var rgb = Konva.Util.getRGB('blue');
	         * var rgb = Konva.Util.getRGB('#0000ff');
	         * var rgb = Konva.Util.getRGB('rgb(0,0,255)');
	         */
	    getRGB: function(color) {
	      var rgb;
	      // color string
	      if (color in COLORS) {
	        rgb = COLORS[color];
	        return {
	          r: rgb[0],
	          g: rgb[1],
	          b: rgb[2]
	        };
	      } else if (color[0] === HASH) {
	        // hex
	        return this._hexToRgb(color.substring(1));
	      } else if (color.substr(0, 4) === RGB_PAREN) {
	        // rgb string
	        rgb = RGB_REGEX.exec(color.replace(/ /g, ''));
	        return {
	          r: parseInt(rgb[1], 10),
	          g: parseInt(rgb[2], 10),
	          b: parseInt(rgb[3], 10)
	        };
	      } else {
	        // default
	        return {
	          r: 0,
	          g: 0,
	          b: 0
	        };
	      }
	    },
	    // convert any color string to RGBA object
	    // from https://github.com/component/color-parser
	    colorToRGBA: function(str) {
	      str = str || 'black';
	      return (
	        Konva.Util._namedColorToRBA(str) ||
	        Konva.Util._hex3ColorToRGBA(str) ||
	        Konva.Util._hex6ColorToRGBA(str) ||
	        Konva.Util._rgbColorToRGBA(str) ||
	        Konva.Util._rgbaColorToRGBA(str)
	      );
	    },
	    // Parse named css color. Like "green"
	    _namedColorToRBA: function(str) {
	      var c = COLORS[str.toLowerCase()];
	      if (!c) {
	        return null;
	      }
	      return {
	        r: c[0],
	        g: c[1],
	        b: c[2],
	        a: 1
	      };
	    },
	    // Parse rgb(n, n, n)
	    _rgbColorToRGBA: function(str) {
	      if (str.indexOf('rgb(') === 0) {
	        str = str.match(/rgb\(([^)]+)\)/)[1];
	        var parts = str.split(/ *, */).map(Number);
	        return {
	          r: parts[0],
	          g: parts[1],
	          b: parts[2],
	          a: 1
	        };
	      }
	    },
	    // Parse rgba(n, n, n, n)
	    _rgbaColorToRGBA: function(str) {
	      if (str.indexOf('rgba(') === 0) {
	        str = str.match(/rgba\(([^)]+)\)/)[1];
	        var parts = str.split(/ *, */).map(Number);
	        return {
	          r: parts[0],
	          g: parts[1],
	          b: parts[2],
	          a: parts[3]
	        };
	      }
	    },
	    // Parse #nnnnnn
	    _hex6ColorToRGBA: function(str) {
	      if (str[0] === '#' && str.length === 7) {
	        return {
	          r: parseInt(str.slice(1, 3), 16),
	          g: parseInt(str.slice(3, 5), 16),
	          b: parseInt(str.slice(5, 7), 16),
	          a: 1
	        };
	      }
	    },
	    // Parse #nnn
	    _hex3ColorToRGBA: function(str) {
	      if (str[0] === '#' && str.length === 4) {
	        return {
	          r: parseInt(str[1] + str[1], 16),
	          g: parseInt(str[2] + str[2], 16),
	          b: parseInt(str[3] + str[3], 16),
	          a: 1
	        };
	      }
	    },
	    // o1 takes precedence over o2
	    _merge: function(o1, o2) {
	      var retObj = this._clone(o2);
	      for (var key in o1) {
	        if (this._isObject(o1[key])) {
	          retObj[key] = this._merge(o1[key], retObj[key]);
	        } else {
	          retObj[key] = o1[key];
	        }
	      }
	      return retObj;
	    },
	    cloneObject: function(obj) {
	      var retObj = {};
	      for (var key in obj) {
	        if (this._isObject(obj[key])) {
	          retObj[key] = this.cloneObject(obj[key]);
	        } else if (this._isArray(obj[key])) {
	          retObj[key] = this.cloneArray(obj[key]);
	        } else {
	          retObj[key] = obj[key];
	        }
	      }
	      return retObj;
	    },
	    cloneArray: function(arr) {
	      return arr.slice(0);
	    },
	    _degToRad: function(deg) {
	      return deg * PI_OVER_DEG180;
	    },
	    _radToDeg: function(rad) {
	      return rad * DEG180_OVER_PI;
	    },
	    _capitalize: function(str) {
	      return str.charAt(0).toUpperCase() + str.slice(1);
	    },
	    throw: function(str) {
	      throw new Error(KONVA_ERROR + str);
	    },
	    error: function(str) {
	      console.error(KONVA_ERROR + str);
	    },
	    warn: function(str) {
	      /*
	             * IE9 on Windows7 64bit will throw a JS error
	             * if we don't use window.console in the conditional
	             */
	      if (Konva.global.console && console.warn && Konva.showWarnings) {
	        console.warn(KONVA_WARNING + str);
	      }
	    },
	    extend: function(child, parent) {
	      function Ctor() {
	        this.constructor = child;
	      }
	      Ctor.prototype = parent.prototype;
	      var oldProto = child.prototype;
	      child.prototype = new Ctor();
	      for (var key in oldProto) {
	        if (oldProto.hasOwnProperty(key)) {
	          child.prototype[key] = oldProto[key];
	        }
	      }
	      child.__super__ = parent.prototype;
	      // create reference to parent
	      child.super = parent;
	    },
	    /**
	         * adds methods to a constructor prototype
	         * @method
	         * @memberof Konva.Util.prototype
	         * @param {Function} constructor
	         * @param {Object} methods
	         */
	    addMethods: function(constructor, methods) {
	      var key;
	
	      for (key in methods) {
	        constructor.prototype[key] = methods[key];
	      }
	    },
	    _getControlPoints: function(x0, y0, x1, y1, x2, y2, t) {
	      var d01 = Math.sqrt(Math.pow(x1 - x0, 2) + Math.pow(y1 - y0, 2)),
	        d12 = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)),
	        fa = t * d01 / (d01 + d12),
	        fb = t * d12 / (d01 + d12),
	        p1x = x1 - fa * (x2 - x0),
	        p1y = y1 - fa * (y2 - y0),
	        p2x = x1 + fb * (x2 - x0),
	        p2y = y1 + fb * (y2 - y0);
	
	      return [p1x, p1y, p2x, p2y];
	    },
	    _expandPoints: function(p, tension) {
	      var len = p.length,
	        allPoints = [],
	        n,
	        cp;
	
	      for (n = 2; n < len - 2; n += 2) {
	        cp = Konva.Util._getControlPoints(
	          p[n - 2],
	          p[n - 1],
	          p[n],
	          p[n + 1],
	          p[n + 2],
	          p[n + 3],
	          tension
	        );
	        allPoints.push(cp[0]);
	        allPoints.push(cp[1]);
	        allPoints.push(p[n]);
	        allPoints.push(p[n + 1]);
	        allPoints.push(cp[2]);
	        allPoints.push(cp[3]);
	      }
	
	      return allPoints;
	    },
	    _removeLastLetter: function(str) {
	      return str.substring(0, str.length - 1);
	    },
	    each: function(obj, func) {
	      for (var key in obj) {
	        func(key, obj[key]);
	      }
	    },
	    _getProjectionToSegment: function(x1, y1, x2, y2, x3, y3) {
	      var x, y, dist;
	
	      var pd2 = (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
	      if (pd2 == 0) {
	        x = x1;
	        y = y1;
	        dist = (x3 - x2) * (x3 - x2) + (y3 - y2) * (y3 - y2);
	      } else {
	        var u = ((x3 - x1) * (x2 - x1) + (y3 - y1) * (y2 - y1)) / pd2;
	        if (u < 0) {
	          x = x1;
	          y = y1;
	          dist = (x1 - x3) * (x1 - x3) + (y1 - y3) * (y1 - y3);
	        } else if (u > 1.0) {
	          x = x2;
	          y = y2;
	          dist = (x2 - x3) * (x2 - x3) + (y2 - y3) * (y2 - y3);
	        } else {
	          x = x1 + u * (x2 - x1);
	          y = y1 + u * (y2 - y1);
	          dist = (x - x3) * (x - x3) + (y - y3) * (y - y3);
	        }
	      }
	      return [x, y, dist];
	    },
	    // line as array of points.
	    // line might be closed
	    _getProjectionToLine: function(pt, line, isClosed) {
	      var pc = Konva.Util.cloneObject(pt);
	      var dist = Number.MAX_VALUE;
	      line.forEach(function(p1, i) {
	        if (!isClosed && i === line.length - 1) {
	          return;
	        }
	        var p2 = line[(i + 1) % line.length];
	        var proj = Konva.Util._getProjectionToSegment(
	          p1.x,
	          p1.y,
	          p2.x,
	          p2.y,
	          pt.x,
	          pt.y
	        );
	        var px = proj[0],
	          py = proj[1],
	          pdist = proj[2];
	        if (pdist < dist) {
	          pc.x = px;
	          pc.y = py;
	          dist = pdist;
	        }
	      });
	      return pc;
	    },
	    _prepareArrayForTween: function(startArray, endArray, isClosed) {
	      var n,
	        start = [],
	        end = [];
	      if (startArray.length > endArray.length) {
	        var temp = endArray;
	        endArray = startArray;
	        startArray = temp;
	      }
	      for (n = 0; n < startArray.length; n += 2) {
	        start.push({
	          x: startArray[n],
	          y: startArray[n + 1]
	        });
	      }
	      for (n = 0; n < endArray.length; n += 2) {
	        end.push({
	          x: endArray[n],
	          y: endArray[n + 1]
	        });
	      }
	
	      var newStart = [];
	      end.forEach(function(point) {
	        var pr = Konva.Util._getProjectionToLine(point, start, isClosed);
	        newStart.push(pr.x);
	        newStart.push(pr.y);
	      });
	      return newStart;
	    },
	    _prepareToStringify: function(obj) {
	      var desc;
	
	      obj.visitedByCircularReferenceRemoval = true;
	
	      for (var key in obj) {
	        if (
	          !(obj.hasOwnProperty(key) && obj[key] && typeof obj[key] == 'object')
	        ) {
	          continue;
	        }
	        desc = Object.getOwnPropertyDescriptor(obj, key);
	        if (
	          obj[key].visitedByCircularReferenceRemoval ||
	          Konva.Util._isElement(obj[key])
	        ) {
	          if (desc.configurable) {
	            delete obj[key];
	          } else {
	            return null;
	          }
	        } else if (Konva.Util._prepareToStringify(obj[key]) === null) {
	          if (desc.configurable) {
	            delete obj[key];
	          } else {
	            return null;
	          }
	        }
	      }
	
	      delete obj.visitedByCircularReferenceRemoval;
	
	      return obj;
	    }
	  };
	})();
	
	(function() {
	  'use strict';
	  // calculate pixel ratio
	
	  var _pixelRatio;
	  function getDevicePixelRatio() {
	    if (_pixelRatio) {
	      return _pixelRatio;
	    }
	    var canvas = Konva.Util.createCanvasElement();
	    var context = canvas.getContext('2d');
	    _pixelRatio = (function() {
	      var devicePixelRatio = Konva.window.devicePixelRatio || 1,
	        backingStoreRatio =
	          context.webkitBackingStorePixelRatio ||
	          context.mozBackingStorePixelRatio ||
	          context.msBackingStorePixelRatio ||
	          context.oBackingStorePixelRatio ||
	          context.backingStorePixelRatio ||
	          1;
	      return devicePixelRatio / backingStoreRatio;
	    })();
	    return _pixelRatio;
	  }
	
	  /**
	     * Canvas Renderer constructor
	     * @constructor
	     * @abstract
	     * @memberof Konva
	     * @param {Object} config
	     * @param {Number} config.width
	     * @param {Number} config.height
	     * @param {Number} config.pixelRatio KonvaJS automatically handles pixel ratio adjustments in order to render crisp drawings
	     *  on all devices. Most desktops, low end tablets, and low end phones, have device pixel ratios
	     *  of 1.  Some high end tablets and phones, like iPhones and iPads (not the mini) have a device pixel ratio
	     *  of 2.  Some Macbook Pros, and iMacs also have a device pixel ratio of 2.  Some high end Android devices have pixel
	     *  ratios of 2 or 3.  Some browsers like Firefox allow you to configure the pixel ratio of the viewport.  Unless otherwise
	     *  specified, the pixel ratio will be defaulted to the actual device pixel ratio.  You can override the device pixel
	     *  ratio for special situations, or, if you don't want the pixel ratio to be taken into account, you can set it to 1.
	     */
	  Konva.Canvas = function(config) {
	    this.init(config);
	  };
	
	  Konva.Canvas.prototype = {
	    init: function(config) {
	      var conf = config || {};
	
	      var pixelRatio =
	        conf.pixelRatio || Konva.pixelRatio || getDevicePixelRatio();
	
	      this.pixelRatio = pixelRatio;
	      this._canvas = Konva.Util.createCanvasElement();
	
	      // set inline styles
	      this._canvas.style.padding = 0;
	      this._canvas.style.margin = 0;
	      this._canvas.style.border = 0;
	      this._canvas.style.background = 'transparent';
	      this._canvas.style.position = 'absolute';
	      this._canvas.style.top = 0;
	      this._canvas.style.left = 0;
	    },
	    /**
	         * get canvas context
	         * @method
	         * @memberof Konva.Canvas.prototype
	         * @returns {CanvasContext} context
	         */
	    getContext: function() {
	      return this.context;
	    },
	    /**
	         * get pixel ratio
	         * @method
	         * @memberof Konva.Canvas.prototype
	         * @returns {Number} pixel ratio
	         */
	    getPixelRatio: function() {
	      return this.pixelRatio;
	    },
	    /**
	         * get pixel ratio
	         * @method
	         * @memberof Konva.Canvas.prototype
	         * @param {Number} pixelRatio KonvaJS automatically handles pixel ratio adustments in order to render crisp drawings
	         *  on all devices. Most desktops, low end tablets, and low end phones, have device pixel ratios
	         *  of 1.  Some high end tablets and phones, like iPhones and iPads have a device pixel ratio
	         *  of 2.  Some Macbook Pros, and iMacs also have a device pixel ratio of 2.  Some high end Android devices have pixel
	         *  ratios of 2 or 3.  Some browsers like Firefox allow you to configure the pixel ratio of the viewport.  Unless otherwise
	         *  specificed, the pixel ratio will be defaulted to the actual device pixel ratio.  You can override the device pixel
	         *  ratio for special situations, or, if you don't want the pixel ratio to be taken into account, you can set it to 1.
	         */
	    setPixelRatio: function(pixelRatio) {
	      var previousRatio = this.pixelRatio;
	      this.pixelRatio = pixelRatio;
	      this.setSize(
	        this.getWidth() / previousRatio,
	        this.getHeight() / previousRatio
	      );
	    },
	    /**
	         * set width
	         * @method
	         * @memberof Konva.Canvas.prototype
	         * @param {Number} width
	         */
	    setWidth: function(width) {
	      // take into account pixel ratio
	      this.width = this._canvas.width = width * this.pixelRatio;
	      this._canvas.style.width = width + 'px';
	
	      var pixelRatio = this.pixelRatio,
	        _context = this.getContext()._context;
	      _context.scale(pixelRatio, pixelRatio);
	    },
	    /**
	         * set height
	         * @method
	         * @memberof Konva.Canvas.prototype
	         * @param {Number} height
	         */
	    setHeight: function(height) {
	      // take into account pixel ratio
	      this.height = this._canvas.height = height * this.pixelRatio;
	      this._canvas.style.height = height + 'px';
	      var pixelRatio = this.pixelRatio,
	        _context = this.getContext()._context;
	      _context.scale(pixelRatio, pixelRatio);
	    },
	    /**
	         * get width
	         * @method
	         * @memberof Konva.Canvas.prototype
	         * @returns {Number} width
	         */
	    getWidth: function() {
	      return this.width;
	    },
	    /**
	         * get height
	         * @method
	         * @memberof Konva.Canvas.prototype
	         * @returns {Number} height
	         */
	    getHeight: function() {
	      return this.height;
	    },
	    /**
	         * set size
	         * @method
	         * @memberof Konva.Canvas.prototype
	         * @param {Number} width
	         * @param {Number} height
	         */
	    setSize: function(width, height) {
	      this.setWidth(width);
	      this.setHeight(height);
	    },
	    /**
	         * to data url
	         * @method
	         * @memberof Konva.Canvas.prototype
	         * @param {String} mimeType
	         * @param {Number} quality between 0 and 1 for jpg mime types
	         * @returns {String} data url string
	         */
	    toDataURL: function(mimeType, quality) {
	      try {
	        // If this call fails (due to browser bug, like in Firefox 3.6),
	        // then revert to previous no-parameter image/png behavior
	        return this._canvas.toDataURL(mimeType, quality);
	      } catch (e) {
	        try {
	          return this._canvas.toDataURL();
	        } catch (err) {
	          Konva.Util.warn('Unable to get data URL. ' + err.message);
	          return '';
	        }
	      }
	    }
	  };
	
	  Konva.SceneCanvas = function(config) {
	    var conf = config || {};
	    var width = conf.width || 0,
	      height = conf.height || 0;
	
	    Konva.Canvas.call(this, conf);
	    this.context = new Konva.SceneContext(this);
	    this.setSize(width, height);
	  };
	
	  Konva.Util.extend(Konva.SceneCanvas, Konva.Canvas);
	
	  Konva.HitCanvas = function(config) {
	    var conf = config || {};
	    var width = conf.width || 0,
	      height = conf.height || 0;
	
	    Konva.Canvas.call(this, conf);
	    this.context = new Konva.HitContext(this);
	    this.setSize(width, height);
	    this.hitCanvas = true;
	  };
	  Konva.Util.extend(Konva.HitCanvas, Konva.Canvas);
	})();
	
	(function() {
	  'use strict';
	  var COMMA = ',',
	    OPEN_PAREN = '(',
	    CLOSE_PAREN = ')',
	    OPEN_PAREN_BRACKET = '([',
	    CLOSE_BRACKET_PAREN = '])',
	    SEMICOLON = ';',
	    DOUBLE_PAREN = '()',
	    // EMPTY_STRING = '',
	    EQUALS = '=',
	    // SET = 'set',
	    CONTEXT_METHODS = [
	      'arc',
	      'arcTo',
	      'beginPath',
	      'bezierCurveTo',
	      'clearRect',
	      'clip',
	      'closePath',
	      'createLinearGradient',
	      'createPattern',
	      'createRadialGradient',
	      'drawImage',
	      'fill',
	      'fillText',
	      'getImageData',
	      'createImageData',
	      'lineTo',
	      'moveTo',
	      'putImageData',
	      'quadraticCurveTo',
	      'rect',
	      'restore',
	      'rotate',
	      'save',
	      'scale',
	      'setLineDash',
	      'setTransform',
	      'stroke',
	      'strokeText',
	      'transform',
	      'translate'
	    ];
	
	  var CONTEXT_PROPERTIES = [
	    'fillStyle',
	    'strokeStyle',
	    'shadowColor',
	    'shadowBlur',
	    'shadowOffsetX',
	    'shadowOffsetY',
	    'lineCap',
	    'lineDashOffset',
	    'lineJoin',
	    'lineWidth',
	    'miterLimit',
	    'font',
	    'textAlign',
	    'textBaseline',
	    'globalAlpha',
	    'globalCompositeOperation'
	  ];
	
	  /**
	     * Canvas Context constructor
	     * @constructor
	     * @abstract
	     * @memberof Konva
	     */
	  Konva.Context = function(canvas) {
	    this.init(canvas);
	  };
	
	  Konva.Context.prototype = {
	    init: function(canvas) {
	      this.canvas = canvas;
	      this._context = canvas._canvas.getContext('2d');
	
	      if (Konva.enableTrace) {
	        this.traceArr = [];
	        this._enableTrace();
	      }
	    },
	    /**
	         * fill shape
	         * @method
	         * @memberof Konva.Context.prototype
	         * @param {Konva.Shape} shape
	         */
	    fillShape: function(shape) {
	      if (shape.getFillEnabled()) {
	        this._fill(shape);
	      }
	    },
	    /**
	         * stroke shape
	         * @method
	         * @memberof Konva.Context.prototype
	         * @param {Konva.Shape} shape
	         */
	    strokeShape: function(shape) {
	      if (shape.getStrokeEnabled()) {
	        this._stroke(shape);
	      }
	    },
	    /**
	         * fill then stroke
	         * @method
	         * @memberof Konva.Context.prototype
	         * @param {Konva.Shape} shape
	         */
	    fillStrokeShape: function(shape) {
	      var fillEnabled = shape.getFillEnabled();
	      if (fillEnabled) {
	        this._fill(shape);
	      }
	      if (shape.getStrokeEnabled()) {
	        this._stroke(shape);
	      }
	    },
	    /**
	         * get context trace if trace is enabled
	         * @method
	         * @memberof Konva.Context.prototype
	         * @param {Boolean} relaxed if false, return strict context trace, which includes method names, method parameters
	         *  properties, and property values.  If true, return relaxed context trace, which only returns method names and
	         *  properites.
	         * @returns {String}
	         */
	    getTrace: function(relaxed) {
	      var traceArr = this.traceArr,
	        len = traceArr.length,
	        str = '',
	        n,
	        trace,
	        method,
	        args;
	
	      for (n = 0; n < len; n++) {
	        trace = traceArr[n];
	        method = trace.method;
	
	        // methods
	        if (method) {
	          args = trace.args;
	          str += method;
	          if (relaxed) {
	            str += DOUBLE_PAREN;
	          } else {
	            if (Konva.Util._isArray(args[0])) {
	              str +=
	                OPEN_PAREN_BRACKET + args.join(COMMA) + CLOSE_BRACKET_PAREN;
	            } else {
	              str += OPEN_PAREN + args.join(COMMA) + CLOSE_PAREN;
	            }
	          }
	        } else {
	          // properties
	          str += trace.property;
	          if (!relaxed) {
	            str += EQUALS + trace.val;
	          }
	        }
	
	        str += SEMICOLON;
	      }
	
	      return str;
	    },
	    /**
	         * clear trace if trace is enabled
	         * @method
	         * @memberof Konva.Context.prototype
	         */
	    clearTrace: function() {
	      this.traceArr = [];
	    },
	    _trace: function(str) {
	      var traceArr = this.traceArr, len;
	
	      traceArr.push(str);
	      len = traceArr.length;
	
	      if (len >= Konva.traceArrMax) {
	        traceArr.shift();
	      }
	    },
	    /**
	         * reset canvas context transform
	         * @method
	         * @memberof Konva.Context.prototype
	         */
	    reset: function() {
	      var pixelRatio = this.getCanvas().getPixelRatio();
	      this.setTransform(1 * pixelRatio, 0, 0, 1 * pixelRatio, 0, 0);
	    },
	    /**
	         * get canvas
	         * @method
	         * @memberof Konva.Context.prototype
	         * @returns {Konva.Canvas}
	         */
	    getCanvas: function() {
	      return this.canvas;
	    },
	    /**
	         * clear canvas
	         * @method
	         * @memberof Konva.Context.prototype
	         * @param {Object} [bounds]
	         * @param {Number} [bounds.x]
	         * @param {Number} [bounds.y]
	         * @param {Number} [bounds.width]
	         * @param {Number} [bounds.height]
	         */
	    clear: function(bounds) {
	      var canvas = this.getCanvas();
	
	      if (bounds) {
	        this.clearRect(
	          bounds.x || 0,
	          bounds.y || 0,
	          bounds.width || 0,
	          bounds.height || 0
	        );
	      } else {
	        this.clearRect(
	          0,
	          0,
	          canvas.getWidth() / canvas.pixelRatio,
	          canvas.getHeight() / canvas.pixelRatio
	        );
	      }
	    },
	    _applyLineCap: function(shape) {
	      var lineCap = shape.getLineCap();
	      if (lineCap) {
	        this.setAttr('lineCap', lineCap);
	      }
	    },
	    _applyOpacity: function(shape) {
	      var absOpacity = shape.getAbsoluteOpacity();
	      if (absOpacity !== 1) {
	        this.setAttr('globalAlpha', absOpacity);
	      }
	    },
	    _applyLineJoin: function(shape) {
	      var lineJoin = shape.getLineJoin();
	      if (lineJoin) {
	        this.setAttr('lineJoin', lineJoin);
	      }
	    },
	    setAttr: function(attr, val) {
	      this._context[attr] = val;
	    },
	
	    // context pass through methods
	    arc: function() {
	      var a = arguments;
	      this._context.arc(a[0], a[1], a[2], a[3], a[4], a[5]);
	    },
	    beginPath: function() {
	      this._context.beginPath();
	    },
	    bezierCurveTo: function() {
	      var a = arguments;
	      this._context.bezierCurveTo(a[0], a[1], a[2], a[3], a[4], a[5]);
	    },
	    clearRect: function() {
	      var a = arguments;
	      this._context.clearRect(a[0], a[1], a[2], a[3]);
	    },
	    clip: function() {
	      this._context.clip();
	    },
	    closePath: function() {
	      this._context.closePath();
	    },
	    createImageData: function() {
	      var a = arguments;
	      if (a.length === 2) {
	        return this._context.createImageData(a[0], a[1]);
	      } else if (a.length === 1) {
	        return this._context.createImageData(a[0]);
	      }
	    },
	    createLinearGradient: function() {
	      var a = arguments;
	      return this._context.createLinearGradient(a[0], a[1], a[2], a[3]);
	    },
	    createPattern: function() {
	      var a = arguments;
	      return this._context.createPattern(a[0], a[1]);
	    },
	    createRadialGradient: function() {
	      var a = arguments;
	      return this._context.createRadialGradient(
	        a[0],
	        a[1],
	        a[2],
	        a[3],
	        a[4],
	        a[5]
	      );
	    },
	    drawImage: function() {
	      var a = arguments, _context = this._context;
	
	      if (a.length === 3) {
	        _context.drawImage(a[0], a[1], a[2]);
	      } else if (a.length === 5) {
	        _context.drawImage(a[0], a[1], a[2], a[3], a[4]);
	      } else if (a.length === 9) {
	        _context.drawImage(
	          a[0],
	          a[1],
	          a[2],
	          a[3],
	          a[4],
	          a[5],
	          a[6],
	          a[7],
	          a[8]
	        );
	      }
	    },
	    isPointInPath: function(x, y) {
	      return this._context.isPointInPath(x, y);
	    },
	    fill: function() {
	      this._context.fill();
	    },
	    fillRect: function(x, y, width, height) {
	      this._context.fillRect(x, y, width, height);
	    },
	    strokeRect: function(x, y, width, height) {
	      this._context.strokeRect(x, y, width, height);
	    },
	    fillText: function() {
	      var a = arguments;
	      this._context.fillText(a[0], a[1], a[2]);
	    },
	    measureText: function(text) {
	      return this._context.measureText(text);
	    },
	    getImageData: function() {
	      var a = arguments;
	      return this._context.getImageData(a[0], a[1], a[2], a[3]);
	    },
	    lineTo: function() {
	      var a = arguments;
	      this._context.lineTo(a[0], a[1]);
	    },
	    moveTo: function() {
	      var a = arguments;
	      this._context.moveTo(a[0], a[1]);
	    },
	    rect: function() {
	      var a = arguments;
	      this._context.rect(a[0], a[1], a[2], a[3]);
	    },
	    putImageData: function() {
	      var a = arguments;
	      this._context.putImageData(a[0], a[1], a[2]);
	    },
	    quadraticCurveTo: function() {
	      var a = arguments;
	      this._context.quadraticCurveTo(a[0], a[1], a[2], a[3]);
	    },
	    restore: function() {
	      this._context.restore();
	    },
	    rotate: function() {
	      var a = arguments;
	      this._context.rotate(a[0]);
	    },
	    save: function() {
	      this._context.save();
	    },
	    scale: function() {
	      var a = arguments;
	      this._context.scale(a[0], a[1]);
	    },
	    setLineDash: function() {
	      var a = arguments, _context = this._context;
	
	      // works for Chrome and IE11
	      if (this._context.setLineDash) {
	        _context.setLineDash(a[0]);
	      } else if ('mozDash' in _context) {
	        // verified that this works in firefox
	        _context.mozDash = a[0];
	      } else if ('webkitLineDash' in _context) {
	        // does not currently work for Safari
	        _context.webkitLineDash = a[0];
	      }
	
	      // no support for IE9 and IE10
	    },
	    getLineDash: function() {
	      return this._context.getLineDash();
	    },
	    setTransform: function() {
	      var a = arguments;
	      this._context.setTransform(a[0], a[1], a[2], a[3], a[4], a[5]);
	    },
	    stroke: function() {
	      this._context.stroke();
	    },
	    strokeText: function() {
	      var a = arguments;
	      this._context.strokeText(a[0], a[1], a[2]);
	    },
	    transform: function() {
	      var a = arguments;
	      this._context.transform(a[0], a[1], a[2], a[3], a[4], a[5]);
	    },
	    translate: function() {
	      var a = arguments;
	      this._context.translate(a[0], a[1]);
	    },
	    _enableTrace: function() {
	      var that = this,
	        len = CONTEXT_METHODS.length,
	        _simplifyArray = Konva.Util._simplifyArray,
	        origSetter = this.setAttr,
	        n,
	        args;
	
	      // to prevent creating scope function at each loop
	      var func = function(methodName) {
	        var origMethod = that[methodName], ret;
	
	        that[methodName] = function() {
	          args = _simplifyArray(Array.prototype.slice.call(arguments, 0));
	          ret = origMethod.apply(that, arguments);
	
	          that._trace({
	            method: methodName,
	            args: args
	          });
	
	          return ret;
	        };
	      };
	      // methods
	      for (n = 0; n < len; n++) {
	        func(CONTEXT_METHODS[n]);
	      }
	
	      // attrs
	      that.setAttr = function() {
	        origSetter.apply(that, arguments);
	        var prop = arguments[0];
	        var val = arguments[1];
	        if (
	          prop === 'shadowOffsetX' ||
	          prop === 'shadowOffsetY' ||
	          prop === 'shadowBlur'
	        ) {
	          val = val / this.canvas.getPixelRatio();
	        }
	        that._trace({
	          property: prop,
	          val: val
	        });
	      };
	    }
	  };
	
	  CONTEXT_PROPERTIES.forEach(function(prop) {
	    Object.defineProperty(Konva.Context.prototype, prop, {
	      get: function() {
	        return this._context[prop];
	      },
	      set: function(val) {
	        this._context[prop] = val;
	      }
	    });
	  });
	
	  Konva.SceneContext = function(canvas) {
	    Konva.Context.call(this, canvas);
	  };
	
	  Konva.SceneContext.prototype = {
	    _fillColor: function(shape) {
	      var fill = shape.fill();
	
	      this.setAttr('fillStyle', fill);
	      shape._fillFunc(this);
	    },
	    _fillPattern: function(shape) {
	      var fillPatternX = shape.getFillPatternX(),
	        fillPatternY = shape.getFillPatternY(),
	        fillPatternScale = shape.getFillPatternScale(),
	        fillPatternRotation = Konva.getAngle(shape.getFillPatternRotation()),
	        fillPatternOffset = shape.getFillPatternOffset();
	
	      if (fillPatternX || fillPatternY) {
	        this.translate(fillPatternX || 0, fillPatternY || 0);
	      }
	      if (fillPatternRotation) {
	        this.rotate(fillPatternRotation);
	      }
	      if (fillPatternScale) {
	        this.scale(fillPatternScale.x, fillPatternScale.y);
	      }
	      if (fillPatternOffset) {
	        this.translate(-1 * fillPatternOffset.x, -1 * fillPatternOffset.y);
	      }
	
	      this.setAttr(
	        'fillStyle',
	        this.createPattern(
	          shape.getFillPatternImage(),
	          shape.getFillPatternRepeat() || 'repeat'
	        )
	      );
	      this.fill();
	    },
	    _fillLinearGradient: function(shape) {
	      var start = shape.getFillLinearGradientStartPoint(),
	        end = shape.getFillLinearGradientEndPoint(),
	        colorStops = shape.getFillLinearGradientColorStops(),
	        grd = this.createLinearGradient(start.x, start.y, end.x, end.y);
	
	      if (colorStops) {
	        // build color stops
	        for (var n = 0; n < colorStops.length; n += 2) {
	          grd.addColorStop(colorStops[n], colorStops[n + 1]);
	        }
	        this.setAttr('fillStyle', grd);
	        shape._fillFunc(this);
	      }
	    },
	    _fillRadialGradient: function(shape) {
	      var start = shape.getFillRadialGradientStartPoint(),
	        end = shape.getFillRadialGradientEndPoint(),
	        startRadius = shape.getFillRadialGradientStartRadius(),
	        endRadius = shape.getFillRadialGradientEndRadius(),
	        colorStops = shape.getFillRadialGradientColorStops(),
	        grd = this.createRadialGradient(
	          start.x,
	          start.y,
	          startRadius,
	          end.x,
	          end.y,
	          endRadius
	        );
	
	      // build color stops
	      for (var n = 0; n < colorStops.length; n += 2) {
	        grd.addColorStop(colorStops[n], colorStops[n + 1]);
	      }
	      this.setAttr('fillStyle', grd);
	      this.fill();
	    },
	    _fill: function(shape) {
	      var hasColor = shape.fill(),
	        hasPattern = shape.getFillPatternImage(),
	        hasLinearGradient = shape.getFillLinearGradientColorStops(),
	        hasRadialGradient = shape.getFillRadialGradientColorStops(),
	        fillPriority = shape.getFillPriority();
	
	      // priority fills
	      if (hasColor && fillPriority === 'color') {
	        this._fillColor(shape);
	      } else if (hasPattern && fillPriority === 'pattern') {
	        this._fillPattern(shape);
	      } else if (hasLinearGradient && fillPriority === 'linear-gradient') {
	        this._fillLinearGradient(shape);
	      } else if (hasRadialGradient && fillPriority === 'radial-gradient') {
	        this._fillRadialGradient(shape);
	      } else if (hasColor) {
	        // now just try and fill with whatever is available
	        this._fillColor(shape);
	      } else if (hasPattern) {
	        this._fillPattern(shape);
	      } else if (hasLinearGradient) {
	        this._fillLinearGradient(shape);
	      } else if (hasRadialGradient) {
	        this._fillRadialGradient(shape);
	      }
	    },
	    _stroke: function(shape) {
	      var dash = shape.dash(),
	        // ignore strokeScaleEnabled for Text
	        strokeScaleEnabled =
	          shape.getStrokeScaleEnabled() || shape instanceof Konva.Text;
	
	      if (shape.hasStroke()) {
	        if (!strokeScaleEnabled) {
	          this.save();
	          this.setTransform(1, 0, 0, 1, 0, 0);
	        }
	
	        this._applyLineCap(shape);
	        if (dash && shape.dashEnabled()) {
	          this.setLineDash(dash);
	          this.setAttr('lineDashOffset', shape.dashOffset());
	        }
	
	        this.setAttr('lineWidth', shape.strokeWidth());
	        this.setAttr('strokeStyle', shape.stroke());
	
	        if (!shape.getShadowForStrokeEnabled()) {
	          this.setAttr('shadowColor', 'rgba(0,0,0,0)');
	        }
	        shape._strokeFunc(this);
	
	        if (!strokeScaleEnabled) {
	          this.restore();
	        }
	      }
	    },
	    _applyShadow: function(shape) {
	      var util = Konva.Util,
	        color = util.get(shape.getShadowRGBA(), 'black'),
	        blur = util.get(shape.getShadowBlur(), 5),
	        offset = util.get(shape.getShadowOffset(), {
	          x: 0,
	          y: 0
	        }),
	        // TODO: get this info from transform??
	        scale = shape.getAbsoluteScale(),
	        ratio = this.canvas.getPixelRatio(),
	        scaleX = scale.x * ratio,
	        scaleY = scale.y * ratio;
	
	      this.setAttr('shadowColor', color);
	      this.setAttr(
	        'shadowBlur',
	        blur * ratio * Math.min(Math.abs(scaleX), Math.abs(scaleY))
	      );
	      this.setAttr('shadowOffsetX', offset.x * scaleX);
	      this.setAttr('shadowOffsetY', offset.y * scaleY);
	    },
	    _applyGlobalCompositeOperation: function(shape) {
	      var globalCompositeOperation = shape.getGlobalCompositeOperation();
	      if (globalCompositeOperation !== 'source-over') {
	        this.setAttr('globalCompositeOperation', globalCompositeOperation);
	      }
	    }
	  };
	  Konva.Util.extend(Konva.SceneContext, Konva.Context);
	
	  Konva.HitContext = function(canvas) {
	    Konva.Context.call(this, canvas);
	  };
	
	  Konva.HitContext.prototype = {
	    _fill: function(shape) {
	      this.save();
	      this.setAttr('fillStyle', shape.colorKey);
	      shape._fillFuncHit(this);
	      this.restore();
	    },
	    _stroke: function(shape) {
	      if (shape.hasStroke() && shape.strokeHitEnabled()) {
	        // ignore strokeScaleEnabled for Text
	        var strokeScaleEnabled =
	          shape.getStrokeScaleEnabled() || shape instanceof Konva.Text;
	        if (!strokeScaleEnabled) {
	          this.save();
	          this.setTransform(1, 0, 0, 1, 0, 0);
	        }
	        this._applyLineCap(shape);
	        this.setAttr('lineWidth', shape.strokeWidth());
	        this.setAttr('strokeStyle', shape.colorKey);
	        shape._strokeFuncHit(this);
	        if (!strokeScaleEnabled) {
	          this.restore();
	        }
	      }
	    }
	  };
	  Konva.Util.extend(Konva.HitContext, Konva.Context);
	})();
	
	(function() {
	  'use strict';
	  // CONSTANTS
	  var GET = 'get', SET = 'set';
	
	  Konva.Factory = {
	    addGetterSetter: function(constructor, attr, def, validator, after) {
	      this.addGetter(constructor, attr, def);
	      this.addSetter(constructor, attr, validator, after);
	      this.addOverloadedGetterSetter(constructor, attr);
	    },
	    addGetter: function(constructor, attr, def) {
	      var method = GET + Konva.Util._capitalize(attr);
	
	      constructor.prototype[method] = function() {
	        var val = this.attrs[attr];
	        return val === undefined ? def : val;
	      };
	    },
	    addSetter: function(constructor, attr, validator, after) {
	      var method = SET + Konva.Util._capitalize(attr);
	
	      constructor.prototype[method] = function(val) {
	        if (validator) {
	          val = validator.call(this, val);
	        }
	
	        this._setAttr(attr, val);
	
	        if (after) {
	          after.call(this);
	        }
	
	        return this;
	      };
	    },
	    addComponentsGetterSetter: function(
	      constructor,
	      attr,
	      components,
	      validator,
	      after
	    ) {
	      var len = components.length,
	        capitalize = Konva.Util._capitalize,
	        getter = GET + capitalize(attr),
	        setter = SET + capitalize(attr),
	        n,
	        component;
	
	      // getter
	      constructor.prototype[getter] = function() {
	        var ret = {};
	
	        for (n = 0; n < len; n++) {
	          component = components[n];
	          ret[component] = this.getAttr(attr + capitalize(component));
	        }
	
	        return ret;
	      };
	
	      // setter
	      constructor.prototype[setter] = function(val) {
	        var oldVal = this.attrs[attr], key;
	
	        if (validator) {
	          val = validator.call(this, val);
	        }
	
	        for (key in val) {
	          if (!val.hasOwnProperty(key)) {
	            continue;
	          }
	          this._setAttr(attr + capitalize(key), val[key]);
	        }
	
	        this._fireChangeEvent(attr, oldVal, val);
	
	        if (after) {
	          after.call(this);
	        }
	
	        return this;
	      };
	
	      this.addOverloadedGetterSetter(constructor, attr);
	    },
	    addOverloadedGetterSetter: function(constructor, attr) {
	      var capitalizedAttr = Konva.Util._capitalize(attr),
	        setter = SET + capitalizedAttr,
	        getter = GET + capitalizedAttr;
	
	      constructor.prototype[attr] = function() {
	        // setting
	        if (arguments.length) {
	          this[setter](arguments[0]);
	          return this;
	        }
	        // getting
	        return this[getter]();
	      };
	    },
	    addDeprecatedGetterSetter: function(constructor, attr, def, validator) {
	      var method = GET + Konva.Util._capitalize(attr);
	      var message =
	        attr +
	        ' property is deprecated and will be removed soon. Look at Konva change log for more information.';
	      constructor.prototype[method] = function() {
	        Konva.Util.error(message);
	        var val = this.attrs[attr];
	        return val === undefined ? def : val;
	      };
	      this.addSetter(constructor, attr, validator, function() {
	        Konva.Util.error(message);
	      });
	      this.addOverloadedGetterSetter(constructor, attr);
	    },
	    backCompat: function(constructor, methods) {
	      Konva.Util.each(methods, function(oldMethodName, newMethodName) {
	        var method = constructor.prototype[newMethodName];
	        constructor.prototype[oldMethodName] = function() {
	          method.apply(this, arguments);
	          Konva.Util.error(
	            oldMethodName +
	              ' method is deprecated and will be removed soon. Use ' +
	              newMethodName +
	              ' instead'
	          );
	        };
	      });
	    },
	    afterSetFilter: function() {
	      this._filterUpToDate = false;
	    }
	  };
	
	  Konva.Validators = {
	    /**
	         * @return {number}
	         */
	    RGBComponent: function(val) {
	      if (val > 255) {
	        return 255;
	      } else if (val < 0) {
	        return 0;
	      }
	      return Math.round(val);
	    },
	    alphaComponent: function(val) {
	      if (val > 1) {
	        return 1;
	      } else if (val < 0.0001) {
	        // chrome does not honor alpha values of 0
	        return 0.0001;
	      }
	
	      return val;
	    }
	  };
	})();
	
	(function(Konva) {
	  'use strict';
	  // CONSTANTS
	  var ABSOLUTE_OPACITY = 'absoluteOpacity',
	    ABSOLUTE_TRANSFORM = 'absoluteTransform',
	    ABSOLUTE_SCALE = 'absoluteScale',
	    CHANGE = 'Change',
	    CHILDREN = 'children',
	    DOT = '.',
	    EMPTY_STRING = '',
	    GET = 'get',
	    ID = 'id',
	    KONVA = 'konva',
	    LISTENING = 'listening',
	    MOUSEENTER = 'mouseenter',
	    MOUSELEAVE = 'mouseleave',
	    NAME = 'name',
	    SET = 'set',
	    SHAPE = 'Shape',
	    SPACE = ' ',
	    STAGE = 'stage',
	    TRANSFORM = 'transform',
	    UPPER_STAGE = 'Stage',
	    VISIBLE = 'visible',
	    CLONE_BLACK_LIST = ['id'],
	    TRANSFORM_CHANGE_STR = [
	      'xChange.konva',
	      'yChange.konva',
	      'scaleXChange.konva',
	      'scaleYChange.konva',
	      'skewXChange.konva',
	      'skewYChange.konva',
	      'rotationChange.konva',
	      'offsetXChange.konva',
	      'offsetYChange.konva',
	      'transformsEnabledChange.konva'
	    ].join(SPACE),
	    SCALE_CHANGE_STR = ['scaleXChange.konva', 'scaleYChange.konva'].join(SPACE);
	
	  /**
	     * Node constructor. Nodes are entities that can be transformed, layered,
	     * and have bound events. The stage, layers, groups, and shapes all extend Node.
	     * @constructor
	     * @memberof Konva
	     * @abstract
	     * @param {Object} config
	     * @param {Number} [config.x]
	     * @param {Number} [config.y]
	     * @param {Number} [config.width]
	     * @param {Number} [config.height]
	     * @param {Boolean} [config.visible]
	     * @param {Boolean} [config.listening] whether or not the node is listening for events
	     * @param {String} [config.id] unique id
	     * @param {String} [config.name] non-unique name
	     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
	     * @param {Object} [config.scale] set scale
	     * @param {Number} [config.scaleX] set scale x
	     * @param {Number} [config.scaleY] set scale y
	     * @param {Number} [config.rotation] rotation in degrees
	     * @param {Object} [config.offset] offset from center point and rotation point
	     * @param {Number} [config.offsetX] set offset x
	     * @param {Number} [config.offsetY] set offset y
	     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
	     *  the entire stage by dragging any portion of the stage
	     * @param {Number} [config.dragDistance]
	     * @param {Function} [config.dragBoundFunc]
	     */
	  Konva.Node = function(config) {
	    this._init(config);
	  };
	
	  Konva.Util.addMethods(Konva.Node, {
	    _init: function(config) {
	      var that = this;
	      this._id = Konva.idCounter++;
	      this.eventListeners = {};
	      this.attrs = {};
	      this._cache = {};
	      this._filterUpToDate = false;
	      this._isUnderCache = false;
	      this.setAttrs(config);
	
	      // event bindings for cache handling
	      this.on(TRANSFORM_CHANGE_STR, function() {
	        this._clearCache(TRANSFORM);
	        that._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
	      });
	
	      this.on(SCALE_CHANGE_STR, function() {
	        that._clearSelfAndDescendantCache(ABSOLUTE_SCALE);
	      });
	
	      this.on('visibleChange.konva', function() {
	        that._clearSelfAndDescendantCache(VISIBLE);
	      });
	      this.on('listeningChange.konva', function() {
	        that._clearSelfAndDescendantCache(LISTENING);
	      });
	      this.on('opacityChange.konva', function() {
	        that._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);
	      });
	    },
	    _clearCache: function(attr) {
	      if (attr) {
	        delete this._cache[attr];
	      } else {
	        this._cache = {};
	      }
	    },
	    _getCache: function(attr, privateGetter) {
	      var cache = this._cache[attr];
	
	      // if not cached, we need to set it using the private getter method.
	      if (cache === undefined) {
	        this._cache[attr] = privateGetter.call(this);
	      }
	
	      return this._cache[attr];
	    },
	    /*
	         * when the logic for a cached result depends on ancestor propagation, use this
	         * method to clear self and children cache
	         */
	    _clearSelfAndDescendantCache: function(attr) {
	      this._clearCache(attr);
	
	      if (this.children) {
	        this.getChildren().each(function(node) {
	          node._clearSelfAndDescendantCache(attr);
	        });
	      }
	    },
	    /**
	        * clear cached canvas
	        * @method
	        * @memberof Konva.Node.prototype
	        * @returns {Konva.Node}
	        * @example
	        * node.clearCache();
	        */
	    clearCache: function() {
	      delete this._cache.canvas;
	      this._filterUpToDate = false;
	      return this;
	    },
	    /**
	        *  cache node to improve drawing performance, apply filters, or create more accurate
	        *  hit regions. For all basic shapes size of cache canvas will be automatically detected.
	        *  If you need to cache your custom `Konva.Shape` instance you have to pass shape's bounding box
	        *  properties. Look at [link to demo page](link to demo page) for more information.
	        * @method
	        * @memberof Konva.Node.prototype
	        * @param {Object} [config]
	        * @param {Number} [config.x]
	        * @param {Number} [config.y]
	        * @param {Number} [config.width]
	        * @param {Number} [config.height]
	        * @param {Number} [config.offset]  increase canvas size by `offset` pixel in all directions.
	        * @param {Boolean} [config.drawBorder] when set to true, a red border will be drawn around the cached
	        *  region for debugging purposes
	        * @param {Number} [config.pixelRatio] change quality (or pixel ratio) of cached image. pixelRatio = 2 will produce 2x sized cache.
	        * @returns {Konva.Node}
	        * @example
	        * // cache a shape with the x,y position of the bounding box at the center and
	        * // the width and height of the bounding box equal to the width and height of
	        * // the shape obtained from shape.width() and shape.height()
	        * image.cache();
	        *
	        * // cache a node and define the bounding box position and size
	        * node.cache({
	        *   x: -30,
	        *   y: -30,
	        *   width: 100,
	        *   height: 200
	        * });
	        *
	        * // cache a node and draw a red border around the bounding box
	        * // for debugging purposes
	        * node.cache({
	        *   x: -30,
	        *   y: -30,
	        *   width: 100,
	        *   height: 200,
	        *   offset : 10,
	        *   drawBorder: true
	        * });
	        */
	    cache: function(config) {
	      var conf = config || {},
	        rect = this.getClientRect({
	          skipTransform: true,
	          relativeTo: this.getParent()
	        }),
	        width = conf.width || rect.width,
	        height = conf.height || rect.height,
	        pixelRatio = conf.pixelRatio,
	        x = conf.x || rect.x,
	        y = conf.y || rect.y,
	        offset = conf.offset || 0,
	        drawBorder = conf.drawBorder || false;
	
	      if (!width || !height) {
	        // make throw async, because we don't need to stop funcion
	        setTimeout(function() {
	          Konva.Util.throw(
	            'Width or height of caching configuration equals 0. Caching is ignored.'
	          );
	        });
	        return;
	      }
	
	      width += offset * 2;
	      height += offset * 2;
	
	      x -= offset;
	      y -= offset;
	
	      var cachedSceneCanvas = new Konva.SceneCanvas({
	          pixelRatio: pixelRatio,
	          width: width,
	          height: height
	        }),
	        cachedFilterCanvas = new Konva.SceneCanvas({
	          pixelRatio: pixelRatio,
	          width: width,
	          height: height
	        }),
	        cachedHitCanvas = new Konva.HitCanvas({
	          pixelRatio: 1,
	          width: width,
	          height: height
	        }),
	        sceneContext = cachedSceneCanvas.getContext(),
	        hitContext = cachedHitCanvas.getContext();
	
	      cachedHitCanvas.isCache = true;
	
	      this.clearCache();
	
	      sceneContext.save();
	      hitContext.save();
	
	      sceneContext.translate(-x, -y);
	      hitContext.translate(-x, -y);
	
	      // extra flag to skip on getAbsolute opacity calc
	      this._isUnderCache = true;
	      this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);
	      this._clearSelfAndDescendantCache(ABSOLUTE_SCALE);
	
	      this.drawScene(cachedSceneCanvas, this, true);
	      this.drawHit(cachedHitCanvas, this, true);
	      this._isUnderCache = false;
	
	      sceneContext.restore();
	      hitContext.restore();
	
	      // this will draw a red border around the cached box for
	      // debugging purposes
	      if (drawBorder) {
	        sceneContext.save();
	        sceneContext.beginPath();
	        sceneContext.rect(0, 0, width, height);
	        sceneContext.closePath();
	        sceneContext.setAttr('strokeStyle', 'red');
	        sceneContext.setAttr('lineWidth', 5);
	        sceneContext.stroke();
	        sceneContext.restore();
	      }
	
	      this._cache.canvas = {
	        scene: cachedSceneCanvas,
	        filter: cachedFilterCanvas,
	        hit: cachedHitCanvas,
	        x: x,
	        y: y
	      };
	
	      return this;
	    },
	    /**
	         * Return client rectangle {x, y, width, height} of node. This rectangle also include all styling (strokes, shadows, etc).
	         * The rectangle position is relative to parent container.
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {Object} config
	         * @param {Boolean} [config.skipTransform] should we apply transform to node for calculating rect?
	         * @param {Object} [config.relativeTo] calculate client rect relative to one of the parents
	         * @returns {Object} rect with {x, y, width, height} properties
	         * @example
	         * var rect = new Konva.Rect({
	         *      width : 100,
	         *      height : 100,
	         *      x : 50,
	         *      y : 50,
	         *      strokeWidth : 4,
	         *      stroke : 'black',
	         *      offsetX : 50,
	         *      scaleY : 2
	         * });
	         *
	         * // get client rect without think off transformations (position, rotation, scale, offset, etc)
	         * rect.getClientRect({ skipTransform: true});
	         * // returns {
	         * //     x : -2,   // two pixels for stroke / 2
	         * //     y : -2,
	         * //     width : 104, // increased by 4 for stroke
	         * //     height : 104
	         * //}
	         *
	         * // get client rect with transformation applied
	         * rect.getClientRect();
	         * // returns Object {x: -2, y: 46, width: 104, height: 208}
	         */
	    getClientRect: function() {
	      // abstract method
	      // redefine in Container and Shape
	      throw new Error('abstract "getClientRect" method call');
	    },
	    _transformedRect: function(rect, top) {
	      var points = [
	        { x: rect.x, y: rect.y },
	        { x: rect.x + rect.width, y: rect.y },
	        { x: rect.x + rect.width, y: rect.y + rect.height },
	        { x: rect.x, y: rect.y + rect.height }
	      ];
	      var minX, minY, maxX, maxY;
	      var trans = this.getAbsoluteTransform(top);
	      points.forEach(function(point) {
	        var transformed = trans.point(point);
	        if (minX === undefined) {
	          minX = maxX = transformed.x;
	          minY = maxY = transformed.y;
	        }
	        minX = Math.min(minX, transformed.x);
	        minY = Math.min(minY, transformed.y);
	        maxX = Math.max(maxX, transformed.x);
	        maxY = Math.max(maxY, transformed.y);
	      });
	      return {
	        x: minX,
	        y: minY,
	        width: maxX - minX,
	        height: maxY - minY
	      };
	    },
	    _drawCachedSceneCanvas: function(context) {
	      context.save();
	      context._applyOpacity(this);
	      context._applyGlobalCompositeOperation(this);
	      context.translate(this._cache.canvas.x, this._cache.canvas.y);
	
	      var cacheCanvas = this._getCachedSceneCanvas();
	      var ratio = cacheCanvas.pixelRatio;
	
	      context.drawImage(
	        cacheCanvas._canvas,
	        0,
	        0,
	        cacheCanvas.width / ratio,
	        cacheCanvas.height / ratio
	      );
	      context.restore();
	    },
	    _drawCachedHitCanvas: function(context) {
	      var cachedCanvas = this._cache.canvas,
	        hitCanvas = cachedCanvas.hit;
	      context.save();
	      context.translate(this._cache.canvas.x, this._cache.canvas.y);
	      context.drawImage(hitCanvas._canvas, 0, 0);
	      context.restore();
	    },
	    _getCachedSceneCanvas: function() {
	      var filters = this.filters(),
	        cachedCanvas = this._cache.canvas,
	        sceneCanvas = cachedCanvas.scene,
	        filterCanvas = cachedCanvas.filter,
	        filterContext = filterCanvas.getContext(),
	        len,
	        imageData,
	        n,
	        filter;
	
	      if (filters) {
	        if (!this._filterUpToDate) {
	          var ratio = sceneCanvas.pixelRatio;
	
	          try {
	            len = filters.length;
	            filterContext.clear();
	
	            // copy cached canvas onto filter context
	            filterContext.drawImage(
	              sceneCanvas._canvas,
	              0,
	              0,
	              sceneCanvas.getWidth() / ratio,
	              sceneCanvas.getHeight() / ratio
	            );
	            imageData = filterContext.getImageData(
	              0,
	              0,
	              filterCanvas.getWidth(),
	              filterCanvas.getHeight()
	            );
	
	            // apply filters to filter context
	            for (n = 0; n < len; n++) {
	              filter = filters[n];
	              if (typeof filter !== 'function') {
	                Konva.Util.error(
	                  'Filter should be type of function, but got ' +
	                    typeof filter +
	                    ' insted. Please check correct filters'
	                );
	                continue;
	              }
	              filter.call(this, imageData);
	              filterContext.putImageData(imageData, 0, 0);
	            }
	          } catch (e) {
	            Konva.Util.error('Unable to apply filter. ' + e.message);
	          }
	
	          this._filterUpToDate = true;
	        }
	
	        return filterCanvas;
	      }
	      return sceneCanvas;
	    },
	    /**
	         * bind events to the node. KonvaJS supports mouseover, mousemove,
	         *  mouseout, mouseenter, mouseleave, mousedown, mouseup, wheel, click, dblclick, touchstart, touchmove,
	         *  touchend, tap, dbltap, dragstart, dragmove, and dragend events. The Konva Stage supports
	         *  contentMouseover, contentMousemove, contentMouseout, contentMousedown, contentMouseup, contentWheel, contentContextmenu
	         *  contentClick, contentDblclick, contentTouchstart, contentTouchmove, contentTouchend, contentTap,
	         *  and contentDblTap.  Pass in a string of events delimmited by a space to bind multiple events at once
	         *  such as 'mousedown mouseup mousemove'. Include a namespace to bind an
	         *  event by name such as 'click.foobar'.
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {String} evtStr e.g. 'click', 'mousedown touchstart', 'mousedown.foo touchstart.foo'
	         * @param {Function} handler The handler function is passed an event object
	         * @returns {Konva.Node}
	         * @example
	         * // add click listener
	         * node.on('click', function() {
	         *   console.log('you clicked me!');
	         * });
	         *
	         * // get the target node
	         * node.on('click', function(evt) {
	         *   console.log(evt.target);
	         * });
	         *
	         * // stop event propagation
	         * node.on('click', function(evt) {
	         *   evt.cancelBubble = true;
	         * });
	         *
	         * // bind multiple listeners
	         * node.on('click touchstart', function() {
	         *   console.log('you clicked/touched me!');
	         * });
	         *
	         * // namespace listener
	         * node.on('click.foo', function() {
	         *   console.log('you clicked/touched me!');
	         * });
	         *
	         * // get the event type
	         * node.on('click tap', function(evt) {
	         *   var eventType = evt.type;
	         * });
	         *
	         * // get native event object
	         * node.on('click tap', function(evt) {
	         *   var nativeEvent = evt.evt;
	         * });
	         *
	         * // for change events, get the old and new val
	         * node.on('xChange', function(evt) {
	         *   var oldVal = evt.oldVal;
	         *   var newVal = evt.newVal;
	         * });
	         *
	         * // get event targets
	         * // with event delegations
	         * layer.on('click', 'Group', function(evt) {
	         *   var shape = evt.target;
	         *   var group = evtn.currentTarger;
	         * });
	         */
	    on: function(evtStr, handler) {
	      if (arguments.length === 3) {
	        return this._delegate.apply(this, arguments);
	      }
	      var events = evtStr.split(SPACE),
	        len = events.length,
	        n,
	        event,
	        parts,
	        baseEvent,
	        name;
	
	      /*
	             * loop through types and attach event listeners to
	             * each one.  eg. 'click mouseover.namespace mouseout'
	             * will create three event bindings
	             */
	      for (n = 0; n < len; n++) {
	        event = events[n];
	        parts = event.split(DOT);
	        baseEvent = parts[0];
	        name = parts[1] || EMPTY_STRING;
	
	        // create events array if it doesn't exist
	        if (!this.eventListeners[baseEvent]) {
	          this.eventListeners[baseEvent] = [];
	        }
	
	        this.eventListeners[baseEvent].push({
	          name: name,
	          handler: handler
	        });
	      }
	
	      return this;
	    },
	    /**
	         * remove event bindings from the node. Pass in a string of
	         *  event types delimmited by a space to remove multiple event
	         *  bindings at once such as 'mousedown mouseup mousemove'.
	         *  include a namespace to remove an event binding by name
	         *  such as 'click.foobar'. If you only give a name like '.foobar',
	         *  all events in that namespace will be removed.
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {String} evtStr e.g. 'click', 'mousedown touchstart', '.foobar'
	         * @returns {Konva.Node}
	         * @example
	         * // remove listener
	         * node.off('click');
	         *
	         * // remove multiple listeners
	         * node.off('click touchstart');
	         *
	         * // remove listener by name
	         * node.off('click.foo');
	         */
	    off: function(evtStr) {
	      var events = (evtStr || '').split(SPACE),
	        len = events.length,
	        n,
	        t,
	        event,
	        parts,
	        baseEvent,
	        name;
	
	      if (!evtStr) {
	        // remove all events
	        for (t in this.eventListeners) {
	          this._off(t);
	        }
	      }
	      for (n = 0; n < len; n++) {
	        event = events[n];
	        parts = event.split(DOT);
	        baseEvent = parts[0];
	        name = parts[1];
	
	        if (baseEvent) {
	          if (this.eventListeners[baseEvent]) {
	            this._off(baseEvent, name);
	          }
	        } else {
	          for (t in this.eventListeners) {
	            this._off(t, name);
	          }
	        }
	      }
	      return this;
	    },
	    // some event aliases for third party integration like HammerJS
	    dispatchEvent: function(evt) {
	      var e = {
	        target: this,
	        type: evt.type,
	        evt: evt
	      };
	      this.fire(evt.type, e);
	      return this;
	    },
	    addEventListener: function(type, handler) {
	      // we have to pass native event to handler
	      this.on(type, function(evt) {
	        handler.call(this, evt.evt);
	      });
	      return this;
	    },
	    removeEventListener: function(type) {
	      this.off(type);
	      return this;
	    },
	    // like node.on
	    _delegate: function(event, selector, handler) {
	      var stopNode = this;
	      this.on(event, function(evt) {
	        var targets = evt.target.findAncestors(selector, true, stopNode);
	        for (var i = 0; i < targets.length; i++) {
	          evt = Konva.Util.cloneObject(evt);
	          evt.currentTarget = targets[i];
	          handler.call(targets[i], evt);
	        }
	      });
	    },
	    /**
	         * remove self from parent, but don't destroy
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Konva.Node}
	         * @example
	         * node.remove();
	         */
	    remove: function() {
	      var parent = this.getParent();
	
	      if (parent && parent.children) {
	        parent.children.splice(this.index, 1);
	        parent._setChildrenIndices();
	        delete this.parent;
	      }
	
	      // every cached attr that is calculated via node tree
	      // traversal must be cleared when removing a node
	      this._clearSelfAndDescendantCache(STAGE);
	      this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
	      this._clearSelfAndDescendantCache(VISIBLE);
	      this._clearSelfAndDescendantCache(LISTENING);
	      this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);
	
	      return this;
	    },
	    /**
	         * remove and destroy self
	         * @method
	         * @memberof Konva.Node.prototype
	         * @example
	         * node.destroy();
	         */
	    destroy: function() {
	      // remove from ids and names hashes
	      Konva._removeId(this.getId());
	
	      // remove all names
	      var names = (this.getName() || '').split(/\s/g);
	      for (var i = 0; i < names.length; i++) {
	        var subname = names[i];
	        Konva._removeName(subname, this._id);
	      }
	
	      this.remove();
	      return this;
	    },
	    /**
	         * get attr
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {String} attr
	         * @returns {Integer|String|Object|Array}
	         * @example
	         * var x = node.getAttr('x');
	         */
	    getAttr: function(attr) {
	      var method = GET + Konva.Util._capitalize(attr);
	      if (Konva.Util._isFunction(this[method])) {
	        return this[method]();
	      }
	      // otherwise get directly
	      return this.attrs[attr];
	    },
	    /**
	        * get ancestors
	        * @method
	        * @memberof Konva.Node.prototype
	        * @returns {Konva.Collection}
	        * @example
	        * shape.getAncestors().each(function(node) {
	        *   console.log(node.getId());
	        * })
	        */
	    getAncestors: function() {
	      var parent = this.getParent(),
	        ancestors = new Konva.Collection();
	
	      while (parent) {
	        ancestors.push(parent);
	        parent = parent.getParent();
	      }
	
	      return ancestors;
	    },
	    /**
	         * get attrs object literal
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Object}
	         */
	    getAttrs: function() {
	      return this.attrs || {};
	    },
	    /**
	         * set multiple attrs at once using an object literal
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {Object} config object containing key value pairs
	         * @returns {Konva.Node}
	         * @example
	         * node.setAttrs({
	         *   x: 5,
	         *   fill: 'red'
	         * });
	         */
	    setAttrs: function(config) {
	      var key, method;
	
	      if (!config) {
	        return this;
	      }
	      for (key in config) {
	        if (key === CHILDREN) {
	          continue;
	        }
	        method = SET + Konva.Util._capitalize(key);
	        // use setter if available
	        if (Konva.Util._isFunction(this[method])) {
	          this[method](config[key]);
	        } else {
	          // otherwise set directly
	          this._setAttr(key, config[key]);
	        }
	      }
	      return this;
	    },
	    /**
	         * determine if node is listening for events by taking into account ancestors.
	         *
	         * Parent    | Self      | isListening
	         * listening | listening |
	         * ----------+-----------+------------
	         * T         | T         | T
	         * T         | F         | F
	         * F         | T         | T
	         * F         | F         | F
	         * ----------+-----------+------------
	         * T         | I         | T
	         * F         | I         | F
	         * I         | I         | T
	         *
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Boolean}
	         */
	    isListening: function() {
	      return this._getCache(LISTENING, this._isListening);
	    },
	    _isListening: function() {
	      var listening = this.getListening(),
	        parent = this.getParent();
	
	      // the following conditions are a simplification of the truth table above.
	      // please modify carefully
	      if (listening === 'inherit') {
	        if (parent) {
	          return parent.isListening();
	        } else {
	          return true;
	        }
	      } else {
	        return listening;
	      }
	    },
	    /**
	         * determine if node is visible by taking into account ancestors.
	         *
	         * Parent    | Self      | isVisible
	         * visible   | visible   |
	         * ----------+-----------+------------
	         * T         | T         | T
	         * T         | F         | F
	         * F         | T         | T
	         * F         | F         | F
	         * ----------+-----------+------------
	         * T         | I         | T
	         * F         | I         | F
	         * I         | I         | T
	
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Boolean}
	         */
	    isVisible: function() {
	      return this._getCache(VISIBLE, this._isVisible);
	    },
	    _isVisible: function() {
	      var visible = this.getVisible(),
	        parent = this.getParent();
	
	      // the following conditions are a simplification of the truth table above.
	      // please modify carefully
	      if (visible === 'inherit') {
	        if (parent) {
	          return parent.isVisible();
	        } else {
	          return true;
	        }
	      } else {
	        return visible;
	      }
	    },
	    /**
	         * determine if listening is enabled by taking into account descendants.  If self or any children
	         * have _isListeningEnabled set to true, then self also has listening enabled.
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Boolean}
	         */
	    shouldDrawHit: function(canvas) {
	      var layer = this.getLayer();
	      return (
	        (canvas && canvas.isCache) ||
	        (layer &&
	          layer.hitGraphEnabled() &&
	          this.isListening() &&
	          this.isVisible())
	      );
	    },
	    /**
	         * show node
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Konva.Node}
	         */
	    show: function() {
	      this.setVisible(true);
	      return this;
	    },
	    /**
	         * hide node.  Hidden nodes are no longer detectable
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Konva.Node}
	         */
	    hide: function() {
	      this.setVisible(false);
	      return this;
	    },
	    /**
	         * get zIndex relative to the node's siblings who share the same parent
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Integer}
	         */
	    getZIndex: function() {
	      return this.index || 0;
	    },
	    /**
	         * get absolute z-index which takes into account sibling
	         *  and ancestor indices
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Integer}
	         */
	    getAbsoluteZIndex: function() {
	      var depth = this.getDepth(),
	        that = this,
	        index = 0,
	        nodes,
	        len,
	        n,
	        child;
	
	      function addChildren(children) {
	        nodes = [];
	        len = children.length;
	        for (n = 0; n < len; n++) {
	          child = children[n];
	          index++;
	
	          if (child.nodeType !== SHAPE) {
	            nodes = nodes.concat(child.getChildren().toArray());
	          }
	
	          if (child._id === that._id) {
	            n = len;
	          }
	        }
	
	        if (nodes.length > 0 && nodes[0].getDepth() <= depth) {
	          addChildren(nodes);
	        }
	      }
	      if (that.nodeType !== UPPER_STAGE) {
	        addChildren(that.getStage().getChildren());
	      }
	
	      return index;
	    },
	    /**
	         * get node depth in node tree.  Returns an integer.
	         *  e.g. Stage depth will always be 0.  Layers will always be 1.  Groups and Shapes will always
	         *  be >= 2
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Integer}
	         */
	    getDepth: function() {
	      var depth = 0,
	        parent = this.parent;
	
	      while (parent) {
	        depth++;
	        parent = parent.parent;
	      }
	      return depth;
	    },
	    setPosition: function(pos) {
	      this.setX(pos.x);
	      this.setY(pos.y);
	      return this;
	    },
	    getPosition: function() {
	      return {
	        x: this.getX(),
	        y: this.getY()
	      };
	    },
	    /**
	         * get absolute position relative to the top left corner of the stage container div
	         * or relative to passed node
	         * @method
	         * @param {Object} [top] optional parent node
	         * @memberof Konva.Node.prototype
	         * @returns {Object}
	         */
	    getAbsolutePosition: function(top) {
	      var absoluteMatrix = this.getAbsoluteTransform(top).getMatrix(),
	        absoluteTransform = new Konva.Transform(),
	        offset = this.offset();
	
	      // clone the matrix array
	      absoluteTransform.m = absoluteMatrix.slice();
	      absoluteTransform.translate(offset.x, offset.y);
	
	      return absoluteTransform.getTranslation();
	    },
	    /**
	         * set absolute position
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {Object} pos
	         * @param {Number} pos.x
	         * @param {Number} pos.y
	         * @returns {Konva.Node}
	         */
	    setAbsolutePosition: function(pos) {
	      var origTrans = this._clearTransform(),
	        it;
	
	      // don't clear translation
	      this.attrs.x = origTrans.x;
	      this.attrs.y = origTrans.y;
	      delete origTrans.x;
	      delete origTrans.y;
	
	      // unravel transform
	      it = this.getAbsoluteTransform();
	
	      it.invert();
	      it.translate(pos.x, pos.y);
	      pos = {
	        x: this.attrs.x + it.getTranslation().x,
	        y: this.attrs.y + it.getTranslation().y
	      };
	
	      this.setPosition({ x: pos.x, y: pos.y });
	      this._setTransform(origTrans);
	
	      return this;
	    },
	    _setTransform: function(trans) {
	      var key;
	
	      for (key in trans) {
	        this.attrs[key] = trans[key];
	      }
	
	      this._clearCache(TRANSFORM);
	      this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
	    },
	    _clearTransform: function() {
	      var trans = {
	        x: this.getX(),
	        y: this.getY(),
	        rotation: this.getRotation(),
	        scaleX: this.getScaleX(),
	        scaleY: this.getScaleY(),
	        offsetX: this.getOffsetX(),
	        offsetY: this.getOffsetY(),
	        skewX: this.getSkewX(),
	        skewY: this.getSkewY()
	      };
	
	      this.attrs.x = 0;
	      this.attrs.y = 0;
	      this.attrs.rotation = 0;
	      this.attrs.scaleX = 1;
	      this.attrs.scaleY = 1;
	      this.attrs.offsetX = 0;
	      this.attrs.offsetY = 0;
	      this.attrs.skewX = 0;
	      this.attrs.skewY = 0;
	
	      this._clearCache(TRANSFORM);
	      this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
	
	      // return original transform
	      return trans;
	    },
	    /**
	         * move node by an amount relative to its current position
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {Object} change
	         * @param {Number} change.x
	         * @param {Number} change.y
	         * @returns {Konva.Node}
	         * @example
	         * // move node in x direction by 1px and y direction by 2px
	         * node.move({
	         *   x: 1,
	         *   y: 2)
	         * });
	         */
	    move: function(change) {
	      var changeX = change.x,
	        changeY = change.y,
	        x = this.getX(),
	        y = this.getY();
	
	      if (changeX !== undefined) {
	        x += changeX;
	      }
	
	      if (changeY !== undefined) {
	        y += changeY;
	      }
	
	      this.setPosition({ x: x, y: y });
	      return this;
	    },
	    _eachAncestorReverse: function(func, top) {
	      var family = [],
	        parent = this.getParent(),
	        len,
	        n;
	
	      // if top node is defined, and this node is top node,
	      // there's no need to build a family tree.  just execute
	      // func with this because it will be the only node
	      if (top && top._id === this._id) {
	        func(this);
	        return true;
	      }
	
	      family.unshift(this);
	
	      while (parent && (!top || parent._id !== top._id)) {
	        family.unshift(parent);
	        parent = parent.parent;
	      }
	
	      len = family.length;
	      for (n = 0; n < len; n++) {
	        func(family[n]);
	      }
	    },
	    /**
	         * rotate node by an amount in degrees relative to its current rotation
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {Number} theta
	         * @returns {Konva.Node}
	         */
	    rotate: function(theta) {
	      this.setRotation(this.getRotation() + theta);
	      return this;
	    },
	    /**
	         * move node to the top of its siblings
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Boolean}
	         */
	    moveToTop: function() {
	      if (!this.parent) {
	        Konva.Util.warn('Node has no parent. moveToTop function is ignored.');
	        return false;
	      }
	      var index = this.index;
	      this.parent.children.splice(index, 1);
	      this.parent.children.push(this);
	      this.parent._setChildrenIndices();
	      return true;
	    },
	    /**
	         * move node up
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Boolean} flag is moved or not
	         */
	    moveUp: function() {
	      if (!this.parent) {
	        Konva.Util.warn('Node has no parent. moveUp function is ignored.');
	        return false;
	      }
	      var index = this.index,
	        len = this.parent.getChildren().length;
	      if (index < len - 1) {
	        this.parent.children.splice(index, 1);
	        this.parent.children.splice(index + 1, 0, this);
	        this.parent._setChildrenIndices();
	        return true;
	      }
	      return false;
	    },
	    /**
	         * move node down
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Boolean}
	         */
	    moveDown: function() {
	      if (!this.parent) {
	        Konva.Util.warn('Node has no parent. moveDown function is ignored.');
	        return false;
	      }
	      var index = this.index;
	      if (index > 0) {
	        this.parent.children.splice(index, 1);
	        this.parent.children.splice(index - 1, 0, this);
	        this.parent._setChildrenIndices();
	        return true;
	      }
	      return false;
	    },
	    /**
	         * move node to the bottom of its siblings
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Boolean}
	         */
	    moveToBottom: function() {
	      if (!this.parent) {
	        Konva.Util.warn(
	          'Node has no parent. moveToBottom function is ignored.'
	        );
	        return false;
	      }
	      var index = this.index;
	      if (index > 0) {
	        this.parent.children.splice(index, 1);
	        this.parent.children.unshift(this);
	        this.parent._setChildrenIndices();
	        return true;
	      }
	      return false;
	    },
	    /**
	         * set zIndex relative to siblings
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {Integer} zIndex
	         * @returns {Konva.Node}
	         */
	    setZIndex: function(zIndex) {
	      if (!this.parent) {
	        Konva.Util.warn('Node has no parent. zIndex parameter is ignored.');
	        return false;
	      }
	      var index = this.index;
	      this.parent.children.splice(index, 1);
	      this.parent.children.splice(zIndex, 0, this);
	      this.parent._setChildrenIndices();
	      return this;
	    },
	    /**
	         * get absolute opacity
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Number}
	         */
	    getAbsoluteOpacity: function() {
	      return this._getCache(ABSOLUTE_OPACITY, this._getAbsoluteOpacity);
	    },
	    _getAbsoluteOpacity: function() {
	      var absOpacity = this.getOpacity();
	      var parent = this.getParent();
	      if (parent && !parent._isUnderCache) {
	        absOpacity *= this.getParent().getAbsoluteOpacity();
	      }
	      return absOpacity;
	    },
	    /**
	         * move node to another container
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {Container} newContainer
	         * @returns {Konva.Node}
	         * @example
	         * // move node from current layer into layer2
	         * node.moveTo(layer2);
	         */
	    moveTo: function(newContainer) {
	      // do nothing if new container is already parent
	      if (this.getParent() !== newContainer) {
	        // this.remove my be overrided by drag and drop
	        // buy we need original
	        (this.__originalRemove || this.remove).call(this);
	        newContainer.add(this);
	      }
	      return this;
	    },
	    /**
	         * convert Node into an object for serialization.  Returns an object.
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Object}
	         */
	    toObject: function() {
	      var obj = {},
	        attrs = this.getAttrs(),
	        key,
	        val,
	        getter,
	        defaultValue;
	
	      obj.attrs = {};
	
	      for (key in attrs) {
	        val = attrs[key];
	        getter = this[key];
	        // remove attr value so that we can extract the default value from the getter
	        delete attrs[key];
	        defaultValue = getter ? getter.call(this) : null;
	        // restore attr value
	        attrs[key] = val;
	        if (defaultValue !== val) {
	          obj.attrs[key] = val;
	        }
	      }
	
	      obj.className = this.getClassName();
	      return Konva.Util._prepareToStringify(obj);
	    },
	    /**
	         * convert Node into a JSON string.  Returns a JSON string.
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {String}}
	         */
	    toJSON: function() {
	      return JSON.stringify(this.toObject());
	    },
	    /**
	         * get parent container
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Konva.Node}
	         */
	    getParent: function() {
	      return this.parent;
	    },
	    /**
	         * get all ancestros (parent then parent of the parent, etc) of the node
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {String} [selector] selector for search
	         * @param {Boolean} [includeSelf] show we think that node is ancestro itself?
	         * @param {Konva.Node} [stopNode] optional node where we need to stop searching (one of ancestors)
	         * @returns {Array} [ancestors]
	         * @example
	         * // get one of the parent group
	         * var parentGroups = node.findAncestors('Group');
	         */
	    findAncestors: function(selector, includeSelf, stopNode) {
	      var res = [];
	
	      if (includeSelf && this._isMatch(selector)) {
	        res.push(this);
	      }
	      var ancestor = this.parent;
	      while (ancestor) {
	        if (ancestor === stopNode) {
	          return res;
	        }
	        if (ancestor._isMatch(selector)) {
	          res.push(ancestor);
	        }
	        ancestor = ancestor.parent;
	      }
	      return res;
	    },
	    /**
	         * get ancestor (parent or parent of the parent, etc) of the node that match passed selector
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {String} [selector] selector for search
	         * @param {Boolean} [includeSelf] show we think that node is ancestro itself?
	         * @param {Konva.Node} [stopNode] optional node where we need to stop searching (one of ancestors)
	         * @returns {Konva.Node} ancestor
	         * @example
	         * // get one of the parent group
	         * var group = node.findAncestors('.mygroup');
	         */
	    findAncestor: function(selector, includeSelf, stopNode) {
	      return this.findAncestors(selector, includeSelf, stopNode)[0];
	    },
	    // is current node match passed selector?
	    _isMatch: function(selector) {
	      if (!selector) {
	        return false;
	      }
	      var selectorArr = selector.replace(/ /g, '').split(','),
	        len = selectorArr.length,
	        n,
	        sel;
	
	      for (n = 0; n < len; n++) {
	        sel = selectorArr[n];
	        if (!Konva.Util.isValidSelector(sel)) {
	          Konva.Util.warn(
	            'Selector "' +
	              sel +
	              '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".'
	          );
	          Konva.Util.warn(
	            'If you have a custom shape with such className, please change it to start with upper letter like "Triangle".'
	          );
	          Konva.Util.warn('Konva is awesome, right?');
	        }
	        // id selector
	        if (sel.charAt(0) === '#') {
	          if (this.id() === sel.slice(1)) {
	            return true;
	          }
	        } else if (sel.charAt(0) === '.') {
	          // name selector
	          if (this.hasName(sel.slice(1))) {
	            return true;
	          }
	        } else if (this._get(sel).length !== 0) {
	          return true;
	        }
	      }
	      return false;
	    },
	    /**
	         * get layer ancestor
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Konva.Layer}
	         */
	    getLayer: function() {
	      var parent = this.getParent();
	      return parent ? parent.getLayer() : null;
	    },
	    /**
	         * get stage ancestor
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Konva.Stage}
	         */
	    getStage: function() {
	      return this._getCache(STAGE, this._getStage);
	    },
	    _getStage: function() {
	      var parent = this.getParent();
	      if (parent) {
	        return parent.getStage();
	      } else {
	        return undefined;
	      }
	    },
	    /**
	         * fire event
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {String} eventType event type.  can be a regular event, like click, mouseover, or mouseout, or it can be a custom event, like myCustomEvent
	         * @param {Event} [evt] event object
	         * @param {Boolean} [bubble] setting the value to false, or leaving it undefined, will result in the event
	         *  not bubbling.  Setting the value to true will result in the event bubbling.
	         * @returns {Konva.Node}
	         * @example
	         * // manually fire click event
	         * node.fire('click');
	         *
	         * // fire custom event
	         * node.fire('foo');
	         *
	         * // fire custom event with custom event object
	         * node.fire('foo', {
	         *   bar: 10
	         * });
	         *
	         * // fire click event that bubbles
	         * node.fire('click', null, true);
	         */
	    fire: function(eventType, evt, bubble) {
	      evt = evt || {};
	      evt.target = evt.target || this;
	      // bubble
	      if (bubble) {
	        this._fireAndBubble(eventType, evt);
	      } else {
	        // no bubble
	        this._fire(eventType, evt);
	      }
	      return this;
	    },
	    /**
	         * get absolute transform of the node which takes into
	         *  account its ancestor transforms
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Konva.Transform}
	         */
	    getAbsoluteTransform: function(top) {
	      // if using an argument, we can't cache the result.
	      if (top) {
	        return this._getAbsoluteTransform(top);
	      } else {
	        // if no argument, we can cache the result
	        return this._getCache(ABSOLUTE_TRANSFORM, this._getAbsoluteTransform);
	      }
	    },
	    _getAbsoluteTransform: function(top) {
	      var at = new Konva.Transform(),
	        transformsEnabled,
	        trans;
	
	      // start with stage and traverse downwards to self
	      this._eachAncestorReverse(function(node) {
	        transformsEnabled = node.transformsEnabled();
	        trans = node.getTransform();
	
	        if (transformsEnabled === 'all') {
	          at.multiply(trans);
	        } else if (transformsEnabled === 'position') {
	          at.translate(node.x(), node.y());
	        }
	      }, top);
	      return at;
	    },
	    /**
	         * get absolute scale of the node which takes into
	         *  account its ancestor scales
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Konva.Transform}
	         */
	    getAbsoluteScale: function(top) {
	      // if using an argument, we can't cache the result.
	      if (top) {
	        return this._getAbsoluteScale(top);
	      } else {
	        // if no argument, we can cache the result
	        return this._getCache(ABSOLUTE_SCALE, this._getAbsoluteScale);
	      }
	    },
	    _getAbsoluteScale: function(top) {
	      // this is special logic for caching with some shapes with shadow
	      var parent = this;
	      while (parent) {
	        if (parent._isUnderCache) {
	          top = parent;
	        }
	        parent = parent.getParent();
	      }
	
	      var scaleX = 1,
	        scaleY = 1;
	
	      // start with stage and traverse downwards to self
	      this._eachAncestorReverse(function(node) {
	        scaleX *= node.scaleX();
	        scaleY *= node.scaleY();
	      }, top);
	      return {
	        x: scaleX,
	        y: scaleY
	      };
	    },
	    /**
	         * get transform of the node
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Konva.Transform}
	         */
	    getTransform: function() {
	      return this._getCache(TRANSFORM, this._getTransform);
	    },
	    _getTransform: function() {
	      var m = new Konva.Transform(),
	        x = this.getX(),
	        y = this.getY(),
	        rotation = Konva.getAngle(this.getRotation()),
	        scaleX = this.getScaleX(),
	        scaleY = this.getScaleY(),
	        skewX = this.getSkewX(),
	        skewY = this.getSkewY(),
	        offsetX = this.getOffsetX(),
	        offsetY = this.getOffsetY();
	
	      if (x !== 0 || y !== 0) {
	        m.translate(x, y);
	      }
	      if (rotation !== 0) {
	        m.rotate(rotation);
	      }
	      if (skewX !== 0 || skewY !== 0) {
	        m.skew(skewX, skewY);
	      }
	      if (scaleX !== 1 || scaleY !== 1) {
	        m.scale(scaleX, scaleY);
	      }
	      if (offsetX !== 0 || offsetY !== 0) {
	        m.translate(-1 * offsetX, -1 * offsetY);
	      }
	
	      return m;
	    },
	    /**
	         * clone node.  Returns a new Node instance with identical attributes.  You can also override
	         *  the node properties with an object literal, enabling you to use an existing node as a template
	         *  for another node
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {Object} obj override attrs
	         * @returns {Konva.Node}
	         * @example
	         * // simple clone
	         * var clone = node.clone();
	         *
	         * // clone a node and override the x position
	         * var clone = rect.clone({
	         *   x: 5
	         * });
	         */
	    clone: function(obj) {
	      // instantiate new node
	      var attrs = Konva.Util.cloneObject(this.attrs),
	        key,
	        allListeners,
	        len,
	        n,
	        listener;
	      // filter black attrs
	      for (var i in CLONE_BLACK_LIST) {
	        var blockAttr = CLONE_BLACK_LIST[i];
	        delete attrs[blockAttr];
	      }
	      // apply attr overrides
	      for (key in obj) {
	        attrs[key] = obj[key];
	      }
	
	      var node = new this.constructor(attrs);
	      // copy over listeners
	      for (key in this.eventListeners) {
	        allListeners = this.eventListeners[key];
	        len = allListeners.length;
	        for (n = 0; n < len; n++) {
	          listener = allListeners[n];
	          /*
	                     * don't include konva namespaced listeners because
	                     *  these are generated by the constructors
	                     */
	          if (listener.name.indexOf(KONVA) < 0) {
	            // if listeners array doesn't exist, then create it
	            if (!node.eventListeners[key]) {
	              node.eventListeners[key] = [];
	            }
	            node.eventListeners[key].push(listener);
	          }
	        }
	      }
	      return node;
	    },
	    _toKonvaCanvas: function(config) {
	      config = config || {};
	
	      var stage = this.getStage(),
	        x = config.x || 0,
	        y = config.y || 0,
	        pixelRatio = config.pixelRatio || 1,
	        canvas = new Konva.SceneCanvas({
	          width:
	            config.width || this.getWidth() || (stage ? stage.getWidth() : 0),
	          height:
	            config.height ||
	            this.getHeight() ||
	            (stage ? stage.getHeight() : 0),
	          pixelRatio: pixelRatio
	        }),
	        context = canvas.getContext();
	
	      context.save();
	
	      if (x || y) {
	        context.translate(-1 * x, -1 * y);
	      }
	
	      this.drawScene(canvas);
	      context.restore();
	
	      return canvas;
	    },
	    /**
	         * converts node into an canvas element.
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {Object} config
	         * @param {Function} config.callback function executed when the composite has completed
	         * @param {Number} [config.x] x position of canvas section
	         * @param {Number} [config.y] y position of canvas section
	         * @param {Number} [config.width] width of canvas section
	         * @param {Number} [config.height] height of canvas section
	         * @paremt {Number} [config.pixelRatio] pixelRatio of ouput image.  Default is 1.
	         * @example
	         * var canvas = node.toCanvas();
	         */
	    toCanvas: function(config) {
	      return this._toKonvaCanvas(config)._canvas;
	    },
	    /**
	         * Creates a composite data URL. If MIME type is not
	         * specified, then "image/png" will result. For "image/jpeg", specify a quality
	         * level as quality (range 0.0 - 1.0)
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {Object} config
	         * @param {String} [config.mimeType] can be "image/png" or "image/jpeg".
	         *  "image/png" is the default
	         * @param {Number} [config.x] x position of canvas section
	         * @param {Number} [config.y] y position of canvas section
	         * @param {Number} [config.width] width of canvas section
	         * @param {Number} [config.height] height of canvas section
	         * @param {Number} [config.quality] jpeg quality.  If using an "image/jpeg" mimeType,
	         *  you can specify the quality from 0 to 1, where 0 is very poor quality and 1
	         *  is very high quality
	         * @paremt {Number} [config.pixelRatio] pixelRatio of ouput image url. Default is 1
	         * @returns {String}
	         */
	    toDataURL: function(config) {
	      config = config || {};
	      var mimeType = config.mimeType || null,
	        quality = config.quality || null;
	      return this._toKonvaCanvas(config).toDataURL(mimeType, quality);
	    },
	    /**
	         * converts node into an image.  Since the toImage
	         *  method is asynchronous, a callback is required.  toImage is most commonly used
	         *  to cache complex drawings as an image so that they don't have to constantly be redrawn
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {Object} config
	         * @param {Function} config.callback function executed when the composite has completed
	         * @param {String} [config.mimeType] can be "image/png" or "image/jpeg".
	         *  "image/png" is the default
	         * @param {Number} [config.x] x position of canvas section
	         * @param {Number} [config.y] y position of canvas section
	         * @param {Number} [config.width] width of canvas section
	         * @param {Number} [config.height] height of canvas section
	         * @param {Number} [config.quality] jpeg quality.  If using an "image/jpeg" mimeType,
	         *  you can specify the quality from 0 to 1, where 0 is very poor quality and 1
	         *  is very high quality
	         * @paremt {Number} [config.pixelRatio] pixelRatio of ouput image.  Default is 1.
	         * @example
	         * var image = node.toImage({
	         *   callback: function(img) {
	         *     // do stuff with img
	         *   }
	         * });
	         */
	    toImage: function(config) {
	      if (!config || !config.callback) {
	        throw 'callback required for toImage method config argument';
	      }
	      Konva.Util._getImage(this.toDataURL(config), function(img) {
	        config.callback(img);
	      });
	    },
	    setSize: function(size) {
	      this.setWidth(size.width);
	      this.setHeight(size.height);
	      return this;
	    },
	    getSize: function() {
	      return {
	        width: this.getWidth(),
	        height: this.getHeight()
	      };
	    },
	    getWidth: function() {
	      return this.attrs.width || 0;
	    },
	    getHeight: function() {
	      return this.attrs.height || 0;
	    },
	    /**
	         * get class name, which may return Stage, Layer, Group, or shape class names like Rect, Circle, Text, etc.
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {String}
	         */
	    getClassName: function() {
	      return this.className || this.nodeType;
	    },
	    /**
	         * get the node type, which may return Stage, Layer, Group, or Node
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {String}
	         */
	    getType: function() {
	      return this.nodeType;
	    },
	    getDragDistance: function() {
	      // compare with undefined because we need to track 0 value
	      if (this.attrs.dragDistance !== undefined) {
	        return this.attrs.dragDistance;
	      } else if (this.parent) {
	        return this.parent.getDragDistance();
	      } else {
	        return Konva.dragDistance;
	      }
	    },
	    _get: function(selector) {
	      return this.className === selector || this.nodeType === selector
	        ? [this]
	        : [];
	    },
	    _off: function(type, name) {
	      var evtListeners = this.eventListeners[type],
	        i,
	        evtName;
	
	      for (i = 0; i < evtListeners.length; i++) {
	        evtName = evtListeners[i].name;
	        // the following two conditions must be true in order to remove a handler:
	        // 1) the current event name cannot be konva unless the event name is konva
	        //    this enables developers to force remove a konva specific listener for whatever reason
	        // 2) an event name is not specified, or if one is specified, it matches the current event name
	        if (
	          (evtName !== 'konva' || name === 'konva') &&
	          (!name || evtName === name)
	        ) {
	          evtListeners.splice(i, 1);
	          if (evtListeners.length === 0) {
	            delete this.eventListeners[type];
	            break;
	          }
	          i--;
	        }
	      }
	    },
	    _fireChangeEvent: function(attr, oldVal, newVal) {
	      this._fire(attr + CHANGE, {
	        oldVal: oldVal,
	        newVal: newVal
	      });
	    },
	    setId: function(id) {
	      var oldId = this.getId();
	
	      Konva._removeId(oldId);
	      Konva._addId(this, id);
	      this._setAttr(ID, id);
	      return this;
	    },
	    setName: function(name) {
	      var oldNames = (this.getName() || '').split(/\s/g);
	      var newNames = (name || '').split(/\s/g);
	      var subname, i;
	      // remove all subnames
	      for (i = 0; i < oldNames.length; i++) {
	        subname = oldNames[i];
	        if (newNames.indexOf(subname) === -1 && subname) {
	          Konva._removeName(subname, this._id);
	        }
	      }
	
	      // add new names
	      for (i = 0; i < newNames.length; i++) {
	        subname = newNames[i];
	        if (oldNames.indexOf(subname) === -1 && subname) {
	          Konva._addName(this, subname);
	        }
	      }
	
	      this._setAttr(NAME, name);
	      return this;
	    },
	    // naming methods
	    /**
	         * add name to node
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {String} name
	         * @returns {Konva.Node}
	         * @example
	         * node.name('red');
	         * node.addName('selected');
	         * node.name(); // return 'red selected'
	         */
	    addName: function(name) {
	      if (!this.hasName(name)) {
	        var oldName = this.name();
	        var newName = oldName ? oldName + ' ' + name : name;
	        this.setName(newName);
	      }
	      return this;
	    },
	    /**
	         * check is node has name
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {String} name
	         * @returns {Boolean}
	         * @example
	         * node.name('red');
	         * node.hasName('red');   // return true
	         * node.hasName('selected'); // return false
	         */
	    hasName: function(name) {
	      var names = (this.name() || '').split(/\s/g);
	      return names.indexOf(name) !== -1;
	    },
	    /**
	         * remove name from node
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {String} name
	         * @returns {Konva.Node}
	         * @example
	         * node.name('red selected');
	         * node.removeName('selected');
	         * node.hasName('selected'); // return false
	         * node.name(); // return 'red'
	         */
	    removeName: function(name) {
	      var names = (this.name() || '').split(/\s/g);
	      var index = names.indexOf(name);
	      if (index !== -1) {
	        names.splice(index, 1);
	        this.setName(names.join(' '));
	      }
	      return this;
	    },
	    /**
	         * set attr
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {String} attr
	         * @param {*} val
	         * @returns {Konva.Node}
	         * @example
	         * node.setAttr('x', 5);
	         */
	    setAttr: function(attr, val) {
	      var method = SET + Konva.Util._capitalize(attr),
	        func = this[method];
	
	      if (Konva.Util._isFunction(func)) {
	        func.call(this, val);
	      } else {
	        // otherwise set directly
	        this._setAttr(attr, val);
	      }
	      return this;
	    },
	    _setAttr: function(key, val) {
	      var oldVal;
	      oldVal = this.attrs[key];
	      if (oldVal === val) {
	        return;
	      }
	      if (val === undefined || val === null) {
	        delete this.attrs[key];
	      } else {
	        this.attrs[key] = val;
	      }
	      this._fireChangeEvent(key, oldVal, val);
	    },
	    _setComponentAttr: function(key, component, val) {
	      var oldVal;
	      if (val !== undefined) {
	        oldVal = this.attrs[key];
	
	        if (!oldVal) {
	          // set value to default value using getAttr
	          this.attrs[key] = this.getAttr(key);
	        }
	
	        this.attrs[key][component] = val;
	        this._fireChangeEvent(key, oldVal, val);
	      }
	    },
	    _fireAndBubble: function(eventType, evt, compareShape) {
	      var okayToRun = true;
	
	      if (evt && this.nodeType === SHAPE) {
	        evt.target = this;
	      }
	
	      if (
	        eventType === MOUSEENTER &&
	        compareShape &&
	        (this._id === compareShape._id ||
	          (this.isAncestorOf && this.isAncestorOf(compareShape)))
	      ) {
	        okayToRun = false;
	      } else if (
	        eventType === MOUSELEAVE &&
	        compareShape &&
	        (this._id === compareShape._id ||
	          (this.isAncestorOf && this.isAncestorOf(compareShape)))
	      ) {
	        okayToRun = false;
	      }
	      if (okayToRun) {
	        this._fire(eventType, evt);
	
	        // simulate event bubbling
	        var stopBubble =
	          (eventType === MOUSEENTER || eventType === MOUSELEAVE) &&
	          (compareShape &&
	            compareShape.isAncestorOf &&
	            compareShape.isAncestorOf(this) &&
	            !compareShape.isAncestorOf(this.parent));
	        if (
	          ((evt && !evt.cancelBubble) || !evt) &&
	          this.parent &&
	          this.parent.isListening() &&
	          !stopBubble
	        ) {
	          if (compareShape && compareShape.parent) {
	            this._fireAndBubble.call(
	              this.parent,
	              eventType,
	              evt,
	              compareShape.parent
	            );
	          } else {
	            this._fireAndBubble.call(this.parent, eventType, evt);
	          }
	        }
	      }
	    },
	    _fire: function(eventType, evt) {
	      var events = this.eventListeners[eventType],
	        i;
	
	      evt = evt || {};
	      evt.currentTarget = this;
	      evt.type = eventType;
	
	      if (events) {
	        for (i = 0; i < events.length; i++) {
	          events[i].handler.call(this, evt);
	        }
	      }
	    },
	    /**
	         * draw both scene and hit graphs.  If the node being drawn is the stage, all of the layers will be cleared and redrawn
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Konva.Node}
	         */
	    draw: function() {
	      this.drawScene();
	      this.drawHit();
	      return this;
	    }
	  });
	
	  /**
	     * create node with JSON string or an Object.  De-serializtion does not generate custom
	     *  shape drawing functions, images, or event handlers (this would make the
	     *  serialized object huge).  If your app uses custom shapes, images, and
	     *  event handlers (it probably does), then you need to select the appropriate
	     *  shapes after loading the stage and set these properties via on(), setDrawFunc(),
	     *  and setImage() methods
	     * @method
	     * @memberof Konva.Node
	     * @param {String|Object} json string or object
	     * @param {Element} [container] optional container dom element used only if you're
	     *  creating a stage node
	     */
	  Konva.Node.create = function(data, container) {
	    if (Konva.Util._isString(data)) {
	      data = JSON.parse(data);
	    }
	    return this._createNode(data, container);
	  };
	  Konva.Node._createNode = function(obj, container) {
	    var className = Konva.Node.prototype.getClassName.call(obj),
	      children = obj.children,
	      no,
	      len,
	      n;
	
	    // if container was passed in, add it to attrs
	    if (container) {
	      obj.attrs.container = container;
	    }
	
	    no = new Konva[className](obj.attrs);
	    if (children) {
	      len = children.length;
	      for (n = 0; n < len; n++) {
	        no.add(this._createNode(children[n]));
	      }
	    }
	
	    return no;
	  };
	
	  // =========================== add getters setters ===========================
	
	  Konva.Factory.addOverloadedGetterSetter(Konva.Node, 'position');
	  /**
	     * get/set node position relative to parent
	     * @name position
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Object} pos
	     * @param {Number} pos.x
	     * @param {Number} pos.y
	     * @returns {Object}
	     * @example
	     * // get position
	     * var position = node.position();
	     *
	     * // set position
	     * node.position({
	     *   x: 5
	     *   y: 10
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'x', 0);
	
	  /**
	     * get/set x position
	     * @name x
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Number} x
	     * @returns {Object}
	     * @example
	     * // get x
	     * var x = node.x();
	     *
	     * // set x
	     * node.x(5);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'y', 0);
	
	  /**
	     * get/set y position
	     * @name y
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Number} y
	     * @returns {Integer}
	     * @example
	     * // get y
	     * var y = node.y();
	     *
	     * // set y
	     * node.y(5);
	     */
	
	  Konva.Factory.addGetterSetter(
	    Konva.Node,
	    'globalCompositeOperation',
	    'source-over'
	  );
	
	  /**
	     * get/set globalCompositeOperation of a shape
	     * @name globalCompositeOperation
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Number} blur
	     * @returns {Number}
	     * @example
	     * // get shadow blur
	     * var globalCompositeOperation = shape.globalCompositeOperation();
	     *
	     * // set shadow blur
	     * shape.globalCompositeOperation('source-in');
	     */
	  Konva.Factory.addGetterSetter(Konva.Node, 'opacity', 1);
	
	  /**
	     * get/set opacity.  Opacity values range from 0 to 1.
	     *  A node with an opacity of 0 is fully transparent, and a node
	     *  with an opacity of 1 is fully opaque
	     * @name opacity
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Object} opacity
	     * @returns {Number}
	     * @example
	     * // get opacity
	     * var opacity = node.opacity();
	     *
	     * // set opacity
	     * node.opacity(0.5);
	     */
	
	  Konva.Factory.addGetter(Konva.Node, 'name');
	  Konva.Factory.addOverloadedGetterSetter(Konva.Node, 'name');
	
	  /**
	     * get/set name
	     * @name name
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {String} name
	     * @returns {String}
	     * @example
	     * // get name
	     * var name = node.name();
	     *
	     * // set name
	     * node.name('foo');
	     *
	     * // also node may have multiple names (as css classes)
	     * node.name('foo bar');
	     */
	
	  Konva.Factory.addGetter(Konva.Node, 'id');
	  Konva.Factory.addOverloadedGetterSetter(Konva.Node, 'id');
	
	  /**
	     * get/set id. Id is global for whole page.
	     * @name id
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {String} id
	     * @returns {String}
	     * @example
	     * // get id
	     * var name = node.id();
	     *
	     * // set id
	     * node.id('foo');
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'rotation', 0);
	
	  /**
	     * get/set rotation in degrees
	     * @name rotation
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Number} rotation
	     * @returns {Number}
	     * @example
	     * // get rotation in degrees
	     * var rotation = node.rotation();
	     *
	     * // set rotation in degrees
	     * node.rotation(45);
	     */
	
	  Konva.Factory.addComponentsGetterSetter(Konva.Node, 'scale', ['x', 'y']);
	
	  /**
	     * get/set scale
	     * @name scale
	     * @param {Object} scale
	     * @param {Number} scale.x
	     * @param {Number} scale.y
	     * @method
	     * @memberof Konva.Node.prototype
	     * @returns {Object}
	     * @example
	     * // get scale
	     * var scale = node.scale();
	     *
	     * // set scale
	     * shape.scale({
	     *   x: 2
	     *   y: 3
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'scaleX', 1);
	
	  /**
	     * get/set scale x
	     * @name scaleX
	     * @param {Number} x
	     * @method
	     * @memberof Konva.Node.prototype
	     * @returns {Number}
	     * @example
	     * // get scale x
	     * var scaleX = node.scaleX();
	     *
	     * // set scale x
	     * node.scaleX(2);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'scaleY', 1);
	
	  /**
	     * get/set scale y
	     * @name scaleY
	     * @param {Number} y
	     * @method
	     * @memberof Konva.Node.prototype
	     * @returns {Number}
	     * @example
	     * // get scale y
	     * var scaleY = node.scaleY();
	     *
	     * // set scale y
	     * node.scaleY(2);
	     */
	
	  Konva.Factory.addComponentsGetterSetter(Konva.Node, 'skew', ['x', 'y']);
	
	  /**
	     * get/set skew
	     * @name skew
	     * @param {Object} skew
	     * @param {Number} skew.x
	     * @param {Number} skew.y
	     * @method
	     * @memberof Konva.Node.prototype
	     * @returns {Object}
	     * @example
	     * // get skew
	     * var skew = node.skew();
	     *
	     * // set skew
	     * node.skew({
	     *   x: 20
	     *   y: 10
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'skewX', 0);
	
	  /**
	     * get/set skew x
	     * @name skewX
	     * @param {Number} x
	     * @method
	     * @memberof Konva.Node.prototype
	     * @returns {Number}
	     * @example
	     * // get skew x
	     * var skewX = node.skewX();
	     *
	     * // set skew x
	     * node.skewX(3);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'skewY', 0);
	
	  /**
	     * get/set skew y
	     * @name skewY
	     * @param {Number} y
	     * @method
	     * @memberof Konva.Node.prototype
	     * @returns {Number}
	     * @example
	     * // get skew y
	     * var skewY = node.skewY();
	     *
	     * // set skew y
	     * node.skewY(3);
	     */
	
	  Konva.Factory.addComponentsGetterSetter(Konva.Node, 'offset', ['x', 'y']);
	
	  /**
	     * get/set offset.  Offsets the default position and rotation point
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Object} offset
	     * @param {Number} offset.x
	     * @param {Number} offset.y
	     * @returns {Object}
	     * @example
	     * // get offset
	     * var offset = node.offset();
	     *
	     * // set offset
	     * node.offset({
	     *   x: 20
	     *   y: 10
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'offsetX', 0);
	
	  /**
	     * get/set offset x
	     * @name offsetX
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Number} x
	     * @returns {Number}
	     * @example
	     * // get offset x
	     * var offsetX = node.offsetX();
	     *
	     * // set offset x
	     * node.offsetX(3);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'offsetY', 0);
	
	  /**
	     * get/set offset y
	     * @name offsetY
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Number} y
	     * @returns {Number}
	     * @example
	     * // get offset y
	     * var offsetY = node.offsetY();
	     *
	     * // set offset y
	     * node.offsetY(3);
	     */
	
	  Konva.Factory.addSetter(Konva.Node, 'dragDistance');
	  Konva.Factory.addOverloadedGetterSetter(Konva.Node, 'dragDistance');
	
	  /**
	     * get/set drag distance
	     * @name dragDistance
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Number} distance
	     * @returns {Number}
	     * @example
	     * // get drag distance
	     * var dragDistance = node.dragDistance();
	     *
	     * // set distance
	     * // node starts dragging only if pointer moved more then 3 pixels
	     * node.dragDistance(3);
	     * // or set globally
	     * Konva.dragDistance = 3;
	     */
	
	  Konva.Factory.addSetter(Konva.Node, 'width', 0);
	  Konva.Factory.addOverloadedGetterSetter(Konva.Node, 'width');
	  /**
	     * get/set width
	     * @name width
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Number} width
	     * @returns {Number}
	     * @example
	     * // get width
	     * var width = node.width();
	     *
	     * // set width
	     * node.width(100);
	     */
	
	  Konva.Factory.addSetter(Konva.Node, 'height', 0);
	  Konva.Factory.addOverloadedGetterSetter(Konva.Node, 'height');
	  /**
	     * get/set height
	     * @name height
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Number} height
	     * @returns {Number}
	     * @example
	     * // get height
	     * var height = node.height();
	     *
	     * // set height
	     * node.height(100);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'listening', 'inherit');
	  /**
	     * get/set listenig attr.  If you need to determine if a node is listening or not
	     *   by taking into account its parents, use the isListening() method
	     * @name listening
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Boolean|String} listening Can be "inherit", true, or false.  The default is "inherit".
	     * @returns {Boolean|String}
	     * @example
	     * // get listening attr
	     * var listening = node.listening();
	     *
	     * // stop listening for events
	     * node.listening(false);
	     *
	     * // listen for events
	     * node.listening(true);
	     *
	     * // listen to events according to the parent
	     * node.listening('inherit');
	     */
	
	  /**
	      * get/set preventDefault
	      * By default all shapes will prevent default behaviour
	      * of a browser on a pointer move or tap.
	      * that will prevent native scrolling when you are trying to drag&drop a node
	      * but sometimes you may need to enable default actions
	      * in that case you can set the property to false
	      * @name preventDefault
	      * @method
	      * @memberof Konva.Node.prototype
	      * @param {Number} preventDefault
	      * @returns {Number}
	      * @example
	      * // get preventDefault
	      * var shouldPrevent = shape.preventDefault();
	      *
	      * // set preventDefault
	      * shape.preventDefault(false);
	      */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'preventDefault', true);
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'filters', undefined, function(
	    val
	  ) {
	    this._filterUpToDate = false;
	    return val;
	  });
	  /**
	     * get/set filters.  Filters are applied to cached canvases
	     * @name filters
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Array} filters array of filters
	     * @returns {Array}
	     * @example
	     * // get filters
	     * var filters = node.filters();
	     *
	     * // set a single filter
	     * node.cache();
	     * node.filters([Konva.Filters.Blur]);
	     *
	     * // set multiple filters
	     * node.cache();
	     * node.filters([
	     *   Konva.Filters.Blur,
	     *   Konva.Filters.Sepia,
	     *   Konva.Filters.Invert
	     * ]);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'visible', 'inherit');
	  /**
	     * get/set visible attr.  Can be "inherit", true, or false.  The default is "inherit".
	     *   If you need to determine if a node is visible or not
	     *   by taking into account its parents, use the isVisible() method
	     * @name visible
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Boolean|String} visible
	     * @returns {Boolean|String}
	     * @example
	     * // get visible attr
	     * var visible = node.visible();
	     *
	     * // make invisible
	     * node.visible(false);
	     *
	     * // make visible
	     * node.visible(true);
	     *
	     * // make visible according to the parent
	     * node.visible('inherit');
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'transformsEnabled', 'all');
	
	  /**
	     * get/set transforms that are enabled.  Can be "all", "none", or "position".  The default
	     *  is "all"
	     * @name transformsEnabled
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {String} enabled
	     * @returns {String}
	     * @example
	     * // enable position transform only to improve draw performance
	     * node.transformsEnabled('position');
	     *
	     * // enable all transforms
	     * node.transformsEnabled('all');
	     */
	
	  /**
	     * get/set node size
	     * @name size
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Object} size
	     * @param {Number} size.width
	     * @param {Number} size.height
	     * @returns {Object}
	     * @example
	     * // get node size
	     * var size = node.size();
	     * var x = size.x;
	     * var y = size.y;
	     *
	     * // set size
	     * node.size({
	     *   width: 100,
	     *   height: 200
	     * });
	     */
	  Konva.Factory.addOverloadedGetterSetter(Konva.Node, 'size');
	
	  Konva.Factory.backCompat(Konva.Node, {
	    rotateDeg: 'rotate',
	    setRotationDeg: 'setRotation',
	    getRotationDeg: 'getRotation'
	  });
	
	  Konva.Collection.mapMethods(Konva.Node);
	})(Konva);
	
	(function() {
	  'use strict';
	  /**
	    * Grayscale Filter
	    * @function
	    * @memberof Konva.Filters
	    * @param {Object} imageData
	    * @example
	    * node.cache();
	    * node.filters([Konva.Filters.Grayscale]);
	    */
	  Konva.Filters.Grayscale = function(imageData) {
	    var data = imageData.data, len = data.length, i, brightness;
	
	    for (i = 0; i < len; i += 4) {
	      brightness = 0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2];
	      // red
	      data[i] = brightness;
	      // green
	      data[i + 1] = brightness;
	      // blue
	      data[i + 2] = brightness;
	    }
	  };
	})();
	
	(function(Konva) {
	  'use strict';
	  /**
	     * Brighten Filter.
	     * @function
	     * @memberof Konva.Filters
	     * @param {Object} imageData
	     * @example
	     * node.cache();
	     * node.filters([Konva.Filters.Brighten]);
	     * node.brightness(0.8);
	     */
	  Konva.Filters.Brighten = function(imageData) {
	    var brightness = this.brightness() * 255,
	      data = imageData.data,
	      len = data.length,
	      i;
	
	    for (i = 0; i < len; i += 4) {
	      // red
	      data[i] += brightness;
	      // green
	      data[i + 1] += brightness;
	      // blue
	      data[i + 2] += brightness;
	    }
	  };
	
	  Konva.Factory.addGetterSetter(
	    Konva.Node,
	    'brightness',
	    0,
	    null,
	    Konva.Factory.afterSetFilter
	  );
	  /**
	    * get/set filter brightness.  The brightness is a number between -1 and 1.&nbsp; Positive values
	    *  brighten the pixels and negative values darken them. Use with {@link Konva.Filters.Brighten} filter.
	    * @name brightness
	    * @method
	    * @memberof Konva.Node.prototype
	    * @param {Number} brightness value between -1 and 1
	    * @returns {Number}
	    */
	})(Konva);
	
	(function() {
	  'use strict';
	  /**
	    * Invert Filter
	    * @function
	    * @memberof Konva.Filters
	    * @param {Object} imageData
	    * @example
	    * node.cache();
	    * node.filters([Konva.Filters.Invert]);
	    */
	  Konva.Filters.Invert = function(imageData) {
	    var data = imageData.data, len = data.length, i;
	
	    for (i = 0; i < len; i += 4) {
	      // red
	      data[i] = 255 - data[i];
	      // green
	      data[i + 1] = 255 - data[i + 1];
	      // blue
	      data[i + 2] = 255 - data[i + 2];
	    }
	  };
	})();
	
	/*
	 the Gauss filter
	 master repo: https://github.com/pavelpower/kineticjsGaussFilter
	*/
	(function(Konva) {
	  'use strict';
	  /*
	
	     StackBlur - a fast almost Gaussian Blur For Canvas
	
	     Version:   0.5
	     Author:    Mario Klingemann
	     Contact:   mario@quasimondo.com
	     Website:   http://www.quasimondo.com/StackBlurForCanvas
	     Twitter:   @quasimondo
	
	     In case you find this class useful - especially in commercial projects -
	     I am not totally unhappy for a small donation to my PayPal account
	     mario@quasimondo.de
	
	     Or support me on flattr:
	     https://flattr.com/thing/72791/StackBlur-a-fast-almost-Gaussian-Blur-Effect-for-CanvasJavascript
	
	     Copyright (c) 2010 Mario Klingemann
	
	     Permission is hereby granted, free of charge, to any person
	     obtaining a copy of this software and associated documentation
	     files (the "Software"), to deal in the Software without
	     restriction, including without limitation the rights to use,
	     copy, modify, merge, publish, distribute, sublicense, and/or sell
	     copies of the Software, and to permit persons to whom the
	     Software is furnished to do so, subject to the following
	     conditions:
	
	     The above copyright notice and this permission notice shall be
	     included in all copies or substantial portions of the Software.
	
	     THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	     EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
	     OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	     NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
	     HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
	     WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
	     FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
	     OTHER DEALINGS IN THE SOFTWARE.
	     */
	
	  function BlurStack() {
	    this.r = 0;
	    this.g = 0;
	    this.b = 0;
	    this.a = 0;
	    this.next = null;
	  }
	
	  var mul_table = [
	    512,
	    512,
	    456,
	    512,
	    328,
	    456,
	    335,
	    512,
	    405,
	    328,
	    271,
	    456,
	    388,
	    335,
	    292,
	    512,
	    454,
	    405,
	    364,
	    328,
	    298,
	    271,
	    496,
	    456,
	    420,
	    388,
	    360,
	    335,
	    312,
	    292,
	    273,
	    512,
	    482,
	    454,
	    428,
	    405,
	    383,
	    364,
	    345,
	    328,
	    312,
	    298,
	    284,
	    271,
	    259,
	    496,
	    475,
	    456,
	    437,
	    420,
	    404,
	    388,
	    374,
	    360,
	    347,
	    335,
	    323,
	    312,
	    302,
	    292,
	    282,
	    273,
	    265,
	    512,
	    497,
	    482,
	    468,
	    454,
	    441,
	    428,
	    417,
	    405,
	    394,
	    383,
	    373,
	    364,
	    354,
	    345,
	    337,
	    328,
	    320,
	    312,
	    305,
	    298,
	    291,
	    284,
	    278,
	    271,
	    265,
	    259,
	    507,
	    496,
	    485,
	    475,
	    465,
	    456,
	    446,
	    437,
	    428,
	    420,
	    412,
	    404,
	    396,
	    388,
	    381,
	    374,
	    367,
	    360,
	    354,
	    347,
	    341,
	    335,
	    329,
	    323,
	    318,
	    312,
	    307,
	    302,
	    297,
	    292,
	    287,
	    282,
	    278,
	    273,
	    269,
	    265,
	    261,
	    512,
	    505,
	    497,
	    489,
	    482,
	    475,
	    468,
	    461,
	    454,
	    447,
	    441,
	    435,
	    428,
	    422,
	    417,
	    411,
	    405,
	    399,
	    394,
	    389,
	    383,
	    378,
	    373,
	    368,
	    364,
	    359,
	    354,
	    350,
	    345,
	    341,
	    337,
	    332,
	    328,
	    324,
	    320,
	    316,
	    312,
	    309,
	    305,
	    301,
	    298,
	    294,
	    291,
	    287,
	    284,
	    281,
	    278,
	    274,
	    271,
	    268,
	    265,
	    262,
	    259,
	    257,
	    507,
	    501,
	    496,
	    491,
	    485,
	    480,
	    475,
	    470,
	    465,
	    460,
	    456,
	    451,
	    446,
	    442,
	    437,
	    433,
	    428,
	    424,
	    420,
	    416,
	    412,
	    408,
	    404,
	    400,
	    396,
	    392,
	    388,
	    385,
	    381,
	    377,
	    374,
	    370,
	    367,
	    363,
	    360,
	    357,
	    354,
	    350,
	    347,
	    344,
	    341,
	    338,
	    335,
	    332,
	    329,
	    326,
	    323,
	    320,
	    318,
	    315,
	    312,
	    310,
	    307,
	    304,
	    302,
	    299,
	    297,
	    294,
	    292,
	    289,
	    287,
	    285,
	    282,
	    280,
	    278,
	    275,
	    273,
	    271,
	    269,
	    267,
	    265,
	    263,
	    261,
	    259
	  ];
	
	  var shg_table = [
	    9,
	    11,
	    12,
	    13,
	    13,
	    14,
	    14,
	    15,
	    15,
	    15,
	    15,
	    16,
	    16,
	    16,
	    16,
	    17,
	    17,
	    17,
	    17,
	    17,
	    17,
	    17,
	    18,
	    18,
	    18,
	    18,
	    18,
	    18,
	    18,
	    18,
	    18,
	    19,
	    19,
	    19,
	    19,
	    19,
	    19,
	    19,
	    19,
	    19,
	    19,
	    19,
	    19,
	    19,
	    19,
	    20,
	    20,
	    20,
	    20,
	    20,
	    20,
	    20,
	    20,
	    20,
	    20,
	    20,
	    20,
	    20,
	    20,
	    20,
	    20,
	    20,
	    20,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    21,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    22,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    23,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24,
	    24
	  ];
	
	  function filterGaussBlurRGBA(imageData, radius) {
	    var pixels = imageData.data,
	      width = imageData.width,
	      height = imageData.height;
	
	    var x,
	      y,
	      i,
	      p,
	      yp,
	      yi,
	      yw,
	      r_sum,
	      g_sum,
	      b_sum,
	      a_sum,
	      r_out_sum,
	      g_out_sum,
	      b_out_sum,
	      a_out_sum,
	      r_in_sum,
	      g_in_sum,
	      b_in_sum,
	      a_in_sum,
	      pr,
	      pg,
	      pb,
	      pa,
	      rbs;
	
	    var div = radius + radius + 1,
	      widthMinus1 = width - 1,
	      heightMinus1 = height - 1,
	      radiusPlus1 = radius + 1,
	      sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2,
	      stackStart = new BlurStack(),
	      stackEnd = null,
	      stack = stackStart,
	      stackIn = null,
	      stackOut = null,
	      mul_sum = mul_table[radius],
	      shg_sum = shg_table[radius];
	
	    for (i = 1; i < div; i++) {
	      stack = stack.next = new BlurStack();
	      if (i === radiusPlus1) {
	        stackEnd = stack;
	      }
	    }
	
	    stack.next = stackStart;
	
	    yw = yi = 0;
	
	    for (y = 0; y < height; y++) {
	      r_in_sum = g_in_sum = b_in_sum = a_in_sum = r_sum = g_sum = b_sum = a_sum = 0;
	
	      r_out_sum = radiusPlus1 * (pr = pixels[yi]);
	      g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
	      b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
	      a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
	
	      r_sum += sumFactor * pr;
	      g_sum += sumFactor * pg;
	      b_sum += sumFactor * pb;
	      a_sum += sumFactor * pa;
	
	      stack = stackStart;
	
	      for (i = 0; i < radiusPlus1; i++) {
	        stack.r = pr;
	        stack.g = pg;
	        stack.b = pb;
	        stack.a = pa;
	        stack = stack.next;
	      }
	
	      for (i = 1; i < radiusPlus1; i++) {
	        p = yi + ((widthMinus1 < i ? widthMinus1 : i) << 2);
	        r_sum += (stack.r = pr = pixels[p]) * (rbs = radiusPlus1 - i);
	        g_sum += (stack.g = pg = pixels[p + 1]) * rbs;
	        b_sum += (stack.b = pb = pixels[p + 2]) * rbs;
	        a_sum += (stack.a = pa = pixels[p + 3]) * rbs;
	
	        r_in_sum += pr;
	        g_in_sum += pg;
	        b_in_sum += pb;
	        a_in_sum += pa;
	
	        stack = stack.next;
	      }
	
	      stackIn = stackStart;
	      stackOut = stackEnd;
	      for (x = 0; x < width; x++) {
	        pixels[yi + 3] = pa = (a_sum * mul_sum) >> shg_sum;
	        if (pa !== 0) {
	          pa = 255 / pa;
	          pixels[yi] = ((r_sum * mul_sum) >> shg_sum) * pa;
	          pixels[yi + 1] = ((g_sum * mul_sum) >> shg_sum) * pa;
	          pixels[yi + 2] = ((b_sum * mul_sum) >> shg_sum) * pa;
	        } else {
	          pixels[yi] = pixels[yi + 1] = pixels[yi + 2] = 0;
	        }
	
	        r_sum -= r_out_sum;
	        g_sum -= g_out_sum;
	        b_sum -= b_out_sum;
	        a_sum -= a_out_sum;
	
	        r_out_sum -= stackIn.r;
	        g_out_sum -= stackIn.g;
	        b_out_sum -= stackIn.b;
	        a_out_sum -= stackIn.a;
	
	        p = (yw + ((p = x + radius + 1) < widthMinus1 ? p : widthMinus1)) << 2;
	
	        r_in_sum += stackIn.r = pixels[p];
	        g_in_sum += stackIn.g = pixels[p + 1];
	        b_in_sum += stackIn.b = pixels[p + 2];
	        a_in_sum += stackIn.a = pixels[p + 3];
	
	        r_sum += r_in_sum;
	        g_sum += g_in_sum;
	        b_sum += b_in_sum;
	        a_sum += a_in_sum;
	
	        stackIn = stackIn.next;
	
	        r_out_sum += pr = stackOut.r;
	        g_out_sum += pg = stackOut.g;
	        b_out_sum += pb = stackOut.b;
	        a_out_sum += pa = stackOut.a;
	
	        r_in_sum -= pr;
	        g_in_sum -= pg;
	        b_in_sum -= pb;
	        a_in_sum -= pa;
	
	        stackOut = stackOut.next;
	
	        yi += 4;
	      }
	      yw += width;
	    }
	
	    for (x = 0; x < width; x++) {
	      g_in_sum = b_in_sum = a_in_sum = r_in_sum = g_sum = b_sum = a_sum = r_sum = 0;
	
	      yi = x << 2;
	      r_out_sum = radiusPlus1 * (pr = pixels[yi]);
	      g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
	      b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
	      a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
	
	      r_sum += sumFactor * pr;
	      g_sum += sumFactor * pg;
	      b_sum += sumFactor * pb;
	      a_sum += sumFactor * pa;
	
	      stack = stackStart;
	
	      for (i = 0; i < radiusPlus1; i++) {
	        stack.r = pr;
	        stack.g = pg;
	        stack.b = pb;
	        stack.a = pa;
	        stack = stack.next;
	      }
	
	      yp = width;
	
	      for (i = 1; i <= radius; i++) {
	        yi = (yp + x) << 2;
	
	        r_sum += (stack.r = pr = pixels[yi]) * (rbs = radiusPlus1 - i);
	        g_sum += (stack.g = pg = pixels[yi + 1]) * rbs;
	        b_sum += (stack.b = pb = pixels[yi + 2]) * rbs;
	        a_sum += (stack.a = pa = pixels[yi + 3]) * rbs;
	
	        r_in_sum += pr;
	        g_in_sum += pg;
	        b_in_sum += pb;
	        a_in_sum += pa;
	
	        stack = stack.next;
	
	        if (i < heightMinus1) {
	          yp += width;
	        }
	      }
	
	      yi = x;
	      stackIn = stackStart;
	      stackOut = stackEnd;
	      for (y = 0; y < height; y++) {
	        p = yi << 2;
	        pixels[p + 3] = pa = (a_sum * mul_sum) >> shg_sum;
	        if (pa > 0) {
	          pa = 255 / pa;
	          pixels[p] = ((r_sum * mul_sum) >> shg_sum) * pa;
	          pixels[p + 1] = ((g_sum * mul_sum) >> shg_sum) * pa;
	          pixels[p + 2] = ((b_sum * mul_sum) >> shg_sum) * pa;
	        } else {
	          pixels[p] = pixels[p + 1] = pixels[p + 2] = 0;
	        }
	
	        r_sum -= r_out_sum;
	        g_sum -= g_out_sum;
	        b_sum -= b_out_sum;
	        a_sum -= a_out_sum;
	
	        r_out_sum -= stackIn.r;
	        g_out_sum -= stackIn.g;
	        b_out_sum -= stackIn.b;
	        a_out_sum -= stackIn.a;
	
	        p =
	          (x +
	            ((p = y + radiusPlus1) < heightMinus1 ? p : heightMinus1) *
	              width) <<
	          2;
	
	        r_sum += r_in_sum += stackIn.r = pixels[p];
	        g_sum += g_in_sum += stackIn.g = pixels[p + 1];
	        b_sum += b_in_sum += stackIn.b = pixels[p + 2];
	        a_sum += a_in_sum += stackIn.a = pixels[p + 3];
	
	        stackIn = stackIn.next;
	
	        r_out_sum += pr = stackOut.r;
	        g_out_sum += pg = stackOut.g;
	        b_out_sum += pb = stackOut.b;
	        a_out_sum += pa = stackOut.a;
	
	        r_in_sum -= pr;
	        g_in_sum -= pg;
	        b_in_sum -= pb;
	        a_in_sum -= pa;
	
	        stackOut = stackOut.next;
	
	        yi += width;
	      }
	    }
	  }
	
	  /**
	     * Blur Filter
	     * @function
	     * @name Blur
	     * @memberof Konva.Filters
	     * @param {Object} imageData
	     * @example
	     * node.cache();
	     * node.filters([Konva.Filters.Blur]);
	     * node.blurRadius(10);
	     */
	  Konva.Filters.Blur = function Blur(imageData) {
	    var radius = Math.round(this.blurRadius());
	
	    if (radius > 0) {
	      filterGaussBlurRGBA(imageData, radius);
	    }
	  };
	
	  Konva.Factory.addGetterSetter(
	    Konva.Node,
	    'blurRadius',
	    0,
	    null,
	    Konva.Factory.afterSetFilter
	  );
	
	  /**
	    * get/set blur radius. Use with {@link Konva.Filters.Blur} filter
	    * @name blurRadius
	    * @method
	    * @memberof Konva.Node.prototype
	    * @param {Integer} radius
	    * @returns {Integer}
	    */
	})(Konva);
	
	/*eslint-disable  max-depth */
	(function() {
	  'use strict';
	  function pixelAt(idata, x, y) {
	    var idx = (y * idata.width + x) * 4;
	    var d = [];
	    d.push(
	      idata.data[idx++],
	      idata.data[idx++],
	      idata.data[idx++],
	      idata.data[idx++]
	    );
	    return d;
	  }
	
	  function rgbDistance(p1, p2) {
	    return Math.sqrt(
	      Math.pow(p1[0] - p2[0], 2) +
	        Math.pow(p1[1] - p2[1], 2) +
	        Math.pow(p1[2] - p2[2], 2)
	    );
	  }
	
	  function rgbMean(pTab) {
	    var m = [0, 0, 0];
	
	    for (var i = 0; i < pTab.length; i++) {
	      m[0] += pTab[i][0];
	      m[1] += pTab[i][1];
	      m[2] += pTab[i][2];
	    }
	
	    m[0] /= pTab.length;
	    m[1] /= pTab.length;
	    m[2] /= pTab.length;
	
	    return m;
	  }
	
	  function backgroundMask(idata, threshold) {
	    var rgbv_no = pixelAt(idata, 0, 0);
	    var rgbv_ne = pixelAt(idata, idata.width - 1, 0);
	    var rgbv_so = pixelAt(idata, 0, idata.height - 1);
	    var rgbv_se = pixelAt(idata, idata.width - 1, idata.height - 1);
	
	    var thres = threshold || 10;
	    if (
	      rgbDistance(rgbv_no, rgbv_ne) < thres &&
	      rgbDistance(rgbv_ne, rgbv_se) < thres &&
	      rgbDistance(rgbv_se, rgbv_so) < thres &&
	      rgbDistance(rgbv_so, rgbv_no) < thres
	    ) {
	      // Mean color
	      var mean = rgbMean([rgbv_ne, rgbv_no, rgbv_se, rgbv_so]);
	
	      // Mask based on color distance
	      var mask = [];
	      for (var i = 0; i < idata.width * idata.height; i++) {
	        var d = rgbDistance(mean, [
	          idata.data[i * 4],
	          idata.data[i * 4 + 1],
	          idata.data[i * 4 + 2]
	        ]);
	        mask[i] = d < thres ? 0 : 255;
	      }
	
	      return mask;
	    }
	  }
	
	  function applyMask(idata, mask) {
	    for (var i = 0; i < idata.width * idata.height; i++) {
	      idata.data[4 * i + 3] = mask[i];
	    }
	  }
	
	  function erodeMask(mask, sw, sh) {
	    var weights = [1, 1, 1, 1, 0, 1, 1, 1, 1];
	    var side = Math.round(Math.sqrt(weights.length));
	    var halfSide = Math.floor(side / 2);
	
	    var maskResult = [];
	    for (var y = 0; y < sh; y++) {
	      for (var x = 0; x < sw; x++) {
	        var so = y * sw + x;
	        var a = 0;
	        for (var cy = 0; cy < side; cy++) {
	          for (var cx = 0; cx < side; cx++) {
	            var scy = y + cy - halfSide;
	            var scx = x + cx - halfSide;
	
	            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
	              var srcOff = scy * sw + scx;
	              var wt = weights[cy * side + cx];
	
	              a += mask[srcOff] * wt;
	            }
	          }
	        }
	
	        maskResult[so] = a === 255 * 8 ? 255 : 0;
	      }
	    }
	
	    return maskResult;
	  }
	
	  function dilateMask(mask, sw, sh) {
	    var weights = [1, 1, 1, 1, 1, 1, 1, 1, 1];
	    var side = Math.round(Math.sqrt(weights.length));
	    var halfSide = Math.floor(side / 2);
	
	    var maskResult = [];
	    for (var y = 0; y < sh; y++) {
	      for (var x = 0; x < sw; x++) {
	        var so = y * sw + x;
	        var a = 0;
	        for (var cy = 0; cy < side; cy++) {
	          for (var cx = 0; cx < side; cx++) {
	            var scy = y + cy - halfSide;
	            var scx = x + cx - halfSide;
	
	            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
	              var srcOff = scy * sw + scx;
	              var wt = weights[cy * side + cx];
	
	              a += mask[srcOff] * wt;
	            }
	          }
	        }
	
	        maskResult[so] = a >= 255 * 4 ? 255 : 0;
	      }
	    }
	
	    return maskResult;
	  }
	
	  function smoothEdgeMask(mask, sw, sh) {
	    var weights = [
	      1 / 9,
	      1 / 9,
	      1 / 9,
	      1 / 9,
	      1 / 9,
	      1 / 9,
	      1 / 9,
	      1 / 9,
	      1 / 9
	    ];
	    var side = Math.round(Math.sqrt(weights.length));
	    var halfSide = Math.floor(side / 2);
	
	    var maskResult = [];
	    for (var y = 0; y < sh; y++) {
	      for (var x = 0; x < sw; x++) {
	        var so = y * sw + x;
	        var a = 0;
	        for (var cy = 0; cy < side; cy++) {
	          for (var cx = 0; cx < side; cx++) {
	            var scy = y + cy - halfSide;
	            var scx = x + cx - halfSide;
	
	            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
	              var srcOff = scy * sw + scx;
	              var wt = weights[cy * side + cx];
	
	              a += mask[srcOff] * wt;
	            }
	          }
	        }
	
	        maskResult[so] = a;
	      }
	    }
	
	    return maskResult;
	  }
	
	  /**
		 * Mask Filter
		 * @function
		 * @name Mask
		 * @memberof Konva.Filters
		 * @param {Object} imageData
		 * @example
	     * node.cache();
	     * node.filters([Konva.Filters.Mask]);
	     * node.threshold(200);
		 */
	  Konva.Filters.Mask = function(imageData) {
	    // Detect pixels close to the background color
	    var threshold = this.threshold(),
	      mask = backgroundMask(imageData, threshold);
	    if (mask) {
	      // Erode
	      mask = erodeMask(mask, imageData.width, imageData.height);
	
	      // Dilate
	      mask = dilateMask(mask, imageData.width, imageData.height);
	
	      // Gradient
	      mask = smoothEdgeMask(mask, imageData.width, imageData.height);
	
	      // Apply mask
	      applyMask(imageData, mask);
	
	      // todo : Update hit region function according to mask
	    }
	
	    return imageData;
	  };
	
	  Konva.Factory.addGetterSetter(
	    Konva.Node,
	    'threshold',
	    0,
	    null,
	    Konva.Factory.afterSetFilter
	  );
	})();
	
	(function() {
	  'use strict';
	  /**
	     * RGB Filter
	     * @function
	     * @name RGB
	     * @memberof Konva.Filters
	     * @param {Object} imageData
	     * @author ippo615
	     * @example
	     * node.cache();
	     * node.filters([Konva.Filters.RGB]);
	     * node.blue(120);
	     * node.green(200);
	     */
	  Konva.Filters.RGB = function(imageData) {
	    var data = imageData.data,
	      nPixels = data.length,
	      red = this.red(),
	      green = this.green(),
	      blue = this.blue(),
	      i,
	      brightness;
	
	    for (i = 0; i < nPixels; i += 4) {
	      brightness =
	        (0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2]) / 255;
	      data[i] = brightness * red; // r
	      data[i + 1] = brightness * green; // g
	      data[i + 2] = brightness * blue; // b
	      data[i + 3] = data[i + 3]; // alpha
	    }
	  };
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'red', 0, function(val) {
	    this._filterUpToDate = false;
	    if (val > 255) {
	      return 255;
	    } else if (val < 0) {
	      return 0;
	    } else {
	      return Math.round(val);
	    }
	  });
	  /**
	    * get/set filter red value. Use with {@link Konva.Filters.RGB} filter.
	    * @name red
	    * @method
	    * @memberof Konva.Node.prototype
	    * @param {Integer} red value between 0 and 255
	    * @returns {Integer}
	    */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'green', 0, function(val) {
	    this._filterUpToDate = false;
	    if (val > 255) {
	      return 255;
	    } else if (val < 0) {
	      return 0;
	    } else {
	      return Math.round(val);
	    }
	  });
	  /**
	    * get/set filter green value. Use with {@link Konva.Filters.RGB} filter.
	    * @name green
	    * @method
	    * @memberof Konva.Node.prototype
	    * @param {Integer} green value between 0 and 255
	    * @returns {Integer}
	    */
	
	  Konva.Factory.addGetterSetter(
	    Konva.Node,
	    'blue',
	    0,
	    Konva.Validators.RGBComponent,
	    Konva.Factory.afterSetFilter
	  );
	  /**
	    * get/set filter blue value. Use with {@link Konva.Filters.RGB} filter.
	    * @name blue
	    * @method
	    * @memberof Konva.Node.prototype
	    * @param {Integer} blue value between 0 and 255
	    * @returns {Integer}
	    */
	})();
	
	(function() {
	  'use strict';
	  /**
	     * RGBA Filter
	     * @function
	     * @name RGBA
	     * @memberof Konva.Filters
	     * @param {Object} imageData
	     * @author codefo
	     * @example
	     * node.cache();
	     * node.filters([Konva.Filters.RGBA]);
	     * node.blue(120);
	     * node.green(200);
	     * node.alpha(0.3);
	     */
	  Konva.Filters.RGBA = function(imageData) {
	    var data = imageData.data,
	      nPixels = data.length,
	      red = this.red(),
	      green = this.green(),
	      blue = this.blue(),
	      alpha = this.alpha(),
	      i,
	      ia;
	
	    for (i = 0; i < nPixels; i += 4) {
	      ia = 1 - alpha;
	
	      data[i] = red * alpha + data[i] * ia; // r
	      data[i + 1] = green * alpha + data[i + 1] * ia; // g
	      data[i + 2] = blue * alpha + data[i + 2] * ia; // b
	    }
	  };
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'red', 0, function(val) {
	    this._filterUpToDate = false;
	    if (val > 255) {
	      return 255;
	    } else if (val < 0) {
	      return 0;
	    } else {
	      return Math.round(val);
	    }
	  });
	  /**
	    * get/set filter red value. Use with {@link Konva.Filters.RGBA} filter.
	    * @name red
	    * @method
	    * @memberof Konva.Node.prototype
	    * @param {Integer} red value between 0 and 255
	    * @returns {Integer}
	    */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'green', 0, function(val) {
	    this._filterUpToDate = false;
	    if (val > 255) {
	      return 255;
	    } else if (val < 0) {
	      return 0;
	    } else {
	      return Math.round(val);
	    }
	  });
	  /**
	    * get/set filter green value. Use with {@link Konva.Filters.RGBA} filter.
	    * @name green
	    * @method
	    * @memberof Konva.Node.prototype
	    * @param {Integer} green value between 0 and 255
	    * @returns {Integer}
	    */
	
	  Konva.Factory.addGetterSetter(
	    Konva.Node,
	    'blue',
	    0,
	    Konva.Validators.RGBComponent,
	    Konva.Factory.afterSetFilter
	  );
	  /**
	    * get/set filter blue value. Use with {@link Konva.Filters.RGBA} filter.
	    * @name blue
	    * @method
	    * @memberof Konva.Node.prototype
	    * @param {Integer} blue value between 0 and 255
	    * @returns {Integer}
	    */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'alpha', 1, function(val) {
	    this._filterUpToDate = false;
	    if (val > 1) {
	      return 1;
	    } else if (val < 0) {
	      return 0;
	    } else {
	      return val;
	    }
	  });
	  /**
	     * get/set filter alpha value. Use with {@link Konva.Filters.RGBA} filter.
	     * @name alpha
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Float} alpha value between 0 and 1
	     * @returns {Float}
	     */
	})();
	
	(function() {
	  'use strict';
	  /**
	    * HSV Filter. Adjusts the hue, saturation and value
	    * @function
	    * @name HSV
	    * @memberof Konva.Filters
	    * @param {Object} imageData
	    * @author ippo615
	    * @example
	    * image.filters([Konva.Filters.HSV]);
	    * image.value(200);
	    */
	
	  Konva.Filters.HSV = function(imageData) {
	    var data = imageData.data,
	      nPixels = data.length,
	      v = Math.pow(2, this.value()),
	      s = Math.pow(2, this.saturation()),
	      h = Math.abs(this.hue() + 360) % 360,
	      i;
	
	    // Basis for the technique used:
	    // http://beesbuzz.biz/code/hsv_color_transforms.php
	    // V is the value multiplier (1 for none, 2 for double, 0.5 for half)
	    // S is the saturation multiplier (1 for none, 2 for double, 0.5 for half)
	    // H is the hue shift in degrees (0 to 360)
	    // vsu = V*S*cos(H*PI/180);
	    // vsw = V*S*sin(H*PI/180);
	    //[ .299V+.701vsu+.168vsw    .587V-.587vsu+.330vsw    .114V-.114vsu-.497vsw ] [R]
	    //[ .299V-.299vsu-.328vsw    .587V+.413vsu+.035vsw    .114V-.114vsu+.292vsw ]*[G]
	    //[ .299V-.300vsu+1.25vsw    .587V-.588vsu-1.05vsw    .114V+.886vsu-.203vsw ] [B]
	
	    // Precompute the values in the matrix:
	    var vsu = v * s * Math.cos(h * Math.PI / 180),
	      vsw = v * s * Math.sin(h * Math.PI / 180);
	    // (result spot)(source spot)
	    var rr = 0.299 * v + 0.701 * vsu + 0.167 * vsw,
	      rg = 0.587 * v - 0.587 * vsu + 0.330 * vsw,
	      rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
	    var gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw,
	      gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw,
	      gb = 0.114 * v - 0.114 * vsu + 0.293 * vsw;
	    var br = 0.299 * v - 0.300 * vsu + 1.250 * vsw,
	      bg = 0.587 * v - 0.586 * vsu - 1.050 * vsw,
	      bb = 0.114 * v + 0.886 * vsu - 0.200 * vsw;
	
	    var r, g, b, a;
	
	    for (i = 0; i < nPixels; i += 4) {
	      r = data[i + 0];
	      g = data[i + 1];
	      b = data[i + 2];
	      a = data[i + 3];
	
	      data[i + 0] = rr * r + rg * g + rb * b;
	      data[i + 1] = gr * r + gg * g + gb * b;
	      data[i + 2] = br * r + bg * g + bb * b;
	      data[i + 3] = a; // alpha
	    }
	  };
	
	  Konva.Factory.addGetterSetter(
	    Konva.Node,
	    'hue',
	    0,
	    null,
	    Konva.Factory.afterSetFilter
	  );
	  /**
	    * get/set hsv hue in degrees. Use with {@link Konva.Filters.HSV} or {@link Konva.Filters.HSL} filter.
	    * @name hue
	    * @method
	    * @memberof Konva.Node.prototype
	    * @param {Number} hue value between 0 and 359
	    * @returns {Number}
	    */
	
	  Konva.Factory.addGetterSetter(
	    Konva.Node,
	    'saturation',
	    0,
	    null,
	    Konva.Factory.afterSetFilter
	  );
	  /**
	    * get/set hsv saturation. Use with {@link Konva.Filters.HSV} or {@link Konva.Filters.HSL} filter.
	    * @name saturation
	    * @method
	    * @memberof Konva.Node.prototype
	    * @param {Number} saturation 0 is no change, -1.0 halves the saturation, 1.0 doubles, etc..
	    * @returns {Number}
	    */
	
	  Konva.Factory.addGetterSetter(
	    Konva.Node,
	    'value',
	    0,
	    null,
	    Konva.Factory.afterSetFilter
	  );
	  /**
	    * get/set hsv value. Use with {@link Konva.Filters.HSV} filter.
	    * @name value
	    * @method
	    * @memberof Konva.Node.prototype
	    * @param {Number} value 0 is no change, -1.0 halves the value, 1.0 doubles, etc..
	    * @returns {Number}
	    */
	})();
	
	(function() {
	  'use strict';
	  Konva.Factory.addGetterSetter(
	    Konva.Node,
	    'hue',
	    0,
	    null,
	    Konva.Factory.afterSetFilter
	  );
	  /**
	    * get/set hsv hue in degrees. Use with {@link Konva.Filters.HSV} or {@link Konva.Filters.HSL} filter.
	    * @name hue
	    * @method
	    * @memberof Konva.Node.prototype
	    * @param {Number} hue value between 0 and 359
	    * @returns {Number}
	    */
	
	  Konva.Factory.addGetterSetter(
	    Konva.Node,
	    'saturation',
	    0,
	    null,
	    Konva.Factory.afterSetFilter
	  );
	  /**
	    * get/set hsv saturation. Use with {@link Konva.Filters.HSV} or {@link Konva.Filters.HSL} filter.
	    * @name saturation
	    * @method
	    * @memberof Konva.Node.prototype
	    * @param {Number} saturation 0 is no change, -1.0 halves the saturation, 1.0 doubles, etc..
	    * @returns {Number}
	    */
	
	  Konva.Factory.addGetterSetter(
	    Konva.Node,
	    'luminance',
	    0,
	    null,
	    Konva.Factory.afterSetFilter
	  );
	  /**
	    * get/set hsl luminance. Use with {@link Konva.Filters.HSL} filter.
	    * @name value
	    * @method
	    * @memberof Konva.Node.prototype
	    * @param {Number} value 0 is no change, -1.0 halves the value, 1.0 doubles, etc..
	    * @returns {Number}
	    */
	
	  /**
	    * HSL Filter. Adjusts the hue, saturation and luminance (or lightness)
	    * @function
	    * @memberof Konva.Filters
	    * @param {Object} imageData
	    * @author ippo615
	    * @example
	    * image.filters([Konva.Filters.HSL]);
	    * image.luminance(200);
	    */
	
	  Konva.Filters.HSL = function(imageData) {
	    var data = imageData.data,
	      nPixels = data.length,
	      v = 1,
	      s = Math.pow(2, this.saturation()),
	      h = Math.abs(this.hue() + 360) % 360,
	      l = this.luminance() * 127,
	      i;
	
	    // Basis for the technique used:
	    // http://beesbuzz.biz/code/hsv_color_transforms.php
	    // V is the value multiplier (1 for none, 2 for double, 0.5 for half)
	    // S is the saturation multiplier (1 for none, 2 for double, 0.5 for half)
	    // H is the hue shift in degrees (0 to 360)
	    // vsu = V*S*cos(H*PI/180);
	    // vsw = V*S*sin(H*PI/180);
	    //[ .299V+.701vsu+.168vsw    .587V-.587vsu+.330vsw    .114V-.114vsu-.497vsw ] [R]
	    //[ .299V-.299vsu-.328vsw    .587V+.413vsu+.035vsw    .114V-.114vsu+.292vsw ]*[G]
	    //[ .299V-.300vsu+1.25vsw    .587V-.588vsu-1.05vsw    .114V+.886vsu-.203vsw ] [B]
	
	    // Precompute the values in the matrix:
	    var vsu = v * s * Math.cos(h * Math.PI / 180),
	      vsw = v * s * Math.sin(h * Math.PI / 180);
	    // (result spot)(source spot)
	    var rr = 0.299 * v + 0.701 * vsu + 0.167 * vsw,
	      rg = 0.587 * v - 0.587 * vsu + 0.330 * vsw,
	      rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
	    var gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw,
	      gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw,
	      gb = 0.114 * v - 0.114 * vsu + 0.293 * vsw;
	    var br = 0.299 * v - 0.300 * vsu + 1.250 * vsw,
	      bg = 0.587 * v - 0.586 * vsu - 1.050 * vsw,
	      bb = 0.114 * v + 0.886 * vsu - 0.200 * vsw;
	
	    var r, g, b, a;
	
	    for (i = 0; i < nPixels; i += 4) {
	      r = data[i + 0];
	      g = data[i + 1];
	      b = data[i + 2];
	      a = data[i + 3];
	
	      data[i + 0] = rr * r + rg * g + rb * b + l;
	      data[i + 1] = gr * r + gg * g + gb * b + l;
	      data[i + 2] = br * r + bg * g + bb * b + l;
	      data[i + 3] = a; // alpha
	    }
	  };
	})();
	
	(function() {
	  'use strict';
	  /**
	     * Emboss Filter.
	     * Pixastic Lib - Emboss filter - v0.1.0
	     * Copyright (c) 2008 Jacob Seidelin, jseidelin@nihilogic.dk, http://blog.nihilogic.dk/
	     * License: [http://www.pixastic.com/lib/license.txt]
	     * @function
	     * @memberof Konva.Filters
	     * @param {Object} imageData
	     * @example
	     * node.cache();
	     * node.filters([Konva.Filters.Emboss]);
	     * node.embossStrength(0.8);
	     * node.embossWhiteLevel(0.3);
	     * node.embossDirection('right');
	     * node.embossBlend(true);
	     */
	  Konva.Filters.Emboss = function(imageData) {
	    // pixastic strength is between 0 and 10.  I want it between 0 and 1
	    // pixastic greyLevel is between 0 and 255.  I want it between 0 and 1.  Also,
	    // a max value of greyLevel yields a white emboss, and the min value yields a black
	    // emboss.  Therefore, I changed greyLevel to whiteLevel
	    var strength = this.embossStrength() * 10,
	      greyLevel = this.embossWhiteLevel() * 255,
	      direction = this.embossDirection(),
	      blend = this.embossBlend(),
	      dirY = 0,
	      dirX = 0,
	      data = imageData.data,
	      w = imageData.width,
	      h = imageData.height,
	      w4 = w * 4,
	      y = h;
	
	    switch (direction) {
	      case 'top-left':
	        dirY = -1;
	        dirX = -1;
	        break;
	      case 'top':
	        dirY = -1;
	        dirX = 0;
	        break;
	      case 'top-right':
	        dirY = -1;
	        dirX = 1;
	        break;
	      case 'right':
	        dirY = 0;
	        dirX = 1;
	        break;
	      case 'bottom-right':
	        dirY = 1;
	        dirX = 1;
	        break;
	      case 'bottom':
	        dirY = 1;
	        dirX = 0;
	        break;
	      case 'bottom-left':
	        dirY = 1;
	        dirX = -1;
	        break;
	      case 'left':
	        dirY = 0;
	        dirX = -1;
	        break;
	      default:
	        Konva.Util.error('Unknown emboss direction: ' + direction);
	    }
	
	    do {
	      var offsetY = (y - 1) * w4;
	
	      var otherY = dirY;
	      if (y + otherY < 1) {
	        otherY = 0;
	      }
	      if (y + otherY > h) {
	        otherY = 0;
	      }
	
	      var offsetYOther = (y - 1 + otherY) * w * 4;
	
	      var x = w;
	      do {
	        var offset = offsetY + (x - 1) * 4;
	
	        var otherX = dirX;
	        if (x + otherX < 1) {
	          otherX = 0;
	        }
	        if (x + otherX > w) {
	          otherX = 0;
	        }
	
	        var offsetOther = offsetYOther + (x - 1 + otherX) * 4;
	
	        var dR = data[offset] - data[offsetOther];
	        var dG = data[offset + 1] - data[offsetOther + 1];
	        var dB = data[offset + 2] - data[offsetOther + 2];
	
	        var dif = dR;
	        var absDif = dif > 0 ? dif : -dif;
	
	        var absG = dG > 0 ? dG : -dG;
	        var absB = dB > 0 ? dB : -dB;
	
	        if (absG > absDif) {
	          dif = dG;
	        }
	        if (absB > absDif) {
	          dif = dB;
	        }
	
	        dif *= strength;
	
	        if (blend) {
	          var r = data[offset] + dif;
	          var g = data[offset + 1] + dif;
	          var b = data[offset + 2] + dif;
	
	          data[offset] = r > 255 ? 255 : r < 0 ? 0 : r;
	          data[offset + 1] = g > 255 ? 255 : g < 0 ? 0 : g;
	          data[offset + 2] = b > 255 ? 255 : b < 0 ? 0 : b;
	        } else {
	          var grey = greyLevel - dif;
	          if (grey < 0) {
	            grey = 0;
	          } else if (grey > 255) {
	            grey = 255;
	          }
	
	          data[offset] = data[offset + 1] = data[offset + 2] = grey;
	        }
	      } while (--x);
	    } while (--y);
	  };
	
	  Konva.Factory.addGetterSetter(
	    Konva.Node,
	    'embossStrength',
	    0.5,
	    null,
	    Konva.Factory.afterSetFilter
	  );
	  /**
	    * get/set emboss strength. Use with {@link Konva.Filters.Emboss} filter.
	    * @name embossStrength
	    * @method
	    * @memberof Konva.Node.prototype
	    * @param {Number} level between 0 and 1.  Default is 0.5
	    * @returns {Number}
	    */
	
	  Konva.Factory.addGetterSetter(
	    Konva.Node,
	    'embossWhiteLevel',
	    0.5,
	    null,
	    Konva.Factory.afterSetFilter
	  );
	  /**
	    * get/set emboss white level. Use with {@link Konva.Filters.Emboss} filter.
	    * @name embossWhiteLevel
	    * @method
	    * @memberof Konva.Node.prototype
	    * @param {Number} embossWhiteLevel between 0 and 1.  Default is 0.5
	    * @returns {Number}
	    */
	
	  Konva.Factory.addGetterSetter(
	    Konva.Node,
	    'embossDirection',
	    'top-left',
	    null,
	    Konva.Factory.afterSetFilter
	  );
	  /**
	    * get/set emboss direction. Use with {@link Konva.Filters.Emboss} filter.
	    * @name embossDirection
	    * @method
	    * @memberof Konva.Node.prototype
	    * @param {String} embossDirection can be top-left, top, top-right, right, bottom-right, bottom, bottom-left or left
	    *   The default is top-left
	    * @returns {String}
	    */
	
	  Konva.Factory.addGetterSetter(
	    Konva.Node,
	    'embossBlend',
	    false,
	    null,
	    Konva.Factory.afterSetFilter
	  );
	  /**
	    * get/set emboss blend. Use with {@link Konva.Filters.Emboss} filter.
	    * @name embossBlend
	    * @method
	    * @memberof Konva.Node.prototype
	    * @param {Boolean} embossBlend
	    * @returns {Boolean}
	    */
	})();
	
	(function() {
	  'use strict';
	  function remap(fromValue, fromMin, fromMax, toMin, toMax) {
	    // Compute the range of the data
	    var fromRange = fromMax - fromMin, toRange = toMax - toMin, toValue;
	
	    // If either range is 0, then the value can only be mapped to 1 value
	    if (fromRange === 0) {
	      return toMin + toRange / 2;
	    }
	    if (toRange === 0) {
	      return toMin;
	    }
	
	    // (1) untranslate, (2) unscale, (3) rescale, (4) retranslate
	    toValue = (fromValue - fromMin) / fromRange;
	    toValue = toRange * toValue + toMin;
	
	    return toValue;
	  }
	
	  /**
	    * Enhance Filter. Adjusts the colors so that they span the widest
	    *  possible range (ie 0-255). Performs w*h pixel reads and w*h pixel
	    *  writes.
	    * @function
	    * @name Enhance
	    * @memberof Konva.Filters
	    * @param {Object} imageData
	    * @author ippo615
	    * @example
	    * node.cache();
	    * node.filters([Konva.Filters.Enhance]);
	    * node.enhance(0.4);
	    */
	  Konva.Filters.Enhance = function(imageData) {
	    var data = imageData.data,
	      nSubPixels = data.length,
	      rMin = data[0],
	      rMax = rMin,
	      r,
	      gMin = data[1],
	      gMax = gMin,
	      g,
	      bMin = data[2],
	      bMax = bMin,
	      b,
	      i;
	
	    // If we are not enhancing anything - don't do any computation
	    var enhanceAmount = this.enhance();
	    if (enhanceAmount === 0) {
	      return;
	    }
	
	    // 1st Pass - find the min and max for each channel:
	    for (i = 0; i < nSubPixels; i += 4) {
	      r = data[i + 0];
	      if (r < rMin) {
	        rMin = r;
	      } else if (r > rMax) {
	        rMax = r;
	      }
	      g = data[i + 1];
	      if (g < gMin) {
	        gMin = g;
	      } else if (g > gMax) {
	        gMax = g;
	      }
	      b = data[i + 2];
	      if (b < bMin) {
	        bMin = b;
	      } else if (b > bMax) {
	        bMax = b;
	      }
	      //a = data[i + 3];
	      //if (a < aMin) { aMin = a; } else
	      //if (a > aMax) { aMax = a; }
	    }
	
	    // If there is only 1 level - don't remap
	    if (rMax === rMin) {
	      rMax = 255;
	      rMin = 0;
	    }
	    if (gMax === gMin) {
	      gMax = 255;
	      gMin = 0;
	    }
	    if (bMax === bMin) {
	      bMax = 255;
	      bMin = 0;
	    }
	
	    var rMid,
	      rGoalMax,
	      rGoalMin,
	      gMid,
	      gGoalMax,
	      gGoalMin,
	      bMid,
	      bGoalMax,
	      bGoalMin;
	
	    // If the enhancement is positive - stretch the histogram
	    if (enhanceAmount > 0) {
	      rGoalMax = rMax + enhanceAmount * (255 - rMax);
	      rGoalMin = rMin - enhanceAmount * (rMin - 0);
	      gGoalMax = gMax + enhanceAmount * (255 - gMax);
	      gGoalMin = gMin - enhanceAmount * (gMin - 0);
	      bGoalMax = bMax + enhanceAmount * (255 - bMax);
	      bGoalMin = bMin - enhanceAmount * (bMin - 0);
	      // If the enhancement is negative -   compress the histogram
	    } else {
	      rMid = (rMax + rMin) * 0.5;
	      rGoalMax = rMax + enhanceAmount * (rMax - rMid);
	      rGoalMin = rMin + enhanceAmount * (rMin - rMid);
	      gMid = (gMax + gMin) * 0.5;
	      gGoalMax = gMax + enhanceAmount * (gMax - gMid);
	      gGoalMin = gMin + enhanceAmount * (gMin - gMid);
	      bMid = (bMax + bMin) * 0.5;
	      bGoalMax = bMax + enhanceAmount * (bMax - bMid);
	      bGoalMin = bMin + enhanceAmount * (bMin - bMid);
	    }
	
	    // Pass 2 - remap everything, except the alpha
	    for (i = 0; i < nSubPixels; i += 4) {
	      data[i + 0] = remap(data[i + 0], rMin, rMax, rGoalMin, rGoalMax);
	      data[i + 1] = remap(data[i + 1], gMin, gMax, gGoalMin, gGoalMax);
	      data[i + 2] = remap(data[i + 2], bMin, bMax, bGoalMin, bGoalMax);
	      //data[i + 3] = remap(data[i + 3], aMin, aMax, aGoalMin, aGoalMax);
	    }
	  };
	
	  Konva.Factory.addGetterSetter(
	    Konva.Node,
	    'enhance',
	    0,
	    null,
	    Konva.Factory.afterSetFilter
	  );
	
	  /**
	    * get/set enhance. Use with {@link Konva.Filters.Enhance} filter.
	    * @name enhance
	    * @method
	    * @memberof Konva.Node.prototype
	    * @param {Float} amount
	    * @returns {Float}
	    */
	})();
	
	(function() {
	  'use strict';
	  /**
	     * Posterize Filter. Adjusts the channels so that there are no more
	     *  than n different values for that channel. This is also applied
	     *  to the alpha channel.
	     * @function
	     * @name Posterize
	     * @author ippo615
	     * @memberof Konva.Filters
	     * @param {Object} imageData
	     * @example
	     * node.cache();
	     * node.filters([Konva.Filters.Posterize]);
	     * node.levels(0.8); // between 0 and 1
	     */
	
	  Konva.Filters.Posterize = function(imageData) {
	    // level must be between 1 and 255
	    var levels = Math.round(this.levels() * 254) + 1,
	      data = imageData.data,
	      len = data.length,
	      scale = 255 / levels,
	      i;
	
	    for (i = 0; i < len; i += 1) {
	      data[i] = Math.floor(data[i] / scale) * scale;
	    }
	  };
	
	  Konva.Factory.addGetterSetter(
	    Konva.Node,
	    'levels',
	    0.5,
	    null,
	    Konva.Factory.afterSetFilter
	  );
	
	  /**
	    * get/set levels.  Must be a number between 0 and 1.  Use with {@link Konva.Filters.Posterize} filter.
	    * @name levels
	    * @method
	    * @memberof Konva.Node.prototype
	    * @param {Number} level between 0 and 1
	    * @returns {Number}
	    */
	})();
	
	(function() {
	  'use strict';
	  /**
	     * Noise Filter. Randomly adds or substracts to the color channels
	     * @function
	     * @name Noise
	     * @memberof Konva.Filters
	     * @param {Object} imageData
	     * @author ippo615
	     * @example
	     * node.cache();
	     * node.filters([Konva.Filters.Noise]);
	     * node.noise(0.8);
	     */
	  Konva.Filters.Noise = function(imageData) {
	    var amount = this.noise() * 255,
	      data = imageData.data,
	      nPixels = data.length,
	      half = amount / 2,
	      i;
	
	    for (i = 0; i < nPixels; i += 4) {
	      data[i + 0] += half - 2 * half * Math.random();
	      data[i + 1] += half - 2 * half * Math.random();
	      data[i + 2] += half - 2 * half * Math.random();
	    }
	  };
	
	  Konva.Factory.addGetterSetter(
	    Konva.Node,
	    'noise',
	    0.2,
	    null,
	    Konva.Factory.afterSetFilter
	  );
	  /**
	    * get/set noise amount.  Must be a value between 0 and 1. Use with {@link Konva.Filters.Noise} filter.
	    * @name noise
	    * @method
	    * @memberof Konva.Node.prototype
	    * @param {Number} noise
	    * @returns {Number}
	    */
	})();
	
	/*eslint-disable max-depth */
	(function() {
	  'use strict';
	  /**
	     * Pixelate Filter. Averages groups of pixels and redraws
	     *  them as larger pixels
	     * @function
	     * @name Pixelate
	     * @memberof Konva.Filters
	     * @param {Object} imageData
	     * @author ippo615
	     * @example
	     * node.cache();
	     * node.filters([Konva.Filters.Pixelate]);
	     * node.pixelSize(10);
	     */
	
	  Konva.Filters.Pixelate = function(imageData) {
	    var pixelSize = Math.ceil(this.pixelSize()),
	      width = imageData.width,
	      height = imageData.height,
	      x,
	      y,
	      i,
	      //pixelsPerBin = pixelSize * pixelSize,
	      red,
	      green,
	      blue,
	      alpha,
	      nBinsX = Math.ceil(width / pixelSize),
	      nBinsY = Math.ceil(height / pixelSize),
	      xBinStart,
	      xBinEnd,
	      yBinStart,
	      yBinEnd,
	      xBin,
	      yBin,
	      pixelsInBin;
	    imageData = imageData.data;
	
	    if (pixelSize <= 0) {
	      Konva.Util.error('pixelSize value can not be <= 0');
	      return;
	    }
	
	    for (xBin = 0; xBin < nBinsX; xBin += 1) {
	      for (yBin = 0; yBin < nBinsY; yBin += 1) {
	        // Initialize the color accumlators to 0
	        red = 0;
	        green = 0;
	        blue = 0;
	        alpha = 0;
	
	        // Determine which pixels are included in this bin
	        xBinStart = xBin * pixelSize;
	        xBinEnd = xBinStart + pixelSize;
	        yBinStart = yBin * pixelSize;
	        yBinEnd = yBinStart + pixelSize;
	
	        // Add all of the pixels to this bin!
	        pixelsInBin = 0;
	        for (x = xBinStart; x < xBinEnd; x += 1) {
	          if (x >= width) {
	            continue;
	          }
	          for (y = yBinStart; y < yBinEnd; y += 1) {
	            if (y >= height) {
	              continue;
	            }
	            i = (width * y + x) * 4;
	            red += imageData[i + 0];
	            green += imageData[i + 1];
	            blue += imageData[i + 2];
	            alpha += imageData[i + 3];
	            pixelsInBin += 1;
	          }
	        }
	
	        // Make sure the channels are between 0-255
	        red = red / pixelsInBin;
	        green = green / pixelsInBin;
	        blue = blue / pixelsInBin;
	
	        // Draw this bin
	        for (x = xBinStart; x < xBinEnd; x += 1) {
	          if (x >= width) {
	            continue;
	          }
	          for (y = yBinStart; y < yBinEnd; y += 1) {
	            if (y >= height) {
	              continue;
	            }
	            i = (width * y + x) * 4;
	            imageData[i + 0] = red;
	            imageData[i + 1] = green;
	            imageData[i + 2] = blue;
	            imageData[i + 3] = alpha;
	          }
	        }
	      }
	    }
	  };
	
	  Konva.Factory.addGetterSetter(
	    Konva.Node,
	    'pixelSize',
	    8,
	    null,
	    Konva.Factory.afterSetFilter
	  );
	  /**
	    * get/set pixel size. Use with {@link Konva.Filters.Pixelate} filter.
	    * @name pixelSize
	    * @method
	    * @memberof Konva.Node.prototype
	    * @param {Integer} pixelSize
	    * @returns {Integer}
	    */
	})();
	
	(function() {
	  'use strict';
	  /**
	     * Threshold Filter. Pushes any value above the mid point to
	     *  the max and any value below the mid point to the min.
	     *  This affects the alpha channel.
	     * @function
	     * @name Threshold
	     * @memberof Konva.Filters
	     * @param {Object} imageData
	     * @author ippo615
	     * @example
	     * node.cache();
	     * node.filters([Konva.Filters.Threshold]);
	     * node.threshold(0.1);
	     */
	
	  Konva.Filters.Threshold = function(imageData) {
	    var level = this.threshold() * 255,
	      data = imageData.data,
	      len = data.length,
	      i;
	
	    for (i = 0; i < len; i += 1) {
	      data[i] = data[i] < level ? 0 : 255;
	    }
	  };
	
	  Konva.Factory.addGetterSetter(
	    Konva.Node,
	    'threshold',
	    0.5,
	    null,
	    Konva.Factory.afterSetFilter
	  );
	  /**
	    * get/set threshold.  Must be a value between 0 and 1. Use with {@link Konva.Filters.Threshold} or {@link Konva.Filters.Mask} filter.
	    * @name threshold
	    * @method
	    * @memberof Konva.Node.prototype
	    * @param {Number} threshold
	    * @returns {Number}
	    */
	})();
	
	(function() {
	  'use strict';
	  /**
	     * Sepia Filter
	     * Based on: Pixastic Lib - Sepia filter - v0.1.0
	     * Copyright (c) 2008 Jacob Seidelin, jseidelin@nihilogic.dk, http://blog.nihilogic.dk/
	     * @function
	     * @name Sepia
	     * @memberof Konva.Filters
	     * @param {Object} imageData
	     * @author Jacob Seidelin <jseidelin@nihilogic.dk>
	     * @license MPL v1.1 [http://www.pixastic.com/lib/license.txt]
	     * @example
	     * node.cache();
	     * node.filters([Konva.Filters.Sepia]);
	     */
	  Konva.Filters.Sepia = function(imageData) {
	    var data = imageData.data,
	      w = imageData.width,
	      y = imageData.height,
	      w4 = w * 4,
	      offsetY,
	      x,
	      offset,
	      or,
	      og,
	      ob,
	      r,
	      g,
	      b;
	
	    do {
	      offsetY = (y - 1) * w4;
	      x = w;
	      do {
	        offset = offsetY + (x - 1) * 4;
	
	        or = data[offset];
	        og = data[offset + 1];
	        ob = data[offset + 2];
	
	        r = or * 0.393 + og * 0.769 + ob * 0.189;
	        g = or * 0.349 + og * 0.686 + ob * 0.168;
	        b = or * 0.272 + og * 0.534 + ob * 0.131;
	
	        data[offset] = r > 255 ? 255 : r;
	        data[offset + 1] = g > 255 ? 255 : g;
	        data[offset + 2] = b > 255 ? 255 : b;
	        data[offset + 3] = data[offset + 3];
	      } while (--x);
	    } while (--y);
	  };
	})();
	
	(function() {
	  'use strict';
	  /**
	     * Solarize Filter
	     * Pixastic Lib - Solarize filter - v0.1.0
	     * Copyright (c) 2008 Jacob Seidelin, jseidelin@nihilogic.dk, http://blog.nihilogic.dk/
	     * License: [http://www.pixastic.com/lib/license.txt]
	     * @function
	     * @name Solarize
	     * @memberof Konva.Filters
	     * @param {Object} imageData
	     * @example
	     * node.cache();
	     * node.filters([Konva.Filters.Solarize]);
	     */
	  Konva.Filters.Solarize = function(imageData) {
	    var data = imageData.data,
	      w = imageData.width,
	      h = imageData.height,
	      w4 = w * 4,
	      y = h;
	
	    do {
	      var offsetY = (y - 1) * w4;
	      var x = w;
	      do {
	        var offset = offsetY + (x - 1) * 4;
	        var r = data[offset];
	        var g = data[offset + 1];
	        var b = data[offset + 2];
	
	        if (r > 127) {
	          r = 255 - r;
	        }
	        if (g > 127) {
	          g = 255 - g;
	        }
	        if (b > 127) {
	          b = 255 - b;
	        }
	
	        data[offset] = r;
	        data[offset + 1] = g;
	        data[offset + 2] = b;
	      } while (--x);
	    } while (--y);
	  };
	})();
	
	(function() {
	  'use strict';
	  /*
	   * ToPolar Filter. Converts image data to polar coordinates. Performs
	   *  w*h*4 pixel reads and w*h pixel writes. The r axis is placed along
	   *  what would be the y axis and the theta axis along the x axis.
	   * @function
	   * @author ippo615
	   * @memberof Konva.Filters
	   * @param {ImageData} src, the source image data (what will be transformed)
	   * @param {ImageData} dst, the destination image data (where it will be saved)
	   * @param {Object} opt
	   * @param {Number} [opt.polarCenterX] horizontal location for the center of the circle,
	   *  default is in the middle
	   * @param {Number} [opt.polarCenterY] vertical location for the center of the circle,
	   *  default is in the middle
	   */
	
	  var ToPolar = function(src, dst, opt) {
	    var srcPixels = src.data,
	      dstPixels = dst.data,
	      xSize = src.width,
	      ySize = src.height,
	      xMid = opt.polarCenterX || xSize / 2,
	      yMid = opt.polarCenterY || ySize / 2,
	      i,
	      x,
	      y,
	      r = 0,
	      g = 0,
	      b = 0,
	      a = 0;
	
	    // Find the largest radius
	    var rad,
	      rMax = Math.sqrt(xMid * xMid + yMid * yMid);
	    x = xSize - xMid;
	    y = ySize - yMid;
	    rad = Math.sqrt(x * x + y * y);
	    rMax = rad > rMax ? rad : rMax;
	
	    // We'll be uisng y as the radius, and x as the angle (theta=t)
	    var rSize = ySize,
	      tSize = xSize,
	      radius,
	      theta;
	
	    // We want to cover all angles (0-360) and we need to convert to
	    // radians (*PI/180)
	    var conversion = 360 / tSize * Math.PI / 180,
	      sin,
	      cos;
	
	    // var x1, x2, x1i, x2i, y1, y2, y1i, y2i, scale;
	
	    for (theta = 0; theta < tSize; theta += 1) {
	      sin = Math.sin(theta * conversion);
	      cos = Math.cos(theta * conversion);
	      for (radius = 0; radius < rSize; radius += 1) {
	        x = Math.floor(xMid + rMax * radius / rSize * cos);
	        y = Math.floor(yMid + rMax * radius / rSize * sin);
	        i = (y * xSize + x) * 4;
	        r = srcPixels[i + 0];
	        g = srcPixels[i + 1];
	        b = srcPixels[i + 2];
	        a = srcPixels[i + 3];
	
	        // Store it
	        //i = (theta * xSize  +  radius) * 4;
	        i = (theta + radius * xSize) * 4;
	        dstPixels[i + 0] = r;
	        dstPixels[i + 1] = g;
	        dstPixels[i + 2] = b;
	        dstPixels[i + 3] = a;
	      }
	    }
	  };
	
	  /*
	     * FromPolar Filter. Converts image data from polar coordinates back to rectangular.
	     *  Performs w*h*4 pixel reads and w*h pixel writes.
	     * @function
	     * @author ippo615
	     * @memberof Konva.Filters
	     * @param {ImageData} src, the source image data (what will be transformed)
	     * @param {ImageData} dst, the destination image data (where it will be saved)
	     * @param {Object} opt
	     * @param {Number} [opt.polarCenterX] horizontal location for the center of the circle,
	     *  default is in the middle
	     * @param {Number} [opt.polarCenterY] vertical location for the center of the circle,
	     *  default is in the middle
	     * @param {Number} [opt.polarRotation] amount to rotate the image counterclockwis,
	     *  0 is no rotation, 360 degrees is a full rotation
	     */
	
	  var FromPolar = function(src, dst, opt) {
	    var srcPixels = src.data,
	      dstPixels = dst.data,
	      xSize = src.width,
	      ySize = src.height,
	      xMid = opt.polarCenterX || xSize / 2,
	      yMid = opt.polarCenterY || ySize / 2,
	      i,
	      x,
	      y,
	      dx,
	      dy,
	      r = 0,
	      g = 0,
	      b = 0,
	      a = 0;
	
	    // Find the largest radius
	    var rad,
	      rMax = Math.sqrt(xMid * xMid + yMid * yMid);
	    x = xSize - xMid;
	    y = ySize - yMid;
	    rad = Math.sqrt(x * x + y * y);
	    rMax = rad > rMax ? rad : rMax;
	
	    // We'll be uisng x as the radius, and y as the angle (theta=t)
	    var rSize = ySize,
	      tSize = xSize,
	      radius,
	      theta,
	      phaseShift = opt.polarRotation || 0;
	
	    // We need to convert to degrees and we need to make sure
	    // it's between (0-360)
	    // var conversion = tSize/360*180/Math.PI;
	    //var conversion = tSize/360*180/Math.PI;
	
	    var x1, y1;
	
	    for (x = 0; x < xSize; x += 1) {
	      for (y = 0; y < ySize; y += 1) {
	        dx = x - xMid;
	        dy = y - yMid;
	        radius = Math.sqrt(dx * dx + dy * dy) * rSize / rMax;
	        theta = (Math.atan2(dy, dx) * 180 / Math.PI + 360 + phaseShift) % 360;
	        theta = theta * tSize / 360;
	        x1 = Math.floor(theta);
	        y1 = Math.floor(radius);
	        i = (y1 * xSize + x1) * 4;
	        r = srcPixels[i + 0];
	        g = srcPixels[i + 1];
	        b = srcPixels[i + 2];
	        a = srcPixels[i + 3];
	
	        // Store it
	        i = (y * xSize + x) * 4;
	        dstPixels[i + 0] = r;
	        dstPixels[i + 1] = g;
	        dstPixels[i + 2] = b;
	        dstPixels[i + 3] = a;
	      }
	    }
	  };
	
	  //Konva.Filters.ToPolar = Konva.Util._FilterWrapDoubleBuffer(ToPolar);
	  //Konva.Filters.FromPolar = Konva.Util._FilterWrapDoubleBuffer(FromPolar);
	
	  // create a temporary canvas for working - shared between multiple calls
	
	  /*
	     * Kaleidoscope Filter.
	     * @function
	     * @name Kaleidoscope
	     * @author ippo615
	     * @memberof Konva.Filters
	     * @example
	     * node.cache();
	     * node.filters([Konva.Filters.Kaleidoscope]);
	     * node.kaleidoscopePower(3);
	     * node.kaleidoscopeAngle(45);
	     */
	  Konva.Filters.Kaleidoscope = function(imageData) {
	    var xSize = imageData.width,
	      ySize = imageData.height;
	
	    var x, y, xoff, i, r, g, b, a, srcPos, dstPos;
	    var power = Math.round(this.kaleidoscopePower());
	    var angle = Math.round(this.kaleidoscopeAngle());
	    var offset = Math.floor(xSize * (angle % 360) / 360);
	
	    if (power < 1) {
	      return;
	    }
	
	    // Work with our shared buffer canvas
	    var tempCanvas = Konva.Util.createCanvasElement();
	    tempCanvas.width = xSize;
	    tempCanvas.height = ySize;
	    var scratchData = tempCanvas
	      .getContext('2d')
	      .getImageData(0, 0, xSize, ySize);
	
	    // Convert thhe original to polar coordinates
	    ToPolar(imageData, scratchData, {
	      polarCenterX: xSize / 2,
	      polarCenterY: ySize / 2
	    });
	
	    // Determine how big each section will be, if it's too small
	    // make it bigger
	    var minSectionSize = xSize / Math.pow(2, power);
	    while (minSectionSize <= 8) {
	      minSectionSize = minSectionSize * 2;
	      power -= 1;
	    }
	    minSectionSize = Math.ceil(minSectionSize);
	    var sectionSize = minSectionSize;
	
	    // Copy the offset region to 0
	    // Depending on the size of filter and location of the offset we may need
	    // to copy the section backwards to prevent it from rewriting itself
	    var xStart = 0,
	      xEnd = sectionSize,
	      xDelta = 1;
	    if (offset + minSectionSize > xSize) {
	      xStart = sectionSize;
	      xEnd = 0;
	      xDelta = -1;
	    }
	    for (y = 0; y < ySize; y += 1) {
	      for (x = xStart; x !== xEnd; x += xDelta) {
	        xoff = Math.round(x + offset) % xSize;
	        srcPos = (xSize * y + xoff) * 4;
	        r = scratchData.data[srcPos + 0];
	        g = scratchData.data[srcPos + 1];
	        b = scratchData.data[srcPos + 2];
	        a = scratchData.data[srcPos + 3];
	        dstPos = (xSize * y + x) * 4;
	        scratchData.data[dstPos + 0] = r;
	        scratchData.data[dstPos + 1] = g;
	        scratchData.data[dstPos + 2] = b;
	        scratchData.data[dstPos + 3] = a;
	      }
	    }
	
	    // Perform the actual effect
	    for (y = 0; y < ySize; y += 1) {
	      sectionSize = Math.floor(minSectionSize);
	      for (i = 0; i < power; i += 1) {
	        for (x = 0; x < sectionSize + 1; x += 1) {
	          srcPos = (xSize * y + x) * 4;
	          r = scratchData.data[srcPos + 0];
	          g = scratchData.data[srcPos + 1];
	          b = scratchData.data[srcPos + 2];
	          a = scratchData.data[srcPos + 3];
	          dstPos = (xSize * y + sectionSize * 2 - x - 1) * 4;
	          scratchData.data[dstPos + 0] = r;
	          scratchData.data[dstPos + 1] = g;
	          scratchData.data[dstPos + 2] = b;
	          scratchData.data[dstPos + 3] = a;
	        }
	        sectionSize *= 2;
	      }
	    }
	
	    // Convert back from polar coordinates
	    FromPolar(scratchData, imageData, { polarRotation: 0 });
	  };
	
	  /**
	    * get/set kaleidoscope power. Use with {@link Konva.Filters.Kaleidoscope} filter.
	    * @name kaleidoscopePower
	    * @method
	    * @memberof Konva.Node.prototype
	    * @param {Integer} power of kaleidoscope
	    * @returns {Integer}
	    */
	  Konva.Factory.addGetterSetter(
	    Konva.Node,
	    'kaleidoscopePower',
	    2,
	    null,
	    Konva.Factory.afterSetFilter
	  );
	
	  /**
	    * get/set kaleidoscope angle. Use with {@link Konva.Filters.Kaleidoscope} filter.
	    * @name kaleidoscopeAngle
	    * @method
	    * @memberof Konva.Node.prototype
	    * @param {Integer} degrees
	    * @returns {Integer}
	    */
	  Konva.Factory.addGetterSetter(
	    Konva.Node,
	    'kaleidoscopeAngle',
	    0,
	    null,
	    Konva.Factory.afterSetFilter
	  );
	})();
	
	(function() {
	  'use strict';
	  /**
	     * Container constructor.&nbsp; Containers are used to contain nodes or other containers
	     * @constructor
	     * @memberof Konva
	     * @augments Konva.Node
	     * @abstract
	     * @param {Object} config
	     * @param {Number} [config.x]
	     * @param {Number} [config.y]
	     * @param {Number} [config.width]
	     * @param {Number} [config.height]
	     * @param {Boolean} [config.visible]
	     * @param {Boolean} [config.listening] whether or not the node is listening for events
	     * @param {String} [config.id] unique id
	     * @param {String} [config.name] non-unique name
	     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
	     * @param {Object} [config.scale] set scale
	     * @param {Number} [config.scaleX] set scale x
	     * @param {Number} [config.scaleY] set scale y
	     * @param {Number} [config.rotation] rotation in degrees
	     * @param {Object} [config.offset] offset from center point and rotation point
	     * @param {Number} [config.offsetX] set offset x
	     * @param {Number} [config.offsetY] set offset y
	     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
	     *  the entire stage by dragging any portion of the stage
	     * @param {Number} [config.dragDistance]
	     * @param {Function} [config.dragBoundFunc]
	     * * @param {Object} [config.clip] set clip
	     * @param {Number} [config.clipX] set clip x
	     * @param {Number} [config.clipY] set clip y
	     * @param {Number} [config.clipWidth] set clip width
	     * @param {Number} [config.clipHeight] set clip height
	     * @param {Function} [config.clipFunc] set clip func
	
	     */
	  Konva.Container = function(config) {
	    this.__init(config);
	  };
	
	  Konva.Util.addMethods(Konva.Container, {
	    __init: function(config) {
	      this.children = new Konva.Collection();
	      Konva.Node.call(this, config);
	    },
	    /**
	         * returns a {@link Konva.Collection} of direct descendant nodes
	         * @method
	         * @memberof Konva.Container.prototype
	         * @param {Function} [filterFunc] filter function
	         * @returns {Konva.Collection}
	         * @example
	         * // get all children
	         * var children = layer.getChildren();
	         *
	         * // get only circles
	         * var circles = layer.getChildren(function(node){
	         *    return node.getClassName() === 'Circle';
	         * });
	         */
	    getChildren: function(filterFunc) {
	      if (!filterFunc) {
	        return this.children;
	      }
	
	      var results = new Konva.Collection();
	      this.children.each(function(child) {
	        if (filterFunc(child)) {
	          results.push(child);
	        }
	      });
	      return results;
	    },
	    /**
	         * determine if node has children
	         * @method
	         * @memberof Konva.Container.prototype
	         * @returns {Boolean}
	         */
	    hasChildren: function() {
	      return this.getChildren().length > 0;
	    },
	    /**
	         * remove all children
	         * @method
	         * @memberof Konva.Container.prototype
	         */
	    removeChildren: function() {
	      var children = Konva.Collection.toCollection(this.children);
	      var child;
	      for (var i = 0; i < children.length; i++) {
	        child = children[i];
	        // reset parent to prevent many _setChildrenIndices calls
	        delete child.parent;
	        child.index = 0;
	        child.remove();
	      }
	      children = null;
	      this.children = new Konva.Collection();
	      return this;
	    },
	    /**
	         * destroy all children
	         * @method
	         * @memberof Konva.Container.prototype
	         */
	    destroyChildren: function() {
	      var children = Konva.Collection.toCollection(this.children);
	      var child;
	      for (var i = 0; i < children.length; i++) {
	        child = children[i];
	        // reset parent to prevent many _setChildrenIndices calls
	        delete child.parent;
	        child.index = 0;
	        child.destroy();
	      }
	      children = null;
	      this.children = new Konva.Collection();
	      return this;
	    },
	    /**
	         * Add node or nodes to container.
	         * @method
	         * @memberof Konva.Container.prototype
	         * @param {...Konva.Node} child
	         * @returns {Container}
	         * @example
	         * layer.add(shape1, shape2, shape3);
	         */
	    add: function(child) {
	      if (arguments.length > 1) {
	        for (var i = 0; i < arguments.length; i++) {
	          this.add(arguments[i]);
	        }
	        return this;
	      }
	      if (child.getParent()) {
	        child.moveTo(this);
	        return this;
	      }
	      var children = this.children;
	      this._validateAdd(child);
	      child.index = children.length;
	      child.parent = this;
	      children.push(child);
	      this._fire('add', {
	        child: child
	      });
	
	      // if node under drag we need to update drag animation
	      if (Konva.DD && child.isDragging()) {
	        Konva.DD.anim.setLayers(child.getLayer());
	      }
	
	      // chainable
	      return this;
	    },
	    destroy: function() {
	      // destroy children
	      if (this.hasChildren()) {
	        this.destroyChildren();
	      }
	      // then destroy self
	      Konva.Node.prototype.destroy.call(this);
	      return this;
	    },
	    /**
	         * return a {@link Konva.Collection} of nodes that match the selector.  Use '#' for id selections
	         * and '.' for name selections.  You can also select by type or class name. Pass multiple selectors
	         * separated by a space.
	         * @method
	         * @memberof Konva.Container.prototype
	         * @param {String} selector
	         * @returns {Collection}
	         * @example
	         * // select node with id foo
	         * var node = stage.find('#foo');
	         *
	         * // select nodes with name bar inside layer
	         * var nodes = layer.find('.bar');
	         *
	         * // select all groups inside layer
	         * var nodes = layer.find('Group');
	         *
	         * // select all rectangles inside layer
	         * var nodes = layer.find('Rect');
	         *
	         * // select node with an id of foo or a name of bar inside layer
	         * var nodes = layer.find('#foo, .bar');
	         */
	    find: function(selector) {
	      var retArr = [],
	        selectorArr = selector.replace(/ /g, '').split(','),
	        len = selectorArr.length,
	        n,
	        i,
	        sel,
	        arr,
	        node,
	        children,
	        clen;
	
	      for (n = 0; n < len; n++) {
	        sel = selectorArr[n];
	        if (!Konva.Util.isValidSelector(sel)) {
	          Konva.Util.warn(
	            'Selector "' +
	              sel +
	              '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".'
	          );
	          Konva.Util.warn(
	            'If you have a custom shape with such className, please change it to start with upper letter like "Triangle".'
	          );
	          Konva.Util.warn('Konva is awesome, right?');
	        }
	        // id selector
	        if (sel.charAt(0) === '#') {
	          node = this._getNodeById(sel.slice(1));
	          if (node) {
	            retArr.push(node);
	          }
	        } else if (sel.charAt(0) === '.') {
	          // name selector
	          arr = this._getNodesByName(sel.slice(1));
	          retArr = retArr.concat(arr);
	        } else {
	          // unrecognized selector, pass to children
	          children = this.getChildren();
	          clen = children.length;
	          for (i = 0; i < clen; i++) {
	            retArr = retArr.concat(children[i]._get(sel));
	          }
	        }
	      }
	
	      return Konva.Collection.toCollection(retArr);
	    },
	    /**
	         * return a first node from `find` method
	         * @method
	         * @memberof Konva.Container.prototype
	         * @param {String} selector
	         * @returns {Konva.Node}
	         * @example
	         * // select node with id foo
	         * var node = stage.findOne('#foo');
	         *
	         * // select node with name bar inside layer
	         * var nodes = layer.findOne('.bar');
	         */
	    findOne: function(selector) {
	      return this.find(selector)[0];
	    },
	    _getNodeById: function(key) {
	      var node = Konva.ids[key];
	
	      if (node !== undefined && this.isAncestorOf(node)) {
	        return node;
	      }
	      return null;
	    },
	    _getNodesByName: function(key) {
	      var arr = Konva.names[key] || [];
	      return this._getDescendants(arr);
	    },
	    _get: function(selector) {
	      var retArr = Konva.Node.prototype._get.call(this, selector);
	      var children = this.getChildren();
	      var len = children.length;
	      for (var n = 0; n < len; n++) {
	        retArr = retArr.concat(children[n]._get(selector));
	      }
	      return retArr;
	    },
	    // extenders
	    toObject: function() {
	      var obj = Konva.Node.prototype.toObject.call(this);
	
	      obj.children = [];
	
	      var children = this.getChildren();
	      var len = children.length;
	      for (var n = 0; n < len; n++) {
	        var child = children[n];
	        obj.children.push(child.toObject());
	      }
	
	      return obj;
	    },
	    _getDescendants: function(arr) {
	      var retArr = [];
	      var len = arr.length;
	      for (var n = 0; n < len; n++) {
	        var node = arr[n];
	        if (this.isAncestorOf(node)) {
	          retArr.push(node);
	        }
	      }
	
	      return retArr;
	    },
	    /**
	         * determine if node is an ancestor
	         * of descendant
	         * @method
	         * @memberof Konva.Container.prototype
	         * @param {Konva.Node} node
	         */
	    isAncestorOf: function(node) {
	      var parent = node.getParent();
	      while (parent) {
	        if (parent._id === this._id) {
	          return true;
	        }
	        parent = parent.getParent();
	      }
	
	      return false;
	    },
	    clone: function(obj) {
	      // call super method
	      var node = Konva.Node.prototype.clone.call(this, obj);
	
	      this.getChildren().each(function(no) {
	        node.add(no.clone());
	      });
	      return node;
	    },
	    /**
	         * get all shapes that intersect a point.  Note: because this method must clear a temporary
	         * canvas and redraw every shape inside the container, it should only be used for special sitations
	         * because it performs very poorly.  Please use the {@link Konva.Stage#getIntersection} method if at all possible
	         * because it performs much better
	         * @method
	         * @memberof Konva.Container.prototype
	         * @param {Object} pos
	         * @param {Number} pos.x
	         * @param {Number} pos.y
	         * @returns {Array} array of shapes
	         */
	    getAllIntersections: function(pos) {
	      var arr = [];
	
	      this.find('Shape').each(function(shape) {
	        if (shape.isVisible() && shape.intersects(pos)) {
	          arr.push(shape);
	        }
	      });
	
	      return arr;
	    },
	    _setChildrenIndices: function() {
	      this.children.each(function(child, n) {
	        child.index = n;
	      });
	    },
	    drawScene: function(can, top, caching) {
	      var layer = this.getLayer(),
	        canvas = can || (layer && layer.getCanvas()),
	        context = canvas && canvas.getContext(),
	        cachedCanvas = this._cache.canvas,
	        cachedSceneCanvas = cachedCanvas && cachedCanvas.scene;
	
	      if (this.isVisible()) {
	        if (!caching && cachedSceneCanvas) {
	          context.save();
	          layer._applyTransform(this, context, top);
	          this._drawCachedSceneCanvas(context);
	          context.restore();
	        } else {
	          this._drawChildren(canvas, 'drawScene', top, false, caching);
	        }
	      }
	      return this;
	    },
	    drawHit: function(can, top, caching) {
	      var layer = this.getLayer(),
	        canvas = can || (layer && layer.hitCanvas),
	        context = canvas && canvas.getContext(),
	        cachedCanvas = this._cache.canvas,
	        cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
	
	      if (this.shouldDrawHit(canvas)) {
	        if (layer) {
	          layer.clearHitCache();
	        }
	        if (!caching && cachedHitCanvas) {
	          context.save();
	          layer._applyTransform(this, context, top);
	          this._drawCachedHitCanvas(context);
	          context.restore();
	        } else {
	          this._drawChildren(canvas, 'drawHit', top);
	        }
	      }
	      return this;
	    },
	    _drawChildren: function(canvas, drawMethod, top, caching, skipBuffer) {
	      var layer = this.getLayer(),
	        context = canvas && canvas.getContext(),
	        clipWidth = this.getClipWidth(),
	        clipHeight = this.getClipHeight(),
	        clipFunc = this.getClipFunc(),
	        hasClip = (clipWidth && clipHeight) || clipFunc,
	        clipX,
	        clipY;
	
	      if (hasClip && layer) {
	        context.save();
	        var transform = this.getAbsoluteTransform(top);
	        var m = transform.getMatrix();
	        context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
	        context.beginPath();
	        if (clipFunc) {
	          clipFunc.call(this, context, this);
	        } else {
	          clipX = this.getClipX();
	          clipY = this.getClipY();
	          context.rect(clipX, clipY, clipWidth, clipHeight);
	        }
	        context.clip();
	        m = transform.copy().invert().getMatrix();
	        context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
	      }
	
	      this.children.each(function(child) {
	        child[drawMethod](canvas, top, caching, skipBuffer);
	      });
	
	      if (hasClip) {
	        context.restore();
	      }
	    },
	    shouldDrawHit: function(canvas) {
	      var layer = this.getLayer();
	      var dd = Konva.DD;
	      var layerUnderDrag =
	        dd &&
	        Konva.isDragging() &&
	        Konva.DD.anim.getLayers().indexOf(layer) !== -1;
	      return (
	        (canvas && canvas.isCache) ||
	        (layer &&
	          layer.hitGraphEnabled() &&
	          this.isVisible() &&
	          !layerUnderDrag)
	      );
	    },
	    getClientRect: function(attrs) {
	      attrs = attrs || {};
	      var skipTransform = attrs.skipTransform;
	      var relativeTo = attrs.relativeTo;
	
	      var minX, minY, maxX, maxY;
	      var selfRect = {
	        x: 0,
	        y: 0,
	        width: 0,
	        height: 0
	      };
	      var that = this;
	      this.children.each(function(child) {
	        // skip invisible children
	        if (!child.isVisible()) {
	          return;
	        }
	        var rect = child.getClientRect({ relativeTo: that });
	
	        // skip invisible children (like empty groups)
	        // or don't skip... hmmm...
	        // if (rect.width === 0 && rect.height === 0) {
	        //     return;
	        // }
	
	        if (minX === undefined) {
	          // initial value for first child
	          minX = rect.x;
	          minY = rect.y;
	          maxX = rect.x + rect.width;
	          maxY = rect.y + rect.height;
	        } else {
	          minX = Math.min(minX, rect.x);
	          minY = Math.min(minY, rect.y);
	          maxX = Math.max(maxX, rect.x + rect.width);
	          maxY = Math.max(maxY, rect.y + rect.height);
	        }
	      });
	
	      if (this.children.length !== 0) {
	        selfRect = {
	          x: minX,
	          y: minY,
	          width: maxX - minX,
	          height: maxY - minY
	        };
	      }
	
	      if (!skipTransform) {
	        return this._transformedRect(selfRect, relativeTo);
	      }
	      return selfRect;
	    }
	  });
	
	  Konva.Util.extend(Konva.Container, Konva.Node);
	  // deprecated methods
	  Konva.Container.prototype.get = Konva.Container.prototype.find;
	
	  // add getters setters
	  Konva.Factory.addComponentsGetterSetter(Konva.Container, 'clip', [
	    'x',
	    'y',
	    'width',
	    'height'
	  ]);
	  /**
	     * get/set clip
	     * @method
	     * @name clip
	     * @memberof Konva.Container.prototype
	     * @param {Object} clip
	     * @param {Number} clip.x
	     * @param {Number} clip.y
	     * @param {Number} clip.width
	     * @param {Number} clip.height
	     * @returns {Object}
	     * @example
	     * // get clip
	     * var clip = container.clip();
	     *
	     * // set clip
	     * container.setClip({
	     *   x: 20,
	     *   y: 20,
	     *   width: 20,
	     *   height: 20
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Container, 'clipX');
	  /**
	     * get/set clip x
	     * @name clipX
	     * @method
	     * @memberof Konva.Container.prototype
	     * @param {Number} x
	     * @returns {Number}
	     * @example
	     * // get clip x
	     * var clipX = container.clipX();
	     *
	     * // set clip x
	     * container.clipX(10);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Container, 'clipY');
	  /**
	     * get/set clip y
	     * @name clipY
	     * @method
	     * @memberof Konva.Container.prototype
	     * @param {Number} y
	     * @returns {Number}
	     * @example
	     * // get clip y
	     * var clipY = container.clipY();
	     *
	     * // set clip y
	     * container.clipY(10);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Container, 'clipWidth');
	  /**
	     * get/set clip width
	     * @name clipWidth
	     * @method
	     * @memberof Konva.Container.prototype
	     * @param {Number} width
	     * @returns {Number}
	     * @example
	     * // get clip width
	     * var clipWidth = container.clipWidth();
	     *
	     * // set clip width
	     * container.clipWidth(100);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Container, 'clipHeight');
	  /**
	     * get/set clip height
	     * @name clipHeight
	     * @method
	     * @memberof Konva.Container.prototype
	     * @param {Number} height
	     * @returns {Number}
	     * @example
	     * // get clip height
	     * var clipHeight = container.clipHeight();
	     *
	     * // set clip height
	     * container.clipHeight(100);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Container, 'clipFunc');
	  /**
	      * get/set clip function
	      * @name clipFunc
	      * @method
	      * @memberof Konva.Container.prototype
	      * @param {Function} function
	      * @returns {Function}
	      * @example
	      * // get clip function
	      * var clipFunction = container.clipFunc();
	      *
	      * // set clip height
	      * container.clipFunc(function(ctx) {
	      *   ctx.rect(0, 0, 100, 100);
	      * });
	      */
	
	  Konva.Collection.mapMethods(Konva.Container);
	})();
	
	(function(Konva) {
	  'use strict';
	  var HAS_SHADOW = 'hasShadow';
	  var SHADOW_RGBA = 'shadowRGBA';
	
	  function _fillFunc(context) {
	    context.fill();
	  }
	  function _strokeFunc(context) {
	    context.stroke();
	  }
	  function _fillFuncHit(context) {
	    context.fill();
	  }
	  function _strokeFuncHit(context) {
	    context.stroke();
	  }
	
	  function _clearHasShadowCache() {
	    this._clearCache(HAS_SHADOW);
	  }
	
	  function _clearGetShadowRGBACache() {
	    this._clearCache(SHADOW_RGBA);
	  }
	
	  /**
	     * Shape constructor.  Shapes are primitive objects such as rectangles,
	     *  circles, text, lines, etc.
	     * @constructor
	     * @memberof Konva
	     * @augments Konva.Node
	     * @param {Object} config
	     * @param {String} [config.fill] fill color
	     * @param {Image} [config.fillPatternImage] fill pattern image
	     * @param {Number} [config.fillPatternX]
	     * @param {Number} [config.fillPatternY]
	     * @param {Object} [config.fillPatternOffset] object with x and y component
	     * @param {Number} [config.fillPatternOffsetX] 
	     * @param {Number} [config.fillPatternOffsetY] 
	     * @param {Object} [config.fillPatternScale] object with x and y component
	     * @param {Number} [config.fillPatternScaleX]
	     * @param {Number} [config.fillPatternScaleY]
	     * @param {Number} [config.fillPatternRotation]
	     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
	     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientStartPointX]
	     * @param {Number} [config.fillLinearGradientStartPointY]
	     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientEndPointX]
	     * @param {Number} [config.fillLinearGradientEndPointY]
	     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
	     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientStartPointX]
	     * @param {Number} [config.fillRadialGradientStartPointY]
	     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientEndPointX] 
	     * @param {Number} [config.fillRadialGradientEndPointY] 
	     * @param {Number} [config.fillRadialGradientStartRadius]
	     * @param {Number} [config.fillRadialGradientEndRadius]
	     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
	     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
	     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
	     * @param {String} [config.stroke] stroke color
	     * @param {Number} [config.strokeWidth] stroke width
	     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
	     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
	     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
	     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
	     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
	     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
	     *  is miter
	     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
	     *  is butt
	     * @param {String} [config.shadowColor]
	     * @param {Number} [config.shadowBlur]
	     * @param {Object} [config.shadowOffset] object with x and y component
	     * @param {Number} [config.shadowOffsetX]
	     * @param {Number} [config.shadowOffsetY]
	     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
	     *  between 0 and 1
	     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
	     * @param {Array} [config.dash]
	     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
	     * @param {Number} [config.x]
	     * @param {Number} [config.y]
	     * @param {Number} [config.width]
	     * @param {Number} [config.height]
	     * @param {Boolean} [config.visible]
	     * @param {Boolean} [config.listening] whether or not the node is listening for events
	     * @param {String} [config.id] unique id
	     * @param {String} [config.name] non-unique name
	     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
	     * @param {Object} [config.scale] set scale
	     * @param {Number} [config.scaleX] set scale x
	     * @param {Number} [config.scaleY] set scale y
	     * @param {Number} [config.rotation] rotation in degrees
	     * @param {Object} [config.offset] offset from center point and rotation point
	     * @param {Number} [config.offsetX] set offset x
	     * @param {Number} [config.offsetY] set offset y
	     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
	     *  the entire stage by dragging any portion of the stage
	     * @param {Number} [config.dragDistance]
	     * @param {Function} [config.dragBoundFunc]
	     * @example
	     * var customShape = new Konva.Shape({
	         *   x: 5,
	         *   y: 10,
	         *   fill: 'red',
	         *   // a Konva.Canvas renderer is passed into the drawFunc function
	         *   drawFunc: function(context) {
	         *     context.beginPath();
	         *     context.moveTo(200, 50);
	         *     context.lineTo(420, 80);
	         *     context.quadraticCurveTo(300, 100, 260, 170);
	         *     context.closePath();
	         *     context.fillStrokeShape(this);
	         *   }
	         *});
	     */
	  Konva.Shape = function(config) {
	    this.__init(config);
	  };
	
	  Konva.Util.addMethods(Konva.Shape, {
	    __init: function(config) {
	      this.nodeType = 'Shape';
	      this._fillFunc = _fillFunc;
	      this._strokeFunc = _strokeFunc;
	      this._fillFuncHit = _fillFuncHit;
	      this._strokeFuncHit = _strokeFuncHit;
	
	      // set colorKey
	      var shapes = Konva.shapes;
	      var key;
	
	      while (true) {
	        key = Konva.Util.getRandomColor();
	        if (key && !(key in shapes)) {
	          break;
	        }
	      }
	
	      this.colorKey = key;
	      shapes[key] = this;
	
	      // call super constructor
	      Konva.Node.call(this, config);
	
	      this.on(
	        'shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva',
	        _clearHasShadowCache
	      );
	
	      this.on(
	        'shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva',
	        _clearGetShadowRGBACache
	      );
	    },
	    hasChildren: function() {
	      return false;
	    },
	    getChildren: function() {
	      return [];
	    },
	    /**
	         * get canvas context tied to the layer
	         * @method
	         * @memberof Konva.Shape.prototype
	         * @returns {Konva.Context}
	         */
	    getContext: function() {
	      return this.getLayer().getContext();
	    },
	    /**
	         * get canvas renderer tied to the layer.  Note that this returns a canvas renderer, not a canvas element
	         * @method
	         * @memberof Konva.Shape.prototype
	         * @returns {Konva.Canvas}
	         */
	    getCanvas: function() {
	      return this.getLayer().getCanvas();
	    },
	    /**
	         * returns whether or not a shadow will be rendered
	         * @method
	         * @memberof Konva.Shape.prototype
	         * @returns {Boolean}
	         */
	    hasShadow: function() {
	      return this._getCache(HAS_SHADOW, this._hasShadow);
	    },
	    _hasShadow: function() {
	      return (
	        this.getShadowEnabled() &&
	        (this.getShadowOpacity() !== 0 &&
	          !!(this.getShadowColor() ||
	            this.getShadowBlur() ||
	            this.getShadowOffsetX() ||
	            this.getShadowOffsetY()))
	      );
	    },
	    getShadowRGBA: function() {
	      return this._getCache(SHADOW_RGBA, this._getShadowRGBA);
	    },
	    _getShadowRGBA: function() {
	      if (this.hasShadow()) {
	        var rgba = Konva.Util.colorToRGBA(this.shadowColor());
	        return (
	          'rgba(' +
	          rgba.r +
	          ',' +
	          rgba.g +
	          ',' +
	          rgba.b +
	          ',' +
	          rgba.a * (this.getShadowOpacity() || 1) +
	          ')'
	        );
	      }
	    },
	    /**
	         * returns whether or not the shape will be filled
	         * @method
	         * @memberof Konva.Shape.prototype
	         * @returns {Boolean}
	         */
	    hasFill: function() {
	      return !!(this.getFill() ||
	        this.getFillPatternImage() ||
	        this.getFillLinearGradientColorStops() ||
	        this.getFillRadialGradientColorStops());
	    },
	    /**
	         * returns whether or not the shape will be stroked
	         * @method
	         * @memberof Konva.Shape.prototype
	         * @returns {Boolean}
	         */
	    hasStroke: function() {
	      return this.strokeEnabled() && !!this.stroke();
	    },
	    /**
	         * determines if point is in the shape, regardless if other shapes are on top of it.  Note: because
	         *  this method clears a temporary canvas and then redraws the shape, it performs very poorly if executed many times
	         *  consecutively.  Please use the {@link Konva.Stage#getIntersection} method if at all possible
	         *  because it performs much better
	         * @method
	         * @memberof Konva.Shape.prototype
	         * @param {Object} point
	         * @param {Number} point.x
	         * @param {Number} point.y
	         * @returns {Boolean}
	         */
	    intersects: function(point) {
	      var stage = this.getStage(), bufferHitCanvas = stage.bufferHitCanvas, p;
	
	      bufferHitCanvas.getContext().clear();
	      this.drawHit(bufferHitCanvas);
	      p = bufferHitCanvas.context.getImageData(
	        Math.round(point.x),
	        Math.round(point.y),
	        1,
	        1
	      ).data;
	      return p[3] > 0;
	    },
	    // extends Node.prototype.destroy
	    destroy: function() {
	      Konva.Node.prototype.destroy.call(this);
	      delete Konva.shapes[this.colorKey];
	      return this;
	    },
	    _useBufferCanvas: function(caching) {
	      return (
	        (!caching &&
	          (this.perfectDrawEnabled() &&
	            this.getAbsoluteOpacity() !== 1 &&
	            this.hasFill() &&
	            this.hasStroke() &&
	            this.getStage())) ||
	        (this.perfectDrawEnabled() &&
	          this.hasShadow() &&
	          this.getAbsoluteOpacity() !== 1 &&
	          this.hasFill() &&
	          this.hasStroke() &&
	          this.getStage())
	      );
	    },
	    /**
	         * return self rectangle (x, y, width, height) of shape.
	         * This method are not taken into account transformation and styles.
	         * @method
	         * @memberof Konva.Shape.prototype
	         * @returns {Object} rect with {x, y, width, height} properties
	         * @example
	         *
	         * rect.getSelfRect();  // return {x:0, y:0, width:rect.width(), height:rect.height()}
	         * circle.getSelfRect();  // return {x: - circle.width() / 2, y: - circle.height() / 2, width:circle.width(), height:circle.height()}
	         *
	         */
	    getSelfRect: function() {
	      var size = this.getSize();
	      return {
	        x: this._centroid ? Math.round(-size.width / 2) : 0,
	        y: this._centroid ? Math.round(-size.height / 2) : 0,
	        width: size.width,
	        height: size.height
	      };
	    },
	    getClientRect: function(attrs) {
	      attrs = attrs || {};
	      var skipTransform = attrs.skipTransform;
	      var relativeTo = attrs.relativeTo;
	
	      var fillRect = this.getSelfRect();
	
	      var strokeWidth = (this.hasStroke() && this.strokeWidth()) || 0;
	      var fillAndStrokeWidth = fillRect.width + strokeWidth;
	      var fillAndStrokeHeight = fillRect.height + strokeWidth;
	
	      var shadowOffsetX = this.hasShadow() ? this.shadowOffsetX() : 0;
	      var shadowOffsetY = this.hasShadow() ? this.shadowOffsetY() : 0;
	
	      var preWidth = fillAndStrokeWidth + Math.abs(shadowOffsetX);
	      var preHeight = fillAndStrokeHeight + Math.abs(shadowOffsetY);
	
	      var blurRadius = (this.hasShadow() && this.shadowBlur()) || 0;
	
	      var width = preWidth + blurRadius * 2;
	      var height = preHeight + blurRadius * 2;
	
	      // if stroke, for example = 3
	      // we need to set x to 1.5, but after Math.round it will be 2
	      // as we have additional offset we need to increase width and height by 1 pixel
	      var roundingOffset = 0;
	      if (Math.round(strokeWidth / 2) !== strokeWidth / 2) {
	        roundingOffset = 1;
	      }
	      var rect = {
	        width: width + roundingOffset,
	        height: height + roundingOffset,
	        x: -Math.round(strokeWidth / 2 + blurRadius) +
	          Math.min(shadowOffsetX, 0) +
	          fillRect.x,
	        y: -Math.round(strokeWidth / 2 + blurRadius) +
	          Math.min(shadowOffsetY, 0) +
	          fillRect.y
	      };
	      if (!skipTransform) {
	        return this._transformedRect(rect, relativeTo);
	      }
	      return rect;
	    },
	    drawScene: function(can, top, caching, skipBuffer) {
	      var layer = this.getLayer(),
	        canvas = can || layer.getCanvas(),
	        context = canvas.getContext(),
	        cachedCanvas = this._cache.canvas,
	        drawFunc = this.sceneFunc(),
	        hasShadow = this.hasShadow(),
	        hasStroke = this.hasStroke(),
	        stage,
	        bufferCanvas,
	        bufferContext;
	
	      if (!this.isVisible()) {
	        return this;
	      }
	      if (cachedCanvas) {
	        context.save();
	        layer._applyTransform(this, context, top);
	        this._drawCachedSceneCanvas(context);
	        context.restore();
	        return this;
	      }
	      if (!drawFunc) {
	        return this;
	      }
	      context.save();
	      // if buffer canvas is needed
	      if (this._useBufferCanvas(caching) && !skipBuffer) {
	        stage = this.getStage();
	        bufferCanvas = stage.bufferCanvas;
	        bufferContext = bufferCanvas.getContext();
	        bufferContext.clear();
	        bufferContext.save();
	        bufferContext._applyLineJoin(this);
	        // layer might be undefined if we are using cache before adding to layer
	        if (!caching) {
	          if (layer) {
	            layer._applyTransform(this, bufferContext, top);
	          } else {
	            var m = this.getAbsoluteTransform(top).getMatrix();
	            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
	          }
	        }
	
	        drawFunc.call(this, bufferContext);
	        bufferContext.restore();
	
	        var ratio = bufferCanvas.pixelRatio;
	        if (hasShadow && !canvas.hitCanvas) {
	          context.save();
	
	          context._applyShadow(this);
	          context._applyOpacity(this);
	          context._applyGlobalCompositeOperation(this);
	          context.drawImage(
	            bufferCanvas._canvas,
	            0,
	            0,
	            bufferCanvas.width / ratio,
	            bufferCanvas.height / ratio
	          );
	          context.restore();
	        } else {
	          context._applyOpacity(this);
	          context._applyGlobalCompositeOperation(this);
	          context.drawImage(
	            bufferCanvas._canvas,
	            0,
	            0,
	            bufferCanvas.width / ratio,
	            bufferCanvas.height / ratio
	          );
	        }
	      } else {
	        // if buffer canvas is not needed
	        context._applyLineJoin(this);
	        // layer might be undefined if we are using cache before adding to layer
	        if (!caching) {
	          if (layer) {
	            layer._applyTransform(this, context, top);
	          } else {
	            var o = this.getAbsoluteTransform(top).getMatrix();
	            context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
	          }
	        }
	
	        if (hasShadow && hasStroke && !canvas.hitCanvas) {
	          context.save();
	          // apply shadow
	          if (!caching) {
	            context._applyOpacity(this);
	            context._applyGlobalCompositeOperation(this);
	          }
	          context._applyShadow(this);
	
	          drawFunc.call(this, context);
	          context.restore();
	          // if shape has stroke we need to redraw shape
	          // otherwise we will see a shadow under stroke (and over fill)
	          // but I think this is unexpected behavior
	          if (this.hasFill() && this.getShadowForStrokeEnabled()) {
	            drawFunc.call(this, context);
	          }
	        } else if (hasShadow && !canvas.hitCanvas) {
	          context.save();
	          if (!caching) {
	            context._applyOpacity(this);
	            context._applyGlobalCompositeOperation(this);
	          }
	          context._applyShadow(this);
	          drawFunc.call(this, context);
	          context.restore();
	        } else {
	          if (!caching) {
	            context._applyOpacity(this);
	            context._applyGlobalCompositeOperation(this);
	          }
	          drawFunc.call(this, context);
	        }
	      }
	      context.restore();
	      return this;
	    },
	    drawHit: function(can, top, caching) {
	      var layer = this.getLayer(),
	        canvas = can || layer.hitCanvas,
	        context = canvas.getContext(),
	        drawFunc = this.hitFunc() || this.sceneFunc(),
	        cachedCanvas = this._cache.canvas,
	        cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
	
	      if (!this.shouldDrawHit(canvas)) {
	        return this;
	      }
	      if (layer) {
	        layer.clearHitCache();
	      }
	      if (cachedHitCanvas) {
	        context.save();
	        layer._applyTransform(this, context, top);
	        this._drawCachedHitCanvas(context);
	        context.restore();
	        return this;
	      }
	      if (!drawFunc) {
	        return this;
	      }
	      context.save();
	      context._applyLineJoin(this);
	      if (!caching) {
	        if (layer) {
	          layer._applyTransform(this, context, top);
	        } else {
	          var o = this.getAbsoluteTransform(top).getMatrix();
	          context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
	        }
	      }
	      drawFunc.call(this, context);
	      context.restore();
	      return this;
	    },
	    /**
	        * draw hit graph using the cached scene canvas
	        * @method
	        * @memberof Konva.Shape.prototype
	        * @param {Integer} alphaThreshold alpha channel threshold that determines whether or not
	        *  a pixel should be drawn onto the hit graph.  Must be a value between 0 and 255.
	        *  The default is 0
	        * @returns {Konva.Shape}
	        * @example
	        * shape.cache();
	        * shape.drawHitFromCache();
	        */
	    drawHitFromCache: function(alphaThreshold) {
	      var threshold = alphaThreshold || 0,
	        cachedCanvas = this._cache.canvas,
	        sceneCanvas = this._getCachedSceneCanvas(),
	        hitCanvas = cachedCanvas.hit,
	        hitContext = hitCanvas.getContext(),
	        hitWidth = hitCanvas.getWidth(),
	        hitHeight = hitCanvas.getHeight(),
	        hitImageData,
	        hitData,
	        len,
	        rgbColorKey,
	        i,
	        alpha;
	
	      hitContext.clear();
	      hitContext.drawImage(sceneCanvas._canvas, 0, 0, hitWidth, hitHeight);
	
	      try {
	        hitImageData = hitContext.getImageData(0, 0, hitWidth, hitHeight);
	        hitData = hitImageData.data;
	        len = hitData.length;
	        rgbColorKey = Konva.Util._hexToRgb(this.colorKey);
	
	        // replace non transparent pixels with color key
	        for (i = 0; i < len; i += 4) {
	          alpha = hitData[i + 3];
	          if (alpha > threshold) {
	            hitData[i] = rgbColorKey.r;
	            hitData[i + 1] = rgbColorKey.g;
	            hitData[i + 2] = rgbColorKey.b;
	            hitData[i + 3] = 255;
	          } else {
	            hitData[i + 3] = 0;
	          }
	        }
	        hitContext.putImageData(hitImageData, 0, 0);
	      } catch (e) {
	        Konva.Util.error(
	          'Unable to draw hit graph from cached scene canvas. ' + e.message
	        );
	      }
	
	      return this;
	    }
	  });
	  Konva.Util.extend(Konva.Shape, Konva.Node);
	
	  // add getters and setters
	  Konva.Factory.addGetterSetter(Konva.Shape, 'stroke');
	
	  /**
	     * get/set stroke color
	     * @name stroke
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {String} color
	     * @returns {String}
	     * @example
	     * // get stroke color
	     * var stroke = shape.stroke();
	     *
	     * // set stroke color with color string
	     * shape.stroke('green');
	     *
	     * // set stroke color with hex
	     * shape.stroke('#00ff00');
	     *
	     * // set stroke color with rgb
	     * shape.stroke('rgb(0,255,0)');
	     *
	     * // set stroke color with rgba and make it 50% opaque
	     * shape.stroke('rgba(0,255,0,0.5');
	     */
	
	  Konva.Factory.addDeprecatedGetterSetter(
	    Konva.Shape,
	    'strokeRed',
	    0,
	    Konva.Validators.RGBComponent
	  );
	  Konva.Factory.addDeprecatedGetterSetter(
	    Konva.Shape,
	    'strokeGreen',
	    0,
	    Konva.Validators.RGBComponent
	  );
	  Konva.Factory.addDeprecatedGetterSetter(
	    Konva.Shape,
	    'strokeBlue',
	    0,
	    Konva.Validators.RGBComponent
	  );
	  Konva.Factory.addDeprecatedGetterSetter(
	    Konva.Shape,
	    'strokeAlpha',
	    1,
	    Konva.Validators.alphaComponent
	  );
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'strokeWidth', 2);
	
	  /**
	     * get/set stroke width
	     * @name strokeWidth
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} strokeWidth
	     * @returns {Number}
	     * @example
	     * // get stroke width
	     * var strokeWidth = shape.strokeWidth();
	     *
	     * // set stroke width
	     * shape.strokeWidth();
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'strokeHitEnabled', true);
	
	  /**
	     * get/set strokeHitEnabled property. Useful for performance optimization.
	     * You may set `shape.strokeHitEnabled(false)`. In this case stroke will be no draw on hit canvas, so hit area
	     * of shape will be decreased (by lineWidth / 2). Remember that non closed line with `strokeHitEnabled = false`
	     * will be not drawn on hit canvas, that is mean line will no trigger pointer events (like mouseover)
	     * Default value is true
	     * @name strokeHitEnabled
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Boolean} strokeHitEnabled
	     * @returns {Boolean}
	     * @example
	     * // get strokeHitEnabled
	     * var strokeHitEnabled = shape.strokeHitEnabled();
	     *
	     * // set strokeHitEnabled
	     * shape.strokeHitEnabled();
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'perfectDrawEnabled', true);
	
	  /**
	     * get/set perfectDrawEnabled. If a shape has fill, stroke and opacity you may set `perfectDrawEnabled` to false to improve performance.
	     * See http://konvajs.github.io/docs/performance/Disable_Perfect_Draw.html for more information.
	     * Default value is true
	     * @name perfectDrawEnabled
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Boolean} perfectDrawEnabled
	     * @returns {Boolean}
	     * @example
	     * // get perfectDrawEnabled
	     * var perfectDrawEnabled = shape.perfectDrawEnabled();
	     *
	     * // set perfectDrawEnabled
	     * shape.perfectDrawEnabled();
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'shadowForStrokeEnabled', true);
	
	  /**
	     * get/set shadowForStrokeEnabled. Useful for performance optimization.
	     * You may set `shape.shadowForStrokeEnabled(false)`. In this case stroke will be no draw shadow for stroke.
	     * Remember if you set `shadowForStrokeEnabled = false` for non closed line - that line with have no shadow!.
	     * Default value is true
	     * @name shadowForStrokeEnabled
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Boolean} shadowForStrokeEnabled
	     * @returns {Boolean}
	     * @example
	     * // get shadowForStrokeEnabled
	     * var shadowForStrokeEnabled = shape.shadowForStrokeEnabled();
	     *
	     * // set shadowForStrokeEnabled
	     * shape.shadowForStrokeEnabled();
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'lineJoin');
	
	  /**
	     * get/set line join.  Can be miter, round, or bevel.  The
	     *  default is miter
	     * @name lineJoin
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {String} lineJoin
	     * @returns {String}
	     * @example
	     * // get line join
	     * var lineJoin = shape.lineJoin();
	     *
	     * // set line join
	     * shape.lineJoin('round');
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'lineCap');
	
	  /**
	     * get/set line cap.  Can be butt, round, or square
	     * @name lineCap
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {String} lineCap
	     * @returns {String}
	     * @example
	     * // get line cap
	     * var lineCap = shape.lineCap();
	     *
	     * // set line cap
	     * shape.lineCap('round');
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'sceneFunc');
	
	  /**
	     * get/set scene draw function
	     * @name sceneFunc
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Function} drawFunc drawing function
	     * @returns {Function}
	     * @example
	     * // get scene draw function
	     * var sceneFunc = shape.sceneFunc();
	     *
	     * // set scene draw function
	     * shape.sceneFunc(function(context) {
	     *   context.beginPath();
	     *   context.rect(0, 0, this.width(), this.height());
	     *   context.closePath();
	     *   context.fillStrokeShape(this);
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'hitFunc');
	
	  /**
	     * get/set hit draw function
	     * @name hitFunc
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Function} drawFunc drawing function
	     * @returns {Function}
	     * @example
	     * // get hit draw function
	     * var hitFunc = shape.hitFunc();
	     *
	     * // set hit draw function
	     * shape.hitFunc(function(context) {
	     *   context.beginPath();
	     *   context.rect(0, 0, this.width(), this.height());
	     *   context.closePath();
	     *   context.fillStrokeShape(this);
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'dash');
	
	  /**
	     * get/set dash array for stroke.
	     * @name dash
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Array} dash
	     * @returns {Array}
	     * @example
	     *  // apply dashed stroke that is 10px long and 5 pixels apart
	     *  line.dash([10, 5]);
	     *  // apply dashed stroke that is made up of alternating dashed
	     *  // lines that are 10px long and 20px apart, and dots that have
	     *  // a radius of 5px and are 20px apart
	     *  line.dash([10, 20, 0.001, 20]);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'dashOffset', 0);
	
	  /**
	     * get/set dash offset for stroke.
	     * @name dash
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} dash offset
	     * @returns {Number}
	     * @example
	     *  // apply dashed stroke that is 10px long and 5 pixels apart with an offset of 5px
	     *  line.dash([10, 5]);
	     *  line.dashOffset(5);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'shadowColor');
	
	  /**
	     * get/set shadow color
	     * @name shadowColor
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {String} color
	     * @returns {String}
	     * @example
	     * // get shadow color
	     * var shadow = shape.shadowColor();
	     *
	     * // set shadow color with color string
	     * shape.shadowColor('green');
	     *
	     * // set shadow color with hex
	     * shape.shadowColor('#00ff00');
	     *
	     * // set shadow color with rgb
	     * shape.shadowColor('rgb(0,255,0)');
	     *
	     * // set shadow color with rgba and make it 50% opaque
	     * shape.shadowColor('rgba(0,255,0,0.5');
	     */
	
	  Konva.Factory.addDeprecatedGetterSetter(
	    Konva.Shape,
	    'shadowRed',
	    0,
	    Konva.Validators.RGBComponent
	  );
	  Konva.Factory.addDeprecatedGetterSetter(
	    Konva.Shape,
	    'shadowGreen',
	    0,
	    Konva.Validators.RGBComponent
	  );
	  Konva.Factory.addDeprecatedGetterSetter(
	    Konva.Shape,
	    'shadowBlue',
	    0,
	    Konva.Validators.RGBComponent
	  );
	  Konva.Factory.addDeprecatedGetterSetter(
	    Konva.Shape,
	    'shadowAlpha',
	    1,
	    Konva.Validators.alphaComponent
	  );
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'shadowBlur');
	
	  /**
	     * get/set shadow blur
	     * @name shadowBlur
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} blur
	     * @returns {Number}
	     * @example
	     * // get shadow blur
	     * var shadowBlur = shape.shadowBlur();
	     *
	     * // set shadow blur
	     * shape.shadowBlur(10);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'shadowOpacity');
	
	  /**
	     * get/set shadow opacity.  must be a value between 0 and 1
	     * @name shadowOpacity
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} opacity
	     * @returns {Number}
	     * @example
	     * // get shadow opacity
	     * var shadowOpacity = shape.shadowOpacity();
	     *
	     * // set shadow opacity
	     * shape.shadowOpacity(0.5);
	     */
	
	  Konva.Factory.addComponentsGetterSetter(Konva.Shape, 'shadowOffset', [
	    'x',
	    'y'
	  ]);
	
	  /**
	     * get/set shadow offset
	     * @name shadowOffset
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Object} offset
	     * @param {Number} offset.x
	     * @param {Number} offset.y
	     * @returns {Object}
	     * @example
	     * // get shadow offset
	     * var shadowOffset = shape.shadowOffset();
	     *
	     * // set shadow offset
	     * shape.shadowOffset({
	     *   x: 20
	     *   y: 10
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'shadowOffsetX', 0);
	
	  /**
	     * get/set shadow offset x
	     * @name shadowOffsetX
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} x
	     * @returns {Number}
	     * @example
	     * // get shadow offset x
	     * var shadowOffsetX = shape.shadowOffsetX();
	     *
	     * // set shadow offset x
	     * shape.shadowOffsetX(5);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'shadowOffsetY', 0);
	
	  /**
	     * get/set shadow offset y
	     * @name shadowOffsetY
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} y
	     * @returns {Number}
	     * @example
	     * // get shadow offset y
	     * var shadowOffsetY = shape.shadowOffsetY();
	     *
	     * // set shadow offset y
	     * shape.shadowOffsetY(5);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillPatternImage');
	
	  /**
	     * get/set fill pattern image
	     * @name fillPatternImage
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Image} image object
	     * @returns {Image}
	     * @example
	     * // get fill pattern image
	     * var fillPatternImage = shape.fillPatternImage();
	     *
	     * // set fill pattern image
	     * var imageObj = new Image();
	     * imageObj.onload = function() {
	     *   shape.fillPatternImage(imageObj);
	     * };
	     * imageObj.src = 'path/to/image/jpg';
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fill');
	
	  /**
	     * get/set fill color
	     * @name fill
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {String} color
	     * @returns {String}
	     * @example
	     * // get fill color
	     * var fill = shape.fill();
	     *
	     * // set fill color with color string
	     * shape.fill('green');
	     *
	     * // set fill color with hex
	     * shape.fill('#00ff00');
	     *
	     * // set fill color with rgb
	     * shape.fill('rgb(0,255,0)');
	     *
	     * // set fill color with rgba and make it 50% opaque
	     * shape.fill('rgba(0,255,0,0.5');
	     *
	     * // shape without fill
	     * shape.fill(null);
	     */
	
	  Konva.Factory.addDeprecatedGetterSetter(
	    Konva.Shape,
	    'fillRed',
	    0,
	    Konva.Validators.RGBComponent
	  );
	  Konva.Factory.addDeprecatedGetterSetter(
	    Konva.Shape,
	    'fillGreen',
	    0,
	    Konva.Validators.RGBComponent
	  );
	  Konva.Factory.addDeprecatedGetterSetter(
	    Konva.Shape,
	    'fillBlue',
	    0,
	    Konva.Validators.RGBComponent
	  );
	  Konva.Factory.addDeprecatedGetterSetter(
	    Konva.Shape,
	    'fillAlpha',
	    1,
	    Konva.Validators.alphaComponent
	  );
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillPatternX', 0);
	
	  /**
	     * get/set fill pattern x
	     * @name fillPatternX
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} x
	     * @returns {Number}
	     * @example
	     * // get fill pattern x
	     * var fillPatternX = shape.fillPatternX();
	     * // set fill pattern x
	     * shape.fillPatternX(20);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillPatternY', 0);
	
	  /**
	     * get/set fill pattern y
	     * @name fillPatternY
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} y
	     * @returns {Number}
	     * @example
	     * // get fill pattern y
	     * var fillPatternY = shape.fillPatternY();
	     * // set fill pattern y
	     * shape.fillPatternY(20);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillLinearGradientColorStops');
	
	  /**
	     * get/set fill linear gradient color stops
	     * @name fillLinearGradientColorStops
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Array} colorStops
	     * @returns {Array} colorStops
	     * @example
	     * // get fill linear gradient color stops
	     * var colorStops = shape.fillLinearGradientColorStops();
	     *
	     * // create a linear gradient that starts with red, changes to blue
	     * // halfway through, and then changes to green
	     * shape.fillLinearGradientColorStops(0, 'red', 0.5, 'blue', 1, 'green');
	     */
	
	  Konva.Factory.addGetterSetter(
	    Konva.Shape,
	    'fillRadialGradientStartRadius',
	    0
	  );
	
	  /**
	     * get/set fill radial gradient start radius
	     * @name fillRadialGradientStartRadius
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} radius
	     * @returns {Number}
	     * @example
	     * // get radial gradient start radius
	     * var startRadius = shape.fillRadialGradientStartRadius();
	     *
	     * // set radial gradient start radius
	     * shape.fillRadialGradientStartRadius(0);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillRadialGradientEndRadius', 0);
	
	  /**
	     * get/set fill radial gradient end radius
	     * @name fillRadialGradientEndRadius
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} radius
	     * @returns {Number}
	     * @example
	     * // get radial gradient end radius
	     * var endRadius = shape.fillRadialGradientEndRadius();
	     *
	     * // set radial gradient end radius
	     * shape.fillRadialGradientEndRadius(100);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillRadialGradientColorStops');
	
	  /**
	     * get/set fill radial gradient color stops
	     * @name fillRadialGradientColorStops
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} colorStops
	     * @returns {Array}
	     * @example
	     * // get fill radial gradient color stops
	     * var colorStops = shape.fillRadialGradientColorStops();
	     *
	     * // create a radial gradient that starts with red, changes to blue
	     * // halfway through, and then changes to green
	     * shape.fillRadialGradientColorStops(0, 'red', 0.5, 'blue', 1, 'green');
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillPatternRepeat', 'repeat');
	
	  /**
	     * get/set fill pattern repeat.  Can be 'repeat', 'repeat-x', 'repeat-y', or 'no-repeat'.  The default is 'repeat'
	     * @name fillPatternRepeat
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {String} repeat
	     * @returns {String}
	     * @example
	     * // get fill pattern repeat
	     * var repeat = shape.fillPatternRepeat();
	     *
	     * // repeat pattern in x direction only
	     * shape.fillPatternRepeat('repeat-x');
	     *
	     * // do not repeat the pattern
	     * shape.fillPatternRepeat('no repeat');
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillEnabled', true);
	
	  /**
	     * get/set fill enabled flag
	     * @name fillEnabled
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Boolean} enabled
	     * @returns {Boolean}
	     * @example
	     * // get fill enabled flag
	     * var fillEnabled = shape.fillEnabled();
	     *
	     * // disable fill
	     * shape.fillEnabled(false);
	     *
	     * // enable fill
	     * shape.fillEnabled(true);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'strokeEnabled', true);
	
	  /**
	     * get/set stroke enabled flag
	     * @name strokeEnabled
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Boolean} enabled
	     * @returns {Boolean}
	     * @example
	     * // get stroke enabled flag
	     * var strokeEnabled = shape.strokeEnabled();
	     *
	     * // disable stroke
	     * shape.strokeEnabled(false);
	     *
	     * // enable stroke
	     * shape.strokeEnabled(true);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'shadowEnabled', true);
	
	  /**
	     * get/set shadow enabled flag
	     * @name shadowEnabled
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Boolean} enabled
	     * @returns {Boolean}
	     * @example
	     * // get shadow enabled flag
	     * var shadowEnabled = shape.shadowEnabled();
	     *
	     * // disable shadow
	     * shape.shadowEnabled(false);
	     *
	     * // enable shadow
	     * shape.shadowEnabled(true);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'dashEnabled', true);
	
	  /**
	     * get/set dash enabled flag
	     * @name dashEnabled
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Boolean} enabled
	     * @returns {Boolean}
	     * @example
	     * // get dash enabled flag
	     * var dashEnabled = shape.dashEnabled();
	     *
	     * // disable dash
	     * shape.dashEnabled(false);
	     *
	     * // enable dash
	     * shape.dashEnabled(true);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'strokeScaleEnabled', true);
	
	  /**
	     * get/set strokeScale enabled flag
	     * @name strokeScaleEnabled
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Boolean} enabled
	     * @returns {Boolean}
	     * @example
	     * // get stroke scale enabled flag
	     * var strokeScaleEnabled = shape.strokeScaleEnabled();
	     *
	     * // disable stroke scale
	     * shape.strokeScaleEnabled(false);
	     *
	     * // enable stroke scale
	     * shape.strokeScaleEnabled(true);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillPriority', 'color');
	
	  /**
	     * get/set fill priority.  can be color, pattern, linear-gradient, or radial-gradient.  The default is color.
	     *   This is handy if you want to toggle between different fill types.
	     * @name fillPriority
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {String} priority
	     * @returns {String}
	     * @example
	     * // get fill priority
	     * var fillPriority = shape.fillPriority();
	     *
	     * // set fill priority
	     * shape.fillPriority('linear-gradient');
	     */
	
	  Konva.Factory.addComponentsGetterSetter(Konva.Shape, 'fillPatternOffset', [
	    'x',
	    'y'
	  ]);
	
	  /**
	     * get/set fill pattern offset
	     * @name fillPatternOffset
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Object} offset
	     * @param {Number} offset.x
	     * @param {Number} offset.y
	     * @returns {Object}
	     * @example
	     * // get fill pattern offset
	     * var patternOffset = shape.fillPatternOffset();
	     *
	     * // set fill pattern offset
	     * shape.fillPatternOffset({
	     *   x: 20
	     *   y: 10
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillPatternOffsetX', 0);
	  /**
	     * get/set fill pattern offset x
	     * @name fillPatternOffsetX
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} x
	     * @returns {Number}
	     * @example
	     * // get fill pattern offset x
	     * var patternOffsetX = shape.fillPatternOffsetX();
	     *
	     * // set fill pattern offset x
	     * shape.fillPatternOffsetX(20);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillPatternOffsetY', 0);
	  /**
	     * get/set fill pattern offset y
	     * @name fillPatternOffsetY
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} y
	     * @returns {Number}
	     * @example
	     * // get fill pattern offset y
	     * var patternOffsetY = shape.fillPatternOffsetY();
	     *
	     * // set fill pattern offset y
	     * shape.fillPatternOffsetY(10);
	     */
	
	  Konva.Factory.addComponentsGetterSetter(Konva.Shape, 'fillPatternScale', [
	    'x',
	    'y'
	  ]);
	
	  /**
	     * get/set fill pattern scale
	     * @name fillPatternScale
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Object} scale
	     * @param {Number} scale.x
	     * @param {Number} scale.y
	     * @returns {Object}
	     * @example
	     * // get fill pattern scale
	     * var patternScale = shape.fillPatternScale();
	     *
	     * // set fill pattern scale
	     * shape.fillPatternScale({
	     *   x: 2
	     *   y: 2
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillPatternScaleX', 1);
	  /**
	     * get/set fill pattern scale x
	     * @name fillPatternScaleX
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} x
	     * @returns {Number}
	     * @example
	     * // get fill pattern scale x
	     * var patternScaleX = shape.fillPatternScaleX();
	     *
	     * // set fill pattern scale x
	     * shape.fillPatternScaleX(2);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillPatternScaleY', 1);
	  /**
	     * get/set fill pattern scale y
	     * @name fillPatternScaleY
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} y
	     * @returns {Number}
	     * @example
	     * // get fill pattern scale y
	     * var patternScaleY = shape.fillPatternScaleY();
	     *
	     * // set fill pattern scale y
	     * shape.fillPatternScaleY(2);
	     */
	
	  Konva.Factory.addComponentsGetterSetter(
	    Konva.Shape,
	    'fillLinearGradientStartPoint',
	    ['x', 'y']
	  );
	
	  /**
	     * get/set fill linear gradient start point
	     * @name fillLinearGradientStartPoint
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Object} startPoint
	     * @param {Number} startPoint.x
	     * @param {Number} startPoint.y
	     * @returns {Object}
	     * @example
	     * // get fill linear gradient start point
	     * var startPoint = shape.fillLinearGradientStartPoint();
	     *
	     * // set fill linear gradient start point
	     * shape.fillLinearGradientStartPoint({
	     *   x: 20
	     *   y: 10
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(
	    Konva.Shape,
	    'fillLinearGradientStartPointX',
	    0
	  );
	  /**
	     * get/set fill linear gradient start point x
	     * @name fillLinearGradientStartPointX
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} x
	     * @returns {Number}
	     * @example
	     * // get fill linear gradient start point x
	     * var startPointX = shape.fillLinearGradientStartPointX();
	     *
	     * // set fill linear gradient start point x
	     * shape.fillLinearGradientStartPointX(20);
	     */
	
	  Konva.Factory.addGetterSetter(
	    Konva.Shape,
	    'fillLinearGradientStartPointY',
	    0
	  );
	  /**
	     * get/set fill linear gradient start point y
	     * @name fillLinearGradientStartPointY
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} y
	     * @returns {Number}
	     * @example
	     * // get fill linear gradient start point y
	     * var startPointY = shape.fillLinearGradientStartPointY();
	     *
	     * // set fill linear gradient start point y
	     * shape.fillLinearGradientStartPointY(20);
	     */
	
	  Konva.Factory.addComponentsGetterSetter(
	    Konva.Shape,
	    'fillLinearGradientEndPoint',
	    ['x', 'y']
	  );
	
	  /**
	     * get/set fill linear gradient end point
	     * @name fillLinearGradientEndPoint
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Object} endPoint
	     * @param {Number} endPoint.x
	     * @param {Number} endPoint.y
	     * @returns {Object}
	     * @example
	     * // get fill linear gradient end point
	     * var endPoint = shape.fillLinearGradientEndPoint();
	     *
	     * // set fill linear gradient end point
	     * shape.fillLinearGradientEndPoint({
	     *   x: 20
	     *   y: 10
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillLinearGradientEndPointX', 0);
	  /**
	     * get/set fill linear gradient end point x
	     * @name fillLinearGradientEndPointX
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} x
	     * @returns {Number}
	     * @example
	     * // get fill linear gradient end point x
	     * var endPointX = shape.fillLinearGradientEndPointX();
	     *
	     * // set fill linear gradient end point x
	     * shape.fillLinearGradientEndPointX(20);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillLinearGradientEndPointY', 0);
	  /**
	     * get/set fill linear gradient end point y
	     * @name fillLinearGradientEndPointY
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} y
	     * @returns {Number}
	     * @example
	     * // get fill linear gradient end point y
	     * var endPointY = shape.fillLinearGradientEndPointY();
	     *
	     * // set fill linear gradient end point y
	     * shape.fillLinearGradientEndPointY(20);
	     */
	
	  Konva.Factory.addComponentsGetterSetter(
	    Konva.Shape,
	    'fillRadialGradientStartPoint',
	    ['x', 'y']
	  );
	
	  /**
	     * get/set fill radial gradient start point
	     * @name fillRadialGradientStartPoint
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Object} startPoint
	     * @param {Number} startPoint.x
	     * @param {Number} startPoint.y
	     * @returns {Object}
	     * @example
	     * // get fill radial gradient start point
	     * var startPoint = shape.fillRadialGradientStartPoint();
	     *
	     * // set fill radial gradient start point
	     * shape.fillRadialGradientStartPoint({
	     *   x: 20
	     *   y: 10
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(
	    Konva.Shape,
	    'fillRadialGradientStartPointX',
	    0
	  );
	  /**
	     * get/set fill radial gradient start point x
	     * @name fillRadialGradientStartPointX
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} x
	     * @returns {Number}
	     * @example
	     * // get fill radial gradient start point x
	     * var startPointX = shape.fillRadialGradientStartPointX();
	     *
	     * // set fill radial gradient start point x
	     * shape.fillRadialGradientStartPointX(20);
	     */
	
	  Konva.Factory.addGetterSetter(
	    Konva.Shape,
	    'fillRadialGradientStartPointY',
	    0
	  );
	  /**
	     * get/set fill radial gradient start point y
	     * @name fillRadialGradientStartPointY
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} y
	     * @returns {Number}
	     * @example
	     * // get fill radial gradient start point y
	     * var startPointY = shape.fillRadialGradientStartPointY();
	     *
	     * // set fill radial gradient start point y
	     * shape.fillRadialGradientStartPointY(20);
	     */
	
	  Konva.Factory.addComponentsGetterSetter(
	    Konva.Shape,
	    'fillRadialGradientEndPoint',
	    ['x', 'y']
	  );
	
	  /**
	     * get/set fill radial gradient end point
	     * @name fillRadialGradientEndPoint
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Object} endPoint
	     * @param {Number} endPoint.x
	     * @param {Number} endPoint.y
	     * @returns {Object}
	     * @example
	     * // get fill radial gradient end point
	     * var endPoint = shape.fillRadialGradientEndPoint();
	     *
	     * // set fill radial gradient end point
	     * shape.fillRadialGradientEndPoint({
	     *   x: 20
	     *   y: 10
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillRadialGradientEndPointX', 0);
	  /**
	     * get/set fill radial gradient end point x
	     * @name fillRadialGradientEndPointX
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} x
	     * @returns {Number}
	     * @example
	     * // get fill radial gradient end point x
	     * var endPointX = shape.fillRadialGradientEndPointX();
	     *
	     * // set fill radial gradient end point x
	     * shape.fillRadialGradientEndPointX(20);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillRadialGradientEndPointY', 0);
	  /**
	     * get/set fill radial gradient end point y
	     * @name fillRadialGradientEndPointY
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} y
	     * @returns {Number}
	     * @example
	     * // get fill radial gradient end point y
	     * var endPointY = shape.fillRadialGradientEndPointY();
	     *
	     * // set fill radial gradient end point y
	     * shape.fillRadialGradientEndPointY(20);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillPatternRotation', 0);
	
	  /**
	     * get/set fill pattern rotation in degrees
	     * @name fillPatternRotation
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} rotation
	     * @returns {Konva.Shape}
	     * @example
	     * // get fill pattern rotation
	     * var patternRotation = shape.fillPatternRotation();
	     *
	     * // set fill pattern rotation
	     * shape.fillPatternRotation(20);
	     */
	
	  Konva.Factory.backCompat(Konva.Shape, {
	    dashArray: 'dash',
	    getDashArray: 'getDash',
	    setDashArray: 'getDash',
	
	    drawFunc: 'sceneFunc',
	    getDrawFunc: 'getSceneFunc',
	    setDrawFunc: 'setSceneFunc',
	
	    drawHitFunc: 'hitFunc',
	    getDrawHitFunc: 'getHitFunc',
	    setDrawHitFunc: 'setHitFunc'
	  });
	
	  Konva.Collection.mapMethods(Konva.Shape);
	})(Konva);
	
	(function() {
	  'use strict';
	  // CONSTANTS
	  var STAGE = 'Stage',
	    STRING = 'string',
	    PX = 'px',
	    MOUSEOUT = 'mouseout',
	    MOUSELEAVE = 'mouseleave',
	    MOUSEOVER = 'mouseover',
	    MOUSEENTER = 'mouseenter',
	    MOUSEMOVE = 'mousemove',
	    MOUSEDOWN = 'mousedown',
	    MOUSEUP = 'mouseup',
	    CONTEXTMENU = 'contextmenu',
	    CLICK = 'click',
	    DBL_CLICK = 'dblclick',
	    TOUCHSTART = 'touchstart',
	    TOUCHEND = 'touchend',
	    TAP = 'tap',
	    DBL_TAP = 'dbltap',
	    TOUCHMOVE = 'touchmove',
	    WHEEL = 'wheel',
	    CONTENT_MOUSEOUT = 'contentMouseout',
	    CONTENT_MOUSEOVER = 'contentMouseover',
	    CONTENT_MOUSEMOVE = 'contentMousemove',
	    CONTENT_MOUSEDOWN = 'contentMousedown',
	    CONTENT_MOUSEUP = 'contentMouseup',
	    CONTENT_CONTEXTMENU = 'contentContextmenu',
	    CONTENT_CLICK = 'contentClick',
	    CONTENT_DBL_CLICK = 'contentDblclick',
	    CONTENT_TOUCHSTART = 'contentTouchstart',
	    CONTENT_TOUCHEND = 'contentTouchend',
	    CONTENT_DBL_TAP = 'contentDbltap',
	    CONTENT_TAP = 'contentTap',
	    CONTENT_TOUCHMOVE = 'contentTouchmove',
	    CONTENT_WHEEL = 'contentWheel',
	    DIV = 'div',
	    RELATIVE = 'relative',
	    KONVA_CONTENT = 'konvajs-content',
	    SPACE = ' ',
	    UNDERSCORE = '_',
	    CONTAINER = 'container',
	    EMPTY_STRING = '',
	    EVENTS = [
	      MOUSEDOWN,
	      MOUSEMOVE,
	      MOUSEUP,
	      MOUSEOUT,
	      TOUCHSTART,
	      TOUCHMOVE,
	      TOUCHEND,
	      MOUSEOVER,
	      WHEEL,
	      CONTEXTMENU
	    ],
	    // cached variables
	    eventsLength = EVENTS.length;
	
	  function addEvent(ctx, eventName) {
	    ctx.content.addEventListener(
	      eventName,
	      function(evt) {
	        ctx[UNDERSCORE + eventName](evt);
	      },
	      false
	    );
	  }
	
	  /**
	     * Stage constructor.  A stage is used to contain multiple layers
	     * @constructor
	     * @memberof Konva
	     * @augments Konva.Container
	     * @param {Object} config
	     * @param {String|Element} config.container Container selector or DOM element
	     * @param {Number} [config.x]
	     * @param {Number} [config.y]
	     * @param {Number} [config.width]
	     * @param {Number} [config.height]
	     * @param {Boolean} [config.visible]
	     * @param {Boolean} [config.listening] whether or not the node is listening for events
	     * @param {String} [config.id] unique id
	     * @param {String} [config.name] non-unique name
	     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
	     * @param {Object} [config.scale] set scale
	     * @param {Number} [config.scaleX] set scale x
	     * @param {Number} [config.scaleY] set scale y
	     * @param {Number} [config.rotation] rotation in degrees
	     * @param {Object} [config.offset] offset from center point and rotation point
	     * @param {Number} [config.offsetX] set offset x
	     * @param {Number} [config.offsetY] set offset y
	     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
	     *  the entire stage by dragging any portion of the stage
	     * @param {Number} [config.dragDistance]
	     * @param {Function} [config.dragBoundFunc]
	     * @example
	     * var stage = new Konva.Stage({
	         *   width: 500,
	         *   height: 800,
	         *   container: 'containerId' // or "#containerId" or ".containerClass"
	         * });
	     */
	  Konva.Stage = function(config) {
	    this.___init(config);
	  };
	
	  Konva.Util.addMethods(Konva.Stage, {
	    ___init: function(config) {
	      this.nodeType = STAGE;
	      // call super constructor
	      Konva.Container.call(this, config);
	      this._id = Konva.idCounter++;
	      this._buildDOM();
	      this._bindContentEvents();
	      this._enableNestedTransforms = false;
	      Konva.stages.push(this);
	    },
	    _validateAdd: function(child) {
	      if (child.getType() !== 'Layer') {
	        Konva.Util.throw('You may only add layers to the stage.');
	      }
	    },
	    /**
	         * set container dom element which contains the stage wrapper div element
	         * @method
	         * @memberof Konva.Stage.prototype
	         * @param {DomElement} container can pass in a dom element or id string
	         */
	    setContainer: function(container) {
	      if (typeof container === STRING) {
	        if (container.charAt(0) === '.') {
	          var className = container.slice(1);
	          container = Konva.document.getElementsByClassName(className)[0];
	        } else {
	          var id;
	          if (container.charAt(0) !== '#') {
	            id = container;
	          } else {
	            id = container.slice(1);
	          }
	          container = Konva.document.getElementById(id);
	        }
	        if (!container) {
	          throw 'Can not find container in document with id ' + id;
	        }
	      }
	      this._setAttr(CONTAINER, container);
	      return this;
	    },
	    shouldDrawHit: function() {
	      return true;
	    },
	    draw: function() {
	      Konva.Node.prototype.draw.call(this);
	      return this;
	    },
	    /**
	         * draw layer scene graphs
	         * @name draw
	         * @method
	         * @memberof Konva.Stage.prototype
	         */
	
	    /**
	         * draw layer hit graphs
	         * @name drawHit
	         * @method
	         * @memberof Konva.Stage.prototype
	         */
	
	    /**
	         * set height
	         * @method
	         * @memberof Konva.Stage.prototype
	         * @param {Number} height
	         */
	    setHeight: function(height) {
	      Konva.Node.prototype.setHeight.call(this, height);
	      this._resizeDOM();
	      return this;
	    },
	    /**
	         * set width
	         * @method
	         * @memberof Konva.Stage.prototype
	         * @param {Number} width
	         */
	    setWidth: function(width) {
	      Konva.Node.prototype.setWidth.call(this, width);
	      this._resizeDOM();
	      return this;
	    },
	    /**
	         * clear all layers
	         * @method
	         * @memberof Konva.Stage.prototype
	         */
	    clear: function() {
	      var layers = this.children,
	        len = layers.length,
	        n;
	
	      for (n = 0; n < len; n++) {
	        layers[n].clear();
	      }
	      return this;
	    },
	    clone: function(obj) {
	      if (!obj) {
	        obj = {};
	      }
	      obj.container = Konva.document.createElement(DIV);
	      return Konva.Container.prototype.clone.call(this, obj);
	    },
	    /**
	         * destroy stage
	         * @method
	         * @memberof Konva.Stage.prototype
	         */
	    destroy: function() {
	      var content = this.content;
	      Konva.Container.prototype.destroy.call(this);
	
	      if (content && Konva.Util._isInDocument(content)) {
	        this.getContainer().removeChild(content);
	      }
	      var index = Konva.stages.indexOf(this);
	      if (index > -1) {
	        Konva.stages.splice(index, 1);
	      }
	      return this;
	    },
	    /**
	         * get pointer position which can be a touch position or mouse position
	         * @method
	         * @memberof Konva.Stage.prototype
	         * @returns {Object}
	         */
	    getPointerPosition: function() {
	      return this.pointerPos;
	    },
	    getStage: function() {
	      return this;
	    },
	    /**
	         * get stage content div element which has the
	         *  the class name "konvajs-content"
	         * @method
	         * @memberof Konva.Stage.prototype
	         */
	    getContent: function() {
	      return this.content;
	    },
	    /**
	         * Creates a composite data URL
	         * @method
	         * @memberof Konva.Stage.prototype
	         * @param {Object} config
	         * @param {Function} [config.callback] function executed when the composite has completed. Deprecated as method is sync now.
	         * @param {String} [config.mimeType] can be "image/png" or "image/jpeg".
	         *  "image/png" is the default
	         * @param {Number} [config.x] x position of canvas section
	         * @param {Number} [config.y] y position of canvas section
	         * @param {Number} [config.width] width of canvas section
	         * @param {Number} [config.height] height of canvas section
	         * @param {Number} [config.quality] jpeg quality.  If using an "image/jpeg" mimeType,
	         *  you can specify the quality from 0 to 1, where 0 is very poor quality and 1
	         *  is very high quality
	         */
	    toDataURL: function(config) {
	      config = config || {};
	
	      var mimeType = config.mimeType || null,
	        quality = config.quality || null,
	        x = config.x || 0,
	        y = config.y || 0,
	        canvas = new Konva.SceneCanvas({
	          width: config.width || this.getWidth(),
	          height: config.height || this.getHeight(),
	          pixelRatio: config.pixelRatio
	        }),
	        _context = canvas.getContext()._context,
	        layers = this.children;
	
	      if (x || y) {
	        _context.translate(-1 * x, -1 * y);
	      }
	
	      layers.each(function(layer) {
	        var width = layer.getCanvas().getWidth();
	        var height = layer.getCanvas().getHeight();
	        var ratio = layer.getCanvas().getPixelRatio();
	        _context.drawImage(
	          layer.getCanvas()._canvas,
	          0,
	          0,
	          width / ratio,
	          height / ratio
	        );
	      });
	      var src = canvas.toDataURL(mimeType, quality);
	
	      if (config.callback) {
	        config.callback(src);
	      }
	
	      return src;
	    },
	    /**
	         * converts stage into an image.
	         * @method
	         * @memberof Konva.Stage.prototype
	         * @param {Object} config
	         * @param {Function} config.callback function executed when the composite has completed
	         * @param {String} [config.mimeType] can be "image/png" or "image/jpeg".
	         *  "image/png" is the default
	         * @param {Number} [config.x] x position of canvas section
	         * @param {Number} [config.y] y position of canvas section
	         * @param {Number} [config.width] width of canvas section
	         * @param {Number} [config.height] height of canvas section
	         * @param {Number} [config.quality] jpeg quality.  If using an "image/jpeg" mimeType,
	         *  you can specify the quality from 0 to 1, where 0 is very poor quality and 1
	         *  is very high quality
	         */
	    toImage: function(config) {
	      var cb = config.callback;
	
	      config.callback = function(dataUrl) {
	        Konva.Util._getImage(dataUrl, function(img) {
	          cb(img);
	        });
	      };
	      this.toDataURL(config);
	    },
	    /**
	         * get visible intersection shape. This is the preferred
	         *  method for determining if a point intersects a shape or not
	         * @method
	         * @memberof Konva.Stage.prototype
	         * @param {Object} pos
	         * @param {Number} pos.x
	         * @param {Number} pos.y
	         * @param {String} [selector]
	         * @returns {Konva.Node}
	         * @example
	         * var shape = stage.getIntersection({x: 50, y: 50});
	         * // or if you interested in shape parent:
	         * var group = stage.getIntersection({x: 50, y: 50}, 'Group');
	         */
	    getIntersection: function(pos, selector) {
	      var layers = this.getChildren(),
	        len = layers.length,
	        end = len - 1,
	        n,
	        shape;
	
	      for (n = end; n >= 0; n--) {
	        shape = layers[n].getIntersection(pos, selector);
	        if (shape) {
	          return shape;
	        }
	      }
	
	      return null;
	    },
	    _resizeDOM: function() {
	      if (this.content) {
	        var width = this.getWidth(),
	          height = this.getHeight(),
	          layers = this.getChildren(),
	          len = layers.length,
	          n,
	          layer;
	
	        // set content dimensions
	        this.content.style.width = width + PX;
	        this.content.style.height = height + PX;
	
	        this.bufferCanvas.setSize(width, height);
	        this.bufferHitCanvas.setSize(width, height);
	
	        // set layer dimensions
	        for (n = 0; n < len; n++) {
	          layer = layers[n];
	          layer.setSize(width, height);
	          layer.draw();
	        }
	      }
	    },
	    /**
	         * add layer or layers to stage
	         * @method
	         * @memberof Konva.Stage.prototype
	         * @param {...Konva.Layer} layer
	         * @example
	         * stage.add(layer1, layer2, layer3);
	         */
	    add: function(layer) {
	      if (arguments.length > 1) {
	        for (var i = 0; i < arguments.length; i++) {
	          this.add(arguments[i]);
	        }
	        return this;
	      }
	      Konva.Container.prototype.add.call(this, layer);
	      layer._setCanvasSize(this.width(), this.height());
	
	      // draw layer and append canvas to container
	      layer.draw();
	
	      if (Konva.isBrowser) {
	        this.content.appendChild(layer.canvas._canvas);
	      }
	
	      // chainable
	      return this;
	    },
	    getParent: function() {
	      return null;
	    },
	    getLayer: function() {
	      return null;
	    },
	    /**
	         * returns a {@link Konva.Collection} of layers
	         * @method
	         * @memberof Konva.Stage.prototype
	         */
	    getLayers: function() {
	      return this.getChildren();
	    },
	    _bindContentEvents: function() {
	      if (!Konva.isBrowser) {
	        return;
	      }
	      for (var n = 0; n < eventsLength; n++) {
	        addEvent(this, EVENTS[n]);
	      }
	    },
	    _mouseover: function(evt) {
	      if (!Konva.UA.mobile) {
	        this._setPointerPosition(evt);
	        this._fire(CONTENT_MOUSEOVER, { evt: evt });
	      }
	    },
	    _mouseout: function(evt) {
	      if (!Konva.UA.mobile) {
	        this._setPointerPosition(evt);
	        var targetShape = this.targetShape;
	
	        if (targetShape && !Konva.isDragging()) {
	          targetShape._fireAndBubble(MOUSEOUT, { evt: evt });
	          targetShape._fireAndBubble(MOUSELEAVE, { evt: evt });
	          this.targetShape = null;
	        }
	        this.pointerPos = undefined;
	
	        this._fire(CONTENT_MOUSEOUT, { evt: evt });
	      }
	    },
	    _mousemove: function(evt) {
	      // workaround for mobile IE to force touch event when unhandled pointer event elevates into a mouse event
	      if (Konva.UA.ieMobile) {
	        return this._touchmove(evt);
	      }
	      // workaround fake mousemove event in chrome browser https://code.google.com/p/chromium/issues/detail?id=161464
	      if (
	        (typeof evt.movementX !== 'undefined' ||
	          typeof evt.movementY !== 'undefined') &&
	        evt.movementY === 0 &&
	        evt.movementX === 0
	      ) {
	        return null;
	      }
	      if (Konva.UA.mobile) {
	        return null;
	      }
	      this._setPointerPosition(evt);
	      var shape;
	
	      if (!Konva.isDragging()) {
	        shape = this.getIntersection(this.getPointerPosition());
	        if (shape && shape.isListening()) {
	          if (
	            !Konva.isDragging() &&
	            (!this.targetShape || this.targetShape._id !== shape._id)
	          ) {
	            if (this.targetShape) {
	              this.targetShape._fireAndBubble(MOUSEOUT, { evt: evt }, shape);
	              this.targetShape._fireAndBubble(MOUSELEAVE, { evt: evt }, shape);
	            }
	            shape._fireAndBubble(MOUSEOVER, { evt: evt }, this.targetShape);
	            shape._fireAndBubble(MOUSEENTER, { evt: evt }, this.targetShape);
	            this.targetShape = shape;
	          } else {
	            shape._fireAndBubble(MOUSEMOVE, { evt: evt });
	          }
	        } else {
	          /*
	                 * if no shape was detected, clear target shape and try
	                 * to run mouseout from previous target shape
	                 */
	          if (this.targetShape && !Konva.isDragging()) {
	            this.targetShape._fireAndBubble(MOUSEOUT, { evt: evt });
	            this.targetShape._fireAndBubble(MOUSELEAVE, { evt: evt });
	            this.targetShape = null;
	          }
	        }
	
	        // content event
	        this._fire(CONTENT_MOUSEMOVE, { evt: evt });
	      }
	
	      // always call preventDefault for desktop events because some browsers
	      // try to drag and drop the canvas element
	      if (evt.preventDefault) {
	        evt.preventDefault();
	      }
	    },
	    _mousedown: function(evt) {
	      // workaround for mobile IE to force touch event when unhandled pointer event elevates into a mouse event
	      if (Konva.UA.ieMobile) {
	        return this._touchstart(evt);
	      }
	      if (!Konva.UA.mobile) {
	        this._setPointerPosition(evt);
	        var shape = this.getIntersection(this.getPointerPosition());
	
	        Konva.listenClickTap = true;
	
	        if (shape && shape.isListening()) {
	          this.clickStartShape = shape;
	          shape._fireAndBubble(MOUSEDOWN, { evt: evt });
	        }
	
	        // content event
	        this._fire(CONTENT_MOUSEDOWN, { evt: evt });
	      }
	
	      // always call preventDefault for desktop events because some browsers
	      // try to drag and drop the canvas element
	      if (evt.preventDefault) {
	        evt.preventDefault();
	      }
	    },
	    _mouseup: function(evt) {
	      // workaround for mobile IE to force touch event when unhandled pointer event elevates into a mouse event
	      if (Konva.UA.ieMobile) {
	        return this._touchend(evt);
	      }
	      if (!Konva.UA.mobile) {
	        this._setPointerPosition(evt);
	        var shape = this.getIntersection(this.getPointerPosition()),
	          clickStartShape = this.clickStartShape,
	          clickEndShape = this.clickEndShape,
	          fireDblClick = false,
	          dd = Konva.DD;
	
	        if (Konva.inDblClickWindow) {
	          fireDblClick = true;
	          Konva.inDblClickWindow = false;
	        } else if (!dd || !dd.justDragged) {
	          // don't set inDblClickWindow after dragging
	          Konva.inDblClickWindow = true;
	        } else if (dd) {
	          dd.justDragged = false;
	        }
	
	        setTimeout(function() {
	          Konva.inDblClickWindow = false;
	        }, Konva.dblClickWindow);
	
	        if (shape && shape.isListening()) {
	          this.clickEndShape = shape;
	          shape._fireAndBubble(MOUSEUP, { evt: evt });
	
	          // detect if click or double click occurred
	          if (
	            Konva.listenClickTap &&
	            clickStartShape &&
	            clickStartShape._id === shape._id
	          ) {
	            shape._fireAndBubble(CLICK, { evt: evt });
	
	            if (
	              fireDblClick &&
	              clickEndShape &&
	              clickEndShape._id === shape._id
	            ) {
	              shape._fireAndBubble(DBL_CLICK, { evt: evt });
	            }
	          }
	        }
	        // content events
	        this._fire(CONTENT_MOUSEUP, { evt: evt });
	        if (Konva.listenClickTap) {
	          this._fire(CONTENT_CLICK, { evt: evt });
	          if (fireDblClick) {
	            this._fire(CONTENT_DBL_CLICK, { evt: evt });
	          }
	        }
	
	        Konva.listenClickTap = false;
	      }
	
	      // always call preventDefault for desktop events because some browsers
	      // try to drag and drop the canvas element
	      if (evt.preventDefault) {
	        evt.preventDefault();
	      }
	    },
	    _contextmenu: function(evt) {
	      this._fire(CONTENT_CONTEXTMENU, { evt: evt });
	    },
	    _touchstart: function(evt) {
	      this._setPointerPosition(evt);
	      var shape = this.getIntersection(this.getPointerPosition());
	
	      Konva.listenClickTap = true;
	
	      if (shape && shape.isListening()) {
	        this.tapStartShape = shape;
	        shape._fireAndBubble(TOUCHSTART, { evt: evt });
	
	        // only call preventDefault if the shape is listening for events
	        if (
	          shape.isListening() &&
	          shape.preventDefault() &&
	          evt.preventDefault
	        ) {
	          evt.preventDefault();
	        }
	      }
	      // content event
	      this._fire(CONTENT_TOUCHSTART, { evt: evt });
	    },
	    _touchend: function(evt) {
	      this._setPointerPosition(evt);
	      var shape = this.getIntersection(this.getPointerPosition()),
	        fireDblClick = false;
	
	      if (Konva.inDblClickWindow) {
	        fireDblClick = true;
	        Konva.inDblClickWindow = false;
	      } else {
	        Konva.inDblClickWindow = true;
	      }
	
	      setTimeout(function() {
	        Konva.inDblClickWindow = false;
	      }, Konva.dblClickWindow);
	
	      if (shape && shape.isListening()) {
	        shape._fireAndBubble(TOUCHEND, { evt: evt });
	
	        // detect if tap or double tap occurred
	        if (
	          Konva.listenClickTap &&
	          this.tapStartShape &&
	          shape._id === this.tapStartShape._id
	        ) {
	          shape._fireAndBubble(TAP, { evt: evt });
	
	          if (fireDblClick) {
	            shape._fireAndBubble(DBL_TAP, { evt: evt });
	          }
	        }
	        // only call preventDefault if the shape is listening for events
	        if (
	          shape.isListening() &&
	          shape.preventDefault() &&
	          evt.preventDefault
	        ) {
	          evt.preventDefault();
	        }
	      }
	      // content events
	      this._fire(CONTENT_TOUCHEND, { evt: evt });
	      if (Konva.listenClickTap) {
	        this._fire(CONTENT_TAP, { evt: evt });
	        if (fireDblClick) {
	          this._fire(CONTENT_DBL_TAP, { evt: evt });
	        }
	      }
	
	      Konva.listenClickTap = false;
	    },
	    _touchmove: function(evt) {
	      this._setPointerPosition(evt);
	      var dd = Konva.DD,
	        shape;
	      if (!Konva.isDragging()) {
	        shape = this.getIntersection(this.getPointerPosition());
	        if (shape && shape.isListening()) {
	          shape._fireAndBubble(TOUCHMOVE, { evt: evt });
	          // only call preventDefault if the shape is listening for events
	          if (
	            shape.isListening() &&
	            shape.preventDefault() &&
	            evt.preventDefault
	          ) {
	            evt.preventDefault();
	          }
	        }
	        this._fire(CONTENT_TOUCHMOVE, { evt: evt });
	      }
	      if (dd) {
	        if (Konva.isDragging() && Konva.DD.node.preventDefault()) {
	          evt.preventDefault();
	        }
	      }
	    },
	    _wheel: function(evt) {
	      this._setPointerPosition(evt);
	      var shape = this.getIntersection(this.getPointerPosition());
	
	      if (shape && shape.isListening()) {
	        shape._fireAndBubble(WHEEL, { evt: evt });
	      }
	      this._fire(CONTENT_WHEEL, { evt: evt });
	    },
	    _setPointerPosition: function(evt) {
	      var contentPosition = this._getContentPosition(),
	        x = null,
	        y = null;
	      evt = evt ? evt : window.event;
	
	      // touch events
	      if (evt.touches !== undefined) {
	        // currently, only handle one finger
	        if (evt.touches.length > 0) {
	          var touch = evt.touches[0];
	          // get the information for finger #1
	          x = touch.clientX - contentPosition.left;
	          y = touch.clientY - contentPosition.top;
	        }
	      } else {
	        // mouse events
	        x = evt.clientX - contentPosition.left;
	        y = evt.clientY - contentPosition.top;
	      }
	      if (x !== null && y !== null) {
	        this.pointerPos = {
	          x: x,
	          y: y
	        };
	      }
	    },
	    _getContentPosition: function() {
	      var rect = this.content.getBoundingClientRect
	        ? this.content.getBoundingClientRect()
	        : { top: 0, left: 0 };
	      return {
	        top: rect.top,
	        left: rect.left
	      };
	    },
	    _buildDOM: function() {
	      // the buffer canvas pixel ratio must be 1 because it is used as an
	      // intermediate canvas before copying the result onto a scene canvas.
	      // not setting it to 1 will result in an over compensation
	      this.bufferCanvas = new Konva.SceneCanvas();
	      this.bufferHitCanvas = new Konva.HitCanvas({ pixelRatio: 1 });
	
	      if (!Konva.isBrowser) {
	        return;
	      }
	      var container = this.getContainer();
	      if (!container) {
	        throw 'Stage has no container. A container is required.';
	      }
	      // clear content inside container
	      container.innerHTML = EMPTY_STRING;
	
	      // content
	      this.content = Konva.document.createElement(DIV);
	      this.content.style.position = RELATIVE;
	      this.content.className = KONVA_CONTENT;
	      this.content.setAttribute('role', 'presentation');
	
	      container.appendChild(this.content);
	
	      this._resizeDOM();
	    },
	    _onContent: function(typesStr, handler) {
	      var types = typesStr.split(SPACE),
	        len = types.length,
	        n,
	        baseEvent;
	
	      for (n = 0; n < len; n++) {
	        baseEvent = types[n];
	        this.content.addEventListener(baseEvent, handler, false);
	      }
	    },
	    // currently cache function is now working for stage, because stage has no its own canvas element
	    // TODO: may be it is better to cache all children layers?
	    cache: function() {
	      Konva.Util.warn(
	        'Cache function is not allowed for stage. You may use cache only for layers, groups and shapes.'
	      );
	    },
	    clearCache: function() {}
	  });
	  Konva.Util.extend(Konva.Stage, Konva.Container);
	
	  // add getters and setters
	  Konva.Factory.addGetter(Konva.Stage, 'container');
	  Konva.Factory.addOverloadedGetterSetter(Konva.Stage, 'container');
	
	  /**
	     * get container DOM element
	     * @name container
	     * @method
	     * @memberof Konva.Stage.prototype
	     * @returns {DomElement} container
	     * @example
	     * // get container
	     * var container = stage.container();
	     * // set container
	     * var container = document.createElement('div');
	     * body.appendChild(container);
	     * stage.container(container);
	     */
	})();
	
	(function(Konva) {
	  'use strict';
	  /**
	     * BaseLayer constructor.
	     * @constructor
	     * @memberof Konva
	     * @augments Konva.Container
	     * @param {Object} config
	     * @param {Boolean} [config.clearBeforeDraw] set this property to false if you don't want
	     * to clear the canvas before each layer draw.  The default value is true.
	     * @param {Number} [config.x]
	     * @param {Number} [config.y]
	     * @param {Number} [config.width]
	     * @param {Number} [config.height]
	     * @param {Boolean} [config.visible]
	     * @param {Boolean} [config.listening] whether or not the node is listening for events
	     * @param {String} [config.id] unique id
	     * @param {String} [config.name] non-unique name
	     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
	     * @param {Object} [config.scale] set scale
	     * @param {Number} [config.scaleX] set scale x
	     * @param {Number} [config.scaleY] set scale y
	     * @param {Number} [config.rotation] rotation in degrees
	     * @param {Object} [config.offset] offset from center point and rotation point
	     * @param {Number} [config.offsetX] set offset x
	     * @param {Number} [config.offsetY] set offset y
	     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
	     *  the entire stage by dragging any portion of the stage
	     * @param {Number} [config.dragDistance]
	     * @param {Function} [config.dragBoundFunc]
	     * * @param {Object} [config.clip] set clip
	     * @param {Number} [config.clipX] set clip x
	     * @param {Number} [config.clipY] set clip y
	     * @param {Number} [config.clipWidth] set clip width
	     * @param {Number} [config.clipHeight] set clip height
	     * @param {Function} [config.clipFunc] set clip func
	
	     */
	  Konva.BaseLayer = function(config) {
	    this.___init(config);
	  };
	
	  Konva.Util.addMethods(Konva.BaseLayer, {
	    ___init: function(config) {
	      this.nodeType = 'Layer';
	      Konva.Container.call(this, config);
	    },
	    createPNGStream: function() {
	      return this.canvas._canvas.createPNGStream();
	    },
	    /**
	     * get layer canvas
	     * @method
	     * @memberof Konva.BaseLayer.prototype
	     */
	    getCanvas: function() {
	      return this.canvas;
	    },
	    /**
	     * get layer hit canvas
	     * @method
	     * @memberof Konva.BaseLayer.prototype
	     */
	    getHitCanvas: function() {
	      return this.hitCanvas;
	    },
	    /**
	     * get layer canvas context
	     * @method
	     * @memberof Konva.BaseLayer.prototype
	     */
	    getContext: function() {
	      return this.getCanvas().getContext();
	    },
	    /**
	     * clear scene and hit canvas contexts tied to the layer
	     * @method
	     * @memberof Konva.BaseLayer.prototype
	     * @param {Object} [bounds]
	     * @param {Number} [bounds.x]
	     * @param {Number} [bounds.y]
	     * @param {Number} [bounds.width]
	     * @param {Number} [bounds.height]
	     * @example
	     * layer.clear();
	     * layer.clear({
	     *   x : 0,
	     *   y : 0,
	     *   width : 100,
	     *   height : 100
	     * });
	     */
	    clear: function(bounds) {
	      this.getContext().clear(bounds);
	      return this;
	    },
	    clearHitCache: function() {
	      this._hitImageData = undefined;
	    },
	    // extend Node.prototype.setZIndex
	    setZIndex: function(index) {
	      Konva.Node.prototype.setZIndex.call(this, index);
	      var stage = this.getStage();
	      if (stage) {
	        stage.content.removeChild(this.getCanvas()._canvas);
	
	        if (index < stage.getChildren().length - 1) {
	          stage.content.insertBefore(
	            this.getCanvas()._canvas,
	            stage.getChildren()[index + 1].getCanvas()._canvas
	          );
	        } else {
	          stage.content.appendChild(this.getCanvas()._canvas);
	        }
	      }
	      return this;
	    },
	    // extend Node.prototype.moveToTop
	    moveToTop: function() {
	      Konva.Node.prototype.moveToTop.call(this);
	      var stage = this.getStage();
	      if (stage) {
	        stage.content.removeChild(this.getCanvas()._canvas);
	        stage.content.appendChild(this.getCanvas()._canvas);
	      }
	      return this;
	    },
	    // extend Node.prototype.moveUp
	    moveUp: function() {
	      var moved = Konva.Node.prototype.moveUp.call(this);
	      if (!moved) {
	        return this;
	      }
	      var stage = this.getStage();
	      if (!stage) {
	        return this;
	      }
	      stage.content.removeChild(this.getCanvas()._canvas);
	
	      if (this.index < stage.getChildren().length - 1) {
	        stage.content.insertBefore(
	          this.getCanvas()._canvas,
	          stage.getChildren()[this.index + 1].getCanvas()._canvas
	        );
	      } else {
	        stage.content.appendChild(this.getCanvas()._canvas);
	      }
	      return this;
	    },
	    // extend Node.prototype.moveDown
	    moveDown: function() {
	      if (Konva.Node.prototype.moveDown.call(this)) {
	        var stage = this.getStage();
	        if (stage) {
	          var children = stage.getChildren();
	          stage.content.removeChild(this.getCanvas()._canvas);
	          stage.content.insertBefore(
	            this.getCanvas()._canvas,
	            children[this.index + 1].getCanvas()._canvas
	          );
	        }
	      }
	      return this;
	    },
	    // extend Node.prototype.moveToBottom
	    moveToBottom: function() {
	      if (Konva.Node.prototype.moveToBottom.call(this)) {
	        var stage = this.getStage();
	        if (stage) {
	          var children = stage.getChildren();
	          stage.content.removeChild(this.getCanvas()._canvas);
	          stage.content.insertBefore(
	            this.getCanvas()._canvas,
	            children[1].getCanvas()._canvas
	          );
	        }
	      }
	      return this;
	    },
	    getLayer: function() {
	      return this;
	    },
	    remove: function() {
	      var _canvas = this.getCanvas()._canvas;
	
	      Konva.Node.prototype.remove.call(this);
	
	      if (_canvas && _canvas.parentNode && Konva.Util._isInDocument(_canvas)) {
	        _canvas.parentNode.removeChild(_canvas);
	      }
	      return this;
	    },
	    getStage: function() {
	      return this.parent;
	    },
	    setSize: function(width, height) {
	      this.canvas.setSize(width, height);
	      return this;
	    },
	    /**
	     * get/set width of layer.getter return width of stage. setter doing nothing.
	     * if you want change width use `stage.width(value);`
	     * @name width
	     * @method
	     * @memberof Konva.BaseLayer.prototype
	     * @returns {Number}
	     * @example
	     * var width = layer.width();
	     */
	    getWidth: function() {
	      if (this.parent) {
	        return this.parent.getWidth();
	      }
	    },
	    setWidth: function() {
	      Konva.Util.warn(
	        'Can not change width of layer. Use "stage.width(value)" function instead.'
	      );
	    },
	    /**
	     * get/set height of layer.getter return height of stage. setter doing nothing.
	     * if you want change height use `stage.height(value);`
	     * @name height
	     * @method
	     * @memberof Konva.BaseLayer.prototype
	     * @returns {Number}
	     * @example
	     * var height = layer.height();
	     */
	    getHeight: function() {
	      if (this.parent) {
	        return this.parent.getHeight();
	      }
	    },
	    setHeight: function() {
	      Konva.Util.warn(
	        'Can not change height of layer. Use "stage.height(value)" function instead.'
	      );
	    },
	    // the apply transform method is handled by the Layer and FastLayer class
	    // because it is up to the layer to decide if an absolute or relative transform
	    // should be used
	    _applyTransform: function(shape, context, top) {
	      var m = shape.getAbsoluteTransform(top).getMatrix();
	      context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
	    }
	  });
	  Konva.Util.extend(Konva.BaseLayer, Konva.Container);
	
	  // add getters and setters
	  Konva.Factory.addGetterSetter(Konva.BaseLayer, 'clearBeforeDraw', true);
	  /**
	   * get/set clearBeforeDraw flag which determines if the layer is cleared or not
	   *  before drawing
	   * @name clearBeforeDraw
	   * @method
	   * @memberof Konva.BaseLayer.prototype
	   * @param {Boolean} clearBeforeDraw
	   * @returns {Boolean}
	   * @example
	   * // get clearBeforeDraw flag
	   * var clearBeforeDraw = layer.clearBeforeDraw();
	   *
	   * // disable clear before draw
	   * layer.clearBeforeDraw(false);
	   *
	   * // enable clear before draw
	   * layer.clearBeforeDraw(true);
	   */
	
	  Konva.Collection.mapMethods(Konva.BaseLayer);
	})(Konva);
	
	(function() {
	  'use strict';
	  // constants
	  var HASH = '#',
	    BEFORE_DRAW = 'beforeDraw',
	    DRAW = 'draw',
	    /*
	         * 2 - 3 - 4
	         * |       |
	         * 1 - 0   5
	         *         |
	         * 8 - 7 - 6
	         */
	    INTERSECTION_OFFSETS = [
	      { x: 0, y: 0 }, // 0
	      { x: -1, y: 0 }, // 1
	      { x: -1, y: -1 }, // 2
	      { x: 0, y: -1 }, // 3
	      { x: 1, y: -1 }, // 4
	      { x: 1, y: 0 }, // 5
	      { x: 1, y: 1 }, // 6
	      { x: 0, y: 1 }, // 7
	      { x: -1, y: 1 } // 8
	    ],
	    INTERSECTION_OFFSETS_LEN = INTERSECTION_OFFSETS.length;
	
	  /**
	     * Layer constructor.  Layers are tied to their own canvas element and are used
	     * to contain groups or shapes.
	     * @constructor
	     * @memberof Konva
	     * @augments Konva.BaseLayer
	     * @param {Object} config
	     * @param {Boolean} [config.clearBeforeDraw] set this property to false if you don't want
	     * to clear the canvas before each layer draw.  The default value is true.
	     * @param {Number} [config.x]
	     * @param {Number} [config.y]
	     * @param {Number} [config.width]
	     * @param {Number} [config.height]
	     * @param {Boolean} [config.visible]
	     * @param {Boolean} [config.listening] whether or not the node is listening for events
	     * @param {String} [config.id] unique id
	     * @param {String} [config.name] non-unique name
	     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
	     * @param {Object} [config.scale] set scale
	     * @param {Number} [config.scaleX] set scale x
	     * @param {Number} [config.scaleY] set scale y
	     * @param {Number} [config.rotation] rotation in degrees
	     * @param {Object} [config.offset] offset from center point and rotation point
	     * @param {Number} [config.offsetX] set offset x
	     * @param {Number} [config.offsetY] set offset y
	     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
	     *  the entire stage by dragging any portion of the stage
	     * @param {Number} [config.dragDistance]
	     * @param {Function} [config.dragBoundFunc]
	     * * @param {Object} [config.clip] set clip
	     * @param {Number} [config.clipX] set clip x
	     * @param {Number} [config.clipY] set clip y
	     * @param {Number} [config.clipWidth] set clip width
	     * @param {Number} [config.clipHeight] set clip height
	     * @param {Function} [config.clipFunc] set clip func
	
	     * @example
	     * var layer = new Konva.Layer();
	     */
	  Konva.Layer = function(config) {
	    this.____init(config);
	  };
	
	  Konva.Util.addMethods(Konva.Layer, {
	    ____init: function(config) {
	      this.nodeType = 'Layer';
	      this.canvas = new Konva.SceneCanvas();
	      this.hitCanvas = new Konva.HitCanvas({
	        pixelRatio: 1
	      });
	      // call super constructor
	      Konva.BaseLayer.call(this, config);
	    },
	    _setCanvasSize: function(width, height) {
	      this.canvas.setSize(width, height);
	      this.hitCanvas.setSize(width, height);
	    },
	    _validateAdd: function(child) {
	      var type = child.getType();
	      if (type !== 'Group' && type !== 'Shape') {
	        Konva.Util.throw('You may only add groups and shapes to a layer.');
	      }
	    },
	    /**
	         * get visible intersection shape. This is the preferred
	         * method for determining if a point intersects a shape or not
	         * also you may pass optional selector parametr to return ancestor of intersected shape
	         * @method
	         * @memberof Konva.Layer.prototype
	         * @param {Object} pos
	         * @param {Number} pos.x
	         * @param {Number} pos.y
	         * @param {String} [selector]
	         * @returns {Konva.Node}
	         * @example
	         * var shape = layer.getIntersection({x: 50, y: 50});
	         * // or if you interested in shape parent:
	         * var group = layer.getIntersection({x: 50, y: 50}, 'Group');
	         */
	    getIntersection: function(pos, selector) {
	      var obj, i, intersectionOffset, shape;
	
	      if (!this.hitGraphEnabled() || !this.isVisible()) {
	        return null;
	      }
	      // in some cases antialiased area may be bigger than 1px
	      // it is possible if we will cache node, then scale it a lot
	      // TODO: check { 0; 0 } point before loop, and remove it from INTERSECTION_OFFSETS.
	      var spiralSearchDistance = 1;
	      var continueSearch = false;
	      while (true) {
	        for (i = 0; i < INTERSECTION_OFFSETS_LEN; i++) {
	          intersectionOffset = INTERSECTION_OFFSETS[i];
	          obj = this._getIntersection({
	            x: pos.x + intersectionOffset.x * spiralSearchDistance,
	            y: pos.y + intersectionOffset.y * spiralSearchDistance
	          });
	          shape = obj.shape;
	          if (shape && selector) {
	            return shape.findAncestor(selector, true);
	          } else if (shape) {
	            return shape;
	          }
	          // we should continue search if we found antialiased pixel
	          // that means our node somewhere very close
	          continueSearch = !!obj.antialiased;
	          // stop search if found empty pixel
	          if (!obj.antialiased) {
	            break;
	          }
	        }
	        // if no shape, and no antialiased pixel, we should end searching
	        if (continueSearch) {
	          spiralSearchDistance += 1;
	        } else {
	          return null;
	        }
	      }
	    },
	    _getImageData: function(x, y) {
	      var width = this.hitCanvas.width || 1,
	        height = this.hitCanvas.height || 1,
	        index = Math.round(y) * width + Math.round(x);
	
	      if (!this._hitImageData) {
	        this._hitImageData = this.hitCanvas.context.getImageData(
	          0,
	          0,
	          width,
	          height
	        );
	      }
	
	      return [
	        this._hitImageData.data[4 * index + 0], // Red
	        this._hitImageData.data[4 * index + 1], // Green
	        this._hitImageData.data[4 * index + 2], // Blue
	        this._hitImageData.data[4 * index + 3] // Alpha
	      ];
	    },
	    _getIntersection: function(pos) {
	      var ratio = this.hitCanvas.pixelRatio;
	      var p = this.hitCanvas.context.getImageData(
	        Math.round(pos.x * ratio),
	        Math.round(pos.y * ratio),
	        1,
	        1
	      ).data,
	        p3 = p[3],
	        colorKey,
	        shape;
	      // fully opaque pixel
	      if (p3 === 255) {
	        colorKey = Konva.Util._rgbToHex(p[0], p[1], p[2]);
	        shape = Konva.shapes[HASH + colorKey];
	        if (shape) {
	          return {
	            shape: shape
	          };
	        }
	        return {
	          antialiased: true
	        };
	      } else if (p3 > 0) {
	        // antialiased pixel
	        return {
	          antialiased: true
	        };
	      }
	      // empty pixel
	      return {};
	    },
	    drawScene: function(can, top) {
	      var layer = this.getLayer(), canvas = can || (layer && layer.getCanvas());
	
	      this._fire(BEFORE_DRAW, {
	        node: this
	      });
	
	      if (this.getClearBeforeDraw()) {
	        canvas.getContext().clear();
	      }
	
	      Konva.Container.prototype.drawScene.call(this, canvas, top);
	
	      this._fire(DRAW, {
	        node: this
	      });
	
	      return this;
	    },
	    drawHit: function(can, top) {
	      var layer = this.getLayer(), canvas = can || (layer && layer.hitCanvas);
	
	      if (layer && layer.getClearBeforeDraw()) {
	        layer.getHitCanvas().getContext().clear();
	      }
	
	      Konva.Container.prototype.drawHit.call(this, canvas, top);
	      this.imageData = null; // Clear imageData cache
	      return this;
	    },
	    clear: function(bounds) {
	      Konva.BaseLayer.prototype.clear.call(this, bounds);
	      this.getHitCanvas().getContext().clear(bounds);
	      this.imageData = null; // Clear getImageData cache
	      return this;
	    },
	    // extend Node.prototype.setVisible
	    setVisible: function(visible) {
	      Konva.Node.prototype.setVisible.call(this, visible);
	      if (visible) {
	        this.getCanvas()._canvas.style.display = 'block';
	        this.hitCanvas._canvas.style.display = 'block';
	      } else {
	        this.getCanvas()._canvas.style.display = 'none';
	        this.hitCanvas._canvas.style.display = 'none';
	      }
	      return this;
	    },
	    /**
	         * enable hit graph
	         * @name enableHitGraph
	         * @method
	         * @memberof Konva.Layer.prototype
	         * @returns {Layer}
	         */
	    enableHitGraph: function() {
	      this.setHitGraphEnabled(true);
	      return this;
	    },
	    /**
	         * disable hit graph
	         * @name disableHitGraph
	         * @method
	         * @memberof Konva.Layer.prototype
	         * @returns {Layer}
	         */
	    disableHitGraph: function() {
	      this.setHitGraphEnabled(false);
	      return this;
	    },
	    setSize: function(width, height) {
	      Konva.BaseLayer.prototype.setSize.call(this, width, height);
	      this.hitCanvas.setSize(width, height);
	      return this;
	    }
	  });
	  Konva.Util.extend(Konva.Layer, Konva.BaseLayer);
	
	  Konva.Factory.addGetterSetter(Konva.Layer, 'hitGraphEnabled', true);
	  /**
	     * get/set hitGraphEnabled flag.  Disabling the hit graph will greatly increase
	     *  draw performance because the hit graph will not be redrawn each time the layer is
	     *  drawn.  This, however, also disables mouse/touch event detection
	     * @name hitGraphEnabled
	     * @method
	     * @memberof Konva.Layer.prototype
	     * @param {Boolean} enabled
	     * @returns {Boolean}
	     * @example
	     * // get hitGraphEnabled flag
	     * var hitGraphEnabled = layer.hitGraphEnabled();
	     *
	     * // disable hit graph
	     * layer.hitGraphEnabled(false);
	     *
	     * // enable hit graph
	     * layer.hitGraphEnabled(true);
	     */
	  Konva.Collection.mapMethods(Konva.Layer);
	})();
	
	(function() {
	  'use strict';
	  /**
	     * FastLayer constructor. Layers are tied to their own canvas element and are used
	     * to contain shapes only.  If you don't need node nesting, mouse and touch interactions,
	     * or event pub/sub, you should use FastLayer instead of Layer to create your layers.
	     * It renders about 2x faster than normal layers.
	     * @constructor
	     * @memberof Konva
	     * @augments Konva.BaseLayer
	     * @param {Object} config
	     * @param {Boolean} [config.clearBeforeDraw] set this property to false if you don't want
	     * to clear the canvas before each layer draw.  The default value is true.
	     * @param {Boolean} [config.visible]
	     * @param {String} [config.id] unique id
	     * @param {String} [config.name] non-unique name
	     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
	     * * @param {Object} [config.clip] set clip
	     * @param {Number} [config.clipX] set clip x
	     * @param {Number} [config.clipY] set clip y
	     * @param {Number} [config.clipWidth] set clip width
	     * @param {Number} [config.clipHeight] set clip height
	     * @param {Function} [config.clipFunc] set clip func
	
	     * @example
	     * var layer = new Konva.FastLayer();
	     */
	  Konva.FastLayer = function(config) {
	    this.____init(config);
	  };
	
	  Konva.Util.addMethods(Konva.FastLayer, {
	    ____init: function(config) {
	      this.nodeType = 'Layer';
	      this.canvas = new Konva.SceneCanvas();
	      // call super constructor
	      Konva.BaseLayer.call(this, config);
	    },
	    _validateAdd: function(child) {
	      var type = child.getType();
	      if (type !== 'Shape') {
	        Konva.Util.throw('You may only add shapes to a fast layer.');
	      }
	    },
	    _setCanvasSize: function(width, height) {
	      this.canvas.setSize(width, height);
	    },
	    hitGraphEnabled: function() {
	      return false;
	    },
	    getIntersection: function() {
	      return null;
	    },
	    drawScene: function(can) {
	      var layer = this.getLayer(), canvas = can || (layer && layer.getCanvas());
	
	      if (this.getClearBeforeDraw()) {
	        canvas.getContext().clear();
	      }
	
	      Konva.Container.prototype.drawScene.call(this, canvas);
	
	      return this;
	    },
	    draw: function() {
	      this.drawScene();
	      return this;
	    },
	    // extend Node.prototype.setVisible
	    setVisible: function(visible) {
	      Konva.Node.prototype.setVisible.call(this, visible);
	      if (visible) {
	        this.getCanvas()._canvas.style.display = 'block';
	      } else {
	        this.getCanvas()._canvas.style.display = 'none';
	      }
	      return this;
	    }
	  });
	  Konva.Util.extend(Konva.FastLayer, Konva.BaseLayer);
	
	  Konva.Collection.mapMethods(Konva.FastLayer);
	})();
	
	(function() {
	  'use strict';
	  /**
	     * Group constructor.  Groups are used to contain shapes or other groups.
	     * @constructor
	     * @memberof Konva
	     * @augments Konva.Container
	     * @param {Object} config
	     * @param {Number} [config.x]
	     * @param {Number} [config.y]
	     * @param {Number} [config.width]
	     * @param {Number} [config.height]
	     * @param {Boolean} [config.visible]
	     * @param {Boolean} [config.listening] whether or not the node is listening for events
	     * @param {String} [config.id] unique id
	     * @param {String} [config.name] non-unique name
	     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
	     * @param {Object} [config.scale] set scale
	     * @param {Number} [config.scaleX] set scale x
	     * @param {Number} [config.scaleY] set scale y
	     * @param {Number} [config.rotation] rotation in degrees
	     * @param {Object} [config.offset] offset from center point and rotation point
	     * @param {Number} [config.offsetX] set offset x
	     * @param {Number} [config.offsetY] set offset y
	     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
	     *  the entire stage by dragging any portion of the stage
	     * @param {Number} [config.dragDistance]
	     * @param {Function} [config.dragBoundFunc]
	     * * @param {Object} [config.clip] set clip
	     * @param {Number} [config.clipX] set clip x
	     * @param {Number} [config.clipY] set clip y
	     * @param {Number} [config.clipWidth] set clip width
	     * @param {Number} [config.clipHeight] set clip height
	     * @param {Function} [config.clipFunc] set clip func
	
	     * @example
	     * var group = new Konva.Group();
	     */
	  Konva.Group = function(config) {
	    this.___init(config);
	  };
	
	  Konva.Util.addMethods(Konva.Group, {
	    ___init: function(config) {
	      this.nodeType = 'Group';
	      // call super constructor
	      Konva.Container.call(this, config);
	    },
	    _validateAdd: function(child) {
	      var type = child.getType();
	      if (type !== 'Group' && type !== 'Shape') {
	        Konva.Util.throw('You may only add groups and shapes to groups.');
	      }
	    }
	  });
	  Konva.Util.extend(Konva.Group, Konva.Container);
	
	  Konva.Collection.mapMethods(Konva.Group);
	})();
	
	(function(Konva) {
	  'use strict';
	  var now = (function() {
	    if (Konva.global.performance && Konva.global.performance.now) {
	      return function() {
	        return Konva.global.performance.now();
	      };
	    }
	
	    return function() {
	      return new Date().getTime();
	    };
	  })();
	
	  function FRAF(callback) {
	    setTimeout(callback, 1000 / 60);
	  }
	
	  var RAF = (function() {
	    return (
	      Konva.global.requestAnimationFrame ||
	      Konva.global.webkitRequestAnimationFrame ||
	      Konva.global.mozRequestAnimationFrame ||
	      Konva.global.oRequestAnimationFrame ||
	      Konva.global.msRequestAnimationFrame ||
	      FRAF
	    );
	  })();
	
	  function requestAnimFrame() {
	    return RAF.apply(Konva.global, arguments);
	  }
	
	  /**
	     * Animation constructor.  A stage is used to contain multiple layers and handle
	     * @constructor
	     * @memberof Konva
	     * @param {Function} func function executed on each animation frame.  The function is passed a frame object, which contains
	     *  timeDiff, lastTime, time, and frameRate properties.  The timeDiff property is the number of milliseconds that have passed
	     *  since the last animation frame.  The lastTime property is time in milliseconds that elapsed from the moment the animation started
	     *  to the last animation frame.  The time property is the time in milliseconds that ellapsed from the moment the animation started
	     *  to the current animation frame.  The frameRate property is the current frame rate in frames / second. Return false from function,
	     *  if you don't need to redraw layer/layers on some frames.
	     * @param {Konva.Layer|Array} [layers] layer(s) to be redrawn on each animation frame. Can be a layer, an array of layers, or null.
	     *  Not specifying a node will result in no redraw.
	     * @example
	     * // move a node to the right at 50 pixels / second
	     * var velocity = 50;
	     *
	     * var anim = new Konva.Animation(function(frame) {
	     *   var dist = velocity * (frame.timeDiff / 1000);
	     *   node.move(dist, 0);
	     * }, layer);
	     *
	     * anim.start();
	     */
	  Konva.Animation = function(func, layers) {
	    var Anim = Konva.Animation;
	    this.func = func;
	    this.setLayers(layers);
	    this.id = Anim.animIdCounter++;
	    this.frame = {
	      time: 0,
	      timeDiff: 0,
	      lastTime: now()
	    };
	  };
	  /*
	     * Animation methods
	     */
	  Konva.Animation.prototype = {
	    /**
	         * set layers to be redrawn on each animation frame
	         * @method
	         * @memberof Konva.Animation.prototype
	         * @param {Konva.Layer|Array} [layers] layer(s) to be redrawn.&nbsp; Can be a layer, an array of layers, or null.  Not specifying a node will result in no redraw.
	         * @return {Konva.Animation} this
	         */
	    setLayers: function(layers) {
	      var lays = [];
	      // if passing in no layers
	      if (!layers) {
	        lays = [];
	      } else if (layers.length > 0) {
	        // if passing in an array of Layers
	        // NOTE: layers could be an array or Konva.Collection.  for simplicity, I'm just inspecting
	        // the length property to check for both cases
	        lays = layers;
	      } else {
	        // if passing in a Layer
	        lays = [layers];
	      }
	
	      this.layers = lays;
	      return this;
	    },
	    /**
	         * get layers
	         * @method
	         * @memberof Konva.Animation.prototype
	         * @return {Array} Array of Konva.Layer
	         */
	    getLayers: function() {
	      return this.layers;
	    },
	    /**
	         * add layer.  Returns true if the layer was added, and false if it was not
	         * @method
	         * @memberof Konva.Animation.prototype
	         * @param {Konva.Layer} layer to add
	         * @return {Bool} true if layer is added to animation, otherwise false
	         */
	    addLayer: function(layer) {
	      var layers = this.layers, len = layers.length, n;
	
	      // don't add the layer if it already exists
	      for (n = 0; n < len; n++) {
	        if (layers[n]._id === layer._id) {
	          return false;
	        }
	      }
	
	      this.layers.push(layer);
	      return true;
	    },
	    /**
	         * determine if animation is running or not.  returns true or false
	         * @method
	         * @memberof Konva.Animation.prototype
	         * @return {Bool} is animation running?
	         */
	    isRunning: function() {
	      var a = Konva.Animation,
	        animations = a.animations,
	        len = animations.length,
	        n;
	
	      for (n = 0; n < len; n++) {
	        if (animations[n].id === this.id) {
	          return true;
	        }
	      }
	      return false;
	    },
	    /**
	         * start animation
	         * @method
	         * @memberof Konva.Animation.prototype
	         * @return {Konva.Animation} this
	         */
	    start: function() {
	      var Anim = Konva.Animation;
	      this.stop();
	      this.frame.timeDiff = 0;
	      this.frame.lastTime = now();
	      Anim._addAnimation(this);
	      return this;
	    },
	    /**
	         * stop animation
	         * @method
	         * @memberof Konva.Animation.prototype
	         * @return {Konva.Animation} this
	         */
	    stop: function() {
	      Konva.Animation._removeAnimation(this);
	      return this;
	    },
	    _updateFrameObject: function(time) {
	      this.frame.timeDiff = time - this.frame.lastTime;
	      this.frame.lastTime = time;
	      this.frame.time += this.frame.timeDiff;
	      this.frame.frameRate = 1000 / this.frame.timeDiff;
	    }
	  };
	  Konva.Animation.animations = [];
	  Konva.Animation.animIdCounter = 0;
	  Konva.Animation.animRunning = false;
	
	  Konva.Animation._addAnimation = function(anim) {
	    this.animations.push(anim);
	    this._handleAnimation();
	  };
	  Konva.Animation._removeAnimation = function(anim) {
	    var id = anim.id, animations = this.animations, len = animations.length, n;
	
	    for (n = 0; n < len; n++) {
	      if (animations[n].id === id) {
	        this.animations.splice(n, 1);
	        break;
	      }
	    }
	  };
	
	  Konva.Animation._runFrames = function() {
	    var layerHash = {},
	      animations = this.animations,
	      anim,
	      layers,
	      func,
	      n,
	      i,
	      layersLen,
	      layer,
	      key,
	      needRedraw;
	    /*
	         * loop through all animations and execute animation
	         *  function.  if the animation object has specified node,
	         *  we can add the node to the nodes hash to eliminate
	         *  drawing the same node multiple times.  The node property
	         *  can be the stage itself or a layer
	         */
	    /*
	         * WARNING: don't cache animations.length because it could change while
	         * the for loop is running, causing a JS error
	         */
	
	    for (n = 0; n < animations.length; n++) {
	      anim = animations[n];
	      layers = anim.layers;
	      func = anim.func;
	
	      anim._updateFrameObject(now());
	      layersLen = layers.length;
	
	      // if animation object has a function, execute it
	      if (func) {
	        // allow anim bypassing drawing
	        needRedraw = func.call(anim, anim.frame) !== false;
	      } else {
	        needRedraw = true;
	      }
	      if (!needRedraw) {
	        continue;
	      }
	      for (i = 0; i < layersLen; i++) {
	        layer = layers[i];
	
	        if (layer._id !== undefined) {
	          layerHash[layer._id] = layer;
	        }
	      }
	    }
	
	    for (key in layerHash) {
	      if (!layerHash.hasOwnProperty(key)) {
	        continue;
	      }
	      layerHash[key].draw();
	    }
	  };
	  Konva.Animation._animationLoop = function() {
	    var Anim = Konva.Animation;
	    if (Anim.animations.length) {
	      Anim._runFrames();
	      requestAnimFrame(Anim._animationLoop);
	    } else {
	      Anim.animRunning = false;
	    }
	  };
	  Konva.Animation._handleAnimation = function() {
	    if (!this.animRunning) {
	      this.animRunning = true;
	      requestAnimFrame(this._animationLoop);
	    }
	  };
	
	  /**
	     * batch draw. this function will not do immediate draw
	     * but it will schedule drawing to next tick (requestAnimFrame)
	     * @method
	     * @return {Konva.Layer} this
	     * @memberof Konva.Base.prototype
	     */
	  Konva.BaseLayer.prototype.batchDraw = function() {
	    var that = this, Anim = Konva.Animation;
	
	    if (!this.batchAnim) {
	      this.batchAnim = new Anim(function() {
	        // stop animation after first tick
	        that.batchAnim.stop();
	      }, this);
	    }
	
	    if (!this.batchAnim.isRunning()) {
	      this.batchAnim.start();
	    }
	    return this;
	  };
	
	  /**
	     * batch draw
	     * @method
	     * @return {Konva.Stage} this
	     * @memberof Konva.Stage.prototype
	     */
	  Konva.Stage.prototype.batchDraw = function() {
	    this.getChildren().each(function(layer) {
	      layer.batchDraw();
	    });
	    return this;
	  };
	})(Konva);
	
	(function() {
	  'use strict';
	  var blacklist = {
	    node: 1,
	    duration: 1,
	    easing: 1,
	    onFinish: 1,
	    yoyo: 1
	  },
	    PAUSED = 1,
	    PLAYING = 2,
	    REVERSING = 3,
	    idCounter = 0,
	    colorAttrs = ['fill', 'stroke', 'shadowColor'];
	
	  var Tween = function(prop, propFunc, func, begin, finish, duration, yoyo) {
	    this.prop = prop;
	    this.propFunc = propFunc;
	    this.begin = begin;
	    this._pos = begin;
	    this.duration = duration;
	    this._change = 0;
	    this.prevPos = 0;
	    this.yoyo = yoyo;
	    this._time = 0;
	    this._position = 0;
	    this._startTime = 0;
	    this._finish = 0;
	    this.func = func;
	    this._change = finish - this.begin;
	    this.pause();
	  };
	  /*
	     * Tween methods
	     */
	  Tween.prototype = {
	    fire: function(str) {
	      var handler = this[str];
	      if (handler) {
	        handler();
	      }
	    },
	    setTime: function(t) {
	      if (t > this.duration) {
	        if (this.yoyo) {
	          this._time = this.duration;
	          this.reverse();
	        } else {
	          this.finish();
	        }
	      } else if (t < 0) {
	        if (this.yoyo) {
	          this._time = 0;
	          this.play();
	        } else {
	          this.reset();
	        }
	      } else {
	        this._time = t;
	        this.update();
	      }
	    },
	    getTime: function() {
	      return this._time;
	    },
	    setPosition: function(p) {
	      this.prevPos = this._pos;
	      this.propFunc(p);
	      this._pos = p;
	    },
	    getPosition: function(t) {
	      if (t === undefined) {
	        t = this._time;
	      }
	      return this.func(t, this.begin, this._change, this.duration);
	    },
	    play: function() {
	      this.state = PLAYING;
	      this._startTime = this.getTimer() - this._time;
	      this.onEnterFrame();
	      this.fire('onPlay');
	    },
	    reverse: function() {
	      this.state = REVERSING;
	      this._time = this.duration - this._time;
	      this._startTime = this.getTimer() - this._time;
	      this.onEnterFrame();
	      this.fire('onReverse');
	    },
	    seek: function(t) {
	      this.pause();
	      this._time = t;
	      this.update();
	      this.fire('onSeek');
	    },
	    reset: function() {
	      this.pause();
	      this._time = 0;
	      this.update();
	      this.fire('onReset');
	    },
	    finish: function() {
	      this.pause();
	      this._time = this.duration;
	      this.update();
	      this.fire('onFinish');
	    },
	    update: function() {
	      this.setPosition(this.getPosition(this._time));
	    },
	    onEnterFrame: function() {
	      var t = this.getTimer() - this._startTime;
	      if (this.state === PLAYING) {
	        this.setTime(t);
	      } else if (this.state === REVERSING) {
	        this.setTime(this.duration - t);
	      }
	    },
	    pause: function() {
	      this.state = PAUSED;
	      this.fire('onPause');
	    },
	    getTimer: function() {
	      return new Date().getTime();
	    }
	  };
	
	  /**
	     * Tween constructor.  Tweens enable you to animate a node between the current state and a new state.
	     *  You can play, pause, reverse, seek, reset, and finish tweens.  By default, tweens are animated using
	     *  a linear easing.  For more tweening options, check out {@link Konva.Easings}
	     * @constructor
	     * @memberof Konva
	     * @example
	     * // instantiate new tween which fully rotates a node in 1 second
	     * var tween = new Konva.Tween({
	     *   node: node,
	     *   rotationDeg: 360,
	     *   duration: 1,
	     *   easing: Konva.Easings.EaseInOut
	     * });
	     *
	     * // play tween
	     * tween.play();
	     *
	     * // pause tween
	     * tween.pause();
	     */
	  Konva.Tween = function(config) {
	    var that = this,
	      node = config.node,
	      nodeId = node._id,
	      duration,
	      easing = config.easing || Konva.Easings.Linear,
	      yoyo = !!config.yoyo,
	      key;
	
	    if (typeof config.duration === 'undefined') {
	      duration = 1;
	    } else if (config.duration === 0) {
	      // zero is bad value for duration
	      duration = 0.001;
	    } else {
	      duration = config.duration;
	    }
	    this.node = node;
	    this._id = idCounter++;
	
	    var layers =
	      node.getLayer() ||
	      (node instanceof Konva.Stage ? node.getLayers() : null);
	    if (!layers) {
	      Konva.Util.error(
	        'Tween constructor have `node` that is not in a layer. Please add node into layer first.'
	      );
	    }
	    this.anim = new Konva.Animation(function() {
	      that.tween.onEnterFrame();
	    }, layers);
	
	    this.tween = new Tween(
	      key,
	      function(i) {
	        that._tweenFunc(i);
	      },
	      easing,
	      0,
	      1,
	      duration * 1000,
	      yoyo
	    );
	
	    this._addListeners();
	
	    // init attrs map
	    if (!Konva.Tween.attrs[nodeId]) {
	      Konva.Tween.attrs[nodeId] = {};
	    }
	    if (!Konva.Tween.attrs[nodeId][this._id]) {
	      Konva.Tween.attrs[nodeId][this._id] = {};
	    }
	    // init tweens map
	    if (!Konva.Tween.tweens[nodeId]) {
	      Konva.Tween.tweens[nodeId] = {};
	    }
	
	    for (key in config) {
	      if (blacklist[key] === undefined) {
	        this._addAttr(key, config[key]);
	      }
	    }
	
	    this.reset();
	
	    // callbacks
	    this.onFinish = config.onFinish;
	    this.onReset = config.onReset;
	  };
	
	  // start/diff object = attrs.nodeId.tweenId.attr
	  Konva.Tween.attrs = {};
	  // tweenId = tweens.nodeId.attr
	  Konva.Tween.tweens = {};
	
	  Konva.Tween.prototype = {
	    _addAttr: function(key, end) {
	      var node = this.node,
	        nodeId = node._id,
	        start,
	        diff,
	        tweenId,
	        n,
	        len,
	        trueEnd,
	        trueStart;
	
	      // remove conflict from tween map if it exists
	      tweenId = Konva.Tween.tweens[nodeId][key];
	
	      if (tweenId) {
	        delete Konva.Tween.attrs[nodeId][tweenId][key];
	      }
	
	      // add to tween map
	      start = node.getAttr(key);
	
	      if (Konva.Util._isArray(end)) {
	        diff = [];
	        len = Math.max(end.length, start.length);
	
	        if (key === 'points' && end.length !== start.length) {
	          // before tweening points we need to make sure that start.length === end.length
	          // Konva.Util._prepareArrayForTween thinking that end.length > start.length
	
	          if (end.length > start.length) {
	            // so in this case we will increase number of starting points
	            trueStart = start;
	            start = Konva.Util._prepareArrayForTween(start, end, node.closed());
	          } else {
	            // in this case we will increase number of eding points
	            trueEnd = end;
	            end = Konva.Util._prepareArrayForTween(end, start, node.closed());
	          }
	        }
	
	        for (n = 0; n < len; n++) {
	          diff.push(end[n] - start[n]);
	        }
	      } else if (colorAttrs.indexOf(key) !== -1) {
	        start = Konva.Util.colorToRGBA(start);
	        var endRGBA = Konva.Util.colorToRGBA(end);
	        diff = {
	          r: endRGBA.r - start.r,
	          g: endRGBA.g - start.g,
	          b: endRGBA.b - start.b,
	          a: endRGBA.a - start.a
	        };
	      } else {
	        diff = end - start;
	      }
	
	      Konva.Tween.attrs[nodeId][this._id][key] = {
	        start: start,
	        diff: diff,
	        end: end,
	        trueEnd: trueEnd,
	        trueStart: trueStart
	      };
	      Konva.Tween.tweens[nodeId][key] = this._id;
	    },
	    _tweenFunc: function(i) {
	      var node = this.node,
	        attrs = Konva.Tween.attrs[node._id][this._id],
	        key,
	        attr,
	        start,
	        diff,
	        newVal,
	        n,
	        len,
	        end;
	
	      for (key in attrs) {
	        attr = attrs[key];
	        start = attr.start;
	        diff = attr.diff;
	        end = attr.end;
	
	        if (Konva.Util._isArray(start)) {
	          newVal = [];
	          len = Math.max(start.length, end.length);
	          for (n = 0; n < len; n++) {
	            newVal.push((start[n] || 0) + diff[n] * i);
	          }
	        } else if (colorAttrs.indexOf(key) !== -1) {
	          newVal =
	            'rgba(' +
	            Math.round(start.r + diff.r * i) +
	            ',' +
	            Math.round(start.g + diff.g * i) +
	            ',' +
	            Math.round(start.b + diff.b * i) +
	            ',' +
	            (start.a + diff.a * i) +
	            ')';
	        } else {
	          newVal = start + diff * i;
	        }
	
	        node.setAttr(key, newVal);
	      }
	    },
	    _addListeners: function() {
	      var that = this;
	
	      // start listeners
	      this.tween.onPlay = function() {
	        that.anim.start();
	      };
	      this.tween.onReverse = function() {
	        that.anim.start();
	      };
	
	      // stop listeners
	      this.tween.onPause = function() {
	        that.anim.stop();
	      };
	      this.tween.onFinish = function() {
	        var node = that.node;
	
	        // after tweening  points of line we need to set original end
	        var attrs = Konva.Tween.attrs[node._id][that._id];
	        if (attrs.points && attrs.points.trueEnd) {
	          node.points(attrs.points.trueEnd);
	        }
	
	        if (that.onFinish) {
	          that.onFinish.call(that);
	        }
	      };
	      this.tween.onReset = function() {
	        var node = that.node;
	        // after tweening  points of line we need to set original start
	        var attrs = Konva.Tween.attrs[node._id][that._id];
	        if (attrs.points && attrs.points.trueStart) {
	          node.points(attrs.points.trueStart);
	        }
	
	        if (that.onReset) {
	          that.onReset();
	        }
	      };
	    },
	    /**
	         * play
	         * @method
	         * @memberof Konva.Tween.prototype
	         * @returns {Tween}
	         */
	    play: function() {
	      this.tween.play();
	      return this;
	    },
	    /**
	         * reverse
	         * @method
	         * @memberof Konva.Tween.prototype
	         * @returns {Tween}
	         */
	    reverse: function() {
	      this.tween.reverse();
	      return this;
	    },
	    /**
	         * reset
	         * @method
	         * @memberof Konva.Tween.prototype
	         * @returns {Tween}
	         */
	    reset: function() {
	      this.tween.reset();
	      return this;
	    },
	    /**
	         * seek
	         * @method
	         * @memberof Konva.Tween.prototype
	         * @param {Integer} t time in seconds between 0 and the duration
	         * @returns {Tween}
	         */
	    seek: function(t) {
	      this.tween.seek(t * 1000);
	      return this;
	    },
	    /**
	         * pause
	         * @method
	         * @memberof Konva.Tween.prototype
	         * @returns {Tween}
	         */
	    pause: function() {
	      this.tween.pause();
	      return this;
	    },
	    /**
	         * finish
	         * @method
	         * @memberof Konva.Tween.prototype
	         * @returns {Tween}
	         */
	    finish: function() {
	      this.tween.finish();
	      return this;
	    },
	    /**
	         * destroy
	         * @method
	         * @memberof Konva.Tween.prototype
	         */
	    destroy: function() {
	      var nodeId = this.node._id,
	        thisId = this._id,
	        attrs = Konva.Tween.tweens[nodeId],
	        key;
	
	      this.pause();
	
	      for (key in attrs) {
	        delete Konva.Tween.tweens[nodeId][key];
	      }
	
	      delete Konva.Tween.attrs[nodeId][thisId];
	    }
	  };
	
	  /**
	     * Tween node properties. Shorter usage of {@link Konva.Tween} object.
	     *
	     * @method Konva.Node#to
	     * @memberof Konva.Node
	     * @param {Object} [params] tween params
	     * @example
	     *
	     * circle.to({
	     *  x : 50,
	     *  duration : 0.5
	     * });
	     */
	  Konva.Node.prototype.to = function(params) {
	    var onFinish = params.onFinish;
	    params.node = this;
	    params.onFinish = function() {
	      this.destroy();
	      if (onFinish) {
	        onFinish();
	      }
	    };
	    var tween = new Konva.Tween(params);
	    tween.play();
	  };
	
	  /*
	    * These eases were ported from an Adobe Flash tweening library to JavaScript
	    * by Xaric
	    */
	
	  /**
	     * @namespace Easings
	     * @memberof Konva
	     */
	  Konva.Easings = {
	    /**
	        * back ease in
	        * @function
	        * @memberof Konva.Easings
	        */
	    BackEaseIn: function(t, b, c, d) {
	      var s = 1.70158;
	      return c * (t /= d) * t * ((s + 1) * t - s) + b;
	    },
	    /**
	        * back ease out
	        * @function
	        * @memberof Konva.Easings
	        */
	    BackEaseOut: function(t, b, c, d) {
	      var s = 1.70158;
	      return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
	    },
	    /**
	        * back ease in out
	        * @function
	        * @memberof Konva.Easings
	        */
	    BackEaseInOut: function(t, b, c, d) {
	      var s = 1.70158;
	      if ((t /= d / 2) < 1) {
	        return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
	      }
	      return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
	    },
	    /**
	        * elastic ease in
	        * @function
	        * @memberof Konva.Easings
	        */
	    ElasticEaseIn: function(t, b, c, d, a, p) {
	      // added s = 0
	      var s = 0;
	      if (t === 0) {
	        return b;
	      }
	      if ((t /= d) === 1) {
	        return b + c;
	      }
	      if (!p) {
	        p = d * 0.3;
	      }
	      if (!a || a < Math.abs(c)) {
	        a = c;
	        s = p / 4;
	      } else {
	        s = p / (2 * Math.PI) * Math.asin(c / a);
	      }
	      return (
	        -(a *
	          Math.pow(2, 10 * (t -= 1)) *
	          Math.sin((t * d - s) * (2 * Math.PI) / p)) + b
	      );
	    },
	    /**
	        * elastic ease out
	        * @function
	        * @memberof Konva.Easings
	        */
	    ElasticEaseOut: function(t, b, c, d, a, p) {
	      // added s = 0
	      var s = 0;
	      if (t === 0) {
	        return b;
	      }
	      if ((t /= d) === 1) {
	        return b + c;
	      }
	      if (!p) {
	        p = d * 0.3;
	      }
	      if (!a || a < Math.abs(c)) {
	        a = c;
	        s = p / 4;
	      } else {
	        s = p / (2 * Math.PI) * Math.asin(c / a);
	      }
	      return (
	        a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) +
	        c +
	        b
	      );
	    },
	    /**
	        * elastic ease in out
	        * @function
	        * @memberof Konva.Easings
	        */
	    ElasticEaseInOut: function(t, b, c, d, a, p) {
	      // added s = 0
	      var s = 0;
	      if (t === 0) {
	        return b;
	      }
	      if ((t /= d / 2) === 2) {
	        return b + c;
	      }
	      if (!p) {
	        p = d * (0.3 * 1.5);
	      }
	      if (!a || a < Math.abs(c)) {
	        a = c;
	        s = p / 4;
	      } else {
	        s = p / (2 * Math.PI) * Math.asin(c / a);
	      }
	      if (t < 1) {
	        return (
	          -0.5 *
	            (a *
	              Math.pow(2, 10 * (t -= 1)) *
	              Math.sin((t * d - s) * (2 * Math.PI) / p)) +
	          b
	        );
	      }
	      return (
	        a *
	          Math.pow(2, -10 * (t -= 1)) *
	          Math.sin((t * d - s) * (2 * Math.PI) / p) *
	          0.5 +
	        c +
	        b
	      );
	    },
	    /**
	        * bounce ease out
	        * @function
	        * @memberof Konva.Easings
	        */
	    BounceEaseOut: function(t, b, c, d) {
	      if ((t /= d) < 1 / 2.75) {
	        return c * (7.5625 * t * t) + b;
	      } else if (t < 2 / 2.75) {
	        return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
	      } else if (t < 2.5 / 2.75) {
	        return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
	      } else {
	        return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
	      }
	    },
	    /**
	        * bounce ease in
	        * @function
	        * @memberof Konva.Easings
	        */
	    BounceEaseIn: function(t, b, c, d) {
	      return c - Konva.Easings.BounceEaseOut(d - t, 0, c, d) + b;
	    },
	    /**
	        * bounce ease in out
	        * @function
	        * @memberof Konva.Easings
	        */
	    BounceEaseInOut: function(t, b, c, d) {
	      if (t < d / 2) {
	        return Konva.Easings.BounceEaseIn(t * 2, 0, c, d) * 0.5 + b;
	      } else {
	        return (
	          Konva.Easings.BounceEaseOut(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b
	        );
	      }
	    },
	    /**
	        * ease in
	        * @function
	        * @memberof Konva.Easings
	        */
	    EaseIn: function(t, b, c, d) {
	      return c * (t /= d) * t + b;
	    },
	    /**
	        * ease out
	        * @function
	        * @memberof Konva.Easings
	        */
	    EaseOut: function(t, b, c, d) {
	      return -c * (t /= d) * (t - 2) + b;
	    },
	    /**
	        * ease in out
	        * @function
	        * @memberof Konva.Easings
	        */
	    EaseInOut: function(t, b, c, d) {
	      if ((t /= d / 2) < 1) {
	        return c / 2 * t * t + b;
	      }
	      return -c / 2 * (--t * (t - 2) - 1) + b;
	    },
	    /**
	        * strong ease in
	        * @function
	        * @memberof Konva.Easings
	        */
	    StrongEaseIn: function(t, b, c, d) {
	      return c * (t /= d) * t * t * t * t + b;
	    },
	    /**
	        * strong ease out
	        * @function
	        * @memberof Konva.Easings
	        */
	    StrongEaseOut: function(t, b, c, d) {
	      return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
	    },
	    /**
	        * strong ease in out
	        * @function
	        * @memberof Konva.Easings
	        */
	    StrongEaseInOut: function(t, b, c, d) {
	      if ((t /= d / 2) < 1) {
	        return c / 2 * t * t * t * t * t + b;
	      }
	      return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
	    },
	    /**
	        * linear
	        * @function
	        * @memberof Konva.Easings
	        */
	    Linear: function(t, b, c, d) {
	      return c * t / d + b;
	    }
	  };
	})();
	
	(function() {
	  'use strict';
	  Konva.DD = {
	    // properties
	    anim: new Konva.Animation(function() {
	      var b = this.dirty;
	      this.dirty = false;
	      return b;
	    }),
	    isDragging: false,
	    justDragged: false,
	    offset: {
	      x: 0,
	      y: 0
	    },
	    node: null,
	
	    // methods
	    _drag: function(evt) {
	      var dd = Konva.DD,
	        node = dd.node;
	      if (node) {
	        if (!dd.isDragging) {
	          var pos = node.getStage().getPointerPosition();
	          // it is possible that pos is undefined
	          // reattach it
	          if (!pos) {
	            node.getStage()._setPointerPosition(evt);
	            pos = node.getStage().getPointerPosition();
	          }
	          var dragDistance = node.dragDistance();
	          var distance = Math.max(
	            Math.abs(pos.x - dd.startPointerPos.x),
	            Math.abs(pos.y - dd.startPointerPos.y)
	          );
	          if (distance < dragDistance) {
	            return;
	          }
	        }
	
	        node.getStage()._setPointerPosition(evt);
	        node._setDragPosition(evt);
	        if (!dd.isDragging) {
	          dd.isDragging = true;
	          node.fire(
	            'dragstart',
	            {
	              type: 'dragstart',
	              target: node,
	              evt: evt
	            },
	            true
	          );
	        }
	
	        // execute ondragmove if defined
	        node.fire(
	          'dragmove',
	          {
	            type: 'dragmove',
	            target: node,
	            evt: evt
	          },
	          true
	        );
	      }
	    },
	    _endDragBefore: function(evt) {
	      var dd = Konva.DD,
	        node = dd.node,
	        layer;
	
	      if (node) {
	        layer = node.getLayer();
	        dd.anim.stop();
	
	        // only fire dragend event if the drag and drop
	        // operation actually started.
	        if (dd.isDragging) {
	          dd.isDragging = false;
	          dd.justDragged = true;
	          Konva.listenClickTap = false;
	
	          if (evt) {
	            evt.dragEndNode = node;
	          }
	        }
	
	        delete dd.node;
	
	        if (node.getLayer() || layer || node instanceof Konva.Stage) {
	          (layer || node).draw();
	        }
	      }
	    },
	    _endDragAfter: function(evt) {
	      evt = evt || {};
	      var dragEndNode = evt.dragEndNode;
	
	      if (evt && dragEndNode) {
	        dragEndNode.fire(
	          'dragend',
	          {
	            type: 'dragend',
	            target: dragEndNode,
	            evt: evt
	          },
	          true
	        );
	      }
	    }
	  };
	
	  // Node extenders
	
	  /**
	     * initiate drag and drop
	     * @method
	     * @memberof Konva.Node.prototype
	     */
	  Konva.Node.prototype.startDrag = function() {
	    var dd = Konva.DD,
	      stage = this.getStage(),
	      layer = this.getLayer(),
	      pos = stage.getPointerPosition(),
	      ap = this.getAbsolutePosition();
	
	    if (pos) {
	      if (dd.node) {
	        dd.node.stopDrag();
	      }
	
	      dd.node = this;
	      dd.startPointerPos = pos;
	      dd.offset.x = pos.x - ap.x;
	      dd.offset.y = pos.y - ap.y;
	      dd.anim.setLayers(layer || this.getLayers());
	      dd.anim.start();
	
	      this._setDragPosition();
	    }
	  };
	
	  Konva.Node.prototype._setDragPosition = function(evt) {
	    var dd = Konva.DD,
	      pos = this.getStage().getPointerPosition(),
	      dbf = this.getDragBoundFunc();
	    if (!pos) {
	      return;
	    }
	    var newNodePos = {
	      x: pos.x - dd.offset.x,
	      y: pos.y - dd.offset.y
	    };
	
	    if (dbf !== undefined) {
	      newNodePos = dbf.call(this, newNodePos, evt);
	    }
	    this.setAbsolutePosition(newNodePos);
	
	    if (
	      !this._lastPos ||
	      this._lastPos.x !== newNodePos.x ||
	      this._lastPos.y !== newNodePos.y
	    ) {
	      dd.anim.dirty = true;
	    }
	
	    this._lastPos = newNodePos;
	  };
	
	  /**
	     * stop drag and drop
	     * @method
	     * @memberof Konva.Node.prototype
	     */
	  Konva.Node.prototype.stopDrag = function() {
	    var dd = Konva.DD,
	      evt = {};
	    dd._endDragBefore(evt);
	    dd._endDragAfter(evt);
	  };
	
	  Konva.Node.prototype.setDraggable = function(draggable) {
	    this._setAttr('draggable', draggable);
	    this._dragChange();
	  };
	
	  var origRemove = Konva.Node.prototype.remove;
	
	  Konva.Node.prototype.__originalRemove = origRemove;
	  Konva.Node.prototype.remove = function() {
	    var dd = Konva.DD;
	
	    // stop DD
	    if (dd.node && dd.node._id === this._id) {
	      this.stopDrag();
	    }
	
	    origRemove.call(this);
	  };
	
	  /**
	     * determine if node is currently in drag and drop mode
	     * @method
	     * @memberof Konva.Node.prototype
	     */
	  Konva.Node.prototype.isDragging = function() {
	    var dd = Konva.DD;
	    return !!(dd.node && dd.node._id === this._id && dd.isDragging);
	  };
	
	  Konva.Node.prototype._listenDrag = function() {
	    var that = this;
	
	    this._dragCleanup();
	
	    if (this.getClassName() === 'Stage') {
	      this.on('contentMousedown.konva contentTouchstart.konva', function(evt) {
	        if (!Konva.DD.node) {
	          that.startDrag(evt);
	        }
	      });
	    } else {
	      this.on('mousedown.konva touchstart.konva', function(evt) {
	        // ignore right and middle buttons
	        if (evt.evt.button === 1 || evt.evt.button === 2) {
	          return;
	        }
	        if (!Konva.DD.node) {
	          that.startDrag(evt);
	        }
	      });
	    }
	
	    // listening is required for drag and drop
	    /*
	        this._listeningEnabled = true;
	        this._clearSelfAndAncestorCache('listeningEnabled');
	        */
	  };
	
	  Konva.Node.prototype._dragChange = function() {
	    if (this.attrs.draggable) {
	      this._listenDrag();
	    } else {
	      // remove event listeners
	      this._dragCleanup();
	
	      /*
	             * force drag and drop to end
	             * if this node is currently in
	             * drag and drop mode
	             */
	      var stage = this.getStage();
	      var dd = Konva.DD;
	      if (stage && dd.node && dd.node._id === this._id) {
	        dd.node.stopDrag();
	      }
	    }
	  };
	
	  Konva.Node.prototype._dragCleanup = function() {
	    if (this.getClassName() === 'Stage') {
	      this.off('contentMousedown.konva');
	      this.off('contentTouchstart.konva');
	    } else {
	      this.off('mousedown.konva');
	      this.off('touchstart.konva');
	    }
	  };
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'dragBoundFunc');
	
	  /**
	     * get/set drag bound function.  This is used to override the default
	     *  drag and drop position
	     * @name dragBoundFunc
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Function} dragBoundFunc
	     * @returns {Function}
	     * @example
	     * // get drag bound function
	     * var dragBoundFunc = node.dragBoundFunc();
	     *
	     * // create vertical drag and drop
	     * node.dragBoundFunc(function(pos){
	     *   return {
	     *     x: this.getAbsolutePosition().x,
	     *     y: pos.y
	     *   };
	     * });
	     */
	
	  Konva.Factory.addGetter(Konva.Node, 'draggable', false);
	  Konva.Factory.addOverloadedGetterSetter(Konva.Node, 'draggable');
	
	  /**
	     * get/set draggable flag
	     * @name draggable
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Boolean} draggable
	     * @returns {Boolean}
	     * @example
	     * // get draggable flag
	     * var draggable = node.draggable();
	     *
	     * // enable drag and drop
	     * node.draggable(true);
	     *
	     * // disable drag and drop
	     * node.draggable(false);
	     */
	
	  if (Konva.isBrowser) {
	    var html = Konva.document.documentElement;
	    html.addEventListener('mouseup', Konva.DD._endDragBefore, true);
	    html.addEventListener('touchend', Konva.DD._endDragBefore, true);
	
	    html.addEventListener('mousemove', Konva.DD._drag);
	    html.addEventListener('touchmove', Konva.DD._drag);
	
	    html.addEventListener('mouseup', Konva.DD._endDragAfter, false);
	    html.addEventListener('touchend', Konva.DD._endDragAfter, false);
	  }
	})();
	
	(function() {
	  'use strict';
	  /**
	     * Rect constructor
	     * @constructor
	     * @memberof Konva
	     * @augments Konva.Shape
	     * @param {Object} config
	     * @param {Number} [config.cornerRadius]
	     * @param {String} [config.fill] fill color
	     * @param {Image} [config.fillPatternImage] fill pattern image
	     * @param {Number} [config.fillPatternX]
	     * @param {Number} [config.fillPatternY]
	     * @param {Object} [config.fillPatternOffset] object with x and y component
	     * @param {Number} [config.fillPatternOffsetX] 
	     * @param {Number} [config.fillPatternOffsetY] 
	     * @param {Object} [config.fillPatternScale] object with x and y component
	     * @param {Number} [config.fillPatternScaleX]
	     * @param {Number} [config.fillPatternScaleY]
	     * @param {Number} [config.fillPatternRotation]
	     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
	     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientStartPointX]
	     * @param {Number} [config.fillLinearGradientStartPointY]
	     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientEndPointX]
	     * @param {Number} [config.fillLinearGradientEndPointY]
	     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
	     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientStartPointX]
	     * @param {Number} [config.fillRadialGradientStartPointY]
	     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientEndPointX] 
	     * @param {Number} [config.fillRadialGradientEndPointY] 
	     * @param {Number} [config.fillRadialGradientStartRadius]
	     * @param {Number} [config.fillRadialGradientEndRadius]
	     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
	     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
	     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
	     * @param {String} [config.stroke] stroke color
	     * @param {Number} [config.strokeWidth] stroke width
	     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
	     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
	     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
	     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
	     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
	     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
	     *  is miter
	     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
	     *  is butt
	     * @param {String} [config.shadowColor]
	     * @param {Number} [config.shadowBlur]
	     * @param {Object} [config.shadowOffset] object with x and y component
	     * @param {Number} [config.shadowOffsetX]
	     * @param {Number} [config.shadowOffsetY]
	     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
	     *  between 0 and 1
	     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
	     * @param {Array} [config.dash]
	     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
	     * @param {Number} [config.x]
	     * @param {Number} [config.y]
	     * @param {Number} [config.width]
	     * @param {Number} [config.height]
	     * @param {Boolean} [config.visible]
	     * @param {Boolean} [config.listening] whether or not the node is listening for events
	     * @param {String} [config.id] unique id
	     * @param {String} [config.name] non-unique name
	     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
	     * @param {Object} [config.scale] set scale
	     * @param {Number} [config.scaleX] set scale x
	     * @param {Number} [config.scaleY] set scale y
	     * @param {Number} [config.rotation] rotation in degrees
	     * @param {Object} [config.offset] offset from center point and rotation point
	     * @param {Number} [config.offsetX] set offset x
	     * @param {Number} [config.offsetY] set offset y
	     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
	     *  the entire stage by dragging any portion of the stage
	     * @param {Number} [config.dragDistance]
	     * @param {Function} [config.dragBoundFunc]
	     * @example
	     * var rect = new Konva.Rect({
	     *   width: 100,
	     *   height: 50,
	     *   fill: 'red',
	     *   stroke: 'black',
	     *   strokeWidth: 5
	     * });
	     */
	  Konva.Rect = function(config) {
	    this.___init(config);
	  };
	
	  Konva.Rect.prototype = {
	    ___init: function(config) {
	      Konva.Shape.call(this, config);
	      this.className = 'Rect';
	      this.sceneFunc(this._sceneFunc);
	    },
	    _sceneFunc: function(context) {
	      var cornerRadius = this.getCornerRadius(),
	        width = this.getWidth(),
	        height = this.getHeight();
	
	      context.beginPath();
	
	      if (!cornerRadius) {
	        // simple rect - don't bother doing all that complicated maths stuff.
	        context.rect(0, 0, width, height);
	      } else {
	        // arcTo would be nicer, but browser support is patchy (Opera)
	        cornerRadius = Math.min(cornerRadius, width / 2, height / 2);
	        context.moveTo(cornerRadius, 0);
	        context.lineTo(width - cornerRadius, 0);
	        context.arc(
	          width - cornerRadius,
	          cornerRadius,
	          cornerRadius,
	          Math.PI * 3 / 2,
	          0,
	          false
	        );
	        context.lineTo(width, height - cornerRadius);
	        context.arc(
	          width - cornerRadius,
	          height - cornerRadius,
	          cornerRadius,
	          0,
	          Math.PI / 2,
	          false
	        );
	        context.lineTo(cornerRadius, height);
	        context.arc(
	          cornerRadius,
	          height - cornerRadius,
	          cornerRadius,
	          Math.PI / 2,
	          Math.PI,
	          false
	        );
	        context.lineTo(0, cornerRadius);
	        context.arc(
	          cornerRadius,
	          cornerRadius,
	          cornerRadius,
	          Math.PI,
	          Math.PI * 3 / 2,
	          false
	        );
	      }
	      context.closePath();
	      context.fillStrokeShape(this);
	    }
	  };
	
	  Konva.Util.extend(Konva.Rect, Konva.Shape);
	
	  Konva.Factory.addGetterSetter(Konva.Rect, 'cornerRadius', 0);
	  /**
	     * get/set corner radius
	     * @name cornerRadius
	     * @method
	     * @memberof Konva.Rect.prototype
	     * @param {Number} cornerRadius
	     * @returns {Number}
	     * @example
	     * // get corner radius
	     * var cornerRadius = rect.cornerRadius();
	     *
	     * // set corner radius
	     * rect.cornerRadius(10);
	     */
	
	  Konva.Collection.mapMethods(Konva.Rect);
	})();
	
	(function(Konva) {
	  'use strict';
	  // the 0.0001 offset fixes a bug in Chrome 27
	  var PIx2 = Math.PI * 2 - 0.0001, CIRCLE = 'Circle';
	
	  /**
	     * Circle constructor
	     * @constructor
	     * @memberof Konva
	     * @augments Konva.Shape
	     * @param {Object} config
	     * @param {Number} config.radius
	     * @param {String} [config.fill] fill color
	     * @param {Image} [config.fillPatternImage] fill pattern image
	     * @param {Number} [config.fillPatternX]
	     * @param {Number} [config.fillPatternY]
	     * @param {Object} [config.fillPatternOffset] object with x and y component
	     * @param {Number} [config.fillPatternOffsetX] 
	     * @param {Number} [config.fillPatternOffsetY] 
	     * @param {Object} [config.fillPatternScale] object with x and y component
	     * @param {Number} [config.fillPatternScaleX]
	     * @param {Number} [config.fillPatternScaleY]
	     * @param {Number} [config.fillPatternRotation]
	     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
	     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientStartPointX]
	     * @param {Number} [config.fillLinearGradientStartPointY]
	     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientEndPointX]
	     * @param {Number} [config.fillLinearGradientEndPointY]
	     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
	     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientStartPointX]
	     * @param {Number} [config.fillRadialGradientStartPointY]
	     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientEndPointX] 
	     * @param {Number} [config.fillRadialGradientEndPointY] 
	     * @param {Number} [config.fillRadialGradientStartRadius]
	     * @param {Number} [config.fillRadialGradientEndRadius]
	     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
	     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
	     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
	     * @param {String} [config.stroke] stroke color
	     * @param {Number} [config.strokeWidth] stroke width
	     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
	     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
	     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
	     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
	     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
	     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
	     *  is miter
	     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
	     *  is butt
	     * @param {String} [config.shadowColor]
	     * @param {Number} [config.shadowBlur]
	     * @param {Object} [config.shadowOffset] object with x and y component
	     * @param {Number} [config.shadowOffsetX]
	     * @param {Number} [config.shadowOffsetY]
	     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
	     *  between 0 and 1
	     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
	     * @param {Array} [config.dash]
	     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
	     * @param {Number} [config.x]
	     * @param {Number} [config.y]
	     * @param {Number} [config.width]
	     * @param {Number} [config.height]
	     * @param {Boolean} [config.visible]
	     * @param {Boolean} [config.listening] whether or not the node is listening for events
	     * @param {String} [config.id] unique id
	     * @param {String} [config.name] non-unique name
	     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
	     * @param {Object} [config.scale] set scale
	     * @param {Number} [config.scaleX] set scale x
	     * @param {Number} [config.scaleY] set scale y
	     * @param {Number} [config.rotation] rotation in degrees
	     * @param {Object} [config.offset] offset from center point and rotation point
	     * @param {Number} [config.offsetX] set offset x
	     * @param {Number} [config.offsetY] set offset y
	     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
	     *  the entire stage by dragging any portion of the stage
	     * @param {Number} [config.dragDistance]
	     * @param {Function} [config.dragBoundFunc]
	     * @example
	     * // create circle
	     * var circle = new Konva.Circle({
	     *   radius: 40,
	     *   fill: 'red',
	     *   stroke: 'black'
	     *   strokeWidth: 5
	     * });
	     */
	  Konva.Circle = function(config) {
	    this.___init(config);
	  };
	
	  Konva.Circle.prototype = {
	    _centroid: true,
	    ___init: function(config) {
	      // call super constructor
	      Konva.Shape.call(this, config);
	      this.className = CIRCLE;
	      this.sceneFunc(this._sceneFunc);
	    },
	    _sceneFunc: function(context) {
	      context.beginPath();
	      context.arc(0, 0, this.getRadius(), 0, PIx2, false);
	      context.closePath();
	      context.fillStrokeShape(this);
	    },
	    // implements Shape.prototype.getWidth()
	    getWidth: function() {
	      return this.getRadius() * 2;
	    },
	    // implements Shape.prototype.getHeight()
	    getHeight: function() {
	      return this.getRadius() * 2;
	    },
	    // implements Shape.prototype.setWidth()
	    setWidth: function(width) {
	      Konva.Node.prototype.setWidth.call(this, width);
	      if (this.radius() !== width / 2) {
	        this.setRadius(width / 2);
	      }
	    },
	    // implements Shape.prototype.setHeight()
	    setHeight: function(height) {
	      Konva.Node.prototype.setHeight.call(this, height);
	      if (this.radius() !== height / 2) {
	        this.setRadius(height / 2);
	      }
	    }
	  };
	  Konva.Util.extend(Konva.Circle, Konva.Shape);
	
	  // add getters setters
	  Konva.Factory.addGetterSetter(Konva.Circle, 'radius', 0);
	  Konva.Factory.addOverloadedGetterSetter(Konva.Circle, 'radius');
	
	  /**
	     * get/set radius
	     * @name radius
	     * @method
	     * @memberof Konva.Circle.prototype
	     * @param {Number} radius
	     * @returns {Number}
	     * @example
	     * // get radius
	     * var radius = circle.radius();
	     *
	     * // set radius
	     * circle.radius(10);
	     */
	
	  Konva.Collection.mapMethods(Konva.Circle);
	})(Konva);
	
	(function() {
	  'use strict';
	  // the 0.0001 offset fixes a bug in Chrome 27
	  var PIx2 = Math.PI * 2 - 0.0001, ELLIPSE = 'Ellipse';
	
	  /**
	     * Ellipse constructor
	     * @constructor
	     * @augments Konva.Shape
	     * @param {Object} config
	     * @param {Object} config.radius defines x and y radius
	     * @param {String} [config.fill] fill color
	     * @param {Image} [config.fillPatternImage] fill pattern image
	     * @param {Number} [config.fillPatternX]
	     * @param {Number} [config.fillPatternY]
	     * @param {Object} [config.fillPatternOffset] object with x and y component
	     * @param {Number} [config.fillPatternOffsetX] 
	     * @param {Number} [config.fillPatternOffsetY] 
	     * @param {Object} [config.fillPatternScale] object with x and y component
	     * @param {Number} [config.fillPatternScaleX]
	     * @param {Number} [config.fillPatternScaleY]
	     * @param {Number} [config.fillPatternRotation]
	     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
	     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientStartPointX]
	     * @param {Number} [config.fillLinearGradientStartPointY]
	     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientEndPointX]
	     * @param {Number} [config.fillLinearGradientEndPointY]
	     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
	     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientStartPointX]
	     * @param {Number} [config.fillRadialGradientStartPointY]
	     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientEndPointX] 
	     * @param {Number} [config.fillRadialGradientEndPointY] 
	     * @param {Number} [config.fillRadialGradientStartRadius]
	     * @param {Number} [config.fillRadialGradientEndRadius]
	     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
	     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
	     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
	     * @param {String} [config.stroke] stroke color
	     * @param {Number} [config.strokeWidth] stroke width
	     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
	     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
	     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
	     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
	     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
	     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
	     *  is miter
	     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
	     *  is butt
	     * @param {String} [config.shadowColor]
	     * @param {Number} [config.shadowBlur]
	     * @param {Object} [config.shadowOffset] object with x and y component
	     * @param {Number} [config.shadowOffsetX]
	     * @param {Number} [config.shadowOffsetY]
	     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
	     *  between 0 and 1
	     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
	     * @param {Array} [config.dash]
	     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
	     * @param {Number} [config.x]
	     * @param {Number} [config.y]
	     * @param {Number} [config.width]
	     * @param {Number} [config.height]
	     * @param {Boolean} [config.visible]
	     * @param {Boolean} [config.listening] whether or not the node is listening for events
	     * @param {String} [config.id] unique id
	     * @param {String} [config.name] non-unique name
	     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
	     * @param {Object} [config.scale] set scale
	     * @param {Number} [config.scaleX] set scale x
	     * @param {Number} [config.scaleY] set scale y
	     * @param {Number} [config.rotation] rotation in degrees
	     * @param {Object} [config.offset] offset from center point and rotation point
	     * @param {Number} [config.offsetX] set offset x
	     * @param {Number} [config.offsetY] set offset y
	     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
	     *  the entire stage by dragging any portion of the stage
	     * @param {Number} [config.dragDistance]
	     * @param {Function} [config.dragBoundFunc]
	     * @example
	     * var ellipse = new Konva.Ellipse({
	     *   radius : {
	     *     x : 50,
	     *     y : 50
	     *   },
	     *   fill: 'red'
	     * });
	     */
	  Konva.Ellipse = function(config) {
	    this.___init(config);
	  };
	
	  Konva.Ellipse.prototype = {
	    _centroid: true,
	    ___init: function(config) {
	      // call super constructor
	      Konva.Shape.call(this, config);
	      this.className = ELLIPSE;
	      this.sceneFunc(this._sceneFunc);
	    },
	    _sceneFunc: function(context) {
	      var rx = this.getRadiusX(), ry = this.getRadiusY();
	
	      context.beginPath();
	      context.save();
	      if (rx !== ry) {
	        context.scale(1, ry / rx);
	      }
	      context.arc(0, 0, rx, 0, PIx2, false);
	      context.restore();
	      context.closePath();
	      context.fillStrokeShape(this);
	    },
	    // implements Shape.prototype.getWidth()
	    getWidth: function() {
	      return this.getRadiusX() * 2;
	    },
	    // implements Shape.prototype.getHeight()
	    getHeight: function() {
	      return this.getRadiusY() * 2;
	    },
	    // implements Shape.prototype.setWidth()
	    setWidth: function(width) {
	      Konva.Node.prototype.setWidth.call(this, width);
	      this.setRadius({
	        x: width / 2
	      });
	    },
	    // implements Shape.prototype.setHeight()
	    setHeight: function(height) {
	      Konva.Node.prototype.setHeight.call(this, height);
	      this.setRadius({
	        y: height / 2
	      });
	    }
	  };
	  Konva.Util.extend(Konva.Ellipse, Konva.Shape);
	
	  // add getters setters
	  Konva.Factory.addComponentsGetterSetter(Konva.Ellipse, 'radius', ['x', 'y']);
	
	  /**
	     * get/set radius
	     * @name radius
	     * @method
	     * @memberof Konva.Ellipse.prototype
	     * @param {Object} radius
	     * @param {Number} radius.x
	     * @param {Number} radius.y
	     * @returns {Object}
	     * @example
	     * // get radius
	     * var radius = ellipse.radius();
	     *
	     * // set radius
	     * ellipse.radius({
	     *   x: 200,
	     *   y: 100
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Ellipse, 'radiusX', 0);
	  /**
	     * get/set radius x
	     * @name radiusX
	     * @method
	     * @memberof Konva.Ellipse.prototype
	     * @param {Number} x
	     * @returns {Number}
	     * @example
	     * // get radius x
	     * var radiusX = ellipse.radiusX();
	     *
	     * // set radius x
	     * ellipse.radiusX(200);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Ellipse, 'radiusY', 0);
	  /**
	     * get/set radius y
	     * @name radiusY
	     * @method
	     * @memberof Konva.Ellipse.prototype
	     * @param {Number} y
	     * @returns {Number}
	     * @example
	     * // get radius y
	     * var radiusY = ellipse.radiusY();
	     *
	     * // set radius y
	     * ellipse.radiusY(200);
	     */
	
	  Konva.Collection.mapMethods(Konva.Ellipse);
	})();
	
	(function() {
	  'use strict';
	  // the 0.0001 offset fixes a bug in Chrome 27
	  var PIx2 = Math.PI * 2 - 0.0001;
	  /**
	     * Ring constructor
	     * @constructor
	     * @augments Konva.Shape
	     * @param {Object} config
	     * @param {Number} config.innerRadius
	     * @param {Number} config.outerRadius
	     * @param {Boolean} [config.clockwise]
	     * @param {String} [config.fill] fill color
	     * @param {Image} [config.fillPatternImage] fill pattern image
	     * @param {Number} [config.fillPatternX]
	     * @param {Number} [config.fillPatternY]
	     * @param {Object} [config.fillPatternOffset] object with x and y component
	     * @param {Number} [config.fillPatternOffsetX] 
	     * @param {Number} [config.fillPatternOffsetY] 
	     * @param {Object} [config.fillPatternScale] object with x and y component
	     * @param {Number} [config.fillPatternScaleX]
	     * @param {Number} [config.fillPatternScaleY]
	     * @param {Number} [config.fillPatternRotation]
	     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
	     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientStartPointX]
	     * @param {Number} [config.fillLinearGradientStartPointY]
	     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientEndPointX]
	     * @param {Number} [config.fillLinearGradientEndPointY]
	     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
	     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientStartPointX]
	     * @param {Number} [config.fillRadialGradientStartPointY]
	     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientEndPointX] 
	     * @param {Number} [config.fillRadialGradientEndPointY] 
	     * @param {Number} [config.fillRadialGradientStartRadius]
	     * @param {Number} [config.fillRadialGradientEndRadius]
	     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
	     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
	     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
	     * @param {String} [config.stroke] stroke color
	     * @param {Number} [config.strokeWidth] stroke width
	     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
	     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
	     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
	     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
	     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
	     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
	     *  is miter
	     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
	     *  is butt
	     * @param {String} [config.shadowColor]
	     * @param {Number} [config.shadowBlur]
	     * @param {Object} [config.shadowOffset] object with x and y component
	     * @param {Number} [config.shadowOffsetX]
	     * @param {Number} [config.shadowOffsetY]
	     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
	     *  between 0 and 1
	     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
	     * @param {Array} [config.dash]
	     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
	     * @param {Number} [config.x]
	     * @param {Number} [config.y]
	     * @param {Number} [config.width]
	     * @param {Number} [config.height]
	     * @param {Boolean} [config.visible]
	     * @param {Boolean} [config.listening] whether or not the node is listening for events
	     * @param {String} [config.id] unique id
	     * @param {String} [config.name] non-unique name
	     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
	     * @param {Object} [config.scale] set scale
	     * @param {Number} [config.scaleX] set scale x
	     * @param {Number} [config.scaleY] set scale y
	     * @param {Number} [config.rotation] rotation in degrees
	     * @param {Object} [config.offset] offset from center point and rotation point
	     * @param {Number} [config.offsetX] set offset x
	     * @param {Number} [config.offsetY] set offset y
	     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
	     *  the entire stage by dragging any portion of the stage
	     * @param {Number} [config.dragDistance]
	     * @param {Function} [config.dragBoundFunc]
	     * @example
	     * var ring = new Konva.Ring({
	     *   innerRadius: 40,
	     *   outerRadius: 80,
	     *   fill: 'red',
	     *   stroke: 'black',
	     *   strokeWidth: 5
	     * });
	     */
	  Konva.Ring = function(config) {
	    this.___init(config);
	  };
	
	  Konva.Ring.prototype = {
	    _centroid: true,
	    ___init: function(config) {
	      // call super constructor
	      Konva.Shape.call(this, config);
	      this.className = 'Ring';
	      this.sceneFunc(this._sceneFunc);
	    },
	    _sceneFunc: function(context) {
	      context.beginPath();
	      context.arc(0, 0, this.getInnerRadius(), 0, PIx2, false);
	      context.moveTo(this.getOuterRadius(), 0);
	      context.arc(0, 0, this.getOuterRadius(), PIx2, 0, true);
	      context.closePath();
	      context.fillStrokeShape(this);
	    },
	    // implements Shape.prototype.getWidth()
	    getWidth: function() {
	      return this.getOuterRadius() * 2;
	    },
	    // implements Shape.prototype.getHeight()
	    getHeight: function() {
	      return this.getOuterRadius() * 2;
	    },
	    // implements Shape.prototype.setWidth()
	    setWidth: function(width) {
	      Konva.Node.prototype.setWidth.call(this, width);
	      if (this.outerRadius() !== width / 2) {
	        this.setOuterRadius(width / 2);
	      }
	    },
	    // implements Shape.prototype.setHeight()
	    setHeight: function(height) {
	      Konva.Node.prototype.setHeight.call(this, height);
	      if (this.outerRadius() !== height / 2) {
	        this.setOuterRadius(height / 2);
	      }
	    },
	    setOuterRadius: function(val) {
	      this._setAttr('outerRadius', val);
	      this.setWidth(val * 2);
	      this.setHeight(val * 2);
	    }
	  };
	  Konva.Util.extend(Konva.Ring, Konva.Shape);
	
	  // add getters setters
	  Konva.Factory.addGetterSetter(Konva.Ring, 'innerRadius', 0);
	
	  /**
	     * get/set innerRadius
	     * @name innerRadius
	     * @method
	     * @memberof Konva.Ring.prototype
	     * @param {Number} innerRadius
	     * @returns {Number}
	     * @example
	     * // get inner radius
	     * var innerRadius = ring.innerRadius();
	     *
	     * // set inner radius
	     * ring.innerRadius(20);
	     */
	  Konva.Factory.addGetter(Konva.Ring, 'outerRadius', 0);
	  Konva.Factory.addOverloadedGetterSetter(Konva.Ring, 'outerRadius');
	
	  /**
	     * get/set outerRadius
	     * @name outerRadius
	     * @method
	     * @memberof Konva.Ring.prototype
	     * @param {Number} outerRadius
	     * @returns {Number}
	     * @example
	     * // get outer radius
	     * var outerRadius = ring.outerRadius();
	     *
	     * // set outer radius
	     * ring.outerRadius(20);
	     */
	
	  Konva.Collection.mapMethods(Konva.Ring);
	})();
	
	(function() {
	  'use strict';
	  /**
	     * Wedge constructor
	     * @constructor
	     * @augments Konva.Shape
	     * @param {Object} config
	     * @param {Number} config.angle in degrees
	     * @param {Number} config.radius
	     * @param {Boolean} [config.clockwise]
	     * @param {String} [config.fill] fill color
	     * @param {Image} [config.fillPatternImage] fill pattern image
	     * @param {Number} [config.fillPatternX]
	     * @param {Number} [config.fillPatternY]
	     * @param {Object} [config.fillPatternOffset] object with x and y component
	     * @param {Number} [config.fillPatternOffsetX] 
	     * @param {Number} [config.fillPatternOffsetY] 
	     * @param {Object} [config.fillPatternScale] object with x and y component
	     * @param {Number} [config.fillPatternScaleX]
	     * @param {Number} [config.fillPatternScaleY]
	     * @param {Number} [config.fillPatternRotation]
	     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
	     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientStartPointX]
	     * @param {Number} [config.fillLinearGradientStartPointY]
	     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientEndPointX]
	     * @param {Number} [config.fillLinearGradientEndPointY]
	     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
	     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientStartPointX]
	     * @param {Number} [config.fillRadialGradientStartPointY]
	     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientEndPointX] 
	     * @param {Number} [config.fillRadialGradientEndPointY] 
	     * @param {Number} [config.fillRadialGradientStartRadius]
	     * @param {Number} [config.fillRadialGradientEndRadius]
	     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
	     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
	     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
	     * @param {String} [config.stroke] stroke color
	     * @param {Number} [config.strokeWidth] stroke width
	     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
	     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
	     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
	     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
	     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
	     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
	     *  is miter
	     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
	     *  is butt
	     * @param {String} [config.shadowColor]
	     * @param {Number} [config.shadowBlur]
	     * @param {Object} [config.shadowOffset] object with x and y component
	     * @param {Number} [config.shadowOffsetX]
	     * @param {Number} [config.shadowOffsetY]
	     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
	     *  between 0 and 1
	     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
	     * @param {Array} [config.dash]
	     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
	     * @param {Number} [config.x]
	     * @param {Number} [config.y]
	     * @param {Number} [config.width]
	     * @param {Number} [config.height]
	     * @param {Boolean} [config.visible]
	     * @param {Boolean} [config.listening] whether or not the node is listening for events
	     * @param {String} [config.id] unique id
	     * @param {String} [config.name] non-unique name
	     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
	     * @param {Object} [config.scale] set scale
	     * @param {Number} [config.scaleX] set scale x
	     * @param {Number} [config.scaleY] set scale y
	     * @param {Number} [config.rotation] rotation in degrees
	     * @param {Object} [config.offset] offset from center point and rotation point
	     * @param {Number} [config.offsetX] set offset x
	     * @param {Number} [config.offsetY] set offset y
	     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
	     *  the entire stage by dragging any portion of the stage
	     * @param {Number} [config.dragDistance]
	     * @param {Function} [config.dragBoundFunc]
	     * @example
	     * // draw a wedge that's pointing downwards
	     * var wedge = new Konva.Wedge({
	     *   radius: 40,
	     *   fill: 'red',
	     *   stroke: 'black'
	     *   strokeWidth: 5,
	     *   angleDeg: 60,
	     *   rotationDeg: -120
	     * });
	     */
	  Konva.Wedge = function(config) {
	    this.___init(config);
	  };
	
	  Konva.Wedge.prototype = {
	    _centroid: true,
	    ___init: function(config) {
	      // call super constructor
	      Konva.Shape.call(this, config);
	      this.className = 'Wedge';
	      this.sceneFunc(this._sceneFunc);
	    },
	    _sceneFunc: function(context) {
	      context.beginPath();
	      context.arc(
	        0,
	        0,
	        this.getRadius(),
	        0,
	        Konva.getAngle(this.getAngle()),
	        this.getClockwise()
	      );
	      context.lineTo(0, 0);
	      context.closePath();
	      context.fillStrokeShape(this);
	    },
	    // implements Shape.prototype.getWidth()
	    getWidth: function() {
	      return this.getRadius() * 2;
	    },
	    // implements Shape.prototype.getHeight()
	    getHeight: function() {
	      return this.getRadius() * 2;
	    },
	    // implements Shape.prototype.setWidth()
	    setWidth: function(width) {
	      Konva.Node.prototype.setWidth.call(this, width);
	      if (this.radius() !== width / 2) {
	        this.setRadius(width / 2);
	      }
	    },
	    // implements Shape.prototype.setHeight()
	    setHeight: function(height) {
	      Konva.Node.prototype.setHeight.call(this, height);
	      if (this.radius() !== height / 2) {
	        this.setRadius(height / 2);
	      }
	    }
	  };
	  Konva.Util.extend(Konva.Wedge, Konva.Shape);
	
	  // add getters setters
	  Konva.Factory.addGetterSetter(Konva.Wedge, 'radius', 0);
	
	  /**
	     * get/set radius
	     * @name radius
	     * @method
	     * @memberof Konva.Wedge.prototype
	     * @param {Number} radius
	     * @returns {Number}
	     * @example
	     * // get radius
	     * var radius = wedge.radius();
	     *
	     * // set radius
	     * wedge.radius(10);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Wedge, 'angle', 0);
	
	  /**
	     * get/set angle in degrees
	     * @name angle
	     * @method
	     * @memberof Konva.Wedge.prototype
	     * @param {Number} angle
	     * @returns {Number}
	     * @example
	     * // get angle
	     * var angle = wedge.angle();
	     *
	     * // set angle
	     * wedge.angle(20);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Wedge, 'clockwise', false);
	
	  /**
	     * get/set clockwise flag
	     * @name clockwise
	     * @method
	     * @memberof Konva.Wedge.prototype
	     * @param {Number} clockwise
	     * @returns {Number}
	     * @example
	     * // get clockwise flag
	     * var clockwise = wedge.clockwise();
	     *
	     * // draw wedge counter-clockwise
	     * wedge.clockwise(false);
	     *
	     * // draw wedge clockwise
	     * wedge.clockwise(true);
	     */
	
	  Konva.Factory.backCompat(Konva.Wedge, {
	    angleDeg: 'angle',
	    getAngleDeg: 'getAngle',
	    setAngleDeg: 'setAngle'
	  });
	
	  Konva.Collection.mapMethods(Konva.Wedge);
	})();
	
	(function(Konva) {
	  'use strict';
	  /**
	     * Arc constructor
	     * @constructor
	     * @augments Konva.Shape
	     * @param {Object} config
	     * @param {Number} config.angle in degrees
	     * @param {Number} config.innerRadius
	     * @param {Number} config.outerRadius
	     * @param {Boolean} [config.clockwise]
	     * @param {String} [config.fill] fill color
	     * @param {Image} [config.fillPatternImage] fill pattern image
	     * @param {Number} [config.fillPatternX]
	     * @param {Number} [config.fillPatternY]
	     * @param {Object} [config.fillPatternOffset] object with x and y component
	     * @param {Number} [config.fillPatternOffsetX] 
	     * @param {Number} [config.fillPatternOffsetY] 
	     * @param {Object} [config.fillPatternScale] object with x and y component
	     * @param {Number} [config.fillPatternScaleX]
	     * @param {Number} [config.fillPatternScaleY]
	     * @param {Number} [config.fillPatternRotation]
	     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
	     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientStartPointX]
	     * @param {Number} [config.fillLinearGradientStartPointY]
	     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientEndPointX]
	     * @param {Number} [config.fillLinearGradientEndPointY]
	     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
	     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientStartPointX]
	     * @param {Number} [config.fillRadialGradientStartPointY]
	     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientEndPointX] 
	     * @param {Number} [config.fillRadialGradientEndPointY] 
	     * @param {Number} [config.fillRadialGradientStartRadius]
	     * @param {Number} [config.fillRadialGradientEndRadius]
	     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
	     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
	     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
	     * @param {String} [config.stroke] stroke color
	     * @param {Number} [config.strokeWidth] stroke width
	     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
	     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
	     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
	     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
	     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
	     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
	     *  is miter
	     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
	     *  is butt
	     * @param {String} [config.shadowColor]
	     * @param {Number} [config.shadowBlur]
	     * @param {Object} [config.shadowOffset] object with x and y component
	     * @param {Number} [config.shadowOffsetX]
	     * @param {Number} [config.shadowOffsetY]
	     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
	     *  between 0 and 1
	     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
	     * @param {Array} [config.dash]
	     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
	     * @param {Number} [config.x]
	     * @param {Number} [config.y]
	     * @param {Number} [config.width]
	     * @param {Number} [config.height]
	     * @param {Boolean} [config.visible]
	     * @param {Boolean} [config.listening] whether or not the node is listening for events
	     * @param {String} [config.id] unique id
	     * @param {String} [config.name] non-unique name
	     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
	     * @param {Object} [config.scale] set scale
	     * @param {Number} [config.scaleX] set scale x
	     * @param {Number} [config.scaleY] set scale y
	     * @param {Number} [config.rotation] rotation in degrees
	     * @param {Object} [config.offset] offset from center point and rotation point
	     * @param {Number} [config.offsetX] set offset x
	     * @param {Number} [config.offsetY] set offset y
	     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
	     *  the entire stage by dragging any portion of the stage
	     * @param {Number} [config.dragDistance]
	     * @param {Function} [config.dragBoundFunc]
	     * @example
	     * // draw a Arc that's pointing downwards
	     * var arc = new Konva.Arc({
	     *   innerRadius: 40,
	     *   outerRadius: 80,
	     *   fill: 'red',
	     *   stroke: 'black'
	     *   strokeWidth: 5,
	     *   angle: 60,
	     *   rotationDeg: -120
	     * });
	     */
	  Konva.Arc = function(config) {
	    this.___init(config);
	  };
	
	  Konva.Arc.prototype = {
	    _centroid: true,
	    ___init: function(config) {
	      // call super constructor
	      Konva.Shape.call(this, config);
	      this.className = 'Arc';
	      this.sceneFunc(this._sceneFunc);
	    },
	    _sceneFunc: function(context) {
	      var angle = Konva.getAngle(this.angle()), clockwise = this.clockwise();
	
	      context.beginPath();
	      context.arc(0, 0, this.getOuterRadius(), 0, angle, clockwise);
	      context.arc(0, 0, this.getInnerRadius(), angle, 0, !clockwise);
	      context.closePath();
	      context.fillStrokeShape(this);
	    },
	    // implements Shape.prototype.getWidth()
	    getWidth: function() {
	      return this.getOuterRadius() * 2;
	    },
	    // implements Shape.prototype.getHeight()
	    getHeight: function() {
	      return this.getOuterRadius() * 2;
	    },
	    // implements Shape.prototype.setWidth()
	    setWidth: function(width) {
	      Konva.Node.prototype.setWidth.call(this, width);
	      if (this.getOuterRadius() !== width / 2) {
	        this.setOuterRadius(width / 2);
	      }
	    },
	    // implements Shape.prototype.setHeight()
	    setHeight: function(height) {
	      Konva.Node.prototype.setHeight.call(this, height);
	      if (this.getOuterRadius() !== height / 2) {
	        this.setOuterRadius(height / 2);
	      }
	    }
	  };
	  Konva.Util.extend(Konva.Arc, Konva.Shape);
	
	  // add getters setters
	  Konva.Factory.addGetterSetter(Konva.Arc, 'innerRadius', 0);
	
	  /**
	     * get/set innerRadius
	     * @name innerRadius
	     * @method
	     * @memberof Konva.Arc.prototype
	     * @param {Number} innerRadius
	     * @returns {Number}
	     * @example
	     * // get inner radius
	     * var innerRadius = arc.innerRadius();
	     *
	     * // set inner radius
	     * arc.innerRadius(20);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Arc, 'outerRadius', 0);
	
	  /**
	     * get/set outerRadius
	     * @name outerRadius
	     * @method
	     * @memberof Konva.Arc.prototype
	     * @param {Number} outerRadius
	     * @returns {Number}
	     * @example
	     * // get outer radius
	     * var outerRadius = arc.outerRadius();
	     *
	     * // set outer radius
	     * arc.outerRadius(20);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Arc, 'angle', 0);
	
	  /**
	     * get/set angle in degrees
	     * @name angle
	     * @method
	     * @memberof Konva.Arc.prototype
	     * @param {Number} angle
	     * @returns {Number}
	     * @example
	     * // get angle
	     * var angle = arc.angle();
	     *
	     * // set angle
	     * arc.angle(20);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Arc, 'clockwise', false);
	
	  /**
	     * get/set clockwise flag
	     * @name clockwise
	     * @method
	     * @memberof Konva.Arc.prototype
	     * @param {Boolean} clockwise
	     * @returns {Boolean}
	     * @example
	     * // get clockwise flag
	     * var clockwise = arc.clockwise();
	     *
	     * // draw arc counter-clockwise
	     * arc.clockwise(false);
	     *
	     * // draw arc clockwise
	     * arc.clockwise(true);
	     */
	
	  Konva.Collection.mapMethods(Konva.Arc);
	})(Konva);
	
	(function() {
	  'use strict';
	  // CONSTANTS
	  var IMAGE = 'Image';
	
	  /**
	     * Image constructor
	     * @constructor
	     * @memberof Konva
	     * @augments Konva.Shape
	     * @param {Object} config
	     * @param {Image} config.image
	     * @param {Object} [config.crop]
	     * @param {String} [config.fill] fill color
	     * @param {Image} [config.fillPatternImage] fill pattern image
	     * @param {Number} [config.fillPatternX]
	     * @param {Number} [config.fillPatternY]
	     * @param {Object} [config.fillPatternOffset] object with x and y component
	     * @param {Number} [config.fillPatternOffsetX] 
	     * @param {Number} [config.fillPatternOffsetY] 
	     * @param {Object} [config.fillPatternScale] object with x and y component
	     * @param {Number} [config.fillPatternScaleX]
	     * @param {Number} [config.fillPatternScaleY]
	     * @param {Number} [config.fillPatternRotation]
	     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
	     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientStartPointX]
	     * @param {Number} [config.fillLinearGradientStartPointY]
	     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientEndPointX]
	     * @param {Number} [config.fillLinearGradientEndPointY]
	     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
	     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientStartPointX]
	     * @param {Number} [config.fillRadialGradientStartPointY]
	     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientEndPointX] 
	     * @param {Number} [config.fillRadialGradientEndPointY] 
	     * @param {Number} [config.fillRadialGradientStartRadius]
	     * @param {Number} [config.fillRadialGradientEndRadius]
	     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
	     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
	     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
	     * @param {String} [config.stroke] stroke color
	     * @param {Number} [config.strokeWidth] stroke width
	     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
	     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
	     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
	     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
	     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
	     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
	     *  is miter
	     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
	     *  is butt
	     * @param {String} [config.shadowColor]
	     * @param {Number} [config.shadowBlur]
	     * @param {Object} [config.shadowOffset] object with x and y component
	     * @param {Number} [config.shadowOffsetX]
	     * @param {Number} [config.shadowOffsetY]
	     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
	     *  between 0 and 1
	     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
	     * @param {Array} [config.dash]
	     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
	     * @param {Number} [config.x]
	     * @param {Number} [config.y]
	     * @param {Number} [config.width]
	     * @param {Number} [config.height]
	     * @param {Boolean} [config.visible]
	     * @param {Boolean} [config.listening] whether or not the node is listening for events
	     * @param {String} [config.id] unique id
	     * @param {String} [config.name] non-unique name
	     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
	     * @param {Object} [config.scale] set scale
	     * @param {Number} [config.scaleX] set scale x
	     * @param {Number} [config.scaleY] set scale y
	     * @param {Number} [config.rotation] rotation in degrees
	     * @param {Object} [config.offset] offset from center point and rotation point
	     * @param {Number} [config.offsetX] set offset x
	     * @param {Number} [config.offsetY] set offset y
	     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
	     *  the entire stage by dragging any portion of the stage
	     * @param {Number} [config.dragDistance]
	     * @param {Function} [config.dragBoundFunc]
	     * @example
	     * var imageObj = new Image();
	     * imageObj.onload = function() {
	     *   var image = new Konva.Image({
	     *     x: 200,
	     *     y: 50,
	     *     image: imageObj,
	     *     width: 100,
	     *     height: 100
	     *   });
	     * };
	     * imageObj.src = '/path/to/image.jpg'
	     */
	  Konva.Image = function(config) {
	    this.___init(config);
	  };
	
	  Konva.Image.prototype = {
	    ___init: function(config) {
	      // call super constructor
	      Konva.Shape.call(this, config);
	      this.className = IMAGE;
	      this.sceneFunc(this._sceneFunc);
	      this.hitFunc(this._hitFunc);
	    },
	    _useBufferCanvas: function() {
	      return (
	        (this.hasShadow() || this.getAbsoluteOpacity() !== 1) &&
	        this.hasStroke() &&
	        this.getStage()
	      );
	    },
	    _sceneFunc: function(context) {
	      var width = this.getWidth(),
	        height = this.getHeight(),
	        image = this.getImage(),
	        cropWidth,
	        cropHeight,
	        params;
	
	      if (image) {
	        cropWidth = this.getCropWidth();
	        cropHeight = this.getCropHeight();
	        if (cropWidth && cropHeight) {
	          params = [
	            image,
	            this.getCropX(),
	            this.getCropY(),
	            cropWidth,
	            cropHeight,
	            0,
	            0,
	            width,
	            height
	          ];
	        } else {
	          params = [image, 0, 0, width, height];
	        }
	      }
	
	      if (this.hasFill() || this.hasStroke()) {
	        context.beginPath();
	        context.rect(0, 0, width, height);
	        context.closePath();
	        context.fillStrokeShape(this);
	      }
	
	      if (image) {
	        context.drawImage.apply(context, params);
	      }
	    },
	    _hitFunc: function(context) {
	      var width = this.getWidth(), height = this.getHeight();
	
	      context.beginPath();
	      context.rect(0, 0, width, height);
	      context.closePath();
	      context.fillStrokeShape(this);
	    },
	    getWidth: function() {
	      var image = this.getImage();
	      return this.attrs.width || (image ? image.width : 0);
	    },
	    getHeight: function() {
	      var image = this.getImage();
	      return this.attrs.height || (image ? image.height : 0);
	    }
	  };
	  Konva.Util.extend(Konva.Image, Konva.Shape);
	
	  // add getters setters
	  Konva.Factory.addGetterSetter(Konva.Image, 'image');
	
	  /**
	     * set image
	     * @name setImage
	     * @method
	     * @memberof Konva.Image.prototype
	     * @param {Image} image
	     */
	
	  /**
	     * get image
	     * @name getImage
	     * @method
	     * @memberof Konva.Image.prototype
	     * @returns {Image}
	     */
	
	  Konva.Factory.addComponentsGetterSetter(Konva.Image, 'crop', [
	    'x',
	    'y',
	    'width',
	    'height'
	  ]);
	  /**
	     * get/set crop
	     * @method
	     * @name crop
	     * @memberof Konva.Image.prototype
	     * @param {Object} crop
	     * @param {Number} crop.x
	     * @param {Number} crop.y
	     * @param {Number} crop.width
	     * @param {Number} crop.height
	     * @returns {Object}
	     * @example
	     * // get crop
	     * var crop = image.crop();
	     *
	     * // set crop
	     * image.crop({
	     *   x: 20,
	     *   y: 20,
	     *   width: 20,
	     *   height: 20
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Image, 'cropX', 0);
	  /**
	     * get/set crop x
	     * @method
	     * @name cropX
	     * @memberof Konva.Image.prototype
	     * @param {Number} x
	     * @returns {Number}
	     * @example
	     * // get crop x
	     * var cropX = image.cropX();
	     *
	     * // set crop x
	     * image.cropX(20);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Image, 'cropY', 0);
	  /**
	     * get/set crop y
	     * @name cropY
	     * @method
	     * @memberof Konva.Image.prototype
	     * @param {Number} y
	     * @returns {Number}
	     * @example
	     * // get crop y
	     * var cropY = image.cropY();
	     *
	     * // set crop y
	     * image.cropY(20);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Image, 'cropWidth', 0);
	  /**
	     * get/set crop width
	     * @name cropWidth
	     * @method
	     * @memberof Konva.Image.prototype
	     * @param {Number} width
	     * @returns {Number}
	     * @example
	     * // get crop width
	     * var cropWidth = image.cropWidth();
	     *
	     * // set crop width
	     * image.cropWidth(20);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Image, 'cropHeight', 0);
	  /**
	     * get/set crop height
	     * @name cropHeight
	     * @method
	     * @memberof Konva.Image.prototype
	     * @param {Number} height
	     * @returns {Number}
	     * @example
	     * // get crop height
	     * var cropHeight = image.cropHeight();
	     *
	     * // set crop height
	     * image.cropHeight(20);
	     */
	
	  Konva.Collection.mapMethods(Konva.Image);
	
	  /**
	     * load image from given url and create `Konva.Image` instance
	     * @method
	     * @memberof Konva.Image
	     * @param {String} url image source
	     * @param {Function} callback with Konva.Image instance as first argument
	     * @example
	     *  Konva.Image.fromURL(imageURL, function(image){
	     *    // image is Konva.Image instance
	     *    layer.add(image);
	     *    layer.draw();
	     *  });
	     */
	  Konva.Image.fromURL = function(url, callback) {
	    var img = new Image();
	    img.onload = function() {
	      var image = new Konva.Image({
	        image: img
	      });
	      callback(image);
	    };
	    img.src = url;
	  };
	})();
	
	/*eslint-disable max-depth */
	(function() {
	  'use strict';
	  // var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
	  // constants
	  var AUTO = 'auto',
	    //CANVAS = 'canvas',
	    CENTER = 'center',
	    JUSTIFY = 'justify',
	    CHANGE_KONVA = 'Change.konva',
	    CONTEXT_2D = '2d',
	    DASH = '-',
	    EMPTY_STRING = '',
	    LEFT = 'left',
	    TEXT = 'text',
	    TEXT_UPPER = 'Text',
	    MIDDLE = 'middle',
	    NORMAL = 'normal',
	    PX_SPACE = 'px ',
	    SPACE = ' ',
	    RIGHT = 'right',
	    WORD = 'word',
	    CHAR = 'char',
	    NONE = 'none',
	    ATTR_CHANGE_LIST = [
	      'fontFamily',
	      'fontSize',
	      'fontStyle',
	      'fontVariant',
	      'padding',
	      'align',
	      'lineHeight',
	      'text',
	      'width',
	      'height',
	      'wrap',
	      'letterSpacing'
	    ],
	    // cached variables
	    attrChangeListLen = ATTR_CHANGE_LIST.length;
	  var dummyContext;
	  function getDummyContext() {
	    if (dummyContext) {
	      return dummyContext;
	    }
	    dummyContext = Konva.Util.createCanvasElement().getContext(CONTEXT_2D);
	    return dummyContext;
	  }
	
	  /**
	     * Text constructor
	     * @constructor
	     * @memberof Konva
	     * @augments Konva.Shape
	     * @param {Object} config
	     * @param {String} [config.fontFamily] default is Arial
	     * @param {Number} [config.fontSize] in pixels.  Default is 12
	     * @param {String} [config.fontStyle] can be normal, bold, or italic.  Default is normal
	     * @param {String} [config.fontVariant] can be normal or small-caps.  Default is normal
	     * @param {String} config.text
	     * @param {String} [config.align] can be left, center, or right
	     * @param {Number} [config.padding]
	     * @param {Number} [config.lineHeight] default is 1
	     * @param {String} [config.wrap] can be word, char, or none. Default is word
	     * @param {String} [config.fill] fill color
	     * @param {Image} [config.fillPatternImage] fill pattern image
	     * @param {Number} [config.fillPatternX]
	     * @param {Number} [config.fillPatternY]
	     * @param {Object} [config.fillPatternOffset] object with x and y component
	     * @param {Number} [config.fillPatternOffsetX] 
	     * @param {Number} [config.fillPatternOffsetY] 
	     * @param {Object} [config.fillPatternScale] object with x and y component
	     * @param {Number} [config.fillPatternScaleX]
	     * @param {Number} [config.fillPatternScaleY]
	     * @param {Number} [config.fillPatternRotation]
	     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
	     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientStartPointX]
	     * @param {Number} [config.fillLinearGradientStartPointY]
	     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientEndPointX]
	     * @param {Number} [config.fillLinearGradientEndPointY]
	     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
	     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientStartPointX]
	     * @param {Number} [config.fillRadialGradientStartPointY]
	     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientEndPointX] 
	     * @param {Number} [config.fillRadialGradientEndPointY] 
	     * @param {Number} [config.fillRadialGradientStartRadius]
	     * @param {Number} [config.fillRadialGradientEndRadius]
	     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
	     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
	     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
	     * @param {String} [config.stroke] stroke color
	     * @param {Number} [config.strokeWidth] stroke width
	     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
	     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
	     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
	     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
	     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
	     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
	     *  is miter
	     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
	     *  is butt
	     * @param {String} [config.shadowColor]
	     * @param {Number} [config.shadowBlur]
	     * @param {Object} [config.shadowOffset] object with x and y component
	     * @param {Number} [config.shadowOffsetX]
	     * @param {Number} [config.shadowOffsetY]
	     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
	     *  between 0 and 1
	     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
	     * @param {Array} [config.dash]
	     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
	     * @param {Number} [config.x]
	     * @param {Number} [config.y]
	     * @param {Number} [config.width]
	     * @param {Number} [config.height]
	     * @param {Boolean} [config.visible]
	     * @param {Boolean} [config.listening] whether or not the node is listening for events
	     * @param {String} [config.id] unique id
	     * @param {String} [config.name] non-unique name
	     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
	     * @param {Object} [config.scale] set scale
	     * @param {Number} [config.scaleX] set scale x
	     * @param {Number} [config.scaleY] set scale y
	     * @param {Number} [config.rotation] rotation in degrees
	     * @param {Object} [config.offset] offset from center point and rotation point
	     * @param {Number} [config.offsetX] set offset x
	     * @param {Number} [config.offsetY] set offset y
	     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
	     *  the entire stage by dragging any portion of the stage
	     * @param {Number} [config.dragDistance]
	     * @param {Function} [config.dragBoundFunc]
	     * @example
	     * var text = new Konva.Text({
	     *   x: 10,
	     *   y: 15,
	     *   text: 'Simple Text',
	     *   fontSize: 30,
	     *   fontFamily: 'Calibri',
	     *   fill: 'green'
	     * });
	     */
	  Konva.Text = function(config) {
	    this.___init(config);
	  };
	  function _fillFunc(context) {
	    context.fillText(this.partialText, 0, 0);
	  }
	  function _strokeFunc(context) {
	    context.strokeText(this.partialText, 0, 0);
	  }
	
	  Konva.Text.prototype = {
	    ___init: function(config) {
	      config = config || {};
	
	      // set default color to black
	      if (
	        !config.fillLinearGradientColorStops &&
	        !config.fillRadialGradientColorStops
	      ) {
	        config.fill = config.fill || 'black';
	      }
	      //
	      // if (config.width === undefined) {
	      //     config.width = AUTO;
	      // }
	      // if (config.height === undefined) {
	      //     config.height = AUTO;
	      // }
	
	      // call super constructor
	      Konva.Shape.call(this, config);
	
	      this._fillFunc = _fillFunc;
	      this._strokeFunc = _strokeFunc;
	      this.className = TEXT_UPPER;
	
	      // update text data for certain attr changes
	      for (var n = 0; n < attrChangeListLen; n++) {
	        this.on(ATTR_CHANGE_LIST[n] + CHANGE_KONVA, this._setTextData);
	      }
	
	      this._setTextData();
	      this.sceneFunc(this._sceneFunc);
	      this.hitFunc(this._hitFunc);
	    },
	    _sceneFunc: function(context) {
	      var p = this.getPadding(),
	        textHeight = this.getTextHeight(),
	        lineHeightPx = this.getLineHeight() * textHeight,
	        textArr = this.textArr,
	        textArrLen = textArr.length,
	        align = this.getAlign(),
	        totalWidth = this.getWidth(),
	        letterSpacing = this.getLetterSpacing(),
	        textDecoration = this.textDecoration(),
	        fill = this.fill(),
	        fontSize = this.fontSize(),
	        n;
	
	      context.setAttr('font', this._getContextFont());
	
	      context.setAttr('textBaseline', MIDDLE);
	      context.setAttr('textAlign', LEFT);
	      context.save();
	      if (p) {
	        context.translate(p, 0);
	        context.translate(0, p + textHeight / 2);
	      } else {
	        context.translate(0, textHeight / 2);
	      }
	
	      // draw text lines
	      for (n = 0; n < textArrLen; n++) {
	        var obj = textArr[n],
	          text = obj.text,
	          width = obj.width;
	
	        // horizontal alignment
	        context.save();
	        if (align === RIGHT) {
	          context.translate(totalWidth - width - p * 2, 0);
	        } else if (align === CENTER) {
	          context.translate((totalWidth - width - p * 2) / 2, 0);
	        }
	
	        if (textDecoration.indexOf('underline') !== -1) {
	          context.save();
	          context.beginPath();
	          context.moveTo(0, Math.round(lineHeightPx / 2));
	          context.lineTo(Math.round(width), Math.round(lineHeightPx / 2));
	          // TODO: I have no idea what is real ratio
	          // just /20 looks good enough
	          context.lineWidth = fontSize / 15;
	          context.strokeStyle = fill;
	          context.stroke();
	          context.restore();
	        }
	        if (textDecoration.indexOf('line-through') !== -1) {
	          context.save();
	          context.beginPath();
	          context.moveTo(0, 0);
	          context.lineTo(Math.round(width), 0);
	          context.lineWidth = fontSize / 15;
	          context.strokeStyle = fill;
	          context.stroke();
	          context.restore();
	        }
	        if (letterSpacing !== 0 || align === JUSTIFY) {
	          //   var words = text.split(' ');
	          var spacesNumber = text.split(' ').length - 1;
	          for (var li = 0; li < text.length; li++) {
	            var letter = text[li];
	            // skip justify for the last line
	            if (letter === ' ' && n !== textArrLen - 1 && align === JUSTIFY) {
	              context.translate(
	                Math.floor((totalWidth - width) / spacesNumber),
	                0
	              );
	            }
	            this.partialText = letter;
	            context.fillStrokeShape(this);
	            context.translate(
	              Math.round(this._getTextSize(letter).width) + letterSpacing,
	              0
	            );
	          }
	        } else {
	          this.partialText = text;
	
	          context.fillStrokeShape(this);
	        }
	        context.restore();
	        context.translate(0, lineHeightPx);
	      }
	      context.restore();
	    },
	    _hitFunc: function(context) {
	      var width = this.getWidth(),
	        height = this.getHeight();
	
	      context.beginPath();
	      context.rect(0, 0, width, height);
	      context.closePath();
	      context.fillStrokeShape(this);
	    },
	    // _useBufferCanvas: function(caching) {
	    //     var useIt = Konva.Shape.prototype._useBufferCanvas.call(this, caching);
	    //     if (useIt) {
	    //       return true;
	    //     }
	    //     return false;
	    //     // return isFirefox && this.hasFill() && this.hasShadow();
	    // },
	    setText: function(text) {
	      var str = Konva.Util._isString(text) ? text : (text || '').toString();
	      this._setAttr(TEXT, str);
	      return this;
	    },
	    /**
	         * get width of text area, which includes padding
	         * @method
	         * @memberof Konva.Text.prototype
	         * @returns {Number}
	         */
	    getWidth: function() {
	      var isAuto = this.attrs.width === AUTO || this.attrs.width === undefined;
	      return isAuto
	        ? this.getTextWidth() + this.getPadding() * 2
	        : this.attrs.width;
	    },
	    /**
	         * get the height of the text area, which takes into account multi-line text, line heights, and padding
	         * @method
	         * @memberof Konva.Text.prototype
	         * @returns {Number}
	         */
	    getHeight: function() {
	      var isAuto =
	        this.attrs.height === AUTO || this.attrs.height === undefined;
	      return isAuto
	        ? this.getTextHeight() * this.textArr.length * this.getLineHeight() +
	          this.getPadding() * 2
	        : this.attrs.height;
	    },
	    /**
	         * get text width
	         * @method
	         * @memberof Konva.Text.prototype
	         * @returns {Number}
	         */
	    getTextWidth: function() {
	      return this.textWidth;
	    },
	    /**
	         * get text height
	         * @method
	         * @memberof Konva.Text.prototype
	         * @returns {Number}
	         */
	    getTextHeight: function() {
	      return this.textHeight;
	    },
	    _getTextSize: function(text) {
	      var _context = getDummyContext(),
	        fontSize = this.getFontSize(),
	        metrics;
	
	      _context.save();
	      _context.font = this._getContextFont();
	
	      metrics = _context.measureText(text);
	      _context.restore();
	      return {
	        width: metrics.width,
	        height: parseInt(fontSize, 10)
	      };
	    },
	    _getContextFont: function() {
	      // IE don't want to work with usual font style
	      // bold was not working
	      // removing font variant will solve
	      // fix for: https://github.com/konvajs/konva/issues/94
	      if (Konva.UA.isIE) {
	        return (
	          this.getFontStyle() +
	          SPACE +
	          this.getFontSize() +
	          PX_SPACE +
	          this.getFontFamily()
	        );
	      }
	      return (
	        this.getFontStyle() +
	        SPACE +
	        this.getFontVariant() +
	        SPACE +
	        this.getFontSize() +
	        PX_SPACE +
	        this.getFontFamily()
	      );
	    },
	    _addTextLine: function(line) {
	      if (this.align() === JUSTIFY) {
	        line = line.trim();
	      }
	      var width = this._getTextWidth(line);
	      return this.textArr.push({ text: line, width: width });
	    },
	    _getTextWidth: function(text) {
	      var latterSpacing = this.getLetterSpacing();
	      var length = text.length;
	      return (
	        getDummyContext().measureText(text).width +
	        (length ? latterSpacing * (length - 1) : 0)
	      );
	    },
	    _setTextData: function() {
	      var lines = this.getText().split('\n'),
	        fontSize = +this.getFontSize(),
	        textWidth = 0,
	        lineHeightPx = this.getLineHeight() * fontSize,
	        width = this.attrs.width,
	        height = this.attrs.height,
	        fixedWidth = width !== AUTO,
	        fixedHeight = height !== AUTO,
	        padding = this.getPadding(),
	        maxWidth = width - padding * 2,
	        maxHeightPx = height - padding * 2,
	        currentHeightPx = 0,
	        wrap = this.getWrap(),
	        shouldWrap = wrap !== NONE,
	        wrapAtWord = wrap !== CHAR && shouldWrap;
	
	      this.textArr = [];
	      getDummyContext().save();
	      getDummyContext().font = this._getContextFont();
	      for (var i = 0, max = lines.length; i < max; ++i) {
	        var line = lines[i];
	
	        var lineWidth = this._getTextWidth(line);
	        if (fixedWidth && lineWidth > maxWidth) {
	          /*
	                     * if width is fixed and line does not fit entirely
	                     * break the line into multiple fitting lines
	                     */
	          while (line.length > 0) {
	            /*
	                         * use binary search to find the longest substring that
	                         * that would fit in the specified width
	                         */
	            var low = 0,
	              high = line.length,
	              match = '',
	              matchWidth = 0;
	            while (low < high) {
	              var mid = (low + high) >>> 1,
	                substr = line.slice(0, mid + 1),
	                substrWidth = this._getTextWidth(substr);
	              if (substrWidth <= maxWidth) {
	                low = mid + 1;
	                match = substr;
	                matchWidth = substrWidth;
	              } else {
	                high = mid;
	              }
	            }
	            /*
	                         * 'low' is now the index of the substring end
	                         * 'match' is the substring
	                         * 'matchWidth' is the substring width in px
	                         */
	            if (match) {
	              // a fitting substring was found
	              if (wrapAtWord) {
	                // try to find a space or dash where wrapping could be done
	                var wrapIndex =
	                  Math.max(match.lastIndexOf(SPACE), match.lastIndexOf(DASH)) +
	                  1;
	                if (wrapIndex > 0) {
	                  // re-cut the substring found at the space/dash position
	                  low = wrapIndex;
	                  match = match.slice(0, low);
	                  matchWidth = this._getTextWidth(match);
	                }
	              }
	              this._addTextLine(match);
	              textWidth = Math.max(textWidth, matchWidth);
	              currentHeightPx += lineHeightPx;
	              if (
	                !shouldWrap ||
	                (fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx)
	              ) {
	                /*
	                                 * stop wrapping if wrapping is disabled or if adding
	                                 * one more line would overflow the fixed height
	                                 */
	                break;
	              }
	              line = line.slice(low);
	              if (line.length > 0) {
	                // Check if the remaining text would fit on one line
	                lineWidth = this._getTextWidth(line);
	                if (lineWidth <= maxWidth) {
	                  // if it does, add the line and break out of the loop
	                  this._addTextLine(line);
	                  currentHeightPx += lineHeightPx;
	                  textWidth = Math.max(textWidth, lineWidth);
	                  break;
	                }
	              }
	            } else {
	              // not even one character could fit in the element, abort
	              break;
	            }
	          }
	        } else {
	          // element width is automatically adjusted to max line width
	          this._addTextLine(line);
	          currentHeightPx += lineHeightPx;
	          textWidth = Math.max(textWidth, lineWidth);
	        }
	        // if element height is fixed, abort if adding one more line would overflow
	        if (fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx) {
	          break;
	        }
	      }
	      getDummyContext().restore();
	      this.textHeight = fontSize;
	      // var maxTextWidth = 0;
	      // for(var j = 0; j < this.textArr.length; j++) {
	      //     maxTextWidth = Math.max(maxTextWidth, this.textArr[j].width);
	      // }
	      this.textWidth = textWidth;
	    }
	  };
	  Konva.Util.extend(Konva.Text, Konva.Shape);
	
	  // add getters setters
	  Konva.Factory.addGetterSetter(Konva.Text, 'fontFamily', 'Arial');
	
	  /**
	     * get/set font family
	     * @name fontFamily
	     * @method
	     * @memberof Konva.Text.prototype
	     * @param {String} fontFamily
	     * @returns {String}
	     * @example
	     * // get font family
	     * var fontFamily = text.fontFamily();
	     *
	     * // set font family
	     * text.fontFamily('Arial');
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Text, 'fontSize', 12);
	
	  /**
	     * get/set font size in pixels
	     * @name fontSize
	     * @method
	     * @memberof Konva.Text.prototype
	     * @param {Number} fontSize
	     * @returns {Number}
	     * @example
	     * // get font size
	     * var fontSize = text.fontSize();
	     *
	     * // set font size to 22px
	     * text.fontSize(22);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Text, 'fontStyle', NORMAL);
	
	  /**
	     * set font style.  Can be 'normal', 'italic', or 'bold'.  'normal' is the default.
	     * @name fontStyle
	     * @method
	     * @memberof Konva.Text.prototype
	     * @param {String} fontStyle
	     * @returns {String}
	     * @example
	     * // get font style
	     * var fontStyle = text.fontStyle();
	     *
	     * // set font style
	     * text.fontStyle('bold');
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Text, 'fontVariant', NORMAL);
	
	  /**
	     * set font variant.  Can be 'normal' or 'small-caps'.  'normal' is the default.
	     * @name fontVariant
	     * @method
	     * @memberof Konva.Text.prototype
	     * @param {String} fontVariant
	     * @returns {String}
	     * @example
	     * // get font variant
	     * var fontVariant = text.fontVariant();
	     *
	     * // set font variant
	     * text.fontVariant('small-caps');
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Text, 'padding', 0);
	
	  /**
	     * set padding
	     * @name padding
	     * @method
	     * @memberof Konva.Text.prototype
	     * @param {Number} padding
	     * @returns {Number}
	     * @example
	     * // get padding
	     * var padding = text.padding();
	     *
	     * // set padding to 10 pixels
	     * text.padding(10);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Text, 'align', LEFT);
	
	  /**
	     * get/set horizontal align of text.  Can be 'left', 'center', 'right' or 'justify'
	     * @name align
	     * @method
	     * @memberof Konva.Text.prototype
	     * @param {String} align
	     * @returns {String}
	     * @example
	     * // get text align
	     * var align = text.align();
	     *
	     * // center text
	     * text.align('center');
	     *
	     * // align text to right
	     * text.align('right');
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Text, 'lineHeight', 1);
	
	  /**
	     * get/set line height.  The default is 1.
	     * @name lineHeight
	     * @method
	     * @memberof Konva.Text.prototype
	     * @param {Number} lineHeight
	     * @returns {Number}
	     * @example
	     * // get line height
	     * var lineHeight = text.lineHeight();
	     *
	     * // set the line height
	     * text.lineHeight(2);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Text, 'wrap', WORD);
	
	  /**
	     * get/set wrap.  Can be word, char, or none. Default is word.
	     * @name wrap
	     * @method
	     * @memberof Konva.Text.prototype
	     * @param {String} wrap
	     * @returns {String}
	     * @example
	     * // get wrap
	     * var wrap = text.wrap();
	     *
	     * // set wrap
	     * text.wrap('word');
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Text, 'letterSpacing', 0);
	
	  /**
	       * set letter spacing property. Default value is 0.
	       * @name letterSpacing
	       * @method
	       * @memberof Konva.TextPath.prototype
	       * @param {Number} letterSpacing
	       */
	
	  Konva.Factory.addGetter(Konva.Text, 'text', EMPTY_STRING);
	  Konva.Factory.addOverloadedGetterSetter(Konva.Text, 'text');
	
	  /**
	     * get/set text
	     * @name getText
	     * @method
	     * @memberof Konva.Text.prototype
	     * @param {String} text
	     * @returns {String}
	     * @example
	     * // get text
	     * var text = text.text();
	     *
	     * // set text
	     * text.text('Hello world!');
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Text, 'textDecoration', EMPTY_STRING);
	
	  /**
	      * get/set text decoration of a text.  Possible values are 'underline', 'line-through' or combination of these values separated by space
	      * @name textDecoration
	      * @method
	      * @memberof Konva.Text.prototype
	      * @param {String} textDecoration
	      * @returns {String}
	      * @example
	      * // get text decoration
	      * var textDecoration = text.textDecoration();
	      *
	      * // underline text
	      * text.textDecoration('underline');
	      *
	      * // strike text
	      * text.textDecoration('line-through');
	      *
	      * // underline and strike text
	      * text.textDecoration('underline line-through');
	      */
	
	  Konva.Collection.mapMethods(Konva.Text);
	})();
	
	(function() {
	  'use strict';
	  /**
	     * Line constructor.&nbsp; Lines are defined by an array of points and
	     *  a tension
	     * @constructor
	     * @memberof Konva
	     * @augments Konva.Shape
	     * @param {Object} config
	     * @param {Array} config.points
	     * @param {Number} [config.tension] Higher values will result in a more curvy line.  A value of 0 will result in no interpolation.
	     *   The default is 0
	     * @param {Boolean} [config.closed] defines whether or not the line shape is closed, creating a polygon or blob
	     * @param {Boolean} [config.bezier] if no tension is provided but bezier=true, we draw the line as a bezier using the passed points
	     * @param {String} [config.fill] fill color
	     * @param {Image} [config.fillPatternImage] fill pattern image
	     * @param {Number} [config.fillPatternX]
	     * @param {Number} [config.fillPatternY]
	     * @param {Object} [config.fillPatternOffset] object with x and y component
	     * @param {Number} [config.fillPatternOffsetX] 
	     * @param {Number} [config.fillPatternOffsetY] 
	     * @param {Object} [config.fillPatternScale] object with x and y component
	     * @param {Number} [config.fillPatternScaleX]
	     * @param {Number} [config.fillPatternScaleY]
	     * @param {Number} [config.fillPatternRotation]
	     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
	     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientStartPointX]
	     * @param {Number} [config.fillLinearGradientStartPointY]
	     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientEndPointX]
	     * @param {Number} [config.fillLinearGradientEndPointY]
	     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
	     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientStartPointX]
	     * @param {Number} [config.fillRadialGradientStartPointY]
	     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientEndPointX] 
	     * @param {Number} [config.fillRadialGradientEndPointY] 
	     * @param {Number} [config.fillRadialGradientStartRadius]
	     * @param {Number} [config.fillRadialGradientEndRadius]
	     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
	     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
	     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
	     * @param {String} [config.stroke] stroke color
	     * @param {Number} [config.strokeWidth] stroke width
	     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
	     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
	     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
	     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
	     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
	     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
	     *  is miter
	     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
	     *  is butt
	     * @param {String} [config.shadowColor]
	     * @param {Number} [config.shadowBlur]
	     * @param {Object} [config.shadowOffset] object with x and y component
	     * @param {Number} [config.shadowOffsetX]
	     * @param {Number} [config.shadowOffsetY]
	     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
	     *  between 0 and 1
	     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
	     * @param {Array} [config.dash]
	     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
	     * @param {Number} [config.x]
	     * @param {Number} [config.y]
	     * @param {Number} [config.width]
	     * @param {Number} [config.height]
	     * @param {Boolean} [config.visible]
	     * @param {Boolean} [config.listening] whether or not the node is listening for events
	     * @param {String} [config.id] unique id
	     * @param {String} [config.name] non-unique name
	     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
	     * @param {Object} [config.scale] set scale
	     * @param {Number} [config.scaleX] set scale x
	     * @param {Number} [config.scaleY] set scale y
	     * @param {Number} [config.rotation] rotation in degrees
	     * @param {Object} [config.offset] offset from center point and rotation point
	     * @param {Number} [config.offsetX] set offset x
	     * @param {Number} [config.offsetY] set offset y
	     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
	     *  the entire stage by dragging any portion of the stage
	     * @param {Number} [config.dragDistance]
	     * @param {Function} [config.dragBoundFunc]
	     * @example
	     * var line = new Konva.Line({
	     *   x: 100,
	     *   y: 50,
	     *   points: [73, 70, 340, 23, 450, 60, 500, 20],
	     *   stroke: 'red',
	     *   tension: 1
	     * });
	     */
	  Konva.Line = function(config) {
	    this.___init(config);
	  };
	
	  Konva.Line.prototype = {
	    ___init: function(config) {
	      // call super constructor
	      Konva.Shape.call(this, config);
	      this.className = 'Line';
	
	      this.on(
	        'pointsChange.konva tensionChange.konva closedChange.konva bezierChange.konva',
	        function() {
	          this._clearCache('tensionPoints');
	        }
	      );
	
	      this.sceneFunc(this._sceneFunc);
	    },
	    _sceneFunc: function(context) {
	      var points = this.getPoints(),
	        length = points.length,
	        tension = this.getTension(),
	        closed = this.getClosed(),
	        bezier = this.getBezier(),
	        tp,
	        len,
	        n;
	
	      if (!length) {
	        return;
	      }
	
	      context.beginPath();
	      context.moveTo(points[0], points[1]);
	
	      // tension
	      if (tension !== 0 && length > 4) {
	        tp = this.getTensionPoints();
	        len = tp.length;
	        n = closed ? 0 : 4;
	
	        if (!closed) {
	          context.quadraticCurveTo(tp[0], tp[1], tp[2], tp[3]);
	        }
	
	        while (n < len - 2) {
	          context.bezierCurveTo(
	            tp[n++],
	            tp[n++],
	            tp[n++],
	            tp[n++],
	            tp[n++],
	            tp[n++]
	          );
	        }
	
	        if (!closed) {
	          context.quadraticCurveTo(
	            tp[len - 2],
	            tp[len - 1],
	            points[length - 2],
	            points[length - 1]
	          );
	        }
	      } else if (bezier) {
	        // no tension but bezier
	        n = 2;
	
	        while (n < length) {
	          context.bezierCurveTo(
	            points[n++],
	            points[n++],
	            points[n++],
	            points[n++],
	            points[n++],
	            points[n++]
	          );
	        }
	      } else {
	        // no tension
	        for (n = 2; n < length; n += 2) {
	          context.lineTo(points[n], points[n + 1]);
	        }
	      }
	
	      // closed e.g. polygons and blobs
	      if (closed) {
	        context.closePath();
	        context.fillStrokeShape(this);
	      } else {
	        // open e.g. lines and splines
	        context.strokeShape(this);
	      }
	    },
	    getTensionPoints: function() {
	      return this._getCache('tensionPoints', this._getTensionPoints);
	    },
	    _getTensionPoints: function() {
	      if (this.getClosed()) {
	        return this._getTensionPointsClosed();
	      } else {
	        return Konva.Util._expandPoints(this.getPoints(), this.getTension());
	      }
	    },
	    _getTensionPointsClosed: function() {
	      var p = this.getPoints(),
	        len = p.length,
	        tension = this.getTension(),
	        util = Konva.Util,
	        firstControlPoints = util._getControlPoints(
	          p[len - 2],
	          p[len - 1],
	          p[0],
	          p[1],
	          p[2],
	          p[3],
	          tension
	        ),
	        lastControlPoints = util._getControlPoints(
	          p[len - 4],
	          p[len - 3],
	          p[len - 2],
	          p[len - 1],
	          p[0],
	          p[1],
	          tension
	        ),
	        middle = Konva.Util._expandPoints(p, tension),
	        tp = [firstControlPoints[2], firstControlPoints[3]]
	          .concat(middle)
	          .concat([
	            lastControlPoints[0],
	            lastControlPoints[1],
	            p[len - 2],
	            p[len - 1],
	            lastControlPoints[2],
	            lastControlPoints[3],
	            firstControlPoints[0],
	            firstControlPoints[1],
	            p[0],
	            p[1]
	          ]);
	
	      return tp;
	    },
	    getWidth: function() {
	      return this.getSelfRect().width;
	    },
	    getHeight: function() {
	      return this.getSelfRect().height;
	    },
	    // overload size detection
	    getSelfRect: function() {
	      var points;
	      if (this.getTension() !== 0) {
	        points = this._getTensionPoints();
	      } else {
	        points = this.getPoints();
	      }
	      var minX = points[0];
	      var maxX = points[0];
	      var minY = points[1];
	      var maxY = points[1];
	      var x, y;
	      for (var i = 0; i < points.length / 2; i++) {
	        x = points[i * 2];
	        y = points[i * 2 + 1];
	        minX = Math.min(minX, x);
	        maxX = Math.max(maxX, x);
	        minY = Math.min(minY, y);
	        maxY = Math.max(maxY, y);
	      }
	      return {
	        x: Math.round(minX),
	        y: Math.round(minY),
	        width: Math.round(maxX - minX),
	        height: Math.round(maxY - minY)
	      };
	    }
	  };
	  Konva.Util.extend(Konva.Line, Konva.Shape);
	
	  // add getters setters
	  Konva.Factory.addGetterSetter(Konva.Line, 'closed', false);
	
	  /**
	     * get/set closed flag.  The default is false
	     * @name closed
	     * @method
	     * @memberof Konva.Line.prototype
	     * @param {Boolean} closed
	     * @returns {Boolean}
	     * @example
	     * // get closed flag
	     * var closed = line.closed();
	     *
	     * // close the shape
	     * line.closed(true);
	     *
	     * // open the shape
	     * line.closed(false);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Line, 'bezier', false);
	
	  /**
	    * get/set bezier flag.  The default is false
	    * @name bezier
	    * @method
	    * @memberof Konva.Line.prototype
	    * @param {Boolean} bezier
	    * @returns {Boolean}
	    * @example
	    * // get whether the line is a bezier
	    * var isBezier = line.bezier();
	    *
	    * // set whether the line is a bezier
	    * line.bezier(true);
	    */
	
	  Konva.Factory.addGetterSetter(Konva.Line, 'tension', 0);
	
	  /**
	     * get/set tension
	     * @name tension
	     * @method
	     * @memberof Konva.Line.prototype
	     * @param {Number} Higher values will result in a more curvy line.  A value of 0 will result in no interpolation.
	     *   The default is 0
	     * @returns {Number}
	     * @example
	     * // get tension
	     * var tension = line.tension();
	     *
	     * // set tension
	     * line.tension(3);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Line, 'points', []);
	  /**
	     * get/set points array
	     * @name points
	     * @method
	     * @memberof Konva.Line.prototype
	     * @param {Array} points
	     * @returns {Array}
	     * @example
	     * // get points
	     * var points = line.points();
	     *
	     * // set points
	     * line.points([10, 20, 30, 40, 50, 60]);
	     *
	     * // push a new point
	     * line.points(line.points().concat([70, 80]));
	     */
	
	  Konva.Collection.mapMethods(Konva.Line);
	})();
	
	(function() {
	  'use strict';
	  /**
	     * Sprite constructor
	     * @constructor
	     * @memberof Konva
	     * @augments Konva.Shape
	     * @param {Object} config
	     * @param {String} config.animation animation key
	     * @param {Object} config.animations animation map
	     * @param {Integer} [config.frameIndex] animation frame index
	     * @param {Image} config.image image object
	     * @param {String} [config.fill] fill color
	     * @param {Image} [config.fillPatternImage] fill pattern image
	     * @param {Number} [config.fillPatternX]
	     * @param {Number} [config.fillPatternY]
	     * @param {Object} [config.fillPatternOffset] object with x and y component
	     * @param {Number} [config.fillPatternOffsetX] 
	     * @param {Number} [config.fillPatternOffsetY] 
	     * @param {Object} [config.fillPatternScale] object with x and y component
	     * @param {Number} [config.fillPatternScaleX]
	     * @param {Number} [config.fillPatternScaleY]
	     * @param {Number} [config.fillPatternRotation]
	     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
	     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientStartPointX]
	     * @param {Number} [config.fillLinearGradientStartPointY]
	     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientEndPointX]
	     * @param {Number} [config.fillLinearGradientEndPointY]
	     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
	     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientStartPointX]
	     * @param {Number} [config.fillRadialGradientStartPointY]
	     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientEndPointX] 
	     * @param {Number} [config.fillRadialGradientEndPointY] 
	     * @param {Number} [config.fillRadialGradientStartRadius]
	     * @param {Number} [config.fillRadialGradientEndRadius]
	     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
	     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
	     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
	     * @param {String} [config.stroke] stroke color
	     * @param {Number} [config.strokeWidth] stroke width
	     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
	     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
	     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
	     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
	     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
	     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
	     *  is miter
	     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
	     *  is butt
	     * @param {String} [config.shadowColor]
	     * @param {Number} [config.shadowBlur]
	     * @param {Object} [config.shadowOffset] object with x and y component
	     * @param {Number} [config.shadowOffsetX]
	     * @param {Number} [config.shadowOffsetY]
	     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
	     *  between 0 and 1
	     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
	     * @param {Array} [config.dash]
	     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
	     * @param {Number} [config.x]
	     * @param {Number} [config.y]
	     * @param {Number} [config.width]
	     * @param {Number} [config.height]
	     * @param {Boolean} [config.visible]
	     * @param {Boolean} [config.listening] whether or not the node is listening for events
	     * @param {String} [config.id] unique id
	     * @param {String} [config.name] non-unique name
	     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
	     * @param {Object} [config.scale] set scale
	     * @param {Number} [config.scaleX] set scale x
	     * @param {Number} [config.scaleY] set scale y
	     * @param {Number} [config.rotation] rotation in degrees
	     * @param {Object} [config.offset] offset from center point and rotation point
	     * @param {Number} [config.offsetX] set offset x
	     * @param {Number} [config.offsetY] set offset y
	     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
	     *  the entire stage by dragging any portion of the stage
	     * @param {Number} [config.dragDistance]
	     * @param {Function} [config.dragBoundFunc]
	     * @example
	     * var imageObj = new Image();
	     * imageObj.onload = function() {
	     *   var sprite = new Konva.Sprite({
	     *     x: 200,
	     *     y: 100,
	     *     image: imageObj,
	     *     animation: 'standing',
	     *     animations: {
	     *       standing: [
	     *         // x, y, width, height (6 frames)
	     *         0, 0, 49, 109,
	     *         52, 0, 49, 109,
	     *         105, 0, 49, 109,
	     *         158, 0, 49, 109,
	     *         210, 0, 49, 109,
	     *         262, 0, 49, 109
	     *       ],
	     *       kicking: [
	     *         // x, y, width, height (6 frames)
	     *         0, 109, 45, 98,
	     *         45, 109, 45, 98,
	     *         95, 109, 63, 98,
	     *         156, 109, 70, 98,
	     *         229, 109, 60, 98,
	     *         287, 109, 41, 98
	     *       ]
	     *     },
	     *     frameRate: 7,
	     *     frameIndex: 0
	     *   });
	     * };
	     * imageObj.src = '/path/to/image.jpg'
	     */
	  Konva.Sprite = function(config) {
	    this.___init(config);
	  };
	
	  Konva.Sprite.prototype = {
	    ___init: function(config) {
	      // call super constructor
	      Konva.Shape.call(this, config);
	      this.className = 'Sprite';
	
	      this._updated = true;
	      var that = this;
	      this.anim = new Konva.Animation(function() {
	        // if we don't need to redraw layer we should return false
	        var updated = that._updated;
	        that._updated = false;
	        return updated;
	      });
	      this.on('animationChange.konva', function() {
	        // reset index when animation changes
	        this.frameIndex(0);
	      });
	      this.on('frameIndexChange.konva', function() {
	        this._updated = true;
	      });
	      // smooth change for frameRate
	      this.on('frameRateChange.konva', function() {
	        if (!this.anim.isRunning()) {
	          return;
	        }
	        clearInterval(this.interval);
	        this._setInterval();
	      });
	
	      this.sceneFunc(this._sceneFunc);
	      this.hitFunc(this._hitFunc);
	    },
	    _sceneFunc: function(context) {
	      var anim = this.getAnimation(),
	        index = this.frameIndex(),
	        ix4 = index * 4,
	        set = this.getAnimations()[anim],
	        offsets = this.frameOffsets(),
	        x = set[ix4 + 0],
	        y = set[ix4 + 1],
	        width = set[ix4 + 2],
	        height = set[ix4 + 3],
	        image = this.getImage();
	
	      if (this.hasFill() || this.hasStroke()) {
	        context.beginPath();
	        context.rect(0, 0, width, height);
	        context.closePath();
	        context.fillStrokeShape(this);
	      }
	
	      if (image) {
	        if (offsets) {
	          var offset = offsets[anim], ix2 = index * 2;
	          context.drawImage(
	            image,
	            x,
	            y,
	            width,
	            height,
	            offset[ix2 + 0],
	            offset[ix2 + 1],
	            width,
	            height
	          );
	        } else {
	          context.drawImage(image, x, y, width, height, 0, 0, width, height);
	        }
	      }
	    },
	    _hitFunc: function(context) {
	      var anim = this.getAnimation(),
	        index = this.frameIndex(),
	        ix4 = index * 4,
	        set = this.getAnimations()[anim],
	        offsets = this.frameOffsets(),
	        width = set[ix4 + 2],
	        height = set[ix4 + 3];
	
	      context.beginPath();
	      if (offsets) {
	        var offset = offsets[anim];
	        var ix2 = index * 2;
	        context.rect(offset[ix2 + 0], offset[ix2 + 1], width, height);
	      } else {
	        context.rect(0, 0, width, height);
	      }
	      context.closePath();
	      context.fillShape(this);
	    },
	    _useBufferCanvas: function() {
	      return (
	        (this.hasShadow() || this.getAbsoluteOpacity() !== 1) &&
	        this.hasStroke()
	      );
	    },
	    _setInterval: function() {
	      var that = this;
	      this.interval = setInterval(function() {
	        that._updateIndex();
	      }, 1000 / this.getFrameRate());
	    },
	    /**
	         * start sprite animation
	         * @method
	         * @memberof Konva.Sprite.prototype
	         */
	    start: function() {
	      var layer = this.getLayer();
	
	      /*
	             * animation object has no executable function because
	             *  the updates are done with a fixed FPS with the setInterval
	             *  below.  The anim object only needs the layer reference for
	             *  redraw
	             */
	      this.anim.setLayers(layer);
	      this._setInterval();
	      this.anim.start();
	    },
	    /**
	         * stop sprite animation
	         * @method
	         * @memberof Konva.Sprite.prototype
	         */
	    stop: function() {
	      this.anim.stop();
	      clearInterval(this.interval);
	    },
	    /**
	         * determine if animation of sprite is running or not.  returns true or false
	         * @method
	         * @memberof Konva.Animation.prototype
	         * @returns {Boolean}
	         */
	    isRunning: function() {
	      return this.anim.isRunning();
	    },
	    _updateIndex: function() {
	      var index = this.frameIndex(),
	        animation = this.getAnimation(),
	        animations = this.getAnimations(),
	        anim = animations[animation],
	        len = anim.length / 4;
	
	      if (index < len - 1) {
	        this.frameIndex(index + 1);
	      } else {
	        this.frameIndex(0);
	      }
	    }
	  };
	  Konva.Util.extend(Konva.Sprite, Konva.Shape);
	
	  // add getters setters
	  Konva.Factory.addGetterSetter(Konva.Sprite, 'animation');
	
	  /**
	     * get/set animation key
	     * @name animation
	     * @method
	     * @memberof Konva.Sprite.prototype
	     * @param {String} anim animation key
	     * @returns {String}
	     * @example
	     * // get animation key
	     * var animation = sprite.animation();
	     *
	     * // set animation key
	     * sprite.animation('kicking');
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Sprite, 'animations');
	
	  /**
	     * get/set animations map
	     * @name animations
	     * @method
	     * @memberof Konva.Sprite.prototype
	     * @param {Object} animations
	     * @returns {Object}
	     * @example
	     * // get animations map
	     * var animations = sprite.animations();
	     *
	     * // set animations map
	     * sprite.animations({
	     *   standing: [
	     *     // x, y, width, height (6 frames)
	     *     0, 0, 49, 109,
	     *     52, 0, 49, 109,
	     *     105, 0, 49, 109,
	     *     158, 0, 49, 109,
	     *     210, 0, 49, 109,
	     *     262, 0, 49, 109
	     *   ],
	     *   kicking: [
	     *     // x, y, width, height (6 frames)
	     *     0, 109, 45, 98,
	     *     45, 109, 45, 98,
	     *     95, 109, 63, 98,
	     *     156, 109, 70, 98,
	     *     229, 109, 60, 98,
	     *     287, 109, 41, 98
	     *   ]
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Sprite, 'frameOffsets');
	
	  /**
	    * get/set offsets map
	    * @name offsets
	    * @method
	    * @memberof Konva.Sprite.prototype
	    * @param {Object} offsets
	    * @returns {Object}
	    * @example
	    * // get offsets map
	    * var offsets = sprite.offsets();
	    *
	    * // set offsets map
	    * sprite.offsets({
	    *   standing: [
	    *     // x, y (6 frames)
	    *     0, 0,
	    *     0, 0,
	    *     5, 0,
	    *     0, 0,
	    *     0, 3,
	    *     2, 0
	    *   ],
	    *   kicking: [
	    *     // x, y (6 frames)
	    *     0, 5,
	    *     5, 0,
	    *     10, 0,
	    *     0, 0,
	    *     2, 1,
	    *     0, 0
	    *   ]
	    * });
	    */
	
	  Konva.Factory.addGetterSetter(Konva.Sprite, 'image');
	
	  /**
	     * get/set image
	     * @name image
	     * @method
	     * @memberof Konva.Sprite.prototype
	     * @param {Image} image
	     * @returns {Image}
	     * @example
	     * // get image
	     * var image = sprite.image();
	     *
	     * // set image
	     * sprite.image(imageObj);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Sprite, 'frameIndex', 0);
	
	  /**
	     * set/set animation frame index
	     * @name frameIndex
	     * @method
	     * @memberof Konva.Sprite.prototype
	     * @param {Integer} frameIndex
	     * @returns {Integer}
	     * @example
	     * // get animation frame index
	     * var frameIndex = sprite.frameIndex();
	     *
	     * // set animation frame index
	     * sprite.frameIndex(3);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Sprite, 'frameRate', 17);
	
	  /**
	     * get/set frame rate in frames per second.  Increase this number to make the sprite
	     *  animation run faster, and decrease the number to make the sprite animation run slower
	     *  The default is 17 frames per second
	     * @name frameRate
	     * @method
	     * @memberof Konva.Sprite.prototype
	     * @param {Integer} frameRate
	     * @returns {Integer}
	     * @example
	     * // get frame rate
	     * var frameRate = sprite.frameRate();
	     *
	     * // set frame rate to 2 frames per second
	     * sprite.frameRate(2);
	     */
	
	  Konva.Factory.backCompat(Konva.Sprite, {
	    index: 'frameIndex',
	    getIndex: 'getFrameIndex',
	    setIndex: 'setFrameIndex'
	  });
	
	  Konva.Collection.mapMethods(Konva.Sprite);
	})();
	
	/*eslint-disable  no-shadow, max-len, max-depth */
	(function() {
	  'use strict';
	  /**
	     * Path constructor.
	     * @author Jason Follas
	     * @constructor
	     * @memberof Konva
	     * @augments Konva.Shape
	     * @param {Object} config
	     * @param {String} config.data SVG data string
	     * @param {String} [config.fill] fill color
	     * @param {Image} [config.fillPatternImage] fill pattern image
	     * @param {Number} [config.fillPatternX]
	     * @param {Number} [config.fillPatternY]
	     * @param {Object} [config.fillPatternOffset] object with x and y component
	     * @param {Number} [config.fillPatternOffsetX] 
	     * @param {Number} [config.fillPatternOffsetY] 
	     * @param {Object} [config.fillPatternScale] object with x and y component
	     * @param {Number} [config.fillPatternScaleX]
	     * @param {Number} [config.fillPatternScaleY]
	     * @param {Number} [config.fillPatternRotation]
	     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
	     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientStartPointX]
	     * @param {Number} [config.fillLinearGradientStartPointY]
	     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientEndPointX]
	     * @param {Number} [config.fillLinearGradientEndPointY]
	     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
	     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientStartPointX]
	     * @param {Number} [config.fillRadialGradientStartPointY]
	     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientEndPointX] 
	     * @param {Number} [config.fillRadialGradientEndPointY] 
	     * @param {Number} [config.fillRadialGradientStartRadius]
	     * @param {Number} [config.fillRadialGradientEndRadius]
	     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
	     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
	     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
	     * @param {String} [config.stroke] stroke color
	     * @param {Number} [config.strokeWidth] stroke width
	     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
	     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
	     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
	     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
	     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
	     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
	     *  is miter
	     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
	     *  is butt
	     * @param {String} [config.shadowColor]
	     * @param {Number} [config.shadowBlur]
	     * @param {Object} [config.shadowOffset] object with x and y component
	     * @param {Number} [config.shadowOffsetX]
	     * @param {Number} [config.shadowOffsetY]
	     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
	     *  between 0 and 1
	     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
	     * @param {Array} [config.dash]
	     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
	     * @param {Number} [config.x]
	     * @param {Number} [config.y]
	     * @param {Number} [config.width]
	     * @param {Number} [config.height]
	     * @param {Boolean} [config.visible]
	     * @param {Boolean} [config.listening] whether or not the node is listening for events
	     * @param {String} [config.id] unique id
	     * @param {String} [config.name] non-unique name
	     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
	     * @param {Object} [config.scale] set scale
	     * @param {Number} [config.scaleX] set scale x
	     * @param {Number} [config.scaleY] set scale y
	     * @param {Number} [config.rotation] rotation in degrees
	     * @param {Object} [config.offset] offset from center point and rotation point
	     * @param {Number} [config.offsetX] set offset x
	     * @param {Number} [config.offsetY] set offset y
	     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
	     *  the entire stage by dragging any portion of the stage
	     * @param {Number} [config.dragDistance]
	     * @param {Function} [config.dragBoundFunc]
	     * @example
	     * var path = new Konva.Path({
	     *   x: 240,
	     *   y: 40,
	     *   data: 'M12.582,9.551C3.251,16.237,0.921,29.021,7.08,38.564l-2.36,1.689l4.893,2.262l4.893,2.262l-0.568-5.36l-0.567-5.359l-2.365,1.694c-4.657-7.375-2.83-17.185,4.352-22.33c7.451-5.338,17.817-3.625,23.156,3.824c5.337,7.449,3.625,17.813-3.821,23.152l2.857,3.988c9.617-6.893,11.827-20.277,4.935-29.896C35.591,4.87,22.204,2.658,12.582,9.551z',
	     *   fill: 'green',
	     *   scale: 2
	     * });
	     */
	  Konva.Path = function(config) {
	    this.___init(config);
	  };
	
	  Konva.Path.prototype = {
	    ___init: function(config) {
	      this.dataArray = [];
	      var that = this;
	
	      // call super constructor
	      Konva.Shape.call(this, config);
	      this.className = 'Path';
	
	      this.dataArray = Konva.Path.parsePathData(this.getData());
	      this.on('dataChange.konva', function() {
	        that.dataArray = Konva.Path.parsePathData(this.getData());
	      });
	
	      this.sceneFunc(this._sceneFunc);
	    },
	    _sceneFunc: function(context) {
	      var ca = this.dataArray;
	
	      // context position
	      context.beginPath();
	      for (var n = 0; n < ca.length; n++) {
	        var c = ca[n].command;
	        var p = ca[n].points;
	        switch (c) {
	          case 'L':
	            context.lineTo(p[0], p[1]);
	            break;
	          case 'M':
	            context.moveTo(p[0], p[1]);
	            break;
	          case 'C':
	            context.bezierCurveTo(p[0], p[1], p[2], p[3], p[4], p[5]);
	            break;
	          case 'Q':
	            context.quadraticCurveTo(p[0], p[1], p[2], p[3]);
	            break;
	          case 'A':
	            var cx = p[0],
	              cy = p[1],
	              rx = p[2],
	              ry = p[3],
	              theta = p[4],
	              dTheta = p[5],
	              psi = p[6],
	              fs = p[7];
	
	            var r = rx > ry ? rx : ry;
	            var scaleX = rx > ry ? 1 : rx / ry;
	            var scaleY = rx > ry ? ry / rx : 1;
	
	            context.translate(cx, cy);
	            context.rotate(psi);
	            context.scale(scaleX, scaleY);
	            context.arc(0, 0, r, theta, theta + dTheta, 1 - fs);
	            context.scale(1 / scaleX, 1 / scaleY);
	            context.rotate(-psi);
	            context.translate(-cx, -cy);
	
	            break;
	          case 'z':
	            context.closePath();
	            break;
	        }
	      }
	
	      context.fillStrokeShape(this);
	    },
	    getSelfRect: function() {
	      var points = [];
	      this.dataArray.forEach(function(data) {
	        points = points.concat(data.points);
	      });
	      var minX = points[0];
	      var maxX = points[0];
	      var minY = points[1];
	      var maxY = points[1];
	      var x, y;
	      for (var i = 0; i < points.length / 2; i++) {
	        x = points[i * 2];
	        y = points[i * 2 + 1];
	        minX = Math.min(minX, x);
	        maxX = Math.max(maxX, x);
	        minY = Math.min(minY, y);
	        maxY = Math.max(maxY, y);
	      }
	      return {
	        x: Math.round(minX),
	        y: Math.round(minY),
	        width: Math.round(maxX - minX),
	        height: Math.round(maxY - minY)
	      };
	    }
	  };
	  Konva.Util.extend(Konva.Path, Konva.Shape);
	
	  Konva.Path.getLineLength = function(x1, y1, x2, y2) {
	    return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
	  };
	  Konva.Path.getPointOnLine = function(dist, P1x, P1y, P2x, P2y, fromX, fromY) {
	    if (fromX === undefined) {
	      fromX = P1x;
	    }
	    if (fromY === undefined) {
	      fromY = P1y;
	    }
	
	    var m = (P2y - P1y) / (P2x - P1x + 0.00000001);
	    var run = Math.sqrt(dist * dist / (1 + m * m));
	    if (P2x < P1x) {
	      run *= -1;
	    }
	    var rise = m * run;
	    var pt;
	
	    if (P2x === P1x) {
	      // vertical line
	      pt = {
	        x: fromX,
	        y: fromY + rise
	      };
	    } else if ((fromY - P1y) / (fromX - P1x + 0.00000001) === m) {
	      pt = {
	        x: fromX + run,
	        y: fromY + rise
	      };
	    } else {
	      var ix, iy;
	
	      var len = this.getLineLength(P1x, P1y, P2x, P2y);
	      if (len < 0.00000001) {
	        return undefined;
	      }
	      var u = (fromX - P1x) * (P2x - P1x) + (fromY - P1y) * (P2y - P1y);
	      u = u / (len * len);
	      ix = P1x + u * (P2x - P1x);
	      iy = P1y + u * (P2y - P1y);
	
	      var pRise = this.getLineLength(fromX, fromY, ix, iy);
	      var pRun = Math.sqrt(dist * dist - pRise * pRise);
	      run = Math.sqrt(pRun * pRun / (1 + m * m));
	      if (P2x < P1x) {
	        run *= -1;
	      }
	      rise = m * run;
	      pt = {
	        x: ix + run,
	        y: iy + rise
	      };
	    }
	
	    return pt;
	  };
	
	  Konva.Path.getPointOnCubicBezier = function(
	    pct,
	    P1x,
	    P1y,
	    P2x,
	    P2y,
	    P3x,
	    P3y,
	    P4x,
	    P4y
	  ) {
	    function CB1(t) {
	      return t * t * t;
	    }
	    function CB2(t) {
	      return 3 * t * t * (1 - t);
	    }
	    function CB3(t) {
	      return 3 * t * (1 - t) * (1 - t);
	    }
	    function CB4(t) {
	      return (1 - t) * (1 - t) * (1 - t);
	    }
	    var x = P4x * CB1(pct) + P3x * CB2(pct) + P2x * CB3(pct) + P1x * CB4(pct);
	    var y = P4y * CB1(pct) + P3y * CB2(pct) + P2y * CB3(pct) + P1y * CB4(pct);
	
	    return {
	      x: x,
	      y: y
	    };
	  };
	  Konva.Path.getPointOnQuadraticBezier = function(
	    pct,
	    P1x,
	    P1y,
	    P2x,
	    P2y,
	    P3x,
	    P3y
	  ) {
	    function QB1(t) {
	      return t * t;
	    }
	    function QB2(t) {
	      return 2 * t * (1 - t);
	    }
	    function QB3(t) {
	      return (1 - t) * (1 - t);
	    }
	    var x = P3x * QB1(pct) + P2x * QB2(pct) + P1x * QB3(pct);
	    var y = P3y * QB1(pct) + P2y * QB2(pct) + P1y * QB3(pct);
	
	    return {
	      x: x,
	      y: y
	    };
	  };
	  Konva.Path.getPointOnEllipticalArc = function(cx, cy, rx, ry, theta, psi) {
	    var cosPsi = Math.cos(psi), sinPsi = Math.sin(psi);
	    var pt = {
	      x: rx * Math.cos(theta),
	      y: ry * Math.sin(theta)
	    };
	    return {
	      x: cx + (pt.x * cosPsi - pt.y * sinPsi),
	      y: cy + (pt.x * sinPsi + pt.y * cosPsi)
	    };
	  };
	  /*
	     * get parsed data array from the data
	     *  string.  V, v, H, h, and l data are converted to
	     *  L data for the purpose of high performance Path
	     *  rendering
	     */
	  Konva.Path.parsePathData = function(data) {
	    // Path Data Segment must begin with a moveTo
	    //m (x y)+  Relative moveTo (subsequent points are treated as lineTo)
	    //M (x y)+  Absolute moveTo (subsequent points are treated as lineTo)
	    //l (x y)+  Relative lineTo
	    //L (x y)+  Absolute LineTo
	    //h (x)+    Relative horizontal lineTo
	    //H (x)+    Absolute horizontal lineTo
	    //v (y)+    Relative vertical lineTo
	    //V (y)+    Absolute vertical lineTo
	    //z (closepath)
	    //Z (closepath)
	    //c (x1 y1 x2 y2 x y)+ Relative Bezier curve
	    //C (x1 y1 x2 y2 x y)+ Absolute Bezier curve
	    //q (x1 y1 x y)+       Relative Quadratic Bezier
	    //Q (x1 y1 x y)+       Absolute Quadratic Bezier
	    //t (x y)+    Shorthand/Smooth Relative Quadratic Bezier
	    //T (x y)+    Shorthand/Smooth Absolute Quadratic Bezier
	    //s (x2 y2 x y)+       Shorthand/Smooth Relative Bezier curve
	    //S (x2 y2 x y)+       Shorthand/Smooth Absolute Bezier curve
	    //a (rx ry x-axis-rotation large-arc-flag sweep-flag x y)+     Relative Elliptical Arc
	    //A (rx ry x-axis-rotation large-arc-flag sweep-flag x y)+  Absolute Elliptical Arc
	
	    // return early if data is not defined
	    if (!data) {
	      return [];
	    }
	
	    // command string
	    var cs = data;
	
	    // command chars
	    var cc = [
	      'm',
	      'M',
	      'l',
	      'L',
	      'v',
	      'V',
	      'h',
	      'H',
	      'z',
	      'Z',
	      'c',
	      'C',
	      'q',
	      'Q',
	      't',
	      'T',
	      's',
	      'S',
	      'a',
	      'A'
	    ];
	    // convert white spaces to commas
	    cs = cs.replace(new RegExp(' ', 'g'), ',');
	    // create pipes so that we can split the data
	    for (var n = 0; n < cc.length; n++) {
	      cs = cs.replace(new RegExp(cc[n], 'g'), '|' + cc[n]);
	    }
	    // create array
	    var arr = cs.split('|');
	    var ca = [];
	    // init context point
	    var cpx = 0;
	    var cpy = 0;
	    for (n = 1; n < arr.length; n++) {
	      var str = arr[n];
	      var c = str.charAt(0);
	      str = str.slice(1);
	      // remove ,- for consistency
	      str = str.replace(new RegExp(',-', 'g'), '-');
	      // add commas so that it's easy to split
	      str = str.replace(new RegExp('-', 'g'), ',-');
	      str = str.replace(new RegExp('e,-', 'g'), 'e-');
	      var p = str.split(',');
	      if (p.length > 0 && p[0] === '') {
	        p.shift();
	      }
	      // convert strings to floats
	      for (var i = 0; i < p.length; i++) {
	        p[i] = parseFloat(p[i]);
	      }
	      while (p.length > 0) {
	        if (isNaN(p[0])) {
	          // case for a trailing comma before next command
	          break;
	        }
	
	        var cmd = null;
	        var points = [];
	        var startX = cpx, startY = cpy;
	        // Move var from within the switch to up here (jshint)
	        var prevCmd, ctlPtx, ctlPty; // Ss, Tt
	        var rx, ry, psi, fa, fs, x1, y1; // Aa
	
	        // convert l, H, h, V, and v to L
	        switch (c) {
	          // Note: Keep the lineTo's above the moveTo's in this switch
	          case 'l':
	            cpx += p.shift();
	            cpy += p.shift();
	            cmd = 'L';
	            points.push(cpx, cpy);
	            break;
	          case 'L':
	            cpx = p.shift();
	            cpy = p.shift();
	            points.push(cpx, cpy);
	            break;
	          // Note: lineTo handlers need to be above this point
	          case 'm':
	            var dx = p.shift();
	            var dy = p.shift();
	            cpx += dx;
	            cpy += dy;
	            cmd = 'M';
	            // After closing the path move the current position
	            // to the the first point of the path (if any).
	            if (ca.length > 2 && ca[ca.length - 1].command === 'z') {
	              for (var idx = ca.length - 2; idx >= 0; idx--) {
	                if (ca[idx].command === 'M') {
	                  cpx = ca[idx].points[0] + dx;
	                  cpy = ca[idx].points[1] + dy;
	                  break;
	                }
	              }
	            }
	            points.push(cpx, cpy);
	            c = 'l';
	            // subsequent points are treated as relative lineTo
	            break;
	          case 'M':
	            cpx = p.shift();
	            cpy = p.shift();
	            cmd = 'M';
	            points.push(cpx, cpy);
	            c = 'L';
	            // subsequent points are treated as absolute lineTo
	            break;
	
	          case 'h':
	            cpx += p.shift();
	            cmd = 'L';
	            points.push(cpx, cpy);
	            break;
	          case 'H':
	            cpx = p.shift();
	            cmd = 'L';
	            points.push(cpx, cpy);
	            break;
	          case 'v':
	            cpy += p.shift();
	            cmd = 'L';
	            points.push(cpx, cpy);
	            break;
	          case 'V':
	            cpy = p.shift();
	            cmd = 'L';
	            points.push(cpx, cpy);
	            break;
	          case 'C':
	            points.push(p.shift(), p.shift(), p.shift(), p.shift());
	            cpx = p.shift();
	            cpy = p.shift();
	            points.push(cpx, cpy);
	            break;
	          case 'c':
	            points.push(
	              cpx + p.shift(),
	              cpy + p.shift(),
	              cpx + p.shift(),
	              cpy + p.shift()
	            );
	            cpx += p.shift();
	            cpy += p.shift();
	            cmd = 'C';
	            points.push(cpx, cpy);
	            break;
	          case 'S':
	            ctlPtx = cpx;
	            ctlPty = cpy;
	            prevCmd = ca[ca.length - 1];
	            if (prevCmd.command === 'C') {
	              ctlPtx = cpx + (cpx - prevCmd.points[2]);
	              ctlPty = cpy + (cpy - prevCmd.points[3]);
	            }
	            points.push(ctlPtx, ctlPty, p.shift(), p.shift());
	            cpx = p.shift();
	            cpy = p.shift();
	            cmd = 'C';
	            points.push(cpx, cpy);
	            break;
	          case 's':
	            ctlPtx = cpx;
	            ctlPty = cpy;
	            prevCmd = ca[ca.length - 1];
	            if (prevCmd.command === 'C') {
	              ctlPtx = cpx + (cpx - prevCmd.points[2]);
	              ctlPty = cpy + (cpy - prevCmd.points[3]);
	            }
	            points.push(ctlPtx, ctlPty, cpx + p.shift(), cpy + p.shift());
	            cpx += p.shift();
	            cpy += p.shift();
	            cmd = 'C';
	            points.push(cpx, cpy);
	            break;
	          case 'Q':
	            points.push(p.shift(), p.shift());
	            cpx = p.shift();
	            cpy = p.shift();
	            points.push(cpx, cpy);
	            break;
	          case 'q':
	            points.push(cpx + p.shift(), cpy + p.shift());
	            cpx += p.shift();
	            cpy += p.shift();
	            cmd = 'Q';
	            points.push(cpx, cpy);
	            break;
	          case 'T':
	            ctlPtx = cpx;
	            ctlPty = cpy;
	            prevCmd = ca[ca.length - 1];
	            if (prevCmd.command === 'Q') {
	              ctlPtx = cpx + (cpx - prevCmd.points[0]);
	              ctlPty = cpy + (cpy - prevCmd.points[1]);
	            }
	            cpx = p.shift();
	            cpy = p.shift();
	            cmd = 'Q';
	            points.push(ctlPtx, ctlPty, cpx, cpy);
	            break;
	          case 't':
	            ctlPtx = cpx;
	            ctlPty = cpy;
	            prevCmd = ca[ca.length - 1];
	            if (prevCmd.command === 'Q') {
	              ctlPtx = cpx + (cpx - prevCmd.points[0]);
	              ctlPty = cpy + (cpy - prevCmd.points[1]);
	            }
	            cpx += p.shift();
	            cpy += p.shift();
	            cmd = 'Q';
	            points.push(ctlPtx, ctlPty, cpx, cpy);
	            break;
	          case 'A':
	            rx = p.shift();
	            ry = p.shift();
	            psi = p.shift();
	            fa = p.shift();
	            fs = p.shift();
	            x1 = cpx;
	            y1 = cpy;
	            cpx = p.shift();
	            cpy = p.shift();
	            cmd = 'A';
	            points = this.convertEndpointToCenterParameterization(
	              x1,
	              y1,
	              cpx,
	              cpy,
	              fa,
	              fs,
	              rx,
	              ry,
	              psi
	            );
	            break;
	          case 'a':
	            rx = p.shift();
	            ry = p.shift();
	            psi = p.shift();
	            fa = p.shift();
	            fs = p.shift();
	            x1 = cpx;
	            y1 = cpy;
	            cpx += p.shift();
	            cpy += p.shift();
	            cmd = 'A';
	            points = this.convertEndpointToCenterParameterization(
	              x1,
	              y1,
	              cpx,
	              cpy,
	              fa,
	              fs,
	              rx,
	              ry,
	              psi
	            );
	            break;
	        }
	
	        ca.push({
	          command: cmd || c,
	          points: points,
	          start: {
	            x: startX,
	            y: startY
	          },
	          pathLength: this.calcLength(startX, startY, cmd || c, points)
	        });
	      }
	
	      if (c === 'z' || c === 'Z') {
	        ca.push({
	          command: 'z',
	          points: [],
	          start: undefined,
	          pathLength: 0
	        });
	      }
	    }
	
	    return ca;
	  };
	  Konva.Path.calcLength = function(x, y, cmd, points) {
	    var len, p1, p2, t;
	    var path = Konva.Path;
	
	    switch (cmd) {
	      case 'L':
	        return path.getLineLength(x, y, points[0], points[1]);
	      case 'C':
	        // Approximates by breaking curve into 100 line segments
	        len = 0.0;
	        p1 = path.getPointOnCubicBezier(
	          0,
	          x,
	          y,
	          points[0],
	          points[1],
	          points[2],
	          points[3],
	          points[4],
	          points[5]
	        );
	        for (t = 0.01; t <= 1; t += 0.01) {
	          p2 = path.getPointOnCubicBezier(
	            t,
	            x,
	            y,
	            points[0],
	            points[1],
	            points[2],
	            points[3],
	            points[4],
	            points[5]
	          );
	          len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
	          p1 = p2;
	        }
	        return len;
	      case 'Q':
	        // Approximates by breaking curve into 100 line segments
	        len = 0.0;
	        p1 = path.getPointOnQuadraticBezier(
	          0,
	          x,
	          y,
	          points[0],
	          points[1],
	          points[2],
	          points[3]
	        );
	        for (t = 0.01; t <= 1; t += 0.01) {
	          p2 = path.getPointOnQuadraticBezier(
	            t,
	            x,
	            y,
	            points[0],
	            points[1],
	            points[2],
	            points[3]
	          );
	          len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
	          p1 = p2;
	        }
	        return len;
	      case 'A':
	        // Approximates by breaking curve into line segments
	        len = 0.0;
	        var start = points[4];
	        // 4 = theta
	        var dTheta = points[5];
	        // 5 = dTheta
	        var end = points[4] + dTheta;
	        var inc = Math.PI / 180.0;
	        // 1 degree resolution
	        if (Math.abs(start - end) < inc) {
	          inc = Math.abs(start - end);
	        }
	        // Note: for purpose of calculating arc length, not going to worry about rotating X-axis by angle psi
	        p1 = path.getPointOnEllipticalArc(
	          points[0],
	          points[1],
	          points[2],
	          points[3],
	          start,
	          0
	        );
	        if (dTheta < 0) {
	          // clockwise
	          for (t = start - inc; t > end; t -= inc) {
	            p2 = path.getPointOnEllipticalArc(
	              points[0],
	              points[1],
	              points[2],
	              points[3],
	              t,
	              0
	            );
	            len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
	            p1 = p2;
	          }
	        } else {
	          // counter-clockwise
	          for (t = start + inc; t < end; t += inc) {
	            p2 = path.getPointOnEllipticalArc(
	              points[0],
	              points[1],
	              points[2],
	              points[3],
	              t,
	              0
	            );
	            len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
	            p1 = p2;
	          }
	        }
	        p2 = path.getPointOnEllipticalArc(
	          points[0],
	          points[1],
	          points[2],
	          points[3],
	          end,
	          0
	        );
	        len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
	
	        return len;
	    }
	
	    return 0;
	  };
	  Konva.Path.convertEndpointToCenterParameterization = function(
	    x1,
	    y1,
	    x2,
	    y2,
	    fa,
	    fs,
	    rx,
	    ry,
	    psiDeg
	  ) {
	    // Derived from: http://www.w3.org/TR/SVG/implnote.html#ArcImplementationNotes
	    var psi = psiDeg * (Math.PI / 180.0);
	    var xp = Math.cos(psi) * (x1 - x2) / 2.0 + Math.sin(psi) * (y1 - y2) / 2.0;
	    var yp =
	      -1 * Math.sin(psi) * (x1 - x2) / 2.0 + Math.cos(psi) * (y1 - y2) / 2.0;
	
	    var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
	
	    if (lambda > 1) {
	      rx *= Math.sqrt(lambda);
	      ry *= Math.sqrt(lambda);
	    }
	
	    var f = Math.sqrt(
	      (rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) /
	        (rx * rx * (yp * yp) + ry * ry * (xp * xp))
	    );
	
	    if (fa === fs) {
	      f *= -1;
	    }
	    if (isNaN(f)) {
	      f = 0;
	    }
	
	    var cxp = f * rx * yp / ry;
	    var cyp = f * -ry * xp / rx;
	
	    var cx = (x1 + x2) / 2.0 + Math.cos(psi) * cxp - Math.sin(psi) * cyp;
	    var cy = (y1 + y2) / 2.0 + Math.sin(psi) * cxp + Math.cos(psi) * cyp;
	
	    var vMag = function(v) {
	      return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
	    };
	    var vRatio = function(u, v) {
	      return (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v));
	    };
	    var vAngle = function(u, v) {
	      return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vRatio(u, v));
	    };
	    var theta = vAngle([1, 0], [(xp - cxp) / rx, (yp - cyp) / ry]);
	    var u = [(xp - cxp) / rx, (yp - cyp) / ry];
	    var v = [(-1 * xp - cxp) / rx, (-1 * yp - cyp) / ry];
	    var dTheta = vAngle(u, v);
	
	    if (vRatio(u, v) <= -1) {
	      dTheta = Math.PI;
	    }
	    if (vRatio(u, v) >= 1) {
	      dTheta = 0;
	    }
	    if (fs === 0 && dTheta > 0) {
	      dTheta = dTheta - 2 * Math.PI;
	    }
	    if (fs === 1 && dTheta < 0) {
	      dTheta = dTheta + 2 * Math.PI;
	    }
	    return [cx, cy, rx, ry, theta, dTheta, psi, fs];
	  };
	  // add getters setters
	  Konva.Factory.addGetterSetter(Konva.Path, 'data');
	
	  /**
	     * set SVG path data string.  This method
	     *  also automatically parses the data string
	     *  into a data array.  Currently supported SVG data:
	     *  M, m, L, l, H, h, V, v, Q, q, T, t, C, c, S, s, A, a, Z, z
	     * @name setData
	     * @method
	     * @memberof Konva.Path.prototype
	     * @param {String} SVG path command string
	     */
	
	  /**
	     * get SVG path data string
	     * @name getData
	     * @method
	     * @memberof Konva.Path.prototype
	     */
	
	  Konva.Collection.mapMethods(Konva.Path);
	})();
	
	(function() {
	  'use strict';
	  var EMPTY_STRING = '',
	    //CALIBRI = 'Calibri',
	    NORMAL = 'normal';
	
	  /**
	     * Path constructor.
	     * @author Jason Follas
	     * @constructor
	     * @memberof Konva
	     * @augments Konva.Shape
	     * @param {Object} config
	     * @param {String} [config.fontFamily] default is Calibri
	     * @param {Number} [config.fontSize] default is 12
	     * @param {String} [config.fontStyle] can be normal, bold, or italic.  Default is normal
	     * @param {String} [config.fontVariant] can be normal or small-caps.  Default is normal
	     * @param {String} config.text
	     * @param {String} config.data SVG data string
	     * @param {String} [config.fill] fill color
	     * @param {Image} [config.fillPatternImage] fill pattern image
	     * @param {Number} [config.fillPatternX]
	     * @param {Number} [config.fillPatternY]
	     * @param {Object} [config.fillPatternOffset] object with x and y component
	     * @param {Number} [config.fillPatternOffsetX] 
	     * @param {Number} [config.fillPatternOffsetY] 
	     * @param {Object} [config.fillPatternScale] object with x and y component
	     * @param {Number} [config.fillPatternScaleX]
	     * @param {Number} [config.fillPatternScaleY]
	     * @param {Number} [config.fillPatternRotation]
	     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
	     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientStartPointX]
	     * @param {Number} [config.fillLinearGradientStartPointY]
	     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientEndPointX]
	     * @param {Number} [config.fillLinearGradientEndPointY]
	     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
	     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientStartPointX]
	     * @param {Number} [config.fillRadialGradientStartPointY]
	     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientEndPointX] 
	     * @param {Number} [config.fillRadialGradientEndPointY] 
	     * @param {Number} [config.fillRadialGradientStartRadius]
	     * @param {Number} [config.fillRadialGradientEndRadius]
	     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
	     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
	     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
	     * @param {String} [config.stroke] stroke color
	     * @param {Number} [config.strokeWidth] stroke width
	     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
	     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
	     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
	     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
	     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
	     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
	     *  is miter
	     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
	     *  is butt
	     * @param {String} [config.shadowColor]
	     * @param {Number} [config.shadowBlur]
	     * @param {Object} [config.shadowOffset] object with x and y component
	     * @param {Number} [config.shadowOffsetX]
	     * @param {Number} [config.shadowOffsetY]
	     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
	     *  between 0 and 1
	     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
	     * @param {Array} [config.dash]
	     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
	     * @param {Number} [config.x]
	     * @param {Number} [config.y]
	     * @param {Number} [config.width]
	     * @param {Number} [config.height]
	     * @param {Boolean} [config.visible]
	     * @param {Boolean} [config.listening] whether or not the node is listening for events
	     * @param {String} [config.id] unique id
	     * @param {String} [config.name] non-unique name
	     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
	     * @param {Object} [config.scale] set scale
	     * @param {Number} [config.scaleX] set scale x
	     * @param {Number} [config.scaleY] set scale y
	     * @param {Number} [config.rotation] rotation in degrees
	     * @param {Object} [config.offset] offset from center point and rotation point
	     * @param {Number} [config.offsetX] set offset x
	     * @param {Number} [config.offsetY] set offset y
	     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
	     *  the entire stage by dragging any portion of the stage
	     * @param {Number} [config.dragDistance]
	     * @param {Function} [config.dragBoundFunc]
	     * @example
	     * var textpath = new Konva.TextPath({
	     *   x: 100,
	     *   y: 50,
	     *   fill: '#333',
	     *   fontSize: '24',
	     *   fontFamily: 'Arial',
	     *   text: 'All the world\'s a stage, and all the men and women merely players.',
	     *   data: 'M10,10 C0,0 10,150 100,100 S300,150 400,50'
	     * });
	     */
	  Konva.TextPath = function(config) {
	    this.___init(config);
	  };
	
	  function _fillFunc(context) {
	    context.fillText(this.partialText, 0, 0);
	  }
	  function _strokeFunc(context) {
	    context.strokeText(this.partialText, 0, 0);
	  }
	
	  Konva.TextPath.prototype = {
	    ___init: function(config) {
	      var that = this;
	      this.dummyCanvas = Konva.Util.createCanvasElement();
	      this.dataArray = [];
	
	      // call super constructor
	      Konva.Shape.call(this, config);
	
	      // overrides
	      // TODO: shouldn't this be on the prototype?
	      this._fillFunc = _fillFunc;
	      this._strokeFunc = _strokeFunc;
	      this._fillFuncHit = _fillFunc;
	      this._strokeFuncHit = _strokeFunc;
	
	      this.className = 'TextPath';
	
	      this.dataArray = Konva.Path.parsePathData(this.attrs.data);
	      this.on('dataChange.konva', function() {
	        that.dataArray = Konva.Path.parsePathData(this.attrs.data);
	        that._setTextData();
	      });
	
	      // update text data for certain attr changes
	      this.on(
	        'textChange.konva alignChange.konva letterSpacingChange.konva',
	        that._setTextData
	      );
	      that._setTextData();
	      this.sceneFunc(this._sceneFunc);
	      this.hitFunc(this._hitFunc);
	    },
	    _sceneFunc: function(context) {
	      context.setAttr('font', this._getContextFont());
	      context.setAttr('textBaseline', this.getTextBaseline());
	      context.setAttr('textAlign', 'left');
	      context.save();
	
	      var textDecoration = this.textDecoration();
	      var fill = this.fill();
	      var fontSize = this.fontSize();
	
	      var glyphInfo = this.glyphInfo;
	      if (textDecoration === 'underline') {
	        context.beginPath();
	      }
	      for (var i = 0; i < glyphInfo.length; i++) {
	        context.save();
	
	        var p0 = glyphInfo[i].p0;
	
	        context.translate(p0.x, p0.y);
	        context.rotate(glyphInfo[i].rotation);
	        this.partialText = glyphInfo[i].text;
	
	        context.fillStrokeShape(this);
	        if (textDecoration === 'underline') {
	          if (i === 0) {
	            context.moveTo(0, fontSize / 2 + 1);
	          }
	
	          context.lineTo(fontSize, fontSize / 2 + 1);
	        }
	        context.restore();
	
	        //// To assist with debugging visually, uncomment following
	        //
	        // if (i % 2)
	        // context.strokeStyle = 'cyan';
	        // else
	        // context.strokeStyle = 'green';
	        // var p1 = glyphInfo[i].p1;
	        // context.moveTo(p0.x, p0.y);
	        // context.lineTo(p1.x, p1.y);
	        // context.stroke();
	      }
	      if (textDecoration === 'underline') {
	        context.strokeStyle = fill;
	        context.lineWidth = fontSize / 20;
	        context.stroke();
	      }
	
	      context.restore();
	    },
	    _hitFunc: function(context) {
	      context.beginPath();
	
	      var glyphInfo = this.glyphInfo;
	      if (glyphInfo.length >= 1) {
	        var p0 = glyphInfo[0].p0;
	        context.moveTo(p0.x, p0.y);
	      }
	      for (var i = 0; i < glyphInfo.length; i++) {
	        var p1 = glyphInfo[i].p1;
	        context.lineTo(p1.x, p1.y);
	      }
	      context.setAttr('lineWidth', this.getFontSize());
	      context.setAttr('strokeStyle', this.colorKey);
	      context.stroke();
	    },
	    /**
	         * get text width in pixels
	         * @method
	         * @memberof Konva.TextPath.prototype
	         */
	    getTextWidth: function() {
	      return this.textWidth;
	    },
	    /**
	         * get text height in pixels
	         * @method
	         * @memberof Konva.TextPath.prototype
	         */
	    getTextHeight: function() {
	      return this.textHeight;
	    },
	    /**
	         * set text
	         * @method
	         * @memberof Konva.TextPath.prototype
	         * @param {String} text
	         */
	    setText: function(text) {
	      Konva.Text.prototype.setText.call(this, text);
	    },
	    _getTextSize: function(text) {
	      var dummyCanvas = this.dummyCanvas;
	      var _context = dummyCanvas.getContext('2d');
	
	      _context.save();
	
	      _context.font = this._getContextFont();
	      var metrics = _context.measureText(text);
	
	      _context.restore();
	
	      return {
	        width: metrics.width,
	        height: parseInt(this.attrs.fontSize, 10)
	      };
	    },
	    _setTextData: function() {
	      var that = this;
	      var size = this._getTextSize(this.attrs.text);
	      var letterSpacing = this.getLetterSpacing();
	      var align = this.align();
	
	      this.textWidth = size.width;
	      this.textHeight = size.height;
	
	      var textFullWidth = Math.max(
	        this.textWidth + ((this.attrs.text || '').length - 1) * letterSpacing,
	        0
	      );
	
	      this.glyphInfo = [];
	
	      var fullPathWidth = 0;
	      for (var l = 0; l < that.dataArray.length; l++) {
	        if (that.dataArray[l].pathLength > 0) {
	          fullPathWidth += that.dataArray[l].pathLength;
	        }
	      }
	
	      var offset = 0;
	      if (align === 'center') {
	        offset = Math.max(0, fullPathWidth / 2 - textFullWidth / 2);
	      }
	      if (align === 'right') {
	        offset = Math.max(0, fullPathWidth - textFullWidth);
	      }
	
	      var charArr = this.getText().split('');
	      var spacesNumber = this.getText().split(' ').length - 1;
	
	      var p0, p1, pathCmd;
	
	      var pIndex = -1;
	      var currentT = 0;
	      // var sumLength = 0;
	      // for(var j = 0; j < that.dataArray.length; j++) {
	      //   if(that.dataArray[j].pathLength > 0) {
	      //
	      //     if (sumLength + that.dataArray[j].pathLength > offset) {}
	      //       fullPathWidth += that.dataArray[j].pathLength;
	      //   }
	      // }
	
	      var getNextPathSegment = function() {
	        currentT = 0;
	        var pathData = that.dataArray;
	
	        for (var j = pIndex + 1; j < pathData.length; j++) {
	          if (pathData[j].pathLength > 0) {
	            pIndex = j;
	
	            return pathData[j];
	          } else if (pathData[j].command === 'M') {
	            p0 = {
	              x: pathData[j].points[0],
	              y: pathData[j].points[1]
	            };
	          }
	        }
	
	        return {};
	      };
	
	      var findSegmentToFitCharacter = function(c) {
	        var glyphWidth = that._getTextSize(c).width + letterSpacing;
	
	        if (c === ' ' && align === 'justify') {
	          glyphWidth += (fullPathWidth - textFullWidth) / spacesNumber;
	        }
	
	        var currLen = 0;
	        var attempts = 0;
	
	        p1 = undefined;
	        while (
	          Math.abs(glyphWidth - currLen) / glyphWidth > 0.01 &&
	          attempts < 25
	        ) {
	          attempts++;
	          var cumulativePathLength = currLen;
	          while (pathCmd === undefined) {
	            pathCmd = getNextPathSegment();
	
	            if (
	              pathCmd &&
	              cumulativePathLength + pathCmd.pathLength < glyphWidth
	            ) {
	              cumulativePathLength += pathCmd.pathLength;
	              pathCmd = undefined;
	            }
	          }
	
	          if (pathCmd === {} || p0 === undefined) {
	            return undefined;
	          }
	
	          var needNewSegment = false;
	
	          switch (pathCmd.command) {
	            case 'L':
	              if (
	                Konva.Path.getLineLength(
	                  p0.x,
	                  p0.y,
	                  pathCmd.points[0],
	                  pathCmd.points[1]
	                ) > glyphWidth
	              ) {
	                p1 = Konva.Path.getPointOnLine(
	                  glyphWidth,
	                  p0.x,
	                  p0.y,
	                  pathCmd.points[0],
	                  pathCmd.points[1],
	                  p0.x,
	                  p0.y
	                );
	              } else {
	                pathCmd = undefined;
	              }
	              break;
	            case 'A':
	              var start = pathCmd.points[4];
	              // 4 = theta
	              var dTheta = pathCmd.points[5];
	              // 5 = dTheta
	              var end = pathCmd.points[4] + dTheta;
	
	              if (currentT === 0) {
	                currentT = start + 0.00000001;
	              } else if (glyphWidth > currLen) {
	                // Just in case start is 0
	                currentT += Math.PI / 180.0 * dTheta / Math.abs(dTheta);
	              } else {
	                currentT -= Math.PI / 360.0 * dTheta / Math.abs(dTheta);
	              }
	
	              // Credit for bug fix: @therth https://github.com/ericdrowell/KonvaJS/issues/249
	              // Old code failed to render text along arc of this path: "M 50 50 a 150 50 0 0 1 250 50 l 50 0"
	              if (
	                (dTheta < 0 && currentT < end) ||
	                (dTheta >= 0 && currentT > end)
	              ) {
	                currentT = end;
	                needNewSegment = true;
	              }
	              p1 = Konva.Path.getPointOnEllipticalArc(
	                pathCmd.points[0],
	                pathCmd.points[1],
	                pathCmd.points[2],
	                pathCmd.points[3],
	                currentT,
	                pathCmd.points[6]
	              );
	              break;
	            case 'C':
	              if (currentT === 0) {
	                if (glyphWidth > pathCmd.pathLength) {
	                  currentT = 0.00000001;
	                } else {
	                  currentT = glyphWidth / pathCmd.pathLength;
	                }
	              } else if (glyphWidth > currLen) {
	                currentT += (glyphWidth - currLen) / pathCmd.pathLength;
	              } else {
	                currentT -= (currLen - glyphWidth) / pathCmd.pathLength;
	              }
	
	              if (currentT > 1.0) {
	                currentT = 1.0;
	                needNewSegment = true;
	              }
	              p1 = Konva.Path.getPointOnCubicBezier(
	                currentT,
	                pathCmd.start.x,
	                pathCmd.start.y,
	                pathCmd.points[0],
	                pathCmd.points[1],
	                pathCmd.points[2],
	                pathCmd.points[3],
	                pathCmd.points[4],
	                pathCmd.points[5]
	              );
	              break;
	            case 'Q':
	              if (currentT === 0) {
	                currentT = glyphWidth / pathCmd.pathLength;
	              } else if (glyphWidth > currLen) {
	                currentT += (glyphWidth - currLen) / pathCmd.pathLength;
	              } else {
	                currentT -= (currLen - glyphWidth) / pathCmd.pathLength;
	              }
	
	              if (currentT > 1.0) {
	                currentT = 1.0;
	                needNewSegment = true;
	              }
	              p1 = Konva.Path.getPointOnQuadraticBezier(
	                currentT,
	                pathCmd.start.x,
	                pathCmd.start.y,
	                pathCmd.points[0],
	                pathCmd.points[1],
	                pathCmd.points[2],
	                pathCmd.points[3]
	              );
	              break;
	          }
	
	          if (p1 !== undefined) {
	            currLen = Konva.Path.getLineLength(p0.x, p0.y, p1.x, p1.y);
	          }
	
	          if (needNewSegment) {
	            needNewSegment = false;
	            pathCmd = undefined;
	          }
	        }
	      };
	
	      // fake search for offset, this is very bad approach
	      // TODO: find other way to add offset from start (for align)
	      var testChar = 'C';
	      var glyphWidth = that._getTextSize(testChar).width + letterSpacing;
	      for (var k = 0; k < offset / glyphWidth; k++) {
	        findSegmentToFitCharacter(testChar);
	        if (p0 === undefined || p1 === undefined) {
	          break;
	        }
	        p0 = p1;
	      }
	
	      for (var i = 0; i < charArr.length; i++) {
	        // Find p1 such that line segment between p0 and p1 is approx. width of glyph
	        findSegmentToFitCharacter(charArr[i]);
	
	        if (p0 === undefined || p1 === undefined) {
	          break;
	        }
	
	        var width = Konva.Path.getLineLength(p0.x, p0.y, p1.x, p1.y);
	
	        // Note: Since glyphs are rendered one at a time, any kerning pair data built into the font will not be used.
	        // Can foresee having a rough pair table built in that the developer can override as needed.
	
	        var kern = 0;
	        // placeholder for future implementation
	
	        var midpoint = Konva.Path.getPointOnLine(
	          kern + width / 2.0,
	          p0.x,
	          p0.y,
	          p1.x,
	          p1.y
	        );
	
	        var rotation = Math.atan2(p1.y - p0.y, p1.x - p0.x);
	        this.glyphInfo.push({
	          transposeX: midpoint.x,
	          transposeY: midpoint.y,
	          text: charArr[i],
	          rotation: rotation,
	          p0: p0,
	          p1: p1
	        });
	        p0 = p1;
	      }
	    },
	    getSelfRect: function() {
	      var points = [];
	
	      this.glyphInfo.forEach(function(info) {
	        points.push(info.p0.x);
	        points.push(info.p0.y);
	        points.push(info.p1.x);
	        points.push(info.p1.y);
	      });
	      var minX = points[0];
	      var maxX = points[0];
	      var minY = points[0];
	      var maxY = points[0];
	      var x, y;
	      for (var i = 0; i < points.length / 2; i++) {
	        x = points[i * 2];
	        y = points[i * 2 + 1];
	        minX = Math.min(minX, x);
	        maxX = Math.max(maxX, x);
	        minY = Math.min(minY, y);
	        maxY = Math.max(maxY, y);
	      }
	      var fontSize = this.fontSize();
	      return {
	        x: Math.round(minX) - fontSize / 2,
	        y: Math.round(minY) - fontSize / 2,
	        width: Math.round(maxX - minX) + fontSize,
	        height: Math.round(maxY - minY) + fontSize
	      };
	    }
	  };
	
	  // map TextPath methods to Text
	  Konva.TextPath.prototype._getContextFont =
	    Konva.Text.prototype._getContextFont;
	
	  Konva.Util.extend(Konva.TextPath, Konva.Shape);
	
	  // add setters and getters
	  Konva.Factory.addGetterSetter(Konva.TextPath, 'fontFamily', 'Arial');
	
	  /**
	     * set font family
	     * @name setFontFamily
	     * @method
	     * @memberof Konva.TextPath.prototype
	     * @param {String} fontFamily
	     */
	
	  /**
	     * get font family
	     * @name getFontFamily
	     * @method
	     * @memberof Konva.TextPath.prototype
	     */
	
	  Konva.Factory.addGetterSetter(Konva.TextPath, 'fontSize', 12);
	
	  /**
	     * set font size
	     * @name setFontSize
	     * @method
	     * @memberof Konva.TextPath.prototype
	     * @param {int} fontSize
	     */
	
	  /**
	     * get font size
	     * @name getFontSize
	     * @method
	     * @memberof Konva.TextPath.prototype
	     */
	
	  Konva.Factory.addGetterSetter(Konva.TextPath, 'fontStyle', NORMAL);
	
	  /**
	     * set font style.  Can be 'normal', 'italic', or 'bold'.  'normal' is the default.
	     * @name setFontStyle
	     * @method
	     * @memberof Konva.TextPath.prototype
	     * @param {String} fontStyle
	     */
	  Konva.Factory.addGetterSetter(Konva.TextPath, 'align', 'left');
	
	  /**
	      * get/set horizontal align of text.  Can be 'left', 'center', 'right' or 'justify'
	      * @name align
	      * @method
	      * @memberof Konva.Text.prototype
	      * @param {String} align
	      * @returns {String}
	      * @example
	      * // get text align
	      * var align = text.align();
	      *
	      * // center text
	      * text.align('center');
	      *
	      * // align text to right
	      * text.align('right');
	      */
	
	  Konva.Factory.addGetterSetter(Konva.TextPath, 'letterSpacing', 0);
	
	  /**
	      * set letter spacing property. Default value is 0.
	      * @name letterSpacing
	      * @method
	      * @memberof Konva.TextPath.prototype
	      * @param {Number} letterSpacing
	      */
	
	  Konva.Factory.addGetterSetter(Konva.TextPath, 'textBaseline', 'middle');
	
	  /**
	      * set textBaseline property. Default value is 'middle'.
	      * Can be 'top', 'bottom', 'middle', 'alphabetic', 'hanging'
	      * @name textBaseline
	      * @method
	      * @memberof Konva.TextPath.prototype
	      * @param {Number} textBaseline
	      */
	
	  /**
	     * get font style
	     * @name getFontStyle
	     * @method
	     * @memberof Konva.TextPath.prototype
	     */
	
	  Konva.Factory.addGetterSetter(Konva.TextPath, 'fontVariant', NORMAL);
	
	  /**
	     * set font variant.  Can be 'normal' or 'small-caps'.  'normal' is the default.
	     * @name setFontVariant
	     * @method
	     * @memberof Konva.TextPath.prototype
	     * @param {String} fontVariant
	     */
	
	  /**
	     * @get font variant
	     * @name getFontVariant
	     * @method
	     * @memberof Konva.TextPath.prototype
	     */
	
	  Konva.Factory.addGetter(Konva.TextPath, 'text', EMPTY_STRING);
	
	  /**
	     * get text
	     * @name getText
	     * @method
	     * @memberof Konva.TextPath.prototype
	     */
	
	  Konva.Factory.addGetterSetter(Konva.TextPath, 'textDecoration', null);
	
	  /**
	      * get/set text decoration of a text.  Can be '' or 'underline'
	      * @name textDecoration
	      * @method
	      * @memberof Konva.Text.prototype
	      * @param {String} textDecoration
	      * @returns {String}
	      * @example
	      * // get text decoration
	      * var textDecoration = text.textDecoration();
	      *
	      * // center text
	      * text.textDecoration('underline');
	      */
	
	  Konva.Collection.mapMethods(Konva.TextPath);
	})();
	
	(function() {
	  'use strict';
	  /**
	     * RegularPolygon constructor.&nbsp; Examples include triangles, squares, pentagons, hexagons, etc.
	     * @constructor
	     * @memberof Konva
	     * @augments Konva.Shape
	     * @param {Object} config
	     * @param {Number} config.sides
	     * @param {Number} config.radius
	     * @param {String} [config.fill] fill color
	     * @param {Image} [config.fillPatternImage] fill pattern image
	     * @param {Number} [config.fillPatternX]
	     * @param {Number} [config.fillPatternY]
	     * @param {Object} [config.fillPatternOffset] object with x and y component
	     * @param {Number} [config.fillPatternOffsetX] 
	     * @param {Number} [config.fillPatternOffsetY] 
	     * @param {Object} [config.fillPatternScale] object with x and y component
	     * @param {Number} [config.fillPatternScaleX]
	     * @param {Number} [config.fillPatternScaleY]
	     * @param {Number} [config.fillPatternRotation]
	     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
	     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientStartPointX]
	     * @param {Number} [config.fillLinearGradientStartPointY]
	     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientEndPointX]
	     * @param {Number} [config.fillLinearGradientEndPointY]
	     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
	     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientStartPointX]
	     * @param {Number} [config.fillRadialGradientStartPointY]
	     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientEndPointX] 
	     * @param {Number} [config.fillRadialGradientEndPointY] 
	     * @param {Number} [config.fillRadialGradientStartRadius]
	     * @param {Number} [config.fillRadialGradientEndRadius]
	     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
	     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
	     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
	     * @param {String} [config.stroke] stroke color
	     * @param {Number} [config.strokeWidth] stroke width
	     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
	     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
	     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
	     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
	     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
	     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
	     *  is miter
	     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
	     *  is butt
	     * @param {String} [config.shadowColor]
	     * @param {Number} [config.shadowBlur]
	     * @param {Object} [config.shadowOffset] object with x and y component
	     * @param {Number} [config.shadowOffsetX]
	     * @param {Number} [config.shadowOffsetY]
	     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
	     *  between 0 and 1
	     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
	     * @param {Array} [config.dash]
	     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
	     * @param {Number} [config.x]
	     * @param {Number} [config.y]
	     * @param {Number} [config.width]
	     * @param {Number} [config.height]
	     * @param {Boolean} [config.visible]
	     * @param {Boolean} [config.listening] whether or not the node is listening for events
	     * @param {String} [config.id] unique id
	     * @param {String} [config.name] non-unique name
	     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
	     * @param {Object} [config.scale] set scale
	     * @param {Number} [config.scaleX] set scale x
	     * @param {Number} [config.scaleY] set scale y
	     * @param {Number} [config.rotation] rotation in degrees
	     * @param {Object} [config.offset] offset from center point and rotation point
	     * @param {Number} [config.offsetX] set offset x
	     * @param {Number} [config.offsetY] set offset y
	     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
	     *  the entire stage by dragging any portion of the stage
	     * @param {Number} [config.dragDistance]
	     * @param {Function} [config.dragBoundFunc]
	     * @example
	     * var hexagon = new Konva.RegularPolygon({
	     *   x: 100,
	     *   y: 200,
	     *   sides: 6,
	     *   radius: 70,
	     *   fill: 'red',
	     *   stroke: 'black',
	     *   strokeWidth: 4
	     * });
	     */
	  Konva.RegularPolygon = function(config) {
	    this.___init(config);
	  };
	
	  Konva.RegularPolygon.prototype = {
	    _centroid: true,
	    ___init: function(config) {
	      // call super constructor
	      Konva.Shape.call(this, config);
	      this.className = 'RegularPolygon';
	      this.sceneFunc(this._sceneFunc);
	    },
	    _sceneFunc: function(context) {
	      var sides = this.attrs.sides, radius = this.attrs.radius, n, x, y;
	
	      context.beginPath();
	      context.moveTo(0, 0 - radius);
	
	      for (n = 1; n < sides; n++) {
	        x = radius * Math.sin(n * 2 * Math.PI / sides);
	        y = -1 * radius * Math.cos(n * 2 * Math.PI / sides);
	        context.lineTo(x, y);
	      }
	      context.closePath();
	      context.fillStrokeShape(this);
	    },
	    getWidth: function() {
	      return this.getRadius() * 2;
	    },
	    // implements Shape.prototype.getHeight()
	    getHeight: function() {
	      return this.getRadius() * 2;
	    },
	    // implements Shape.prototype.setWidth()
	    setWidth: function(width) {
	      Konva.Node.prototype.setWidth.call(this, width);
	      if (this.radius() !== width / 2) {
	        this.setRadius(width / 2);
	      }
	    },
	    // implements Shape.prototype.setHeight()
	    setHeight: function(height) {
	      Konva.Node.prototype.setHeight.call(this, height);
	      if (this.radius() !== height / 2) {
	        this.setRadius(height / 2);
	      }
	    }
	  };
	  Konva.Util.extend(Konva.RegularPolygon, Konva.Shape);
	
	  // add getters setters
	  Konva.Factory.addGetterSetter(Konva.RegularPolygon, 'radius', 0);
	
	  /**
	     * set radius
	     * @name setRadius
	     * @method
	     * @memberof Konva.RegularPolygon.prototype
	     * @param {Number} radius
	     */
	
	  /**
	     * get radius
	     * @name getRadius
	     * @method
	     * @memberof Konva.RegularPolygon.prototype
	     */
	
	  Konva.Factory.addGetterSetter(Konva.RegularPolygon, 'sides', 0);
	
	  /**
	     * set number of sides
	     * @name setSides
	     * @method
	     * @memberof Konva.RegularPolygon.prototype
	     * @param {int} sides
	     */
	
	  /**
	     * get number of sides
	     * @name getSides
	     * @method
	     * @memberof Konva.RegularPolygon.prototype
	     */
	
	  Konva.Collection.mapMethods(Konva.RegularPolygon);
	})();
	
	(function() {
	  'use strict';
	  /**
	     * Star constructor
	     * @constructor
	     * @memberof Konva
	     * @augments Konva.Shape
	     * @param {Object} config
	     * @param {Integer} config.numPoints
	     * @param {Number} config.innerRadius
	     * @param {Number} config.outerRadius
	     * @param {String} [config.fill] fill color
	     * @param {Image} [config.fillPatternImage] fill pattern image
	     * @param {Number} [config.fillPatternX]
	     * @param {Number} [config.fillPatternY]
	     * @param {Object} [config.fillPatternOffset] object with x and y component
	     * @param {Number} [config.fillPatternOffsetX] 
	     * @param {Number} [config.fillPatternOffsetY] 
	     * @param {Object} [config.fillPatternScale] object with x and y component
	     * @param {Number} [config.fillPatternScaleX]
	     * @param {Number} [config.fillPatternScaleY]
	     * @param {Number} [config.fillPatternRotation]
	     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
	     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientStartPointX]
	     * @param {Number} [config.fillLinearGradientStartPointY]
	     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientEndPointX]
	     * @param {Number} [config.fillLinearGradientEndPointY]
	     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
	     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientStartPointX]
	     * @param {Number} [config.fillRadialGradientStartPointY]
	     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientEndPointX] 
	     * @param {Number} [config.fillRadialGradientEndPointY] 
	     * @param {Number} [config.fillRadialGradientStartRadius]
	     * @param {Number} [config.fillRadialGradientEndRadius]
	     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
	     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
	     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
	     * @param {String} [config.stroke] stroke color
	     * @param {Number} [config.strokeWidth] stroke width
	     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
	     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
	     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
	     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
	     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
	     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
	     *  is miter
	     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
	     *  is butt
	     * @param {String} [config.shadowColor]
	     * @param {Number} [config.shadowBlur]
	     * @param {Object} [config.shadowOffset] object with x and y component
	     * @param {Number} [config.shadowOffsetX]
	     * @param {Number} [config.shadowOffsetY]
	     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
	     *  between 0 and 1
	     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
	     * @param {Array} [config.dash]
	     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
	     * @param {Number} [config.x]
	     * @param {Number} [config.y]
	     * @param {Number} [config.width]
	     * @param {Number} [config.height]
	     * @param {Boolean} [config.visible]
	     * @param {Boolean} [config.listening] whether or not the node is listening for events
	     * @param {String} [config.id] unique id
	     * @param {String} [config.name] non-unique name
	     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
	     * @param {Object} [config.scale] set scale
	     * @param {Number} [config.scaleX] set scale x
	     * @param {Number} [config.scaleY] set scale y
	     * @param {Number} [config.rotation] rotation in degrees
	     * @param {Object} [config.offset] offset from center point and rotation point
	     * @param {Number} [config.offsetX] set offset x
	     * @param {Number} [config.offsetY] set offset y
	     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
	     *  the entire stage by dragging any portion of the stage
	     * @param {Number} [config.dragDistance]
	     * @param {Function} [config.dragBoundFunc]
	     * @example
	     * var star = new Konva.Star({
	     *   x: 100,
	     *   y: 200,
	     *   numPoints: 5,
	     *   innerRadius: 70,
	     *   outerRadius: 70,
	     *   fill: 'red',
	     *   stroke: 'black',
	     *   strokeWidth: 4
	     * });
	     */
	  Konva.Star = function(config) {
	    this.___init(config);
	  };
	
	  Konva.Star.prototype = {
	    _centroid: true,
	    ___init: function(config) {
	      // call super constructor
	      Konva.Shape.call(this, config);
	      this.className = 'Star';
	      this.sceneFunc(this._sceneFunc);
	    },
	    _sceneFunc: function(context) {
	      var innerRadius = this.innerRadius(),
	        outerRadius = this.outerRadius(),
	        numPoints = this.numPoints();
	
	      context.beginPath();
	      context.moveTo(0, 0 - outerRadius);
	
	      for (var n = 1; n < numPoints * 2; n++) {
	        var radius = n % 2 === 0 ? outerRadius : innerRadius;
	        var x = radius * Math.sin(n * Math.PI / numPoints);
	        var y = -1 * radius * Math.cos(n * Math.PI / numPoints);
	        context.lineTo(x, y);
	      }
	      context.closePath();
	
	      context.fillStrokeShape(this);
	    },
	    // implements Shape.prototype.getWidth()
	    getWidth: function() {
	      return this.getOuterRadius() * 2;
	    },
	    // implements Shape.prototype.getHeight()
	    getHeight: function() {
	      return this.getOuterRadius() * 2;
	    },
	    // implements Shape.prototype.setWidth()
	    setWidth: function(width) {
	      Konva.Node.prototype.setWidth.call(this, width);
	      if (this.outerRadius() !== width / 2) {
	        this.setOuterRadius(width / 2);
	      }
	    },
	    // implements Shape.prototype.setHeight()
	    setHeight: function(height) {
	      Konva.Node.prototype.setHeight.call(this, height);
	      if (this.outerRadius() !== height / 2) {
	        this.setOuterRadius(height / 2);
	      }
	    }
	  };
	  Konva.Util.extend(Konva.Star, Konva.Shape);
	
	  // add getters setters
	  Konva.Factory.addGetterSetter(Konva.Star, 'numPoints', 5);
	
	  /**
	     * set number of points
	     * @name setNumPoints
	     * @method
	     * @memberof Konva.Star.prototype
	     * @param {Integer} points
	     */
	
	  /**
	     * get number of points
	     * @name getNumPoints
	     * @method
	     * @memberof Konva.Star.prototype
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Star, 'innerRadius', 0);
	
	  /**
	     * set inner radius
	     * @name setInnerRadius
	     * @method
	     * @memberof Konva.Star.prototype
	     * @param {Number} radius
	     */
	
	  /**
	     * get inner radius
	     * @name getInnerRadius
	     * @method
	     * @memberof Konva.Star.prototype
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Star, 'outerRadius', 0);
	
	  /**
	     * set outer radius
	     * @name setOuterRadius
	     * @method
	     * @memberof Konva.Star.prototype
	     * @param {Number} radius
	     */
	
	  /**
	     * get outer radius
	     * @name getOuterRadius
	     * @method
	     * @memberof Konva.Star.prototype
	     */
	
	  Konva.Collection.mapMethods(Konva.Star);
	})();
	
	(function() {
	  'use strict';
	  // constants
	  var ATTR_CHANGE_LIST = [
	    'fontFamily',
	    'fontSize',
	    'fontStyle',
	    'padding',
	    'lineHeight',
	    'text',
	    'width'
	  ],
	    CHANGE_KONVA = 'Change.konva',
	    NONE = 'none',
	    UP = 'up',
	    RIGHT = 'right',
	    DOWN = 'down',
	    LEFT = 'left',
	    LABEL = 'Label',
	    // cached variables
	    attrChangeListLen = ATTR_CHANGE_LIST.length;
	
	  /**
	     * Label constructor.&nbsp; Labels are groups that contain a Text and Tag shape
	     * @constructor
	     * @memberof Konva
	     * @param {Object} config
	     * @param {Number} [config.x]
	     * @param {Number} [config.y]
	     * @param {Number} [config.width]
	     * @param {Number} [config.height]
	     * @param {Boolean} [config.visible]
	     * @param {Boolean} [config.listening] whether or not the node is listening for events
	     * @param {String} [config.id] unique id
	     * @param {String} [config.name] non-unique name
	     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
	     * @param {Object} [config.scale] set scale
	     * @param {Number} [config.scaleX] set scale x
	     * @param {Number} [config.scaleY] set scale y
	     * @param {Number} [config.rotation] rotation in degrees
	     * @param {Object} [config.offset] offset from center point and rotation point
	     * @param {Number} [config.offsetX] set offset x
	     * @param {Number} [config.offsetY] set offset y
	     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
	     *  the entire stage by dragging any portion of the stage
	     * @param {Number} [config.dragDistance]
	     * @param {Function} [config.dragBoundFunc]
	     * @example
	     * // create label
	     * var label = new Konva.Label({
	     *   x: 100,
	     *   y: 100,
	     *   draggable: true
	     * });
	     *
	     * // add a tag to the label
	     * label.add(new Konva.Tag({
	     *   fill: '#bbb',
	     *   stroke: '#333',
	     *   shadowColor: 'black',
	     *   shadowBlur: 10,
	     *   shadowOffset: [10, 10],
	     *   shadowOpacity: 0.2,
	     *   lineJoin: 'round',
	     *   pointerDirection: 'up',
	     *   pointerWidth: 20,
	     *   pointerHeight: 20,
	     *   cornerRadius: 5
	     * }));
	     *
	     * // add text to the label
	     * label.add(new Konva.Text({
	     *   text: 'Hello World!',
	     *   fontSize: 50,
	     *   lineHeight: 1.2,
	     *   padding: 10,
	     *   fill: 'green'
	     *  }));
	     */
	  Konva.Label = function(config) {
	    this.____init(config);
	  };
	
	  Konva.Label.prototype = {
	    ____init: function(config) {
	      var that = this;
	
	      Konva.Group.call(this, config);
	      this.className = LABEL;
	
	      this.on('add.konva', function(evt) {
	        that._addListeners(evt.child);
	        that._sync();
	      });
	    },
	    /**
	         * get Text shape for the label.  You need to access the Text shape in order to update
	         * the text properties
	         * @name getText
	         * @method
	         * @memberof Konva.Label.prototype
	         */
	    getText: function() {
	      return this.find('Text')[0];
	    },
	    /**
	         * get Tag shape for the label.  You need to access the Tag shape in order to update
	         * the pointer properties and the corner radius
	         * @name getTag
	         * @method
	         * @memberof Konva.Label.prototype
	         */
	    getTag: function() {
	      return this.find('Tag')[0];
	    },
	    _addListeners: function(text) {
	      var that = this, n;
	      var func = function() {
	        that._sync();
	      };
	
	      // update text data for certain attr changes
	      for (n = 0; n < attrChangeListLen; n++) {
	        text.on(ATTR_CHANGE_LIST[n] + CHANGE_KONVA, func);
	      }
	    },
	    getWidth: function() {
	      return this.getText().getWidth();
	    },
	    getHeight: function() {
	      return this.getText().getHeight();
	    },
	    _sync: function() {
	      var text = this.getText(),
	        tag = this.getTag(),
	        width,
	        height,
	        pointerDirection,
	        pointerWidth,
	        x,
	        y,
	        pointerHeight;
	
	      if (text && tag) {
	        width = text.getWidth();
	        height = text.getHeight();
	        pointerDirection = tag.getPointerDirection();
	        pointerWidth = tag.getPointerWidth();
	        pointerHeight = tag.getPointerHeight();
	        x = 0;
	        y = 0;
	
	        switch (pointerDirection) {
	          case UP:
	            x = width / 2;
	            y = -1 * pointerHeight;
	            break;
	          case RIGHT:
	            x = width + pointerWidth;
	            y = height / 2;
	            break;
	          case DOWN:
	            x = width / 2;
	            y = height + pointerHeight;
	            break;
	          case LEFT:
	            x = -1 * pointerWidth;
	            y = height / 2;
	            break;
	        }
	
	        tag.setAttrs({
	          x: -1 * x,
	          y: -1 * y,
	          width: width,
	          height: height
	        });
	
	        text.setAttrs({
	          x: -1 * x,
	          y: -1 * y
	        });
	      }
	    }
	  };
	
	  Konva.Util.extend(Konva.Label, Konva.Group);
	
	  Konva.Collection.mapMethods(Konva.Label);
	
	  /**
	     * Tag constructor.&nbsp; A Tag can be configured
	     *  to have a pointer element that points up, right, down, or left
	     * @constructor
	     * @memberof Konva
	     * @param {Object} config
	     * @param {String} [config.pointerDirection] can be up, right, down, left, or none; the default
	     *  is none.  When a pointer is present, the positioning of the label is relative to the tip of the pointer.
	     * @param {Number} [config.pointerWidth]
	     * @param {Number} [config.pointerHeight]
	     * @param {Number} [config.cornerRadius]
	     */
	  Konva.Tag = function(config) {
	    this.___init(config);
	  };
	
	  Konva.Tag.prototype = {
	    ___init: function(config) {
	      Konva.Shape.call(this, config);
	      this.className = 'Tag';
	      this.sceneFunc(this._sceneFunc);
	    },
	    _sceneFunc: function(context) {
	      var width = this.getWidth(),
	        height = this.getHeight(),
	        pointerDirection = this.getPointerDirection(),
	        pointerWidth = this.getPointerWidth(),
	        pointerHeight = this.getPointerHeight(),
	        cornerRadius = Math.min(this.getCornerRadius(), width / 2, height / 2);
	
	      context.beginPath();
	      if (!cornerRadius) {
	        context.moveTo(0, 0);
	      } else {
	        context.moveTo(cornerRadius, 0);
	      }
	
	      if (pointerDirection === UP) {
	        context.lineTo((width - pointerWidth) / 2, 0);
	        context.lineTo(width / 2, -1 * pointerHeight);
	        context.lineTo((width + pointerWidth) / 2, 0);
	      }
	
	      if (!cornerRadius) {
	        context.lineTo(width, 0);
	      } else {
	        context.lineTo(width - cornerRadius, 0);
	        context.arc(
	          width - cornerRadius,
	          cornerRadius,
	          cornerRadius,
	          Math.PI * 3 / 2,
	          0,
	          false
	        );
	      }
	
	      if (pointerDirection === RIGHT) {
	        context.lineTo(width, (height - pointerHeight) / 2);
	        context.lineTo(width + pointerWidth, height / 2);
	        context.lineTo(width, (height + pointerHeight) / 2);
	      }
	
	      if (!cornerRadius) {
	        context.lineTo(width, height);
	      } else {
	        context.lineTo(width, height - cornerRadius);
	        context.arc(
	          width - cornerRadius,
	          height - cornerRadius,
	          cornerRadius,
	          0,
	          Math.PI / 2,
	          false
	        );
	      }
	
	      if (pointerDirection === DOWN) {
	        context.lineTo((width + pointerWidth) / 2, height);
	        context.lineTo(width / 2, height + pointerHeight);
	        context.lineTo((width - pointerWidth) / 2, height);
	      }
	
	      if (!cornerRadius) {
	        context.lineTo(0, height);
	      } else {
	        context.lineTo(cornerRadius, height);
	        context.arc(
	          cornerRadius,
	          height - cornerRadius,
	          cornerRadius,
	          Math.PI / 2,
	          Math.PI,
	          false
	        );
	      }
	
	      if (pointerDirection === LEFT) {
	        context.lineTo(0, (height + pointerHeight) / 2);
	        context.lineTo(-1 * pointerWidth, height / 2);
	        context.lineTo(0, (height - pointerHeight) / 2);
	      }
	
	      if (cornerRadius) {
	        context.lineTo(0, cornerRadius);
	        context.arc(
	          cornerRadius,
	          cornerRadius,
	          cornerRadius,
	          Math.PI,
	          Math.PI * 3 / 2,
	          false
	        );
	      }
	
	      context.closePath();
	      context.fillStrokeShape(this);
	    },
	    getSelfRect: function() {
	      var x = 0,
	        y = 0,
	        pointerWidth = this.getPointerWidth(),
	        pointerHeight = this.getPointerHeight(),
	        direction = this.pointerDirection(),
	        width = this.getWidth(),
	        height = this.getHeight();
	
	      if (direction === UP) {
	        y -= pointerHeight;
	        height += pointerHeight;
	      } else if (direction === DOWN) {
	        height += pointerHeight;
	      } else if (direction === LEFT) {
	        // ARGH!!! I have no idea why should I used magic 1.5!!!!!!!!!
	        x -= pointerWidth * 1.5;
	        width += pointerWidth;
	      } else if (direction === RIGHT) {
	        width += pointerWidth * 1.5;
	      }
	      return {
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      };
	    }
	  };
	
	  Konva.Util.extend(Konva.Tag, Konva.Shape);
	  Konva.Factory.addGetterSetter(Konva.Tag, 'pointerDirection', NONE);
	
	  /**
	     * set pointer Direction
	     * @name setPointerDirection
	     * @method
	     * @memberof Konva.Tag.prototype
	     * @param {String} pointerDirection can be up, right, down, left, or none.  The
	     *  default is none
	     */
	
	  /**
	     * get pointer Direction
	     * @name getPointerDirection
	     * @method
	     * @memberof Konva.Tag.prototype
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Tag, 'pointerWidth', 0);
	
	  /**
	     * set pointer width
	     * @name setPointerWidth
	     * @method
	     * @memberof Konva.Tag.prototype
	     * @param {Number} pointerWidth
	     */
	
	  /**
	     * get pointer width
	     * @name getPointerWidth
	     * @method
	     * @memberof Konva.Tag.prototype
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Tag, 'pointerHeight', 0);
	
	  /**
	     * set pointer height
	     * @name setPointerHeight
	     * @method
	     * @memberof Konva.Tag.prototype
	     * @param {Number} pointerHeight
	     */
	
	  /**
	     * get pointer height
	     * @name getPointerHeight
	     * @method
	     * @memberof Konva.Tag.prototype
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Tag, 'cornerRadius', 0);
	
	  /**
	     * set corner radius
	     * @name setCornerRadius
	     * @method
	     * @memberof Konva.Tag.prototype
	     * @param {Number} corner radius
	     */
	
	  /**
	     * get corner radius
	     * @name getCornerRadius
	     * @method
	     * @memberof Konva.Tag.prototype
	     */
	
	  Konva.Collection.mapMethods(Konva.Tag);
	})();
	
	(function(Konva) {
	  'use strict';
	  /**
	     * Arrow constructor
	     * @constructor
	     * @memberof Konva
	     * @augments Konva.Shape
	     * @param {Object} config
	     * @param {Array} config.points
	     * @param {Number} [config.tension] Higher values will result in a more curvy line.  A value of 0 will result in no interpolation.
	     *   The default is 0
	     * @param {Number} config.pointerLength
	     * @param {Number} config.pointerWidth
	     * @param {String} [config.fill] fill color
	     * @param {Image} [config.fillPatternImage] fill pattern image
	     * @param {Number} [config.fillPatternX]
	     * @param {Number} [config.fillPatternY]
	     * @param {Object} [config.fillPatternOffset] object with x and y component
	     * @param {Number} [config.fillPatternOffsetX] 
	     * @param {Number} [config.fillPatternOffsetY] 
	     * @param {Object} [config.fillPatternScale] object with x and y component
	     * @param {Number} [config.fillPatternScaleX]
	     * @param {Number} [config.fillPatternScaleY]
	     * @param {Number} [config.fillPatternRotation]
	     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
	     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientStartPointX]
	     * @param {Number} [config.fillLinearGradientStartPointY]
	     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillLinearGradientEndPointX]
	     * @param {Number} [config.fillLinearGradientEndPointY]
	     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
	     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientStartPointX]
	     * @param {Number} [config.fillRadialGradientStartPointY]
	     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
	     * @param {Number} [config.fillRadialGradientEndPointX] 
	     * @param {Number} [config.fillRadialGradientEndPointY] 
	     * @param {Number} [config.fillRadialGradientStartRadius]
	     * @param {Number} [config.fillRadialGradientEndRadius]
	     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
	     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
	     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
	     * @param {String} [config.stroke] stroke color
	     * @param {Number} [config.strokeWidth] stroke width
	     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
	     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
	     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
	     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
	     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
	     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
	     *  is miter
	     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
	     *  is butt
	     * @param {String} [config.shadowColor]
	     * @param {Number} [config.shadowBlur]
	     * @param {Object} [config.shadowOffset] object with x and y component
	     * @param {Number} [config.shadowOffsetX]
	     * @param {Number} [config.shadowOffsetY]
	     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
	     *  between 0 and 1
	     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
	     * @param {Array} [config.dash]
	     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
	     * @param {Number} [config.x]
	     * @param {Number} [config.y]
	     * @param {Number} [config.width]
	     * @param {Number} [config.height]
	     * @param {Boolean} [config.visible]
	     * @param {Boolean} [config.listening] whether or not the node is listening for events
	     * @param {String} [config.id] unique id
	     * @param {String} [config.name] non-unique name
	     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
	     * @param {Object} [config.scale] set scale
	     * @param {Number} [config.scaleX] set scale x
	     * @param {Number} [config.scaleY] set scale y
	     * @param {Number} [config.rotation] rotation in degrees
	     * @param {Object} [config.offset] offset from center point and rotation point
	     * @param {Number} [config.offsetX] set offset x
	     * @param {Number} [config.offsetY] set offset y
	     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
	     *  the entire stage by dragging any portion of the stage
	     * @param {Number} [config.dragDistance]
	     * @param {Function} [config.dragBoundFunc]
	     * @example
	     * var line = new Konva.Line({
	     *   points: [73, 70, 340, 23, 450, 60, 500, 20],
	     *   stroke: 'red',
	     *   tension: 1,
	     *   pointerLength : 10,
	     *   pointerWidth : 12
	     * });
	     */
	  Konva.Arrow = function(config) {
	    this.____init(config);
	  };
	
	  Konva.Arrow.prototype = {
	    ____init: function(config) {
	      // call super constructor
	      Konva.Line.call(this, config);
	      this.className = 'Arrow';
	    },
	    _sceneFunc: function(ctx) {
	      Konva.Line.prototype._sceneFunc.apply(this, arguments);
	      var PI2 = Math.PI * 2;
	      var points = this.points();
	      var n = points.length;
	      var dx = points[n - 2] - points[n - 4];
	      var dy = points[n - 1] - points[n - 3];
	      var radians = (Math.atan2(dy, dx) + PI2) % PI2;
	      var length = this.pointerLength();
	      var width = this.pointerWidth();
	
	      ctx.save();
	      ctx.beginPath();
	      ctx.translate(points[n - 2], points[n - 1]);
	      ctx.rotate(radians);
	      ctx.moveTo(0, 0);
	      ctx.lineTo(-length, width / 2);
	      ctx.lineTo(-length, -width / 2);
	      ctx.closePath();
	      ctx.restore();
	
	      if (this.pointerAtBeginning()) {
	        ctx.save();
	        ctx.translate(points[0], points[1]);
	        dx = points[2] - points[0];
	        dy = points[3] - points[1];
	        ctx.rotate((Math.atan2(-dy, -dx) + PI2) % PI2);
	        ctx.moveTo(0, 0);
	        ctx.lineTo(-length, width / 2);
	        ctx.lineTo(-length, -width / 2);
	        ctx.closePath();
	        ctx.restore();
	      }
	      ctx.fillStrokeShape(this);
	    }
	  };
	
	  Konva.Util.extend(Konva.Arrow, Konva.Line);
	  /**
	     * get/set pointerLength
	     * @name pointerLength
	     * @method
	     * @memberof Konva.Arrow.prototype
	     * @param {Number} Length of pointer of arrow.
	     *   The default is 10.
	     * @returns {Number}
	     * @example
	     * // get tension
	     * var pointerLength = line.pointerLength();
	     *
	     * // set tension
	     * line.pointerLength(15);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Arrow, 'pointerLength', 10);
	  /**
	     * get/set pointerWidth
	     * @name pointerWidth
	     * @method
	     * @memberof Konva.Arrow.prototype
	     * @param {Number} Width of pointer of arrow.
	     *   The default is 10.
	     * @returns {Number}
	     * @example
	     * // get tension
	     * var pointerWidth = line.pointerWidth();
	     *
	     * // set tension
	     * line.pointerWidth(15);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Arrow, 'pointerWidth', 10);
	  /**
	     * get/set pointerAtBeginning
	     * @name pointerAtBeginning
	     * @method
	     * @memberof Konva.Arrow.prototype
	     * @param {Number} Should pointer displayed at beginning of arrow.
	     *   The default is false.
	     * @returns {Boolean}
	     * @example
	     * // get tension
	     * var pointerAtBeginning = line.pointerAtBeginning();
	     *
	     * // set tension
	     * line.pointerAtBeginning(true);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Arrow, 'pointerAtBeginning', false);
	  Konva.Collection.mapMethods(Konva.Arrow);
	})(Konva);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(161),
	    getRawTag = __webpack_require__(378),
	    objectToString = __webpack_require__(379);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 376 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(380);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(161);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 379 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 380 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(376);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 382 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.10';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Gets the value at `key`, unless `key` is "__proto__".
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function safeGet(object, key) {
	    return key == '__proto__'
	      ? undefined
	      : object[key];
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	
	        return result;
	      }
	
	      if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	
	        return result;
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(73)(module)))

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 *  * machina - A library for creating powerful and flexible finite state machines. Loosely inspired by Erlang/OTP's gen_fsm behavior.
	 *  * Author: Jim Cowart (http://ifandelse.com)
	 *  * Version: v2.0.2
	 *  * Url: http://machina-js.org/
	 *  * License(s): 
	 */
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(385));
		else if(typeof define === 'function' && define.amd)
			define(["lodash"], factory);
		else if(typeof exports === 'object')
			exports["machina"] = factory(require("lodash"));
		else
			root["machina"] = factory(root["_"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var _ = __webpack_require__( 1 );
		var emitter = __webpack_require__( 2 );
		
		module.exports = _.merge( emitter.instance, {
			Fsm: __webpack_require__( 5 ),
			BehavioralFsm: __webpack_require__( 6 ),
			utils: __webpack_require__( 3 ),
			eventListeners: {
				newFsm: []
			}
		} );
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var utils = __webpack_require__( 3 );
		var _ = __webpack_require__( 1 );
		
		function getInstance() {
			return {
				emit: function( eventName ) {
					var args = utils.getLeaklessArgs( arguments );
					if ( this.eventListeners[ "*" ] ) {
						_.each( this.eventListeners[ "*" ], function( callback ) {
							if ( !this.useSafeEmit ) {
								callback.apply( this, args );
							} else {
								try {
									callback.apply( this, args );
								} catch ( exception ) {
									/* istanbul ignore else  */
									if ( console && typeof console.log !== "undefined" ) {
										console.log( exception.stack );
									}
								}
							}
						}, this );
					}
					if ( this.eventListeners[ eventName ] ) {
						_.each( this.eventListeners[ eventName ], function( callback ) {
							if ( !this.useSafeEmit ) {
								callback.apply( this, args.slice( 1 ) );
							} else {
								try {
									callback.apply( this, args.slice( 1 ) );
								} catch ( exception ) {
									/* istanbul ignore else  */
									if ( console && typeof console.log !== "undefined" ) {
										console.log( exception.stack );
									}
								}
							}
						}, this );
					}
				},
		
				on: function( eventName, callback ) {
					var self = this;
					self.eventListeners = self.eventListeners || { "*": [] };
					if ( !self.eventListeners[ eventName ] ) {
						self.eventListeners[ eventName ] = [];
					}
					self.eventListeners[ eventName ].push( callback );
					return {
						eventName: eventName,
						callback: callback,
						off: function() {
							self.off( eventName, callback );
						}
					};
				},
		
				off: function( eventName, callback ) {
					this.eventListeners = this.eventListeners || { "*": [] };
					if ( !eventName ) {
						this.eventListeners = {};
					} else {
						if ( callback ) {
							this.eventListeners[ eventName ] = _.without( this.eventListeners[ eventName ], callback );
						} else {
							this.eventListeners[ eventName ] = [];
						}
					}
				}
			};
		}
		
		module.exports = {
			getInstance: getInstance,
			instance: getInstance()
		};
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var slice = [].slice;
		var events = __webpack_require__( 4 );
		var _ = __webpack_require__( 1 );
		
		var makeFsmNamespace = ( function() {
			var machinaCount = 0;
			return function() {
				return "fsm." + machinaCount++;
			};
		} )();
		
		function getDefaultBehavioralOptions() {
			return {
				initialState: "uninitialized",
				eventListeners: {
					"*": []
				},
				states: {},
				namespace: makeFsmNamespace(),
				useSafeEmit: false,
				hierarchy: {},
				pendingDelegations: {}
			};
		}
		
		function getDefaultClientMeta() {
			return {
				inputQueue: [],
				targetReplayState: "",
				state: undefined,
				priorState: undefined,
				priorAction: "",
				currentAction: "",
				currentActionArgs: undefined,
				inExitHandler: false
			};
		}
		
		function getLeaklessArgs( args, startIdx ) {
			var result = [];
			for ( var i = ( startIdx || 0 ); i < args.length; i++ ) {
				result[ i ] = args[ i ];
			}
			return result;
		}
		/*
			handle ->
				child = stateObj._child && stateObj._child.instance;
		
			transition ->
				newStateObj._child = getChildFsmInstance( newStateObj._child );
				child = newStateObj._child && newStateObj._child.instance;
		*/
		function getChildFsmInstance( config ) {
			if ( !config ) {
				return;
			}
			var childFsmDefinition = {};
			if ( typeof config === "object" ) {
				// is this a config object with a factory?
				if ( config.factory ) {
					childFsmDefinition = config;
					childFsmDefinition.instance = childFsmDefinition.factory();
				} else {
					// assuming this is a machina instance
					childFsmDefinition.factory = function() {
						return config;
					};
				}
			} else if ( typeof config === "function" ) {
				childFsmDefinition.factory = config;
			}
			childFsmDefinition.instance = childFsmDefinition.factory();
			return childFsmDefinition;
		}
		
		function listenToChild( fsm, child ) {
			// Need to investigate potential for discarded event
			// listener memory leak in long-running, deeply-nested hierarchies.
			return child.on( "*", function( eventName, data ) {
				switch ( eventName ) {
					case events.NO_HANDLER:
						if ( !data.ticket && !data.delegated && data.namespace !== fsm.namespace ) {
							// Ok - we're dealing w/ a child handling input that should bubble up
							data.args[ 1 ].bubbling = true;
						}
						// we do NOT bubble _reset inputs up to the parent
						if ( data.inputType !== "_reset" ) {
							fsm.handle.apply( fsm, data.args );
						}
						break;
					case events.HANDLING :
						var ticket = data.ticket;
						if ( ticket && fsm.pendingDelegations[ ticket ] ) {
							delete fsm.pendingDelegations[ ticket ];
						}
						fsm.emit( eventName, data ); // possibly transform payload?
						break;
					default:
						fsm.emit( eventName, data ); // possibly transform payload?
						break;
				}
			} );
		}
		
		// _machKeys are members we want to track across the prototype chain of an extended FSM constructor
		// Since we want to eventually merge the aggregate of those values onto the instance so that FSMs
		// that share the same extended prototype won't share state *on* those prototypes.
		var _machKeys = [ "states", "initialState" ];
		var extend = function( protoProps, staticProps ) {
			var parent = this;
			var fsm; // placeholder for instance constructor
			var machObj = {}; // object used to hold initialState & states from prototype for instance-level merging
			var Ctor = function() {}; // placeholder ctor function used to insert level in prototype chain
		
			// The constructor function for the new subclass is either defined by you
			// (the "constructor" property in your `extend` definition), or defaulted
			// by us to simply call the parent's constructor.
			if ( protoProps && protoProps.hasOwnProperty( "constructor" ) ) {
				fsm = protoProps.constructor;
			} else {
				// The default machina constructor (when using inheritance) creates a
				// deep copy of the states/initialState values from the prototype and
				// extends them over the instance so that they'll be instance-level.
				// If an options arg (args[0]) is passed in, a states or intialState
				// value will be preferred over any data pulled up from the prototype.
				fsm = function() {
					var args = slice.call( arguments, 0 );
					args[ 0 ] = args[ 0 ] || {};
					var blendedState;
					var instanceStates = args[ 0 ].states || {};
					blendedState = _.merge( _.cloneDeep( machObj ), { states: instanceStates } );
					blendedState.initialState = args[ 0 ].initialState || this.initialState;
					_.extend( args[ 0 ], blendedState );
					parent.apply( this, args );
				};
			}
		
			// Inherit class (static) properties from parent.
			_.merge( fsm, parent );
		
			// Set the prototype chain to inherit from `parent`, without calling
			// `parent`'s constructor function.
			Ctor.prototype = parent.prototype;
			fsm.prototype = new Ctor();
		
			// Add prototype properties (instance properties) to the subclass,
			// if supplied.
			if ( protoProps ) {
				_.extend( fsm.prototype, protoProps );
				_.merge( machObj, _.transform( protoProps, function( accum, val, key ) {
					if ( _machKeys.indexOf( key ) !== -1 ) {
						accum[ key ] = val;
					}
				} ) );
			}
		
			// Add static properties to the constructor function, if supplied.
			if ( staticProps ) {
				_.merge( fsm, staticProps );
			}
		
			// Correctly set child's `prototype.constructor`.
			fsm.prototype.constructor = fsm;
		
			// Set a convenience property in case the parent's prototype is needed later.
			fsm.__super__ = parent.prototype;
			return fsm;
		};
		
		function createUUID() {
			var s = [];
			var hexDigits = "0123456789abcdef";
			for ( var i = 0; i < 36; i++ ) {
				s[ i ] = hexDigits.substr( Math.floor( Math.random() * 0x10 ), 1 );
			}
			s[ 14 ] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
			/* jshint ignore:start */
			s[ 19 ] = hexDigits.substr( ( s[ 19 ] & 0x3 ) | 0x8, 1 ); // bits 6-7 of the clock_seq_hi_and_reserved to 01
			/* jshint ignore:end */
			s[ 8 ] = s[ 13 ] = s[ 18 ] = s[ 23 ] = "-";
			return s.join( "" );
		}
		
		module.exports = {
			createUUID: createUUID,
			extend: extend,
			getDefaultBehavioralOptions: getDefaultBehavioralOptions,
			getDefaultOptions: getDefaultBehavioralOptions,
			getDefaultClientMeta: getDefaultClientMeta,
			getChildFsmInstance: getChildFsmInstance,
			getLeaklessArgs: getLeaklessArgs,
			listenToChild: listenToChild,
			makeFsmNamespace: makeFsmNamespace
		};
	
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports) {
	
		module.exports = {
			NEXT_TRANSITION: "transition",
			HANDLING: "handling",
			HANDLED: "handled",
			NO_HANDLER: "nohandler",
			TRANSITION: "transition",
			TRANSITIONED: "transitioned",
			INVALID_STATE: "invalidstate",
			DEFERRED: "deferred",
			NEW_FSM: "newfsm"
		};
	
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var BehavioralFsm = __webpack_require__( 6 );
		var utils = __webpack_require__( 3 );
		var _ = __webpack_require__( 1 );
		
		var Fsm = {
			constructor: function() {
				BehavioralFsm.apply( this, arguments );
				this.ensureClientMeta();
			},
			initClient: function initClient() {
				var initialState = this.initialState;
				if ( !initialState ) {
					throw new Error( "You must specify an initial state for this FSM" );
				}
				if ( !this.states[ initialState ] ) {
					throw new Error( "The initial state specified does not exist in the states object." );
				}
				this.transition( initialState );
			},
			ensureClientMeta: function ensureClientMeta() {
				if ( !this._stamped ) {
					this._stamped = true;
					_.defaults( this, _.cloneDeep( utils.getDefaultClientMeta() ) );
					this.initClient();
				}
				return this;
			},
		
			ensureClientArg: function( args ) {
				var _args = args;
				// we need to test the args and verify that if a client arg has
				// been passed, it must be this FSM instance (this isn't a behavioral FSM)
				if ( typeof _args[ 0 ] === "object" && !( "inputType" in _args[ 0 ] ) && _args[ 0 ] !== this ) {
					_args.splice( 0, 1, this );
				} else if ( typeof _args[ 0 ] !== "object" || ( typeof _args[ 0 ] === "object" && ( "inputType" in _args[ 0 ] ) ) ) {
					_args.unshift( this );
				}
				return _args;
			},
		
			getHandlerArgs: function( args, isCatchAll ) {
				// index 0 is the client, index 1 is inputType
				// if we're in a catch-all handler, input type needs to be included in the args
				// inputType might be an object, so we need to just get the inputType string if so
				var _args = args;
				var input = _args[ 1 ];
				if ( typeof inputType === "object" ) {
					_args.splice( 1, 1, input.inputType );
				}
				return isCatchAll ?
					_args.slice( 1 ) :
					_args.slice( 2 );
			},
		
			getSystemHandlerArgs: function( args, client ) {
				return args;
			},
		
			// "classic" machina FSM do not emit the client property on events (which would be the FSM itself)
			buildEventPayload: function() {
				var args = this.ensureClientArg( utils.getLeaklessArgs( arguments ) );
				var data = args[ 1 ];
				if ( _.isPlainObject( data ) ) {
					return _.extend( data, { namespace: this.namespace } );
				} else {
					return { data: data || null, namespace: this.namespace };
				}
			}
		};
		
		_.each( [
			"handle",
			"transition",
			"deferUntilTransition",
			"processQueue",
			"clearQueue"
		], function( methodWithClientInjected ) {
			Fsm[ methodWithClientInjected ] = function() {
				var args = this.ensureClientArg( utils.getLeaklessArgs( arguments ) );
				return BehavioralFsm.prototype[ methodWithClientInjected ].apply( this, args );
			};
		} );
		
		Fsm = BehavioralFsm.extend( Fsm );
		
		module.exports = Fsm;
	
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var _ = __webpack_require__( 1 );
		var utils = __webpack_require__( 3 );
		var emitter = __webpack_require__( 2 );
		var topLevelEmitter = emitter.instance;
		var events = __webpack_require__( 4 );
		
		var MACHINA_PROP = "__machina__";
		
		function BehavioralFsm( options ) {
			_.extend( this, options );
			_.defaults( this, utils.getDefaultBehavioralOptions() );
			this.initialize.apply( this, arguments );
			topLevelEmitter.emit( events.NEW_FSM, this );
		}
		
		_.extend( BehavioralFsm.prototype, {
			initialize: function() {},
		
			initClient: function initClient( client ) {
				var initialState = this.initialState;
				if ( !initialState ) {
					throw new Error( "You must specify an initial state for this FSM" );
				}
				if ( !this.states[ initialState ] ) {
					throw new Error( "The initial state specified does not exist in the states object." );
				}
				this.transition( client, initialState );
			},
		
			configForState: function configForState( newState ) {
				var newStateObj = this.states[ newState ];
				var child;
				_.each( this.hierarchy, function( childListener, key ) {
					if ( childListener && typeof childListener.off === "function" ) {
						childListener.off();
					}
				} );
		
				if ( newStateObj._child ) {
					newStateObj._child = utils.getChildFsmInstance( newStateObj._child );
					child = newStateObj._child && newStateObj._child.instance;
					this.hierarchy[ child.namespace ] = utils.listenToChild( this, child );
				}
		
				return child;
			},
		
			ensureClientMeta: function ensureClientMeta( client ) {
				if ( typeof client !== "object" ) {
					throw new Error( "An FSM client must be an object." );
				}
				client[ MACHINA_PROP ] = client[ MACHINA_PROP ] || {};
				if ( !client[ MACHINA_PROP ][ this.namespace ] ) {
					client[ MACHINA_PROP ][ this.namespace ] = _.cloneDeep( utils.getDefaultClientMeta() );
					this.initClient( client );
				}
				return client[ MACHINA_PROP ][ this.namespace ];
			},
		
			buildEventPayload: function( client, data ) {
				if ( _.isPlainObject( data ) ) {
					return _.extend( data, { client: client, namespace: this.namespace } );
				} else {
					return { client: client, data: data || null, namespace: this.namespace };
				}
			},
		
			getHandlerArgs: function( args, isCatchAll ) {
				// index 0 is the client, index 1 is inputType
				// if we're in a catch-all handler, input type needs to be included in the args
				// inputType might be an object, so we need to just get the inputType string if so
				var _args = args.slice( 0 );
				var input = _args[ 1 ];
				if ( typeof input === "object" ) {
					_args.splice( 1, 1, input.inputType );
				}
				return isCatchAll ?
					_args :
					[ _args[ 0 ] ].concat( _args.slice( 2 ) );
			},
		
			getSystemHandlerArgs: function( args, client ) {
				return [ client ].concat( args );
			},
		
			handle: function( client, input ) {
				var inputDef = input;
				if ( typeof input === "undefined" ) {
					throw new Error( "The input argument passed to the FSM's handle method is undefined. Did you forget to pass the input name?" );
				}
				if ( typeof input === "string" ) {
					inputDef = { inputType: input, delegated: false, ticket: undefined };
				}
				var clientMeta = this.ensureClientMeta( client );
				var args = utils.getLeaklessArgs( arguments );
				if ( typeof input !== "object" ) {
					args.splice( 1, 1, inputDef );
				}
				clientMeta.currentActionArgs = args.slice( 1 );
				var currentState = clientMeta.state;
				var stateObj = this.states[ currentState ];
				var handlerName;
				var handler;
				var isCatchAll = false;
				var child;
				var result;
				var action;
				if ( !clientMeta.inExitHandler ) {
					child = this.configForState( currentState );
					if ( child && !this.pendingDelegations[ inputDef.ticket ] && !inputDef.bubbling ) {
						inputDef.ticket = ( inputDef.ticket || utils.createUUID() );
						inputDef.delegated = true;
						this.pendingDelegations[ inputDef.ticket ] = { delegatedTo: child.namespace };
						// WARNING - returning a value from `handle` on child FSMs is not really supported.
						// If you need to return values from child FSM input handlers, use events instead.
						result = child.handle.apply( child, args );
					} else {
						if ( inputDef.ticket && this.pendingDelegations[ inputDef.ticket ] ) {
							delete this.pendingDelegations[ inputDef.ticket ];
						}
						handlerName = stateObj[ inputDef.inputType ] ? inputDef.inputType : "*";
						isCatchAll = ( handlerName === "*" );
						handler = ( stateObj[ handlerName ] || this[ handlerName ] ) || this[ "*" ];
						action = clientMeta.state + "." + handlerName;
						clientMeta.currentAction = action;
						var eventPayload = this.buildEventPayload(
							client,
							{ inputType: inputDef.inputType, delegated: inputDef.delegated, ticket: inputDef.ticket }
						);
						if ( !handler ) {
							this.emit( events.NO_HANDLER, _.extend( { args: args }, eventPayload ) );
						} else {
							this.emit( events.HANDLING, eventPayload );
							if ( typeof handler === "function" ) {
								result = handler.apply( this, this.getHandlerArgs( args, isCatchAll ) );
							} else {
								result = handler;
								this.transition( client, handler );
							}
							this.emit( events.HANDLED, eventPayload );
						}
						clientMeta.priorAction = clientMeta.currentAction;
						clientMeta.currentAction = "";
						clientMeta.currentActionArgs = undefined;
					}
				}
				return result;
			},
		
			transition: function( client, newState ) {
				var clientMeta = this.ensureClientMeta( client );
				var curState = clientMeta.state;
				var curStateObj = this.states[ curState ];
				var newStateObj = this.states[ newState ];
				var child;
				var args = utils.getLeaklessArgs( arguments ).slice( 2 );
				if ( !clientMeta.inExitHandler && newState !== curState ) {
					if ( newStateObj ) {
						child = this.configForState( newState );
						if ( curStateObj && curStateObj._onExit ) {
							clientMeta.inExitHandler = true;
							curStateObj._onExit.call( this, client );
							clientMeta.inExitHandler = false;
						}
						clientMeta.targetReplayState = newState;
						clientMeta.priorState = curState;
						clientMeta.state = newState;
						var eventPayload = this.buildEventPayload( client, {
							fromState: clientMeta.priorState,
							action: clientMeta.currentAction,
							toState: newState
						} );
						this.emit( events.TRANSITION, eventPayload );
						if ( newStateObj._onEnter ) {
							newStateObj._onEnter.apply( this, this.getSystemHandlerArgs( args, client ) );
						}
						this.emit( events.TRANSITIONED, eventPayload );
						if ( child ) {
							child.handle( client, "_reset" );
						}
		
						if ( clientMeta.targetReplayState === newState ) {
							this.processQueue( client, events.NEXT_TRANSITION );
						}
						return;
					}
					this.emit( events.INVALID_STATE, this.buildEventPayload( client, {
						state: clientMeta.state,
						attemptedState: newState
					} ) );
				}
			},
		
			deferUntilTransition: function( client, stateName ) {
				var clientMeta = this.ensureClientMeta( client );
				if ( clientMeta.currentActionArgs ) {
					var queued = {
						type: events.NEXT_TRANSITION,
						untilState: stateName,
						args: clientMeta.currentActionArgs
					};
					clientMeta.inputQueue.push( queued );
					var eventPayload = this.buildEventPayload( client, {
						state: clientMeta.state,
						queuedArgs: queued
					} );
					this.emit( events.DEFERRED, eventPayload );
				}
			},
		
			deferAndTransition: function( client, stateName ) {
				this.deferUntilTransition( client, stateName );
				this.transition( client, stateName );
			},
		
			processQueue: function( client ) {
				var clientMeta = this.ensureClientMeta( client );
				var filterFn = function( item ) {
					return ( ( !item.untilState ) || ( item.untilState === clientMeta.state ) );
				};
				var toProcess = _.filter( clientMeta.inputQueue, filterFn );
				clientMeta.inputQueue = _.difference( clientMeta.inputQueue, toProcess );
				_.each( toProcess, function( item ) {
					this.handle.apply( this, [ client ].concat( item.args ) );
				}.bind( this ) );
			},
		
			clearQueue: function( client, name ) {
				var clientMeta = this.ensureClientMeta( client );
				if ( !name ) {
					clientMeta.inputQueue = [];
				} else {
					var filter = function( evnt ) {
						return ( name ? evnt.untilState !== name : true );
					};
					clientMeta.inputQueue = _.filter( clientMeta.inputQueue, filter );
				}
			},
		
			compositeState: function( client ) {
				var clientMeta = this.ensureClientMeta( client );
				var state = clientMeta.state;
				var child = this.states[state]._child && this.states[state]._child.instance;
				if ( child ) {
					state += "." + child.compositeState( client );
				}
				return state;
			}
		}, emitter.getInstance() );
		
		BehavioralFsm.extend = utils.extend;
		
		module.exports = BehavioralFsm;
	
	
	/***/ })
	/******/ ])
	});
	;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * @license
	 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern -d -o ./index.js`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '3.10.1';
	
	  /** Used to compose bitmasks for wrapper metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256;
	
	  /** Used as default options for `_.trunc`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect when a function becomes hot. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2;
	
	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      weakMapTag = '[object WeakMap]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	      reUnescapedHtml = /[&<>"'`]/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	  /**
	   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
	   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
	   */
	  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
	      reHasRegExpChars = RegExp(reRegExpChars.source);
	
	  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
	  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect hexadecimal string values. */
	  var reHasHexPrefix = /^0[xX]/;
	
	  /** Used to detect host constructors (Safari > 5). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^\d+$/;
	
	  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to match words to create compound words. */
	  var reWords = (function() {
	    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
	        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';
	
	    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
	  }());
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
	    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
	    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	  cloneableTags[dateTag] = cloneableTags[float32Tag] =
	  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[stringTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[mapTag] = cloneableTags[setTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map latin-1 supplementary letters to basic latin letters. */
	  var deburredLetters = {
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '`': '&#96;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'",
	    '&#96;': '`'
	  };
	
	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };
	
	  /** Used to escape characters for inclusion in compiled regexes. */
	  var regexpEscapes = {
	    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
	    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
	    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
	    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
	    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Detect free variable `exports`. */
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = objectTypes[typeof self] && self && self.Object && self;
	
	  /** Detect free variable `window`. */
	  var freeWindow = objectTypes[typeof window] && window && window.Object && window;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;
	
	  /**
	   * Used as a reference to the global object.
	   *
	   * The `this` value is used if it's the global object to avoid Greasemonkey's
	   * restricted `window` object, otherwise the `window` object is used.
	   */
	  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * The base implementation of `compareAscending` which compares values and
	   * sorts them in ascending order without guaranteeing a stable sort.
	   *
	   * @private
	   * @param {*} value The value to compare.
	   * @param {*} other The other value to compare.
	   * @returns {number} Returns the sort order indicator for `value`.
	   */
	  function baseCompareAscending(value, other) {
	    if (value !== other) {
	      var valIsNull = value === null,
	          valIsUndef = value === undefined,
	          valIsReflexive = value === value;
	
	      var othIsNull = other === null,
	          othIsUndef = other === undefined,
	          othIsReflexive = other === other;
	
	      if ((value > other && !othIsNull) || !valIsReflexive ||
	          (valIsNull && !othIsUndef && othIsReflexive) ||
	          (valIsUndef && othIsReflexive)) {
	        return 1;
	      }
	      if ((value < other && !valIsNull) || !othIsReflexive ||
	          (othIsNull && !valIsUndef && valIsReflexive) ||
	          (othIsUndef && valIsReflexive)) {
	        return -1;
	      }
	    }
	    return 0;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromRight) {
	    var length = array.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without support for binary searches.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return indexOfNaN(array, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isFunction` without support for environments
	   * with incorrect `typeof` results.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   */
	  function baseIsFunction(value) {
	    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
	    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
	    return typeof value == 'function' || false;
	  }
	
	  /**
	   * Converts `value` to a string if it's not one. An empty string is returned
	   * for `null` or `undefined` values.
	   *
	   * @private
	   * @param {*} value The value to process.
	   * @returns {string} Returns the string.
	   */
	  function baseToString(value) {
	    return value == null ? '' : (value + '');
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the first character not found in `chars`.
	   */
	  function charsLeftIndex(string, chars) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the last character not found in `chars`.
	   */
	  function charsRightIndex(string, chars) {
	    var index = string.length;
	
	    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.sortBy` to compare transformed elements of a collection and stable
	   * sort them in ascending order.
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareAscending(object, other) {
	    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
	  }
	
	  /**
	   * Used by `_.sortByOrder` to compare multiple properties of a value to another
	   * and stable sort them.
	   *
	   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
	   * a value is sorted in ascending order if its corresponding order is "asc", and
	   * descending if "desc".
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @param {boolean[]} orders The order to sort by for each property.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareMultiple(object, other, orders) {
	    var index = -1,
	        objCriteria = object.criteria,
	        othCriteria = other.criteria,
	        length = objCriteria.length,
	        ordersLength = orders.length;
	
	    while (++index < length) {
	      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
	      if (result) {
	        if (index >= ordersLength) {
	          return result;
	        }
	        var order = orders[index];
	        return result * ((order === 'asc' || order === true) ? 1 : -1);
	      }
	    }
	    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	    // that causes it, under certain circumstances, to provide the same value for
	    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	    // for more details.
	    //
	    // This also ensures a stable sort in V8 and other engines.
	    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
	    return object.index - other.index;
	  }
	
	  /**
	   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  function deburrLetter(letter) {
	    return deburredLetters[letter];
	  }
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeHtmlChar(chr) {
	    return htmlEscapes[chr];
	  }
	
	  /**
	   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @param {string} leadingChar The capture group for a leading character.
	   * @param {string} whitespaceChar The capture group for a whitespace character.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
	    if (leadingChar) {
	      chr = regexpEscapes[chr];
	    } else if (whitespaceChar) {
	      chr = stringEscapes[chr];
	    }
	    return '\\' + chr;
	  }
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the index at which the first occurrence of `NaN` is found in `array`.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	   */
	  function indexOfNaN(array, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 0 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var other = array[index];
	      if (other !== other) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * Checks if `value` is object-like.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	   */
	  function isObjectLike(value) {
	    return !!value && typeof value == 'object';
	  }
	
	  /**
	   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
	   * character code is whitespace.
	   *
	   * @private
	   * @param {number} charCode The character code to inspect.
	   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
	   */
	  function isSpace(charCode) {
	    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
	      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      if (array[index] === placeholder) {
	        array[index] = PLACEHOLDER;
	        result[++resIndex] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * An implementation of `_.uniq` optimized for sorted arrays without support
	   * for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} [iteratee] The function invoked per iteration.
	   * @returns {Array} Returns the new duplicate-value-free array.
	   */
	  function sortedUniq(array, iteratee) {
	    var seen,
	        index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index],
	          computed = iteratee ? iteratee(value, index, array) : value;
	
	      if (!index || seen !== computed) {
	        seen = computed;
	        result[++resIndex] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the first non-whitespace character.
	   */
	  function trimmedLeftIndex(string) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedRightIndex(string) {
	    var index = string.length;
	
	    while (index-- && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  function unescapeHtmlChar(chr) {
	    return htmlUnescapes[chr];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the given `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @category Utility
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // using `context` to mock `Date#getTime` use in `_.now`
	   * var mock = _.runInContext({
	   *   'Date': function() {
	   *     return { 'getTime': getTimeMock };
	   *   }
	   * });
	   *
	   * // or creating a suped-up `defer` in Node.js
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  function runInContext(context) {
	    // Avoid issues with some ES3 environments that attempt to use values, named
	    // after built-in constructors like `Object`, for the creation of literals.
	    // ES5 clears this up by stating that literals must use built-in constructors.
	    // See https://es5.github.io/#x11.1.5 for more details.
	    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;
	
	    /** Native constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Number = context.Number,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for native method references. */
	    var arrayProto = Array.prototype,
	        objectProto = Object.prototype,
	        stringProto = String.prototype;
	
	    /** Used to resolve the decompiled source of functions. */
	    var fnToString = Function.prototype.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /**
	     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objToString = objectProto.toString;
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Native method references. */
	    var ArrayBuffer = context.ArrayBuffer,
	        clearTimeout = context.clearTimeout,
	        parseFloat = context.parseFloat,
	        pow = Math.pow,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        Set = getNative(context, 'Set'),
	        setTimeout = context.setTimeout,
	        splice = arrayProto.splice,
	        Uint8Array = context.Uint8Array,
	        WeakMap = getNative(context, 'WeakMap');
	
	    /* Native method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeCreate = getNative(Object, 'create'),
	        nativeFloor = Math.floor,
	        nativeIsArray = getNative(Array, 'isArray'),
	        nativeIsFinite = context.isFinite,
	        nativeKeys = getNative(Object, 'keys'),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = getNative(Date, 'now'),
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random;
	
	    /** Used as references for `-Infinity` and `Infinity`. */
	    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
	        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;
	
	    /** Used as references for the maximum length and index of an array. */
	    var MAX_ARRAY_LENGTH = 4294967295,
	        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	    /**
	     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	     * of an array-like value.
	     */
	    var MAX_SAFE_INTEGER = 9007199254740991;
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
	     * Methods that operate on and return arrays, collections, and functions can
	     * be chained together. Methods that retrieve a single value or may return a
	     * primitive value will automatically end the chain returning the unwrapped
	     * value. Explicit chaining may be enabled using `_.chain`. The execution of
	     * chained methods is lazy, that is, execution is deferred until `_#value`
	     * is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
	     * fusion is an optimization strategy which merge iteratee calls; this can help
	     * to avoid the creation of intermediate data structures and greatly reduce the
	     * number of iteratee executions.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
	     * `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
	     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
	     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
	     * and `where`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
	     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
	     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
	     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
	     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
	     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
	     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
	     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
	     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
	     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
	     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
	     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
	     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
	     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
	     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
	     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
	     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
	     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
	     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
	     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
	     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
	     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
	     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
	     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
	     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
	     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
	     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
	     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
	     * `unescape`, `uniqueId`, `value`, and `words`
	     *
	     * The wrapper method `sample` will return a wrapped value when `n` is provided,
	     * otherwise an unwrapped value is returned.
	     *
	     * @name _
	     * @constructor
	     * @category Chain
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // returns an unwrapped value
	     * wrapped.reduce(function(total, n) {
	     *   return total + n;
	     * });
	     * // => 6
	     *
	     * // returns a wrapped value
	     * var squares = wrapped.map(function(n) {
	     *   return n * n;
	     * });
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The function whose prototype all chaining wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
	     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
	     */
	    function LodashWrapper(value, chainAll, actions) {
	      this.__wrapped__ = value;
	      this.__actions__ = actions || [];
	      this.__chain__ = !!chainAll;
	    }
	
	    /**
	     * An object environment feature flags.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    var support = lodash.support = {};
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type string
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type Object
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type Function
	         */
	        '_': lodash
	      }
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = POSITIVE_INFINITY;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = arrayCopy(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = arrayCopy(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = arrayCopy(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
	        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a cache object to store key/value pairs.
	     *
	     * @private
	     * @static
	     * @name Cache
	     * @memberOf _.memoize
	     */
	    function MapCache() {
	      this.__data__ = {};
	    }
	
	    /**
	     * Removes `key` and its value from the cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
	     */
	    function mapDelete(key) {
	      return this.has(key) && delete this.__data__[key];
	    }
	
	    /**
	     * Gets the cached value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the cached value.
	     */
	    function mapGet(key) {
	      return key == '__proto__' ? undefined : this.__data__[key];
	    }
	
	    /**
	     * Checks if a cached value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapHas(key) {
	      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
	    }
	
	    /**
	     * Sets `value` to `key` of the cache.
	     *
	     * @private
	     * @name set
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to cache.
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache object.
	     */
	    function mapSet(key, value) {
	      if (key != '__proto__') {
	        this.__data__[key] = value;
	      }
	      return this;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates a cache object to store unique values.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var length = values ? values.length : 0;
	
	      this.data = { 'hash': nativeCreate(null), 'set': new Set };
	      while (length--) {
	        this.push(values[length]);
	      }
	    }
	
	    /**
	     * Checks if `value` is in `cache` mimicking the return signature of
	     * `_.indexOf` by returning `0` if the value is found, else `-1`.
	     *
	     * @private
	     * @param {Object} cache The cache to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `0` if `value` is found, else `-1`.
	     */
	    function cacheIndexOf(cache, value) {
	      var data = cache.data,
	          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	      return result ? 0 : -1;
	    }
	
	    /**
	     * Adds `value` to the cache.
	     *
	     * @private
	     * @name push
	     * @memberOf SetCache
	     * @param {*} value The value to cache.
	     */
	    function cachePush(value) {
	      var data = this.data;
	      if (typeof value == 'string' || isObject(value)) {
	        data.set.add(value);
	      } else {
	        data.hash[value] = true;
	      }
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a new array joining `array` with `other`.
	     *
	     * @private
	     * @param {Array} array The array to join.
	     * @param {Array} other The other array to join.
	     * @returns {Array} Returns the new concatenated array.
	     */
	    function arrayConcat(array, other) {
	      var index = -1,
	          length = array.length,
	          othIndex = -1,
	          othLength = other.length,
	          result = Array(length + othLength);
	
	      while (++index < length) {
	        result[index] = array[index];
	      }
	      while (++othIndex < othLength) {
	        result[index++] = other[othIndex];
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayCopy(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEach` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEach(array, iteratee) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (iteratee(array[index], index, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEachRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEachRight(array, iteratee) {
	      var length = array.length;
	
	      while (length--) {
	        if (iteratee(array[length], length, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.every` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     */
	    function arrayEvery(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (!predicate(array[index], index, array)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
	     * with one argument: (value).
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function arrayExtremum(array, iteratee, comparator, exValue) {
	      var index = -1,
	          length = array.length,
	          computed = exValue,
	          result = computed;
	
	      while (++index < length) {
	        var value = array[index],
	            current = +iteratee(value);
	
	        if (comparator(current, computed)) {
	          computed = current;
	          result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.filter` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function arrayFilter(array, predicate) {
	      var index = -1,
	          length = array.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.map` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function arrayMap(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = iteratee(array[index], index, array);
	      }
	      return result;
	    }
	
	    /**
	     * Appends the elements of `values` to `array`.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to append.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayPush(array, values) {
	      var index = -1,
	          length = values.length,
	          offset = array.length;
	
	      while (++index < length) {
	        array[offset + index] = values[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.reduce` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the first element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduce(array, iteratee, accumulator, initFromArray) {
	      var index = -1,
	          length = array.length;
	
	      if (initFromArray && length) {
	        accumulator = array[++index];
	      }
	      while (++index < length) {
	        accumulator = iteratee(accumulator, array[index], index, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.reduceRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the last element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
	      var length = array.length;
	      if (initFromArray && length) {
	        accumulator = array[--length];
	      }
	      while (length--) {
	        accumulator = iteratee(accumulator, array[length], length, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.some` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function arraySome(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (predicate(array[index], index, array)) {
	          return true;
	        }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `_.sum` for arrays without support for callback
	     * shorthands and `this` binding..
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function arraySum(array, iteratee) {
	      var length = array.length,
	          result = 0;
	
	      while (length--) {
	        result += +iteratee(array[length]) || 0;
	      }
	      return result;
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assign` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : objectValue;
	    }
	
	    /**
	     * Used by `_.template` to customize its `_.assign` use.
	     *
	     * **Note:** This function is like `assignDefaults` except that it ignores
	     * inherited property values when checking if a property is `undefined`.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @param {string} key The key associated with the object and source values.
	     * @param {Object} object The destination object.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignOwnDefaults(objectValue, sourceValue, key, object) {
	      return (objectValue === undefined || !hasOwnProperty.call(object, key))
	        ? sourceValue
	        : objectValue;
	    }
	
	    /**
	     * A specialized version of `_.assign` for customizing assigned values without
	     * support for argument juggling, multiple sources, and `this` binding `customizer`
	     * functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     */
	    function assignWith(object, source, customizer) {
	      var index = -1,
	          props = keys(source),
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key],
	            result = customizer(value, source[key], key, object, source);
	
	        if ((result === result ? (result !== value) : (value === value)) ||
	            (value === undefined && !(key in object))) {
	          object[key] = result;
	        }
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for argument juggling,
	     * multiple sources, and `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return source == null
	        ? object
	        : baseCopy(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.at` without support for string collections
	     * and individual key arguments.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {number[]|string[]} props The property names or indexes of elements to pick.
	     * @returns {Array} Returns the new array of picked elements.
	     */
	    function baseAt(collection, props) {
	      var index = -1,
	          isNil = collection == null,
	          isArr = !isNil && isArrayLike(collection),
	          length = isArr ? collection.length : 0,
	          propsLength = props.length,
	          result = Array(propsLength);
	
	      while(++index < propsLength) {
	        var key = props[index];
	        if (isArr) {
	          result[index] = isIndex(key, length) ? collection[key] : undefined;
	        } else {
	          result[index] = isNil ? undefined : collection[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property names to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @returns {Object} Returns `object`.
	     */
	    function baseCopy(source, props, object) {
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	        object[key] = source[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.callback` which supports specifying the
	     * number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function baseCallback(func, thisArg, argCount) {
	      var type = typeof func;
	      if (type == 'function') {
	        return thisArg === undefined
	          ? func
	          : bindCallback(func, thisArg, argCount);
	      }
	      if (func == null) {
	        return identity;
	      }
	      if (type == 'object') {
	        return baseMatches(func);
	      }
	      return thisArg === undefined
	        ? property(func)
	        : baseMatchesProperty(func, thisArg);
	    }
	
	    /**
	     * The base implementation of `_.clone` without support for argument juggling
	     * and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The object `value` belongs to.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates clones with source counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return arrayCopy(value, result);
	        }
	      } else {
	        var tag = objToString.call(value),
	            isFunc = tag == funcTag;
	
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return baseAssign(result, value);
	          }
	        } else {
	          return cloneableTags[tag]
	            ? initCloneByTag(value, tag, isDeep)
	            : (object ? value : {});
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == value) {
	          return stackB[length];
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate it with its clone.
	      stackA.push(value);
	      stackB.push(result);
	
	      // Recursively populate clone (susceptible to call stack limits).
	      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(prototype) {
	        if (isObject(prototype)) {
	          object.prototype = prototype;
	          var result = new object;
	          object.prototype = undefined;
	        }
	        return result || {};
	      };
	    }());
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts an index
	     * of where to slice the arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Object} args The arguments provide to `func`.
	     * @returns {number} Returns the timer id.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of `_.difference` which accepts a single array
	     * of values to exclude.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values) {
	      var length = array ? array.length : 0,
	          result = [];
	
	      if (!length) {
	        return result;
	      }
	      var index = -1,
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
	          valuesLength = values.length;
	
	      if (cache) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	        values = cache;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index];
	
	        if (isCommon && value === value) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === value) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (indexOf(values, value, 0) < 0) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * Gets the extremum value of `collection` invoking `iteratee` for each value
	     * in `collection` to generate the criterion by which the value is ranked.
	     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(collection, iteratee, comparator, exValue) {
	      var computed = exValue,
	          result = computed;
	
	      baseEach(collection, function(value, index, collection) {
	        var current = +iteratee(value, index, collection);
	        if (comparator(current, computed) || (current === exValue && current === result)) {
	          computed = current;
	          result = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : (end >>> 0);
	      start >>>= 0;
	
	      while (start < length) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	     * without support for callback shorthands and `this` binding, which iterates
	     * over `collection` using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @param {boolean} [retKey] Specify returning the key of the found element
	     *  instead of the element itself.
	     * @returns {*} Returns the found element or its key, else `undefined`.
	     */
	    function baseFind(collection, predicate, eachFunc, retKey) {
	      var result;
	      eachFunc(collection, function(value, key, collection) {
	        if (predicate(value, key, collection)) {
	          result = retKey ? key : value;
	          return false;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with added support for restricting
	     * flattening and specifying the start index.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, isDeep, isStrict, result) {
	      result || (result = []);
	
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index];
	        if (isObjectLike(value) && isArrayLike(value) &&
	            (isStrict || isArray(value) || isArguments(value))) {
	          if (isDeep) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, isDeep, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForIn` and `baseForOwn` which iterates
	     * over `object` properties returned by `keysFunc` invoking `iteratee` for
	     * each property. Iteratee functions may exit iteration early by explicitly
	     * returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forIn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForIn(object, iteratee) {
	      return baseFor(object, iteratee, keysIn);
	    }
	
	    /**
	     * The base implementation of `_.forOwn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from those provided.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the new array of filtered property names.
	     */
	    function baseFunctions(object, props) {
	      var index = -1,
	          length = props.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var key = props[index];
	        if (isFunction(object[key])) {
	          result[++resIndex] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `get` without support for string paths
	     * and default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path of the property to get.
	     * @param {string} [pathKey] The key representation of path.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path, pathKey) {
	      if (object == null) {
	        return;
	      }
	      if (pathKey !== undefined && pathKey in toObject(object)) {
	        path = [pathKey];
	      }
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[path[index++]];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` without support for `this` binding
	     * `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;
	
	      if (!objIsArr) {
	        objTag = objToString.call(object);
	        if (objTag == argsTag) {
	          objTag = objectTag;
	        } else if (objTag != objectTag) {
	          objIsArr = isTypedArray(object);
	        }
	      }
	      if (!othIsArr) {
	        othTag = objToString.call(other);
	        if (othTag == argsTag) {
	          othTag = objectTag;
	        } else if (othTag != objectTag) {
	          othIsArr = isTypedArray(other);
	        }
	      }
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && !(objIsArr || objIsObj)) {
	        return equalByTag(object, other, objTag);
	      }
	      if (!isLoose) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      // For more information on detecting circular references see https://es5.github.io/#JO.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == object) {
	          return stackB[length] == other;
	        }
	      }
	      // Add `object` and `other` to the stack of traversed objects.
	      stackA.push(object);
	      stackB.push(other);
	
	      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	      stackA.pop();
	      stackB.pop();
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} matchData The propery names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = toObject(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which does not clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        var key = matchData[0][0],
	            value = matchData[0][1];
	
	        return function(object) {
	          if (object == null) {
	            return false;
	          }
	          return object[key] === value && (value !== undefined || (key in toObject(object)));
	        };
	      }
	      return function(object) {
	        return baseIsMatch(object, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to compare.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      var isArr = isArray(path),
	          isCommon = isKey(path) && isStrictComparable(srcValue),
	          pathKey = (path + '');
	
	      path = toPath(path);
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        var key = pathKey;
	        object = toObject(object);
	        if ((isArr || !isCommon) && !(key in object)) {
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          if (object == null) {
	            return false;
	          }
	          key = last(path);
	          object = toObject(object);
	        }
	        return object[key] === srcValue
	          ? (srcValue !== undefined || (key in object))
	          : baseIsEqual(srcValue, object[key], undefined, true);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for argument juggling,
	     * multiple sources, and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {Object} Returns `object`.
	     */
	    function baseMerge(object, source, customizer, stackA, stackB) {
	      if (!isObject(object)) {
	        return object;
	      }
	      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
	          props = isSrcArr ? undefined : keys(source);
	
	      arrayEach(props || source, function(srcValue, key) {
	        if (props) {
	          key = srcValue;
	          srcValue = source[key];
	        }
	        if (isObjectLike(srcValue)) {
	          stackA || (stackA = []);
	          stackB || (stackB = []);
	          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
	        }
	        else {
	          var value = object[key],
	              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	              isCommon = result === undefined;
	
	          if (isCommon) {
	            result = srcValue;
	          }
	          if ((result !== undefined || (isSrcArr && !(key in object))) &&
	              (isCommon || (result === result ? (result !== value) : (value === value)))) {
	            object[key] = result;
	          }
	        }
	      });
	      return object;
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
	      var length = stackA.length,
	          srcValue = source[key];
	
	      while (length--) {
	        if (stackA[length] == srcValue) {
	          object[key] = stackB[length];
	          return;
	        }
	      }
	      var value = object[key],
	          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	          isCommon = result === undefined;
	
	      if (isCommon) {
	        result = srcValue;
	        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
	          result = isArray(value)
	            ? value
	            : (isArrayLike(value) ? arrayCopy(value) : []);
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          result = isArguments(value)
	            ? toPlainObject(value)
	            : (isPlainObject(value) ? value : {});
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate
	      // it with its merged value.
	      stackA.push(srcValue);
	      stackB.push(result);
	
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
	      } else if (result === result ? (result !== value) : (value === value)) {
	        object[key] = result;
	      }
	    }
	
	    /**
	     * The base implementation of `_.property` without support for deep paths.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function baseProperty(key) {
	      return function(object) {
	        return object == null ? undefined : object[key];
	      };
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function basePropertyDeep(path) {
	      var pathKey = (path + '');
	      path = toPath(path);
	      return function(object) {
	        return baseGet(object, path, pathKey);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * index arguments and capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0;
	      while (length--) {
	        var index = indexes[length];
	        if (index != previous && isIndex(index)) {
	          var previous = index;
	          splice.call(array, index, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for argument juggling
	     * and returning floating-point numbers.
	     *
	     * @private
	     * @param {number} min The minimum possible value.
	     * @param {number} max The maximum possible value.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(min, max) {
	      return min + nativeFloor(nativeRandom() * (max - min + 1));
	    }
	
	    /**
	     * The base implementation of `_.reduce` and `_.reduceRight` without support
	     * for callback shorthands and `this` binding, which iterates over `collection`
	     * using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} accumulator The initial value.
	     * @param {boolean} initFromCollection Specify using the first or last element
	     *  of `collection` as the initial value.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @returns {*} Returns the accumulated value.
	     */
	    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
	      eachFunc(collection, function(value, index, collection) {
	        accumulator = initFromCollection
	          ? (initFromCollection = false, value)
	          : iteratee(accumulator, value, index, collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop detection.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortBy` which uses `comparer` to define
	     * the sort order of `array` and replaces criteria objects with their
	     * corresponding values.
	     *
	     * @private
	     * @param {Array} array The array to sort.
	     * @param {Function} comparer The function to define sort order.
	     * @returns {Array} Returns `array`.
	     */
	    function baseSortBy(array, comparer) {
	      var length = array.length;
	
	      array.sort(comparer);
	      while (length--) {
	        array[length] = array[length].value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.sortByOrder` without param guards.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseSortByOrder(collection, iteratees, orders) {
	      var callback = getCallback(),
	          index = -1;
	
	      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });
	
	      var result = baseMap(collection, function(value) {
	        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.sum` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function baseSum(collection, iteratee) {
	      var result = 0;
	      baseEach(collection, function(value, index, collection) {
	        result += +iteratee(value, index, collection) || 0;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.uniq` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The function invoked per iteration.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     */
	    function baseUniq(array, iteratee) {
	      var index = -1,
	          indexOf = getIndexOf(),
	          length = array.length,
	          isCommon = indexOf == baseIndexOf,
	          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
	          seen = isLarge ? createCache() : null,
	          result = [];
	
	      if (seen) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	      } else {
	        isLarge = false;
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value, index, array) : value;
	
	        if (isCommon && value === value) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (indexOf(seen, computed, 0) < 0) {
	          if (iteratee || isLarge) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.values` and `_.valuesIn` which creates an
	     * array of `object` property values corresponding to the property names
	     * of `props`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} props The property names to get values for.
	     * @returns {Object} Returns the array of property values.
	     */
	    function baseValues(object, props) {
	      var index = -1,
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = object[props[index]];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
	     * and `_.takeWhile` without support for callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to peform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      var index = -1,
	          length = actions.length;
	
	      while (++index < length) {
	        var action = actions[index];
	        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }
	      return result;
	    }
	
	    /**
	     * Performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return binaryIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * This function is like `binaryIndex` except that it invokes `iteratee` for
	     * `value` and each element of `array` to compute their sort ranking. The
	     * iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsUndef = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            isDef = computed !== undefined,
	            isReflexive = computed === computed;
	
	        if (valIsNaN) {
	          var setLow = isReflexive || retHighest;
	        } else if (valIsNull) {
	          setLow = isReflexive && isDef && (retHighest || computed != null);
	        } else if (valIsUndef) {
	          setLow = isReflexive && (retHighest || isDef);
	        } else if (computed == null) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * A specialized version of `baseCallback` which only supports `this` binding
	     * and specifying the number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function bindCallback(func, thisArg, argCount) {
	      if (typeof func != 'function') {
	        return identity;
	      }
	      if (thisArg === undefined) {
	        return func;
	      }
	      switch (argCount) {
	        case 1: return function(value) {
	          return func.call(thisArg, value);
	        };
	        case 3: return function(value, index, collection) {
	          return func.call(thisArg, value, index, collection);
	        };
	        case 4: return function(accumulator, value, index, collection) {
	          return func.call(thisArg, accumulator, value, index, collection);
	        };
	        case 5: return function(value, other, key, object, source) {
	          return func.call(thisArg, value, other, key, object, source);
	        };
	      }
	      return function() {
	        return func.apply(thisArg, arguments);
	      };
	    }
	
	    /**
	     * Creates a clone of the given array buffer.
	     *
	     * @private
	     * @param {ArrayBuffer} buffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function bufferClone(buffer) {
	      var result = new ArrayBuffer(buffer.byteLength),
	          view = new Uint8Array(result);
	
	      view.set(new Uint8Array(buffer));
	      return result;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders) {
	      var holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          leftIndex = -1,
	          leftLength = partials.length,
	          result = Array(leftLength + argsLength);
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        result[holders[argsIndex]] = args[argsIndex];
	      }
	      while (argsLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders) {
	      var holdersIndex = -1,
	          holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          rightIndex = -1,
	          rightLength = partials.length,
	          result = Array(argsLength + rightLength);
	
	      while (++argsIndex < argsLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        result[offset + holders[holdersIndex]] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
	     *
	     * @private
	     * @param {Function} setter The function to set keys and values of the accumulator object.
	     * @param {Function} [initializer] The function to initialize the accumulator object.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee, thisArg) {
	        var result = initializer ? initializer() : {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        if (isArray(collection)) {
	          var index = -1,
	              length = collection.length;
	
	          while (++index < length) {
	            var value = collection[index];
	            setter(result, value, iteratee(value, index, collection), collection);
	          }
	        } else {
	          baseEach(collection, function(value, key, collection) {
	            setter(result, value, iteratee(value, key, collection), collection);
	          });
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return restParam(function(object, sources) {
	        var index = -1,
	            length = object == null ? 0 : sources.length,
	            customizer = length > 2 ? sources[length - 2] : undefined,
	            guard = length > 2 ? sources[2] : undefined,
	            thisArg = length > 1 ? sources[length - 1] : undefined;
	
	        if (typeof customizer == 'function') {
	          customizer = bindCallback(customizer, thisArg, 5);
	          length -= 2;
	        } else {
	          customizer = typeof thisArg == 'function' ? thisArg : undefined;
	          length -= (customizer ? 1 : 0);
	        }
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        var length = collection ? getLength(collection) : 0;
	        if (!isLength(length)) {
	          return eachFunc(collection, iteratee);
	        }
	        var index = fromRight ? length : -1,
	            iterable = toObject(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var iterable = toObject(object),
	            props = keysFunc(object),
	            length = props.length,
	            index = fromRight ? length : -1;
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var key = props[index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createBindWrapper(func, thisArg) {
	      var Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(thisArg, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `Set` cache object to optimize linear searches of large arrays.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	     */
	    function createCache(values) {
	      return (nativeCreate && Set) ? new SetCache(values) : null;
	    }
	
	    /**
	     * Creates a function that produces compound words out of the words in a
	     * given string.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        var index = -1,
	            array = words(deburr(string)),
	            length = array.length,
	            result = '';
	
	        while (++index < length) {
	          result = callback(result, array[index], index);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtorWrapper(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors.
	        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a `_.curry` or `_.curryRight` function.
	     *
	     * @private
	     * @param {boolean} flag The curry bit flag.
	     * @returns {Function} Returns the new curry function.
	     */
	    function createCurry(flag) {
	      function curryFunc(func, arity, guard) {
	        if (guard && isIterateeCall(func, arity, guard)) {
	          arity = undefined;
	        }
	        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
	        result.placeholder = curryFunc.placeholder;
	        return result;
	      }
	      return curryFunc;
	    }
	
	    /**
	     * Creates a `_.defaults` or `_.defaultsDeep` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Function} Returns the new defaults function.
	     */
	    function createDefaults(assigner, customizer) {
	      return restParam(function(args) {
	        var object = args[0];
	        if (object == null) {
	          return object;
	        }
	        args.push(customizer);
	        return assigner.apply(undefined, args);
	      });
	    }
	
	    /**
	     * Creates a `_.max` or `_.min` function.
	     *
	     * @private
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {Function} Returns the new extremum function.
	     */
	    function createExtremum(comparator, exValue) {
	      return function(collection, iteratee, thisArg) {
	        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	          iteratee = undefined;
	        }
	        iteratee = getCallback(iteratee, thisArg, 3);
	        if (iteratee.length == 1) {
	          collection = isArray(collection) ? collection : toIterable(collection);
	          var result = arrayExtremum(collection, iteratee, comparator, exValue);
	          if (!(collection.length && result === exValue)) {
	            return result;
	          }
	        }
	        return baseExtremum(collection, iteratee, comparator, exValue);
	      };
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(eachFunc, fromRight) {
	      return function(collection, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        if (isArray(collection)) {
	          var index = baseFindIndex(collection, predicate, fromRight);
	          return index > -1 ? collection[index] : undefined;
	        }
	        return baseFind(collection, predicate, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a `_.findIndex` or `_.findLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindIndex(fromRight) {
	      return function(array, predicate, thisArg) {
	        if (!(array && array.length)) {
	          return -1;
	        }
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFindIndex(array, predicate, fromRight);
	      };
	    }
	
	    /**
	     * Creates a `_.findKey` or `_.findLastKey` function.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindKey(objectFunc) {
	      return function(object, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFind(object, predicate, objectFunc, true);
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return function() {
	        var wrapper,
	            length = arguments.length,
	            index = fromRight ? length : -1,
	            leftIndex = 0,
	            funcs = Array(length);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var func = funcs[leftIndex++] = arguments[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
	            wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? -1 : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      };
	    }
	
	    /**
	     * Creates a function for `_.forEach` or `_.forEachRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForEach(arrayFunc, eachFunc) {
	      return function(collection, iteratee, thisArg) {
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee)
	          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
	      };
	    }
	
	    /**
	     * Creates a function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForIn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee, keysIn);
	      };
	    }
	
	    /**
	     * Creates a function for `_.forOwn` or `_.forOwnRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForOwn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee);
	      };
	    }
	
	    /**
	     * Creates a function for `_.mapKeys` or `_.mapValues`.
	     *
	     * @private
	     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
	     * @returns {Function} Returns the new map function.
	     */
	    function createObjectMapper(isMapKeys) {
	      return function(object, iteratee, thisArg) {
	        var result = {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        baseForOwn(object, function(value, key, object) {
	          var mapped = iteratee(value, key, object);
	          key = isMapKeys ? mapped : key;
	          value = isMapKeys ? value : mapped;
	          result[key] = value;
	        });
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function for `_.padLeft` or `_.padRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify padding from the right.
	     * @returns {Function} Returns the new pad function.
	     */
	    function createPadDir(fromRight) {
	      return function(string, length, chars) {
	        string = baseToString(string);
	        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
	      };
	    }
	
	    /**
	     * Creates a `_.partial` or `_.partialRight` function.
	     *
	     * @private
	     * @param {boolean} flag The partial bit flag.
	     * @returns {Function} Returns the new partial function.
	     */
	    function createPartial(flag) {
	      var partialFunc = restParam(function(func, partials) {
	        var holders = replaceHolders(partials, partialFunc.placeholder);
	        return createWrapper(func, flag, undefined, partials, holders);
	      });
	      return partialFunc;
	    }
	
	    /**
	     * Creates a function for `_.reduce` or `_.reduceRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createReduce(arrayFunc, eachFunc) {
	      return function(collection, iteratee, accumulator, thisArg) {
	        var initFromArray = arguments.length < 3;
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
	          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with optional `this`
	     * binding of, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurry = bitmask & CURRY_FLAG,
	          isCurryBound = bitmask & CURRY_BOUND_FLAG,
	          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
	          Ctor = isBindKey ? undefined : createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it to other functions.
	        var length = arguments.length,
	            index = length,
	            args = Array(length);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight);
	        }
	        if (isCurry || isCurryRight) {
	          var placeholder = wrapper.placeholder,
	              argsHolders = replaceHolders(args, placeholder);
	
	          length -= argsHolders.length;
	          if (length < arity) {
	            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
	                newArity = nativeMax(arity - length, 0),
	                newsHolders = isCurry ? argsHolders : undefined,
	                newHoldersRight = isCurry ? undefined : argsHolders,
	                newPartials = isCurry ? args : undefined,
	                newPartialsRight = isCurry ? undefined : args;
	
	            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	            if (!isCurryBound) {
	              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	            }
	            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
	                result = createHybridWrapper.apply(undefined, newData);
	
	            if (isLaziable(func)) {
	              setData(result, newData);
	            }
	            result.placeholder = placeholder;
	            return result;
	          }
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        if (argPos) {
	          args = reorder(args, argPos);
	        }
	        if (isAry && ary < args.length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtorWrapper(func);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates the padding required for `string` based on the given `length`.
	     * The `chars` string is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {string} string The string to create padding for.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the pad for `string`.
	     */
	    function createPadding(string, length, chars) {
	      var strLength = string.length;
	      length = +length;
	
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return '';
	      }
	      var padLength = length - strLength;
	      chars = chars == null ? ' ' : (chars + '');
	      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the optional `this`
	     * binding of `thisArg` and the `partials` prepended to those provided to
	     * the wrapper.
	     *
	     * @private
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to the new function.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createPartialWrapper(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it `func`.
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength);
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        precision = precision === undefined ? 0 : (+precision || 0);
	        if (precision) {
	          precision = pow(10, precision);
	          return func(number * precision) / precision;
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {Function} Returns the new index function.
	     */
	    function createSortedIndex(retHighest) {
	      return function(array, value, iteratee, thisArg) {
	        var callback = getCallback(iteratee);
	        return (iteratee == null && callback === baseCallback)
	          ? binaryIndex(array, value, retHighest)
	          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      length -= (holders ? holders.length : 0);
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func),
	          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
	
	      if (data) {
	        mergeData(newData, data);
	        bitmask = newData[1];
	        arity = newData[9];
	      }
	      newData[9] = arity == null
	        ? (isBindKey ? 0 : func.length)
	        : (nativeMax(arity - length, 0) || 0);
	
	      if (bitmask == BIND_FLAG) {
	        var result = createBindWrapper(newData[0], newData[2]);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
	        result = createPartialWrapper.apply(undefined, newData);
	      } else {
	        result = createHybridWrapper.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setter(result, newData);
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing arrays.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var index = -1,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	        return false;
	      }
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index],
	            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	        if (result !== undefined) {
	          if (result) {
	            continue;
	          }
	          return false;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (isLoose) {
	          if (!arraySome(other, function(othValue) {
	                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	              })) {
	            return false;
	          }
	        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag) {
	      switch (tag) {
	        case boolTag:
	        case dateTag:
	          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	          return +object == +other;
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case numberTag:
	          // Treat `NaN` vs. `NaN` as equal.
	          return (object != +object)
	            ? other != +other
	            : object == +other;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings primitives and string
	          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	          return object == (other + '');
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isLoose) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      var skipCtor = isLoose;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key],
	            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	          return false;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (!skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Gets the appropriate "callback" function. If the `_.callback` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseCallback` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getCallback(func, thisArg, argCount) {
	      var result = lodash.callback || callback;
	      result = result === callback ? baseCallback : result;
	      return argCount ? result(func, thisArg, argCount) : result;
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = func.name,
	          array = realNames[result],
	          length = array ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseIndexOf` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function|number} Returns the chosen function or its result.
	     */
	    function getIndexOf(collection, target, fromIndex) {
	      var result = lodash.indexOf || indexOf;
	      result = result === indexOf ? baseIndexOf : result;
	      return collection ? result(collection, target, fromIndex) : result;
	    }
	
	    /**
	     * Gets the "length" property value of `object`.
	     *
	     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	     * that affects Safari on at least iOS 8.1-8.3 ARM64.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {*} Returns the "length" value.
	     */
	    var getLength = baseProperty('length');
	
	    /**
	     * Gets the propery names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = pairs(object),
	          length = result.length;
	
	      while (length--) {
	        result[length][2] = isStrictComparable(result[length][1]);
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = object == null ? undefined : object[key];
	      return isNative(value) ? value : undefined;
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add array properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      var Ctor = object.constructor;
	      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
	        Ctor = Object;
	      }
	      return new Ctor;
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return bufferClone(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          var buffer = object.buffer;
	          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          var result = new Ctor(object.source, reFlags.exec(object));
	          result.lastIndex = object.lastIndex;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the method at `path` on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function invokePath(object, path, args) {
	      if (object != null && !isKey(path, object)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        path = last(path);
	      }
	      var func = object == null ? object : object[path];
	      return func == null ? undefined : func.apply(object, args);
	    }
	
	    /**
	     * Checks if `value` is array-like.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(getLength(value));
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return value > -1 && value % 1 == 0 && value < length;
	    }
	
	    /**
	     * Checks if the provided arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	          ? (isArrayLike(object) && isIndex(index, object.length))
	          : (type == 'string' && index in object)) {
	        var other = object[index];
	        return value === value ? (value === other) : (other !== other);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      var type = typeof value;
	      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	        return true;
	      }
	      if (isArray(value)) {
	        return false;
	      }
	      var result = !reIsDeepProp.test(value);
	      return result || (object != null && value in toObject(object));
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func);
	      if (!(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      var other = lodash[funcName];
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     */
	    function isLength(value) {
	      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers required to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
	     * augment function arguments, making the order in which they are executed important,
	     * preventing the merging of metadata. However, we make an exception for a safe
	     * common case where curried functions have `_.ary` and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < ARY_FLAG;
	
	      var isCombo =
	        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
	        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
	        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = arrayCopy(value);
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function mergeDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties specified
	     * by `props`.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property names to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByArray(object, props) {
	      object = toObject(object);
	
	      var index = -1,
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index];
	        if (key in object) {
	          result[key] = object[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties `predicate`
	     * returns truthy for.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByCallback(object, predicate) {
	      var result = {};
	      baseForIn(object, function(value, key, object) {
	        if (predicate(value, key, object)) {
	          result[key] = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = arrayCopy(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity function
	     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = (function() {
	      var count = 0,
	          lastCalled = 0;
	
	      return function(key, value) {
	        var stamp = now(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return key;
	          }
	        } else {
	          count = 0;
	        }
	        return baseSetData(key, value);
	      };
	    }());
	
	    /**
	     * A fallback implementation of `Object.keys` which creates an array of the
	     * own enumerable property names of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function shimKeys(object) {
	      var props = keysIn(object),
	          propsLength = props.length,
	          length = propsLength && object.length;
	
	      var allowIndexes = !!length && isLength(length) &&
	        (isArray(object) || isArguments(object));
	
	      var index = -1,
	          result = [];
	
	      while (++index < propsLength) {
	        var key = props[index];
	        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to an array-like object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array|Object} Returns the array-like object.
	     */
	    function toIterable(value) {
	      if (value == null) {
	        return [];
	      }
	      if (!isArrayLike(value)) {
	        return values(value);
	      }
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to an object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Object} Returns the object.
	     */
	    function toObject(value) {
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to property path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array} Returns the property path array.
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return value;
	      }
	      var result = [];
	      baseToString(value).replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      return wrapper instanceof LazyWrapper
	        ? wrapper.clone()
	        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `collection` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new array containing chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if (guard ? isIterateeCall(array, size, guard) : size == null) {
	        size = 1;
	      } else {
	        size = nativeMax(nativeFloor(size) || 1, 1);
	      }
	      var index = 0,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[++resIndex] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of unique `array` values not included in the other
	     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The arrays of values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.difference([1, 2, 3], [4, 2]);
	     * // => [1, 3]
	     */
	    var difference = restParam(function(array, values) {
	      return (isObjectLike(array) && isArrayLike(array))
	        ? baseDifference(array, baseFlatten(values, false, true))
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that match the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [1]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active', false), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8], '*', 1, 2);
	     * // => [4, '*', 8]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(chr) {
	     *   return chr.user == 'barney';
	     * });
	     * // => 0
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findIndex(users, 'active', false);
	     * // => 0
	     *
	     * // using the `_.property` callback shorthand
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    var findIndex = createFindIndex();
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(chr) {
	     *   return chr.user == 'pebbles';
	     * });
	     * // => 2
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastIndex(users, 'active', false);
	     * // => 2
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    var findLastIndex = createFindIndex(true);
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias head
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.first([1, 2, 3]);
	     * // => 1
	     *
	     * _.first([]);
	     * // => undefined
	     */
	    function first(array) {
	      return array ? array[0] : undefined;
	    }
	
	    /**
	     * Flattens a nested array. If `isDeep` is `true` the array is recursively
	     * flattened, otherwise it is only flattened a single level.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, [4]]
	     *
	     * // using `isDeep`
	     * _.flatten([1, [2, 3, [4]]], true);
	     * // => [1, 2, 3, 4]
	     */
	    function flatten(array, isDeep, guard) {
	      var length = array ? array.length : 0;
	      if (guard && isIterateeCall(array, isDeep, guard)) {
	        isDeep = false;
	      }
	      return length ? baseFlatten(array, isDeep) : [];
	    }
	
	    /**
	     * Recursively flattens a nested array.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to recursively flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, 4]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, true) : [];
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
	     * performs a faster binary search.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
	     *  to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // using `fromIndex`
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     *
	     * // performing a binary search
	     * _.indexOf([1, 1, 2, 2], 2, true);
	     * // => 2
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      if (typeof fromIndex == 'number') {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
	      } else if (fromIndex) {
	        var index = binaryIndex(array, value);
	        if (index < length &&
	            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
	          return index;
	        }
	        return -1;
	      }
	      return baseIndexOf(array, value, fromIndex || 0);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      return dropRight(array, 1);
	    }
	
	    /**
	     * Creates an array of unique values that are included in all of the provided
	     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of shared values.
	     * @example
	     * _.intersection([1, 2], [4, 2], [2, 1]);
	     * // => [2]
	     */
	    var intersection = restParam(function(arrays) {
	      var othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(length),
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          result = [];
	
	      while (othIndex--) {
	        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
	        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
	      }
	      var array = arrays[0],
	          index = -1,
	          length = array ? array.length : 0,
	          seen = caches[0];
	
	      outer:
	      while (++index < length) {
	        value = array[index];
	        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
	          var othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(value);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    });
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
	     *  or `true` to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // using `fromIndex`
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     *
	     * // performing a binary search
	     * _.lastIndexOf([1, 1, 2, 2], 2, true);
	     * // => 3
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (typeof fromIndex == 'number') {
	        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
	      } else if (fromIndex) {
	        index = binaryIndex(array, value, true) - 1;
	        var other = array[index];
	        if (value === value ? (value === other) : (other !== other)) {
	          return index;
	        }
	        return -1;
	      }
	      if (value !== value) {
	        return indexOfNaN(array, index, true);
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Removes all provided values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3, 1, 2, 3];
	     *
	     * _.pull(array, 2, 3);
	     * console.log(array);
	     * // => [1, 1]
	     */
	    function pull() {
	      var args = arguments,
	          array = args[0];
	
	      if (!(array && array.length)) {
	        return array;
	      }
	      var index = 0,
	          indexOf = getIndexOf(),
	          length = args.length;
	
	      while (++index < length) {
	        var fromIndex = 0,
	            value = args[index];
	
	        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to the given indexes and returns
	     * an array of the removed elements. Indexes may be specified as an array of
	     * indexes or as individual arguments.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [5, 10, 15, 20];
	     * var evens = _.pullAt(array, 1, 3);
	     *
	     * console.log(array);
	     * // => [5, 15]
	     *
	     * console.log(evens);
	     * // => [10, 20]
	     */
	    var pullAt = restParam(function(array, indexes) {
	      indexes = baseFlatten(indexes);
	
	      var result = baseAt(array, indexes);
	      basePullAt(array, indexes.sort(baseCompareAscending));
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate, thisArg) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getCallback(predicate, thisArg, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias tail
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.rest([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function rest(array) {
	      return drop(array, 1);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of `Array#slice` to support node
	     * lists in IE < 9 and to ensure dense arrays are returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value` should
	     * be inserted into `array` in order to maintain its sort order. If an iteratee
	     * function is provided it is invoked for `value` and each element of `array`
	     * to compute their sort ranking. The iteratee is bound to `thisArg` and
	     * invoked with one argument; (value).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     *
	     * _.sortedIndex([4, 4, 5, 5], 5);
	     * // => 2
	     *
	     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
	     *
	     * // using an iteratee function
	     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
	     *   return this.data[word];
	     * }, dict);
	     * // => 1
	     *
	     * // using the `_.property` callback shorthand
	     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
	     * // => 1
	     */
	    var sortedIndex = createSortedIndex();
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 4, 5, 5], 5);
	     * // => 4
	     */
	    var sortedLastIndex = createSortedIndex(true);
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
	     * and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [2, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [1, 2]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active', false), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all of the provided arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([1, 2], [4, 2], [2, 1]);
	     * // => [1, 2, 4]
	     */
	    var union = restParam(function(arrays) {
	      return baseUniq(baseFlatten(arrays, false, true));
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurence of each element
	     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
	     * for sorted arrays. If an iteratee function is provided it is invoked for
	     * each element in the array to generate the criterion by which uniqueness
	     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, array).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias unique
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {boolean} [isSorted] Specify the array is sorted.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     *
	     * // using `isSorted`
	     * _.uniq([1, 1, 2], true);
	     * // => [1, 2]
	     *
	     * // using an iteratee function
	     * _.uniq([1, 2.5, 1.5, 2], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => [1, 2.5]
	     *
	     * // using the `_.property` callback shorthand
	     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniq(array, isSorted, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (isSorted != null && typeof isSorted != 'boolean') {
	        thisArg = iteratee;
	        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
	        isSorted = false;
	      }
	      var callback = getCallback();
	      if (!(iteratee == null && callback === baseCallback)) {
	        iteratee = callback(iteratee, thisArg, 3);
	      }
	      return (isSorted && getIndexOf() == baseIndexOf)
	        ? sortedUniq(array, iteratee)
	        : baseUniq(array, iteratee);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['fred', 'barney'], [30, 40], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var index = -1,
	          length = 0;
	
	      array = arrayFilter(array, function(group) {
	        if (isArrayLike(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = arrayMap(array, baseProperty(index));
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts an iteratee to specify
	     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee] The function to combine regrouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      iteratee = bindCallback(iteratee, thisArg, 4);
	      return arrayMap(result, function(group) {
	        return arrayReduce(group, iteratee, undefined, true);
	      });
	    }
	
	    /**
	     * Creates an array excluding all provided values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to filter.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.without([1, 2, 1, 3], 1, 2);
	     * // => [3]
	     */
	    var without = restParam(function(array, values) {
	      return isArrayLike(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the provided arrays.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * _.xor([1, 2], [4, 2]);
	     * // => [1, 4]
	     */
	    function xor() {
	      var index = -1,
	          length = arguments.length;
	
	      while (++index < length) {
	        var array = arguments[index];
	        if (isArrayLike(array)) {
	          var result = result
	            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
	            : array;
	        }
	      }
	      return result ? baseUniq(result) : [];
	    }
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the first
	     * elements of the given arrays, the second of which contains the second elements
	     * of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     */
	    var zip = restParam(unzip);
	
	    /**
	     * The inverse of `_.pairs`; this method returns an object composed from arrays
	     * of property names and values. Provide either a single two dimensional array,
	     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
	     * and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @alias object
	     * @category Array
	     * @param {Array} props The property names.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject([['fred', 30], ['barney', 40]]);
	     * // => { 'fred': 30, 'barney': 40 }
	     *
	     * _.zipObject(['fred', 'barney'], [30, 40]);
	     * // => { 'fred': 30, 'barney': 40 }
	     */
	    function zipObject(props, values) {
	      var index = -1,
	          length = props ? props.length : 0,
	          result = {};
	
	      if (length && !values && !isArray(props[0])) {
	        values = [];
	      }
	      while (++index < length) {
	        var key = props[index];
	        if (values) {
	          result[key] = values[index];
	        } else if (key) {
	          result[key[0]] = key[1];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an iteratee to specify
	     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee] The function to combine grouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
	     * // => [111, 222]
	     */
	    var zipWith = restParam(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 2 ? arrays[length - 2] : undefined,
	          thisArg = length > 1 ? arrays[length - 1] : undefined;
	
	      if (length > 2 && typeof iteratee == 'function') {
	        length -= 2;
	      } else {
	        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
	        thisArg = undefined;
	      }
	      arrays.length = length;
	      return unzipWith(arrays, iteratee, thisArg);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object that wraps `value` with explicit method
	     * chaining enabled.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _.chain(users)
	     *   .sortBy('age')
	     *   .map(function(chr) {
	     *     return chr.user + ' is ' + chr.age;
	     *   })
	     *   .first()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor is
	     * bound to `thisArg` and invoked with one argument; (value). The purpose of
	     * this method is to "tap into" a method chain in order to perform operations
	     * on intermediate results within the chain.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor, thisArg) {
	      interceptor.call(thisArg, value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor, thisArg) {
	      return interceptor.call(thisArg, value);
	    }
	
	    /**
	     * Enables explicit method chaining on the wrapper object.
	     *
	     * @name chain
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // without explicit chaining
	     * _(users).first();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // with explicit chaining
	     * _(users).chain()
	     *   .first()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chained sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Creates a new array joining a wrapped array with any additional arrays
	     * and/or values.
	     *
	     * @name concat
	     * @memberOf _
	     * @category Chain
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var wrapped = _(array).concat(2, [3], [[4]]);
	     *
	     * console.log(wrapped.value());
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    var wrapperConcat = restParam(function(values) {
	      values = baseFlatten(values);
	      return this.thru(function(array) {
	        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
	      });
	    });
	
	    /**
	     * Creates a clone of the chained sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).map(function(value) {
	     *   return Math.pow(value, 2);
	     * });
	     *
	     * var other = [3, 4];
	     * var otherWrapped = wrapped.plant(other);
	     *
	     * otherWrapped.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * Reverses the wrapped array so the first element becomes the last, the
	     * second element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	
	      var interceptor = function(value) {
	        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
	      };
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(interceptor);
	    }
	
	    /**
	     * Produces the result of coercing the unwrapped value to a string.
	     *
	     * @name toString
	     * @memberOf _
	     * @category Chain
	     * @returns {string} Returns the coerced string value.
	     * @example
	     *
	     * _([1, 2, 3]).toString();
	     * // => '1,2,3'
	     */
	    function wrapperToString() {
	      return (this.value() + '');
	    }
	
	    /**
	     * Executes the chained sequence to extract the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @alias run, toJSON, valueOf
	     * @category Chain
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements corresponding to the given keys, or indexes,
	     * of `collection`. Keys may be specified as individual arguments or as arrays
	     * of keys.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(number|number[]|string|string[])} [props] The property names
	     *  or indexes of elements to pick, specified individually or in arrays.
	     * @returns {Array} Returns the new array of picked elements.
	     * @example
	     *
	     * _.at(['a', 'b', 'c'], [0, 2]);
	     * // => ['a', 'c']
	     *
	     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
	     * // => ['barney', 'pebbles']
	     */
	    var at = restParam(function(collection, props) {
	      return baseAt(collection, baseFlatten(props));
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the number of times the key was returned by `iteratee`.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * The predicate is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias all
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': false },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.every(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias select
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.filter([4, 5, 6], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 6]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.filter(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.filter(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function filter(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias detect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.result(_.find(users, function(chr) {
	     *   return chr.age < 40;
	     * }), 'user');
	     * // => 'barney'
	     *
	     * // using the `_.matches` callback shorthand
	     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.result(_.find(users, 'active', false), 'user');
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.result(_.find(users, 'active'), 'user');
	     * // => 'barney'
	     */
	    var find = createFind(baseEach);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(baseEachRight, true);
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning the first element that has equivalent property
	     * values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
	     * // => 'barney'
	     *
	     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
	     * // => 'fred'
	     */
	    function findWhere(collection, source) {
	      return find(collection, baseMatches(source));
	    }
	
	    /**
	     * Iterates over elements of `collection` invoking `iteratee` for each element.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection). Iteratee functions may exit iteration early
	     * by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length" property
	     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
	     * may be used for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @alias each
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEach(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from left to right and returns the array
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
	     *   console.log(n, key);
	     * });
	     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
	     */
	    var forEach = createForEach(arrayEach, baseEach);
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEachRight(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from right to left and returns the array
	     */
	    var forEachRight = createForEach(arrayEachRight, baseEachRight);
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is an array of the elements responsible for generating the key.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * // using the `_.property` callback shorthand
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        result[key] = [value];
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @alias contains, include
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {*} target The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	     * // => true
	     *
	     * _.includes('pebbles', 'eb');
	     * // => true
	     */
	    function includes(collection, target, fromIndex, guard) {
	      var length = collection ? getLength(collection) : 0;
	      if (!isLength(length)) {
	        collection = values(collection);
	        length = collection.length;
	      }
	      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
	        fromIndex = 0;
	      } else {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
	      }
	      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
	        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
	        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the last element responsible for generating the key. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var keyData = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.indexBy(keyData, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return String.fromCharCode(object.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return this.fromCharCode(object.code);
	     * }, String);
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     */
	    var indexBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `methodName` is a function it is
	     * invoked for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invoke([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invoke = restParam(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` through
	     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
	     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
	     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
	     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
	     * `sum`, `uniq`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @alias collect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function timesThree(n) {
	     *   return n * 3;
	     * }
	     *
	     * _.map([1, 2], timesThree);
	     * // => [3, 6]
	     *
	     * _.map({ 'a': 1, 'b': 2 }, timesThree);
	     * // => [3, 6] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee, thisArg) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return func(collection, iteratee);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, while the second of which
	     * contains elements `predicate` returns falsey for. The predicate is bound
	     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * _.partition([1, 2, 3], function(n) {
	     *   return n % 2;
	     * });
	     * // => [[1, 3], [2]]
	     *
	     * _.partition([1.2, 2.3, 3.4], function(n) {
	     *   return this.floor(n) % 2;
	     * }, Math);
	     * // => [[1.2, 3.4], [2.3]]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * var mapper = function(array) {
	     *   return _.pluck(array, 'user');
	     * };
	     *
	     * // using the `_.matches` callback shorthand
	     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
	     * // => [['pebbles'], ['barney', 'fred']]
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.map(_.partition(users, 'active', false), mapper);
	     * // => [['barney', 'pebbles'], ['fred']]
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(_.partition(users, 'active'), mapper);
	     * // => [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Gets the property value of `path` from all elements in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|string} path The path of the property to pluck.
	     * @returns {Array} Returns the property values.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.pluck(users, 'user');
	     * // => ['barney', 'fred']
	     *
	     * var userIndex = _.indexBy(users, 'user');
	     * _.pluck(userIndex, 'age');
	     * // => [36, 40] (iteration order is not guaranteed)
	     */
	    function pluck(collection, path) {
	      return map(collection, property(path));
	    }
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` through `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not provided the first element of `collection` is used as the initial
	     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
	     * and `sortByOrder`
	     *
	     * @static
	     * @memberOf _
	     * @alias foldl, inject
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.reduce([1, 2], function(total, n) {
	     *   return total + n;
	     * });
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     *   return result;
	     * }, {});
	     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
	     */
	    var reduce = createReduce(arrayReduce, baseEach);
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias foldr
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    var reduceRight = createReduce(arrayReduceRight, baseEachRight);
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.reject([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [1, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.reject(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.reject(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function reject(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, function(value, index, collection) {
	        return !predicate(value, index, collection);
	      });
	    }
	
	    /**
	     * Gets a random element or `n` random elements from a collection.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to sample.
	     * @param {number} [n] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {*} Returns the random sample(s).
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     *
	     * _.sample([1, 2, 3, 4], 2);
	     * // => [3, 1]
	     */
	    function sample(collection, n, guard) {
	      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
	        collection = toIterable(collection);
	        var length = collection.length;
	        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
	      }
	      var index = -1,
	          result = toArray(collection),
	          length = result.length,
	          lastIndex = length - 1;
	
	      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
	      while (++index < n) {
	        var rand = baseRandom(index, lastIndex),
	            value = result[rand];
	
	        result[rand] = result[index];
	        result[index] = value;
	      }
	      result.length = n;
	      return result;
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      return sample(collection, POSITIVE_INFINITY);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the size of `collection`.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      var length = collection ? getLength(collection) : 0;
	      return isLength(length) ? length : keys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * The function returns as soon as it finds a passing value and does not iterate
	     * over the entire collection. The predicate is bound to `thisArg` and invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias any
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.some(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection through `iteratee`. This method performs
	     * a stable sort, that is, it preserves the original sort order of equal elements.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return Math.sin(n);
	     * });
	     * // => [3, 1, 2]
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return this.sin(n);
	     * }, Math);
	     * // => [3, 1, 2]
	     *
	     * var users = [
	     *   { 'user': 'fred' },
	     *   { 'user': 'pebbles' },
	     *   { 'user': 'barney' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.sortBy(users, 'user'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function sortBy(collection, iteratee, thisArg) {
	      if (collection == null) {
	        return [];
	      }
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      var index = -1;
	      iteratee = getCallback(iteratee, thisArg, 3);
	
	      var result = baseMap(collection, function(value, key, collection) {
	        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
	      });
	      return baseSortBy(result, compareAscending);
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it can sort by multiple iteratees
	     * or property names.
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
	     *  The iteratees to sort by, specified as individual values or arrays of values.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
	     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
	     *
	     * _.map(_.sortByAll(users, 'user', function(chr) {
	     *   return Math.floor(chr.age / 10);
	     * }), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    var sortByAll = restParam(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var guard = iteratees[2];
	      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
	        iteratees.length = 1;
	      }
	      return baseSortByOrder(collection, baseFlatten(iteratees), []);
	    });
	
	    /**
	     * This method is like `_.sortByAll` except that it allows specifying the
	     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
	     * values are sorted in ascending order. Otherwise, a value is sorted in
	     * ascending order if its corresponding order is "asc", and descending if "desc".
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // sort by `user` in ascending order and by `age` in descending order
	     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    function sortByOrder(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (guard && isIterateeCall(iteratees, orders, guard)) {
	        orders = undefined;
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseSortByOrder(collection, iteratees, orders);
	    }
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning an array of all elements that have equivalent
	     * property values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
	     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
	     * ];
	     *
	     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
	     * // => ['fred']
	     */
	    function where(collection, source) {
	      return filter(collection, baseMatches(source));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the number of milliseconds that have elapsed since the Unix epoch
	     * (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @category Date
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => logs the number of milliseconds it took for the deferred function to be invoked
	     */
	    var now = nativeNow || function() {
	      return new Date().getTime();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it is called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => logs 'done saving!' after the two async saves have completed
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      n = nativeIsFinite(n = +n) ? n : 0;
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that accepts up to `n` arguments ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      if (guard && isIterateeCall(func, n, guard)) {
	        n = undefined;
	      }
	      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
	      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it is called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery('#add').on('click', _.before(5, addContactToList));
	     * // => allows adding up to 4 contacts to the list
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and prepends any additional `_.bind` arguments to those provided to the
	     * bound function.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind` this method does not set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var greet = function(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * };
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // using placeholders
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = restParam(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bind.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method. Method names may be specified as individual arguments or as arrays
	     * of method names. If no method names are provided all enumerable function
	     * properties, own and inherited, of `object` are bound.
	     *
	     * **Note:** This method does not set the "length" property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} [methodNames] The object method names to bind,
	     *  specified as individual method names or arrays of method names.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'onClick': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view);
	     * jQuery('#docs').on('click', view.onClick);
	     * // => logs 'clicked docs' when the element is clicked
	     */
	    var bindAll = restParam(function(object, methodNames) {
	      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);
	
	      var index = -1,
	          length = methodNames.length;
	
	      while (++index < length) {
	        var key = methodNames[index];
	        object[key] = createWrapper(object[key], BIND_FLAG, object);
	      }
	      return object;
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` and prepends
	     * any additional `_.bindKey` arguments to those provided to the bound function.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist.
	     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object the method belongs to.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // using placeholders
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = restParam(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bindKey.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts one or more arguments of `func` that when
	     * called either invokes `func` returning its result, if all `func` arguments
	     * have been provided, or returns a function that accepts one or more of the
	     * remaining `func` arguments, and so on. The arity of `func` may be specified
	     * if `func.length` is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    var curry = createCurry(CURRY_FLAG);
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    var curryRight = createCurry(CURRY_RIGHT_FLAG);
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed invocations. Provide an options object to indicate that `func`
	     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
	     * Subsequent calls to the debounced function return the result of the last
	     * `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the debounced function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=false] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	     *  delayed before it is invoked.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // avoid costly calculations while the window size is in flux
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
	     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // ensure `batchLog` is invoked once after 1 second of debounced calls
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', _.debounce(batchLog, 250, {
	     *   'maxWait': 1000
	     * }));
	     *
	     * // cancel a debounced call
	     * var todoChanges = _.debounce(batchLog, 1000);
	     * Object.observe(models.todo, todoChanges);
	     *
	     * Object.observe(models, function(changes) {
	     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
	     *     todoChanges.cancel();
	     *   }
	     * }, ['delete']);
	     *
	     * // ...at some point `models.todo` is changed
	     * models.todo.completed = true;
	     *
	     * // ...before 1 second has passed `models.todo` is deleted
	     * // which cancels the debounced `todoChanges` call
	     * delete models.todo;
	     */
	    function debounce(func, wait, options) {
	      var args,
	          maxTimeoutId,
	          result,
	          stamp,
	          thisArg,
	          timeoutId,
	          trailingCall,
	          lastCalled = 0,
	          maxWait = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = wait < 0 ? 0 : (+wait || 0);
	      if (options === true) {
	        var leading = true;
	        trailing = false;
	      } else if (isObject(options)) {
	        leading = !!options.leading;
	        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function cancel() {
	        if (timeoutId) {
	          clearTimeout(timeoutId);
	        }
	        if (maxTimeoutId) {
	          clearTimeout(maxTimeoutId);
	        }
	        lastCalled = 0;
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	      }
	
	      function complete(isCalled, id) {
	        if (id) {
	          clearTimeout(id);
	        }
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	        if (isCalled) {
	          lastCalled = now();
	          result = func.apply(thisArg, args);
	          if (!timeoutId && !maxTimeoutId) {
	            args = thisArg = undefined;
	          }
	        }
	      }
	
	      function delayed() {
	        var remaining = wait - (now() - stamp);
	        if (remaining <= 0 || remaining > wait) {
	          complete(trailingCall, maxTimeoutId);
	        } else {
	          timeoutId = setTimeout(delayed, remaining);
	        }
	      }
	
	      function maxDelayed() {
	        complete(trailing, timeoutId);
	      }
	
	      function debounced() {
	        args = arguments;
	        stamp = now();
	        thisArg = this;
	        trailingCall = trailing && (timeoutId || !leading);
	
	        if (maxWait === false) {
	          var leadingCall = leading && !timeoutId;
	        } else {
	          if (!maxTimeoutId && !leading) {
	            lastCalled = stamp;
	          }
	          var remaining = maxWait - (stamp - lastCalled),
	              isCalled = remaining <= 0 || remaining > maxWait;
	
	          if (isCalled) {
	            if (maxTimeoutId) {
	              maxTimeoutId = clearTimeout(maxTimeoutId);
	            }
	            lastCalled = stamp;
	            result = func.apply(thisArg, args);
	          }
	          else if (!maxTimeoutId) {
	            maxTimeoutId = setTimeout(maxDelayed, remaining);
	          }
	        }
	        if (isCalled && timeoutId) {
	          timeoutId = clearTimeout(timeoutId);
	        }
	        else if (!timeoutId && wait !== maxWait) {
	          timeoutId = setTimeout(delayed, wait);
	        }
	        if (leadingCall) {
	          isCalled = true;
	          result = func.apply(thisArg, args);
	        }
	        if (isCalled && !timeoutId && !maxTimeoutId) {
	          args = thisArg = undefined;
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // logs 'deferred' after one or more milliseconds
	     */
	    var defer = restParam(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => logs 'later' after one second
	     */
	    var delay = restParam(function(func, wait, args) {
	      return baseDelay(func, wait, args);
	    });
	
	    /**
	     * Creates a function that returns the result of invoking the provided
	     * functions with the `this` binding of the created function, where each
	     * successive invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow(_.add, square);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the provided functions from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias backflow, compose
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight(square, _.add);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is coerced to a string and used as the
	     * cache key. The `func` is invoked with the `this` binding of the memoized
	     * function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoizing function.
	     * @example
	     *
	     * var upperCase = _.memoize(function(string) {
	     *   return string.toUpperCase();
	     * });
	     *
	     * upperCase('fred');
	     * // => 'FRED'
	     *
	     * // modifying the result cache
	     * upperCase.cache.set('fred', 'BARNEY');
	     * upperCase('fred');
	     * // => 'BARNEY'
	     *
	     * // replacing `_.memoize.Cache`
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'barney' };
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'fred' }
	     *
	     * _.memoize.Cache = WeakMap;
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'barney' }
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new memoize.Cache;
	      return memoized;
	    }
	
	    /**
	     * Creates a function that runs each argument through a corresponding
	     * transform function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms] The functions to transform
	     * arguments, specified as individual functions or arrays of functions.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var modded = _.modArgs(function(x, y) {
	     *   return [x, y];
	     * }, square, doubled);
	     *
	     * modded(1, 2);
	     * // => [1, 4]
	     *
	     * modded(5, 10);
	     * // => [25, 20]
	     */
	    var modArgs = restParam(function(func, transforms) {
	      transforms = baseFlatten(transforms);
	      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = transforms.length;
	      return restParam(function(args) {
	        var index = nativeMin(args.length, length);
	        while (index--) {
	          args[index] = transforms[index](args[index]);
	        }
	        return func.apply(this, args);
	      });
	    });
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        return !predicate.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first call. The `func` is invoked
	     * with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // `initialize` invokes `createApplication` once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with `partial` arguments prepended
	     * to those provided to the new function. This method is like `_.bind` except
	     * it does **not** alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // using placeholders
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = createPartial(PARTIAL_FLAG);
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to those provided to the new function.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // using placeholders
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified indexes where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, 2, 0, 1);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     *
	     * var map = _.rearg(_.map, [1, 0]);
	     * map(function(n) {
	     *   return n * 3;
	     * }, [1, 2, 3]);
	     * // => [3, 6, 9]
	     */
	    var rearg = restParam(function(func, indexes) {
	      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as an array.
	     *
	     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.restParam(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function restParam(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            rest = Array(length);
	
	        while (++index < length) {
	          rest[index] = args[start + index];
	        }
	        switch (start) {
	          case 0: return func.call(this, rest);
	          case 1: return func.call(this, args[0], rest);
	          case 2: return func.call(this, args[0], args[1], rest);
	        }
	        var otherArgs = Array(start + 1);
	        index = -1;
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = rest;
	        return func.apply(this, otherArgs);
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the created
	     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
	     *
	     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * // with a Promise
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function(array) {
	        return func.apply(this, array);
	      };
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed invocations. Provide an options object to indicate
	     * that `func` should be invoked on the leading and/or trailing edge of the
	     * `wait` timeout. Subsequent calls to the throttled function return the
	     * result of the last `func` call.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the throttled function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=true] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // avoid excessively updating the position while scrolling
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
	     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
	     *   'trailing': false
	     * }));
	     *
	     * // cancel a trailing throttled call
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (options === false) {
	        leading = false;
	      } else if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
	    }
	
	    /**
	     * Creates a function that provides `value` to the wrapper function as its
	     * first argument. Any additional arguments provided to the function are
	     * appended to those provided to the wrapper function. The wrapper is invoked
	     * with the `this` binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} wrapper The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
	     * otherwise they are assigned by reference. If `customizer` is provided it is
	     * invoked to produce the cloned values. If `customizer` returns `undefined`
	     * cloning is handled by the method instead. The `customizer` is bound to
	     * `thisArg` and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var shallow = _.clone(users);
	     * shallow[0] === users[0];
	     * // => true
	     *
	     * var deep = _.clone(users, true);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.clone(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 0
	     */
	    function clone(value, isDeep, customizer, thisArg) {
	      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
	        isDeep = false;
	      }
	      else if (typeof isDeep == 'function') {
	        thisArg = customizer;
	        customizer = isDeep;
	        isDeep = false;
	      }
	      return typeof customizer == 'function'
	        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, isDeep);
	    }
	
	    /**
	     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
	     * to produce the cloned values. If `customizer` returns `undefined` cloning
	     * is handled by the method instead. The `customizer` is bound to `thisArg`
	     * and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the deep cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var deep = _.cloneDeep(users);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.cloneDeep(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 20
	     */
	    function cloneDeep(value, customizer, thisArg) {
	      return typeof customizer == 'function'
	        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, true);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    function gt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    function gte(value, other) {
	      return value >= other;
	    }
	
	    /**
	     * Checks if `value` is classified as an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      return isObjectLike(value) && isArrayLike(value) &&
	        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	    }
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(function() { return arguments; }());
	     * // => false
	     */
	    var isArray = nativeIsArray || function(value) {
	      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	    };
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    function isDate(value) {
	      return isObjectLike(value) && objToString.call(value) == dateTag;
	    }
	
	    /**
	     * Checks if `value` is a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is empty. A value is considered empty unless it is an
	     * `arguments` object, array, string, or jQuery-like collection with a length
	     * greater than `0` or an object with own enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Array|Object|string} value The value to inspect.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
	          (isObjectLike(value) && isFunction(value.splice)))) {
	        return !value.length;
	      }
	      return !keys(value).length;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent. If `customizer` is provided it is invoked to compare values.
	     * If `customizer` returns `undefined` comparisons are handled by the method
	     * instead. The `customizer` is bound to `thisArg` and invoked with three
	     * arguments: (value, other [, index|key]).
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. Functions and DOM nodes
	     * are **not** supported. Provide a customizer function to extend support
	     * for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @alias eq
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * object == other;
	     * // => false
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * // using a customizer callback
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqual(array, other, function(value, other) {
	     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
	     *     return true;
	     *   }
	     * });
	     * // => true
	     */
	    function isEqual(value, other, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(10);
	     * // => true
	     *
	     * _.isFinite('10');
	     * // => false
	     *
	     * _.isFinite(true);
	     * // => false
	     *
	     * _.isFinite(Object(10));
	     * // => false
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in older versions of Chrome and Safari which return 'function' for regexes
	      // and Safari 8 equivalents which return 'object' for typed array constructors.
	      return isObject(value) && objToString.call(value) == funcTag;
	    }
	
	    /**
	     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(1);
	     * // => false
	     */
	    function isObject(value) {
	      // Avoid a V8 JIT bug in Chrome 19-20.
	      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Performs a deep comparison between `object` and `source` to determine if
	     * `object` contains equivalent property values. If `customizer` is provided
	     * it is invoked to compare values. If `customizer` returns `undefined`
	     * comparisons are handled by the method instead. The `customizer` is bound
	     * to `thisArg` and invoked with three arguments: (value, other, index|key).
	     *
	     * **Note:** This method supports comparing properties of arrays, booleans,
	     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
	     * and DOM nodes are **not** supported. Provide a customizer function to extend
	     * support for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.isMatch(object, { 'age': 40 });
	     * // => true
	     *
	     * _.isMatch(object, { 'age': 36 });
	     * // => false
	     *
	     * // using a customizer callback
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatch(object, source, function(value, other) {
	     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
	     * });
	     * // => true
	     */
	    function isMatch(object, source, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      return baseIsMatch(object, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
	     * which returns `true` for `undefined` and other non-numeric values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a native function.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (value == null) {
	        return false;
	      }
	      if (isFunction(value)) {
	        return reIsNative.test(fnToString.call(value));
	      }
	      return isObjectLike(value) && reIsHostCtor.test(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	     * as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isNumber(8.4);
	     * // => true
	     *
	     * _.isNumber(NaN);
	     * // => true
	     *
	     * _.isNumber('8.4');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * **Note:** This method assumes objects created by the `Object` constructor
	     * have no inherited enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      var Ctor;
	
	      // Exit early for non `Object` objects.
	      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	        return false;
	      }
	      // IE < 9 iterates inherited properties before own properties. If the first
	      // iterated property is an object's own property then there are no inherited
	      // enumerable properties.
	      var result;
	      // In most environments an object's own properties are iterated before
	      // its inherited properties. If the last iterated property is an object's
	      // own property then there are no inherited enumerable properties.
	      baseForIn(value, function(subValue, key) {
	        result = key;
	      });
	      return result === undefined || hasOwnProperty.call(value, result);
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    function isRegExp(value) {
	      return isObject(value) && objToString.call(value) == regexpTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    function isTypedArray(value) {
	      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	    }
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    function lt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    function lte(value, other) {
	      return value <= other;
	    }
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * (function() {
	     *   return _.toArray(arguments).slice(1);
	     * }(1, 2, 3));
	     * // => [2, 3]
	     */
	    function toArray(value) {
	      var length = value ? getLength(value) : 0;
	      if (!isLength(length)) {
	        return values(value);
	      }
	      if (!length) {
	        return [];
	      }
	      return arrayCopy(value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable
	     * properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return baseCopy(value, keysIn(value));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Recursively merges own enumerable properties of the source object(s), that
	     * don't resolve to `undefined` into the destination object. Subsequent sources
	     * overwrite property assignments of previous sources. If `customizer` is
	     * provided it is invoked to produce the merged values of the destination and
	     * source properties. If `customizer` returns `undefined` merging is handled
	     * by the method instead. The `customizer` is bound to `thisArg` and invoked
	     * with five arguments: (objectValue, sourceValue, key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var users = {
	     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	     * };
	     *
	     * var ages = {
	     *   'data': [{ 'age': 36 }, { 'age': 40 }]
	     * };
	     *
	     * _.merge(users, ages);
	     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	     *
	     * // using a customizer callback
	     * var object = {
	     *   'fruits': ['apple'],
	     *   'vegetables': ['beet']
	     * };
	     *
	     * var other = {
	     *   'fruits': ['banana'],
	     *   'vegetables': ['carrot']
	     * };
	     *
	     * _.merge(object, other, function(a, b) {
	     *   if (_.isArray(a)) {
	     *     return a.concat(b);
	     *   }
	     * });
	     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	     */
	    var merge = createAssigner(baseMerge);
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object. Subsequent sources overwrite property assignments of previous sources.
	     * If `customizer` is provided it is invoked to produce the assigned values.
	     * The `customizer` is bound to `thisArg` and invoked with five arguments:
	     * (objectValue, sourceValue, key, object, source).
	     *
	     * **Note:** This method mutates `object` and is based on
	     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
	     *
	     * @static
	     * @memberOf _
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using a customizer callback
	     * var defaults = _.partialRight(_.assign, function(value, other) {
	     *   return _.isUndefined(value) ? other : value;
	     * });
	     *
	     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var assign = createAssigner(function(object, source, customizer) {
	      return customizer
	        ? assignWith(object, source, customizer)
	        : baseAssign(object, source);
	    });
	
	    /**
	     * Creates an object that inherits from the given `prototype` object. If a
	     * `properties` object is provided its own enumerable properties are assigned
	     * to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties, guard) {
	      var result = baseCreate(prototype);
	      if (guard && isIterateeCall(prototype, properties, guard)) {
	        properties = undefined;
	      }
	      return properties ? baseAssign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object for all destination properties that resolve to `undefined`. Once a
	     * property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var defaults = createDefaults(assign, assignDefaults);
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
	     * // => { 'user': { 'name': 'barney', 'age': 36 } }
	     *
	     */
	    var defaultsDeep = createDefaults(merge, mergeDefaults);
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    var findKey = createFindKey(baseForOwn);
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => returns `pebbles` assuming `_.findKey` returns `barney`
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    var findLastKey = createFindKey(baseForOwnRight);
	
	    /**
	     * Iterates over own and inherited enumerable properties of an object invoking
	     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
	     */
	    var forIn = createForIn(baseFor);
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
	     */
	    var forInRight = createForIn(baseForRight);
	
	    /**
	     * Iterates over own enumerable properties of an object invoking `iteratee`
	     * for each property. The `iteratee` is bound to `thisArg` and invoked with
	     * three arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a' and 'b' (iteration order is not guaranteed)
	     */
	    var forOwn = createForOwn(baseForOwn);
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
	     */
	    var forOwnRight = createForOwn(baseForOwnRight);
	
	    /**
	     * Creates an array of function property names from all enumerable properties,
	     * own and inherited, of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @alias methods
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the new array of property names.
	     * @example
	     *
	     * _.functions(_);
	     * // => ['after', 'ary', 'assign', ...]
	     */
	    function functions(object) {
	      return baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the property value at `path` of `object`. If the resolved value is
	     * `undefined` the `defaultValue` is used in its place.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': { 'c': 3 } } };
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b.c');
	     * // => true
	     *
	     * _.has(object, ['a', 'b', 'c']);
	     * // => true
	     */
	    function has(object, path) {
	      if (object == null) {
	        return false;
	      }
	      var result = hasOwnProperty.call(object, path);
	      if (!result && !isKey(path)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        if (object == null) {
	          return false;
	        }
	        path = last(path);
	        result = hasOwnProperty.call(object, path);
	      }
	      return result || (isLength(object.length) && isIndex(path, object.length) &&
	        (isArray(object) || isArguments(object)));
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite property
	     * assignments of previous values unless `multiValue` is `true`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {boolean} [multiValue] Allow multiple values per key.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     *
	     * // with `multiValue`
	     * _.invert(object, true);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function invert(object, multiValue, guard) {
	      if (guard && isIterateeCall(object, multiValue, guard)) {
	        multiValue = undefined;
	      }
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key];
	
	        if (multiValue) {
	          if (hasOwnProperty.call(result, value)) {
	            result[value].push(key);
	          } else {
	            result[value] = [key];
	          }
	        }
	        else {
	          result[value] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    var keys = !nativeKeys ? shimKeys : function(object) {
	      var Ctor = object == null ? undefined : object.constructor;
	      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	          (typeof object != 'function' && isArrayLike(object))) {
	        return shimKeys(object);
	      }
	      return isObject(object) ? nativeKeys(object) : [];
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      if (object == null) {
	        return [];
	      }
	      if (!isObject(object)) {
	        object = Object(object);
	      }
	      var length = object.length;
	      length = (length && isLength(length) &&
	        (isArray(object) || isArguments(object)) && length) || 0;
	
	      var Ctor = object.constructor,
	          index = -1,
	          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	          result = Array(length),
	          skipIndexes = length > 0;
	
	      while (++index < length) {
	        result[index] = (index + '');
	      }
	      for (var key in object) {
	        if (!(skipIndexes && isIndex(key, length)) &&
	            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * property of `object` through `iteratee`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    var mapKeys = createObjectMapper(true);
	
	    /**
	     * Creates an object with the same keys as `object` and values generated by
	     * running each own enumerable property of `object` through `iteratee`. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, key, object).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
	     *   return n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * // using the `_.property` callback shorthand
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    var mapValues = createObjectMapper();
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable properties of `object` that are not omitted.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to omit, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.omit(object, 'age');
	     * // => { 'user': 'fred' }
	     *
	     * _.omit(object, _.isNumber);
	     * // => { 'user': 'fred' }
	     */
	    var omit = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      if (typeof props[0] != 'function') {
	        var props = arrayMap(baseFlatten(props), String);
	        return pickByArray(object, baseDifference(keysIn(object), props));
	      }
	      var predicate = bindCallback(props[0], props[1], 3);
	      return pickByCallback(object, function(value, key, object) {
	        return !predicate(value, key, object);
	      });
	    });
	
	    /**
	     * Creates a two dimensional array of the key-value pairs for `object`,
	     * e.g. `[[key1, value1], [key2, value2]]`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the new array of key-value pairs.
	     * @example
	     *
	     * _.pairs({ 'barney': 36, 'fred': 40 });
	     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	     */
	    function pairs(object) {
	      object = toObject(object);
	
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        var key = props[index];
	        result[index] = [key, object[key]];
	      }
	      return result;
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties. Property
	     * names may be specified as individual arguments or as arrays of property
	     * names. If `predicate` is provided it is invoked for each property of `object`
	     * picking the properties `predicate` returns truthy for. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to pick, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.pick(object, 'user');
	     * // => { 'user': 'fred' }
	     *
	     * _.pick(object, _.isString);
	     * // => { 'user': 'fred' }
	     */
	    var pick = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      return typeof props[0] == 'function'
	        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
	        : pickByArray(object, baseFlatten(props));
	    });
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a function
	     * it is invoked with the `this` binding of its parent object and its result
	     * is returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a.b.c', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a.b.c', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      var result = object == null ? undefined : object[path];
	      if (result === undefined) {
	        if (object != null && !isKey(path, object)) {
	          path = toPath(path);
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          result = object == null ? undefined : object[last(path)];
	        }
	        result = result === undefined ? defaultValue : result;
	      }
	      return isFunction(result) ? result.call(object) : result;
	    }
	
	    /**
	     * Sets the property value of `path` on `object`. If a portion of `path`
	     * does not exist it is created.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to augment.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, 'x[0].y.z', 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      if (object == null) {
	        return object;
	      }
	      var pathKey = (path + '');
	      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = path[index];
	        if (isObject(nested)) {
	          if (index == lastIndex) {
	            nested[key] = value;
	          } else if (nested[key] == null) {
	            nested[key] = isIndex(path[index + 1]) ? [] : {};
	          }
	        }
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own enumerable
	     * properties through `iteratee`, with each invocation potentially mutating
	     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
	     * with four arguments: (accumulator, value, key, object). Iteratee functions
	     * may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Array|Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     */
	    function transform(object, iteratee, accumulator, thisArg) {
	      var isArr = isArray(object) || isTypedArray(object);
	      iteratee = getCallback(iteratee, thisArg, 4);
	
	      if (accumulator == null) {
	        if (isArr || isObject(object)) {
	          var Ctor = object.constructor;
	          if (isArr) {
	            accumulator = isArray(object) ? new Ctor : [];
	          } else {
	            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
	          }
	        } else {
	          accumulator = {};
	        }
	      }
	      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Creates an array of the own enumerable property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property values
	     * of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Checks if `n` is between `start` and up to but not including, `end`. If
	     * `end` is not specified it is set to `start` with `start` then set to `0`.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} n The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     */
	    function inRange(value, start, end) {
	      start = +start || 0;
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      return value >= nativeMin(start, end) && value < nativeMax(start, end);
	    }
	
	    /**
	     * Produces a random number between `min` and `max` (inclusive). If only one
	     * argument is provided a number between `0` and the given number is returned.
	     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
	     * number is returned instead of an integer.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} [min=0] The minimum possible value.
	     * @param {number} [max=1] The maximum possible value.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(min, max, floating) {
	      if (floating && isIterateeCall(min, max, floating)) {
	        max = floating = undefined;
	      }
	      var noMin = min == null,
	          noMax = max == null;
	
	      if (floating == null) {
	        if (noMax && typeof min == 'boolean') {
	          floating = min;
	          min = 1;
	        }
	        else if (typeof max == 'boolean') {
	          floating = max;
	          noMax = true;
	        }
	      }
	      if (noMin && noMax) {
	        max = 1;
	        noMax = false;
	      }
	      min = +min || 0;
	      if (noMax) {
	        max = min;
	        min = 0;
	      } else {
	        max = +max || 0;
	      }
	      if (floating || min % 1 || max % 1) {
	        var rand = nativeRandom();
	        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
	      }
	      return baseRandom(min, max);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__foo_bar__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
	    });
	
	    /**
	     * Capitalizes the first character of `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('fred');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      string = baseToString(string);
	      return string && (string.charAt(0).toUpperCase() + string.slice(1));
	    }
	
	    /**
	     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = baseToString(string);
	      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search from.
	     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = baseToString(string);
	      target = (target + '');
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : nativeMin(position < 0 ? 0 : (+position || 0), length);
	
	      position -= target.length;
	      return position >= 0 && string.indexOf(target, position) == position;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
	     * their corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional characters
	     * use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value.
	     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * Backticks are escaped because in Internet Explorer < 9, they can break out
	     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
	     * for more details.
	     *
	     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
	     * to reduce XSS vectors.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
	      string = baseToString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
	     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
	     */
	    function escapeRegExp(string) {
	      string = baseToString(string);
	      return (string && reHasRegExpChars.test(string))
	        ? string.replace(reRegExpChars, escapeRegExpChar)
	        : (string || '(?:)');
	    }
	
	    /**
	     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__foo_bar__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = baseToString(string);
	      length = +length;
	
	      var strLength = string.length;
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return string;
	      }
	      var mid = (length - strLength) / 2,
	          leftLength = nativeFloor(mid),
	          rightLength = nativeCeil(mid);
	
	      chars = createPadding('', rightLength, chars);
	      return chars.slice(0, leftLength) + string + chars;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padLeft('abc', 6);
	     * // => '   abc'
	     *
	     * _.padLeft('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padLeft('abc', 3);
	     * // => 'abc'
	     */
	    var padLeft = createPadDir();
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padRight('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padRight('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padRight('abc', 3);
	     * // => 'abc'
	     */
	    var padRight = createPadDir(true);
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
	     * in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
	     * of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
	      // Chrome fails to trim leading <BOM> whitespace characters.
	      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
	      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      string = trim(string);
	      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=0] The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n) {
	      var result = '';
	      string = baseToString(string);
	      n = +n;
	      if (n < 1 || !string || !nativeIsFinite(n)) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        string += string;
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--foo-bar');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__foo_bar__');
	     * // => 'Foo Bar'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = baseToString(string);
	      position = position == null
	        ? 0
	        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);
	
	      return string.lastIndexOf(target, position) == position;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is provided it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options] The options object.
	     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
	     * @param {Object} [options.imports] An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
	     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
	     * @param {string} [options.variable] The data object variable name.
	     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // using the "interpolate" delimiter to create a compiled template
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // using the HTML "escape" delimiter to escape data property values
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the internal `print` function in "evaluate" delimiters
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // using custom template delimiters
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // using backslashes to treat delimiters as plain text
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // using the `imports` option to import `jQuery` as `jq`
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the `sourceURL` option to specify a custom sourceURL for the template
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
	     *
	     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // using the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and a stack trace
	     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, otherOptions) {
	      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
	        options = otherOptions = undefined;
	      }
	      string = baseToString(string);
	      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);
	
	      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products requires returning the `match`
	        // string in order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
	      }
	      chars = (chars + '');
	      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimLeft('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimLeft('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimLeft(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string));
	      }
	      return string.slice(charsLeftIndex(string, (chars + '')));
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimRight('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimRight('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimRight(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(0, trimmedRightIndex(string) + 1);
	      }
	      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object|number} [options] The options object or maximum string length.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.trunc('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', 24);
	     * // => 'hi-diddly-ho there, n...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function trunc(string, options, guard) {
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (options != null) {
	        if (isObject(options)) {
	          var separator = 'separator' in options ? options.separator : separator;
	          length = 'length' in options ? (+options.length || 0) : length;
	          omission = 'omission' in options ? baseToString(options.omission) : omission;
	        } else {
	          length = +options || 0;
	        }
	      }
	      string = baseToString(string);
	      if (length >= string.length) {
	        return string;
	      }
	      var end = length - omission.length;
	      if (end < 1) {
	        return omission;
	      }
	      var result = string.slice(0, end);
	      if (separator == null) {
	        return result + omission;
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              newEnd,
	              substring = string.slice(0, end);
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            newEnd = match.index;
	          }
	          result = result.slice(0, newEnd == null ? end : newEnd);
	        }
	      } else if (string.indexOf(separator, end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
	     * corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
	     * entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = baseToString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      if (guard && isIterateeCall(string, pattern, guard)) {
	        pattern = undefined;
	      }
	      string = baseToString(string);
	      return string.match(pattern || reWords) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function} func The function to attempt.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // avoid throwing errors for invalid selectors
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = restParam(function(func, args) {
	      try {
	        return func.apply(undefined, args);
	      } catch(e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and arguments of the created function. If `func` is a property name the
	     * created callback returns the property value for a given element. If `func`
	     * is an object the created callback returns `true` for elements that contain
	     * the equivalent object properties, otherwise it returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias iteratee
	     * @category Utility
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // wrap to create custom callback shorthands
	     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
	     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
	     *   if (!match) {
	     *     return callback(func, thisArg);
	     *   }
	     *   return function(object) {
	     *     return match[2] == 'gt'
	     *       ? object[match[1]] > match[3]
	     *       : object[match[1]] < match[3];
	     *   };
	     * });
	     *
	     * _.filter(users, 'age__gt36');
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     */
	    function callback(func, thisArg, guard) {
	      if (guard && isIterateeCall(func, thisArg, guard)) {
	        thisArg = undefined;
	      }
	      return isObjectLike(func)
	        ? matches(func)
	        : baseCallback(func, thisArg);
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var getter = _.constant(object);
	     *
	     * getter() === object;
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * This method returns the first argument provided to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.identity(object) === object;
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that performs a deep comparison between a given object
	     * and `source`, returning `true` if the given object has equivalent property
	     * values, else `false`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
	     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that compares the property value of `path` on a given
	     * object to `value`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * _.find(users, _.matchesProperty('user', 'fred'));
	     * // => { 'user': 'fred' }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` on a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': _.constant(2) } } },
	     *   { 'a': { 'b': { 'c': _.constant(1) } } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    var method = restParam(function(path, args) {
	      return function(object) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path on `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = restParam(function(object, args) {
	      return function(path) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable function properties of a source object to the
	     * destination object. If `object` is a function then methods are added to
	     * its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.chain=true] Specify whether the functions added
	     *  are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      if (options == null) {
	        var isObj = isObject(source),
	            props = isObj ? keys(source) : undefined,
	            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;
	
	        if (!(methodNames ? methodNames.length : isObj)) {
	          methodNames = false;
	          options = source;
	          source = object;
	          object = this;
	        }
	      }
	      if (!methodNames) {
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = true,
	          index = -1,
	          isFunc = isFunction(object),
	          length = methodNames.length;
	
	      if (options === false) {
	        chain = false;
	      } else if (isObject(options) && 'chain' in options) {
	        chain = options.chain;
	      }
	      while (++index < length) {
	        var methodName = methodNames[index],
	            func = source[methodName];
	
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = (function(func) {
	            return function() {
	              var chainAll = this.__chain__;
	              if (chain || chainAll) {
	                var result = object(this.__wrapped__),
	                    actions = result.__actions__ = arrayCopy(this.__actions__);
	
	                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	                result.__chain__ = chainAll;
	                return result;
	              }
	              return func.apply(object, arrayPush([this.value()], arguments));
	            };
	          }(func));
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      root._ = oldDash;
	      return this;
	    }
	
	    /**
	     * A no-operation function that returns `undefined` regardless of the
	     * arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.noop(object) === undefined;
	     * // => true
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that returns the property value at `path` on a
	     * given object.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': 2 } } },
	     *   { 'a': { 'b': { 'c': 1 } } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the property value at a given path on `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return baseGet(object, toPath(path), path + '');
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. If `end` is not specified it is
	     * set to `start` with `start` then set to `0`. If `end` is less than `start`
	     * a zero-length range is created unless a negative `step` is specified.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the new array of numbers.
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    function range(start, end, step) {
	      if (step && isIterateeCall(start, end, step)) {
	        end = step = undefined;
	      }
	      start = +start || 0;
	      step = step == null ? 1 : (+step || 0);
	
	      if (end == null) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
	      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the iteratee function `n` times, returning an array of the results
	     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
	     * one argument; (index).
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
	     * // => [3, 6, 4]
	     *
	     * _.times(3, function(n) {
	     *   mage.castSpell(n);
	     * });
	     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
	     *
	     * _.times(3, function(n) {
	     *   this.cast(n);
	     * }, mage);
	     * // => also invokes `mage.castSpell(n)` three times
	     */
	    function times(n, iteratee, thisArg) {
	      n = nativeFloor(n);
	
	      // Exit early to avoid a JSC JIT bug in Safari 8
	      // where `Array(0)` is treated as `Array(1)`.
	      if (n < 1 || !nativeIsFinite(n)) {
	        return [];
	      }
	      var index = -1,
	          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));
	
	      iteratee = bindCallback(iteratee, thisArg, 1);
	      while (++index < n) {
	        if (index < MAX_ARRAY_LENGTH) {
	          result[index] = iteratee(index);
	        } else {
	          iteratee(index);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {string} [prefix] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return baseToString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} augend The first number to add.
	     * @param {number} addend The second number to add.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    function add(augend, addend) {
	      return (+augend || 0) + (+addend || 0);
	    }
	
	    /**
	     * Calculates `n` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Calculates `n` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Gets the maximum value of `collection`. If `collection` is empty or falsey
	     * `-Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => -Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.max(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.max(users, 'age');
	     * // => { 'user': 'fred', 'age': 40 }
	     */
	    var max = createExtremum(gt, NEGATIVE_INFINITY);
	
	    /**
	     * Gets the minimum value of `collection`. If `collection` is empty or falsey
	     * `Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.min(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.min(users, 'age');
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var min = createExtremum(lt, POSITIVE_INFINITY);
	
	    /**
	     * Calculates `n` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Gets the sum of the values in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 6]);
	     * // => 10
	     *
	     * _.sum({ 'a': 4, 'b': 6 });
	     * // => 10
	     *
	     * var objects = [
	     *   { 'n': 4 },
	     *   { 'n': 6 }
	     * ];
	     *
	     * _.sum(objects, function(object) {
	     *   return object.n;
	     * });
	     * // => 10
	     *
	     * // using the `_.property` callback shorthand
	     * _.sum(objects, 'n');
	     * // => 10
	     */
	    function sum(collection, iteratee, thisArg) {
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return iteratee.length == 1
	        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
	        : baseSum(collection, iteratee);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    // Add functions to the `Map` cache.
	    MapCache.prototype['delete'] = mapDelete;
	    MapCache.prototype.get = mapGet;
	    MapCache.prototype.has = mapHas;
	    MapCache.prototype.set = mapSet;
	
	    // Add functions to the `Set` cache.
	    SetCache.prototype.push = cachePush;
	
	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;
	
	    // Add functions that return wrapped values when chaining.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.callback = callback;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.functions = functions;
	    lodash.groupBy = groupBy;
	    lodash.indexBy = indexBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.invert = invert;
	    lodash.invoke = invoke;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.modArgs = modArgs;
	    lodash.negate = negate;
	    lodash.omit = omit;
	    lodash.once = once;
	    lodash.pairs = pairs;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pluck = pluck;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.restParam = restParam;
	    lodash.set = set;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortByAll = sortByAll;
	    lodash.sortByOrder = sortByOrder;
	    lodash.spread = spread;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.times = times;
	    lodash.toArray = toArray;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.union = union;
	    lodash.uniq = uniq;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.where = where;
	    lodash.without = without;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.backflow = flowRight;
	    lodash.collect = map;
	    lodash.compose = flowRight;
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.extend = assign;
	    lodash.iteratee = callback;
	    lodash.methods = functions;
	    lodash.object = zipObject;
	    lodash.select = filter;
	    lodash.tail = rest;
	    lodash.unique = uniq;
	
	    // Add functions to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions that return unwrapped values when chaining.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.deburr = deburr;
	    lodash.endsWith = endsWith;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.findWhere = findWhere;
	    lodash.first = first;
	    lodash.floor = floor;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isBoolean = isBoolean;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isMatch = isMatch;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isString = isString;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.min = min;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padLeft = padLeft;
	    lodash.padRight = padRight;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.sum = sum;
	    lodash.template = template;
	    lodash.trim = trim;
	    lodash.trimLeft = trimLeft;
	    lodash.trimRight = trimRight;
	    lodash.trunc = trunc;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.words = words;
	
	    // Add aliases.
	    lodash.all = every;
	    lodash.any = some;
	    lodash.contains = includes;
	    lodash.eq = isEqual;
	    lodash.detect = find;
	    lodash.foldl = reduce;
	    lodash.foldr = reduceRight;
	    lodash.head = first;
	    lodash.include = includes;
	    lodash.inject = reduce;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!lodash.prototype[methodName]) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), false);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions capable of returning wrapped and unwrapped values when chaining.
	    lodash.sample = sample;
	
	    lodash.prototype.sample = function(n) {
	      if (!this.__chain__ && n == null) {
	        return sample(this.value());
	      }
	      return this.thru(function(value) {
	        return sample(value, n);
	      });
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type string
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);
	
	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(result.__takeCount__, n);
	        } else {
	          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type != LAZY_MAP_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
	        var result = this.clone();
	        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.first` and `_.last`.
	    arrayEach(['first', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
	    arrayEach(['initial', 'rest'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
	    arrayEach(['pluck', 'where'], function(methodName, index) {
	      var operationName = index ? 'filter' : 'map',
	          createCallback = index ? baseMatches : property;
	
	      LazyWrapper.prototype[methodName] = function(value) {
	        return this[operationName](createCallback(value));
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.reject = function(predicate, thisArg) {
	      predicate = getCallback(predicate, thisArg, 1);
	      return this.filter(function(value) {
	        return !predicate(value);
	      });
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = start == null ? 0 : (+start || 0);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = (+end || 0);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
	      return this.reverse().takeWhile(predicate, thisArg).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(POSITIVE_INFINITY);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
	          retUnwrapped = /^(?:first|last)$/.test(methodName),
	          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var args = retUnwrapped ? [1] : arguments,
	            chainAll = this.__chain__,
	            value = this.__wrapped__,
	            isHybrid = !!this.__actions__.length,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var interceptor = function(value) {
	          return (retUnwrapped && chainAll)
	            ? lodashFunc(value, 1)[0]
	            : lodashFunc.apply(undefined, arrayPush([value], args));
	        };
	
	        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
	            onlyLazy = isLazy && !isHybrid;
	
	        if (retUnwrapped && !chainAll) {
	          if (onlyLazy) {
	            value = value.clone();
	            value.__actions__.push(action);
	            return func.call(value);
	          }
	          return lodashFunc.call(undefined, this.value())[0];
	        }
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push(action);
	          return new LodashWrapper(result, chainAll);
	        }
	        return this.thru(interceptor);
	      };
	    });
	
	    // Add `Array` and `String` methods to `lodash.prototype`.
	    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
	      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          return func.apply(this.value(), args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(value, args);
	        });
	      };
	    });
	
	    // Map minified function names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name,
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];
	
	    // Add functions to the lazy wrapper.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chaining functions to the `lodash` wrapper.
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.concat = wrapperConcat;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toString = wrapperToString;
	    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add function aliases to the `lodash` wrapper.
	    lodash.prototype.collect = lodash.prototype.map;
	    lodash.prototype.head = lodash.prototype.first;
	    lodash.prototype.select = lodash.prototype.filter;
	    lodash.prototype.tail = lodash.prototype.rest;
	
	    return lodash;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers like r.js check for condition patterns like the following:
	  if (true) {
	    // Expose lodash to the global object when an AMD loader is present to avoid
	    // errors in cases where lodash is loaded by a script tag and not intended
	    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
	    // more details.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for Node.js or RingoJS.
	    if (moduleExports) {
	      (freeModule.exports = _)._ = _;
	    }
	    // Export for Rhino with CommonJS support.
	    else {
	      freeExports._ = _;
	    }
	  }
	  else {
	    // Export for a browser or Rhino.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(73)(module), (function() { return this; }())))

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict'
	var inherits = __webpack_require__(13)
	var HashBase = __webpack_require__(366)
	
	var ARRAY16 = new Array(16)
	
	function MD5 () {
	  HashBase.call(this, 64)
	
	  // state
	  this._a = 0x67452301
	  this._b = 0xefcdab89
	  this._c = 0x98badcfe
	  this._d = 0x10325476
	}
	
	inherits(MD5, HashBase)
	
	MD5.prototype._update = function () {
	  var M = ARRAY16
	  for (var i = 0; i < 16; ++i) M[i] = this._block.readInt32LE(i * 4)
	
	  var a = this._a
	  var b = this._b
	  var c = this._c
	  var d = this._d
	
	  a = fnF(a, b, c, d, M[0], 0xd76aa478, 7)
	  d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12)
	  c = fnF(c, d, a, b, M[2], 0x242070db, 17)
	  b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22)
	  a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7)
	  d = fnF(d, a, b, c, M[5], 0x4787c62a, 12)
	  c = fnF(c, d, a, b, M[6], 0xa8304613, 17)
	  b = fnF(b, c, d, a, M[7], 0xfd469501, 22)
	  a = fnF(a, b, c, d, M[8], 0x698098d8, 7)
	  d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12)
	  c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17)
	  b = fnF(b, c, d, a, M[11], 0x895cd7be, 22)
	  a = fnF(a, b, c, d, M[12], 0x6b901122, 7)
	  d = fnF(d, a, b, c, M[13], 0xfd987193, 12)
	  c = fnF(c, d, a, b, M[14], 0xa679438e, 17)
	  b = fnF(b, c, d, a, M[15], 0x49b40821, 22)
	
	  a = fnG(a, b, c, d, M[1], 0xf61e2562, 5)
	  d = fnG(d, a, b, c, M[6], 0xc040b340, 9)
	  c = fnG(c, d, a, b, M[11], 0x265e5a51, 14)
	  b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20)
	  a = fnG(a, b, c, d, M[5], 0xd62f105d, 5)
	  d = fnG(d, a, b, c, M[10], 0x02441453, 9)
	  c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14)
	  b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20)
	  a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5)
	  d = fnG(d, a, b, c, M[14], 0xc33707d6, 9)
	  c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14)
	  b = fnG(b, c, d, a, M[8], 0x455a14ed, 20)
	  a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5)
	  d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9)
	  c = fnG(c, d, a, b, M[7], 0x676f02d9, 14)
	  b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20)
	
	  a = fnH(a, b, c, d, M[5], 0xfffa3942, 4)
	  d = fnH(d, a, b, c, M[8], 0x8771f681, 11)
	  c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16)
	  b = fnH(b, c, d, a, M[14], 0xfde5380c, 23)
	  a = fnH(a, b, c, d, M[1], 0xa4beea44, 4)
	  d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11)
	  c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16)
	  b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23)
	  a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4)
	  d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11)
	  c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16)
	  b = fnH(b, c, d, a, M[6], 0x04881d05, 23)
	  a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4)
	  d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11)
	  c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16)
	  b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23)
	
	  a = fnI(a, b, c, d, M[0], 0xf4292244, 6)
	  d = fnI(d, a, b, c, M[7], 0x432aff97, 10)
	  c = fnI(c, d, a, b, M[14], 0xab9423a7, 15)
	  b = fnI(b, c, d, a, M[5], 0xfc93a039, 21)
	  a = fnI(a, b, c, d, M[12], 0x655b59c3, 6)
	  d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10)
	  c = fnI(c, d, a, b, M[10], 0xffeff47d, 15)
	  b = fnI(b, c, d, a, M[1], 0x85845dd1, 21)
	  a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6)
	  d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10)
	  c = fnI(c, d, a, b, M[6], 0xa3014314, 15)
	  b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21)
	  a = fnI(a, b, c, d, M[4], 0xf7537e82, 6)
	  d = fnI(d, a, b, c, M[11], 0xbd3af235, 10)
	  c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15)
	  b = fnI(b, c, d, a, M[9], 0xeb86d391, 21)
	
	  this._a = (this._a + a) | 0
	  this._b = (this._b + b) | 0
	  this._c = (this._c + c) | 0
	  this._d = (this._d + d) | 0
	}
	
	MD5.prototype._digest = function () {
	  // create padding and handle blocks
	  this._block[this._blockOffset++] = 0x80
	  if (this._blockOffset > 56) {
	    this._block.fill(0, this._blockOffset, 64)
	    this._update()
	    this._blockOffset = 0
	  }
	
	  this._block.fill(0, this._blockOffset, 56)
	  this._block.writeUInt32LE(this._length[0], 56)
	  this._block.writeUInt32LE(this._length[1], 60)
	  this._update()
	
	  // produce result
	  var buffer = new Buffer(16)
	  buffer.writeInt32LE(this._a, 0)
	  buffer.writeInt32LE(this._b, 4)
	  buffer.writeInt32LE(this._c, 8)
	  buffer.writeInt32LE(this._d, 12)
	  return buffer
	}
	
	function rotl (x, n) {
	  return (x << n) | (x >>> (32 - n))
	}
	
	function fnF (a, b, c, d, m, k, s) {
	  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + b) | 0
	}
	
	function fnG (a, b, c, d, m, k, s) {
	  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + b) | 0
	}
	
	function fnH (a, b, c, d, m, k, s) {
	  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0
	}
	
	function fnI (a, b, c, d, m, k, s) {
	  return (rotl((a + ((c ^ (b | (~d)))) + m + k) | 0, s) + b) | 0
	}
	
	module.exports = MD5
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 387 */
/***/ function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function(crypto) {
	  function pbkdf2(password, salt, iterations, keylen, digest, callback) {
	    if ('function' === typeof digest) {
	      callback = digest
	      digest = undefined
	    }
	
	    if ('function' !== typeof callback)
	      throw new Error('No callback provided to pbkdf2')
	
	    setTimeout(function() {
	      var result
	
	      try {
	        result = pbkdf2Sync(password, salt, iterations, keylen, digest)
	      } catch (e) {
	        return callback(e)
	      }
	
	      callback(undefined, result)
	    })
	  }
	
	  function pbkdf2Sync(password, salt, iterations, keylen, digest) {
	    if ('number' !== typeof iterations)
	      throw new TypeError('Iterations not a number')
	
	    if (iterations < 0)
	      throw new TypeError('Bad iterations')
	
	    if ('number' !== typeof keylen)
	      throw new TypeError('Key length not a number')
	
	    if (keylen < 0)
	      throw new TypeError('Bad key length')
	
	    digest = digest || 'sha1'
	
	    if (!Buffer.isBuffer(password)) password = new Buffer(password)
	    if (!Buffer.isBuffer(salt)) salt = new Buffer(salt)
	
	    var hLen, l = 1, r, T
	    var DK = new Buffer(keylen)
	    var block1 = new Buffer(salt.length + 4)
	    salt.copy(block1, 0, 0, salt.length)
	
	    for (var i = 1; i <= l; i++) {
	      block1.writeUInt32BE(i, salt.length)
	
	      var U = crypto.createHmac(digest, password).update(block1).digest()
	
	      if (!hLen) {
	        hLen = U.length
	        T = new Buffer(hLen)
	        l = Math.ceil(keylen / hLen)
	        r = keylen - (l - 1) * hLen
	
	        if (keylen > (Math.pow(2, 32) - 1) * hLen)
	          throw new TypeError('keylen exceeds maximum length')
	      }
	
	      U.copy(T, 0, 0, hLen)
	
	      for (var j = 1; j < iterations; j++) {
	        U = crypto.createHmac(digest, password).update(U).digest()
	
	        for (var k = 0; k < hLen; k++) {
	          T[k] ^= U[k]
	        }
	      }
	
	      var destPos = (i - 1) * hLen
	      var len = (i == l ? r : hLen)
	      T.copy(DK, destPos, 0, len)
	    }
	
	    return DK
	  }
	
	  return {
	    pbkdf2: pbkdf2,
	    pbkdf2Sync: pbkdf2Sync
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(163);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(163);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(18);
	var invariant = __webpack_require__(3);
	var ReactPropTypesSecret = __webpack_require__(165);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(18);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	var assign = __webpack_require__(7);
	
	var ReactPropTypesSecret = __webpack_require__(165);
	var checkPropTypes = __webpack_require__(392);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 395 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ },
/* 396 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ },
/* 397 */
/***/ function(module, exports) {

	module.exports = "module.exports = {\n\t\"bindings\": [\n\t\t{\n\t\t\t\"type\": \"eventHubTrigger\",\n\t\t\t\"name\": \"myEventHubMessage\",\n\t\t\t\"direction\": \"in\",\n\t\t\t\"path\": \"%eventHubConnectionPath%\",\n\t\t\t\"connection\": \"eventHubConnectionString\",\n\t\t\t\"cardinality\": \"one\"\n\t\t}\n\t],\n\t\"disabled\": false\n};"

/***/ },
/* 398 */
/***/ function(module, exports) {

	module.exports = "module.exports = {\n\t\"frameworks\": {\n\t\t\"net46\": {\n\t\t\t\"dependencies\": {\n\t\t\t\t\"Microsoft.Azure.Amqp\": \"2.0.3\",\n\t\t\t\t\"Microsoft.AspNet.WebApi.Client\": \"5.2.3\",\n\t\t\t\t\"Microsoft.Azure.Devices\": \"1.3.1\",\n\t\t\t\t\"Microsoft.AspNet.WebApi.Core\": \"5.2.3\"\n\t\t\t}\n\t\t}\n\t}\n};"

/***/ },
/* 399 */
/***/ function(module, exports) {

	module.exports = "#include \"AzureIotHub.h\"\r\n#include \"AZ3166WiFi.h\"\r\n#include \"config.h\"\r\n#include \"utility.h\"\r\n#include \"iothub_client_sample_mqtt.h\"\r\n#include \"telemetry.h\"\r\n\r\nstatic bool hasWifi = false;\r\nint messageCount = 1;\r\n\r\nvoid initWifi()\r\n{\r\n     Screen.print(\"Azure IoT DevKit\\r\\n \\r\\nConnecting...\\r\\n\");\r\n\r\n    if (WiFi.begin() == WL_CONNECTED)\r\n    {\r\n        IPAddress ip = WiFi.localIP();\r\n        Screen.print(1, ip.get_address());\r\n        hasWifi = true;\r\n        Screen.print(2, \"Running... \\r\\n\");\r\n    }\r\n    else\r\n    {\r\n        Screen.print(1, \"No Wi-Fi\\r\\n \");\r\n    }\r\n}\r\n\r\nvoid setup()\r\n{\r\n    hasWifi = false;\r\n    initWifi();\r\n    if (!hasWifi)\r\n    {\r\n        LogInfo(\"Please make sure the wifi connected!\");\r\n        return;\r\n    }\r\n    send_telemetry_data(\"\", \"HappyPathSetup\", \"\");\r\n\r\n    Serial.begin(115200);\r\n    sensorInit();\r\n    iothubInit();\r\n}\r\n\r\nvoid loop()\r\n{\r\n    char messagePayload[MESSAGE_MAX_LEN];\r\n    bool temperatureAlert = readMessage(messageCount, messagePayload);\r\n    iothubSendMessage((const unsigned char *)messagePayload, temperatureAlert);\r\n    iothubLoop();\r\n    delay(10);\r\n}\r\n"

/***/ },
/* 400 */
/***/ function(module, exports) {

	module.exports = "// Interval time(ms) for sending message to IoT Hub\r\n#define INTERVAL 2000\r\n\r\n#define MESSAGE_MAX_LEN 256\r\n\r\n#define DEVICE_ID \"AZ3166\"\r\n\r\n#define TEMPERATURE_ALERT 30"

/***/ },
/* 401 */
/***/ function(module, exports) {

	module.exports = "// Copyright (c) Microsoft. All rights reserved.\n// Licensed under the MIT license. See LICENSE file in the project root for full license information.\n\n#include \"AzureIotHub.h\"\n#include \"Arduino.h\"\n#include \"config.h\"\n#include \"utility.h\"\n#include \"EEPROMInterface.h\"\n#include \"iothub_client_sample_mqtt.h\"\n#include <ArduinoJson.h>\n\nstatic IOTHUB_CLIENT_LL_HANDLE iotHubClientHandle;\nstatic bool messagePending = false;\nstatic bool messageSending = true;\n\nstatic IOTHUBMESSAGE_DISPOSITION_RESULT c2dMessageCallback(IOTHUB_MESSAGE_HANDLE message, void *userContextCallback)\n{\n    const char *buffer;\n    size_t size;\n\n    if (IoTHubMessage_GetByteArray(message, (const unsigned char **)&buffer, &size) != IOTHUB_MESSAGE_OK)\n    {\n        LogInfo(\"unable to IoTHubMessage_GetByteArray\");\n        return IOTHUBMESSAGE_REJECTED;\n    }\n    else\n    {\n        char *temp = (char *)malloc(size + 1);\n        if (temp == NULL)\n        {\n            LogInfo(\"Failed to malloc for command\");\n            return IOTHUBMESSAGE_REJECTED;\n        }\n        memcpy(temp, buffer, size);\n        temp[size] = '\\0';\n        LogInfo(\"Receive C2D message: %s\", temp);\n        blinkLED();\n        free(temp);\n        return IOTHUBMESSAGE_ACCEPTED;\n    }\n}\n\nstatic void twinCallback(DEVICE_TWIN_UPDATE_STATE updateState, const unsigned char *payLoad, size_t size, void *userContextCallback)\n{\n    char *temp = (char *)malloc(size + 1);\n    for (int i = 0; i < size; i++)\n    {\n        temp[i] = (char)(payLoad[i]);\n    }\n    temp[size] = '\\0';\n    parseTwinMessage(temp);\n    free(temp);\n}\n\nvoid start()\n{\n    LogInfo(\"Start sending temperature and humidity data\");\n    messageSending = true;\n}\n\nvoid stop()\n{\n    LogInfo(\"Stop sending temperature and humidity data\");\n    messageSending = false;\n}\n\nconst char *onSuccess = \"\\\"Successfully invoke device method\\\"\";\nconst char *notFound = \"\\\"No method found\\\"\";\n\nint deviceMethodCallback(const char *methodName, const unsigned char *payload, size_t size, unsigned char **response, size_t *response_size, void *userContextCallback)\n{\n    LogInfo(\"Try to invoke method %s\", methodName);\n    const char *responseMessage = onSuccess;\n    int result = 200;\n\n    if (strcmp(methodName, \"start\") == 0)\n    {\n        start();\n    }\n    else if (strcmp(methodName, \"stop\") == 0)\n    {\n        stop();\n    }\n    else\n    {\n        LogInfo(\"No method %s found\", methodName);\n        responseMessage = notFound;\n        result = 404;\n    }\n\n    *response_size = strlen(responseMessage);\n    *response = (unsigned char *)malloc(*response_size);\n    strncpy((char *)(*response), responseMessage, *response_size);\n\n    return result;\n}\n\nvoid iothubInit()\n{\n    srand((unsigned int)time(NULL));\n\n    // Load connection from EEPROM\n    EEPROMInterface eeprom;\n    uint8_t connString[AZ_IOT_HUB_MAX_LEN + 1] = { '\\0' };\n    int ret = eeprom.read(connString, AZ_IOT_HUB_MAX_LEN, 0x00, AZ_IOT_HUB_ZONE_IDX);\n    if (ret < 0)\n    { \n        LogInfo(\"ERROR: Unable to get the azure iot connection string from EEPROM. Please set the value in configuration mode.\");\n        return;\n    }\n    else if (ret == 0)\n    {\n        LogInfo(\"INFO: The connection string is empty. Please set the value in configuration mode.\");\n        return;\n    }\n\n    if (platform_init() != 0)\n    {\n        LogInfo(\"Failed to initialize the platform.\");\n        return;\n    }\n\n    if ((iotHubClientHandle = IoTHubClient_LL_CreateFromConnectionString((char*)connString, MQTT_Protocol)) == NULL)\n    {\n        LogInfo(\"iotHubClientHandle is NULL!\");\n        return;\n    }\n\n    if (IoTHubClient_LL_SetOption(iotHubClientHandle, \"TrustedCerts\", certificates) != IOTHUB_CLIENT_OK)\n    {\n        LogInfo(\"failure to set option \\\"TrustedCerts\\\"\");\n        return;\n    }\n\n    if (IoTHubClient_LL_SetMessageCallback(iotHubClientHandle, c2dMessageCallback, NULL) != IOTHUB_CLIENT_OK)\n    {\n        LogInfo(\"IoTHubClient_LL_SetMessageCallback FAILED!\");\n        return;\n    }\n    if (IoTHubClient_LL_SetDeviceTwinCallback(iotHubClientHandle, twinCallback, NULL) != IOTHUB_CLIENT_OK)\n    {\n        LogInfo(\"Failed on IoTHubClient_LL_SetDeviceTwinCallback\");\n        return;\n    }\n\n    if(IoTHubClient_LL_SetDeviceMethodCallback(iotHubClientHandle, deviceMethodCallback, NULL) != IOTHUB_CLIENT_OK)\n    {\n        LogInfo(\"Failed on IoTHubClient_LL_SetDeviceMethodCallback\");\n        return;\n    }    \n}\n\nstatic void sendConfirmationCallback(IOTHUB_CLIENT_CONFIRMATION_RESULT result, void *userContextCallback)\n{\n    if (IOTHUB_CLIENT_CONFIRMATION_OK == result)\n    {\n        LogInfo(\"Message sent to Azure IoT Hub\");\n        blinkSendConfirmation();\n    }\n    else\n    {\n        LogInfo(\"Failed to send message to Azure IoT Hub\");\n    }\n    messageCount++;\n    messagePending = false;\n}\n\nvoid iothubSendMessage(const unsigned char *text, bool temperatureAlert)\n{\n    if (messageSending && !messagePending)\n    {\n        IOTHUB_MESSAGE_HANDLE messageHandle = IoTHubMessage_CreateFromByteArray(text, strlen((const char *)text));\n        if (messageHandle == NULL)\n        {\n            LogInfo(\"unable to create a new IoTHubMessage\");\n            return;\n        }\n        MAP_HANDLE properties = IoTHubMessage_Properties(messageHandle);\n        Map_Add(properties, \"temperatureAlert\", temperatureAlert ? \"true\" : \"false\");\n        LogInfo(\"Sending message: %s\", text);\n        if (IoTHubClient_LL_SendEventAsync(iotHubClientHandle, messageHandle, sendConfirmationCallback, NULL) != IOTHUB_CLIENT_OK)\n        {\n            LogInfo(\"Failed to hand over the message to IoTHubClient\");\n            return;\n        }\n        LogInfo(\"IoTHubClient accepted the message for delivery\");\n        messagePending = true;\n        IoTHubMessage_Destroy(messageHandle);\n        delay(getInterval());\n    }\n}\n\nvoid iothubLoop(void)\n{\n    IoTHubClient_LL_DoWork(iotHubClientHandle);\n}\n"

/***/ },
/* 402 */
/***/ function(module, exports) {

	module.exports = "// Copyright (c) Microsoft. All rights reserved.\r\n// Licensed under the MIT license. See LICENSE file in the project root for full license information.\r\n\r\n#ifndef IOTHUB_CLIENT_SAMPLE_MQTT_H\r\n#define IOTHUB_CLIENT_SAMPLE_MQTT_H\r\n\r\n#include \"iothub_client_ll.h\"\r\n\r\nvoid iothubInit(void);\r\nvoid iothubSendMessage(const unsigned char *, bool);\r\nvoid iothubLoop(void);\r\nvoid iothubClose(void);\r\n\r\nextern int messageCount;\r\n#endif /* IOTHUB_CLIENT_SAMPLE_MQTT_H */"

/***/ },
/* 403 */
/***/ function(module, exports) {

	module.exports = "/*\r\n* IoT Hub Raspberry Pi NodeJS - Microsoft Sample Code - Copyright (c) 2017 - Licensed MIT\r\n*/\r\nconst Client = require('azure-iot-device').Client;\r\nconst Message = require('azure-iot-device').Message;\r\nconst Protocol = require('azure-iot-device-mqtt').Mqtt;\r\nvar led = require('led');\r\nvar buttonA = require('buttonA');\r\nvar Screen = require('oled');\r\nvar HTS221 = require('hts221');\r\nconst connectionString = '[CONNECTION_STRING_PLACE_HOLDER]';\r\nvar sendingMessage = false;\r\nvar messageId = 0;\r\nvar client, sensor;\r\nfunction getMessage(cb) {\r\n    messageId++;\r\n    sensor.readSensorData()\r\n        .then(function (data) {\r\n            cb(JSON.stringify({\r\n                messageId: messageId,\r\n                deviceId: 'Raspberry Pi Web Client',\r\n                temperature: data.temperature_C,\r\n                humidity: data.humidity\r\n            }), data.temperature_C > 30);\r\n        })\r\n        .catch(function (err) {\r\n            console.error('Failed to read out sensor data: ' + err);\r\n        });\r\n}\r\nfunction sendMessage() {\r\n    if (!sendingMessage) { return; }\r\n    var tempature = HTS221.getTempature();\r\n    var humidity = HTS221.getHumidity();\r\n    var messageObject = JSON.stringify({\r\n        messageId: messageId,\r\n        deviceId: 'Devkit playground',\r\n        temperature: tempature,\r\n        humidity: humidity\r\n    });\r\n    var message = new Message(messageObject);\r\n    message.properties.add('temperatureAlert', (tempature > 30).toString());\r\n    console.log(\"Sending message: \" + messageObject);\r\n    client.sendEvent(message, async function (err) {\r\n        if (err) {\r\n            console.error('Failed to send message to Azure IoT Hub');\r\n        } else {\r\n            await blinkSendConfirmation();\r\n            console.log('Message sent to Azure IoT Hub');\r\n        }\r\n    });\r\n    console.log(\"IoTHubClient accepted the message for delivery\");\r\n}\r\nfunction onStart(request, response) {\r\n    console.log('Try to invoke method start(' + request.payload + ')');\r\n    sendingMessage = true;\r\n    response.send(200, 'Successully start sending message to cloud', function (err) {\r\n        if (err) {\r\n            console.error('[IoT hub Client] Failed sending a method response:\\n' + err.message);\r\n        }\r\n    });\r\n}\r\nfunction onStop(request, response) {\r\n    console.log('Try to invoke method stop(' + request.payload + ')');\r\n    sendingMessage = false;\r\n    response.send(200, 'Successully stop sending message to cloud', function (err) {\r\n        if (err) {\r\n            console.error('[IoT hub Client] Failed sending a method response:\\n' + err.message);\r\n        }\r\n    });\r\n}\r\nfunction receiveMessageCallback(msg) {\r\n    blinkLED();\r\n    var message = msg.getData().toString('utf-8');\r\n    client.complete(msg, function () {\r\n        console.log('Receive message: ' + message);\r\n    });\r\n}\r\nasync function blinkLED() {\r\n    led.turnOff();\r\n    led.setColor(255,0,0);\r\n    await delay(500);\r\n    led.turnOff();\r\n}\r\nasync function blinkSendConfirmation() {\r\n    led.turnOff();\r\n    led.setColor(66, 229, 244);\r\n    await delay(500);\r\n    led.turnOff();\r\n}\r\nfunction delay(ms) {\r\n    return new Promise(resolve => setTimeout(resolve, ms));\r\n}\r\nasync function setup() {\r\n    Screen.print(0, \"Azure IoT DevKit\");\r\n    Screen.print(1, \"192.168.1.1\");\r\n    Screen.print(2, \"Connecting\");\r\n    await delay(1000);\r\n    Screen.print(2, \"Running...\");\r\n    // TODO: send telemetry data\r\n    client = Client.fromConnectionString(connectionString, Protocol);\r\n    client.open(function (err) {\r\n        if (err) {\r\n            console.error('[IoT hub Client] Connect error: ' + err.message);\r\n            return;\r\n        }\r\n        client.onDeviceMethod('start', onStart);\r\n        client.onDeviceMethod('stop', onStop);\r\n        client.on('message', receiveMessageCallback);\r\n        sendingMessage = true;\r\n    });\r\n}\r\nfunction loop() {\r\n    if (sendingMessage) {\r\n        sendMessage();\r\n    }\r\n}\r\nasync function run() {\r\n    await setup();\r\n    while (true) {\r\n        loop();\r\n        await delay(3000);\r\n    }\r\n}\r\nrun();\r\n"

/***/ },
/* 404 */
/***/ function(module, exports) {

	module.exports = "#include \"HTS221Sensor.h\"\r\n#include \"AzureIotHub.h\"\r\n#include \"Arduino.h\"\r\n#include <ArduinoJson.h>\r\n#include \"config.h\"\r\n#include \"RGB_LED.h\"\r\n\r\n#define RGB_LED_BRIGHTNESS 32\r\n\r\nDevI2C *i2c;\r\nHTS221Sensor *sensor;\r\nstatic RGB_LED rgbLed;\r\nstatic int interval = INTERVAL;\r\n\r\nint getInterval()\r\n{\r\n    return interval;\r\n}\r\n\r\nvoid blinkLED()\r\n{\r\n    rgbLed.turnOff();\r\n    rgbLed.setColor(RGB_LED_BRIGHTNESS, 0, 0);\r\n    delay(500);\r\n    rgbLed.turnOff();\r\n}\r\n\r\nvoid blinkSendConfirmation()\r\n{\r\n    rgbLed.turnOff();\r\n    rgbLed.setColor(0, 0, RGB_LED_BRIGHTNESS);\r\n    delay(500);\r\n    rgbLed.turnOff();\r\n}\r\n\r\nvoid parseTwinMessage(const char *message)\r\n{\r\n    StaticJsonBuffer<MESSAGE_MAX_LEN> jsonBuffer;\r\n    JsonObject &root = jsonBuffer.parseObject(message);\r\n    if (!root.success())\r\n    {\r\n        LogError(\"parse %s failed\", message);\r\n        return;\r\n    }\r\n\r\n    if (root[\"desired\"][\"interval\"].success())\r\n    {\r\n        interval = root[\"desired\"][\"interval\"];\r\n    }\r\n    else if (root.containsKey(\"interval\"))\r\n    {\r\n        interval = root[\"interval\"];\r\n    }\r\n}\r\n\r\nvoid sensorInit()\r\n{\r\n    i2c = new DevI2C(D14, D15);\r\n    sensor = new HTS221Sensor(*i2c);\r\n    sensor->init(NULL);\r\n}\r\n\r\nfloat readTemperature()\r\n{\r\n    sensor->reset();\r\n\r\n    float temperature = 0;\r\n    sensor->getTemperature(&temperature);\r\n\r\n    return temperature;\r\n}\r\n\r\nfloat readHumidity()\r\n{\r\n    sensor->reset();\r\n\r\n    float humidity = 0;\r\n    sensor->getHumidity(&humidity);\r\n\r\n    return humidity;\r\n}\r\n\r\nbool readMessage(int messageId, char *payload)\r\n{\r\n    float temperature = readTemperature();\r\n    float humidity = readHumidity();\r\n    StaticJsonBuffer<MESSAGE_MAX_LEN> jsonBuffer;\r\n    JsonObject& root = jsonBuffer.createObject();\r\n    root[\"deviceId\"] = DEVICE_ID;\r\n    root[\"messageId\"] = messageId;\r\n    bool temperatureAlert = false;\r\n\r\n    if(temperature != temperature)\r\n    {\r\n        root[\"temperature\"] = NULL;\r\n    }\r\n    else\r\n    {\r\n        root[\"temperature\"] = temperature;\r\n        if(temperature > TEMPERATURE_ALERT)\r\n        {\r\n            temperatureAlert = true;\r\n        }\r\n    }\r\n\r\n    if(humidity != humidity)\r\n    {\r\n        root[\"humidity\"] = NULL;\r\n    }\r\n    else\r\n    {\r\n        root[\"humidity\"] = humidity;\r\n    }\r\n    root.printTo(payload, MESSAGE_MAX_LEN);\r\n    return temperatureAlert;\r\n}"

/***/ },
/* 405 */
/***/ function(module, exports) {

	module.exports = "// Copyright (c) Microsoft. All rights reserved.\r\n// Licensed under the MIT license. See LICENSE file in the project root for full license information.\r\n\r\n#ifndef UTILITY_H\r\n#define UTILITY_H\r\n\r\nvoid parseTwinMessage(const char *);\r\nbool readMessage(int, char *);\r\nvoid sensorInit(void);\r\nvoid blinkLED(void);\r\nvoid blinkSendConfirmation(void);\r\nint getInterval(void);\r\n\r\n#endif /* UTILITY_H */"

/***/ },
/* 406 */
/***/ function(module, exports) {

	module.exports = "// Copyright (c) Microsoft. All rights reserved.\r\n// Licensed under the MIT license. \r\n#include \"Arduino.h\"\r\n#include \"ShakeUI.h\"\r\n#include \"SystemTickCounter.h\"\r\n\r\n//////////////////////////////////////////////////////////////////////////////////////////////////////////\r\n// Shake shake icon\r\nstatic const unsigned char smallTweet [] = \r\n{\r\n    0x00,0x00,0x38,0xf0,0xe0,0xe0,0xc0,0xc0,0xf0,0xfc,0xfa,0xfa,0xd8,0xf0,0xe0,0x80,\r\n    0x40,0x00,\r\n    0x00,0x04,0x08,0x18,0x19,0x3b,0x3f,0x3f,0x3f,0x3f,0x3f,0x1f,0x1f,0x0f,0x07,0x01,\r\n    0x01,0x00,\r\n};\r\n\r\nvoid DrawAppTitle(char* text)\r\n{\r\n    char sz[32];\r\n    snprintf(sz, 32, \"   %s\", text);\r\n    Screen.print(0, sz);\r\n    Screen.draw(0, 0, 18, 2, (unsigned char*)smallTweet);\r\n}\r\n\r\n//////////////////////////////////////////////////////////////////////////////////////////////////////////\r\n// Shake shake animation\r\nstatic const unsigned char shakeImag1 [] =\r\n{\r\n    0x00,0x00,0x00,0x00,0x00,0xC0,0xE0,0xF0,0x38,0x9C,0xDE,0xEF,0x77,0x76,0xB0,0x80,0xC0,0xC0,0xC0,0xC0,0xE0,0xE0,0xE0,0xF0,0x70,0x70,0x70,0x78,0x38,0x38,0x78,0xF8,0xF0,0xC0,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,\r\n    0x00,0x00,0x00,0x00,0x00,0x03,0x03,0x00,0x06,0x87,0xC3,0xF9,0xFE,0x7F,0x7F,0x7F,0x73,0xE3,0xE1,0xE1,0xC1,0x81,0x00,0xC0,0xE0,0xF0,0x38,0x18,0x1C,0x1C,0x0C,0x0F,0x8F,0x8F,0x8E,0xFC,0xFC,0xF0,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,\r\n    0x00,0x00,0x00,0x00,0x00,0x00,0x00,0xF8,0xFF,0xFF,0x07,0x01,0x00,0x00,0x70,0xF0,0xE0,0xE0,0x61,0x61,0x63,0xE3,0xFF,0x7E,0x79,0xFF,0xCF,0x86,0xC7,0xC7,0xC7,0xC3,0xC3,0xE3,0x61,0x63,0x73,0x7F,0xFE,0xC0,0x80,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,\r\n    0x00,0x00,0x00,0x00,0x00,0x80,0xC0,0xC0,0xF7,0xFF,0x3F,0x18,0x00,0x00,0x00,0x07,0x7F,0xFF,0xFC,0xF0,0xC0,0x00,0x00,0x00,0x00,0x00,0x01,0x1F,0x3F,0xB1,0xF1,0x70,0x30,0x30,0x18,0x18,0x18,0x1C,0x1F,0xFF,0xF3,0xE0,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,\r\n    0x38,0x7C,0xFE,0xFE,0xEF,0xC7,0x83,0x01,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x83,0xFF,0xFF,0xFF,0xF0,0xC0,0xC0,0xC0,0xC0,0xC0,0xC0,0xE0,0xE3,0xE7,0xE6,0xEE,0xEC,0xEE,0xE6,0x76,0x7F,0x7F,0xBF,0xCF,0xF0,0x7C,0x3C,0xC0,0xF8,0xFC,0x38,0x00,0x00,0x00,0x00,0x00,0x00,\r\n    0x00,0x00,0x00,0x01,0x03,0x03,0x07,0x0F,0x1E,0x3C,0x78,0xF8,0xF0,0xF0,0xF8,0x7C,0x3F,0x1F,0x07,0x01,0x01,0x03,0x03,0x03,0x03,0x03,0x03,0x01,0x01,0x01,0x01,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x01,0x03,0x09,0x1D,0x0E,0x0F,0x07,0x03,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,\r\n};\r\n\r\nstatic const unsigned char shakeImag2 [] =\r\n{\r\n    0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0xC0,0xE0,0xF0,0x38,0x9C,0xDE,0xEF,0x77,0x76,0xB0,0x80,0xC0,0xC0,0xC0,0xC0,0xE0,0xE0,0xE0,0xF0,0x70,0x70,0x70,0x78,0x38,0x38,0x78,0xF8,0xF0,0xC0,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,\r\n    0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x03,0x03,0x00,0x06,0x87,0xC3,0xF9,0xFE,0x7F,0x7F,0x7F,0x73,0xE3,0xE1,0xE1,0xC1,0x81,0x00,0xC0,0xE0,0xF0,0x38,0x18,0x1C,0x1C,0x0C,0x0F,0x8F,0x8F,0x8E,0xFC,0xFC,0xF0,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,\r\n    0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0xF8,0xFF,0xFF,0x07,0x01,0x00,0x00,0x70,0xF0,0xE0,0xE0,0x61,0x61,0x63,0xE3,0xFF,0x7E,0x79,0xFF,0xCF,0x86,0xC7,0xC7,0xC7,0xC3,0xC3,0xE3,0x61,0x63,0x73,0x7F,0xFE,0xC0,0x80,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,\r\n    0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x80,0xC0,0xC0,0xF7,0xFF,0x3F,0x18,0x00,0x00,0x00,0x07,0x7F,0xFF,0xFC,0xF0,0xC0,0x00,0x00,0x00,0x00,0x00,0x01,0x1F,0x3F,0xB1,0xF1,0x70,0x30,0x30,0x18,0x18,0x18,0x1C,0x1F,0xFF,0xF3,0xE0,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,\r\n    0x00,0x00,0x00,0x38,0x7C,0xFE,0xFE,0xEF,0xC7,0x83,0x01,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x83,0xFF,0xFF,0xFF,0xF0,0xC0,0xC0,0xC0,0xC0,0xC0,0xC0,0xE0,0xE3,0xE7,0xE6,0xEE,0xEC,0xEE,0xE6,0x76,0x7F,0x7F,0xBF,0xCF,0xF0,0x7C,0x3C,0xC0,0xF8,0xFC,0x38,0x00,0x00,0x00,\r\n    0x00,0x00,0x00,0x00,0x00,0x00,0x01,0x03,0x03,0x07,0x0F,0x1E,0x3C,0x78,0xF8,0xF0,0xF0,0xF8,0x7C,0x3F,0x1F,0x07,0x01,0x01,0x03,0x03,0x03,0x03,0x03,0x03,0x01,0x01,0x01,0x01,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x01,0x03,0x09,0x1D,0x0E,0x0F,0x07,0x03,0x00,0x00,0x00,0x00,0x00,\r\n};\r\n\r\nstatic const unsigned char shakeImag3 [] =\r\n{\r\n    0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0xC0,0xE0,0xF0,0x38,0x9C,0xDE,0xEF,0x77,0x76,0xB0,0x80,0xC0,0xC0,0xC0,0xC0,0xE0,0xE0,0xE0,0xF0,0x70,0x70,0x70,0x78,0x38,0x38,0x78,0xF8,0xF0,0xC0,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,\r\n    0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x03,0x03,0x00,0x06,0x87,0xC3,0xF9,0xFE,0x7F,0x7F,0x7F,0x73,0xE3,0xE1,0xE1,0xC1,0x81,0x00,0xC0,0xE0,0xF0,0x38,0x18,0x1C,0x1C,0x0C,0x0F,0x8F,0x8F,0x8E,0xFC,0xFC,0xF0,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,\r\n    0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0xF8,0xFF,0xFF,0x07,0x01,0x00,0x00,0x70,0xF0,0xE0,0xE0,0x61,0x61,0x63,0xE3,0xFF,0x7E,0x79,0xFF,0xCF,0x86,0xC7,0xC7,0xC7,0xC3,0xC3,0xE3,0x61,0x63,0x73,0x7F,0xFE,0xC0,0x80,0x00,0x00,0x00,0x00,0x00,0x00,0x00,\r\n    0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x80,0xC0,0xC0,0xF7,0xFF,0x3F,0x18,0x00,0x00,0x00,0x07,0x7F,0xFF,0xFC,0xF0,0xC0,0x00,0x00,0x00,0x00,0x00,0x01,0x1F,0x3F,0xB1,0xF1,0x70,0x30,0x30,0x18,0x18,0x18,0x1C,0x1F,0xFF,0xF3,0xE0,0x00,0x00,0x00,0x00,0x00,0x00,\r\n    0x00,0x00,0x00,0x00,0x00,0x00,0x38,0x7C,0xFE,0xFE,0xEF,0xC7,0x83,0x01,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x83,0xFF,0xFF,0xFF,0xF0,0xC0,0xC0,0xC0,0xC0,0xC0,0xC0,0xE0,0xE3,0xE7,0xE6,0xEE,0xEC,0xEE,0xE6,0x76,0x7F,0x7F,0xBF,0xCF,0xF0,0x7C,0x3C,0xC0,0xF8,0xFC,0x38,\r\n    0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x01,0x03,0x03,0x07,0x0F,0x1E,0x3C,0x78,0xF8,0xF0,0xF0,0xF8,0x7C,0x3F,0x1F,0x07,0x01,0x01,0x03,0x03,0x03,0x03,0x03,0x03,0x01,0x01,0x01,0x01,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x01,0x03,0x09,0x1D,0x0E,0x0F,0x07,0x03,0x00,0x00,\r\n};\r\n\r\nstatic const unsigned char* listShake[4] = { shakeImag1, shakeImag2, shakeImag3, shakeImag1 };\r\nstatic  int idx = 0;\r\n\r\nvoid DrawShakeAnimation(void)\r\n{\r\n    idx = (idx + 1) % 4;\r\n    Screen.draw(35, 2, 35 + 54, 8, (unsigned char*)listShake[idx]);\r\n}\r\n\r\n//////////////////////////////////////////////////////////////////////////////////////////////////////////\r\n// Checkbox\r\nstatic const unsigned char imgCheckbox1 [] = \r\n{\r\n    0x00,0x00,0xfc,0x04,0x04,0x04,0x04,0x04,0x04,0x04,0x04,0x04,0x04,0xfc,0x00,0x00,\r\n    0x00,0x00,0x3f,0x20,0x20,0x20,0x20,0x20,0x20,0x20,0x20,0x20,0x20,0x3f,0x00,0x00\r\n};\r\n\r\nstatic const unsigned char imgCheckbox2 [] = \r\n{\r\n    0x00,0x00,0xfc,0x04,0x84,0x84,0x04,0x04,0x84,0x84,0x44,0x24,0x04,0xfc,0x00,0x00,\r\n    0x00,0x00,0x3f,0x20,0x20,0x21,0x23,0x23,0x21,0x20,0x20,0x20,0x20,0x3f,0x00,0x00\r\n};\r\n\r\nvoid DrawCheckBox(int line, int col, int status)\r\n{\r\n    if (status == 0)\r\n    {\r\n        Screen.draw(col, line * 2, col + 16, line * 2 + 2, (unsigned char*)imgCheckbox1);\r\n    }\r\n    else\r\n    {\r\n        Screen.draw(col, line * 2, col + 16, line * 2 + 2, (unsigned char*)imgCheckbox2);\r\n    }\r\n}\r\n\r\n//////////////////////////////////////////////////////////////////////////////////////////////////////////\r\n// Incoming tweet\r\nstatic const unsigned char newTweet [] = \r\n{\r\n    0x00,0x00,0x00,0x00,0xc0,0xc0,0x80,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,\r\n    0x00,0x80,0xf0,0xf0,0xf8,0xdc,0xcc,0xcc,0xcc,0xc0,0xc0,0x80,0x00,0x00,0x00,0x00,\r\n    0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,\r\n    0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,\r\n    0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,\r\n    0x00,0x00,0x00,0x00,0x0f,0x1f,0xff,0xff,0xfe,0xfc,0xfc,0xfc,0xf8,0xf0,0xf0,0xf8,\r\n    0xff,0xff,0xff,0xff,0xff,0xff,0xff,0xff,0xff,0xf3,0xf3,0xff,0xff,0xfe,0xfc,0xe0,\r\n    0xe0,0x60,0x30,0x30,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0xf3,0xf3,0xcf,0xcf,\r\n    0xcf,0xcf,0x3f,0x3f,0x3f,0x3f,0xff,0xff,0xff,0xff,0xff,0xff,0xff,0xff,0xff,0xff,\r\n    0x3f,0x3f,0x3f,0x3f,0xcf,0xcf,0xcf,0xcf,0xf3,0xf3,0x00,0x00,\r\n    0x00,0x00,0x30,0x70,0xe0,0xc0,0xc0,0xc1,0xc3,0xc7,0xcf,0xef,0xff,0xff,0xff,0xff,\r\n    0xff,0xff,0xff,0xff,0xff,0xff,0xff,0xff,0xff,0xff,0xff,0xff,0xff,0x7f,0x3f,0x07,\r\n    0x03,0x07,0x06,0x06,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0xff,0xff,0xff,0xff,\r\n    0xff,0xff,0xff,0xff,0xff,0xff,0xfc,0xfc,0xfc,0xfc,0xf3,0xf3,0xfc,0xfc,0xfe,0xfe,\r\n    0xff,0xff,0xff,0xff,0xff,0xff,0xff,0xff,0xff,0xff,0x00,0x00,\r\n    0x00,0x00,0x00,0x00,0x00,0x01,0x03,0x03,0x03,0x07,0x0f,0x0f,0x0f,0x0f,0x0f,0x0f,\r\n    0x0f,0x0f,0x0f,0x0f,0x0f,0x0f,0x0f,0x07,0x03,0x03,0x03,0x01,0x00,0x00,0x00,0x00,\r\n    0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x03,0x03,0x03,0x03,\r\n    0x03,0x03,0x03,0x03,0x03,0x03,0x03,0x03,0x03,0x03,0x03,0x03,0x03,0x03,0x03,0x03,\r\n    0x03,0x03,0x03,0x03,0x03,0x03,0x03,0x03,0x03,0x03,0x00,0x00\r\n};\r\n\r\nstatic const unsigned char bigCry [] =\r\n{\r\n    0x00,0x00,0x00,0x00,0x00,0x00,0x80,0xc0,0xe0,0xf0,0xf0,0xf8,0xf8,0xfc,0xfc,0xfc,\r\n    0xfc,0xfc,0xfc,0xf8,0xf8,0xf0,0xf0,0xe0,0xc0,0x80,0x00,0x00,0x00,0x00,0x00,0x00,\r\n    0x00,0x00,0xe0,0xf8,0xfe,0xff,0xff,0xe7,0xc3,0x81,0x81,0xc3,0xe7,0xff,0xff,0xff,\r\n    0xff,0xff,0xff,0xe7,0xc3,0x81,0x81,0xc3,0xe7,0xff,0xff,0xfe,0xf8,0xe0,0x00,0x00,\r\n    0x00,0x00,0x07,0x1f,0x7f,0xff,0xff,0xdf,0x8f,0x87,0xc3,0xe3,0xf1,0xf1,0xf8,0xf8,\r\n    0xf8,0xf8,0xf1,0xf1,0xe3,0xc3,0x87,0x8f,0xdf,0xff,0xff,0x7f,0x1f,0x07,0x00,0x00,\r\n    0x00,0x00,0x00,0x00,0x00,0x00,0x01,0x03,0x07,0x0f,0x0f,0x1f,0x1f,0x3f,0x3f,0x3f,\r\n    0x3f,0x3f,0x3f,0x1f,0x1f,0x0f,0x0f,0x07,0x03,0x01,0x00,0x00,0x00,0x00,0x00,0x00\r\n};\r\n\r\nvoid DrawTweetImage(int line, int col, int status)\r\n{\r\n    if (status == 0)\r\n    {\r\n        Screen.draw(col + 20, line * 2, col + 52, line * 2 + 4, (unsigned char*)bigCry);\r\n    }\r\n    else \r\n    {\r\n        Screen.draw(col, line * 2, col + 76, line * 2 + 4, (unsigned char*)newTweet);\r\n    }\r\n}"

/***/ },
/* 407 */
/***/ function(module, exports) {

	module.exports = "// Copyright (c) Microsoft. All rights reserved.\r\n// Licensed under the MIT license. \r\n\r\n#ifndef __SHAKE_UI_H__\r\n#define __SHAKE_UI_H__\r\n\r\n#ifdef __cplusplus\r\nextern \"C\"{\r\n#endif // __cplusplus\r\n\r\nvoid DrawAppTitle(char* text);\r\n\r\nvoid DrawShakeAnimation(void);\r\n\r\nvoid DrawCheckBox(int line, int col, int status);\r\n\r\nvoid DrawTweetImage(int line, int col, int status);\r\n\r\n#ifdef __cplusplus\r\n}\r\n#endif // __cplusplus\r\n\r\n#endif // __SHAKE_UI_H__"

/***/ },
/* 408 */
/***/ function(module, exports) {

	module.exports = "#r \"Newtonsoft.Json\"\n#r \"System.Web\"\n\nusing System;\nusing System.Text;\nusing System.Configuration;\nusing System.Net;\nusing System.IO;\nusing System.Web;\n\nusing Microsoft.Azure.Devices;\nusing Newtonsoft.Json;\nusing Newtonsoft.Json.Linq;\n\npublic class DeviceObject\n{\n    public string topic;\n}\n\npublic class ShakeShakeException : Exception\n{\n    public ShakeShakeException(string message)\n        : base($\"ShakeShakeError:{message}\")\n    {\n    }\n}\n\nstatic ServiceClient serviceClient;\n\npublic static void Run(string myEventHubMessage, TraceWriter log)\n{\n    log.Info($\"C# Event Hub trigger function processed a message: {myEventHubMessage}\");\n    string deviceId = \"AZ3166\";\n\n    DeviceObject deviceObject;\n    try\n    {\n        deviceObject =\n            Newtonsoft.Json.JsonConvert.DeserializeObject<DeviceObject>(myEventHubMessage);\n    }\n    catch (Exception ex)\n    {\n        throw new ShakeShakeException($\"Failed to deserialize message:{myEventHubMessage}. Error detail: {ex.Message}\");\n    }\n    \n    if (String.IsNullOrEmpty(deviceObject.topic))\n    {\n        // No hash tag or this is a heartbeat package\n        return;\n    }\n    \n    string message = string.Empty;\n    try\n    {\n        string tweet = string.Empty;\n        string url = \"https://api.twitter.com/1.1/search/tweets.json\" + \"?count=3&q=%23\" + HttpUtility.UrlEncode(deviceObject.topic);\n        string authHeader = \"Bearer \" + \"AAAAAAAAAAAAAAAAAAAAAGVU0AAAAAAAucpxA9aXc2TO6rNMnTcVit1P3YM%3DrQpyFeQ6LOwyvy7cqW5djhLPnFfjEK8H3hA1qfGDh93JRbI1le\";\n\n        HttpWebRequest request = (HttpWebRequest)WebRequest.Create(url);\n        request.Headers.Add(\"Authorization\", authHeader);\n        request.Method = \"GET\";\n        request.ContentType = \"application/x-www-form-urlencoded;charset=UTF-8\";\n\n        var response = (HttpWebResponse)request.GetResponse();\n        var reader = new StreamReader(response.GetResponseStream());\n        string objText = reader.ReadToEnd();\n\n        try\n        {\n            JObject o = JObject.Parse(objText);\n            string name = o[\"statuses\"][0][\"user\"][\"name\"].ToString();\n            string txt = o[\"statuses\"][0][\"text\"].ToString();\n\n            message = $\"@{name}:\\n {txt}\";\n        }\n        catch\n        {\n            message = \"No new tweet.\";\n        }\n    }\n    catch(Exception ex)\n    {\n        throw new ShakeShakeException($\"Failed to call twitter API: {ex.Message}\");\n    }\n\n    log.Info($\"Twitter: {message}\");\n\n    try\n    {\n        var connectionString = ConfigurationManager.AppSettings[\"iotHubConnectionString\"];\n        serviceClient = ServiceClient.CreateFromConnectionString(connectionString);\n        var commandMessage = new Message(Encoding.ASCII.GetBytes(message));\n        serviceClient.SendAsync(deviceId, commandMessage);\n    }\n    catch(Exception ex)\n    {\n        throw new ShakeShakeException($\"Failed to send C2D message: {ex.Message}\");\n    }\n}"

/***/ },
/* 409 */
/***/ function(module, exports) {

	module.exports = "/*\r\n* IoT Hub Raspberry Pi NodeJS - Microsoft Sample Code - Copyright (c) 2017 - Licensed MIT\r\n*/\r\nconst Client = require('azure-iot-device').Client;\r\nconst Message = require('azure-iot-device').Message;\r\nconst Protocol = require('azure-iot-device-mqtt').Mqtt;\r\nvar rgbLed = require('led');\r\nvar buttonA = require('buttonA');\r\nvar buttonB = require('buttonB');\r\nvar Screen = require('oled');\r\nvar HTS221 = require('hts221');\r\nvar LSM6DSL = require('lsm6dsl');\r\nvar traceEvent = require('traceEvent');\r\nconst connectionString = '[CONNECTION_STRING_PLACE_HOLDER]';\r\nvar sendingMessage = false;\r\nvar messageId = 0;\r\nvar client, sensor;\r\nvar iot_event = \"{\\\"topic\\\":\\\"[TOPIC_PLACE_HOLDER]\\\"}\";\r\nvar iot_event_heartbeat = \"{\\\"topic\\\":\\\"\\\"}\";\r\nvar msgHeader = \"\";\r\nvar msgBody = \"\";\r\nvar msgStart = 0;\r\nvar app_status;\r\nvar shake_progress;\r\nvar hb_interval_ms = SystemTickCounterRead();\r\nvar tweet_timeout_ms;\r\nvar idx = 0;\r\nconst RGB_LED_BRIGHTNESS = 256;\r\nconst HEARTBEAT_INTERVAL = 300000;\r\nconst PULL_TIMEOUT = 15000;\r\nconst SCROLL_OFFSET = 16;\r\nconst MSG_HEADER_SIZE = 20;\r\nconst MSG_BODY_SIZE = 200;\r\n\r\nvar smallTweet =\r\n    [\r\n        0x00, 0x00, 0x38, 0xf0, 0xe0, 0xe0, 0xc0, 0xc0, 0xf0, 0xfc, 0xfa, 0xfa, 0xd8, 0xf0, 0xe0, 0x80,\r\n        0x40, 0x00,\r\n        0x00, 0x04, 0x08, 0x18, 0x19, 0x3b, 0x3f, 0x3f, 0x3f, 0x3f, 0x3f, 0x1f, 0x1f, 0x0f, 0x07, 0x01,\r\n        0x01, 0x00,\r\n    ];\r\n\r\nvar shakeImag1 =\r\n    [\r\n        0x00, 0x00, 0x00, 0x00, 0x00, 0xC0, 0xE0, 0xF0, 0x38, 0x9C, 0xDE, 0xEF, 0x77, 0x76, 0xB0, 0x80, 0xC0, 0xC0, 0xC0, 0xC0, 0xE0, 0xE0, 0xE0, 0xF0, 0x70, 0x70, 0x70, 0x78, 0x38, 0x38, 0x78, 0xF8, 0xF0, 0xC0, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,\r\n        0x00, 0x00, 0x00, 0x00, 0x00, 0x03, 0x03, 0x00, 0x06, 0x87, 0xC3, 0xF9, 0xFE, 0x7F, 0x7F, 0x7F, 0x73, 0xE3, 0xE1, 0xE1, 0xC1, 0x81, 0x00, 0xC0, 0xE0, 0xF0, 0x38, 0x18, 0x1C, 0x1C, 0x0C, 0x0F, 0x8F, 0x8F, 0x8E, 0xFC, 0xFC, 0xF0, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,\r\n        0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0xF8, 0xFF, 0xFF, 0x07, 0x01, 0x00, 0x00, 0x70, 0xF0, 0xE0, 0xE0, 0x61, 0x61, 0x63, 0xE3, 0xFF, 0x7E, 0x79, 0xFF, 0xCF, 0x86, 0xC7, 0xC7, 0xC7, 0xC3, 0xC3, 0xE3, 0x61, 0x63, 0x73, 0x7F, 0xFE, 0xC0, 0x80, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,\r\n        0x00, 0x00, 0x00, 0x00, 0x00, 0x80, 0xC0, 0xC0, 0xF7, 0xFF, 0x3F, 0x18, 0x00, 0x00, 0x00, 0x07, 0x7F, 0xFF, 0xFC, 0xF0, 0xC0, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x1F, 0x3F, 0xB1, 0xF1, 0x70, 0x30, 0x30, 0x18, 0x18, 0x18, 0x1C, 0x1F, 0xFF, 0xF3, 0xE0, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,\r\n        0x38, 0x7C, 0xFE, 0xFE, 0xEF, 0xC7, 0x83, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x83, 0xFF, 0xFF, 0xFF, 0xF0, 0xC0, 0xC0, 0xC0, 0xC0, 0xC0, 0xC0, 0xE0, 0xE3, 0xE7, 0xE6, 0xEE, 0xEC, 0xEE, 0xE6, 0x76, 0x7F, 0x7F, 0xBF, 0xCF, 0xF0, 0x7C, 0x3C, 0xC0, 0xF8, 0xFC, 0x38, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,\r\n        0x00, 0x00, 0x00, 0x01, 0x03, 0x03, 0x07, 0x0F, 0x1E, 0x3C, 0x78, 0xF8, 0xF0, 0xF0, 0xF8, 0x7C, 0x3F, 0x1F, 0x07, 0x01, 0x01, 0x03, 0x03, 0x03, 0x03, 0x03, 0x03, 0x01, 0x01, 0x01, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x03, 0x09, 0x1D, 0x0E, 0x0F, 0x07, 0x03, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,\r\n    ];\r\n\r\nvar shakeImag2 =\r\n    [\r\n        0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0xC0, 0xE0, 0xF0, 0x38, 0x9C, 0xDE, 0xEF, 0x77, 0x76, 0xB0, 0x80, 0xC0, 0xC0, 0xC0, 0xC0, 0xE0, 0xE0, 0xE0, 0xF0, 0x70, 0x70, 0x70, 0x78, 0x38, 0x38, 0x78, 0xF8, 0xF0, 0xC0, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,\r\n        0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03, 0x03, 0x00, 0x06, 0x87, 0xC3, 0xF9, 0xFE, 0x7F, 0x7F, 0x7F, 0x73, 0xE3, 0xE1, 0xE1, 0xC1, 0x81, 0x00, 0xC0, 0xE0, 0xF0, 0x38, 0x18, 0x1C, 0x1C, 0x0C, 0x0F, 0x8F, 0x8F, 0x8E, 0xFC, 0xFC, 0xF0, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,\r\n        0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0xF8, 0xFF, 0xFF, 0x07, 0x01, 0x00, 0x00, 0x70, 0xF0, 0xE0, 0xE0, 0x61, 0x61, 0x63, 0xE3, 0xFF, 0x7E, 0x79, 0xFF, 0xCF, 0x86, 0xC7, 0xC7, 0xC7, 0xC3, 0xC3, 0xE3, 0x61, 0x63, 0x73, 0x7F, 0xFE, 0xC0, 0x80, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,\r\n        0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x80, 0xC0, 0xC0, 0xF7, 0xFF, 0x3F, 0x18, 0x00, 0x00, 0x00, 0x07, 0x7F, 0xFF, 0xFC, 0xF0, 0xC0, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x1F, 0x3F, 0xB1, 0xF1, 0x70, 0x30, 0x30, 0x18, 0x18, 0x18, 0x1C, 0x1F, 0xFF, 0xF3, 0xE0, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,\r\n        0x00, 0x00, 0x00, 0x38, 0x7C, 0xFE, 0xFE, 0xEF, 0xC7, 0x83, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x83, 0xFF, 0xFF, 0xFF, 0xF0, 0xC0, 0xC0, 0xC0, 0xC0, 0xC0, 0xC0, 0xE0, 0xE3, 0xE7, 0xE6, 0xEE, 0xEC, 0xEE, 0xE6, 0x76, 0x7F, 0x7F, 0xBF, 0xCF, 0xF0, 0x7C, 0x3C, 0xC0, 0xF8, 0xFC, 0x38, 0x00, 0x00, 0x00,\r\n        0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x03, 0x03, 0x07, 0x0F, 0x1E, 0x3C, 0x78, 0xF8, 0xF0, 0xF0, 0xF8, 0x7C, 0x3F, 0x1F, 0x07, 0x01, 0x01, 0x03, 0x03, 0x03, 0x03, 0x03, 0x03, 0x01, 0x01, 0x01, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x03, 0x09, 0x1D, 0x0E, 0x0F, 0x07, 0x03, 0x00, 0x00, 0x00, 0x00, 0x00,\r\n    ];\r\n\r\nvar shakeImag3 =\r\n    [\r\n        0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0xC0, 0xE0, 0xF0, 0x38, 0x9C, 0xDE, 0xEF, 0x77, 0x76, 0xB0, 0x80, 0xC0, 0xC0, 0xC0, 0xC0, 0xE0, 0xE0, 0xE0, 0xF0, 0x70, 0x70, 0x70, 0x78, 0x38, 0x38, 0x78, 0xF8, 0xF0, 0xC0, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,\r\n        0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03, 0x03, 0x00, 0x06, 0x87, 0xC3, 0xF9, 0xFE, 0x7F, 0x7F, 0x7F, 0x73, 0xE3, 0xE1, 0xE1, 0xC1, 0x81, 0x00, 0xC0, 0xE0, 0xF0, 0x38, 0x18, 0x1C, 0x1C, 0x0C, 0x0F, 0x8F, 0x8F, 0x8E, 0xFC, 0xFC, 0xF0, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,\r\n        0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0xF8, 0xFF, 0xFF, 0x07, 0x01, 0x00, 0x00, 0x70, 0xF0, 0xE0, 0xE0, 0x61, 0x61, 0x63, 0xE3, 0xFF, 0x7E, 0x79, 0xFF, 0xCF, 0x86, 0xC7, 0xC7, 0xC7, 0xC3, 0xC3, 0xE3, 0x61, 0x63, 0x73, 0x7F, 0xFE, 0xC0, 0x80, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,\r\n        0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x80, 0xC0, 0xC0, 0xF7, 0xFF, 0x3F, 0x18, 0x00, 0x00, 0x00, 0x07, 0x7F, 0xFF, 0xFC, 0xF0, 0xC0, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x1F, 0x3F, 0xB1, 0xF1, 0x70, 0x30, 0x30, 0x18, 0x18, 0x18, 0x1C, 0x1F, 0xFF, 0xF3, 0xE0, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,\r\n        0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x38, 0x7C, 0xFE, 0xFE, 0xEF, 0xC7, 0x83, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x83, 0xFF, 0xFF, 0xFF, 0xF0, 0xC0, 0xC0, 0xC0, 0xC0, 0xC0, 0xC0, 0xE0, 0xE3, 0xE7, 0xE6, 0xEE, 0xEC, 0xEE, 0xE6, 0x76, 0x7F, 0x7F, 0xBF, 0xCF, 0xF0, 0x7C, 0x3C, 0xC0, 0xF8, 0xFC, 0x38,\r\n        0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x03, 0x03, 0x07, 0x0F, 0x1E, 0x3C, 0x78, 0xF8, 0xF0, 0xF0, 0xF8, 0x7C, 0x3F, 0x1F, 0x07, 0x01, 0x01, 0x03, 0x03, 0x03, 0x03, 0x03, 0x03, 0x01, 0x01, 0x01, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x03, 0x09, 0x1D, 0x0E, 0x0F, 0x07, 0x03, 0x00, 0x00,\r\n    ];\r\n\r\nvar imgCheckbox1 =\r\n    [\r\n        0x00, 0x00, 0xfc, 0x04, 0x04, 0x04, 0x04, 0x04, 0x04, 0x04, 0x04, 0x04, 0x04, 0xfc, 0x00, 0x00,\r\n        0x00, 0x00, 0x3f, 0x20, 0x20, 0x20, 0x20, 0x20, 0x20, 0x20, 0x20, 0x20, 0x20, 0x3f, 0x00, 0x00\r\n    ];\r\n\r\nvar imgCheckbox2 =\r\n    [\r\n        0x00, 0x00, 0xfc, 0x04, 0x84, 0x84, 0x04, 0x04, 0x84, 0x84, 0x44, 0x24, 0x04, 0xfc, 0x00, 0x00,\r\n        0x00, 0x00, 0x3f, 0x20, 0x20, 0x21, 0x23, 0x23, 0x21, 0x20, 0x20, 0x20, 0x20, 0x3f, 0x00, 0x00\r\n    ];\r\n\r\nvar bigCry =\r\n    [\r\n        0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x80, 0xc0, 0xe0, 0xf0, 0xf0, 0xf8, 0xf8, 0xfc, 0xfc, 0xfc,\r\n        0xfc, 0xfc, 0xfc, 0xf8, 0xf8, 0xf0, 0xf0, 0xe0, 0xc0, 0x80, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,\r\n        0x00, 0x00, 0xe0, 0xf8, 0xfe, 0xff, 0xff, 0xe7, 0xc3, 0x81, 0x81, 0xc3, 0xe7, 0xff, 0xff, 0xff,\r\n        0xff, 0xff, 0xff, 0xe7, 0xc3, 0x81, 0x81, 0xc3, 0xe7, 0xff, 0xff, 0xfe, 0xf8, 0xe0, 0x00, 0x00,\r\n        0x00, 0x00, 0x07, 0x1f, 0x7f, 0xff, 0xff, 0xdf, 0x8f, 0x87, 0xc3, 0xe3, 0xf1, 0xf1, 0xf8, 0xf8,\r\n        0xf8, 0xf8, 0xf1, 0xf1, 0xe3, 0xc3, 0x87, 0x8f, 0xdf, 0xff, 0xff, 0x7f, 0x1f, 0x07, 0x00, 0x00,\r\n        0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x03, 0x07, 0x0f, 0x0f, 0x1f, 0x1f, 0x3f, 0x3f, 0x3f,\r\n        0x3f, 0x3f, 0x3f, 0x1f, 0x1f, 0x0f, 0x0f, 0x07, 0x03, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00\r\n    ];\r\n\r\nvar newTweet =\r\n    [\r\n        0x00, 0x00, 0x00, 0x00, 0xc0, 0xc0, 0x80, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,\r\n        0x00, 0x80, 0xf0, 0xf0, 0xf8, 0xdc, 0xcc, 0xcc, 0xcc, 0xc0, 0xc0, 0x80, 0x00, 0x00, 0x00, 0x00,\r\n        0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,\r\n        0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,\r\n        0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,\r\n        0x00, 0x00, 0x00, 0x00, 0x0f, 0x1f, 0xff, 0xff, 0xfe, 0xfc, 0xfc, 0xfc, 0xf8, 0xf0, 0xf0, 0xf8,\r\n        0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xf3, 0xf3, 0xff, 0xff, 0xfe, 0xfc, 0xe0,\r\n        0xe0, 0x60, 0x30, 0x30, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0xf3, 0xf3, 0xcf, 0xcf,\r\n        0xcf, 0xcf, 0x3f, 0x3f, 0x3f, 0x3f, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff,\r\n        0x3f, 0x3f, 0x3f, 0x3f, 0xcf, 0xcf, 0xcf, 0xcf, 0xf3, 0xf3, 0x00, 0x00,\r\n        0x00, 0x00, 0x30, 0x70, 0xe0, 0xc0, 0xc0, 0xc1, 0xc3, 0xc7, 0xcf, 0xef, 0xff, 0xff, 0xff, 0xff,\r\n        0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0x7f, 0x3f, 0x07,\r\n        0x03, 0x07, 0x06, 0x06, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0xff, 0xff, 0xff, 0xff,\r\n        0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xfc, 0xfc, 0xfc, 0xfc, 0xf3, 0xf3, 0xfc, 0xfc, 0xfe, 0xfe,\r\n        0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0x00, 0x00,\r\n        0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x03, 0x03, 0x03, 0x07, 0x0f, 0x0f, 0x0f, 0x0f, 0x0f, 0x0f,\r\n        0x0f, 0x0f, 0x0f, 0x0f, 0x0f, 0x0f, 0x0f, 0x07, 0x03, 0x03, 0x03, 0x01, 0x00, 0x00, 0x00, 0x00,\r\n        0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03, 0x03, 0x03, 0x03,\r\n        0x03, 0x03, 0x03, 0x03, 0x03, 0x03, 0x03, 0x03, 0x03, 0x03, 0x03, 0x03, 0x03, 0x03, 0x03, 0x03,\r\n        0x03, 0x03, 0x03, 0x03, 0x03, 0x03, 0x03, 0x03, 0x03, 0x03, 0x00, 0x00\r\n    ];\r\n\r\nvar listShake = [\r\n    shakeImag1, shakeImag2, shakeImag3, shakeImag1\r\n];\r\n\r\nfunction SystemTickCounterRead() {\r\n    return +new Date();\r\n}\r\n\r\nfunction DrawAppTitle(text) {\r\n    let sz = \"   \" + text.substring(0, 32);\r\n    Screen.print(0, sz);\r\n    Screen.draw(0, 0, 18, 2, smallTweet);\r\n}\r\n\r\nfunction DrawShakeAnimation() {\r\n    idx = (idx + 1) % 4;\r\n    Screen.draw(35, 2, 35 + 54, 8, listShake[idx]);\r\n}\r\n\r\nfunction DrawCheckBox(line, col, status) {\r\n    if (status == 0) {\r\n        Screen.draw(col, line * 2, col + 16, line * 2 + 2, imgCheckbox1);\r\n    }\r\n    else {\r\n        Screen.draw(col, line * 2, col + 16, line * 2 + 2, imgCheckbox2);\r\n    }\r\n}\r\n\r\nfunction DrawTweetImage(line, col, status) {\r\n    if (status == 0) {\r\n        Screen.draw(col + 20, line * 2, col + 52, line * 2 + 4, bigCry);\r\n    }\r\n    else {\r\n        Screen.draw(col, line * 2, col + 76, line * 2 + 4, newTweet);\r\n    }\r\n}\r\n\r\nasync function ShowShakeProgress() {\r\n    if (shake_progress == 1) {\r\n        DrawAppTitle(\"Processing...\");\r\n        Screen.print(1, \"   DevKit\");\r\n        Screen.print(2, \"   Azure\");\r\n        Screen.print(3, \"   Twitter\");\r\n    }\r\n\r\n    DrawCheckBox(1, 0, (shake_progress >= 1) ? 1 : 0);\r\n    DrawCheckBox(2, 0, (shake_progress >= 2) ? 1 : 0);\r\n    DrawCheckBox(3, 0, (shake_progress == 4) ? 1 : 0);\r\n\r\n    await delay(500);\r\n}\r\n\r\nfunction NoTweets() {\r\n    Screen.clean();\r\n    DrawAppTitle(\"No tweets...\");\r\n    Screen.print(3, \"Press A to Shake!\");\r\n    DrawTweetImage(1, 20, 0);\r\n\r\n    // Turn off the RGB LED\r\n    rgbLed.setColor(0, 0, 0);\r\n\r\n    // Switch back to idle mode\r\n    app_status = 0;\r\n}\r\n\r\nfunction HeartBeat() {\r\n    let now = SystemTickCounterRead();\r\n    if (now - hb_interval_ms < HEARTBEAT_INTERVAL) {\r\n        return;\r\n    }\r\n    console.log(\">>Heartbeat<<\");\r\n    hb_interval_ms = SystemTickCounterRead();\r\n    // todo add user led\r\n    // var msgObj = new Message(iot_event);\r\n    // client.sendEvent(new Message(iot_event_heartbeat), async function (err) {\r\n    //     if (err) {\r\n    //         console.error('Failed to send message to Azure IoT Hub');\r\n    //     } else {\r\n    //         hb_interval_ms = SystemTickCounterRead();\r\n    //     }\r\n    // });\r\n}\r\n\r\nasync function blinkLED() {\r\n    rgbLed.turnOff();\r\n    rgbLed.setColor(66, 229, 244);\r\n    await delay(500);\r\n    rgbLed.turnOff();\r\n}\r\n\r\nfunction delay(ms) {\r\n    return new Promise(resolve => setTimeout(resolve, ms));\r\n}\r\n\r\nfunction min(a, b) {\r\n    return a < b ? a : b;\r\n}\r\n\r\nfunction ParseTweet(tweet, lenTweet) {\r\n    if (lenTweet == 0) {\r\n        msgHeader = \"\";\r\n        msgBody = \"\";\r\n        return false;\r\n    }\r\n\r\n    var message = tweet.getData().toString('utf-8');\r\n    var splitIndex = message.indexOf(\"\\n\");\r\n    if (splitIndex == -1) {\r\n        msgHeader = message;\r\n    } else {\r\n        msgHeader = message.substring(0, splitIndex);\r\n        msgBody = message.substring(splitIndex + 1);\r\n    }\r\n\r\n    msgHeader = msgHeader.substring(0, MSG_HEADER_SIZE);\r\n    msgBody = msgBody.substring(0, MSG_BODY_SIZE);\r\n    console.log(msgHeader);\r\n\r\n    if (msgHeader === \"No new tweet.\") {\r\n        // Not a tweet from Twitter, there must be something wrong on the Service side.\r\n        msgHeader = \"\";\r\n        msgBody = \"\";\r\n        return false;\r\n    }\r\n    else {\r\n        console.log(msgBody);\r\n        return true;\r\n    }\r\n}\r\nasync function TwitterMessageCallback(tweet, lenTweet) {\r\n    if (app_status != 2 || !tweet) {\r\n        // Return if not under do work mode or the tweet is empty.\r\n        return;\r\n    }\r\n\r\n    await delay(3000);\r\n\r\n    if (ParseTweet(tweet, lenTweet)) {\r\n        // The tweet message is OK\r\n        shake_progress = 4;\r\n    }\r\n    else {\r\n        // Got message from Azure, but not a tweet from Twitter.\r\n        // There must be something wrong on the Service side.\r\n        shake_progress = 3;\r\n    }\r\n}\r\nasync function setup() {\r\n    app_status = 0;\r\n    shake_progress = 0;\r\n    DrawAppTitle(\"IoT DevKit\");\r\n    Screen.print(2, \"Connecting...\");\r\n\r\n    Screen.print(3, \" > WiFi\");\r\n    await delay(1500);\r\n    // todo turn on wifi led\r\n    Screen.print(3, \" > LEDs\");\r\n    rgbLed.turnOff();\r\n    await delay(100);\r\n    Screen.print(3, \" > IoT Hub\");\r\n    await delay(1500);\r\n    rgbLed.setColor(RGB_LED_BRIGHTNESS, 0, 0);\r\n    // TODO: send telemetry data\r\n    client = Client.fromConnectionString(connectionString, Protocol);\r\n    client.open(function (err) {\r\n        if (err) {\r\n            console.error('[IoT hub Client] Connect error: ' + err.message);\r\n            return;\r\n        }\r\n        client.on('message', TwitterMessageCallback);\r\n        sendingMessage = true;\r\n        hb_interval_ms = -(HEARTBEAT_INTERVAL);   // Trigger heart beat immediately\r\n        HeartBeat();\r\n        rgbLed.turnOff();\r\n        // todo turn on azure led\r\n        Screen.print(1, \"192.168.1.1\");\r\n        Screen.print(2, \"Press A to Shake!\");\r\n        Screen.print(3, \" \");\r\n    });\r\n}\r\nasync function DoIdle() {\r\n    if (buttonA.getSwitch()) {\r\n        Screen.clean();\r\n        app_status = 1;\r\n        shake_progress = 0;\r\n        DrawAppTitle(\"Shake Shake!\");\r\n        rgbLed.setColor(0, RGB_LED_BRIGHTNESS, 0);\r\n        LSM6DSL.clearDistance();\r\n    } else if (buttonB.getSwitch()) {\r\n        ScrollTweet();\r\n    }\r\n    HeartBeat();\r\n}\r\nasync function DoShake() {\r\n    if (LSM6DSL.getDistance() > 600) {\r\n        app_status = 2;\r\n        shake_progress = 1;\r\n        // todo user led light on\r\n        rgbLed.setColor(RGB_LED_BRIGHTNESS, 0, 0);\r\n        ShowShakeProgress();\r\n        traceEvent('shake-success');\r\n\r\n        await delay(1000);\r\n        var msgObj = new Message(iot_event);\r\n        await delay(2000);\r\n        let promise = new Promise((resolve, reject) => {\r\n            client.sendEvent(msgObj, function (err) {\r\n                if (!err) {\r\n                    if (shake_progress < 2) {\r\n                        // Because the tweet may return quickly and the TwitterMessageCallback be executed before run to here,\r\n                        // So check the shake_progress to avoid set the wrong value.\r\n                        // IoT hub has got the message\r\n                        shake_progress = 2;\r\n                    }\r\n                    // Update the screen\r\n                    ShowShakeProgress();\r\n                    // Start retrieving tweet timeout clock\r\n                    tweet_timeout_ms = SystemTickCounterRead();\r\n                    resolve();\r\n                }\r\n                else {\r\n                    reject();\r\n                    NoTweets();\r\n                }\r\n                // todo user led off\r\n            });\r\n        });\r\n        await promise;\r\n    } else {\r\n        DrawShakeAnimation();\r\n    }\r\n}\r\nasync function DoWork() {\r\n    if (SystemTickCounterRead() - tweet_timeout_ms >= PULL_TIMEOUT) {\r\n        // Timeout\r\n        NoTweets();\r\n    }\r\n\r\n    if (shake_progress > 2) {\r\n        // Got the tweet message\r\n        // Update the progress\r\n        ShowShakeProgress();\r\n\r\n        if (shake_progress == 4) {\r\n            Screen.clean();\r\n            // Got the tweet\r\n            // Show the action UI and let user to choose read or shake again\r\n            DrawAppTitle(\"New tweet!\");\r\n            Screen.print(3, \"Press B to read!\");\r\n            DrawTweetImage(1, 20, 1);\r\n\r\n            // Prepare for reading and scrolling\r\n            msgStart = -SCROLL_OFFSET;\r\n\r\n            // Set RGB LED to blue, means for reading\r\n            rgbLed.setColor(0, 0, RGB_LED_BRIGHTNESS);\r\n            // Switch back to idle mode\r\n            app_status = 0;\r\n\r\n            // Log shake succeed message\r\n            //   LogShakeResult(\"ShakeShakeSucceed\");\r\n        }\r\n        else {\r\n            // No tweet\r\n            NoTweets();\r\n        }\r\n    }\r\n}\r\n\r\nasync function ScrollTweet() {\r\n    if (msgBody != \"\") {\r\n        if (msgStart < 0) {\r\n            // First time\r\n            DrawAppTitle(msgHeader);\r\n            msgStart = 0;\r\n        }\r\n        else {\r\n            msgStart += SCROLL_OFFSET;\r\n            if (msgStart >= msgBody.length) {\r\n                msgStart = 0;\r\n            }\r\n        }\r\n        // Clean the msg screen\r\n        Screen.print(1, \" \");\r\n        Screen.print(2, \" \");\r\n        Screen.print(3, \" \");\r\n        // Update it\r\n        Screen.print(1, msgBody.substring(msgStart), true);\r\n        await delay(300);\r\n    }\r\n}\r\nasync function loop() {\r\n    switch (app_status) {\r\n        case 0:\r\n            await DoIdle();\r\n            break;\r\n        case 1:\r\n            await DoShake();\r\n            break;\r\n        case 2:\r\n            await DoWork();\r\n            break;\r\n    }\r\n    await delay(100);\r\n}\r\nasync function run() {\r\n    await setup();\r\n    while (true) {\r\n        await loop();\r\n    }\r\n}\r\nrun();\r\n"

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var __extends = (this && this.__extends) || function (d, b) {
		    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
		    function __() { this.constructor = d; }
		    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
		};
		var React = __webpack_require__(1);
		__webpack_require__(2);
		var ConsolePrompt = (function (_super) {
		    __extends(ConsolePrompt, _super);
		    function ConsolePrompt() {
		        _super.apply(this, arguments);
		        this.child = {};
		        // DOM Management
		        this.updateSemaphore = 0;
		    }
		    // Component Lifecycle
		    ConsolePrompt.prototype.componentDidMount = function () {
		        this.idle();
		    };
		    ConsolePrompt.prototype.componentDidUpdate = function () {
		        this.idle();
		    };
		    ConsolePrompt.prototype.idle = function () {
		        var _this = this;
		        // Blink cursor when idle
		        if (this.child.cursor) {
		            if (this.updateSemaphore == 0) {
		                this.child.cursor.className = "react-console-cursor";
		            }
		            this.updateSemaphore++;
		            window.setTimeout(function () {
		                _this.updateSemaphore--;
		                if (_this.updateSemaphore == 0 && _this.child.cursor) {
		                    _this.child.cursor.className = "react-console-cursor react-console-cursor-idle";
		                }
		            }, 1000);
		        }
		    };
		    ConsolePrompt.prototype.renderValue = function () {
		        var _this = this;
		        if (this.props.point < 0) {
		            return [this.props.value];
		        }
		        else if (this.props.point == this.props.value.length) {
		            return [this.props.value, React.createElement("span", {ref: function (ref) { return _this.child.cursor = ref; }, key: "cursor", className: "react-console-cursor"}, " ")];
		        }
		        else {
		            return [this.props.value.substring(0, this.props.point),
		                React.createElement("span", {ref: function (ref) { return _this.child.cursor = ref; }, key: "cursor", className: "react-console-cursor"}, this.props.value.substring(this.props.point, this.props.point + 1)),
		                this.props.value.substring(this.props.point + 1)];
		        }
		    };
		    ConsolePrompt.prototype.render = function () {
		        var label = this.props.label;
		        if (this.props.argument) {
		            var idx = label.lastIndexOf("\n");
		            if (idx >= 0) {
		                label = label.substring(0, idx + 1);
		            }
		            else {
		                label = '';
		            }
		        }
		        return React.createElement("div", {className: "react-console-prompt-box"}, React.createElement("span", {className: "react-console-prompt-label"}, label), React.createElement("span", {className: "react-console-prompt-argument"}, this.props.argument), React.createElement("span", {className: "react-console-prompt"}, this.renderValue()));
		    };
		    ConsolePrompt.defaultProps = {
		        point: -1,
		        value: "",
		        label: "> ",
		        argument: null,
		    };
		    return ConsolePrompt;
		}(React.Component));
		var ConsoleMessage = function (props) {
		    return React.createElement("div", {className: "react-console-message" + (props.type ? " react-console-message-" + props.type : "")}, props.value.map(function (val) {
		        if (typeof val == 'string') {
		            return val;
		        }
		        else {
		            return JSON.stringify(val);
		        }
		    }).join("\n"));
		};
		ConsoleMessage.defaultProps = {
		    type: null,
		    value: [],
		};
		;
		;
		var default_1 = (function (_super) {
		    __extends(default_1, _super);
		    function default_1(props) {
		        var _this = this;
		        _super.call(this, props);
		        this.child = {};
		        // Command API
		        this.log = function () {
		            var messages = [];
		            for (var _i = 0; _i < arguments.length; _i++) {
		                messages[_i - 0] = arguments[_i];
		            }
		            var log = _this.state.log;
		            log[_this.state.log.length - 1].message.push({ value: messages });
		            _this.setState({
		                log: log,
		            }, _this.scrollIfBottom());
		        };
		        this.logX = function (type) {
		            var messages = [];
		            for (var _i = 1; _i < arguments.length; _i++) {
		                messages[_i - 1] = arguments[_i];
		            }
		            var log = _this.state.log;
		            log[_this.state.log.length - 1].message.push({ type: type, value: messages });
		            _this.setState({
		                log: log,
		            }, _this.scrollIfBottom());
		        };
		        this.return = function () {
		            _this.setState({
		                acceptInput: true,
		                currLabel: _this.nextLabel(),
		            }, _this.scrollIfBottom());
		        };
		        // Event Handlers
		        this.focus = function () {
		            if (!window.getSelection().toString()) {
		                _this.child.typer.focus();
		                _this.setState({ focus: true }, _this.scrollToBottom);
		            }
		        };
		        this.blur = function () {
		            _this.setState({ focus: false });
		        };
		        this.keyDown = function (e) {
		            var keyCodes = {
		                // return
		                13: _this.acceptLine,
		                // left
		                37: _this.backwardChar,
		                // right
		                39: _this.forwardChar,
		                // up
		                38: _this.previousHistory,
		                // down
		                40: _this.nextHistory,
		                // backspace
		                8: _this.backwardDeleteChar,
		                // delete
		                46: _this.deleteChar,
		                // end
		                35: _this.endOfLine,
		                // start
		                36: _this.beginningOfLine,
		                // tab
		                9: _this.complete,
		                // esc
		                27: _this.prefixMeta,
		            };
		            var ctrlCodes = {
		                // C-a
		                65: _this.beginningOfLine,
		                // C-e
		                69: _this.endOfLine,
		                // C-f
		                70: _this.forwardChar,
		                // C-b
		                66: _this.backwardChar,
		                // C-l TODO
		                //76: this.clearScreen,
		                // C-p
		                80: _this.previousHistory,
		                // C-n
		                78: _this.nextHistory,
		                // C-r
		                82: _this.reverseSearchHistory,
		                // C-s
		                83: _this.forwardSearchHistory,
		                // C-d
		                68: _this.deleteChar,
		                // C-q TODO
		                //81: this.quotedInsert,
		                // C-v TODO
		                //86: this.quotedInsert,
		                // C-t TODO
		                //84: this.transposeChars,
		                // C-k
		                75: _this.killLine,
		                // C-u
		                85: _this.backwardKillLine,
		                // C-y TODO
		                89: _this.yank,
		                // C-c
		                67: _this.cancelCommand,
		            };
		            var ctrlXCodes = {
		                // C-x Rubout
		                8: _this.backwardKillLine,
		            };
		            var ctrlShiftCodes = {};
		            var metaCodes = {
		                // M-f
		                70: _this.forwardWord,
		                // M-b
		                66: _this.backwardWord,
		                // M-p
		                80: _this.nonIncrementalReverseSearchHistory,
		                // M-n
		                78: _this.nonIncrementalForwardSearchHistory,
		                // M-.
		                190: _this.yankLastArg,
		                // M-TAB TODO
		                //9: this.tabInsert,
		                // M-t TODO
		                //84: this.transposeWords,
		                // M-u TODO
		                //85: this.upcaseWord,
		                // M-l TODO
		                //76: this.downcaseWord,
		                // M-c TODO
		                //67: this.capitalizeWord,
		                // M-d
		                68: _this.killWord,
		                // M-backspace
		                8: _this.backwardKillWord,
		                // M-w TODO
		                //87: this.unixWordRubout,
		                // M-\ TODO
		                //220: this.deleteHorizontalSpace,
		                // M-y
		                89: _this.yankPop,
		            };
		            var metaShiftCodes = {
		                // M-<
		                188: _this.beginningOfHistory,
		                // M->
		                190: _this.endOfHistory,
		                // M-_
		                189: _this.yankLastArg,
		            };
		            var metaCtrlCodes = {
		                // M-C-y
		                89: _this.yankNthArg,
		            };
		            if (_this.state.acceptInput) {
		                if (e.altKey) {
		                    if (e.ctrlKey) {
		                        if (e.keyCode in metaCtrlCodes) {
		                            metaCtrlCodes[e.keyCode]();
		                            e.preventDefault();
		                        }
		                    }
		                    else if (e.shiftKey) {
		                        if (e.keyCode in metaShiftCodes) {
		                            metaShiftCodes[e.keyCode]();
		                            e.preventDefault();
		                        }
		                    }
		                    else if (e.keyCode in metaCodes) {
		                        metaCodes[e.keyCode]();
		                        e.preventDefault();
		                    }
		                    e.preventDefault();
		                }
		                else if (e.ctrlKey) {
		                    if (e.keyCode in ctrlCodes) {
		                        ctrlCodes[e.keyCode]();
		                        e.preventDefault();
		                    }
		                    e.preventDefault();
		                }
		                else if (e.keyCode in keyCodes) {
		                    keyCodes[e.keyCode]();
		                    e.preventDefault();
		                }
		            }
		        };
		        this.change = function () {
		            var idx = 0;
		            for (; idx < _this.state.typer.length && idx < _this.child.typer.value.length; idx++) {
		                if (_this.state.typer[idx] != _this.child.typer.value[idx]) {
		                    break;
		                }
		            }
		            var insert = _this.child.typer.value.substring(idx);
		            var replace = _this.state.typer.length - idx;
		            if (_this.state.lastCommand == 1 /* Search */) {
		                _this.setState({
		                    searchText: _this.state.searchInit ? insert : _this.textInsert(insert, _this.state.searchText, replace),
		                    typer: _this.child.typer.value,
		                }, _this.triggerSearch);
		            }
		            else {
		                _this.setState(Object.assign(_this.consoleInsert(insert, replace), {
		                    typer: _this.child.typer.value,
		                    lastCommand: 0 /* Default */,
		                }), _this.scrollToBottom);
		            }
		        };
		        this.paste = function (e) {
		            var insert = e.clipboardData.getData('text');
		            if (_this.state.lastCommand == 1 /* Search */) {
		                _this.setState({
		                    searchText: _this.state.searchInit ? insert : _this.textInsert(insert, _this.state.searchText),
		                    typer: _this.child.typer.value,
		                }, _this.triggerSearch);
		            }
		            else {
		                _this.setState(Object.assign(_this.consoleInsert(insert), {
		                    lastCommand: 0 /* Default */,
		                }), _this.scrollToBottom);
		            }
		            e.preventDefault();
		        };
		        // Commands for Moving
		        this.beginningOfLine = function () {
		            _this.setState({
		                point: 0,
		                argument: null,
		                lastCommand: 0 /* Default */,
		            }, _this.scrollToBottom);
		        };
		        this.endOfLine = function () {
		            _this.setState({
		                point: _this.state.promptText.length,
		                argument: null,
		                lastCommand: 0 /* Default */,
		            }, _this.scrollToBottom);
		        };
		        this.forwardChar = function () {
		            _this.setState({
		                point: _this.movePoint(1),
		                argument: null,
		                lastCommand: 0 /* Default */,
		            }, _this.scrollToBottom);
		        };
		        this.backwardChar = function () {
		            _this.setState({
		                point: _this.movePoint(-1),
		                argument: null,
		                lastCommand: 0 /* Default */,
		            }, _this.scrollToBottom);
		        };
		        this.forwardWord = function () {
		            _this.setState({
		                point: _this.nextWord(),
		                argument: null,
		                lastCommand: 0 /* Default */,
		            }, _this.scrollToBottom);
		        };
		        this.backwardWord = function () {
		            _this.setState({
		                point: _this.previousWord(),
		                argument: null,
		                lastCommand: 0 /* Default */,
		            }, _this.scrollToBottom);
		        };
		        // Commands for Manipulating the History
		        this.acceptLine = function () {
		            _this.child.typer.value = "";
		            if (_this.props.continue(_this.state.promptText)) {
		                _this.setState(Object.assign(_this.consoleInsert("\n"), {
		                    typer: "",
		                    lastCommand: 0 /* Default */,
		                }), _this.scrollToBottom);
		            }
		            else {
		                var command_1 = _this.state.promptText;
		                var history_1 = _this.state.history;
		                var log = _this.state.log;
		                if (!history_1 || history_1[history_1.length - 1] != command_1) {
		                    history_1.push(command_1);
		                }
		                log.push({
		                    label: _this.state.currLabel,
		                    command: command_1,
		                    message: []
		                });
		                _this.setState({
		                    acceptInput: false,
		                    typer: "",
		                    point: 0,
		                    promptText: "",
		                    restoreText: "",
		                    log: log,
		                    history: history_1,
		                    historyn: 0,
		                    argument: null,
		                    lastCommand: 0 /* Default */,
		                }, function () {
		                    _this.scrollToBottom();
		                    _this.props.handler(command_1);
		                });
		            }
		        };
		        this.previousHistory = function () {
		            _this.rotateHistory(-1);
		        };
		        this.nextHistory = function () {
		            _this.rotateHistory(1);
		        };
		        this.beginningOfHistory = function () {
		            _this.rotateHistory(-_this.state.history.length);
		        };
		        this.endOfHistory = function () {
		            _this.rotateHistory(_this.state.history.length);
		        };
		        this.triggerSearch = function () {
		            if (_this.state.searchDirection == 0 /* Reverse */) {
		                _this.reverseSearchHistory();
		            }
		            else {
		                _this.forwardSearchHistory();
		            }
		        };
		        this.reverseSearchHistory = function () {
		            if (_this.state.lastCommand == 1 /* Search */) {
		                _this.setState(Object.assign(_this.searchHistory(0 /* Reverse */, true), {
		                    argument: "(reverse-i-search)`" + _this.state.searchText + "': ",
		                    lastCommand: 1 /* Search */,
		                }), _this.scrollToBottom);
		            }
		            else {
		                _this.setState({
		                    searchDirection: 0 /* Reverse */,
		                    searchInit: true,
		                    argument: "(reverse-i-search)`': ",
		                    lastCommand: 1 /* Search */,
		                }, _this.scrollToBottom);
		            }
		        };
		        this.forwardSearchHistory = function () {
		            if (_this.state.lastCommand == 1 /* Search */) {
		                _this.setState(Object.assign(_this.searchHistory(1 /* Forward */, true), {
		                    argument: "(forward-i-search)`" + _this.state.searchText + "': ",
		                    lastCommand: 1 /* Search */,
		                }), _this.scrollToBottom);
		            }
		            else {
		                _this.setState({
		                    searchDirection: 1 /* Forward */,
		                    searchInit: true,
		                    argument: "(forward-i-search)`': ",
		                    lastCommand: 1 /* Search */,
		                }, _this.scrollToBottom);
		            }
		        };
		        this.nonIncrementalReverseSearchHistory = function () {
		            // TODO
		        };
		        this.nonIncrementalForwardSearchHistory = function () {
		            // TODO
		        };
		        this.historySearchBackward = function () {
		            // TODO
		        };
		        this.historySearchForward = function () {
		            // TODO
		        };
		        this.historySubstringSearchBackward = function () {
		            // TODO
		        };
		        this.historySubstringSearchForward = function () {
		            // TODO
		        };
		        this.yankNthArg = function () {
		            // TODO
		        };
		        this.yankLastArg = function () {
		            // TODO
		        };
		        // Commands for Changing Text
		        this.deleteChar = function () {
		            if (_this.state.point < _this.state.promptText.length) {
		                _this.setState({
		                    promptText: _this.state.promptText.substring(0, _this.state.point)
		                        + _this.state.promptText.substring(_this.state.point + 1),
		                    argument: null,
		                    lastCommand: 0 /* Default */,
		                }, _this.scrollToBottom);
		            }
		        };
		        this.backwardDeleteChar = function () {
		            if (_this.state.lastCommand == 1 /* Search */) {
		                _this.setState({
		                    searchText: _this.state.searchText.substring(0, _this.state.searchText.length - 1),
		                    typer: _this.child.typer.value,
		                }, _this.triggerSearch);
		            }
		            else if (_this.state.point > 0) {
		                _this.setState({
		                    point: _this.movePoint(-1),
		                    promptText: _this.state.promptText.substring(0, _this.state.point - 1)
		                        + _this.state.promptText.substring(_this.state.point),
		                    argument: null,
		                    lastCommand: 0 /* Default */,
		                }, _this.scrollToBottom);
		            }
		        };
		        // Killing and Yanking
		        this.killLine = function () {
		            var kill = _this.state.kill;
		            if (_this.state.lastCommand == 2 /* Kill */) {
		                kill[0] = kill[0] + _this.state.promptText.substring(_this.state.point);
		            }
		            else {
		                kill.unshift(_this.state.promptText.substring(_this.state.point));
		            }
		            _this.setState({
		                promptText: _this.state.promptText.substring(0, _this.state.point),
		                kill: kill,
		                killn: 0,
		                argument: null,
		                lastCommand: 2 /* Kill */,
		            }, _this.scrollToBottom);
		        };
		        this.backwardKillLine = function () {
		            var kill = _this.state.kill;
		            if (_this.state.lastCommand == 2 /* Kill */) {
		                kill[0] = _this.state.promptText.substring(0, _this.state.point) + kill[0];
		            }
		            else {
		                kill.unshift(_this.state.promptText.substring(0, _this.state.point));
		            }
		            _this.setState({
		                point: 0,
		                promptText: _this.state.promptText.substring(_this.state.point),
		                kill: kill,
		                killn: 0,
		                argument: null,
		                lastCommand: 2 /* Kill */,
		            }, _this.scrollToBottom);
		        };
		        this.killWholeLine = function () {
		            var kill = _this.state.kill;
		            if (_this.state.lastCommand == 2 /* Kill */) {
		                kill[0] = _this.state.promptText.substring(0, _this.state.point)
		                    + kill[0] + _this.state.promptText.substring(_this.state.point);
		            }
		            else {
		                kill.unshift(_this.state.promptText);
		            }
		            _this.setState({
		                point: 0,
		                promptText: '',
		                kill: kill,
		                killn: 0,
		                argument: null,
		                lastCommand: 2 /* Kill */,
		            }, _this.scrollToBottom);
		        };
		        this.killWord = function () {
		            var kill = _this.state.kill;
		            if (_this.state.lastCommand == 2 /* Kill */) {
		                kill[0] = kill[0] + _this.state.promptText.substring(_this.state.point, _this.nextWord());
		            }
		            else {
		                kill.unshift(_this.state.promptText.substring(_this.state.point, _this.nextWord()));
		            }
		            _this.setState({
		                promptText: _this.state.promptText.substring(0, _this.state.point)
		                    + _this.state.promptText.substring(_this.nextWord()),
		                kill: kill,
		                killn: 0,
		                argument: null,
		                lastCommand: 2 /* Kill */,
		            }, _this.scrollToBottom);
		        };
		        this.backwardKillWord = function () {
		            var kill = _this.state.kill;
		            if (_this.state.lastCommand == 2 /* Kill */) {
		                kill[0] = _this.state.promptText.substring(_this.previousWord(), _this.state.point) + kill[0];
		            }
		            else {
		                kill.unshift(_this.state.promptText.substring(_this.previousWord(), _this.state.point));
		            }
		            _this.setState({
		                point: _this.previousWord(),
		                promptText: _this.state.promptText.substring(0, _this.previousWord())
		                    + _this.state.promptText.substring(_this.state.point),
		                kill: kill,
		                killn: 0,
		                argument: null,
		                lastCommand: 2 /* Kill */,
		            }, _this.scrollToBottom);
		        };
		        this.yank = function () {
		            _this.setState(Object.assign(_this.consoleInsert(_this.state.kill[_this.state.killn]), {
		                lastCommand: 3 /* Yank */,
		            }), _this.scrollToBottom);
		        };
		        this.yankPop = function () {
		            if (_this.state.lastCommand == 3 /* Yank */) {
		                var killn = _this.rotateRing(1, _this.state.killn, _this.state.kill.length);
		                _this.setState(Object.assign(_this.consoleInsert(_this.state.kill[killn], _this.state.kill[_this.state.killn].length), {
		                    killn: killn,
		                    lastCommand: 3 /* Yank */,
		                }), _this.scrollToBottom);
		            }
		        };
		        // Numeric Arguments
		        // Completing
		        this.complete = function () {
		            if (_this.props.complete) {
		                // Split text and find current word
		                var words = _this.state.promptText.split(" ");
		                var curr = 0;
		                var idx = words[0].length;
		                while (idx < _this.state.point && curr + 1 < words.length) {
		                    idx += words[++curr].length + 1;
		                }
		                var completions = _this.props.complete(words, curr, _this.state.promptText);
		                if (completions.length == 1) {
		                    // Perform completion
		                    words[curr] = completions[0];
		                    var point = -1;
		                    for (var i = 0; i <= curr; i++) {
		                        point += words[i].length + 1;
		                    }
		                    _this.setState({
		                        point: point,
		                        promptText: words.join(" "),
		                        argument: null,
		                        lastCommand: 0 /* Default */,
		                    }, _this.scrollToBottom);
		                }
		                else if (completions.length > 1) {
		                    // show completions
		                    var log = _this.state.log;
		                    log.push({
		                        label: _this.state.currLabel,
		                        command: _this.state.promptText,
		                        message: [{
		                                type: "completion",
		                                value: [completions.join("\t")],
		                            }]
		                    });
		                    _this.setState({
		                        currLabel: _this.nextLabel(),
		                        log: log,
		                        argument: null,
		                        lastCommand: 0 /* Default */,
		                    }, _this.scrollToBottom);
		                }
		            }
		        };
		        // Keyboard Macros
		        // Miscellaneous
		        this.prefixMeta = function () {
		            if (_this.state.lastCommand == 1 /* Search */) {
		                _this.setState({
		                    argument: null,
		                    lastCommand: 0 /* Default */,
		                });
		            }
		            // TODO Meta prefixed state
		        };
		        this.cancelCommand = function () {
		            if (_this.state.acceptInput) {
		                _this.child.typer.value = "";
		                var log = _this.state.log;
		                log.push({
		                    label: _this.state.currLabel,
		                    command: _this.state.promptText,
		                    message: []
		                });
		                _this.setState({
		                    typer: "",
		                    point: 0,
		                    promptText: "",
		                    restoreText: "",
		                    log: log,
		                    historyn: 0,
		                    argument: null,
		                    lastCommand: 0 /* Default */,
		                }, _this.scrollToBottom);
		            }
		            else {
		                _this.props.cancel();
		            }
		        };
		        // Helper functions
		        this.textInsert = function (insert, text, replace, point) {
		            if (replace === void 0) { replace = 0; }
		            if (point === void 0) { point = text.length; }
		            return text.substring(0, point - replace) + insert + text.substring(point);
		        };
		        this.consoleInsert = function (insert, replace) {
		            if (replace === void 0) { replace = 0; }
		            var promptText = _this.textInsert(insert, _this.state.promptText, replace, _this.state.point);
		            return {
		                point: _this.movePoint(insert.length - replace, insert.length - replace + _this.state.promptText.length),
		                promptText: promptText,
		                restoreText: promptText,
		                argument: null,
		                lastCommand: 0 /* Default */,
		            };
		        };
		        this.movePoint = function (n, max) {
		            if (max === void 0) { max = _this.state.promptText.length; }
		            var pos = _this.state.point + n;
		            if (pos < 0) {
		                return 0;
		            }
		            if (pos > max) {
		                return max;
		            }
		            else {
		                return pos;
		            }
		        };
		        this.rotateRing = function (n, ringn, ring, circular) {
		            if (circular === void 0) { circular = true; }
		            if (ring == 0)
		                return 0;
		            if (circular) {
		                return (ring + (ringn + n) % ring) % ring;
		            }
		            else {
		                ringn = ringn - n;
		                if (ringn < 0) {
		                    return 0;
		                }
		                else if (ringn >= ring) {
		                    return ring;
		                }
		                else {
		                    return ringn;
		                }
		            }
		        };
		        this.rotateHistory = function (n) {
		            var historyn = _this.rotateRing(n, _this.state.historyn, _this.state.history.length, false);
		            if (historyn == 0) {
		                _this.setState({
		                    point: _this.state.restoreText.length,
		                    promptText: _this.state.restoreText,
		                    historyn: historyn,
		                    argument: null,
		                    lastCommand: 0 /* Default */,
		                }, _this.scrollToBottom);
		            }
		            else {
		                var promptText = _this.state.history[_this.state.history.length - historyn];
		                _this.setState({
		                    point: promptText.length,
		                    promptText: promptText,
		                    historyn: historyn,
		                    argument: null,
		                    lastCommand: 0 /* Default */,
		                }, _this.scrollToBottom);
		            }
		        };
		        this.searchHistory = function (direction, next) {
		            if (direction === void 0) { direction = _this.state.searchDirection; }
		            if (next === void 0) { next = false; }
		            var idx = _this.state.historyn;
		            var inc = (direction == 0 /* Reverse */) ? 1 : -1;
		            if (next) {
		                idx = idx + inc;
		            }
		            for (; idx > 0 && idx <= _this.state.history.length; idx = idx + inc) {
		                var entry = _this.state.history[_this.state.history.length - idx];
		                var point = entry.indexOf(_this.state.searchText);
		                if (point > -1) {
		                    return {
		                        point: point,
		                        promptText: entry,
		                        searchDirection: direction,
		                        searchInit: false,
		                        historyn: idx,
		                    };
		                }
		            }
		            return {
		                searchDirection: direction,
		                searchInit: false,
		            };
		        };
		        // DOM management
		        this.scrollSemaphore = 0;
		        this.scrollIfBottom = function () {
		            if (_this.scrollSemaphore > 0 || _this.child.container.scrollTop == _this.child.container.scrollHeight - _this.child.container.offsetHeight) {
		                _this.scrollSemaphore++;
		                return _this.scrollIfBottomTrue;
		            }
		            else {
		                return null;
		            }
		        };
		        this.scrollIfBottomTrue = function () {
		            _this.scrollToBottom();
		            _this.scrollSemaphore--;
		        };
		        this.scrollToBottom = function () {
		            _this.child.container.scrollTop = _this.child.container.scrollHeight;
		            var rect = _this.child.focus.getBoundingClientRect();
		            if (rect.top < 0 || rect.left < 0 ||
		                rect.bottom > (window.innerHeight || document.documentElement.clientHeight) ||
		                rect.right > (window.innerWidth || document.documentElement.clientWidth)) {
		                _this.child.typer.scrollIntoView(false);
		            }
		        };
		        this.nextLabel = function () {
		            if (typeof _this.props.promptLabel === "string") {
		                return _this.props.promptLabel;
		            }
		            else {
		                return _this.props.promptLabel();
		            }
		        };
		        this.state = {
		            focus: false,
		            acceptInput: true,
		            typer: '',
		            point: 0,
		            currLabel: this.nextLabel(),
		            promptText: '',
		            restoreText: '',
		            searchText: '',
		            searchDirection: null,
		            searchInit: false,
		            log: [],
		            history: [],
		            historyn: 0,
		            kill: [],
		            killn: 0,
		            argument: null,
		            lastCommand: 0 /* Default */,
		        };
		    }
		    // Component Lifecycle
		    default_1.prototype.componentDidMount = function () {
		        if (this.props.autofocus) {
		            this.focus();
		        }
		    };
		    default_1.prototype.nextWord = function () {
		        // Find first alphanumeric char after first non-alphanumeric char
		        var search = /\W\w/.exec(this.state.promptText.substring(this.state.point));
		        if (search) {
		            return search.index + this.state.point + 1;
		        }
		        else {
		            return this.state.promptText.length;
		        }
		    };
		    default_1.prototype.previousWord = function () {
		        // Find first non-alphanumeric char after first alphanumeric char in reverse
		        var search = /\W\w(?!.*\W\w)/.exec(this.state.promptText.substring(0, this.state.point - 1));
		        if (search) {
		            return search.index + 1;
		        }
		        else {
		            return 0;
		        }
		    };
		    default_1.prototype.render = function () {
		        var _this = this;
		        return React.createElement("div", {ref: function (ref) { return _this.child.container = ref; }, className: "react-console-container " + (this.state.focus ? "react-console-focus" : "react-console-nofocus"), onClick: this.focus}, this.props.welcomeMessage ?
		            React.createElement("div", {className: "react-console-message react-console-welcome"}, this.props.welcomeMessage)
		            : null, this.state.log.map(function (val) {
		            return [
		                React.createElement(ConsolePrompt, {label: val.label, value: val.command})
		            ].concat(val.message.map(function (val, idx) {
		                return React.createElement(ConsoleMessage, {key: idx, type: val.type, value: val.value});
		            }));
		        }), this.state.acceptInput ?
		            React.createElement(ConsolePrompt, {label: this.state.currLabel, value: this.state.promptText, point: this.state.point, argument: this.state.argument})
		            : null, React.createElement("div", {style: { overflow: "hidden", height: 1, width: 1 }}, React.createElement("textarea", {ref: function (ref) { return _this.child.typer = ref; }, className: "react-console-typer", autoComplete: "off", autoCorrect: "off", autoCapitalize: "off", spellCheck: "false", style: { outline: "none",
		            color: "transparent",
		            backgroundColor: "transparent",
		            border: "none",
		            resize: "none",
		            overflow: "hidden",
		        }, onBlur: this.blur, onKeyDown: this.keyDown, onChange: this.change, onPaste: this.paste})), React.createElement("div", {ref: function (ref) { return _this.child.focus = ref; }}, " "));
		    };
		    default_1.defaultProps = {
		        promptLabel: '> ',
		        continue: function () { return false; },
		        cancel: function () { },
		    };
		    return default_1;
		}(React.Component));
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.default = default_1;
	
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(9);
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		// removed by extract-text-webpack-plugin
	
	/***/ }
	/******/ ]);
	//# sourceMappingURL=react-console.js.map

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = __webpack_require__(410);


/***/ },
/* 412 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(11);
	
	var focusNode = __webpack_require__(159);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(56);
	var ExecutionEnvironment = __webpack_require__(17);
	var FallbackCompositionState = __webpack_require__(420);
	var SyntheticCompositionEvent = __webpack_require__(456);
	var SyntheticInputEvent = __webpack_require__(459);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(168);
	var ExecutionEnvironment = __webpack_require__(17);
	var ReactInstrumentation = __webpack_require__(22);
	
	var camelizeStyleName = __webpack_require__(355);
	var dangerousStyleValue = __webpack_require__(465);
	var hyphenateStyleName = __webpack_require__(362);
	var memoizeStringOnly = __webpack_require__(365);
	var warning = __webpack_require__(5);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(55);
	var EventPropagators = __webpack_require__(56);
	var ExecutionEnvironment = __webpack_require__(17);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactUpdates = __webpack_require__(23);
	var SyntheticEvent = __webpack_require__(27);
	
	var inputValueTracking = __webpack_require__(185);
	var getEventTarget = __webpack_require__(106);
	var isEventSupported = __webpack_require__(107);
	var isTextInputElement = __webpack_require__(187);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var DOMLazyTree = __webpack_require__(44);
	var ExecutionEnvironment = __webpack_require__(17);
	
	var createNodesFromMarkup = __webpack_require__(358);
	var emptyFunction = __webpack_require__(18);
	var invariant = __webpack_require__(3);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ },
/* 418 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(56);
	var ReactDOMComponentTree = __webpack_require__(11);
	var SyntheticMouseEvent = __webpack_require__(67);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var PooledClass = __webpack_require__(38);
	
	var getTextContentAccessor = __webpack_require__(184);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(45);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(47);
	
	var instantiateReactComponent = __webpack_require__(186);
	var KeyEscapeUtils = __webpack_require__(98);
	var shouldUpdateReactComponent = __webpack_require__(108);
	var traverseAllChildren = __webpack_require__(189);
	var warning = __webpack_require__(5);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"."}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(195);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(94);
	var ReactDOMIDOperations = __webpack_require__(430);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(7);
	
	var React = __webpack_require__(40);
	var ReactComponentEnvironment = __webpack_require__(100);
	var ReactCurrentOwner = __webpack_require__(29);
	var ReactErrorUtils = __webpack_require__(101);
	var ReactInstanceMap = __webpack_require__(46);
	var ReactInstrumentation = __webpack_require__(22);
	var ReactNodeTypes = __webpack_require__(179);
	var ReactReconciler = __webpack_require__(47);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(42);
	var invariant = __webpack_require__(3);
	var shallowEqual = __webpack_require__(88);
	var shouldUpdateReactComponent = __webpack_require__(108);
	var warning = __webpack_require__(5);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactDefaultInjection = __webpack_require__(438);
	var ReactMount = __webpack_require__(177);
	var ReactReconciler = __webpack_require__(47);
	var ReactUpdates = __webpack_require__(23);
	var ReactVersion = __webpack_require__(450);
	
	var findDOMNode = __webpack_require__(466);
	var getHostComponentFromComposite = __webpack_require__(183);
	var renderSubtreeIntoContainer = __webpack_require__(473);
	var warning = __webpack_require__(5);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(7);
	
	var AutoFocusUtils = __webpack_require__(413);
	var CSSPropertyOperations = __webpack_require__(415);
	var DOMLazyTree = __webpack_require__(44);
	var DOMNamespaces = __webpack_require__(95);
	var DOMProperty = __webpack_require__(45);
	var DOMPropertyOperations = __webpack_require__(170);
	var EventPluginHub = __webpack_require__(55);
	var EventPluginRegistry = __webpack_require__(96);
	var ReactBrowserEventEmitter = __webpack_require__(66);
	var ReactDOMComponentFlags = __webpack_require__(171);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactDOMInput = __webpack_require__(431);
	var ReactDOMOption = __webpack_require__(432);
	var ReactDOMSelect = __webpack_require__(172);
	var ReactDOMTextarea = __webpack_require__(435);
	var ReactInstrumentation = __webpack_require__(22);
	var ReactMultiChild = __webpack_require__(178);
	var ReactServerRenderingTransaction = __webpack_require__(448);
	
	var emptyFunction = __webpack_require__(18);
	var escapeTextContentForBrowser = __webpack_require__(69);
	var invariant = __webpack_require__(3);
	var isEventSupported = __webpack_require__(107);
	var shallowEqual = __webpack_require__(88);
	var inputValueTracking = __webpack_require__(185);
	var validateDOMNesting = __webpack_require__(109);
	var warning = __webpack_require__(5);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(109);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var DOMLazyTree = __webpack_require__(44);
	var ReactDOMComponentTree = __webpack_require__(11);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 429 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(94);
	var ReactDOMComponentTree = __webpack_require__(11);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(7);
	
	var DOMPropertyOperations = __webpack_require__(170);
	var LinkedValueUtils = __webpack_require__(99);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactUpdates = __webpack_require__(23);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var React = __webpack_require__(40);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactDOMSelect = __webpack_require__(172);
	
	var warning = __webpack_require__(5);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(17);
	
	var getNodeForCharacterOffset = __webpack_require__(470);
	var getTextContentAccessor = __webpack_require__(184);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(7);
	
	var DOMChildrenOperations = __webpack_require__(94);
	var DOMLazyTree = __webpack_require__(44);
	var ReactDOMComponentTree = __webpack_require__(11);
	
	var escapeTextContentForBrowser = __webpack_require__(69);
	var invariant = __webpack_require__(3);
	var validateDOMNesting = __webpack_require__(109);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(7);
	
	var LinkedValueUtils = __webpack_require__(99);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactUpdates = __webpack_require__(23);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var ReactUpdates = __webpack_require__(23);
	var Transaction = __webpack_require__(68);
	
	var emptyFunction = __webpack_require__(18);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(412);
	var BeforeInputEventPlugin = __webpack_require__(414);
	var ChangeEventPlugin = __webpack_require__(416);
	var DefaultEventPluginOrder = __webpack_require__(418);
	var EnterLeaveEventPlugin = __webpack_require__(419);
	var HTMLDOMPropertyConfig = __webpack_require__(421);
	var ReactComponentBrowserEnvironment = __webpack_require__(423);
	var ReactDOMComponent = __webpack_require__(426);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactDOMEmptyComponent = __webpack_require__(428);
	var ReactDOMTreeTraversal = __webpack_require__(436);
	var ReactDOMTextComponent = __webpack_require__(434);
	var ReactDefaultBatchingStrategy = __webpack_require__(437);
	var ReactEventListener = __webpack_require__(441);
	var ReactInjection = __webpack_require__(442);
	var ReactReconcileTransaction = __webpack_require__(446);
	var SVGDOMPropertyConfig = __webpack_require__(451);
	var SelectEventPlugin = __webpack_require__(452);
	var SimpleEventPlugin = __webpack_require__(453);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 439 */
196,
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(55);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var EventListener = __webpack_require__(158);
	var ExecutionEnvironment = __webpack_require__(17);
	var PooledClass = __webpack_require__(38);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactUpdates = __webpack_require__(23);
	
	var getEventTarget = __webpack_require__(106);
	var getUnboundedScrollPosition = __webpack_require__(360);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(45);
	var EventPluginHub = __webpack_require__(55);
	var EventPluginUtils = __webpack_require__(97);
	var ReactComponentEnvironment = __webpack_require__(100);
	var ReactEmptyComponent = __webpack_require__(173);
	var ReactBrowserEventEmitter = __webpack_require__(66);
	var ReactHostComponent = __webpack_require__(175);
	var ReactUpdates = __webpack_require__(23);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(464);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ },
/* 445 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var CallbackQueue = __webpack_require__(169);
	var PooledClass = __webpack_require__(38);
	var ReactBrowserEventEmitter = __webpack_require__(66);
	var ReactInputSelection = __webpack_require__(176);
	var ReactInstrumentation = __webpack_require__(22);
	var Transaction = __webpack_require__(68);
	var ReactUpdateQueue = __webpack_require__(102);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(444);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var PooledClass = __webpack_require__(38);
	var Transaction = __webpack_require__(68);
	var ReactInstrumentation = __webpack_require__(22);
	var ReactServerUpdateQueue = __webpack_require__(449);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(102);
	
	var warning = __webpack_require__(5);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 450 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ },
/* 451 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(56);
	var ExecutionEnvironment = __webpack_require__(17);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactInputSelection = __webpack_require__(176);
	var SyntheticEvent = __webpack_require__(27);
	
	var getActiveElement = __webpack_require__(160);
	var isTextInputElement = __webpack_require__(187);
	var shallowEqual = __webpack_require__(88);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var EventListener = __webpack_require__(158);
	var EventPropagators = __webpack_require__(56);
	var ReactDOMComponentTree = __webpack_require__(11);
	var SyntheticAnimationEvent = __webpack_require__(454);
	var SyntheticClipboardEvent = __webpack_require__(455);
	var SyntheticEvent = __webpack_require__(27);
	var SyntheticFocusEvent = __webpack_require__(458);
	var SyntheticKeyboardEvent = __webpack_require__(460);
	var SyntheticMouseEvent = __webpack_require__(67);
	var SyntheticDragEvent = __webpack_require__(457);
	var SyntheticTouchEvent = __webpack_require__(461);
	var SyntheticTransitionEvent = __webpack_require__(462);
	var SyntheticUIEvent = __webpack_require__(57);
	var SyntheticWheelEvent = __webpack_require__(463);
	
	var emptyFunction = __webpack_require__(18);
	var getEventCharCode = __webpack_require__(104);
	var invariant = __webpack_require__(3);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(27);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(27);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(27);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(67);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(57);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(27);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(57);
	
	var getEventCharCode = __webpack_require__(104);
	var getEventKey = __webpack_require__(468);
	var getEventModifierState = __webpack_require__(105);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(57);
	
	var getEventModifierState = __webpack_require__(105);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(27);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(67);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 464 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(168);
	var warning = __webpack_require__(5);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactCurrentOwner = __webpack_require__(29);
	var ReactDOMComponentTree = __webpack_require__(11);
	var ReactInstanceMap = __webpack_require__(46);
	
	var getHostComponentFromComposite = __webpack_require__(183);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(98);
	var traverseAllChildren = __webpack_require__(189);
	var warning = __webpack_require__(5);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"."}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(195);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(104);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 469 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 470 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(17);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(69);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(177);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(9), __webpack_require__(54));
		else if(typeof define === 'function' && define.amd)
			define(["react", "prop-types"], factory);
		else {
			var a = typeof exports === 'object' ? factory(require("react"), require("prop-types")) : factory(root["react"], root["prop-types"]);
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_12__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 2);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = warn;
	function warn(s) {
	  console.warn('[react-ga]', s);
	}
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = trim;
	// GA strings need to have leading/trailing whitespace trimmed, and not all
	// browsers have String.prototoype.trim().
	
	function trim(s) {
	  return s.replace(/^\s+|\s+$/g, '');
	}
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.testModeAPI = exports.OutboundLink = exports.plugin = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.initialize = initialize;
	exports.ga = ga;
	exports.set = set;
	exports.send = send;
	exports.pageview = pageview;
	exports.modalview = modalview;
	exports.timing = timing;
	exports.event = event;
	exports.exception = exception;
	exports.outboundLink = outboundLink;
	
	var _format2 = __webpack_require__(3);
	
	var _format3 = _interopRequireDefault(_format2);
	
	var _removeLeadingSlash = __webpack_require__(6);
	
	var _removeLeadingSlash2 = _interopRequireDefault(_removeLeadingSlash);
	
	var _trim = __webpack_require__(1);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	var _loadGA = __webpack_require__(7);
	
	var _loadGA2 = _interopRequireDefault(_loadGA);
	
	var _warn = __webpack_require__(0);
	
	var _warn2 = _interopRequireDefault(_warn);
	
	var _log = __webpack_require__(8);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _testModeAPI = __webpack_require__(9);
	
	var _testModeAPI2 = _interopRequireDefault(_testModeAPI);
	
	var _OutboundLink = __webpack_require__(10);
	
	var _OutboundLink2 = _interopRequireDefault(_OutboundLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /**
	                                                                                                                                                                                                     * React Google Analytics Module
	                                                                                                                                                                                                     *
	                                                                                                                                                                                                     * @package react-ga
	                                                                                                                                                                                                     * @author  Adam Lofting <adam@mozillafoundation.org>
	                                                                                                                                                                                                     *          Atul Varma <atul@mozillafoundation.org>
	                                                                                                                                                                                                     */
	
	/**
	 * Utilities
	 */
	
	
	var _debug = false;
	var _titleCase = true;
	var _testMode = false;
	
	var internalGa = function internalGa() {
	  var _window;
	
	  if (_testMode) return _testModeAPI2.default.ga.apply(_testModeAPI2.default, arguments);
	  if (!window.ga) return (0, _warn2.default)('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
	  return (_window = window).ga.apply(_window, arguments);
	};
	
	function _format(s) {
	  return (0, _format3.default)(s, _titleCase);
	}
	
	function _gaCommand(trackerNames) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  var command = args[0];
	  if (typeof internalGa === 'function') {
	    if (typeof command !== 'string') {
	      (0, _warn2.default)('ga command must be a string');
	      return;
	    }
	
	    internalGa.apply(undefined, args);
	    if (Array.isArray(trackerNames)) {
	      trackerNames.forEach(function (name) {
	        internalGa.apply(undefined, _toConsumableArray([name + '.' + command].concat(args.slice(1))));
	      });
	    }
	  }
	}
	
	function _initialize(gaTrackingID, options) {
	  if (!gaTrackingID) {
	    (0, _warn2.default)('gaTrackingID is required in initialize()');
	    return;
	  }
	
	  if (options) {
	    if (options.debug && options.debug === true) {
	      _debug = true;
	    }
	
	    if (options.titleCase === false) {
	      _titleCase = false;
	    }
	  }
	
	  if (options && options.gaOptions) {
	    internalGa('create', gaTrackingID, options.gaOptions);
	  } else {
	    internalGa('create', gaTrackingID, 'auto');
	  }
	}
	
	function initialize(configsOrTrackingId, options) {
	  if (options && options.testMode === true) {
	    _testMode = true;
	  } else {
	    if (typeof window === 'undefined') {
	      return false;
	    }
	
	    (0, _loadGA2.default)(options);
	  }
	
	  if (Array.isArray(configsOrTrackingId)) {
	    configsOrTrackingId.forEach(function (config) {
	      if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) !== 'object') {
	        (0, _warn2.default)('All configs must be an object');
	        return;
	      }
	      _initialize(config.trackingId, config);
	    });
	  } else {
	    _initialize(configsOrTrackingId, options);
	  }
	  return true;
	}
	
	/**
	 * ga:
	 * Returns the original GA object.
	 */
	function ga() {
	  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (args.length > 0) {
	    internalGa.apply(undefined, args);
	    if (_debug) {
	      (0, _log2.default)('called ga(\'arguments\');');
	      (0, _log2.default)('with arguments: ' + JSON.stringify(args));
	    }
	  }
	
	  return window.ga;
	}
	
	/**
	 * set:
	 * GA tracker set method
	 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function set(fieldsObject, trackerNames) {
	  if (!fieldsObject) {
	    (0, _warn2.default)('`fieldsObject` is required in .set()');
	    return;
	  }
	
	  if ((typeof fieldsObject === 'undefined' ? 'undefined' : _typeof(fieldsObject)) !== 'object') {
	    (0, _warn2.default)('Expected `fieldsObject` arg to be an Object');
	    return;
	  }
	
	  if (Object.keys(fieldsObject).length === 0) {
	    (0, _warn2.default)('empty `fieldsObject` given to .set()');
	  }
	
	  _gaCommand(trackerNames, 'set', fieldsObject);
	
	  if (_debug) {
	    (0, _log2.default)('called ga(\'set\', fieldsObject);');
	    (0, _log2.default)('with fieldsObject: ' + JSON.stringify(fieldsObject));
	  }
	}
	
	/**
	 * send:
	 * Clone of the low level `ga.send` method
	 * WARNING: No validations will be applied to this
	 * @param  {Object} fieldObject - field object for tracking different analytics
	 * @param  {Array} trackerNames - trackers to send the command to
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function send(fieldObject, trackerNames) {
	  _gaCommand(trackerNames, 'send', fieldObject);
	  if (_debug) {
	    (0, _log2.default)('called ga(\'send\', fieldObject);');
	    (0, _log2.default)('with fieldObject: ' + JSON.stringify(fieldObject));
	    (0, _log2.default)('with trackers: ' + JSON.stringify(trackerNames));
	  }
	}
	
	/**
	 * pageview:
	 * Basic GA pageview tracking
	 * @param  {String} path - the current page page e.g. '/about'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 * @param {String} title - (optional) the page title e. g. 'My Website'
	 */
	function pageview(rawPath, trackerNames, title) {
	  if (!rawPath) {
	    (0, _warn2.default)('path is required in .pageview()');
	    return;
	  }
	
	  var path = (0, _trim2.default)(rawPath);
	  if (path === '') {
	    (0, _warn2.default)('path cannot be an empty string in .pageview()');
	    return;
	  }
	
	  var extraFields = {};
	  if (title) {
	    extraFields.title = title;
	  }
	
	  if (typeof ga === 'function') {
	    _gaCommand(trackerNames, 'send', _extends({
	      hitType: 'pageview',
	      page: path
	    }, extraFields));
	
	    if (_debug) {
	      (0, _log2.default)('called ga(\'send\', \'pageview\', path);');
	      var extraLog = '';
	      if (title) {
	        extraLog = ' and title: ' + title;
	      }
	      (0, _log2.default)('with path: ' + path + extraLog);
	    }
	  }
	}
	
	/**
	 * modalview:
	 * a proxy to basic GA pageview tracking to consistently track
	 * modal views that are an equivalent UX to a traditional pageview
	 * @param  {String} modalName e.g. 'add-or-edit-club'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function modalview(rawModalName, trackerNames) {
	  if (!rawModalName) {
	    (0, _warn2.default)('modalName is required in .modalview(modalName)');
	    return;
	  }
	
	  var modalName = (0, _removeLeadingSlash2.default)((0, _trim2.default)(rawModalName));
	
	  if (modalName === '') {
	    (0, _warn2.default)('modalName cannot be an empty string or a single / in .modalview()');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    var path = '/modal/' + modalName;
	    _gaCommand(trackerNames, 'send', 'pageview', path);
	
	    if (_debug) {
	      (0, _log2.default)('called ga(\'send\', \'pageview\', path);');
	      (0, _log2.default)('with path: ' + path);
	    }
	  }
	}
	
	/**
	 * timing:
	 * GA timing
	 * @param args.category {String} required
	 * @param args.variable {String} required
	 * @param args.value  {Int}  required
	 * @param args.label  {String} required
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function timing() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref.category,
	      variable = _ref.variable,
	      value = _ref.value,
	      label = _ref.label;
	
	  var trackerNames = arguments[1];
	
	  if (typeof ga === 'function') {
	    if (!category || !variable || !value || typeof value !== 'number') {
	      (0, _warn2.default)('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
	      return;
	    }
	
	    // Required Fields
	    var fieldObject = {
	      hitType: 'timing',
	      timingCategory: _format(category),
	      timingVar: _format(variable),
	      timingValue: value
	    };
	
	    if (label) {
	      fieldObject.timingLabel = _format(label);
	    }
	
	    send(fieldObject, trackerNames);
	  }
	}
	
	/**
	 * event:
	 * GA event tracking
	 * @param args.category {String} required
	 * @param args.action {String} required
	 * @param args.label {String} optional
	 * @param args.value {Int} optional
	 * @param args.nonInteraction {boolean} optional
	 * @param args.transport {string} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function event() {
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var trackerNames = arguments[1];
	
	  var category = _ref2.category,
	      action = _ref2.action,
	      label = _ref2.label,
	      value = _ref2.value,
	      nonInteraction = _ref2.nonInteraction,
	      transport = _ref2.transport,
	      args = _objectWithoutProperties(_ref2, ['category', 'action', 'label', 'value', 'nonInteraction', 'transport']);
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!category || !action) {
	      (0, _warn2.default)('args.category AND args.action are required in event()');
	      return;
	    }
	
	    // Required Fields
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: _format(category),
	      eventAction: _format(action)
	    };
	
	    // Optional Fields
	    if (label) {
	      fieldObject.eventLabel = _format(label);
	    }
	
	    if (typeof value !== 'undefined') {
	      if (typeof value !== 'number') {
	        (0, _warn2.default)('Expected `args.value` arg to be a Number.');
	      } else {
	        fieldObject.eventValue = value;
	      }
	    }
	
	    if (typeof nonInteraction !== 'undefined') {
	      if (typeof nonInteraction !== 'boolean') {
	        (0, _warn2.default)('`args.nonInteraction` must be a boolean.');
	      } else {
	        fieldObject.nonInteraction = nonInteraction;
	      }
	    }
	
	    if (typeof transport !== 'undefined') {
	      if (typeof transport !== 'string') {
	        (0, _warn2.default)('`args.transport` must be a string.');
	      } else {
	        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
	          (0, _warn2.default)('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
	        }
	
	        fieldObject.transport = transport;
	      }
	    }
	
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'dimension'.length) === 'dimension';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    });
	
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'metric'.length) === 'metric';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    });
	
	    // Send to GA
	    send(fieldObject, trackerNames);
	  }
	}
	
	/**
	 * exception:
	 * GA exception tracking
	 * @param args.description {String} optional
	 * @param args.fatal {boolean} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function exception(_ref3, trackerNames) {
	  var description = _ref3.description,
	      fatal = _ref3.fatal;
	
	  if (typeof ga === 'function') {
	    // Required Fields
	    var fieldObject = {
	      hitType: 'exception'
	    };
	
	    // Optional Fields
	    if (description) {
	      fieldObject.exDescription = _format(description);
	    }
	
	    if (typeof fatal !== 'undefined') {
	      if (typeof fatal !== 'boolean') {
	        (0, _warn2.default)('`args.fatal` must be a boolean.');
	      } else {
	        fieldObject.exFatal = fatal;
	      }
	    }
	
	    // Send to GA
	    send(fieldObject, trackerNames);
	  }
	}
	
	var plugin = exports.plugin = {
	  /**
	   * require:
	   * GA requires a plugin
	   * @param name {String} e.g. 'ecommerce' or 'myplugin'
	   * @param options {Object} optional e.g {path: '/log', debug: true}
	   */
	  require: function require(rawName, options) {
	    if (typeof ga === 'function') {
	      // Required Fields
	      if (!rawName) {
	        (0, _warn2.default)('`name` is required in .require()');
	        return;
	      }
	
	      var name = (0, _trim2.default)(rawName);
	      if (name === '') {
	        (0, _warn2.default)('`name` cannot be an empty string in .require()');
	        return;
	      }
	
	      // Optional Fields
	      if (options) {
	        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
	          (0, _warn2.default)('Expected `options` arg to be an Object');
	          return;
	        }
	
	        if (Object.keys(options).length === 0) {
	          (0, _warn2.default)('Empty `options` given to .require()');
	        }
	
	        ga('require', name, options);
	
	        if (_debug) {
	          (0, _log2.default)('called ga(\'require\', \'' + name + '\', ' + JSON.stringify(options));
	        }
	      } else {
	        ga('require', name);
	
	        if (_debug) {
	          (0, _log2.default)('called ga(\'require\', \'' + name + '\');');
	        }
	      }
	    }
	  },
	
	  /**
	   * execute:
	   * GA execute action for plugin
	   * Takes variable number of arguments
	   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
	   * @param action {String} e.g. 'addItem' or 'myCustomAction'
	   * @param actionType {String} optional e.g. 'detail'
	   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
	   */
	  execute: function execute(pluginName, action) {
	    var payload = void 0;
	    var actionType = void 0;
	
	    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
	      payload = arguments.length <= 2 ? undefined : arguments[2];
	    } else {
	      actionType = arguments.length <= 2 ? undefined : arguments[2];
	      payload = arguments.length <= 3 ? undefined : arguments[3];
	    }
	
	    if (typeof ga === 'function') {
	      if (typeof pluginName !== 'string') {
	        (0, _warn2.default)('Expected `pluginName` arg to be a String.');
	      } else if (typeof action !== 'string') {
	        (0, _warn2.default)('Expected `action` arg to be a String.');
	      } else {
	        var command = pluginName + ':' + action;
	        payload = payload || null;
	        if (actionType && payload) {
	          ga(command, actionType, payload);
	          if (_debug) {
	            (0, _log2.default)('called ga(\'' + command + '\');');
	            (0, _log2.default)('actionType: "' + actionType + '" with payload: ' + JSON.stringify(payload));
	          }
	        } else if (payload) {
	          ga(command, payload);
	          if (_debug) {
	            (0, _log2.default)('called ga(\'' + command + '\');');
	            (0, _log2.default)('with payload: ' + JSON.stringify(payload));
	          }
	        } else {
	          ga(command);
	          if (_debug) {
	            (0, _log2.default)('called ga(\'' + command + '\');');
	          }
	        }
	      }
	    }
	  }
	};
	
	/**
	 * outboundLink:
	 * GA outboundLink tracking
	 * @param args.label {String} e.g. url, or 'Create an Account'
	 * @param {function} hitCallback - Called after processing a hit.
	 */
	function outboundLink(args, hitCallback, trackerNames) {
	  if (typeof hitCallback !== 'function') {
	    (0, _warn2.default)('hitCallback function is required');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!args || !args.label) {
	      (0, _warn2.default)('args.label is required in outboundLink()');
	      return;
	    }
	
	    // Required Fields
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: 'Outbound',
	      eventAction: 'Click',
	      eventLabel: _format(args.label)
	    };
	
	    var safetyCallbackCalled = false;
	    var safetyCallback = function safetyCallback() {
	      // This prevents a delayed response from GA
	      // causing hitCallback from being fired twice
	      safetyCallbackCalled = true;
	
	      hitCallback();
	    };
	
	    // Using a timeout to ensure the execution of critical application code
	    // in the case when the GA server might be down
	    // or an ad blocker prevents sending the data
	
	    // register safety net timeout:
	    var t = setTimeout(safetyCallback, 250);
	
	    var clearableCallbackForGA = function clearableCallbackForGA() {
	      clearTimeout(t);
	      if (!safetyCallbackCalled) {
	        hitCallback();
	      }
	    };
	
	    fieldObject.hitCallback = clearableCallbackForGA;
	
	    // Send to GA
	    send(fieldObject, trackerNames);
	  } else {
	    // if ga is not defined, return the callback so the application
	    // continues to work as expected
	    setTimeout(hitCallback, 0);
	  }
	}
	
	_OutboundLink2.default.origTrackLink = _OutboundLink2.default.trackLink;
	_OutboundLink2.default.trackLink = outboundLink;
	var OutboundLink = exports.OutboundLink = _OutboundLink2.default;
	var testModeAPI = exports.testModeAPI = _testModeAPI2.default;
	
	exports.default = {
	  initialize: initialize,
	  ga: ga,
	  set: set,
	  send: send,
	  pageview: pageview,
	  modalview: modalview,
	  timing: timing,
	  event: event,
	  exception: exception,
	  plugin: plugin,
	  outboundLink: outboundLink,
	  OutboundLink: OutboundLink,
	  testModeAPI: _testModeAPI2.default
	};
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = format;
	
	var _mightBeEmail = __webpack_require__(4);
	
	var _mightBeEmail2 = _interopRequireDefault(_mightBeEmail);
	
	var _toTitleCase = __webpack_require__(5);
	
	var _toTitleCase2 = _interopRequireDefault(_toTitleCase);
	
	var _warn = __webpack_require__(0);
	
	var _warn2 = _interopRequireDefault(_warn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var redacted = 'REDACTED (Potential Email Address)';
	
	function format(s, titleCase) {
	  if ((0, _mightBeEmail2.default)(s)) {
	    (0, _warn2.default)('This arg looks like an email address, redacting.');
	    return redacted;
	  }
	
	  if (titleCase) {
	    return (0, _toTitleCase2.default)(s);
	  }
	
	  return s;
	}
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mightBeEmail;
	// See if s could be an email address. We don't want to send personal data like email.
	// https://support.google.com/analytics/answer/2795983?hl=en
	function mightBeEmail(s) {
	  // There's no point trying to validate rfc822 fully, just look for ...@...
	  return (/[^@]+@[^@]+/.test(s)
	  );
	}
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toTitleCase;
	
	var _trim = __webpack_require__(1);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i; /**
	                                                                                                * To Title Case 2.1 - http://individed.com/code/to-title-case/
	                                                                                                * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
	                                                                                                * https://github.com/gouch/to-title-case
	                                                                                                */
	
	function toTitleCase(string) {
	  return (0, _trim2.default)(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
	    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
	      return match.toLowerCase();
	    }
	
	    if (match.substr(1).search(/[A-Z]|\../) > -1) {
	      return match;
	    }
	
	    return match.charAt(0).toUpperCase() + match.substr(1);
	  });
	}
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = removeLeadingSlash;
	function removeLeadingSlash(string) {
	  if (string.substring(0, 1) === '/') {
	    return string.substring(1);
	  }
	
	  return string;
	}
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (options) {
	  // https://developers.google.com/analytics/devguides/collection/analyticsjs/
	  /* eslint-disable */
	  (function (i, s, o, g, r, a, m) {
	    i['GoogleAnalyticsObject'] = r;
	    i[r] = i[r] || function () {
	      (i[r].q = i[r].q || []).push(arguments);
	    }, i[r].l = 1 * new Date();
	    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
	    a.async = 1;
	    a.src = g;
	    m.parentNode.insertBefore(a, m);
	  })(window, document, 'script', options && options.gaAddress ? options.gaAddress : 'https://www.google-analytics.com/analytics.js', 'ga');
	  /* eslint-enable */
	};
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = log;
	function log(s) {
	  console.info('[react-ga]', s);
	}
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var gaCalls = exports.gaCalls = [];
	
	exports.default = {
	  calls: gaCalls,
	  ga: function ga() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    gaCalls.push([].concat(args));
	  }
	};
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warn = __webpack_require__(0);
	
	var _warn2 = _interopRequireDefault(_warn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NEWTAB = '_blank';
	var MIDDLECLICK = 1;
	
	var OutboundLink = function (_Component) {
	  _inherits(OutboundLink, _Component);
	
	  function OutboundLink() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, OutboundLink);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OutboundLink.__proto__ || Object.getPrototypeOf(OutboundLink)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
	      var _this$props = _this.props,
	          target = _this$props.target,
	          eventLabel = _this$props.eventLabel,
	          to = _this$props.to,
	          onClick = _this$props.onClick;
	
	      var eventMeta = { label: eventLabel };
	      var sameTarget = target !== NEWTAB;
	      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);
	
	      if (sameTarget && normalClick) {
	        event.preventDefault();
	        OutboundLink.trackLink(eventMeta, function () {
	          window.location.href = to;
	        });
	      } else {
	        OutboundLink.trackLink(eventMeta, function () {});
	      }
	
	      if (onClick) {
	        onClick(event);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(OutboundLink, [{
	    key: 'render',
	    value: function render() {
	      var props = _extends({}, this.props, {
	        href: this.props.to,
	        onClick: this.handleClick
	      });
	      delete props.eventLabel;
	      return _react2.default.createElement('a', props);
	    }
	  }]);
	
	  return OutboundLink;
	}(_react.Component);
	
	OutboundLink.propTypes = {
	  eventLabel: _propTypes2.default.string.isRequired,
	  target: _propTypes2.default.string,
	  to: _propTypes2.default.string,
	  onClick: _propTypes2.default.func
	};
	OutboundLink.defaultProps = {
	  target: null,
	  to: null,
	  onClick: null
	};
	
	OutboundLink.trackLink = function () {
	  (0, _warn2.default)('ga tracking not enabled');
	};
	
	exports.default = OutboundLink;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_11__;
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_12__;
	
	/***/ })
	/******/ ]);
	});

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Script = function (_React$Component) {
	  _inherits(Script, _React$Component);
	
	  // A dictionary mapping script URL to a boolean value indicating if the script
	  // has failed to load.
	
	
	  // A dictionary mapping script URLs to a dictionary mapping
	  // component key to component for all components that are waiting
	  // for the script to load.
	  function Script(props) {
	    _classCallCheck(this, Script);
	
	    var _this = _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).call(this, props));
	
	    _this.scriptLoaderId = 'id' + _this.constructor.idCount++; // eslint-disable-line space-unary-ops, no-plusplus
	    return _this;
	  }
	
	  // A counter used to generate a unique id for each component that uses
	  // ScriptLoaderMixin.
	
	
	  // A dictionary mapping script URL to a boolean value indicating if the script
	  // has already been loaded.
	
	
	  _createClass(Script, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          onError = _props.onError,
	          onLoad = _props.onLoad,
	          url = _props.url;
	
	
	      if (this.constructor.loadedScripts[url]) {
	        onLoad();
	        return;
	      }
	
	      if (this.constructor.erroredScripts[url]) {
	        onError();
	        return;
	      }
	
	      // If the script is loading, add the component to the script's observers
	      // and return. Otherwise, initialize the script's observers with the component
	      // and start loading the script.
	      if (this.constructor.scriptObservers[url]) {
	        this.constructor.scriptObservers[url][this.scriptLoaderId] = this.props;
	        return;
	      }
	
	      this.constructor.scriptObservers[url] = _defineProperty({}, this.scriptLoaderId, this.props);
	
	      this.createScript();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var url = this.props.url;
	
	      var observers = this.constructor.scriptObservers[url];
	
	      // If the component is waiting for the script to load, remove the
	      // component from the script's observers before unmounting the component.
	      if (observers) {
	        delete observers[this.scriptLoaderId];
	      }
	    }
	  }, {
	    key: 'createScript',
	    value: function createScript() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          onCreate = _props2.onCreate,
	          url = _props2.url,
	          attributes = _props2.attributes;
	
	      var script = document.createElement('script');
	
	      onCreate();
	
	      // add 'data-' or non standard attributes to the script tag
	      if (attributes) {
	        Object.keys(attributes).forEach(function (prop) {
	          return script.setAttribute(prop, attributes[prop]);
	        });
	      }
	
	      script.src = url;
	
	      // default async to true if not set with custom attributes
	      if (!script.hasAttribute('async')) {
	        script.async = 1;
	      }
	
	      var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(shouldRemoveObserver) {
	        var observers = _this2.constructor.scriptObservers[url];
	        Object.keys(observers).forEach(function (key) {
	          if (shouldRemoveObserver(observers[key])) {
	            delete _this2.constructor.scriptObservers[url][_this2.scriptLoaderId];
	          }
	        });
	      };
	      script.onload = function () {
	        _this2.constructor.loadedScripts[url] = true;
	        callObserverFuncAndRemoveObserver(function (observer) {
	          observer.onLoad();
	          return true;
	        });
	      };
	
	      script.onerror = function () {
	        _this2.constructor.erroredScripts[url] = true;
	        callObserverFuncAndRemoveObserver(function (observer) {
	          observer.onError();
	          return true;
	        });
	      };
	
	      document.body.appendChild(script);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Script;
	}(_react2.default.Component);
	
	Script.propTypes = {
	  attributes: _propTypes.PropTypes.object, // eslint-disable-line react/forbid-prop-types
	  onCreate: _propTypes.PropTypes.func,
	  onError: _propTypes.PropTypes.func.isRequired,
	  onLoad: _propTypes.PropTypes.func.isRequired,
	  url: _propTypes.PropTypes.string.isRequired
	};
	Script.defaultProps = {
	  attributes: {},
	  onCreate: function onCreate() {},
	  onError: function onError() {},
	  onLoad: function onLoad() {} };
	Script.scriptObservers = {};
	Script.loadedScripts = {};
	Script.erroredScripts = {};
	Script.idCount = 0;
	exports.default = Script;
	module.exports = exports['default'];

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(479);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(477);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Simple module to localize the React interface using the same syntax
	 * used in the ReactNativeLocalization module
	 * (https://github.com/stefalda/ReactNativeLocalization)
	 *
	 * Originally developed by Stefano Falda (stefano.falda@gmail.com)
	 *
	 * It uses a call to the Navigator/Browser object to get the current interface language,
	 * then display the correct language strings or the default language (the first
	 * one if a match is not found).
	 *
	 * How to use:
	 * Check the instructions at:
	 * https://github.com/stefalda/react-localization
	 */
	
	var placeholderRegex = /(\{[\d|\w]+\})/;
	var isReactComponent = function isReactComponent(value) {
	    return _typeof(value.$$typeof) === 'symbol';
	};
	
	var LocalizedStrings = function () {
	    _createClass(LocalizedStrings, [{
	        key: '_getBestMatchingLanguage',
	        value: function _getBestMatchingLanguage(language, props) {
	            //If an object with the passed language key exists return it
	            if (props[language]) return language;
	
	            //if the string is composed try to find a match with only the first language identifiers (en-US --> en)
	            var idx = language.indexOf('-');
	            var auxLang = idx >= 0 ? language.substring(0, idx) : language;
	            return props[auxLang] ? auxLang : Object.keys(props)[0];
	        }
	    }]);
	
	    function LocalizedStrings(props) {
	        _classCallCheck(this, LocalizedStrings);
	
	        this._interfaceLanguage = utils.getInterfaceLanguage();
	        this._language = this._interfaceLanguage;
	        this.setContent(props);
	    }
	
	    _createClass(LocalizedStrings, [{
	        key: 'setContent',
	        value: function setContent(props) {
	            this._defaultLanguage = Object.keys(props)[0];
	            this._defaultLanguageFirstLevelKeys = [];
	            //Store locally the passed strings
	            this._props = props;
	            utils.validateTranslationKeys(Object.keys(props[this._defaultLanguage]));
	            //Store first level keys (for identifying missing translations)
	            for (var key in this._props[this._defaultLanguage]) {
	                if (typeof this._props[this._defaultLanguage][key] == "string") {
	                    this._defaultLanguageFirstLevelKeys.push(key);
	                }
	            }
	            //Set language to its default value (the interface)
	            this.setLanguage(this._interfaceLanguage);
	        }
	
	        //Can be used from ouside the class to force a particular language
	        //indipendently from the interface one
	
	    }, {
	        key: 'setLanguage',
	        value: function setLanguage(language) {
	            //Check if exists a translation for the current language or if the default
	            //should be used
	            var bestLanguage = this._getBestMatchingLanguage(language, this._props);
	            var defaultLanguage = Object.keys(this._props)[0];
	            this._language = bestLanguage;
	            //Associate the language object to the this object
	            if (this._props[bestLanguage]) {
	                //delete default propery values to identify missing translations
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = this._defaultLanguageFirstLevelKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        key = _step.value;
	
	                        delete this[key];
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	
	                var localizedStrings = Object.assign({}, this._props[this._language]);
	                for (var key in localizedStrings) {
	                    if (localizedStrings.hasOwnProperty(key)) {
	                        this[key] = localizedStrings[key];
	                    }
	                }
	                //Now add any string missing from the translation but existing in the default language
	                if (defaultLanguage !== this._language) {
	                    localizedStrings = this._props[defaultLanguage];
	                    this._fallbackValues(localizedStrings, this);
	                }
	            }
	        }
	
	        //Load fallback values for missing translations
	
	    }, {
	        key: '_fallbackValues',
	        value: function _fallbackValues(defaultStrings, strings) {
	            for (var key in defaultStrings) {
	                if (defaultStrings.hasOwnProperty(key) && !strings[key]) {
	                    strings[key] = defaultStrings[key];
	                    console.log('\uD83D\uDEA7 \uD83D\uDC77 key \'' + key + '\' not found in localizedStrings for language ' + this._language + ' \uD83D\uDEA7');
	                } else {
	                    if (typeof strings[key] != "string") {
	                        //It's an object
	                        this._fallbackValues(defaultStrings[key], strings[key]);
	                    }
	                }
	            }
	        }
	
	        //The current language displayed (could differ from the interface language
	        // if it has been forced manually and a matching translation has been found)
	
	    }, {
	        key: 'getLanguage',
	        value: function getLanguage() {
	            return this._language;
	        }
	
	        //The current interface language (could differ from the language displayed)
	
	    }, {
	        key: 'getInterfaceLanguage',
	        value: function getInterfaceLanguage() {
	            return this._interfaceLanguage;
	        }
	
	        //Return an array containing the available languages passed as props in the constructor
	
	    }, {
	        key: 'getAvailableLanguages',
	        value: function getAvailableLanguages() {
	            if (!this._availableLanguages) {
	                this._availableLanguages = [];
	                for (var language in this._props) {
	                    this._availableLanguages.push(language);
	                }
	            }
	            return this._availableLanguages;
	        }
	
	        //Format the passed string replacing the numbered or tokenized placeholders
	        //eg. 1: I'd like some {0} and {1}, or just {0}
	        //eg. 2: I'd like some {bread} and {butter}, or just {bread}
	        //Use example:
	        //eg. 1: strings.formatString(strings.question, strings.bread, strings.butter)
	        //eg. 2: strings.formatString(strings.question, { bread: strings.bread, butter: strings.butter })
	
	    }, {
	        key: 'formatString',
	        value: function formatString(str) {
	            for (var _len = arguments.length, valuesForPlaceholders = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	                valuesForPlaceholders[_key - 1] = arguments[_key];
	            }
	
	            return str.split(placeholderRegex).filter(function (textPart) {
	                return !!textPart;
	            }).map(function (textPart, index) {
	                if (textPart.match(placeholderRegex)) {
	                    var matchedKey = textPart.slice(1, -1);
	                    var valueForPlaceholder = valuesForPlaceholders[matchedKey];
	
	                    // If no value found, check if working with an object instead
	                    if (valueForPlaceholder == undefined) {
	                        var valueFromObjectPlaceholder = valuesForPlaceholders[0][matchedKey];
	                        if (valueFromObjectPlaceholder !== undefined) {
	                            valueForPlaceholder = valueFromObjectPlaceholder;
	                        } else {
	                            // If value still isn't found, then it must have been undefined/null
	                            return valueForPlaceholder;
	                        }
	                    }
	
	                    if (isReactComponent(valueForPlaceholder)) {
	                        return _react2.default.Children.toArray(valueForPlaceholder).map(function (component) {
	                            return _extends({}, component, { key: index.toString() });
	                        });
	                    }
	
	                    return valueForPlaceholder;
	                }
	                return textPart;
	            });
	        }
	
	        //Return a string with the passed key in a different language
	
	    }, {
	        key: 'getString',
	        value: function getString(key, language) {
	            try {
	                return this._props[language][key];
	            } catch (ex) {
	                console.log("No localization found for key " + key + " and language " + language);
	            }
	            return null;
	        }
	    }]);
	
	    return LocalizedStrings;
	}();
	
	exports.default = LocalizedStrings;

/***/ },
/* 477 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getInterfaceLanguage = getInterfaceLanguage;
	exports.validateTranslationKeys = validateTranslationKeys;
	function getInterfaceLanguage() {
	  var defaultLang = 'en-US';
	  if (typeof navigator === "undefined") {
	    return defaultLang;
	  }
	  if (!!navigator && !!navigator.language) {
	    return navigator.language;
	  } else if (!!navigator && !!navigator.languages && !!navigator.languages[0]) {
	    return navigator.languages[0];
	  } else if (!!navigator && !!navigator.userLanguage) {
	    return navigator.userLanguage;
	  } else if (!!navigator && !!navigator.browserLanguage) {
	    return navigator.browserLanguage;
	  }
	  return defaultLang;
	}
	
	function validateTranslationKeys(translationKeys) {
	  var reservedNames = ['_interfaceLanguage', '_language', '_defaultLanguage', '_defaultLanguageFirstLevelKeys', '_props'];
	  translationKeys.forEach(function (key) {
	    if (reservedNames.indexOf(key) !== -1) {
	      throw new Error(key + ' cannot be used as a key. It is a reserved word.');
	    }
	  });
	}

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.3.2
	 * react.production.min.js
	 *
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var m=__webpack_require__(7),n=__webpack_require__(3),p=__webpack_require__(42),q=__webpack_require__(18),r="function"===typeof Symbol&&Symbol["for"],t=r?Symbol["for"]("react.element"):60103,u=r?Symbol["for"]("react.portal"):60106,v=r?Symbol["for"]("react.fragment"):60107,w=r?Symbol["for"]("react.strict_mode"):60108,x=r?Symbol["for"]("react.provider"):60109,y=r?Symbol["for"]("react.context"):60110,z=r?Symbol["for"]("react.async_mode"):60111,A=r?Symbol["for"]("react.forward_ref"):
	60112,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b=arguments.length-1,e="http://reactjs.org/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};
	function E(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||D}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?C("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||D}var H=G.prototype=new F;
	H.constructor=G;m(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J=Object.prototype.hasOwnProperty,K={key:!0,ref:!0,__self:!0,__source:!0};
	function L(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)J.call(b,c)&&!K.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var k=Array(f),l=0;l<f;l++)k[l]=arguments[l+2];d.children=k}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:I.current}}
	function M(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var N=/\/+/g,O=[];function P(a,b,e,c){if(O.length){var d=O.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function Q(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>O.length&&O.push(a)}
	function R(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+S(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+S(d,h);g+=R(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
	h=0;!(d=a.next()).done;)d=d.value,f=b+S(d,h++),g+=R(d,f,e,c);else"object"===d&&(e=""+a,C("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function S(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function T(a,b){a.func.call(a.context,b,a.count++)}
	function U(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,e,q.thatReturnsArgument):null!=a&&(M(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(N,"$\x26/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function V(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(N,"$\x26/")+"/");b=P(b,g,c,d);null==a||R(a,"",U,b);Q(b)}
	var W={Children:{map:function(a,b,e){if(null==a)return a;var c=[];V(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=P(null,null,b,e);null==a||R(a,"",T,b);Q(b)},count:function(a){return null==a?0:R(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];V(a,b,null,q.thatReturnsArgument);return b},only:function(a){M(a)?void 0:C("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:y,
	_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_changedBits:0,Provider:null,Consumer:null};a.Provider={$$typeof:x,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:A,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:z,createElement:L,cloneElement:function(a,b,e){null===a||void 0===a?C("267",a):void 0;var c=void 0,d=m({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=I.current);void 0!==b.key&&(g=""+b.key);var k=void 0;a.type&&a.type.defaultProps&&
	(k=a.type.defaultProps);for(c in b)J.call(b,c)&&!K.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==k?k[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){k=Array(c);for(var l=0;l<c;l++)k[l]=arguments[l+2];d.children=k}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=L.bind(null,a);b.type=a;return b},isValidElement:M,version:"16.3.2",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:I,assign:m}},X=Object.freeze({default:W}),
	Y=X&&W||X;module.exports=Y["default"]?Y["default"]:Y;


/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(478);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	
	var _react = __webpack_require__(9);
	
	var _propTypes = __webpack_require__(54);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PropTypes = __webpack_require__(192);
	
	var _warning = __webpack_require__(110);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider() {
	  var _Provider$childContex;
	
	  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
	  var subKey = arguments[1];
	
	  var subscriptionKey = subKey || storeKey + 'Subscription';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      _classCallCheck(this, Provider);
	
	      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    Provider.prototype.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    Provider.prototype.componentWillReceiveProps = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes2.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	
	  return Provider;
	}
	
	exports.default = createProvider();

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createConnect = createConnect;
	
	var _connectAdvanced = __webpack_require__(190);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _shallowEqual = __webpack_require__(488);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _mapDispatchToProps = __webpack_require__(482);
	
	var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);
	
	var _mapStateToProps = __webpack_require__(483);
	
	var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);
	
	var _mergeProps = __webpack_require__(484);
	
	var _mergeProps2 = _interopRequireDefault(_mergeProps);
	
	var _selectorFactory = __webpack_require__(485);
	
	var _selectorFactory2 = _interopRequireDefault(_selectorFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        _ref2$pure = _ref2.pure,
	        pure = _ref2$pure === undefined ? true : _ref2$pure,
	        _ref2$areStatesEqual = _ref2.areStatesEqual,
	        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
	        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
	        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
	        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
	        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
	        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
	        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
	        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	exports.default = createConnect();

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _redux = __webpack_require__(113);
	
	var _wrapMapToProps = __webpack_require__(191);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	exports.default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(191);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	exports.default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	
	var _verifyPlainObject = __webpack_require__(193);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	exports.default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _verifySubselectors = __webpack_require__(486);
	
	var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = __webpack_require__(110);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ },
/* 487 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub, onStateChange) {
	    _classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ },
/* 488 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 489 */
98,
/* 490 */
[603, 58],
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(490);
	var ReactElement = __webpack_require__(48);
	
	var emptyFunction = __webpack_require__(18);
	var traverseAllChildren = __webpack_require__(500);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(48);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(48),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(164);
	
	module.exports = factory(isValidElement);

/***/ },
/* 494 */
450,
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(194),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(48),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(197);
	var factory = __webpack_require__(155);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 496 */
469,
/* 497 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(58);
	
	var ReactElement = __webpack_require__(48);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(58);
	
	var ReactCurrentOwner = __webpack_require__(29);
	var REACT_ELEMENT_TYPE = __webpack_require__(196);
	
	var getIteratorFn = __webpack_require__(496);
	var invariant = __webpack_require__(3);
	var KeyEscapeUtils = __webpack_require__(489);
	var warning = __webpack_require__(5);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(41)


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(199)


/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	var Stream = (function (){
	  try {
	    return __webpack_require__(20); // hack to fix a circular dependency issue when used with browserify
	  } catch(_){}
	}());
	exports = module.exports = __webpack_require__(200);
	exports.Stream = Stream || exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(112);
	exports.Duplex = __webpack_require__(41);
	exports.Transform = __webpack_require__(111);
	exports.PassThrough = __webpack_require__(199);


/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(111)


/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(112)


/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(201);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 507 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(202);
	
	var _isPlainObject = __webpack_require__(91);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(203);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = ripemd160
	
	
	
	/*
	CryptoJS v3.1.2
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.
	
	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	
	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	
	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/
	
	// Constants table
	var zl = [
	    0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	    7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	    3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	    1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	    4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13];
	var zr = [
	    5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	    6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	    15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	    8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	    12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11];
	var sl = [
	     11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	    7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	    11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	      11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	    9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ];
	var sr = [
	    8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	    9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	    9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	    15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	    8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ];
	
	var hl =  [ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E];
	var hr =  [ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000];
	
	var bytesToWords = function (bytes) {
	  var words = [];
	  for (var i = 0, b = 0; i < bytes.length; i++, b += 8) {
	    words[b >>> 5] |= bytes[i] << (24 - b % 32);
	  }
	  return words;
	};
	
	var wordsToBytes = function (words) {
	  var bytes = [];
	  for (var b = 0; b < words.length * 32; b += 8) {
	    bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	  }
	  return bytes;
	};
	
	var processBlock = function (H, M, offset) {
	
	  // Swap endian
	  for (var i = 0; i < 16; i++) {
	    var offset_i = offset + i;
	    var M_offset_i = M[offset_i];
	
	    // Swap
	    M[offset_i] = (
	        (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	        (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	    );
	  }
	
	  // Working variables
	  var al, bl, cl, dl, el;
	  var ar, br, cr, dr, er;
	
	  ar = al = H[0];
	  br = bl = H[1];
	  cr = cl = H[2];
	  dr = dl = H[3];
	  er = el = H[4];
	  // Computation
	  var t;
	  for (var i = 0; i < 80; i += 1) {
	    t = (al +  M[offset+zl[i]])|0;
	    if (i<16){
	        t +=  f1(bl,cl,dl) + hl[0];
	    } else if (i<32) {
	        t +=  f2(bl,cl,dl) + hl[1];
	    } else if (i<48) {
	        t +=  f3(bl,cl,dl) + hl[2];
	    } else if (i<64) {
	        t +=  f4(bl,cl,dl) + hl[3];
	    } else {// if (i<80) {
	        t +=  f5(bl,cl,dl) + hl[4];
	    }
	    t = t|0;
	    t =  rotl(t,sl[i]);
	    t = (t+el)|0;
	    al = el;
	    el = dl;
	    dl = rotl(cl, 10);
	    cl = bl;
	    bl = t;
	
	    t = (ar + M[offset+zr[i]])|0;
	    if (i<16){
	        t +=  f5(br,cr,dr) + hr[0];
	    } else if (i<32) {
	        t +=  f4(br,cr,dr) + hr[1];
	    } else if (i<48) {
	        t +=  f3(br,cr,dr) + hr[2];
	    } else if (i<64) {
	        t +=  f2(br,cr,dr) + hr[3];
	    } else {// if (i<80) {
	        t +=  f1(br,cr,dr) + hr[4];
	    }
	    t = t|0;
	    t =  rotl(t,sr[i]) ;
	    t = (t+er)|0;
	    ar = er;
	    er = dr;
	    dr = rotl(cr, 10);
	    cr = br;
	    br = t;
	  }
	  // Intermediate hash value
	  t    = (H[1] + cl + dr)|0;
	  H[1] = (H[2] + dl + er)|0;
	  H[2] = (H[3] + el + ar)|0;
	  H[3] = (H[4] + al + br)|0;
	  H[4] = (H[0] + bl + cr)|0;
	  H[0] =  t;
	};
	
	function f1(x, y, z) {
	  return ((x) ^ (y) ^ (z));
	}
	
	function f2(x, y, z) {
	  return (((x)&(y)) | ((~x)&(z)));
	}
	
	function f3(x, y, z) {
	  return (((x) | (~(y))) ^ (z));
	}
	
	function f4(x, y, z) {
	  return (((x) & (z)) | ((y)&(~(z))));
	}
	
	function f5(x, y, z) {
	  return ((x) ^ ((y) |(~(z))));
	}
	
	function rotl(x,n) {
	  return (x<<n) | (x>>>(32-n));
	}
	
	function ripemd160(message) {
	  var H = [0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0];
	
	  if (typeof message == 'string')
	    message = new Buffer(message, 'utf8');
	
	  var m = bytesToWords(message);
	
	  var nBitsLeft = message.length * 8;
	  var nBitsTotal = message.length * 8;
	
	  // Add padding
	  m[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	  m[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	      (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	      (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	  );
	
	  for (var i=0 ; i<m.length; i += 16) {
	    processBlock(H, m, i);
	  }
	
	  // Swap endian
	  for (var i = 0; i < 5; i++) {
	      // Shortcut
	    var H_i = H[i];
	
	    // Swap
	    H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	          (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	  }
	
	  var digestbytes = wordsToBytes(H);
	  return new Buffer(digestbytes);
	}
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// wrapper for non-node envs
	;(function (sax) {
	
	sax.parser = function (strict, opt) { return new SAXParser(strict, opt) }
	sax.SAXParser = SAXParser
	sax.SAXStream = SAXStream
	sax.createStream = createStream
	
	// When we pass the MAX_BUFFER_LENGTH position, start checking for buffer overruns.
	// When we check, schedule the next check for MAX_BUFFER_LENGTH - (max(buffer lengths)),
	// since that's the earliest that a buffer overrun could occur.  This way, checks are
	// as rare as required, but as often as necessary to ensure never crossing this bound.
	// Furthermore, buffers are only tested at most once per write(), so passing a very
	// large string into write() might have undesirable effects, but this is manageable by
	// the caller, so it is assumed to be safe.  Thus, a call to write() may, in the extreme
	// edge case, result in creating at most one complete copy of the string passed in.
	// Set to Infinity to have unlimited buffers.
	sax.MAX_BUFFER_LENGTH = 64 * 1024
	
	var buffers = [
	  "comment", "sgmlDecl", "textNode", "tagName", "doctype",
	  "procInstName", "procInstBody", "entity", "attribName",
	  "attribValue", "cdata", "script"
	]
	
	sax.EVENTS = // for discoverability.
	  [ "text"
	  , "processinginstruction"
	  , "sgmldeclaration"
	  , "doctype"
	  , "comment"
	  , "attribute"
	  , "opentag"
	  , "closetag"
	  , "opencdata"
	  , "cdata"
	  , "closecdata"
	  , "error"
	  , "end"
	  , "ready"
	  , "script"
	  , "opennamespace"
	  , "closenamespace"
	  ]
	
	function SAXParser (strict, opt) {
	  if (!(this instanceof SAXParser)) return new SAXParser(strict, opt)
	
	  var parser = this
	  clearBuffers(parser)
	  parser.q = parser.c = ""
	  parser.bufferCheckPosition = sax.MAX_BUFFER_LENGTH
	  parser.opt = opt || {}
	  parser.opt.lowercase = parser.opt.lowercase || parser.opt.lowercasetags
	  parser.looseCase = parser.opt.lowercase ? "toLowerCase" : "toUpperCase"
	  parser.tags = []
	  parser.closed = parser.closedRoot = parser.sawRoot = false
	  parser.tag = parser.error = null
	  parser.strict = !!strict
	  parser.noscript = !!(strict || parser.opt.noscript)
	  parser.state = S.BEGIN
	  parser.ENTITIES = Object.create(sax.ENTITIES)
	  parser.attribList = []
	
	  // namespaces form a prototype chain.
	  // it always points at the current tag,
	  // which protos to its parent tag.
	  if (parser.opt.xmlns) parser.ns = Object.create(rootNS)
	
	  // mostly just for error reporting
	  parser.trackPosition = parser.opt.position !== false
	  if (parser.trackPosition) {
	    parser.position = parser.line = parser.column = 0
	  }
	  emit(parser, "onready")
	}
	
	if (!Object.create) Object.create = function (o) {
	  function f () { this.__proto__ = o }
	  f.prototype = o
	  return new f
	}
	
	if (!Object.getPrototypeOf) Object.getPrototypeOf = function (o) {
	  return o.__proto__
	}
	
	if (!Object.keys) Object.keys = function (o) {
	  var a = []
	  for (var i in o) if (o.hasOwnProperty(i)) a.push(i)
	  return a
	}
	
	function checkBufferLength (parser) {
	  var maxAllowed = Math.max(sax.MAX_BUFFER_LENGTH, 10)
	    , maxActual = 0
	  for (var i = 0, l = buffers.length; i < l; i ++) {
	    var len = parser[buffers[i]].length
	    if (len > maxAllowed) {
	      // Text/cdata nodes can get big, and since they're buffered,
	      // we can get here under normal conditions.
	      // Avoid issues by emitting the text node now,
	      // so at least it won't get any bigger.
	      switch (buffers[i]) {
	        case "textNode":
	          closeText(parser)
	        break
	
	        case "cdata":
	          emitNode(parser, "oncdata", parser.cdata)
	          parser.cdata = ""
	        break
	
	        case "script":
	          emitNode(parser, "onscript", parser.script)
	          parser.script = ""
	        break
	
	        default:
	          error(parser, "Max buffer length exceeded: "+buffers[i])
	      }
	    }
	    maxActual = Math.max(maxActual, len)
	  }
	  // schedule the next check for the earliest possible buffer overrun.
	  parser.bufferCheckPosition = (sax.MAX_BUFFER_LENGTH - maxActual)
	                             + parser.position
	}
	
	function clearBuffers (parser) {
	  for (var i = 0, l = buffers.length; i < l; i ++) {
	    parser[buffers[i]] = ""
	  }
	}
	
	function flushBuffers (parser) {
	  closeText(parser)
	  if (parser.cdata !== "") {
	    emitNode(parser, "oncdata", parser.cdata)
	    parser.cdata = ""
	  }
	  if (parser.script !== "") {
	    emitNode(parser, "onscript", parser.script)
	    parser.script = ""
	  }
	}
	
	SAXParser.prototype =
	  { end: function () { end(this) }
	  , write: write
	  , resume: function () { this.error = null; return this }
	  , close: function () { return this.write(null) }
	  , flush: function () { flushBuffers(this) }
	  }
	
	try {
	  var Stream = __webpack_require__(20).Stream
	} catch (ex) {
	  var Stream = function () {}
	}
	
	
	var streamWraps = sax.EVENTS.filter(function (ev) {
	  return ev !== "error" && ev !== "end"
	})
	
	function createStream (strict, opt) {
	  return new SAXStream(strict, opt)
	}
	
	function SAXStream (strict, opt) {
	  if (!(this instanceof SAXStream)) return new SAXStream(strict, opt)
	
	  Stream.apply(this)
	
	  this._parser = new SAXParser(strict, opt)
	  this.writable = true
	  this.readable = true
	
	
	  var me = this
	
	  this._parser.onend = function () {
	    me.emit("end")
	  }
	
	  this._parser.onerror = function (er) {
	    me.emit("error", er)
	
	    // if didn't throw, then means error was handled.
	    // go ahead and clear error, so we can write again.
	    me._parser.error = null
	  }
	
	  this._decoder = null;
	
	  streamWraps.forEach(function (ev) {
	    Object.defineProperty(me, "on" + ev, {
	      get: function () { return me._parser["on" + ev] },
	      set: function (h) {
	        if (!h) {
	          me.removeAllListeners(ev)
	          return me._parser["on"+ev] = h
	        }
	        me.on(ev, h)
	      },
	      enumerable: true,
	      configurable: false
	    })
	  })
	}
	
	SAXStream.prototype = Object.create(Stream.prototype,
	  { constructor: { value: SAXStream } })
	
	SAXStream.prototype.write = function (data) {
	  if (typeof Buffer === 'function' &&
	      typeof Buffer.isBuffer === 'function' &&
	      Buffer.isBuffer(data)) {
	    if (!this._decoder) {
	      var SD = __webpack_require__(115).StringDecoder
	      this._decoder = new SD('utf8')
	    }
	    data = this._decoder.write(data);
	  }
	
	  this._parser.write(data.toString())
	  this.emit("data", data)
	  return true
	}
	
	SAXStream.prototype.end = function (chunk) {
	  if (chunk && chunk.length) this.write(chunk)
	  this._parser.end()
	  return true
	}
	
	SAXStream.prototype.on = function (ev, handler) {
	  var me = this
	  if (!me._parser["on"+ev] && streamWraps.indexOf(ev) !== -1) {
	    me._parser["on"+ev] = function () {
	      var args = arguments.length === 1 ? [arguments[0]]
	               : Array.apply(null, arguments)
	      args.splice(0, 0, ev)
	      me.emit.apply(me, args)
	    }
	  }
	
	  return Stream.prototype.on.call(me, ev, handler)
	}
	
	
	
	// character classes and tokens
	var whitespace = "\r\n\t "
	  // this really needs to be replaced with character classes.
	  // XML allows all manner of ridiculous numbers and digits.
	  , number = "0124356789"
	  , letter = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
	  // (Letter | "_" | ":")
	  , quote = "'\""
	  , entity = number+letter+"#"
	  , attribEnd = whitespace + ">"
	  , CDATA = "[CDATA["
	  , DOCTYPE = "DOCTYPE"
	  , XML_NAMESPACE = "http://www.w3.org/XML/1998/namespace"
	  , XMLNS_NAMESPACE = "http://www.w3.org/2000/xmlns/"
	  , rootNS = { xml: XML_NAMESPACE, xmlns: XMLNS_NAMESPACE }
	
	// turn all the string character sets into character class objects.
	whitespace = charClass(whitespace)
	number = charClass(number)
	letter = charClass(letter)
	
	// http://www.w3.org/TR/REC-xml/#NT-NameStartChar
	// This implementation works on strings, a single character at a time
	// as such, it cannot ever support astral-plane characters (10000-EFFFF)
	// without a significant breaking change to either this  parser, or the
	// JavaScript language.  Implementation of an emoji-capable xml parser
	// is left as an exercise for the reader.
	var nameStart = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/
	
	var nameBody = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040\.\d-]/
	
	quote = charClass(quote)
	entity = charClass(entity)
	attribEnd = charClass(attribEnd)
	
	function charClass (str) {
	  return str.split("").reduce(function (s, c) {
	    s[c] = true
	    return s
	  }, {})
	}
	
	function isRegExp (c) {
	  return Object.prototype.toString.call(c) === '[object RegExp]'
	}
	
	function is (charclass, c) {
	  return isRegExp(charclass) ? !!c.match(charclass) : charclass[c]
	}
	
	function not (charclass, c) {
	  return !is(charclass, c)
	}
	
	var S = 0
	sax.STATE =
	{ BEGIN                     : S++
	, TEXT                      : S++ // general stuff
	, TEXT_ENTITY               : S++ // &amp and such.
	, OPEN_WAKA                 : S++ // <
	, SGML_DECL                 : S++ // <!BLARG
	, SGML_DECL_QUOTED          : S++ // <!BLARG foo "bar
	, DOCTYPE                   : S++ // <!DOCTYPE
	, DOCTYPE_QUOTED            : S++ // <!DOCTYPE "//blah
	, DOCTYPE_DTD               : S++ // <!DOCTYPE "//blah" [ ...
	, DOCTYPE_DTD_QUOTED        : S++ // <!DOCTYPE "//blah" [ "foo
	, COMMENT_STARTING          : S++ // <!-
	, COMMENT                   : S++ // <!--
	, COMMENT_ENDING            : S++ // <!-- blah -
	, COMMENT_ENDED             : S++ // <!-- blah --
	, CDATA                     : S++ // <![CDATA[ something
	, CDATA_ENDING              : S++ // ]
	, CDATA_ENDING_2            : S++ // ]]
	, PROC_INST                 : S++ // <?hi
	, PROC_INST_BODY            : S++ // <?hi there
	, PROC_INST_ENDING          : S++ // <?hi "there" ?
	, OPEN_TAG                  : S++ // <strong
	, OPEN_TAG_SLASH            : S++ // <strong /
	, ATTRIB                    : S++ // <a
	, ATTRIB_NAME               : S++ // <a foo
	, ATTRIB_NAME_SAW_WHITE     : S++ // <a foo _
	, ATTRIB_VALUE              : S++ // <a foo=
	, ATTRIB_VALUE_QUOTED       : S++ // <a foo="bar
	, ATTRIB_VALUE_CLOSED       : S++ // <a foo="bar"
	, ATTRIB_VALUE_UNQUOTED     : S++ // <a foo=bar
	, ATTRIB_VALUE_ENTITY_Q     : S++ // <foo bar="&quot;"
	, ATTRIB_VALUE_ENTITY_U     : S++ // <foo bar=&quot;
	, CLOSE_TAG                 : S++ // </a
	, CLOSE_TAG_SAW_WHITE       : S++ // </a   >
	, SCRIPT                    : S++ // <script> ...
	, SCRIPT_ENDING             : S++ // <script> ... <
	}
	
	sax.ENTITIES =
	{ "amp" : "&"
	, "gt" : ">"
	, "lt" : "<"
	, "quot" : "\""
	, "apos" : "'"
	, "AElig" : 198
	, "Aacute" : 193
	, "Acirc" : 194
	, "Agrave" : 192
	, "Aring" : 197
	, "Atilde" : 195
	, "Auml" : 196
	, "Ccedil" : 199
	, "ETH" : 208
	, "Eacute" : 201
	, "Ecirc" : 202
	, "Egrave" : 200
	, "Euml" : 203
	, "Iacute" : 205
	, "Icirc" : 206
	, "Igrave" : 204
	, "Iuml" : 207
	, "Ntilde" : 209
	, "Oacute" : 211
	, "Ocirc" : 212
	, "Ograve" : 210
	, "Oslash" : 216
	, "Otilde" : 213
	, "Ouml" : 214
	, "THORN" : 222
	, "Uacute" : 218
	, "Ucirc" : 219
	, "Ugrave" : 217
	, "Uuml" : 220
	, "Yacute" : 221
	, "aacute" : 225
	, "acirc" : 226
	, "aelig" : 230
	, "agrave" : 224
	, "aring" : 229
	, "atilde" : 227
	, "auml" : 228
	, "ccedil" : 231
	, "eacute" : 233
	, "ecirc" : 234
	, "egrave" : 232
	, "eth" : 240
	, "euml" : 235
	, "iacute" : 237
	, "icirc" : 238
	, "igrave" : 236
	, "iuml" : 239
	, "ntilde" : 241
	, "oacute" : 243
	, "ocirc" : 244
	, "ograve" : 242
	, "oslash" : 248
	, "otilde" : 245
	, "ouml" : 246
	, "szlig" : 223
	, "thorn" : 254
	, "uacute" : 250
	, "ucirc" : 251
	, "ugrave" : 249
	, "uuml" : 252
	, "yacute" : 253
	, "yuml" : 255
	, "copy" : 169
	, "reg" : 174
	, "nbsp" : 160
	, "iexcl" : 161
	, "cent" : 162
	, "pound" : 163
	, "curren" : 164
	, "yen" : 165
	, "brvbar" : 166
	, "sect" : 167
	, "uml" : 168
	, "ordf" : 170
	, "laquo" : 171
	, "not" : 172
	, "shy" : 173
	, "macr" : 175
	, "deg" : 176
	, "plusmn" : 177
	, "sup1" : 185
	, "sup2" : 178
	, "sup3" : 179
	, "acute" : 180
	, "micro" : 181
	, "para" : 182
	, "middot" : 183
	, "cedil" : 184
	, "ordm" : 186
	, "raquo" : 187
	, "frac14" : 188
	, "frac12" : 189
	, "frac34" : 190
	, "iquest" : 191
	, "times" : 215
	, "divide" : 247
	, "OElig" : 338
	, "oelig" : 339
	, "Scaron" : 352
	, "scaron" : 353
	, "Yuml" : 376
	, "fnof" : 402
	, "circ" : 710
	, "tilde" : 732
	, "Alpha" : 913
	, "Beta" : 914
	, "Gamma" : 915
	, "Delta" : 916
	, "Epsilon" : 917
	, "Zeta" : 918
	, "Eta" : 919
	, "Theta" : 920
	, "Iota" : 921
	, "Kappa" : 922
	, "Lambda" : 923
	, "Mu" : 924
	, "Nu" : 925
	, "Xi" : 926
	, "Omicron" : 927
	, "Pi" : 928
	, "Rho" : 929
	, "Sigma" : 931
	, "Tau" : 932
	, "Upsilon" : 933
	, "Phi" : 934
	, "Chi" : 935
	, "Psi" : 936
	, "Omega" : 937
	, "alpha" : 945
	, "beta" : 946
	, "gamma" : 947
	, "delta" : 948
	, "epsilon" : 949
	, "zeta" : 950
	, "eta" : 951
	, "theta" : 952
	, "iota" : 953
	, "kappa" : 954
	, "lambda" : 955
	, "mu" : 956
	, "nu" : 957
	, "xi" : 958
	, "omicron" : 959
	, "pi" : 960
	, "rho" : 961
	, "sigmaf" : 962
	, "sigma" : 963
	, "tau" : 964
	, "upsilon" : 965
	, "phi" : 966
	, "chi" : 967
	, "psi" : 968
	, "omega" : 969
	, "thetasym" : 977
	, "upsih" : 978
	, "piv" : 982
	, "ensp" : 8194
	, "emsp" : 8195
	, "thinsp" : 8201
	, "zwnj" : 8204
	, "zwj" : 8205
	, "lrm" : 8206
	, "rlm" : 8207
	, "ndash" : 8211
	, "mdash" : 8212
	, "lsquo" : 8216
	, "rsquo" : 8217
	, "sbquo" : 8218
	, "ldquo" : 8220
	, "rdquo" : 8221
	, "bdquo" : 8222
	, "dagger" : 8224
	, "Dagger" : 8225
	, "bull" : 8226
	, "hellip" : 8230
	, "permil" : 8240
	, "prime" : 8242
	, "Prime" : 8243
	, "lsaquo" : 8249
	, "rsaquo" : 8250
	, "oline" : 8254
	, "frasl" : 8260
	, "euro" : 8364
	, "image" : 8465
	, "weierp" : 8472
	, "real" : 8476
	, "trade" : 8482
	, "alefsym" : 8501
	, "larr" : 8592
	, "uarr" : 8593
	, "rarr" : 8594
	, "darr" : 8595
	, "harr" : 8596
	, "crarr" : 8629
	, "lArr" : 8656
	, "uArr" : 8657
	, "rArr" : 8658
	, "dArr" : 8659
	, "hArr" : 8660
	, "forall" : 8704
	, "part" : 8706
	, "exist" : 8707
	, "empty" : 8709
	, "nabla" : 8711
	, "isin" : 8712
	, "notin" : 8713
	, "ni" : 8715
	, "prod" : 8719
	, "sum" : 8721
	, "minus" : 8722
	, "lowast" : 8727
	, "radic" : 8730
	, "prop" : 8733
	, "infin" : 8734
	, "ang" : 8736
	, "and" : 8743
	, "or" : 8744
	, "cap" : 8745
	, "cup" : 8746
	, "int" : 8747
	, "there4" : 8756
	, "sim" : 8764
	, "cong" : 8773
	, "asymp" : 8776
	, "ne" : 8800
	, "equiv" : 8801
	, "le" : 8804
	, "ge" : 8805
	, "sub" : 8834
	, "sup" : 8835
	, "nsub" : 8836
	, "sube" : 8838
	, "supe" : 8839
	, "oplus" : 8853
	, "otimes" : 8855
	, "perp" : 8869
	, "sdot" : 8901
	, "lceil" : 8968
	, "rceil" : 8969
	, "lfloor" : 8970
	, "rfloor" : 8971
	, "lang" : 9001
	, "rang" : 9002
	, "loz" : 9674
	, "spades" : 9824
	, "clubs" : 9827
	, "hearts" : 9829
	, "diams" : 9830
	}
	
	Object.keys(sax.ENTITIES).forEach(function (key) {
	    var e = sax.ENTITIES[key]
	    var s = typeof e === 'number' ? String.fromCharCode(e) : e
	    sax.ENTITIES[key] = s
	})
	
	for (var S in sax.STATE) sax.STATE[sax.STATE[S]] = S
	
	// shorthand
	S = sax.STATE
	
	function emit (parser, event, data) {
	  parser[event] && parser[event](data)
	}
	
	function emitNode (parser, nodeType, data) {
	  if (parser.textNode) closeText(parser)
	  emit(parser, nodeType, data)
	}
	
	function closeText (parser) {
	  parser.textNode = textopts(parser.opt, parser.textNode)
	  if (parser.textNode) emit(parser, "ontext", parser.textNode)
	  parser.textNode = ""
	}
	
	function textopts (opt, text) {
	  if (opt.trim) text = text.trim()
	  if (opt.normalize) text = text.replace(/\s+/g, " ")
	  return text
	}
	
	function error (parser, er) {
	  closeText(parser)
	  if (parser.trackPosition) {
	    er += "\nLine: "+parser.line+
	          "\nColumn: "+parser.column+
	          "\nChar: "+parser.c
	  }
	  er = new Error(er)
	  parser.error = er
	  emit(parser, "onerror", er)
	  return parser
	}
	
	function end (parser) {
	  if (!parser.closedRoot) strictFail(parser, "Unclosed root tag")
	  if ((parser.state !== S.BEGIN) && (parser.state !== S.TEXT)) error(parser, "Unexpected end")
	  closeText(parser)
	  parser.c = ""
	  parser.closed = true
	  emit(parser, "onend")
	  SAXParser.call(parser, parser.strict, parser.opt)
	  return parser
	}
	
	function strictFail (parser, message) {
	  if (typeof parser !== 'object' || !(parser instanceof SAXParser))
	    throw new Error('bad call to strictFail');
	  if (parser.strict) error(parser, message)
	}
	
	function newTag (parser) {
	  if (!parser.strict) parser.tagName = parser.tagName[parser.looseCase]()
	  var parent = parser.tags[parser.tags.length - 1] || parser
	    , tag = parser.tag = { name : parser.tagName, attributes : {} }
	
	  // will be overridden if tag contails an xmlns="foo" or xmlns:foo="bar"
	  if (parser.opt.xmlns) tag.ns = parent.ns
	  parser.attribList.length = 0
	}
	
	function qname (name, attribute) {
	  var i = name.indexOf(":")
	    , qualName = i < 0 ? [ "", name ] : name.split(":")
	    , prefix = qualName[0]
	    , local = qualName[1]
	
	  // <x "xmlns"="http://foo">
	  if (attribute && name === "xmlns") {
	    prefix = "xmlns"
	    local = ""
	  }
	
	  return { prefix: prefix, local: local }
	}
	
	function attrib (parser) {
	  if (!parser.strict) parser.attribName = parser.attribName[parser.looseCase]()
	
	  if (parser.attribList.indexOf(parser.attribName) !== -1 ||
	      parser.tag.attributes.hasOwnProperty(parser.attribName)) {
	    return parser.attribName = parser.attribValue = ""
	  }
	
	  if (parser.opt.xmlns) {
	    var qn = qname(parser.attribName, true)
	      , prefix = qn.prefix
	      , local = qn.local
	
	    if (prefix === "xmlns") {
	      // namespace binding attribute; push the binding into scope
	      if (local === "xml" && parser.attribValue !== XML_NAMESPACE) {
	        strictFail( parser
	                  , "xml: prefix must be bound to " + XML_NAMESPACE + "\n"
	                  + "Actual: " + parser.attribValue )
	      } else if (local === "xmlns" && parser.attribValue !== XMLNS_NAMESPACE) {
	        strictFail( parser
	                  , "xmlns: prefix must be bound to " + XMLNS_NAMESPACE + "\n"
	                  + "Actual: " + parser.attribValue )
	      } else {
	        var tag = parser.tag
	          , parent = parser.tags[parser.tags.length - 1] || parser
	        if (tag.ns === parent.ns) {
	          tag.ns = Object.create(parent.ns)
	        }
	        tag.ns[local] = parser.attribValue
	      }
	    }
	
	    // defer onattribute events until all attributes have been seen
	    // so any new bindings can take effect; preserve attribute order
	    // so deferred events can be emitted in document order
	    parser.attribList.push([parser.attribName, parser.attribValue])
	  } else {
	    // in non-xmlns mode, we can emit the event right away
	    parser.tag.attributes[parser.attribName] = parser.attribValue
	    emitNode( parser
	            , "onattribute"
	            , { name: parser.attribName
	              , value: parser.attribValue } )
	  }
	
	  parser.attribName = parser.attribValue = ""
	}
	
	function openTag (parser, selfClosing) {
	  if (parser.opt.xmlns) {
	    // emit namespace binding events
	    var tag = parser.tag
	
	    // add namespace info to tag
	    var qn = qname(parser.tagName)
	    tag.prefix = qn.prefix
	    tag.local = qn.local
	    tag.uri = tag.ns[qn.prefix] || ""
	
	    if (tag.prefix && !tag.uri) {
	      strictFail(parser, "Unbound namespace prefix: "
	                       + JSON.stringify(parser.tagName))
	      tag.uri = qn.prefix
	    }
	
	    var parent = parser.tags[parser.tags.length - 1] || parser
	    if (tag.ns && parent.ns !== tag.ns) {
	      Object.keys(tag.ns).forEach(function (p) {
	        emitNode( parser
	                , "onopennamespace"
	                , { prefix: p , uri: tag.ns[p] } )
	      })
	    }
	
	    // handle deferred onattribute events
	    // Note: do not apply default ns to attributes:
	    //   http://www.w3.org/TR/REC-xml-names/#defaulting
	    for (var i = 0, l = parser.attribList.length; i < l; i ++) {
	      var nv = parser.attribList[i]
	      var name = nv[0]
	        , value = nv[1]
	        , qualName = qname(name, true)
	        , prefix = qualName.prefix
	        , local = qualName.local
	        , uri = prefix == "" ? "" : (tag.ns[prefix] || "")
	        , a = { name: name
	              , value: value
	              , prefix: prefix
	              , local: local
	              , uri: uri
	              }
	
	      // if there's any attributes with an undefined namespace,
	      // then fail on them now.
	      if (prefix && prefix != "xmlns" && !uri) {
	        strictFail(parser, "Unbound namespace prefix: "
	                         + JSON.stringify(prefix))
	        a.uri = prefix
	      }
	      parser.tag.attributes[name] = a
	      emitNode(parser, "onattribute", a)
	    }
	    parser.attribList.length = 0
	  }
	
	  parser.tag.isSelfClosing = !!selfClosing
	
	  // process the tag
	  parser.sawRoot = true
	  parser.tags.push(parser.tag)
	  emitNode(parser, "onopentag", parser.tag)
	  if (!selfClosing) {
	    // special case for <script> in non-strict mode.
	    if (!parser.noscript && parser.tagName.toLowerCase() === "script") {
	      parser.state = S.SCRIPT
	    } else {
	      parser.state = S.TEXT
	    }
	    parser.tag = null
	    parser.tagName = ""
	  }
	  parser.attribName = parser.attribValue = ""
	  parser.attribList.length = 0
	}
	
	function closeTag (parser) {
	  if (!parser.tagName) {
	    strictFail(parser, "Weird empty close tag.")
	    parser.textNode += "</>"
	    parser.state = S.TEXT
	    return
	  }
	
	  if (parser.script) {
	    if (parser.tagName !== "script") {
	      parser.script += "</" + parser.tagName + ">"
	      parser.tagName = ""
	      parser.state = S.SCRIPT
	      return
	    }
	    emitNode(parser, "onscript", parser.script)
	    parser.script = ""
	  }
	
	  // first make sure that the closing tag actually exists.
	  // <a><b></c></b></a> will close everything, otherwise.
	  var t = parser.tags.length
	  var tagName = parser.tagName
	  if (!parser.strict) tagName = tagName[parser.looseCase]()
	  var closeTo = tagName
	  while (t --) {
	    var close = parser.tags[t]
	    if (close.name !== closeTo) {
	      // fail the first time in strict mode
	      strictFail(parser, "Unexpected close tag")
	    } else break
	  }
	
	  // didn't find it.  we already failed for strict, so just abort.
	  if (t < 0) {
	    strictFail(parser, "Unmatched closing tag: "+parser.tagName)
	    parser.textNode += "</" + parser.tagName + ">"
	    parser.state = S.TEXT
	    return
	  }
	  parser.tagName = tagName
	  var s = parser.tags.length
	  while (s --> t) {
	    var tag = parser.tag = parser.tags.pop()
	    parser.tagName = parser.tag.name
	    emitNode(parser, "onclosetag", parser.tagName)
	
	    var x = {}
	    for (var i in tag.ns) x[i] = tag.ns[i]
	
	    var parent = parser.tags[parser.tags.length - 1] || parser
	    if (parser.opt.xmlns && tag.ns !== parent.ns) {
	      // remove namespace bindings introduced by tag
	      Object.keys(tag.ns).forEach(function (p) {
	        var n = tag.ns[p]
	        emitNode(parser, "onclosenamespace", { prefix: p, uri: n })
	      })
	    }
	  }
	  if (t === 0) parser.closedRoot = true
	  parser.tagName = parser.attribValue = parser.attribName = ""
	  parser.attribList.length = 0
	  parser.state = S.TEXT
	}
	
	function parseEntity (parser) {
	  var entity = parser.entity
	    , entityLC = entity.toLowerCase()
	    , num
	    , numStr = ""
	  if (parser.ENTITIES[entity])
	    return parser.ENTITIES[entity]
	  if (parser.ENTITIES[entityLC])
	    return parser.ENTITIES[entityLC]
	  entity = entityLC
	  if (entity.charAt(0) === "#") {
	    if (entity.charAt(1) === "x") {
	      entity = entity.slice(2)
	      num = parseInt(entity, 16)
	      numStr = num.toString(16)
	    } else {
	      entity = entity.slice(1)
	      num = parseInt(entity, 10)
	      numStr = num.toString(10)
	    }
	  }
	  entity = entity.replace(/^0+/, "")
	  if (numStr.toLowerCase() !== entity) {
	    strictFail(parser, "Invalid character entity")
	    return "&"+parser.entity + ";"
	  }
	  return String.fromCharCode(num)
	}
	
	function write (chunk) {
	  var parser = this
	  if (this.error) throw this.error
	  if (parser.closed) return error(parser,
	    "Cannot write after close. Assign an onready handler.")
	  if (chunk === null) return end(parser)
	  var i = 0, c = ""
	  while (parser.c = c = chunk.charAt(i++)) {
	    if (parser.trackPosition) {
	      parser.position ++
	      if (c === "\n") {
	        parser.line ++
	        parser.column = 0
	      } else parser.column ++
	    }
	    switch (parser.state) {
	
	      case S.BEGIN:
	        if (c === "<") {
	          parser.state = S.OPEN_WAKA
	          parser.startTagPosition = parser.position
	        } else if (not(whitespace,c)) {
	          // have to process this as a text node.
	          // weird, but happens.
	          strictFail(parser, "Non-whitespace before first tag.")
	          parser.textNode = c
	          parser.state = S.TEXT
	        }
	      continue
	
	      case S.TEXT:
	        if (parser.sawRoot && !parser.closedRoot) {
	          var starti = i-1
	          while (c && c!=="<" && c!=="&") {
	            c = chunk.charAt(i++)
	            if (c && parser.trackPosition) {
	              parser.position ++
	              if (c === "\n") {
	                parser.line ++
	                parser.column = 0
	              } else parser.column ++
	            }
	          }
	          parser.textNode += chunk.substring(starti, i-1)
	        }
	        if (c === "<") {
	          parser.state = S.OPEN_WAKA
	          parser.startTagPosition = parser.position
	        } else {
	          if (not(whitespace, c) && (!parser.sawRoot || parser.closedRoot))
	            strictFail(parser, "Text data outside of root node.")
	          if (c === "&") parser.state = S.TEXT_ENTITY
	          else parser.textNode += c
	        }
	      continue
	
	      case S.SCRIPT:
	        // only non-strict
	        if (c === "<") {
	          parser.state = S.SCRIPT_ENDING
	        } else parser.script += c
	      continue
	
	      case S.SCRIPT_ENDING:
	        if (c === "/") {
	          parser.state = S.CLOSE_TAG
	        } else {
	          parser.script += "<" + c
	          parser.state = S.SCRIPT
	        }
	      continue
	
	      case S.OPEN_WAKA:
	        // either a /, ?, !, or text is coming next.
	        if (c === "!") {
	          parser.state = S.SGML_DECL
	          parser.sgmlDecl = ""
	        } else if (is(whitespace, c)) {
	          // wait for it...
	        } else if (is(nameStart,c)) {
	          parser.state = S.OPEN_TAG
	          parser.tagName = c
	        } else if (c === "/") {
	          parser.state = S.CLOSE_TAG
	          parser.tagName = ""
	        } else if (c === "?") {
	          parser.state = S.PROC_INST
	          parser.procInstName = parser.procInstBody = ""
	        } else {
	          strictFail(parser, "Unencoded <")
	          // if there was some whitespace, then add that in.
	          if (parser.startTagPosition + 1 < parser.position) {
	            var pad = parser.position - parser.startTagPosition
	            c = new Array(pad).join(" ") + c
	          }
	          parser.textNode += "<" + c
	          parser.state = S.TEXT
	        }
	      continue
	
	      case S.SGML_DECL:
	        if ((parser.sgmlDecl+c).toUpperCase() === CDATA) {
	          emitNode(parser, "onopencdata")
	          parser.state = S.CDATA
	          parser.sgmlDecl = ""
	          parser.cdata = ""
	        } else if (parser.sgmlDecl+c === "--") {
	          parser.state = S.COMMENT
	          parser.comment = ""
	          parser.sgmlDecl = ""
	        } else if ((parser.sgmlDecl+c).toUpperCase() === DOCTYPE) {
	          parser.state = S.DOCTYPE
	          if (parser.doctype || parser.sawRoot) strictFail(parser,
	            "Inappropriately located doctype declaration")
	          parser.doctype = ""
	          parser.sgmlDecl = ""
	        } else if (c === ">") {
	          emitNode(parser, "onsgmldeclaration", parser.sgmlDecl)
	          parser.sgmlDecl = ""
	          parser.state = S.TEXT
	        } else if (is(quote, c)) {
	          parser.state = S.SGML_DECL_QUOTED
	          parser.sgmlDecl += c
	        } else parser.sgmlDecl += c
	      continue
	
	      case S.SGML_DECL_QUOTED:
	        if (c === parser.q) {
	          parser.state = S.SGML_DECL
	          parser.q = ""
	        }
	        parser.sgmlDecl += c
	      continue
	
	      case S.DOCTYPE:
	        if (c === ">") {
	          parser.state = S.TEXT
	          emitNode(parser, "ondoctype", parser.doctype)
	          parser.doctype = true // just remember that we saw it.
	        } else {
	          parser.doctype += c
	          if (c === "[") parser.state = S.DOCTYPE_DTD
	          else if (is(quote, c)) {
	            parser.state = S.DOCTYPE_QUOTED
	            parser.q = c
	          }
	        }
	      continue
	
	      case S.DOCTYPE_QUOTED:
	        parser.doctype += c
	        if (c === parser.q) {
	          parser.q = ""
	          parser.state = S.DOCTYPE
	        }
	      continue
	
	      case S.DOCTYPE_DTD:
	        parser.doctype += c
	        if (c === "]") parser.state = S.DOCTYPE
	        else if (is(quote,c)) {
	          parser.state = S.DOCTYPE_DTD_QUOTED
	          parser.q = c
	        }
	      continue
	
	      case S.DOCTYPE_DTD_QUOTED:
	        parser.doctype += c
	        if (c === parser.q) {
	          parser.state = S.DOCTYPE_DTD
	          parser.q = ""
	        }
	      continue
	
	      case S.COMMENT:
	        if (c === "-") parser.state = S.COMMENT_ENDING
	        else parser.comment += c
	      continue
	
	      case S.COMMENT_ENDING:
	        if (c === "-") {
	          parser.state = S.COMMENT_ENDED
	          parser.comment = textopts(parser.opt, parser.comment)
	          if (parser.comment) emitNode(parser, "oncomment", parser.comment)
	          parser.comment = ""
	        } else {
	          parser.comment += "-" + c
	          parser.state = S.COMMENT
	        }
	      continue
	
	      case S.COMMENT_ENDED:
	        if (c !== ">") {
	          strictFail(parser, "Malformed comment")
	          // allow <!-- blah -- bloo --> in non-strict mode,
	          // which is a comment of " blah -- bloo "
	          parser.comment += "--" + c
	          parser.state = S.COMMENT
	        } else parser.state = S.TEXT
	      continue
	
	      case S.CDATA:
	        if (c === "]") parser.state = S.CDATA_ENDING
	        else parser.cdata += c
	      continue
	
	      case S.CDATA_ENDING:
	        if (c === "]") parser.state = S.CDATA_ENDING_2
	        else {
	          parser.cdata += "]" + c
	          parser.state = S.CDATA
	        }
	      continue
	
	      case S.CDATA_ENDING_2:
	        if (c === ">") {
	          if (parser.cdata) emitNode(parser, "oncdata", parser.cdata)
	          emitNode(parser, "onclosecdata")
	          parser.cdata = ""
	          parser.state = S.TEXT
	        } else if (c === "]") {
	          parser.cdata += "]"
	        } else {
	          parser.cdata += "]]" + c
	          parser.state = S.CDATA
	        }
	      continue
	
	      case S.PROC_INST:
	        if (c === "?") parser.state = S.PROC_INST_ENDING
	        else if (is(whitespace, c)) parser.state = S.PROC_INST_BODY
	        else parser.procInstName += c
	      continue
	
	      case S.PROC_INST_BODY:
	        if (!parser.procInstBody && is(whitespace, c)) continue
	        else if (c === "?") parser.state = S.PROC_INST_ENDING
	        else parser.procInstBody += c
	      continue
	
	      case S.PROC_INST_ENDING:
	        if (c === ">") {
	          emitNode(parser, "onprocessinginstruction", {
	            name : parser.procInstName,
	            body : parser.procInstBody
	          })
	          parser.procInstName = parser.procInstBody = ""
	          parser.state = S.TEXT
	        } else {
	          parser.procInstBody += "?" + c
	          parser.state = S.PROC_INST_BODY
	        }
	      continue
	
	      case S.OPEN_TAG:
	        if (is(nameBody, c)) parser.tagName += c
	        else {
	          newTag(parser)
	          if (c === ">") openTag(parser)
	          else if (c === "/") parser.state = S.OPEN_TAG_SLASH
	          else {
	            if (not(whitespace, c)) strictFail(
	              parser, "Invalid character in tag name")
	            parser.state = S.ATTRIB
	          }
	        }
	      continue
	
	      case S.OPEN_TAG_SLASH:
	        if (c === ">") {
	          openTag(parser, true)
	          closeTag(parser)
	        } else {
	          strictFail(parser, "Forward-slash in opening tag not followed by >")
	          parser.state = S.ATTRIB
	        }
	      continue
	
	      case S.ATTRIB:
	        // haven't read the attribute name yet.
	        if (is(whitespace, c)) continue
	        else if (c === ">") openTag(parser)
	        else if (c === "/") parser.state = S.OPEN_TAG_SLASH
	        else if (is(nameStart, c)) {
	          parser.attribName = c
	          parser.attribValue = ""
	          parser.state = S.ATTRIB_NAME
	        } else strictFail(parser, "Invalid attribute name")
	      continue
	
	      case S.ATTRIB_NAME:
	        if (c === "=") parser.state = S.ATTRIB_VALUE
	        else if (c === ">") {
	          strictFail(parser, "Attribute without value")
	          parser.attribValue = parser.attribName
	          attrib(parser)
	          openTag(parser)
	        }
	        else if (is(whitespace, c)) parser.state = S.ATTRIB_NAME_SAW_WHITE
	        else if (is(nameBody, c)) parser.attribName += c
	        else strictFail(parser, "Invalid attribute name")
	      continue
	
	      case S.ATTRIB_NAME_SAW_WHITE:
	        if (c === "=") parser.state = S.ATTRIB_VALUE
	        else if (is(whitespace, c)) continue
	        else {
	          strictFail(parser, "Attribute without value")
	          parser.tag.attributes[parser.attribName] = ""
	          parser.attribValue = ""
	          emitNode(parser, "onattribute",
	                   { name : parser.attribName, value : "" })
	          parser.attribName = ""
	          if (c === ">") openTag(parser)
	          else if (is(nameStart, c)) {
	            parser.attribName = c
	            parser.state = S.ATTRIB_NAME
	          } else {
	            strictFail(parser, "Invalid attribute name")
	            parser.state = S.ATTRIB
	          }
	        }
	      continue
	
	      case S.ATTRIB_VALUE:
	        if (is(whitespace, c)) continue
	        else if (is(quote, c)) {
	          parser.q = c
	          parser.state = S.ATTRIB_VALUE_QUOTED
	        } else {
	          strictFail(parser, "Unquoted attribute value")
	          parser.state = S.ATTRIB_VALUE_UNQUOTED
	          parser.attribValue = c
	        }
	      continue
	
	      case S.ATTRIB_VALUE_QUOTED:
	        if (c !== parser.q) {
	          if (c === "&") parser.state = S.ATTRIB_VALUE_ENTITY_Q
	          else parser.attribValue += c
	          continue
	        }
	        attrib(parser)
	        parser.q = ""
	        parser.state = S.ATTRIB_VALUE_CLOSED
	      continue
	
	      case S.ATTRIB_VALUE_CLOSED:
	        if (is(whitespace, c)) {
	          parser.state = S.ATTRIB
	        } else if (c === ">") openTag(parser)
	        else if (c === "/") parser.state = S.OPEN_TAG_SLASH
	        else if (is(nameStart, c)) {
	          strictFail(parser, "No whitespace between attributes")
	          parser.attribName = c
	          parser.attribValue = ""
	          parser.state = S.ATTRIB_NAME
	        } else strictFail(parser, "Invalid attribute name")
	      continue
	
	      case S.ATTRIB_VALUE_UNQUOTED:
	        if (not(attribEnd,c)) {
	          if (c === "&") parser.state = S.ATTRIB_VALUE_ENTITY_U
	          else parser.attribValue += c
	          continue
	        }
	        attrib(parser)
	        if (c === ">") openTag(parser)
	        else parser.state = S.ATTRIB
	      continue
	
	      case S.CLOSE_TAG:
	        if (!parser.tagName) {
	          if (is(whitespace, c)) continue
	          else if (not(nameStart, c)) {
	            if (parser.script) {
	              parser.script += "</" + c
	              parser.state = S.SCRIPT
	            } else {
	              strictFail(parser, "Invalid tagname in closing tag.")
	            }
	          } else parser.tagName = c
	        }
	        else if (c === ">") closeTag(parser)
	        else if (is(nameBody, c)) parser.tagName += c
	        else if (parser.script) {
	          parser.script += "</" + parser.tagName
	          parser.tagName = ""
	          parser.state = S.SCRIPT
	        } else {
	          if (not(whitespace, c)) strictFail(parser,
	            "Invalid tagname in closing tag")
	          parser.state = S.CLOSE_TAG_SAW_WHITE
	        }
	      continue
	
	      case S.CLOSE_TAG_SAW_WHITE:
	        if (is(whitespace, c)) continue
	        if (c === ">") closeTag(parser)
	        else strictFail(parser, "Invalid characters in closing tag")
	      continue
	
	      case S.TEXT_ENTITY:
	      case S.ATTRIB_VALUE_ENTITY_Q:
	      case S.ATTRIB_VALUE_ENTITY_U:
	        switch(parser.state) {
	          case S.TEXT_ENTITY:
	            var returnState = S.TEXT, buffer = "textNode"
	          break
	
	          case S.ATTRIB_VALUE_ENTITY_Q:
	            var returnState = S.ATTRIB_VALUE_QUOTED, buffer = "attribValue"
	          break
	
	          case S.ATTRIB_VALUE_ENTITY_U:
	            var returnState = S.ATTRIB_VALUE_UNQUOTED, buffer = "attribValue"
	          break
	        }
	        if (c === ";") {
	          parser[buffer] += parseEntity(parser)
	          parser.entity = ""
	          parser.state = returnState
	        }
	        else if (is(entity, c)) parser.entity += c
	        else {
	          strictFail(parser, "Invalid character entity")
	          parser[buffer] += "&" + parser.entity + c
	          parser.entity = ""
	          parser.state = returnState
	        }
	      continue
	
	      default:
	        throw new Error(parser, "Unknown state: " + parser.state)
	    }
	  } // while
	  // cdata blocks can get very big under normal conditions. emit and move on.
	  // if (parser.state === S.CDATA && parser.cdata) {
	  //   emitNode(parser, "oncdata", parser.cdata)
	  //   parser.cdata = ""
	  // }
	  if (parser.position >= parser.bufferCheckPosition) checkBufferLength(parser)
	  return parser
	}
	
	})( false ? sax = {} : exports)
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(10)))

/***/ },
/* 512 */
/***/ function(module, exports) {

	module.exports = function (Buffer) {
	
	  //prototype class for hash functions
	  function Hash (blockSize, finalSize) {
	    this._block = new Buffer(blockSize) //new Uint32Array(blockSize/4)
	    this._finalSize = finalSize
	    this._blockSize = blockSize
	    this._len = 0
	    this._s = 0
	  }
	
	  Hash.prototype.init = function () {
	    this._s = 0
	    this._len = 0
	  }
	
	  Hash.prototype.update = function (data, enc) {
	    if ("string" === typeof data) {
	      enc = enc || "utf8"
	      data = new Buffer(data, enc)
	    }
	
	    var l = this._len += data.length
	    var s = this._s = (this._s || 0)
	    var f = 0
	    var buffer = this._block
	
	    while (s < l) {
	      var t = Math.min(data.length, f + this._blockSize - (s % this._blockSize))
	      var ch = (t - f)
	
	      for (var i = 0; i < ch; i++) {
	        buffer[(s % this._blockSize) + i] = data[i + f]
	      }
	
	      s += ch
	      f += ch
	
	      if ((s % this._blockSize) === 0) {
	        this._update(buffer)
	      }
	    }
	    this._s = s
	
	    return this
	  }
	
	  Hash.prototype.digest = function (enc) {
	    // Suppose the length of the message M, in bits, is l
	    var l = this._len * 8
	
	    // Append the bit 1 to the end of the message
	    this._block[this._len % this._blockSize] = 0x80
	
	    // and then k zero bits, where k is the smallest non-negative solution to the equation (l + 1 + k) === finalSize mod blockSize
	    this._block.fill(0, this._len % this._blockSize + 1)
	
	    if (l % (this._blockSize * 8) >= this._finalSize * 8) {
	      this._update(this._block)
	      this._block.fill(0)
	    }
	
	    // to this append the block which is equal to the number l written in binary
	    // TODO: handle case where l is > Math.pow(2, 29)
	    this._block.writeInt32BE(l, this._blockSize - 4)
	
	    var hash = this._update(this._block) || this._hash()
	
	    return enc ? hash.toString(enc) : hash
	  }
	
	  Hash.prototype._update = function () {
	    throw new Error('_update must be implemented by subclass')
	  }
	
	  return Hash
	}


/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	var exports = module.exports = function (alg) {
	  var Alg = exports[alg]
	  if(!Alg) throw new Error(alg + ' is not supported (we accept pull requests)')
	  return new Alg()
	}
	
	var Buffer = __webpack_require__(2).Buffer
	var Hash   = __webpack_require__(512)(Buffer)
	
	exports.sha1 = __webpack_require__(514)(Buffer, Hash)
	exports.sha256 = __webpack_require__(515)(Buffer, Hash)
	exports.sha512 = __webpack_require__(516)(Buffer, Hash)


/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
	 * in FIPS PUB 180-1
	 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for details.
	 */
	
	var inherits = __webpack_require__(4).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var A = 0|0
	  var B = 4|0
	  var C = 8|0
	  var D = 12|0
	  var E = 16|0
	
	  var W = new (typeof Int32Array === 'undefined' ? Array : Int32Array)(80)
	
	  var POOL = []
	
	  function Sha1 () {
	    if(POOL.length)
	      return POOL.pop().init()
	
	    if(!(this instanceof Sha1)) return new Sha1()
	    this._w = W
	    Hash.call(this, 16*4, 14*4)
	
	    this._h = null
	    this.init()
	  }
	
	  inherits(Sha1, Hash)
	
	  Sha1.prototype.init = function () {
	    this._a = 0x67452301
	    this._b = 0xefcdab89
	    this._c = 0x98badcfe
	    this._d = 0x10325476
	    this._e = 0xc3d2e1f0
	
	    Hash.prototype.init.call(this)
	    return this
	  }
	
	  Sha1.prototype._POOL = POOL
	  Sha1.prototype._update = function (X) {
	
	    var a, b, c, d, e, _a, _b, _c, _d, _e
	
	    a = _a = this._a
	    b = _b = this._b
	    c = _c = this._c
	    d = _d = this._d
	    e = _e = this._e
	
	    var w = this._w
	
	    for(var j = 0; j < 80; j++) {
	      var W = w[j] = j < 16 ? X.readInt32BE(j*4)
	        : rol(w[j - 3] ^ w[j -  8] ^ w[j - 14] ^ w[j - 16], 1)
	
	      var t = add(
	        add(rol(a, 5), sha1_ft(j, b, c, d)),
	        add(add(e, W), sha1_kt(j))
	      )
	
	      e = d
	      d = c
	      c = rol(b, 30)
	      b = a
	      a = t
	    }
	
	    this._a = add(a, _a)
	    this._b = add(b, _b)
	    this._c = add(c, _c)
	    this._d = add(d, _d)
	    this._e = add(e, _e)
	  }
	
	  Sha1.prototype._hash = function () {
	    if(POOL.length < 100) POOL.push(this)
	    var H = new Buffer(20)
	    //console.log(this._a|0, this._b|0, this._c|0, this._d|0, this._e|0)
	    H.writeInt32BE(this._a|0, A)
	    H.writeInt32BE(this._b|0, B)
	    H.writeInt32BE(this._c|0, C)
	    H.writeInt32BE(this._d|0, D)
	    H.writeInt32BE(this._e|0, E)
	    return H
	  }
	
	  /*
	   * Perform the appropriate triplet combination function for the current
	   * iteration
	   */
	  function sha1_ft(t, b, c, d) {
	    if(t < 20) return (b & c) | ((~b) & d);
	    if(t < 40) return b ^ c ^ d;
	    if(t < 60) return (b & c) | (b & d) | (c & d);
	    return b ^ c ^ d;
	  }
	
	  /*
	   * Determine the appropriate additive constant for the current iteration
	   */
	  function sha1_kt(t) {
	    return (t < 20) ?  1518500249 : (t < 40) ?  1859775393 :
	           (t < 60) ? -1894007588 : -899497514;
	  }
	
	  /*
	   * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	   * to work around bugs in some JS interpreters.
	   * //dominictarr: this is 10 years old, so maybe this can be dropped?)
	   *
	   */
	  function add(x, y) {
	    return (x + y ) | 0
	  //lets see how this goes on testling.
	  //  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  //  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  //  return (msw << 16) | (lsw & 0xFFFF);
	  }
	
	  /*
	   * Bitwise rotate a 32-bit number to the left.
	   */
	  function rol(num, cnt) {
	    return (num << cnt) | (num >>> (32 - cnt));
	  }
	
	  return Sha1
	}


/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */
	
	var inherits = __webpack_require__(4).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var K = [
	      0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
	      0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
	      0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
	      0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
	      0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
	      0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
	      0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
	      0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
	      0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
	      0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
	      0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
	      0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
	      0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
	      0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
	      0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
	      0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
	    ]
	
	  var W = new Array(64)
	
	  function Sha256() {
	    this.init()
	
	    this._w = W //new Array(64)
	
	    Hash.call(this, 16*4, 14*4)
	  }
	
	  inherits(Sha256, Hash)
	
	  Sha256.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, n) {
	    return (X >>> n) | (X << (32 - n));
	  }
	
	  function R (X, n) {
	    return (X >>> n);
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  function Sigma0256 (x) {
	    return (S(x, 2) ^ S(x, 13) ^ S(x, 22));
	  }
	
	  function Sigma1256 (x) {
	    return (S(x, 6) ^ S(x, 11) ^ S(x, 25));
	  }
	
	  function Gamma0256 (x) {
	    return (S(x, 7) ^ S(x, 18) ^ R(x, 3));
	  }
	
	  function Gamma1256 (x) {
	    return (S(x, 17) ^ S(x, 19) ^ R(x, 10));
	  }
	
	  Sha256.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var T1, T2
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    for (var j = 0; j < 64; j++) {
	      var w = W[j] = j < 16
	        ? M.readInt32BE(j * 4)
	        : Gamma1256(W[j - 2]) + W[j - 7] + Gamma0256(W[j - 15]) + W[j - 16]
	
	      T1 = h + Sigma1256(e) + Ch(e, f, g) + K[j] + w
	
	      T2 = Sigma0256(a) + Maj(a, b, c);
	      h = g; g = f; f = e; e = d + T1; d = c; c = b; b = a; a = T1 + T2;
	    }
	
	    this._a = (a + this._a) | 0
	    this._b = (b + this._b) | 0
	    this._c = (c + this._c) | 0
	    this._d = (d + this._d) | 0
	    this._e = (e + this._e) | 0
	    this._f = (f + this._f) | 0
	    this._g = (g + this._g) | 0
	    this._h = (h + this._h) | 0
	
	  };
	
	  Sha256.prototype._hash = function () {
	    var H = new Buffer(32)
	
	    H.writeInt32BE(this._a,  0)
	    H.writeInt32BE(this._b,  4)
	    H.writeInt32BE(this._c,  8)
	    H.writeInt32BE(this._d, 12)
	    H.writeInt32BE(this._e, 16)
	    H.writeInt32BE(this._f, 20)
	    H.writeInt32BE(this._g, 24)
	    H.writeInt32BE(this._h, 28)
	
	    return H
	  }
	
	  return Sha256
	
	}


/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__(4).inherits
	
	module.exports = function (Buffer, Hash) {
	  var K = [
	    0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
	    0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
	    0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
	    0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
	    0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
	    0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
	    0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
	    0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
	    0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
	    0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
	    0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
	    0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
	    0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
	    0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
	    0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
	    0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
	    0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
	    0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
	    0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
	    0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
	    0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
	    0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
	    0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
	    0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
	    0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
	    0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
	    0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
	    0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
	    0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
	    0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
	    0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
	    0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
	    0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
	    0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
	    0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
	    0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
	    0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
	    0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
	    0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
	    0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
	  ]
	
	  var W = new Array(160)
	
	  function Sha512() {
	    this.init()
	    this._w = W
	
	    Hash.call(this, 128, 112)
	  }
	
	  inherits(Sha512, Hash)
	
	  Sha512.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._al = 0xf3bcc908|0
	    this._bl = 0x84caa73b|0
	    this._cl = 0xfe94f82b|0
	    this._dl = 0x5f1d36f1|0
	    this._el = 0xade682d1|0
	    this._fl = 0x2b3e6c1f|0
	    this._gl = 0xfb41bd6b|0
	    this._hl = 0x137e2179|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, Xl, n) {
	    return (X >>> n) | (Xl << (32 - n))
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  Sha512.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var al, bl, cl, dl, el, fl, gl, hl
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    al = this._al | 0
	    bl = this._bl | 0
	    cl = this._cl | 0
	    dl = this._dl | 0
	    el = this._el | 0
	    fl = this._fl | 0
	    gl = this._gl | 0
	    hl = this._hl | 0
	
	    for (var i = 0; i < 80; i++) {
	      var j = i * 2
	
	      var Wi, Wil
	
	      if (i < 16) {
	        Wi = W[j] = M.readInt32BE(j * 4)
	        Wil = W[j + 1] = M.readInt32BE(j * 4 + 4)
	
	      } else {
	        var x  = W[j - 15*2]
	        var xl = W[j - 15*2 + 1]
	        var gamma0  = S(x, xl, 1) ^ S(x, xl, 8) ^ (x >>> 7)
	        var gamma0l = S(xl, x, 1) ^ S(xl, x, 8) ^ S(xl, x, 7)
	
	        x  = W[j - 2*2]
	        xl = W[j - 2*2 + 1]
	        var gamma1  = S(x, xl, 19) ^ S(xl, x, 29) ^ (x >>> 6)
	        var gamma1l = S(xl, x, 19) ^ S(x, xl, 29) ^ S(xl, x, 6)
	
	        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	        var Wi7  = W[j - 7*2]
	        var Wi7l = W[j - 7*2 + 1]
	
	        var Wi16  = W[j - 16*2]
	        var Wi16l = W[j - 16*2 + 1]
	
	        Wil = gamma0l + Wi7l
	        Wi  = gamma0  + Wi7 + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0)
	        Wil = Wil + gamma1l
	        Wi  = Wi  + gamma1  + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0)
	        Wil = Wil + Wi16l
	        Wi  = Wi  + Wi16 + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0)
	
	        W[j] = Wi
	        W[j + 1] = Wil
	      }
	
	      var maj = Maj(a, b, c)
	      var majl = Maj(al, bl, cl)
	
	      var sigma0h = S(a, al, 28) ^ S(al, a, 2) ^ S(al, a, 7)
	      var sigma0l = S(al, a, 28) ^ S(a, al, 2) ^ S(a, al, 7)
	      var sigma1h = S(e, el, 14) ^ S(e, el, 18) ^ S(el, e, 9)
	      var sigma1l = S(el, e, 14) ^ S(el, e, 18) ^ S(e, el, 9)
	
	      // t1 = h + sigma1 + ch + K[i] + W[i]
	      var Ki = K[j]
	      var Kil = K[j + 1]
	
	      var ch = Ch(e, f, g)
	      var chl = Ch(el, fl, gl)
	
	      var t1l = hl + sigma1l
	      var t1 = h + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0)
	      t1l = t1l + chl
	      t1 = t1 + ch + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0)
	      t1l = t1l + Kil
	      t1 = t1 + Ki + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0)
	      t1l = t1l + Wil
	      t1 = t1 + Wi + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0)
	
	      // t2 = sigma0 + maj
	      var t2l = sigma0l + majl
	      var t2 = sigma0h + maj + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0)
	
	      h  = g
	      hl = gl
	      g  = f
	      gl = fl
	      f  = e
	      fl = el
	      el = (dl + t1l) | 0
	      e  = (d + t1 + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	      d  = c
	      dl = cl
	      c  = b
	      cl = bl
	      b  = a
	      bl = al
	      al = (t1l + t2l) | 0
	      a  = (t1 + t2 + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0
	    }
	
	    this._al = (this._al + al) | 0
	    this._bl = (this._bl + bl) | 0
	    this._cl = (this._cl + cl) | 0
	    this._dl = (this._dl + dl) | 0
	    this._el = (this._el + el) | 0
	    this._fl = (this._fl + fl) | 0
	    this._gl = (this._gl + gl) | 0
	    this._hl = (this._hl + hl) | 0
	
	    this._a = (this._a + a + ((this._al >>> 0) < (al >>> 0) ? 1 : 0)) | 0
	    this._b = (this._b + b + ((this._bl >>> 0) < (bl >>> 0) ? 1 : 0)) | 0
	    this._c = (this._c + c + ((this._cl >>> 0) < (cl >>> 0) ? 1 : 0)) | 0
	    this._d = (this._d + d + ((this._dl >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	    this._e = (this._e + e + ((this._el >>> 0) < (el >>> 0) ? 1 : 0)) | 0
	    this._f = (this._f + f + ((this._fl >>> 0) < (fl >>> 0) ? 1 : 0)) | 0
	    this._g = (this._g + g + ((this._gl >>> 0) < (gl >>> 0) ? 1 : 0)) | 0
	    this._h = (this._h + h + ((this._hl >>> 0) < (hl >>> 0) ? 1 : 0)) | 0
	  }
	
	  Sha512.prototype._hash = function () {
	    var H = new Buffer(64)
	
	    function writeInt64BE(h, l, offset) {
	      H.writeInt32BE(h, offset)
	      H.writeInt32BE(l, offset + 4)
	    }
	
	    writeInt64BE(this._a, this._al, 0)
	    writeInt64BE(this._b, this._bl, 8)
	    writeInt64BE(this._c, this._cl, 16)
	    writeInt64BE(this._d, this._dl, 24)
	    writeInt64BE(this._e, this._el, 32)
	    writeInt64BE(this._f, this._fl, 40)
	    writeInt64BE(this._g, this._gl, 48)
	    writeInt64BE(this._h, this._hl, 56)
	
	    return H
	  }
	
	  return Sha512
	
	}


/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, global, process) {var capability = __webpack_require__(204)
	var inherits = __webpack_require__(13)
	var response = __webpack_require__(205)
	var stream = __webpack_require__(211)
	var toArrayBuffer = __webpack_require__(522)
	
	var IncomingMessage = response.IncomingMessage
	var rStates = response.readyStates
	
	function decideMode (preferBinary, useFetch) {
		if (capability.fetch && useFetch) {
			return 'fetch'
		} else if (capability.mozchunkedarraybuffer) {
			return 'moz-chunked-arraybuffer'
		} else if (capability.msstream) {
			return 'ms-stream'
		} else if (capability.arraybuffer && preferBinary) {
			return 'arraybuffer'
		} else if (capability.vbArray && preferBinary) {
			return 'text:vbarray'
		} else {
			return 'text'
		}
	}
	
	var ClientRequest = module.exports = function (opts) {
		var self = this
		stream.Writable.call(self)
	
		self._opts = opts
		self._body = []
		self._headers = {}
		if (opts.auth)
			self.setHeader('Authorization', 'Basic ' + new Buffer(opts.auth).toString('base64'))
		Object.keys(opts.headers).forEach(function (name) {
			self.setHeader(name, opts.headers[name])
		})
	
		var preferBinary
		var useFetch = true
		if (opts.mode === 'disable-fetch' || ('requestTimeout' in opts && !capability.abortController)) {
			// If the use of XHR should be preferred. Not typically needed.
			useFetch = false
			preferBinary = true
		} else if (opts.mode === 'prefer-streaming') {
			// If streaming is a high priority but binary compatibility and
			// the accuracy of the 'content-type' header aren't
			preferBinary = false
		} else if (opts.mode === 'allow-wrong-content-type') {
			// If streaming is more important than preserving the 'content-type' header
			preferBinary = !capability.overrideMimeType
		} else if (!opts.mode || opts.mode === 'default' || opts.mode === 'prefer-fast') {
			// Use binary if text streaming may corrupt data or the content-type header, or for speed
			preferBinary = true
		} else {
			throw new Error('Invalid value for opts.mode')
		}
		self._mode = decideMode(preferBinary, useFetch)
	
		self.on('finish', function () {
			self._onFinish()
		})
	}
	
	inherits(ClientRequest, stream.Writable)
	
	ClientRequest.prototype.setHeader = function (name, value) {
		var self = this
		var lowerName = name.toLowerCase()
		// This check is not necessary, but it prevents warnings from browsers about setting unsafe
		// headers. To be honest I'm not entirely sure hiding these warnings is a good thing, but
		// http-browserify did it, so I will too.
		if (unsafeHeaders.indexOf(lowerName) !== -1)
			return
	
		self._headers[lowerName] = {
			name: name,
			value: value
		}
	}
	
	ClientRequest.prototype.getHeader = function (name) {
		var header = this._headers[name.toLowerCase()]
		if (header)
			return header.value
		return null
	}
	
	ClientRequest.prototype.removeHeader = function (name) {
		var self = this
		delete self._headers[name.toLowerCase()]
	}
	
	ClientRequest.prototype._onFinish = function () {
		var self = this
	
		if (self._destroyed)
			return
		var opts = self._opts
	
		var headersObj = self._headers
		var body = null
		if (opts.method !== 'GET' && opts.method !== 'HEAD') {
			if (capability.arraybuffer) {
				body = toArrayBuffer(Buffer.concat(self._body))
			} else if (capability.blobConstructor) {
				body = new global.Blob(self._body.map(function (buffer) {
					return toArrayBuffer(buffer)
				}), {
					type: (headersObj['content-type'] || {}).value || ''
				})
			} else {
				// get utf8 string
				body = Buffer.concat(self._body).toString()
			}
		}
	
		// create flattened list of headers
		var headersList = []
		Object.keys(headersObj).forEach(function (keyName) {
			var name = headersObj[keyName].name
			var value = headersObj[keyName].value
			if (Array.isArray(value)) {
				value.forEach(function (v) {
					headersList.push([name, v])
				})
			} else {
				headersList.push([name, value])
			}
		})
	
		if (self._mode === 'fetch') {
			var signal = null
			if (capability.abortController) {
				var controller = new AbortController()
				signal = controller.signal
				self._fetchAbortController = controller
	
				if ('requestTimeout' in opts && opts.requestTimeout !== 0) {
					global.setTimeout(function () {
						self.emit('requestTimeout')
						if (self._fetchAbortController)
							self._fetchAbortController.abort()
					}, opts.requestTimeout)
				}
			}
	
			global.fetch(self._opts.url, {
				method: self._opts.method,
				headers: headersList,
				body: body || undefined,
				mode: 'cors',
				credentials: opts.withCredentials ? 'include' : 'same-origin',
				signal: signal
			}).then(function (response) {
				self._fetchResponse = response
				self._connect()
			}, function (reason) {
				self.emit('error', reason)
			})
		} else {
			var xhr = self._xhr = new global.XMLHttpRequest()
			try {
				xhr.open(self._opts.method, self._opts.url, true)
			} catch (err) {
				process.nextTick(function () {
					self.emit('error', err)
				})
				return
			}
	
			// Can't set responseType on really old browsers
			if ('responseType' in xhr)
				xhr.responseType = self._mode.split(':')[0]
	
			if ('withCredentials' in xhr)
				xhr.withCredentials = !!opts.withCredentials
	
			if (self._mode === 'text' && 'overrideMimeType' in xhr)
				xhr.overrideMimeType('text/plain; charset=x-user-defined')
	
			if ('requestTimeout' in opts) {
				xhr.timeout = opts.requestTimeout
				xhr.ontimeout = function () {
					self.emit('requestTimeout')
				}
			}
	
			headersList.forEach(function (header) {
				xhr.setRequestHeader(header[0], header[1])
			})
	
			self._response = null
			xhr.onreadystatechange = function () {
				switch (xhr.readyState) {
					case rStates.LOADING:
					case rStates.DONE:
						self._onXHRProgress()
						break
				}
			}
			// Necessary for streaming in Firefox, since xhr.response is ONLY defined
			// in onprogress, not in onreadystatechange with xhr.readyState = 3
			if (self._mode === 'moz-chunked-arraybuffer') {
				xhr.onprogress = function () {
					self._onXHRProgress()
				}
			}
	
			xhr.onerror = function () {
				if (self._destroyed)
					return
				self.emit('error', new Error('XHR error'))
			}
	
			try {
				xhr.send(body)
			} catch (err) {
				process.nextTick(function () {
					self.emit('error', err)
				})
				return
			}
		}
	}
	
	/**
	 * Checks if xhr.status is readable and non-zero, indicating no error.
	 * Even though the spec says it should be available in readyState 3,
	 * accessing it throws an exception in IE8
	 */
	function statusValid (xhr) {
		try {
			var status = xhr.status
			return (status !== null && status !== 0)
		} catch (e) {
			return false
		}
	}
	
	ClientRequest.prototype._onXHRProgress = function () {
		var self = this
	
		if (!statusValid(self._xhr) || self._destroyed)
			return
	
		if (!self._response)
			self._connect()
	
		self._response._onXHRProgress()
	}
	
	ClientRequest.prototype._connect = function () {
		var self = this
	
		if (self._destroyed)
			return
	
		self._response = new IncomingMessage(self._xhr, self._fetchResponse, self._mode)
		self._response.on('error', function(err) {
			self.emit('error', err)
		})
	
		self.emit('response', self._response)
	}
	
	ClientRequest.prototype._write = function (chunk, encoding, cb) {
		var self = this
	
		self._body.push(chunk)
		cb()
	}
	
	ClientRequest.prototype.abort = ClientRequest.prototype.destroy = function () {
		var self = this
		self._destroyed = true
		if (self._response)
			self._response._destroyed = true
		if (self._xhr)
			self._xhr.abort()
		else if (self._fetchAbortController)
			self._fetchAbortController.abort()
	}
	
	ClientRequest.prototype.end = function (data, encoding, cb) {
		var self = this
		if (typeof data === 'function') {
			cb = data
			data = undefined
		}
	
		stream.Writable.prototype.end.call(self, data, encoding, cb)
	}
	
	ClientRequest.prototype.flushHeaders = function () {}
	ClientRequest.prototype.setTimeout = function () {}
	ClientRequest.prototype.setNoDelay = function () {}
	ClientRequest.prototype.setSocketKeepAlive = function () {}
	
	// Taken from http://www.w3.org/TR/XMLHttpRequest/#the-setrequestheader%28%29-method
	var unsafeHeaders = [
		'accept-charset',
		'accept-encoding',
		'access-control-request-headers',
		'access-control-request-method',
		'connection',
		'content-length',
		'cookie',
		'cookie2',
		'date',
		'dnt',
		'expect',
		'host',
		'keep-alive',
		'origin',
		'referer',
		'te',
		'trailer',
		'transfer-encoding',
		'upgrade',
		'user-agent',
		'via'
	]
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer, (function() { return this; }()), __webpack_require__(10)))

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(207);
	
	/*<replacement>*/
	var util = __webpack_require__(24);
	util.inherits = __webpack_require__(13);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Buffer = __webpack_require__(59).Buffer;
	var util = __webpack_require__(598);
	
	function copyBuffer(src, target, offset) {
	  src.copy(target, offset);
	}
	
	module.exports = function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);
	
	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }
	
	  BufferList.prototype.push = function push(v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.unshift = function unshift(v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.shift = function shift() {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };
	
	  BufferList.prototype.clear = function clear() {
	    this.head = this.tail = null;
	    this.length = 0;
	  };
	
	  BufferList.prototype.join = function join(s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };
	
	  BufferList.prototype.concat = function concat(n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    if (this.length === 1) return this.head.data;
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      copyBuffer(p.data, ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };
	
	  return BufferList;
	}();
	
	if (util && util.inspect && util.inspect.custom) {
	  module.exports.prototype[util.inspect.custom] = function () {
	    var obj = util.inspect({ length: this.length });
	    return this.constructor.name + ' ' + obj;
	  };
	}

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(521);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(73)(module)))

/***/ },
/* 521 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	var Buffer = __webpack_require__(2).Buffer
	
	module.exports = function (buf) {
		// If the buffer is backed by a Uint8Array, a faster version will work
		if (buf instanceof Uint8Array) {
			// If the buffer isn't a subarray, return the underlying ArrayBuffer
			if (buf.byteOffset === 0 && buf.byteLength === buf.buffer.byteLength) {
				return buf.buffer
			} else if (typeof buf.buffer.slice === 'function') {
				// Otherwise we need to get a proper copy
				return buf.buffer.slice(buf.byteOffset, buf.byteOffset + buf.byteLength)
			}
		}
	
		if (Buffer.isBuffer(buf)) {
			// This is the slow version that will work with any Buffer
			// implementation (even in old browsers)
			var arrayCopy = new Uint8Array(buf.length)
			var len = buf.length
			for (var i = 0; i < len; i++) {
				arrayCopy[i] = buf[i]
			}
			return arrayCopy.buffer
		} else {
			throw new Error('Argument must be a Buffer')
		}
	}


/***/ },
/* 523 */
/***/ function(module, exports) {

	var traverse = module.exports = function (obj) {
	    return new Traverse(obj);
	};
	
	function Traverse (obj) {
	    this.value = obj;
	}
	
	Traverse.prototype.get = function (ps) {
	    var node = this.value;
	    for (var i = 0; i < ps.length; i ++) {
	        var key = ps[i];
	        if (!node || !hasOwnProperty.call(node, key)) {
	            node = undefined;
	            break;
	        }
	        node = node[key];
	    }
	    return node;
	};
	
	Traverse.prototype.has = function (ps) {
	    var node = this.value;
	    for (var i = 0; i < ps.length; i ++) {
	        var key = ps[i];
	        if (!node || !hasOwnProperty.call(node, key)) {
	            return false;
	        }
	        node = node[key];
	    }
	    return true;
	};
	
	Traverse.prototype.set = function (ps, value) {
	    var node = this.value;
	    for (var i = 0; i < ps.length - 1; i ++) {
	        var key = ps[i];
	        if (!hasOwnProperty.call(node, key)) node[key] = {};
	        node = node[key];
	    }
	    node[ps[i]] = value;
	    return value;
	};
	
	Traverse.prototype.map = function (cb) {
	    return walk(this.value, cb, true);
	};
	
	Traverse.prototype.forEach = function (cb) {
	    this.value = walk(this.value, cb, false);
	    return this.value;
	};
	
	Traverse.prototype.reduce = function (cb, init) {
	    var skip = arguments.length === 1;
	    var acc = skip ? this.value : init;
	    this.forEach(function (x) {
	        if (!this.isRoot || !skip) {
	            acc = cb.call(this, acc, x);
	        }
	    });
	    return acc;
	};
	
	Traverse.prototype.paths = function () {
	    var acc = [];
	    this.forEach(function (x) {
	        acc.push(this.path); 
	    });
	    return acc;
	};
	
	Traverse.prototype.nodes = function () {
	    var acc = [];
	    this.forEach(function (x) {
	        acc.push(this.node);
	    });
	    return acc;
	};
	
	Traverse.prototype.clone = function () {
	    var parents = [], nodes = [];
	    
	    return (function clone (src) {
	        for (var i = 0; i < parents.length; i++) {
	            if (parents[i] === src) {
	                return nodes[i];
	            }
	        }
	        
	        if (typeof src === 'object' && src !== null) {
	            var dst = copy(src);
	            
	            parents.push(src);
	            nodes.push(dst);
	            
	            forEach(objectKeys(src), function (key) {
	                dst[key] = clone(src[key]);
	            });
	            
	            parents.pop();
	            nodes.pop();
	            return dst;
	        }
	        else {
	            return src;
	        }
	    })(this.value);
	};
	
	function walk (root, cb, immutable) {
	    var path = [];
	    var parents = [];
	    var alive = true;
	    
	    return (function walker (node_) {
	        var node = immutable ? copy(node_) : node_;
	        var modifiers = {};
	        
	        var keepGoing = true;
	        
	        var state = {
	            node : node,
	            node_ : node_,
	            path : [].concat(path),
	            parent : parents[parents.length - 1],
	            parents : parents,
	            key : path.slice(-1)[0],
	            isRoot : path.length === 0,
	            level : path.length,
	            circular : null,
	            update : function (x, stopHere) {
	                if (!state.isRoot) {
	                    state.parent.node[state.key] = x;
	                }
	                state.node = x;
	                if (stopHere) keepGoing = false;
	            },
	            'delete' : function (stopHere) {
	                delete state.parent.node[state.key];
	                if (stopHere) keepGoing = false;
	            },
	            remove : function (stopHere) {
	                if (isArray(state.parent.node)) {
	                    state.parent.node.splice(state.key, 1);
	                }
	                else {
	                    delete state.parent.node[state.key];
	                }
	                if (stopHere) keepGoing = false;
	            },
	            keys : null,
	            before : function (f) { modifiers.before = f },
	            after : function (f) { modifiers.after = f },
	            pre : function (f) { modifiers.pre = f },
	            post : function (f) { modifiers.post = f },
	            stop : function () { alive = false },
	            block : function () { keepGoing = false }
	        };
	        
	        if (!alive) return state;
	        
	        function updateState() {
	            if (typeof state.node === 'object' && state.node !== null) {
	                if (!state.keys || state.node_ !== state.node) {
	                    state.keys = objectKeys(state.node)
	                }
	                
	                state.isLeaf = state.keys.length == 0;
	                
	                for (var i = 0; i < parents.length; i++) {
	                    if (parents[i].node_ === node_) {
	                        state.circular = parents[i];
	                        break;
	                    }
	                }
	            }
	            else {
	                state.isLeaf = true;
	                state.keys = null;
	            }
	            
	            state.notLeaf = !state.isLeaf;
	            state.notRoot = !state.isRoot;
	        }
	        
	        updateState();
	        
	        // use return values to update if defined
	        var ret = cb.call(state, state.node);
	        if (ret !== undefined && state.update) state.update(ret);
	        
	        if (modifiers.before) modifiers.before.call(state, state.node);
	        
	        if (!keepGoing) return state;
	        
	        if (typeof state.node == 'object'
	        && state.node !== null && !state.circular) {
	            parents.push(state);
	            
	            updateState();
	            
	            forEach(state.keys, function (key, i) {
	                path.push(key);
	                
	                if (modifiers.pre) modifiers.pre.call(state, state.node[key], key);
	                
	                var child = walker(state.node[key]);
	                if (immutable && hasOwnProperty.call(state.node, key)) {
	                    state.node[key] = child.node;
	                }
	                
	                child.isLast = i == state.keys.length - 1;
	                child.isFirst = i == 0;
	                
	                if (modifiers.post) modifiers.post.call(state, child);
	                
	                path.pop();
	            });
	            parents.pop();
	        }
	        
	        if (modifiers.after) modifiers.after.call(state, state.node);
	        
	        return state;
	    })(root).node;
	}
	
	function copy (src) {
	    if (typeof src === 'object' && src !== null) {
	        var dst;
	        
	        if (isArray(src)) {
	            dst = [];
	        }
	        else if (isDate(src)) {
	            dst = new Date(src.getTime ? src.getTime() : src);
	        }
	        else if (isRegExp(src)) {
	            dst = new RegExp(src);
	        }
	        else if (isError(src)) {
	            dst = { message: src.message };
	        }
	        else if (isBoolean(src)) {
	            dst = new Boolean(src);
	        }
	        else if (isNumber(src)) {
	            dst = new Number(src);
	        }
	        else if (isString(src)) {
	            dst = new String(src);
	        }
	        else if (Object.create && Object.getPrototypeOf) {
	            dst = Object.create(Object.getPrototypeOf(src));
	        }
	        else if (src.constructor === Object) {
	            dst = {};
	        }
	        else {
	            var proto =
	                (src.constructor && src.constructor.prototype)
	                || src.__proto__
	                || {}
	            ;
	            var T = function () {};
	            T.prototype = proto;
	            dst = new T;
	        }
	        
	        forEach(objectKeys(src), function (key) {
	            dst[key] = src[key];
	        });
	        return dst;
	    }
	    else return src;
	}
	
	var objectKeys = Object.keys || function keys (obj) {
	    var res = [];
	    for (var key in obj) res.push(key)
	    return res;
	};
	
	function toS (obj) { return Object.prototype.toString.call(obj) }
	function isDate (obj) { return toS(obj) === '[object Date]' }
	function isRegExp (obj) { return toS(obj) === '[object RegExp]' }
	function isError (obj) { return toS(obj) === '[object Error]' }
	function isBoolean (obj) { return toS(obj) === '[object Boolean]' }
	function isNumber (obj) { return toS(obj) === '[object Number]' }
	function isString (obj) { return toS(obj) === '[object String]' }
	
	var isArray = Array.isArray || function isArray (xs) {
	    return Object.prototype.toString.call(xs) === '[object Array]';
	};
	
	var forEach = function (xs, fn) {
	    if (xs.forEach) return xs.forEach(fn)
	    else for (var i = 0; i < xs.length; i++) {
	        fn(xs[i], i, xs);
	    }
	};
	
	forEach(objectKeys(Traverse.prototype), function (key) {
	    traverse[key] = function (obj) {
	        var args = [].slice.call(arguments, 1);
	        var t = new Traverse(obj);
	        return t[key].apply(t, args);
	    };
	});
	
	var hasOwnProperty = Object.hasOwnProperty || function (obj, key) {
	    return key in obj;
	};


/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/devkit-board.f84348e6.png";

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/shake.38f57a16.png";

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/step1.8a2cbc40.png";

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/step2.348a0e76.png";

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/step3.e1bee8a1.png";

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/step4.b59d98f5.png";

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/step5.5fd6f838.png";

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.3.2 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(73)(module), (function() { return this; }())))

/***/ },
/* 532 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  isString: function(arg) {
	    return typeof(arg) === 'string';
	  },
	  isObject: function(arg) {
	    return typeof(arg) === 'object' && arg !== null;
	  },
	  isNull: function(arg) {
	    return arg === null;
	  },
	  isNullOrUndefined: function(arg) {
	    return arg == null;
	  }
	};


/***/ },
/* 533 */
13,
/* 534 */
/***/ function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(216);
	var bytesToUuid = __webpack_require__(215);
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	
	var _nodeId;
	var _clockseq;
	
	// Previous uuid creation time
	var _lastMSecs = 0;
	var _lastNSecs = 0;
	
	// See https://github.com/broofa/node-uuid for API details
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	
	  options = options || {};
	  var node = options.node || _nodeId;
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
	
	  // node and clockseq need to be initialized to random values if they're not
	  // specified.  We do this lazily to minimize issues related to insufficient
	  // system entropy.  See #189
	  if (node == null || clockseq == null) {
	    var seedBytes = rng();
	    if (node == null) {
	      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	      node = _nodeId = [
	        seedBytes[0] | 0x01,
	        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
	      ];
	    }
	    if (clockseq == null) {
	      // Per 4.2.2, randomize (14 bit) clockseq
	      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
	    }
	  }
	
	  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
	
	  // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
	
	  // Time since last uuid creation (in msecs)
	  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
	
	  // Per 4.2.1.2, Bump clockseq on clock regression
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  }
	
	  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  }
	
	  // Per 4.2.1.2 Throw error if too many uuids are requested
	  if (nsecs >= 10000) {
	    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq;
	
	  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	  msecs += 12219292800000;
	
	  // `time_low`
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff;
	
	  // `time_mid`
	  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff;
	
	  // `time_high_and_version`
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	  b[i++] = tmh >>> 16 & 0xff;
	
	  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	  b[i++] = clockseq >>> 8 | 0x80;
	
	  // `clock_seq_low`
	  b[i++] = clockseq & 0xff;
	
	  // `node`
	  for (var n = 0; n < 6; ++n) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : bytesToUuid(b);
	}
	
	module.exports = v1;


/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(216);
	var bytesToUuid = __webpack_require__(215);
	
	function v4(options, buf, offset) {
	  var i = buf && offset || 0;
	
	  if (typeof(options) == 'string') {
	    buf = options === 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};
	
	  var rnds = options.random || (options.rng || rng)();
	
	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || bytesToUuid(rnds);
	}
	
	module.exports = v4;


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = contains;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _toString = __webpack_require__(119);
	
	var _toString2 = _interopRequireDefault(_toString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function contains(str, elem) {
	  (0, _assertString2.default)(str);
	  return str.indexOf((0, _toString2.default)(elem)) >= 0;
	}
	module.exports = exports['default'];

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = equals;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function equals(str, comparison) {
	  (0, _assertString2.default)(str);
	  return str === comparison;
	}
	module.exports = exports['default'];

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = escape;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escape(str) {
	  (0, _assertString2.default)(str);
	  return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\//g, '&#x2F;').replace(/\\/g, '&#x5C;').replace(/`/g, '&#96;');
	}
	module.exports = exports['default'];

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAfter;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _toDate = __webpack_require__(118);
	
	var _toDate2 = _interopRequireDefault(_toDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isAfter(str) {
	  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String(new Date());
	
	  (0, _assertString2.default)(str);
	  var comparison = (0, _toDate2.default)(date);
	  var original = (0, _toDate2.default)(str);
	  return !!(original && comparison && original > comparison);
	}
	module.exports = exports['default'];

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAlpha;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _alpha = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isAlpha(str) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
	
	  (0, _assertString2.default)(str);
	  if (locale in _alpha.alpha) {
	    return _alpha.alpha[locale].test(str);
	  }
	  throw new Error('Invalid locale \'' + locale + '\'');
	}
	module.exports = exports['default'];

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAlphanumeric;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _alpha = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isAlphanumeric(str) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
	
	  (0, _assertString2.default)(str);
	  if (locale in _alpha.alphanumeric) {
	    return _alpha.alphanumeric[locale].test(str);
	  }
	  throw new Error('Invalid locale \'' + locale + '\'');
	}
	module.exports = exports['default'];

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAscii;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-control-regex */
	var ascii = /^[\x00-\x7F]+$/;
	/* eslint-enable no-control-regex */
	
	function isAscii(str) {
	  (0, _assertString2.default)(str);
	  return ascii.test(str);
	}
	module.exports = exports['default'];

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBase64;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var notBase64 = /[^A-Z0-9+\/=]/i;
	
	function isBase64(str) {
	  (0, _assertString2.default)(str);
	  var len = str.length;
	  if (!len || len % 4 !== 0 || notBase64.test(str)) {
	    return false;
	  }
	  var firstPaddingChar = str.indexOf('=');
	  return firstPaddingChar === -1 || firstPaddingChar === len - 1 || firstPaddingChar === len - 2 && str[len - 1] === '=';
	}
	module.exports = exports['default'];

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBefore;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _toDate = __webpack_require__(118);
	
	var _toDate2 = _interopRequireDefault(_toDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBefore(str) {
	  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String(new Date());
	
	  (0, _assertString2.default)(str);
	  var comparison = (0, _toDate2.default)(date);
	  var original = (0, _toDate2.default)(str);
	  return !!(original && comparison && original < comparison);
	}
	module.exports = exports['default'];

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBoolean;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBoolean(str) {
	  (0, _assertString2.default)(str);
	  return ['true', 'false', '1', '0'].indexOf(str) >= 0;
	}
	module.exports = exports['default'];

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isCreditCard;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	var creditCard = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|62[0-9]{14})$/;
	/* eslint-enable max-len */
	
	function isCreditCard(str) {
	  (0, _assertString2.default)(str);
	  var sanitized = str.replace(/[- ]+/g, '');
	  if (!creditCard.test(sanitized)) {
	    return false;
	  }
	  var sum = 0;
	  var digit = void 0;
	  var tmpNum = void 0;
	  var shouldDouble = void 0;
	  for (var i = sanitized.length - 1; i >= 0; i--) {
	    digit = sanitized.substring(i, i + 1);
	    tmpNum = parseInt(digit, 10);
	    if (shouldDouble) {
	      tmpNum *= 2;
	      if (tmpNum >= 10) {
	        sum += tmpNum % 10 + 1;
	      } else {
	        sum += tmpNum;
	      }
	    } else {
	      sum += tmpNum;
	    }
	    shouldDouble = !shouldDouble;
	  }
	  return !!(sum % 10 === 0 ? sanitized : false);
	}
	module.exports = exports['default'];

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isCurrency;
	
	var _merge = __webpack_require__(50);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function currencyRegex(options) {
	  var decimal_digits = '\\d{' + options.digits_after_decimal[0] + '}';
	  options.digits_after_decimal.forEach(function (digit, index) {
	    if (index !== 0) decimal_digits = decimal_digits + '|\\d{' + digit + '}';
	  });
	  var symbol = '(\\' + options.symbol.replace(/\./g, '\\.') + ')' + (options.require_symbol ? '' : '?'),
	      negative = '-?',
	      whole_dollar_amount_without_sep = '[1-9]\\d*',
	      whole_dollar_amount_with_sep = '[1-9]\\d{0,2}(\\' + options.thousands_separator + '\\d{3})*',
	      valid_whole_dollar_amounts = ['0', whole_dollar_amount_without_sep, whole_dollar_amount_with_sep],
	      whole_dollar_amount = '(' + valid_whole_dollar_amounts.join('|') + ')?',
	      decimal_amount = '(\\' + options.decimal_separator + '(' + decimal_digits + '))' + (options.require_decimal ? '' : '?');
	  var pattern = whole_dollar_amount + (options.allow_decimal || options.require_decimal ? decimal_amount : '');
	
	  // default is negative sign before symbol, but there are two other options (besides parens)
	  if (options.allow_negatives && !options.parens_for_negatives) {
	    if (options.negative_sign_after_digits) {
	      pattern += negative;
	    } else if (options.negative_sign_before_digits) {
	      pattern = negative + pattern;
	    }
	  }
	
	  // South African Rand, for example, uses R 123 (space) and R-123 (no space)
	  if (options.allow_negative_sign_placeholder) {
	    pattern = '( (?!\\-))?' + pattern;
	  } else if (options.allow_space_after_symbol) {
	    pattern = ' ?' + pattern;
	  } else if (options.allow_space_after_digits) {
	    pattern += '( (?!$))?';
	  }
	
	  if (options.symbol_after_digits) {
	    pattern += symbol;
	  } else {
	    pattern = symbol + pattern;
	  }
	
	  if (options.allow_negatives) {
	    if (options.parens_for_negatives) {
	      pattern = '(\\(' + pattern + '\\)|' + pattern + ')';
	    } else if (!(options.negative_sign_before_digits || options.negative_sign_after_digits)) {
	      pattern = negative + pattern;
	    }
	  }
	
	  // ensure there's a dollar and/or decimal amount, and that
	  // it doesn't start with a space or a negative sign followed by a space
	  return new RegExp('^(?!-? )(?=.*\\d)' + pattern + '$');
	}
	
	var default_currency_options = {
	  symbol: '$',
	  require_symbol: false,
	  allow_space_after_symbol: false,
	  symbol_after_digits: false,
	  allow_negatives: true,
	  parens_for_negatives: false,
	  negative_sign_before_digits: false,
	  negative_sign_after_digits: false,
	  allow_negative_sign_placeholder: false,
	  thousands_separator: ',',
	  decimal_separator: '.',
	  allow_decimal: true,
	  require_decimal: false,
	  digits_after_decimal: [2],
	  allow_space_after_digits: false
	};
	
	function isCurrency(str, options) {
	  (0, _assertString2.default)(str);
	  options = (0, _merge2.default)(options, default_currency_options);
	  return currencyRegex(options).test(str);
	}
	module.exports = exports['default'];

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDataURI;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validMediaType = /^[a-z]+\/[a-z0-9\-\+]+$/i;
	
	var validAttribute = /^[a-z\-]+=[a-z0-9\-]+$/i;
	
	var validData = /^[a-z0-9!\$&'\(\)\*\+,;=\-\._~:@\/\?%\s]*$/i;
	
	function isDataURI(str) {
	  (0, _assertString2.default)(str);
	  var data = str.split(',');
	  if (data.length < 2) {
	    return false;
	  }
	  var attributes = data.shift().trim().split(';');
	  var schemeAndMediaType = attributes.shift();
	  if (schemeAndMediaType.substr(0, 5) !== 'data:') {
	    return false;
	  }
	  var mediaType = schemeAndMediaType.substr(5);
	  if (mediaType !== '' && !validMediaType.test(mediaType)) {
	    return false;
	  }
	  for (var i = 0; i < attributes.length; i++) {
	    if (i === attributes.length - 1 && attributes[i].toLowerCase() === 'base64') {
	      // ok
	    } else if (!validAttribute.test(attributes[i])) {
	      return false;
	    }
	  }
	  for (var _i = 0; _i < data.length; _i++) {
	    if (!validData.test(data[_i])) {
	      return false;
	    }
	  }
	  return true;
	}
	module.exports = exports['default'];

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDecimal;
	
	var _merge = __webpack_require__(50);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _alpha = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function decimalRegExp(options) {
	  var regExp = new RegExp('^[-+]?([0-9]+)?(\\' + _alpha.decimal[options.locale] + '[0-9]{' + options.decimal_digits + '})' + (options.force_decimal ? '' : '?') + '$');
	  return regExp;
	}
	
	var default_decimal_options = {
	  force_decimal: false,
	  decimal_digits: '1,',
	  locale: 'en-US'
	};
	
	var blacklist = ['', '-', '+'];
	
	function isDecimal(str, options) {
	  (0, _assertString2.default)(str);
	  options = (0, _merge2.default)(options, default_decimal_options);
	  if (options.locale in _alpha.decimal) {
	    return !blacklist.includes(str.replace(/ /g, '')) && decimalRegExp(options).test(str);
	  }
	  throw new Error('Invalid locale \'' + options.locale + '\'');
	}
	module.exports = exports['default'];

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDivisibleBy;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _toFloat = __webpack_require__(227);
	
	var _toFloat2 = _interopRequireDefault(_toFloat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isDivisibleBy(str, num) {
	  (0, _assertString2.default)(str);
	  return (0, _toFloat2.default)(str) % parseInt(num, 10) === 0;
	}
	module.exports = exports['default'];

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEmail;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _merge = __webpack_require__(50);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _isByteLength = __webpack_require__(219);
	
	var _isByteLength2 = _interopRequireDefault(_isByteLength);
	
	var _isFQDN = __webpack_require__(117);
	
	var _isFQDN2 = _interopRequireDefault(_isFQDN);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_email_options = {
	  allow_display_name: false,
	  require_display_name: false,
	  allow_utf8_local_part: true,
	  require_tld: true
	};
	
	/* eslint-disable max-len */
	/* eslint-disable no-control-regex */
	var displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\,\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
	var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
	var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
	var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
	var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
	/* eslint-enable max-len */
	/* eslint-enable no-control-regex */
	
	function isEmail(str, options) {
	  (0, _assertString2.default)(str);
	  options = (0, _merge2.default)(options, default_email_options);
	
	  if (options.require_display_name || options.allow_display_name) {
	    var display_email = str.match(displayName);
	    if (display_email) {
	      str = display_email[1];
	    } else if (options.require_display_name) {
	      return false;
	    }
	  }
	
	  var parts = str.split('@');
	  var domain = parts.pop();
	  var user = parts.join('@');
	
	  var lower_domain = domain.toLowerCase();
	  if (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com') {
	    user = user.replace(/\./g, '').toLowerCase();
	  }
	
	  if (!(0, _isByteLength2.default)(user, { max: 64 }) || !(0, _isByteLength2.default)(domain, { max: 254 })) {
	    return false;
	  }
	
	  if (!(0, _isFQDN2.default)(domain, { require_tld: options.require_tld })) {
	    return false;
	  }
	
	  if (user[0] === '"') {
	    user = user.slice(1, user.length - 1);
	    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
	  }
	
	  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
	
	  var user_parts = user.split('.');
	  for (var i = 0; i < user_parts.length; i++) {
	    if (!pattern.test(user_parts[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	module.exports = exports['default'];

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEmpty;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isEmpty(str) {
	  (0, _assertString2.default)(str);
	  return str.length === 0;
	}
	module.exports = exports['default'];

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFloat;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _alpha = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isFloat(str, options) {
	  (0, _assertString2.default)(str);
	  options = options || {};
	  var float = new RegExp('^(?:[-+])?(?:[0-9]+)?(?:\\' + (options.locale ? _alpha.decimal[options.locale] : '.') + '[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$');
	  if (str === '' || str === '.' || str === '-' || str === '+') {
	    return false;
	  }
	  return float.test(str) && (!options.hasOwnProperty('min') || str >= options.min) && (!options.hasOwnProperty('max') || str <= options.max) && (!options.hasOwnProperty('lt') || str < options.lt) && (!options.hasOwnProperty('gt') || str > options.gt);
	}
	module.exports = exports['default'];

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isHash;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lengths = {
	  md5: 32,
	  md4: 32,
	  sha1: 40,
	  sha256: 64,
	  sha384: 96,
	  sha512: 128,
	  ripemd128: 32,
	  ripemd160: 40,
	  tiger128: 32,
	  tiger160: 40,
	  tiger192: 48,
	  crc32: 8,
	  crc32b: 8
	};
	
	function isHash(str, algorithm) {
	  (0, _assertString2.default)(str);
	  var hash = new RegExp('^[a-f0-9]{' + lengths[algorithm] + '}$');
	  return hash.test(str);
	}
	module.exports = exports['default'];

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isHexColor;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hexcolor = /^#?([0-9A-F]{3}|[0-9A-F]{6})$/i;
	
	function isHexColor(str) {
	  (0, _assertString2.default)(str);
	  return hexcolor.test(str);
	}
	module.exports = exports['default'];

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISBN;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isbn10Maybe = /^(?:[0-9]{9}X|[0-9]{10})$/;
	var isbn13Maybe = /^(?:[0-9]{13})$/;
	var factor = [1, 3];
	
	function isISBN(str) {
	  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  (0, _assertString2.default)(str);
	  version = String(version);
	  if (!version) {
	    return isISBN(str, 10) || isISBN(str, 13);
	  }
	  var sanitized = str.replace(/[\s-]+/g, '');
	  var checksum = 0;
	  var i = void 0;
	  if (version === '10') {
	    if (!isbn10Maybe.test(sanitized)) {
	      return false;
	    }
	    for (i = 0; i < 9; i++) {
	      checksum += (i + 1) * sanitized.charAt(i);
	    }
	    if (sanitized.charAt(9) === 'X') {
	      checksum += 10 * 10;
	    } else {
	      checksum += 10 * sanitized.charAt(9);
	    }
	    if (checksum % 11 === 0) {
	      return !!sanitized;
	    }
	  } else if (version === '13') {
	    if (!isbn13Maybe.test(sanitized)) {
	      return false;
	    }
	    for (i = 0; i < 12; i++) {
	      checksum += factor[i % 2] * sanitized.charAt(i);
	    }
	    if (sanitized.charAt(12) - (10 - checksum % 10) % 10 === 0) {
	      return !!sanitized;
	    }
	  }
	  return false;
	}
	module.exports = exports['default'];

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISIN;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isin = /^[A-Z]{2}[0-9A-Z]{9}[0-9]$/;
	
	function isISIN(str) {
	  (0, _assertString2.default)(str);
	  if (!isin.test(str)) {
	    return false;
	  }
	
	  var checksumStr = str.replace(/[A-Z]/g, function (character) {
	    return parseInt(character, 36);
	  });
	
	  var sum = 0;
	  var digit = void 0;
	  var tmpNum = void 0;
	  var shouldDouble = true;
	  for (var i = checksumStr.length - 2; i >= 0; i--) {
	    digit = checksumStr.substring(i, i + 1);
	    tmpNum = parseInt(digit, 10);
	    if (shouldDouble) {
	      tmpNum *= 2;
	      if (tmpNum >= 10) {
	        sum += tmpNum + 1;
	      } else {
	        sum += tmpNum;
	      }
	    } else {
	      sum += tmpNum;
	    }
	    shouldDouble = !shouldDouble;
	  }
	
	  return parseInt(str.substr(str.length - 1), 10) === (10000 - sum) % 10;
	}
	module.exports = exports['default'];

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISO31661Alpha2;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
	var validISO31661Alpha2CountriesCodes = ['AD', 'AE', 'AF', 'AG', 'AI', 'AL', 'AM', 'AO', 'AQ', 'AR', 'AS', 'AT', 'AU', 'AW', 'AX', 'AZ', 'BA', 'BB', 'BD', 'BE', 'BF', 'BG', 'BH', 'BI', 'BJ', 'BL', 'BM', 'BN', 'BO', 'BQ', 'BR', 'BS', 'BT', 'BV', 'BW', 'BY', 'BZ', 'CA', 'CC', 'CD', 'CF', 'CG', 'CH', 'CI', 'CK', 'CL', 'CM', 'CN', 'CO', 'CR', 'CU', 'CV', 'CW', 'CX', 'CY', 'CZ', 'DE', 'DJ', 'DK', 'DM', 'DO', 'DZ', 'EC', 'EE', 'EG', 'EH', 'ER', 'ES', 'ET', 'FI', 'FJ', 'FK', 'FM', 'FO', 'FR', 'GA', 'GB', 'GD', 'GE', 'GF', 'GG', 'GH', 'GI', 'GL', 'GM', 'GN', 'GP', 'GQ', 'GR', 'GS', 'GT', 'GU', 'GW', 'GY', 'HK', 'HM', 'HN', 'HR', 'HT', 'HU', 'ID', 'IE', 'IL', 'IM', 'IN', 'IO', 'IQ', 'IR', 'IS', 'IT', 'JE', 'JM', 'JO', 'JP', 'KE', 'KG', 'KH', 'KI', 'KM', 'KN', 'KP', 'KR', 'KW', 'KY', 'KZ', 'LA', 'LB', 'LC', 'LI', 'LK', 'LR', 'LS', 'LT', 'LU', 'LV', 'LY', 'MA', 'MC', 'MD', 'ME', 'MF', 'MG', 'MH', 'MK', 'ML', 'MM', 'MN', 'MO', 'MP', 'MQ', 'MR', 'MS', 'MT', 'MU', 'MV', 'MW', 'MX', 'MY', 'MZ', 'NA', 'NC', 'NE', 'NF', 'NG', 'NI', 'NL', 'NO', 'NP', 'NR', 'NU', 'NZ', 'OM', 'PA', 'PE', 'PF', 'PG', 'PH', 'PK', 'PL', 'PM', 'PN', 'PR', 'PS', 'PT', 'PW', 'PY', 'QA', 'RE', 'RO', 'RS', 'RU', 'RW', 'SA', 'SB', 'SC', 'SD', 'SE', 'SG', 'SH', 'SI', 'SJ', 'SK', 'SL', 'SM', 'SN', 'SO', 'SR', 'SS', 'ST', 'SV', 'SX', 'SY', 'SZ', 'TC', 'TD', 'TF', 'TG', 'TH', 'TJ', 'TK', 'TL', 'TM', 'TN', 'TO', 'TR', 'TT', 'TV', 'TW', 'TZ', 'UA', 'UG', 'UM', 'US', 'UY', 'UZ', 'VA', 'VC', 'VE', 'VG', 'VI', 'VN', 'VU', 'WF', 'WS', 'YE', 'YT', 'ZA', 'ZM', 'ZW'];
	
	function isISO31661Alpha2(str) {
	  (0, _assertString2.default)(str);
	  return validISO31661Alpha2CountriesCodes.includes(str.toUpperCase());
	}
	module.exports = exports['default'];

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISO8601;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	// from http://goo.gl/0ejHHW
	var iso8601 = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
	/* eslint-enable max-len */
	
	function isISO8601(str) {
	  (0, _assertString2.default)(str);
	  return iso8601.test(str);
	}
	module.exports = exports['default'];

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISRC;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// see http://isrc.ifpi.org/en/isrc-standard/code-syntax
	var isrc = /^[A-Z]{2}[0-9A-Z]{3}\d{2}\d{5}$/;
	
	function isISRC(str) {
	  (0, _assertString2.default)(str);
	  return isrc.test(str);
	}
	module.exports = exports['default'];

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isISSN;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var issn = '^\\d{4}-?\\d{3}[\\dX]$';
	
	function isISSN(str) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  (0, _assertString2.default)(str);
	  var testIssn = issn;
	  testIssn = options.require_hyphen ? testIssn.replace('?', '') : testIssn;
	  testIssn = options.case_sensitive ? new RegExp(testIssn) : new RegExp(testIssn, 'i');
	  if (!testIssn.test(str)) {
	    return false;
	  }
	  var issnDigits = str.replace('-', '');
	  var position = 8;
	  var checksum = 0;
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = issnDigits[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var digit = _step.value;
	
	      var digitValue = digit.toUpperCase() === 'X' ? 10 : +digit;
	      checksum += digitValue * position;
	      --position;
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return checksum % 11 === 0;
	}
	module.exports = exports['default'];

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isIn;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _toString = __webpack_require__(119);
	
	var _toString2 = _interopRequireDefault(_toString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isIn(str, options) {
	  (0, _assertString2.default)(str);
	  var i = void 0;
	  if (Object.prototype.toString.call(options) === '[object Array]') {
	    var array = [];
	    for (i in options) {
	      if ({}.hasOwnProperty.call(options, i)) {
	        array[i] = (0, _toString2.default)(options[i]);
	      }
	    }
	    return array.indexOf(str) >= 0;
	  } else if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	    return options.hasOwnProperty(str);
	  } else if (options && typeof options.indexOf === 'function') {
	    return options.indexOf(str) >= 0;
	  }
	  return false;
	}
	module.exports = exports['default'];

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isJSON;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isJSON(str) {
	  (0, _assertString2.default)(str);
	  try {
	    var obj = JSON.parse(str);
	    return !!obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
	  } catch (e) {/* ignore */}
	  return false;
	}
	module.exports = exports['default'];

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (str) {
	  (0, _assertString2.default)(str);
	  if (!str.includes(',')) return false;
	  var pair = str.split(',');
	  return lat.test(pair[0]) && long.test(pair[1]);
	};
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lat = /^\(?[+-]?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/;
	var long = /^\s?[+-]?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)\)?$/;
	
	module.exports = exports['default'];

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isLength;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable prefer-rest-params */
	function isLength(str, options) {
	  (0, _assertString2.default)(str);
	  var min = void 0;
	  var max = void 0;
	  if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	    min = options.min || 0;
	    max = options.max;
	  } else {
	    // backwards compatibility: isLength(str, min [, max])
	    min = arguments[1];
	    max = arguments[2];
	  }
	  var surrogatePairs = str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [];
	  var len = str.length - surrogatePairs.length;
	  return len >= min && (typeof max === 'undefined' || len <= max);
	}
	module.exports = exports['default'];

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isLowercase;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isLowercase(str) {
	  (0, _assertString2.default)(str);
	  return str === str.toLowerCase();
	}
	module.exports = exports['default'];

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMACAddress;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var macAddress = /^([0-9a-fA-F][0-9a-fA-F]:){5}([0-9a-fA-F][0-9a-fA-F])$/;
	
	function isMACAddress(str) {
	  (0, _assertString2.default)(str);
	  return macAddress.test(str);
	}
	module.exports = exports['default'];

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMD5;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var md5 = /^[a-f0-9]{32}$/;
	
	function isMD5(str) {
	  (0, _assertString2.default)(str);
	  return md5.test(str);
	}
	module.exports = exports['default'];

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMimeType;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	  Checks if the provided string matches to a correct Media type format (MIME type)
	
	  This function only checks is the string format follows the
	  etablished rules by the according RFC specifications.
	  This function supports 'charset' in textual media types
	  (https://tools.ietf.org/html/rfc6657).
	
	  This function does not check against all the media types listed
	  by the IANA (https://www.iana.org/assignments/media-types/media-types.xhtml)
	  because of lightness purposes : it would require to include
	  all these MIME types in this librairy, which would weigh it
	  significantly. This kind of effort maybe is not worth for the use that
	  this function has in this entire librairy.
	
	  More informations in the RFC specifications :
	  - https://tools.ietf.org/html/rfc2045
	  - https://tools.ietf.org/html/rfc2046
	  - https://tools.ietf.org/html/rfc7231#section-3.1.1.1
	  - https://tools.ietf.org/html/rfc7231#section-3.1.1.5
	*/
	
	// Match simple MIME types
	// NB :
	//   Subtype length must not exceed 100 characters.
	//   This rule does not comply to the RFC specs (what is the max length ?).
	var mimeTypeSimple = /^(application|audio|font|image|message|model|multipart|text|video)\/[a-zA-Z0-9\.\-\+]{1,100}$/i; // eslint-disable-line max-len
	
	// Handle "charset" in "text/*"
	var mimeTypeText = /^text\/[a-zA-Z0-9\.\-\+]{1,100};\s?charset=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?$/i; // eslint-disable-line max-len
	
	// Handle "boundary" in "multipart/*"
	var mimeTypeMultipart = /^multipart\/[a-zA-Z0-9\.\-\+]{1,100}(;\s?(boundary|charset)=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?){0,2}$/i; // eslint-disable-line max-len
	
	function isMimeType(str) {
	  (0, _assertString2.default)(str);
	  return mimeTypeSimple.test(str) || mimeTypeText.test(str) || mimeTypeMultipart.test(str);
	}
	module.exports = exports['default'];

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMobilePhone;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	var phones = {
	  'ar-AE': /^((\+?971)|0)?5[024568]\d{7}$/,
	  'ar-DZ': /^(\+?213|0)(5|6|7)\d{8}$/,
	  'ar-EG': /^((\+?20)|0)?1[012]\d{8}$/,
	  'ar-JO': /^(\+?962|0)?7[789]\d{7}$/,
	  'ar-SA': /^(!?(\+?966)|0)?5\d{8}$/,
	  'ar-SY': /^(!?(\+?963)|0)?9\d{8}$/,
	  'be-BY': /^(\+?375)?(24|25|29|33|44)\d{7}$/,
	  'bg-BG': /^(\+?359|0)?8[789]\d{7}$/,
	  'cs-CZ': /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
	  'da-DK': /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
	  'de-DE': /^(\+?49[ \.\-])?([\(]{1}[0-9]{1,6}[\)])?([0-9 \.\-\/]{3,20})((x|ext|extension)[ ]?[0-9]{1,4})?$/,
	  'el-GR': /^(\+?30|0)?(69\d{8})$/,
	  'en-AU': /^(\+?61|0)4\d{8}$/,
	  'en-GB': /^(\+?44|0)7\d{9}$/,
	  'en-HK': /^(\+?852\-?)?[456789]\d{3}\-?\d{4}$/,
	  'en-IN': /^(\+?91|0)?[6789]\d{9}$/,
	  'en-KE': /^(\+?254|0)?[7]\d{8}$/,
	  'en-NG': /^(\+?234|0)?[789]\d{9}$/,
	  'en-NZ': /^(\+?64|0)2\d{7,9}$/,
	  'en-PK': /^((\+92)|(0092))-{0,1}\d{3}-{0,1}\d{7}$|^\d{11}$|^\d{4}-\d{7}$/,
	  'en-RW': /^(\+?250|0)?[7]\d{8}$/,
	  'en-SG': /^(\+65)?[89]\d{7}$/,
	  'en-TZ': /^(\+?255|0)?[67]\d{8}$/,
	  'en-UG': /^(\+?256|0)?[7]\d{8}$/,
	  'en-US': /^(\+?1)?[2-9]\d{2}[2-9](?!11)\d{6}$/,
	  'en-ZA': /^(\+?27|0)\d{9}$/,
	  'en-ZM': /^(\+?26)?09[567]\d{7}$/,
	  'es-ES': /^(\+?34)?(6\d{1}|7[1234])\d{7}$/,
	  'et-EE': /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
	  'fa-IR': /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
	  'fi-FI': /^(\+?358|0)\s?(4(0|1|2|4|5|6)?|50)\s?(\d\s?){4,8}\d$/,
	  'fo-FO': /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
	  'fr-FR': /^(\+?33|0)[67]\d{8}$/,
	  'he-IL': /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}/,
	  'hu-HU': /^(\+?36)(20|30|70)\d{7}$/,
	  'id-ID': /^(\+?62|0[1-9])[\s|\d]+$/,
	  'it-IT': /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
	  'ja-JP': /^(\+?81|0)[789]0[ \-]?[1-9]\d{2}[ \-]?\d{5}$/,
	  'kk-KZ': /^(\+?7|8)?7\d{9}$/,
	  'kl-GL': /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
	  'ko-KR': /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
	  'lt-LT': /^(\+370|8)\d{8}$/,
	  'ms-MY': /^(\+?6?01){1}(([145]{1}(\-|\s)?\d{7,8})|([236789]{1}(\s|\-)?\d{7}))$/,
	  'nb-NO': /^(\+?47)?[49]\d{7}$/,
	  'nl-BE': /^(\+?32|0)4?\d{8}$/,
	  'nn-NO': /^(\+?47)?[49]\d{7}$/,
	  'pl-PL': /^(\+?48)? ?[5-8]\d ?\d{3} ?\d{2} ?\d{2}$/,
	  'pt-BR': /^(\+?55|0)\-?[1-9]{2}\-?[2-9]{1}\d{3,4}\-?\d{4}$/,
	  'pt-PT': /^(\+?351)?9[1236]\d{7}$/,
	  'ro-RO': /^(\+?4?0)\s?7\d{2}(\/|\s|\.|\-)?\d{3}(\s|\.|\-)?\d{3}$/,
	  'ru-RU': /^(\+?7|8)?9\d{9}$/,
	  'sk-SK': /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
	  'sr-RS': /^(\+3816|06)[- \d]{5,9}$/,
	  'th-TH': /^(\+66|66|0)\d{9}$/,
	  'tr-TR': /^(\+?90|0)?5\d{9}$/,
	  'uk-UA': /^(\+?38|8)?0\d{9}$/,
	  'vi-VN': /^(\+?84|0)?((1(2([0-9])|6([2-9])|88|99))|(9((?!5)[0-9])))([0-9]{7})$/,
	  'zh-CN': /^(\+?0?86\-?)?1[3456789]\d{9}$/,
	  'zh-TW': /^(\+?886\-?|0)?9\d{8}$/
	};
	/* eslint-enable max-len */
	
	// aliases
	phones['en-CA'] = phones['en-US'];
	phones['fr-BE'] = phones['nl-BE'];
	phones['zh-HK'] = phones['en-HK'];
	
	function isMobilePhone(str, locale, options) {
	  (0, _assertString2.default)(str);
	  if (options && options.strictMode && !str.startsWith('+')) {
	    return false;
	  }
	  if (locale in phones) {
	    return phones[locale].test(str);
	  } else if (locale === 'any') {
	    for (var key in phones) {
	      if (phones.hasOwnProperty(key)) {
	        var phone = phones[key];
	        if (phone.test(str)) {
	          return true;
	        }
	      }
	    }
	    return false;
	  }
	  throw new Error('Invalid locale \'' + locale + '\'');
	}
	module.exports = exports['default'];

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMongoId;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _isHexadecimal = __webpack_require__(222);
	
	var _isHexadecimal2 = _interopRequireDefault(_isHexadecimal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isMongoId(str) {
	  (0, _assertString2.default)(str);
	  return (0, _isHexadecimal2.default)(str) && str.length === 24;
	}
	module.exports = exports['default'];

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMultibyte;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-control-regex */
	var multibyte = /[^\x00-\x7F]/;
	/* eslint-enable no-control-regex */
	
	function isMultibyte(str) {
	  (0, _assertString2.default)(str);
	  return multibyte.test(str);
	}
	module.exports = exports['default'];

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isNumeric;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var numeric = /^[-+]?[0-9]+$/;
	
	function isNumeric(str) {
	  (0, _assertString2.default)(str);
	  return numeric.test(str);
	}
	module.exports = exports['default'];

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPort;
	
	var _isInt = __webpack_require__(224);
	
	var _isInt2 = _interopRequireDefault(_isInt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isPort(str) {
	  return (0, _isInt2.default)(str, { min: 0, max: 65535 });
	}
	module.exports = exports['default'];

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.locales = undefined;
	
	exports.default = function (str, locale) {
	  (0, _assertString2.default)(str);
	  if (locale in patterns) {
	    return patterns[locale].test(str);
	  } else if (locale === 'any') {
	    for (var key in patterns) {
	      if (patterns.hasOwnProperty(key)) {
	        var pattern = patterns[key];
	        if (pattern.test(str)) {
	          return true;
	        }
	      }
	    }
	    return false;
	  }
	  throw new Error('Invalid locale \'' + locale + '\'');
	};
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// common patterns
	var threeDigit = /^\d{3}$/;
	var fourDigit = /^\d{4}$/;
	var fiveDigit = /^\d{5}$/;
	var sixDigit = /^\d{6}$/;
	
	var patterns = {
	  AT: fourDigit,
	  AU: fourDigit,
	  BE: fourDigit,
	  BG: fourDigit,
	  CA: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][\s\-]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
	  CH: fourDigit,
	  CZ: /^\d{3}\s?\d{2}$/,
	  DE: fiveDigit,
	  DK: fourDigit,
	  DZ: fiveDigit,
	  ES: fiveDigit,
	  FI: fiveDigit,
	  FR: /^\d{2}\s?\d{3}$/,
	  GB: /^(gir\s?0aa|[a-z]{1,2}\d[\da-z]?\s?(\d[a-z]{2})?)$/i,
	  GR: /^\d{3}\s?\d{2}$/,
	  IL: fiveDigit,
	  IN: sixDigit,
	  IS: threeDigit,
	  IT: fiveDigit,
	  JP: /^\d{3}\-\d{4}$/,
	  KE: fiveDigit,
	  LI: /^(948[5-9]|949[0-7])$/,
	  MX: fiveDigit,
	  NL: /^\d{4}\s?[a-z]{2}$/i,
	  NO: fourDigit,
	  PL: /^\d{2}\-\d{3}$/,
	  PT: /^\d{4}\-\d{3}?$/,
	  RO: sixDigit,
	  RU: sixDigit,
	  SA: fiveDigit,
	  SE: /^\d{3}\s?\d{2}$/,
	  TW: /^\d{3}(\d{2})?$/,
	  US: /^\d{5}(-\d{4})?$/,
	  ZA: fourDigit,
	  ZM: fiveDigit
	};
	
	var locales = exports.locales = Object.keys(patterns);

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSurrogatePair;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var surrogatePair = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
	
	function isSurrogatePair(str) {
	  (0, _assertString2.default)(str);
	  return surrogatePair.test(str);
	}
	module.exports = exports['default'];

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isURL;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _isFQDN = __webpack_require__(117);
	
	var _isFQDN2 = _interopRequireDefault(_isFQDN);
	
	var _isIP = __webpack_require__(223);
	
	var _isIP2 = _interopRequireDefault(_isIP);
	
	var _merge = __webpack_require__(50);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_url_options = {
	  protocols: ['http', 'https', 'ftp'],
	  require_tld: true,
	  require_protocol: false,
	  require_host: true,
	  require_valid_protocol: true,
	  allow_underscores: false,
	  allow_trailing_dot: false,
	  allow_protocol_relative_urls: false
	};
	
	var wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;
	
	function isRegExp(obj) {
	  return Object.prototype.toString.call(obj) === '[object RegExp]';
	}
	
	function checkHost(host, matches) {
	  for (var i = 0; i < matches.length; i++) {
	    var match = matches[i];
	    if (host === match || isRegExp(match) && match.test(host)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	function isURL(url, options) {
	  (0, _assertString2.default)(url);
	  if (!url || url.length >= 2083 || /[\s<>]/.test(url)) {
	    return false;
	  }
	  if (url.indexOf('mailto:') === 0) {
	    return false;
	  }
	  options = (0, _merge2.default)(options, default_url_options);
	  var protocol = void 0,
	      auth = void 0,
	      host = void 0,
	      hostname = void 0,
	      port = void 0,
	      port_str = void 0,
	      split = void 0,
	      ipv6 = void 0;
	
	  split = url.split('#');
	  url = split.shift();
	
	  split = url.split('?');
	  url = split.shift();
	
	  split = url.split('://');
	  if (split.length > 1) {
	    protocol = split.shift();
	    if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) {
	      return false;
	    }
	  } else if (options.require_protocol) {
	    return false;
	  } else if (options.allow_protocol_relative_urls && url.substr(0, 2) === '//') {
	    split[0] = url.substr(2);
	  }
	  url = split.join('://');
	
	  if (url === '') {
	    return false;
	  }
	
	  split = url.split('/');
	  url = split.shift();
	
	  if (url === '' && !options.require_host) {
	    return true;
	  }
	
	  split = url.split('@');
	  if (split.length > 1) {
	    auth = split.shift();
	    if (auth.indexOf(':') >= 0 && auth.split(':').length > 2) {
	      return false;
	    }
	  }
	  hostname = split.join('@');
	
	  port_str = null;
	  ipv6 = null;
	  var ipv6_match = hostname.match(wrapped_ipv6);
	  if (ipv6_match) {
	    host = '';
	    ipv6 = ipv6_match[1];
	    port_str = ipv6_match[2] || null;
	  } else {
	    split = hostname.split(':');
	    host = split.shift();
	    if (split.length) {
	      port_str = split.join(':');
	    }
	  }
	
	  if (port_str !== null) {
	    port = parseInt(port_str, 10);
	    if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) {
	      return false;
	    }
	  }
	
	  if (!(0, _isIP2.default)(host) && !(0, _isFQDN2.default)(host, options) && (!ipv6 || !(0, _isIP2.default)(ipv6, 6))) {
	    return false;
	  }
	
	  host = host || ipv6;
	
	  if (options.host_whitelist && !checkHost(host, options.host_whitelist)) {
	    return false;
	  }
	  if (options.host_blacklist && checkHost(host, options.host_blacklist)) {
	    return false;
	  }
	
	  return true;
	}
	module.exports = exports['default'];

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isUUID;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var uuid = {
	  3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
	  4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
	  5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
	  all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
	};
	
	function isUUID(str) {
	  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';
	
	  (0, _assertString2.default)(str);
	  var pattern = uuid[version];
	  return pattern && pattern.test(str);
	}
	module.exports = exports['default'];

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isUppercase;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isUppercase(str) {
	  (0, _assertString2.default)(str);
	  return str === str.toUpperCase();
	}
	module.exports = exports['default'];

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isVariableWidth;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _isFullWidth = __webpack_require__(220);
	
	var _isHalfWidth = __webpack_require__(221);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isVariableWidth(str) {
	  (0, _assertString2.default)(str);
	  return _isFullWidth.fullWidth.test(str) && _isHalfWidth.halfWidth.test(str);
	}
	module.exports = exports['default'];

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWhitelisted;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isWhitelisted(str, chars) {
	  (0, _assertString2.default)(str);
	  for (var i = str.length - 1; i >= 0; i--) {
	    if (chars.indexOf(str[i]) === -1) {
	      return false;
	    }
	  }
	  return true;
	}
	module.exports = exports['default'];

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = matches;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function matches(str, pattern, modifiers) {
	  (0, _assertString2.default)(str);
	  if (Object.prototype.toString.call(pattern) !== '[object RegExp]') {
	    pattern = new RegExp(pattern, modifiers);
	  }
	  return pattern.test(str);
	}
	module.exports = exports['default'];

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = normalizeEmail;
	
	var _merge = __webpack_require__(50);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_normalize_email_options = {
	  // The following options apply to all email addresses
	  // Lowercases the local part of the email address.
	  // Please note this may violate RFC 5321 as per http://stackoverflow.com/a/9808332/192024).
	  // The domain is always lowercased, as per RFC 1035
	  all_lowercase: true,
	
	  // The following conversions are specific to GMail
	  // Lowercases the local part of the GMail address (known to be case-insensitive)
	  gmail_lowercase: true,
	  // Removes dots from the local part of the email address, as that's ignored by GMail
	  gmail_remove_dots: true,
	  // Removes the subaddress (e.g. "+foo") from the email address
	  gmail_remove_subaddress: true,
	  // Conversts the googlemail.com domain to gmail.com
	  gmail_convert_googlemaildotcom: true,
	
	  // The following conversions are specific to Outlook.com / Windows Live / Hotmail
	  // Lowercases the local part of the Outlook.com address (known to be case-insensitive)
	  outlookdotcom_lowercase: true,
	  // Removes the subaddress (e.g. "+foo") from the email address
	  outlookdotcom_remove_subaddress: true,
	
	  // The following conversions are specific to Yahoo
	  // Lowercases the local part of the Yahoo address (known to be case-insensitive)
	  yahoo_lowercase: true,
	  // Removes the subaddress (e.g. "-foo") from the email address
	  yahoo_remove_subaddress: true,
	
	  // The following conversions are specific to iCloud
	  // Lowercases the local part of the iCloud address (known to be case-insensitive)
	  icloud_lowercase: true,
	  // Removes the subaddress (e.g. "+foo") from the email address
	  icloud_remove_subaddress: true
	};
	
	// List of domains used by iCloud
	var icloud_domains = ['icloud.com', 'me.com'];
	
	// List of domains used by Outlook.com and its predecessors
	// This list is likely incomplete.
	// Partial reference:
	// https://blogs.office.com/2013/04/17/outlook-com-gets-two-step-verification-sign-in-by-alias-and-new-international-domains/
	var outlookdotcom_domains = ['hotmail.at', 'hotmail.be', 'hotmail.ca', 'hotmail.cl', 'hotmail.co.il', 'hotmail.co.nz', 'hotmail.co.th', 'hotmail.co.uk', 'hotmail.com', 'hotmail.com.ar', 'hotmail.com.au', 'hotmail.com.br', 'hotmail.com.gr', 'hotmail.com.mx', 'hotmail.com.pe', 'hotmail.com.tr', 'hotmail.com.vn', 'hotmail.cz', 'hotmail.de', 'hotmail.dk', 'hotmail.es', 'hotmail.fr', 'hotmail.hu', 'hotmail.id', 'hotmail.ie', 'hotmail.in', 'hotmail.it', 'hotmail.jp', 'hotmail.kr', 'hotmail.lv', 'hotmail.my', 'hotmail.ph', 'hotmail.pt', 'hotmail.sa', 'hotmail.sg', 'hotmail.sk', 'live.be', 'live.co.uk', 'live.com', 'live.com.ar', 'live.com.mx', 'live.de', 'live.es', 'live.eu', 'live.fr', 'live.it', 'live.nl', 'msn.com', 'outlook.at', 'outlook.be', 'outlook.cl', 'outlook.co.il', 'outlook.co.nz', 'outlook.co.th', 'outlook.com', 'outlook.com.ar', 'outlook.com.au', 'outlook.com.br', 'outlook.com.gr', 'outlook.com.pe', 'outlook.com.tr', 'outlook.com.vn', 'outlook.cz', 'outlook.de', 'outlook.dk', 'outlook.es', 'outlook.fr', 'outlook.hu', 'outlook.id', 'outlook.ie', 'outlook.in', 'outlook.it', 'outlook.jp', 'outlook.kr', 'outlook.lv', 'outlook.my', 'outlook.ph', 'outlook.pt', 'outlook.sa', 'outlook.sg', 'outlook.sk', 'passport.com'];
	
	// List of domains used by Yahoo Mail
	// This list is likely incomplete
	var yahoo_domains = ['rocketmail.com', 'yahoo.ca', 'yahoo.co.uk', 'yahoo.com', 'yahoo.de', 'yahoo.fr', 'yahoo.in', 'yahoo.it', 'ymail.com'];
	
	function normalizeEmail(email, options) {
	  options = (0, _merge2.default)(options, default_normalize_email_options);
	
	  var raw_parts = email.split('@');
	  var domain = raw_parts.pop();
	  var user = raw_parts.join('@');
	  var parts = [user, domain];
	
	  // The domain is always lowercased, as it's case-insensitive per RFC 1035
	  parts[1] = parts[1].toLowerCase();
	
	  if (parts[1] === 'gmail.com' || parts[1] === 'googlemail.com') {
	    // Address is GMail
	    if (options.gmail_remove_subaddress) {
	      parts[0] = parts[0].split('+')[0];
	    }
	    if (options.gmail_remove_dots) {
	      parts[0] = parts[0].replace(/\./g, '');
	    }
	    if (!parts[0].length) {
	      return false;
	    }
	    if (options.all_lowercase || options.gmail_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	    parts[1] = options.gmail_convert_googlemaildotcom ? 'gmail.com' : parts[1];
	  } else if (~icloud_domains.indexOf(parts[1])) {
	    // Address is iCloud
	    if (options.icloud_remove_subaddress) {
	      parts[0] = parts[0].split('+')[0];
	    }
	    if (!parts[0].length) {
	      return false;
	    }
	    if (options.all_lowercase || options.icloud_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	  } else if (~outlookdotcom_domains.indexOf(parts[1])) {
	    // Address is Outlook.com
	    if (options.outlookdotcom_remove_subaddress) {
	      parts[0] = parts[0].split('+')[0];
	    }
	    if (!parts[0].length) {
	      return false;
	    }
	    if (options.all_lowercase || options.outlookdotcom_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	  } else if (~yahoo_domains.indexOf(parts[1])) {
	    // Address is Yahoo
	    if (options.yahoo_remove_subaddress) {
	      var components = parts[0].split('-');
	      parts[0] = components.length > 1 ? components.slice(0, -1).join('-') : components[0];
	    }
	    if (!parts[0].length) {
	      return false;
	    }
	    if (options.all_lowercase || options.yahoo_lowercase) {
	      parts[0] = parts[0].toLowerCase();
	    }
	  } else if (options.all_lowercase) {
	    // Any other address
	    parts[0] = parts[0].toLowerCase();
	  }
	  return parts.join('@');
	}
	module.exports = exports['default'];

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = stripLow;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _blacklist = __webpack_require__(218);
	
	var _blacklist2 = _interopRequireDefault(_blacklist);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function stripLow(str, keep_new_lines) {
	  (0, _assertString2.default)(str);
	  var chars = keep_new_lines ? '\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F' : '\\x00-\\x1F\\x7F';
	  return (0, _blacklist2.default)(str, chars);
	}
	module.exports = exports['default'];

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toBoolean;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toBoolean(str, strict) {
	  (0, _assertString2.default)(str);
	  if (strict) {
	    return str === '1' || str === 'true';
	  }
	  return str !== '0' && str !== 'false' && str !== '';
	}
	module.exports = exports['default'];

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toInt;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toInt(str, radix) {
	  (0, _assertString2.default)(str);
	  return parseInt(str, radix || 10);
	}
	module.exports = exports['default'];

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = trim;
	
	var _rtrim = __webpack_require__(226);
	
	var _rtrim2 = _interopRequireDefault(_rtrim);
	
	var _ltrim = __webpack_require__(225);
	
	var _ltrim2 = _interopRequireDefault(_ltrim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function trim(str, chars) {
	  return (0, _rtrim2.default)((0, _ltrim2.default)(str, chars), chars);
	}
	module.exports = exports['default'];

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = unescape;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function unescape(str) {
	  (0, _assertString2.default)(str);
	  return str.replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&#x2F;/g, '/').replace(/&#x5C;/g, '\\').replace(/&#96;/g, '`');
	}
	module.exports = exports['default'];

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = whitelist;
	
	var _assertString = __webpack_require__(1);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function whitelist(str, chars) {
	  (0, _assertString2.default)(str);
	  return str.replace(new RegExp('[^' + chars + ']+', 'g'), '');
	}
	module.exports = exports['default'];

/***/ },
/* 591 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 592 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.3.3
	(function() {
	  var XMLFragment,
	    __hasProp = {}.hasOwnProperty;
	
	  XMLFragment = (function() {
	
	    function XMLFragment(parent, name, attributes, text) {
	      this.isRoot = false;
	      this.documentObject = null;
	      this.parent = parent;
	      this.name = name;
	      this.attributes = attributes;
	      this.value = text;
	      this.children = [];
	      this.assertLegalChar = parent.assertLegalChar;
	    }
	
	    XMLFragment.prototype.element = function(name, attributes, text) {
	      var child, key, val, _ref, _ref1;
	      if (!(name != null)) {
	        throw new Error("Missing element name");
	      }
	      name = '' + name || '';
	      this.assertLegalChar(name);
	      if (attributes == null) {
	        attributes = {};
	      }
	      if (this.is(attributes, 'String') && this.is(text, 'Object')) {
	        _ref = [text, attributes], attributes = _ref[0], text = _ref[1];
	      } else if (this.is(attributes, 'String')) {
	        _ref1 = [{}, attributes], attributes = _ref1[0], text = _ref1[1];
	      }
	      for (key in attributes) {
	        if (!__hasProp.call(attributes, key)) continue;
	        val = attributes[key];
	        val = '' + val || '';
	        attributes[key] = this.escape(val);
	      }
	      child = new XMLFragment(this, name, attributes);
	      if (text != null) {
	        text = '' + text || '';
	        text = this.escape(text);
	        this.assertLegalChar(text);
	        child.raw(text);
	      }
	      this.children.push(child);
	      return child;
	    };
	
	    XMLFragment.prototype.insertBefore = function(name, attributes, text) {
	      var child, i, key, val, _ref, _ref1;
	      if (this.isRoot) {
	        throw new Error("Cannot insert elements at root level");
	      }
	      if (!(name != null)) {
	        throw new Error("Missing element name");
	      }
	      name = '' + name || '';
	      this.assertLegalChar(name);
	      if (attributes == null) {
	        attributes = {};
	      }
	      if (this.is(attributes, 'String') && this.is(text, 'Object')) {
	        _ref = [text, attributes], attributes = _ref[0], text = _ref[1];
	      } else if (this.is(attributes, 'String')) {
	        _ref1 = [{}, attributes], attributes = _ref1[0], text = _ref1[1];
	      }
	      for (key in attributes) {
	        if (!__hasProp.call(attributes, key)) continue;
	        val = attributes[key];
	        val = '' + val || '';
	        attributes[key] = this.escape(val);
	      }
	      child = new XMLFragment(this.parent, name, attributes);
	      if (text != null) {
	        text = '' + text || '';
	        text = this.escape(text);
	        this.assertLegalChar(text);
	        child.raw(text);
	      }
	      i = this.parent.children.indexOf(this);
	      this.parent.children.splice(i, 0, child);
	      return child;
	    };
	
	    XMLFragment.prototype.insertAfter = function(name, attributes, text) {
	      var child, i, key, val, _ref, _ref1;
	      if (this.isRoot) {
	        throw new Error("Cannot insert elements at root level");
	      }
	      if (!(name != null)) {
	        throw new Error("Missing element name");
	      }
	      name = '' + name || '';
	      this.assertLegalChar(name);
	      if (attributes == null) {
	        attributes = {};
	      }
	      if (this.is(attributes, 'String') && this.is(text, 'Object')) {
	        _ref = [text, attributes], attributes = _ref[0], text = _ref[1];
	      } else if (this.is(attributes, 'String')) {
	        _ref1 = [{}, attributes], attributes = _ref1[0], text = _ref1[1];
	      }
	      for (key in attributes) {
	        if (!__hasProp.call(attributes, key)) continue;
	        val = attributes[key];
	        val = '' + val || '';
	        attributes[key] = this.escape(val);
	      }
	      child = new XMLFragment(this.parent, name, attributes);
	      if (text != null) {
	        text = '' + text || '';
	        text = this.escape(text);
	        this.assertLegalChar(text);
	        child.raw(text);
	      }
	      i = this.parent.children.indexOf(this);
	      this.parent.children.splice(i + 1, 0, child);
	      return child;
	    };
	
	    XMLFragment.prototype.remove = function() {
	      var i, _ref;
	      if (this.isRoot) {
	        throw new Error("Cannot remove the root element");
	      }
	      i = this.parent.children.indexOf(this);
	      [].splice.apply(this.parent.children, [i, i - i + 1].concat(_ref = [])), _ref;
	      return this.parent;
	    };
	
	    XMLFragment.prototype.text = function(value) {
	      var child;
	      if (!(value != null)) {
	        throw new Error("Missing element text");
	      }
	      value = '' + value || '';
	      value = this.escape(value);
	      this.assertLegalChar(value);
	      child = new XMLFragment(this, '', {}, value);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLFragment.prototype.cdata = function(value) {
	      var child;
	      if (!(value != null)) {
	        throw new Error("Missing CDATA text");
	      }
	      value = '' + value || '';
	      this.assertLegalChar(value);
	      if (value.match(/]]>/)) {
	        throw new Error("Invalid CDATA text: " + value);
	      }
	      child = new XMLFragment(this, '', {}, '<![CDATA[' + value + ']]>');
	      this.children.push(child);
	      return this;
	    };
	
	    XMLFragment.prototype.comment = function(value) {
	      var child;
	      if (!(value != null)) {
	        throw new Error("Missing comment text");
	      }
	      value = '' + value || '';
	      value = this.escape(value);
	      this.assertLegalChar(value);
	      if (value.match(/--/)) {
	        throw new Error("Comment text cannot contain double-hypen: " + value);
	      }
	      child = new XMLFragment(this, '', {}, '<!-- ' + value + ' -->');
	      this.children.push(child);
	      return this;
	    };
	
	    XMLFragment.prototype.raw = function(value) {
	      var child;
	      if (!(value != null)) {
	        throw new Error("Missing raw text");
	      }
	      value = '' + value || '';
	      child = new XMLFragment(this, '', {}, value);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLFragment.prototype.up = function() {
	      if (this.isRoot) {
	        throw new Error("This node has no parent. Use doc() if you need to get the document object.");
	      }
	      return this.parent;
	    };
	
	    XMLFragment.prototype.root = function() {
	      var child;
	      if (this.isRoot) {
	        return this;
	      }
	      child = this.parent;
	      while (!child.isRoot) {
	        child = child.parent;
	      }
	      return child;
	    };
	
	    XMLFragment.prototype.document = function() {
	      return this.root().documentObject;
	    };
	
	    XMLFragment.prototype.end = function(options) {
	      return this.document().toString(options);
	    };
	
	    XMLFragment.prototype.prev = function() {
	      var i;
	      if (this.isRoot) {
	        throw new Error("Root node has no siblings");
	      }
	      i = this.parent.children.indexOf(this);
	      if (i < 1) {
	        throw new Error("Already at the first node");
	      }
	      return this.parent.children[i - 1];
	    };
	
	    XMLFragment.prototype.next = function() {
	      var i;
	      if (this.isRoot) {
	        throw new Error("Root node has no siblings");
	      }
	      i = this.parent.children.indexOf(this);
	      if (i === -1 || i === this.parent.children.length - 1) {
	        throw new Error("Already at the last node");
	      }
	      return this.parent.children[i + 1];
	    };
	
	    XMLFragment.prototype.clone = function(deep) {
	      var clonedSelf;
	      clonedSelf = new XMLFragment(this.parent, this.name, this.attributes, this.value);
	      if (deep) {
	        this.children.forEach(function(child) {
	          var clonedChild;
	          clonedChild = child.clone(deep);
	          clonedChild.parent = clonedSelf;
	          return clonedSelf.children.push(clonedChild);
	        });
	      }
	      return clonedSelf;
	    };
	
	    XMLFragment.prototype.importXMLBuilder = function(xmlbuilder) {
	      var clonedRoot;
	      clonedRoot = xmlbuilder.root().clone(true);
	      clonedRoot.parent = this;
	      this.children.push(clonedRoot);
	      clonedRoot.isRoot = false;
	      return this;
	    };
	
	    XMLFragment.prototype.attribute = function(name, value) {
	      var _ref;
	      if (!(name != null)) {
	        throw new Error("Missing attribute name");
	      }
	      if (!(value != null)) {
	        throw new Error("Missing attribute value");
	      }
	      name = '' + name || '';
	      value = '' + value || '';
	      if ((_ref = this.attributes) == null) {
	        this.attributes = {};
	      }
	      this.attributes[name] = this.escape(value);
	      return this;
	    };
	
	    XMLFragment.prototype.removeAttribute = function(name) {
	      if (!(name != null)) {
	        throw new Error("Missing attribute name");
	      }
	      name = '' + name || '';
	      delete this.attributes[name];
	      return this;
	    };
	
	    XMLFragment.prototype.toString = function(options, level) {
	      var attName, attValue, child, indent, newline, pretty, r, space, _i, _len, _ref, _ref1;
	      pretty = (options != null) && options.pretty || false;
	      indent = (options != null) && options.indent || '  ';
	      newline = (options != null) && options.newline || '\n';
	      level || (level = 0);
	      space = new Array(level + 1).join(indent);
	      r = '';
	      if (pretty) {
	        r += space;
	      }
	      if (!(this.value != null)) {
	        r += '<' + this.name;
	      } else {
	        r += '' + this.value;
	      }
	      _ref = this.attributes;
	      for (attName in _ref) {
	        if (!__hasProp.call(_ref, attName)) continue;
	        attValue = _ref[attName];
	        if (this.name === '!DOCTYPE') {
	          r += ' ' + attValue;
	        } else {
	          r += ' ' + attName + '="' + attValue + '"';
	        }
	      }
	      if (this.children.length === 0) {
	        if (!(this.value != null)) {
	          r += this.name === '?xml' ? '?>' : this.name === '!DOCTYPE' ? '>' : '/>';
	        }
	        if (pretty) {
	          r += newline;
	        }
	      } else if (pretty && this.children.length === 1 && (this.children[0].value != null)) {
	        r += '>';
	        r += this.children[0].value;
	        r += '</' + this.name + '>';
	        r += newline;
	      } else {
	        r += '>';
	        if (pretty) {
	          r += newline;
	        }
	        _ref1 = this.children;
	        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
	          child = _ref1[_i];
	          r += child.toString(options, level + 1);
	        }
	        if (pretty) {
	          r += space;
	        }
	        r += '</' + this.name + '>';
	        if (pretty) {
	          r += newline;
	        }
	      }
	      return r;
	    };
	
	    XMLFragment.prototype.escape = function(str) {
	      return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&apos;').replace(/"/g, '&quot;');
	    };
	
	    XMLFragment.prototype.is = function(obj, type) {
	      var clas;
	      clas = Object.prototype.toString.call(obj).slice(8, -1);
	      return (obj != null) && clas === type;
	    };
	
	    XMLFragment.prototype.ele = function(name, attributes, text) {
	      return this.element(name, attributes, text);
	    };
	
	    XMLFragment.prototype.txt = function(value) {
	      return this.text(value);
	    };
	
	    XMLFragment.prototype.dat = function(value) {
	      return this.cdata(value);
	    };
	
	    XMLFragment.prototype.att = function(name, value) {
	      return this.attribute(name, value);
	    };
	
	    XMLFragment.prototype.com = function(value) {
	      return this.comment(value);
	    };
	
	    XMLFragment.prototype.doc = function() {
	      return this.document();
	    };
	
	    XMLFragment.prototype.e = function(name, attributes, text) {
	      return this.element(name, attributes, text);
	    };
	
	    XMLFragment.prototype.t = function(value) {
	      return this.text(value);
	    };
	
	    XMLFragment.prototype.d = function(value) {
	      return this.cdata(value);
	    };
	
	    XMLFragment.prototype.a = function(name, value) {
	      return this.attribute(name, value);
	    };
	
	    XMLFragment.prototype.c = function(value) {
	      return this.comment(value);
	    };
	
	    XMLFragment.prototype.r = function(value) {
	      return this.raw(value);
	    };
	
	    XMLFragment.prototype.u = function() {
	      return this.up();
	    };
	
	    return XMLFragment;
	
	  })();
	
	  module.exports = XMLFragment;
	
	}).call(this);


/***/ },
/* 593 */
/***/ function(module, exports) {

	module.exports = extend
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ },
/* 594 */
/***/ function(module, exports) {

	module.exports = Paho;

/***/ },
/* 595 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 596 */
595,
/* 597 */
595,
/* 598 */
595,
/* 599 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__) {

	// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	
	'use strict';
	
	/**
	 * The `azure-iot-common` module contains code common to the Azure IoT Hub Device and Service SDKs.
	 * 
	 * @module azure-iot-common
	 */
	
	module.exports = {
	  anHourFromNow: __webpack_require__(__webpack_module_template_argument_0__).anHourFromNow,
	  encodeUriComponentStrict: __webpack_require__(__webpack_module_template_argument_1__).encodeUriComponentStrict,
	  ConnectionString: __webpack_require__(__webpack_module_template_argument_2__),
	  endpoint: __webpack_require__(__webpack_module_template_argument_3__),
	  errors: __webpack_require__(__webpack_module_template_argument_4__),
	  results: __webpack_require__(__webpack_module_template_argument_5__),
	  Message: __webpack_require__(__webpack_module_template_argument_6__),
	  SharedAccessSignature: __webpack_require__(__webpack_module_template_argument_7__)
	};

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	
	'use strict';
	
	var createDictionary = __webpack_require__(__webpack_module_template_argument_0__);
	var ArgumentError = __webpack_require__(__webpack_module_template_argument_1__).ArgumentError;
	
	function ConnectionString() {}
	
	ConnectionString.parse = function parse(source, requiredFields) {
	  /*Codes_SRS_NODE_CONNSTR_05_001: [The input argument source shall be converted to string if necessary.]*/
	  var dict = createDictionary(source, ';');
	  var err = 'The connection string is missing the property: ';
	
	  /*Codes_SRS_NODE_CONNSTR_05_007: [If requiredFields is falsy, parse shall not validate fields.]*/
	  requiredFields = requiredFields || [];
	
	  /*Codes_SRS_NODE_CONNSTR_05_005: [The parse method shall throw ArgumentError if any of fields in the requiredFields argument are not found in the source argument.]*/
	  requiredFields.forEach(function (key) {
	    if (!(key in dict)) throw new ArgumentError(err + key);
	  });
	
	  /*Codes_SRS_NODE_CONNSTR_05_002: [The parse method shall create a new instance of ConnectionString.]*/
	  var cn = new ConnectionString();
	
	  /*Codes_SRS_NODE_CONNSTR_05_003: [It shall accept a string argument of the form 'name=value[;name=value…]' and for each name extracted it shall create a new property on the ConnectionString object instance.]*/
	  /*Codes_SRS_NODE_CONNSTR_05_004: [The value of the property shall be the value extracted from the source argument for the corresponding name.]*/
	  Object.keys(dict).forEach(function (key) {
	    cn[key] = dict[key];
	  });
	
	  /*Codes_SRS_NODE_CONNSTR_05_006: [The generated ConnectionString object shall be returned to the caller.]*/
	  return cn;
	};
	
	module.exports = ConnectionString;

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	
	'use strict';
	
	var Properties = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * @class module:azure-iot-common.Message
	 * @classdesc Constructs a {@linkcode Message} object with the given data.
	 *            `data` can be a Node [Buffer]{@linkcode https://nodejs.org/api/globals.html#globals_class_buffer}
	 *            object or anything that can be used to construct a `Buffer`
	 *            object from.
	 * @property {Object}   properties      A map containing string
	 *                                      keys and values for storing
	 *                                      custom message properties.
	 * @property {String}   messageId       Used to correlate two-way
	 *                                      communication.
	 *                                      Format: A case-sensitive string
	 *                                      (up to 128 char long) of ASCII
	 *                                      7-bit alphanumeric chars and the
	 *                                      following special symbols:
	 *                                      <br/>`- : . + % _ # * ? ! ( ) , = @ ; $ '`
	 * @property {String}   to              Destination of the message
	 * @property {Date}     expiryTimeUtc   Expiry time in UTC interpreted by hub on
	 *                                      C2D messages. Ignored in other cases.
	 * @property {String}   lockToken       Used by receiver to Abandon, Reject or
	 *                                      Complete the message
	 * @property {String}   correlationId   Used in message responses and feedback
	 * @property {String}   userId          Used to specify the entity creating the
	 *                                      message
	 * @see {@link https://nodejs.org/api/globals.html#globals_class_buffer|Buffer}
	 */
	/*Codes_SRS_NODE_IOTHUB_MESSAGE_07_004: [The Message constructor shall accept a variable message that will be transmitted.]*/
	function Message(data) {
	  this.data = data;
	
	  this.properties = new Properties();
	  this.messageId = '';
	  this.to = '';
	  this.expiryTimeUtc = null;
	  this.lockToken = '';
	  this.correlationId = '';
	  this.userId = '';
	}
	
	/**
	 * @method          module:azure-iot-common.Message#getData
	 * @description     Returns the data that was passed in to the [constructor]{@link Message}.
	 * 
	 * @returns {*} The data that was passed to the [constructor]{@link Message}.
	 */
	Message.prototype.getData = function() {
	  /*Codes_SRS_NODE_IOTHUB_MESSAGE_07_003: [The getData function shall return a representation of the body of the message as the type that was presented during construction.]*/
	  return this.data;
	};
	
	/**
	 * @method          module:azure-iot-common.Message#getBytes
	 * @description     Returns the data passed to the constructor as a Node
	 *                  [Buffer]{@linkcode https://nodejs.org/api/globals.html#globals_class_buffer}
	 *                  of bytes.
	 * 
	 * @returns {Buffer}
	 */
	Message.prototype.getBytes = function() {
	  if (Buffer.isBuffer(this.data) ) {
	    /*Codes_SRS_NODE_IOTHUB_MESSAGE_07_001: [If the data message that is store is of type Buffer then the data object will get returned unaltered.]*/
	    return this.data;
	  }
	  else {
	    /*Codes_SRS_NODE_IOTHUB_MESSAGE_07_002: [If the data message is of any other type then the data will be converted to a Buffer object and returned.]*/
	    return new Buffer(this.data);
	  }
	};
	
	module.exports = Message;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	// Copyright (c) Microsoft. All rights reserved.
	// Licensed under the MIT license. See LICENSE file in the project root for full license information.
	
	'use strict';
	
	var authorization = __webpack_require__(__webpack_module_template_argument_0__);
	var ArgumentError = __webpack_require__(__webpack_module_template_argument_1__).ArgumentError;
	var createDictionary = __webpack_require__(__webpack_module_template_argument_2__);
	var FormatError = __webpack_require__(__webpack_module_template_argument_3__).FormatError;
	
	/**
	 * @class           module:azure-iot-common.SharedAccessSignature
	 * @classdesc       An object representing a shared access signature
	 * @param {String}  resourceUri   The resource URI to encode into the signature
	 * @param {String}  keyName       An identifier associated with the key
	 * @param {String}  key           A base64-encoded key value
	 * @param {String}  expiry        An integer value representing the number of
	 *                                seconds since the epoch 00:00:00 UTC on
	 *                                1 January 1970.
	 */
	function SharedAccessSignature() {
	}
	
	/**
	 * @method          module:azure-iot-common.SharedAccessSignature.create
	 * @description     Instantiate a SharedAccessSignature token with the given parameters.
	 *
	 * @param {String}  resourceUri     the resource URI to encode into the token.
	 * @param {String}  keyName         an identifier associated with the key.
	 * @param {String}  key             a base64-encoded key value.
	 * @param {Integer} expiry          an integer value representing the number of seconds since the epoch 00:00:00 UTC on 1 January 1970.
	 *
	 * @throws {ReferenceError}         Will be thrown if one of the arguments is falsy.
	 *
	 * @returns {SharedAccessSignature} A shared access signature token.
	 */
	/*Codes_SRS_NODE_COMMON_SAS_05_008: [The create method shall accept four arguments:
	    resourceUri - the resource URI to encode into the token
	    keyName - an identifier associated with the key
	    key - a base64-encoded key value
	    expiry - an integer value representing the number of seconds since the epoch 00:00:00 UTC on 1 January 1970.]*/
	SharedAccessSignature.create = function create(resourceUri, keyName, key, expiry) {
	
	  function throwRef(name, value) {
	    throw new ReferenceError('Argument \'' + name + '\' is ' + value);
	  }
	
	  /*Codes_SRS_NODE_COMMON_SAS_05_009: [If resourceUri, key, or expiry are falsy (i.e., undefined, null, or empty), create shall throw ReferenceException.]*/
	  if (!resourceUri) throwRef('resourceUri', resourceUri);
	  if (!key) throwRef('key', key);
	  if (!expiry) throwRef('expiry', expiry);
	
	  /*Codes_SRS_NODE_COMMON_SAS_05_010: [The create method shall create a new instance of SharedAccessSignature with properties: sr, sig, se, and optionally skn.]*/
	  var sas = new SharedAccessSignature();
	  sas._key = key;
	  /*Codes_SRS_NODE_COMMON_SAS_05_011: [The sr property shall have the value of resourceUri.]*/
	  sas.sr = resourceUri;
	  /*Codes_SRS_NODE_COMMON_SAS_05_018: [If the keyName argument to the create method was falsy, skn shall not be defined.]*/
	  /*Codes_SRS_NODE_COMMON_SAS_05_017: [<urlEncodedKeyName> shall be the URL-encoded value of keyName.]*/
	  /*Codes_SRS_NODE_COMMON_SAS_05_016: [The skn property shall be the value <urlEncodedKeyName>.]*/
	  if (keyName) sas.skn = authorization.encodeUriComponentStrict(keyName);
	  /*Codes_SRS_NODE_COMMON_SAS_05_015: [The se property shall have the value of expiry.]*/
	  sas.se = expiry;
	  /*Codes_SRS_NODE_COMMON_SAS_05_013: [<signature> shall be an HMAC-SHA256 hash of the value <stringToSign>, which is then base64-encoded.]*/
	  /*Codes_SRS_NODE_COMMON_SAS_05_014: [<stringToSign> shall be a concatenation of resourceUri + '\n' + expiry.]*/
	  /*Codes_SRS_NODE_COMMON_SAS_05_012: [The sig property shall be the result of URL-encoding the value <signature>.]*/
	  sas.sig = authorization.encodeUriComponentStrict(authorization.hmacHash(sas._key, authorization.stringToSign(sas.sr, sas.se)));
	  return sas;
	};
	
	/**
	 * @method          module:azure-iot-common.SharedAccessSignature.extend
	 * @description     Extend the Sas and return the string form of it.
	 *
	 * @param {Integer} expiry          an integer value representing the number of seconds since the epoch 00:00:00 UTC on 1 January 1970.
	 *
	 * @throws {ReferenceError}         Will be thrown if the argument is falsy.
	 *
	 * @returns {string} The string form of the shared access signature.
	 *
	 */
	SharedAccessSignature.prototype.extend = function extend(expiry) {
	  if (!expiry) throw new ReferenceError('expiry' + ' is ' + expiry);
	  this.se = expiry;
	  this.sig = authorization.encodeUriComponentStrict(authorization.hmacHash(this._key, authorization.stringToSign(this.sr, this.se)));
	  return this.toString();
	};
	
	/**
	 * @method          module:azure-iot-common.SharedAccessSignature.parse
	 * @description     Instantiate a SharedAccessSignature token from a string.
	 *
	 * @param {String}  source          the string to parse in order to create the SharedAccessSignature token.
	 * @param {Array}   requiredFields  an array of fields that we expect to find in the source string.
	 *
	 * @throws {FormatError}            Will be thrown if the source string is malformed.
	 *
	 * @returns {SharedAccessSignature} A shared access signature token.
	 */
	SharedAccessSignature.parse = function parse(source, requiredFields) {
	  /*Codes_SRS_NODE_COMMON_SAS_05_001: [The input argument source shall be converted to string if necessary.]*/
	  var parts = String(source).split(/\s/);
	  /*Codes_SRS_NODE_COMMON_SAS_05_005: [The parse method shall throw FormatError if the shared access signature string does not start with 'SharedAccessSignature<space>'.]*/
	  if (parts.length !== 2 || !parts[0].match(/SharedAccessSignature/)) {
	    throw new FormatError('Malformed signature');
	  }
	
	  var dict = createDictionary(parts[1], '&');
	  var err = 'The shared access signature is missing the property: ';
	
	  requiredFields = requiredFields || [];
	
	  /*Codes_SRS_NODE_COMMON_SAS_05_006: [The parse method shall throw ArgumentError if any of fields in the requiredFields argument are not found in the source argument.]*/
	  requiredFields.forEach(function (key) {
	    if (!(key in dict)) throw new ArgumentError(err + key);
	  });
	
	  /*Codes_SRS_NODE_COMMON_SAS_05_002: [The parse method shall create a new instance of SharedAccessSignature.]*/
	  var sas = new SharedAccessSignature();
	
	  /*Codes_SRS_NODE_COMMON_SAS_05_003: [It shall accept a string argument of the form 'name=value[&name=value…]' and for each name extracted it shall create a new property on the SharedAccessSignature object instance.]*/
	  /*Codes_SRS_NODE_COMMON_SAS_05_004: [The value of the property shall be the value extracted from the source argument for the corresponding name.]*/
	  Object.keys(dict).forEach(function (key) {
	    sas[key] = dict[key];
	  });
	
	  /*Codes_SRS_NODE_COMMON_SAS_05_007: [The generated SharedAccessSignature object shall be returned to the caller.]*/
	  return sas;
	};
	
	
	/**
	 * @method          module:azure-iot-common.SharedAccessSignature#toString
	 * @description     Formats a SharedAccessSignatureObject into a properly formatted string.
	 *
	 * @returns {String} A properly formatted shared access signature token.
	 */
	SharedAccessSignature.prototype.toString = function () {
	  /*Codes_SRS_NODE_COMMON_SAS_05_019: [The toString method shall return a shared-access signature token of the form:
	  SharedAccessSignature sr=<url-encoded resourceUri>&sig=<urlEncodedSignature>&se=<expiry>&skn=<urlEncodedKeyName>]*/
	  var sas = 'SharedAccessSignature ';
	  ['sr', 'sig', 'skn', 'se'].forEach(function (key) {
	    /*Codes_SRS_NODE_COMMON_SAS_05_020: [The skn segment is not part of the returned string if the skn property is not defined.]*/
	    if (this[key]) {
	      if (sas[sas.length - 1] !== ' ') sas += '&';
	      sas += key + '=' + this[key];
	    }
	  }.bind(this));
	
	  return sas;
	};
	
	module.exports = SharedAccessSignature;

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.14dd2136.js